webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPgress = getPgress;
exports.getLxdzProgress = getLxdzProgress;
exports.sUpdate0 = sUpdate0;
exports.getPressList = getPressList;
exports.tabUpdate1 = tabUpdate1;
exports.tabRead1 = tabRead1;
exports.tabUpdate209 = tabUpdate209;
exports.tabRead209 = tabRead209;
exports.tabList2 = tabList2;
exports.mebRemove = mebRemove;
exports.mebClean = mebClean;
exports.dicSeek = dicSeek;
exports.mebUpdate = mebUpdate;
exports.tabRead2 = tabRead2;
exports.tabUpdate3 = tabUpdate3;
exports.tabRead3 = tabRead3;
exports.tabList4 = tabList4;
exports.tab4Remove = tab4Remove;
exports.tab4Clean = tab4Clean;
exports.tabUpdate4 = tabUpdate4;
exports.tabRead4 = tabRead4;
exports.tabList5 = tabList5;
exports.tab5Remove = tab5Remove;
exports.tab5Clean = tab5Clean;
exports.tabUpdate5 = tabUpdate5;
exports.tabRead5 = tabRead5;
exports.tabList6 = tabList6;
exports.tab6Remove = tab6Remove;
exports.tab6Clean = tab6Clean;
exports.tabUpdate6 = tabUpdate6;
exports.tabRead6 = tabRead6;
exports.tabUpdate7 = tabUpdate7;
exports.tabRead7 = tabRead7;
exports.tabList8 = tabList8;
exports.tab8Remove = tab8Remove;
exports.tab8Clean = tab8Clean;
exports.tabUpdate8 = tabUpdate8;
exports.tabRead8 = tabRead8;
exports.tabList9 = tabList9;
exports.tab9Remove = tab9Remove;
exports.tab9Clean = tab9Clean;
exports.tabUpdate9 = tabUpdate9;
exports.tabRead9 = tabRead9;
exports.subExcel = subExcel;
exports.excelErrors = excelErrors;
exports.subToPvc = subToPvc;
exports.cancelTabSubmit = cancelTabSubmit;
exports.exPersons = exPersons;
exports.copyList = copyList;
exports.copySet = copySet;
exports.percentCount = percentCount;
exports.percentCountLxdz = percentCountLxdz;
exports.pSubmitHistoryList = pSubmitHistoryList;
exports.submitDeclare = submitDeclare;
exports.code201HistoryData = code201HistoryData;
exports.code202HistoryData = code202HistoryData;
exports.code204HistoryData = code204HistoryData;
exports.postImg = postImg;
exports.getPfileUrl = getPfileUrl;
exports.getSelYearRecord = getSelYearRecord;
exports.tb9PullProductFromSystem = tb9PullProductFromSystem;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* 获取核验进度 */

function getPgress(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getMaterialExamineList',
    url: "eavar/publisher/progress",
    method: "post",
    data: params
  });
}

// progress 是连续型电子出版物出版物的
function getLxdzProgress(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getMaterialExamineList',
    url: "eavar/lxdz/publication/list",
    method: "post",
    data: params
  });
}

// zym.文件上传后，修改p_file1、p_file2表记录
function sUpdate0(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/updateCode101',
    url: "eavar/file/updateCode101",
    method: "post",
    data: params
  });
}

// zym.省局审核：出版单位材料列表页面？
function getPressList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getMaterialList',
    //  url:'eavar/examine/details',
    url: "eavar/publisher/materials",
    method: "post",
    data: params
  });
}

// 基本信息表保存
function tabUpdate1(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/updateCode201',
    url: "eavar/material/update/201",
    method: "post",
    data: params
  });
}

function tabRead1(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode201',
    url: "eavar/material/code/201",
    method: "post",
    data: params
  });
}

// 表 1-9：出版经营情况调查表 209
function tabUpdate209(params) {
  return (0, _fetch2.default)({
    url: "eavar/material/update/209",
    method: "post",
    data: params
  });
}

function tabRead209(params) {
  return (0, _fetch2.default)({
    url: "eavar/material/code/209",
    method: "post",
    data: params
  });
}

/* 表二 */

function tabList2(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode202List',
    url: "eavar/material/code/202",
    method: "post",
    data: params
  });
}

function mebRemove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode202',
    url: "eavar/material/delete/202",
    method: "post",
    data: params
  });
}

function mebClean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode202',
    url: "eavar/material/clear/202",
    method: "post",
    data: params
  });
}

function dicSeek(params) {
  return (0, _fetch2.default)({
    //  url:'System/System/getDataDictionaryDTOs',
    url: "/eavar/dictionary/code",
    method: "post",
    data: params
  });
}

function mebUpdate(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/updateCode202',
    url: "eavar/material/update/202",
    method: "post",
    data: params
  });
}

function tabRead2(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode202',
    url: "eavar/material/code/202",
    method: "post",
    data: params
  });
}

/* 表三 */

function tabUpdate3(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/updateCode203',
    url: "eavar/material/update/203",
    method: "post",
    data: params
  });
}

function tabRead3(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode203',
    url: "eavar/material/code/203",
    method: "post",
    data: params
  });
}

/* 表四 */

function tabList4(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode204List',
    url: "eavar/material/code/204",
    method: "post",
    data: params
  });
}

function tab4Remove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode204',
    url: "eavar/material/delete/204",
    method: "post",
    data: params
  });
}

function tab4Clean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode204',
    url: "eavar/material/clear/204",
    method: "post",
    data: params
  });
}

function tabUpdate4(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/updateCode204',
    url: "eavar/material/update/204",
    method: "post",
    data: params
  });
}

function tabRead4(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode204',
    url: "eavar/material/code/204",
    method: "post",
    data: params
  });
}

/* 表五 */

function tabList5(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode205List',
    url: "eavar/material/code/205",
    method: "post",
    data: params
  });
}

function tab5Remove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode205',
    url: "eavar/material/delete/205",
    method: "post",
    data: params
  });
}

function tab5Clean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode205',
    url: "eavar/material/clear/205",
    method: "post",
    data: params
  });
}

function tabUpdate5(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/updateCode205',
    url: "eavar/material/update/205",
    method: "post",
    data: params
  });
}

function tabRead5(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode205',
    url: "eavar/material/code/205",
    method: "post",
    data: params
  });
}

/* 表六 */

function tabList6(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode206List',
    url: "eavar/material/code/206",
    method: "post",
    data: params
  });
}

function tab6Remove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode206',
    url: "eavar/material/delete/206",
    method: "post",
    data: params
  });
}

function tab6Clean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode206',
    url: "eavar/material/clear/206",
    method: "post",
    data: params
  });
}

function tabUpdate6(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/updateCode206',
    url: "eavar/material/update/206",
    method: "post",
    data: params
  });
}

function tabRead6(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode206',
    url: "eavar/material/code/206",
    method: "post",
    data: params
  });
}

/* 表七 */

function tabUpdate7(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/updateCode207',
    url: "eavar/material/update/207",
    method: "post",
    data: params
  });
}

function tabRead7(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode207',
    url: "eavar/material/code/207",
    method: "post",
    data: params
  });
}

/* 表八 */

function tabList8(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode208List',
    url: "eavar/material/code/208",
    method: "post",
    data: params
  });
}

function tab8Remove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode208',
    url: "eavar/material/delete/208",
    method: "post",
    data: params
  });
}

function tab8Clean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode208',
    url: "eavar/material/clear/208",
    method: "post",
    data: params
  });
}

// zym.人员基本情况登记表 - 新增、修改
function tabUpdate8(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/updateCode208',
    url: "eavar/material/update/208",
    method: "post",
    data: params
  });
}

function tabRead8(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode208',
    url: "eavar/material/code/208",
    method: "post",
    data: params
  });
}

/* 表九 */

function tabList9(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode301List',
    url: "eavar/material/code/301",
    method: "post",
    data: params
  });
}

function tab9Remove(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/deleteCode301',
    url: "eavar/material/delete/301",
    method: "post",
    data: params
  });
}

function tab9Clean(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/clearCode301',
    url: "eavar/material/clear/301",
    method: "post",
    data: params
  });
}

function tabUpdate9(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/updateCode301',
    url: "eavar/material/update/301",
    method: "post",
    data: params
  });
}

function tabRead9(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getCode301',
    url: "eavar/material/code/301",
    method: "post",
    data: params
  });
}

function subExcel(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/importCode301',
    url: "eavar/material/import/301",
    method: "post",
    data: params
  });
}

function excelErrors(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/exportLog',
    url: "export/export/exportLog",
    method: "post",
    data: params
  });
}

// zym.音像、电子提交
function subToPvc(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/submit',
    url: "eavar/publisher/submit",
    method: "post",
    data: params
  });
}

// zym.音像、电子撤回
function cancelTabSubmit(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/submit',
    url: "eavar/publisher/cancelSubmit",
    method: "post",
    data: params
  });
}

/* 表 8导入 */

function exPersons(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/importCode208',
    url: "eavar/material/import/208",
    method: "post",
    data: params
  });
}

/* 获取可拷贝的表 */

function copyList(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/getSynchroCodeList',
    url: "eavar/material/getSynchroCodeList",
    method: "post",
    data: params
  });
}

/* 拷贝执行 */

function copySet(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/getBasicDTOByUscc',
    url: "eavar/material/getBasicDTOByUscc",
    method: "post",
    data: params
  });
}

// zym.统计(提交之后，人员列表上调用了这个方法)
function percentCount(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getWorkerProportion',
    url: "eavar/statistic/worker",
    method: "post",
    data: params
  });
}

// zym.统计(提交之后，人员列表上调用了这个方法)
function percentCountLxdz(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getWorkerProportion',
    url: "eavar/statistic/lxdzworker",
    method: "post",
    data: params
  });
}

/*获取出版单位历史提交版本列表*/

function pSubmitHistoryList(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getPSubmitHistoryList',
    url: "eavar/publisher/history",
    method: "post",
    data: params
  });
}

/*提交申报人信息*/
function submitDeclare(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/savePOrganizationPersonnel',
    url: "eavar/material/updatePersonnel",
    method: "post",
    data: params
  });
}

/*获取表1历史导入数据*/
function code201HistoryData(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getCode201HistoryData',
    url: "eavar/material/history/code/201",
    method: "post",
    data: params
  });
}
/*获取表2历史导入数据*/

function code202HistoryData(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/getCode202HistoryData',
    url: "eavar/material/history/code/202",
    method: "post",
    data: params
  });
}
/*获取表4历史导入数据*/

function code204HistoryData(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/getCode204HistoryData',
    url: "eavar/material/getCode204HistoryData",
    method: "post",
    data: params
  });
}
/*上传图片*/

function postImg(params) {
  return (0, _fetch2.default)({
    url: "/File/File/upload",
    method: "post",
    data: params
  });
}

function getPfileUrl(params) {
  return (0, _fetch2.default)({
    url: "/eavar/pfile/url",
    method: "post",
    data: params
  });
}

//年度纪录下拉选择数据
function getSelYearRecord(params) {
  return (0, _fetch2.default)({
    url: "/eavar/material/getSelYearRecord",
    method: "post",
    data: params
  });
}

// 出版社获取年度的音电作品数据
function tb9PullProductFromSystem(params) {
  return (0, _fetch2.default)({
    url: "/eavar/material/tb9PullProductFromSystem",
    method: "post",
    data: params
  });
}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAccountPage = getAccountPage;
exports.getAccount = getAccount;
exports.getPostList = getPostList;
exports.addAccount = addAccount;
exports.delAccount = delAccount;
exports.getCompanyOrganizationTree = getCompanyOrganizationTree;
exports.editAccount = editAccount;
exports.getOrganizationAndPostAndUserTreeByMenu = getOrganizationAndPostAndUserTreeByMenu;
exports.resetPasswordFormAdmin = resetPasswordFormAdmin;
exports.getFileToken = getFileToken;
exports.detFile = detFile;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 获取账号列表
 * @param query
 */
function getAccountPage(query) {
    return (0, _fetch2.default)({
        url: '/User/User/getUserListByOrganizationId',
        method: 'post',
        data: query
    });
}

/**
 * 初始化用户信息
 */
function getAccount(account) {
    return (0, _fetch2.default)({
        url: '/User/User/getOrganizationUserByUserId',
        method: 'post',
        data: account
    });
}

/**
 * 根据部门id获取职位列表
 * @param deparmentid 部门id
 */
function getPostList(deparmentid) {
    return (0, _fetch2.default)({
        url: '/Rule/Rule/getPostList',
        method: 'post',
        data: deparmentid
    });
}

/**
 * 提交账号信息
 * @param account
 */
function addAccount(account) {
    return (0, _fetch2.default)({
        url: '/User/User/registerOrganization',
        method: 'post',
        data: account
    });
}

/**
 * 提交账号信息
 * @param account
 */
function delAccount(account) {
    return (0, _fetch2.default)({
        url: '/User/User/delOrganizationUser',
        method: 'post',
        data: account
    });
}

/**
 * 获取公司部门树列表
 * @param query
 */
function getCompanyOrganizationTree(query) {
    return (0, _fetch2.default)({
        url: '/Rule/Rule/getCompanyOrganizationTree',
        method: 'post',
        data: query
    });
}

/**
 * 修改账号
 * @param query
 */
function editAccount(query) {
    return (0, _fetch2.default)({
        url: '/User/User/updateOrganizationUser',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * @param query
 */
function getOrganizationAndPostAndUserTreeByMenu(query) {
    return (0, _fetch2.default)({
        url: '/Rule/Rule/getOrganizationAndPostAndUserTreeByMenu',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * zym.2023-01-12 修改注释信息  重置密码
 * @param query
 */
function resetPasswordFormAdmin(query) {
    return (0, _fetch2.default)({
        // url: '/User/User/resetPasswordFormAdmin',
        // url: 'eavar/organization/resetPasswordFormAdmin',
        // 强制改密码的
        url: 'eavar/user/resetPasswordFormAdmin',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥图片 token
 * @param query
 */
function getFileToken(query) {
    return (0, _fetch2.default)({
        // url: '/File/File/getToken',
        url: '/eavar/file/getToken',
        method: 'post',
        data: query
    });
}

/**
 * 图片删除
 * @param query
 */
function detFile(query) {
    return (0, _fetch2.default)({
        url: '/File/File/deletePFile',
        method: 'post',
        data: query
    });
}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProvinceList = getProvinceList;
exports.goProvinceExam = goProvinceExam;
exports.stepToAdmin = stepToAdmin;
exports.isSubmited = isSubmited;
exports.registList = registList;
exports.goRegist = goRegist;
exports.successiveWaitList = successiveWaitList;
exports.successiveRegistList = successiveRegistList;
exports.successiveHistoryNew = successiveHistoryNew;
exports.successiveHistory = successiveHistory;
exports.successiveReported = successiveReported;
exports.ssReportLoad = ssReportLoad;
exports.getPostponeDesc = getPostponeDesc;
exports.ssReportUpload = ssReportUpload;
exports.upPostponeDesc = upPostponeDesc;
exports.pressSeek = pressSeek;
exports.successiveSeek = successiveSeek;
exports.publishStatic = publishStatic;
exports.writeReadTime = writeReadTime;
exports.writeReadTimeLxdz = writeReadTimeLxdz;
exports.provinceStatistics = provinceStatistics;
exports.batchAuditGen = batchAuditGen;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// zym.省局：出版单位审核列表
function getProvinceList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getExamineProvinceList',
    url: "eavar/bureau/examine/list",
    method: "post",
    data: params
  });
}

// zym.省局：审核
function goProvinceExam(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/batchExamineProvince',
    url: "eavar/bureau/examine/batchExamineProvince",
    method: "post",
    data: params
  });
}

// zym.省局上报总局
function stepToAdmin(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/submitProvince',
    url: "eavar/bureau/submitProvince",
    method: "post",
    data: params
  });
}

/* 省局是否上报 */

function isSubmited(params) {
  return (0, _fetch2.default)({
    url: "Ydnj/Ydnj/isSubmit",
    method: "post",
    data: params
  });
}

// zym.省局登记列表
function registList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getRecordExamineProvinceList',
    url: "eavar/bureau/examine/getRecordExamineProvinceList",
    method: "post",
    data: params
  });
}

// zym.省局登记
function goRegist(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/register',
    url: "eavar/bureau/goRegist",
    method: "post",
    data: params
  });
}

// zym.连续型出版物审核列表
function successiveWaitList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getLxdzMaterialExamineProvinceList',
    url: "lxdzpress/lxdz/getLxProvinceMaterialList",
    method: "post",
    data: params
  });
}

// zym.连续型出版物登记列表
function successiveRegistList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getLxdzMaterialRecordList',
    url: "lxdzpress/lxdz/getLxdzMaterialRecordList",
    method: "post",
    data: params
  });
}

// zym.流转记录（原审核历史） - 新
function successiveHistoryNew(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getFlowTasks',
    url: "eavar/examine/getExamineFlowNew",
    method: "post",
    data: params
  });
}

// zym.流转记录（原审核历史） - 废弃（省局审核页面）
function successiveHistory(params) {
  return successiveHistoryNew(params);
  // return fetch({
  //     //  url:'Ydnj/Ydnj/getFlowTasks',
  //      url:'eavar/examine/flow',
  //      method:"post",
  //      data:params
  // })
}

// zym.判断是否已审核完毕
function successiveReported(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getStatus',
    url: "eavar/bureau/getStatus",
    method: "post",
    data: params
  });
}

// zym.获取核验上传报告
function ssReportLoad(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getReport',
    url: "eavar/bureau/report",
    method: "post",
    data: params
  });
}

// zym.获取整改报告
function getPostponeDesc(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getPostponeDesc',
    url: "eavar/bureau/getPostponeDesc",
    method: "post",
    data: params
  });
}

// zym.省局：上传/更新分析报告
function ssReportUpload(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/upReport',
    url: "eavar/bureau/upReport",
    method: "post",
    data: params
  });
}

// zym.省局：上传/更新整改报告
function upPostponeDesc(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/upReport',
    url: "eavar/bureau/upPostponeDesc",
    method: "post",
    data: params
  });
}

/* 音像电子出版单位查询 */

function pressSeek(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/publisherMaterial',
    url: "eavar/publisher/list",
    method: "post",
    data: params
  });
}

/* 连续查询 */

function successiveSeek(params) {
  return (0, _fetch2.default)({
    //url:'Ydnj/Ydnj/lxPublisherMaterial',
    url: "eavar/publisher/lxPublisherMaterial",
    method: "post",
    data: params
  });
}

// zym.获取出版单位各项统计信息
function publishStatic(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/examine/statistics",
    method: "post",
    data: params
  });
}

// zym.审阅时间 - 音像、电子
function writeReadTime(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/bureau/writeReadTime",
    method: "post",
    data: params
  });
}

// zym.审阅时间 - 连续电子
function writeReadTimeLxdz(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getPublisherStatistics',
    url: "eavar/bureau/writeReadTimeLxdz",
    method: "post",
    data: params
  });
}

/* 省局首页增加各项统计下的出版单位数量 */

function provinceStatistics(params) {
  return (0, _fetch2.default)({
    // url:'Ydnj/Ydnj/getProvinceStatisticsList',
    url: "eavar/bureau/examine/statistics",
    method: "post",
    data: params
  });
}

// zym.省局：批量生成审核的条件数据
function batchAuditGen(params) {
  return (0, _fetch2.default)({
    url: "eavar/bureau/examine/batchAuditGen",
    method: "post",
    data: params
  });
}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelYearRecordLxdz = getSelYearRecordLxdz;
exports.getSuccessList = getSuccessList;
exports.getSuccessTabs = getSuccessTabs;
exports.getSuccessCheckTabs = getSuccessCheckTabs;
exports.successTabSubmit = successTabSubmit;
exports.cancelTabSubmit = cancelTabSubmit;
exports.getLxdzModifyFlagByOrganization = getLxdzModifyFlagByOrganization;
exports.getLxdzModifyFlagByOMaterial = getLxdzModifyFlagByOMaterial;
exports.getLxdzModifyFlagByPublication = getLxdzModifyFlagByPublication;
exports.successPgress = successPgress;
exports.ssSave1 = ssSave1;
exports.ssRead1 = ssRead1;
exports.ssSave2 = ssSave2;
exports.ssRead2 = ssRead2;
exports.ssSave3 = ssSave3;
exports.ssRead3 = ssRead3;
exports.ssList4 = ssList4;
exports.ssRead5 = ssRead5;
exports.ssRemove4 = ssRemove4;
exports.ssClean4 = ssClean4;
exports.ssSave4 = ssSave4;
exports.ssSave5 = ssSave5;
exports.ssRead4 = ssRead4;
exports.ssExcel = ssExcel;
exports.ssErrors = ssErrors;
exports.pExcel = pExcel;
exports.ssCopyList = ssCopyList;
exports.ssCopyAct = ssCopyAct;
exports.submitDeclare = submitDeclare;
exports.code401HistoryData = code401HistoryData;
exports.code402HistoryData = code402HistoryData;
exports.code403HistoryData = code403HistoryData;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// zym.获取出版社连续型出版物年度选择范围 - 新增
function getSelYearRecordLxdz(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getSelYearRecordLxdz',
        method: "post",
        data: params
    });
}

// zym.获取出版社连续型出版物 
function getSuccessList(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getLxPublisherMaterialList',
        //  url:'lxdzpress/lxdz/getLxPublisherMaterialList',
        url: 'lxdzpress/lxdz/getLxPublisherMaterialList',
        method: "post",
        data: params
    });
}

// zym.出版社 - 连续型出版物列表
function getSuccessTabs(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getPublicationOrganizationMaterialList',
        //  url:'eavar/lxdz/material/list',
        url: 'lxdzpress/lxdz/material/list',
        method: "post",
        data: params
    });
}

// zym.审核 - 连续型出版物列表
function getSuccessCheckTabs(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getPublicationOrganizationMaterialList',
        //  url:'eavar/lxdz/material/list',
        url: 'lxdzpress/lxdz/material/listcheck',
        method: "post",
        data: params
    });
}

// zym.连续型出版物填报表 - 整体提交
function successTabSubmit(params) {
    return (0, _fetch2.default)({
        // url: 'Ydnj/Ydnj/sumbitLxdzOrganizationMaterial',
        url: 'lxdzpress/lxdz/submitLxdzOrganizationMaterial',
        method: "post",
        data: params
    });
}

// zym.连续型出版物填报表 - 整体撤回
function cancelTabSubmit(params) {
    return (0, _fetch2.default)({
        // url: 'Ydnj/Ydnj/sumbitLxdzOrganizationMaterial',
        url: 'lxdzpress/lxdz/cancelLxdzOrganizationMaterial',
        method: "post",
        data: params
    });
}

// zym.判断是否可以修改数据 - 连续型电子出版物列表
function getLxdzModifyFlagByOrganization(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getLxdzModifyFlagByOrganization',
        method: "post",
        data: params
    });
}

// zym.判断是否可以修改数据 - 资料清单列表页面
function getLxdzModifyFlagByOMaterial(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getLxdzModifyFlagByOMaterial',
        method: "post",
        data: params
    });
}

// zym.判断是否可以修改数据 - 资料填报页面
function getLxdzModifyFlagByPublication(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getLxdzModifyFlagByPublication',
        method: "post",
        data: params
    });
}

/* 连续型出版物核验进度 */
function successPgress(params) {
    return (0, _fetch2.default)({
        url: 'Ydnj/Ydnj/getLxdzExaminePage',
        method: "post",
        data: params
    });
}

// zym.(连续电子型)出版物基本信息 code=401
function ssSave1(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/updateCode401',
        url: 'lxdzpress/lxdz/material/update/401',
        method: "post",
        data: params
    });
}

// zym.连续型电子出版物 - 出版物基本信息表的信息查询
function ssRead1(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode401',
        //  url:'eavar/material/code/401',        
        url: 'lxdzpress/lxdz/material/code/401',
        method: "post",
        data: params
    });
}

// zym.(连续电子型)出版单位基本信息 code=402
function ssSave2(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/updateCode402',
        url: 'lxdzpress/lxdz/material/update/402',
        method: "post",
        data: params
    });
}

// zym.连续型电子出版物 - 出版单位基本信息查询
function ssRead2(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode402',
        //  url:'eavar/material/code/402', 
        url: 'lxdzpress/lxdz/material/code/402',
        method: "post",
        data: params
    });
}

// zym.(连续电子型)经营情况信息 code=403
function ssSave3(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/updateCode403',
        url: 'lxdzpress/lxdz/material/update/403',
        method: "post",
        data: params
    });
}

// zym.连续型电子出版物 - 经营情况查询
function ssRead3(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode403',
        //  url:'eavar/material/code/403',
        url: 'lxdzpress/lxdz/material/code/403',
        method: "post",
        data: params
    });
}

// zym.连续型电子出版物 - 人员基本信息
function ssList4(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode404List',
        // url:'eavar/material/code/404',
        url: 'lxdzpress/lxdz/material/code/404',
        method: "post",
        data: params
    });
}

// zym.连续型电子出版物 - 调查表
function ssRead5(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode403',
        //  url:'eavar/material/code/403',
        url: 'lxdzpress/lxdz/material/code/405',
        method: "post",
        data: params
    });
}

// zym.连续型电子 - 人员删除
function ssRemove4(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/deleteCode404',
        url: 'lxdzpress/lxdz/material/delete/404',
        method: "post",
        data: params
    });
}

// zym.人员列表，清除全部
function ssClean4(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/clearCode404',
        url: 'lxdzpress/lxdz/material/clearCode404',
        method: "post",
        data: params
    });
}

// zym.保存人员基本信息
function ssSave4(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/updateCode404',
        url: 'lxdzpress/lxdz/material/update/404',
        method: "post",
        data: params
    });
}

// zym.保存调查表
function ssSave5(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/updateCode404',
        url: 'lxdzpress/lxdz/material/update/405',
        method: "post",
        data: params
    });
}

// zym.人员基本信息列表
function ssRead4(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getCode404',
        url: 'lxdzpress/lxdz/material/code/404',
        method: "post",
        data: params
    });
}

// zym.连续出版物表1导入 
function ssExcel(params) {

    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/importLxcbCode401',
        url: 'lxdzpress/lxdz/material/importLxdzCode401',
        method: "post",
        data: params
    });
}

/* 导入错误提示 */

function ssErrors(params) {

    return (0, _fetch2.default)({
        url: 'Ydnj/Ydnj/exportLog',
        method: "post",
        data: params
    });
}

// zym.连续出版物人员导入
function pExcel(params) {

    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/importCode404',
        url: 'lxdzpress/lxdz/material/importLxdzCode404',
        method: "post",
        data: params
    });
}

/* 连续出版物拷贝表 */

function ssCopyList(params) {
    return (0, _fetch2.default)({
        //  url:'Ydnj/Ydnj/getSynchroCodeLxList',
        url: 'lxdzpress/lxdz/material/getSynchroCodeLxList',
        method: "post",
        data: params
    });
}

/* 连续出版物拷贝表 */

function ssCopyAct(params) {
    return (0, _fetch2.default)({
        // url: 'Ydnj/Ydnj/synchroLxCode',
        url: 'lxdzpress/lxdz/material/synchroLxCode',
        method: "post",
        data: params
    });
}
/*提交申报人信息*/

function submitDeclare(params) {
    return (0, _fetch2.default)({
        // url: 'Ydnj/Ydnj/saveLxdzPOrganizationPersonnel',
        url: 'lxdzpress/lxdz/material/saveLxdzPOrganizationPersonnel',
        method: "post",
        data: params
    });
}

function code401HistoryData(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/401',
        method: "post",
        data: params
    });
}

function code402HistoryData(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/402',
        method: "post",
        data: params
    });
}

function code403HistoryData(params) {
    return (0, _fetch2.default)({
        url: 'lxdzpress/lxdz/getCodeHistoryDataLxdz/403',
        method: "post",
        data: params
    });
}

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;

var _jsCookie = __webpack_require__(490);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenKey = 'Admin-Token';

function getToken() {
    return _jsCookie2.default.get(TokenKey);
}

function setToken(token) {
    return _jsCookie2.default.set(TokenKey, token);
}

function removeToken() {
    return _jsCookie2.default.remove(TokenKey);
}

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(665);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(664);

var _store = __webpack_require__(264);

var _store2 = _interopRequireDefault(_store);

var _auth = __webpack_require__(46);

var _object = __webpack_require__(266);

var _validate = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 创建axios实例
var service = _axios2.default.create({
  baseURL: "https://ydnj.capub.cn", // api的base_url
  withCredentials: true, // zym.send cookies when cross-domain request
  // timeout: 72000000 // 请求超时时间
  // timeout: 20 * 60 * 1000, // 请求超时时间
  timeout: 2 * 60 * 1000, // 请求超时时间
  // zym.20250630，重保措施增加
  allowAbsoluteUrls: false // 确保 axios@1.8.2+ 的修复生效[3](@ref)
});

// request拦截器
service.interceptors.request.use(function (config) {
  // zym.20250630，重保措施增加。在请求拦截器中动态检查目标地址
  // if (config.url.startsWith("http://") || config.url.startsWith("https://")) {
  //   throw new Error("Absolute URLs are not allowed");
  // }
  if (_store2.default.getters.token) {
    // config.headers['X-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers["Authorization"] = "Bearer " + (0, _auth.getToken)();
  }

  var param = (0, _object.tirm)(config.data);
  config.data = param;
  // config['data1']= param;
  console.debug(config.url, config.data);
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  _promise2.default.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
  // console.debug('rep: ', response.data.data)
  /**
   * code大于0抛错
   */
  var res = response.data;
  // const payload = res.payload
  // if(payload.resultStatus&&payload.resultStatus.status>0){
  //     console.log(res.payload.resultStatus.status)
  if (res.code && res.code !== 0) {
    console.warn("返回异常: ", res.code, res);
    (0, _elementUi.Message)({
      message: res.message || res.error,
      type: "error",
      duration: 5 * 1000
    });
    // 画面sonomama 不想统一处理
    return _promise2.default.resolve(res);
    // 130033:非法的token; 130033:其他客户端登录了;  130033:Token 过期了;
    // if (res.payload.resultStatus.status === 130033) {
    //     MessageBox.alert('你已被登出，请重新登录，如非本人操作请修改密码', '提示', {
    //         confirmButtonText: '重新登录',
    //         callback: action => {
    //             store.dispatch('FedLogOut').then(() => {
    //                 location.reload();// 为了重新实例化vue-router对象 避免bug
    //             });
    //         }
    //     });
    // }else{
    //     Message({
    //         message: payload.resultStatus.message,
    //         type: 'error',
    //         duration: 5 * 1000
    //     });
    // }
    // return Promise.reject('error');
  } else {
    //HYY 修改
    if (res instanceof Blob) {
      var content = response.headers["content-disposition"];
      var filename = "文件名称";
      if (!(0, _validate.isEmpty)(content)) {
        var arr = content.split("=");
        if (arr.length > 1) {
          filename = arr[1];
        }
      }
      localStorage.setItem("dfilename", filename);
      return _promise2.default.resolve(res);
    } else {
      return _promise2.default.resolve(res.data);
    }
  }
}, function (error) {
  console.log("err:", error); // for debug
  var _error$response = error.response,
      data = _error$response.data,
      status = _error$response.status,
      statusText = _error$response.statusText;

  var message = "";
  if (error.message === "Network Error") {
    message = "网络异常";
  } else if (error.message === "timeout of 200000ms exceeded") {
    message = "请求服务器超时，请重试";
  } else {
    message = error.message;
  }
  if (status && status === 401) message = "认证已经过期，请尝试退出并重新登录。";
  (0, _elementUi.Message)({
    message: message,
    type: "error",
    duration: 5 * 1000
  });
  // var message = '网络异常'
  // if(error==='Error: Network Error'){
  //     message = '网络异常'
  // }
  return _promise2.default.reject(error);
});

exports.default = service;

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {Object.defineProperty(exports,"__esModule",{value:true});exports.CFB=exports.SSF=exports.stream=exports.utils=exports.writeFileXLSX=exports.writeXLSX=exports.writeFileAsync=exports.writeFileSync=exports.writeFile=exports.write=exports.readFileSync=exports.readFile=exports.read=exports.parse_zip=exports.parse_xlscfb=exports.version=exports.set_fs=exports.set_cptable=undefined;var _defineProperty=__webpack_require__(268);var _defineProperty2=_interopRequireDefault(_defineProperty);var _map=__webpack_require__(824);var _map2=_interopRequireDefault(_map);var _log=__webpack_require__(825);var _log2=_interopRequireDefault(_log);var _stringify=__webpack_require__(17);var _stringify2=_interopRequireDefault(_stringify);var _keys=__webpack_require__(150);var _keys2=_interopRequireDefault(_keys);var _create=__webpack_require__(826);var _create2=_interopRequireDefault(_create);var _typeof2=__webpack_require__(181);var _typeof3=_interopRequireDefault(_typeof2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com *//* vim: set ts=2: *//*exported XLSX *//*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */var XLSX={};XLSX.version='0.18.5';var current_codepage=1200,current_ansi=1252;var VALID_ANSI=[874,932,936,949,950,1250,1251,1252,1253,1254,1255,1256,1257,1258,10000];/* ECMA-376 Part I 18.4.1 charset to codepage mapping */var CS2CP={/*::[*/0/*::]*/:1252,/* ANSI *//*::[*/1/*::]*/:65001,/* DEFAULT *//*::[*/2/*::]*/:65001,/* SYMBOL *//*::[*/77/*::]*/:10000,/* MAC *//*::[*/128/*::]*/:932,/* SHIFTJIS *//*::[*/129/*::]*/:949,/* HANGUL *//*::[*/130/*::]*/:1361,/* JOHAB *//*::[*/134/*::]*/:936,/* GB2312 *//*::[*/136/*::]*/:950,/* CHINESEBIG5 *//*::[*/161/*::]*/:1253,/* GREEK *//*::[*/162/*::]*/:1254,/* TURKISH *//*::[*/163/*::]*/:1258,/* VIETNAMESE *//*::[*/177/*::]*/:1255,/* HEBREW *//*::[*/178/*::]*/:1256,/* ARABIC *//*::[*/186/*::]*/:1257,/* BALTIC *//*::[*/204/*::]*/:1251,/* RUSSIAN *//*::[*/222/*::]*/:874,/* THAI *//*::[*/238/*::]*/:1250,/* EASTEUROPE *//*::[*/255/*::]*/:1252,/* OEM *//*::[*/69/*::]*/:6969/* MISC *//*:any*/};var set_ansi=function set_ansi(cp/*:number*/){if(VALID_ANSI.indexOf(cp)==-1)return;current_ansi=CS2CP[0]=cp;};function reset_ansi(){set_ansi(1252);}var set_cp=function set_cp(cp/*:number*/){current_codepage=cp;set_ansi(cp);};function reset_cp(){set_cp(1200);reset_ansi();}function char_codes(data/*:string*/)/*:Array<number>*/{var o/*:Array<number>*/=[];for(var i=0,len=data.length;i<len;++i){o[i]=data.charCodeAt(i);}return o;}function utf16leread(data/*:string*/)/*:string*/{var o/*:Array<string>*/=[];for(var i=0;i<data.length>>1;++i){o[i]=String.fromCharCode(data.charCodeAt(2*i)+(data.charCodeAt(2*i+1)<<8));}return o.join("");}function utf16beread(data/*:string*/)/*:string*/{var o/*:Array<string>*/=[];for(var i=0;i<data.length>>1;++i){o[i]=String.fromCharCode(data.charCodeAt(2*i+1)+(data.charCodeAt(2*i)<<8));}return o.join("");}var debom=function debom(data/*:string*/)/*:string*/{var c1=data.charCodeAt(0),c2=data.charCodeAt(1);if(c1==0xFF&&c2==0xFE)return utf16leread(data.slice(2));if(c1==0xFE&&c2==0xFF)return utf16beread(data.slice(2));if(c1==0xFEFF)return data.slice(1);return data;};var _getchar=function _gc1(x/*:number*/)/*:string*/{return String.fromCharCode(x);};var _getansi=function _ga1(x/*:number*/)/*:string*/{return String.fromCharCode(x);};var $cptable;function set_cptable(cptable){$cptable=cptable;set_cp=function set_cp(cp/*:number*/){current_codepage=cp;set_ansi(cp);};debom=function debom(data/*:string*/){if(data.charCodeAt(0)===0xFF&&data.charCodeAt(1)===0xFE){return $cptable.utils.decode(1200,char_codes(data.slice(2)));}return data;};_getchar=function _gc2(x/*:number*/)/*:string*/{if(current_codepage===1200)return String.fromCharCode(x);return $cptable.utils.decode(current_codepage,[x&255,x>>8])[0];};_getansi=function _ga2(x/*:number*/)/*:string*/{return $cptable.utils.decode(current_ansi,[x])[0];};cpdoit();}exports.set_cptable=set_cptable;var DENSE=null;var DIF_XL=true;var Base64_map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";function Base64_encode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;for(var i=0;i<input.length;){c1=input.charCodeAt(i++);e1=c1>>2;c2=input.charCodeAt(i++);e2=(c1&3)<<4|c2>>4;c3=input.charCodeAt(i++);e3=(c2&15)<<2|c3>>6;e4=c3&63;if(isNaN(c2)){e3=e4=64;}else if(isNaN(c3)){e4=64;}o+=Base64_map.charAt(e1)+Base64_map.charAt(e2)+Base64_map.charAt(e3)+Base64_map.charAt(e4);}return o;}function Base64_decode(input){var o="";var c1=0,c2=0,c3=0,e1=0,e2=0,e3=0,e4=0;input=input.replace(/[^\w\+\/\=]/g,"");for(var i=0;i<input.length;){e1=Base64_map.indexOf(input.charAt(i++));e2=Base64_map.indexOf(input.charAt(i++));c1=e1<<2|e2>>4;o+=String.fromCharCode(c1);e3=Base64_map.indexOf(input.charAt(i++));c2=(e2&15)<<4|e3>>2;if(e3!==64){o+=String.fromCharCode(c2);}e4=Base64_map.indexOf(input.charAt(i++));c3=(e3&3)<<6|e4;if(e4!==64){o+=String.fromCharCode(c3);}}return o;}var has_buf=/*#__PURE__*/function(){return typeof Buffer!=='undefined'&&typeof process!=='undefined'&&typeof process.versions!=='undefined'&&!!process.versions.node;}();var Buffer_from=/*#__PURE__*/function(){if(typeof Buffer!=='undefined'){var nbfs=!Buffer.from;if(!nbfs)try{Buffer.from("foo","utf8");}catch(e){nbfs=true;}return nbfs?function(buf,enc){return enc?new Buffer(buf,enc):new Buffer(buf);}:Buffer.from.bind(Buffer);}return function(){};}();function new_raw_buf(len/*:number*/){/* jshint -W056 */if(has_buf)return Buffer.alloc?Buffer.alloc(len):new Buffer(len);return typeof Uint8Array!="undefined"?new Uint8Array(len):new Array(len);/* jshint +W056 */}function new_unsafe_buf(len/*:number*/){/* jshint -W056 */if(has_buf)return Buffer.allocUnsafe?Buffer.allocUnsafe(len):new Buffer(len);return typeof Uint8Array!="undefined"?new Uint8Array(len):new Array(len);/* jshint +W056 */}var s2a=function s2a(s/*:string*/)/*:any*/{if(has_buf)return Buffer_from(s,"binary");return s.split("").map(function(x/*:string*/)/*:number*/{return x.charCodeAt(0)&0xff;});};function s2ab(s/*:string*/)/*:any*/{if(typeof ArrayBuffer==='undefined')return s2a(s);var buf=new ArrayBuffer(s.length),view=new Uint8Array(buf);for(var i=0;i!=s.length;++i){view[i]=s.charCodeAt(i)&0xFF;}return buf;}function a2s(data/*:any*/)/*:string*/{if(Array.isArray(data))return data.map(function(c){return String.fromCharCode(c);}).join("");var o/*:Array<string>*/=[];for(var i=0;i<data.length;++i){o[i]=String.fromCharCode(data[i]);}return o.join("");}function a2u(data/*:Array<number>*/)/*:Uint8Array*/{if(typeof Uint8Array==='undefined')throw new Error("Unsupported");return new Uint8Array(data);}function ab2a(data/*:ArrayBuffer|Uint8Array*/)/*:Array<number>*/{if(typeof ArrayBuffer=='undefined')throw new Error("Unsupported");if(data instanceof ArrayBuffer)return ab2a(new Uint8Array(data));/*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */var o=new Array(data.length);for(var i=0;i<data.length;++i){o[i]=data[i];}return o;}var bconcat=has_buf?function(bufs){return Buffer.concat(bufs.map(function(buf){return Buffer.isBuffer(buf)?buf:Buffer_from(buf);}));}:function(bufs){if(typeof Uint8Array!=="undefined"){var i=0,maxlen=0;for(i=0;i<bufs.length;++i){maxlen+=bufs[i].length;}var o=new Uint8Array(maxlen);var len=0;for(i=0,maxlen=0;i<bufs.length;maxlen+=len,++i){len=bufs[i].length;if(bufs[i]instanceof Uint8Array)o.set(bufs[i],maxlen);else if(typeof bufs[i]=="string"){throw"wtf";}else o.set(new Uint8Array(bufs[i]),maxlen);}return o;}return[].concat.apply([],bufs.map(function(buf){return Array.isArray(buf)?buf:[].slice.call(buf);}));};function utf8decode(content/*:string*/){var out=[],widx=0,L=content.length+250;var o=new_raw_buf(content.length+255);for(var ridx=0;ridx<content.length;++ridx){var c=content.charCodeAt(ridx);if(c<0x80)o[widx++]=c;else if(c<0x800){o[widx++]=192|c>>6&31;o[widx++]=128|c&63;}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;var d=content.charCodeAt(++ridx)&1023;o[widx++]=240|c>>8&7;o[widx++]=128|c>>2&63;o[widx++]=128|d>>6&15|(c&3)<<4;o[widx++]=128|d&63;}else{o[widx++]=224|c>>12&15;o[widx++]=128|c>>6&63;o[widx++]=128|c&63;}if(widx>L){out.push(o.slice(0,widx));widx=0;o=new_raw_buf(65535);L=65530;}}out.push(o.slice(0,widx));return bconcat(out);}var chr0=/\u0000/g,chr1=/[\u0001-\u0006]/g;/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*//* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com *//*jshint -W041 */function _strrev(x/*:string*/)/*:string*/{var o="",i=x.length-1;while(i>=0){o+=x.charAt(i--);}return o;}function pad0(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}function pad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}function rpad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:t+fill(' ',d-t.length);}function pad0r1(v/*:any*/,d/*:number*/)/*:string*/{var t=""+Math.round(v);return t.length>=d?t:fill('0',d-t.length)+t;}function pad0r2(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill('0',d-t.length)+t;}var p2_32=/*#__PURE__*/Math.pow(2,32);function pad0r(v/*:any*/,d/*:number*/)/*:string*/{if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d);}/* yes, in 2022 this is still faster than string compare */function SSF_isgeneral(s/*:string*/,i/*:?number*/)/*:boolean*/{i=i||0;return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108;}var days/*:Array<Array<string> >*/=[['Sun','Sunday'],['Mon','Monday'],['Tue','Tuesday'],['Wed','Wednesday'],['Thu','Thursday'],['Fri','Friday'],['Sat','Saturday']];var months/*:Array<Array<string> >*/=[['J','Jan','January'],['F','Feb','February'],['M','Mar','March'],['A','Apr','April'],['M','May','May'],['J','Jun','June'],['J','Jul','July'],['A','Aug','August'],['S','Sep','September'],['O','Oct','October'],['N','Nov','November'],['D','Dec','December']];function SSF_init_table(t/*:any*/){if(!t)t={};t[0]='General';t[1]='0';t[2]='0.00';t[3]='#,##0';t[4]='#,##0.00';t[9]='0%';t[10]='0.00%';t[11]='0.00E+00';t[12]='# ?/?';t[13]='# ??/??';t[14]='m/d/yy';t[15]='d-mmm-yy';t[16]='d-mmm';t[17]='mmm-yy';t[18]='h:mm AM/PM';t[19]='h:mm:ss AM/PM';t[20]='h:mm';t[21]='h:mm:ss';t[22]='m/d/yy h:mm';t[37]='#,##0 ;(#,##0)';t[38]='#,##0 ;[Red](#,##0)';t[39]='#,##0.00;(#,##0.00)';t[40]='#,##0.00;[Red](#,##0.00)';t[45]='mm:ss';t[46]='[h]:mm:ss';t[47]='mmss.0';t[48]='##0.0E+0';t[49]='@';t[56]='"上午/下午 "hh"時"mm"分"ss"秒 "';return t;}/* repeated to satiate webpack */var table_fmt={0:'General',1:'0',2:'0.00',3:'#,##0',4:'#,##0.00',9:'0%',10:'0.00%',11:'0.00E+00',12:'# ?/?',13:'# ??/??',14:'m/d/yy',15:'d-mmm-yy',16:'d-mmm',17:'mmm-yy',18:'h:mm AM/PM',19:'h:mm:ss AM/PM',20:'h:mm',21:'h:mm:ss',22:'m/d/yy h:mm',37:'#,##0 ;(#,##0)',38:'#,##0 ;[Red](#,##0)',39:'#,##0.00;(#,##0.00)',40:'#,##0.00;[Red](#,##0.00)',45:'mm:ss',46:'[h]:mm:ss',47:'mmss.0',48:'##0.0E+0',49:'@',56:'"上午/下午 "hh"時"mm"分"ss"秒 "'};/* Defaults determined by systematically testing in Excel 2019 *//* These formats appear to default to other formats in the table */var SSF_default_map={5:37,6:38,7:39,8:40,//  5 -> 37 ...  8 -> 40
23:0,24:0,25:0,26:0,// 23 ->  0 ... 26 ->  0
27:14,28:14,29:14,30:14,31:14,// 27 -> 14 ... 31 -> 14
50:14,51:14,52:14,53:14,54:14,// 50 -> 14 ... 58 -> 14
55:14,56:14,57:14,58:14,59:1,60:2,61:3,62:4,// 59 ->  1 ... 62 ->  4
67:9,68:10,// 67 ->  9 ... 68 -> 10
69:12,70:13,71:14,// 69 -> 12 ... 71 -> 14
72:14,73:15,74:16,75:17,// 72 -> 14 ... 75 -> 17
76:20,77:21,78:22,// 76 -> 20 ... 78 -> 22
79:45,80:46,81:47,// 79 -> 45 ... 81 -> 47
82:0// 82 ->  0 ... 65536 -> 0 (omitted)
};/* These formats technically refer to Accounting formats with no equivalent */var SSF_default_str={//  5 -- Currency,   0 decimal, black negative
5:'"$"#,##0_);\\("$"#,##0\\)',63:'"$"#,##0_);\\("$"#,##0\\)',//  6 -- Currency,   0 decimal, red   negative
6:'"$"#,##0_);[Red]\\("$"#,##0\\)',64:'"$"#,##0_);[Red]\\("$"#,##0\\)',//  7 -- Currency,   2 decimal, black negative
7:'"$"#,##0.00_);\\("$"#,##0.00\\)',65:'"$"#,##0.00_);\\("$"#,##0.00\\)',//  8 -- Currency,   2 decimal, red   negative
8:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',66:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',// 41 -- Accounting, 0 decimal, No Symbol
41:'_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',// 42 -- Accounting, 0 decimal, $  Symbol
42:'_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',// 43 -- Accounting, 2 decimal, No Symbol
43:'_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',// 44 -- Accounting, 2 decimal, $  Symbol
44:'_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'};function SSF_frac(x/*:number*/,D/*:number*/,mixed/*:?boolean*/)/*:Array<number>*/{var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<0.00000005)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q;}if(Q>D){if(Q_1>D){Q=Q_2;P=P_2;}else{Q=Q_1;P=P_1;}}if(!mixed)return[0,sgn*P,Q];var q=Math.floor(sgn*P/Q);return[q,sgn*P-q*Q,Q];}function SSF_parse_date_code(v/*:number*/,opts/*:?any*/,b2/*:?boolean*/){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;if(opts&&opts.date1904)date+=1462;if(out.u>0.9999){out.u=0;if(++time==86400){out.T=time=0;++date;++out.D;}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3;}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6;}else{if(date>60)--date;/* 1 = Jan 1 1900 in Gregorian */var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=SSF_fix_hijri(d,dout);}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out;}var SSFbasedate=/*#__PURE__*/new Date(1899,11,31,0,0,0);var SSFdnthresh=/*#__PURE__*/SSFbasedate.getTime();var SSFbase1904=/*#__PURE__*/new Date(1900,2,1,0,0,0);function datenum_local(v/*:Date*/,date1904/*:?boolean*/)/*:number*/{var epoch=/*#__PURE__*/v.getTime();if(date1904)epoch-=1461*24*60*60*1000;else if(v>=SSFbase1904)epoch+=24*60*60*1000;return(epoch-(SSFdnthresh+(/*#__PURE__*/v.getTimezoneOffset()-/*#__PURE__*/SSFbasedate.getTimezoneOffset())*60000))/(24*60*60*1000);}/* ECMA-376 18.8.30 numFmt*//* Note: `toPrecision` uses standard form when prec > E and E >= -6 *//* exponent >= -9 and <= 9 */function SSF_strip_decimal(o/*:string*/)/*:string*/{return o.indexOf(".")==-1?o:o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/,"$1");}/* General Exponential always shows 2 digits exp and trims the mantissa */function SSF_normalize_exp(o/*:string*/)/*:string*/{if(o.indexOf("E")==-1)return o;return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");}/* exponent >= -9 and <= 9 */function SSF_small_exp(v/*:number*/)/*:string*/{var w=v<0?12:11;var o=SSF_strip_decimal(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return v.toExponential(5);}/* exponent >= 11 or <= -10 likely exponential */function SSF_large_exp(v/*:number*/)/*:string*/{var o=SSF_strip_decimal(v.toFixed(11));return o.length>(v<0?12:11)||o==="0"||o==="-0"?v.toPrecision(6):o;}function SSF_general_num(v/*:number*/)/*:string*/{var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=SSF_small_exp(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=SSF_large_exp(v);return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));}/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/function SSF_general(v/*:any*/,opts/*:any*/){switch(typeof v==="undefined"?"undefined":(0,_typeof3.default)(v)){case'string':return v;case'boolean':return v?"TRUE":"FALSE";case'number':return(v|0)===v?v.toString(10):SSF_general_num(v);case'undefined':return"";case'object':if(v==null)return"";if(v instanceof Date)return SSF_format(14,datenum_local(v,opts&&opts.date1904),opts);}throw new Error("unsupported value in General format: "+v);}function SSF_fix_hijri(date/*:Date*/,o/*:[number, number, number]*/){/* TODO: properly adjust y/m/d and  */o[0]-=581;var dow=date.getDay();if(date<60)dow=(dow+6)%7;return dow;}//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function SSF_write_date(type/*:number*/,fmt/*:string*/,val,ss0/*:?number*/)/*:string*/{var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:/* 'b' buddhist year */y=val.y+543;/* falls through */case 121:/* 'y' year */switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%10000;outl=4;break;}break;case 109:/* 'm' month */switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2];}break;case 100:/* 'd' day */switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1];}break;case 104:/* 'h' 12-hour */switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 72:/* 'H' 24-hour */switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw'bad hour format: '+fmt;}break;case 77:/* 'M' minutes */switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw'bad minute format: '+fmt;}break;case 115:/* 's' seconds */if(fmt!='s'&&fmt!='ss'&&fmt!='.0'&&fmt!='.00'&&fmt!='.000')throw'bad second format: '+fmt;if(val.u===0&&(fmt=="s"||fmt=="ss"))return pad0(val.S,fmt.length);/*::if(!ss0) ss0 = 0; */if(ss0>=2)tt=ss0===3?1000:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==='s')return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==='ss')return o.substr(0,2);return"."+o.substr(2,fmt.length-1);case 90:/* 'Z' absolute time */switch(fmt){case'[h]':case'[hh]':out=val.D*24+val.H;break;case'[m]':case'[mm]':out=(val.D*24+val.H)*60+val.M;break;case'[s]':case'[ss]':out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw'bad abstime format: '+fmt;}outl=fmt.length===3?1:2;break;case 101:/* 'e' era */out=y;outl=1;break;}var outstr=outl>0?pad0(out,outl):"";return outstr;}/*jshint -W086 *//*jshint +W086 */function commaify(s/*:string*/)/*:string*/{var w=3;if(s.length<=w)return s;var j=s.length%w,o=s.substr(0,j);for(;j!=s.length;j+=w){o+=(o.length>0?",":"")+s.substr(j,w);}return o;}var pct1=/%/g;function write_num_pct(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_cm(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_exp(fmt/*:string*/,val/*:number*/)/*:string*/{var o/*:string*/;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o.charAt(0)+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");}o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r/*:Array<string>*/,aval/*:number*/,sign/*:string*/)/*:string*/{var den=parseInt(r[4],10),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length));}function write_num_f2(r/*:Array<string>*/,aval/*:number*/,sign/*:string*/)/*:string*/{return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length);}var dec1=/^#*0*\.([0#]+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str/*:string*/)/*:string*/{var o="",cc;for(var i=0;i!=str.length;++i){switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc);}}return o;}function rnd(val/*:number*/,d/*:number*/)/*:string*/{var dd=Math.pow(10,d);return""+Math.round(val*dd)/dd;}function dec(val/*:number*/,d/*:number*/)/*:number*/{var _frac=val-Math.floor(val),dd=Math.pow(10,d);if(d<(''+Math.round(_frac*dd)).length)return 0;return Math.round(_frac*dd);}function carry(val/*:number*/,d/*:number*/)/*:number*/{if(d<(''+Math.round((val-Math.floor(val))*Math.pow(10,d))).length){return 1;}return 0;}function flr(val/*:number*/)/*:string*/{if(val<2147483647&&val>-2147483648)return""+(val>=0?val|0:val-1|0);return""+Math.floor(val);}function write_num_flt(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt('n',ffmt,val);return'('+write_num_flt('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r/*:?Array<string>*/,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",hashq(/*::(*/r/*::||[""])*/[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(pad0r(aval,0));if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+(Math.floor(val)+carry(val,r[1].length)))+"."+pad0(dec(val,r[1].length),r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_flt(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(/*::String(*/r[4]/*::)*/.length,7);ff=SSF_frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",/*::String(*/r[1]/*::)*/,ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+/*::String(*/r[2]/*::)*/+"/"+/*::String(*/r[3]/*::)*/;oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=SSF_frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0?]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(ri,r[1].length);}switch(fmt){case"###,##0.00":return write_num_flt(type,"#,##0.00",val);case"###,###":case"##,###":case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";case"###,###.00":return write_num_flt(type,"###,##0.00",val).replace(/^0\./,".");case"#,###.00":return write_num_flt(type,"#,##0.00",val).replace(/^0\./,".");default:}throw new Error("unsupported format |"+fmt+"|");}function write_num_cm2(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44){--idx;}return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)));}function write_num_pct2(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul);}function write_num_exp2(fmt/*:string*/,val/*:number*/)/*:string*/{var o/*:string*/;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){if(val==0)return"0.0E+0";else if(val<0)return"-"+write_num_exp2(fmt,-val);var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf('E');var ee=Math.floor(Math.log(val)*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(val)*Math.LOG10E);if(o.indexOf(".")===-1)o=o.charAt(0)+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-");}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E";});}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o.charAt(o.length-1);if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E");}function write_num_int(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int('n',ffmt,val);return'('+write_num_int('n',ffmt,-val)+')';}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf('%')!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf('E')!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);var o;var r/*:?Array<string>*/,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(frac1))return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/))return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if(r=fmt.match(dec1)){/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */o=(""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));o=o.replace(/\.(\d*)$/,function($$,$1){/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */return"."+$1+fill("0",hashq(r[1]).length-$1.length);});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");}fmt=fmt.replace(/^#+([0.])/,"$1");if(r=fmt.match(/^(0*)\.(#*)$/)){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");}if(r=fmt.match(/^#{1,3},##0(\.?)$/))return sign+commaify(""+aval);if(r=fmt.match(/^#,##0\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill('0',r[1].length);}if(r=fmt.match(/^#,#*,#0/))return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if(r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/)){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));}if(fmt.match(phone)){o=write_num_int(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6);}var oa="";if(r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(/*::String(*/r[4]/*::)*/.length,7);ff=SSF_frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",/*::String(*/r[1]/*::)*/,ff[1]);if(oa.charAt(oa.length-1)==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+/*::String(*/r[2]/*::)*/+"/"+/*::String(*/r[3]/*::)*/;oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o;}if(r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=SSF_frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length));}if(r=fmt.match(/^[#0?]+$/)){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o;}if(r=fmt.match(/^([#0]+)\.([#0]+)$/)){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres));}if(r=fmt.match(/^00,000\.([#0]*0)$/)){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$;})+"."+pad0(0,r[1].length);}switch(fmt){case"###,###":case"##,###":case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:if(fmt.match(/\.[0#?]*$/))return write_num_int(type,fmt.slice(0,fmt.lastIndexOf(".")),val)+hashq(fmt.slice(fmt.lastIndexOf(".")));}throw new Error("unsupported format |"+fmt+"|");}function write_num(type/*:string*/,fmt/*:string*/,val/*:number*/)/*:string*/{return(val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val);}function SSF_split_fmt(fmt/*:string*/)/*:Array<string>*/{var out/*:Array<string>*/=[];var in_str=false/*, cc*/;for(var i=0,j=0;i<fmt.length;++i){switch(/*cc=*/fmt.charCodeAt(i)){case 34:/* '"' */in_str=!in_str;break;case 95:case 42:case 92:/* '_' '*' '\\' */++i;break;case 59:/* ';' */out[out.length]=fmt.substr(j,i-j);j=i+1;}}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out;}var SSF_abstime=/\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;function fmt_is_date(fmt/*:string*/)/*:boolean*/{var i=0,/*cc = 0,*/c="",o="";while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':if(SSF_isgeneral(fmt,i))i+=6;i++;break;case'"':for(;/*cc=*/fmt.charCodeAt(++i)!==34&&i<fmt.length;){/*empty*/}++i;break;case'\\':i+=2;break;case'_':i+=2;break;case'@':++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2")return true;/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':return true;case'A':case'a':case'上':if(fmt.substr(i,3).toUpperCase()==="A/P")return true;if(fmt.substr(i,5).toUpperCase()==="AM/PM")return true;if(fmt.substr(i,5).toUpperCase()==="上午/下午")return true;++i;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length){o+=fmt.charAt(i);}if(o.match(SSF_abstime))return true;break;case'.':/* falls through */case'0':case'#':while(i<fmt.length&&("0#?.,E+-%".indexOf(c=fmt.charAt(++i))>-1||c=='\\'&&fmt.charAt(i+1)=="-"&&"0#".indexOf(fmt.charAt(i+2))>-1)){/* empty */}break;case'?':while(fmt.charAt(++i)===c){/* empty */}break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;case'(':case')':++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){/* empty */}break;case' ':++i;break;default:++i;break;}}return false;}function eval_fmt(fmt/*:string*/,v/*:any*/,opts/*:any*/,flen/*:number*/){var out=[],o="",i=0,c="",lst='t',dt,j,cc;var hr='H';/* Tokenize */while(i<fmt.length){switch(c=fmt.charAt(i)){case'G':/* General */if(!SSF_isgeneral(fmt,i))throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'G',v:'General'};i+=7;break;case'"':/* Literal text */for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;){o+=String.fromCharCode(cc);}out[out.length]={t:'t',v:o};++i;break;case'\\':var w=fmt.charAt(++i),t=w==="("||w===")"?w:'t';out[out.length]={t:t,v:w};++i;break;case'_':out[out.length]={t:'t',v:" "};i+=2;break;case'@':/* Text Placeholder */out[out.length]={t:'T',v:v};++i;break;case'B':case'b':if(fmt.charAt(i+1)==="1"||fmt.charAt(i+1)==="2"){if(dt==null){dt=SSF_parse_date_code(v,opts,fmt.charAt(i+1)==="2");if(dt==null)return"";}out[out.length]={t:'X',v:fmt.substr(i,2)};lst=c;i+=2;break;}/* falls through */case'M':case'D':case'Y':case'H':case'S':case'E':c=c.toLowerCase();/* falls through */case'm':case'd':case'y':case'h':case's':case'e':case'g':if(v<0)return"";if(dt==null){dt=SSF_parse_date_code(v,opts);if(dt==null)return"";}o=c;while(++i<fmt.length&&fmt.charAt(i).toLowerCase()===c){o+=c;}if(c==='m'&&lst.toLowerCase()==='h')c='M';if(c==='h')c=hr;out[out.length]={t:c,v:o};lst=c;break;case'A':case'a':case'上':var q={t:c,v:c};if(dt==null)dt=SSF_parse_date_code(v,opts);if(fmt.substr(i,3).toUpperCase()==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t='T';hr='h';i+=3;}else if(fmt.substr(i,5).toUpperCase()==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t='T';i+=5;hr='h';}else if(fmt.substr(i,5).toUpperCase()==="上午/下午"){if(dt!=null)q.v=dt.H>=12?"下午":"上午";q.t='T';i+=5;hr='h';}else{q.t="t";++i;}if(dt==null&&q.t==='T')return"";out[out.length]=q;lst=c;break;case'[':o=c;while(fmt.charAt(i++)!==']'&&i<fmt.length){o+=fmt.charAt(i);}if(o.slice(-1)!==']')throw'unterminated "[" block: |'+o+'|';if(o.match(SSF_abstime)){if(dt==null){dt=SSF_parse_date_code(v,opts);if(dt==null)return"";}out[out.length]={t:'Z',v:o.toLowerCase()};lst=o.charAt(1);}else if(o.indexOf("$")>-1){o=(o.match(/\$([^-\[\]]*)/)||[])[1]||"$";if(!fmt_is_date(fmt))out[out.length]={t:'t',v:o};}break;/* Numbers */case'.':if(dt!=null){o=c;while(++i<fmt.length&&(c=fmt.charAt(i))==="0"){o+=c;}out[out.length]={t:'s',v:o};break;}/* falls through */case'0':case'#':o=c;while(++i<fmt.length&&"0#?.,E+-%".indexOf(c=fmt.charAt(i))>-1){o+=c;}out[out.length]={t:'n',v:o};break;case'?':o=c;while(fmt.charAt(++i)===c){o+=c;}out[out.length]={t:c,v:o};lst=c;break;case'*':++i;if(fmt.charAt(i)==' '||fmt.charAt(i)=='*')++i;break;// **
case'(':case')':out[out.length]={t:flen===1?'t':c,v:c};++i;break;case'1':case'2':case'3':case'4':case'5':case'6':case'7':case'8':case'9':o=c;while(i<fmt.length&&"0123456789".indexOf(fmt.charAt(++i))>-1){o+=fmt.charAt(i);}out[out.length]={t:'D',v:o};break;case' ':out[out.length]={t:c,v:c};++i;break;case'$':out[out.length]={t:'t',v:'$'};++i;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c)===-1)throw new Error('unrecognized character '+c+' in '+fmt);out[out.length]={t:'t',v:c};++i;break;}}/* Scan for date/time parts */var bt=0,ss0=0,ssm;for(i=out.length-1,lst='t';i>=0;--i){switch(out[i].t){case'h':case'H':out[i].t=hr;lst='h';if(bt<1)bt=1;break;case's':if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;/* falls through */case'd':case'y':case'M':case'e':lst=out[i].t;break;case'm':if(lst==='s'){out[i].t='M';if(bt<2)bt=2;}break;case'X':/*if(out[i].v === "B2");*/break;case'Z':if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3;}}/* time rounding depends on presence of minute / second / usec fields */switch(bt){case 0:break;case 1:/*::if(!dt) break;*/if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}if(dt.M>=60){dt.M=0;++dt.H;}break;case 2:/*::if(!dt) break;*/if(dt.u>=0.5){dt.u=0;++dt.S;}if(dt.S>=60){dt.S=0;++dt.M;}break;}/* replace fields */var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case't':case'T':case' ':case'D':break;case'X':out[i].v="";out[i].t=";";break;case'd':case'm':case'y':case'h':case'H':case'M':case's':case'e':case'b':case'Z':/*::if(!dt) throw "unreachable"; */out[i].v=SSF_write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t='t';break;case'n':case'?':jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==='?'||out[jj+1].t==="t"&&out[jj+1].v==='/')||out[i].t==='('&&(c===' '||c==='n'||c===')')||c==='t'&&(out[jj].v==='/'||out[jj].v===' '&&out[jj+1]!=null&&out[jj+1].t=='?'))){out[i].v+=out[jj].v;out[jj]={v:"",t:";"};++jj;}nstr+=out[i].v;i=jj-1;break;case'G':out[i].t='t';out[i].v=SSF_general(v,opts);break;}}var vv="",myv,ostr;if(nstr.length>0){if(nstr.charCodeAt(0)==40)/* '(' */{myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num('n',nstr,myv);}else{myv=v<0&&flen>1?-v:v;ostr=write_num('n',nstr,myv);if(myv<0&&out[0]&&out[0].t=='t'){ostr=ostr.substr(1);out[0].v="-"+out[0].v;}}jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i){if(out[i]!=null&&out[i].t!='t'&&out[i].v.indexOf(".")>-1){decpt=i;break;}}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length);}else if(jj<0)out[i].v="";else{out[i].v=ostr.substr(0,jj+1);jj=-1;}out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||'n?'.indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v.charAt(j)==="0"||out[i].v.charAt(j)==="#"))vv=ostr.charAt(jj--)+vv;}out[i].v=vv;out[i].t='t';lasti=i;}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||'n?('.indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr.charAt(jj++);}out[i].v=vv;out[i].t='t';lasti=i;}}}for(i=0;i<out.length;++i){if(out[i]!=null&&'n?'.indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t='t';}}var retval="";for(i=0;i!==out.length;++i){if(out[i]!=null)retval+=out[i].v;}return retval;}var cfregex2=/\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break;}return false;}function choose_fmt(f/*:string*/,v/*:any*/){var fmt=SSF_split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw new Error("cannot find right format for |"+fmt.join("|")+"|");if(typeof v!=="number")return[4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;case 4:break;}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return[l,ff];if(fmt[0].match(/\[[=<>]/)!=null||fmt[1].match(/\[[=<>]/)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]];}return[l,ff];}function SSF_format(fmt/*:string|number*/,v/*:any*/,o/*:?any*/){if(o==null)o={};var sfmt="";switch(typeof fmt==="undefined"?"undefined":(0,_typeof3.default)(fmt)){case"string":if(fmt=="m/d/yy"&&o.dateNF)sfmt=o.dateNF;else sfmt=fmt;break;case"number":if(fmt==14&&o.dateNF)sfmt=o.dateNF;else sfmt=(o.table!=null?o.table/*:any*/:table_fmt)[fmt];if(sfmt==null)sfmt=o.table&&o.table[SSF_default_map[fmt]]||table_fmt[SSF_default_map[fmt]];if(sfmt==null)sfmt=SSF_default_str[fmt]||"General";break;}if(SSF_isgeneral(sfmt,0))return SSF_general(v,o);if(v instanceof Date)v=datenum_local(v,o.date1904);var f=choose_fmt(sfmt,v);if(SSF_isgeneral(f[1]))return SSF_general(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return"";return eval_fmt(f[1],v,o,f[0]);}function SSF_load(fmt/*:string*/,idx/*:?number*/)/*:number*/{if(typeof idx!='number'){idx=+idx||-1;/*::if(typeof idx != 'number') return 0x188; */for(var i=0;i<0x0188;++i){/*::if(typeof idx != 'number') return 0x188; */if(table_fmt[i]==undefined){if(idx<0)idx=i;continue;}if(table_fmt[i]==fmt){idx=i;break;}}/*::if(typeof idx != 'number') return 0x188; */if(idx<0)idx=0x187;}/*::if(typeof idx != 'number') return 0x188; */table_fmt[idx]=fmt;return idx;}function SSF_load_table(tbl/*:SSFTable*/)/*:void*/{for(var i=0;i!=0x0188;++i){if(tbl[i]!==undefined)SSF_load(tbl[i],i);}}function make_ssf(){table_fmt=SSF_init_table();}var SSF={format:SSF_format,load:SSF_load,_table:table_fmt,load_table:SSF_load_table,parse_date_code:SSF_parse_date_code,is_date:fmt_is_date,get_table:function get_table(){return SSF._table=table_fmt;}};var SSFImplicit/*{[number]:string}*/={"5":'"$"#,##0_);\\("$"#,##0\\)',"6":'"$"#,##0_);[Red]\\("$"#,##0\\)',"7":'"$"#,##0.00_);\\("$"#,##0.00\\)',"8":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"23":'General',"24":'General',"25":'General',"26":'General',"27":'m/d/yy',"28":'m/d/yy',"29":'m/d/yy',"30":'m/d/yy',"31":'m/d/yy',"32":'h:mm:ss',"33":'h:mm:ss',"34":'h:mm:ss',"35":'h:mm:ss',"36":'m/d/yy',"41":'_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',"42":'_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',"43":'_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',"44":'_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',"50":'m/d/yy',"51":'m/d/yy',"52":'m/d/yy',"53":'m/d/yy',"54":'m/d/yy',"55":'m/d/yy',"56":'m/d/yy',"57":'m/d/yy',"58":'m/d/yy',"59":'0',"60":'0.00',"61":'#,##0',"62":'#,##0.00',"63":'"$"#,##0_);\\("$"#,##0\\)',"64":'"$"#,##0_);[Red]\\("$"#,##0\\)',"65":'"$"#,##0.00_);\\("$"#,##0.00\\)',"66":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"67":'0%',"68":'0.00%',"69":'# ?/?',"70":'# ??/??',"71":'m/d/yy',"72":'m/d/yy',"73":'d-mmm-yy',"74":'d-mmm',"75":'mmm-yy',"76":'h:mm',"77":'h:mm:ss',"78":'m/d/yy h:mm',"79":'mm:ss',"80":'[h]:mm:ss',"81":'mmss.0'/*:any*/};/* dateNF parse TODO: move to SSF */var dateNFregex=/[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;function dateNF_regex(dateNF/*:string|number*/)/*:RegExp*/{var fmt=typeof dateNF=="number"?table_fmt[dateNF]:dateNF;fmt=fmt.replace(dateNFregex,"(\\d+)");return new RegExp("^"+fmt+"$");}function dateNF_fix(str/*:string*/,dateNF/*:string*/,match/*:Array<string>*/)/*:string*/{var Y=-1,m=-1,d=-1,H=-1,M=-1,S=-1;(dateNF.match(dateNFregex)||[]).forEach(function(n,i){var v=parseInt(match[i+1],10);switch(n.toLowerCase().charAt(0)){case'y':Y=v;break;case'd':d=v;break;case'h':H=v;break;case's':S=v;break;case'm':if(H>=0)M=v;else m=v;break;}});if(S>=0&&M==-1&&m>=0){M=m;m=-1;}var datestr=(""+(Y>=0?Y:new Date().getFullYear())).slice(-4)+"-"+("00"+(m>=1?m:1)).slice(-2)+"-"+("00"+(d>=1?d:1)).slice(-2);if(datestr.length==7)datestr="0"+datestr;if(datestr.length==8)datestr="20"+datestr;var timestr=("00"+(H>=0?H:0)).slice(-2)+":"+("00"+(M>=0?M:0)).slice(-2)+":"+("00"+(S>=0?S:0)).slice(-2);if(H==-1&&M==-1&&S==-1)return datestr;if(Y==-1&&m==-1&&d==-1)return timestr;return datestr+"T"+timestr;}/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*//* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com *//* vim: set ts=2: *//*jshint eqnull:true *//*exported CFB *//*global Uint8Array:false, Uint16Array:false *//*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*//* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com *//* vim: set ts=2: *//*exported CRC32 */var CRC32=/*#__PURE__*/function(){var CRC32={};CRC32.version='1.2.0';/* see perf/crc32table.js *//*global Int32Array */function signed_crc_table()/*:any*/{var c=0,table/*:Array<number>*/=new Array(256);for(var n=0;n!=256;++n){c=n;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;c=c&1?-306674912^c>>>1:c>>>1;table[n]=c;}return typeof Int32Array!=='undefined'?new Int32Array(table):table;}var T0=signed_crc_table();function slice_by_16_tables(T){var c=0,v=0,n=0,table/*:Array<number>*/=typeof Int32Array!=='undefined'?new Int32Array(4096):new Array(4096);for(n=0;n!=256;++n){table[n]=T[n];}for(n=0;n!=256;++n){v=T[n];for(c=256+n;c<4096;c+=256){v=table[c]=v>>>8^T[v&0xFF];}}var out=[];for(n=1;n!=16;++n){out[n-1]=typeof Int32Array!=='undefined'?table.subarray(n*256,n*256+256):table.slice(n*256,n*256+256);}return out;}var TT=slice_by_16_tables(T0);var T1=TT[0],T2=TT[1],T3=TT[2],T4=TT[3],T5=TT[4];var T6=TT[5],T7=TT[6],T8=TT[7],T9=TT[8],Ta=TT[9];var Tb=TT[10],Tc=TT[11],Td=TT[12],Te=TT[13],Tf=TT[14];function crc32_bstr(bstr/*:string*/,seed/*:number*/)/*:number*/{var C=seed/*:: ? 0 : 0 */^-1;for(var i=0,L=bstr.length;i<L;){C=C>>>8^T0[(C^bstr.charCodeAt(i++))&0xFF];}return~C;}function crc32_buf(B/*:Uint8Array|Array<number>*/,seed/*:number*/)/*:number*/{var C=seed/*:: ? 0 : 0 */^-1,L=B.length-15,i=0;for(;i<L;){C=Tf[B[i++]^C&255]^Te[B[i++]^C>>8&255]^Td[B[i++]^C>>16&255]^Tc[B[i++]^C>>>24]^Tb[B[i++]]^Ta[B[i++]]^T9[B[i++]]^T8[B[i++]]^T7[B[i++]]^T6[B[i++]]^T5[B[i++]]^T4[B[i++]]^T3[B[i++]]^T2[B[i++]]^T1[B[i++]]^T0[B[i++]];}L+=15;while(i<L){C=C>>>8^T0[(C^B[i++])&0xFF];}return~C;}function crc32_str(str/*:string*/,seed/*:number*/)/*:number*/{var C=seed^-1;for(var i=0,L=str.length,c=0,d=0;i<L;){c=str.charCodeAt(i++);if(c<0x80){C=C>>>8^T0[(C^c)&0xFF];}else if(c<0x800){C=C>>>8^T0[(C^(192|c>>6&31))&0xFF];C=C>>>8^T0[(C^(128|c&63))&0xFF];}else if(c>=0xD800&&c<0xE000){c=(c&1023)+64;d=str.charCodeAt(i++)&1023;C=C>>>8^T0[(C^(240|c>>8&7))&0xFF];C=C>>>8^T0[(C^(128|c>>2&63))&0xFF];C=C>>>8^T0[(C^(128|d>>6&15|(c&3)<<4))&0xFF];C=C>>>8^T0[(C^(128|d&63))&0xFF];}else{C=C>>>8^T0[(C^(224|c>>12&15))&0xFF];C=C>>>8^T0[(C^(128|c>>6&63))&0xFF];C=C>>>8^T0[(C^(128|c&63))&0xFF];}}return~C;}CRC32.table=T0;CRC32.bstr=crc32_bstr;CRC32.buf=crc32_buf;CRC32.str=crc32_str;return CRC32;}();/* [MS-CFB] v20171201 */var CFB=/*#__PURE__*/function _CFB(){var exports={};exports.version='1.2.1';/* [MS-CFB] 2.6.4 */function namecmp(l/*:string*/,r/*:string*/)/*:number*/{var L=l.split("/"),R=r.split("/");for(var i=0,c=0,Z=Math.min(L.length,R.length);i<Z;++i){if(c=L[i].length-R[i].length)return c;if(L[i]!=R[i])return L[i]<R[i]?-1:1;}return L.length-R.length;}function dirname(p/*:string*/)/*:string*/{if(p.charAt(p.length-1)=="/")return p.slice(0,-1).indexOf("/")===-1?p:dirname(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(0,c+1);}function filename(p/*:string*/)/*:string*/{if(p.charAt(p.length-1)=="/")return filename(p.slice(0,-1));var c=p.lastIndexOf("/");return c===-1?p:p.slice(c+1);}/* -------------------------------------------------------------------------- *//* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*//* write JS date to buf as a DOS date */function write_dos_date(buf/*:CFBlob*/,date/*:Date|string*/){if(typeof date==="string")date=new Date(date);var hms/*:number*/=date.getHours();hms=hms<<6|date.getMinutes();hms=hms<<5|date.getSeconds()>>>1;buf.write_shift(2,hms);var ymd/*:number*/=date.getFullYear()-1980;ymd=ymd<<4|date.getMonth()+1;ymd=ymd<<5|date.getDate();buf.write_shift(2,ymd);}/* read four bytes from buf and interpret as a DOS date */function parse_dos_date(buf/*:CFBlob*/)/*:Date*/{var hms=buf.read_shift(2)&0xFFFF;var ymd=buf.read_shift(2)&0xFFFF;var val=new Date();var d=ymd&0x1F;ymd>>>=5;var m=ymd&0x0F;ymd>>>=4;val.setMilliseconds(0);val.setFullYear(ymd+1980);val.setMonth(m-1);val.setDate(d);var S=hms&0x1F;hms>>>=5;var M=hms&0x3F;hms>>>=6;val.setHours(hms);val.setMinutes(M);val.setSeconds(S<<1);return val;}function parse_extra_field(blob/*:CFBlob*/)/*:any*/{prep_blob(blob,0);var o=/*::(*/{}/*:: :any)*/;var flags=0;while(blob.l<=blob.length-4){var type=blob.read_shift(2);var sz=blob.read_shift(2),tgt=blob.l+sz;var p={};switch(type){/* UNIX-style Timestamps */case 0x5455:{flags=blob.read_shift(1);if(flags&1)p.mtime=blob.read_shift(4);/* for some reason, CD flag corresponds to LFH */if(sz>5){if(flags&2)p.atime=blob.read_shift(4);if(flags&4)p.ctime=blob.read_shift(4);}if(p.mtime)p.mt=new Date(p.mtime*1000);}break;}blob.l=tgt;o[type]=p;}return o;}var fs/*:: = require('fs'); */;function get_fs(){return fs||(fs={});}function parse(file/*:RawBytes*/,options/*:CFBReadOpts*/)/*:CFBContainer*/{if(file[0]==0x50&&file[1]==0x4b)return parse_zip(file,options);if((file[0]|0x20)==0x6d&&(file[1]|0x20)==0x69)return parse_mad(file,options);if(file.length<512)throw new Error("CFB file size "+file.length+" < 512");var mver=3;var ssz=512;var nmfs=0;// number of mini FAT sectors
var difat_sec_cnt=0;var dir_start=0;var minifat_start=0;var difat_start=0;var fat_addrs/*:Array<number>*/=[];// locations of FAT sectors
/* [MS-CFB] 2.2 Compound File Header */var blob/*:CFBlob*/=/*::(*/file.slice(0,512)/*:: :any)*/;prep_blob(blob,0);/* major version */var mv=check_get_mver(blob);mver=mv[0];switch(mver){case 3:ssz=512;break;case 4:ssz=4096;break;case 0:if(mv[1]==0)return parse_zip(file,options);/* falls through */default:throw new Error("Major Version: Expected 3 or 4 saw "+mver);}/* reprocess header */if(ssz!==512){blob=/*::(*/file.slice(0,ssz)/*:: :any)*/;prep_blob(blob,28/* blob.l */);}/* Save header for final object */var header/*:RawBytes*/=file.slice(0,ssz);check_shifts(blob,mver);// Number of Directory Sectors
var dir_cnt/*:number*/=blob.read_shift(4,'i');if(mver===3&&dir_cnt!==0)throw new Error('# Directory Sectors: Expected 0 saw '+dir_cnt);// Number of FAT Sectors
blob.l+=4;// First Directory Sector Location
dir_start=blob.read_shift(4,'i');// Transaction Signature
blob.l+=4;// Mini Stream Cutoff Size
blob.chk('00100000','Mini Stream Cutoff Size: ');// First Mini FAT Sector Location
minifat_start=blob.read_shift(4,'i');// Number of Mini FAT Sectors
nmfs=blob.read_shift(4,'i');// First DIFAT sector location
difat_start=blob.read_shift(4,'i');// Number of DIFAT Sectors
difat_sec_cnt=blob.read_shift(4,'i');// Grab FAT Sector Locations
for(var q=-1,j=0;j<109;++j){/* 109 = (512 - blob.l)>>>2; */q=blob.read_shift(4,'i');if(q<0)break;fat_addrs[j]=q;}/** Break the file up into sectors */var sectors/*:Array<RawBytes>*/=sectorify(file,ssz);sleuth_fat(difat_start,difat_sec_cnt,sectors,ssz,fat_addrs);/** Chains */var sector_list/*:SectorList*/=make_sector_list(sectors,dir_start,fat_addrs,ssz);sector_list[dir_start].name="!Directory";if(nmfs>0&&minifat_start!==ENDOFCHAIN)sector_list[minifat_start].name="!MiniFAT";sector_list[fat_addrs[0]].name="!FAT";sector_list.fat_addrs=fat_addrs;sector_list.ssz=ssz;/* [MS-CFB] 2.6.1 Compound File Directory Entry */var files/*:CFBFiles*/={},Paths/*:Array<string>*/=[],FileIndex/*:CFBFileIndex*/=[],FullPaths/*:Array<string>*/=[];read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex,minifat_start);build_full_paths(FileIndex,FullPaths,Paths);Paths.shift();var o={FileIndex:FileIndex,FullPaths:FullPaths};// $FlowIgnore
if(options&&options.raw)o.raw={header:header,sectors:sectors};return o;}// parse
/* [MS-CFB] 2.2 Compound File Header -- read up to major version */function check_get_mver(blob/*:CFBlob*/)/*:[number, number]*/{if(blob[blob.l]==0x50&&blob[blob.l+1]==0x4b)return[0,0];// header signature 8
blob.chk(HEADER_SIGNATURE,'Header Signature: ');// clsid 16
//blob.chk(HEADER_CLSID, 'CLSID: ');
blob.l+=16;// minor version 2
var mver/*:number*/=blob.read_shift(2,'u');return[blob.read_shift(2,'u'),mver];}function check_shifts(blob/*:CFBlob*/,mver/*:number*/)/*:void*/{var shift=0x09;// Byte Order
//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
blob.l+=2;// Sector Shift
switch(shift=blob.read_shift(2)){case 0x09:if(mver!=3)throw new Error('Sector Shift: Expected 9 saw '+shift);break;case 0x0c:if(mver!=4)throw new Error('Sector Shift: Expected 12 saw '+shift);break;default:throw new Error('Sector Shift: Expected 9 or 12 saw '+shift);}// Mini Sector Shift
blob.chk('0600','Mini Sector Shift: ');// Reserved
blob.chk('000000000000','Reserved: ');}/** Break the file up into sectors */function sectorify(file/*:RawBytes*/,ssz/*:number*/)/*:Array<RawBytes>*/{var nsectors=Math.ceil(file.length/ssz)-1;var sectors/*:Array<RawBytes>*/=[];for(var i=1;i<nsectors;++i){sectors[i-1]=file.slice(i*ssz,(i+1)*ssz);}sectors[nsectors-1]=file.slice(nsectors*ssz);return sectors;}/* [MS-CFB] 2.6.4 Red-Black Tree */function build_full_paths(FI/*:CFBFileIndex*/,FP/*:Array<string>*/,Paths/*:Array<string>*/)/*:void*/{var i=0,L=0,R=0,C=0,j=0,pl=Paths.length;var dad/*:Array<number>*/=[],q/*:Array<number>*/=[];for(;i<pl;++i){dad[i]=q[i]=i;FP[i]=Paths[i];}for(;j<q.length;++j){i=q[j];L=FI[i].L;R=FI[i].R;C=FI[i].C;if(dad[i]===i){if(L!==-1/*NOSTREAM*/&&dad[L]!==L)dad[i]=dad[L];if(R!==-1&&dad[R]!==R)dad[i]=dad[R];}if(C!==-1/*NOSTREAM*/)dad[C]=i;if(L!==-1&&i!=dad[i]){dad[L]=dad[i];if(q.lastIndexOf(L)<j)q.push(L);}if(R!==-1&&i!=dad[i]){dad[R]=dad[i];if(q.lastIndexOf(R)<j)q.push(R);}}for(i=1;i<pl;++i){if(dad[i]===i){if(R!==-1/*NOSTREAM*/&&dad[R]!==R)dad[i]=dad[R];else if(L!==-1&&dad[L]!==L)dad[i]=dad[L];}}for(i=1;i<pl;++i){if(FI[i].type===0/* unknown */)continue;j=i;if(j!=dad[j])do{j=dad[j];FP[i]=FP[j]+"/"+FP[i];}while(j!==0&&-1!==dad[j]&&j!=dad[j]);dad[i]=-1;}FP[0]+="/";for(i=1;i<pl;++i){if(FI[i].type!==2/* stream */)FP[i]+="/";}}function get_mfat_entry(entry/*:CFBEntry*/,payload/*:RawBytes*/,mini/*:?RawBytes*/)/*:CFBlob*/{var start=entry.start,size=entry.size;//return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
var o=[];var idx=start;while(mini&&size>0&&idx>=0){o.push(payload.slice(idx*MSSZ,idx*MSSZ+MSSZ));size-=MSSZ;idx=__readInt32LE(mini,idx*4);}if(o.length===0)return new_buf(0)/*:any*/;return bconcat(o).slice(0,entry.size)/*:any*/;}/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */function sleuth_fat(idx/*:number*/,cnt/*:number*/,sectors/*:Array<RawBytes>*/,ssz/*:number*/,fat_addrs)/*:void*/{var q/*:number*/=ENDOFCHAIN;if(idx===ENDOFCHAIN){if(cnt!==0)throw new Error("DIFAT chain shorter than expected");}else if(idx!==-1/*FREESECT*/){var sector=sectors[idx],m=(ssz>>>2)-1;if(!sector)return;for(var i=0;i<m;++i){if((q=__readInt32LE(sector,i*4))===ENDOFCHAIN)break;fat_addrs.push(q);}sleuth_fat(__readInt32LE(sector,ssz-4),cnt-1,sectors,ssz,fat_addrs);}}/** Follow the linked list of sectors for a given starting point */function get_sector_list(sectors/*:Array<RawBytes>*/,start/*:number*/,fat_addrs/*:Array<number>*/,ssz/*:number*/,chkd/*:?Array<boolean>*/)/*:SectorEntry*/{var buf/*:Array<number>*/=[],buf_chain/*:Array<any>*/=[];if(!chkd)chkd=[];var modulus=ssz-1,j=0,jj=0;for(j=start;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);}return{nodes:buf,data:__toBuffer([buf_chain])};}/** Chase down the sector linked lists */function make_sector_list(sectors/*:Array<RawBytes>*/,dir_start/*:number*/,fat_addrs/*:Array<number>*/,ssz/*:number*/)/*:SectorList*/{var sl=sectors.length,sector_list/*:SectorList*/=[]/*:any*/;var chkd/*:Array<boolean>*/=[],buf/*:Array<number>*/=[],buf_chain/*:Array<RawBytes>*/=[];var modulus=ssz-1,i=0,j=0,k=0,jj=0;for(i=0;i<sl;++i){buf=[]/*:Array<number>*/;k=i+dir_start;if(k>=sl)k-=sl;if(chkd[k])continue;buf_chain=[];var seen=[];for(j=k;j>=0;){seen[j]=true;chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr/*:number*/=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw new Error("FAT boundary crossed: "+j+" 4 "+ssz);if(!sectors[addr])break;j=__readInt32LE(sectors[addr],jj);if(seen[j])break;}sector_list[k]={nodes:buf,data:__toBuffer([buf_chain])/*:SectorEntry*/};}return sector_list;}/* [MS-CFB] 2.6.1 Compound File Directory Entry */function read_directory(dir_start/*:number*/,sector_list/*:SectorList*/,sectors/*:Array<RawBytes>*/,Paths/*:Array<string>*/,nmfs,files,FileIndex,mini){var minifat_store=0,pl=Paths.length?2:0;var sector=sector_list[dir_start].data;var i=0,namelen=0,name;for(;i<sector.length;i+=128){var blob/*:CFBlob*/=/*::(*/sector.slice(i,i+128)/*:: :any)*/;prep_blob(blob,64);namelen=blob.read_shift(2);name=__utf16le(blob,0,namelen-pl);Paths.push(name);var o/*:CFBEntry*/={name:name,type:blob.read_shift(1),color:blob.read_shift(1),L:blob.read_shift(4,'i'),R:blob.read_shift(4,'i'),C:blob.read_shift(4,'i'),clsid:blob.read_shift(16),state:blob.read_shift(4,'i'),start:0,size:0};var ctime/*:number*/=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(ctime!==0)o.ct=read_date(blob,blob.l-8);var mtime/*:number*/=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(mtime!==0)o.mt=read_date(blob,blob.l-8);o.start=blob.read_shift(4,'i');o.size=blob.read_shift(4,'i');if(o.size<0&&o.start<0){o.size=o.type=0;o.start=ENDOFCHAIN;o.name="";}if(o.type===5){/* root */minifat_store=o.start;if(nmfs>0&&minifat_store!==ENDOFCHAIN)sector_list[minifat_store].name="!StreamData";/*minifat_size = o.size;*/}else if(o.size>=4096/* MSCSZ */){o.storage='fat';if(sector_list[o.start]===undefined)sector_list[o.start]=get_sector_list(sectors,o.start,sector_list.fat_addrs,sector_list.ssz);sector_list[o.start].name=o.name;o.content=sector_list[o.start].data.slice(0,o.size)/*:any*/;}else{o.storage='minifat';if(o.size<0)o.size=0;else if(minifat_store!==ENDOFCHAIN&&o.start!==ENDOFCHAIN&&sector_list[minifat_store]){o.content=get_mfat_entry(o,sector_list[minifat_store].data,(sector_list[mini]||{}).data);}}if(o.content)prep_blob(o.content,0);files[name]=o;FileIndex.push(o);}}function read_date(blob/*:RawBytes|CFBlob*/,offset/*:number*/)/*:Date*/{return new Date((__readUInt32LE(blob,offset+4)/1e7*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7-11644473600)*1000);}function read_file(filename/*:string*/,options/*:CFBReadOpts*/){get_fs();return parse(fs.readFileSync(filename),options);}function read(blob/*:RawBytes|string*/,options/*:CFBReadOpts*/){var type=options&&options.type;if(!type){if(has_buf&&Buffer.isBuffer(blob))type="buffer";}switch(type||"base64"){case"file":/*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */return read_file(blob,options);case"base64":/*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */return parse(s2a(Base64_decode(blob)),options);case"binary":/*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */return parse(s2a(blob),options);}return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */blob,options);}function init_cfb(cfb/*:CFBContainer*/,opts/*:?any*/)/*:void*/{var o=opts||{},root=o.root||"Root Entry";if(!cfb.FullPaths)cfb.FullPaths=[];if(!cfb.FileIndex)cfb.FileIndex=[];if(cfb.FullPaths.length!==cfb.FileIndex.length)throw new Error("inconsistent CFB structure");if(cfb.FullPaths.length===0){cfb.FullPaths[0]=root+"/";cfb.FileIndex[0]={name:root,type:5/*:any*/};}if(o.CLSID)cfb.FileIndex[0].clsid=o.CLSID;seed_cfb(cfb);}function seed_cfb(cfb/*:CFBContainer*/)/*:void*/{var nm="\x01Sh33tJ5";if(CFB.find(cfb,"/"+nm))return;var p=new_buf(4);p[0]=55;p[1]=p[3]=50;p[2]=54;cfb.FileIndex.push({name:nm,type:2,content:p,size:4,L:69,R:69,C:69/*:any*/});cfb.FullPaths.push(cfb.FullPaths[0]+nm);rebuild_cfb(cfb);}function rebuild_cfb(cfb/*:CFBContainer*/,f/*:?boolean*/)/*:void*/{init_cfb(cfb);var gc=false,s=false;for(var i=cfb.FullPaths.length-1;i>=0;--i){var _file=cfb.FileIndex[i];switch(_file.type){case 0:if(s)gc=true;else{cfb.FileIndex.pop();cfb.FullPaths.pop();}break;case 1:case 2:case 5:s=true;if(isNaN(_file.R*_file.L*_file.C))gc=true;if(_file.R>-1&&_file.L>-1&&_file.R==_file.L)gc=true;break;default:gc=true;break;}}if(!gc&&!f)return;var now=new Date(1987,1,19),j=0;// Track which names exist
var fullPaths=_create2.default?(0,_create2.default)(null):{};var data/*:Array<[string, CFBEntry]>*/=[];for(i=0;i<cfb.FullPaths.length;++i){fullPaths[cfb.FullPaths[i]]=true;if(cfb.FileIndex[i].type===0)continue;data.push([cfb.FullPaths[i],cfb.FileIndex[i]]);}for(i=0;i<data.length;++i){var dad=dirname(data[i][0]);s=fullPaths[dad];if(!s){data.push([dad,{name:filename(dad).replace("/",""),type:1,clsid:HEADER_CLSID,ct:now,mt:now,content:null/*:any*/}]);// Add name to set
fullPaths[dad]=true;}}data.sort(function(x,y){return namecmp(x[0],y[0]);});cfb.FullPaths=[];cfb.FileIndex=[];for(i=0;i<data.length;++i){cfb.FullPaths[i]=data[i][0];cfb.FileIndex[i]=data[i][1];}for(i=0;i<data.length;++i){var elt=cfb.FileIndex[i];var nm=cfb.FullPaths[i];elt.name=filename(nm).replace("/","");elt.L=elt.R=elt.C=-(elt.color=1);elt.size=elt.content?elt.content.length:0;elt.start=0;elt.clsid=elt.clsid||HEADER_CLSID;if(i===0){elt.C=data.length>1?1:-1;elt.size=0;elt.type=5;}else if(nm.slice(-1)=="/"){for(j=i+1;j<data.length;++j){if(dirname(cfb.FullPaths[j])==nm)break;}elt.C=j>=data.length?-1:j;for(j=i+1;j<data.length;++j){if(dirname(cfb.FullPaths[j])==dirname(nm))break;}elt.R=j>=data.length?-1:j;elt.type=1;}else{if(dirname(cfb.FullPaths[i+1]||"")==dirname(nm))elt.R=i+1;elt.type=2;}}}function _write(cfb/*:CFBContainer*/,options/*:CFBWriteOpts*/)/*:RawBytes|string*/{var _opts=options||{};/* MAD is order-sensitive, skip rebuild and sort */if(_opts.fileType=='mad')return write_mad(cfb,_opts);rebuild_cfb(cfb);switch(_opts.fileType){case'zip':return write_zip(cfb,_opts);//case 'mad': return write_mad(cfb, _opts);
}var L=function(cfb/*:CFBContainer*/)/*:Array<number>*/{var mini_size=0,fat_size=0;for(var i=0;i<cfb.FileIndex.length;++i){var file=cfb.FileIndex[i];if(!file.content)continue;/*:: if(file.content == null) throw new Error("unreachable"); */var flen=file.content.length;if(flen>0){if(flen<0x1000)mini_size+=flen+0x3F>>6;else fat_size+=flen+0x01FF>>9;}}var dir_cnt=cfb.FullPaths.length+3>>2;var mini_cnt=mini_size+7>>3;var mfat_cnt=mini_size+0x7F>>7;var fat_base=mini_cnt+fat_size+dir_cnt+mfat_cnt;var fat_cnt=fat_base+0x7F>>7;var difat_cnt=fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);while(fat_base+fat_cnt+difat_cnt+0x7F>>7>fat_cnt){difat_cnt=++fat_cnt<=109?0:Math.ceil((fat_cnt-109)/0x7F);}var L=[1,difat_cnt,fat_cnt,mfat_cnt,dir_cnt,fat_size,mini_size,0];cfb.FileIndex[0].size=mini_size<<6;L[7]=(cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+(L[6]+7>>3);return L;}(cfb);var o=new_buf(L[7]<<9);var i=0,T=0;{for(i=0;i<8;++i){o.write_shift(1,HEADER_SIG[i]);}for(i=0;i<8;++i){o.write_shift(2,0);}o.write_shift(2,0x003E);o.write_shift(2,0x0003);o.write_shift(2,0xFFFE);o.write_shift(2,0x0009);o.write_shift(2,0x0006);for(i=0;i<3;++i){o.write_shift(2,0);}o.write_shift(4,0);o.write_shift(4,L[2]);o.write_shift(4,L[0]+L[1]+L[2]+L[3]-1);o.write_shift(4,0);o.write_shift(4,1<<12);o.write_shift(4,L[3]?L[0]+L[1]+L[2]-1:ENDOFCHAIN);o.write_shift(4,L[3]);o.write_shift(-4,L[1]?L[0]-1:ENDOFCHAIN);o.write_shift(4,L[1]);for(i=0;i<109;++i){o.write_shift(-4,i<L[2]?L[1]+i:-1);}}if(L[1]){for(T=0;T<L[1];++T){for(;i<236+T*127;++i){o.write_shift(-4,i<L[2]?L[1]+i:-1);}o.write_shift(-4,T===L[1]-1?ENDOFCHAIN:T+1);}}var chainit=function chainit(w/*:number*/)/*:void*/{for(T+=w;i<T-1;++i){o.write_shift(-4,i+1);}if(w){++i;o.write_shift(-4,ENDOFCHAIN);}};T=i=0;for(T+=L[1];i<T;++i){o.write_shift(-4,consts.DIFSECT);}for(T+=L[2];i<T;++i){o.write_shift(-4,consts.FATSECT);}chainit(L[3]);chainit(L[4]);var j/*:number*/=0,flen/*:number*/=0;var file/*:CFBEntry*/=cfb.FileIndex[0];for(;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;/*:: if(file.content == null) throw new Error("unreachable"); */flen=file.content.length;if(flen<0x1000)continue;file.start=T;chainit(flen+0x01FF>>9);}chainit(L[6]+7>>3);while(o.l&0x1FF){o.write_shift(-4,consts.ENDOFCHAIN);}T=i=0;for(j=0;j<cfb.FileIndex.length;++j){file=cfb.FileIndex[j];if(!file.content)continue;/*:: if(file.content == null) throw new Error("unreachable"); */flen=file.content.length;if(!flen||flen>=0x1000)continue;file.start=T;chainit(flen+0x3F>>6);}while(o.l&0x1FF){o.write_shift(-4,consts.ENDOFCHAIN);}for(i=0;i<L[4]<<2;++i){var nm=cfb.FullPaths[i];if(!nm||nm.length===0){for(j=0;j<17;++j){o.write_shift(4,0);}for(j=0;j<3;++j){o.write_shift(4,-1);}for(j=0;j<12;++j){o.write_shift(4,0);}continue;}file=cfb.FileIndex[i];if(i===0)file.start=file.size?file.start-1:ENDOFCHAIN;var _nm/*:string*/=i===0&&_opts.root||file.name;flen=2*(_nm.length+1);o.write_shift(64,_nm,"utf16le");o.write_shift(2,flen);o.write_shift(1,file.type);o.write_shift(1,file.color);o.write_shift(-4,file.L);o.write_shift(-4,file.R);o.write_shift(-4,file.C);if(!file.clsid)for(j=0;j<4;++j){o.write_shift(4,0);}else o.write_shift(16,file.clsid,"hex");o.write_shift(4,file.state||0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,file.start);o.write_shift(4,file.size);o.write_shift(4,0);}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];/*:: if(!file.content) throw new Error("unreachable"); */if(file.size>=0x1000){o.l=file.start+1<<9;if(has_buf&&Buffer.isBuffer(file.content)){file.content.copy(o,o.l,0,file.size);// o is a 0-filled Buffer so just set next offset
o.l+=file.size+511&-512;}else{for(j=0;j<file.size;++j){o.write_shift(1,file.content[j]);}for(;j&0x1FF;++j){o.write_shift(1,0);}}}}for(i=1;i<cfb.FileIndex.length;++i){file=cfb.FileIndex[i];/*:: if(!file.content) throw new Error("unreachable"); */if(file.size>0&&file.size<0x1000){if(has_buf&&Buffer.isBuffer(file.content)){file.content.copy(o,o.l,0,file.size);// o is a 0-filled Buffer so just set next offset
o.l+=file.size+63&-64;}else{for(j=0;j<file.size;++j){o.write_shift(1,file.content[j]);}for(;j&0x3F;++j){o.write_shift(1,0);}}}}if(has_buf){o.l=o.length;}else{// When using Buffer, already 0-filled
while(o.l<o.length){o.write_shift(1,0);}}return o;}/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */function find(cfb/*:CFBContainer*/,path/*:string*/)/*:?CFBEntry*/{var UCFullPaths/*:Array<string>*/=cfb.FullPaths.map(function(x){return x.toUpperCase();});var UCPaths/*:Array<string>*/=UCFullPaths.map(function(x){var y=x.split("/");return y[y.length-(x.slice(-1)=="/"?2:1)];});var k/*:boolean*/=false;if(path.charCodeAt(0)===47/* "/" */){k=true;path=UCFullPaths[0].slice(0,-1)+path;}else k=path.indexOf("/")!==-1;var UCPath/*:string*/=path.toUpperCase();var w/*:number*/=k===true?UCFullPaths.indexOf(UCPath):UCPaths.indexOf(UCPath);if(w!==-1)return cfb.FileIndex[w];var m=!UCPath.match(chr1);UCPath=UCPath.replace(chr0,'');if(m)UCPath=UCPath.replace(chr1,'!');for(w=0;w<UCFullPaths.length;++w){if((m?UCFullPaths[w].replace(chr1,'!'):UCFullPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];if((m?UCPaths[w].replace(chr1,'!'):UCPaths[w]).replace(chr0,'')==UCPath)return cfb.FileIndex[w];}return null;}/** CFB Constants */var MSSZ=64;/* Mini Sector Size = 1<<6 *///var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */var ENDOFCHAIN=-2;/* 2.2 Compound File Header */var HEADER_SIGNATURE='d0cf11e0a1b11ae1';var HEADER_SIG=[0xD0,0xCF,0x11,0xE0,0xA1,0xB1,0x1A,0xE1];var HEADER_CLSID='00000000000000000000000000000000';var consts={/* 2.1 Compund File Sector Numbers and Types */MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:ENDOFCHAIN,FREESECT:-1,/* 2.2 Compound File Header */HEADER_SIGNATURE:HEADER_SIGNATURE,HEADER_MINOR_VERSION:'3e00',MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:HEADER_CLSID,/* 2.6.1 Compound File Directory Entry */EntryTypes:['unknown','storage','stream','lockbytes','property','root']};function write_file(cfb/*:CFBContainer*/,filename/*:string*/,options/*:CFBWriteOpts*/)/*:void*/{get_fs();var o=_write(cfb,options);/*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */fs.writeFileSync(filename,o);}function a2s(o/*:RawBytes*/)/*:string*/{var out=new Array(o.length);for(var i=0;i<o.length;++i){out[i]=String.fromCharCode(o[i]);}return out.join("");}function write(cfb/*:CFBContainer*/,options/*:CFBWriteOpts*/)/*:RawBytes|string*/{var o=_write(cfb,options);switch(options&&options.type||"buffer"){case"file":get_fs();fs.writeFileSync(options.filename,o/*:any*/);return o;case"binary":return typeof o=="string"?o:a2s(o);case"base64":return Base64_encode(typeof o=="string"?o:a2s(o));case"buffer":if(has_buf)return Buffer.isBuffer(o)?o:Buffer_from(o);/* falls through */case"array":return typeof o=="string"?s2a(o):o;}return o;}/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */var _zlib;function use_zlib(zlib){try{var InflateRaw=zlib.InflateRaw;var InflRaw=new InflateRaw();InflRaw._processChunk(new Uint8Array([3,0]),InflRaw._finishFlushFlag);if(InflRaw.bytesRead)_zlib=zlib;else throw new Error("zlib does not expose bytesRead");}catch(e){console.error("cannot use native zlib: "+(e.message||e));}}function _inflateRawSync(payload,usz){if(!_zlib)return _inflate(payload,usz);var InflateRaw=_zlib.InflateRaw;var InflRaw=new InflateRaw();var out=InflRaw._processChunk(payload.slice(payload.l),InflRaw._finishFlushFlag);payload.l+=InflRaw.bytesRead;return out;}function _deflateRawSync(payload){return _zlib?_zlib.deflateRawSync(payload):_deflate(payload);}var CLEN_ORDER=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */var LEN_LN=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258];/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */var DST_LN=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577];function bit_swap_8(n){var t=(n<<1|n<<11)&0x22110|(n<<5|n<<15)&0x88440;return(t>>16|t>>8|t)&0xFF;}var use_typed_arrays=typeof Uint8Array!=='undefined';var bitswap8=use_typed_arrays?new Uint8Array(1<<8):[];for(var q=0;q<1<<8;++q){bitswap8[q]=bit_swap_8(q);}function bit_swap_n(n,b){var rev=bitswap8[n&0xFF];if(b<=8)return rev>>>8-b;rev=rev<<8|bitswap8[n>>8&0xFF];if(b<=16)return rev>>>16-b;rev=rev<<8|bitswap8[n>>16&0xFF];return rev>>>24-b;}/* helpers for unaligned bit reads */function read_bits_2(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=6?0:buf[h+1]<<8))>>>w&0x03;}function read_bits_3(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=5?0:buf[h+1]<<8))>>>w&0x07;}function read_bits_4(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=4?0:buf[h+1]<<8))>>>w&0x0F;}function read_bits_5(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=3?0:buf[h+1]<<8))>>>w&0x1F;}function read_bits_7(buf,bl){var w=bl&7,h=bl>>>3;return(buf[h]|(w<=1?0:buf[h+1]<<8))>>>w&0x7F;}/* works up to n = 3 * 8 + 1 = 25 */function read_bits_n(buf,bl,n){var w=bl&7,h=bl>>>3,f=(1<<n)-1;var v=buf[h]>>>w;if(n<8-w)return v&f;v|=buf[h+1]<<8-w;if(n<16-w)return v&f;v|=buf[h+2]<<16-w;if(n<24-w)return v&f;v|=buf[h+3]<<24-w;return v&f;}/* helpers for unaligned bit writes */function write_bits_3(buf,bl,v){var w=bl&7,h=bl>>>3;if(w<=5)buf[h]|=(v&7)<<w;else{buf[h]|=v<<w&0xFF;buf[h+1]=(v&7)>>8-w;}return bl+3;}function write_bits_1(buf,bl,v){var w=bl&7,h=bl>>>3;v=(v&1)<<w;buf[h]|=v;return bl+1;}function write_bits_8(buf,bl,v){var w=bl&7,h=bl>>>3;v<<=w;buf[h]|=v&0xFF;v>>>=8;buf[h+1]=v;return bl+8;}function write_bits_16(buf,bl,v){var w=bl&7,h=bl>>>3;v<<=w;buf[h]|=v&0xFF;v>>>=8;buf[h+1]=v&0xFF;buf[h+2]=v>>>8;return bl+16;}/* until ArrayBuffer#realloc is a thing, fake a realloc */function realloc(b,sz/*:number*/){var L=b.length,M=2*L>sz?2*L:sz+5,i=0;if(L>=sz)return b;if(has_buf){var o=new_unsafe_buf(M);// $FlowIgnore
if(b.copy)b.copy(o);else for(;i<b.length;++i){o[i]=b[i];}return o;}else if(use_typed_arrays){var a=new Uint8Array(M);if(a.set)a.set(b);else for(;i<L;++i){a[i]=b[i];}return a;}b.length=M;return b;}/* zero-filled arrays for older browsers */function zero_fill_array(n){var o=new Array(n);for(var i=0;i<n;++i){o[i]=0;}return o;}/* build tree (used for literals and lengths) */function build_tree(clens,cmap,MAX/*:number*/)/*:number*/{var maxlen=1,w=0,i=0,j=0,ccode=0,L=clens.length;var bl_count=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);for(i=0;i<32;++i){bl_count[i]=0;}for(i=L;i<MAX;++i){clens[i]=0;}L=clens.length;var ctree=use_typed_arrays?new Uint16Array(L):zero_fill_array(L);// []
/* build code tree */for(i=0;i<L;++i){bl_count[w=clens[i]]++;if(maxlen<w)maxlen=w;ctree[i]=0;}bl_count[0]=0;for(i=1;i<=maxlen;++i){bl_count[i+16]=ccode=ccode+bl_count[i-1]<<1;}for(i=0;i<L;++i){ccode=clens[i];if(ccode!=0)ctree[i]=bl_count[ccode+16]++;}/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bit_swap_n(ctree[i],maxlen)>>maxlen-cleni;for(j=(1<<maxlen+4-cleni)-1;j>=0;--j){cmap[ccode|j<<cleni]=cleni&15|i<<4;}}}return maxlen;}/* Fixed Huffman */var fix_lmap=use_typed_arrays?new Uint16Array(512):zero_fill_array(512);var fix_dmap=use_typed_arrays?new Uint16Array(32):zero_fill_array(32);if(!use_typed_arrays){for(var i=0;i<512;++i){fix_lmap[i]=0;}for(i=0;i<32;++i){fix_dmap[i]=0;}}(function(){var dlens/*:Array<number>*/=[];var i=0;for(;i<32;i++){dlens.push(5);}build_tree(dlens,fix_dmap,32);var clens/*:Array<number>*/=[];i=0;for(;i<=143;i++){clens.push(8);}for(;i<=255;i++){clens.push(9);}for(;i<=279;i++){clens.push(7);}for(;i<=287;i++){clens.push(8);}build_tree(clens,fix_lmap,288);})();var _deflateRaw=/*#__PURE__*/function _deflateRawIIFE(){var DST_LN_RE=use_typed_arrays?new Uint8Array(0x8000):[];var j=0,k=0;for(;j<DST_LN.length-1;++j){for(;k<DST_LN[j+1];++k){DST_LN_RE[k]=j;}}for(;k<32768;++k){DST_LN_RE[k]=29;}var LEN_LN_RE=use_typed_arrays?new Uint8Array(0x103):[];for(j=0,k=0;j<LEN_LN.length-1;++j){for(;k<LEN_LN[j+1];++k){LEN_LN_RE[k]=j;}}function write_stored(data,out){var boff=0;while(boff<data.length){var L=Math.min(0xFFFF,data.length-boff);var h=boff+L==data.length;out.write_shift(1,+h);out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0){out[out.l++]=data[boff++];}}return out.l;}/* Fixed Huffman */function write_huff_fixed(data,out){var bl=0;var boff=0;var addrs=use_typed_arrays?new Uint16Array(0x8000):[];while(boff<data.length){var L=/* data.length - boff; */Math.min(0xFFFF,data.length-boff);/* write a stored block for short data */if(L<10){bl=write_bits_3(out,bl,+!!(boff+L==data.length));// jshint ignore:line
if(bl&7)bl+=8-(bl&7);out.l=bl/8|0;out.write_shift(2,L);out.write_shift(2,~L&0xFFFF);while(L-->0){out[out.l++]=data[boff++];}bl=out.l*8;continue;}bl=write_bits_3(out,bl,+!!(boff+L==data.length)+2);// jshint ignore:line
var hash=0;while(L-->0){var d=data[boff];hash=(hash<<5^d)&0x7FFF;var match=-1,mlen=0;if(match=addrs[hash]){match|=boff&~0x7FFF;if(match>boff)match-=0x8000;if(match<boff)while(data[match+mlen]==data[boff+mlen]&&mlen<250){++mlen;}}if(mlen>2){/* Copy Token  */d=LEN_LN_RE[mlen];if(d<=22)bl=write_bits_8(out,bl,bitswap8[d+1]>>1)-1;else{write_bits_8(out,bl,3);bl+=5;write_bits_8(out,bl,bitswap8[d-23]>>5);bl+=3;}var len_eb=d<8?0:d-4>>2;if(len_eb>0){write_bits_16(out,bl,mlen-LEN_LN[d]);bl+=len_eb;}d=DST_LN_RE[boff-match];bl=write_bits_8(out,bl,bitswap8[d]>>3);bl-=3;var dst_eb=d<4?0:d-2>>1;if(dst_eb>0){write_bits_16(out,bl,boff-match-DST_LN[d]);bl+=dst_eb;}for(var q=0;q<mlen;++q){addrs[hash]=boff&0x7FFF;hash=(hash<<5^data[boff])&0x7FFF;++boff;}L-=mlen-1;}else{/* Literal Token */if(d<=143)d=d+48;else bl=write_bits_1(out,bl,1);bl=write_bits_8(out,bl,bitswap8[d]);addrs[hash]=boff&0x7FFF;++boff;}}bl=write_bits_8(out,bl,0)-1;}out.l=(bl+7)/8|0;return out.l;}return function _deflateRaw(data,out){if(data.length<8)return write_stored(data,out);return write_huff_fixed(data,out);};}();function _deflate(data){var buf=new_buf(50+Math.floor(data.length*1.1));var off=_deflateRaw(data,buf);return buf.slice(0,off);}/* modified inflate function also moves original read head */var dyn_lmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_dmap=use_typed_arrays?new Uint16Array(32768):zero_fill_array(32768);var dyn_cmap=use_typed_arrays?new Uint16Array(128):zero_fill_array(128);var dyn_len_1=1,dyn_len_2=1;/* 5.5.3 Expanding Huffman Codes */function dyn(data,boff/*:number*/){/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */var _HLIT=read_bits_5(data,boff)+257;boff+=5;var _HDIST=read_bits_5(data,boff)+1;boff+=5;var _HCLEN=read_bits_4(data,boff)+4;boff+=4;var w=0;/* grab and store code lengths */var clens=use_typed_arrays?new Uint8Array(19):zero_fill_array(19);var ctree=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var maxlen=1;var bl_count=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var next_code=use_typed_arrays?new Uint8Array(8):zero_fill_array(8);var L=clens.length;/* 19 */for(var i=0;i<_HCLEN;++i){clens[CLEN_ORDER[i]]=w=read_bits_3(data,boff);if(maxlen<w)maxlen=w;bl_count[w]++;boff+=3;}/* build code tree */var ccode=0;bl_count[0]=0;for(i=1;i<=maxlen;++i){next_code[i]=ccode=ccode+bl_count[i-1]<<1;}for(i=0;i<L;++i){if((ccode=clens[i])!=0)ctree[i]=next_code[ccode]++;}/* cmap[7 bits from stream] = (off&7) + (lit<<3) */var cleni=0;for(i=0;i<L;++i){cleni=clens[i];if(cleni!=0){ccode=bitswap8[ctree[i]]>>8-cleni;for(var j=(1<<7-cleni)-1;j>=0;--j){dyn_cmap[ccode|j<<cleni]=cleni&7|i<<3;}}}/* read literal and dist codes at once */var hcodes/*:Array<number>*/=[];maxlen=1;for(;hcodes.length<_HLIT+_HDIST;){ccode=dyn_cmap[read_bits_7(data,boff)];boff+=ccode&7;switch(ccode>>>=3){case 16:w=3+read_bits_2(data,boff);boff+=2;ccode=hcodes[hcodes.length-1];while(w-->0){hcodes.push(ccode);}break;case 17:w=3+read_bits_3(data,boff);boff+=3;while(w-->0){hcodes.push(0);}break;case 18:w=11+read_bits_7(data,boff);boff+=7;while(w-->0){hcodes.push(0);}break;default:hcodes.push(ccode);if(maxlen<ccode)maxlen=ccode;break;}}/* build literal / length trees */var h1=hcodes.slice(0,_HLIT),h2=hcodes.slice(_HLIT);for(i=_HLIT;i<286;++i){h1[i]=0;}for(i=_HDIST;i<30;++i){h2[i]=0;}dyn_len_1=build_tree(h1,dyn_lmap,286);dyn_len_2=build_tree(h2,dyn_dmap,30);return boff;}/* return [ data, bytesRead ] */function inflate(data,usz/*:number*/){/* shortcircuit for empty buffer [0x03, 0x00] */if(data[0]==3&&!(data[1]&0x3)){return[new_raw_buf(usz),2];}/* bit offset */var boff=0;/* header includes final bit and type bits */var header=0;var outbuf=new_unsafe_buf(usz?usz:1<<18);var woff=0;var OL=outbuf.length>>>0;var max_len_1=0,max_len_2=0;while((header&1)==0){header=read_bits_3(data,boff);boff+=3;if(header>>>1==0){/* Stored block */if(boff&7)boff+=8-(boff&7);/* 2 bytes sz, 2 bytes bit inverse */var sz=data[boff>>>3]|data[(boff>>>3)+1]<<8;boff+=32;/* push sz bytes */if(sz>0){if(!usz&&OL<woff+sz){outbuf=realloc(outbuf,woff+sz);OL=outbuf.length;}while(sz-->0){outbuf[woff++]=data[boff>>>3];boff+=8;}}continue;}else if(header>>1==1){/* Fixed Huffman */max_len_1=9;max_len_2=5;}else{/* Dynamic Huffman */boff=dyn(data,boff);max_len_1=dyn_len_1;max_len_2=dyn_len_2;}for(;;){// while(true) is apparently out of vogue in modern JS circles
if(!usz&&OL<woff+32767){outbuf=realloc(outbuf,woff+32767);OL=outbuf.length;}/* ingest code and move read head */var bits=read_bits_n(data,boff,max_len_1);var code=header>>>1==1?fix_lmap[bits]:dyn_lmap[bits];boff+=code&15;code>>>=4;/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */if((code>>>8&0xFF)===0)outbuf[woff++]=code;else if(code==256)break;else{code-=257;var len_eb=code<8?0:code-4>>2;if(len_eb>5)len_eb=0;var tgt=woff+LEN_LN[code];/* length extra bits */if(len_eb>0){tgt+=read_bits_n(data,boff,len_eb);boff+=len_eb;}/* dist code */bits=read_bits_n(data,boff,max_len_2);code=header>>>1==1?fix_dmap[bits]:dyn_dmap[bits];boff+=code&15;code>>>=4;var dst_eb=code<4?0:code-2>>1;var dst=DST_LN[code];/* dist extra bits */if(dst_eb>0){dst+=read_bits_n(data,boff,dst_eb);boff+=dst_eb;}/* in the common case, manual byte copy is faster than TA set / Buffer copy */if(!usz&&OL<tgt){outbuf=realloc(outbuf,tgt+100);OL=outbuf.length;}while(woff<tgt){outbuf[woff]=outbuf[woff-dst];++woff;}}}}if(usz)return[outbuf,boff+7>>>3];return[outbuf.slice(0,woff),boff+7>>>3];}function _inflate(payload,usz){var data=payload.slice(payload.l||0);var out=inflate(data,usz);payload.l+=out[1];return out[0];}function warn_or_throw(wrn,msg){if(wrn){if(typeof console!=='undefined')console.error(msg);}else throw new Error(msg);}function parse_zip(file/*:RawBytes*/,options/*:CFBReadOpts*/)/*:CFBContainer*/{var blob/*:CFBlob*/=/*::(*/file/*:: :any)*/;prep_blob(blob,0);var FileIndex/*:CFBFileIndex*/=[],FullPaths/*:Array<string>*/=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o,{root:options.root});/* find end of central directory, start just after signature */var i=blob.length-4;while((blob[i]!=0x50||blob[i+1]!=0x4b||blob[i+2]!=0x05||blob[i+3]!=0x06)&&i>=0){--i;}blob.l=i+4;/* parse end of central directory */blob.l+=4;var fcnt=blob.read_shift(2);blob.l+=6;var start_cd=blob.read_shift(4);/* parse central directory */blob.l=start_cd;for(i=0;i<fcnt;++i){/* trust local file header instead of CD entry */blob.l+=20;var csz=blob.read_shift(4);var usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);var fcsz=blob.read_shift(2);blob.l+=8;var offset=blob.read_shift(4);var EF=parse_extra_field(/*::(*/blob.slice(blob.l+namelen,blob.l+namelen+efsz)/*:: :any)*/);blob.l+=namelen+efsz+fcsz;var L=blob.l;blob.l=offset+4;parse_local_file(blob,csz,usz,o,EF);blob.l=L;}return o;}/* head starts just after local file header signature */function parse_local_file(blob/*:CFBlob*/,csz/*:number*/,usz/*:number*/,o/*:CFBContainer*/,EF){/* [local file header] */blob.l+=2;var flags=blob.read_shift(2);var meth=blob.read_shift(2);var date=parse_dos_date(blob);if(flags&0x2041)throw new Error("Unsupported ZIP encryption");var crc32=blob.read_shift(4);var _csz=blob.read_shift(4);var _usz=blob.read_shift(4);var namelen=blob.read_shift(2);var efsz=blob.read_shift(2);// TODO: flags & (1<<11) // UTF8
var name="";for(var i=0;i<namelen;++i){name+=String.fromCharCode(blob[blob.l++]);}if(efsz){var ef=parse_extra_field(/*::(*/blob.slice(blob.l,blob.l+efsz)/*:: :any)*/);if((ef[0x5455]||{}).mt)date=ef[0x5455].mt;if(((EF||{})[0x5455]||{}).mt)date=EF[0x5455].mt;}blob.l+=efsz;/* [encryption header] *//* [file data] */var data=blob.slice(blob.l,blob.l+_csz);switch(meth){case 8:data=_inflateRawSync(blob,_usz);break;case 0:break;// TODO: scan for magic number
default:throw new Error("Unsupported ZIP Compression method "+meth);}/* [data descriptor] */var wrn=false;if(flags&8){crc32=blob.read_shift(4);if(crc32==0x08074b50){crc32=blob.read_shift(4);wrn=true;}_csz=blob.read_shift(4);_usz=blob.read_shift(4);}if(_csz!=csz)warn_or_throw(wrn,"Bad compressed size: "+csz+" != "+_csz);if(_usz!=usz)warn_or_throw(wrn,"Bad uncompressed size: "+usz+" != "+_usz);//var _crc32 = CRC32.buf(data, 0);
//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
cfb_add(o,name,data,{unsafe:true,mt:date});}function write_zip(cfb/*:CFBContainer*/,options/*:CFBWriteOpts*/)/*:RawBytes*/{var _opts=options||{};var out=[],cdirs=[];var o/*:CFBlob*/=new_buf(1);var method=_opts.compression?8:0,flags=0;var desc=false;if(desc)flags|=8;var i=0,j=0;var start_cd=0,fcnt=0;var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];var crcs=[];var sz_cd=0;for(i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\x01Sh33tJ5")continue;var start=start_cd;/* TODO: CP437 filename */var namebuf=new_buf(fp.length);for(j=0;j<fp.length;++j){namebuf.write_shift(1,fp.charCodeAt(j)&0x7F);}namebuf=namebuf.slice(0,namebuf.l);crcs[fcnt]=CRC32.buf(/*::((*/fi.content/*::||[]):any)*/,0);var outbuf=fi.content/*::||[]*/;if(method==8)outbuf=_deflateRawSync(outbuf);/* local file header */o=new_buf(30);o.write_shift(4,0x04034b50);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);/* TODO: last mod file time/date */if(fi.mt)write_dos_date(o,fi.mt);else o.write_shift(4,0);o.write_shift(-4,flags&8?0:crcs[fcnt]);o.write_shift(4,flags&8?0:outbuf.length);o.write_shift(4,flags&8?0:/*::(*/fi.content/*::||[])*/.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);start_cd+=o.length;out.push(o);start_cd+=namebuf.length;out.push(namebuf);/* TODO: extra fields? *//* TODO: encryption header ? */start_cd+=outbuf.length;out.push(outbuf);/* data descriptor */if(flags&8){o=new_buf(12);o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,/*::(*/fi.content/*::||[])*/.length);start_cd+=o.l;out.push(o);}/* central directory */o=new_buf(46);o.write_shift(4,0x02014b50);o.write_shift(2,0);o.write_shift(2,20);o.write_shift(2,flags);o.write_shift(2,method);o.write_shift(4,0);/* TODO: last mod file time/date */o.write_shift(-4,crcs[fcnt]);o.write_shift(4,outbuf.length);o.write_shift(4,/*::(*/fi.content/*::||[])*/.length);o.write_shift(2,namebuf.length);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);o.write_shift(4,start);sz_cd+=o.l;cdirs.push(o);sz_cd+=namebuf.length;cdirs.push(namebuf);++fcnt;}/* end of central directory */o=new_buf(22);o.write_shift(4,0x06054b50);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,fcnt);o.write_shift(2,fcnt);o.write_shift(4,sz_cd);o.write_shift(4,start_cd);o.write_shift(2,0);return bconcat([bconcat(out/*:any*/),bconcat(cdirs),o]/*:any*/);}var ContentTypeMap={"htm":"text/html","xml":"text/xml","gif":"image/gif","jpg":"image/jpeg","png":"image/png","mso":"application/x-mso","thmx":"application/vnd.ms-officetheme","sh33tj5":"application/octet-stream"/*:any*/};function get_content_type(fi/*:CFBEntry*/,fp/*:string*/)/*:string*/{if(fi.ctype)return fi.ctype;var ext=fi.name||"",m=ext.match(/\.([^\.]+)$/);if(m&&ContentTypeMap[m[1]])return ContentTypeMap[m[1]];if(fp){m=(ext=fp).match(/[\.\\]([^\.\\])+$/);if(m&&ContentTypeMap[m[1]])return ContentTypeMap[m[1]];}return"application/octet-stream";}/* 76 character chunks TODO: intertwine encoding */function write_base64_76(bstr/*:string*/)/*:string*/{var data=Base64_encode(bstr);var o=[];for(var i=0;i<data.length;i+=76){o.push(data.slice(i,i+76));}return o.join("\r\n")+"\r\n";}/*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/function write_quoted_printable(text/*:string*/)/*:string*/{var encoded=text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g,function(c){var w=c.charCodeAt(0).toString(16).toUpperCase();return"="+(w.length==1?"0"+w:w);});encoded=encoded.replace(/ $/mg,"=20").replace(/\t$/mg,"=09");if(encoded.charAt(0)=="\n")encoded="=0D"+encoded.slice(1);encoded=encoded.replace(/\r(?!\n)/mg,"=0D").replace(/\n\n/mg,"\n=0A").replace(/([^\r\n])\n/mg,"$1=0A");var o/*:Array<string>*/=[],split=encoded.split("\r\n");for(var si=0;si<split.length;++si){var str=split[si];if(str.length==0){o.push("");continue;}for(var i=0;i<str.length;){var end=76;var tmp=str.slice(i,i+end);if(tmp.charAt(end-1)=="=")end--;else if(tmp.charAt(end-2)=="=")end-=2;else if(tmp.charAt(end-3)=="=")end-=3;tmp=str.slice(i,i+end);i+=end;if(i<str.length)tmp+="=";o.push(tmp);}}return o.join("\r\n");}function parse_quoted_printable(data/*:Array<string>*/)/*:RawBytes*/{var o=[];/* unify long lines */for(var di=0;di<data.length;++di){var line=data[di];while(di<=data.length&&line.charAt(line.length-1)=="="){line=line.slice(0,line.length-1)+data[++di];}o.push(line);}/* decode */for(var oi=0;oi<o.length;++oi){o[oi]=o[oi].replace(/[=][0-9A-Fa-f]{2}/g,function($$){return String.fromCharCode(parseInt($$.slice(1),16));});}return s2a(o.join("\r\n"));}function parse_mime(cfb/*:CFBContainer*/,data/*:Array<string>*/,root/*:string*/)/*:void*/{var fname="",cte="",ctype="",fdata;var di=0;for(;di<10;++di){var line=data[di];if(!line||line.match(/^\s*$/))break;var m=line.match(/^(.*?):\s*([^\s].*)$/);if(m)switch(m[1].toLowerCase()){case"content-location":fname=m[2].trim();break;case"content-type":ctype=m[2].trim();break;case"content-transfer-encoding":cte=m[2].trim();break;}}++di;switch(cte.toLowerCase()){case'base64':fdata=s2a(Base64_decode(data.slice(di).join("")));break;case'quoted-printable':fdata=parse_quoted_printable(data.slice(di));break;default:throw new Error("Unsupported Content-Transfer-Encoding "+cte);}var file=cfb_add(cfb,fname.slice(root.length),fdata,{unsafe:true});if(ctype)file.ctype=ctype;}function parse_mad(file/*:RawBytes*/,options/*:CFBReadOpts*/)/*:CFBContainer*/{if(a2s(file.slice(0,13)).toLowerCase()!="mime-version:")throw new Error("Unsupported MAD header");var root=options&&options.root||"";// $FlowIgnore
var data=(has_buf&&Buffer.isBuffer(file)?file.toString("binary"):a2s(file)).split("\r\n");var di=0,row="";/* if root is not specified, scan for the common prefix */for(di=0;di<data.length;++di){row=data[di];if(!/^Content-Location:/i.test(row))continue;row=row.slice(row.indexOf("file"));if(!root)root=row.slice(0,row.lastIndexOf("/")+1);if(row.slice(0,root.length)==root)continue;while(root.length>0){root=root.slice(0,root.length-1);root=root.slice(0,root.lastIndexOf("/")+1);if(row.slice(0,root.length)==root)break;}}var mboundary=(data[1]||"").match(/boundary="(.*?)"/);if(!mboundary)throw new Error("MAD cannot find boundary");var boundary="--"+(mboundary[1]||"");var FileIndex/*:CFBFileIndex*/=[],FullPaths/*:Array<string>*/=[];var o={FileIndex:FileIndex,FullPaths:FullPaths};init_cfb(o);var start_di,fcnt=0;for(di=0;di<data.length;++di){var line=data[di];if(line!==boundary&&line!==boundary+"--")continue;if(fcnt++)parse_mime(o,data.slice(start_di,di),root);start_di=di;}return o;}function write_mad(cfb/*:CFBContainer*/,options/*:CFBWriteOpts*/)/*:string*/{var opts=options||{};var boundary=opts.boundary||"SheetJS";boundary='------='+boundary;var out=['MIME-Version: 1.0','Content-Type: multipart/related; boundary="'+boundary.slice(2)+'"','','',''];var root=cfb.FullPaths[0],fp=root,fi=cfb.FileIndex[0];for(var i=1;i<cfb.FullPaths.length;++i){fp=cfb.FullPaths[i].slice(root.length);fi=cfb.FileIndex[i];if(!fi.size||!fi.content||fp=="\x01Sh33tJ5")continue;/* Normalize filename */fp=fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g,function(c){return"_x"+c.charCodeAt(0).toString(16)+"_";}).replace(/[\u0080-\uFFFF]/g,function(u){return"_u"+u.charCodeAt(0).toString(16)+"_";});/* Extract content as binary string */var ca=fi.content;// $FlowIgnore
var cstr=has_buf&&Buffer.isBuffer(ca)?ca.toString("binary"):a2s(ca);/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */var dispcnt=0,L=Math.min(1024,cstr.length),cc=0;for(var csl=0;csl<=L;++csl){if((cc=cstr.charCodeAt(csl))>=0x20&&cc<0x80)++dispcnt;}var qp=dispcnt>=L*4/5;out.push(boundary);out.push('Content-Location: '+(opts.root||'file:///C:/SheetJS/')+fp);out.push('Content-Transfer-Encoding: '+(qp?'quoted-printable':'base64'));out.push('Content-Type: '+get_content_type(fi,fp));out.push('');out.push(qp?write_quoted_printable(cstr):write_base64_76(cstr));}out.push(boundary+'--\r\n');return out.join("\r\n");}function cfb_new(opts/*:?any*/)/*:CFBContainer*/{var o/*:CFBContainer*/={}/*:any*/;init_cfb(o,opts);return o;}function cfb_add(cfb/*:CFBContainer*/,name/*:string*/,content/*:?RawBytes*/,opts/*:?any*/)/*:CFBEntry*/{var unsafe=opts&&opts.unsafe;if(!unsafe)init_cfb(cfb);var file=!unsafe&&CFB.find(cfb,name);if(!file){var fpath/*:string*/=cfb.FullPaths[0];if(name.slice(0,fpath.length)==fpath)fpath=name;else{if(fpath.slice(-1)!="/")fpath+="/";fpath=(fpath+name).replace("//","/");}file={name:filename(name),type:2/*:any*/};cfb.FileIndex.push(file);cfb.FullPaths.push(fpath);if(!unsafe)CFB.utils.cfb_gc(cfb);}/*:: if(!file) throw new Error("unreachable"); */file.content=content/*:any*/;file.size=content?content.length:0;if(opts){if(opts.CLSID)file.clsid=opts.CLSID;if(opts.mt)file.mt=opts.mt;if(opts.ct)file.ct=opts.ct;}return file;}function cfb_del(cfb/*:CFBContainer*/,name/*:string*/)/*:boolean*/{init_cfb(cfb);var file=CFB.find(cfb,name);if(file)for(var j=0;j<cfb.FileIndex.length;++j){if(cfb.FileIndex[j]==file){cfb.FileIndex.splice(j,1);cfb.FullPaths.splice(j,1);return true;}}return false;}function cfb_mov(cfb/*:CFBContainer*/,old_name/*:string*/,new_name/*:string*/)/*:boolean*/{init_cfb(cfb);var file=CFB.find(cfb,old_name);if(file)for(var j=0;j<cfb.FileIndex.length;++j){if(cfb.FileIndex[j]==file){cfb.FileIndex[j].name=filename(new_name);cfb.FullPaths[j]=new_name;return true;}}return false;}function cfb_gc(cfb/*:CFBContainer*/)/*:void*/{rebuild_cfb(cfb,true);}exports.find=find;exports.read=read;exports.parse=parse;exports.write=write;exports.writeFile=write_file;exports.utils={cfb_new:cfb_new,cfb_add:cfb_add,cfb_del:cfb_del,cfb_mov:cfb_mov,cfb_gc:cfb_gc,ReadShift:ReadShift,CheckField:CheckField,prep_blob:prep_blob,bconcat:bconcat,use_zlib:use_zlib,_deflateRaw:_deflate,_inflateRaw:_inflate,consts:consts};return exports;}();var _fs=void 0;function set_fs(fs){_fs=fs;}exports.set_fs=set_fs;/* normalize data for blob ctor */function blobify(data){if(typeof data==="string")return s2ab(data);if(Array.isArray(data))return a2u(data);return data;}/* write or download file */function write_dl(fname/*:string*/,payload/*:any*/,enc/*:?string*/){/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */if(typeof _fs!=='undefined'&&_fs.writeFileSync)return enc?_fs.writeFileSync(fname,payload,enc):_fs.writeFileSync(fname,payload);if(typeof Deno!=='undefined'){/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */if(enc&&typeof payload=="string")switch(enc){case"utf8":payload=new TextEncoder(enc).encode(payload);break;case"binary":payload=s2ab(payload);break;/* TODO: binary equivalent */default:throw new Error("Unsupported encoding "+enc);}return Deno.writeFileSync(fname,payload);}var data=enc=="utf8"?utf8write(payload):payload;/*:: declare var IE_SaveFile: any; */if(typeof IE_SaveFile!=='undefined')return IE_SaveFile(data,fname);if(typeof Blob!=='undefined'){var blob=new Blob([blobify(data)],{type:"application/octet-stream"});/*:: declare var navigator: any; */if(typeof navigator!=='undefined'&&navigator.msSaveBlob)return navigator.msSaveBlob(blob,fname);/*:: declare var saveAs: any; */if(typeof saveAs!=='undefined')return saveAs(blob,fname);if(typeof URL!=='undefined'&&typeof document!=='undefined'&&document.createElement&&URL.createObjectURL){var url=URL.createObjectURL(blob);/*:: declare var chrome: any; */if((typeof chrome==="undefined"?"undefined":(0,_typeof3.default)(chrome))==='object'&&typeof(chrome.downloads||{}).download=="function"){if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return chrome.downloads.download({url:url,filename:fname,saveAs:true});}var a=document.createElement("a");if(a.download!=null){/*:: if(document.body == null) throw new Error("unreachable"); */a.download=fname;a.href=url;document.body.appendChild(a);a.click();/*:: if(document.body == null) throw new Error("unreachable"); */document.body.removeChild(a);if(URL.revokeObjectURL&&typeof setTimeout!=='undefined')setTimeout(function(){URL.revokeObjectURL(url);},60000);return url;}}}// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var out=File(fname);out.open("w");out.encoding="binary";if(Array.isArray(payload))payload=a2s(payload);out.write(payload);out.close();return payload;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("cannot save file "+fname);}/* read binary data from file */function read_binary(path/*:string*/){if(typeof _fs!=='undefined')return _fs.readFileSync(path);if(typeof Deno!=='undefined')return Deno.readFileSync(path);// $FlowIgnore
if(typeof $!=='undefined'&&typeof File!=='undefined'&&typeof Folder!=='undefined')try{// extendscript
// $FlowIgnore
var infile=File(path);infile.open("r");infile.encoding="binary";var data=infile.read();infile.close();return data;}catch(e){if(!e.message||!e.message.match(/onstruct/))throw e;}throw new Error("Cannot access file "+path);}function keys(o/*:any*/)/*:Array<any>*/{var ks=(0,_keys2.default)(o),o2=[];for(var i=0;i<ks.length;++i){if(Object.prototype.hasOwnProperty.call(o,ks[i]))o2.push(ks[i]);}return o2;}function evert_key(obj/*:any*/,key/*:string*/)/*:EvertType*/{var o=[]/*:any*/,K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]][key]]==null)o[obj[K[i]][key]]=K[i];}return o;}function evert(obj/*:any*/)/*:EvertType*/{var o=[]/*:any*/,K=keys(obj);for(var i=0;i!==K.length;++i){o[obj[K[i]]]=K[i];}return o;}function evert_num(obj/*:any*/)/*:EvertNumType*/{var o=[]/*:any*/,K=keys(obj);for(var i=0;i!==K.length;++i){o[obj[K[i]]]=parseInt(K[i],10);}return o;}function evert_arr(obj/*:any*/)/*:EvertArrType*/{var o/*:EvertArrType*/=[]/*:any*/,K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]]]==null)o[obj[K[i]]]=[];o[obj[K[i]]].push(K[i]);}return o;}var basedate=/*#__PURE__*/new Date(1899,11,30,0,0,0);// 2209161600000
function datenum(v/*:Date*/,date1904/*:?boolean*/)/*:number*/{var epoch=/*#__PURE__*/v.getTime();if(date1904)epoch-=1462*24*60*60*1000;var dnthresh=/*#__PURE__*/basedate.getTime()+(/*#__PURE__*/v.getTimezoneOffset()-/*#__PURE__*/basedate.getTimezoneOffset())*60000;return(epoch-dnthresh)/(24*60*60*1000);}var refdate=/*#__PURE__*/new Date();var dnthresh=/*#__PURE__*/basedate.getTime()+(/*#__PURE__*/refdate.getTimezoneOffset()-/*#__PURE__*/basedate.getTimezoneOffset())*60000;var refoffset=/*#__PURE__*/refdate.getTimezoneOffset();function numdate(v/*:number*/)/*:Date*/{var out=new Date();out.setTime(v*24*60*60*1000+dnthresh);if(out.getTimezoneOffset()!==refoffset){out.setTime(out.getTime()+(out.getTimezoneOffset()-refoffset)*60000);}return out;}/* ISO 8601 Duration */function parse_isodur(s){var sec=0,mt=0,time=false;var m=s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);if(!m)throw new Error("|"+s+"| is not an ISO8601 Duration");for(var i=1;i!=m.length;++i){if(!m[i])continue;mt=1;if(i>3)time=true;switch(m[i].slice(m[i].length-1)){case'Y':throw new Error("Unsupported ISO Duration Field: "+m[i].slice(m[i].length-1));case'D':mt*=24;/* falls through */case'H':mt*=60;/* falls through */case'M':if(!time)throw new Error("Unsupported ISO Duration Field: M");else mt*=60;/* falls through */case'S':break;}sec+=mt*parseInt(m[i],10);}return sec;}var good_pd_date_1=/*#__PURE__*/new Date('2017-02-19T19:06:09.000Z');var good_pd_date=/*#__PURE__*/isNaN(/*#__PURE__*/good_pd_date_1.getFullYear())?/*#__PURE__*/new Date('2/19/17'):good_pd_date_1;var good_pd=/*#__PURE__*/good_pd_date.getFullYear()==2017;/* parses a date as a local date */function parseDate(str/*:string|Date*/,fixdate/*:?number*/)/*:Date*/{var d=new Date(str);if(good_pd){/*:: if(fixdate == null) fixdate = 0; */if(fixdate>0)d.setTime(d.getTime()+d.getTimezoneOffset()*60*1000);else if(fixdate<0)d.setTime(d.getTime()-d.getTimezoneOffset()*60*1000);return d;}if(str instanceof Date)return str;if(good_pd_date.getFullYear()==1917&&!isNaN(d.getFullYear())){var s=d.getFullYear();if(str.indexOf(""+s)>-1)return d;d.setFullYear(d.getFullYear()+100);return d;}var n=str.match(/\d+/g)||["2017","2","19","0","0","0"];var out=new Date(+n[0],+n[1]-1,+n[2],+n[3]||0,+n[4]||0,+n[5]||0);if(str.indexOf("Z")>-1)out=new Date(out.getTime()-out.getTimezoneOffset()*60*1000);return out;}function cc2str(arr/*:Array<number>*/,debomit)/*:string*/{if(has_buf&&Buffer.isBuffer(arr)){if(debomit){if(arr[0]==0xFF&&arr[1]==0xFE)return utf8write(arr.slice(2).toString("utf16le"));if(arr[1]==0xFE&&arr[2]==0xFF)return utf8write(utf16beread(arr.slice(2).toString("binary")));}return arr.toString("binary");}if(typeof TextDecoder!=="undefined")try{if(debomit){if(arr[0]==0xFF&&arr[1]==0xFE)return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));if(arr[0]==0xFE&&arr[1]==0xFF)return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));}var rev={"\u20AC":"\x80","\u201A":"\x82","\u0192":"\x83","\u201E":"\x84","\u2026":"\x85","\u2020":"\x86","\u2021":"\x87","\u02C6":"\x88","\u2030":"\x89","\u0160":"\x8a","\u2039":"\x8b","\u0152":"\x8c","\u017D":"\x8e","\u2018":"\x91","\u2019":"\x92","\u201C":"\x93","\u201D":"\x94","\u2022":"\x95","\u2013":"\x96","\u2014":"\x97","\u02DC":"\x98","\u2122":"\x99","\u0161":"\x9a","\u203A":"\x9b","\u0153":"\x9c","\u017E":"\x9e","\u0178":"\x9f"};if(Array.isArray(arr))arr=new Uint8Array(arr);return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g,function(c){return rev[c]||c;});}catch(e){}var o=[];for(var i=0;i!=arr.length;++i){o.push(String.fromCharCode(arr[i]));}return o.join("");}function dup(o/*:any*/)/*:any*/{if(typeof JSON!='undefined'&&!Array.isArray(o))return JSON.parse((0,_stringify2.default)(o));if((typeof o==="undefined"?"undefined":(0,_typeof3.default)(o))!='object'||o==null)return o;if(o instanceof Date)return new Date(o.getTime());var out={};for(var k in o){if(Object.prototype.hasOwnProperty.call(o,k))out[k]=dup(o[k]);}return out;}function fill(c/*:string*/,l/*:number*/)/*:string*/{var o="";while(o.length<l){o+=c;}return o;}/* TODO: stress test */function fuzzynum(s/*:string*/)/*:number*/{var v/*:number*/=Number(s);if(!isNaN(v))return isFinite(v)?v:NaN;if(!/\d/.test(s))return v;var wt=1;var ss=s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g,function(){wt*=100;return"";});if(!isNaN(v=Number(ss)))return v/wt;ss=ss.replace(/[(](.*)[)]/,function($$,$1){wt=-wt;return $1;});if(!isNaN(v=Number(ss)))return v/wt;return v;}var lower_months=['january','february','march','april','may','june','july','august','september','october','november','december'];function fuzzydate(s/*:string*/)/*:Date*/{var o=new Date(s),n=new Date(NaN);var y=o.getYear(),m=o.getMonth(),d=o.getDate();if(isNaN(d))return n;var lower=s.toLowerCase();if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)){lower=lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");if(lower.length>3&&lower_months.indexOf(lower)==-1)return n;}else if(lower.match(/[a-z]/))return n;if(y<0||y>8099)return n;if((m>0||d>1)&&y!=101)return o;if(s.match(/[^-0-9:,\/\\]/))return n;return o;}var split_regex=/*#__PURE__*/function(){var safe_split_regex="abacaba".split(/(:?b)/i).length==5;return function split_regex(str/*:string*/,re,def/*:string*/)/*:Array<string>*/{if(safe_split_regex||typeof re=="string")return str.split(re);var p=str.split(re),o=[p[0]];for(var i=1;i<p.length;++i){o.push(def);o.push(p[i]);}return o;};}();function getdatastr(data)/*:?string*/{if(!data)return null;if(data.content&&data.type)return cc2str(data.content,true);if(data.data)return debom(data.data);if(data.asNodeBuffer&&has_buf)return debom(data.asNodeBuffer().toString('binary'));if(data.asBinary)return debom(data.asBinary());if(data._data&&data._data.getContent)return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));return null;}function getdatabin(data){if(!data)return null;if(data.data)return char_codes(data.data);if(data.asNodeBuffer&&has_buf)return data.asNodeBuffer();if(data._data&&data._data.getContent){var o=data._data.getContent();if(typeof o=="string")return char_codes(o);return Array.prototype.slice.call(o);}if(data.content&&data.type)return data.content;return null;}function getdata(data){return data&&data.name.slice(-4)===".bin"?getdatabin(data):getdatastr(data);}/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive *//* OASIS does not comment on filename case sensitivity */function safegetzipfile(zip,file/*:string*/){var k=zip.FullPaths||keys(zip.files);var f=file.toLowerCase().replace(/[\/]/g,'\\'),g=f.replace(/\\/g,'\/');for(var i=0;i<k.length;++i){var n=k[i].replace(/^Root Entry[\/]/,"").toLowerCase();if(f==n||g==n)return zip.files?zip.files[k[i]]:zip.FileIndex[i];}return null;}function getzipfile(zip,file/*:string*/){var o=safegetzipfile(zip,file);if(o==null)throw new Error("Cannot find file "+file+" in zip");return o;}function getzipdata(zip,file/*:string*/,safe/*:?boolean*/)/*:any*/{if(!safe)return getdata(getzipfile(zip,file));if(!file)return null;try{return getzipdata(zip,file);}catch(e){return null;}}function getzipstr(zip,file/*:string*/,safe/*:?boolean*/)/*:?string*/{if(!safe)return getdatastr(getzipfile(zip,file));if(!file)return null;try{return getzipstr(zip,file);}catch(e){return null;}}function getzipbin(zip,file/*:string*/,safe/*:?boolean*/)/*:any*/{if(!safe)return getdatabin(getzipfile(zip,file));if(!file)return null;try{return getzipbin(zip,file);}catch(e){return null;}}function zipentries(zip){var k=zip.FullPaths||keys(zip.files),o=[];for(var i=0;i<k.length;++i){if(k[i].slice(-1)!='/')o.push(k[i].replace(/^Root Entry[\/]/,""));}return o.sort();}function zip_add_file(zip,path,content){if(zip.FullPaths){if(typeof content=="string"){var res;if(has_buf)res=Buffer_from(content);/* TODO: investigate performance in Edge 13 *///else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
else res=utf8decode(content);return CFB.utils.cfb_add(zip,path,res);}CFB.utils.cfb_add(zip,path,content);}else zip.file(path,content);}function zip_new(){return CFB.utils.cfb_new();}function zip_read(d,o){switch(o.type){case"base64":return CFB.read(d,{type:"base64"});case"binary":return CFB.read(d,{type:"binary"});case"buffer":case"array":return CFB.read(d,{type:"buffer"});}throw new Error("Unrecognized type "+o.type);}function resolve_path(path/*:string*/,base/*:string*/)/*:string*/{if(path.charAt(0)=="/")return path.slice(1);var result=base.split('/');if(base.slice(-1)!="/")result.pop();// folder path
var target=path.split('/');while(target.length!==0){var step=target.shift();if(step==='..')result.pop();else if(step!=='.')result.push(step);}return result.join('/');}var XML_HEADER='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg,tagregex2=/<[^>]*>/g;var tagregex=/*#__PURE__*/XML_HEADER.match(tagregex1)?tagregex1:tagregex2;var nsregex=/<\w*:/,nsregex2=/<(\/?)\w+:/;function parsexmltag(tag/*:string*/,skip_root/*:?boolean*/,skip_LC/*:?boolean*/)/*:any*/{var z={}/*:any*/;var eq=0,c=0;for(;eq!==tag.length;++eq){if((c=tag.charCodeAt(eq))===32||c===10||c===13)break;}if(!skip_root)z[0]=tag.slice(0,eq);if(eq===tag.length)return z;var m=tag.match(attregexg),j=0,v="",i=0,q="",cc="",quot=1;if(m)for(i=0;i!=m.length;++i){cc=m[i];for(c=0;c!=cc.length;++c){if(cc.charCodeAt(c)===61)break;}q=cc.slice(0,c).trim();while(cc.charCodeAt(c+1)==32){++c;}quot=(eq=cc.charCodeAt(c+1))==34||eq==39?1:0;v=cc.slice(c+1+quot,cc.length-quot);for(j=0;j!=q.length;++j){if(q.charCodeAt(j)===58)break;}if(j===q.length){if(q.indexOf("_")>0)q=q.slice(0,q.indexOf("_"));// from ods
z[q]=v;if(!skip_LC)z[q.toLowerCase()]=v;}else{var k=(j===5&&q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);if(z[k]&&q.slice(j-3,j)=="ext")continue;// from ods
z[k]=v;if(!skip_LC)z[k.toLowerCase()]=v;}}return z;}function strip_ns(x/*:string*/)/*:string*/{return x.replace(nsregex2,"<$1");}var encodings={'&quot;':'"','&apos;':"'",'&gt;':'>','&lt;':'<','&amp;':'&'};var rencoding=/*#__PURE__*/evert(encodings);//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var unescapexml/*:StringConv*/=/*#__PURE__*/function(){/* 22.4.2.4 bstr (Basic String) */var encregex=/&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig,coderegex=/_x([\da-fA-F]{4})_/ig;return function unescapexml(text/*:string*/)/*:string*/{var s=text+'',i=s.indexOf("<![CDATA[");if(i==-1)return s.replace(encregex,function($$,$1){return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$;}).replace(coderegex,function(m,c){return String.fromCharCode(parseInt(c,16));});var j=s.indexOf("]]>");return unescapexml(s.slice(0,i))+s.slice(i+9,j)+unescapexml(s.slice(j+3));};}();var decregex=/[&<>'"]/g,charegex=/[\u0000-\u0008\u000b-\u001f]/g;function escapexml(text/*:string*/)/*:string*/{var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(charegex,function(s){return"_x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+"_";});}function escapexmltag(text/*:string*/)/*:string*/{return escapexml(text).replace(/ /g,"_x0020_");}var htmlcharegex=/[\u0000-\u001f]/g;function escapehtml(text/*:string*/)/*:string*/{var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(/\n/g,"<br/>").replace(htmlcharegex,function(s){return"&#x"+("000"+s.charCodeAt(0).toString(16)).slice(-4)+";";});}function escapexlml(text/*:string*/)/*:string*/{var s=text+'';return s.replace(decregex,function(y){return rencoding[y];}).replace(htmlcharegex,function(s){return"&#x"+s.charCodeAt(0).toString(16).toUpperCase()+";";});}/* TODO: handle codepages */var xlml_fixstr/*:StringConv*/=/*#__PURE__*/function(){var entregex=/&#(\d+);/g;function entrepl($$/*:string*/,$1/*:string*/)/*:string*/{return String.fromCharCode(parseInt($1,10));}return function xlml_fixstr(str/*:string*/)/*:string*/{return str.replace(entregex,entrepl);};}();function xlml_unfixstr(str/*:string*/)/*:string*/{return str.replace(/(\r\n|[\r\n])/g,"\&#10;");}function parsexmlbool(value/*:any*/)/*:boolean*/{switch(value){case 1:case true:case'1':case'true':case'TRUE':return true;/* case '0': case 'false': case 'FALSE':*/default:return false;}}function utf8reada(orig/*:string*/)/*:string*/{var out="",i=0,c=0,d=0,e=0,f=0,w=0;while(i<orig.length){c=orig.charCodeAt(i++);if(c<128){out+=String.fromCharCode(c);continue;}d=orig.charCodeAt(i++);if(c>191&&c<224){f=(c&31)<<6;f|=d&63;out+=String.fromCharCode(f);continue;}e=orig.charCodeAt(i++);if(c<240){out+=String.fromCharCode((c&15)<<12|(d&63)<<6|e&63);continue;}f=orig.charCodeAt(i++);w=((c&7)<<18|(d&63)<<12|(e&63)<<6|f&63)-65536;out+=String.fromCharCode(0xD800+(w>>>10&1023));out+=String.fromCharCode(0xDC00+(w&1023));}return out;}function utf8readb(data){var out=new_raw_buf(2*data.length),w,i,j=1,k=0,ww=0,c;for(i=0;i<data.length;i+=j){j=1;if((c=data.charCodeAt(i))<128)w=c;else if(c<224){w=(c&31)*64+(data.charCodeAt(i+1)&63);j=2;}else if(c<240){w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63);j=3;}else{j=4;w=(c&7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);w-=65536;ww=0xD800+(w>>>10&1023);w=0xDC00+(w&1023);}if(ww!==0){out[k++]=ww&255;out[k++]=ww>>>8;ww=0;}out[k++]=w%256;out[k++]=w>>>8;}return out.slice(0,k).toString('ucs2');}function utf8readc(data){return Buffer_from(data,'binary').toString('utf8');}var utf8corpus="foo bar baz\xE2\x98\x83\xF0\x9F\x8D\xA3";var utf8read=has_buf&&(/*#__PURE__*/utf8readc(utf8corpus)==/*#__PURE__*/utf8reada(utf8corpus)&&utf8readc||/*#__PURE__*/utf8readb(utf8corpus)==/*#__PURE__*/utf8reada(utf8corpus)&&utf8readb)||utf8reada;var utf8write/*:StringConv*/=has_buf?function(data){return Buffer_from(data,'utf8').toString("binary");}:function(orig/*:string*/)/*:string*/{var out/*:Array<string>*/=[],i=0,c=0,d=0;while(i<orig.length){c=orig.charCodeAt(i++);switch(true){case c<128:out.push(String.fromCharCode(c));break;case c<2048:out.push(String.fromCharCode(192+(c>>6)));out.push(String.fromCharCode(128+(c&63)));break;case c>=55296&&c<57344:c-=55296;d=orig.charCodeAt(i++)-56320+(c<<10);out.push(String.fromCharCode(240+(d>>18&7)));out.push(String.fromCharCode(144+(d>>12&63)));out.push(String.fromCharCode(128+(d>>6&63)));out.push(String.fromCharCode(128+(d&63)));break;default:out.push(String.fromCharCode(224+(c>>12)));out.push(String.fromCharCode(128+(c>>6&63)));out.push(String.fromCharCode(128+(c&63)));}}return out.join("");};// matches <foo>...</foo> extracts content
var matchtag=/*#__PURE__*/function(){var mtcache/*:{[k:string]:RegExp}*/={}/*:any*/;return function matchtag(f/*:string*/,g/*:?string*/)/*:RegExp*/{var t=f+"|"+(g||"");if(mtcache[t])return mtcache[t];return mtcache[t]=new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',g||"");};}();/*:any*/var htmldecode/*:{(s:string):string}*/=/*#__PURE__*/function(){var entities/*:Array<[RegExp, string]>*/=[['nbsp',' '],['middot','·'],['quot','"'],['apos',"'"],['gt','>'],['lt','<'],['amp','&']].map(function(x/*:[string, string]*/){return[new RegExp('&'+x[0]+';',"ig"),x[1]];});return function htmldecode(str/*:string*/)/*:string*/{var o=str// Remove new lines and spaces from start of content
.replace(/^[\t\n\r ]+/,"")// Remove new lines and spaces from end of content
.replace(/[\t\n\r ]+$/,"")// Added line which removes any white space characters after and before html tags
.replace(/>\s+/g,">").replace(/\s+</g,"<")// Replace remaining new lines and spaces with space
.replace(/[\t\n\r ]+/g," ")// Replace <br> tags with new lines
.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")// Strip HTML elements
.replace(/<[^>]*>/g,"");for(var i=0;i<entities.length;++i){o=o.replace(entities[i][0],entities[i][1]);}return o;};}();var vtregex=/*#__PURE__*/function(){var vt_cache={};return function vt_regex(bt){if(vt_cache[bt]!==undefined)return vt_cache[bt];return vt_cache[bt]=new RegExp("<(?:vt:)?"+bt+">([\\s\\S]*?)</(?:vt:)?"+bt+">",'g');};}();var vtvregex=/<\/?(?:vt:)?variant>/g,vtmregex=/<(?:vt:)([^>]*)>([\s\S]*)</;function parseVector(data/*:string*/,opts)/*:Array<{v:string,t:string}>*/{var h=parsexmltag(data);var matches/*:Array<string>*/=data.match(vtregex(h.baseType))||[];var res/*:Array<any>*/=[];if(matches.length!=h.size){if(opts.WTF)throw new Error("unexpected vector length "+matches.length+" != "+h.size);return res;}matches.forEach(function(x/*:string*/){var v=x.replace(vtvregex,"").match(vtmregex);if(v)res.push({v:utf8read(v[2]),t:v[1]});});return res;}var wtregex=/(^\s|\s$|\n)/;function writetag(f/*:string*/,g/*:string*/)/*:string*/{return'<'+f+(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f+'>';}function wxt_helper(h)/*:string*/{return keys(h).map(function(k){return" "+k+'="'+h[k]+'"';}).join("");}function writextag(f/*:string*/,g/*:?string*/,h){return'<'+f+(h!=null?wxt_helper(h):"")+(g!=null?(g.match(wtregex)?' xml:space="preserve"':"")+'>'+g+'</'+f:"/")+'>';}function write_w3cdtf(d/*:Date*/,t/*:?boolean*/)/*:string*/{try{return d.toISOString().replace(/\.\d*/,"");}catch(e){if(t)throw e;}return"";}function write_vt(s,xlsx/*:?boolean*/)/*:string*/{switch(typeof s==="undefined"?"undefined":(0,_typeof3.default)(s)){case'string':var o=writextag('vt:lpwstr',escapexml(s));if(xlsx)o=o.replace(/&quot;/g,"_x0022_");return o;case'number':return writextag((s|0)==s?'vt:i4':'vt:r8',escapexml(String(s)));case'boolean':return writextag('vt:bool',s?'true':'false');}if(s instanceof Date)return writextag('vt:filetime',write_w3cdtf(s));throw new Error("Unable to serialize "+s);}function xlml_normalize(d)/*:string*/{if(has_buf&&/*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/Buffer.isBuffer(d))return d.toString('utf8');if(typeof d==='string')return d;/* duktape */if(typeof Uint8Array!=='undefined'&&d instanceof Uint8Array)return utf8read(a2s(ab2a(d)));throw new Error("Bad input format: expected Buffer or string");}/* UOS uses CJK in tags */var xlmlregex=/<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
var XMLNS={CORE_PROPS:'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',CUST_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",EXT_PROPS:"http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",CT:'http://schemas.openxmlformats.org/package/2006/content-types',RELS:'http://schemas.openxmlformats.org/package/2006/relationships',TCMNT:'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments','dc':'http://purl.org/dc/elements/1.1/','dcterms':'http://purl.org/dc/terms/','dcmitype':'http://purl.org/dc/dcmitype/','mx':'http://schemas.microsoft.com/office/mac/excel/2008/main','r':'http://schemas.openxmlformats.org/officeDocument/2006/relationships','sjs':'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties','vt':'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes','xsi':'http://www.w3.org/2001/XMLSchema-instance','xsd':'http://www.w3.org/2001/XMLSchema'/*:any*/};var XMLNS_main=['http://schemas.openxmlformats.org/spreadsheetml/2006/main','http://purl.oclc.org/ooxml/spreadsheetml/main','http://schemas.microsoft.com/office/excel/2006/main','http://schemas.microsoft.com/office/excel/2006/2'];var XLMLNS={'o':'urn:schemas-microsoft-com:office:office','x':'urn:schemas-microsoft-com:office:excel','ss':'urn:schemas-microsoft-com:office:spreadsheet','dt':'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882','mv':'http://macVmlSchemaUri','v':'urn:schemas-microsoft-com:vml','html':'http://www.w3.org/TR/REC-html40'/*:any*/};function read_double_le(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{var s=1-2*(b[idx+7]>>>7);var e=((b[idx+7]&0x7f)<<4)+(b[idx+6]>>>4&0x0f);var m=b[idx+6]&0x0f;for(var i=5;i>=0;--i){m=m*256+b[idx+i];}if(e==0x7ff)return m==0?s*Infinity:NaN;if(e==0)e=-1022;else{e-=1023;m+=Math.pow(2,52);}return s*Math.pow(2,e-52)*m;}function write_double_le(b/*:RawBytes|CFBlob*/,v/*:number*/,idx/*:number*/){var bs=(v<0||1/v==-Infinity?1:0)<<7,e=0,m=0;var av=bs?-v:v;if(!isFinite(av)){e=0x7ff;m=isNaN(v)?0x6969:0;}else if(av==0)e=m=0;else{e=Math.floor(Math.log(av)/Math.LN2);m=av*Math.pow(2,52-e);if(e<=-1023&&(!isFinite(m)||m<Math.pow(2,52))){e=-1022;}else{m-=Math.pow(2,52);e+=1023;}}for(var i=0;i<=5;++i,m/=256){b[idx+i]=m&0xff;}b[idx+6]=(e&0x0f)<<4|m&0xf;b[idx+7]=e>>4|bs;}var ___toBuffer=function ___toBuffer(bufs/*:Array<Array<RawBytes> >*/)/*:RawBytes*/{var x=[],w=10240;for(var i=0;i<bufs[0].length;++i){if(bufs[0][i])for(var j=0,L=bufs[0][i].length;j<L;j+=w){x.push.apply(x,bufs[0][i].slice(j,j+w));}}return x;};var __toBuffer=has_buf?function(bufs){return bufs[0].length>0&&Buffer.isBuffer(bufs[0][0])?Buffer.concat(bufs[0].map(function(x){return Buffer.isBuffer(x)?x:Buffer_from(x);})):___toBuffer(bufs);}:___toBuffer;var ___utf16le=function ___utf16le(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/{var ss/*:Array<string>*/=[];for(var i=s;i<e;i+=2){ss.push(String.fromCharCode(__readUInt16LE(b,i)));}return ss.join("").replace(chr0,'');};var __utf16le=has_buf?function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/{if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___utf16le(b,s,e);return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/;}:___utf16le;var ___hexlify=function ___hexlify(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/{var ss/*:Array<string>*/=[];for(var i=s;i<s+l;++i){ss.push(("0"+b[i].toString(16)).slice(-2));}return ss.join("");};var __hexlify=has_buf?function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/{return Buffer.isBuffer(b)/*:: && b instanceof Buffer*/?b.toString('hex',s,s+l):___hexlify(b,s,l);}:___hexlify;var ___utf8=function ___utf8(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/){var ss=[];for(var i=s;i<e;i++){ss.push(String.fromCharCode(__readUInt8(b,i)));}return ss.join("");};var __utf8=has_buf?function utf8_b(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/){return Buffer.isBuffer(b)/*:: && (b instanceof Buffer)*/?b.toString('utf8',s,e):___utf8(b,s,e);}:___utf8;var ___lpstr=function ___lpstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __lpstr=___lpstr;var ___cpstr=function ___cpstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __cpstr=___cpstr;var ___lpwstr=function ___lpwstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=2*__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):"";};var __lpwstr=___lpwstr;var ___lpp4=function lpp4_(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?__utf16le(b,i+4,i+4+len):"";};var __lpp4=___lpp4;var ___8lpp4=function ___8lpp4(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len):"";};var __8lpp4=___8lpp4;var ___double=function ___double(b/*:RawBytes|CFBlob*/,idx/*:number*/){return read_double_le(b,idx);};var __double=___double;var is_buf=function is_buf_a(a){return Array.isArray(a)||typeof Uint8Array!=="undefined"&&a instanceof Uint8Array;};if(has_buf/*:: && typeof Buffer !== 'undefined'*/){__lpstr=function lpstr_b(b/*:RawBytes|CFBlob*/,i/*:number*/){if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___lpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__cpstr=function cpstr_b(b/*:RawBytes|CFBlob*/,i/*:number*/){if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___cpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString('utf8',i+4,i+4+len-1):"";};__lpwstr=function lpwstr_b(b/*:RawBytes|CFBlob*/,i/*:number*/){if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___lpwstr(b,i);var len=2*b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len-1);};__lpp4=function lpp4_b(b/*:RawBytes|CFBlob*/,i/*:number*/){if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf16le',i+4,i+4+len);};__8lpp4=function lpp4_8b(b/*:RawBytes|CFBlob*/,i/*:number*/){if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/)return ___8lpp4(b,i);var len=b.readUInt32LE(i);return b.toString('utf8',i+4,i+4+len);};__double=function double_(b/*:RawBytes|CFBlob*/,i/*:number*/){if(Buffer.isBuffer(b)/*::&& b instanceof Buffer*/)return b.readDoubleLE(i);return ___double(b,i);};is_buf=function is_buf_b(a){return Buffer.isBuffer(a)||Array.isArray(a)||typeof Uint8Array!=="undefined"&&a instanceof Uint8Array;};}/* from js-xls */function cpdoit(){__utf16le=function __utf16le(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/){return $cptable.utils.decode(1200,b.slice(s,e)).replace(chr0,'');};__utf8=function __utf8(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/){return $cptable.utils.decode(65001,b.slice(s,e));};__lpstr=function __lpstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(current_ansi,b.slice(i+4,i+4+len-1)):"";};__cpstr=function __cpstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(current_codepage,b.slice(i+4,i+4+len-1)):"";};__lpwstr=function __lpwstr(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=2*__readUInt32LE(b,i);return len>0?$cptable.utils.decode(1200,b.slice(i+4,i+4+len-1)):"";};__lpp4=function __lpp4(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(1200,b.slice(i+4,i+4+len)):"";};__8lpp4=function __8lpp4(b/*:RawBytes|CFBlob*/,i/*:number*/){var len=__readUInt32LE(b,i);return len>0?$cptable.utils.decode(65001,b.slice(i+4,i+4+len)):"";};}if(typeof $cptable!=='undefined')cpdoit();var __readUInt8=function __readUInt8(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{return b[idx];};var __readUInt16LE=function __readUInt16LE(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{return b[idx+1]*(1<<8)+b[idx];};var __readInt16LE=function __readInt16LE(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{var u=b[idx+1]*(1<<8)+b[idx];return u<0x8000?u:(0xffff-u+1)*-1;};var __readUInt32LE=function __readUInt32LE(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx];};var __readInt32LE=function __readInt32LE(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{return b[idx+3]<<24|b[idx+2]<<16|b[idx+1]<<8|b[idx];};var __readInt32BE=function __readInt32BE(b/*:RawBytes|CFBlob*/,idx/*:number*/)/*:number*/{return b[idx]<<24|b[idx+1]<<16|b[idx+2]<<8|b[idx+3];};function ReadShift(size/*:number*/,t/*:?string*/)/*:number|string*/{var o="",oI/*:: :number = 0*/,oR,oo=[],w,vv,i,loc;switch(t){case'dbcs':loc=this.l;if(has_buf&&Buffer.isBuffer(this))o=this.slice(this.l,this.l+2*size).toString("utf16le");else for(i=0;i<size;++i){o+=String.fromCharCode(__readUInt16LE(this,loc));loc+=2;}size*=2;break;case'utf8':o=__utf8(this,this.l,this.l+size);break;case'utf16le':size*=2;o=__utf16le(this,this.l,this.l+size);break;case'wstr':if(typeof $cptable!=='undefined')o=$cptable.utils.decode(current_codepage,this.slice(this.l,this.l+2*size));else return ReadShift.call(this,size,'dbcs');size=2*size;break;/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */case'lpstr-ansi':o=__lpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;case'lpstr-cp':o=__cpstr(this,this.l);size=4+__readUInt32LE(this,this.l);break;/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */case'lpwstr':o=__lpwstr(this,this.l);size=4+2*__readUInt32LE(this,this.l);break;/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */case'lpp4':size=4+__readUInt32LE(this,this.l);o=__lpp4(this,this.l);if(size&0x02)size+=2;break;/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */case'8lpp4':size=4+__readUInt32LE(this,this.l);o=__8lpp4(this,this.l);if(size&0x03)size+=4-(size&0x03);break;case'cstr':size=0;o="";while((w=__readUInt8(this,this.l+size++))!==0){oo.push(_getchar(w));}o=oo.join("");break;case'_wstr':size=0;o="";while((w=__readUInt16LE(this,this.l+size))!==0){oo.push(_getchar(w));size+=2;}size+=2;o=oo.join("");break;/* sbcs and dbcs support continue records in the SST way TODO codepages */case'dbcs-cont':o="";loc=this.l;for(i=0;i<size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt16LE(this,loc)));loc+=2;}o=oo.join("");size*=2;break;case'cpstr':if(typeof $cptable!=='undefined'){o=$cptable.utils.decode(current_codepage,this.slice(this.l,this.l+size));break;}/* falls through */case'sbcs-cont':o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?'dbcs-cont':'sbcs-cont');return oo.join("")+vv;}oo.push(_getchar(__readUInt8(this,loc)));loc+=1;}o=oo.join("");break;default:switch(size){case 1:oI=__readUInt8(this,this.l);this.l++;return oI;case 2:oI=(t==='i'?__readInt16LE:__readUInt16LE)(this,this.l);this.l+=2;return oI;case 4:case-4:if(t==='i'||(this[this.l+3]&0x80)===0){oI=(size>0?__readInt32LE:__readInt32BE)(this,this.l);this.l+=4;return oI;}else{oR=__readUInt32LE(this,this.l);this.l+=4;}return oR;case 8:case-8:if(t==='f'){if(size==8)oR=__double(this,this.l);else oR=__double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]],0);this.l+=8;return oR;}else size=8;/* falls through */case 16:o=__hexlify(this,this.l,size);break;}}this.l+=size;return o;}var __writeUInt32LE=function __writeUInt32LE(b/*:RawBytes|CFBlob*/,val/*:number*/,idx/*:number*/)/*:void*/{b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;b[idx+2]=val>>>16&0xFF;b[idx+3]=val>>>24&0xFF;};var __writeInt32LE=function __writeInt32LE(b/*:RawBytes|CFBlob*/,val/*:number*/,idx/*:number*/)/*:void*/{b[idx]=val&0xFF;b[idx+1]=val>>8&0xFF;b[idx+2]=val>>16&0xFF;b[idx+3]=val>>24&0xFF;};var __writeUInt16LE=function __writeUInt16LE(b/*:RawBytes|CFBlob*/,val/*:number*/,idx/*:number*/)/*:void*/{b[idx]=val&0xFF;b[idx+1]=val>>>8&0xFF;};function WriteShift(t/*:number*/,val/*:string|number*/,f/*:?string*/)/*:any*/{var size=0,i=0;if(f==='dbcs'){/*:: if(typeof val !== 'string') throw new Error("unreachable"); */for(i=0;i!=val.length;++i){__writeUInt16LE(this,val.charCodeAt(i),this.l+2*i);}size=2*val.length;}else if(f==='sbcs'){if(typeof $cptable!=='undefined'&&current_ansi==874){/* TODO: use tables directly, don't encode *//*:: if(typeof val !== "string") throw new Error("unreachable"); */for(i=0;i!=val.length;++i){var cppayload=$cptable.utils.encode(current_ansi,val.charAt(i));this[this.l+i]=cppayload[0];}}else{/*:: if(typeof val !== 'string') throw new Error("unreachable"); */val=val.replace(/[^\x00-\x7F]/g,"_");/*:: if(typeof val !== 'string') throw new Error("unreachable"); */for(i=0;i!=val.length;++i){this[this.l+i]=val.charCodeAt(i)&0xFF;}}size=val.length;}else if(f==='hex'){for(;i<t;++i){/*:: if(typeof val !== "string") throw new Error("unreachable"); */this[this.l++]=parseInt(val.slice(2*i,2*i+2),16)||0;}return this;}else if(f==='utf16le'){/*:: if(typeof val !== "string") throw new Error("unreachable"); */var end/*:number*/=Math.min(this.l+t,this.length);for(i=0;i<Math.min(val.length,t);++i){var cc=val.charCodeAt(i);this[this.l++]=cc&0xff;this[this.l++]=cc>>8;}while(this.l<end){this[this.l++]=0;}return this;}else/*:: if(typeof val === 'number') */switch(t){case 1:size=1;this[this.l]=val&0xFF;break;case 2:size=2;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;break;case 3:size=3;this[this.l]=val&0xFF;val>>>=8;this[this.l+1]=val&0xFF;val>>>=8;this[this.l+2]=val&0xFF;break;case 4:size=4;__writeUInt32LE(this,val,this.l);break;case 8:size=8;if(f==='f'){write_double_le(this,val,this.l);break;}/* falls through */case 16:break;case-4:size=4;__writeInt32LE(this,val,this.l);break;}this.l+=size;return this;}function CheckField(hexstr/*:string*/,fld/*:string*/)/*:void*/{var m=__hexlify(this,this.l,hexstr.length>>1);if(m!==hexstr)throw new Error(fld+'Expected '+hexstr+' saw '+m);this.l+=hexstr.length>>1;}function prep_blob(blob,pos/*:number*/)/*:void*/{blob.l=pos;blob.read_shift=/*::(*/ReadShift/*:: :any)*/;blob.chk=CheckField;blob.write_shift=WriteShift;}function parsenoop(blob,length/*:: :number, opts?:any */){blob.l+=length;}function new_buf(sz/*:number*/)/*:Block*/{var o=new_raw_buf(sz);prep_blob(o,0);return o;}/* [MS-XLSB] 2.1.4 Record */function recordhopper(data,cb/*:RecordHopperCB*/,opts/*:?any*/){if(!data)return;var tmpbyte,cntbyte,length;prep_blob(data,data.l||0);var L=data.length,RT=0,tgt=0;while(data.l<L){RT=data.read_shift(1);if(RT&0x80)RT=(RT&0x7F)+((data.read_shift(1)&0x7F)<<7);var R=XLSBRecordEnum[RT]||XLSBRecordEnum[0xFFFF];tmpbyte=data.read_shift(1);length=tmpbyte&0x7F;for(cntbyte=1;cntbyte<4&&tmpbyte&0x80;++cntbyte){length+=((tmpbyte=data.read_shift(1))&0x7F)<<7*cntbyte;}tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R,RT))return;}}/* control buffer usage for fixed-length buffers */function buf_array()/*:BufArray*/{var bufs/*:Array<Block>*/=[],blksz=has_buf?256:2048;var newblk=function ba_newblk(sz/*:number*/)/*:Block*/{var o/*:Block*/=new_buf(sz)/*:any*/;prep_blob(o,0);return o;};var curbuf/*:Block*/=newblk(blksz);var endbuf=function ba_endbuf(){if(!curbuf)return;if(curbuf.length>curbuf.l){curbuf=curbuf.slice(0,curbuf.l);curbuf.l=curbuf.length;}if(curbuf.length>0)bufs.push(curbuf);curbuf=null;};var next=function ba_next(sz/*:number*/)/*:Block*/{if(curbuf&&sz<curbuf.length-curbuf.l)return curbuf;endbuf();return curbuf=newblk(Math.max(sz+1,blksz));};var end=function ba_end(){endbuf();return bconcat(bufs);};var push=function ba_push(buf){endbuf();curbuf=buf;if(curbuf.l==null)curbuf.l=curbuf.length;next(blksz);};return{next:next,push:push,end:end,_bufs:bufs/*:any*/};}function write_record(ba/*:BufArray*/,type/*:number*/,payload,length/*:?number*/){var t/*:number*/=+type,l;if(isNaN(t))return;// TODO: throw something here?
if(!length)length=XLSBRecordEnum[t].p||(payload||[]).length||0;l=1+(t>=0x80?1:0)+1/* + length*/;if(length>=0x80)++l;if(length>=0x4000)++l;if(length>=0x200000)++l;var o=ba.next(l);if(t<=0x7F)o.write_shift(1,t);else{o.write_shift(1,(t&0x7F)+0x80);o.write_shift(1,t>>7);}for(var i=0;i!=4;++i){if(length>=0x80){o.write_shift(1,(length&0x7F)+0x80);length>>=7;}else{o.write_shift(1,length);break;}}if(/*:: length != null &&*/length>0&&is_buf(payload))ba.push(payload);}/* XLS ranges enforced */function shift_cell_xls(cell/*:CellAddress*/,tgt/*:any*/,opts/*:?any*/)/*:CellAddress*/{var out=dup(cell);if(tgt.s){if(out.cRel)out.c+=tgt.s.c;if(out.rRel)out.r+=tgt.s.r;}else{if(out.cRel)out.c+=tgt.c;if(out.rRel)out.r+=tgt.r;}if(!opts||opts.biff<12){while(out.c>=0x100){out.c-=0x100;}while(out.r>=0x10000){out.r-=0x10000;}}return out;}function shift_range_xls(cell,range,opts){var out=dup(cell);out.s=shift_cell_xls(out.s,range.s,opts);out.e=shift_cell_xls(out.e,range.s,opts);return out;}function encode_cell_xls(c/*:CellAddress*/,biff/*:number*/)/*:string*/{if(c.cRel&&c.c<0){c=dup(c);while(c.c<0){c.c+=biff>8?0x4000:0x100;}}if(c.rRel&&c.r<0){c=dup(c);while(c.r<0){c.r+=biff>8?0x100000:biff>5?0x10000:0x4000;}}var s=encode_cell(c);if(!c.cRel&&c.cRel!=null)s=fix_col(s);if(!c.rRel&&c.rRel!=null)s=fix_row(s);return s;}function encode_range_xls(r,opts)/*:string*/{if(r.s.r==0&&!r.s.rRel){if(r.e.r==(opts.biff>=12?0xFFFFF:opts.biff>=8?0x10000:0x4000)&&!r.e.rRel){return(r.s.cRel?"":"$")+encode_col(r.s.c)+":"+(r.e.cRel?"":"$")+encode_col(r.e.c);}}if(r.s.c==0&&!r.s.cRel){if(r.e.c==(opts.biff>=12?0x3FFF:0xFF)&&!r.e.cRel){return(r.s.rRel?"":"$")+encode_row(r.s.r)+":"+(r.e.rRel?"":"$")+encode_row(r.e.r);}}return encode_cell_xls(r.s,opts.biff)+":"+encode_cell_xls(r.e,opts.biff);}function decode_row(rowstr/*:string*/)/*:number*/{return parseInt(unfix_row(rowstr),10)-1;}function encode_row(row/*:number*/)/*:string*/{return""+(row+1);}function fix_row(cstr/*:string*/)/*:string*/{return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2");}function unfix_row(cstr/*:string*/)/*:string*/{return cstr.replace(/\$(\d+)$/,"$1");}function decode_col(colstr/*:string*/)/*:number*/{var c=unfix_col(colstr),d=0,i=0;for(;i!==c.length;++i){d=26*d+c.charCodeAt(i)-64;}return d-1;}function encode_col(col/*:number*/)/*:string*/{if(col<0)throw new Error("invalid column "+col);var s="";for(++col;col;col=Math.floor((col-1)/26)){s=String.fromCharCode((col-1)%26+65)+s;}return s;}function fix_col(cstr/*:string*/)/*:string*/{return cstr.replace(/^([A-Z])/,"$$$1");}function unfix_col(cstr/*:string*/)/*:string*/{return cstr.replace(/^\$([A-Z])/,"$1");}function split_cell(cstr/*:string*/)/*:Array<string>*/{return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",");}//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr/*:string*/)/*:CellAddress*/{var R=0,C=0;for(var i=0;i<cstr.length;++i){var cc=cstr.charCodeAt(i);if(cc>=48&&cc<=57)R=10*R+(cc-48);else if(cc>=65&&cc<=90)C=26*C+(cc-64);}return{c:C-1,r:R-1};}//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell/*:CellAddress*/)/*:string*/{var col=cell.c+1;var s="";for(;col;col=(col-1)/26|0){s=String.fromCharCode((col-1)%26+65)+s;}return s+(cell.r+1);}function decode_range(range/*:string*/)/*:Range*/{var idx=range.indexOf(":");if(idx==-1)return{s:decode_cell(range),e:decode_cell(range)};return{s:decode_cell(range.slice(0,idx)),e:decode_cell(range.slice(idx+1))};}/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */function encode_range(cs/*:CellAddrSpec|Range*/,ce/*:?CellAddrSpec*/)/*:string*/{if(typeof ce==='undefined'||typeof ce==='number'){/*:: if(!(cs instanceof Range)) throw "unreachable"; */return encode_range(cs.s,cs.e);}/*:: if((cs instanceof Range)) throw "unreachable"; */if(typeof cs!=='string')cs=encode_cell(cs/*:any*/);if(typeof ce!=='string')ce=encode_cell(ce/*:any*/);/*:: if(typeof cs !== 'string') throw "unreachable"; *//*:: if(typeof ce !== 'string') throw "unreachable"; */return cs==ce?cs:cs+":"+ce;}function safe_decode_range(range/*:string*/)/*:Range*/{var o={s:{c:0,r:0},e:{c:0,r:0}};var idx=0,i=0,cc=0;var len=range.length;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.s.c=--idx;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.s.r=--idx;if(i===len||cc!=10){o.e.c=o.s.c;o.e.r=o.s.r;return o;}++i;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}o.e.c=--idx;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc;}o.e.r=--idx;return o;}function safe_format_cell(cell/*:Cell*/,v/*:any*/){var q=cell.t=='d'&&v instanceof Date;if(cell.z!=null)try{return cell.w=SSF_format(cell.z,q?datenum(v):v);}catch(e){}try{return cell.w=SSF_format((cell.XF||{}).numFmtId||(q?14:0),q?datenum(v):v);}catch(e){return''+v;}}function format_cell(cell/*:Cell*/,v/*:any*/,o/*:any*/){if(cell==null||cell.t==null||cell.t=='z')return"";if(cell.w!==undefined)return cell.w;if(cell.t=='d'&&!cell.z&&o&&o.dateNF)cell.z=o.dateNF;if(cell.t=="e")return BErr[cell.v]||cell.v;if(v==undefined)return safe_format_cell(cell,cell.v);return safe_format_cell(cell,v);}function sheet_to_workbook(sheet/*:Worksheet*/,opts)/*:Workbook*/{var n=opts&&opts.sheet?opts.sheet:"Sheet1";var sheets={};sheets[n]=sheet;return{SheetNames:[n],Sheets:sheets};}function sheet_add_aoa(_ws/*:?Worksheet*/,data/*:AOA*/,opts/*:?any*/)/*:Worksheet*/{var o=opts||{};var dense=_ws?Array.isArray(_ws):o.dense;if(DENSE!=null&&dense==null)dense=DENSE;var ws/*:Worksheet*/=_ws||(dense?[]/*:any*/:{}/*:any*/);var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin/*:CellAddress*/=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}if(!ws["!ref"])ws["!ref"]="A1:A1";}var range/*:Range*/={s:{c:10000000,r:10000000},e:{c:0,r:0}/*:any*/};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.s.c=_range.s.c;range.s.r=_range.s.r;range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1)range.e.r=_R=_range.e.r+1;}for(var R=0;R!=data.length;++R){if(!data[R])continue;if(!Array.isArray(data[R]))throw new Error("aoa_to_sheet expects an array of arrays");for(var C=0;C!=data[R].length;++C){if(typeof data[R][C]==='undefined')continue;var cell/*:Cell*/={v:data[R][C]/*:any*/};var __R=_R+R,__C=_C+C;if(range.s.r>__R)range.s.r=__R;if(range.s.c>__C)range.s.c=__C;if(range.e.r<__R)range.e.r=__R;if(range.e.c<__C)range.e.c=__C;if(data[R][C]&&(0,_typeof3.default)(data[R][C])==='object'&&!Array.isArray(data[R][C])&&!(data[R][C]instanceof Date))cell=data[R][C];else{if(Array.isArray(cell.v)){cell.f=data[R][C][1];cell.v=cell.v[0];}if(cell.v===null){if(cell.f)cell.t='n';else if(o.nullError){cell.t='e';cell.v=0;}else if(!o.sheetStubs)continue;else cell.t='z';}else if(typeof cell.v==='number')cell.t='n';else if(typeof cell.v==='boolean')cell.t='b';else if(cell.v instanceof Date){cell.z=o.dateNF||table_fmt[14];if(o.cellDates){cell.t='d';cell.w=SSF_format(cell.z,datenum(cell.v));}else{cell.t='n';cell.v=datenum(cell.v);cell.w=SSF_format(cell.z,cell.v);}}else cell.t='s';}if(dense){if(!ws[__R])ws[__R]=[];if(ws[__R][__C]&&ws[__R][__C].z)cell.z=ws[__R][__C].z;ws[__R][__C]=cell;}else{var cell_ref=encode_cell({c:__C,r:__R/*:any*/});if(ws[cell_ref]&&ws[cell_ref].z)cell.z=ws[cell_ref].z;ws[cell_ref]=cell;}}}if(range.s.c<10000000)ws['!ref']=encode_range(range);return ws;}function aoa_to_sheet(data/*:AOA*/,opts/*:?any*/)/*:Worksheet*/{return sheet_add_aoa(null,data,opts);}function parse_Int32LE(data){return data.read_shift(4,'i');}function write_UInt32LE(x/*:number*/,o){if(!o)o=new_buf(4);o.write_shift(4,x);return o;}/* [MS-XLSB] 2.5.168 */function parse_XLWideString(data/*::, length*/)/*:string*/{var cchCharacters=data.read_shift(4);return cchCharacters===0?"":data.read_shift(cchCharacters,'dbcs');}function write_XLWideString(data/*:string*/,o){var _null=false;if(o==null){_null=true;o=new_buf(4+2*data.length);}o.write_shift(4,data.length);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.91 *///function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */function parse_StrRun(data){return{ich:data.read_shift(2),ifnt:data.read_shift(2)};}function write_StrRun(run,o){if(!o)o=new_buf(4);o.write_shift(2,run.ich||0);o.write_shift(2,run.ifnt||0);return o;}/* [MS-XLSB] 2.5.121 */function parse_RichStr(data,length/*:number*/)/*:XLString*/{var start=data.l;var flags=data.read_shift(1);var str=parse_XLWideString(data);var rgsStrRun=[];var z={t:str,h:str/*:any*/};if((flags&1)!==0){/* fRichStr *//* TODO: formatted string */var dwSizeStrRun=data.read_shift(4);for(var i=0;i!=dwSizeStrRun;++i){rgsStrRun.push(parse_StrRun(data));}z.r=rgsStrRun;}else z.r=[{ich:0,ifnt:0}];//if((flags & 2) !== 0) { /* fExtStr */
//	/* TODO: phonetic string */
//}
data.l=start+length;return z;}function write_RichStr(str/*:XLString*/,o/*:?Block*/)/*:Block*/{/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(15+4*str.t.length);}o.write_shift(1,0);write_XLWideString(str.t,o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */var parse_BrtCommentText=parse_RichStr;function write_BrtCommentText(str/*:XLString*/,o/*:?Block*/)/*:Block*/{/* TODO: formatted string */var _null=false;if(o==null){_null=true;o=new_buf(23+4*str.t.length);}o.write_shift(1,1);write_XLWideString(str.t,o);o.write_shift(4,1);write_StrRun({ich:0,ifnt:0},o);return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.9 */function parse_XLSBCell(data)/*:any*/{var col=data.read_shift(4);var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return{c:col,iStyleRef:iStyleRef};}function write_XLSBCell(cell/*:any*/,o/*:?Block*/){if(o==null)o=new_buf(8);o.write_shift(-4,cell.c);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* Short XLSB Cell does not include column */function parse_XLSBShortCell(data)/*:any*/{var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;data.l++;//var fPhShow = data.read_shift(1);
return{c:-1,iStyleRef:iStyleRef};}function write_XLSBShortCell(cell/*:any*/,o/*:?Block*/){if(o==null)o=new_buf(4);o.write_shift(3,cell.iStyleRef||cell.s);o.write_shift(1,0);/* fPhShow */return o;}/* [MS-XLSB] 2.5.21 */var parse_XLSBCodeName=parse_XLWideString;var write_XLSBCodeName=write_XLWideString;/* [MS-XLSB] 2.5.166 */function parse_XLNullableWideString(data/*::, length*/)/*:string*/{var cchCharacters=data.read_shift(4);return cchCharacters===0||cchCharacters===0xFFFFFFFF?"":data.read_shift(cchCharacters,'dbcs');}function write_XLNullableWideString(data/*:string*/,o){var _null=false;if(o==null){_null=true;o=new_buf(127);}o.write_shift(4,data.length>0?data.length:0xFFFFFFFF);if(data.length>0)o.write_shift(0,data,'dbcs');return _null?o.slice(0,o.l):o;}/* [MS-XLSB] 2.5.165 */var parse_XLNameWideString=parse_XLWideString;//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */var parse_RelID=parse_XLNullableWideString;var write_RelID=write_XLNullableWideString;/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */function parse_RkNumber(data)/*:number*/{var b=data.slice(data.l,data.l+4);var fX100=b[0]&1,fInt=b[0]&2;data.l+=4;var RK=fInt===0?__double([0,0,0,0,b[0]&0xFC,b[1],b[2],b[3]],0):__readInt32LE(b,0)>>2;return fX100?RK/100:RK;}function write_RkNumber(data/*:number*/,o){if(o==null)o=new_buf(4);var fX100=0,fInt=0,d100=data*100;if(data==(data|0)&&data>=-(1<<29)&&data<1<<29){fInt=1;}else if(d100==(d100|0)&&d100>=-(1<<29)&&d100<1<<29){fInt=1;fX100=1;}if(fInt)o.write_shift(-4,((fX100?d100:data)<<2)+(fX100+2));else throw new Error("unsupported RkNumber "+data);// TODO
}/* [MS-XLSB] 2.5.117 RfX */function parse_RfX(data/*::, length*/)/*:Range*/{var cell/*:Range*/={s:{},e:{}/*:any*/};cell.s.r=data.read_shift(4);cell.e.r=data.read_shift(4);cell.s.c=data.read_shift(4);cell.e.c=data.read_shift(4);return cell;}function write_RfX(r/*:Range*/,o){if(!o)o=new_buf(16);o.write_shift(4,r.s.r);o.write_shift(4,r.e.r);o.write_shift(4,r.s.c);o.write_shift(4,r.e.c);return o;}/* [MS-XLSB] 2.5.153 UncheckedRfX */var parse_UncheckedRfX=parse_RfX;var write_UncheckedRfX=write_RfX;/* [MS-XLSB] 2.5.155 UncheckedSqRfX *///function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 *//* TODO: error checking, NaN and Infinity values are not valid Xnum */function parse_Xnum(data/*::, length*/){if(data.length-data.l<8)throw"XLS Xnum Buffer underflow";return data.read_shift(8,'f');}function write_Xnum(data,o){return(o||new_buf(8)).write_shift(8,data,'f');}/* [MS-XLSB] 2.4.324 BrtColor */function parse_BrtColor(data/*::, length*/){var out={};var d=data.read_shift(1);//var fValidRGB = d & 1;
var xColorType=d>>>1;var index=data.read_shift(1);var nTS=data.read_shift(2,'i');var bR=data.read_shift(1);var bG=data.read_shift(1);var bB=data.read_shift(1);data.l++;//var bAlpha = data.read_shift(1);
switch(xColorType){case 0:out.auto=1;break;case 1:out.index=index;var icv=XLSIcv[index];/* automatic pseudo index 81 */if(icv)out.rgb=rgb2Hex(icv);break;case 2:/* if(!fValidRGB) throw new Error("invalid"); */out.rgb=rgb2Hex([bR,bG,bB]);break;case 3:out.theme=index;break;}if(nTS!=0)out.tint=nTS>0?nTS/32767:nTS/32768;return out;}function write_BrtColor(color,o){if(!o)o=new_buf(8);if(!color||color.auto){o.write_shift(4,0);o.write_shift(4,0);return o;}if(color.index!=null){o.write_shift(1,0x02);o.write_shift(1,color.index);}else if(color.theme!=null){o.write_shift(1,0x06);o.write_shift(1,color.theme);}else{o.write_shift(1,0x05);o.write_shift(1,0);}var nTS=color.tint||0;if(nTS>0)nTS*=32767;else if(nTS<0)nTS*=32768;o.write_shift(2,nTS);if(!color.rgb||color.theme!=null){o.write_shift(2,0);o.write_shift(1,0);o.write_shift(1,0);}else{var rgb=color.rgb||'FFFFFF';if(typeof rgb=='number')rgb=("000000"+rgb.toString(16)).slice(-6);o.write_shift(1,parseInt(rgb.slice(0,2),16));o.write_shift(1,parseInt(rgb.slice(2,4),16));o.write_shift(1,parseInt(rgb.slice(4,6),16));o.write_shift(1,0xFF);}return o;}/* [MS-XLSB] 2.5.52 */function parse_FontFlags(data/*::, length, opts*/){var d=data.read_shift(1);data.l++;var out={fBold:d&0x01,fItalic:d&0x02,fUnderline:d&0x04,fStrikeout:d&0x08,fOutline:d&0x10,fShadow:d&0x20,fCondense:d&0x40,fExtend:d&0x80};return out;}function write_FontFlags(font,o){if(!o)o=new_buf(2);var grbit=(font.italic?0x02:0)|(font.strike?0x08:0)|(font.outline?0x10:0)|(font.shadow?0x20:0)|(font.condense?0x40:0)|(font.extend?0x80:0);o.write_shift(1,grbit);o.write_shift(1,0);return o;}/* [MS-OLEDS] 2.3.1 and 2.3.2 */function parse_ClipboardFormatOrString(o,w/*:number*/)/*:string*/{// $FlowIgnore
var ClipFmt={2:"BITMAP",3:"METAFILEPICT",8:"DIB",14:"ENHMETAFILE"};var m/*:number*/=o.read_shift(4);switch(m){case 0x00000000:return"";case 0xffffffff:case 0xfffffffe:return ClipFmt[o.read_shift(4)]||"";}if(m>0x190)throw new Error("Unsupported Clipboard: "+m.toString(16));o.l-=4;return o.read_shift(0,w==1?"lpstr":"lpwstr");}function parse_ClipboardFormatOrAnsiString(o){return parse_ClipboardFormatOrString(o,1);}function parse_ClipboardFormatOrUnicodeString(o){return parse_ClipboardFormatOrString(o,2);}/* [MS-OLEPS] 2.2 PropertyType */// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2=0x0002;var VT_I4=0x0003;//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL=0x000B;var VT_VARIANT=0x000C;//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4=0x0013;//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR=0x001E;//var VT_LPWSTR   = 0x001F;
var VT_FILETIME=0x0040;var VT_BLOB=0x0041;//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF=0x0047;//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR=0x1000;var VT_VECTOR_VARIANT=0x100C;var VT_VECTOR_LPSTR=0x101E;//var VT_ARRAY    = 0x2000;
var VT_STRING=0x0050;// 2.3.3.1.11 VtString
var VT_USTR=0x0051;// 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM=[VT_STRING,VT_USTR];/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */var DocSummaryPIDDSI={/*::[*/0x01/*::]*/:{n:'CodePage',t:VT_I2},/*::[*/0x02/*::]*/:{n:'Category',t:VT_STRING},/*::[*/0x03/*::]*/:{n:'PresentationFormat',t:VT_STRING},/*::[*/0x04/*::]*/:{n:'ByteCount',t:VT_I4},/*::[*/0x05/*::]*/:{n:'LineCount',t:VT_I4},/*::[*/0x06/*::]*/:{n:'ParagraphCount',t:VT_I4},/*::[*/0x07/*::]*/:{n:'SlideCount',t:VT_I4},/*::[*/0x08/*::]*/:{n:'NoteCount',t:VT_I4},/*::[*/0x09/*::]*/:{n:'HiddenCount',t:VT_I4},/*::[*/0x0a/*::]*/:{n:'MultimediaClipCount',t:VT_I4},/*::[*/0x0b/*::]*/:{n:'ScaleCrop',t:VT_BOOL},/*::[*/0x0c/*::]*/:{n:'HeadingPairs',t:VT_VECTOR_VARIANT/* VT_VECTOR | VT_VARIANT */},/*::[*/0x0d/*::]*/:{n:'TitlesOfParts',t:VT_VECTOR_LPSTR/* VT_VECTOR | VT_LPSTR */},/*::[*/0x0e/*::]*/:{n:'Manager',t:VT_STRING},/*::[*/0x0f/*::]*/:{n:'Company',t:VT_STRING},/*::[*/0x10/*::]*/:{n:'LinksUpToDate',t:VT_BOOL},/*::[*/0x11/*::]*/:{n:'CharacterCount',t:VT_I4},/*::[*/0x13/*::]*/:{n:'SharedDoc',t:VT_BOOL},/*::[*/0x16/*::]*/:{n:'HyperlinksChanged',t:VT_BOOL},/*::[*/0x17/*::]*/:{n:'AppVersion',t:VT_I4,p:'version'},/*::[*/0x18/*::]*/:{n:'DigSig',t:VT_BLOB},/*::[*/0x1A/*::]*/:{n:'ContentType',t:VT_STRING},/*::[*/0x1B/*::]*/:{n:'ContentStatus',t:VT_STRING},/*::[*/0x1C/*::]*/:{n:'Language',t:VT_STRING},/*::[*/0x1D/*::]*/:{n:'Version',t:VT_STRING},/*::[*/0xFF/*::]*/:{},/* [MS-OLEPS] 2.18 *//*::[*/0x80000000/*::]*/:{n:'Locale',t:VT_UI4},/*::[*/0x80000003/*::]*/:{n:'Behavior',t:VT_UI4},/*::[*/0x72627262/*::]*/:{}};/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */var SummaryPIDSI={/*::[*/0x01/*::]*/:{n:'CodePage',t:VT_I2},/*::[*/0x02/*::]*/:{n:'Title',t:VT_STRING},/*::[*/0x03/*::]*/:{n:'Subject',t:VT_STRING},/*::[*/0x04/*::]*/:{n:'Author',t:VT_STRING},/*::[*/0x05/*::]*/:{n:'Keywords',t:VT_STRING},/*::[*/0x06/*::]*/:{n:'Comments',t:VT_STRING},/*::[*/0x07/*::]*/:{n:'Template',t:VT_STRING},/*::[*/0x08/*::]*/:{n:'LastAuthor',t:VT_STRING},/*::[*/0x09/*::]*/:{n:'RevNumber',t:VT_STRING},/*::[*/0x0A/*::]*/:{n:'EditTime',t:VT_FILETIME},/*::[*/0x0B/*::]*/:{n:'LastPrinted',t:VT_FILETIME},/*::[*/0x0C/*::]*/:{n:'CreatedDate',t:VT_FILETIME},/*::[*/0x0D/*::]*/:{n:'ModifiedDate',t:VT_FILETIME},/*::[*/0x0E/*::]*/:{n:'PageCount',t:VT_I4},/*::[*/0x0F/*::]*/:{n:'WordCount',t:VT_I4},/*::[*/0x10/*::]*/:{n:'CharCount',t:VT_I4},/*::[*/0x11/*::]*/:{n:'Thumbnail',t:VT_CF},/*::[*/0x12/*::]*/:{n:'Application',t:VT_STRING},/*::[*/0x13/*::]*/:{n:'DocSecurity',t:VT_I4},/*::[*/0xFF/*::]*/:{},/* [MS-OLEPS] 2.18 *//*::[*/0x80000000/*::]*/:{n:'Locale',t:VT_UI4},/*::[*/0x80000003/*::]*/:{n:'Behavior',t:VT_UI4},/*::[*/0x72627262/*::]*/:{}};/* [MS-XLS] 2.4.63 Country/Region codes */var CountryEnum={/*::[*/0x0001/*::]*/:"US",// United States
/*::[*/0x0002/*::]*/:"CA",// Canada
/*::[*/0x0003/*::]*/:"",// Latin America (except Brazil)
/*::[*/0x0007/*::]*/:"RU",// Russia
/*::[*/0x0014/*::]*/:"EG",// Egypt
/*::[*/0x001E/*::]*/:"GR",// Greece
/*::[*/0x001F/*::]*/:"NL",// Netherlands
/*::[*/0x0020/*::]*/:"BE",// Belgium
/*::[*/0x0021/*::]*/:"FR",// France
/*::[*/0x0022/*::]*/:"ES",// Spain
/*::[*/0x0024/*::]*/:"HU",// Hungary
/*::[*/0x0027/*::]*/:"IT",// Italy
/*::[*/0x0029/*::]*/:"CH",// Switzerland
/*::[*/0x002B/*::]*/:"AT",// Austria
/*::[*/0x002C/*::]*/:"GB",// United Kingdom
/*::[*/0x002D/*::]*/:"DK",// Denmark
/*::[*/0x002E/*::]*/:"SE",// Sweden
/*::[*/0x002F/*::]*/:"NO",// Norway
/*::[*/0x0030/*::]*/:"PL",// Poland
/*::[*/0x0031/*::]*/:"DE",// Germany
/*::[*/0x0034/*::]*/:"MX",// Mexico
/*::[*/0x0037/*::]*/:"BR",// Brazil
/*::[*/0x003d/*::]*/:"AU",// Australia
/*::[*/0x0040/*::]*/:"NZ",// New Zealand
/*::[*/0x0042/*::]*/:"TH",// Thailand
/*::[*/0x0051/*::]*/:"JP",// Japan
/*::[*/0x0052/*::]*/:"KR",// Korea
/*::[*/0x0054/*::]*/:"VN",// Viet Nam
/*::[*/0x0056/*::]*/:"CN",// China
/*::[*/0x005A/*::]*/:"TR",// Turkey
/*::[*/0x0069/*::]*/:"JS",// Ramastan
/*::[*/0x00D5/*::]*/:"DZ",// Algeria
/*::[*/0x00D8/*::]*/:"MA",// Morocco
/*::[*/0x00DA/*::]*/:"LY",// Libya
/*::[*/0x015F/*::]*/:"PT",// Portugal
/*::[*/0x0162/*::]*/:"IS",// Iceland
/*::[*/0x0166/*::]*/:"FI",// Finland
/*::[*/0x01A4/*::]*/:"CZ",// Czech Republic
/*::[*/0x0376/*::]*/:"TW",// Taiwan
/*::[*/0x03C1/*::]*/:"LB",// Lebanon
/*::[*/0x03C2/*::]*/:"JO",// Jordan
/*::[*/0x03C3/*::]*/:"SY",// Syria
/*::[*/0x03C4/*::]*/:"IQ",// Iraq
/*::[*/0x03C5/*::]*/:"KW",// Kuwait
/*::[*/0x03C6/*::]*/:"SA",// Saudi Arabia
/*::[*/0x03CB/*::]*/:"AE",// United Arab Emirates
/*::[*/0x03CC/*::]*/:"IL",// Israel
/*::[*/0x03CE/*::]*/:"QA",// Qatar
/*::[*/0x03D5/*::]*/:"IR",// Iran
/*::[*/0xFFFF/*::]*/:"US"// United States
};/* [MS-XLS] 2.5.127 */var XLSFillPattern=[null,'solid','mediumGray','darkGray','lightGray','darkHorizontal','darkVertical','darkDown','darkUp','darkGrid','darkTrellis','lightHorizontal','lightVertical','lightDown','lightUp','lightGrid','lightTrellis','gray125','gray0625'];function rgbify(arr/*:Array<number>*/)/*:Array<[number, number, number]>*/{return arr.map(function(x){return[x>>16&255,x>>8&255,x&255];});}/* [MS-XLS] 2.5.161 *//* [MS-XLSB] 2.5.75 Icv */var _XLSIcv=/*#__PURE__*/rgbify([/* Color Constants */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,/* Overridable Defaults */0x000000,0xFFFFFF,0xFF0000,0x00FF00,0x0000FF,0xFFFF00,0xFF00FF,0x00FFFF,0x800000,0x008000,0x000080,0x808000,0x800080,0x008080,0xC0C0C0,0x808080,0x9999FF,0x993366,0xFFFFCC,0xCCFFFF,0x660066,0xFF8080,0x0066CC,0xCCCCFF,0x000080,0xFF00FF,0xFFFF00,0x00FFFF,0x800080,0x800000,0x008080,0x0000FF,0x00CCFF,0xCCFFFF,0xCCFFCC,0xFFFF99,0x99CCFF,0xFF99CC,0xCC99FF,0xFFCC99,0x3366FF,0x33CCCC,0x99CC00,0xFFCC00,0xFF9900,0xFF6600,0x666699,0x969696,0x003366,0x339966,0x003300,0x333300,0x993300,0x993366,0x333399,0x333333,/* Other entries to appease BIFF8/12 */0xFFFFFF,/* 0x40 icvForeground ?? */0x000000,/* 0x41 icvBackground ?? */0x000000,/* 0x42 icvFrame ?? */0x000000,/* 0x43 icv3D ?? */0x000000,/* 0x44 icv3DText ?? */0x000000,/* 0x45 icv3DHilite ?? */0x000000,/* 0x46 icv3DShadow ?? */0x000000,/* 0x47 icvHilite ?? */0x000000,/* 0x48 icvCtlText ?? */0x000000,/* 0x49 icvCtlScrl ?? */0x000000,/* 0x4A icvCtlInv ?? */0x000000,/* 0x4B icvCtlBody ?? */0x000000,/* 0x4C icvCtlFrame ?? */0x000000,/* 0x4D icvCtlFore ?? */0x000000,/* 0x4E icvCtlBack ?? */0x000000,/* 0x4F icvCtlNeutral */0x000000,/* 0x50 icvInfoBk ?? */0x000000/* 0x51 icvInfoText ?? */]);var XLSIcv=/*#__PURE__*/dup(_XLSIcv);/* [MS-XLSB] 2.5.97.2 */var BErr={/*::[*/0x00/*::]*/:"#NULL!",/*::[*/0x07/*::]*/:"#DIV/0!",/*::[*/0x0F/*::]*/:"#VALUE!",/*::[*/0x17/*::]*/:"#REF!",/*::[*/0x1D/*::]*/:"#NAME?",/*::[*/0x24/*::]*/:"#NUM!",/*::[*/0x2A/*::]*/:"#N/A",/*::[*/0x2B/*::]*/:"#GETTING_DATA",/*::[*/0xFF/*::]*/:"#WTF?"};//var RBErr = evert_num(BErr);
var RBErr={"#NULL!":0x00,"#DIV/0!":0x07,"#VALUE!":0x0F,"#REF!":0x17,"#NAME?":0x1D,"#NUM!":0x24,"#N/A":0x2A,"#GETTING_DATA":0x2B,"#WTF?":0xFF};/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX *//* 12.3 Part Summary <SpreadsheetML> *//* 14.2 Part Summary <DrawingML> *//* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */var ct2type/*{[string]:string}*/={/* Workbook */"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.sheet.macroEnabled.main+xml":"workbooks","application/vnd.ms-excel.sheet.binary.macroEnabled.main":"workbooks","application/vnd.ms-excel.addin.macroEnabled.main+xml":"workbooks","application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":"workbooks",/* Worksheet */"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":"sheets","application/vnd.ms-excel.worksheet":"sheets","application/vnd.ms-excel.binIndexWs":"TODO",/* Binary Index *//* Chartsheet */"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":"charts","application/vnd.ms-excel.chartsheet":"charts",/* Macrosheet */"application/vnd.ms-excel.macrosheet+xml":"macros","application/vnd.ms-excel.macrosheet":"macros","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO",/* Binary Index *//* Dialogsheet */"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":"dialogs","application/vnd.ms-excel.dialogsheet":"dialogs",/* Shared Strings */"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml":"strs","application/vnd.ms-excel.sharedStrings":"strs",/* Styles */"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":"styles","application/vnd.ms-excel.styles":"styles",/* File Properties */"application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops",/* Custom Data Properties */"application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty":"TODO",/* Comments */"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":"comments","application/vnd.ms-excel.comments":"comments","application/vnd.ms-excel.threadedcomments+xml":"threadedcomments","application/vnd.ms-excel.person+xml":"people",/* Metadata (Stock/Geography and Dynamic Array) */"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"metadata","application/vnd.ms-excel.sheetMetadata":"metadata",/* PivotTable */"application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO",/* Chart Objects */"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO",/* Chart Colors */"application/vnd.ms-office.chartcolorstyle+xml":"TODO",/* Chart Style */"application/vnd.ms-office.chartstyle+xml":"TODO",/* Chart Advanced */"application/vnd.ms-office.chartex+xml":"TODO",/* Calculation Chain */"application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains",/* Printer Settings */"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO",/* ActiveX */"application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO",/* Custom Toolbars */"application/vnd.ms-excel.attachedToolbars":"TODO",/* External Data Connections */"application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO",/* External Links */"application/vnd.ms-excel.externalLink":"links","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"links",/* PivotCache */"application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO",/* Query Table */"application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO",/* Shared Workbook */"application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO",/* Single Cell Table */"application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO",/* Slicer */"application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO",/* Sort Map */"application/vnd.ms-excel.wsSortMap":"TODO",/* Table */"application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO",/* Themes */"application/vnd.openxmlformats-officedocument.theme+xml":"themes",/* Theme Override */"application/vnd.openxmlformats-officedocument.themeOverride+xml":"TODO",/* Timeline */"application/vnd.ms-excel.Timeline+xml":"TODO",/* verify */"application/vnd.ms-excel.TimelineCache+xml":"TODO",/* verify *//* VBA */"application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"TODO",/* Volatile Dependencies */"application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO",/* Control Properties */"application/vnd.ms-excel.controlproperties+xml":"TODO",/* Data Model */"application/vnd.openxmlformats-officedocument.model+data":"TODO",/* Survey */"application/vnd.ms-excel.Survey+xml":"TODO",/* Drawing */"application/vnd.openxmlformats-officedocument.drawing+xml":"drawings","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO",/* VML */"application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO",/* Image */"image/png":"TODO","sheet":"js"/*:any*/};var CT_LIST={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xlam:"application/vnd.ms-excel.addin.macroEnabled.main+xml",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{/* Shared Strings */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},comments:{/* Comments */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",xlsb:"application/vnd.ms-excel.comments"},sheets:{/* Worksheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},charts:{/* Chartsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",xlsb:"application/vnd.ms-excel.chartsheet"},dialogs:{/* Dialogsheet */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",xlsb:"application/vnd.ms-excel.dialogsheet"},macros:{/* Macrosheet (Excel 4.0 Macros) */xlsx:"application/vnd.ms-excel.macrosheet+xml",xlsb:"application/vnd.ms-excel.macrosheet"},metadata:{/* Metadata (Stock/Geography and Dynamic Array) */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",xlsb:"application/vnd.ms-excel.sheetMetadata"},styles:{/* Styles */xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};function new_ct()/*:any*/{return{workbooks:[],sheets:[],charts:[],dialogs:[],macros:[],rels:[],strs:[],comments:[],threadedcomments:[],links:[],coreprops:[],extprops:[],custprops:[],themes:[],styles:[],calcchains:[],vba:[],drawings:[],metadata:[],people:[],TODO:[],xmlns:""/*:any*/};}function parse_ct(data/*:?string*/){var ct=new_ct();if(!data||!data.match)return ct;var ctext={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0].replace(nsregex,"<")){case'<?xml':break;case'<Types':ct.xmlns=y['xmlns'+(y[0].match(/<(\w+):/)||["",""])[1]];break;case'<Default':ctext[y.Extension]=y.ContentType;break;case'<Override':if(ct[ct2type[y.ContentType]]!==undefined)ct[ct2type[y.ContentType]].push(y.PartName);break;}});if(ct.xmlns!==XMLNS.CT)throw new Error("Unknown Namespace: "+ct.xmlns);ct.calcchain=ct.calcchains.length>0?ct.calcchains[0]:"";ct.sst=ct.strs.length>0?ct.strs[0]:"";ct.style=ct.styles.length>0?ct.styles[0]:"";ct.defaults=ctext;delete ct.calcchains;return ct;}function write_ct(ct,opts)/*:string*/{var type2ct/*{[string]:Array<string>}*/=evert_arr(ct2type);var o/*:Array<string>*/=[],v;o[o.length]=XML_HEADER;o[o.length]=writextag('Types',null,{'xmlns':XMLNS.CT,'xmlns:xsd':XMLNS.xsd,'xmlns:xsi':XMLNS.xsi});o=o.concat([['xml','application/xml'],['bin','application/vnd.ms-excel.sheet.binary.macroEnabled.main'],['vml','application/vnd.openxmlformats-officedocument.vmlDrawing'],['data','application/vnd.openxmlformats-officedocument.model+data'],/* from test files */['bmp','image/bmp'],['png','image/png'],['gif','image/gif'],['emf','image/x-emf'],['wmf','image/x-wmf'],['jpg','image/jpeg'],['jpeg','image/jpeg'],['tif','image/tiff'],['tiff','image/tiff'],['pdf','application/pdf'],['rels','application/vnd.openxmlformats-package.relationships+xml']].map(function(x){return writextag('Default',null,{'Extension':x[0],'ContentType':x[1]});}));/* only write first instance */var f1=function f1(w){if(ct[w]&&ct[w].length>0){v=ct[w][0];o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType]||CT_LIST[w]['xlsx']});}};/* book type-specific */var f2=function f2(w){(ct[w]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':CT_LIST[w][opts.bookType]||CT_LIST[w]['xlsx']});});};/* standard type */var f3=function f3(t){(ct[t]||[]).forEach(function(v){o[o.length]=writextag('Override',null,{'PartName':(v[0]=='/'?"":"/")+v,'ContentType':type2ct[t][0]});});};f1('workbooks');f2('sheets');f2('charts');f3('themes');['strs','styles'].forEach(f1);['coreprops','extprops','custprops'].forEach(f3);f3('vba');f3('comments');f3('threadedcomments');f3('drawings');f2('metadata');f3('people');if(o.length>2){o[o.length]='</Types>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 9.3 Relationships */var RELS={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",HLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",VML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",XPATH:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",XMISS:"http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",XLINK:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",CXML:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",CXMLP:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",CMNT:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",CORE_PROPS:"http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",EXT_PROPS:'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',CUST_PROPS:'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',SST:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",STY:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",THEME:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",CHART:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",CHARTEX:"http://schemas.microsoft.com/office/2014/relationships/chartEx",CS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",WS:["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet","http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"],DS:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",MS:"http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",IMG:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",DRAW:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",XLMETA:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",TCMNT:"http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",PEOPLE:"http://schemas.microsoft.com/office/2017/10/relationships/person",VBA:"http://schemas.microsoft.com/office/2006/relationships/vbaProject"/*:any*/};/* 9.3.3 Representing Relationships */function get_rels_path(file/*:string*/)/*:string*/{var n=file.lastIndexOf("/");return file.slice(0,n+1)+'_rels/'+file.slice(n+1)+".rels";}function parse_rels(data/*:?string*/,currentFilePath/*:string*/){var rels={"!id":{}};if(!data)return rels;if(currentFilePath.charAt(0)!=='/'){currentFilePath='/'+currentFilePath;}var hash={};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);/* 9.3.2.2 OPC_Relationships */if(y[0]==='<Relationship'){var rel={};rel.Type=y.Type;rel.Target=y.Target;rel.Id=y.Id;if(y.TargetMode)rel.TargetMode=y.TargetMode;var canonictarget=y.TargetMode==='External'?y.Target:resolve_path(y.Target,currentFilePath);rels[canonictarget]=rel;hash[y.Id]=rel;}});rels["!id"]=hash;return rels;}/* TODO */function write_rels(rels)/*:string*/{var o=[XML_HEADER,writextag('Relationships',null,{//'xmlns:ns0': XMLNS.RELS,
'xmlns':XMLNS.RELS})];keys(rels['!id']).forEach(function(rid){o[o.length]=writextag('Relationship',null,rels['!id'][rid]);});if(o.length>2){o[o.length]='</Relationships>';o[1]=o[1].replace("/>",">");}return o.join("");}function add_rels(rels,rId/*:number*/,f,type,relobj,targetmode/*:?string*/)/*:number*/{if(!relobj)relobj={};if(!rels['!id'])rels['!id']={};if(!rels['!idx'])rels['!idx']=1;if(rId<0)for(rId=rels['!idx'];rels['!id']['rId'+rId];++rId){/* empty */}rels['!idx']=rId+1;relobj.Id='rId'+rId;relobj.Type=type;relobj.Target=f;if(targetmode)relobj.TargetMode=targetmode;else if([RELS.HLINK,RELS.XPATH,RELS.XMISS].indexOf(relobj.Type)>-1)relobj.TargetMode="External";if(rels['!id'][relobj.Id])throw new Error("Cannot rewrite rId "+rId);rels['!id'][relobj.Id]=relobj;rels[('/'+relobj.Target).replace("//","/")]=relobj;return rId;}/* Open Document Format for Office Applications (OpenDocument) Version 1.2 *//* Part 3 Section 4 Manifest File */var CT_ODS="application/vnd.oasis.opendocument.spreadsheet";function parse_manifest(d,opts){var str=xlml_normalize(d);var Rn;var FEtag;while(Rn=xlmlregex.exec(str)){switch(Rn[3]){case'manifest':break;// 4.2 <manifest:manifest>
case'file-entry':// 4.3 <manifest:file-entry>
FEtag=parsexmltag(Rn[0],false);if(FEtag.path=='/'&&FEtag.type!==CT_ODS)throw new Error("This OpenDocument is not a spreadsheet");break;case'encryption-data':// 4.4 <manifest:encryption-data>
case'algorithm':// 4.5 <manifest:algorithm>
case'start-key-generation':// 4.6 <manifest:start-key-generation>
case'key-derivation':// 4.7 <manifest:key-derivation>
throw new Error("Unsupported ODS Encryption");default:if(opts&&opts.WTF)throw Rn;}}}function write_manifest(manifest/*:Array<Array<string> >*/)/*:string*/{var o=[XML_HEADER];o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');for(var i=0;i<manifest.length;++i){o.push('  <manifest:file-entry manifest:full-path="'+manifest[i][0]+'" manifest:media-type="'+manifest[i][1]+'"/>\n');}o.push('</manifest:manifest>');return o.join("");}/* Part 3 Section 6 Metadata Manifest File */function write_rdf_type(file/*:string*/,res/*:string*/,tag/*:?string*/){return['  <rdf:Description rdf:about="'+file+'">\n','    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/'+(tag||"odf")+'#'+res+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf_has(base/*:string*/,file/*:string*/){return['  <rdf:Description rdf:about="'+base+'">\n','    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="'+file+'"/>\n','  </rdf:Description>\n'].join("");}function write_rdf(rdf){var o=[XML_HEADER];o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');for(var i=0;i!=rdf.length;++i){o.push(write_rdf_type(rdf[i][0],rdf[i][1]));o.push(write_rdf_has("",rdf[i][0]));}o.push(write_rdf_type("","Document","pkg"));o.push('</rdf:RDF>');return o.join("");}/* TODO: pull properties */function write_meta_ods()/*:: wb: Workbook, opts: any*//*:string*/{return'<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet'+'JS '+XLSX.version+'</meta:generator></office:meta></office:document-meta>';}/* ECMA-376 Part II 11.1 Core Properties Part *//* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var CORE_PROPS/*:Array<Array<string> >*/=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate",'date'],["dcterms:modified","ModifiedDate",'date']];var CORE_PROPS_REGEX/*:Array<RegExp>*/=/*#__PURE__*/function(){var r=new Array(CORE_PROPS.length);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i];var g="(?:"+f[0].slice(0,f[0].indexOf(":"))+":)"+f[0].slice(f[0].indexOf(":")+1);r[i]=new RegExp("<"+g+"[^>]*>([\\s\\S]*?)<\/"+g+">");}return r;}();function parse_core_props(data){var p={};data=utf8read(data);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i],cur=data.match(CORE_PROPS_REGEX[i]);if(cur!=null&&cur.length>0)p[f[1]]=unescapexml(cur[1]);if(f[2]==='date'&&p[f[1]])p[f[1]]=parseDate(p[f[1]]);}return p;}function cp_doit(f,g,h,o,p){if(p[f]!=null||g==null||g==="")return;p[f]=g;g=escapexml(g);o[o.length]=h?writextag(f,g,h):writetag(f,g);}function write_core_props(cp,_opts){var opts=_opts||{};var o=[XML_HEADER,writextag('cp:coreProperties',null,{//'xmlns': XMLNS.CORE_PROPS,
'xmlns:cp':XMLNS.CORE_PROPS,'xmlns:dc':XMLNS.dc,'xmlns:dcterms':XMLNS.dcterms,'xmlns:dcmitype':XMLNS.dcmitype,'xmlns:xsi':XMLNS.xsi})],p={};if(!cp&&!opts.Props)return o.join("");if(cp){if(cp.CreatedDate!=null)cp_doit("dcterms:created",typeof cp.CreatedDate==="string"?cp.CreatedDate:write_w3cdtf(cp.CreatedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);if(cp.ModifiedDate!=null)cp_doit("dcterms:modified",typeof cp.ModifiedDate==="string"?cp.ModifiedDate:write_w3cdtf(cp.ModifiedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);}for(var i=0;i!=CORE_PROPS.length;++i){var f=CORE_PROPS[i];var v=opts.Props&&opts.Props[f[1]]!=null?opts.Props[f[1]]:cp?cp[f[1]]:null;if(v===true)v="1";else if(v===false)v="0";else if(typeof v=="number")v=String(v);if(v!=null)cp_doit(f[0],v,null,o,p);}if(o.length>2){o[o.length]='</cp:coreProperties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.3 Extended File Properties Part *//* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */var EXT_PROPS/*:Array<Array<string> >*/=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];var PseudoPropsPairs=["Worksheets","SheetNames","NamedRanges","DefinedNames","Chartsheets","ChartNames"];function load_props_pairs(HP/*:string|Array<Array<any>>*/,TOP,props,opts){var v=[];if(typeof HP=="string")v=parseVector(HP,opts);else for(var j=0;j<HP.length;++j){v=v.concat(HP[j].map(function(hp){return{v:hp};}));}var parts=typeof TOP=="string"?parseVector(TOP,opts).map(function(x){return x.v;}):TOP;var idx=0,len=0;if(parts.length>0)for(var i=0;i!==v.length;i+=2){len=+v[i+1].v;switch(v[i].v){case"Worksheets":case"工作表":case"Листы":case"أوراق العمل":case"ワークシート":case"גליונות עבודה":case"Arbeitsblätter":case"Çalışma Sayfaları":case"Feuilles de calcul":case"Fogli di lavoro":case"Folhas de cálculo":case"Planilhas":case"Regneark":case"Hojas de cálculo":case"Werkbladen":props.Worksheets=len;props.SheetNames=parts.slice(idx,idx+len);break;case"Named Ranges":case"Rangos con nombre":case"名前付き一覧":case"Benannte Bereiche":case"Navngivne områder":props.NamedRanges=len;props.DefinedNames=parts.slice(idx,idx+len);break;case"Charts":case"Diagramme":props.Chartsheets=len;props.ChartNames=parts.slice(idx,idx+len);break;}idx+=len;}}function parse_ext_props(data,p,opts){var q={};if(!p)p={};data=utf8read(data);EXT_PROPS.forEach(function(f){var xml=(data.match(matchtag(f[0]))||[])[1];switch(f[2]){case"string":if(xml)p[f[1]]=unescapexml(xml);break;case"bool":p[f[1]]=xml==="true";break;case"raw":var cur=data.match(new RegExp("<"+f[0]+"[^>]*>([\\s\\S]*?)<\/"+f[0]+">"));if(cur&&cur.length>0)q[f[1]]=cur[1];break;}});if(q.HeadingPairs&&q.TitlesOfParts)load_props_pairs(q.HeadingPairs,q.TitlesOfParts,p,opts);return p;}function write_ext_props(cp/*::, opts*/)/*:string*/{var o/*:Array<string>*/=[],W=writextag;if(!cp)cp={};cp.Application="SheetJS";o[o.length]=XML_HEADER;o[o.length]=writextag('Properties',null,{'xmlns':XMLNS.EXT_PROPS,'xmlns:vt':XMLNS.vt});EXT_PROPS.forEach(function(f){if(cp[f[1]]===undefined)return;var v;switch(f[2]){case'string':v=escapexml(String(cp[f[1]]));break;case'bool':v=cp[f[1]]?'true':'false';break;}if(v!==undefined)o[o.length]=W(f[0],v);});/* TODO: HeadingPairs, TitlesOfParts */o[o.length]=W('HeadingPairs',W('vt:vector',W('vt:variant','<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant',W('vt:i4',String(cp.Worksheets))),{size:2,baseType:"variant"}));o[o.length]=W('TitlesOfParts',W('vt:vector',cp.SheetNames.map(function(s){return"<vt:lpstr>"+escapexml(s)+"</vt:lpstr>";}).join(""),{size:cp.Worksheets,baseType:"lpstr"}));if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* 15.2.12.2 Custom File Properties Part */var custregex=/<[^>]+>[^<]*/g;function parse_cust_props(data/*:string*/,opts){var p={},name="";var m=data.match(custregex);if(m)for(var i=0;i!=m.length;++i){var x=m[i],y=parsexmltag(x);switch(y[0]){case'<?xml':break;case'<Properties':break;case'<property':name=unescapexml(y.name);break;case'</property>':name=null;break;default:if(x.indexOf('<vt:')===0){var toks=x.split('>');var type=toks[0].slice(4),text=toks[1];/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */switch(type){case'lpstr':case'bstr':case'lpwstr':p[name]=unescapexml(text);break;case'bool':p[name]=parsexmlbool(text);break;case'i1':case'i2':case'i4':case'i8':case'int':case'uint':p[name]=parseInt(text,10);break;case'r4':case'r8':case'decimal':p[name]=parseFloat(text);break;case'filetime':case'date':p[name]=parseDate(text);break;case'cy':case'error':p[name]=unescapexml(text);break;default:if(type.slice(-1)=='/')break;if(opts.WTF&&typeof console!=='undefined')console.warn('Unexpected',x,type,toks);}}else if(x.slice(0,2)==="</"){/* empty */}else if(opts.WTF)throw new Error(x);}}return p;}function write_cust_props(cp/*::, opts*/)/*:string*/{var o=[XML_HEADER,writextag('Properties',null,{'xmlns':XMLNS.CUST_PROPS,'xmlns:vt':XMLNS.vt})];if(!cp)return o.join("");var pid=1;keys(cp).forEach(function custprop(k){++pid;o[o.length]=writextag('property',write_vt(cp[k],true),{'fmtid':'{D5CDD505-2E9C-101B-9397-08002B2CF9AE}','pid':pid,'name':escapexml(k)});});if(o.length>2){o[o.length]='</Properties>';o[1]=o[1].replace("/>",">");}return o.join("");}/* Common Name -> XLML Name */var XLMLDocPropsMap={Title:'Title',Subject:'Subject',Author:'Author',Keywords:'Keywords',Comments:'Description',LastAuthor:'LastAuthor',RevNumber:'Revision',Application:'AppName',/* TotalTime: 'TotalTime', */LastPrinted:'LastPrinted',CreatedDate:'Created',ModifiedDate:'LastSaved',/* Pages *//* Words *//* Characters */Category:'Category',/* PresentationFormat */Manager:'Manager',Company:'Company',/* Guid *//* HyperlinkBase *//* Bytes *//* Lines *//* Paragraphs *//* CharactersWithSpaces */AppVersion:'Version',ContentStatus:'ContentStatus',/* NOTE: missing from schema */Identifier:'Identifier',/* NOTE: missing from schema */Language:'Language'/* NOTE: missing from schema */};var evert_XLMLDPM;function xlml_set_prop(Props,tag/*:string*/,val){if(!evert_XLMLDPM)evert_XLMLDPM=evert(XLMLDocPropsMap);tag=evert_XLMLDPM[tag]||tag;Props[tag]=val;}function xlml_write_docprops(Props,opts){var o/*:Array<string>*/=[];keys(XLMLDocPropsMap).map(function(m){for(var i=0;i<CORE_PROPS.length;++i){if(CORE_PROPS[i][1]==m)return CORE_PROPS[i];}for(i=0;i<EXT_PROPS.length;++i){if(EXT_PROPS[i][1]==m)return EXT_PROPS[i];}throw m;}).forEach(function(p){if(Props[p[1]]==null)return;var m=opts&&opts.Props&&opts.Props[p[1]]!=null?opts.Props[p[1]]:Props[p[1]];switch(p[2]){case'date':m=new Date(m).toISOString().replace(/\.\d*Z/,"Z");break;}if(typeof m=='number')m=String(m);else if(m===true||m===false){m=m?"1":"0";}else if(m instanceof Date)m=new Date(m).toISOString().replace(/\.\d*Z/,"");o.push(writetag(XLMLDocPropsMap[p[1]]||p[1],m));});return writextag('DocumentProperties',o.join(""),{xmlns:XLMLNS.o});}function xlml_write_custprops(Props,Custprops/*::, opts*/){var BLACKLIST=["Worksheets","SheetNames"];var T='CustomDocumentProperties';var o/*:Array<string>*/=[];if(Props)keys(Props).forEach(function(k){/*:: if(!Props) return; */if(!Object.prototype.hasOwnProperty.call(Props,k))return;for(var i=0;i<CORE_PROPS.length;++i){if(k==CORE_PROPS[i][1])return;}for(i=0;i<EXT_PROPS.length;++i){if(k==EXT_PROPS[i][1])return;}for(i=0;i<BLACKLIST.length;++i){if(k==BLACKLIST[i])return;}var m=Props[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});if(Custprops)keys(Custprops).forEach(function(k){/*:: if(!Custprops) return; */if(!Object.prototype.hasOwnProperty.call(Custprops,k))return;if(Props&&Object.prototype.hasOwnProperty.call(Props,k))return;var m=Custprops[k];var t="string";if(typeof m=='number'){t="float";m=String(m);}else if(m===true||m===false){t="boolean";m=m?"1":"0";}else if(m instanceof Date){t="dateTime.tz";m=m.toISOString();}else m=String(m);o.push(writextag(escapexmltag(k),m,{"dt:dt":t}));});return'<'+T+' xmlns="'+XLMLNS.o+'">'+o.join("")+'</'+T+'>';}/* [MS-DTYP] 2.3.3 FILETIME *//* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) *//* [MS-OLEPS] 2.8 FILETIME (Packet Version) */function parse_FILETIME(blob){var dwLowDateTime=blob.read_shift(4),dwHighDateTime=blob.read_shift(4);return new Date((dwHighDateTime/1e7*Math.pow(2,32)+dwLowDateTime/1e7-11644473600)*1000).toISOString().replace(/\.000/,"");}function write_FILETIME(time/*:string|Date*/){var date=typeof time=="string"?new Date(Date.parse(time)):time;var t=date.getTime()/1000+11644473600;var l=t%Math.pow(2,32),h=(t-l)/Math.pow(2,32);l*=1e7;h*=1e7;var w=l/Math.pow(2,32)|0;if(w>0){l=l%Math.pow(2,32);h+=w;}var o=new_buf(8);o.write_shift(4,l);o.write_shift(4,h);return o;}/* [MS-OSHARED] 2.3.3.1.4 Lpstr */function parse_lpstr(blob,type,pad/*:?number*/){var start=blob.l;var str=blob.read_shift(0,'lpstr-cp');if(pad)while(blob.l-start&3){++blob.l;}return str;}/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */function parse_lpwstr(blob,type,pad){var str=blob.read_shift(0,'lpwstr');if(pad)blob.l+=4-(str.length+1&3)&3;return str;}/* [MS-OSHARED] 2.3.3.1.11 VtString *//* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */function parse_VtStringBase(blob,stringType,pad){if(stringType===0x1F/*VT_LPWSTR*/)return parse_lpwstr(blob);return parse_lpstr(blob,stringType,pad);}function parse_VtString(blob,t/*:number*/,pad/*:?boolean*/){return parse_VtStringBase(blob,t,pad===false?0:4);}function parse_VtUnalignedString(blob,t/*:number*/){if(!t)throw new Error("VtUnalignedString must have positive length");return parse_VtStringBase(blob,t,0);}/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */function parse_VtVecLpwstrValue(blob)/*:Array<string>*/{var length=blob.read_shift(4);var ret/*:Array<string>*/=[];for(var i=0;i!=length;++i){var start=blob.l;ret[i]=blob.read_shift(0,'lpwstr').replace(chr0,'');if(blob.l-start&0x02)blob.l+=2;}return ret;}/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */function parse_VtVecUnalignedLpstrValue(blob)/*:Array<string>*/{var length=blob.read_shift(4);var ret/*:Array<string>*/=[];for(var i=0;i!=length;++i){ret[i]=blob.read_shift(0,'lpstr-cp').replace(chr0,'');}return ret;}/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */function parse_VtHeadingPair(blob){var start=blob.l;var headingString=parse_TypedPropertyValue(blob,VT_USTR);if(blob[blob.l]==0x00&&blob[blob.l+1]==0x00&&blob.l-start&0x02)blob.l+=2;var headerParts=parse_TypedPropertyValue(blob,VT_I4);return[headingString,headerParts];}/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */function parse_VtVecHeadingPairValue(blob){var cElements=blob.read_shift(4);var out=[];for(var i=0;i<cElements/2;++i){out.push(parse_VtHeadingPair(blob));}return out;}/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */function parse_dictionary(blob,CodePage){var cnt=blob.read_shift(4);var dict/*:{[number]:string}*/={}/*:any*/;for(var j=0;j!=cnt;++j){var pid=blob.read_shift(4);var len=blob.read_shift(4);dict[pid]=blob.read_shift(len,CodePage===0x4B0?'utf16le':'utf8').replace(chr0,'').replace(chr1,'!');if(CodePage===0x4B0&&len%2)blob.l+=2;}if(blob.l&3)blob.l=blob.l>>2+1<<2;return dict;}/* [MS-OLEPS] 2.9 BLOB */function parse_BLOB(blob){var size=blob.read_shift(4);var bytes=blob.slice(blob.l,blob.l+size);blob.l+=size;if((size&3)>0)blob.l+=4-(size&3)&3;return bytes;}/* [MS-OLEPS] 2.11 ClipboardData */function parse_ClipboardData(blob){// TODO
var o={};o.Size=blob.read_shift(4);//o.Format = blob.read_shift(4);
blob.l+=o.Size+3-(o.Size-1)%4;return o;}/* [MS-OLEPS] 2.15 TypedPropertyValue */function parse_TypedPropertyValue(blob,type/*:number*/,_opts)/*:any*/{var t=blob.read_shift(2),ret,opts=_opts||{};blob.l+=2;if(type!==VT_VARIANT)if(t!==type&&VT_CUSTOM.indexOf(type)===-1&&!((type&0xFFFE)==0x101E&&(t&0xFFFE)==0x101E))throw new Error('Expected type '+type+' saw '+t);switch(type===VT_VARIANT?t:type){case 0x02/*VT_I2*/:ret=blob.read_shift(2,'i');if(!opts.raw)blob.l+=2;return ret;case 0x03/*VT_I4*/:ret=blob.read_shift(4,'i');return ret;case 0x0B/*VT_BOOL*/:return blob.read_shift(4)!==0x0;case 0x13/*VT_UI4*/:ret=blob.read_shift(4);return ret;case 0x1E/*VT_LPSTR*/:return parse_lpstr(blob,t,4).replace(chr0,'');case 0x1F/*VT_LPWSTR*/:return parse_lpwstr(blob);case 0x40/*VT_FILETIME*/:return parse_FILETIME(blob);case 0x41/*VT_BLOB*/:return parse_BLOB(blob);case 0x47/*VT_CF*/:return parse_ClipboardData(blob);case 0x50/*VT_STRING*/:return parse_VtString(blob,t,!opts.raw).replace(chr0,'');case 0x51/*VT_USTR*/:return parse_VtUnalignedString(blob,t/*, 4*/).replace(chr0,'');case 0x100C/*VT_VECTOR|VT_VARIANT*/:return parse_VtVecHeadingPairValue(blob);case 0x101E/*VT_VECTOR|VT_LPSTR*/:case 0x101F/*VT_VECTOR|VT_LPWSTR*/:return t==0x101F?parse_VtVecLpwstrValue(blob):parse_VtVecUnalignedLpstrValue(blob);default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+t);}}function write_TypedPropertyValue(type/*:number*/,value){var o=new_buf(4),p=new_buf(4);o.write_shift(4,type==0x50?0x1F:type);switch(type){case 0x03/*VT_I4*/:p.write_shift(-4,value);break;case 0x05/*VT_I4*/:p=new_buf(8);p.write_shift(8,value,'f');break;case 0x0B/*VT_BOOL*/:p.write_shift(4,value?0x01:0x00);break;case 0x40/*VT_FILETIME*/:/*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */p=write_FILETIME(value);break;case 0x1F/*VT_LPWSTR*/:case 0x50/*VT_STRING*/:/*:: if(typeof value !== "string") throw "unreachable"; */p=new_buf(4+2*(value.length+1)+(value.length%2?0:2));p.write_shift(4,value.length+1);p.write_shift(0,value,"dbcs");while(p.l!=p.length){p.write_shift(1,0);}break;default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+value);}return bconcat([o,p]);}/* [MS-OLEPS] 2.20 PropertySet */function parse_PropertySet(blob,PIDSI){var start_addr=blob.l;var size=blob.read_shift(4);var NumProps=blob.read_shift(4);var Props=[],i=0;var CodePage=0;var Dictionary=-1,DictObj/*:{[number]:string}*/={}/*:any*/;for(i=0;i!=NumProps;++i){var PropID=blob.read_shift(4);var Offset=blob.read_shift(4);Props[i]=[PropID,Offset+start_addr];}Props.sort(function(x,y){return x[1]-y[1];});var PropH={};for(i=0;i!=NumProps;++i){if(blob.l!==Props[i][1]){var fail=true;if(i>0&&PIDSI)switch(PIDSI[Props[i-1][0]].t){case 0x02/*VT_I2*/:if(blob.l+2===Props[i][1]){blob.l+=2;fail=false;}break;case 0x50/*VT_STRING*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;case 0x100C/*VT_VECTOR|VT_VARIANT*/:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false;}break;}if((!PIDSI||i==0)&&blob.l<=Props[i][1]){fail=false;blob.l=Props[i][1];}if(fail)throw new Error("Read Error: Expected address "+Props[i][1]+' at '+blob.l+' :'+i);}if(PIDSI){var piddsi=PIDSI[Props[i][0]];PropH[piddsi.n]=parse_TypedPropertyValue(blob,piddsi.t,{raw:true});if(piddsi.p==='version')PropH[piddsi.n]=String(PropH[piddsi.n]>>16)+"."+("0000"+String(PropH[piddsi.n]&0xFFFF)).slice(-4);if(piddsi.n=="CodePage")switch(PropH[piddsi.n]){case 0:PropH[piddsi.n]=1252;/* falls through */case 874:case 932:case 936:case 949:case 950:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 10000:case 1200:case 1201:case 1252:case 65000:case-536:case 65001:case-535:set_cp(CodePage=PropH[piddsi.n]>>>0&0xFFFF);break;default:throw new Error("Unsupported CodePage: "+PropH[piddsi.n]);}}else{if(Props[i][0]===0x1){CodePage=PropH.CodePage=parse_TypedPropertyValue(blob,VT_I2)/*:number*/;set_cp(CodePage);if(Dictionary!==-1){var oldpos=blob.l;blob.l=Props[Dictionary][1];DictObj=parse_dictionary(blob,CodePage);blob.l=oldpos;}}else if(Props[i][0]===0){if(CodePage===0){Dictionary=i;blob.l=Props[i+1][1];continue;}DictObj=parse_dictionary(blob,CodePage);}else{var name=DictObj[Props[i][0]];var val;/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */switch(blob[blob.l]){case 0x41/*VT_BLOB*/:blob.l+=4;val=parse_BLOB(blob);break;case 0x1E/*VT_LPSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x1F/*VT_LPWSTR*/:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]).replace(/\u0000+$/,"");break;case 0x03/*VT_I4*/:blob.l+=4;val=blob.read_shift(4,'i');break;case 0x13/*VT_UI4*/:blob.l+=4;val=blob.read_shift(4);break;case 0x05/*VT_R8*/:blob.l+=4;val=blob.read_shift(8,'f');break;case 0x0B/*VT_BOOL*/:blob.l+=4;val=parsebool(blob,4);break;case 0x40/*VT_FILETIME*/:blob.l+=4;val=parseDate(parse_FILETIME(blob));break;default:throw new Error("unparsed value: "+blob[blob.l]);}PropH[name]=val;}}}blob.l=start_addr+size;/* step ahead to skip padding */return PropH;}var XLSPSSkip=["CodePage","Thumbnail","_PID_LINKBASE","_PID_HLINKS","SystemIdentifier","FMTID"];//.concat(PseudoPropsPairs);
function guess_property_type(val/*:any*/)/*:number*/{switch(typeof val==="undefined"?"undefined":(0,_typeof3.default)(val)){case"boolean":return 0x0B;case"number":return(val|0)==val?0x03:0x05;case"string":return 0x1F;case"object":if(val instanceof Date)return 0x40;break;}return-1;}function write_PropertySet(entries,RE,PIDSI){var hdr=new_buf(8),piao=[],prop=[];var sz=8,i=0;var pr=new_buf(8),pio=new_buf(8);pr.write_shift(4,0x0002);pr.write_shift(4,0x04B0);pio.write_shift(4,0x0001);prop.push(pr);piao.push(pio);sz+=8+pr.length;if(!RE){pio=new_buf(8);pio.write_shift(4,0);piao.unshift(pio);var bufs=[new_buf(4)];bufs[0].write_shift(4,entries.length);for(i=0;i<entries.length;++i){var value=entries[i][0];pr=new_buf(4+4+2*(value.length+1)+(value.length%2?0:2));pr.write_shift(4,i+2);pr.write_shift(4,value.length+1);pr.write_shift(0,value,"dbcs");while(pr.l!=pr.length){pr.write_shift(1,0);}bufs.push(pr);}pr=bconcat(bufs);prop.unshift(pr);sz+=8+pr.length;}for(i=0;i<entries.length;++i){if(RE&&!RE[entries[i][0]])continue;if(XLSPSSkip.indexOf(entries[i][0])>-1||PseudoPropsPairs.indexOf(entries[i][0])>-1)continue;if(entries[i][1]==null)continue;var val=entries[i][1],idx=0;if(RE){idx=+RE[entries[i][0]];var pinfo=PIDSI/*:: || {}*/[idx]/*:: || {} */;if(pinfo.p=="version"&&typeof val=="string"){/*:: if(typeof val !== "string") throw "unreachable"; */var arr=val.split(".");val=(+arr[0]<<16)+(+arr[1]||0);}pr=write_TypedPropertyValue(pinfo.t,val);}else{var T=guess_property_type(val);if(T==-1){T=0x1F;val=String(val);}pr=write_TypedPropertyValue(T,val);}prop.push(pr);pio=new_buf(8);pio.write_shift(4,!RE?2+i:idx);piao.push(pio);sz+=8+pr.length;}var w=8*(prop.length+1);for(i=0;i<prop.length;++i){piao[i].write_shift(4,w);w+=prop[i].length;}hdr.write_shift(4,sz);hdr.write_shift(4,prop.length);return bconcat([hdr].concat(piao).concat(prop));}/* [MS-OLEPS] 2.21 PropertySetStream */function parse_PropertySetStream(file,PIDSI,clsid){var blob=file.content;if(!blob)return{}/*:any*/;prep_blob(blob,0);var NumSets,FMTID0,FMTID1,Offset0,Offset1=0;blob.chk('feff','Byte Order: ');/*var vers = */blob.read_shift(2);// TODO: check version
var SystemIdentifier=blob.read_shift(4);var CLSID=blob.read_shift(16);if(CLSID!==CFB.utils.consts.HEADER_CLSID&&CLSID!==clsid)throw new Error("Bad PropertySet CLSID "+CLSID);NumSets=blob.read_shift(4);if(NumSets!==1&&NumSets!==2)throw new Error("Unrecognized #Sets: "+NumSets);FMTID0=blob.read_shift(16);Offset0=blob.read_shift(4);if(NumSets===1&&Offset0!==blob.l)throw new Error("Length mismatch: "+Offset0+" !== "+blob.l);else if(NumSets===2){FMTID1=blob.read_shift(16);Offset1=blob.read_shift(4);}var PSet0=parse_PropertySet(blob,PIDSI);var rval={SystemIdentifier:SystemIdentifier/*:any*/};for(var y in PSet0){rval[y]=PSet0[y];}//rval.blob = blob;
rval.FMTID=FMTID0;//rval.PSet0 = PSet0;
if(NumSets===1)return rval;if(Offset1-blob.l==2)blob.l+=2;if(blob.l!==Offset1)throw new Error("Length mismatch 2: "+blob.l+" !== "+Offset1);var PSet1;try{PSet1=parse_PropertySet(blob,null);}catch(e){/* empty */}for(y in PSet1){rval[y]=PSet1[y];}rval.FMTID=[FMTID0,FMTID1];// TODO: verify FMTID0/1
return rval;}function write_PropertySetStream(entries,clsid,RE,PIDSI/*:{[key:string|number]:any}*/,entries2/*:?any*/,clsid2/*:?any*/){var hdr=new_buf(entries2?68:48);var bufs=[hdr];hdr.write_shift(2,0xFFFE);hdr.write_shift(2,0x0000);/* TODO: type 1 props */hdr.write_shift(4,0x32363237);hdr.write_shift(16,CFB.utils.consts.HEADER_CLSID,"hex");hdr.write_shift(4,entries2?2:1);hdr.write_shift(16,clsid,"hex");hdr.write_shift(4,entries2?68:48);var ps0=write_PropertySet(entries,RE,PIDSI);bufs.push(ps0);if(entries2){var ps1=write_PropertySet(entries2,null,null);hdr.write_shift(16,clsid2,"hex");hdr.write_shift(4,68+ps0.length);bufs.push(ps1);}return bconcat(bufs);}function parsenoop2(blob,length){blob.read_shift(length);return null;}function writezeroes(n,o){if(!o)o=new_buf(n);for(var j=0;j<n;++j){o.write_shift(1,0);}return o;}function parslurp(blob,length,cb){var arr=[],target=blob.l+length;while(blob.l<target){arr.push(cb(blob,target-blob.l));}if(target!==blob.l)throw new Error("Slurp error");return arr;}function parsebool(blob,length/*:number*/){return blob.read_shift(length)===0x1;}function writebool(v/*:any*/,o){if(!o)o=new_buf(2);o.write_shift(2,+!!v);return o;}function parseuint16(blob/*::, length:?number, opts:?any*/){return blob.read_shift(2,'u');}function writeuint16(v/*:number*/,o){if(!o)o=new_buf(2);o.write_shift(2,v);return o;}function parseuint16a(blob,length/*:: :?number, opts:?any*/){return parslurp(blob,length,parseuint16);}/* --- 2.5 Structures --- *//* [MS-XLS] 2.5.10 Bes (boolean or error) */function parse_Bes(blob/*::, length*/){var v=blob.read_shift(1),t=blob.read_shift(1);return t===0x01?v:v===0x01;}function write_Bes(v,t/*:string*/,o){if(!o)o=new_buf(2);o.write_shift(1,t=='e'?+v:+!!v);o.write_shift(1,t=='e'?1:0);return o;}/* [MS-XLS] 2.5.240 ShortXLUnicodeString */function parse_ShortXLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff>=12?2:1);var encoding='sbcs-cont';var cp=current_codepage;if(opts&&opts.biff>=8)current_codepage=1200;if(!opts||opts.biff==8){var fHighByte=blob.read_shift(1);if(fHighByte){encoding='dbcs-cont';}}else if(opts.biff==12){encoding='wstr';}if(opts.biff>=2&&opts.biff<=5)encoding='cpstr';var o=cch?blob.read_shift(cch,encoding):"";current_codepage=cp;return o;}/* 2.5.293 XLUnicodeRichExtendedString */function parse_XLUnicodeRichExtendedString(blob){var cp=current_codepage;current_codepage=1200;var cch=blob.read_shift(2),flags=blob.read_shift(1);var/*fHighByte = flags & 0x1,*/fExtSt=flags&0x4,fRichSt=flags&0x8;var width=1+(flags&0x1);// 0x0 -> utf8, 0x1 -> dbcs
var cRun=0,cbExtRst;var z={};if(fRichSt)cRun=blob.read_shift(2);if(fExtSt)cbExtRst=blob.read_shift(4);var encoding=width==2?'dbcs-cont':'sbcs-cont';var msg=cch===0?"":blob.read_shift(cch,encoding);if(fRichSt)blob.l+=4*cRun;//TODO: parse this
if(fExtSt)blob.l+=cbExtRst;//TODO: parse this
z.t=msg;if(!fRichSt){z.raw="<t>"+z.t+"</t>";z.r=z.t;}current_codepage=cp;return z;}function write_XLUnicodeRichExtendedString(xlstr/*:: :XLString, opts*/){var str=xlstr.t||"",nfmts=1;var hdr=new_buf(3+(nfmts>1?2:0));hdr.write_shift(2,str.length);hdr.write_shift(1,(nfmts>1?0x08:0x00)|0x01);if(nfmts>1)hdr.write_shift(2,nfmts);var otext=new_buf(2*str.length);otext.write_shift(2*str.length,str,'utf16le');var out=[hdr,otext];return bconcat(out);}/* 2.5.296 XLUnicodeStringNoCch */function parse_XLUnicodeStringNoCch(blob,cch,opts){var retval;if(opts){if(opts.biff>=2&&opts.biff<=5)return blob.read_shift(cch,'cpstr');if(opts.biff>=12)return blob.read_shift(cch,'dbcs-cont');}var fHighByte=blob.read_shift(1);if(fHighByte===0){retval=blob.read_shift(cch,'sbcs-cont');}else{retval=blob.read_shift(cch,'dbcs-cont');}return retval;}/* 2.5.294 XLUnicodeString */function parse_XLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts&&opts.biff==2?1:2);if(cch===0){blob.l++;return"";}return parse_XLUnicodeStringNoCch(blob,cch,opts);}/* BIFF5 override */function parse_XLUnicodeString2(blob,length,opts){if(opts.biff>5)return parse_XLUnicodeString(blob,length,opts);var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,opts.biff<=4||!blob.lens?'cpstr':'sbcs-cont');}/* TODO: BIFF5 and lower, codepage awareness */function write_XLUnicodeString(str,opts,o){if(!o)o=new_buf(3+2*str.length);o.write_shift(2,str.length);o.write_shift(1,1);o.write_shift(31,str,'utf16le');return o;}/* [MS-XLS] 2.5.61 ControlInfo */function parse_ControlInfo(blob/*::, length, opts*/){var flags=blob.read_shift(1);blob.l++;var accel=blob.read_shift(2);blob.l+=2;return[flags,accel];}/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */function parse_URLMoniker(blob/*::, length, opts*/){var len=blob.read_shift(4),start=blob.l;var extra=false;if(len>24){/* look ahead */blob.l+=len-24;if(blob.read_shift(16)==="795881f43b1d7f48af2c825dc4852763")extra=true;blob.l=start;}var url=blob.read_shift((extra?len-24:len)>>1,'utf16le').replace(chr0,"");if(extra)blob.l+=24;return url;}/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */function parse_FileMoniker(blob/*::, length*/){var cAnti=blob.read_shift(2);var preamble="";while(cAnti-->0){preamble+="../";}var ansiPath=blob.read_shift(0,'lpstr-ansi');blob.l+=2;//var endServer = blob.read_shift(2);
if(blob.read_shift(2)!=0xDEAD)throw new Error("Bad FileMoniker");var sz=blob.read_shift(4);if(sz===0)return preamble+ansiPath.replace(/\\/g,"/");var bytes=blob.read_shift(4);if(blob.read_shift(2)!=3)throw new Error("Bad FileMoniker");var unicodePath=blob.read_shift(bytes>>1,'utf16le').replace(chr0,"");return preamble+unicodePath;}/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */function parse_HyperlinkMoniker(blob,length){var clsid=blob.read_shift(16);length-=16;switch(clsid){case"e0c9ea79f9bace118c8200aa004ba90b":return parse_URLMoniker(blob,length);case"0303000000000000c000000000000046":return parse_FileMoniker(blob,length);default:throw new Error("Unsupported Moniker "+clsid);}}/* [MS-OSHARED] 2.3.7.9 HyperlinkString */function parse_HyperlinkString(blob/*::, length*/){var len=blob.read_shift(4);var o=len>0?blob.read_shift(len,'utf16le').replace(chr0,""):"";return o;}function write_HyperlinkString(str/*:string*/,o){if(!o)o=new_buf(6+str.length*2);o.write_shift(4,1+str.length);for(var i=0;i<str.length;++i){o.write_shift(2,str.charCodeAt(i));}o.write_shift(2,0);return o;}/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */function parse_Hyperlink(blob,length)/*:Hyperlink*/{var end=blob.l+length;var sVer=blob.read_shift(4);if(sVer!==2)throw new Error("Unrecognized streamVersion: "+sVer);var flags=blob.read_shift(2);blob.l+=2;var displayName,targetFrameName,moniker,oleMoniker,Loc="",guid,fileTime;if(flags&0x0010)displayName=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0080)targetFrameName=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0101)moniker=parse_HyperlinkString(blob,end-blob.l);if((flags&0x0101)===0x0001)oleMoniker=parse_HyperlinkMoniker(blob,end-blob.l);if(flags&0x0008)Loc=parse_HyperlinkString(blob,end-blob.l);if(flags&0x0020)guid=blob.read_shift(16);if(flags&0x0040)fileTime=parse_FILETIME(blob/*, 8*/);blob.l=end;var target=targetFrameName||moniker||oleMoniker||"";if(target&&Loc)target+="#"+Loc;if(!target)target="#"+Loc;if(flags&0x0002&&target.charAt(0)=="/"&&target.charAt(1)!="/")target="file://"+target;var out={Target:target/*:any*/};if(guid)out.guid=guid;if(fileTime)out.time=fileTime;if(displayName)out.Tooltip=displayName;return out;}function write_Hyperlink(hl){var out=new_buf(512),i=0;var Target=hl.Target;if(Target.slice(0,7)=="file://")Target=Target.slice(7);var hashidx=Target.indexOf("#");var F=hashidx>-1?0x1f:0x17;switch(Target.charAt(0)){case"#":F=0x1c;break;case".":F&=~2;break;}out.write_shift(4,2);out.write_shift(4,F);var data=[8,6815827,6619237,4849780,83];for(i=0;i<data.length;++i){out.write_shift(4,data[i]);}if(F==0x1C){Target=Target.slice(1);write_HyperlinkString(Target,out);}else if(F&0x02){data="e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(i=0;i<data.length;++i){out.write_shift(1,parseInt(data[i],16));}var Pretarget=hashidx>-1?Target.slice(0,hashidx):Target;out.write_shift(4,2*(Pretarget.length+1));for(i=0;i<Pretarget.length;++i){out.write_shift(2,Pretarget.charCodeAt(i));}out.write_shift(2,0);if(F&0x08)write_HyperlinkString(hashidx>-1?Target.slice(hashidx+1):"",out);}else{data="03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");for(i=0;i<data.length;++i){out.write_shift(1,parseInt(data[i],16));}var P=0;while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\"){++P;}out.write_shift(2,P);out.write_shift(4,Target.length-3*P+1);for(i=0;i<Target.length-3*P;++i){out.write_shift(1,Target.charCodeAt(i+3*P)&0xFF);}out.write_shift(1,0);out.write_shift(2,0xFFFF);out.write_shift(2,0xDEAD);for(i=0;i<6;++i){out.write_shift(4,0);}}return out.slice(0,out.l);}/* 2.5.178 LongRGBA */function parse_LongRGBA(blob/*::, length*/){var r=blob.read_shift(1),g=blob.read_shift(1),b=blob.read_shift(1),a=blob.read_shift(1);return[r,g,b,a];}/* 2.5.177 LongRGB */function parse_LongRGB(blob,length){var x=parse_LongRGBA(blob,length);x[3]=0;return x;}/* [MS-XLS] 2.5.19 */function parse_XLSCell(blob/*::, length*/)/*:Cell*/{var rw=blob.read_shift(2);// 0-indexed
var col=blob.read_shift(2);var ixfe=blob.read_shift(2);return{r:rw,c:col,ixfe:ixfe/*:any*/};}function write_XLSCell(R/*:number*/,C/*:number*/,ixfe/*:?number*/,o){if(!o)o=new_buf(6);o.write_shift(2,R);o.write_shift(2,C);o.write_shift(2,ixfe||0);return o;}/* [MS-XLS] 2.5.134 */function parse_frtHeader(blob){var rt=blob.read_shift(2);var flags=blob.read_shift(2);// TODO: parse these flags
blob.l+=8;return{type:rt,flags:flags};}function parse_OptXLUnicodeString(blob,length,opts){return length===0?"":parse_XLUnicodeString2(blob,length,opts);}/* [MS-XLS] 2.5.344 */function parse_XTI(blob,length,opts){var w=opts.biff>8?4:2;var iSupBook=blob.read_shift(w),itabFirst=blob.read_shift(w,'i'),itabLast=blob.read_shift(w,'i');return[iSupBook,itabFirst,itabLast];}/* [MS-XLS] 2.5.218 */function parse_RkRec(blob){var ixfe=blob.read_shift(2);var RK=parse_RkNumber(blob);return[ixfe,RK];}/* [MS-XLS] 2.5.1 */function parse_AddinUdf(blob,length,opts){blob.l+=4;length-=4;var l=blob.l+length;var udfName=parse_ShortXLUnicodeString(blob,length,opts);var cb=blob.read_shift(2);l-=blob.l;if(cb!==l)throw new Error("Malformed AddinUdf: padding = "+l+" != "+cb);blob.l+=cb;return udfName;}/* [MS-XLS] 2.5.209 TODO: Check sizes */function parse_Ref8U(blob/*::, length*/){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(2);var colLast=blob.read_shift(2);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}function write_Ref8U(r/*:Range*/,o){if(!o)o=new_buf(8);o.write_shift(2,r.s.r);o.write_shift(2,r.e.r);o.write_shift(2,r.s.c);o.write_shift(2,r.e.c);return o;}/* [MS-XLS] 2.5.211 */function parse_RefU(blob/*::, length*/){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(1);var colLast=blob.read_shift(1);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}};}/* [MS-XLS] 2.5.207 */var parse_Ref=parse_RefU;/* [MS-XLS] 2.5.143 */function parse_FtCmo(blob/*::, length*/){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=12;return[id,ot,flags];}/* [MS-XLS] 2.5.149 */function parse_FtNts(blob){var out={};blob.l+=4;blob.l+=16;// GUID TODO
out.fSharedNote=blob.read_shift(2);blob.l+=4;return out;}/* [MS-XLS] 2.5.142 */function parse_FtCf(blob){var out={};blob.l+=4;blob.cf=blob.read_shift(2);return out;}/* [MS-XLS] 2.5.140 - 2.5.154 and friends */function parse_FtSkip(blob){blob.l+=2;blob.l+=blob.read_shift(2);}var FtTab={/*::[*/0x00/*::]*/:parse_FtSkip,/* FtEnd *//*::[*/0x04/*::]*/:parse_FtSkip,/* FtMacro *//*::[*/0x05/*::]*/:parse_FtSkip,/* FtButton *//*::[*/0x06/*::]*/:parse_FtSkip,/* FtGmo *//*::[*/0x07/*::]*/:parse_FtCf,/* FtCf *//*::[*/0x08/*::]*/:parse_FtSkip,/* FtPioGrbit *//*::[*/0x09/*::]*/:parse_FtSkip,/* FtPictFmla *//*::[*/0x0A/*::]*/:parse_FtSkip,/* FtCbls *//*::[*/0x0B/*::]*/:parse_FtSkip,/* FtRbo *//*::[*/0x0C/*::]*/:parse_FtSkip,/* FtSbs *//*::[*/0x0D/*::]*/:parse_FtNts,/* FtNts *//*::[*/0x0E/*::]*/:parse_FtSkip,/* FtSbsFmla *//*::[*/0x0F/*::]*/:parse_FtSkip,/* FtGboData *//*::[*/0x10/*::]*/:parse_FtSkip,/* FtEdoData *//*::[*/0x11/*::]*/:parse_FtSkip,/* FtRboData *//*::[*/0x12/*::]*/:parse_FtSkip,/* FtCblsData *//*::[*/0x13/*::]*/:parse_FtSkip,/* FtLbsData *//*::[*/0x14/*::]*/:parse_FtSkip,/* FtCblsFmla *//*::[*/0x15/*::]*/:parse_FtCmo};function parse_FtArray(blob,length/*::, ot*/){var tgt=blob.l+length;var fts=[];while(blob.l<tgt){var ft=blob.read_shift(2);blob.l-=2;try{fts.push(FtTab[ft](blob,tgt-blob.l));}catch(e){blob.l=tgt;return fts;}}if(blob.l!=tgt)blob.l=tgt;//throw new Error("bad Object Ft-sequence");
return fts;}/* --- 2.4 Records --- *//* [MS-XLS] 2.4.21 */function parse_BOF(blob,length){var o={BIFFVer:0,dt:0};o.BIFFVer=blob.read_shift(2);length-=2;if(length>=2){o.dt=blob.read_shift(2);blob.l-=2;}switch(o.BIFFVer){case 0x0600:/* BIFF8 */case 0x0500:/* BIFF5 */case 0x0400:/* BIFF4 */case 0x0300:/* BIFF3 */case 0x0200:/* BIFF2 */case 0x0002:case 0x0007:/* BIFF2 */break;default:if(length>6)throw new Error("Unexpected BIFF Ver "+o.BIFFVer);}blob.read_shift(length);return o;}function write_BOF(wb/*:Workbook*/,t/*:number*/,o){var h=0x0600,w=16;switch(o.bookType){case'biff8':break;case'biff5':h=0x0500;w=8;break;case'biff4':h=0x0004;w=6;break;case'biff3':h=0x0003;w=6;break;case'biff2':h=0x0002;w=4;break;case'xla':break;default:throw new Error("unsupported BIFF version");}var out=new_buf(w);out.write_shift(2,h);out.write_shift(2,t);if(w>4)out.write_shift(2,0x7262);if(w>6)out.write_shift(2,0x07CD);if(w>8){out.write_shift(2,0xC009);out.write_shift(2,0x0001);out.write_shift(2,0x0706);out.write_shift(2,0x0000);}return out;}/* [MS-XLS] 2.4.146 */function parse_InterfaceHdr(blob,length){if(length===0)return 0x04b0;if(blob.read_shift(2)!==0x04b0){/* empty */}return 0x04b0;}/* [MS-XLS] 2.4.349 */function parse_WriteAccess(blob,length,opts){if(opts.enc){blob.l+=length;return"";}var l=blob.l;// TODO: make sure XLUnicodeString doesnt overrun
var UserName=parse_XLUnicodeString2(blob,0,opts);blob.read_shift(length+l-blob.l);return UserName;}function write_WriteAccess(s/*:string*/,opts){var b8=!opts||opts.biff==8;var o=new_buf(b8?112:54);o.write_shift(opts.biff==8?2:1,7);if(b8)o.write_shift(1,0);o.write_shift(4,0x33336853);o.write_shift(4,0x00534A74|(b8?0:0x20000000));while(o.l<o.length){o.write_shift(1,b8?0:32);}return o;}/* [MS-XLS] 2.4.351 */function parse_WsBool(blob,length,opts){var flags=opts&&opts.biff==8||length==2?blob.read_shift(2):(blob.l+=length,0);return{fDialog:flags&0x10,fBelow:flags&0x40,fRight:flags&0x80};}/* [MS-XLS] 2.4.28 */function parse_BoundSheet8(blob,length,opts){var pos=blob.read_shift(4);var hidden=blob.read_shift(1)&0x03;var dt=blob.read_shift(1);switch(dt){case 0:dt='Worksheet';break;case 1:dt='Macrosheet';break;case 2:dt='Chartsheet';break;case 6:dt='VBAModule';break;}var name=parse_ShortXLUnicodeString(blob,0,opts);if(name.length===0)name="Sheet1";return{pos:pos,hs:hidden,dt:dt,name:name};}function write_BoundSheet8(data,opts){var w=!opts||opts.biff>=8?2:1;var o=new_buf(8+w*data.name.length);o.write_shift(4,data.pos);o.write_shift(1,data.hs||0);o.write_shift(1,data.dt);o.write_shift(1,data.name.length);if(opts.biff>=8)o.write_shift(1,1);o.write_shift(w*data.name.length,data.name,opts.biff<8?'sbcs':'utf16le');var out=o.slice(0,o.l);out.l=o.l;return out;}/* [MS-XLS] 2.4.265 TODO */function parse_SST(blob,length)/*:SST*/{var end=blob.l+length;var cnt=blob.read_shift(4);var ucnt=blob.read_shift(4);var strs/*:SST*/=[]/*:any*/;for(var i=0;i!=ucnt&&blob.l<end;++i){strs.push(parse_XLUnicodeRichExtendedString(blob));}strs.Count=cnt;strs.Unique=ucnt;return strs;}function write_SST(sst,opts){var header=new_buf(8);header.write_shift(4,sst.Count);header.write_shift(4,sst.Unique);var strs=[];for(var j=0;j<sst.length;++j){strs[j]=write_XLUnicodeRichExtendedString(sst[j],opts);}var o=bconcat([header].concat(strs));/*::(*/o/*:: :any)*/.parts=[header.length].concat(strs.map(function(str){return str.length;}));return o;}/* [MS-XLS] 2.4.107 */function parse_ExtSST(blob,length){var extsst={};extsst.dsst=blob.read_shift(2);blob.l+=length-2;return extsst;}/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */function parse_Row(blob){var z={}/*:any*/;z.r=blob.read_shift(2);z.c=blob.read_shift(2);z.cnt=blob.read_shift(2)-z.c;var miyRw=blob.read_shift(2);blob.l+=4;// reserved(2), unused(2)
var flags=blob.read_shift(1);// various flags
blob.l+=3;// reserved(8), ixfe(12), flags(4)
if(flags&0x07)z.level=flags&0x07;// collapsed: flags & 0x10
if(flags&0x20)z.hidden=true;if(flags&0x40)z.hpt=miyRw/20;return z;}/* [MS-XLS] 2.4.125 */function parse_ForceFullCalculation(blob){var header=parse_frtHeader(blob);if(header.type!=0x08A3)throw new Error("Invalid Future Record "+header.type);var fullcalc=blob.read_shift(4);return fullcalc!==0x0;}/* [MS-XLS] 2.4.215 rt */function parse_RecalcId(blob){blob.read_shift(2);return blob.read_shift(4);}/* [MS-XLS] 2.4.87 */function parse_DefaultRowHeight(blob,length,opts){var f=0;if(!(opts&&opts.biff==2)){f=blob.read_shift(2);}var miyRw=blob.read_shift(2);if(opts&&opts.biff==2){f=1-(miyRw>>15);miyRw&=0x7fff;}var fl={Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};return[fl,miyRw];}/* [MS-XLS] 2.4.345 TODO */function parse_Window1(blob){var xWn=blob.read_shift(2),yWn=blob.read_shift(2),dxWn=blob.read_shift(2),dyWn=blob.read_shift(2);var flags=blob.read_shift(2),iTabCur=blob.read_shift(2),iTabFirst=blob.read_shift(2);var ctabSel=blob.read_shift(2),wTabRatio=blob.read_shift(2);return{Pos:[xWn,yWn],Dim:[dxWn,dyWn],Flags:flags,CurTab:iTabCur,FirstTab:iTabFirst,Selected:ctabSel,TabRatio:wTabRatio};}function write_Window1()/*::opts*/{var o=new_buf(18);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0x7260);o.write_shift(2,0x44c0);o.write_shift(2,0x38);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,1);o.write_shift(2,0x01f4);return o;}/* [MS-XLS] 2.4.346 TODO */function parse_Window2(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<5)return{};var f=blob.read_shift(2);return{RTL:f&0x40};}function write_Window2(view){var o=new_buf(18),f=0x6b6;if(view&&view.RTL)f|=0x40;o.write_shift(2,f);o.write_shift(4,0);o.write_shift(4,64);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLS] 2.4.189 TODO */function parse_Pane()/*blob, length, opts*/{}/* [MS-XLS] 2.4.122 TODO */function parse_Font(blob,length,opts){var o/*:any*/={dyHeight:blob.read_shift(2),fl:blob.read_shift(2)};switch(opts&&opts.biff||8){case 2:break;case 3:case 4:blob.l+=2;break;default:blob.l+=10;break;}o.name=parse_ShortXLUnicodeString(blob,0,opts);return o;}function write_Font(data,opts){var name=data.name||"Arial";var b5=opts&&opts.biff==5,w=b5?15+name.length:16+2*name.length;var o=new_buf(w);o.write_shift(2,(data.sz||12)*20);o.write_shift(4,0);o.write_shift(2,400);o.write_shift(4,0);o.write_shift(2,0);o.write_shift(1,name.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*name.length,name,b5?"sbcs":"utf16le");return o;}/* [MS-XLS] 2.4.149 */function parse_LabelSst(blob){var cell=parse_XLSCell(blob);cell.isst=blob.read_shift(4);return cell;}function write_LabelSst(R/*:number*/,C/*:number*/,v/*:number*/,os/*:number*//*::, opts*/){var o=new_buf(10);write_XLSCell(R,C,os,o);o.write_shift(4,v);return o;}/* [MS-XLS] 2.4.148 */function parse_Label(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var target=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)blob.l++;var str=parse_XLUnicodeString(blob,target-blob.l,opts);cell.val=str;return cell;}function write_Label(R/*:number*/,C/*:number*/,v/*:string*/,os/*:number*/,opts){var b8=!opts||opts.biff==8;var o=new_buf(6+2+ +b8+(1+b8)*v.length);write_XLSCell(R,C,os,o);o.write_shift(2,v.length);if(b8)o.write_shift(1,1);o.write_shift((1+b8)*v.length,v,b8?'utf16le':'sbcs');return o;}/* [MS-XLS] 2.4.126 Number Formats */function parse_Format(blob,length,opts){var numFmtId=blob.read_shift(2);var fmtstr=parse_XLUnicodeString2(blob,0,opts);return[numFmtId,fmtstr];}function write_Format(i/*:number*/,f/*:string*/,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?3+f.length:5+2*f.length);o.write_shift(2,i);o.write_shift(b5?1:2,f.length);if(!b5)o.write_shift(1,1);o.write_shift((b5?1:2)*f.length,f,b5?'sbcs':'utf16le');var out=o.length>o.l?o.slice(0,o.l):o;if(out.l==null)out.l=out.length;return out;}var parse_BIFF2Format=parse_XLUnicodeString2;/* [MS-XLS] 2.4.90 */function parse_Dimensions(blob,length,opts){var end=blob.l+length;var w=opts.biff==8||!opts.biff?4:2;var r=blob.read_shift(w),R=blob.read_shift(w);var c=blob.read_shift(2),C=blob.read_shift(2);blob.l=end;return{s:{r:r,c:c},e:{r:R,c:C}};}function write_Dimensions(range,opts){var w=opts.biff==8||!opts.biff?4:2;var o=new_buf(2*w+6);o.write_shift(w,range.s.r);o.write_shift(w,range.e.r+1);o.write_shift(2,range.s.c);o.write_shift(2,range.e.c+1);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.220 */function parse_RK(blob){var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrec=parse_RkRec(blob);return{r:rw,c:col,ixfe:rkrec[0],rknum:rkrec[1]};}/* [MS-XLS] 2.4.175 */function parse_MulRk(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrecs=[];while(blob.l<target){rkrecs.push(parse_RkRec(blob));}if(blob.l!==target)throw new Error("MulRK read error");var lastcol=blob.read_shift(2);if(rkrecs.length!=lastcol-col+1)throw new Error("MulRK length mismatch");return{r:rw,c:col,C:lastcol,rkrec:rkrecs};}/* [MS-XLS] 2.4.174 */function parse_MulBlank(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var ixfes=[];while(blob.l<target){ixfes.push(blob.read_shift(2));}if(blob.l!==target)throw new Error("MulBlank read error");var lastcol=blob.read_shift(2);if(ixfes.length!=lastcol-col+1)throw new Error("MulBlank length mismatch");return{r:rw,c:col,C:lastcol,ixfe:ixfes};}/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */function parse_CellStyleXF(blob,length,style,opts){var o={};var a=blob.read_shift(4),b=blob.read_shift(4);var c=blob.read_shift(4),d=blob.read_shift(2);o.patternType=XLSFillPattern[c>>26];if(!opts.cellStyles)return o;o.alc=a&0x07;o.fWrap=a>>3&0x01;o.alcV=a>>4&0x07;o.fJustLast=a>>7&0x01;o.trot=a>>8&0xFF;o.cIndent=a>>16&0x0F;o.fShrinkToFit=a>>20&0x01;o.iReadOrder=a>>22&0x02;o.fAtrNum=a>>26&0x01;o.fAtrFnt=a>>27&0x01;o.fAtrAlc=a>>28&0x01;o.fAtrBdr=a>>29&0x01;o.fAtrPat=a>>30&0x01;o.fAtrProt=a>>31&0x01;o.dgLeft=b&0x0F;o.dgRight=b>>4&0x0F;o.dgTop=b>>8&0x0F;o.dgBottom=b>>12&0x0F;o.icvLeft=b>>16&0x7F;o.icvRight=b>>23&0x7F;o.grbitDiag=b>>30&0x03;o.icvTop=c&0x7F;o.icvBottom=c>>7&0x7F;o.icvDiag=c>>14&0x7F;o.dgDiag=c>>21&0x0F;o.icvFore=d&0x7F;o.icvBack=d>>7&0x7F;o.fsxButton=d>>14&0x01;return o;}//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */function parse_XF(blob,length,opts){var o={};o.ifnt=blob.read_shift(2);o.numFmtId=blob.read_shift(2);o.flags=blob.read_shift(2);o.fStyle=o.flags>>2&0x01;length-=6;o.data=parse_CellStyleXF(blob,length,o.fStyle,opts);return o;}function write_XF(data,ixfeP,opts,o){var b5=opts&&opts.biff==5;if(!o)o=new_buf(b5?16:20);o.write_shift(2,0);if(data.style){o.write_shift(2,data.numFmtId||0);o.write_shift(2,0xFFF4);}else{o.write_shift(2,data.numFmtId||0);o.write_shift(2,ixfeP<<4);}var f=0;if(data.numFmtId>0&&b5)f|=0x0400;o.write_shift(4,f);o.write_shift(4,0);if(!b5)o.write_shift(4,0);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.134 */function parse_Guts(blob){blob.l+=4;var out=[blob.read_shift(2),blob.read_shift(2)];if(out[0]!==0)out[0]--;if(out[1]!==0)out[1]--;if(out[0]>7||out[1]>7)throw new Error("Bad Gutters: "+out.join("|"));return out;}function write_Guts(guts/*:Array<number>*/){var o=new_buf(8);o.write_shift(4,0);o.write_shift(2,guts[0]?guts[0]+1:0);o.write_shift(2,guts[1]?guts[1]+1:0);return o;}/* [MS-XLS] 2.4.24 */function parse_BoolErr(blob,length,opts){var cell=parse_XLSCell(blob,6);if(opts.biff==2||length==9)++blob.l;var val=parse_Bes(blob,2);cell.val=val;cell.t=val===true||val===false?'b':'e';return cell;}function write_BoolErr(R/*:number*/,C/*:number*/,v,os/*:number*/,opts,t/*:string*/){var o=new_buf(8);write_XLSCell(R,C,os,o);write_Bes(v,t,o);return o;}/* [MS-XLS] 2.4.180 Number */function parse_Number(blob,length,opts){if(opts.biffguess&&opts.biff==2)opts.biff=5;var cell=parse_XLSCell(blob,6);var xnum=parse_Xnum(blob,8);cell.val=xnum;return cell;}function write_Number(R/*:number*/,C/*:number*/,v,os/*:: :number, opts*/){var o=new_buf(14);write_XLSCell(R,C,os,o);write_Xnum(v,o);return o;}var parse_XLHeaderFooter=parse_OptXLUnicodeString;// TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */function parse_SupBook(blob,length,opts){var end=blob.l+length;var ctab=blob.read_shift(2);var cch=blob.read_shift(2);opts.sbcch=cch;if(cch==0x0401||cch==0x3A01)return[cch,ctab];if(cch<0x01||cch>0xff)throw new Error("Unexpected SupBook type: "+cch);var virtPath=parse_XLUnicodeStringNoCch(blob,cch);/* TODO: 2.5.277 Virtual Path */var rgst=[];while(end>blob.l){rgst.push(parse_XLUnicodeString(blob));}return[cch,ctab,virtPath,rgst];}/* [MS-XLS] 2.4.105 TODO */function parse_ExternName(blob,length,opts){var flags=blob.read_shift(2);var body;var o={fBuiltIn:flags&0x01,fWantAdvise:flags>>>1&0x01,fWantPict:flags>>>2&0x01,fOle:flags>>>3&0x01,fOleLink:flags>>>4&0x01,cf:flags>>>5&0x3FF,fIcon:flags>>>15&0x01/*:any*/};if(opts.sbcch===0x3A01)body=parse_AddinUdf(blob,length-2,opts);//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
o.body=body||blob.read_shift(length-2);if(typeof body==="string")o.Name=body;return o;}/* [MS-XLS] 2.4.150 TODO */var XLSLblBuiltIn=["_xlnm.Consolidate_Area","_xlnm.Auto_Open","_xlnm.Auto_Close","_xlnm.Extract","_xlnm.Database","_xlnm.Criteria","_xlnm.Print_Area","_xlnm.Print_Titles","_xlnm.Recorder","_xlnm.Data_Form","_xlnm.Auto_Activate","_xlnm.Auto_Deactivate","_xlnm.Sheet_Title","_xlnm._FilterDatabase"];function parse_Lbl(blob,length,opts){var target=blob.l+length;var flags=blob.read_shift(2);var chKey=blob.read_shift(1);var cch=blob.read_shift(1);var cce=blob.read_shift(opts&&opts.biff==2?1:2);var itab=0;if(!opts||opts.biff>=5){if(opts.biff!=5)blob.l+=2;itab=blob.read_shift(2);if(opts.biff==5)blob.l+=2;blob.l+=4;}var name=parse_XLUnicodeStringNoCch(blob,cch,opts);if(flags&0x20)name=XLSLblBuiltIn[name.charCodeAt(0)];var npflen=target-blob.l;if(opts&&opts.biff==2)--npflen;/*jshint -W018 */var rgce=target==blob.l||cce===0||!(npflen>0)?[]:parse_NameParsedFormula(blob,npflen,opts,cce);/*jshint +W018 */return{chKey:chKey,Name:name,itab:itab,rgce:rgce};}/* [MS-XLS] 2.4.106 TODO: verify filename encoding */function parse_ExternSheet(blob,length,opts){if(opts.biff<8)return parse_BIFF5ExternSheet(blob,length,opts);var o=[],target=blob.l+length,len=blob.read_shift(opts.biff>8?4:2);while(len--!==0){o.push(parse_XTI(blob,opts.biff>8?12:6,opts));}// [iSupBook, itabFirst, itabLast];
if(blob.l!=target)throw new Error("Bad ExternSheet: "+blob.l+" != "+target);return o;}function parse_BIFF5ExternSheet(blob,length,opts){if(blob[blob.l+1]==0x03)blob[blob.l]++;var o=parse_ShortXLUnicodeString(blob,length,opts);return o.charCodeAt(0)==0x03?o.slice(1):o;}/* [MS-XLS] 2.4.176 TODO: check older biff */function parse_NameCmt(blob,length,opts){if(opts.biff<8){blob.l+=length;return;}var cchName=blob.read_shift(2);var cchComment=blob.read_shift(2);var name=parse_XLUnicodeStringNoCch(blob,cchName,opts);var comment=parse_XLUnicodeStringNoCch(blob,cchComment,opts);return[name,comment];}/* [MS-XLS] 2.4.260 */function parse_ShrFmla(blob,length,opts){var ref=parse_RefU(blob,6);blob.l++;var cUse=blob.read_shift(1);length-=8;return[parse_SharedParsedFormula(blob,length,opts),cUse,ref];}/* [MS-XLS] 2.4.4 TODO */function parse_Array(blob,length,opts){var ref=parse_Ref(blob,6);/* TODO: fAlwaysCalc */switch(opts.biff){case 2:blob.l++;length-=7;break;case 3:case 4:blob.l+=2;length-=8;break;default:blob.l+=6;length-=12;}return[ref,parse_ArrayParsedFormula(blob,length,opts,ref)];}/* [MS-XLS] 2.4.173 */function parse_MTRSettings(blob){var fMTREnabled=blob.read_shift(4)!==0x00;var fUserSetThreadCount=blob.read_shift(4)!==0x00;var cUserThreadCount=blob.read_shift(4);return[fMTREnabled,fUserSetThreadCount,cUserThreadCount];}/* [MS-XLS] 2.5.186 TODO: BIFF5 */function parse_NoteSh(blob,length,opts){if(opts.biff<8)return;var row=blob.read_shift(2),col=blob.read_shift(2);var flags=blob.read_shift(2),idObj=blob.read_shift(2);var stAuthor=parse_XLUnicodeString2(blob,0,opts);if(opts.biff<8)blob.read_shift(1);return[{r:row,c:col},stAuthor,idObj,flags];}/* [MS-XLS] 2.4.179 */function parse_Note(blob,length,opts){/* TODO: Support revisions */return parse_NoteSh(blob,length,opts);}/* [MS-XLS] 2.4.168 */function parse_MergeCells(blob,length)/*:Array<Range>*/{var merges/*:Array<Range>*/=[];var cmcs=blob.read_shift(2);while(cmcs--){merges.push(parse_Ref8U(blob,length));}return merges;}function write_MergeCells(merges/*:Array<Range>*/){var o=new_buf(2+merges.length*8);o.write_shift(2,merges.length);for(var i=0;i<merges.length;++i){write_Ref8U(merges[i],o);}return o;}/* [MS-XLS] 2.4.181 TODO: parse all the things! */function parse_Obj(blob,length,opts){if(opts&&opts.biff<8)return parse_BIFF5Obj(blob,length,opts);var cmo=parse_FtCmo(blob,22);// id, ot, flags
var fts=parse_FtArray(blob,length-22,cmo[1]);return{cmo:cmo,ft:fts};}/* from older spec */var parse_BIFF5OT={0x08:function _(blob,length){var tgt=blob.l+length;blob.l+=10;// todo
var cf=blob.read_shift(2);blob.l+=4;blob.l+=2;//var cbPictFmla = blob.read_shift(2);
blob.l+=2;blob.l+=2;//var grbit = blob.read_shift(2);
blob.l+=4;var cchName=blob.read_shift(1);blob.l+=cchName;// TODO: stName
blob.l=tgt;// TODO: fmla
return{fmt:cf};}};function parse_BIFF5Obj(blob,length,opts){blob.l+=4;//var cnt = blob.read_shift(4);
var ot=blob.read_shift(2);var id=blob.read_shift(2);var grbit=blob.read_shift(2);blob.l+=2;//var colL = blob.read_shift(2);
blob.l+=2;//var dxL = blob.read_shift(2);
blob.l+=2;//var rwT = blob.read_shift(2);
blob.l+=2;//var dyT = blob.read_shift(2);
blob.l+=2;//var colR = blob.read_shift(2);
blob.l+=2;//var dxR = blob.read_shift(2);
blob.l+=2;//var rwB = blob.read_shift(2);
blob.l+=2;//var dyB = blob.read_shift(2);
blob.l+=2;//var cbMacro = blob.read_shift(2);
blob.l+=6;length-=36;var fts=[];fts.push((parse_BIFF5OT[ot]||parsenoop)(blob,length,opts));return{cmo:[id,ot,grbit],ft:fts};}/* [MS-XLS] 2.4.329 TODO: parse properly */function parse_TxO(blob,length,opts){var s=blob.l;var texts="";try{blob.l+=4;var ot=(opts.lastobj||{cmo:[0,0]}).cmo[1];var controlInfo;// eslint-disable-line no-unused-vars
if([0,5,7,11,12,14].indexOf(ot)==-1)blob.l+=6;else controlInfo=parse_ControlInfo(blob,6,opts);// eslint-disable-line no-unused-vars
var cchText=blob.read_shift(2);/*var cbRuns = */blob.read_shift(2);/*var ifntEmpty = */parseuint16(blob,2);var len=blob.read_shift(2);blob.l+=len;//var fmla = parse_ObjFmla(blob, s + length - blob.l);
for(var i=1;i<blob.lens.length-1;++i){if(blob.l-s!=blob.lens[i])throw new Error("TxO: bad continue record");var hdr=blob[blob.l];var t=parse_XLUnicodeStringNoCch(blob,blob.lens[i+1]-blob.lens[i]-1);texts+=t;if(texts.length>=(hdr?cchText:2*cchText))break;}if(texts.length!==cchText&&texts.length!==cchText*2){throw new Error("cchText: "+cchText+" != "+texts.length);}blob.l=s+length;/* [MS-XLS] 2.5.272 TxORuns *///	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
return{t:texts};}catch(e){blob.l=s+length;return{t:texts};}}/* [MS-XLS] 2.4.140 */function parse_HLink(blob,length){var ref=parse_Ref8U(blob,8);blob.l+=16;/* CLSID */var hlink=parse_Hyperlink(blob,length-24);return[ref,hlink];}function write_HLink(hl){var O=new_buf(24);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);var clsid="d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");for(var i=0;i<16;++i){O.write_shift(1,parseInt(clsid[i],16));}return bconcat([O,write_Hyperlink(hl[1])]);}/* [MS-XLS] 2.4.141 */function parse_HLinkTooltip(blob,length){blob.read_shift(2);var ref=parse_Ref8U(blob,8);var wzTooltip=blob.read_shift((length-10)/2,'dbcs-cont');wzTooltip=wzTooltip.replace(chr0,"");return[ref,wzTooltip];}function write_HLinkTooltip(hl){var TT=hl[1].Tooltip;var O=new_buf(10+2*(TT.length+1));O.write_shift(2,0x0800);var ref=decode_cell(hl[0]);O.write_shift(2,ref.r);O.write_shift(2,ref.r);O.write_shift(2,ref.c);O.write_shift(2,ref.c);for(var i=0;i<TT.length;++i){O.write_shift(2,TT.charCodeAt(i));}O.write_shift(2,0);return O;}/* [MS-XLS] 2.4.63 */function parse_Country(blob)/*:[string|number, string|number]*/{var o=[0,0],d;d=blob.read_shift(2);o[0]=CountryEnum[d]||d;d=blob.read_shift(2);o[1]=CountryEnum[d]||d;return o;}function write_Country(o){if(!o)o=new_buf(4);o.write_shift(2,0x01);o.write_shift(2,0x01);return o;}/* [MS-XLS] 2.4.50 ClrtClient */function parse_ClrtClient(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0){o.push(parse_LongRGB(blob,8));}return o;}/* [MS-XLS] 2.4.188 */function parse_Palette(blob){var ccv=blob.read_shift(2);var o=[];while(ccv-->0){o.push(parse_LongRGB(blob,8));}return o;}/* [MS-XLS] 2.4.354 */function parse_XFCRC(blob){blob.l+=2;var o={cxfs:0,crc:0};o.cxfs=blob.read_shift(2);o.crc=blob.read_shift(4);return o;}/* [MS-XLS] 2.4.53 TODO: parse flags *//* [MS-XLSB] 2.4.323 TODO: parse flags */function parse_ColInfo(blob,length,opts){if(!opts.cellStyles)return parsenoop(blob,length);var w=opts&&opts.biff>=12?4:2;var colFirst=blob.read_shift(w);var colLast=blob.read_shift(w);var coldx=blob.read_shift(w);var ixfe=blob.read_shift(w);var flags=blob.read_shift(2);if(w==2)blob.l+=2;var o={s:colFirst,e:colLast,w:coldx,ixfe:ixfe,flags:flags/*:any*/};if(opts.biff>=5||!opts.biff)o.level=flags>>8&0x7;return o;}function write_ColInfo(col,idx){var o=new_buf(12);o.write_shift(2,idx);o.write_shift(2,idx);o.write_shift(2,col.width*256);o.write_shift(2,0);var f=0;if(col.hidden)f|=1;o.write_shift(1,f);f=col.level||0;o.write_shift(1,f);o.write_shift(2,0);return o;}/* [MS-XLS] 2.4.257 */function parse_Setup(blob,length){var o={};if(length<32)return o;blob.l+=16;o.header=parse_Xnum(blob,8);o.footer=parse_Xnum(blob,8);blob.l+=2;return o;}/* [MS-XLS] 2.4.261 */function parse_ShtProps(blob,length,opts){var def={area:false};if(opts.biff!=5){blob.l+=length;return def;}var d=blob.read_shift(1);blob.l+=3;if(d&0x10)def.area=true;return def;}/* [MS-XLS] 2.4.241 */function write_RRTabId(n/*:number*/){var out=new_buf(2*n);for(var i=0;i<n;++i){out.write_shift(2,i+1);}return out;}var parse_Blank=parse_XLSCell;/* [MS-XLS] 2.4.20 Just the cell */var parse_Scl=parseuint16a;/* [MS-XLS] 2.4.247 num, den */var parse_String=parse_XLUnicodeString;/* [MS-XLS] 2.4.268 *//* --- Specific to versions before BIFF8 --- */function parse_ImData(blob){var cf=blob.read_shift(2);var env=blob.read_shift(2);var lcb=blob.read_shift(4);var o={fmt:cf,env:env,len:lcb,data:blob.slice(blob.l,blob.l+lcb)};blob.l+=lcb;return o;}/* BIFF2_??? where ??? is the name from [XLS] */function parse_BIFF2STR(blob,length,opts){if(opts.biffguess&&opts.biff==5)opts.biff=2;var cell=parse_XLSCell(blob,6);++blob.l;var str=parse_XLUnicodeString2(blob,length-7,opts);cell.t='str';cell.val=str;return cell;}function parse_BIFF2NUM(blob/*::, length*/){var cell=parse_XLSCell(blob,6);++blob.l;var num=parse_Xnum(blob,8);cell.t='n';cell.val=num;return cell;}function write_BIFF2NUM(r/*:number*/,c/*:number*/,val/*:number*/){var out=new_buf(15);write_BIFF2Cell(out,r,c);out.write_shift(8,val,'f');return out;}function parse_BIFF2INT(blob){var cell=parse_XLSCell(blob,6);++blob.l;var num=blob.read_shift(2);cell.t='n';cell.val=num;return cell;}function write_BIFF2INT(r/*:number*/,c/*:number*/,val/*:number*/){var out=new_buf(9);write_BIFF2Cell(out,r,c);out.write_shift(2,val);return out;}function parse_BIFF2STRING(blob){var cch=blob.read_shift(1);if(cch===0){blob.l++;return"";}return blob.read_shift(cch,'sbcs-cont');}/* TODO: convert to BIFF8 font struct */function parse_BIFF2FONTXTRA(blob,length){blob.l+=6;// unknown
blob.l+=2;// font weight "bls"
blob.l+=1;// charset
blob.l+=3;// unknown
blob.l+=1;// font family
blob.l+=length-13;}/* TODO: parse rich text runs */function parse_RString(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);var cch=blob.read_shift(2);var str=parse_XLUnicodeStringNoCch(blob,cch,opts);blob.l=end;cell.t='str';cell.val=str;return cell;}/* from js-harb (C) 2014-present  SheetJS */var DBF_SUPPORTED_VERSIONS=[0x02,0x03,0x30,0x31,0x83,0x8B,0x8C,0xF5];var DBF=/*#__PURE__*/function(){var dbf_codepage_map={/* Code Pages Supported by Visual FoxPro *//*::[*/0x01/*::]*/:437,/*::[*/0x02/*::]*/:850,/*::[*/0x03/*::]*/:1252,/*::[*/0x04/*::]*/:10000,/*::[*/0x64/*::]*/:852,/*::[*/0x65/*::]*/:866,/*::[*/0x66/*::]*/:865,/*::[*/0x67/*::]*/:861,/*::[*/0x68/*::]*/:895,/*::[*/0x69/*::]*/:620,/*::[*/0x6A/*::]*/:737,/*::[*/0x6B/*::]*/:857,/*::[*/0x78/*::]*/:950,/*::[*/0x79/*::]*/:949,/*::[*/0x7A/*::]*/:936,/*::[*/0x7B/*::]*/:932,/*::[*/0x7C/*::]*/:874,/*::[*/0x7D/*::]*/:1255,/*::[*/0x7E/*::]*/:1256,/*::[*/0x96/*::]*/:10007,/*::[*/0x97/*::]*/:10029,/*::[*/0x98/*::]*/:10006,/*::[*/0xC8/*::]*/:1250,/*::[*/0xC9/*::]*/:1251,/*::[*/0xCA/*::]*/:1254,/*::[*/0xCB/*::]*/:1253,/* shapefile DBF extension *//*::[*/0x00/*::]*/:20127,/*::[*/0x08/*::]*/:865,/*::[*/0x09/*::]*/:437,/*::[*/0x0A/*::]*/:850,/*::[*/0x0B/*::]*/:437,/*::[*/0x0D/*::]*/:437,/*::[*/0x0E/*::]*/:850,/*::[*/0x0F/*::]*/:437,/*::[*/0x10/*::]*/:850,/*::[*/0x11/*::]*/:437,/*::[*/0x12/*::]*/:850,/*::[*/0x13/*::]*/:932,/*::[*/0x14/*::]*/:850,/*::[*/0x15/*::]*/:437,/*::[*/0x16/*::]*/:850,/*::[*/0x17/*::]*/:865,/*::[*/0x18/*::]*/:437,/*::[*/0x19/*::]*/:437,/*::[*/0x1A/*::]*/:850,/*::[*/0x1B/*::]*/:437,/*::[*/0x1C/*::]*/:863,/*::[*/0x1D/*::]*/:850,/*::[*/0x1F/*::]*/:852,/*::[*/0x22/*::]*/:852,/*::[*/0x23/*::]*/:852,/*::[*/0x24/*::]*/:860,/*::[*/0x25/*::]*/:850,/*::[*/0x26/*::]*/:866,/*::[*/0x37/*::]*/:850,/*::[*/0x40/*::]*/:852,/*::[*/0x4D/*::]*/:936,/*::[*/0x4E/*::]*/:949,/*::[*/0x4F/*::]*/:950,/*::[*/0x50/*::]*/:874,/*::[*/0x57/*::]*/:1252,/*::[*/0x58/*::]*/:1252,/*::[*/0x59/*::]*/:1252,/*::[*/0x6C/*::]*/:863,/*::[*/0x86/*::]*/:737,/*::[*/0x87/*::]*/:852,/*::[*/0x88/*::]*/:857,/*::[*/0xCC/*::]*/:1257,/*::[*/0xFF/*::]*/:16969};var dbf_reverse_map=evert({/*::[*/0x01/*::]*/:437,/*::[*/0x02/*::]*/:850,/*::[*/0x03/*::]*/:1252,/*::[*/0x04/*::]*/:10000,/*::[*/0x64/*::]*/:852,/*::[*/0x65/*::]*/:866,/*::[*/0x66/*::]*/:865,/*::[*/0x67/*::]*/:861,/*::[*/0x68/*::]*/:895,/*::[*/0x69/*::]*/:620,/*::[*/0x6A/*::]*/:737,/*::[*/0x6B/*::]*/:857,/*::[*/0x78/*::]*/:950,/*::[*/0x79/*::]*/:949,/*::[*/0x7A/*::]*/:936,/*::[*/0x7B/*::]*/:932,/*::[*/0x7C/*::]*/:874,/*::[*/0x7D/*::]*/:1255,/*::[*/0x7E/*::]*/:1256,/*::[*/0x96/*::]*/:10007,/*::[*/0x97/*::]*/:10029,/*::[*/0x98/*::]*/:10006,/*::[*/0xC8/*::]*/:1250,/*::[*/0xC9/*::]*/:1251,/*::[*/0xCA/*::]*/:1254,/*::[*/0xCB/*::]*/:1253,/*::[*/0x00/*::]*/:20127});/* TODO: find an actual specification */function dbf_to_aoa(buf,opts)/*:AOA*/{var out/*:AOA*/=[];var d/*:Block*/=new_raw_buf(1)/*:any*/;switch(opts.type){case'base64':d=s2a(Base64_decode(buf));break;case'binary':d=s2a(buf);break;case'buffer':case'array':d=buf;break;}prep_blob(d,0);/* header */var ft=d.read_shift(1);var memo=!!(ft&0x88);var vfp=false,l7=false;switch(ft){case 0x02:break;// dBASE II
case 0x03:break;// dBASE III
case 0x30:vfp=true;memo=true;break;// VFP
case 0x31:vfp=true;memo=true;break;// VFP with autoincrement
// 0x43 dBASE IV SQL table files
// 0x63 dBASE IV SQL system files
case 0x83:break;// dBASE III with memo
case 0x8B:break;// dBASE IV with memo
case 0x8C:l7=true;break;// dBASE Level 7 with memo
// case 0xCB dBASE IV SQL table files with memo
case 0xF5:break;// FoxPro 2.x with memo
// case 0xFB FoxBASE
default:throw new Error("DBF Unsupported Version: "+ft.toString(16));}var nrow=0,fpos=0x0209;if(ft==0x02)nrow=d.read_shift(2);d.l+=3;// dBASE II stores DDMMYY date, others use YYMMDD
if(ft!=0x02)nrow=d.read_shift(4);if(nrow>1048576)nrow=1e6;if(ft!=0x02)fpos=d.read_shift(2);// header length
var rlen=d.read_shift(2);// record length
var/*flags = 0,*/current_cp=opts.codepage||1252;if(ft!=0x02){// 20 reserved bytes
d.l+=16;/*flags = */d.read_shift(1);//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
/* codepage present in FoxPro and dBASE Level 7 */if(d[d.l]!==0)current_cp=dbf_codepage_map[d[d.l]];d.l+=1;d.l+=2;}if(l7)d.l+=36;// Level 7: 32 byte "Language driver name", 4 byte reserved
/*:: type DBFField = { name:string; len:number; type:string; } */var fields/*:Array<DBFField>*/=[],field/*:DBFField*/={}/*:any*/;var hend=Math.min(d.length,ft==0x02?0x209:fpos-10-(vfp?264:0));var ww=l7?32:11;while(d.l<hend&&d[d.l]!=0x0d){field={}/*:any*/;field.name=$cptable.utils.decode(current_cp,d.slice(d.l,d.l+ww)).replace(/[\u0000\r\n].*$/g,"");d.l+=ww;field.type=String.fromCharCode(d.read_shift(1));if(ft!=0x02&&!l7)field.offset=d.read_shift(4);field.len=d.read_shift(1);if(ft==0x02)field.offset=d.read_shift(2);field.dec=d.read_shift(1);if(field.name.length)fields.push(field);if(ft!=0x02)d.l+=l7?13:14;switch(field.type){case'B':// Double (VFP) / Binary (dBASE L7)
if((!vfp||field.len!=8)&&opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'G':// General (FoxPro and dBASE L7)
case'P':// Picture (FoxPro and dBASE L7)
if(opts.WTF)console.log('Skipping '+field.name+':'+field.type);break;case'+':// Autoincrement (dBASE L7 only)
case'0':// _NullFlags (VFP only)
case'@':// Timestamp (dBASE L7 only)
case'C':// Character (dBASE II)
case'D':// Date (dBASE III)
case'F':// Float (dBASE IV)
case'I':// Long (VFP and dBASE L7)
case'L':// Logical (dBASE II)
case'M':// Memo (dBASE III)
case'N':// Number (dBASE II)
case'O':// Double (dBASE L7 only)
case'T':// Datetime (VFP only)
case'Y':// Currency (VFP only)
break;default:throw new Error('Unknown Field Type: '+field.type);}}if(d[d.l]!==0x0D)d.l=fpos-1;if(d.read_shift(1)!==0x0D)throw new Error("DBF Terminator not found "+d.l+" "+d[d.l]);d.l=fpos;/* data */var R=0,C=0;out[0]=[];for(C=0;C!=fields.length;++C){out[0][C]=fields[C].name;}while(nrow-->0){if(d[d.l]===0x2A){// TODO: record marked as deleted -- create a hidden row?
d.l+=rlen;continue;}++d.l;out[++R]=[];C=0;for(C=0;C!=fields.length;++C){var dd=d.slice(d.l,d.l+fields[C].len);d.l+=fields[C].len;prep_blob(dd,0);var s=$cptable.utils.decode(current_cp,dd);switch(fields[C].type){case'C':// NOTE: it is conventional to write '  /  /  ' for empty dates
if(s.trim().length)out[R][C]=s.replace(/\s+$/,"");break;case'D':if(s.length===8)out[R][C]=new Date(+s.slice(0,4),+s.slice(4,6)-1,+s.slice(6,8));else out[R][C]=s;break;case'F':out[R][C]=parseFloat(s.trim());break;case'+':case'I':out[R][C]=l7?dd.read_shift(-4,'i')^0x80000000:dd.read_shift(4,'i');break;case'L':switch(s.trim().toUpperCase()){case'Y':case'T':out[R][C]=true;break;case'N':case'F':out[R][C]=false;break;case'':case'?':break;default:throw new Error("DBF Unrecognized L:|"+s+"|");}break;case'M':/* TODO: handle memo files */if(!memo)throw new Error("DBF Unexpected MEMO for type "+ft.toString(16));out[R][C]="##MEMO##"+(l7?parseInt(s.trim(),10):dd.read_shift(4));break;case'N':s=s.replace(/\u0000/g,"").trim();// NOTE: dBASE II interprets "  .  " as 0
if(s&&s!=".")out[R][C]=+s||0;break;case'@':// NOTE: dBASE specs appear to be incorrect
out[R][C]=new Date(dd.read_shift(-8,'f')-0x388317533400);break;case'T':out[R][C]=new Date((dd.read_shift(4)-0x253D8C)*0x5265C00+dd.read_shift(4));break;case'Y':out[R][C]=dd.read_shift(4,'i')/1e4+dd.read_shift(4,'i')/1e4*Math.pow(2,32);break;case'O':out[R][C]=-dd.read_shift(-8,'f');break;case'B':if(vfp&&fields[C].len==8){out[R][C]=dd.read_shift(8,'f');break;}/* falls through */case'G':case'P':dd.l+=fields[C].len;break;case'0':if(fields[C].name==='_NullFlags')break;/* falls through */default:throw new Error("DBF Unsupported data type "+fields[C].type);}}}if(ft!=0x02)if(d.l<d.length&&d[d.l++]!=0x1A)throw new Error("DBF EOF Marker missing "+(d.l-1)+" of "+d.length+" "+d[d.l-1].toString(16));if(opts&&opts.sheetRows)out=out.slice(0,opts.sheetRows);opts.DBF=fields;return out;}function dbf_to_sheet(buf,opts)/*:Worksheet*/{var o=opts||{};if(!o.dateNF)o.dateNF="yyyymmdd";var ws=aoa_to_sheet(dbf_to_aoa(buf,o),o);ws["!cols"]=o.DBF.map(function(field){return{wch:field.len,DBF:field};});delete o.DBF;return ws;}function dbf_to_workbook(buf,opts)/*:Workbook*/{try{return sheet_to_workbook(dbf_to_sheet(buf,opts),opts);}catch(e){if(opts&&opts.WTF)throw e;}return{SheetNames:[],Sheets:{}};}var _RLEN={'B':8,'C':250,'L':1,'D':8,'?':0,'':0};function sheet_to_dbf(ws/*:Worksheet*/,opts/*:WriteOpts*/){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write DBF to JS string");var ba=buf_array();var aoa/*:AOA*/=sheet_to_json(ws,{header:1,raw:true,cellDates:true});var headers=aoa[0],data=aoa.slice(1),cols=ws["!cols"]||[];var i=0,j=0,hcnt=0,rlen=1;for(i=0;i<headers.length;++i){if(((cols[i]||{}).DBF||{}).name){headers[i]=cols[i].DBF.name;++hcnt;continue;}if(headers[i]==null)continue;++hcnt;if(typeof headers[i]==='number')headers[i]=headers[i].toString(10);if(typeof headers[i]!=='string')throw new Error("DBF Invalid column name "+headers[i]+" |"+(0,_typeof3.default)(headers[i])+"|");if(headers.indexOf(headers[i])!==i)for(j=0;j<1024;++j){if(headers.indexOf(headers[i]+"_"+j)==-1){headers[i]+="_"+j;break;}}}var range=safe_decode_range(ws['!ref']);var coltypes/*:Array<string>*/=[];var colwidths/*:Array<number>*/=[];var coldecimals/*:Array<number>*/=[];for(i=0;i<=range.e.c-range.s.c;++i){var guess='',_guess='',maxlen=0;var col/*:Array<any>*/=[];for(j=0;j<data.length;++j){if(data[j][i]!=null)col.push(data[j][i]);}if(col.length==0||headers[i]==null){coltypes[i]='?';continue;}for(j=0;j<col.length;++j){switch((0,_typeof3.default)(col[j])){/* TODO: check if L2 compat is desired */case'number':_guess='B';break;case'string':_guess='C';break;case'boolean':_guess='L';break;case'object':_guess=col[j]instanceof Date?'D':'C';break;default:_guess='C';}maxlen=Math.max(maxlen,String(col[j]).length);guess=guess&&guess!=_guess?'C':_guess;//if(guess == 'C') break;
}if(maxlen>250)maxlen=250;_guess=((cols[i]||{}).DBF||{}).type;/* TODO: more fine grained control over DBF type resolution */if(_guess=='C'){if(cols[i].DBF.len>maxlen)maxlen=cols[i].DBF.len;}if(guess=='B'&&_guess=='N'){guess='N';coldecimals[i]=cols[i].DBF.dec;maxlen=cols[i].DBF.len;}colwidths[i]=guess=='C'||_guess=='N'?maxlen:_RLEN[guess]||0;rlen+=colwidths[i];coltypes[i]=guess;}var h=ba.next(32);h.write_shift(4,0x13021130);h.write_shift(4,data.length);h.write_shift(2,296+32*hcnt);h.write_shift(2,rlen);for(i=0;i<4;++i){h.write_shift(4,0);}h.write_shift(4,0x00000000|(+dbf_reverse_map[/*::String(*/current_ansi/*::)*/]||0x03)<<8);for(i=0,j=0;i<headers.length;++i){if(headers[i]==null)continue;var hf=ba.next(32);var _f=(headers[i].slice(-10)+"\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0,11);hf.write_shift(1,_f,"sbcs");hf.write_shift(1,coltypes[i]=='?'?'C':coltypes[i],"sbcs");hf.write_shift(4,j);hf.write_shift(1,colwidths[i]||_RLEN[coltypes[i]]||0);hf.write_shift(1,coldecimals[i]||0);hf.write_shift(1,0x02);hf.write_shift(4,0);hf.write_shift(1,0);hf.write_shift(4,0);hf.write_shift(4,0);j+=colwidths[i]||_RLEN[coltypes[i]]||0;}var hb=ba.next(264);hb.write_shift(4,0x0000000D);for(i=0;i<65;++i){hb.write_shift(4,0x00000000);}for(i=0;i<data.length;++i){var rout=ba.next(rlen);rout.write_shift(1,0);for(j=0;j<headers.length;++j){if(headers[j]==null)continue;switch(coltypes[j]){case'L':rout.write_shift(1,data[i][j]==null?0x3F:data[i][j]?0x54:0x46);break;case'B':rout.write_shift(8,data[i][j]||0,'f');break;case'N':var _n="0";if(typeof data[i][j]=="number")_n=data[i][j].toFixed(coldecimals[j]||0);for(hcnt=0;hcnt<colwidths[j]-_n.length;++hcnt){rout.write_shift(1,0x20);}rout.write_shift(1,_n,"sbcs");break;case'D':if(!data[i][j])rout.write_shift(8,"00000000","sbcs");else{rout.write_shift(4,("0000"+data[i][j].getFullYear()).slice(-4),"sbcs");rout.write_shift(2,("00"+(data[i][j].getMonth()+1)).slice(-2),"sbcs");rout.write_shift(2,("00"+data[i][j].getDate()).slice(-2),"sbcs");}break;case'C':var _s=String(data[i][j]!=null?data[i][j]:"").slice(0,colwidths[j]);rout.write_shift(1,_s,"sbcs");for(hcnt=0;hcnt<colwidths[j]-_s.length;++hcnt){rout.write_shift(1,0x20);}break;}}// data
}ba.next(1).write_shift(1,0x1A);return ba.end();}return{to_workbook:dbf_to_workbook,to_sheet:dbf_to_sheet,from_sheet:sheet_to_dbf};}();var SYLK=/*#__PURE__*/function(){/* TODO: stress test sequences */var sylk_escapes={AA:'À',BA:'Á',CA:'Â',DA:195,HA:'Ä',JA:197,AE:'È',BE:'É',CE:'Ê',HE:'Ë',AI:'Ì',BI:'Í',CI:'Î',HI:'Ï',AO:'Ò',BO:'Ó',CO:'Ô',DO:213,HO:'Ö',AU:'Ù',BU:'Ú',CU:'Û',HU:'Ü',Aa:'à',Ba:'á',Ca:'â',Da:227,Ha:'ä',Ja:229,Ae:'è',Be:'é',Ce:'ê',He:'ë',Ai:'ì',Bi:'í',Ci:'î',Hi:'ï',Ao:'ò',Bo:'ó',Co:'ô',Do:245,Ho:'ö',Au:'ù',Bu:'ú',Cu:'û',Hu:'ü',KC:'Ç',Kc:'ç',q:'æ',z:'œ',a:'Æ',j:'Œ',DN:209,Dn:241,Hy:255,S:169,c:170,R:174,"B ":180,/*::[*/0/*::]*/:176,/*::[*/1/*::]*/:177,/*::[*/2/*::]*/:178,/*::[*/3/*::]*/:179,/*::[*/5/*::]*/:181,/*::[*/6/*::]*/:182,/*::[*/7/*::]*/:183,Q:185,k:186,b:208,i:216,l:222,s:240,y:248,"!":161,'"':162,"#":163,"(":164,"%":165,"'":167,"H ":168,"+":171,";":187,"<":188,"=":189,">":190,"?":191,"{":223/*:any*/};var sylk_char_regex=new RegExp("\x1BN("+keys(sylk_escapes).join("|").replace(/\|\|\|/,"|\\||").replace(/([?()+])/g,"\\$1")+"|\\|)","gm");var sylk_char_fn=function sylk_char_fn(_,$1){var o=sylk_escapes[$1];return typeof o=="number"?_getansi(o):o;};var decode_sylk_char=function decode_sylk_char($$,$1,$2){var newcc=$1.charCodeAt(0)-0x20<<4|$2.charCodeAt(0)-0x30;return newcc==59?$$:_getansi(newcc);};sylk_escapes["|"]=254;/* TODO: find an actual specification */function sylk_to_aoa(d/*:RawData*/,opts)/*:[AOA, Worksheet]*/{switch(opts.type){case'base64':return sylk_to_aoa_str(Base64_decode(d),opts);case'binary':return sylk_to_aoa_str(d,opts);case'buffer':return sylk_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return sylk_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function sylk_to_aoa_str(str/*:string*/,opts)/*:[AOA, Worksheet]*/{var records=str.split(/[\n\r]+/),R=-1,C=-1,ri=0,rj=0,arr/*:AOA*/=[];var formats/*:Array<string>*/=[];var next_cell_format/*:string|null*/=null;var sht={},rowinfo/*:Array<RowInfo>*/=[],colinfo/*:Array<ColInfo>*/=[],cw/*:Array<string>*/=[];var Mval=0,j;if(+opts.codepage>=0)set_cp(+opts.codepage);for(;ri!==records.length;++ri){Mval=0;var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g,decode_sylk_char).replace(sylk_char_regex,sylk_char_fn);var record=rstr.replace(/;;/g,"\0").split(";").map(function(x){return x.replace(/\u0000/g,";");});var RT=record[0],val;if(rstr.length>0)switch(RT){case'ID':break;/* header */case'E':break;/* EOF */case'B':break;/* dimensions */case'O':break;/* options? */case'W':break;/* window? */case'P':if(record[1].charAt(0)=='P')formats.push(rstr.slice(3).replace(/;;/g,";"));break;case'C':var C_seen_K=false,C_seen_X=false,C_seen_S=false,C_seen_E=false,_R=-1,_C=-1;for(rj=1;rj<record.length;++rj){switch(record[rj].charAt(0)){case'A':break;// TODO: comment
case'X':C=parseInt(record[rj].slice(1))-1;C_seen_X=true;break;case'Y':R=parseInt(record[rj].slice(1))-1;if(!C_seen_X)C=0;for(j=arr.length;j<=R;++j){arr[j]=[];}break;case'K':val=record[rj].slice(1);if(val.charAt(0)==='"')val=val.slice(1,val.length-1);else if(val==='TRUE')val=true;else if(val==='FALSE')val=false;else if(!isNaN(fuzzynum(val))){val=fuzzynum(val);if(next_cell_format!==null&&fmt_is_date(next_cell_format))val=numdate(val);}else if(!isNaN(fuzzydate(val).getDate())){val=parseDate(val);}if(typeof $cptable!=='undefined'&&typeof val=="string"&&(opts||{}).type!="string"&&(opts||{}).codepage)val=$cptable.utils.decode(opts.codepage,val);C_seen_K=true;break;case'E':C_seen_E=true;var formula=rc_to_a1(record[rj].slice(1),{r:R,c:C});arr[R][C]=[arr[R][C],formula];break;case'S':C_seen_S=true;arr[R][C]=[arr[R][C],"S5S"];break;case'G':break;// unknown
case'R':_R=parseInt(record[rj].slice(1))-1;break;case'C':_C=parseInt(record[rj].slice(1))-1;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(C_seen_K){if(arr[R][C]&&arr[R][C].length==2)arr[R][C][0]=val;else arr[R][C]=val;next_cell_format=null;}if(C_seen_S){if(C_seen_E)throw new Error("SYLK shared formula cannot have own formula");var shrbase=_R>-1&&arr[_R][_C];if(!shrbase||!shrbase[1])throw new Error("SYLK shared formula cannot find base");arr[R][C][1]=shift_formula_str(shrbase[1],{r:R-_R,c:C-_C});}break;case'F':var F_seen=0;for(rj=1;rj<record.length;++rj){switch(record[rj].charAt(0)){case'X':C=parseInt(record[rj].slice(1))-1;++F_seen;break;case'Y':R=parseInt(record[rj].slice(1))-1;/*C = 0;*/for(j=arr.length;j<=R;++j){arr[j]=[];}break;case'M':Mval=parseInt(record[rj].slice(1))/20;break;case'F':break;/* ??? */case'G':break;/* hide grid */case'P':next_cell_format=formats[parseInt(record[rj].slice(1))];break;case'S':break;/* cell style */case'D':break;/* column */case'N':break;/* font */case'W':cw=record[rj].slice(1).split(" ");for(j=parseInt(cw[0],10);j<=parseInt(cw[1],10);++j){Mval=parseInt(cw[2],10);colinfo[j-1]=Mval===0?{hidden:true}:{wch:Mval};process_col(colinfo[j-1]);}break;case'C':/* default column format */C=parseInt(record[rj].slice(1))-1;if(!colinfo[C])colinfo[C]={};break;case'R':/* row properties */R=parseInt(record[rj].slice(1))-1;if(!rowinfo[R])rowinfo[R]={};if(Mval>0){rowinfo[R].hpt=Mval;rowinfo[R].hpx=pt2px(Mval);}else if(Mval===0)rowinfo[R].hidden=true;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(F_seen<1)next_cell_format=null;break;default:if(opts&&opts.WTF)throw new Error("SYLK bad record "+rstr);}}if(rowinfo.length>0)sht['!rows']=rowinfo;if(colinfo.length>0)sht['!cols']=colinfo;if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return[arr,sht];}function sylk_to_sheet(d/*:RawData*/,opts)/*:Worksheet*/{var aoasht=sylk_to_aoa(d,opts);var aoa=aoasht[0],ws=aoasht[1];var o=aoa_to_sheet(aoa,opts);keys(ws).forEach(function(k){o[k]=ws[k];});return o;}function sylk_to_workbook(d/*:RawData*/,opts)/*:Workbook*/{return sheet_to_workbook(sylk_to_sheet(d,opts),opts);}function write_ws_cell_sylk(cell/*:Cell*/,ws/*:Worksheet*/,R/*:number*/,C/*:number*//*::, opts*/)/*:string*/{var o="C;Y"+(R+1)+";X"+(C+1)+";K";switch(cell.t){case'n':o+=cell.v||0;if(cell.f&&!cell.F)o+=";E"+a1_to_rc(cell.f,{r:R,c:C});break;case'b':o+=cell.v?"TRUE":"FALSE";break;case'e':o+=cell.w||cell.v;break;case'd':o+='"'+(cell.w||cell.v)+'"';break;case's':o+='"'+cell.v.replace(/"/g,"").replace(/;/g,";;")+'"';break;}return o;}function write_ws_cols_sylk(out,cols){cols.forEach(function(col,i){var rec="F;W"+(i+1)+" "+(i+1)+" ";if(col.hidden)rec+="0";else{if(typeof col.width=='number'&&!col.wpx)col.wpx=width2px(col.width);if(typeof col.wpx=='number'&&!col.wch)col.wch=px2char(col.wpx);if(typeof col.wch=='number')rec+=Math.round(col.wch);}if(rec.charAt(rec.length-1)!=" ")out.push(rec);});}function write_ws_rows_sylk(out/*:Array<string>*/,rows/*:Array<RowInfo>*/){rows.forEach(function(row,i){var rec="F;";if(row.hidden)rec+="M0;";else if(row.hpt)rec+="M"+20*row.hpt+";";else if(row.hpx)rec+="M"+20*px2pt(row.hpx)+";";if(rec.length>2)out.push(rec+"R"+(i+1));});}function sheet_to_sylk(ws/*:Worksheet*/,opts/*:?any*/)/*:string*/{var preamble/*:Array<string>*/=["ID;PWXL;N;E"],o/*:Array<string>*/=[];var r=safe_decode_range(ws['!ref']),cell/*:Cell*/;var dense=Array.isArray(ws);var RS="\r\n";preamble.push("P;PGeneral");preamble.push("F;P0;DG0G8;M255");if(ws['!cols'])write_ws_cols_sylk(preamble,ws['!cols']);if(ws['!rows'])write_ws_rows_sylk(preamble,ws['!rows']);preamble.push("B;Y"+(r.e.r-r.s.r+1)+";X"+(r.e.c-r.s.c+1)+";D"+[r.s.c,r.s.r,r.e.c,r.e.r].join(" "));for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(write_ws_cell_sylk(cell,ws,R,C,opts));}}return preamble.join(RS)+RS+o.join(RS)+RS+"E"+RS;}return{to_workbook:sylk_to_workbook,to_sheet:sylk_to_sheet,from_sheet:sheet_to_sylk};}();var DIF=/*#__PURE__*/function(){function dif_to_aoa(d/*:RawData*/,opts)/*:AOA*/{switch(opts.type){case'base64':return dif_to_aoa_str(Base64_decode(d),opts);case'binary':return dif_to_aoa_str(d,opts);case'buffer':return dif_to_aoa_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return dif_to_aoa_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}function dif_to_aoa_str(str/*:string*/,opts)/*:AOA*/{var records=str.split('\n'),R=-1,C=-1,ri=0,arr/*:AOA*/=[];for(;ri!==records.length;++ri){if(records[ri].trim()==='BOT'){arr[++R]=[];C=0;continue;}if(R<0)continue;var metadata=records[ri].trim().split(",");var type=metadata[0],value=metadata[1];++ri;var data=records[ri]||"";while((data.match(/["]/g)||[]).length&1&&ri<records.length-1){data+="\n"+records[++ri];}data=data.trim();switch(+type){case-1:if(data==='BOT'){arr[++R]=[];C=0;continue;}else if(data!=='EOD')throw new Error("Unrecognized DIF special command "+data);break;case 0:if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(value)))arr[R][C]=fuzzynum(value);else if(!isNaN(fuzzydate(value).getDate()))arr[R][C]=parseDate(value);else arr[R][C]=value;++C;break;case 1:data=data.slice(1,data.length-1);data=data.replace(/""/g,'"');if(DIF_XL&&data&&data.match(/^=".*"$/))data=data.slice(2,-1);arr[R][C++]=data!==''?data:null;break;}if(data==='EOD')break;}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function dif_to_sheet(str/*:string*/,opts)/*:Worksheet*/{return aoa_to_sheet(dif_to_aoa(str,opts),opts);}function dif_to_workbook(str/*:string*/,opts)/*:Workbook*/{return sheet_to_workbook(dif_to_sheet(str,opts),opts);}var sheet_to_dif=/*#__PURE__*/function(){var push_field=function pf(o/*:Array<string>*/,topic/*:string*/,v/*:number*/,n/*:number*/,s/*:string*/){o.push(topic);o.push(v+","+n);o.push('"'+s.replace(/"/g,'""')+'"');};var push_value=function po(o/*:Array<string>*/,type/*:number*/,v/*:any*/,s/*:string*/){o.push(type+","+v);o.push(type==1?'"'+s.replace(/"/g,'""')+'"':s);};return function sheet_to_dif(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/{var o/*:Array<string>*/=[];var r=safe_decode_range(ws['!ref']),cell/*:Cell*/;var dense=Array.isArray(ws);push_field(o,"TABLE",0,1,"sheetjs");push_field(o,"VECTORS",0,r.e.r-r.s.r+1,"");push_field(o,"TUPLES",0,r.e.c-r.s.c+1,"");push_field(o,"DATA",0,0,"");for(var R=r.s.r;R<=r.e.r;++R){push_value(o,-1,0,"BOT");for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell){push_value(o,1,0,"");continue;}switch(cell.t){case'n':var val=DIF_XL?cell.w:cell.v;if(!val&&cell.v!=null)val=cell.v;if(val==null){if(DIF_XL&&cell.f&&!cell.F)push_value(o,1,0,"="+cell.f);else push_value(o,1,0,"");}else push_value(o,0,val,"V");break;case'b':push_value(o,0,cell.v?1:0,cell.v?"TRUE":"FALSE");break;case's':push_value(o,1,0,!DIF_XL||isNaN(cell.v)?cell.v:'="'+cell.v+'"');break;case'd':if(!cell.w)cell.w=SSF_format(cell.z||table_fmt[14],datenum(parseDate(cell.v)));if(DIF_XL)push_value(o,0,cell.w,"V");else push_value(o,1,0,cell.w);break;default:push_value(o,1,0,"");}}}push_value(o,-1,0,"EOD");var RS="\r\n";var oo=o.join(RS);//while((oo.length & 0x7F) != 0) oo += "\0";
return oo;};}();return{to_workbook:dif_to_workbook,to_sheet:dif_to_sheet,from_sheet:sheet_to_dif};}();var ETH=/*#__PURE__*/function(){function decode(s/*:string*/)/*:string*/{return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n");}function encode(s/*:string*/)/*:string*/{return s.replace(/\\/g,"\\b").replace(/:/g,"\\c").replace(/\n/g,"\\n");}function eth_to_aoa(str/*:string*/,opts)/*:AOA*/{var records=str.split('\n'),R=-1,C=-1,ri=0,arr/*:AOA*/=[];for(;ri!==records.length;++ri){var record=records[ri].trim().split(":");if(record[0]!=='cell')continue;var addr=decode_cell(record[1]);if(arr.length<=addr.r)for(R=arr.length;R<=addr.r;++R){if(!arr[R])arr[R]=[];}R=addr.r;C=addr.c;switch(record[2]){case't':arr[R][C]=decode(record[3]);break;case'v':arr[R][C]=+record[3];break;case'vtf':var _f=record[record.length-1];/* falls through */case'vtc':switch(record[3]){case'nl':arr[R][C]=+record[4]?true:false;break;default:arr[R][C]=+record[4];break;}if(record[2]=='vtf')arr[R][C]=[arr[R][C],_f];}}if(opts&&opts.sheetRows)arr=arr.slice(0,opts.sheetRows);return arr;}function eth_to_sheet(d/*:string*/,opts)/*:Worksheet*/{return aoa_to_sheet(eth_to_aoa(d,opts),opts);}function eth_to_workbook(d/*:string*/,opts)/*:Workbook*/{return sheet_to_workbook(eth_to_sheet(d,opts),opts);}var header=["socialcalc:version:1.5","MIME-Version: 1.0","Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"].join("\n");var sep=["--SocialCalcSpreadsheetControlSave","Content-type: text/plain; charset=UTF-8"].join("\n")+"\n";/* TODO: the other parts */var meta=["# SocialCalc Spreadsheet Control Save","part:sheet"].join("\n");var end="--SocialCalcSpreadsheetControlSave--";function sheet_to_eth_data(ws/*:Worksheet*/)/*:string*/{if(!ws||!ws['!ref'])return"";var o/*:Array<string>*/=[],oo/*:Array<string>*/=[],cell,coord="";var r=decode_range(ws['!ref']);var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){for(var C=r.s.c;C<=r.e.c;++C){coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null||cell.t==='z')continue;oo=["cell",coord,'t'];switch(cell.t){case's':case'str':oo.push(encode(cell.v));break;case'n':if(!cell.f){oo[2]='v';oo[3]=cell.v;}else{oo[2]='vtf';oo[3]='n';oo[4]=cell.v;oo[5]=encode(cell.f);}break;case'b':oo[2]='vt'+(cell.f?'f':'c');oo[3]='nl';oo[4]=cell.v?"1":"0";oo[5]=encode(cell.f||(cell.v?'TRUE':'FALSE'));break;case'd':var t=datenum(parseDate(cell.v));oo[2]='vtc';oo[3]='nd';oo[4]=""+t;oo[5]=cell.w||SSF_format(cell.z||table_fmt[14],t);break;case'e':continue;}o.push(oo.join(":"));}}o.push("sheet:c:"+(r.e.c-r.s.c+1)+":r:"+(r.e.r-r.s.r+1)+":tvf:1");o.push("valueformat:1:text-wiki");//o.push("copiedfrom:" + ws['!ref']); // clipboard only
return o.join("\n");}function sheet_to_eth(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/{return[header,sep,meta,sep,sheet_to_eth_data(ws),end].join("\n");// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
}return{to_workbook:eth_to_workbook,to_sheet:eth_to_sheet,from_sheet:sheet_to_eth};}();var PRN=/*#__PURE__*/function(){function set_text_arr(data/*:string*/,arr/*:AOA*/,R/*:number*/,C/*:number*/,o/*:any*/){if(o.raw)arr[R][C]=data;else if(data===""){/* empty */}else if(data==='TRUE')arr[R][C]=true;else if(data==='FALSE')arr[R][C]=false;else if(!isNaN(fuzzynum(data)))arr[R][C]=fuzzynum(data);else if(!isNaN(fuzzydate(data).getDate()))arr[R][C]=parseDate(data);else arr[R][C]=data;}function prn_to_aoa_str(f/*:string*/,opts)/*:AOA*/{var o=opts||{};var arr/*:AOA*/=[]/*:any*/;if(!f||f.length===0)return arr;var lines=f.split(/[\r\n]/);var L=lines.length-1;while(L>=0&&lines[L].length===0){--L;}var start=10,idx=0;var R=0;for(;R<=L;++R){idx=lines[R].indexOf(" ");if(idx==-1)idx=lines[R].length;else idx++;start=Math.max(start,idx);}for(R=0;R<=L;++R){arr[R]=[];/* TODO: confirm that widths are always 10 */var C=0;set_text_arr(lines[R].slice(0,start).trim(),arr,R,C,o);for(C=1;C<=(lines[R].length-start)/10+1;++C){set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);}}if(o.sheetRows)arr=arr.slice(0,o.sheetRows);return arr;}// List of accepted CSV separators
var guess_seps={/*::[*/0x2C/*::]*/:',',/*::[*/0x09/*::]*/:"\t",/*::[*/0x3B/*::]*/:';',/*::[*/0x7C/*::]*/:'|'};// CSV separator weights to be used in case of equal numbers
var guess_sep_weights={/*::[*/0x2C/*::]*/:3,/*::[*/0x09/*::]*/:2,/*::[*/0x3B/*::]*/:1,/*::[*/0x7C/*::]*/:0};function guess_sep(str){var cnt={},instr=false,end=0,cc=0;for(;end<str.length;++end){if((cc=str.charCodeAt(end))==0x22)instr=!instr;else if(!instr&&cc in guess_seps)cnt[cc]=(cnt[cc]||0)+1;}cc=[];for(end in cnt){if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}if(!cc.length){cnt=guess_sep_weights;for(end in cnt){if(Object.prototype.hasOwnProperty.call(cnt,end)){cc.push([cnt[end],end]);}}}cc.sort(function(a,b){return a[0]-b[0]||guess_sep_weights[a[1]]-guess_sep_weights[b[1]];});return guess_seps[cc.pop()[1]]||0x2C;}function dsv_to_sheet_str(str/*:string*/,opts)/*:Worksheet*/{var o=opts||{};var sep="";if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ws/*:Worksheet*/=o.dense?[]/*:any*/:{}/*:any*/;var range/*:Range*/={s:{c:0,r:0},e:{c:0,r:0}/*:any*/};if(str.slice(0,4)=="sep="){// If the line ends in \r\n
if(str.charCodeAt(5)==13&&str.charCodeAt(6)==10){sep=str.charAt(4);str=str.slice(7);}// If line ends in \r OR \n
else if(str.charCodeAt(5)==13||str.charCodeAt(5)==10){sep=str.charAt(4);str=str.slice(6);}else sep=guess_sep(str.slice(0,1024));}else if(o&&o.FS)sep=o.FS;else sep=guess_sep(str.slice(0,1024));var R=0,C=0,v=0;var start=0,end=0,sepcc=sep.charCodeAt(0),instr=false,cc=0,startcc=str.charCodeAt(0);str=str.replace(/\r\n/mg,"\n");var _re/*:?RegExp*/=o.dateNF!=null?dateNF_regex(o.dateNF):null;function finish_cell(){var s=str.slice(start,end);var cell={}/*:any*/;if(s.charAt(0)=='"'&&s.charAt(s.length-1)=='"')s=s.slice(1,-1).replace(/""/g,'"');if(s.length===0)cell.t='z';else if(o.raw){cell.t='s';cell.v=s;}else if(s.trim().length===0){cell.t='s';cell.v=s;}else if(s.charCodeAt(0)==0x3D){if(s.charCodeAt(1)==0x22&&s.charCodeAt(s.length-1)==0x22){cell.t='s';cell.v=s.slice(2,-1).replace(/""/g,'"');}else if(fuzzyfmla(s)){cell.t='n';cell.f=s.slice(1);}else{cell.t='s';cell.v=s;}}else if(s=="TRUE"){cell.t='b';cell.v=true;}else if(s=="FALSE"){cell.t='b';cell.v=false;}else if(!isNaN(v=fuzzynum(s))){cell.t='n';if(o.cellText!==false)cell.w=s;cell.v=v;}else if(!isNaN(fuzzydate(s).getDate())||_re&&s.match(_re)){cell.z=o.dateNF||table_fmt[14];var k=0;if(_re&&s.match(_re)){s=dateNF_fix(s,o.dateNF,s.match(_re)||[]);k=1;}if(o.cellDates){cell.t='d';cell.v=parseDate(s,k);}else{cell.t='n';cell.v=datenum(parseDate(s,k));}if(o.cellText!==false)cell.w=SSF_format(cell.z,cell.v instanceof Date?datenum(cell.v):cell.v);if(!o.cellNF)delete cell.z;}else{cell.t='s';cell.v=s;}if(cell.t=='z'){}else if(o.dense){if(!ws[R])ws[R]=[];ws[R][C]=cell;}else ws[encode_cell({c:C,r:R})]=cell;start=end+1;startcc=str.charCodeAt(start);if(range.e.c<C)range.e.c=C;if(range.e.r<R)range.e.r=R;if(cc==sepcc)++C;else{C=0;++R;if(o.sheetRows&&o.sheetRows<=R)return true;}}outer:for(;end<str.length;++end){switch(cc=str.charCodeAt(end)){case 0x22:if(startcc===0x22)instr=!instr;break;case sepcc:case 0x0a:case 0x0d:if(!instr&&finish_cell())break outer;break;default:break;}}if(end-start>0)finish_cell();ws['!ref']=encode_range(range);return ws;}function prn_to_sheet_str(str/*:string*/,opts)/*:Worksheet*/{if(!(opts&&opts.PRN))return dsv_to_sheet_str(str,opts);if(opts.FS)return dsv_to_sheet_str(str,opts);if(str.slice(0,4)=="sep=")return dsv_to_sheet_str(str,opts);if(str.indexOf("\t")>=0||str.indexOf(",")>=0||str.indexOf(";")>=0)return dsv_to_sheet_str(str,opts);return aoa_to_sheet(prn_to_aoa_str(str,opts),opts);}function prn_to_sheet(d/*:RawData*/,opts)/*:Worksheet*/{var str="",bytes=opts.type=='string'?[0,0,0,0]:firstbyte(d,opts);switch(opts.type){case'base64':str=Base64_decode(d);break;case'binary':str=d;break;case'buffer':if(opts.codepage==65001)str=d.toString('utf8');// TODO: test if buf
else if(opts.codepage&&typeof $cptable!=='undefined')str=$cptable.utils.decode(opts.codepage,d);else str=has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d);break;case'array':str=cc2str(d);break;case'string':str=d;break;default:throw new Error("Unrecognized type "+opts.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str.slice(3));else if(opts.type!='string'&&opts.type!='buffer'&&opts.codepage==65001)str=utf8read(str);else if(opts.type=='binary'&&typeof $cptable!=='undefined'&&opts.codepage)str=$cptable.utils.decode(opts.codepage,$cptable.utils.encode(28591,str));if(str.slice(0,19)=="socialcalc:version:")return ETH.to_sheet(opts.type=='string'?str:utf8read(str),opts);return prn_to_sheet_str(str,opts);}function prn_to_workbook(d/*:RawData*/,opts)/*:Workbook*/{return sheet_to_workbook(prn_to_sheet(d,opts),opts);}function sheet_to_prn(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/{var o/*:Array<string>*/=[];var r=safe_decode_range(ws['!ref']),cell/*:Cell*/;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){var oo/*:Array<string>*/=[];for(var C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null){oo.push("          ");continue;}var w=(cell.w||(format_cell(cell),cell.w)||"").slice(0,10);while(w.length<10){w+=" ";}oo.push(w+(C===0?" ":""));}o.push(oo.join(""));}return o.join("\n");}return{to_workbook:prn_to_workbook,to_sheet:prn_to_sheet,from_sheet:sheet_to_prn};}();/* Excel defaults to SYLK but warns if data is not valid */function read_wb_ID(d,opts){var o=opts||{},OLD_WTF=!!o.WTF;o.WTF=true;try{var out=SYLK.to_workbook(d,o);o.WTF=OLD_WTF;return out;}catch(e){o.WTF=OLD_WTF;if(!e.message.match(/SYLK bad record ID/)&&OLD_WTF)throw e;return PRN.to_workbook(d,opts);}}var WK_=/*#__PURE__*/function(){function lotushopper(data,cb/*:RecordHopperCB*/,opts/*:any*/){if(!data)return;prep_blob(data,data.l||0);var Enum=opts.Enum||WK1Enum;while(data.l<data.length){var RT=data.read_shift(2);var R=Enum[RT]||Enum[0xFFFF];var length=data.read_shift(2);var tgt=data.l+length;var d=R.f&&R.f(data,length,opts);data.l=tgt;if(cb(d,R,RT))return;}}function lotus_to_workbook(d/*:RawData*/,opts){switch(opts.type){case'base64':return lotus_to_workbook_buf(s2a(Base64_decode(d)),opts);case'binary':return lotus_to_workbook_buf(s2a(d),opts);case'buffer':case'array':return lotus_to_workbook_buf(d,opts);}throw"Unsupported type "+opts.type;}function lotus_to_workbook_buf(d,opts)/*:Workbook*/{if(!d)return d;var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var s/*:Worksheet*/=o.dense?[]:{},n="Sheet1",next_n="",sidx=0;var sheets={},snames=[],realnames=[];var refguess={s:{r:0,c:0},e:{r:0,c:0}};var sheetRows=o.sheetRows||0;if(d[2]==0x00){if(d[3]==0x08||d[3]==0x09){if(d.length>=16&&d[14]==0x05&&d[15]===0x6c)throw new Error("Unsupported Works 3 for Mac file");}}if(d[2]==0x02){o.Enum=WK1Enum;lotushopper(d,function(val,R,RT){switch(RT){case 0x00:/* BOF */o.vers=val;if(val>=0x1000)o.qpro=true;break;case 0x06:refguess=val;break;/* RANGE */case 0xCC:if(val)next_n=val;break;/* SHEETNAMECS */case 0xDE:next_n=val;break;/* SHEETNAMELP */case 0x0F:/* LABEL */case 0x33:/* STRING */if(!o.qpro)val[1].v=val[1].v.slice(1);/* falls through */case 0x0D:/* INTEGER */case 0x0E:/* NUMBER */case 0x10:/* FORMULA *//* TODO: actual translation of the format code */if(RT==0x0E&&(val[2]&0x70)==0x70&&(val[2]&0x0F)>1&&(val[2]&0x0F)<15){val[1].z=o.dateNF||table_fmt[14];if(o.cellDates){val[1].t='d';val[1].v=numdate(val[1].v);}}if(o.qpro){if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n=next_n||"Sheet"+(sidx+1);next_n="";}}var tmpcell=o.dense?(s[val[0].r]||[])[val[0].c]:s[encode_cell(val[0])];if(tmpcell){tmpcell.t=val[1].t;tmpcell.v=val[1].v;if(val[1].z!=null)tmpcell.z=val[1].z;if(val[1].f!=null)tmpcell.f=val[1].f;break;}if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];break;default:}},o);}else if(d[2]==0x1A||d[2]==0x0E){o.Enum=WK3Enum;if(d[2]==0x0E){o.qpro=true;d.l=0;}lotushopper(d,function(val,R,RT){switch(RT){case 0xCC:n=val;break;/* SHEETNAMECS */case 0x16:/* LABEL16 */val[1].v=val[1].v.slice(1);/* falls through */case 0x17:/* NUMBER17 */case 0x18:/* NUMBER18 */case 0x19:/* FORMULA19 */case 0x25:/* NUMBER25 */case 0x27:/* NUMBER27 */case 0x28:/* FORMULA28 */if(val[3]>sidx){s["!ref"]=encode_range(refguess);sheets[n]=s;snames.push(n);s=o.dense?[]:{};refguess={s:{r:0,c:0},e:{r:0,c:0}};sidx=val[3];n="Sheet"+(sidx+1);}if(sheetRows>0&&val[0].r>=sheetRows)break;if(o.dense){if(!s[val[0].r])s[val[0].r]=[];s[val[0].r][val[0].c]=val[1];}else s[encode_cell(val[0])]=val[1];if(refguess.e.c<val[0].c)refguess.e.c=val[0].c;if(refguess.e.r<val[0].r)refguess.e.r=val[0].r;break;case 0x1B:/* XFORMAT */if(val[0x36b0])realnames[val[0x36b0][0]]=val[0x36b0][1];break;case 0x0601:/* SHEETINFOQP */realnames[val[0]]=val[1];if(val[0]==sidx)n=val[1];break;default:break;}},o);}else throw new Error("Unrecognized LOTUS BOF "+d[2]);s["!ref"]=encode_range(refguess);sheets[next_n||n]=s;snames.push(next_n||n);if(!realnames.length)return{SheetNames:snames,Sheets:sheets};var osheets={},rnames=[];/* TODO: verify no collisions */for(var i=0;i<realnames.length;++i){if(sheets[snames[i]]){rnames.push(realnames[i]||snames[i]);osheets[realnames[i]]=sheets[realnames[i]]||sheets[snames[i]];}else{rnames.push(realnames[i]);osheets[realnames[i]]={"!ref":"A1"};}}return{SheetNames:rnames,Sheets:osheets};}function sheet_to_wk1(ws/*:Worksheet*/,opts/*:WriteOpts*/){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK1 to JS string");var ba=buf_array();var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];write_biff_rec(ba,0x00,write_BOF_WK1(0x0406));write_biff_rec(ba,0x06,write_RANGE(range));var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;/* TODO: formula records */if(cell.t=="n"){if((cell.v|0)==cell.v&&cell.v>=-32768&&cell.v<=32767)write_biff_rec(ba,0x0d,write_INTEGER(R,C,cell.v));else write_biff_rec(ba,0x0e,write_NUMBER(R,C,cell.v));}else{var str=format_cell(cell);write_biff_rec(ba,0x0F,write_LABEL(R,C,str.slice(0,239)));}}}write_biff_rec(ba,0x01);return ba.end();}function book_to_wk3(wb/*:Workbook*/,opts/*:WriteOpts*/){var o=opts||{};if(+o.codepage>=0)set_cp(+o.codepage);if(o.type=="string")throw new Error("Cannot write WK3 to JS string");var ba=buf_array();write_biff_rec(ba,0x00,write_BOF_WK3(wb));for(var i=0,cnt=0;i<wb.SheetNames.length;++i){if((wb.Sheets[wb.SheetNames[i]]||{})["!ref"])write_biff_rec(ba,0x1b,write_XFORMAT_SHEETNAME(wb.SheetNames[i],cnt++));}var wsidx=0;for(i=0;i<wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=safe_decode_range(ws["!ref"]);var dense=Array.isArray(ws);var cols=[];var max_R=Math.min(range.e.r,8191);for(var R=range.s.r;R<=max_R;++R){var rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);var ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell||cell.t=="z")continue;/* TODO: FORMULA19 NUMBER18 records */if(cell.t=="n"){write_biff_rec(ba,0x17,write_NUMBER_17(R,C,wsidx,cell.v));}else{var str=format_cell(cell);/* TODO: max len? */write_biff_rec(ba,0x16,write_LABEL_16(R,C,wsidx,str.slice(0,239)));}}}++wsidx;}write_biff_rec(ba,0x01);return ba.end();}function write_BOF_WK1(v/*:number*/){var out=new_buf(2);out.write_shift(2,v);return out;}function write_BOF_WK3(wb/*:Workbook*/){var out=new_buf(26);out.write_shift(2,0x1000);out.write_shift(2,0x0004);out.write_shift(4,0x0000);var rows=0,cols=0,wscnt=0;for(var i=0;i<wb.SheetNames.length;++i){var name=wb.SheetNames[i];var ws=wb.Sheets[name];if(!ws||!ws["!ref"])continue;++wscnt;var range=decode_range(ws["!ref"]);if(rows<range.e.r)rows=range.e.r;if(cols<range.e.c)cols=range.e.c;}if(rows>8191)rows=8191;out.write_shift(2,rows);out.write_shift(1,wscnt);out.write_shift(1,cols);out.write_shift(2,0x00);out.write_shift(2,0x00);out.write_shift(1,0x01);out.write_shift(1,0x02);out.write_shift(4,0);out.write_shift(4,0);return out;}function parse_RANGE(blob,length,opts){var o={s:{c:0,r:0},e:{c:0,r:0}};if(length==8&&opts.qpro){o.s.c=blob.read_shift(1);blob.l++;o.s.r=blob.read_shift(2);o.e.c=blob.read_shift(1);blob.l++;o.e.r=blob.read_shift(2);return o;}o.s.c=blob.read_shift(2);o.s.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;o.e.c=blob.read_shift(2);o.e.r=blob.read_shift(2);if(length==12&&opts.qpro)blob.l+=2;if(o.s.c==0xFFFF)o.s.c=o.e.c=o.s.r=o.e.r=0;return o;}function write_RANGE(range){var out=new_buf(8);out.write_shift(2,range.s.c);out.write_shift(2,range.s.r);out.write_shift(2,range.e.c);out.write_shift(2,range.e.r);return out;}function parse_cell(blob,length,opts){var o=[{c:0,r:0},{t:'n',v:0},0,0];if(opts.qpro&&opts.vers!=0x5120){o[0].c=blob.read_shift(1);o[3]=blob.read_shift(1);o[0].r=blob.read_shift(2);blob.l+=2;}else{o[2]=blob.read_shift(1);o[0].c=blob.read_shift(2);o[0].r=blob.read_shift(2);}return o;}function parse_LABEL(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);o[1].t='s';if(opts.vers==0x5120){blob.l++;var len=blob.read_shift(1);o[1].v=blob.read_shift(len,'utf8');return o;}if(opts.qpro)blob.l++;o[1].v=blob.read_shift(tgt-blob.l,'cstr');return o;}function write_LABEL(R,C,s){/* TODO: encoding */var o=new_buf(7+s.length);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(1,0x27);// ??
for(var i=0;i<o.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_INTEGER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(2,'i');return o;}function write_INTEGER(R,C,v){var o=new_buf(7);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(2,v,'i');return o;}function parse_NUMBER(blob,length,opts){var o=parse_cell(blob,length,opts);o[1].v=blob.read_shift(8,'f');return o;}function write_NUMBER(R,C,v){var o=new_buf(13);o.write_shift(1,0xFF);o.write_shift(2,C);o.write_shift(2,R);o.write_shift(8,v,'f');return o;}function parse_FORMULA(blob,length,opts){var tgt=blob.l+length;var o=parse_cell(blob,length,opts);/* TODO: formula */o[1].v=blob.read_shift(8,'f');if(opts.qpro)blob.l=tgt;else{var flen=blob.read_shift(2);wk1_fmla_to_csf(blob.slice(blob.l,blob.l+flen),o);blob.l+=flen;}return o;}function wk1_parse_rc(B,V,col){var rel=V&0x8000;V&=~0x8000;V=(rel?B:0)+(V>=0x2000?V-0x4000:V);return(rel?"":"$")+(col?encode_col(V):encode_row(V));}/* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; *//* TODO: flesh out */var FuncTab={0x33:["FALSE",0],0x34:["TRUE",0],0x46:["LEN",1],0x50:["SUM",69],0x51:["AVERAGEA",69],0x52:["COUNTA",69],0x53:["MINA",69],0x54:["MAXA",69],0x6F:["T",1]};var BinOpTab=["","","","","","","","",// eslint-disable-line no-mixed-spaces-and-tabs
"","+","-","*","/","^","=","<>",// eslint-disable-line no-mixed-spaces-and-tabs
"<=",">=","<",">","","","","",// eslint-disable-line no-mixed-spaces-and-tabs
"&","","","","","","",""// eslint-disable-line no-mixed-spaces-and-tabs
];function wk1_fmla_to_csf(blob,o){prep_blob(blob,0);var out=[],argc=0,R="",C="",argL="",argR="";while(blob.l<blob.length){var cc=blob[blob.l++];switch(cc){case 0x00:out.push(blob.read_shift(8,'f'));break;case 0x01:{C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(C+R);}break;case 0x02:{var c=wk1_parse_rc(o[0].c,blob.read_shift(2),true);var r=wk1_parse_rc(o[0].r,blob.read_shift(2),false);C=wk1_parse_rc(o[0].c,blob.read_shift(2),true);R=wk1_parse_rc(o[0].r,blob.read_shift(2),false);out.push(c+r+":"+C+R);}break;case 0x03:if(blob.l<blob.length){console.error("WK1 premature formula end");return;}break;case 0x04:out.push("("+out.pop()+")");break;case 0x05:out.push(blob.read_shift(2));break;case 0x06:{/* TODO: text encoding */var Z="";while(cc=blob[blob.l++]){Z+=String.fromCharCode(cc);}out.push('"'+Z.replace(/"/g,'""')+'"');}break;case 0x08:out.push("-"+out.pop());break;case 0x17:out.push("+"+out.pop());break;case 0x16:out.push("NOT("+out.pop()+")");break;case 0x14:case 0x15:{argR=out.pop();argL=out.pop();out.push(["AND","OR"][cc-0x14]+"("+argL+","+argR+")");}break;default:if(cc<0x20&&BinOpTab[cc]){argR=out.pop();argL=out.pop();out.push(argL+BinOpTab[cc]+argR);}else if(FuncTab[cc]){argc=FuncTab[cc][1];if(argc==69)argc=blob[blob.l++];if(argc>out.length){console.error("WK1 bad formula parse 0x"+cc.toString(16)+":|"+out.join("|")+"|");return;}var args=out.slice(-argc);out.length-=argc;out.push(FuncTab[cc][0]+"("+args.join(",")+")");}else if(cc<=0x07)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x18)return console.error("WK1 unsupported op "+cc.toString(16));else if(cc<=0x1E)return console.error("WK1 invalid opcode "+cc.toString(16));else if(cc<=0x73)return console.error("WK1 unsupported function opcode "+cc.toString(16));// possible future functions ??
else return console.error("WK1 unrecognized opcode "+cc.toString(16));}}if(out.length==1)o[1].f=""+out[0];else console.error("WK1 bad formula parse |"+out.join("|")+"|");}function parse_cell_3(blob/*::, length*/){var o=[{c:0,r:0},{t:'n',v:0},0];o[0].r=blob.read_shift(2);o[3]=blob[blob.l++];o[0].c=blob[blob.l++];return o;}function parse_LABEL_16(blob,length){var o=parse_cell_3(blob,length);o[1].t='s';o[1].v=blob.read_shift(length-4,'cstr');return o;}function write_LABEL_16(R,C,wsidx,s){/* TODO: encoding */var o=new_buf(6+s.length);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);o.write_shift(1,0x27);for(var i=0;i<s.length;++i){var cc=s.charCodeAt(i);o.write_shift(1,cc>=0x80?0x5F:cc);}o.write_shift(1,0);return o;}function parse_NUMBER_18(blob,length){var o=parse_cell_3(blob,length);o[1].v=blob.read_shift(2);var v=o[1].v>>1;if(o[1].v&0x1){switch(v&0x07){case 0:v=(v>>3)*5000;break;case 1:v=(v>>3)*500;break;case 2:v=(v>>3)/20;break;case 3:v=(v>>3)/200;break;case 4:v=(v>>3)/2000;break;case 5:v=(v>>3)/20000;break;case 6:v=(v>>3)/16;break;case 7:v=(v>>3)/64;break;}}o[1].v=v;return o;}function parse_NUMBER_17(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);var v2=blob.read_shift(4);var e=blob.read_shift(2);if(e==0xFFFF){if(v1===0&&v2===0xC0000000){o[1].t="e";o[1].v=0x0F;}// ERR -> #VALUE!
else if(v1===0&&v2===0xD0000000){o[1].t="e";o[1].v=0x2A;}// NA -> #N/A
else o[1].v=0;return o;}var s=e&0x8000;e=(e&0x7FFF)-16446;o[1].v=(1-s*2)*(v2*Math.pow(2,e+32)+v1*Math.pow(2,e));return o;}function write_NUMBER_17(R,C,wsidx,v){var o=new_buf(14);o.write_shift(2,R);o.write_shift(1,wsidx);o.write_shift(1,C);if(v==0){o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,0xFFFF);return o;}var s=0,e=0,v1=0,v2=0;if(v<0){s=1;v=-v;}e=(0,_log2.default)(v)|0;v/=Math.pow(2,e-31);v2=v>>>0;if((v2&0x80000000)==0){v/=2;++e;v2=v>>>0;}v-=v2;v2|=0x80000000;v2>>>=0;v*=Math.pow(2,32);v1=v>>>0;o.write_shift(4,v1);o.write_shift(4,v2);e+=0x3FFF+(s?0x8000:0);o.write_shift(2,e);return o;}function parse_FORMULA_19(blob,length){var o=parse_NUMBER_17(blob,14);blob.l+=length-14;/* TODO: WK3 formula */return o;}function parse_NUMBER_25(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(4);o[1].v=v1>>6;return o;}function parse_NUMBER_27(blob,length){var o=parse_cell_3(blob,length);var v1=blob.read_shift(8,'f');o[1].v=v1;return o;}function parse_FORMULA_28(blob,length){var o=parse_NUMBER_27(blob,14);blob.l+=length-10;/* TODO: formula */return o;}function parse_SHEETNAMECS(blob,length){return blob[blob.l+length-1]==0?blob.read_shift(length,'cstr'):"";}function parse_SHEETNAMELP(blob,length){var len=blob[blob.l++];if(len>length-1)len=length-1;var o="";while(o.length<len){o+=String.fromCharCode(blob[blob.l++]);}return o;}function parse_SHEETINFOQP(blob,length,opts){if(!opts.qpro||length<21)return;var id=blob.read_shift(1);blob.l+=17;blob.l+=1;//var len = blob.read_shift(1);
blob.l+=2;var nm=blob.read_shift(length-21,'cstr');return[id,nm];}function parse_XFORMAT(blob,length){var o={},tgt=blob.l+length;while(blob.l<tgt){var dt=blob.read_shift(2);if(dt==0x36b0){o[dt]=[0,""];o[dt][0]=blob.read_shift(2);while(blob[blob.l]){o[dt][1]+=String.fromCharCode(blob[blob.l]);blob.l++;}blob.l++;}// TODO: 0x3a99 ??
}return o;}function write_XFORMAT_SHEETNAME(name,wsidx){var out=new_buf(5+name.length);out.write_shift(2,0x36b0);out.write_shift(2,wsidx);for(var i=0;i<name.length;++i){var cc=name.charCodeAt(i);out[out.l++]=cc>0x7F?0x5F:cc;}out[out.l++]=0;return out;}var WK1Enum={/*::[*/0x0000/*::]*/:{n:"BOF",f:parseuint16},/*::[*/0x0001/*::]*/:{n:"EOF"},/*::[*/0x0002/*::]*/:{n:"CALCMODE"},/*::[*/0x0003/*::]*/:{n:"CALCORDER"},/*::[*/0x0004/*::]*/:{n:"SPLIT"},/*::[*/0x0005/*::]*/:{n:"SYNC"},/*::[*/0x0006/*::]*/:{n:"RANGE",f:parse_RANGE},/*::[*/0x0007/*::]*/:{n:"WINDOW1"},/*::[*/0x0008/*::]*/:{n:"COLW1"},/*::[*/0x0009/*::]*/:{n:"WINTWO"},/*::[*/0x000A/*::]*/:{n:"COLW2"},/*::[*/0x000B/*::]*/:{n:"NAME"},/*::[*/0x000C/*::]*/:{n:"BLANK"},/*::[*/0x000D/*::]*/:{n:"INTEGER",f:parse_INTEGER},/*::[*/0x000E/*::]*/:{n:"NUMBER",f:parse_NUMBER},/*::[*/0x000F/*::]*/:{n:"LABEL",f:parse_LABEL},/*::[*/0x0010/*::]*/:{n:"FORMULA",f:parse_FORMULA},/*::[*/0x0018/*::]*/:{n:"TABLE"},/*::[*/0x0019/*::]*/:{n:"ORANGE"},/*::[*/0x001A/*::]*/:{n:"PRANGE"},/*::[*/0x001B/*::]*/:{n:"SRANGE"},/*::[*/0x001C/*::]*/:{n:"FRANGE"},/*::[*/0x001D/*::]*/:{n:"KRANGE1"},/*::[*/0x0020/*::]*/:{n:"HRANGE"},/*::[*/0x0023/*::]*/:{n:"KRANGE2"},/*::[*/0x0024/*::]*/:{n:"PROTEC"},/*::[*/0x0025/*::]*/:{n:"FOOTER"},/*::[*/0x0026/*::]*/:{n:"HEADER"},/*::[*/0x0027/*::]*/:{n:"SETUP"},/*::[*/0x0028/*::]*/:{n:"MARGINS"},/*::[*/0x0029/*::]*/:{n:"LABELFMT"},/*::[*/0x002A/*::]*/:{n:"TITLES"},/*::[*/0x002B/*::]*/:{n:"SHEETJS"},/*::[*/0x002D/*::]*/:{n:"GRAPH"},/*::[*/0x002E/*::]*/:{n:"NGRAPH"},/*::[*/0x002F/*::]*/:{n:"CALCCOUNT"},/*::[*/0x0030/*::]*/:{n:"UNFORMATTED"},/*::[*/0x0031/*::]*/:{n:"CURSORW12"},/*::[*/0x0032/*::]*/:{n:"WINDOW"},/*::[*/0x0033/*::]*/:{n:"STRING",f:parse_LABEL},/*::[*/0x0037/*::]*/:{n:"PASSWORD"},/*::[*/0x0038/*::]*/:{n:"LOCKED"},/*::[*/0x003C/*::]*/:{n:"QUERY"},/*::[*/0x003D/*::]*/:{n:"QUERYNAME"},/*::[*/0x003E/*::]*/:{n:"PRINT"},/*::[*/0x003F/*::]*/:{n:"PRINTNAME"},/*::[*/0x0040/*::]*/:{n:"GRAPH2"},/*::[*/0x0041/*::]*/:{n:"GRAPHNAME"},/*::[*/0x0042/*::]*/:{n:"ZOOM"},/*::[*/0x0043/*::]*/:{n:"SYMSPLIT"},/*::[*/0x0044/*::]*/:{n:"NSROWS"},/*::[*/0x0045/*::]*/:{n:"NSCOLS"},/*::[*/0x0046/*::]*/:{n:"RULER"},/*::[*/0x0047/*::]*/:{n:"NNAME"},/*::[*/0x0048/*::]*/:{n:"ACOMM"},/*::[*/0x0049/*::]*/:{n:"AMACRO"},/*::[*/0x004A/*::]*/:{n:"PARSE"},/*::[*/0x0066/*::]*/:{n:"PRANGES??"},/*::[*/0x0067/*::]*/:{n:"RRANGES??"},/*::[*/0x0068/*::]*/:{n:"FNAME??"},/*::[*/0x0069/*::]*/:{n:"MRANGES??"},/*::[*/0x00CC/*::]*/:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},/*::[*/0x00DE/*::]*/:{n:"SHEETNAMELP",f:parse_SHEETNAMELP},/*::[*/0xFFFF/*::]*/:{n:""}};var WK3Enum={/*::[*/0x0000/*::]*/:{n:"BOF"},/*::[*/0x0001/*::]*/:{n:"EOF"},/*::[*/0x0002/*::]*/:{n:"PASSWORD"},/*::[*/0x0003/*::]*/:{n:"CALCSET"},/*::[*/0x0004/*::]*/:{n:"WINDOWSET"},/*::[*/0x0005/*::]*/:{n:"SHEETCELLPTR"},/*::[*/0x0006/*::]*/:{n:"SHEETLAYOUT"},/*::[*/0x0007/*::]*/:{n:"COLUMNWIDTH"},/*::[*/0x0008/*::]*/:{n:"HIDDENCOLUMN"},/*::[*/0x0009/*::]*/:{n:"USERRANGE"},/*::[*/0x000A/*::]*/:{n:"SYSTEMRANGE"},/*::[*/0x000B/*::]*/:{n:"ZEROFORCE"},/*::[*/0x000C/*::]*/:{n:"SORTKEYDIR"},/*::[*/0x000D/*::]*/:{n:"FILESEAL"},/*::[*/0x000E/*::]*/:{n:"DATAFILLNUMS"},/*::[*/0x000F/*::]*/:{n:"PRINTMAIN"},/*::[*/0x0010/*::]*/:{n:"PRINTSTRING"},/*::[*/0x0011/*::]*/:{n:"GRAPHMAIN"},/*::[*/0x0012/*::]*/:{n:"GRAPHSTRING"},/*::[*/0x0013/*::]*/:{n:"??"},/*::[*/0x0014/*::]*/:{n:"ERRCELL"},/*::[*/0x0015/*::]*/:{n:"NACELL"},/*::[*/0x0016/*::]*/:{n:"LABEL16",f:parse_LABEL_16},/*::[*/0x0017/*::]*/:{n:"NUMBER17",f:parse_NUMBER_17},/*::[*/0x0018/*::]*/:{n:"NUMBER18",f:parse_NUMBER_18},/*::[*/0x0019/*::]*/:{n:"FORMULA19",f:parse_FORMULA_19},/*::[*/0x001A/*::]*/:{n:"FORMULA1A"},/*::[*/0x001B/*::]*/:{n:"XFORMAT",f:parse_XFORMAT},/*::[*/0x001C/*::]*/:{n:"DTLABELMISC"},/*::[*/0x001D/*::]*/:{n:"DTLABELCELL"},/*::[*/0x001E/*::]*/:{n:"GRAPHWINDOW"},/*::[*/0x001F/*::]*/:{n:"CPA"},/*::[*/0x0020/*::]*/:{n:"LPLAUTO"},/*::[*/0x0021/*::]*/:{n:"QUERY"},/*::[*/0x0022/*::]*/:{n:"HIDDENSHEET"},/*::[*/0x0023/*::]*/:{n:"??"},/*::[*/0x0025/*::]*/:{n:"NUMBER25",f:parse_NUMBER_25},/*::[*/0x0026/*::]*/:{n:"??"},/*::[*/0x0027/*::]*/:{n:"NUMBER27",f:parse_NUMBER_27},/*::[*/0x0028/*::]*/:{n:"FORMULA28",f:parse_FORMULA_28},/*::[*/0x008E/*::]*/:{n:"??"},/*::[*/0x0093/*::]*/:{n:"??"},/*::[*/0x0096/*::]*/:{n:"??"},/*::[*/0x0097/*::]*/:{n:"??"},/*::[*/0x0098/*::]*/:{n:"??"},/*::[*/0x0099/*::]*/:{n:"??"},/*::[*/0x009A/*::]*/:{n:"??"},/*::[*/0x009B/*::]*/:{n:"??"},/*::[*/0x009C/*::]*/:{n:"??"},/*::[*/0x00A3/*::]*/:{n:"??"},/*::[*/0x00AE/*::]*/:{n:"??"},/*::[*/0x00AF/*::]*/:{n:"??"},/*::[*/0x00B0/*::]*/:{n:"??"},/*::[*/0x00B1/*::]*/:{n:"??"},/*::[*/0x00B8/*::]*/:{n:"??"},/*::[*/0x00B9/*::]*/:{n:"??"},/*::[*/0x00BA/*::]*/:{n:"??"},/*::[*/0x00BB/*::]*/:{n:"??"},/*::[*/0x00BC/*::]*/:{n:"??"},/*::[*/0x00C3/*::]*/:{n:"??"},/*::[*/0x00C9/*::]*/:{n:"??"},/*::[*/0x00CC/*::]*/:{n:"SHEETNAMECS",f:parse_SHEETNAMECS},/*::[*/0x00CD/*::]*/:{n:"??"},/*::[*/0x00CE/*::]*/:{n:"??"},/*::[*/0x00CF/*::]*/:{n:"??"},/*::[*/0x00D0/*::]*/:{n:"??"},/*::[*/0x0100/*::]*/:{n:"??"},/*::[*/0x0103/*::]*/:{n:"??"},/*::[*/0x0104/*::]*/:{n:"??"},/*::[*/0x0105/*::]*/:{n:"??"},/*::[*/0x0106/*::]*/:{n:"??"},/*::[*/0x0107/*::]*/:{n:"??"},/*::[*/0x0109/*::]*/:{n:"??"},/*::[*/0x010A/*::]*/:{n:"??"},/*::[*/0x010B/*::]*/:{n:"??"},/*::[*/0x010C/*::]*/:{n:"??"},/*::[*/0x010E/*::]*/:{n:"??"},/*::[*/0x010F/*::]*/:{n:"??"},/*::[*/0x0180/*::]*/:{n:"??"},/*::[*/0x0185/*::]*/:{n:"??"},/*::[*/0x0186/*::]*/:{n:"??"},/*::[*/0x0189/*::]*/:{n:"??"},/*::[*/0x018C/*::]*/:{n:"??"},/*::[*/0x0200/*::]*/:{n:"??"},/*::[*/0x0202/*::]*/:{n:"??"},/*::[*/0x0201/*::]*/:{n:"??"},/*::[*/0x0204/*::]*/:{n:"??"},/*::[*/0x0205/*::]*/:{n:"??"},/*::[*/0x0280/*::]*/:{n:"??"},/*::[*/0x0281/*::]*/:{n:"??"},/*::[*/0x0282/*::]*/:{n:"??"},/*::[*/0x0283/*::]*/:{n:"??"},/*::[*/0x0284/*::]*/:{n:"??"},/*::[*/0x0285/*::]*/:{n:"??"},/*::[*/0x0286/*::]*/:{n:"??"},/*::[*/0x0287/*::]*/:{n:"??"},/*::[*/0x0288/*::]*/:{n:"??"},/*::[*/0x0292/*::]*/:{n:"??"},/*::[*/0x0293/*::]*/:{n:"??"},/*::[*/0x0294/*::]*/:{n:"??"},/*::[*/0x0295/*::]*/:{n:"??"},/*::[*/0x0296/*::]*/:{n:"??"},/*::[*/0x0299/*::]*/:{n:"??"},/*::[*/0x029A/*::]*/:{n:"??"},/*::[*/0x0300/*::]*/:{n:"??"},/*::[*/0x0304/*::]*/:{n:"??"},/*::[*/0x0601/*::]*/:{n:"SHEETINFOQP",f:parse_SHEETINFOQP},/*::[*/0x0640/*::]*/:{n:"??"},/*::[*/0x0642/*::]*/:{n:"??"},/*::[*/0x0701/*::]*/:{n:"??"},/*::[*/0x0702/*::]*/:{n:"??"},/*::[*/0x0703/*::]*/:{n:"??"},/*::[*/0x0704/*::]*/:{n:"??"},/*::[*/0x0780/*::]*/:{n:"??"},/*::[*/0x0800/*::]*/:{n:"??"},/*::[*/0x0801/*::]*/:{n:"??"},/*::[*/0x0804/*::]*/:{n:"??"},/*::[*/0x0A80/*::]*/:{n:"??"},/*::[*/0x2AF6/*::]*/:{n:"??"},/*::[*/0x3231/*::]*/:{n:"??"},/*::[*/0x6E49/*::]*/:{n:"??"},/*::[*/0x6F44/*::]*/:{n:"??"},/*::[*/0xFFFF/*::]*/:{n:""}};return{sheet_to_wk1:sheet_to_wk1,book_to_wk3:book_to_wk3,to_workbook:lotus_to_workbook};}();/* 18.4.7 rPr CT_RPrElt */function parse_rpr(rpr){var font={},m=rpr.match(tagregex),i=0;var pass=false;if(m)for(;i!=m.length;++i){var y=parsexmltag(m[i]);switch(y[0].replace(/\w*:/g,"")){/* 18.8.12 condense CT_BooleanProperty *//* ** not required . */case'<condense':break;/* 18.8.17 extend CT_BooleanProperty *//* ** not required . */case'<extend':break;/* 18.8.36 shadow CT_BooleanProperty *//* ** not required . */case'<shadow':if(!y.val)break;/* falls through */case'<shadow>':case'<shadow/>':font.shadow=1;break;case'</shadow>':break;/* 18.4.1 charset CT_IntProperty TODO */case'<charset':if(y.val=='1')break;font.cp=CS2CP[parseInt(y.val,10)];break;/* 18.4.2 outline CT_BooleanProperty TODO */case'<outline':if(!y.val)break;/* falls through */case'<outline>':case'<outline/>':font.outline=1;break;case'</outline>':break;/* 18.4.5 rFont CT_FontName */case'<rFont':font.name=y.val;break;/* 18.4.11 sz CT_FontSize */case'<sz':font.sz=y.val;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':if(!y.val)break;/* falls through */case'<strike>':case'<strike/>':font.strike=1;break;case'</strike>':break;/* 18.4.13 u CT_UnderlineProperty */case'<u':if(!y.val)break;switch(y.val){case'double':font.uval="double";break;case'singleAccounting':font.uval="single-accounting";break;case'doubleAccounting':font.uval="double-accounting";break;}/* falls through */case'<u>':case'<u/>':font.u=1;break;case'</u>':break;/* 18.8.2 b */case'<b':if(y.val=='0')break;/* falls through */case'<b>':case'<b/>':font.b=1;break;case'</b>':break;/* 18.8.26 i */case'<i':if(y.val=='0')break;/* falls through */case'<i>':case'<i/>':font.i=1;break;case'</i>':break;/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */case'<color':if(y.rgb)font.color=y.rgb.slice(2,8);break;case'<color>':case'<color/>':case'</color>':break;/* 18.8.18 family ST_FontFamily */case'<family':font.family=y.val;break;case'<family>':case'<family/>':case'</family>':break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */case'<vertAlign':font.valign=y.val;break;case'<vertAlign>':case'<vertAlign/>':case'</vertAlign>':break;/* 18.8.35 scheme CT_FontScheme TODO */case'<scheme':break;case'<scheme>':case'<scheme/>':case'</scheme>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(y[0].charCodeAt(1)!==47&&!pass)throw new Error('Unrecognized rich format '+y[0]);}}return font;}var parse_rs=/*#__PURE__*/function(){var tregex=matchtag("t"),rpregex=matchtag("rPr");/* 18.4.4 r CT_RElt */function parse_r(r){/* 18.4.12 t ST_Xstring */var t=r.match(tregex)/*, cp = 65001*/;if(!t)return{t:"s",v:""};var o/*:Cell*/={t:'s',v:unescapexml(t[1])/*:any*/};var rpr=r.match(rpregex);if(rpr)o.s=parse_rpr(rpr[1]);return o;}var rregex=/<(?:\w+:)?r>/g,rend=/<\/(?:\w+:)?r>/;return function parse_rs(rs){return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r){return r.v;});};}();/* Parse a list of <r> tags */var rs_to_html=/*#__PURE__*/function parse_rs_factory(){var nlregex=/(\r\n|\n)/g;function parse_rpr2(font,intro,outro){var style/*:Array<string>*/=[];if(font.u)style.push("text-decoration: underline;");if(font.uval)style.push("text-underline-style:"+font.uval+";");if(font.sz)style.push("font-size:"+font.sz+"pt;");if(font.outline)style.push("text-effect: outline;");if(font.shadow)style.push("text-shadow: auto;");intro.push('<span style="'+style.join("")+'">');if(font.b){intro.push("<b>");outro.push("</b>");}if(font.i){intro.push("<i>");outro.push("</i>");}if(font.strike){intro.push("<s>");outro.push("</s>");}var align=font.valign||"";if(align=="superscript"||align=="super")align="sup";else if(align=="subscript")align="sub";if(align!=""){intro.push("<"+align+">");outro.push("</"+align+">");}outro.push("</span>");return font;}/* 18.4.4 r CT_RElt */function r_to_html(r){var terms/*:[Array<string>, string, Array<string>]*/=[[],r.v,[]];if(!r.v)return"";if(r.s)parse_rpr2(r.s,terms[0],terms[2]);return terms[0].join("")+terms[1].replace(nlregex,'<br/>')+terms[2].join("");}return function parse_rs(rs){return rs.map(r_to_html).join("");};}();/* 18.4.8 si CT_Rst */var sitregex=/<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,sirregex=/<(?:\w+:)?r>/;var sirphregex=/<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;function parse_si(x,opts){var html=opts?opts.cellHTML:true;var z={};if(!x)return{t:""};//var y;
/* 18.4.12 t ST_Xstring (Plaintext String) */// TODO: is whitespace actually valid here?
if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)){z.t=unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));z.r=utf8read(x);if(html)z.h=escapehtml(z.t);}/* 18.4.4 r CT_RElt (Rich Text Run) */else if(/*y = */x.match(sirregex)){z.r=utf8read(x);z.t=unescapexml(utf8read((x.replace(sirphregex,'').match(sitregex)||[]).join("").replace(tagregex,"")));if(html)z.h=rs_to_html(parse_rs(z.r));}/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) *//* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */return z;}/* 18.4 Shared String Table */var sstr0=/<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;var sstr1=/<(?:\w+:)?(?:si|sstItem)>/g;var sstr2=/<\/(?:\w+:)?(?:si|sstItem)>/;function parse_sst_xml(data/*:string*/,opts)/*:SST*/{var s/*:SST*/=[]/*:any*/,ss="";if(!data)return s;/* 18.4.9 sst CT_Sst */var sst=data.match(sstr0);if(sst){ss=sst[2].replace(sstr1,"").split(sstr2);for(var i=0;i!=ss.length;++i){var o=parse_si(ss[i].trim(),opts);if(o!=null)s[s.length]=o;}sst=parsexmltag(sst[1]);s.Count=sst.count;s.Unique=sst.uniqueCount;}return s;}var straywsregex=/^\s|\s$|[\t\n\r]/;function write_sst_xml(sst/*:SST*/,opts)/*:string*/{if(!opts.bookSST)return"";var o=[XML_HEADER];o[o.length]=writextag('sst',null,{xmlns:XMLNS_main[0],count:sst.Count,uniqueCount:sst.Unique});for(var i=0;i!=sst.length;++i){if(sst[i]==null)continue;var s/*:XLString*/=sst[i];var sitag="<si>";if(s.r)sitag+=s.r;else{sitag+="<t";if(!s.t)s.t="";if(s.t.match(straywsregex))sitag+=' xml:space="preserve"';sitag+=">"+escapexml(s.t)+"</t>";}sitag+="</si>";o[o.length]=sitag;}if(o.length>2){o[o.length]='</sst>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.221 BrtBeginSst */function parse_BrtBeginSst(data){return[data.read_shift(4),data.read_shift(4)];}/* [MS-XLSB] 2.1.7.45 Shared Strings */function parse_sst_bin(data,opts)/*:SST*/{var s/*:SST*/=[]/*:any*/;var pass=false;recordhopper(data,function hopper_sst(val,R,RT){switch(RT){case 0x009F:/* BrtBeginSst */s.Count=val[0];s.Unique=val[1];break;case 0x0013:/* BrtSSTItem */s.push(val);break;case 0x00A0:/* BrtEndSst */return true;case 0x0023:/* BrtFRTBegin */pass=true;break;case 0x0024:/* BrtFRTEnd */pass=false;break;default:if(R.T){}if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return s;}function write_BrtBeginSst(sst,o){if(!o)o=new_buf(8);o.write_shift(4,sst.Count);o.write_shift(4,sst.Unique);return o;}var write_BrtSSTItem=write_RichStr;function write_sst_bin(sst/*::, opts*/){var ba=buf_array();write_record(ba,0x009F/* BrtBeginSst */,write_BrtBeginSst(sst));for(var i=0;i<sst.length;++i){write_record(ba,0x0013/* BrtSSTItem */,write_BrtSSTItem(sst[i]));}/* FRTSST */write_record(ba,0x00A0/* BrtEndSst */);return ba.end();}function _JS2ANSI(str/*:string*/)/*:Array<number>*/{if(typeof $cptable!=='undefined')return $cptable.utils.encode(current_ansi,str);var o/*:Array<number>*/=[],oo=str.split("");for(var i=0;i<oo.length;++i){o[i]=oo[i].charCodeAt(0);}return o;}/* [MS-OFFCRYPTO] 2.1.4 Version */function parse_CRYPTOVersion(blob,length/*:?number*/){var o/*:any*/={};o.Major=blob.read_shift(2);o.Minor=blob.read_shift(2);/*:: if(length == null) return o; */if(length>=4)blob.l+=length-4;return o;}/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */function parse_DataSpaceVersionInfo(blob){var o={};o.id=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */function parse_DataSpaceMapEntry(blob){var len=blob.read_shift(4);var end=blob.l+len-4;var o={};var cnt=blob.read_shift(4);var comps/*:Array<{t:number, v:string}>*/=[];/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */while(cnt-->0){comps.push({t:blob.read_shift(4),v:blob.read_shift(0,'lpp4')});}o.name=blob.read_shift(0,'lpp4');o.comps=comps;if(blob.l!=end)throw new Error("Bad DataSpaceMapEntry: "+blob.l+" != "+end);return o;}/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */function parse_DataSpaceMap(blob){var o=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0){o.push(parse_DataSpaceMapEntry(blob));}return o;}/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */function parse_DataSpaceDefinition(blob)/*:Array<string>*/{var o/*:Array<string>*/=[];blob.l+=4;// must be 0x8
var cnt=blob.read_shift(4);while(cnt-->0){o.push(blob.read_shift(0,'lpp4'));}return o;}/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */function parse_TransformInfoHeader(blob){var o={};/*var len = */blob.read_shift(4);blob.l+=4;// must be 0x1
o.id=blob.read_shift(0,'lpp4');o.name=blob.read_shift(0,'lpp4');o.R=parse_CRYPTOVersion(blob,4);o.U=parse_CRYPTOVersion(blob,4);o.W=parse_CRYPTOVersion(blob,4);return o;}function parse_Primary(blob){/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */var hdr=parse_TransformInfoHeader(blob);/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */hdr.ename=blob.read_shift(0,'8lpp4');hdr.blksz=blob.read_shift(4);hdr.cmode=blob.read_shift(4);if(blob.read_shift(4)!=0x04)throw new Error("Bad !Primary record");return hdr;}/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */function parse_EncryptionHeader(blob,length/*:number*/){var tgt=blob.l+length;var o={};o.Flags=blob.read_shift(4)&0x3F;blob.l+=4;o.AlgID=blob.read_shift(4);var valid=false;switch(o.AlgID){case 0x660E:case 0x660F:case 0x6610:valid=o.Flags==0x24;break;case 0x6801:valid=o.Flags==0x04;break;case 0:valid=o.Flags==0x10||o.Flags==0x04||o.Flags==0x24;break;default:throw'Unrecognized encryption algorithm: '+o.AlgID;}if(!valid)throw new Error("Encryption Flags/AlgID mismatch");o.AlgIDHash=blob.read_shift(4);o.KeySize=blob.read_shift(4);o.ProviderType=blob.read_shift(4);blob.l+=8;o.CSPName=blob.read_shift(tgt-blob.l>>1,'utf16le');blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */function parse_EncryptionVerifier(blob,length/*:number*/){var o={},tgt=blob.l+length;blob.l+=4;// SaltSize must be 0x10
o.Salt=blob.slice(blob.l,blob.l+16);blob.l+=16;o.Verifier=blob.slice(blob.l,blob.l+16);blob.l+=16;/*var sz = */blob.read_shift(4);o.VerifierHash=blob.slice(blob.l,tgt);blob.l=tgt;return o;}/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */function parse_EncryptionInfo(blob){var vers=parse_CRYPTOVersion(blob);switch(vers.Minor){case 0x02:return[vers.Minor,parse_EncInfoStd(blob,vers)];case 0x03:return[vers.Minor,parse_EncInfoExt(blob,vers)];case 0x04:return[vers.Minor,parse_EncInfoAgl(blob,vers)];}throw new Error("ECMA-376 Encrypted file unrecognized Version: "+vers.Minor);}/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */function parse_EncInfoStd(blob/*::, vers*/){var flags=blob.read_shift(4);if((flags&0x3F)!=0x24)throw new Error("EncryptionInfo mismatch");var sz=blob.read_shift(4);//var tgt = blob.l + sz;
var hdr=parse_EncryptionHeader(blob,sz);var verifier=parse_EncryptionVerifier(blob,blob.length-blob.l);return{t:"Std",h:hdr,v:verifier};}/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */function parse_EncInfoExt()/*::blob, vers*/{throw new Error("File is password-protected: ECMA-376 Extensible");}/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */function parse_EncInfoAgl(blob/*::, vers*/){var KeyData=["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];blob.l+=4;var xml=blob.read_shift(blob.length-blob.l,'utf8');var o={};xml.replace(tagregex,function xml_agile(x){var y/*:any*/=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;case'<encryption':case'</encryption>':break;case'<keyData':KeyData.forEach(function(k){o[k]=y[k];});break;case'<dataIntegrity':o.encryptedHmacKey=y.encryptedHmacKey;o.encryptedHmacValue=y.encryptedHmacValue;break;case'<keyEncryptors>':case'<keyEncryptors':o.encs=[];break;case'</keyEncryptors>':break;case'<keyEncryptor':o.uri=y.uri;break;case'</keyEncryptor>':break;case'<encryptedKey':o.encs.push(y);break;default:throw y[0];}});return o;}/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */function parse_RC4CryptoHeader(blob,length/*:number*/){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);length-=4;if(vers.Minor!=2)throw new Error('unrecognized minor version code: '+vers.Minor);if(vers.Major>4||vers.Major<2)throw new Error('unrecognized major version code: '+vers.Major);o.Flags=blob.read_shift(4);length-=4;var sz=blob.read_shift(4);length-=4;o.EncryptionHeader=parse_EncryptionHeader(blob,sz);length-=sz;o.EncryptionVerifier=parse_EncryptionVerifier(blob,length);return o;}/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */function parse_RC4Header(blob/*::, length*/){var o={};var vers=o.EncryptionVersionInfo=parse_CRYPTOVersion(blob,4);if(vers.Major!=1||vers.Minor!=1)throw'unrecognized version code '+vers.Major+' : '+vers.Minor;o.Salt=blob.read_shift(16);o.EncryptedVerifier=blob.read_shift(16);o.EncryptedVerifierHash=blob.read_shift(16);return o;}/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */function crypto_CreatePasswordVerifier_Method1(Password/*:string*/){var Verifier=0x0000,PasswordArray;var PasswordDecoded=_JS2ANSI(Password);var len=PasswordDecoded.length+1,i,PasswordByte;var Intermediate1,Intermediate2,Intermediate3;PasswordArray=new_raw_buf(len);PasswordArray[0]=PasswordDecoded.length;for(i=1;i!=len;++i){PasswordArray[i]=PasswordDecoded[i-1];}for(i=len-1;i>=0;--i){PasswordByte=PasswordArray[i];Intermediate1=(Verifier&0x4000)===0x0000?0:1;Intermediate2=Verifier<<1&0x7FFF;Intermediate3=Intermediate1|Intermediate2;Verifier=Intermediate3^PasswordByte;}return Verifier^0xCE4B;}/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */var crypto_CreateXorArray_Method1=/*#__PURE__*/function(){var PadArray=[0xBB,0xFF,0xFF,0xBA,0xFF,0xFF,0xB9,0x80,0x00,0xBE,0x0F,0x00,0xBF,0x0F,0x00];var InitialCode=[0xE1F0,0x1D0F,0xCC9C,0x84C0,0x110C,0x0E10,0xF1CE,0x313E,0x1872,0xE139,0xD40F,0x84F9,0x280C,0xA96A,0x4EC3];var XorMatrix=[0xAEFC,0x4DD9,0x9BB2,0x2745,0x4E8A,0x9D14,0x2A09,0x7B61,0xF6C2,0xFDA5,0xEB6B,0xC6F7,0x9DCF,0x2BBF,0x4563,0x8AC6,0x05AD,0x0B5A,0x16B4,0x2D68,0x5AD0,0x0375,0x06EA,0x0DD4,0x1BA8,0x3750,0x6EA0,0xDD40,0xD849,0xA0B3,0x5147,0xA28E,0x553D,0xAA7A,0x44D5,0x6F45,0xDE8A,0xAD35,0x4A4B,0x9496,0x390D,0x721A,0xEB23,0xC667,0x9CEF,0x29FF,0x53FE,0xA7FC,0x5FD9,0x47D3,0x8FA6,0x0F6D,0x1EDA,0x3DB4,0x7B68,0xF6D0,0xB861,0x60E3,0xC1C6,0x93AD,0x377B,0x6EF6,0xDDEC,0x45A0,0x8B40,0x06A1,0x0D42,0x1A84,0x3508,0x6A10,0xAA51,0x4483,0x8906,0x022D,0x045A,0x08B4,0x1168,0x76B4,0xED68,0xCAF1,0x85C3,0x1BA7,0x374E,0x6E9C,0x3730,0x6E60,0xDCC0,0xA9A1,0x4363,0x86C6,0x1DAD,0x3331,0x6662,0xCCC4,0x89A9,0x0373,0x06E6,0x0DCC,0x1021,0x2042,0x4084,0x8108,0x1231,0x2462,0x48C4];var Ror=function Ror(Byte){return(Byte/2|Byte*128)&0xFF;};var XorRor=function XorRor(byte1,byte2){return Ror(byte1^byte2);};var CreateXorKey_Method1=function CreateXorKey_Method1(Password){var XorKey=InitialCode[Password.length-1];var CurrentElement=0x68;for(var i=Password.length-1;i>=0;--i){var Char=Password[i];for(var j=0;j!=7;++j){if(Char&0x40)XorKey^=XorMatrix[CurrentElement];Char*=2;--CurrentElement;}}return XorKey;};return function(password/*:string*/){var Password=_JS2ANSI(password);var XorKey=CreateXorKey_Method1(Password);var Index=Password.length;var ObfuscationArray=new_raw_buf(16);for(var i=0;i!=16;++i){ObfuscationArray[i]=0x00;}var Temp,PasswordLastChar,PadIndex;if((Index&1)===1){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[0],Temp);--Index;Temp=XorKey&0xFF;PasswordLastChar=Password[Password.length-1];ObfuscationArray[Index]=XorRor(PasswordLastChar,Temp);}while(Index>0){--Index;Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);}Index=15;PadIndex=15-Password.length;while(PadIndex>0){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[PadIndex],Temp);--Index;--PadIndex;Temp=XorKey&0xFF;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;--PadIndex;}return ObfuscationArray;};}();/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */var crypto_DecryptData_Method1=function crypto_DecryptData_Method1(password/*:string*/,Data,XorArrayIndex,XorArray,O){/* If XorArray is set, use it; if O is not set, make changes in-place */if(!O)O=Data;if(!XorArray)XorArray=crypto_CreateXorArray_Method1(password);var Index,Value;for(Index=0;Index!=Data.length;++Index){Value=Data[Index];Value^=XorArray[XorArrayIndex];Value=(Value>>5|Value<<3)&0xFF;O[Index]=Value;++XorArrayIndex;}return[O,XorArrayIndex,XorArray];};var crypto_MakeXorDecryptor=function crypto_MakeXorDecryptor(password/*:string*/){var XorArrayIndex=0,XorArray=crypto_CreateXorArray_Method1(password);return function(Data){var O=crypto_DecryptData_Method1("",Data,XorArrayIndex,XorArray);XorArrayIndex=O[1];return O[0];};};/* 2.5.343 */function parse_XORObfuscation(blob,length,opts,out){var o={key:parseuint16(blob),verificationBytes:parseuint16(blob)/*:any*/};if(opts.password)o.verifier=crypto_CreatePasswordVerifier_Method1(opts.password);out.valid=o.verificationBytes===o.verifier;if(out.valid)out.insitu=crypto_MakeXorDecryptor(opts.password);return o;}/* 2.4.117 */function parse_FilePassHeader(blob,length/*:number*/,oo){var o=oo||{};o.Info=blob.read_shift(2);blob.l-=2;if(o.Info===1)o.Data=parse_RC4Header(blob,length);else o.Data=parse_RC4CryptoHeader(blob,length);return o;}function parse_FilePass(blob,length/*:number*/,opts){var o={Type:opts.biff>=8?blob.read_shift(2):0/*:any*/};/* wEncryptionType */if(o.Type)parse_FilePassHeader(blob,length-2,o);else parse_XORObfuscation(blob,opts.biff>=8?length:length-2,opts,o);return o;}var RTF=/*#__PURE__*/function(){function rtf_to_sheet(d/*:RawData*/,opts)/*:Worksheet*/{switch(opts.type){case'base64':return rtf_to_sheet_str(Base64_decode(d),opts);case'binary':return rtf_to_sheet_str(d,opts);case'buffer':return rtf_to_sheet_str(has_buf&&Buffer.isBuffer(d)?d.toString('binary'):a2s(d),opts);case'array':return rtf_to_sheet_str(cc2str(d),opts);}throw new Error("Unrecognized type "+opts.type);}/* TODO: this is a stub */function rtf_to_sheet_str(str/*:string*/,opts)/*:Worksheet*/{var o=opts||{};var ws/*:Worksheet*/=o.dense?[]/*:any*/:{}/*:any*/;var rows=str.match(/\\trowd.*?\\row\b/g);if(!rows.length)throw new Error("RTF missing table");var range/*:Range*/={s:{c:0,r:0},e:{c:0,r:rows.length-1}/*:any*/};rows.forEach(function(rowtf,R){if(Array.isArray(ws))ws[R]=[];var rtfre=/\\\w+\b/g;var last_index=0;var res;var C=-1;while(res=rtfre.exec(rowtf)){switch(res[0]){case"\\cell":var data=rowtf.slice(last_index,rtfre.lastIndex-res[0].length);if(data[0]==" ")data=data.slice(1);++C;if(data.length){// TODO: value parsing, including codepage adjustments
var cell={v:data,t:"s"};if(Array.isArray(ws))ws[R][C]=cell;else ws[encode_cell({r:R,c:C})]=cell;}break;}last_index=rtfre.lastIndex;}if(C>range.e.c)range.e.c=C;});ws['!ref']=encode_range(range);return ws;}function rtf_to_workbook(d/*:RawData*/,opts)/*:Workbook*/{return sheet_to_workbook(rtf_to_sheet(d,opts),opts);}/* TODO: this is a stub */function sheet_to_rtf(ws/*:Worksheet*//*::, opts*/)/*:string*/{var o=["{\\rtf1\\ansi"];var r=safe_decode_range(ws['!ref']),cell/*:Cell*/;var dense=Array.isArray(ws);for(var R=r.s.r;R<=r.e.r;++R){o.push("\\trowd\\trautofit1");for(var C=r.s.c;C<=r.e.c;++C){o.push("\\cellx"+(C+1));}o.push("\\pard\\intbl");for(C=r.s.c;C<=r.e.c;++C){var coord=encode_cell({r:R,c:C});cell=dense?(ws[R]||[])[C]:ws[coord];if(!cell||cell.v==null&&(!cell.f||cell.F))continue;o.push(" "+(cell.w||(format_cell(cell),cell.w)));o.push("\\cell");}o.push("\\pard\\intbl\\row");}return o.join("")+"}";}return{to_workbook:rtf_to_workbook,to_sheet:rtf_to_sheet,from_sheet:sheet_to_rtf};}();function hex2RGB(h){var o=h.slice(h[0]==="#"?1:0).slice(0,6);return[parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];}function rgb2Hex(rgb){for(var i=0,o=1;i!=3;++i){o=o*256+(rgb[i]>255?255:rgb[i]<0?0:rgb[i]);}return o.toString(16).toUpperCase().slice(1);}function rgb2HSL(rgb){var R=rgb[0]/255,G=rgb[1]/255,B=rgb[2]/255;var M=Math.max(R,G,B),m=Math.min(R,G,B),C=M-m;if(C===0)return[0,0,R];var H6=0,S=0,L2=M+m;S=C/(L2>1?2-L2:L2);switch(M){case R:H6=((G-B)/C+6)%6;break;case G:H6=(B-R)/C+2;break;case B:H6=(R-G)/C+4;break;}return[H6/6,S,L2/2];}function hsl2RGB(hsl){var H=hsl[0],S=hsl[1],L=hsl[2];var C=S*2*(L<0.5?L:1-L),m=L-C/2;var rgb=[m,m,m],h6=6*H;var X;if(S!==0)switch(h6|0){case 0:case 6:X=C*h6;rgb[0]+=C;rgb[1]+=X;break;case 1:X=C*(2-h6);rgb[0]+=X;rgb[1]+=C;break;case 2:X=C*(h6-2);rgb[1]+=C;rgb[2]+=X;break;case 3:X=C*(4-h6);rgb[1]+=X;rgb[2]+=C;break;case 4:X=C*(h6-4);rgb[2]+=C;rgb[0]+=X;break;case 5:X=C*(6-h6);rgb[2]+=X;rgb[0]+=C;break;}for(var i=0;i!=3;++i){rgb[i]=Math.round(rgb[i]*255);}return rgb;}/* 18.8.3 bgColor tint algorithm */function rgb_tint(hex,tint){if(tint===0)return hex;var hsl=rgb2HSL(hex2RGB(hex));if(tint<0)hsl[2]=hsl[2]*(1+tint);else hsl[2]=1-(1-hsl[2])*(1-tint);return rgb2Hex(hsl2RGB(hsl));}/* 18.3.1.13 width calculations *//* [MS-OI29500] 2.1.595 Column Width & Formatting */var DEF_MDW=6,MAX_MDW=15,MIN_MDW=1,MDW=DEF_MDW;function width2px(width){return Math.floor((width+Math.round(128/MDW)/256)*MDW);}function px2char(px){return Math.floor((px-5)/MDW*100+0.5)/100;}function char2width(chr){return Math.round((chr*MDW+5)/MDW*256)/256;}//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw){return char2width(px2char(width2px(collw)));}/* XLSX/XLSB/XLS specify width in units of MDW */function find_mdw_colw(collw){var delta=Math.abs(collw-cycle_width(collw)),_MDW=MDW;if(delta>0.005)for(MDW=MIN_MDW;MDW<MAX_MDW;++MDW){if(Math.abs(collw-cycle_width(collw))<=delta){delta=Math.abs(collw-cycle_width(collw));_MDW=MDW;}}MDW=_MDW;}/* XLML specifies width in terms of pixels *//*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/function process_col(coll/*:ColInfo*/){if(coll.width){coll.wpx=width2px(coll.width);coll.wch=px2char(coll.wpx);coll.MDW=MDW;}else if(coll.wpx){coll.wch=px2char(coll.wpx);coll.width=char2width(coll.wch);coll.MDW=MDW;}else if(typeof coll.wch=='number'){coll.width=char2width(coll.wch);coll.wpx=width2px(coll.width);coll.MDW=MDW;}if(coll.customWidth)delete coll.customWidth;}var DEF_PPI=96,PPI=DEF_PPI;function px2pt(px){return px*96/PPI;}function pt2px(pt){return pt*PPI/96;}/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */var XLMLPatternTypeMap={"None":"none","Solid":"solid","Gray50":"mediumGray","Gray75":"darkGray","Gray25":"lightGray","HorzStripe":"darkHorizontal","VertStripe":"darkVertical","ReverseDiagStripe":"darkDown","DiagStripe":"darkUp","DiagCross":"darkGrid","ThickDiagCross":"darkTrellis","ThinHorzStripe":"lightHorizontal","ThinVertStripe":"lightVertical","ThinReverseDiagStripe":"lightDown","ThinHorzCross":"lightGrid"};/* 18.8.5 borders CT_Borders */function parse_borders(t,styles,themes,opts){styles.Borders=[];var border={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<borders':case'<borders>':case'</borders>':break;/* 18.8.4 border CT_Border */case'<border':case'<border>':case'<border/>':border=/*::(*/{}/*:: :any)*/;if(y.diagonalUp)border.diagonalUp=parsexmlbool(y.diagonalUp);if(y.diagonalDown)border.diagonalDown=parsexmlbool(y.diagonalDown);styles.Borders.push(border);break;case'</border>':break;/* note: not in spec, appears to be CT_BorderPr */case'<left/>':break;case'<left':case'<left>':break;case'</left>':break;/* note: not in spec, appears to be CT_BorderPr */case'<right/>':break;case'<right':case'<right>':break;case'</right>':break;/* 18.8.43 top CT_BorderPr */case'<top/>':break;case'<top':case'<top>':break;case'</top>':break;/* 18.8.6 bottom CT_BorderPr */case'<bottom/>':break;case'<bottom':case'<bottom>':break;case'</bottom>':break;/* 18.8.13 diagonal CT_BorderPr */case'<diagonal':case'<diagonal>':case'<diagonal/>':break;case'</diagonal>':break;/* 18.8.25 horizontal CT_BorderPr */case'<horizontal':case'<horizontal>':case'<horizontal/>':break;case'</horizontal>':break;/* 18.8.44 vertical CT_BorderPr */case'<vertical':case'<vertical>':case'<vertical/>':break;case'</vertical>':break;/* 18.8.37 start CT_BorderPr */case'<start':case'<start>':case'<start/>':break;case'</start>':break;/* 18.8.16 end CT_BorderPr */case'<end':case'<end>':case'<end/>':break;case'</end>':break;/* 18.8.? color CT_Color */case'<color':case'<color>':break;case'<color/>':case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in borders');}}});}/* 18.8.21 fills CT_Fills */function parse_fills(t,styles,themes,opts){styles.Fills=[];var fill={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fills':case'<fills>':case'</fills>':break;/* 18.8.20 fill CT_Fill */case'<fill>':case'<fill':case'<fill/>':fill={};styles.Fills.push(fill);break;case'</fill>':break;/* 18.8.24 gradientFill CT_GradientFill */case'<gradientFill>':break;case'<gradientFill':case'</gradientFill>':styles.Fills.push(fill);fill={};break;/* 18.8.32 patternFill CT_PatternFill */case'<patternFill':case'<patternFill>':if(y.patternType)fill.patternType=y.patternType;break;case'<patternFill/>':case'</patternFill>':break;/* 18.8.3 bgColor CT_Color */case'<bgColor':if(!fill.bgColor)fill.bgColor={};if(y.indexed)fill.bgColor.indexed=parseInt(y.indexed,10);if(y.theme)fill.bgColor.theme=parseInt(y.theme,10);if(y.tint)fill.bgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb)fill.bgColor.rgb=y.rgb.slice(-6);break;case'<bgColor/>':case'</bgColor>':break;/* 18.8.19 fgColor CT_Color */case'<fgColor':if(!fill.fgColor)fill.fgColor={};if(y.theme)fill.fgColor.theme=parseInt(y.theme,10);if(y.tint)fill.fgColor.tint=parseFloat(y.tint);/* Excel uses ARGB strings */if(y.rgb!=null)fill.fgColor.rgb=y.rgb.slice(-6);break;case'<fgColor/>':case'</fgColor>':break;/* 18.8.38 stop CT_GradientStop */case'<stop':case'<stop/>':break;case'</stop>':break;/* 18.8.? color CT_Color */case'<color':case'<color/>':break;case'</color>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fills');}}});}/* 18.8.23 fonts CT_Fonts */function parse_fonts(t,styles,themes,opts){styles.Fonts=[];var font={};var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case'<fonts':case'<fonts>':case'</fonts>':break;/* 18.8.22 font CT_Font */case'<font':case'<font>':break;case'</font>':case'<font/>':styles.Fonts.push(font);font={};break;/* 18.8.29 name CT_FontName */case'<name':if(y.val)font.name=utf8read(y.val);break;case'<name/>':case'</name>':break;/* 18.8.2  b CT_BooleanProperty */case'<b':font.bold=y.val?parsexmlbool(y.val):1;break;case'<b/>':font.bold=1;break;/* 18.8.26 i CT_BooleanProperty */case'<i':font.italic=y.val?parsexmlbool(y.val):1;break;case'<i/>':font.italic=1;break;/* 18.4.13 u CT_UnderlineProperty */case'<u':switch(y.val){case"none":font.underline=0x00;break;case"single":font.underline=0x01;break;case"double":font.underline=0x02;break;case"singleAccounting":font.underline=0x21;break;case"doubleAccounting":font.underline=0x22;break;}break;case'<u/>':font.underline=1;break;/* 18.4.10 strike CT_BooleanProperty */case'<strike':font.strike=y.val?parsexmlbool(y.val):1;break;case'<strike/>':font.strike=1;break;/* 18.4.2  outline CT_BooleanProperty */case'<outline':font.outline=y.val?parsexmlbool(y.val):1;break;case'<outline/>':font.outline=1;break;/* 18.8.36 shadow CT_BooleanProperty */case'<shadow':font.shadow=y.val?parsexmlbool(y.val):1;break;case'<shadow/>':font.shadow=1;break;/* 18.8.12 condense CT_BooleanProperty */case'<condense':font.condense=y.val?parsexmlbool(y.val):1;break;case'<condense/>':font.condense=1;break;/* 18.8.17 extend CT_BooleanProperty */case'<extend':font.extend=y.val?parsexmlbool(y.val):1;break;case'<extend/>':font.extend=1;break;/* 18.4.11 sz CT_FontSize */case'<sz':if(y.val)font.sz=+y.val;break;case'<sz/>':case'</sz>':break;/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */case'<vertAlign':if(y.val)font.vertAlign=y.val;break;case'<vertAlign/>':case'</vertAlign>':break;/* 18.8.18 family CT_FontFamily */case'<family':if(y.val)font.family=parseInt(y.val,10);break;case'<family/>':case'</family>':break;/* 18.8.35 scheme CT_FontScheme */case'<scheme':if(y.val)font.scheme=y.val;break;case'<scheme/>':case'</scheme>':break;/* 18.4.1 charset CT_IntProperty */case'<charset':if(y.val=='1')break;y.codepage=CS2CP[parseInt(y.val,10)];break;/* 18.?.? color CT_Color */case'<color':if(!font.color)font.color={};if(y.auto)font.color.auto=parsexmlbool(y.auto);if(y.rgb)font.color.rgb=y.rgb.slice(-6);else if(y.indexed){font.color.index=parseInt(y.indexed,10);var icv=XLSIcv[font.color.index];if(font.color.index==81)icv=XLSIcv[1];if(!icv)icv=XLSIcv[1];//throw new Error(x); // note: 206 is valid
font.color.rgb=icv[0].toString(16)+icv[1].toString(16)+icv[2].toString(16);}else if(y.theme){font.color.theme=parseInt(y.theme,10);if(y.tint)font.color.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){font.color.rgb=rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb,font.color.tint||0);}}break;case'<color/>':case'</color>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in fonts');}}});}/* 18.8.31 numFmts CT_NumFmts */function parse_numFmts(t,styles,opts){styles.NumberFmt=[];var k/*Array<number>*/=keys(table_fmt)/*:any*/;for(var i=0;i<k.length;++i){styles.NumberFmt[k[i]]=table_fmt[k[i]];}var m=t[0].match(tagregex);if(!m)return;for(i=0;i<m.length;++i){var y=parsexmltag(m[i]);switch(strip_ns(y[0])){case'<numFmts':case'</numFmts>':case'<numFmts/>':case'<numFmts>':break;case'<numFmt':{var f=unescapexml(utf8read(y.formatCode)),j=parseInt(y.numFmtId,10);styles.NumberFmt[j]=f;if(j>0){if(j>0x188){for(j=0x188;j>0x3c;--j){if(styles.NumberFmt[j]==null)break;}styles.NumberFmt[j]=f;}SSF_load(f,j);}}break;case'</numFmt>':break;default:if(opts.WTF)throw new Error('unrecognized '+y[0]+' in numFmts');}}}function write_numFmts(NF/*:{[n:number|string]:string}*//*::, opts*/){var o=["<numFmts>"];[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)o[o.length]=writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])});}});if(o.length===1)return"";o[o.length]="</numFmts>";o[0]=writextag('numFmts',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8.10 cellXfs CT_CellXfs */var cellXF_uint=["numFmtId","fillId","fontId","borderId","xfId"];var cellXF_bool=["applyAlignment","applyBorder","applyFill","applyFont","applyNumberFormat","applyProtection","pivotButton","quotePrefix"];function parse_cellXfs(t,styles,opts){styles.CellXf=[];var xf;var pass=false;(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x),i=0;switch(strip_ns(y[0])){case'<cellXfs':case'<cellXfs>':case'<cellXfs/>':case'</cellXfs>':break;/* 18.8.45 xf CT_Xf */case'<xf':case'<xf/>':xf=y;delete xf[0];for(i=0;i<cellXF_uint.length;++i){if(xf[cellXF_uint[i]])xf[cellXF_uint[i]]=parseInt(xf[cellXF_uint[i]],10);}for(i=0;i<cellXF_bool.length;++i){if(xf[cellXF_bool[i]])xf[cellXF_bool[i]]=parsexmlbool(xf[cellXF_bool[i]]);}if(styles.NumberFmt&&xf.numFmtId>0x188){for(i=0x188;i>0x3c;--i){if(styles.NumberFmt[xf.numFmtId]==styles.NumberFmt[i]){xf.numFmtId=i;break;}}}styles.CellXf.push(xf);break;case'</xf>':break;/* 18.8.1 alignment CT_CellAlignment */case'<alignment':case'<alignment/>':var alignment={};if(y.vertical)alignment.vertical=y.vertical;if(y.horizontal)alignment.horizontal=y.horizontal;if(y.textRotation!=null)alignment.textRotation=y.textRotation;if(y.indent)alignment.indent=y.indent;if(y.wrapText)alignment.wrapText=parsexmlbool(y.wrapText);xf.alignment=alignment;break;case'</alignment>':break;/* 18.8.33 protection CT_CellProtection */case'<protection':break;case'</protection>':case'<protection/>':break;/* note: sometimes mc:AlternateContent appears bare */case'<AlternateContent':pass=true;break;case'</AlternateContent>':pass=false;break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':break;case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(opts&&opts.WTF){if(!pass)throw new Error('unrecognized '+y[0]+' in cellXfs');}}});}function write_cellXfs(cellXfs)/*:string*/{var o/*:Array<string>*/=[];o[o.length]=writextag('cellXfs',null);cellXfs.forEach(function(c){o[o.length]=writextag('xf',null,c);});o[o.length]="</cellXfs>";if(o.length===2)return"";o[0]=writextag('cellXfs',null,{count:o.length-2}).replace("/>",">");return o.join("");}/* 18.8 Styles CT_Stylesheet*/var parse_sty_xml=/*#__PURE__*/function make_pstyx(){var numFmtRegex=/<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;var cellXfRegex=/<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;var fillsRegex=/<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;var fontsRegex=/<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;var bordersRegex=/<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;return function parse_sty_xml(data,themes,opts){var styles={};if(!data)return styles;data=data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");/* 18.8.39 styleSheet CT_Stylesheet */var t;/* 18.8.31 numFmts CT_NumFmts ? */if(t=data.match(numFmtRegex))parse_numFmts(t,styles,opts);/* 18.8.23 fonts CT_Fonts ? */if(t=data.match(fontsRegex))parse_fonts(t,styles,themes,opts);/* 18.8.21 fills CT_Fills ? */if(t=data.match(fillsRegex))parse_fills(t,styles,themes,opts);/* 18.8.5  borders CT_Borders ? */if(t=data.match(bordersRegex))parse_borders(t,styles,themes,opts);/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? *//* 18.8.8  cellStyles CT_CellStyles ? *//* 18.8.10 cellXfs CT_CellXfs ? */if(t=data.match(cellXfRegex))parse_cellXfs(t,styles,opts);/* 18.8.15 dxfs CT_Dxfs ? *//* 18.8.42 tableStyles CT_TableStyles ? *//* 18.8.11 colors CT_Colors ? *//* 18.2.10 extLst CT_ExtensionList ? */return styles;};}();function write_sty_xml(wb/*:Workbook*/,opts)/*:string*/{var o=[XML_HEADER,writextag('styleSheet',null,{'xmlns':XMLNS_main[0],'xmlns:vt':XMLNS.vt})],w;if(wb.SSF&&(w=write_numFmts(wb.SSF))!=null)o[o.length]=w;o[o.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';o[o.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';o[o.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';o[o.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(w=write_cellXfs(opts.cellXfs))o[o.length]=w;o[o.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';o[o.length]='<dxfs count="0"/>';o[o.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(o.length>2){o[o.length]='</styleSheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.657 BrtFmt */function parse_BrtFmt(data,length/*:number*/){var numFmtId=data.read_shift(2);var stFmtCode=parse_XLWideString(data,length-2);return[numFmtId,stFmtCode];}function write_BrtFmt(i/*:number*/,f/*:string*/,o){if(!o)o=new_buf(6+4*f.length);o.write_shift(2,i);write_XLWideString(f,o);var out=o.length>o.l?o.slice(0,o.l):o;if(o.l==null)o.l=o.length;return out;}/* [MS-XLSB] 2.4.659 BrtFont TODO */function parse_BrtFont(data,length/*:number*/,opts){var out={}/*:any*/;out.sz=data.read_shift(2)/20;var grbit=parse_FontFlags(data,2,opts);if(grbit.fItalic)out.italic=1;if(grbit.fCondense)out.condense=1;if(grbit.fExtend)out.extend=1;if(grbit.fShadow)out.shadow=1;if(grbit.fOutline)out.outline=1;if(grbit.fStrikeout)out.strike=1;var bls=data.read_shift(2);if(bls===0x02BC)out.bold=1;switch(data.read_shift(2)){/* case 0: out.vertAlign = "baseline"; break; */case 1:out.vertAlign="superscript";break;case 2:out.vertAlign="subscript";break;}var underline=data.read_shift(1);if(underline!=0)out.underline=underline;var family=data.read_shift(1);if(family>0)out.family=family;var bCharSet=data.read_shift(1);if(bCharSet>0)out.charset=bCharSet;data.l++;out.color=parse_BrtColor(data,8);switch(data.read_shift(1)){/* case 0: out.scheme = "none": break; */case 1:out.scheme="major";break;case 2:out.scheme="minor";break;}out.name=parse_XLWideString(data,length-21);return out;}function write_BrtFont(font/*:any*/,o){if(!o)o=new_buf(25+4*32);o.write_shift(2,font.sz*20);write_FontFlags(font,o);o.write_shift(2,font.bold?0x02BC:0x0190);var sss=0;if(font.vertAlign=="superscript")sss=1;else if(font.vertAlign=="subscript")sss=2;o.write_shift(2,sss);o.write_shift(1,font.underline||0);o.write_shift(1,font.family||0);o.write_shift(1,font.charset||0);o.write_shift(1,0);write_BrtColor(font.color,o);var scheme=0;if(font.scheme=="major")scheme=1;if(font.scheme=="minor")scheme=2;o.write_shift(1,scheme);write_XLWideString(font.name,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.650 BrtFill */var XLSBFillPTNames=["none","solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];var rev_XLSBFillPTNames/*:EvertNumType*/;/* TODO: gradient fill representation */var parse_BrtFill=parsenoop;function write_BrtFill(fill,o){if(!o)o=new_buf(4*3+8*7+16*1);if(!rev_XLSBFillPTNames)rev_XLSBFillPTNames=evert(XLSBFillPTNames)/*:any*/;var fls/*:number*/=rev_XLSBFillPTNames[fill.patternType];if(fls==null)fls=0x28;o.write_shift(4,fls);var j=0;if(fls!=0x28){/* TODO: custom FG Color */write_BrtColor({auto:1},o);/* TODO: custom BG Color */write_BrtColor({auto:1},o);for(;j<12;++j){o.write_shift(4,0);}}else{for(;j<4;++j){o.write_shift(4,0);}for(;j<12;++j){o.write_shift(4,0);}/* TODO *//* iGradientType *//* xnumDegree *//* xnumFillToLeft *//* xnumFillToRight *//* xnumFillToTop *//* xnumFillToBottom *//* cNumStop *//* xfillGradientStop */}return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.824 BrtXF */function parse_BrtXF(data,length/*:number*/){var tgt=data.l+length;var ixfeParent=data.read_shift(2);var ifmt=data.read_shift(2);data.l=tgt;return{ixfe:ixfeParent,numFmtId:ifmt};}function write_BrtXF(data,ixfeP,o){if(!o)o=new_buf(16);o.write_shift(2,ixfeP||0);o.write_shift(2,data.numFmtId||0);o.write_shift(2,0);/* iFont */o.write_shift(2,0);/* iFill */o.write_shift(2,0);/* ixBorder */o.write_shift(1,0);/* trot */o.write_shift(1,0);/* indent */var flow=0;o.write_shift(1,flow);/* flags */o.write_shift(1,0);/* flags */o.write_shift(1,0);/* xfGrbitAtr */o.write_shift(1,0);return o;}/* [MS-XLSB] 2.5.4 Blxf TODO */function write_Blxf(data,o){if(!o)o=new_buf(10);o.write_shift(1,0);/* dg */o.write_shift(1,0);o.write_shift(4,0);/* color */o.write_shift(4,0);/* color */return o;}/* [MS-XLSB] 2.4.302 BrtBorder TODO */var parse_BrtBorder=parsenoop;function write_BrtBorder(border,o){if(!o)o=new_buf(51);o.write_shift(1,0);/* diagonal */write_Blxf(null,o);/* top */write_Blxf(null,o);/* bottom */write_Blxf(null,o);/* left */write_Blxf(null,o);/* right */write_Blxf(null,o);/* diag */return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.763 BrtStyle TODO */function write_BrtStyle(style,o){if(!o)o=new_buf(12+4*10);o.write_shift(4,style.xfId);o.write_shift(2,1);o.write_shift(1,+style.builtinId);o.write_shift(1,0);/* iLevel */write_XLNullableWideString(style.name||"",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */function write_BrtBeginTableStyles(cnt,defTableStyle,defPivotStyle){var o=new_buf(4+256*2*4);o.write_shift(4,cnt);write_XLNullableWideString(defTableStyle,o);write_XLNullableWideString(defPivotStyle,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.1.7.50 Styles */function parse_sty_bin(data,themes,opts){var styles={};styles.NumberFmt=[]/*:any*/;for(var y in table_fmt){styles.NumberFmt[y]=table_fmt[y];}styles.CellXf=[];styles.Fonts=[];var state/*:Array<string>*/=[];var pass=false;recordhopper(data,function hopper_sty(val,R,RT){switch(RT){case 0x002C:/* BrtFmt */styles.NumberFmt[val[0]]=val[1];SSF_load(val[1],val[0]);break;case 0x002B:/* BrtFont */styles.Fonts.push(val);if(val.color.theme!=null&&themes&&themes.themeElements&&themes.themeElements.clrScheme){val.color.rgb=rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb,val.color.tint||0);}break;case 0x0401:/* BrtKnownFonts */break;case 0x002D:/* BrtFill */break;case 0x002E:/* BrtBorder */break;case 0x002F:/* BrtXF */if(state[state.length-1]==0x0269/* BrtBeginCellXFs */){styles.CellXf.push(val);}break;case 0x0030:/* BrtStyle */case 0x01FB:/* BrtDXF */case 0x023C:/* BrtMRUColor */case 0x01DB:/* BrtIndexedColor */break;case 0x0493:/* BrtDXF14 */case 0x0836:/* BrtDXF15 */case 0x046A:/* BrtSlicerStyleElement */case 0x0200:/* BrtTableStyleElement */case 0x082F:/* BrtTimelineStyleElement */case 0x0C00:/* BrtUid */break;case 0x0023:/* BrtFRTBegin */pass=true;break;case 0x0024:/* BrtFRTEnd */pass=false;break;case 0x0025:/* BrtACBegin */state.push(RT);pass=true;break;case 0x0026:/* BrtACEnd */state.pop();pass=false;break;default:if(R.T>0)state.push(RT);else if(R.T<0)state.pop();else if(!pass||opts.WTF&&state[state.length-1]!=0x0025/* BrtACBegin */)throw new Error("Unexpected record 0x"+RT.toString(16));}});return styles;}function write_FMTS_bin(ba,NF/*:?SSFTable*/){if(!NF)return;var cnt=0;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){/*:: if(!NF) return; */for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)++cnt;}});if(cnt==0)return;write_record(ba,0x0267/* BrtBeginFmts */,write_UInt32LE(cnt));[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){/*:: if(!NF) return; */for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)write_record(ba,0x002C/* BrtFmt */,write_BrtFmt(i,NF[i]));}});write_record(ba,0x0268/* BrtEndFmts */);}function write_FONTS_bin(ba/*::, data*/){var cnt=1;if(cnt==0)return;write_record(ba,0x0263/* BrtBeginFonts */,write_UInt32LE(cnt));write_record(ba,0x002B/* BrtFont */,write_BrtFont({sz:12,color:{theme:1},name:"Calibri",family:2,scheme:"minor"}));/* 1*65491BrtFont [ACFONTS] */write_record(ba,0x0264/* BrtEndFonts */);}function write_FILLS_bin(ba/*::, data*/){var cnt=2;if(cnt==0)return;write_record(ba,0x025B/* BrtBeginFills */,write_UInt32LE(cnt));write_record(ba,0x002D/* BrtFill */,write_BrtFill({patternType:"none"}));write_record(ba,0x002D/* BrtFill */,write_BrtFill({patternType:"gray125"}));/* 1*65431BrtFill */write_record(ba,0x025C/* BrtEndFills */);}function write_BORDERS_bin(ba/*::, data*/){var cnt=1;if(cnt==0)return;write_record(ba,0x0265/* BrtBeginBorders */,write_UInt32LE(cnt));write_record(ba,0x002E/* BrtBorder */,write_BrtBorder({}));/* 1*65430BrtBorder */write_record(ba,0x0266/* BrtEndBorders */);}function write_CELLSTYLEXFS_bin(ba/*::, data*/){var cnt=1;write_record(ba,0x0272/* BrtBeginCellStyleXFs */,write_UInt32LE(cnt));write_record(ba,0x002F/* BrtXF */,write_BrtXF({numFmtId:0,fontId:0,fillId:0,borderId:0},0xFFFF));/* 1*65430(BrtXF *FRT) */write_record(ba,0x0273/* BrtEndCellStyleXFs */);}function write_CELLXFS_bin(ba,data){write_record(ba,0x0269/* BrtBeginCellXFs */,write_UInt32LE(data.length));data.forEach(function(c){write_record(ba,0x002F/* BrtXF */,write_BrtXF(c,0));});/* 1*65430(BrtXF *FRT) */write_record(ba,0x026A/* BrtEndCellXFs */);}function write_STYLES_bin(ba/*::, data*/){var cnt=1;write_record(ba,0x026B/* BrtBeginStyles */,write_UInt32LE(cnt));write_record(ba,0x0030/* BrtStyle */,write_BrtStyle({xfId:0,builtinId:0,name:"Normal"}));/* 1*65430(BrtStyle *FRT) */write_record(ba,0x026C/* BrtEndStyles */);}function write_DXFS_bin(ba/*::, data*/){var cnt=0;write_record(ba,0x01F9/* BrtBeginDXFs */,write_UInt32LE(cnt));/* *2147483647(BrtDXF *FRT) */write_record(ba,0x01FA/* BrtEndDXFs */);}function write_TABLESTYLES_bin(ba/*::, data*/){var cnt=0;write_record(ba,0x01FC/* BrtBeginTableStyles */,write_BrtBeginTableStyles(cnt,"TableStyleMedium9","PivotStyleMedium4"));/* *TABLESTYLE */write_record(ba,0x01FD/* BrtEndTableStyles */);}function write_COLORPALETTE_bin()/*::ba, data*/{return;/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */}/* [MS-XLSB] 2.1.7.50 Styles */function write_sty_bin(wb,opts){var ba=buf_array();write_record(ba,0x0116/* BrtBeginStyleSheet */);write_FMTS_bin(ba,wb.SSF);write_FONTS_bin(ba,wb);write_FILLS_bin(ba,wb);write_BORDERS_bin(ba,wb);write_CELLSTYLEXFS_bin(ba,wb);write_CELLXFS_bin(ba,opts.cellXfs);write_STYLES_bin(ba,wb);write_DXFS_bin(ba,wb);write_TABLESTYLES_bin(ba,wb);write_COLORPALETTE_bin(ba,wb);/* FRTSTYLESHEET*/write_record(ba,0x0117/* BrtEndStyleSheet */);return ba.end();}/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */var XLSXThemeClrScheme=['</a:lt1>','</a:dk1>','</a:lt2>','</a:dk2>','</a:accent1>','</a:accent2>','</a:accent3>','</a:accent4>','</a:accent5>','</a:accent6>','</a:hlink>','</a:folHlink>'];/* 20.1.6.2 clrScheme CT_ColorScheme */function parse_clrScheme(t,themes,opts){themes.themeElements.clrScheme=[];var color={};(t[0].match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */case'<a:clrScheme':case'</a:clrScheme>':break;/* 20.1.2.3.32 srgbClr CT_SRgbColor */case'<a:srgbClr':color.rgb=y.val;break;/* 20.1.2.3.33 sysClr CT_SystemColor */case'<a:sysClr':color.rgb=y.lastClr;break;/* 20.1.4.1.1 accent1 (Accent 1) *//* 20.1.4.1.2 accent2 (Accent 2) *//* 20.1.4.1.3 accent3 (Accent 3) *//* 20.1.4.1.4 accent4 (Accent 4) *//* 20.1.4.1.5 accent5 (Accent 5) *//* 20.1.4.1.6 accent6 (Accent 6) *//* 20.1.4.1.9 dk1 (Dark 1) *//* 20.1.4.1.10 dk2 (Dark 2) *//* 20.1.4.1.15 folHlink (Followed Hyperlink) *//* 20.1.4.1.19 hlink (Hyperlink) *//* 20.1.4.1.22 lt1 (Light 1) *//* 20.1.4.1.23 lt2 (Light 2) */case'<a:dk1>':case'</a:dk1>':case'<a:lt1>':case'</a:lt1>':case'<a:dk2>':case'</a:dk2>':case'<a:lt2>':case'</a:lt2>':case'<a:accent1>':case'</a:accent1>':case'<a:accent2>':case'</a:accent2>':case'<a:accent3>':case'</a:accent3>':case'<a:accent4>':case'</a:accent4>':case'<a:accent5>':case'</a:accent5>':case'<a:accent6>':case'</a:accent6>':case'<a:hlink>':case'</a:hlink>':case'<a:folHlink>':case'</a:folHlink>':if(y[0].charAt(1)==='/'){themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])]=color;color={};}else{color.name=y[0].slice(3,y[0].length-1);}break;default:if(opts&&opts.WTF)throw new Error('Unrecognized '+y[0]+' in clrScheme');}});}/* 20.1.4.1.18 fontScheme CT_FontScheme */function parse_fontScheme()/*::t, themes, opts*/{}/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */function parse_fmtScheme()/*::t, themes, opts*/{}var clrsregex=/<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;var fntsregex=/<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;var fmtsregex=/<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;/* 20.1.6.10 themeElements CT_BaseStyles */function parse_themeElements(data,themes,opts){themes.themeElements={};var t;[/* clrScheme CT_ColorScheme */['clrScheme',clrsregex,parse_clrScheme],/* fontScheme CT_FontScheme */['fontScheme',fntsregex,parse_fontScheme],/* fmtScheme CT_StyleMatrix */['fmtScheme',fmtsregex,parse_fmtScheme]].forEach(function(m){if(!(t=data.match(m[1])))throw new Error(m[0]+' not found in themeElements');m[2](t,themes,opts);});}var themeltregex=/<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;/* 14.2.7 Theme Part */function parse_theme_xml(data/*:string*/,opts){/* 20.1.6.9 theme CT_OfficeStyleSheet */if(!data||data.length===0)data=write_theme();var t;var themes={};/* themeElements CT_BaseStyles */if(!(t=data.match(themeltregex)))throw new Error('themeElements not found in theme');parse_themeElements(t[0],themes,opts);themes.raw=data;return themes;}function write_theme(Themes,opts)/*:string*/{if(opts&&opts.themeXLSX)return opts.themeXLSX;if(Themes&&typeof Themes.raw=="string")return Themes.raw;var o=[XML_HEADER];o[o.length]='<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';o[o.length]='<a:themeElements>';o[o.length]='<a:clrScheme name="Office">';o[o.length]='<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';o[o.length]='<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';o[o.length]='<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';o[o.length]='<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';o[o.length]='<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';o[o.length]='<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';o[o.length]='<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';o[o.length]='<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';o[o.length]='<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';o[o.length]='<a:accent6><a:srgbClr val="F79646"/></a:accent6>';o[o.length]='<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';o[o.length]='<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';o[o.length]='</a:clrScheme>';o[o.length]='<a:fontScheme name="Office">';o[o.length]='<a:majorFont>';o[o.length]='<a:latin typeface="Cambria"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Times New Roman"/>';o[o.length]='<a:font script="Hebr" typeface="Times New Roman"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="MoolBoran"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Times New Roman"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:majorFont>';o[o.length]='<a:minorFont>';o[o.length]='<a:latin typeface="Calibri"/>';o[o.length]='<a:ea typeface=""/>';o[o.length]='<a:cs typeface=""/>';o[o.length]='<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';o[o.length]='<a:font script="Hang" typeface="맑은 고딕"/>';o[o.length]='<a:font script="Hans" typeface="宋体"/>';o[o.length]='<a:font script="Hant" typeface="新細明體"/>';o[o.length]='<a:font script="Arab" typeface="Arial"/>';o[o.length]='<a:font script="Hebr" typeface="Arial"/>';o[o.length]='<a:font script="Thai" typeface="Tahoma"/>';o[o.length]='<a:font script="Ethi" typeface="Nyala"/>';o[o.length]='<a:font script="Beng" typeface="Vrinda"/>';o[o.length]='<a:font script="Gujr" typeface="Shruti"/>';o[o.length]='<a:font script="Khmr" typeface="DaunPenh"/>';o[o.length]='<a:font script="Knda" typeface="Tunga"/>';o[o.length]='<a:font script="Guru" typeface="Raavi"/>';o[o.length]='<a:font script="Cans" typeface="Euphemia"/>';o[o.length]='<a:font script="Cher" typeface="Plantagenet Cherokee"/>';o[o.length]='<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';o[o.length]='<a:font script="Tibt" typeface="Microsoft Himalaya"/>';o[o.length]='<a:font script="Thaa" typeface="MV Boli"/>';o[o.length]='<a:font script="Deva" typeface="Mangal"/>';o[o.length]='<a:font script="Telu" typeface="Gautami"/>';o[o.length]='<a:font script="Taml" typeface="Latha"/>';o[o.length]='<a:font script="Syrc" typeface="Estrangelo Edessa"/>';o[o.length]='<a:font script="Orya" typeface="Kalinga"/>';o[o.length]='<a:font script="Mlym" typeface="Kartika"/>';o[o.length]='<a:font script="Laoo" typeface="DokChampa"/>';o[o.length]='<a:font script="Sinh" typeface="Iskoola Pota"/>';o[o.length]='<a:font script="Mong" typeface="Mongolian Baiti"/>';o[o.length]='<a:font script="Viet" typeface="Arial"/>';o[o.length]='<a:font script="Uigh" typeface="Microsoft Uighur"/>';o[o.length]='<a:font script="Geor" typeface="Sylfaen"/>';o[o.length]='</a:minorFont>';o[o.length]='</a:fontScheme>';o[o.length]='<a:fmtScheme name="Office">';o[o.length]='<a:fillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="1"/>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:lin ang="16200000" scaled="0"/>';o[o.length]='</a:gradFill>';o[o.length]='</a:fillStyleLst>';o[o.length]='<a:lnStyleLst>';o[o.length]='<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';o[o.length]='</a:lnStyleLst>';o[o.length]='<a:effectStyleLst>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='</a:effectStyle>';o[o.length]='<a:effectStyle>';o[o.length]='<a:effectLst>';o[o.length]='<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';o[o.length]='</a:effectLst>';o[o.length]='<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';o[o.length]='<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';o[o.length]='</a:effectStyle>';o[o.length]='</a:effectStyleLst>';o[o.length]='<a:bgFillStyleLst>';o[o.length]='<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='<a:gradFill rotWithShape="1">';o[o.length]='<a:gsLst>';o[o.length]='<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';o[o.length]='<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';o[o.length]='</a:gsLst>';o[o.length]='<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';o[o.length]='</a:gradFill>';o[o.length]='</a:bgFillStyleLst>';o[o.length]='</a:fmtScheme>';o[o.length]='</a:themeElements>';o[o.length]='<a:objectDefaults>';o[o.length]='<a:spDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';o[o.length]='</a:spDef>';o[o.length]='<a:lnDef>';o[o.length]='<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';o[o.length]='</a:lnDef>';o[o.length]='</a:objectDefaults>';o[o.length]='<a:extraClrSchemeLst/>';o[o.length]='</a:theme>';return o.join("");}/* [MS-XLS] 2.4.326 TODO: payload is a zip file */function parse_Theme(blob,length,opts){var end=blob.l+length;var dwThemeVersion=blob.read_shift(4);if(dwThemeVersion===124226)return;if(!opts.cellStyles){blob.l=end;return;}var data=blob.slice(blob.l);blob.l=end;var zip;try{zip=zip_read(data,{type:"array"});}catch(e){return;}var themeXML=getzipstr(zip,"theme/theme/theme1.xml",true);if(!themeXML)return;return parse_theme_xml(themeXML,opts);}/* 2.5.49 */function parse_ColorTheme(blob/*::, length*/){return blob.read_shift(4);}/* 2.5.155 */function parse_FullColorExt(blob/*::, length*/){var o={};o.xclrType=blob.read_shift(2);o.nTintShade=blob.read_shift(2);switch(o.xclrType){case 0:blob.l+=4;break;case 1:o.xclrValue=parse_IcvXF(blob,4);break;case 2:o.xclrValue=parse_LongRGBA(blob,4);break;case 3:o.xclrValue=parse_ColorTheme(blob,4);break;case 4:blob.l+=4;break;}blob.l+=8;return o;}/* 2.5.164 TODO: read 7 bits*/function parse_IcvXF(blob,length){return parsenoop(blob,length);}/* 2.5.280 */function parse_XFExtGradient(blob,length){return parsenoop(blob,length);}/* [MS-XLS] 2.5.108 */function parse_ExtProp(blob/*::, length*/)/*:Array<any>*/{var extType=blob.read_shift(2);var cb=blob.read_shift(2)-4;var o=[extType];switch(extType){case 0x04:case 0x05:case 0x07:case 0x08:case 0x09:case 0x0A:case 0x0B:case 0x0D:o[1]=parse_FullColorExt(blob,cb);break;case 0x06:o[1]=parse_XFExtGradient(blob,cb);break;case 0x0E:case 0x0F:o[1]=blob.read_shift(cb===1?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+extType+" "+cb);}return o;}/* 2.4.355 */function parse_XFExt(blob,length){var end=blob.l+length;blob.l+=2;var ixfe=blob.read_shift(2);blob.l+=2;var cexts=blob.read_shift(2);var ext/*:AOA*/=[];while(cexts-->0){ext.push(parse_ExtProp(blob,end-blob.l));}return{ixfe:ixfe,ext:ext};}/* xf is an XF, see parse_XFExt for xfext */function update_xfext(xf,xfext){xfext.forEach(function(xfe){switch(xfe[0]){/* 2.5.108 extPropData */case 0x04:break;/* foreground color */case 0x05:break;/* background color */case 0x06:break;/* gradient fill */case 0x07:break;/* top cell border color */case 0x08:break;/* bottom cell border color */case 0x09:break;/* left cell border color */case 0x0a:break;/* right cell border color */case 0x0b:break;/* diagonal cell border color */case 0x0d:/* text color */break;case 0x0e:break;/* font scheme */case 0x0f:break;/* indentation level */}});}function parse_BrtMdtinfo(data,length){return{flags:data.read_shift(4),version:data.read_shift(4),name:parse_XLWideString(data,length-8)};}function write_BrtMdtinfo(data){var o=new_buf(12+2*data.name.length);o.write_shift(4,data.flags);o.write_shift(4,data.version);write_XLWideString(data.name,o);return o.slice(0,o.l);}function parse_BrtMdb(data){var out=[];var cnt=data.read_shift(4);while(cnt-->0){out.push([data.read_shift(4),data.read_shift(4)]);}return out;}function write_BrtMdb(mdb){var o=new_buf(4+8*mdb.length);o.write_shift(4,mdb.length);for(var i=0;i<mdb.length;++i){o.write_shift(4,mdb[i][0]);o.write_shift(4,mdb[i][1]);}return o;}function write_BrtBeginEsfmd(cnt,name){var o=new_buf(8+2*name.length);o.write_shift(4,cnt);write_XLWideString(name,o);return o.slice(0,o.l);}function parse_BrtBeginEsmdb(data){data.l+=4;return data.read_shift(4)!=0;}function write_BrtBeginEsmdb(cnt,cm){var o=new_buf(8);o.write_shift(4,cnt);o.write_shift(4,cm?1:0);return o;}function parse_xlmeta_bin(data,name,_opts){var out={Types:[],Cell:[],Value:[]};var opts=_opts||{};var state=[];var pass=false;var metatype=2;recordhopper(data,function(val,R,RT){switch(RT){case 335:out.Types.push({name:val.name});break;case 51:val.forEach(function(r){if(metatype==1)out.Cell.push({type:out.Types[r[0]-1].name,index:r[1]});else if(metatype==0)out.Value.push({type:out.Types[r[0]-1].name,index:r[1]});});break;case 337:metatype=val?1:0;break;case 338:metatype=2;break;case 35:state.push(RT);pass=true;break;case 36:state.pop();pass=false;break;default:if(R.T){}else if(!pass||opts.WTF&&state[state.length-1]!=35)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}function write_xlmeta_bin(){var ba=buf_array();write_record(ba,332);write_record(ba,334,write_UInt32LE(1));write_record(ba,335,write_BrtMdtinfo({name:"XLDAPR",version:12e4,flags:3496657072}));write_record(ba,336);write_record(ba,339,write_BrtBeginEsfmd(1,"XLDAPR"));write_record(ba,52);write_record(ba,35,write_UInt32LE(514));write_record(ba,4096,write_UInt32LE(0));write_record(ba,4097,writeuint16(1));write_record(ba,36);write_record(ba,53);write_record(ba,340);write_record(ba,337,write_BrtBeginEsmdb(1,true));write_record(ba,51,write_BrtMdb([[1,0]]));write_record(ba,338);write_record(ba,333);return ba.end();}function parse_xlmeta_xml(data,name,opts){var out={Types:[],Cell:[],Value:[]};if(!data)return out;var pass=false;var metatype=2;var lastmeta;data.replace(tagregex,function(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case"<?xml":break;case"<metadata":case"</metadata>":break;case"<metadataTypes":case"</metadataTypes>":break;case"<metadataType":out.Types.push({name:y.name});break;case"</metadataType>":break;case"<futureMetadata":for(var j=0;j<out.Types.length;++j){if(out.Types[j].name==y.name)lastmeta=out.Types[j];}break;case"</futureMetadata>":break;case"<bk>":break;case"</bk>":break;case"<rc":if(metatype==1)out.Cell.push({type:out.Types[y.t-1].name,index:+y.v});else if(metatype==0)out.Value.push({type:out.Types[y.t-1].name,index:+y.v});break;case"</rc>":break;case"<cellMetadata":metatype=1;break;case"</cellMetadata>":metatype=2;break;case"<valueMetadata":metatype=0;break;case"</valueMetadata>":metatype=2;break;case"<extLst":case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":pass=true;break;case"</ext>":pass=false;break;case"<rvb":if(!lastmeta)break;if(!lastmeta.offsets)lastmeta.offsets=[];lastmeta.offsets.push(+y.i);break;default:if(!pass&&opts.WTF)throw new Error("unrecognized "+y[0]+" in metadata");}return x;});return out;}function write_xlmeta_xml(){var o=[XML_HEADER];o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');return o.join("");}/* 18.6 Calculation Chain */function parse_cc_xml(data/*::, name, opts*/)/*:Array<any>*/{var d=[];if(!data)return d;var i=1;(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case'<?xml':break;/* 18.6.2  calcChain CT_CalcChain 1 */case'<calcChain':case'<calcChain>':case'</calcChain>':break;/* 18.6.1  c CT_CalcCell 1 */case'<c':delete y[0];if(y.i)i=y.i;else y.i=i;d.push(y);break;}});return d;}//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */function parse_BrtCalcChainItem$(data){var out={};out.i=data.read_shift(4);var cell={};cell.r=data.read_shift(4);cell.c=data.read_shift(4);out.r=encode_cell(cell);var flags=data.read_shift(1);if(flags&0x2)out.l='1';if(flags&0x8)out.a='1';return out;}/* 18.6 Calculation Chain */function parse_cc_bin(data,name,opts){var out=[];var pass=false;recordhopper(data,function hopper_cc(val,R,RT){switch(RT){case 0x003F:/* 'BrtCalcChainItem$' */out.push(val);break;default:if(R.T){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */function parse_xlink_xml()/*::data, rel, name:string, _opts*/{}//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
/* [MS-XLSB] 2.1.7.25 External Link */function parse_xlink_bin(data,rel,name/*:string*/,_opts){if(!data)return data;var opts=_opts||{};var pass=false,end=false;recordhopper(data,function xlink_parse(val,R,RT){if(end)return;switch(RT){case 0x0167:/* 'BrtSupTabs' */case 0x016B:/* 'BrtExternTableStart' */case 0x016C:/* 'BrtExternTableEnd' */case 0x016E:/* 'BrtExternRowHdr' */case 0x016F:/* 'BrtExternCellBlank' */case 0x0170:/* 'BrtExternCellReal' */case 0x0171:/* 'BrtExternCellBool' */case 0x0172:/* 'BrtExternCellError' */case 0x0173:/* 'BrtExternCellString' */case 0x01D8:/* 'BrtExternValueMeta' */case 0x0241:/* 'BrtSupNameStart' */case 0x0242:/* 'BrtSupNameValueStart' */case 0x0243:/* 'BrtSupNameValueEnd' */case 0x0244:/* 'BrtSupNameNum' */case 0x0245:/* 'BrtSupNameErr' */case 0x0246:/* 'BrtSupNameSt' */case 0x0247:/* 'BrtSupNameNil' */case 0x0248:/* 'BrtSupNameBool' */case 0x0249:/* 'BrtSupNameFmla' */case 0x024A:/* 'BrtSupNameBits' */case 0x024B:/* 'BrtSupNameEnd' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;default:if(R.T){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);}/* 20.5 DrawingML - SpreadsheetML Drawing *//* 20.5.2.35 wsDr CT_Drawing */function parse_drawing(data,rels/*:any*/){if(!data)return"??";/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/var id=(data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];return rels['!id'][id].Target;}/* L.5.5.2 SpreadsheetML Comments + VML Schema */var _shapeid=1024;function write_comments_vml(rId/*:number*/,comments){var csize=[21600,21600];/* L.5.2.1.2 Path Attribute */var bbox=["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");var o=[writextag("xml",null,{'xmlns:v':XLMLNS.v,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:mv':XLMLNS.mv}).replace(/\/>/,">"),writextag("o:shapelayout",writextag("o:idmap",null,{'v:ext':"edit",'data':rId}),{'v:ext':"edit"}),writextag("v:shapetype",[writextag("v:stroke",null,{joinstyle:"miter"}),writextag("v:path",null,{gradientshapeok:"t",'o:connecttype':"rect"})].join(""),{id:"_x0000_t202",'o:spt':202,coordsize:csize.join(","),path:bbox})];while(_shapeid<rId*1000){_shapeid+=1000;}comments.forEach(function(x){var c=decode_cell(x[0]);var fillopts=/*::(*/{'color2':"#BEFF82",'type':"gradient"/*:: :any)*/};if(fillopts.type=="gradient")fillopts.angle="-180";var fillparm=fillopts.type=="gradient"?writextag("o:fill",null,{type:"gradientUnscaled",'v:ext':"view"}):null;var fillxml=writextag('v:fill',fillparm,fillopts);var shadata={on:"t",'obscured':"t"/*:any*/};++_shapeid;o=o.concat(['<v:shape'+wxt_helper({id:'_x0000_s'+_shapeid,type:"#_x0000_t202",style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10"+(x[1].hidden?";visibility:hidden":""),fillcolor:"#ECFAD4",strokecolor:"#edeaa1"})+'>',fillxml,writextag("v:shadow",null,shadata),writextag("v:path",null,{'o:connecttype':"none"}),'<v:textbox><div style="text-align:left"></div></v:textbox>','<x:ClientData ObjectType="Note">','<x:MoveWithCells/>','<x:SizeWithCells/>',/* Part 4 19.4.2.3 Anchor (Anchor) */writetag('x:Anchor',[c.c+1,0,c.r+1,0,c.c+3,20,c.r+5,20].join(",")),writetag('x:AutoFill',"False"),writetag('x:Row',String(c.r)),writetag('x:Column',String(c.c)),x[1].hidden?'':'<x:Visible/>','</x:ClientData>','</v:shape>']);});o.push('</xml>');return o.join("");}function sheet_insert_comments(sheet,comments/*:Array<RawComment>*/,threaded/*:boolean*/,people/*:?Array<any>*/){var dense=Array.isArray(sheet);var cell/*:Cell*/;comments.forEach(function(comment){var r=decode_cell(comment.ref);if(dense){if(!sheet[r.r])sheet[r.r]=[];cell=sheet[r.r][r.c];}else cell=sheet[comment.ref];if(!cell){cell={t:"z"/*:any*/};if(dense)sheet[r.r][r.c]=cell;else sheet[comment.ref]=cell;var range=safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");if(range.s.r>r.r)range.s.r=r.r;if(range.e.r<r.r)range.e.r=r.r;if(range.s.c>r.c)range.s.c=r.c;if(range.e.c<r.c)range.e.c=r.c;var encoded=encode_range(range);if(encoded!==sheet["!ref"])sheet["!ref"]=encoded;}if(!cell.c)cell.c=[];var o/*:Comment*/={a:comment.author,t:comment.t,r:comment.r,T:threaded};if(comment.h)o.h=comment.h;/* threaded comments always override */for(var i=cell.c.length-1;i>=0;--i){if(!threaded&&cell.c[i].T)return;if(threaded&&!cell.c[i].T)cell.c.splice(i,1);}if(threaded&&people)for(i=0;i<people.length;++i){if(o.a==people[i].id){o.a=people[i].name||o.a;break;}}cell.c.push(o);});}/* 18.7 Comments */function parse_comments_xml(data/*:string*/,opts)/*:Array<RawComment>*/{/* 18.7.6 CT_Comments */if(data.match(/<(?:\w+:)?comments *\/>/))return[];var authors/*:Array<string>*/=[];var commentList/*:Array<RawComment>*/=[];var authtag=data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);if(authtag&&authtag[1])authtag[1].split(/<\/\w*:?author>/).forEach(function(x){if(x===""||x.trim()==="")return;var a=x.match(/<(?:\w+:)?author[^>]*>(.*)/);if(a)authors.push(a[1]);});var cmnttag=data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);if(cmnttag&&cmnttag[1])cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x){if(x===""||x.trim()==="")return;var cm=x.match(/<(?:\w+:)?comment[^>]*>/);if(!cm)return;var y=parsexmltag(cm[0]);var comment/*:RawComment*/={author:y.authorId&&authors[y.authorId]||"sheetjsghost",ref:y.ref,guid:y.guid/*:any*/};var cell=decode_cell(y.ref);if(opts.sheetRows&&opts.sheetRows<=cell.r)return;var textMatch=x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);var rt=!!textMatch&&!!textMatch[1]&&parse_si(textMatch[1])||{r:"",t:"",h:""};comment.r=rt.r;if(rt.r=="<t></t>")rt.t=rt.h="";comment.t=(rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");if(opts.cellHTML)comment.h=rt.h;commentList.push(comment);});return commentList;}function write_comments_xml(data/*::, opts*/){var o=[XML_HEADER,writextag('comments',null,{'xmlns':XMLNS_main[0]})];var iauthor/*:Array<string>*/=[];o.push("<authors>");data.forEach(function(x){x[1].forEach(function(w){var a=escapexml(w.a);if(iauthor.indexOf(a)==-1){iauthor.push(a);o.push("<author>"+a+"</author>");}if(w.T&&w.ID&&iauthor.indexOf("tc="+w.ID)==-1){iauthor.push("tc="+w.ID);o.push("<author>"+"tc="+w.ID+"</author>");}});});if(iauthor.length==0){iauthor.push("SheetJ5");o.push("<author>SheetJ5</author>");}o.push("</authors>");o.push("<commentList>");data.forEach(function(d){/* 18.7.3 CT_Comment */var lastauthor=0,ts=[];if(d[1][0]&&d[1][0].T&&d[1][0].ID)lastauthor=iauthor.indexOf("tc="+d[1][0].ID);else d[1].forEach(function(c){if(c.a)lastauthor=iauthor.indexOf(escapexml(c.a));ts.push(c.t||"");});o.push('<comment ref="'+d[0]+'" authorId="'+lastauthor+'"><text>');if(ts.length<=1)o.push(writetag("t",escapexml(ts[0]||"")));else{/* based on Threaded Comments -> Comments projection */var t="Comment:\n    "+ts[0]+"\n";for(var i=1;i<ts.length;++i){t+="Reply:\n    "+ts[i]+"\n";}o.push(writetag("t",escapexml(t)));}o.push('</text></comment>');});o.push("</commentList>");if(o.length>2){o[o.length]='</comments>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSX] 2.1.17 */function parse_tcmnt_xml(data/*:string*/,opts)/*:Array<RawComment>*/{var out=[];var pass=false,comment={},tidx=0;data.replace(tagregex,function xml_tcmnt(x,idx){var y/*:any*/=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;/* 2.6.207 ThreadedComments CT_ThreadedComments */case'<ThreadedComments':break;case'</ThreadedComments>':break;/* 2.6.205 threadedComment CT_ThreadedComment */case'<threadedComment':comment={author:y.personId,guid:y.id,ref:y.ref,T:1};break;case'</threadedComment>':if(comment.t!=null)out.push(comment);break;case'<text>':case'<text':tidx=idx+x.length;break;case'</text>':comment.t=data.slice(tidx,idx).replace(/\r\n/g,"\n").replace(/\r/g,"\n");break;/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */case'<mentions':case'<mentions>':pass=true;break;case'</mentions>':pass=false;break;/* 2.6.202 mention CT_Mention TODO *//* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;/* 18.2.7  ext CT_Extension + */case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in threaded comments');}return x;});return out;}function write_tcmnt_xml(comments,people,opts){var o=[XML_HEADER,writextag('ThreadedComments',null,{'xmlns':XMLNS.TCMNT}).replace(/[\/]>/,">")];comments.forEach(function(carr){var rootid="";(carr[1]||[]).forEach(function(c,idx){if(!c.T){delete c.ID;return;}if(c.a&&people.indexOf(c.a)==-1)people.push(c.a);var tcopts={ref:carr[0],id:"{54EE7951-7262-4200-6969-"+("000000000000"+opts.tcid++).slice(-12)+"}"};if(idx==0)rootid=tcopts.id;else tcopts.parentId=rootid;c.ID=tcopts.id;if(c.a)tcopts.personId="{54EE7950-7262-4200-6969-"+("000000000000"+people.indexOf(c.a)).slice(-12)+"}";o.push(writextag('threadedComment',writetag('text',c.t||""),tcopts));});});o.push('</ThreadedComments>');return o.join("");}/* [MS-XLSX] 2.1.18 */function parse_people_xml(data/*:string*/,opts){var out=[];var pass=false;data.replace(tagregex,function xml_tcmnt(x){var y/*:any*/=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;/* 2.4.85 personList CT_PersonList */case'<personList':break;case'</personList>':break;/* 2.6.203 person CT_Person TODO: providers */case'<person':out.push({name:y.displayname,id:y.id});break;case'</person>':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;/* 18.2.7  ext CT_Extension + */case'<ext':pass=true;break;case'</ext>':pass=false;break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in threaded comments');}return x;});return out;}function write_people_xml(people/*, opts*/){var o=[XML_HEADER,writextag('personList',null,{'xmlns':XMLNS.TCMNT,'xmlns:x':XMLNS_main[0]}).replace(/[\/]>/,">")];people.forEach(function(person,idx){o.push(writextag('person',null,{displayName:person,id:"{54EE7950-7262-4200-6969-"+("000000000000"+idx).slice(-12)+"}",userId:person,providerId:"None"}));});o.push("</personList>");return o.join("");}/* [MS-XLSB] 2.4.28 BrtBeginComment */function parse_BrtBeginComment(data){var out={};out.iauthor=data.read_shift(4);var rfx=parse_UncheckedRfX(data,16);out.rfx=rfx.s;out.ref=encode_cell(rfx.s);data.l+=16;/*var guid = parse_GUID(data); */return out;}function write_BrtBeginComment(data,o){if(o==null)o=new_buf(36);o.write_shift(4,data[1].iauthor);write_UncheckedRfX(data[0]/*:any*/,o);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(4,0);return o;}/* [MS-XLSB] 2.4.327 BrtCommentAuthor */var parse_BrtCommentAuthor=parse_XLWideString;function write_BrtCommentAuthor(data){return write_XLWideString(data.slice(0,54));}/* [MS-XLSB] 2.1.7.8 Comments */function parse_comments_bin(data,opts)/*:Array<RawComment>*/{var out/*:Array<RawComment>*/=[];var authors/*:Array<string>*/=[];var c={};var pass=false;recordhopper(data,function hopper_cmnt(val,R,RT){switch(RT){case 0x0278:/* 'BrtCommentAuthor' */authors.push(val);break;case 0x027B:/* 'BrtBeginComment' */c=val;break;case 0x027D:/* 'BrtCommentText' */c.t=val.t;c.h=val.h;c.r=val.r;break;case 0x027C:/* 'BrtEndComment' */c.author=authors[c.iauthor];delete c/*:any*/.iauthor;if(opts.sheetRows&&c.rfx&&opts.sheetRows<=c.rfx.r)break;if(!c.t)c.t="";delete c.rfx;out.push(c);break;case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */break;case 0x0026:/* 'BrtACEnd' */break;default:if(R.T){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}});return out;}function write_comments_bin(data/*::, opts*/){var ba=buf_array();var iauthor/*:Array<string>*/=[];write_record(ba,0x0274/* BrtBeginComments */);write_record(ba,0x0276/* BrtBeginCommentAuthors */);data.forEach(function(comment){comment[1].forEach(function(c){if(iauthor.indexOf(c.a)>-1)return;iauthor.push(c.a.slice(0,54));write_record(ba,0x0278/* BrtCommentAuthor */,write_BrtCommentAuthor(c.a));});});write_record(ba,0x0277/* BrtEndCommentAuthors */);write_record(ba,0x0279/* BrtBeginCommentList */);data.forEach(function(comment){comment[1].forEach(function(c){c.iauthor=iauthor.indexOf(c.a);var range={s:decode_cell(comment[0]),e:decode_cell(comment[0])};write_record(ba,0x027B/* BrtBeginComment */,write_BrtBeginComment([range,c]));if(c.t&&c.t.length>0)write_record(ba,0x027D/* BrtCommentText */,write_BrtCommentText(c));write_record(ba,0x027C/* BrtEndComment */);delete c.iauthor;});});write_record(ba,0x027A/* BrtEndCommentList */);write_record(ba,0x0275/* BrtEndComments */);return ba.end();}var CT_VBA="application/vnd.ms-office.vbaProject";function make_vba_xls(cfb){var newcfb=CFB.utils.cfb_new({root:"R"});cfb.FullPaths.forEach(function(p,i){if(p.slice(-1)==="/"||!p.match(/_VBA_PROJECT_CUR/))return;var newpath=p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/,"");CFB.utils.cfb_add(newcfb,newpath,cfb.FileIndex[i].content);});return CFB.write(newcfb);}function fill_vba_xls(cfb,vba){vba.FullPaths.forEach(function(p,i){if(i==0)return;var newpath=p.replace(/[^\/]*[\/]/,"/_VBA_PROJECT_CUR/");if(newpath.slice(-1)!=="/")CFB.utils.cfb_add(cfb,newpath,vba.FileIndex[i].content);});}var VBAFMTS=["xlsb","xlsm","xlam","biff8","xla"];/* macro and dialog sheet stubs */function parse_ds_bin()/*::data:any, opts, idx:number, rels, wb, themes, styles*//*:Worksheet*/{return{'!type':'dialog'};}function parse_ds_xml()/*::data:any, opts, idx:number, rels, wb, themes, styles*//*:Worksheet*/{return{'!type':'dialog'};}function parse_ms_bin()/*::data:any, opts, idx:number, rels, wb, themes, styles*//*:Worksheet*/{return{'!type':'macro'};}function parse_ms_xml()/*::data:any, opts, idx:number, rels, wb, themes, styles*//*:Worksheet*/{return{'!type':'macro'};}/* TODO: it will be useful to parse the function str */var rc_to_a1=/*#__PURE__*/function(){var rcregex=/(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;var rcbase/*:Cell*/={r:0,c:0/*:any*/};function rcfunc($$,$1,$2,$3){var cRel=false,rRel=false;if($2.length==0)rRel=true;else if($2.charAt(0)=="["){rRel=true;$2=$2.slice(1,-1);}if($3.length==0)cRel=true;else if($3.charAt(0)=="["){cRel=true;$3=$3.slice(1,-1);}var R=$2.length>0?parseInt($2,10)|0:0,C=$3.length>0?parseInt($3,10)|0:0;if(cRel)C+=rcbase.c;else--C;if(rRel)R+=rcbase.r;else--R;return $1+(cRel?"":"$")+encode_col(C)+(rRel?"":"$")+encode_row(R);}return function rc_to_a1(fstr/*:string*/,base/*:Cell*/)/*:string*/{rcbase=base;return fstr.replace(rcregex,rcfunc);};}();var crefregex=/(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;var a1_to_rc=/*#__PURE__*/function(){return function a1_to_rc(fstr/*:string*/,base/*:CellAddress*/){return fstr.replace(crefregex,function($0,$1,$2,$3,$4,$5){var c=decode_col($3)-($2?0:base.c);var r=decode_row($5)-($4?0:base.r);var R=r==0?"":!$4?"["+r+"]":r+1;var C=c==0?"":!$2?"["+c+"]":c+1;return $1+"R"+R+"C"+C;});};}();/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */function shift_formula_str(f/*:string*/,delta/*:Cell*/)/*:string*/{return f.replace(crefregex,function($0,$1,$2,$3,$4,$5){return $1+($2=="$"?$2+$3:encode_col(decode_col($3)+delta.c))+($4=="$"?$4+$5:encode_row(decode_row($5)+delta.r));});}function shift_formula_xlsx(f/*:string*/,range/*:string*/,cell/*:string*/)/*:string*/{var r=decode_range(range),s=r.s,c=decode_cell(cell);var delta={r:c.r-s.r,c:c.c-s.c};return shift_formula_str(f,delta);}/* TODO: parse formula */function fuzzyfmla(f/*:string*/)/*:boolean*/{if(f.length==1)return false;return true;}function _xlfn(f/*:string*/)/*:string*/{return f.replace(/_xlfn\./g,"");}function parseread1(blob){blob.l+=1;return;}/* [MS-XLS] 2.5.51 */function parse_ColRelU(blob,length){var c=blob.read_shift(length==1?1:2);return[c&0x3FFF,c>>14&1,c>>15&1];}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */function parse_RgceArea(blob,length,opts){var w=2;if(opts){if(opts.biff>=2&&opts.biff<=5)return parse_RgceArea_BIFF2(blob,length,opts);else if(opts.biff==12)w=4;}var r=blob.read_shift(w),R=blob.read_shift(w);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* BIFF 2-5 encodes flags in the row field */function parse_RgceArea_BIFF2(blob/*::, length, opts*/){var r=parse_ColRelU(blob,2),R=parse_ColRelU(blob,2);var c=blob.read_shift(1);var C=blob.read_shift(1);return{s:{r:r[0],c:c,cRel:r[1],rRel:r[2]},e:{r:R[0],c:C,cRel:R[1],rRel:R[2]}};}/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */function parse_RgceAreaRel(blob,length,opts){if(opts.biff<8)return parse_RgceArea_BIFF2(blob,length,opts);var r=blob.read_shift(opts.biff==12?4:2),R=blob.read_shift(opts.biff==12?4:2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}};}/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */function parse_RgceLoc(blob,length,opts){if(opts&&opts.biff>=2&&opts.biff<=5)return parse_RgceLoc_BIFF2(blob,length,opts);var r=blob.read_shift(opts&&opts.biff==12?4:2);var c=parse_ColRelU(blob,2);return{r:r,c:c[0],cRel:c[1],rRel:c[2]};}function parse_RgceLoc_BIFF2(blob/*::, length, opts*/){var r=parse_ColRelU(blob,2);var c=blob.read_shift(1);return{r:r[0],c:c,cRel:r[1],rRel:r[2]};}/* [MS-XLS] 2.5.198.107, 2.5.47 */function parse_RgceElfLoc(blob/*::, length, opts*/){var r=blob.read_shift(2);var c=blob.read_shift(2);return{r:r,c:c&0xFF,fQuoted:!!(c&0x4000),cRel:c>>15,rRel:c>>15};}/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */function parse_RgceLocRel(blob,length,opts){var biff=opts&&opts.biff?opts.biff:8;if(biff>=2&&biff<=5)return parse_RgceLocRel_BIFF2(blob,length,opts);var r=blob.read_shift(biff>=12?4:2);var cl=blob.read_shift(2);var cRel=(cl&0x4000)>>14,rRel=(cl&0x8000)>>15;cl&=0x3FFF;if(rRel==1)while(r>0x7FFFF){r-=0x100000;}if(cRel==1)while(cl>0x1FFF){cl=cl-0x4000;}return{r:r,c:cl,cRel:cRel,rRel:rRel};}function parse_RgceLocRel_BIFF2(blob/*::, length:number, opts*/){var rl=blob.read_shift(2);var c=blob.read_shift(1);var rRel=(rl&0x8000)>>15,cRel=(rl&0x4000)>>14;rl&=0x3FFF;if(rRel==1&&rl>=0x2000)rl=rl-0x4000;if(cRel==1&&c>=0x80)c=c-0x100;return{r:rl,c:c,cRel:cRel,rRel:rRel};}/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */function parse_PtgArea(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceArea(blob,opts.biff>=2&&opts.biff<=5?6:8,opts);return[type,area];}/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */function parse_PtgArea3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2,'i');var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}var area=parse_RgceArea(blob,w,opts);return[type,ixti,area];}/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */function parse_PtgAreaErr(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts&&opts.biff>8?12:opts.biff<8?6:8;return[type];}/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */function parse_PtgAreaErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=8;if(opts)switch(opts.biff){case 5:blob.l+=12;w=6;break;case 12:w=12;break;}blob.l+=w;return[type,ixti];}/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */function parse_PtgAreaN(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var area=parse_RgceAreaRel(blob,length-1,opts);return[type,area];}/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */function parse_PtgArray(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;blob.l+=opts.biff==2?6:opts.biff==12?14:7;return[type];}/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */function parse_PtgAttrBaxcel(blob){var bitSemi=blob[blob.l+1]&0x01;/* 1 = volatile */var bitBaxcel=1;blob.l+=4;return[bitSemi,bitBaxcel];}/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */function parse_PtgAttrChoose(blob,length,opts)/*:Array<number>*/{blob.l+=2;var offset=blob.read_shift(opts&&opts.biff==2?1:2);var o/*:Array<number>*/=[];/* offset is 1 less than the number of elements */for(var i=0;i<=offset;++i){o.push(blob.read_shift(opts&&opts.biff==2?1:2));}return o;}/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */function parse_PtgAttrGoto(blob,length,opts){var bitGoto=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitGoto,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */function parse_PtgAttrIf(blob,length,opts){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(opts&&opts.biff==2?1:2)];}/* [MS-XLSB] 2.5.97.28 */function parse_PtgAttrIfError(blob){var bitIf=blob[blob.l+1]&0xFF?1:0;blob.l+=2;return[bitIf,blob.read_shift(2)];}/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */function parse_PtgAttrSemi(blob,length,opts){var bitSemi=blob[blob.l+1]&0xFF?1:0;blob.l+=opts&&opts.biff==2?3:4;return[bitSemi];}/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */function parse_PtgAttrSpaceType(blob/*::, length*/){var type=blob.read_shift(1),cch=blob.read_shift(1);return[type,cch];}/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */function parse_PtgAttrSpace(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */function parse_PtgAttrSpaceSemi(blob){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2);}/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */function parse_PtgRef(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLoc(blob,0,opts);return[type,loc];}/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */function parse_PtgRefN(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var loc=parse_RgceLocRel(blob,0,opts);return[type,loc];}/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */function parse_PtgRef3d(blob,length,opts){var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var ixti=blob.read_shift(2);// XtiIndex
if(opts&&opts.biff==5)blob.l+=12;var loc=parse_RgceLoc(blob,0,opts);// TODO: or RgceLocRel
return[type,ixti,loc];}/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */function parse_PtgFunc(blob,length,opts){//var ptg = blob[blob.l] & 0x1F;
var type=(blob[blob.l]&0x60)>>5;blob.l+=1;var iftab=blob.read_shift(opts&&opts.biff<=3?1:2);return[FtabArgc[iftab],Ftab[iftab],type];}/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */function parse_PtgFuncVar(blob,length,opts){var type=blob[blob.l++];var cparams=blob.read_shift(1),tab=opts&&opts.biff<=3?[type==0x58?-1:0,blob.read_shift(1)]:parsetab(blob);return[cparams,(tab[0]===0?Ftab:Cetab)[tab[1]]];}function parsetab(blob){return[blob[blob.l+1]>>7,blob.read_shift(2)&0x7FFF];}/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */function parse_PtgAttrSum(blob,length,opts){blob.l+=opts&&opts.biff==2?3:4;return;}/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */function parse_PtgExp(blob,length,opts){blob.l++;if(opts&&opts.biff==12)return[blob.read_shift(4,'i'),0];var row=blob.read_shift(2);var col=blob.read_shift(opts&&opts.biff==2?1:2);return[row,col];}/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */function parse_PtgErr(blob){blob.l++;return BErr[blob.read_shift(1)];}/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */function parse_PtgInt(blob){blob.l++;return blob.read_shift(2);}/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */function parse_PtgBool(blob){blob.l++;return blob.read_shift(1)!==0;}/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */function parse_PtgNum(blob){blob.l++;return parse_Xnum(blob,8);}/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */function parse_PtgStr(blob,length,opts){blob.l++;return parse_ShortXLUnicodeString(blob,length-1,opts);}/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} *//* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */function parse_SerAr(blob,biff/*:number*/){var val=[blob.read_shift(1)];if(biff==12)switch(val[0]){case 0x02:val[0]=0x04;break;/* SerBool */case 0x04:val[0]=0x10;break;/* SerErr */case 0x00:val[0]=0x01;break;/* SerNum */case 0x01:val[0]=0x02;break;/* SerStr */}switch(val[0]){case 0x04:/* SerBool -- boolean */val[1]=parsebool(blob,1)?'TRUE':'FALSE';if(biff!=12)blob.l+=7;break;case 0x25:/* appears to be an alias */case 0x10:/* SerErr -- error */val[1]=BErr[blob[blob.l]];blob.l+=biff==12?4:8;break;case 0x00:/* SerNil -- honestly, I'm not sure how to reproduce this */blob.l+=8;break;case 0x01:/* SerNum -- Xnum */val[1]=parse_Xnum(blob,8);break;case 0x02:/* SerStr -- XLUnicodeString (<256 chars) */val[1]=parse_XLUnicodeString2(blob,0,{biff:biff>0&&biff<8?2:biff});break;default:throw new Error("Bad SerAr: "+val[0]);/* Unreachable */}return val;}/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */function parse_PtgExtraMem(blob,cce,opts){var count=blob.read_shift(opts.biff==12?4:2);var out/*:Array<Range>*/=[];for(var i=0;i!=count;++i){out.push((opts.biff==12?parse_UncheckedRfX:parse_Ref8U)(blob,8));}return out;}/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */function parse_PtgExtraArray(blob,length,opts){var rows=0,cols=0;if(opts.biff==12){rows=blob.read_shift(4);// DRw
cols=blob.read_shift(4);// DCol
}else{cols=1+blob.read_shift(1);//DColByteU
rows=1+blob.read_shift(2);//DRw
}if(opts.biff>=2&&opts.biff<8){--rows;if(--cols==0)cols=0x100;}// $FlowIgnore
for(var i=0,o/*:Array<Array<any>>*/=[];i!=rows&&(o[i]=[]);++i){for(var j=0;j!=cols;++j){o[i][j]=parse_SerAr(blob,opts.biff);}}return o;}/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */function parse_PtgName(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var w=!opts||opts.biff>=8?4:2;var nameindex=blob.read_shift(w);switch(opts.biff){case 2:blob.l+=5;break;case 3:case 4:blob.l+=8;break;case 5:blob.l+=12;break;}return[type,0,nameindex];}/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */function parse_PtgNameX(blob,length,opts){if(opts.biff==5)return parse_PtgNameX_BIFF5(blob,length,opts);var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2);// XtiIndex
var nameindex=blob.read_shift(4);return[type,ixti,nameindex];}function parse_PtgNameX_BIFF5(blob/*::, length, opts*/){var type=blob.read_shift(1)>>>5&0x03;var ixti=blob.read_shift(2,'i');// XtiIndex
blob.l+=8;var nameindex=blob.read_shift(2);blob.l+=12;return[type,ixti,nameindex];}/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */function parse_PtgMemArea(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=opts&&opts.biff==2?3:4;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */function parse_PtgMemFunc(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(opts&&opts.biff==2?1:2);return[type,cce];}/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */function parse_PtgRefErr(blob,length,opts){var type=blob.read_shift(1)>>>5&0x03;blob.l+=4;if(opts.biff<8)blob.l--;if(opts.biff==12)blob.l+=2;return[type];}/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */function parse_PtgRefErr3d(blob,length,opts){var type=(blob[blob.l++]&0x60)>>5;var ixti=blob.read_shift(2);var w=4;if(opts)switch(opts.biff){case 5:w=15;break;case 12:w=6;break;}blob.l+=w;return[type,ixti];}/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */var parse_PtgMemErr=parsenoop;/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */var parse_PtgMemNoMem=parsenoop;/* [MS-XLS] 2.5.198.92 */var parse_PtgTbl=parsenoop;function parse_PtgElfLoc(blob,length,opts){blob.l+=2;return[parse_RgceElfLoc(blob,4,opts)];}function parse_PtgElfNoop(blob/*::, length, opts*/){blob.l+=6;return[];}/* [MS-XLS] 2.5.198.46 */var parse_PtgElfCol=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.47 */var parse_PtgElfColS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.48 */var parse_PtgElfColSV=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.49 */var parse_PtgElfColV=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.50 */function parse_PtgElfLel(blob/*::, length, opts*/){blob.l+=2;return[parseuint16(blob),blob.read_shift(2)&0x01];}/* [MS-XLS] 2.5.198.51 */var parse_PtgElfRadical=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.52 */var parse_PtgElfRadicalLel=parse_PtgElfLel;/* [MS-XLS] 2.5.198.53 */var parse_PtgElfRadicalS=parse_PtgElfNoop;/* [MS-XLS] 2.5.198.54 */var parse_PtgElfRw=parse_PtgElfLoc;/* [MS-XLS] 2.5.198.55 */var parse_PtgElfRwV=parse_PtgElfLoc;/* [MS-XLSB] 2.5.97.52 TODO */var PtgListRT=["Data","All","Headers","??","?Data2","??","?DataHeaders","??","Totals","??","??","??","?DataTotals","??","??","??","?Current"];function parse_PtgList(blob/*::, length, opts*/){blob.l+=2;var ixti=blob.read_shift(2);var flags=blob.read_shift(2);var idx=blob.read_shift(4);var c=blob.read_shift(2);var C=blob.read_shift(2);var rt=PtgListRT[flags>>2&0x1F];return{ixti:ixti,coltype:flags&0x3,rt:rt,idx:idx,c:c,C:C};}/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */function parse_PtgSxName(blob/*::, length, opts*/){blob.l+=2;return[blob.read_shift(4)];}/* [XLS] old spec */function parse_PtgSheet(blob,length,opts){blob.l+=5;blob.l+=2;blob.l+=opts.biff==2?1:4;return["PTGSHEET"];}function parse_PtgEndSheet(blob,length,opts){blob.l+=opts.biff==2?4:5;return["PTGENDSHEET"];}function parse_PtgMemAreaN(blob/*::, length, opts*/){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgMemNoMemN(blob/*::, length, opts*/){var type=blob.read_shift(1)>>>5&0x03;var cce=blob.read_shift(2);return[type,cce];}function parse_PtgAttrNoop(blob/*::, length, opts*/){blob.l+=4;return[0,0];}/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */var PtgTypes={/*::[*/0x01/*::]*/:{n:'PtgExp',f:parse_PtgExp},/*::[*/0x02/*::]*/:{n:'PtgTbl',f:parse_PtgTbl},/*::[*/0x03/*::]*/:{n:'PtgAdd',f:parseread1},/*::[*/0x04/*::]*/:{n:'PtgSub',f:parseread1},/*::[*/0x05/*::]*/:{n:'PtgMul',f:parseread1},/*::[*/0x06/*::]*/:{n:'PtgDiv',f:parseread1},/*::[*/0x07/*::]*/:{n:'PtgPower',f:parseread1},/*::[*/0x08/*::]*/:{n:'PtgConcat',f:parseread1},/*::[*/0x09/*::]*/:{n:'PtgLt',f:parseread1},/*::[*/0x0A/*::]*/:{n:'PtgLe',f:parseread1},/*::[*/0x0B/*::]*/:{n:'PtgEq',f:parseread1},/*::[*/0x0C/*::]*/:{n:'PtgGe',f:parseread1},/*::[*/0x0D/*::]*/:{n:'PtgGt',f:parseread1},/*::[*/0x0E/*::]*/:{n:'PtgNe',f:parseread1},/*::[*/0x0F/*::]*/:{n:'PtgIsect',f:parseread1},/*::[*/0x10/*::]*/:{n:'PtgUnion',f:parseread1},/*::[*/0x11/*::]*/:{n:'PtgRange',f:parseread1},/*::[*/0x12/*::]*/:{n:'PtgUplus',f:parseread1},/*::[*/0x13/*::]*/:{n:'PtgUminus',f:parseread1},/*::[*/0x14/*::]*/:{n:'PtgPercent',f:parseread1},/*::[*/0x15/*::]*/:{n:'PtgParen',f:parseread1},/*::[*/0x16/*::]*/:{n:'PtgMissArg',f:parseread1},/*::[*/0x17/*::]*/:{n:'PtgStr',f:parse_PtgStr},/*::[*/0x1A/*::]*/:{n:'PtgSheet',f:parse_PtgSheet},/*::[*/0x1B/*::]*/:{n:'PtgEndSheet',f:parse_PtgEndSheet},/*::[*/0x1C/*::]*/:{n:'PtgErr',f:parse_PtgErr},/*::[*/0x1D/*::]*/:{n:'PtgBool',f:parse_PtgBool},/*::[*/0x1E/*::]*/:{n:'PtgInt',f:parse_PtgInt},/*::[*/0x1F/*::]*/:{n:'PtgNum',f:parse_PtgNum},/*::[*/0x20/*::]*/:{n:'PtgArray',f:parse_PtgArray},/*::[*/0x21/*::]*/:{n:'PtgFunc',f:parse_PtgFunc},/*::[*/0x22/*::]*/:{n:'PtgFuncVar',f:parse_PtgFuncVar},/*::[*/0x23/*::]*/:{n:'PtgName',f:parse_PtgName},/*::[*/0x24/*::]*/:{n:'PtgRef',f:parse_PtgRef},/*::[*/0x25/*::]*/:{n:'PtgArea',f:parse_PtgArea},/*::[*/0x26/*::]*/:{n:'PtgMemArea',f:parse_PtgMemArea},/*::[*/0x27/*::]*/:{n:'PtgMemErr',f:parse_PtgMemErr},/*::[*/0x28/*::]*/:{n:'PtgMemNoMem',f:parse_PtgMemNoMem},/*::[*/0x29/*::]*/:{n:'PtgMemFunc',f:parse_PtgMemFunc},/*::[*/0x2A/*::]*/:{n:'PtgRefErr',f:parse_PtgRefErr},/*::[*/0x2B/*::]*/:{n:'PtgAreaErr',f:parse_PtgAreaErr},/*::[*/0x2C/*::]*/:{n:'PtgRefN',f:parse_PtgRefN},/*::[*/0x2D/*::]*/:{n:'PtgAreaN',f:parse_PtgAreaN},/*::[*/0x2E/*::]*/:{n:'PtgMemAreaN',f:parse_PtgMemAreaN},/*::[*/0x2F/*::]*/:{n:'PtgMemNoMemN',f:parse_PtgMemNoMemN},/*::[*/0x39/*::]*/:{n:'PtgNameX',f:parse_PtgNameX},/*::[*/0x3A/*::]*/:{n:'PtgRef3d',f:parse_PtgRef3d},/*::[*/0x3B/*::]*/:{n:'PtgArea3d',f:parse_PtgArea3d},/*::[*/0x3C/*::]*/:{n:'PtgRefErr3d',f:parse_PtgRefErr3d},/*::[*/0x3D/*::]*/:{n:'PtgAreaErr3d',f:parse_PtgAreaErr3d},/*::[*/0xFF/*::]*/:{}};/* These are duplicated in the PtgTypes table */var PtgDupes={/*::[*/0x40/*::]*/:0x20,/*::[*/0x60/*::]*/:0x20,/*::[*/0x41/*::]*/:0x21,/*::[*/0x61/*::]*/:0x21,/*::[*/0x42/*::]*/:0x22,/*::[*/0x62/*::]*/:0x22,/*::[*/0x43/*::]*/:0x23,/*::[*/0x63/*::]*/:0x23,/*::[*/0x44/*::]*/:0x24,/*::[*/0x64/*::]*/:0x24,/*::[*/0x45/*::]*/:0x25,/*::[*/0x65/*::]*/:0x25,/*::[*/0x46/*::]*/:0x26,/*::[*/0x66/*::]*/:0x26,/*::[*/0x47/*::]*/:0x27,/*::[*/0x67/*::]*/:0x27,/*::[*/0x48/*::]*/:0x28,/*::[*/0x68/*::]*/:0x28,/*::[*/0x49/*::]*/:0x29,/*::[*/0x69/*::]*/:0x29,/*::[*/0x4A/*::]*/:0x2A,/*::[*/0x6A/*::]*/:0x2A,/*::[*/0x4B/*::]*/:0x2B,/*::[*/0x6B/*::]*/:0x2B,/*::[*/0x4C/*::]*/:0x2C,/*::[*/0x6C/*::]*/:0x2C,/*::[*/0x4D/*::]*/:0x2D,/*::[*/0x6D/*::]*/:0x2D,/*::[*/0x4E/*::]*/:0x2E,/*::[*/0x6E/*::]*/:0x2E,/*::[*/0x4F/*::]*/:0x2F,/*::[*/0x6F/*::]*/:0x2F,/*::[*/0x58/*::]*/:0x22,/*::[*/0x78/*::]*/:0x22,/*::[*/0x59/*::]*/:0x39,/*::[*/0x79/*::]*/:0x39,/*::[*/0x5A/*::]*/:0x3A,/*::[*/0x7A/*::]*/:0x3A,/*::[*/0x5B/*::]*/:0x3B,/*::[*/0x7B/*::]*/:0x3B,/*::[*/0x5C/*::]*/:0x3C,/*::[*/0x7C/*::]*/:0x3C,/*::[*/0x5D/*::]*/:0x3D,/*::[*/0x7D/*::]*/:0x3D};var Ptg18={/*::[*/0x01/*::]*/:{n:'PtgElfLel',f:parse_PtgElfLel},/*::[*/0x02/*::]*/:{n:'PtgElfRw',f:parse_PtgElfRw},/*::[*/0x03/*::]*/:{n:'PtgElfCol',f:parse_PtgElfCol},/*::[*/0x06/*::]*/:{n:'PtgElfRwV',f:parse_PtgElfRwV},/*::[*/0x07/*::]*/:{n:'PtgElfColV',f:parse_PtgElfColV},/*::[*/0x0A/*::]*/:{n:'PtgElfRadical',f:parse_PtgElfRadical},/*::[*/0x0B/*::]*/:{n:'PtgElfRadicalS',f:parse_PtgElfRadicalS},/*::[*/0x0D/*::]*/:{n:'PtgElfColS',f:parse_PtgElfColS},/*::[*/0x0F/*::]*/:{n:'PtgElfColSV',f:parse_PtgElfColSV},/*::[*/0x10/*::]*/:{n:'PtgElfRadicalLel',f:parse_PtgElfRadicalLel},/*::[*/0x19/*::]*/:{n:'PtgList',f:parse_PtgList},/*::[*/0x1D/*::]*/:{n:'PtgSxName',f:parse_PtgSxName},/*::[*/0xFF/*::]*/:{}};var Ptg19={/*::[*/0x00/*::]*/:{n:'PtgAttrNoop',f:parse_PtgAttrNoop},/*::[*/0x01/*::]*/:{n:'PtgAttrSemi',f:parse_PtgAttrSemi},/*::[*/0x02/*::]*/:{n:'PtgAttrIf',f:parse_PtgAttrIf},/*::[*/0x04/*::]*/:{n:'PtgAttrChoose',f:parse_PtgAttrChoose},/*::[*/0x08/*::]*/:{n:'PtgAttrGoto',f:parse_PtgAttrGoto},/*::[*/0x10/*::]*/:{n:'PtgAttrSum',f:parse_PtgAttrSum},/*::[*/0x20/*::]*/:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},/*::[*/0x21/*::]*/:{n:'PtgAttrBaxcel',f:parse_PtgAttrBaxcel},/*::[*/0x40/*::]*/:{n:'PtgAttrSpace',f:parse_PtgAttrSpace},/*::[*/0x41/*::]*/:{n:'PtgAttrSpaceSemi',f:parse_PtgAttrSpaceSemi},/*::[*/0x80/*::]*/:{n:'PtgAttrIfError',f:parse_PtgAttrIfError},/*::[*/0xFF/*::]*/:{}};/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */function parse_RgbExtra(blob,length,rgce,opts){if(opts.biff<8)return parsenoop(blob,length);var target=blob.l+length;var o=[];for(var i=0;i!==rgce.length;++i){switch(rgce[i][0]){case'PtgArray':/* PtgArray -> PtgExtraArray */rgce[i][1]=parse_PtgExtraArray(blob,0,opts);o.push(rgce[i][1]);break;case'PtgMemArea':/* PtgMemArea -> PtgExtraMem */rgce[i][2]=parse_PtgExtraMem(blob,rgce[i][1],opts);o.push(rgce[i][2]);break;case'PtgExp':/* PtgExp -> PtgExtraCol */if(opts&&opts.biff==12){rgce[i][1][1]=blob.read_shift(4);o.push(rgce[i][1]);}break;case'PtgList':/* TODO: PtgList -> PtgExtraList */case'PtgElfRadicalS':/* TODO: PtgElfRadicalS -> PtgExtraElf */case'PtgElfColS':/* TODO: PtgElfColS -> PtgExtraElf */case'PtgElfColSV':/* TODO: PtgElfColSV -> PtgExtraElf */throw"Unsupported "+rgce[i][0];default:break;}}length=target-blob.l;/* note: this is technically an error but Excel disregards *///if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
if(length!==0)o.push(parsenoop(blob,length));return o;}/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */function parse_Rgce(blob,length,opts){var target=blob.l+length;var R,id,ptgs=[];while(target!=blob.l){length=target-blob.l;id=blob[blob.l];R=PtgTypes[id]||PtgTypes[PtgDupes[id]];if(id===0x18||id===0x19)R=(id===0x18?Ptg18:Ptg19)[blob[blob.l+1]];if(!R||!R.f){/*ptgs.push*/parsenoop(blob,length);}else{ptgs.push([R.n,R.f(blob,length,opts)]);}}return ptgs;}function stringify_array(f/*:Array<Array<string>>*/)/*:string*/{var o/*:Array<string>*/=[];for(var i=0;i<f.length;++i){var x=f[i],r/*:Array<string>*/=[];for(var j=0;j<x.length;++j){var y=x[j];if(y)switch(y[0]){// TODO: handle embedded quotes
case 0x02:/*:: if(typeof y[1] != 'string') throw "unreachable"; */r.push('"'+y[1].replace(/"/g,'""')+'"');break;default:r.push(y[1]);}else r.push("");}o.push(r.join(","));}return o.join(";");}/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */var PtgBinOp={PtgAdd:"+",PtgConcat:"&",PtgDiv:"/",PtgEq:"=",PtgGe:">=",PtgGt:">",PtgLe:"<=",PtgLt:"<",PtgMul:"*",PtgNe:"<>",PtgPower:"^",PtgSub:"-"};// List of invalid characters needs to be tested further
function formula_quote_sheet_name(sname/*:string*/,opts)/*:string*/{if(!sname&&!(opts&&opts.biff<=5&&opts.biff>=2))throw new Error("empty sheet name");if(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname))return"'"+sname+"'";return sname;}function get_ixti_raw(supbooks,ixti/*:number*/,opts)/*:string*/{if(!supbooks)return"SH33TJSERR0";if(opts.biff>8&&(!supbooks.XTI||!supbooks.XTI[ixti]))return supbooks.SheetNames[ixti];if(!supbooks.XTI)return"SH33TJSERR6";var XTI=supbooks.XTI[ixti];if(opts.biff<8){if(ixti>10000)ixti-=65536;if(ixti<0)ixti=-ixti;return ixti==0?"":supbooks.XTI[ixti-1];}if(!XTI)return"SH33TJSERR1";var o="";if(opts.biff>8)switch(supbooks[XTI[0]][0]){case 0x0165:/* 'BrtSupSelf' */o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]];return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x0166:/* 'BrtSupSame' */if(opts.SID!=null)return supbooks.SheetNames[opts.SID];return"SH33TJSSAME"+supbooks[XTI[0]][0];case 0x0163:/* 'BrtSupBookSrc' *//* falls through */default:return"SH33TJSSRC"+supbooks[XTI[0]][0];}switch(supbooks[XTI[0]][0][0]){case 0x0401:o=XTI[1]==-1?"#REF":supbooks.SheetNames[XTI[1]]||"SH33TJSERR3";return XTI[1]==XTI[2]?o:o+":"+supbooks.SheetNames[XTI[2]];case 0x3A01:return supbooks[XTI[0]].slice(1).map(function(name){return name.Name;}).join(";;");//return "SH33TJSERR8";
default:if(!supbooks[XTI[0]][0][3])return"SH33TJSERR2";o=XTI[1]==-1?"#REF":supbooks[XTI[0]][0][3][XTI[1]]||"SH33TJSERR4";return XTI[1]==XTI[2]?o:o+":"+supbooks[XTI[0]][0][3][XTI[2]];}}function get_ixti(supbooks,ixti/*:number*/,opts)/*:string*/{var ixtiraw=get_ixti_raw(supbooks,ixti,opts);return ixtiraw=="#REF"?ixtiraw:formula_quote_sheet_name(ixtiraw,opts);}function stringify_formula(formula/*Array<any>*/,range,cell/*:any*/,supbooks,opts)/*:string*/{var biff=opts&&opts.biff||8;var _range=/*range != null ? range :*/{s:{c:0,r:0},e:{c:0,r:0}};var stack/*:Array<string>*/=[],e1,e2,/*::type,*/c/*:CellAddress*/,ixti=0,nameidx=0,r,sname="";if(!formula[0]||!formula[0][0])return"";var last_sp=-1,sp="";for(var ff=0,fflen=formula[0].length;ff<fflen;++ff){var f=formula[0][ff];switch(f[0]){case'PtgUminus':/* [MS-XLS] 2.5.198.93 */stack.push("-"+stack.pop());break;case'PtgUplus':/* [MS-XLS] 2.5.198.95 */stack.push("+"+stack.pop());break;case'PtgPercent':/* [MS-XLS] 2.5.198.81 */stack.push(stack.pop()+"%");break;case'PtgAdd':/* [MS-XLS] 2.5.198.26 */case'PtgConcat':/* [MS-XLS] 2.5.198.43 */case'PtgDiv':/* [MS-XLS] 2.5.198.45 */case'PtgEq':/* [MS-XLS] 2.5.198.56 */case'PtgGe':/* [MS-XLS] 2.5.198.64 */case'PtgGt':/* [MS-XLS] 2.5.198.65 */case'PtgLe':/* [MS-XLS] 2.5.198.68 */case'PtgLt':/* [MS-XLS] 2.5.198.69 */case'PtgMul':/* [MS-XLS] 2.5.198.75 */case'PtgNe':/* [MS-XLS] 2.5.198.78 */case'PtgPower':/* [MS-XLS] 2.5.198.82 */case'PtgSub':/* [MS-XLS] 2.5.198.90 */e1=stack.pop();e2=stack.pop();if(last_sp>=0){switch(formula[0][last_sp][1][0]){case 0:// $FlowIgnore
sp=fill(" ",formula[0][last_sp][1][1]);break;case 1:// $FlowIgnore
sp=fill("\r",formula[0][last_sp][1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}e2=e2+sp;last_sp=-1;}stack.push(e2+PtgBinOp[f[0]]+e1);break;case'PtgIsect':/* [MS-XLS] 2.5.198.67 */e1=stack.pop();e2=stack.pop();stack.push(e2+" "+e1);break;case'PtgUnion':/* [MS-XLS] 2.5.198.94 */e1=stack.pop();e2=stack.pop();stack.push(e2+","+e1);break;case'PtgRange':/* [MS-XLS] 2.5.198.83 */e1=stack.pop();e2=stack.pop();stack.push(e2+":"+e1);break;case'PtgAttrChoose':/* [MS-XLS] 2.5.198.34 */break;case'PtgAttrGoto':/* [MS-XLS] 2.5.198.35 */break;case'PtgAttrIf':/* [MS-XLS] 2.5.198.36 */break;case'PtgAttrIfError':/* [MS-XLSB] 2.5.97.28 */break;case'PtgRef':/* [MS-XLS] 2.5.198.84 *//*::type = f[1][0]; */c=shift_cell_xls(f[1][1]/*:any*/,_range,opts);stack.push(encode_cell_xls(c,biff));break;case'PtgRefN':/* [MS-XLS] 2.5.198.88 *//*::type = f[1][0]; */c=cell?shift_cell_xls(f[1][1]/*:any*/,cell,opts):f[1][1]/*:any*/;stack.push(encode_cell_xls(c,biff));break;case'PtgRef3d':/* [MS-XLS] 2.5.198.85 *//*::type = f[1][0]; */ixti=/*::Number(*/f[1][1]/*::)*/;c=shift_cell_xls(f[1][2]/*:any*/,_range,opts);sname=get_ixti(supbooks,ixti,opts);var w=sname;/* IE9 fails on defined names */// eslint-disable-line no-unused-vars
stack.push(sname+"!"+encode_cell_xls(c,biff));break;case'PtgFunc':/* [MS-XLS] 2.5.198.62 */case'PtgFuncVar':/* [MS-XLS] 2.5.198.63 *//* f[1] = [argc, func, type] */var argc/*:number*/=f[1][0]/*:any*/,func/*:string*/=f[1][1]/*:any*/;if(!argc)argc=0;argc&=0x7F;var args=argc==0?[]:stack.slice(-argc);stack.length-=argc;if(func==='User')func=args.shift();stack.push(func+"("+args.join(",")+")");break;case'PtgBool':/* [MS-XLS] 2.5.198.42 */stack.push(f[1]?"TRUE":"FALSE");break;case'PtgInt':/* [MS-XLS] 2.5.198.66 */stack.push(/*::String(*/f[1]/*::)*/);break;case'PtgNum':/* [MS-XLS] 2.5.198.79 TODO: precision? */stack.push(String(f[1]));break;case'PtgStr':/* [MS-XLS] 2.5.198.89 */// $FlowIgnore
stack.push('"'+f[1].replace(/"/g,'""')+'"');break;case'PtgErr':/* [MS-XLS] 2.5.198.57 */stack.push(/*::String(*/f[1]/*::)*/);break;case'PtgAreaN':/* [MS-XLS] 2.5.198.31 TODO *//*::type = f[1][0]; */r=shift_range_xls(f[1][1],cell?{s:cell}:_range,opts);stack.push(encode_range_xls(r/*:any*/,opts));break;case'PtgArea':/* [MS-XLS] 2.5.198.27 TODO: fixed points *//*::type = f[1][0]; */r=shift_range_xls(f[1][1],_range,opts);stack.push(encode_range_xls(r/*:any*/,opts));break;case'PtgArea3d':/* [MS-XLS] 2.5.198.28 TODO *//*::type = f[1][0]; */ixti=/*::Number(*/f[1][1]/*::)*/;r=f[1][2];sname=get_ixti(supbooks,ixti,opts);stack.push(sname+"!"+encode_range_xls(r/*:any*/,opts));break;case'PtgAttrSum':/* [MS-XLS] 2.5.198.41 */stack.push("SUM("+stack.pop()+")");break;case'PtgAttrBaxcel':/* [MS-XLS] 2.5.198.33 */case'PtgAttrSemi':/* [MS-XLS] 2.5.198.37 */break;case'PtgName':/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions *//* f[1] = type, 0, nameindex */nameidx=f[1][2]/*:any*/;var lbl=(supbooks.names||[])[nameidx-1]||(supbooks[0]||[])[nameidx];var name=lbl?lbl.Name:"SH33TJSNAME"+String(nameidx);/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */if(name&&name.slice(0,6)=="_xlfn."&&!opts.xlfn)name=name.slice(6);stack.push(name);break;case'PtgNameX':/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions *//* f[1] = type, ixti, nameindex */var bookidx/*:number*/=f[1][1]/*:any*/;nameidx=f[1][2]/*:any*/;var externbook;/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */if(opts.biff<=5){if(bookidx<0)bookidx=-bookidx;if(supbooks[bookidx])externbook=supbooks[bookidx][nameidx];}else{var o="";if(((supbooks[bookidx]||[])[0]||[])[0]==0x3A01){/* empty */}else if(((supbooks[bookidx]||[])[0]||[])[0]==0x0401){if(supbooks[bookidx][nameidx]&&supbooks[bookidx][nameidx].itab>0){o=supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1]+"!";}}else o=supbooks.SheetNames[nameidx-1]+"!";if(supbooks[bookidx]&&supbooks[bookidx][nameidx])o+=supbooks[bookidx][nameidx].Name;else if(supbooks[0]&&supbooks[0][nameidx])o+=supbooks[0][nameidx].Name;else{var ixtidata=(get_ixti_raw(supbooks,bookidx,opts)||"").split(";;");if(ixtidata[nameidx-1])o=ixtidata[nameidx-1];// TODO: confirm this is correct
else o+="SH33TJSERRX";}stack.push(o);break;}if(!externbook)externbook={Name:"SH33TJSERRY"};stack.push(externbook.Name);break;case'PtgParen':/* [MS-XLS] 2.5.198.80 */var lp='(',rp=')';if(last_sp>=0){sp="";switch(formula[0][last_sp][1][0]){// $FlowIgnore
case 2:lp=fill(" ",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 3:lp=fill("\r",formula[0][last_sp][1][1])+lp;break;// $FlowIgnore
case 4:rp=fill(" ",formula[0][last_sp][1][1])+rp;break;// $FlowIgnore
case 5:rp=fill("\r",formula[0][last_sp][1][1])+rp;break;default:// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+formula[0][last_sp][1][0]);}last_sp=-1;}stack.push(lp+stack.pop()+rp);break;case'PtgRefErr':/* [MS-XLS] 2.5.198.86 */stack.push('#REF!');break;case'PtgRefErr3d':/* [MS-XLS] 2.5.198.87 */stack.push('#REF!');break;case'PtgExp':/* [MS-XLS] 2.5.198.58 TODO */c={c:f[1][1]/*:any*/,r:f[1][0]/*:any*/};var q={c:cell.c,r:cell.r/*:any*/};if(supbooks.sharedf[encode_cell(c)]){var parsedf=supbooks.sharedf[encode_cell(c)];stack.push(stringify_formula(parsedf,_range,q,supbooks,opts));}else{var fnd=false;for(e1=0;e1!=supbooks.arrayf.length;++e1){/* TODO: should be something like range_has */e2=supbooks.arrayf[e1];if(c.c<e2[0].s.c||c.c>e2[0].e.c)continue;if(c.r<e2[0].s.r||c.r>e2[0].e.r)continue;stack.push(stringify_formula(e2[1],_range,q,supbooks,opts));fnd=true;break;}if(!fnd)stack.push(/*::String(*/f[1]/*::)*/);}break;case'PtgArray':/* [MS-XLS] 2.5.198.32 TODO */stack.push("{"+stringify_array(/*::(*/f[1]/*:: :any)*/)+"}");break;case'PtgMemArea':/* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display *///stack.push("(" + f[2].map(encode_range).join(",") + ")");
break;case'PtgAttrSpace':/* [MS-XLS] 2.5.198.38 */case'PtgAttrSpaceSemi':/* [MS-XLS] 2.5.198.39 */last_sp=ff;break;case'PtgTbl':/* [MS-XLS] 2.5.198.92 TODO */break;case'PtgMemErr':/* [MS-XLS] 2.5.198.71 */break;case'PtgMissArg':/* [MS-XLS] 2.5.198.74 */stack.push("");break;case'PtgAreaErr':/* [MS-XLS] 2.5.198.29 */stack.push("#REF!");break;case'PtgAreaErr3d':/* [MS-XLS] 2.5.198.30 */stack.push("#REF!");break;case'PtgList':/* [MS-XLSB] 2.5.97.52 */// $FlowIgnore
stack.push("Table"+f[1].idx+"[#"+f[1].rt+"]");break;case'PtgMemAreaN':case'PtgMemNoMemN':case'PtgAttrNoop':case'PtgSheet':case'PtgEndSheet':break;case'PtgMemFunc':/* [MS-XLS] 2.5.198.72 TODO */break;case'PtgMemNoMem':/* [MS-XLS] 2.5.198.73 TODO */break;case'PtgElfCol':/* [MS-XLS] 2.5.198.46 */case'PtgElfColS':/* [MS-XLS] 2.5.198.47 */case'PtgElfColSV':/* [MS-XLS] 2.5.198.48 */case'PtgElfColV':/* [MS-XLS] 2.5.198.49 */case'PtgElfLel':/* [MS-XLS] 2.5.198.50 */case'PtgElfRadical':/* [MS-XLS] 2.5.198.51 */case'PtgElfRadicalLel':/* [MS-XLS] 2.5.198.52 */case'PtgElfRadicalS':/* [MS-XLS] 2.5.198.53 */case'PtgElfRw':/* [MS-XLS] 2.5.198.54 */case'PtgElfRwV':/* [MS-XLS] 2.5.198.55 */throw new Error("Unsupported ELFs");case'PtgSxName':/* [MS-XLS] 2.5.198.91 TODO -- find a test case */throw new Error('Unrecognized Formula Token: '+String(f));default:throw new Error('Unrecognized Formula Token: '+String(f));}var PtgNonDisp=['PtgAttrSpace','PtgAttrSpaceSemi','PtgAttrGoto'];if(opts.biff!=3)if(last_sp>=0&&PtgNonDisp.indexOf(formula[0][ff][0])==-1){f=formula[0][last_sp];var _left=true;switch(f[1][0]){/* note: some bad XLSB files omit the PtgParen */case 4:_left=false;/* falls through */case 0:// $FlowIgnore
sp=fill(" ",f[1][1]);break;case 5:_left=false;/* falls through */case 1:// $FlowIgnore
sp=fill("\r",f[1][1]);break;default:sp="";// $FlowIgnore
if(opts.WTF)throw new Error("Unexpected PtgAttrSpaceType "+f[1][0]);}stack.push((_left?sp:"")+stack.pop()+(_left?"":sp));last_sp=-1;}}if(stack.length>1&&opts.WTF)throw new Error("bad formula stack");return stack[0];}/* [MS-XLS] 2.5.198.1 TODO */function parse_ArrayParsedFormula(blob,length,opts/*::, ref*/){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}/* [MS-XLS] 2.5.198.3 TODO */function parse_XLSCellParsedFormula(blob,length,opts){var target=blob.l+length,len=opts.biff==2?1:2;var rgcb,cce=blob.read_shift(len);// length of rgce
if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce,opts);if(length!==cce+len)rgcb=parse_RgbExtra(blob,length-cce-len,rgce,opts);blob.l=target;return[rgce,rgcb];}/* [MS-XLS] 2.5.198.21 */function parse_NameParsedFormula(blob,length,opts,cce){var target=blob.l+length;var rgce=parse_Rgce(blob,cce,opts);var rgcb;if(target!==blob.l)rgcb=parse_RgbExtra(blob,target-blob.l,rgce,opts);return[rgce,rgcb];}/* [MS-XLS] 2.5.198.118 TODO */function parse_SharedParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);// length of rgce
var rgce=parse_Rgce(blob,cce,opts);if(cce==0xFFFF)return[[],parsenoop(blob,length-2)];if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return[rgce,rgcb];}/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */function parse_FormulaValue(blob/*::, length*/){var b;if(__readUInt16LE(blob,blob.l+6)!==0xFFFF)return[parse_Xnum(blob),'n'];switch(blob[blob.l]){case 0x00:blob.l+=8;return["String",'s'];case 0x01:b=blob[blob.l+2]===0x1;blob.l+=8;return[b,'b'];case 0x02:b=blob[blob.l+2];blob.l+=8;return[b,'e'];case 0x03:blob.l+=8;return["",'s'];}return[];}function write_FormulaValue(value){if(value==null){// Blank String Value
var o=new_buf(8);o.write_shift(1,0x03);o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0xFFFF);return o;}else if(typeof value=="number")return write_Xnum(value);return write_Xnum(0);}/* [MS-XLS] 2.4.127 TODO */function parse_Formula(blob,length,opts){var end=blob.l+length;var cell=parse_XLSCell(blob,6);if(opts.biff==2)++blob.l;var val=parse_FormulaValue(blob,8);var flags=blob.read_shift(1);if(opts.biff!=2){blob.read_shift(1);if(opts.biff>=5){/*var chn = */blob.read_shift(4);}}var cbf=parse_XLSCellParsedFormula(blob,end-blob.l,opts);return{cell:cell,val:val[0],formula:cbf,shared:flags>>3&1,tt:val[1]};}function write_Formula(cell/*:Cell*/,R/*:number*/,C/*:number*/,opts,os/*:number*/){// Cell
var o1=write_XLSCell(R,C,os);// FormulaValue
var o2=write_FormulaValue(cell.v);// flags + cache
var o3=new_buf(6);var flags=0x01|0x20;o3.write_shift(2,flags);o3.write_shift(4,0);// CellParsedFormula
var bf=new_buf(cell.bf.length);for(var i=0;i<cell.bf.length;++i){bf[i]=cell.bf[i];}var out=bconcat([o1,o2,o3,bf]);return out;}/* XLSB Parsed Formula records have the same shape */function parse_XLSBParsedFormula(data,length,opts){var cce=data.read_shift(4);var rgce=parse_Rgce(data,cce,opts);var cb=data.read_shift(4);var rgcb=cb>0?parse_RgbExtra(data,cb,rgce,opts):null;return[rgce,rgcb];}/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */var parse_XLSBArrayParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.4 CellParsedFormula */var parse_XLSBCellParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.8 DVParsedFormula *///var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula *///var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */var parse_XLSBNameParsedFormula=parse_XLSBParsedFormula;/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */var parse_XLSBSharedParsedFormula=parse_XLSBParsedFormula;var Cetab={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var Ftab={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD",380:"CUBEVALUE",381:"CUBEMEMBER",382:"CUBEMEMBERPROPERTY",383:"CUBERANKEDMEMBER",384:"HEX2BIN",385:"HEX2DEC",386:"HEX2OCT",387:"DEC2BIN",388:"DEC2HEX",389:"DEC2OCT",390:"OCT2BIN",391:"OCT2HEX",392:"OCT2DEC",393:"BIN2DEC",394:"BIN2OCT",395:"BIN2HEX",396:"IMSUB",397:"IMDIV",398:"IMPOWER",399:"IMABS",400:"IMSQRT",401:"IMLN",402:"IMLOG2",403:"IMLOG10",404:"IMSIN",405:"IMCOS",406:"IMEXP",407:"IMARGUMENT",408:"IMCONJUGATE",409:"IMAGINARY",410:"IMREAL",411:"COMPLEX",412:"IMSUM",413:"IMPRODUCT",414:"SERIESSUM",415:"FACTDOUBLE",416:"SQRTPI",417:"QUOTIENT",418:"DELTA",419:"GESTEP",420:"ISEVEN",421:"ISODD",422:"MROUND",423:"ERF",424:"ERFC",425:"BESSELJ",426:"BESSELK",427:"BESSELY",428:"BESSELI",429:"XIRR",430:"XNPV",431:"PRICEMAT",432:"YIELDMAT",433:"INTRATE",434:"RECEIVED",435:"DISC",436:"PRICEDISC",437:"YIELDDISC",438:"TBILLEQ",439:"TBILLPRICE",440:"TBILLYIELD",441:"PRICE",442:"YIELD",443:"DOLLARDE",444:"DOLLARFR",445:"NOMINAL",446:"EFFECT",447:"CUMPRINC",448:"CUMIPMT",449:"EDATE",450:"EOMONTH",451:"YEARFRAC",452:"COUPDAYBS",453:"COUPDAYS",454:"COUPDAYSNC",455:"COUPNCD",456:"COUPNUM",457:"COUPPCD",458:"DURATION",459:"MDURATION",460:"ODDLPRICE",461:"ODDLYIELD",462:"ODDFPRICE",463:"ODDFYIELD",464:"RANDBETWEEN",465:"WEEKNUM",466:"AMORDEGRC",467:"AMORLINC",468:"CONVERT",724:"SHEETJS",469:"ACCRINT",470:"ACCRINTM",471:"WORKDAY",472:"NETWORKDAYS",473:"GCD",474:"MULTINOMIAL",475:"LCM",476:"FVSCHEDULE",477:"CUBEKPIMEMBER",478:"CUBESET",479:"CUBESETCOUNT",480:"IFERROR",481:"COUNTIFS",482:"SUMIFS",483:"AVERAGEIF",484:"AVERAGEIFS"};var FtabArgc={2:1,3:1,10:0,15:1,16:1,17:1,18:1,19:0,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,34:0,35:0,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,63:0,65:3,66:3,67:1,68:1,69:1,70:1,71:1,72:1,73:1,74:0,75:1,76:1,77:1,79:2,80:2,83:1,85:0,86:1,89:0,90:1,94:0,95:0,97:2,98:1,99:1,101:3,102:3,105:1,106:1,108:2,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,144:4,161:1,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,186:1,189:3,190:1,195:3,196:3,197:1,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,225:0,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,247:4,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,382:3,385:1,392:1,393:1,396:2,397:2,398:2,399:1,400:1,401:1,402:1,403:1,404:1,405:1,406:1,407:1,408:1,409:1,410:1,414:4,415:1,416:1,417:2,420:1,421:1,422:2,424:1,425:2,426:2,427:2,428:2,430:3,438:3,439:3,440:3,443:2,444:2,445:2,446:2,447:6,448:6,449:2,450:2,464:2,468:3,476:2,479:1,480:2,65535:0};/* Part 3 TODO: actually parse formulae */function ods_to_csf_formula(f/*:string*/)/*:string*/{if(f.slice(0,3)=="of:")f=f.slice(3);/* 5.2 Basic Expressions */if(f.charCodeAt(0)==61){f=f.slice(1);if(f.charCodeAt(0)==61)f=f.slice(1);}f=f.replace(/COM\.MICROSOFT\./g,"");/* Part 3 Section 5.8 References */f=f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g,function($$,$1){return $1.replace(/\./g,"");});/* TODO: something other than this */f=f.replace(/\[.(#[A-Z]*[?!])\]/g,"$1");return f.replace(/[;~]/g,",").replace(/\|/g,";");}function csf_to_ods_formula(f/*:string*/)/*:string*/{var o="of:="+f.replace(crefregex,"$1[.$2$3$4$5]").replace(/\]:\[/g,":");/* TODO: something other than this */return o.replace(/;/g,"|").replace(/,/g,";");}function ods_to_csf_3D(r/*:string*/)/*:[string, string]*/{var a=r.split(":");var s=a[0].split(".")[0];return[s,a[0].split(".")[1]+(a.length>1?":"+(a[1].split(".")[1]||a[1].split(".")[0]):"")];}function csf_to_ods_3D(r/*:string*/)/*:string*/{return r.replace(/\./,"!");}var strs={};// shared strings
var _ssfopts={};// spreadsheet formatting options
/*global Map */var browser_has_Map=typeof _map2.default!=='undefined';function get_sst_id(sst/*:SST*/,str/*:string*/,rev)/*:number*/{var i=0,len=sst.length;if(rev){if(browser_has_Map?rev.has(str):Object.prototype.hasOwnProperty.call(rev,str)){var revarr=browser_has_Map?rev.get(str):rev[str];for(;i<revarr.length;++i){if(sst[revarr[i]].t===str){sst.Count++;return revarr[i];}}}}else for(;i<len;++i){if(sst[i].t===str){sst.Count++;return i;}}sst[len]={t:str/*:any*/};sst.Count++;sst.Unique++;if(rev){if(browser_has_Map){if(!rev.has(str))rev.set(str,[]);rev.get(str).push(len);}else{if(!Object.prototype.hasOwnProperty.call(rev,str))rev[str]=[];rev[str].push(len);}}return len;}function col_obj_w(C/*:number*/,col){var p={min:C+1,max:C+1/*:any*/};/* wch (chars), wpx (pixels) */var wch=-1;if(col.MDW)MDW=col.MDW;if(col.width!=null)p.customWidth=1;else if(col.wpx!=null)wch=px2char(col.wpx);else if(col.wch!=null)wch=col.wch;if(wch>-1){p.width=char2width(wch);p.customWidth=1;}else if(col.width!=null)p.width=col.width;if(col.hidden)p.hidden=true;if(col.level!=null){p.outlineLevel=p.level=col.level;}return p;}function default_margins(margins/*:Margins*/,mode/*:?string*/){if(!margins)return;var defs=[0.7,0.7,0.75,0.75,0.3,0.3];if(mode=='xlml')defs=[1,1,1,1,0.5,0.5];if(margins.left==null)margins.left=defs[0];if(margins.right==null)margins.right=defs[1];if(margins.top==null)margins.top=defs[2];if(margins.bottom==null)margins.bottom=defs[3];if(margins.header==null)margins.header=defs[4];if(margins.footer==null)margins.footer=defs[5];}function get_cell_style(styles/*:Array<any>*/,cell/*:Cell*/,opts){var z=opts.revssf[cell.z!=null?cell.z:"General"];var i=0x3c,len=styles.length;if(z==null&&opts.ssf){for(;i<0x188;++i){if(opts.ssf[i]==null){SSF_load(cell.z,i);// $FlowIgnore
opts.ssf[i]=cell.z;opts.revssf[cell.z]=z=i;break;}}}for(i=0;i!=len;++i){if(styles[i].numFmtId===z)return i;}styles[len]={numFmtId:z,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return len;}function safe_format(p/*:Cell*/,fmtid/*:number*/,fillid/*:?number*/,opts,themes,styles){try{if(opts.cellNF)p.z=table_fmt[fmtid];}catch(e){if(opts.WTF)throw e;}if(p.t==='z'&&!opts.cellStyles)return;if(p.t==='d'&&typeof p.v==='string')p.v=parseDate(p.v);if((!opts||opts.cellText!==false)&&p.t!=='z')try{if(table_fmt[fmtid]==null)SSF_load(SSFImplicit[fmtid]||"General",fmtid);if(p.t==='e')p.w=p.w||BErr[p.v];else if(fmtid===0){if(p.t==='n'){if((p.v|0)===p.v)p.w=p.v.toString(10);else p.w=SSF_general_num(p.v);}else if(p.t==='d'){var dd=datenum(p.v);if((dd|0)===dd)p.w=dd.toString(10);else p.w=SSF_general_num(dd);}else if(p.v===undefined)return"";else p.w=SSF_general(p.v,_ssfopts);}else if(p.t==='d')p.w=SSF_format(fmtid,datenum(p.v),_ssfopts);else p.w=SSF_format(fmtid,p.v,_ssfopts);}catch(e){if(opts.WTF)throw e;}if(!opts.cellStyles)return;if(fillid!=null)try{p.s=styles.Fills[fillid];if(p.s.fgColor&&p.s.fgColor.theme&&!p.s.fgColor.rgb){p.s.fgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb,p.s.fgColor.tint||0);if(opts.WTF)p.s.fgColor.raw_rgb=themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;}if(p.s.bgColor&&p.s.bgColor.theme){p.s.bgColor.rgb=rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb,p.s.bgColor.tint||0);if(opts.WTF)p.s.bgColor.raw_rgb=themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;}}catch(e){if(opts.WTF&&styles.Fills)throw e;}}function check_ws(ws/*:Worksheet*/,sname/*:string*/,i/*:number*/){if(ws&&ws['!ref']){var range=safe_decode_range(ws['!ref']);if(range.e.c<range.s.c||range.e.r<range.s.r)throw new Error("Bad range ("+i+"): "+ws['!ref']);}}function parse_ws_xml_dim(ws/*:Worksheet*/,s/*:string*/){var d=safe_decode_range(s);if(d.s.r<=d.e.r&&d.s.c<=d.e.c&&d.s.r>=0&&d.s.c>=0)ws["!ref"]=encode_range(d);}var mergecregex=/<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;var sheetdataregex=/<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;var hlinkregex=/<(?:\w:)?hyperlink [^>]*>/mg;var dimregex=/"(\w*:\w*)"/;var colregex=/<(?:\w:)?col\b[^>]*[\/]?>/g;var afregex=/<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;var marginregex=/<(?:\w:)?pageMargins[^>]*\/>/g;var sheetprregex=/<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;var sheetprregex2=/<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;var svsregex=/<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;/* 18.3 Worksheets */function parse_ws_xml(data/*:?string*/,opts,idx/*:number*/,rels,wb/*:WBWBProps*/,themes,styles)/*:Worksheet*/{if(!data)return data;if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;/* 18.3.1.99 worksheet CT_Worksheet */var s=opts.dense?[]/*:any*/:{}/*:any*/;var refguess/*:Range*/={s:{r:2000000,c:2000000},e:{r:0,c:0}/*:any*/};var data1="",data2="";var mtch/*:?any*/=data.match(sheetdataregex);if(mtch){data1=data.slice(0,mtch.index);data2=data.slice(mtch.index+mtch[0].length);}else data1=data2=data;/* 18.3.1.82 sheetPr CT_SheetPr */var sheetPr=data1.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);else if(sheetPr=data1.match(sheetprregex2))parse_ws_xml_sheetpr2(sheetPr[0],sheetPr[1]||"",s,wb,idx,styles,themes);/* 18.3.1.35 dimension CT_SheetDimension */var ridx=(data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;if(ridx>0){var ref=data1.slice(ridx,ridx+50).match(dimregex);if(ref)parse_ws_xml_dim(s,ref[1]);}/* 18.3.1.88 sheetViews CT_SheetViews */var svs=data1.match(svsregex);if(svs&&svs[1])parse_ws_xml_sheetviews(svs[1],wb);/* 18.3.1.17 cols CT_Cols */var columns/*:Array<ColInfo>*/=[];if(opts.cellStyles){/* 18.3.1.13 col CT_Col */var cols=data1.match(colregex);if(cols)parse_ws_xml_cols(columns,cols);}/* 18.3.1.80 sheetData CT_SheetData ? */if(mtch)parse_ws_xml_data(mtch[1],s,opts,refguess,themes,styles);/* 18.3.1.2  autoFilter CT_AutoFilter */var afilter=data2.match(afregex);if(afilter)s['!autofilter']=parse_ws_xml_autofilter(afilter[0]);/* 18.3.1.55 mergeCells CT_MergeCells */var merges/*:Array<Range>*/=[];var _merge=data2.match(mergecregex);if(_merge)for(ridx=0;ridx!=_merge.length;++ridx){merges[ridx]=safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));}/* 18.3.1.48 hyperlinks CT_Hyperlinks */var hlink=data2.match(hlinkregex);if(hlink)parse_ws_xml_hlinks(s,hlink,rels);/* 18.3.1.62 pageMargins CT_PageMargins */var margins=data2.match(marginregex);if(margins)s['!margins']=parse_ws_xml_margins(parsexmltag(margins[0]));if(!s["!ref"]&&refguess.e.c>=refguess.s.c&&refguess.e.r>=refguess.s.r)s["!ref"]=encode_range(refguess);if(opts.sheetRows>0&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(columns.length>0)s["!cols"]=columns;if(merges.length>0)s["!merges"]=merges;return s;}function write_ws_xml_merges(merges/*:Array<Range>*/)/*:string*/{if(merges.length===0)return"";var o='<mergeCells count="'+merges.length+'">';for(var i=0;i!=merges.length;++i){o+='<mergeCell ref="'+encode_range(merges[i])+'"/>';}return o+'</mergeCells>';}/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */function parse_ws_xml_sheetpr(sheetPr/*:string*/,s,wb/*:WBWBProps*/,idx/*:number*/){var data=parsexmltag(sheetPr);if(!wb.Sheets[idx])wb.Sheets[idx]={};if(data.codeName)wb.Sheets[idx].CodeName=unescapexml(utf8read(data.codeName));}function parse_ws_xml_sheetpr2(sheetPr/*:string*/,body/*:string*/,s,wb/*:WBWBProps*/,idx/*:number*/){parse_ws_xml_sheetpr(sheetPr.slice(0,sheetPr.indexOf(">")),s,wb,idx);}function write_ws_xml_sheetpr(ws,wb,idx,opts,o){var needed=false;var props={},payload=null;if(opts.bookType!=='xlsx'&&wb.vbaraw){var cname=wb.SheetNames[idx];try{if(wb.Workbook)cname=wb.Workbook.Sheets[idx].CodeName||cname;}catch(e){}needed=true;props.codeName=utf8write(escapexml(cname));}if(ws&&ws["!outline"]){var outlineprops={summaryBelow:1,summaryRight:1};if(ws["!outline"].above)outlineprops.summaryBelow=0;if(ws["!outline"].left)outlineprops.summaryRight=0;payload=(payload||"")+writextag('outlinePr',null,outlineprops);}if(!needed&&!payload)return;o[o.length]=writextag('sheetPr',payload,props);}/* 18.3.1.85 sheetProtection CT_SheetProtection */var sheetprot_deffalse=["objects","scenarios","selectLockedCells","selectUnlockedCells"];var sheetprot_deftrue=["formatColumns","formatRows","formatCells","insertColumns","insertRows","insertHyperlinks","deleteColumns","deleteRows","sort","autoFilter","pivotTables"];function write_ws_xml_protection(sp)/*:string*/{// algorithmName, hashValue, saltValue, spinCount
var o={sheet:1/*:any*/};sheetprot_deffalse.forEach(function(n){if(sp[n]!=null&&sp[n])o[n]="1";});sheetprot_deftrue.forEach(function(n){if(sp[n]!=null&&!sp[n])o[n]="0";});/* TODO: algorithm */if(sp.password)o.password=crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();return writextag('sheetProtection',null,o);}function parse_ws_xml_hlinks(s,data/*:Array<string>*/,rels){var dense=Array.isArray(s);for(var i=0;i!=data.length;++i){var val=parsexmltag(utf8read(data[i]),true);if(!val.ref)return;var rel=((rels||{})['!id']||[])[val.id];if(rel){val.Target=rel.Target;if(val.location)val.Target+="#"+unescapexml(val.location);}else{val.Target="#"+unescapexml(val.location);rel={Target:val.Target,TargetMode:'Internal'};}val.Rel=rel;if(val.tooltip){val.Tooltip=val.tooltip;delete val.tooltip;}var rng=safe_decode_range(val.ref);for(var R=rng.s.r;R<=rng.e.r;++R){for(var C=rng.s.c;C<=rng.e.c;++C){var addr=encode_cell({c:C,r:R});if(dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:"z",v:undefined};s[R][C].l=val;}else{if(!s[addr])s[addr]={t:"z",v:undefined};s[addr].l=val;}}}}}function parse_ws_xml_margins(margin){var o={};["left","right","top","bottom","header","footer"].forEach(function(k){if(margin[k])o[k]=parseFloat(margin[k]);});return o;}function write_ws_xml_margins(margin)/*:string*/{default_margins(margin);return writextag('pageMargins',null,margin);}function parse_ws_xml_cols(columns,cols){var seencol=false;for(var coli=0;coli!=cols.length;++coli){var coll=parsexmltag(cols[coli],true);if(coll.hidden)coll.hidden=parsexmlbool(coll.hidden);var colm=parseInt(coll.min,10)-1,colM=parseInt(coll.max,10)-1;if(coll.outlineLevel)coll.level=+coll.outlineLevel||0;delete coll.min;delete coll.max;coll.width=+coll.width;if(!seencol&&coll.width){seencol=true;find_mdw_colw(coll.width);}process_col(coll);while(colm<=colM){columns[colm++]=dup(coll);}}}function write_ws_xml_cols(ws,cols)/*:string*/{var o=["<cols>"],col;for(var i=0;i!=cols.length;++i){if(!(col=cols[i]))continue;o[o.length]=writextag('col',null,col_obj_w(i,col));}o[o.length]="</cols>";return o.join("");}function parse_ws_xml_autofilter(data/*:string*/){var o={ref:(data.match(/ref="([^"]*)"/)||[])[1]};return o;}function write_ws_xml_autofilter(data,ws,wb,idx)/*:string*/{var ref=typeof data.ref=="string"?data.ref:encode_range(data.ref);if(!wb.Workbook)wb.Workbook={Sheets:[]/*:any*/};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names/*: Array<any> */=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});return writextag("autoFilter",null,{ref:ref});}/* 18.3.1.88 sheetViews CT_SheetViews *//* 18.3.1.87 sheetView CT_SheetView */var sviewregex=/<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;function parse_ws_xml_sheetviews(data,wb/*:WBWBProps*/){if(!wb.Views)wb.Views=[{}];(data.match(sviewregex)||[]).forEach(function(r/*:string*/,i/*:number*/){var tag=parsexmltag(r);// $FlowIgnore
if(!wb.Views[i])wb.Views[i]={};// $FlowIgnore
if(+tag.zoomScale)wb.Views[i].zoom=+tag.zoomScale;// $FlowIgnore
if(parsexmlbool(tag.rightToLeft))wb.Views[i].RTL=true;});}function write_ws_xml_sheetviews(ws,opts,idx,wb)/*:string*/{var sview={workbookViewId:"0"/*:any*/};// $FlowIgnore
if((((wb||{}).Workbook||{}).Views||[])[0])sview.rightToLeft=wb.Workbook.Views[0].RTL?"1":"0";return writextag("sheetViews",writextag("sheetView",null,sview),{});}function write_ws_xml_cell(cell/*:Cell*/,ref,ws,opts/*::, idx, wb*/)/*:string*/{if(cell.c)ws['!comments'].push([ref,cell.c]);if(cell.v===undefined&&typeof cell.f!=="string"||cell.t==='z'&&!cell.f)return"";var vv="";var oldt=cell.t,oldv=cell.v;if(cell.t!=="z")switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'n':vv=''+cell.v;break;case'e':vv=BErr[cell.v];break;case'd':if(opts&&opts.cellDates)vv=parseDate(cell.v,-1).toISOString();else{cell=dup(cell);cell.t='n';vv=''+(cell.v=datenum(parseDate(cell.v)));}if(typeof cell.z==='undefined')cell.z=table_fmt[14];break;default:vv=cell.v;break;}var v=writetag('v',escapexml(vv)),o={r:ref/*:any*/};/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);if(os!==0)o.s=os;switch(cell.t){case'n':break;case'd':o.t="d";break;case'b':o.t="b";break;case'e':o.t="e";break;case'z':break;default:if(cell.v==null){delete cell.t;break;}if(cell.v.length>32767)throw new Error("Text length must not exceed 32767 characters");if(opts&&opts.bookSST){v=writetag('v',''+get_sst_id(opts.Strings,cell.v,opts.revStrings));o.t="s";break;}o.t="str";break;}if(cell.t!=oldt){cell.t=oldt;cell.v=oldv;}if(typeof cell.f=="string"&&cell.f){var ff=cell.F&&cell.F.slice(0,ref.length)==ref?{t:"array",ref:cell.F}:null;v=writextag('f',escapexml(cell.f),ff)+(cell.v!=null?v:"");}if(cell.l)ws['!links'].push([ref,cell.l]);if(cell.D)o.cm=1;return writextag('c',v,o);}var parse_ws_xml_data=/*#__PURE__*/function(){var cellregex=/<(?:\w+:)?c[ \/>]/,rowregex=/<\/(?:\w+:)?row>/;var rregex=/r=["']([^"']*)["']/,isregex=/<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;var refregex=/ref=["']([^"']*)["']/;var match_v=matchtag("v"),match_f=matchtag("f");return function parse_ws_xml_data(sdata/*:string*/,s,opts,guess/*:Range*/,themes,styles){var ri=0,x="",cells/*:Array<string>*/=[],cref/*:?Array<string>*/=[],idx=0,i=0,cc=0,d="",p/*:any*/;var tag,tagr=0,tagc=0;var sstr,ftag;var fmtid=0,fillid=0;var do_format=Array.isArray(styles.CellXf),cf;var arrayf/*:Array<[Range, string]>*/=[];var sharedf=[];var dense=Array.isArray(s);var rows/*:Array<RowInfo>*/=[],rowobj={},rowrite=false;var sheetStubs=!!opts.sheetStubs;for(var marr=sdata.split(rowregex),mt=0,marrlen=marr.length;mt!=marrlen;++mt){x=marr[mt].trim();var xlen=x.length;if(xlen===0)continue;/* 18.3.1.73 row CT_Row */var rstarti=0;outa:for(ri=0;ri<xlen;++ri){switch(/*x.charCodeAt(ri)*/x[ri]){case">"/*62*/:if(/*x.charCodeAt(ri-1) != 47*/x[ri-1]!="/"){++ri;break outa;}if(opts&&opts.cellStyles){// TODO: avoid duplication
tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}break;case"<"/*60*/:rstarti=ri;break;}}if(rstarti>=ri)break;tag=parsexmltag(x.slice(rstarti,ri),true);tagr=tag.r!=null?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;if(guess.s.r>tagr-1)guess.s.r=tagr-1;if(guess.e.r<tagr-1)guess.e.r=tagr-1;if(opts&&opts.cellStyles){rowobj={};rowrite=false;if(tag.ht){rowrite=true;rowobj.hpt=parseFloat(tag.ht);rowobj.hpx=pt2px(rowobj.hpt);}if(tag.hidden=="1"){rowrite=true;rowobj.hidden=true;}if(tag.outlineLevel!=null){rowrite=true;rowobj.level=+tag.outlineLevel;}if(rowrite)rows[tagr-1]=rowobj;}/* 18.3.1.4 c CT_Cell */cells=x.slice(ri).split(cellregex);for(var rslice=0;rslice!=cells.length;++rslice){if(cells[rslice].trim().charAt(0)!="<")break;}cells=cells.slice(rslice);for(ri=0;ri!=cells.length;++ri){x=cells[ri].trim();if(x.length===0)continue;cref=x.match(rregex);idx=ri;i=0;cc=0;x="<c "+(x.slice(0,1)=="<"?">":"")+x;if(cref!=null&&cref.length===2){idx=0;d=cref[1];for(i=0;i!=d.length;++i){if((cc=d.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc;}--idx;tagc=idx;}else++tagc;for(i=0;i!=x.length;++i){if(x.charCodeAt(i)===62)break;}++i;tag=parsexmltag(x.slice(0,i),true);if(!tag.r)tag.r=encode_cell({r:tagr-1,c:tagc});d=x.slice(i);p={t:""/*:any*/};if((cref=d.match(match_v))!=null&&/*::cref != null && */cref[1]!=='')p.v=unescapexml(cref[1]);if(opts.cellFormula){if((cref=d.match(match_f))!=null&&/*::cref != null && */cref[1]!==''){/* TODO: match against XLSXFutureFunctions */p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g,"\n");if(!opts.xlfn)p.f=_xlfn(p.f);if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="array"')>-1){p.F=(d.match(refregex)||[])[1];if(p.F.indexOf(":")>-1)arrayf.push([safe_decode_range(p.F),p.F]);}else if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="shared"')>-1){// TODO: parse formula
ftag=parsexmltag(cref[0]);var ___f=unescapexml(utf8read(cref[1]));if(!opts.xlfn)___f=_xlfn(___f);sharedf[parseInt(ftag.si,10)]=[ftag,___f,tag.r];}}else if(cref=d.match(/<f[^>]*\/>/)){ftag=parsexmltag(cref[0]);if(sharedf[ftag.si])p.f=shift_formula_xlsx(sharedf[ftag.si][1],sharedf[ftag.si][2]/*[0].ref*/,tag.r);}/* TODO: factor out contains logic */var _tag=decode_cell(tag.r);for(i=0;i<arrayf.length;++i){if(_tag.r>=arrayf[i][0].s.r&&_tag.r<=arrayf[i][0].e.r)if(_tag.c>=arrayf[i][0].s.c&&_tag.c<=arrayf[i][0].e.c)p.F=arrayf[i][1];}}if(tag.t==null&&p.v===undefined){if(p.f||p.F){p.v=0;p.t="n";}else if(!sheetStubs)continue;else p.t="z";}else p.t=tag.t||"n";if(guess.s.c>tagc)guess.s.c=tagc;if(guess.e.c<tagc)guess.e.c=tagc;/* 18.18.11 t ST_CellType */switch(p.t){case'n':if(p.v==""||p.v==null){if(!sheetStubs)continue;p.t='z';}else p.v=parseFloat(p.v);break;case's':if(typeof p.v=='undefined'){if(!sheetStubs)continue;p.t='z';}else{sstr=strs[parseInt(p.v,10)];p.v=sstr.t;p.r=sstr.r;if(opts.cellHTML)p.h=sstr.h;}break;case'str':p.t="s";p.v=p.v!=null?utf8read(p.v):'';if(opts.cellHTML)p.h=escapehtml(p.v);break;case'inlineStr':cref=d.match(isregex);p.t='s';if(cref!=null&&(sstr=parse_si(cref[1]))){p.v=sstr.t;if(opts.cellHTML)p.h=sstr.h;}else p.v="";break;case'b':p.v=parsexmlbool(p.v);break;case'd':if(opts.cellDates)p.v=parseDate(p.v,1);else{p.v=datenum(parseDate(p.v,1));p.t='n';}break;/* error string in .w, number in .v */case'e':if(!opts||opts.cellText!==false)p.w=p.v;p.v=RBErr[p.v];break;}/* formatting */fmtid=fillid=0;cf=null;if(do_format&&tag.s!==undefined){cf=styles.CellXf[tag.s];if(cf!=null){if(cf.numFmtId!=null)fmtid=cf.numFmtId;if(opts.cellStyles){if(cf.fillId!=null)fillid=cf.fillId;}}}safe_format(p,fmtid,fillid,opts,themes,styles);if(opts.cellDates&&do_format&&p.t=='n'&&fmt_is_date(table_fmt[fmtid])){p.t='d';p.v=numdate(p.v);}if(tag.cm&&opts.xlmeta){var cm=(opts.xlmeta.Cell||[])[+tag.cm-1];if(cm&&cm.type=='XLDAPR')p.D=true;}if(dense){var _r=decode_cell(tag.r);if(!s[_r.r])s[_r.r]=[];s[_r.r][_r.c]=p;}else s[tag.r]=p;}}if(rows.length>0)s['!rows']=rows;};}();function write_ws_xml_data(ws/*:Worksheet*/,opts,idx/*:number*/,wb/*:Workbook*//*::, rels*/)/*:string*/{var o/*:Array<string>*/=[],r/*:Array<string>*/=[],range=safe_decode_range(ws['!ref']),cell="",ref,rr="",cols/*:Array<string>*/=[],R=0,C=0,rows=ws['!rows'];var dense=Array.isArray(ws);var params={r:rr/*:any*/},row/*:RowInfo*/,height=-1;for(C=range.s.c;C<=range.e.c;++C){cols[C]=encode_col(C);}for(R=range.s.r;R<=range.e.r;++R){r=[];rr=encode_row(R);for(C=range.s.c;C<=range.e.c;++C){ref=cols[C]+rr;var _cell=dense?(ws[R]||[])[C]:ws[ref];if(_cell===undefined)continue;if((cell=write_ws_xml_cell(_cell,ref,ws,opts,idx,wb))!=null)r.push(cell);}if(r.length>0||rows&&rows[R]){params={r:rr/*:any*/};if(rows&&rows[R]){row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}}o[o.length]=writextag('row',r.join(""),params);}}if(rows)for(;R<rows.length;++R){if(rows&&rows[R]){params={r:R+1/*:any*/};row=rows[R];if(row.hidden)params.hidden=1;height=-1;if(row.hpx)height=px2pt(row.hpx);else if(row.hpt)height=row.hpt;if(height>-1){params.ht=height;params.customHeight=1;}if(row.level){params.outlineLevel=row.level;}o[o.length]=writextag('row',"",params);}}return o.join("");}function write_ws_xml(idx/*:number*/,opts,wb/*:Workbook*/,rels)/*:string*/{var o=[XML_HEADER,writextag('worksheet',null,{'xmlns':XMLNS_main[0],'xmlns:r':XMLNS.r})];var s=wb.SheetNames[idx],sidx=0,rdata="";var ws=wb.Sheets[s];if(ws==null)ws={};var ref=ws['!ref']||'A1';var range=safe_decode_range(ref);if(range.e.c>0x3FFF||range.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+ref+" exceeds format limit A1:XFD1048576");range.e.c=Math.min(range.e.c,0x3FFF);range.e.r=Math.min(range.e.c,0xFFFFF);ref=encode_range(range);}if(!rels)rels={};ws['!comments']=[];var _drawing=[];write_ws_xml_sheetpr(ws,wb,idx,opts,o);o[o.length]=writextag('dimension',null,{'ref':ref});o[o.length]=write_ws_xml_sheetviews(ws,opts,idx,wb);/* TODO: store in WB, process styles */if(opts.sheetFormat)o[o.length]=writextag('sheetFormatPr',null,{defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',baseColWidth:opts.sheetFormat.baseColWidth||'10',outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'});if(ws['!cols']!=null&&ws['!cols'].length>0)o[o.length]=write_ws_xml_cols(ws,ws['!cols']);o[sidx=o.length]='<sheetData/>';ws['!links']=[];if(ws['!ref']!=null){rdata=write_ws_xml_data(ws,opts,idx,wb,rels);if(rdata.length>0)o[o.length]=rdata;}if(o.length>sidx+1){o[o.length]='</sheetData>';o[sidx]=o[sidx].replace("/>",">");}/* sheetCalcPr */if(ws['!protect'])o[o.length]=write_ws_xml_protection(ws['!protect']);/* protectedRanges *//* scenarios */if(ws['!autofilter']!=null)o[o.length]=write_ws_xml_autofilter(ws['!autofilter'],ws,wb,idx);/* sortState *//* dataConsolidate *//* customSheetViews */if(ws['!merges']!=null&&ws['!merges'].length>0)o[o.length]=write_ws_xml_merges(ws['!merges']);/* phoneticPr *//* conditionalFormatting *//* dataValidations */var relc=-1,rel,rId=-1;if(/*::(*/ws['!links']/*::||[])*/.length>0){o[o.length]="<hyperlinks>";/*::(*/ws['!links']/*::||[])*/.forEach(function(l){if(!l[1].Target)return;rel={"ref":l[0]/*:any*/};if(l[1].Target.charAt(0)!="#"){rId=add_rels(rels,-1,escapexml(l[1].Target).replace(/#.*$/,""),RELS.HLINK);rel["r:id"]="rId"+rId;}if((relc=l[1].Target.indexOf("#"))>-1)rel.location=escapexml(l[1].Target.slice(relc+1));if(l[1].Tooltip)rel.tooltip=escapexml(l[1].Tooltip);o[o.length]=writextag("hyperlink",null,rel);});o[o.length]="</hyperlinks>";}delete ws['!links'];/* printOptions */if(ws['!margins']!=null)o[o.length]=write_ws_xml_margins(ws['!margins']);/* pageSetup *//* headerFooter *//* rowBreaks *//* colBreaks *//* customProperties *//* cellWatches */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)o[o.length]=writetag("ignoredErrors",writextag("ignoredError",null,{numberStoredAsText:1,sqref:ref}));/* smartTags */if(_drawing.length>0){rId=add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);o[o.length]=writextag("drawing",null,{"r:id":"rId"+rId});ws['!drawing']=_drawing;}if(ws['!comments'].length>0){rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);o[o.length]=writextag("legacyDrawing",null,{"r:id":"rId"+rId});ws['!legacy']=rId;}/* legacyDrawingHF *//* picture *//* oleObjects *//* controls *//* webPublishItems *//* tableParts *//* extLst */if(o.length>1){o[o.length]='</worksheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.726 BrtRowHdr */function parse_BrtRowHdr(data,length){var z={}/*:any*/;var tgt=data.l+length;z.r=data.read_shift(4);data.l+=4;// TODO: ixfe
var miyRw=data.read_shift(2);data.l+=1;// TODO: top/bot padding
var flags=data.read_shift(1);data.l=tgt;if(flags&0x07)z.level=flags&0x07;if(flags&0x10)z.hidden=true;if(flags&0x20)z.hpt=miyRw/20;return z;}function write_BrtRowHdr(R/*:number*/,range,ws){var o=new_buf(17+8*16);var row=(ws['!rows']||[])[R]||{};o.write_shift(4,R);o.write_shift(4,0);/* TODO: ixfe */var miyRw=0x0140;if(row.hpx)miyRw=px2pt(row.hpx)*20;else if(row.hpt)miyRw=row.hpt*20;o.write_shift(2,miyRw);o.write_shift(1,0);/* top/bot padding */var flags=0x0;if(row.level)flags|=row.level;if(row.hidden)flags|=0x10;if(row.hpx||row.hpt)flags|=0x20;o.write_shift(1,flags);o.write_shift(1,0);/* phonetic guide *//* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */var ncolspan=0,lcs=o.l;o.l+=4;var caddr={r:R,c:0};for(var i=0;i<16;++i){if(range.s.c>i+1<<10||range.e.c<i<<10)continue;var first=-1,last=-1;for(var j=i<<10;j<i+1<<10;++j){caddr.c=j;var cell=Array.isArray(ws)?(ws[caddr.r]||[])[caddr.c]:ws[encode_cell(caddr)];if(cell){if(first<0)first=j;last=j;}}if(first<0)continue;++ncolspan;o.write_shift(4,first);o.write_shift(4,last);}var l=o.l;o.l=lcs;o.write_shift(4,ncolspan);o.l=l;return o.length>o.l?o.slice(0,o.l):o;}function write_row_header(ba,ws,range,R){var o=write_BrtRowHdr(R,range,ws);if(o.length>17||(ws['!rows']||[])[R])write_record(ba,0x0000/* BrtRowHdr */,o);}/* [MS-XLSB] 2.4.820 BrtWsDim */var parse_BrtWsDim=parse_UncheckedRfX;var write_BrtWsDim=write_UncheckedRfX;/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */function parse_BrtWsFmtInfo()/*::data, length*/{}//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */function parse_BrtWsProp(data,length){var z={};var f=data[data.l];++data.l;z.above=!(f&0x40);z.left=!(f&0x80);/* TODO: pull flags */data.l+=18;z.name=parse_XLSBCodeName(data,length-19);return z;}function write_BrtWsProp(str,outl,o){if(o==null)o=new_buf(84+4*str.length);var f=0xC0;if(outl){if(outl.above)f&=~0x40;if(outl.left)f&=~0x80;}o.write_shift(1,f);for(var i=1;i<3;++i){o.write_shift(1,0);}write_BrtColor({auto:1},o);o.write_shift(-4,-1);o.write_shift(-4,-1);write_XLSBCodeName(str,o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.306 BrtCellBlank */function parse_BrtCellBlank(data){var cell=parse_XLSBCell(data);return[cell];}function write_BrtCellBlank(cell,ncell,o){if(o==null)o=new_buf(8);return write_XLSBCell(ncell,o);}function parse_BrtShortBlank(data){var cell=parse_XLSBShortCell(data);return[cell];}function write_BrtShortBlank(cell,ncell,o){if(o==null)o=new_buf(4);return write_XLSBShortCell(ncell,o);}/* [MS-XLSB] 2.4.307 BrtCellBool */function parse_BrtCellBool(data){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtCellBool(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}function parse_BrtShortBool(data){var cell=parse_XLSBShortCell(data);var fBool=data.read_shift(1);return[cell,fBool,'b'];}function write_BrtShortBool(cell,ncell,o){if(o==null)o=new_buf(5);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v?1:0);return o;}/* [MS-XLSB] 2.4.308 BrtCellError */function parse_BrtCellError(data){var cell=parse_XLSBCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtCellError(cell,ncell,o){if(o==null)o=new_buf(9);write_XLSBCell(ncell,o);o.write_shift(1,cell.v);return o;}function parse_BrtShortError(data){var cell=parse_XLSBShortCell(data);var bError=data.read_shift(1);return[cell,bError,'e'];}function write_BrtShortError(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(1,cell.v);o.write_shift(2,0);o.write_shift(1,0);return o;}/* [MS-XLSB] 2.4.311 BrtCellIsst */function parse_BrtCellIsst(data){var cell=parse_XLSBCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtCellIsst(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);o.write_shift(4,ncell.v);return o;}function parse_BrtShortIsst(data){var cell=parse_XLSBShortCell(data);var isst=data.read_shift(4);return[cell,isst,'s'];}function write_BrtShortIsst(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);o.write_shift(4,ncell.v);return o;}/* [MS-XLSB] 2.4.313 BrtCellReal */function parse_BrtCellReal(data){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtCellReal(cell,ncell,o){if(o==null)o=new_buf(16);write_XLSBCell(ncell,o);write_Xnum(cell.v,o);return o;}function parse_BrtShortReal(data){var cell=parse_XLSBShortCell(data);var value=parse_Xnum(data);return[cell,value,'n'];}function write_BrtShortReal(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBShortCell(ncell,o);write_Xnum(cell.v,o);return o;}/* [MS-XLSB] 2.4.314 BrtCellRk */function parse_BrtCellRk(data){var cell=parse_XLSBCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtCellRk(cell,ncell,o){if(o==null)o=new_buf(12);write_XLSBCell(ncell,o);write_RkNumber(cell.v,o);return o;}function parse_BrtShortRk(data){var cell=parse_XLSBShortCell(data);var value=parse_RkNumber(data);return[cell,value,'n'];}function write_BrtShortRk(cell,ncell,o){if(o==null)o=new_buf(8);write_XLSBShortCell(ncell,o);write_RkNumber(cell.v,o);return o;}/* [MS-XLSB] 2.4.323 BrtCellRString */function parse_BrtCellRString(data){var cell=parse_XLSBCell(data);var value=parse_RichStr(data);return[cell,value,'is'];}/* [MS-XLSB] 2.4.317 BrtCellSt */function parse_BrtCellSt(data){var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtCellSt(cell,ncell,o){if(o==null)o=new_buf(12+4*cell.v.length);write_XLSBCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}function parse_BrtShortSt(data){var cell=parse_XLSBShortCell(data);var value=parse_XLWideString(data);return[cell,value,'str'];}function write_BrtShortSt(cell,ncell,o){if(o==null)o=new_buf(8+4*cell.v.length);write_XLSBShortCell(ncell,o);write_XLWideString(cell.v,o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.653 BrtFmlaBool */function parse_BrtFmlaBool(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'b'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.654 BrtFmlaError */function parse_BrtFmlaError(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=data.read_shift(1);var o=[cell,value,'e'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.655 BrtFmlaNum */function parse_BrtFmlaNum(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_Xnum(data);var o=[cell,value,'n'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.656 BrtFmlaString */function parse_BrtFmlaString(data,length,opts){var end=data.l+length;var cell=parse_XLSBCell(data);cell.r=opts['!row'];var value=parse_XLWideString(data);var o=[cell,value,'str'];if(opts.cellFormula){data.l+=2;var formula=parse_XLSBCellParsedFormula(data,end-data.l,opts);o[3]=stringify_formula(formula,null/*range*/,cell,opts.supbooks,opts);/* TODO */}else data.l=end;return o;}/* [MS-XLSB] 2.4.682 BrtMergeCell */var parse_BrtMergeCell=parse_UncheckedRfX;var write_BrtMergeCell=write_UncheckedRfX;/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */function write_BrtBeginMergeCells(cnt,o){if(o==null)o=new_buf(4);o.write_shift(4,cnt);return o;}/* [MS-XLSB] 2.4.662 BrtHLink */function parse_BrtHLink(data,length/*::, opts*/){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var relId=parse_XLNullableWideString(data);var loc=parse_XLWideString(data);var tooltip=parse_XLWideString(data);var display=parse_XLWideString(data);data.l=end;var o={rfx:rfx,relId:relId,loc:loc,display:display/*:any*/};if(tooltip)o.Tooltip=tooltip;return o;}function write_BrtHLink(l,rId){var o=new_buf(50+4*(l[1].Target.length+(l[1].Tooltip||"").length));write_UncheckedRfX({s:decode_cell(l[0]),e:decode_cell(l[0])},o);write_RelID("rId"+rId,o);var locidx=l[1].Target.indexOf("#");var loc=locidx==-1?"":l[1].Target.slice(locidx+1);write_XLWideString(loc||"",o);write_XLWideString(l[1].Tooltip||"",o);write_XLWideString("",o);return o.slice(0,o.l);}/* [MS-XLSB] 2.4.692 BrtPane */function parse_BrtPane()/*data, length, opts*/{}/* [MS-XLSB] 2.4.6 BrtArrFmla */function parse_BrtArrFmla(data,length,opts){var end=data.l+length;var rfx=parse_RfX(data,16);var fAlwaysCalc=data.read_shift(1);var o=[rfx];o[2]=fAlwaysCalc;if(opts.cellFormula){var formula=parse_XLSBArrayParsedFormula(data,end-data.l,opts);o[1]=formula;}else data.l=end;return o;}/* [MS-XLSB] 2.4.750 BrtShrFmla */function parse_BrtShrFmla(data,length,opts){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var o=[rfx];if(opts.cellFormula){var formula=parse_XLSBSharedParsedFormula(data,end-data.l,opts);o[1]=formula;data.l=end;}else data.l=end;return o;}/* [MS-XLSB] 2.4.323 BrtColInfo *//* TODO: once XLS ColInfo is set, combine the functions */function write_BrtColInfo(C/*:number*/,col,o){if(o==null)o=new_buf(18);var p=col_obj_w(C,col);o.write_shift(-4,C);o.write_shift(-4,C);o.write_shift(4,(p.width||10)*256);o.write_shift(4,0/*ixfe*/);// style
var flags=0;if(col.hidden)flags|=0x01;if(typeof p.width=='number')flags|=0x02;if(col.level)flags|=col.level<<8;o.write_shift(2,flags);// bit flag
return o;}/* [MS-XLSB] 2.4.678 BrtMargins */var BrtMarginKeys=["left","right","top","bottom","header","footer"];function parse_BrtMargins(data/*::, length, opts*/)/*:Margins*/{var margins={}/*:any*/;BrtMarginKeys.forEach(function(k){margins[k]=parse_Xnum(data,8);});return margins;}function write_BrtMargins(margins/*:Margins*/,o){if(o==null)o=new_buf(6*8);default_margins(margins);BrtMarginKeys.forEach(function(k){write_Xnum(margins/*:any*/[k],o);});return o;}/* [MS-XLSB] 2.4.299 BrtBeginWsView */function parse_BrtBeginWsView(data/*::, length, opts*/){var f=data.read_shift(2);data.l+=28;return{RTL:f&0x20};}function write_BrtBeginWsView(ws,Workbook,o){if(o==null)o=new_buf(30);var f=0x39c;if((((Workbook||{}).Views||[])[0]||{}).RTL)f|=0x20;o.write_shift(2,f);// bit flag
o.write_shift(4,0);o.write_shift(4,0);// view first row
o.write_shift(4,0);// view first col
o.write_shift(1,0);// gridline color ICV
o.write_shift(1,0);o.write_shift(2,0);o.write_shift(2,100);// zoom scale
o.write_shift(2,0);o.write_shift(2,0);o.write_shift(2,0);o.write_shift(4,0);// workbook view id
return o;}/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */function write_BrtCellIgnoreEC(ref){var o=new_buf(24);o.write_shift(4,4);o.write_shift(4,1);write_UncheckedRfX(ref,o);return o;}/* [MS-XLSB] 2.4.748 BrtSheetProtection */function write_BrtSheetProtection(sp,o){if(o==null)o=new_buf(16*4+2);o.write_shift(2,sp.password?crypto_CreatePasswordVerifier_Method1(sp.password):0);o.write_shift(4,1);// this record should not be written if no protection
[["objects",false],// fObjects
["scenarios",false],// fScenarios
["formatCells",true],// fFormatCells
["formatColumns",true],// fFormatColumns
["formatRows",true],// fFormatRows
["insertColumns",true],// fInsertColumns
["insertRows",true],// fInsertRows
["insertHyperlinks",true],// fInsertHyperlinks
["deleteColumns",true],// fDeleteColumns
["deleteRows",true],// fDeleteRows
["selectLockedCells",false],// fSelLockedCells
["sort",true],// fSort
["autoFilter",true],// fAutoFilter
["pivotTables",true],// fPivotTables
["selectUnlockedCells",false]// fSelUnlockedCells
].forEach(function(n){/*:: if(o == null) throw "unreachable"; */if(n[1])o.write_shift(4,sp[n[0]]!=null&&!sp[n[0]]?1:0);else o.write_shift(4,sp[n[0]]!=null&&sp[n[0]]?0:1);});return o;}function parse_BrtDVal()/*data, length, opts*/{}function parse_BrtDVal14()/*data, length, opts*/{}/* [MS-XLSB] 2.1.7.61 Worksheet */function parse_ws_bin(data,_opts,idx,rels,wb/*:WBWBProps*/,themes,styles)/*:Worksheet*/{if(!data)return data;var opts=_opts||{};if(!rels)rels={'!id':{}};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var s/*:Worksheet*/=opts.dense?[]:{};var ref;var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};var state/*:Array<string>*/=[];var pass=false,end=false;var row,p,cf,R,C,addr,sstr,rr,cell/*:Cell*/;var merges/*:Array<Range>*/=[];opts.biff=12;opts['!row']=0;var ai=0,af=false;var arrayf/*:Array<[Range, string]>*/=[];var sharedf={};var supbooks=opts.supbooks||/*::(*/wb/*:: :any)*/.supbooks||[[]]/*:any*/;supbooks.sharedf=sharedf;supbooks.arrayf=arrayf;supbooks.SheetNames=wb.SheetNames||wb.Sheets.map(function(x){return x.name;});if(!opts.supbooks){opts.supbooks=supbooks;if(wb.Names)for(var i=0;i<wb.Names.length;++i){supbooks[0][i+1]=wb.Names[i];}}var colinfo/*:Array<ColInfo>*/=[],rowinfo/*:Array<RowInfo>*/=[];var seencol=false;XLSBRecordEnum[0x0010]={n:"BrtShortReal",f:parse_BrtShortReal};var cm,vm;recordhopper(data,function ws_parse(val,RR,RT){if(end)return;switch(RT){case 0x0094:/* 'BrtWsDim' */ref=val;break;case 0x0000:/* 'BrtRowHdr' */row=val;if(opts.sheetRows&&opts.sheetRows<=row.r)end=true;rr=encode_row(R=row.r);opts['!row']=row.r;if(val.hidden||val.hpt||val.level!=null){if(val.hpt)val.hpx=pt2px(val.hpt);rowinfo[val.r]=val;}break;case 0x0002:/* 'BrtCellRk' */case 0x0003:/* 'BrtCellError' */case 0x0004:/* 'BrtCellBool' */case 0x0005:/* 'BrtCellReal' */case 0x0006:/* 'BrtCellSt' */case 0x0007:/* 'BrtCellIsst' */case 0x0008:/* 'BrtFmlaString' */case 0x0009:/* 'BrtFmlaNum' */case 0x000A:/* 'BrtFmlaBool' */case 0x000B:/* 'BrtFmlaError' */case 0x000D:/* 'BrtShortRk' */case 0x000E:/* 'BrtShortError' */case 0x000F:/* 'BrtShortBool' */case 0x0010:/* 'BrtShortReal' */case 0x0011:/* 'BrtShortSt' */case 0x0012:/* 'BrtShortIsst' */case 0x003E:/* 'BrtCellRString' */p={t:val[2]/*:any*/};switch(val[2]){case'n':p.v=val[1];break;case's':sstr=strs[val[1]];p.v=sstr.t;p.r=sstr.r;break;case'b':p.v=val[1]?true:false;break;case'e':p.v=val[1];if(opts.cellText!==false)p.w=BErr[p.v];break;case'str':p.t='s';p.v=val[1];break;case'is':p.t='s';p.v=val[1].t;break;}if(cf=styles.CellXf[val[0].iStyleRef])safe_format(p,cf.numFmtId,null,opts,themes,styles);C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(opts.cellFormula){af=false;for(ai=0;ai<arrayf.length;++ai){var aii=arrayf[ai];if(row.r>=aii[0].s.r&&row.r<=aii[0].e.r)if(C>=aii[0].s.c&&C<=aii[0].e.c){p.F=encode_range(aii[0]);af=true;}}if(!af&&val.length>3)p.f=val[3];}if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(opts.cellDates&&cf&&p.t=='n'&&fmt_is_date(table_fmt[cf.numFmtId])){var _d=SSF_parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}if(cm){if(cm.type=='XLDAPR')p.D=true;cm=void 0;}if(vm)vm=void 0;break;case 0x0001:/* 'BrtCellBlank' */case 0x000C:/* 'BrtShortBlank' */if(!opts.sheetStubs||pass)break;p={t:'z',v:void 0/*:any*/};C=val[0].c==-1?C+1:val[0].c;if(opts.dense){if(!s[R])s[R]=[];s[R][C]=p;}else s[encode_col(C)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;if(cm){if(cm.type=='XLDAPR')p.D=true;cm=void 0;}if(vm)vm=void 0;break;case 0x00B0:/* 'BrtMergeCell' */merges.push(val);break;case 0x0031:{/* 'BrtCellMeta' */cm=((opts.xlmeta||{}).Cell||[])[val-1];}break;case 0x01EE:/* 'BrtHLink' */var rel=rels['!id'][val.relId];if(rel){val.Target=rel.Target;if(val.loc)val.Target+="#"+val.loc;val.Rel=rel;}else if(val.relId==''){val.Target="#"+val.loc;}for(R=val.rfx.s.r;R<=val.rfx.e.r;++R){for(C=val.rfx.s.c;C<=val.rfx.e.c;++C){if(opts.dense){if(!s[R])s[R]=[];if(!s[R][C])s[R][C]={t:'z',v:undefined};s[R][C].l=val;}else{addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:'z',v:undefined};s[addr].l=val;}}}break;case 0x01AA:/* 'BrtArrFmla' */if(!opts.cellFormula)break;arrayf.push(val);cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);cell.F=encode_range(val[0]);break;case 0x01AB:/* 'BrtShrFmla' */if(!opts.cellFormula)break;sharedf[encode_cell(val[0].s)]=val[1];cell=opts.dense?s[R][C]:s[encode_col(C)+rr];cell.f=stringify_formula(val[1],refguess,{r:row.r,c:C},supbooks,opts);break;/* identical to 'ColInfo' in XLS */case 0x003C:/* 'BrtColInfo' */if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,hidden:!!(val.flags&0x01),level:val.level};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}break;case 0x00A1:/* 'BrtBeginAFilter' */s['!autofilter']={ref:encode_range(val)};break;case 0x01DC:/* 'BrtMargins' */s['!margins']=val;break;case 0x0093:/* 'BrtWsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;if(val.above||val.left)s['!outline']={above:val.above,left:val.left};break;case 0x0089:/* 'BrtBeginWsView' */if(!wb.Views)wb.Views=[{}];if(!wb.Views[0])wb.Views[0]={};if(val.RTL)wb.Views[0].RTL=true;break;case 0x01E5:/* 'BrtWsFmtInfo' */break;case 0x0040:/* 'BrtDVal' */case 0x041D:/* 'BrtDVal14' */break;case 0x0097:/* 'BrtPane' */break;case 0x0098:/* 'BrtSel' */case 0x00AF:/* 'BrtAFilterDateGroupItem' */case 0x0284:/* 'BrtActiveX' */case 0x0271:/* 'BrtBigName' */case 0x0232:/* 'BrtBkHim' */case 0x018C:/* 'BrtBrk' */case 0x0458:/* 'BrtCFIcon' */case 0x047A:/* 'BrtCFRuleExt' */case 0x01D7:/* 'BrtCFVO' */case 0x041A:/* 'BrtCFVO14' */case 0x0289:/* 'BrtCellIgnoreEC' */case 0x0451:/* 'BrtCellIgnoreEC14' */case 0x024D:/* 'BrtCellSmartTagProperty' */case 0x025F:/* 'BrtCellWatch' */case 0x0234:/* 'BrtColor' */case 0x041F:/* 'BrtColor14' */case 0x00A8:/* 'BrtColorFilter' */case 0x00AE:/* 'BrtCustomFilter' */case 0x049C:/* 'BrtCustomFilter14' */case 0x01F3:/* 'BrtDRef' */case 0x01FB:/* 'BrtDXF' */case 0x0226:/* 'BrtDrawing' */case 0x00AB:/* 'BrtDynamicFilter' */case 0x00A7:/* 'BrtFilter' */case 0x0499:/* 'BrtFilter14' */case 0x00A9:/* 'BrtIconFilter' */case 0x049D:/* 'BrtIconFilter14' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x0295:/* 'BrtListPart' */case 0x027F:/* 'BrtOleObject' */case 0x01DE:/* 'BrtPageSetup' */case 0x0219:/* 'BrtPhoneticInfo' */case 0x01DD:/* 'BrtPrintOptions' */case 0x0218:/* 'BrtRangeProtection' */case 0x044F:/* 'BrtRangeProtection14' */case 0x02A8:/* 'BrtRangeProtectionIso' */case 0x0450:/* 'BrtRangeProtectionIso14' */case 0x0400:/* 'BrtRwDescent' */case 0x0297:/* 'BrtSheetCalcProp' */case 0x0217:/* 'BrtSheetProtection' */case 0x02A6:/* 'BrtSheetProtectionIso' */case 0x01F8:/* 'BrtSlc' */case 0x0413:/* 'BrtSparkline' */case 0x01AC:/* 'BrtTable' */case 0x00AA:/* 'BrtTop10Filter' */case 0x0C00:/* 'BrtUid' */case 0x0032:/* 'BrtValueMeta' */case 0x0816:/* 'BrtWebExtension' */case 0x0415:/* 'BrtWsFmtInfoEx14' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(RT);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;default:if(RR.T){/* empty */}else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);delete opts.supbooks;delete opts['!row'];if(!s["!ref"]&&(refguess.s.r<2000000||ref&&(ref.e.r>0||ref.e.c>0||ref.s.r>0||ref.s.c>0)))s["!ref"]=encode_range(ref||refguess);if(opts.sheetRows&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<=+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref);}}if(merges.length>0)s["!merges"]=merges;if(colinfo.length>0)s["!cols"]=colinfo;if(rowinfo.length>0)s["!rows"]=rowinfo;return s;}/* TODO: something useful -- this is a stub */function write_ws_bin_cell(ba/*:BufArray*/,cell/*:Cell*/,R/*:number*/,C/*:number*/,opts,ws/*:Worksheet*/,last_seen/*:boolean*/)/*:boolean*/{if(cell.v===undefined)return false;var vv="";switch(cell.t){case'b':vv=cell.v?"1":"0";break;case'd':// no BrtCellDate :(
cell=dup(cell);cell.z=cell.z||table_fmt[14];cell.v=datenum(parseDate(cell.v));cell.t='n';break;/* falls through */case'n':case'e':vv=''+cell.v;break;default:vv=cell.v;break;}var o/*:any*/={r:R,c:C/*:any*/};/* TODO: cell style */o.s=get_cell_style(opts.cellXfs,cell,opts);if(cell.l)ws['!links'].push([encode_cell(o),cell.l]);if(cell.c)ws['!comments'].push([encode_cell(o),cell.c]);switch(cell.t){case's':case'str':if(opts.bookSST){vv=get_sst_id(opts.Strings,cell.v/*:any*/,opts.revStrings);o.t="s";o.v=vv;if(last_seen)write_record(ba,0x0012/* BrtShortIsst */,write_BrtShortIsst(cell,o));else write_record(ba,0x0007/* BrtCellIsst */,write_BrtCellIsst(cell,o));}else{o.t="str";if(last_seen)write_record(ba,0x0011/* BrtShortSt */,write_BrtShortSt(cell,o));else write_record(ba,0x0006/* BrtCellSt */,write_BrtCellSt(cell,o));}return true;case'n':/* TODO: determine threshold for Real vs RK */if(cell.v==(cell.v|0)&&cell.v>-1000&&cell.v<1000){if(last_seen)write_record(ba,0x000D/* BrtShortRk */,write_BrtShortRk(cell,o));else write_record(ba,0x0002/* BrtCellRk */,write_BrtCellRk(cell,o));}else{if(last_seen)write_record(ba,0x0010/* BrtShortReal */,write_BrtShortReal(cell,o));else write_record(ba,0x0005/* BrtCellReal */,write_BrtCellReal(cell,o));}return true;case'b':o.t="b";if(last_seen)write_record(ba,0x000F/* BrtShortBool */,write_BrtShortBool(cell,o));else write_record(ba,0x0004/* BrtCellBool */,write_BrtCellBool(cell,o));return true;case'e':o.t="e";if(last_seen)write_record(ba,0x000E/* BrtShortError */,write_BrtShortError(cell,o));else write_record(ba,0x0003/* BrtCellError */,write_BrtCellError(cell,o));return true;}if(last_seen)write_record(ba,0x000C/* BrtShortBlank */,write_BrtShortBlank(cell,o));else write_record(ba,0x0001/* BrtCellBlank */,write_BrtCellBlank(cell,o));return true;}function write_CELLTABLE(ba,ws/*:Worksheet*/,idx/*:number*/,opts/*::, wb:Workbook*/){var range=safe_decode_range(ws['!ref']||"A1"),ref,rr="",cols/*:Array<string>*/=[];write_record(ba,0x0091/* BrtBeginSheetData */);var dense=Array.isArray(ws);var cap=range.e.r;if(ws['!rows'])cap=Math.max(range.e.r,ws['!rows'].length-1);for(var R=range.s.r;R<=cap;++R){rr=encode_row(R);/* [ACCELLTABLE] *//* BrtRowHdr */write_row_header(ba,ws,range,R);var last_seen=false;if(R<=range.e.r)for(var C=range.s.c;C<=range.e.c;++C){/* *16384CELL */if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell){last_seen=false;continue;}/* write cell */last_seen=write_ws_bin_cell(ba,cell,R,C,opts,ws,last_seen);}}write_record(ba,0x0092/* BrtEndSheetData */);}function write_MERGECELLS(ba,ws/*:Worksheet*/){if(!ws||!ws['!merges'])return;write_record(ba,0x00B1/* BrtBeginMergeCells */,write_BrtBeginMergeCells(ws['!merges'].length));ws['!merges'].forEach(function(m){write_record(ba,0x00B0/* BrtMergeCell */,write_BrtMergeCell(m));});write_record(ba,0x00B2/* BrtEndMergeCells */);}function write_COLINFOS(ba,ws/*:Worksheet*//*::, idx:number, opts, wb:Workbook*/){if(!ws||!ws['!cols'])return;write_record(ba,0x0186/* BrtBeginColInfos */);ws['!cols'].forEach(function(m,i){if(m)write_record(ba,0x003C/* 'BrtColInfo' */,write_BrtColInfo(i,m));});write_record(ba,0x0187/* BrtEndColInfos */);}function write_IGNOREECS(ba,ws/*:Worksheet*/){if(!ws||!ws['!ref'])return;write_record(ba,0x0288/* BrtBeginCellIgnoreECs */);write_record(ba,0x0289/* BrtCellIgnoreEC */,write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));write_record(ba,0x028A/* BrtEndCellIgnoreECs */);}function write_HLINKS(ba,ws/*:Worksheet*/,rels){/* *BrtHLink */ws['!links'].forEach(function(l){if(!l[1].Target)return;var rId=add_rels(rels,-1,l[1].Target.replace(/#.*$/,""),RELS.HLINK);write_record(ba,0x01EE/* BrtHLink */,write_BrtHLink(l,rId));});delete ws['!links'];}function write_LEGACYDRAWING(ba,ws/*:Worksheet*/,idx/*:number*/,rels){/* [BrtLegacyDrawing] */if(ws['!comments'].length>0){var rId=add_rels(rels,-1,"../drawings/vmlDrawing"+(idx+1)+".vml",RELS.VML);write_record(ba,0x0227/* BrtLegacyDrawing */,write_RelID("rId"+rId));ws['!legacy']=rId;}}function write_AUTOFILTER(ba,ws,wb,idx){if(!ws['!autofilter'])return;var data=ws['!autofilter'];var ref=typeof data.ref==="string"?data.ref:encode_range(data.ref);/* Update FilterDatabase defined name for the worksheet */if(!wb.Workbook)wb.Workbook={Sheets:[]/*:any*/};if(!wb.Workbook.Names)wb.Workbook.Names=[];var names/*: Array<any> */=wb.Workbook.Names;var range=decode_range(ref);if(range.s.r==range.e.r){range.e.r=decode_range(ws["!ref"]).e.r;ref=encode_range(range);}for(var i=0;i<names.length;++i){var name=names[i];if(name.Name!='_xlnm._FilterDatabase')continue;if(name.Sheet!=idx)continue;name.Ref="'"+wb.SheetNames[idx]+"'!"+ref;break;}if(i==names.length)names.push({Name:'_xlnm._FilterDatabase',Sheet:idx,Ref:"'"+wb.SheetNames[idx]+"'!"+ref});write_record(ba,0x00A1/* BrtBeginAFilter */,write_UncheckedRfX(safe_decode_range(ref)));/* *FILTERCOLUMN *//* [SORTSTATE] *//* BrtEndAFilter */write_record(ba,0x00A2/* BrtEndAFilter */);}function write_WSVIEWS2(ba,ws,Workbook){write_record(ba,0x0085/* BrtBeginWsViews */);{/* 1*WSVIEW2 *//* [ACUID] */write_record(ba,0x0089/* BrtBeginWsView */,write_BrtBeginWsView(ws,Workbook));/* [BrtPane] *//* *4BrtSel *//* *4SXSELECT *//* *FRT */write_record(ba,0x008A/* BrtEndWsView */);}/* *FRT */write_record(ba,0x0086/* BrtEndWsViews */);}function write_WSFMTINFO()/*::ba, ws*/{/* [ACWSFMTINFO] */// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}function write_SHEETPROTECT(ba,ws){if(!ws['!protect'])return;/* [BrtSheetProtectionIso] */write_record(ba,0x0217/* BrtSheetProtection */,write_BrtSheetProtection(ws['!protect']));}function write_ws_bin(idx/*:number*/,opts,wb/*:Workbook*/,rels){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var c/*:string*/=s;try{if(wb&&wb.Workbook)c=wb.Workbook.Sheets[idx].CodeName||c;}catch(e){}var r=safe_decode_range(ws['!ref']||"A1");if(r.e.c>0x3FFF||r.e.r>0xFFFFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:XFD1048576");r.e.c=Math.min(r.e.c,0x3FFF);r.e.r=Math.min(r.e.c,0xFFFFF);}ws['!links']=[];/* passed back to write_zip and removed there */ws['!comments']=[];write_record(ba,0x0081/* BrtBeginSheet */);if(wb.vbaraw||ws['!outline'])write_record(ba,0x0093/* BrtWsProp */,write_BrtWsProp(c,ws['!outline']));write_record(ba,0x0094/* BrtWsDim */,write_BrtWsDim(r));write_WSVIEWS2(ba,ws,wb.Workbook);write_WSFMTINFO(ba,ws);write_COLINFOS(ba,ws,idx,opts,wb);write_CELLTABLE(ba,ws,idx,opts,wb);/* [BrtSheetCalcProp] */write_SHEETPROTECT(ba,ws);/* *([BrtRangeProtectionIso] BrtRangeProtection) *//* [SCENMAN] */write_AUTOFILTER(ba,ws,wb,idx);/* [SORTSTATE] *//* [DCON] *//* [USERSHVIEWS] */write_MERGECELLS(ba,ws);/* [BrtPhoneticInfo] *//* *CONDITIONALFORMATTING *//* [DVALS] */write_HLINKS(ba,ws,rels);/* [BrtPrintOptions] */if(ws['!margins'])write_record(ba,0x01DC/* BrtMargins */,write_BrtMargins(ws['!margins']));/* [BrtPageSetup] *//* [HEADERFOOTER] *//* [RWBRK] *//* [COLBRK] *//* *BrtBigName *//* [CELLWATCHES] */if(!opts||opts.ignoreEC||opts.ignoreEC==void 0)write_IGNOREECS(ba,ws);/* [SMARTTAGS] *//* [BrtDrawing] */write_LEGACYDRAWING(ba,ws,idx,rels);/* [BrtLegacyDrawingHF] *//* [BrtBkHim] *//* [OLEOBJECTS] *//* [ACTIVEXCONTROLS] *//* [WEBPUBITEMS] *//* [LISTPARTS] *//* FRTWORKSHEET */write_record(ba,0x0082/* BrtEndSheet */);return ba.end();}function parse_Cache(data/*:string*/)/*:[Array<number|string>, string, ?string]*/{var col/*:Array<number|string>*/=[];var num=data.match(/^<c:numCache>/);var f;/* 21.2.2.150 pt CT_NumVal */(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt){var q=pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);if(!q)return;col[+q[1]]=num?+q[2]:q[2];});/* 21.2.2.71 formatCode CT_Xstring */var nf=unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/)||["","General"])[1]);(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F){f=F.replace(/<.*?>/g,"");});return[col,nf,f];}/* 21.2 DrawingML - Charts */function parse_chart(data/*:?string*/,name/*:string*/,opts,rels,wb,csheet){var cs/*:Worksheet*/=csheet||{"!type":"chart"};if(!data)return csheet;/* 21.2.2.27 chart CT_Chart */var C=0,R=0,col="A";var refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};/* 21.2.2.120 numCache CT_NumData */(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc){var cache=parse_Cache(nc);refguess.s.r=refguess.s.c=0;refguess.e.c=C;col=encode_col(C);cache[0].forEach(function(n,i){cs[col+encode_row(i)]={t:'n',v:n,z:cache[1]};R=i;});if(refguess.e.r<R)refguess.e.r=R;++C;});if(C>0)cs["!ref"]=encode_range(refguess);return cs;}/* 18.3 Worksheets also covers Chartsheets */function parse_cs_xml(data/*:?string*/,opts,idx/*:number*/,rels,wb/*::, themes, styles*/)/*:Worksheet*/{if(!data)return data;/* 18.3.1.12 chartsheet CT_ChartSheet */if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""/*:any*/};var m;/* 18.3.1.83 sheetPr CT_ChartsheetPr */var sheetPr=data.match(sheetprregex);if(sheetPr)parse_ws_xml_sheetpr(sheetPr[0],s,wb,idx);/* 18.3.1.36 drawing CT_Drawing */if(m=data.match(/drawing r:id="(.*?)"/))s['!rel']=m[1];if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_xml(idx/*:number*/,opts,wb/*:Workbook*/,rels)/*:string*/{var o=[XML_HEADER,writextag('chartsheet',null,{'xmlns':XMLNS_main[0],'xmlns:r':XMLNS.r})];o[o.length]=writextag("drawing",null,{"r:id":"rId1"});add_rels(rels,-1,"../drawings/drawing"+(idx+1)+".xml",RELS.DRAW);if(o.length>2){o[o.length]='</chartsheet>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.331 BrtCsProp */function parse_BrtCsProp(data,length/*:number*/){data.l+=10;var name=parse_XLWideString(data,length-10);return{name:name};}/* [MS-XLSB] 2.1.7.7 Chart Sheet */function parse_cs_bin(data,opts,idx/*:number*/,rels,wb/*::, themes, styles*/)/*:Worksheet*/{if(!data)return data;if(!rels)rels={'!id':{}};var s={'!type':"chart",'!drawel':null,'!rel':""};var state/*:Array<string>*/=[];var pass=false;recordhopper(data,function cs_parse(val,R,RT){switch(RT){case 0x0226:/* 'BrtDrawing' */s['!rel']=val;break;case 0x028B:/* 'BrtCsProp' */if(!wb.Sheets[idx])wb.Sheets[idx]={};if(val.name)wb.Sheets[idx].CodeName=val.name;break;case 0x0232:/* 'BrtBkHim' */case 0x028C:/* 'BrtCsPageSetup' */case 0x029D:/* 'BrtCsProtection' */case 0x02A7:/* 'BrtCsProtectionIso' */case 0x0227:/* 'BrtLegacyDrawing' */case 0x0228:/* 'BrtLegacyDrawingHF' */case 0x01DC:/* 'BrtMargins' */case 0x0C00:/* 'BrtUid' */break;case 0x0023:/* 'BrtFRTBegin' */pass=true;break;case 0x0024:/* 'BrtFRTEnd' */pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(RT);break;case 0x0026:/* 'BrtACEnd' */state.pop();break;default:if(R.T>0)state.push(RT);else if(R.T<0)state.pop();else if(!pass||opts.WTF)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);if(rels['!id'][s['!rel']])s['!drawel']=rels['!id'][s['!rel']];return s;}function write_cs_bin()/*::idx:number, opts, wb:Workbook, rels*/{var ba=buf_array();write_record(ba,0x0081/* BrtBeginSheet */);/* [BrtCsProp] *//* CSVIEWS *//* [[BrtCsProtectionIso] BrtCsProtection] *//* [USERCSVIEWS] *//* [BrtMargins] *//* [BrtCsPageSetup] *//* [HEADERFOOTER] *//* BrtDrawing *//* [BrtLegacyDrawing] *//* [BrtLegacyDrawingHF] *//* [BrtBkHim] *//* [WEBPUBITEMS] *//* FRTCHARTSHEET */write_record(ba,0x0082/* BrtEndSheet */);return ba.end();}/* 18.2.28 (CT_WorkbookProtection) Defaults */var WBPropsDef=[['allowRefreshQuery',false,"bool"],['autoCompressPictures',true,"bool"],['backupFile',false,"bool"],['checkCompatibility',false,"bool"],['CodeName',''],['date1904',false,"bool"],['defaultThemeVersion',0,"int"],['filterPrivacy',false,"bool"],['hidePivotFieldList',false,"bool"],['promptedSolutions',false,"bool"],['publishItems',false,"bool"],['refreshAllConnections',false,"bool"],['saveExternalLinkValues',true,"bool"],['showBorderUnselectedTables',true,"bool"],['showInkAnnotation',true,"bool"],['showObjects','all'],['showPivotChartFilter',false,"bool"],['updateLinks','userSet']];/* 18.2.30 (CT_BookView) Defaults */var WBViewDef=[['activeTab',0,"int"],['autoFilterDateGrouping',true,"bool"],['firstSheet',0,"int"],['minimized',false,"bool"],['showHorizontalScroll',true,"bool"],['showSheetTabs',true,"bool"],['showVerticalScroll',true,"bool"],['tabRatio',600,"int"],['visibility','visible']//window{Height,Width}, {x,y}Window
];/* 18.2.19 (CT_Sheet) Defaults */var SheetDef=[//['state', 'visible']
];/* 18.2.2  (CT_CalcPr) Defaults */var CalcPrDef=[['calcCompleted','true'],['calcMode','auto'],['calcOnSave','true'],['concurrentCalc','true'],['fullCalcOnLoad','false'],['fullPrecision','true'],['iterate','false'],['iterateCount','100'],['iterateDelta','0.001'],['refMode','A1']];/* 18.2.3 (CT_CustomWorkbookView) Defaults *//*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/function push_defaults_array(target,defaults){for(var j=0;j!=target.length;++j){var w=target[j];for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(w[z[0]]==null)w[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof w[z[0]]=="string")w[z[0]]=parsexmlbool(w[z[0]]);break;case"int":if(typeof w[z[0]]=="string")w[z[0]]=parseInt(w[z[0]],10);break;}}}}function push_defaults(target,defaults){for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(target[z[0]]==null)target[z[0]]=z[1];else switch(z[2]){case"bool":if(typeof target[z[0]]=="string")target[z[0]]=parsexmlbool(target[z[0]]);break;case"int":if(typeof target[z[0]]=="string")target[z[0]]=parseInt(target[z[0]],10);break;}}}function parse_wb_defaults(wb){push_defaults(wb.WBProps,WBPropsDef);push_defaults(wb.CalcPr,CalcPrDef);push_defaults_array(wb.WBView,WBViewDef);push_defaults_array(wb.Sheets,SheetDef);_ssfopts.date1904=parsexmlbool(wb.WBProps.date1904);}function safe1904(wb/*:Workbook*/)/*:string*/{/* TODO: store date1904 somewhere else */if(!wb.Workbook)return"false";if(!wb.Workbook.WBProps)return"false";return parsexmlbool(wb.Workbook.WBProps.date1904)?"true":"false";}var badchars=/*#__PURE__*/"][*?\/\\".split("");function check_ws_name(n/*:string*/,safe/*:?boolean*/)/*:boolean*/{if(n.length>31){if(safe)return false;throw new Error("Sheet names cannot exceed 31 chars");}var _good=true;badchars.forEach(function(c){if(n.indexOf(c)==-1)return;if(!safe)throw new Error("Sheet name cannot contain : \\ / ? * [ ]");_good=false;});return _good;}function check_wb_names(N,S,codes){N.forEach(function(n,i){check_ws_name(n);for(var j=0;j<i;++j){if(n==N[j])throw new Error("Duplicate Sheet Name: "+n);}if(codes){var cn=S&&S[i]&&S[i].CodeName||n;if(cn.charCodeAt(0)==95&&cn.length>22)throw new Error("Bad Code Name: Worksheet"+cn);}});}function check_wb(wb){if(!wb||!wb.SheetNames||!wb.Sheets)throw new Error("Invalid Workbook");if(!wb.SheetNames.length)throw new Error("Workbook is empty");var Sheets=wb.Workbook&&wb.Workbook.Sheets||[];check_wb_names(wb.SheetNames,Sheets,!!wb.vbaraw);for(var i=0;i<wb.SheetNames.length;++i){check_ws(wb.Sheets[wb.SheetNames[i]],wb.SheetNames[i],i);}/* TODO: validate workbook */}/* 18.2 Workbook */var wbnsregex=/<\w+:workbook/;function parse_wb_xml(data,opts)/*:WorkbookFile*/{if(!data)throw new Error("Could not find file");var wb=/*::(*/{AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},Names:[],xmlns:""/*::)*/};var pass=false,xmlns="xmlns";var dname={},dnstart=0;data.replace(tagregex,function xml_wb(x,idx){var y/*:any*/=parsexmltag(x);switch(strip_ns(y[0])){case'<?xml':break;/* 18.2.27 workbook CT_Workbook 1 */case'<workbook':if(x.match(wbnsregex))xmlns="xmlns"+x.match(/<(\w+):/)[1];wb.xmlns=y[xmlns];break;case'</workbook>':break;/* 18.2.13 fileVersion CT_FileVersion ? */case'<fileVersion':delete y[0];wb.AppVersion=y;break;case'<fileVersion/>':case'</fileVersion>':break;/* 18.2.12 fileSharing CT_FileSharing ? */case'<fileSharing':break;case'<fileSharing/>':break;/* 18.2.28 workbookPr CT_WorkbookPr ? */case'<workbookPr':case'<workbookPr/>':WBPropsDef.forEach(function(w){if(y[w[0]]==null)return;switch(w[2]){case"bool":wb.WBProps[w[0]]=parsexmlbool(y[w[0]]);break;case"int":wb.WBProps[w[0]]=parseInt(y[w[0]],10);break;default:wb.WBProps[w[0]]=y[w[0]];}});if(y.codeName)wb.WBProps.CodeName=utf8read(y.codeName);break;case'</workbookPr>':break;/* 18.2.29 workbookProtection CT_WorkbookProtection ? */case'<workbookProtection':break;case'<workbookProtection/>':break;/* 18.2.1  bookViews CT_BookViews ? */case'<bookViews':case'<bookViews>':case'</bookViews>':break;/* 18.2.30   workbookView CT_BookView + */case'<workbookView':case'<workbookView/>':delete y[0];wb.WBView.push(y);break;case'</workbookView>':break;/* 18.2.20 sheets CT_Sheets 1 */case'<sheets':case'<sheets>':case'</sheets>':break;// aggregate sheet
/* 18.2.19   sheet CT_Sheet + */case'<sheet':switch(y.state){case"hidden":y.Hidden=1;break;case"veryHidden":y.Hidden=2;break;default:y.Hidden=0;}delete y.state;y.name=unescapexml(utf8read(y.name));delete y[0];wb.Sheets.push(y);break;case'</sheet>':break;/* 18.2.15 functionGroups CT_FunctionGroups ? */case'<functionGroups':case'<functionGroups/>':break;/* 18.2.14   functionGroup CT_FunctionGroup + */case'<functionGroup':break;/* 18.2.9  externalReferences CT_ExternalReferences ? */case'<externalReferences':case'</externalReferences>':case'<externalReferences>':break;/* 18.2.8    externalReference CT_ExternalReference + */case'<externalReference':break;/* 18.2.6  definedNames CT_DefinedNames ? */case'<definedNames/>':break;case'<definedNames>':case'<definedNames':pass=true;break;case'</definedNames>':pass=false;break;/* 18.2.5    definedName CT_DefinedName + */case'<definedName':{dname={};dname.Name=utf8read(y.name);if(y.comment)dname.Comment=y.comment;if(y.localSheetId)dname.Sheet=+y.localSheetId;if(parsexmlbool(y.hidden||"0"))dname.Hidden=true;dnstart=idx+x.length;}break;case'</definedName>':{dname.Ref=unescapexml(utf8read(data.slice(dnstart,idx)));wb.Names.push(dname);}break;case'<definedName/>':break;/* 18.2.2  calcPr CT_CalcPr ? */case'<calcPr':delete y[0];wb.CalcPr=y;break;case'<calcPr/>':delete y[0];wb.CalcPr=y;break;case'</calcPr>':break;/* 18.2.16 oleSize CT_OleSize ? (ref required) */case'<oleSize':break;/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */case'<customWorkbookViews>':case'</customWorkbookViews>':case'<customWorkbookViews':break;/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */case'<customWorkbookView':case'</customWorkbookView>':break;/* 18.2.18 pivotCaches CT_PivotCaches ? */case'<pivotCaches>':case'</pivotCaches>':case'<pivotCaches':break;/* 18.2.17 pivotCache CT_PivotCache ? */case'<pivotCache':break;/* 18.2.21 smartTagPr CT_SmartTagPr ? */case'<smartTagPr':case'<smartTagPr/>':break;/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */case'<smartTagTypes':case'<smartTagTypes>':case'</smartTagTypes>':break;/* 18.2.22 smartTagType CT_SmartTagType ? */case'<smartTagType':break;/* 18.2.24 webPublishing CT_WebPublishing ? */case'<webPublishing':case'<webPublishing/>':break;/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */case'<fileRecoveryPr':case'<fileRecoveryPr/>':break;/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */case'<webPublishObjects>':case'<webPublishObjects':case'</webPublishObjects>':break;/* 18.2.25 webPublishObject CT_WebPublishObject ? */case'<webPublishObject':break;/* 18.2.10 extLst CT_ExtensionList ? */case'<extLst':case'<extLst>':case'</extLst>':case'<extLst/>':break;/* 18.2.7  ext CT_Extension + */case'<ext':pass=true;break;//TODO: check with versions of excel
case'</ext>':pass=false;break;/* Others */case'<ArchID':break;case'<AlternateContent':case'<AlternateContent>':pass=true;break;case'</AlternateContent>':pass=false;break;/* TODO */case'<revisionPtr':break;default:if(!pass&&opts.WTF)throw new Error('unrecognized '+y[0]+' in workbook');}return x;});if(XMLNS_main.indexOf(wb.xmlns)===-1)throw new Error("Unknown Namespace: "+wb.xmlns);parse_wb_defaults(wb);return wb;}function write_wb_xml(wb/*:Workbook*//*::, opts:?WriteOpts*/)/*:string*/{var o=[XML_HEADER];o[o.length]=writextag('workbook',null,{'xmlns':XMLNS_main[0],//'xmlns:mx': XMLNS.mx,
//'xmlns:s': XMLNS_main[0],
'xmlns:r':XMLNS.r});var write_names=wb.Workbook&&(wb.Workbook.Names||[]).length>0;/* fileVersion *//* fileSharing */var workbookPr/*:any*/={codeName:"ThisWorkbook"/*:any*/};if(wb.Workbook&&wb.Workbook.WBProps){WBPropsDef.forEach(function(x){/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */if(wb.Workbook.WBProps[x[0]]/*:any*/==null)return;if(wb.Workbook.WBProps[x[0]]/*:any*/==x[1])return;workbookPr[x[0]]=wb.Workbook.WBProps[x[0]]/*:any*/;});/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */if(wb.Workbook.WBProps.CodeName){workbookPr.codeName=wb.Workbook.WBProps.CodeName;delete workbookPr.CodeName;}}o[o.length]=writextag('workbookPr',null,workbookPr);/* workbookProtection */var sheets=wb.Workbook&&wb.Workbook.Sheets||[];var i=0;/* bookViews only written if first worksheet is hidden */if(sheets&&sheets[0]&&!!sheets[0].Hidden){o[o.length]="<bookViews>";for(i=0;i!=wb.SheetNames.length;++i){if(!sheets[i])break;if(!sheets[i].Hidden)break;}if(i==wb.SheetNames.length)i=0;o[o.length]='<workbookView firstSheet="'+i+'" activeTab="'+i+'"/>';o[o.length]="</bookViews>";}o[o.length]="<sheets>";for(i=0;i!=wb.SheetNames.length;++i){var sht={name:escapexml(wb.SheetNames[i].slice(0,31))/*:any*/};sht.sheetId=""+(i+1);sht["r:id"]="rId"+(i+1);if(sheets[i])switch(sheets[i].Hidden){case 1:sht.state="hidden";break;case 2:sht.state="veryHidden";break;}o[o.length]=writextag('sheet',null,sht);}o[o.length]="</sheets>";/* functionGroups *//* externalReferences */if(write_names){o[o.length]="<definedNames>";if(wb.Workbook&&wb.Workbook.Names)wb.Workbook.Names.forEach(function(n){var d/*:any*/={name:n.Name};if(n.Comment)d.comment=n.Comment;if(n.Sheet!=null)d.localSheetId=""+n.Sheet;if(n.Hidden)d.hidden="1";if(!n.Ref)return;o[o.length]=writextag('definedName',escapexml(n.Ref),d);});o[o.length]="</definedNames>";}/* calcPr *//* oleSize *//* customWorkbookViews *//* pivotCaches *//* smartTagPr *//* smartTagTypes *//* webPublishing *//* fileRecoveryPr *//* webPublishObjects *//* extLst */if(o.length>2){o[o.length]='</workbook>';o[1]=o[1].replace("/>",">");}return o.join("");}/* [MS-XLSB] 2.4.304 BrtBundleSh */function parse_BrtBundleSh(data,length/*:number*/){var z={};z.Hidden=data.read_shift(4);//hsState ST_SheetState
z.iTabID=data.read_shift(4);z.strRelID=parse_RelID(data,length-8);z.name=parse_XLWideString(data);return z;}function write_BrtBundleSh(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.Hidden);o.write_shift(4,data.iTabID);write_RelID(data.strRelID,o);write_XLWideString(data.name.slice(0,31),o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.815 BrtWbProp */function parse_BrtWbProp(data,length)/*:WBProps*/{var o/*:WBProps*/={}/*:any*/;var flags=data.read_shift(4);o.defaultThemeVersion=data.read_shift(4);var strName=length>8?parse_XLWideString(data):"";if(strName.length>0)o.CodeName=strName;o.autoCompressPictures=!!(flags&0x10000);o.backupFile=!!(flags&0x40);o.checkCompatibility=!!(flags&0x1000);o.date1904=!!(flags&0x01);o.filterPrivacy=!!(flags&0x08);o.hidePivotFieldList=!!(flags&0x400);o.promptedSolutions=!!(flags&0x10);o.publishItems=!!(flags&0x800);o.refreshAllConnections=!!(flags&0x40000);o.saveExternalLinkValues=!!(flags&0x80);o.showBorderUnselectedTables=!!(flags&0x04);o.showInkAnnotation=!!(flags&0x20);o.showObjects=["all","placeholders","none"][flags>>13&0x03];o.showPivotChartFilter=!!(flags&0x8000);o.updateLinks=["userSet","never","always"][flags>>8&0x03];return o;}function write_BrtWbProp(data/*:?WBProps*/,o){if(!o)o=new_buf(72);var flags=0;if(data){/* TODO: mirror parse_BrtWbProp fields */if(data.filterPrivacy)flags|=0x08;}o.write_shift(4,flags);o.write_shift(4,0);write_XLSBCodeName(data&&data.CodeName||"ThisWorkbook",o);return o.slice(0,o.l);}function parse_BrtFRTArchID$(data,length){var o={};data.read_shift(4);o.ArchID=data.read_shift(4);data.l+=length-8;return o;}/* [MS-XLSB] 2.4.687 BrtName */function parse_BrtName(data,length,opts){var end=data.l+length;data.l+=4;//var flags = data.read_shift(4);
data.l+=1;//var chKey = data.read_shift(1);
var itab=data.read_shift(4);var name=parse_XLNameWideString(data);var formula=parse_XLSBNameParsedFormula(data,0,opts);var comment=parse_XLNullableWideString(data);//if(0 /* fProc */) {
// unusedstring1: XLNullableWideString
// description: XLNullableWideString
// helpTopic: XLNullableWideString
// unusedstring2: XLNullableWideString
//}
data.l=end;var out={Name:name,Ptg:formula/*:any*/};if(itab<0xFFFFFFF)out.Sheet=itab;if(comment)out.Comment=comment;return out;}/* [MS-XLSB] 2.1.7.61 Workbook */function parse_wb_bin(data,opts)/*:WorkbookFile*/{var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var state/*:Array<string>*/=[];var pass=false;if(!opts)opts={};opts.biff=12;var Names=[];var supbooks=[[]]/*:any*/;supbooks.SheetNames=[];supbooks.XTI=[];XLSBRecordEnum[0x0010]={n:"BrtFRTArchID$",f:parse_BrtFRTArchID$};recordhopper(data,function hopper_wb(val,R,RT){switch(RT){case 0x009C:/* 'BrtBundleSh' */supbooks.SheetNames.push(val.name);wb.Sheets.push(val);break;case 0x0099:/* 'BrtWbProp' */wb.WBProps=val;break;case 0x0027:/* 'BrtName' */if(val.Sheet!=null)opts.SID=val.Sheet;val.Ref=stringify_formula(val.Ptg,null,null,supbooks,opts);delete opts.SID;delete val.Ptg;Names.push(val);break;case 0x040C:/* 'BrtNameExt' */break;case 0x0165:/* 'BrtSupSelf' */case 0x0166:/* 'BrtSupSame' */case 0x0163:/* 'BrtSupBookSrc' */case 0x029B:/* 'BrtSupAddin' */if(!supbooks[0].length)supbooks[0]=[RT,val];else supbooks.push([RT,val]);supbooks[supbooks.length-1].XTI=[];break;case 0x016A:/* 'BrtExternSheet' */if(supbooks.length===0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0169:/* 'BrtPlaceholderName' */break;case 0x0817:/* 'BrtAbsPath15' */case 0x009E:/* 'BrtBookView' */case 0x008F:/* 'BrtBeginBundleShs' */case 0x0298:/* 'BrtBeginFnGroup' */case 0x0161:/* 'BrtBeginExternals' */break;/* case 'BrtModelTimeGroupingCalcCol' */case 0x0C00:/* 'BrtUid' */case 0x0C01:/* 'BrtRevisionPtr' */case 0x0216:/* 'BrtBookProtection' */case 0x02A5:/* 'BrtBookProtectionIso' */case 0x009D:/* 'BrtCalcProp' */case 0x0262:/* 'BrtCrashRecErr' */case 0x0802:/* 'BrtDecoupledPivotCacheID' */case 0x009B:/* 'BrtFileRecover' */case 0x0224:/* 'BrtFileSharing' */case 0x02A4:/* 'BrtFileSharingIso' */case 0x0080:/* 'BrtFileVersion' */case 0x0299:/* 'BrtFnGroup' */case 0x0850:/* 'BrtModelRelationship' */case 0x084D:/* 'BrtModelTable' */case 0x0225:/* 'BrtOleSize' */case 0x0805:/* 'BrtPivotTableRef' */case 0x0254:/* 'BrtSmartTagType' */case 0x081C:/* 'BrtTableSlicerCacheID' */case 0x081B:/* 'BrtTableSlicerCacheIDs' */case 0x0822:/* 'BrtTimelineCachePivotCacheID' */case 0x018D:/* 'BrtUserBookView' */case 0x009A:/* 'BrtWbFactoid' */case 0x045D:/* 'BrtWbProp14' */case 0x0229:/* 'BrtWebOpt' */case 0x082B:/* 'BrtWorkBookPr15' */break;case 0x0023:/* 'BrtFRTBegin' */state.push(RT);pass=true;break;case 0x0024:/* 'BrtFRTEnd' */state.pop();pass=false;break;case 0x0025:/* 'BrtACBegin' */state.push(RT);pass=true;break;case 0x0026:/* 'BrtACEnd' */state.pop();pass=false;break;case 0x0010:/* 'BrtFRTArchID$' */break;default:if(R.T){/* empty */}else if(!pass||opts.WTF&&state[state.length-1]!=0x0025/* BrtACBegin */&&state[state.length-1]!=0x0023/* BrtFRTBegin */)throw new Error("Unexpected record 0x"+RT.toString(16));}},opts);parse_wb_defaults(wb);// $FlowIgnore
wb.Names=Names;wb/*:any*/.supbooks=supbooks;return wb;}function write_BUNDLESHS(ba,wb/*::, opts*/){write_record(ba,0x008F/* BrtBeginBundleShs */);for(var idx=0;idx!=wb.SheetNames.length;++idx){var viz=wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]&&wb.Workbook.Sheets[idx].Hidden||0;var d={Hidden:viz,iTabID:idx+1,strRelID:'rId'+(idx+1),name:wb.SheetNames[idx]};write_record(ba,0x009C/* BrtBundleSh */,write_BrtBundleSh(d));}write_record(ba,0x0090/* BrtEndBundleShs */);}/* [MS-XLSB] 2.4.649 BrtFileVersion */function write_BrtFileVersion(data,o){if(!o)o=new_buf(127);for(var i=0;i!=4;++i){o.write_shift(4,0);}write_XLWideString("SheetJS",o);write_XLWideString(XLSX.version,o);write_XLWideString(XLSX.version,o);write_XLWideString("7262",o);return o.length>o.l?o.slice(0,o.l):o;}/* [MS-XLSB] 2.4.301 BrtBookView */function write_BrtBookView(idx,o){if(!o)o=new_buf(29);o.write_shift(-4,0);o.write_shift(-4,460);o.write_shift(4,28800);o.write_shift(4,17600);o.write_shift(4,500);o.write_shift(4,idx);o.write_shift(4,idx);var flags=0x78;o.write_shift(1,flags);return o.length>o.l?o.slice(0,o.l):o;}function write_BOOKVIEWS(ba,wb/*::, opts*/){/* required if hidden tab appears before visible tab */if(!wb.Workbook||!wb.Workbook.Sheets)return;var sheets=wb.Workbook.Sheets;var i=0,vistab=-1,hidden=-1;for(;i<sheets.length;++i){if(!sheets[i]||!sheets[i].Hidden&&vistab==-1)vistab=i;else if(sheets[i].Hidden==1&&hidden==-1)hidden=i;}if(hidden>vistab)return;write_record(ba,0x0087/* BrtBeginBookViews */);write_record(ba,0x009E/* BrtBookView */,write_BrtBookView(vistab));/* 1*(BrtBookView *FRT) */write_record(ba,0x0088/* BrtEndBookViews */);}/* [MS-XLSB] 2.4.305 BrtCalcProp *//*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*//* [MS-XLSB] 2.4.646 BrtFileRecover *//*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*//* [MS-XLSB] 2.1.7.61 Workbook */function write_wb_bin(wb,opts){var ba=buf_array();write_record(ba,0x0083/* BrtBeginBook */);write_record(ba,0x0080/* BrtFileVersion */,write_BrtFileVersion());/* [[BrtFileSharingIso] BrtFileSharing] */write_record(ba,0x0099/* BrtWbProp */,write_BrtWbProp(wb.Workbook&&wb.Workbook.WBProps||null));/* [ACABSPATH] *//* [[BrtBookProtectionIso] BrtBookProtection] */write_BOOKVIEWS(ba,wb,opts);write_BUNDLESHS(ba,wb,opts);/* [FNGROUP] *//* [EXTERNALS] *//* *BrtName *//* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); *//* [BrtOleSize] *//* *(BrtUserBookView *FRT) *//* [PIVOTCACHEIDS] *//* [BrtWbFactoid] *//* [SMARTTAGTYPES] *//* [BrtWebOpt] *//* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); *//* [WEBPUBITEMS] *//* [CRERRS] *//* FRTWORKBOOK */write_record(ba,0x0084/* BrtEndBook */);return ba.end();}function parse_wb(data,name/*:string*/,opts)/*:WorkbookFile*/{if(name.slice(-4)===".bin")return parse_wb_bin(data/*:any*/,opts);return parse_wb_xml(data/*:any*/,opts);}function parse_ws(data,name/*:string*/,idx/*:number*/,opts,rels,wb,themes,styles)/*:Worksheet*/{if(name.slice(-4)===".bin")return parse_ws_bin(data/*:any*/,opts,idx,rels,wb,themes,styles);return parse_ws_xml(data/*:any*/,opts,idx,rels,wb,themes,styles);}function parse_cs(data,name/*:string*/,idx/*:number*/,opts,rels,wb,themes,styles)/*:Worksheet*/{if(name.slice(-4)===".bin")return parse_cs_bin(data/*:any*/,opts,idx,rels,wb,themes,styles);return parse_cs_xml(data/*:any*/,opts,idx,rels,wb,themes,styles);}function parse_ms(data,name/*:string*/,idx/*:number*/,opts,rels,wb,themes,styles)/*:Worksheet*/{if(name.slice(-4)===".bin")return parse_ms_bin(data/*:any*/,opts,idx,rels,wb,themes,styles);return parse_ms_xml(data/*:any*/,opts,idx,rels,wb,themes,styles);}function parse_ds(data,name/*:string*/,idx/*:number*/,opts,rels,wb,themes,styles)/*:Worksheet*/{if(name.slice(-4)===".bin")return parse_ds_bin(data/*:any*/,opts,idx,rels,wb,themes,styles);return parse_ds_xml(data/*:any*/,opts,idx,rels,wb,themes,styles);}function parse_sty(data,name/*:string*/,themes,opts){if(name.slice(-4)===".bin")return parse_sty_bin(data/*:any*/,themes,opts);return parse_sty_xml(data/*:any*/,themes,opts);}function parse_theme(data/*:string*/,name/*:string*/,opts){return parse_theme_xml(data,opts);}function parse_sst(data,name/*:string*/,opts)/*:SST*/{if(name.slice(-4)===".bin")return parse_sst_bin(data/*:any*/,opts);return parse_sst_xml(data/*:any*/,opts);}function parse_cmnt(data,name/*:string*/,opts)/*:Array<RawComment>*/{if(name.slice(-4)===".bin")return parse_comments_bin(data/*:any*/,opts);return parse_comments_xml(data/*:any*/,opts);}function parse_cc(data,name/*:string*/,opts){if(name.slice(-4)===".bin")return parse_cc_bin(data/*:any*/,name,opts);return parse_cc_xml(data/*:any*/,name,opts);}function parse_xlink(data,rel,name/*:string*/,opts){if(name.slice(-4)===".bin")return parse_xlink_bin(data/*:any*/,rel,name,opts);return parse_xlink_xml(data/*:any*/,rel,name,opts);}function parse_xlmeta(data,name/*:string*/,opts){if(name.slice(-4)===".bin")return parse_xlmeta_bin(data/*:any*/,name,opts);return parse_xlmeta_xml(data/*:any*/,name,opts);}function write_wb(wb,name/*:string*/,opts){return(name.slice(-4)===".bin"?write_wb_bin:write_wb_xml)(wb,opts);}function write_ws(data/*:number*/,name/*:string*/,opts,wb/*:Workbook*/,rels){return(name.slice(-4)===".bin"?write_ws_bin:write_ws_xml)(data,opts,wb,rels);}// eslint-disable-next-line no-unused-vars
function write_cs(data/*:number*/,name/*:string*/,opts,wb/*:Workbook*/,rels){return(name.slice(-4)===".bin"?write_cs_bin:write_cs_xml)(data,opts,wb,rels);}function write_sty(data,name/*:string*/,opts){return(name.slice(-4)===".bin"?write_sty_bin:write_sty_xml)(data,opts);}function write_sst(data/*:SST*/,name/*:string*/,opts){return(name.slice(-4)===".bin"?write_sst_bin:write_sst_xml)(data,opts);}function write_cmnt(data/*:Array<any>*/,name/*:string*/,opts){return(name.slice(-4)===".bin"?write_comments_bin:write_comments_xml)(data,opts);}/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/function write_xlmeta(name/*:string*/){return(name.slice(-4)===".bin"?write_xlmeta_bin:write_xlmeta_xml)();}var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;function xlml_parsexmltag(tag/*:string*/,skip_root/*:?boolean*/){var words=tag.split(/\s+/);var z/*:any*/=[]/*:any*/;if(!skip_root)z[0]=words[0];if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);/*:: if(!y || !y[2]) continue; */if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}function xlml_parsexmltagobj(tag/*:string*/){var words=tag.split(/\s+/);var z={};if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);/*:: if(!y || !y[2]) continue; */if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].slice(1,y[2].length-1);else{if(y[1].slice(0,6)==="xmlns:")w="xmlns"+y[1].slice(6);else w=y[1].slice(j+1);z[w]=y[2].slice(1,y[2].length-1);}}return z;}// ----
/* map from xlml named formats to SSF TODO: localize */var XLMLFormatMap/*: {[string]:string}*/;function xlml_format(format,value)/*:string*/{var fmt=XLMLFormatMap[format]||unescapexml(format);if(fmt==="General")return SSF_general(value);return SSF_format(fmt,value);}function xlml_set_custprop(Custprops,key,cp,val/*:string*/){var oval/*:any*/=val;switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":oval=parsexmlbool(val);break;case"i2":case"int":oval=parseInt(val,10);break;case"r4":case"float":oval=parseFloat(val);break;case"date":case"dateTime.tz":oval=parseDate(val);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw new Error("bad custprop:"+cp[0]);}Custprops[unescapexml(key)]=oval;}function safe_format_xlml(cell/*:Cell*/,nf,o){if(cell.t==='z')return;if(!o||o.cellText!==false)try{if(cell.t==='e'){cell.w=cell.w||BErr[cell.v];}else if(nf==="General"){if(cell.t==='n'){if((cell.v|0)===cell.v)cell.w=cell.v.toString(10);else cell.w=SSF_general_num(cell.v);}else cell.w=SSF_general(cell.v);}else cell.w=xlml_format(nf||"General",cell.v);}catch(e){if(o.WTF)throw e;}try{var z=XLMLFormatMap[nf]||nf||"General";if(o.cellNF)cell.z=z;if(o.cellDates&&cell.t=='n'&&fmt_is_date(z)){var _d=SSF_parse_date_code(cell.v);if(_d){cell.t='d';cell.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}catch(e){if(o.WTF)throw e;}}function process_style_xlml(styles,stag,opts){if(opts.cellStyles){if(stag.Interior){var I=stag.Interior;if(I.Pattern)I.patternType=XLMLPatternTypeMap[I.Pattern]||I.Pattern;}}styles[stag.ID]=stag;}/* TODO: there must exist some form of OSP-blessed spec */function parse_xlml_data(xml,ss,data,cell/*:any*/,base,styles,csty,row,arrayf,o){var nf="General",sid=cell.StyleID,S={};o=o||{};var interiors=[];var i=0;if(sid===undefined&&row)sid=row.StyleID;if(sid===undefined&&csty)sid=csty.StyleID;while(styles[sid]!==undefined){if(styles[sid].nf)nf=styles[sid].nf;if(styles[sid].Interior)interiors.push(styles[sid].Interior);if(!styles[sid].Parent)break;sid=styles[sid].Parent;}switch(data.Type){case'Boolean':cell.t='b';cell.v=parsexmlbool(xml);break;case'String':cell.t='s';cell.r=xlml_fixstr(unescapexml(xml));cell.v=xml.indexOf("<")>-1?unescapexml(ss||xml).replace(/<.*?>/g,""):cell.r;// todo: BR etc
break;case'DateTime':if(xml.slice(-1)!="Z")xml+="Z";cell.v=(parseDate(xml)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1000);if(cell.v!==cell.v)cell.v=unescapexml(xml);else if(cell.v<60)cell.v=cell.v-1;if(!nf||nf=="General")nf="yyyy-mm-dd";/* falls through */case'Number':if(cell.v===undefined)cell.v=+xml;if(!cell.t)cell.t='n';break;case'Error':cell.t='e';cell.v=RBErr[xml];if(o.cellText!==false)cell.w=xml;break;default:if(xml==""&&ss==""){cell.t='z';}else{cell.t='s';cell.v=xlml_fixstr(ss||xml);}break;}safe_format_xlml(cell,nf,o);if(o.cellFormula!==false){if(cell.Formula){var fstr=unescapexml(cell.Formula);/* strictly speaking, the leading = is required but some writers omit */if(fstr.charCodeAt(0)==61/* = */)fstr=fstr.slice(1);cell.f=rc_to_a1(fstr,base);delete cell.Formula;if(cell.ArrayRange=="RC")cell.F=rc_to_a1("RC:RC",base);else if(cell.ArrayRange){cell.F=rc_to_a1(cell.ArrayRange,base);arrayf.push([safe_decode_range(cell.F),cell.F]);}}else{for(i=0;i<arrayf.length;++i){if(base.r>=arrayf[i][0].s.r&&base.r<=arrayf[i][0].e.r)if(base.c>=arrayf[i][0].s.c&&base.c<=arrayf[i][0].e.c)cell.F=arrayf[i][1];}}}if(o.cellStyles){interiors.forEach(function(x){if(!S.patternType&&x.patternType)S.patternType=x.patternType;});cell.s=S;}if(cell.StyleID!==undefined)cell.ixfe=cell.StyleID;}function xlml_clean_comment(comment/*:any*/){comment.t=comment.v||"";comment.t=comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");comment.v=comment.w=comment.ixfe=undefined;}/* TODO: Everything */function parse_xlml_xml(d,_opts)/*:Workbook*/{var opts=_opts||{};make_ssf();var str=debom(xlml_normalize(d));if(opts.type=='binary'||opts.type=='array'||opts.type=='base64'){if(typeof $cptable!=='undefined')str=$cptable.utils.decode(65001,char_codes(str));else str=utf8read(str);}var opening=str.slice(0,1024).toLowerCase(),ishtml=false;opening=opening.replace(/".*?"/g,"");if((opening.indexOf(">")&1023)>Math.min(opening.indexOf(",")&1023,opening.indexOf(";")&1023)){var _o=dup(opts);_o.type="string";return PRN.to_workbook(str,_o);}if(opening.indexOf("<?xml")==-1)["html","table","head","meta","script","style","div"].forEach(function(tag){if(opening.indexOf("<"+tag)>=0)ishtml=true;});if(ishtml)return html_to_workbook(str,opts);XLMLFormatMap={"General Number":"General","General Date":table_fmt[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":table_fmt[15],"Short Date":table_fmt[14],"Long Time":table_fmt[19],"Medium Time":table_fmt[18],"Short Time":table_fmt[20],"Currency":'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',"Fixed":table_fmt[2],"Standard":table_fmt[4],"Percent":table_fmt[10],"Scientific":table_fmt[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'/*:any*/};var Rn;var state=[],tmp;if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var sheets={},sheetnames/*:Array<string>*/=[],cursheet/*:Worksheet*/=opts.dense?[]:{},sheetname="";var cell={}/*:any*/,row={};// eslint-disable-line no-unused-vars
var dtag=xlml_parsexmltag('<Data ss:Type="String">'),didx=0;var c=0,r=0;var refguess/*:Range*/={s:{r:2000000,c:2000000},e:{r:0,c:0}};var styles={},stag={};var ss="",fidx=0;var merges/*:Array<Range>*/=[];var Props={},Custprops={},pidx=0,cp=[];var comments/*:Array<Comment>*/=[],comment/*:Comment*/={}/*:any*/;var cstys=[],csty,seencol=false;var arrayf/*:Array<[Range, string]>*/=[];var rowinfo/*:Array<RowInfo>*/=[],rowobj={},cc=0,rr=0;var Workbook/*:WBWBProps*/={Sheets:[],WBProps:{date1904:false}/*:any*/},wsprops={};xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"");var raw_Rn3="";while(Rn=xlmlregex.exec(str)){switch(Rn[3]=(raw_Rn3=Rn[3]).toLowerCase()){case'data'/*case 'Data'*/:if(raw_Rn3=="data"){if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;}if(state[state.length-1][1])break;if(Rn[1]==='/')parse_xlml_data(str.slice(didx,Rn.index),ss,dtag,state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell,{c:c,r:r},styles,cstys[c],row,arrayf,opts);else{ss="";dtag=xlml_parsexmltag(Rn[0]);didx=Rn.index+Rn[0].length;}break;case'cell'/*case 'Cell'*/:if(Rn[1]==='/'){if(comments.length>0)cell.c=comments;if((!opts.sheetRows||opts.sheetRows>r)&&cell.v!==undefined){if(opts.dense){if(!cursheet[r])cursheet[r]=[];cursheet[r][c]=cell;}else cursheet[encode_col(c)+encode_row(r)]=cell;}if(cell.HRef){cell.l={Target:unescapexml(cell.HRef)/*:any*/};if(cell.HRefScreenTip)cell.l.Tooltip=cell.HRefScreenTip;delete cell.HRef;delete cell.HRefScreenTip;}if(cell.MergeAcross||cell.MergeDown){cc=c+(parseInt(cell.MergeAcross,10)|0);rr=r+(parseInt(cell.MergeDown,10)|0);merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});}if(!opts.sheetStubs){if(cell.MergeAcross)c=cc+1;else++c;}else if(cell.MergeAcross||cell.MergeDown){/*:: if(!cc) cc = 0; if(!rr) rr = 0; */for(var cma=c;cma<=cc;++cma){for(var cmd=r;cmd<=rr;++cmd){if(cma>c||cmd>r){if(opts.dense){if(!cursheet[cmd])cursheet[cmd]=[];cursheet[cmd][cma]={t:'z'};}else cursheet[encode_col(cma)+encode_row(cmd)]={t:'z'};}}}c=cc+1;}else++c;}else{cell=xlml_parsexmltagobj(Rn[0]);if(cell.Index)c=+cell.Index-1;if(c<refguess.s.c)refguess.s.c=c;if(c>refguess.e.c)refguess.e.c=c;if(Rn[0].slice(-2)==="/>")++c;comments=[];}break;case'row'/*case 'Row'*/:if(Rn[1]==='/'||Rn[0].slice(-2)==="/>"){if(r<refguess.s.r)refguess.s.r=r;if(r>refguess.e.r)refguess.e.r=r;if(Rn[0].slice(-2)==="/>"){row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;}c=0;++r;}else{row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1;rowobj={};if(row.AutoFitHeight=="0"||row.Height){rowobj.hpx=parseInt(row.Height,10);rowobj.hpt=px2pt(rowobj.hpx);rowinfo[r]=rowobj;}if(row.Hidden=="1"){rowobj.hidden=true;rowinfo[r]=rowobj;}}break;case'worksheet'/*case 'Worksheet'*/:/* TODO: read range from FullRows/FullColumns */if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));sheetnames.push(sheetname);if(refguess.s.r<=refguess.e.r&&refguess.s.c<=refguess.e.c){cursheet["!ref"]=encode_range(refguess);if(opts.sheetRows&&opts.sheetRows<=refguess.e.r){cursheet["!fullref"]=cursheet["!ref"];refguess.e.r=opts.sheetRows-1;cursheet["!ref"]=encode_range(refguess);}}if(merges.length)cursheet["!merges"]=merges;if(cstys.length>0)cursheet["!cols"]=cstys;if(rowinfo.length>0)cursheet["!rows"]=rowinfo;sheets[sheetname]=cursheet;}else{refguess={s:{r:2000000,c:2000000},e:{r:0,c:0}};r=c=0;state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);sheetname=unescapexml(tmp.Name);cursheet=opts.dense?[]:{};merges=[];arrayf=[];rowinfo=[];wsprops={name:sheetname,Hidden:0};Workbook.Sheets.push(wsprops);}break;case'table'/*case 'Table'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].slice(-2)=="/>")break;else{state.push([Rn[3],false]);cstys=[];seencol=false;}break;case'style'/*case 'Style'*/:if(Rn[1]==='/')process_style_xlml(styles,stag,opts);else stag=xlml_parsexmltag(Rn[0]);break;case'numberformat'/*case 'NumberFormat'*/:stag.nf=unescapexml(xlml_parsexmltag(Rn[0]).Format||"General");if(XLMLFormatMap[stag.nf])stag.nf=XLMLFormatMap[stag.nf];for(var ssfidx=0;ssfidx!=0x188;++ssfidx){if(table_fmt[ssfidx]==stag.nf)break;}if(ssfidx==0x188)for(ssfidx=0x39;ssfidx!=0x188;++ssfidx){if(table_fmt[ssfidx]==null){SSF_load(stag.nf,ssfidx);break;}}break;case'column'/*case 'Column'*/:if(state[state.length-1][0]!==/*'Table'*/'table')break;csty=xlml_parsexmltag(Rn[0]);if(csty.Hidden){csty.hidden=true;delete csty.Hidden;}if(csty.Width)csty.wpx=parseInt(csty.Width,10);if(!seencol&&csty.wpx>10){seencol=true;MDW=DEF_MDW;//find_mdw_wpx(csty.wpx);
for(var _col=0;_col<cstys.length;++_col){if(cstys[_col])process_col(cstys[_col]);}}if(seencol)process_col(csty);cstys[csty.Index-1||cstys.length]=csty;for(var i=0;i<+csty.Span;++i){cstys[cstys.length]=dup(csty);}break;case'namedrange'/*case 'NamedRange'*/:if(Rn[1]==='/')break;if(!Workbook.Names)Workbook.Names=[];var _NamedRange=parsexmltag(Rn[0]);var _DefinedName/*:DefinedName*/={Name:_NamedRange.Name,Ref:rc_to_a1(_NamedRange.RefersTo.slice(1),{r:0,c:0})/*:any*/};if(Workbook.Sheets.length>0)_DefinedName.Sheet=Workbook.Sheets.length-1;/*:: if(Workbook.Names) */Workbook.Names.push(_DefinedName);break;case'namedcell'/*case 'NamedCell'*/:break;case'b'/*case 'B'*/:break;case'i'/*case 'I'*/:break;case'u'/*case 'U'*/:break;case's'/*case 'S'*/:break;case'em'/*case 'EM'*/:break;case'h2'/*case 'H2'*/:break;case'h3'/*case 'H3'*/:break;case'sub'/*case 'Sub'*/:break;case'sup'/*case 'Sup'*/:break;case'span'/*case 'Span'*/:break;case'alignment'/*case 'Alignment'*/:break;case'borders'/*case 'Borders'*/:break;case'border'/*case 'Border'*/:break;case'font'/*case 'Font'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")ss+=str.slice(fidx,Rn.index);else fidx=Rn.index+Rn[0].length;break;case'interior'/*case 'Interior'*/:if(!opts.cellStyles)break;stag.Interior=xlml_parsexmltag(Rn[0]);break;case'protection'/*case 'Protection'*/:break;case'author'/*case 'Author'*/:case'title'/*case 'Title'*/:case'description'/*case 'Description'*/:case'created'/*case 'Created'*/:case'keywords'/*case 'Keywords'*/:case'subject'/*case 'Subject'*/:case'category'/*case 'Category'*/:case'company'/*case 'Company'*/:case'lastauthor'/*case 'LastAuthor'*/:case'lastsaved'/*case 'LastSaved'*/:case'lastprinted'/*case 'LastPrinted'*/:case'version'/*case 'Version'*/:case'revision'/*case 'Revision'*/:case'totaltime'/*case 'TotalTime'*/:case'hyperlinkbase'/*case 'HyperlinkBase'*/:case'manager'/*case 'Manager'*/:case'contentstatus'/*case 'ContentStatus'*/:case'identifier'/*case 'Identifier'*/:case'language'/*case 'Language'*/:case'appname'/*case 'AppName'*/:if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_prop(Props,raw_Rn3,str.slice(pidx,Rn.index));else pidx=Rn.index+Rn[0].length;break;case'paragraphs'/*case 'Paragraphs'*/:break;case'styles'/*case 'Styles'*/:case'workbook'/*case 'Workbook'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else state.push([Rn[3],false]);break;case'comment'/*case 'Comment'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));xlml_clean_comment(comment);comments.push(comment);}else{state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);comment={a:tmp.Author/*:any*/};}break;case'autofilter'/*case 'AutoFilter'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){var AutoFilter=xlml_parsexmltag(Rn[0]);cursheet['!autofilter']={ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"")};state.push([Rn[3],true]);}break;case'name'/*case 'Name'*/:break;case'datavalidation'/*case 'DataValidation'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else{if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);}break;case'pixelsperinch'/*case 'PixelsPerInch'*/:break;case'componentoptions'/*case 'ComponentOptions'*/:case'documentproperties'/*case 'DocumentProperties'*/:case'customdocumentproperties'/*case 'CustomDocumentProperties'*/:case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:case'names'/*case 'Names'*/:case'mapinfo'/*case 'MapInfo'*/:case'pagebreaks'/*case 'PageBreaks'*/:case'querytable'/*case 'QueryTable'*/:case'sorting'/*case 'Sorting'*/:case'schema'/*case 'Schema'*/://case 'data' /*case 'data'*/:
case'conditionalformatting'/*case 'ConditionalFormatting'*/:case'smarttagtype'/*case 'SmartTagType'*/:case'smarttags'/*case 'SmartTags'*/:case'excelworkbook'/*case 'ExcelWorkbook'*/:case'workbookoptions'/*case 'WorkbookOptions'*/:case'worksheetoptions'/*case 'WorksheetOptions'*/:if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw new Error("Bad state: "+tmp.join("|"));}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'null'/*case 'Null'*/:break;default:/* FODS file root is <office:document> */if(state.length==0&&Rn[3]=="document")return parse_fods(str,opts);/* UOS file root is <uof:UOF> */if(state.length==0&&Rn[3]=="uof"/*"UOF"*/)return parse_fods(str,opts);var seen=true;switch(state[state.length-1][0]){/* OfficeDocumentSettings */case'officedocumentsettings'/*case 'OfficeDocumentSettings'*/:switch(Rn[3]){case'allowpng'/*case 'AllowPNG'*/:break;case'removepersonalinformation'/*case 'RemovePersonalInformation'*/:break;case'downloadcomponents'/*case 'DownloadComponents'*/:break;case'locationofcomponents'/*case 'LocationOfComponents'*/:break;case'colors'/*case 'Colors'*/:break;case'color'/*case 'Color'*/:break;case'index'/*case 'Index'*/:break;case'rgb'/*case 'RGB'*/:break;case'targetscreensize'/*case 'TargetScreenSize'*/:break;case'readonlyrecommended'/*case 'ReadOnlyRecommended'*/:break;default:seen=false;}break;/* ComponentOptions */case'componentoptions'/*case 'ComponentOptions'*/:switch(Rn[3]){case'toolbar'/*case 'Toolbar'*/:break;case'hideofficelogo'/*case 'HideOfficeLogo'*/:break;case'spreadsheetautofit'/*case 'SpreadsheetAutoFit'*/:break;case'label'/*case 'Label'*/:break;case'caption'/*case 'Caption'*/:break;case'maxheight'/*case 'MaxHeight'*/:break;case'maxwidth'/*case 'MaxWidth'*/:break;case'nextsheetnumber'/*case 'NextSheetNumber'*/:break;default:seen=false;}break;/* ExcelWorkbook */case'excelworkbook'/*case 'ExcelWorkbook'*/:switch(Rn[3]){case'date1904'/*case 'Date1904'*/:/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */Workbook.WBProps.date1904=true;break;case'windowheight'/*case 'WindowHeight'*/:break;case'windowwidth'/*case 'WindowWidth'*/:break;case'windowtopx'/*case 'WindowTopX'*/:break;case'windowtopy'/*case 'WindowTopY'*/:break;case'tabratio'/*case 'TabRatio'*/:break;case'protectstructure'/*case 'ProtectStructure'*/:break;case'protectwindow'/*case 'ProtectWindow'*/:break;case'protectwindows'/*case 'ProtectWindows'*/:break;case'activesheet'/*case 'ActiveSheet'*/:break;case'displayinknotes'/*case 'DisplayInkNotes'*/:break;case'firstvisiblesheet'/*case 'FirstVisibleSheet'*/:break;case'supbook'/*case 'SupBook'*/:break;case'sheetname'/*case 'SheetName'*/:break;case'sheetindex'/*case 'SheetIndex'*/:break;case'sheetindexfirst'/*case 'SheetIndexFirst'*/:break;case'sheetindexlast'/*case 'SheetIndexLast'*/:break;case'dll'/*case 'Dll'*/:break;case'acceptlabelsinformulas'/*case 'AcceptLabelsInFormulas'*/:break;case'donotsavelinkvalues'/*case 'DoNotSaveLinkValues'*/:break;case'iteration'/*case 'Iteration'*/:break;case'maxiterations'/*case 'MaxIterations'*/:break;case'maxchange'/*case 'MaxChange'*/:break;case'path'/*case 'Path'*/:break;case'xct'/*case 'Xct'*/:break;case'count'/*case 'Count'*/:break;case'selectedsheets'/*case 'SelectedSheets'*/:break;case'calculation'/*case 'Calculation'*/:break;case'uncalced'/*case 'Uncalced'*/:break;case'startupprompt'/*case 'StartupPrompt'*/:break;case'crn'/*case 'Crn'*/:break;case'externname'/*case 'ExternName'*/:break;case'formula'/*case 'Formula'*/:break;case'colfirst'/*case 'ColFirst'*/:break;case'collast'/*case 'ColLast'*/:break;case'wantadvise'/*case 'WantAdvise'*/:break;case'boolean'/*case 'Boolean'*/:break;case'error'/*case 'Error'*/:break;case'text'/*case 'Text'*/:break;case'ole'/*case 'OLE'*/:break;case'noautorecover'/*case 'NoAutoRecover'*/:break;case'publishobjects'/*case 'PublishObjects'*/:break;case'donotcalculatebeforesave'/*case 'DoNotCalculateBeforeSave'*/:break;case'number'/*case 'Number'*/:break;case'refmoder1c1'/*case 'RefModeR1C1'*/:break;case'embedsavesmarttags'/*case 'EmbedSaveSmartTags'*/:break;default:seen=false;}break;/* WorkbookOptions */case'workbookoptions'/*case 'WorkbookOptions'*/:switch(Rn[3]){case'owcversion'/*case 'OWCVersion'*/:break;case'height'/*case 'Height'*/:break;case'width'/*case 'Width'*/:break;default:seen=false;}break;/* WorksheetOptions */case'worksheetoptions'/*case 'WorksheetOptions'*/:switch(Rn[3]){case'visible'/*case 'Visible'*/:if(Rn[0].slice(-2)==="/>"){/* empty */}else if(Rn[1]==="/")switch(str.slice(pidx,Rn.index)){case"SheetHidden":wsprops.Hidden=1;break;case"SheetVeryHidden":wsprops.Hidden=2;break;}else pidx=Rn.index+Rn[0].length;break;case'header'/*case 'Header'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+parsexmltag(Rn[0]).Margin))cursheet['!margins'].header=+parsexmltag(Rn[0]).Margin;break;case'footer'/*case 'Footer'*/:if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+parsexmltag(Rn[0]).Margin))cursheet['!margins'].footer=+parsexmltag(Rn[0]).Margin;break;case'pagemargins'/*case 'PageMargins'*/:var pagemargins=parsexmltag(Rn[0]);if(!cursheet['!margins'])default_margins(cursheet['!margins']={},'xlml');if(!isNaN(+pagemargins.Top))cursheet['!margins'].top=+pagemargins.Top;if(!isNaN(+pagemargins.Left))cursheet['!margins'].left=+pagemargins.Left;if(!isNaN(+pagemargins.Right))cursheet['!margins'].right=+pagemargins.Right;if(!isNaN(+pagemargins.Bottom))cursheet['!margins'].bottom=+pagemargins.Bottom;break;case'displayrighttoleft'/*case 'DisplayRightToLeft'*/:if(!Workbook.Views)Workbook.Views=[];if(!Workbook.Views[0])Workbook.Views[0]={};Workbook.Views[0].RTL=true;break;case'freezepanes'/*case 'FreezePanes'*/:break;case'frozennosplit'/*case 'FrozenNoSplit'*/:break;case'splithorizontal'/*case 'SplitHorizontal'*/:case'splitvertical'/*case 'SplitVertical'*/:break;case'donotdisplaygridlines'/*case 'DoNotDisplayGridlines'*/:break;case'activerow'/*case 'ActiveRow'*/:break;case'activecol'/*case 'ActiveCol'*/:break;case'toprowbottompane'/*case 'TopRowBottomPane'*/:break;case'leftcolumnrightpane'/*case 'LeftColumnRightPane'*/:break;case'unsynced'/*case 'Unsynced'*/:break;case'print'/*case 'Print'*/:break;case'printerrors'/*case 'PrintErrors'*/:break;case'panes'/*case 'Panes'*/:break;case'scale'/*case 'Scale'*/:break;case'pane'/*case 'Pane'*/:break;case'number'/*case 'Number'*/:break;case'layout'/*case 'Layout'*/:break;case'pagesetup'/*case 'PageSetup'*/:break;case'selected'/*case 'Selected'*/:break;case'protectobjects'/*case 'ProtectObjects'*/:break;case'enableselection'/*case 'EnableSelection'*/:break;case'protectscenarios'/*case 'ProtectScenarios'*/:break;case'validprinterinfo'/*case 'ValidPrinterInfo'*/:break;case'horizontalresolution'/*case 'HorizontalResolution'*/:break;case'verticalresolution'/*case 'VerticalResolution'*/:break;case'numberofcopies'/*case 'NumberofCopies'*/:break;case'activepane'/*case 'ActivePane'*/:break;case'toprowvisible'/*case 'TopRowVisible'*/:break;case'leftcolumnvisible'/*case 'LeftColumnVisible'*/:break;case'fittopage'/*case 'FitToPage'*/:break;case'rangeselection'/*case 'RangeSelection'*/:break;case'papersizeindex'/*case 'PaperSizeIndex'*/:break;case'pagelayoutzoom'/*case 'PageLayoutZoom'*/:break;case'pagebreakzoom'/*case 'PageBreakZoom'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'fitwidth'/*case 'FitWidth'*/:break;case'fitheight'/*case 'FitHeight'*/:break;case'commentslayout'/*case 'CommentsLayout'*/:break;case'zoom'/*case 'Zoom'*/:break;case'lefttoright'/*case 'LeftToRight'*/:break;case'gridlines'/*case 'Gridlines'*/:break;case'allowsort'/*case 'AllowSort'*/:break;case'allowfilter'/*case 'AllowFilter'*/:break;case'allowinsertrows'/*case 'AllowInsertRows'*/:break;case'allowdeleterows'/*case 'AllowDeleteRows'*/:break;case'allowinsertcols'/*case 'AllowInsertCols'*/:break;case'allowdeletecols'/*case 'AllowDeleteCols'*/:break;case'allowinserthyperlinks'/*case 'AllowInsertHyperlinks'*/:break;case'allowformatcells'/*case 'AllowFormatCells'*/:break;case'allowsizecols'/*case 'AllowSizeCols'*/:break;case'allowsizerows'/*case 'AllowSizeRows'*/:break;case'nosummaryrowsbelowdetail'/*case 'NoSummaryRowsBelowDetail'*/:if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].above=true;break;case'tabcolorindex'/*case 'TabColorIndex'*/:break;case'donotdisplayheadings'/*case 'DoNotDisplayHeadings'*/:break;case'showpagelayoutzoom'/*case 'ShowPageLayoutZoom'*/:break;case'nosummarycolumnsrightdetail'/*case 'NoSummaryColumnsRightDetail'*/:if(!cursheet["!outline"])cursheet["!outline"]={};cursheet["!outline"].left=true;break;case'blackandwhite'/*case 'BlackAndWhite'*/:break;case'donotdisplayzeros'/*case 'DoNotDisplayZeros'*/:break;case'displaypagebreak'/*case 'DisplayPageBreak'*/:break;case'rowcolheadings'/*case 'RowColHeadings'*/:break;case'donotdisplayoutline'/*case 'DoNotDisplayOutline'*/:break;case'noorientation'/*case 'NoOrientation'*/:break;case'allowusepivottables'/*case 'AllowUsePivotTables'*/:break;case'zeroheight'/*case 'ZeroHeight'*/:break;case'viewablerange'/*case 'ViewableRange'*/:break;case'selection'/*case 'Selection'*/:break;case'protectcontents'/*case 'ProtectContents'*/:break;default:seen=false;}break;/* PivotTable */case'pivottable'/*case 'PivotTable'*/:case'pivotcache'/*case 'PivotCache'*/:switch(Rn[3]){case'immediateitemsondrop'/*case 'ImmediateItemsOnDrop'*/:break;case'showpagemultipleitemlabel'/*case 'ShowPageMultipleItemLabel'*/:break;case'compactrowindent'/*case 'CompactRowIndent'*/:break;case'location'/*case 'Location'*/:break;case'pivotfield'/*case 'PivotField'*/:break;case'orientation'/*case 'Orientation'*/:break;case'layoutform'/*case 'LayoutForm'*/:break;case'layoutsubtotallocation'/*case 'LayoutSubtotalLocation'*/:break;case'layoutcompactrow'/*case 'LayoutCompactRow'*/:break;case'position'/*case 'Position'*/:break;case'pivotitem'/*case 'PivotItem'*/:break;case'datatype'/*case 'DataType'*/:break;case'datafield'/*case 'DataField'*/:break;case'sourcename'/*case 'SourceName'*/:break;case'parentfield'/*case 'ParentField'*/:break;case'ptlineitems'/*case 'PTLineItems'*/:break;case'ptlineitem'/*case 'PTLineItem'*/:break;case'countofsameitems'/*case 'CountOfSameItems'*/:break;case'item'/*case 'Item'*/:break;case'itemtype'/*case 'ItemType'*/:break;case'ptsource'/*case 'PTSource'*/:break;case'cacheindex'/*case 'CacheIndex'*/:break;case'consolidationreference'/*case 'ConsolidationReference'*/:break;case'filename'/*case 'FileName'*/:break;case'reference'/*case 'Reference'*/:break;case'nocolumngrand'/*case 'NoColumnGrand'*/:break;case'norowgrand'/*case 'NoRowGrand'*/:break;case'blanklineafteritems'/*case 'BlankLineAfterItems'*/:break;case'hidden'/*case 'Hidden'*/:break;case'subtotal'/*case 'Subtotal'*/:break;case'basefield'/*case 'BaseField'*/:break;case'mapchilditems'/*case 'MapChildItems'*/:break;case'function'/*case 'Function'*/:break;case'refreshonfileopen'/*case 'RefreshOnFileOpen'*/:break;case'printsettitles'/*case 'PrintSetTitles'*/:break;case'mergelabels'/*case 'MergeLabels'*/:break;case'defaultversion'/*case 'DefaultVersion'*/:break;case'refreshname'/*case 'RefreshName'*/:break;case'refreshdate'/*case 'RefreshDate'*/:break;case'refreshdatecopy'/*case 'RefreshDateCopy'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;case'versionlastupdate'/*case 'VersionLastUpdate'*/:break;case'versionupdateablemin'/*case 'VersionUpdateableMin'*/:break;case'versionrefreshablemin'/*case 'VersionRefreshableMin'*/:break;case'calculation'/*case 'Calculation'*/:break;default:seen=false;}break;/* PageBreaks */case'pagebreaks'/*case 'PageBreaks'*/:switch(Rn[3]){case'colbreaks'/*case 'ColBreaks'*/:break;case'colbreak'/*case 'ColBreak'*/:break;case'rowbreaks'/*case 'RowBreaks'*/:break;case'rowbreak'/*case 'RowBreak'*/:break;case'colstart'/*case 'ColStart'*/:break;case'colend'/*case 'ColEnd'*/:break;case'rowend'/*case 'RowEnd'*/:break;default:seen=false;}break;/* AutoFilter */case'autofilter'/*case 'AutoFilter'*/:switch(Rn[3]){case'autofiltercolumn'/*case 'AutoFilterColumn'*/:break;case'autofiltercondition'/*case 'AutoFilterCondition'*/:break;case'autofilterand'/*case 'AutoFilterAnd'*/:break;case'autofilteror'/*case 'AutoFilterOr'*/:break;default:seen=false;}break;/* QueryTable */case'querytable'/*case 'QueryTable'*/:switch(Rn[3]){case'id'/*case 'Id'*/:break;case'autoformatfont'/*case 'AutoFormatFont'*/:break;case'autoformatpattern'/*case 'AutoFormatPattern'*/:break;case'querysource'/*case 'QuerySource'*/:break;case'querytype'/*case 'QueryType'*/:break;case'enableredirections'/*case 'EnableRedirections'*/:break;case'refreshedinxl9'/*case 'RefreshedInXl9'*/:break;case'urlstring'/*case 'URLString'*/:break;case'htmltables'/*case 'HTMLTables'*/:break;case'connection'/*case 'Connection'*/:break;case'commandtext'/*case 'CommandText'*/:break;case'refreshinfo'/*case 'RefreshInfo'*/:break;case'notitles'/*case 'NoTitles'*/:break;case'nextid'/*case 'NextId'*/:break;case'columninfo'/*case 'ColumnInfo'*/:break;case'overwritecells'/*case 'OverwriteCells'*/:break;case'donotpromptforfile'/*case 'DoNotPromptForFile'*/:break;case'textwizardsettings'/*case 'TextWizardSettings'*/:break;case'source'/*case 'Source'*/:break;case'number'/*case 'Number'*/:break;case'decimal'/*case 'Decimal'*/:break;case'thousandseparator'/*case 'ThousandSeparator'*/:break;case'trailingminusnumbers'/*case 'TrailingMinusNumbers'*/:break;case'formatsettings'/*case 'FormatSettings'*/:break;case'fieldtype'/*case 'FieldType'*/:break;case'delimiters'/*case 'Delimiters'*/:break;case'tab'/*case 'Tab'*/:break;case'comma'/*case 'Comma'*/:break;case'autoformatname'/*case 'AutoFormatName'*/:break;case'versionlastedit'/*case 'VersionLastEdit'*/:break;case'versionlastrefresh'/*case 'VersionLastRefresh'*/:break;default:seen=false;}break;case'datavalidation'/*case 'DataValidation'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;default:seen=false;}break;case'sorting'/*case 'Sorting'*/:case'conditionalformatting'/*case 'ConditionalFormatting'*/:switch(Rn[3]){case'range'/*case 'Range'*/:break;case'type'/*case 'Type'*/:break;case'min'/*case 'Min'*/:break;case'max'/*case 'Max'*/:break;case'sort'/*case 'Sort'*/:break;case'descending'/*case 'Descending'*/:break;case'order'/*case 'Order'*/:break;case'casesensitive'/*case 'CaseSensitive'*/:break;case'value'/*case 'Value'*/:break;case'errorstyle'/*case 'ErrorStyle'*/:break;case'errormessage'/*case 'ErrorMessage'*/:break;case'errortitle'/*case 'ErrorTitle'*/:break;case'cellrangelist'/*case 'CellRangeList'*/:break;case'inputmessage'/*case 'InputMessage'*/:break;case'inputtitle'/*case 'InputTitle'*/:break;case'combohide'/*case 'ComboHide'*/:break;case'inputhide'/*case 'InputHide'*/:break;case'condition'/*case 'Condition'*/:break;case'qualifier'/*case 'Qualifier'*/:break;case'useblank'/*case 'UseBlank'*/:break;case'value1'/*case 'Value1'*/:break;case'value2'/*case 'Value2'*/:break;case'format'/*case 'Format'*/:break;default:seen=false;}break;/* MapInfo (schema) */case'mapinfo'/*case 'MapInfo'*/:case'schema'/*case 'Schema'*/:case'data'/*case 'data'*/:switch(Rn[3]){case'map'/*case 'Map'*/:break;case'entry'/*case 'Entry'*/:break;case'range'/*case 'Range'*/:break;case'xpath'/*case 'XPath'*/:break;case'field'/*case 'Field'*/:break;case'xsdtype'/*case 'XSDType'*/:break;case'filteron'/*case 'FilterOn'*/:break;case'aggregate'/*case 'Aggregate'*/:break;case'elementtype'/*case 'ElementType'*/:break;case'attributetype'/*case 'AttributeType'*/:break;/* These are from xsd (XML Schema Definition) */case'schema'/*case 'schema'*/:case'element'/*case 'element'*/:case'complextype'/*case 'complexType'*/:case'datatype'/*case 'datatype'*/:case'all'/*case 'all'*/:case'attribute'/*case 'attribute'*/:case'extends'/*case 'extends'*/:break;case'row'/*case 'row'*/:break;default:seen=false;}break;/* SmartTags (can be anything) */case'smarttags'/*case 'SmartTags'*/:break;default:seen=false;break;}if(seen)break;/* CustomDocumentProperties */if(Rn[3].match(/!\[CDATA/))break;if(!state[state.length-1][1])throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties'){if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_custprop(Custprops,raw_Rn3,cp,str.slice(pidx,Rn.index));else{cp=Rn;pidx=Rn.index+Rn[0].length;}break;}if(opts.WTF)throw'Unrecognized tag: '+Rn[3]+"|"+state.join("|");}}var out={}/*:any*/;if(!opts.bookSheets&&!opts.bookProps)out.Sheets=sheets;out.SheetNames=sheetnames;out.Workbook=Workbook;out.SSF=dup(table_fmt);out.Props=Props;out.Custprops=Custprops;return out;}function parse_xlml(data/*:RawBytes|string*/,opts)/*:Workbook*/{fix_read_opts(opts=opts||{});switch(opts.type||"base64"){case"base64":return parse_xlml_xml(Base64_decode(data),opts);case"binary":case"buffer":case"file":return parse_xlml_xml(data,opts);case"array":return parse_xlml_xml(a2s(data),opts);}/*:: throw new Error("unsupported type " + opts.type); */}/* TODO */function write_props_xlml(wb/*:Workbook*/,opts)/*:string*/{var o/*:Array<string>*/=[];/* DocumentProperties */if(wb.Props)o.push(xlml_write_docprops(wb.Props,opts));/* CustomDocumentProperties */if(wb.Custprops)o.push(xlml_write_custprops(wb.Props,wb.Custprops,opts));return o.join("");}/* TODO */function write_wb_xlml()/*::wb, opts*//*:string*/{/* OfficeDocumentSettings *//* ExcelWorkbook */return"";}/* TODO */function write_sty_xlml(wb,opts)/*:string*/{/* Styles */var styles/*:Array<string>*/=['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];opts.cellXfs.forEach(function(xf,id){var payload/*:Array<string>*/=[];payload.push(writextag('NumberFormat',null,{"ss:Format":escapexml(table_fmt[xf.numFmtId])}));var o=/*::(*/{"ss:ID":"s"+(21+id)/*:: :any)*/};styles.push(writextag('Style',payload.join(""),o));});return writextag("Styles",styles.join(""));}function write_name_xlml(n){return writextag("NamedRange",null,{"ss:Name":n.Name,"ss:RefersTo":"="+a1_to_rc(n.Ref,{r:0,c:0})});}function write_names_xlml(wb/*::, opts*/)/*:string*/{if(!((wb||{}).Workbook||{}).Names)return"";/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */var names/*:Array<any>*/=wb.Workbook.Names;var out/*:Array<string>*/=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=null)continue;if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return writextag("Names",out.join(""));}function write_ws_xlml_names(ws/*:Worksheet*/,opts,idx/*:number*/,wb/*:Workbook*/)/*:string*/{if(!ws)return"";if(!((wb||{}).Workbook||{}).Names)return"";/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */var names/*:Array<any>*/=wb.Workbook.Names;var out/*:Array<string>*/=[];for(var i=0;i<names.length;++i){var n=names[i];if(n.Sheet!=idx)continue;/*switch(n.Name) {
			case "_": continue;
		}*/if(n.Name.match(/^_xlfn\./))continue;out.push(write_name_xlml(n));}return out.join("");}/* WorksheetOptions */function write_ws_xlml_wsopts(ws/*:Worksheet*/,opts,idx/*:number*/,wb/*:Workbook*/)/*:string*/{if(!ws)return"";var o/*:Array<string>*/=[];/* NOTE: spec technically allows any order, but stick with implied order *//* FitToPage *//* DoNotDisplayColHeaders *//* DoNotDisplayRowHeaders *//* ViewableRange *//* Selection *//* GridlineColor *//* Name *//* ExcelWorksheetType *//* IntlMacro *//* Unsynced *//* Selected *//* CodeName */if(ws['!margins']){o.push("<PageSetup>");if(ws['!margins'].header)o.push(writextag("Header",null,{'x:Margin':ws['!margins'].header}));if(ws['!margins'].footer)o.push(writextag("Footer",null,{'x:Margin':ws['!margins'].footer}));o.push(writextag("PageMargins",null,{'x:Bottom':ws['!margins'].bottom||"0.75",'x:Left':ws['!margins'].left||"0.7",'x:Right':ws['!margins'].right||"0.7",'x:Top':ws['!margins'].top||"0.75"}));o.push("</PageSetup>");}/* PageSetup *//* DisplayPageBreak *//* TransitionExpressionEvaluation *//* TransitionFormulaEntry *//* Print *//* Zoom *//* PageLayoutZoom *//* PageBreakZoom *//* ShowPageBreakZoom *//* DefaultRowHeight *//* DefaultColumnWidth *//* StandardWidth */if(wb&&wb.Workbook&&wb.Workbook.Sheets&&wb.Workbook.Sheets[idx]){/* Visible */if(wb.Workbook.Sheets[idx].Hidden)o.push(writextag("Visible",wb.Workbook.Sheets[idx].Hidden==1?"SheetHidden":"SheetVeryHidden",{}));else{/* Selected */for(var i=0;i<idx;++i){if(wb.Workbook.Sheets[i]&&!wb.Workbook.Sheets[i].Hidden)break;}if(i==idx)o.push("<Selected/>");}}/* LeftColumnVisible */if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL)o.push("<DisplayRightToLeft/>");/* GridlineColorIndex *//* DisplayFormulas *//* DoNotDisplayGridlines *//* DoNotDisplayHeadings *//* DoNotDisplayOutline *//* ApplyAutomaticOutlineStyles *//* NoSummaryRowsBelowDetail *//* NoSummaryColumnsRightDetail *//* DoNotDisplayZeros *//* ActiveRow *//* ActiveColumn *//* FilterOn *//* RangeSelection *//* TopRowVisible *//* TopRowBottomPane *//* LeftColumnRightPane *//* ActivePane *//* SplitHorizontal *//* SplitVertical *//* FreezePanes *//* FrozenNoSplit *//* TabColorIndex *//* Panes *//* NOTE: Password not supported in XLML Format */if(ws['!protect']){o.push(writetag("ProtectContents","True"));if(ws['!protect'].objects)o.push(writetag("ProtectObjects","True"));if(ws['!protect'].scenarios)o.push(writetag("ProtectScenarios","True"));if(ws['!protect'].selectLockedCells!=null&&!ws['!protect'].selectLockedCells)o.push(writetag("EnableSelection","NoSelection"));else if(ws['!protect'].selectUnlockedCells!=null&&!ws['!protect'].selectUnlockedCells)o.push(writetag("EnableSelection","UnlockedCells"));[["formatCells","AllowFormatCells"],["formatColumns","AllowSizeCols"],["formatRows","AllowSizeRows"],["insertColumns","AllowInsertCols"],["insertRows","AllowInsertRows"],["insertHyperlinks","AllowInsertHyperlinks"],["deleteColumns","AllowDeleteCols"],["deleteRows","AllowDeleteRows"],["sort","AllowSort"],["autoFilter","AllowFilter"],["pivotTables","AllowUsePivotTables"]].forEach(function(x){if(ws['!protect'][x[0]])o.push("<"+x[1]+"/>");});}if(o.length==0)return"";return writextag("WorksheetOptions",o.join(""),{xmlns:XLMLNS.x});}function write_ws_xlml_comment(comments/*:Array<any>*/)/*:string*/{return comments.map(function(c){// TODO: formatted text
var t=xlml_unfixstr(c.t||"");var d=writextag("ss:Data",t,{"xmlns":"http://www.w3.org/TR/REC-html40"});return writextag("Comment",d,{"ss:Author":c.a});}).join("");}function write_ws_xlml_cell(cell,ref/*:string*/,ws,opts,idx/*:number*/,wb,addr)/*:string*/{if(!cell||cell.v==undefined&&cell.f==undefined)return"";var attr={};if(cell.f)attr["ss:Formula"]="="+escapexml(a1_to_rc(cell.f,addr));if(cell.F&&cell.F.slice(0,ref.length)==ref){var end=decode_cell(cell.F.slice(ref.length+1));attr["ss:ArrayRange"]="RC:R"+(end.r==addr.r?"":"["+(end.r-addr.r)+"]")+"C"+(end.c==addr.c?"":"["+(end.c-addr.c)+"]");}if(cell.l&&cell.l.Target){attr["ss:HRef"]=escapexml(cell.l.Target);if(cell.l.Tooltip)attr["x:HRefScreenTip"]=escapexml(cell.l.Tooltip);}if(ws['!merges']){var marr=ws['!merges'];for(var mi=0;mi!=marr.length;++mi){if(marr[mi].s.c!=addr.c||marr[mi].s.r!=addr.r)continue;if(marr[mi].e.c>marr[mi].s.c)attr['ss:MergeAcross']=marr[mi].e.c-marr[mi].s.c;if(marr[mi].e.r>marr[mi].s.r)attr['ss:MergeDown']=marr[mi].e.r-marr[mi].s.r;}}var t="",p="";switch(cell.t){case'z':if(!opts.sheetStubs)return"";break;case'n':t='Number';p=String(cell.v);break;case'b':t='Boolean';p=cell.v?"1":"0";break;case'e':t='Error';p=BErr[cell.v];break;case'd':t='DateTime';p=new Date(cell.v).toISOString();if(cell.z==null)cell.z=cell.z||table_fmt[14];break;case's':t='String';p=escapexlml(cell.v||"");break;}/* TODO: cell style */var os=get_cell_style(opts.cellXfs,cell,opts);attr["ss:StyleID"]="s"+(21+os);attr["ss:Index"]=addr.c+1;var _v=cell.v!=null?p:"";var m=cell.t=='z'?"":'<Data ss:Type="'+t+'">'+_v+'</Data>';if((cell.c||[]).length>0)m+=write_ws_xlml_comment(cell.c);return writextag("Cell",m,attr);}function write_ws_xlml_row(R/*:number*/,row)/*:string*/{var o='<Row ss:Index="'+(R+1)+'"';if(row){if(row.hpt&&!row.hpx)row.hpx=pt2px(row.hpt);if(row.hpx)o+=' ss:AutoFitHeight="0" ss:Height="'+row.hpx+'"';if(row.hidden)o+=' ss:Hidden="1"';}return o+'>';}/* TODO */function write_ws_xlml_table(ws/*:Worksheet*/,opts,idx/*:number*/,wb/*:Workbook*/)/*:string*/{if(!ws['!ref'])return"";var range/*:Range*/=safe_decode_range(ws['!ref']);var marr/*:Array<Range>*/=ws['!merges']||[],mi=0;var o/*:Array<string>*/=[];if(ws['!cols'])ws['!cols'].forEach(function(n,i){process_col(n);var w=!!n.width;var p=col_obj_w(i,n);var k/*:any*/={"ss:Index":i+1};if(w)k['ss:Width']=width2px(p.width);if(n.hidden)k['ss:Hidden']="1";o.push(writextag("Column",null,k));});var dense=Array.isArray(ws);for(var R=range.s.r;R<=range.e.r;++R){var row=[write_ws_xlml_row(R,(ws['!rows']||[])[R])];for(var C=range.s.c;C<=range.e.c;++C){var skip=false;for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;break;}if(skip)continue;var addr={r:R,c:C};var ref=encode_cell(addr),cell=dense?(ws[R]||[])[C]:ws[ref];row.push(write_ws_xlml_cell(cell,ref,ws,opts,idx,wb,addr));}row.push("</Row>");if(row.length>2)o.push(row.join(""));}return o.join("");}function write_ws_xlml(idx/*:number*/,opts,wb/*:Workbook*/)/*:string*/{var o/*:Array<string>*/=[];var s=wb.SheetNames[idx];var ws=wb.Sheets[s];var t/*:string*/=ws?write_ws_xlml_names(ws,opts,idx,wb):"";if(t.length>0)o.push("<Names>"+t+"</Names>");/* Table */t=ws?write_ws_xlml_table(ws,opts,idx,wb):"";if(t.length>0)o.push("<Table>"+t+"</Table>");/* WorksheetOptions */o.push(write_ws_xlml_wsopts(ws,opts,idx,wb));return o.join("");}function write_xlml(wb,opts)/*:string*/{if(!opts)opts={};if(!wb.SSF)wb.SSF=dup(table_fmt);if(wb.SSF){make_ssf();SSF_load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});}var d/*:Array<string>*/=[];d.push(write_props_xlml(wb,opts));d.push(write_wb_xlml(wb,opts));d.push("");d.push("");for(var i=0;i<wb.SheetNames.length;++i){d.push(writextag("Worksheet",write_ws_xlml(i,opts,wb),{"ss:Name":escapexml(wb.SheetNames[i])}));}d[2]=write_sty_xlml(wb,opts);d[3]=write_names_xlml(wb,opts);return XML_HEADER+writextag("Workbook",d.join(""),{'xmlns':XLMLNS.ss,'xmlns:o':XLMLNS.o,'xmlns:x':XLMLNS.x,'xmlns:ss':XLMLNS.ss,'xmlns:dt':XLMLNS.dt,'xmlns:html':XLMLNS.html});}/* [MS-OLEDS] 2.3.8 CompObjStream */function parse_compobj(obj/*:CFBEntry*/){var v={};var o=obj.content;/*:: if(o == null) return; *//* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */o.l=28;v.AnsiUserType=o.read_shift(0,"lpstr-ansi");v.AnsiClipboardFormat=parse_ClipboardFormatOrAnsiString(o);if(o.length-o.l<=4)return v;var m/*:number*/=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved1=o.read_shift(0,"lpstr-ansi");if(o.length-o.l<=4)return v;m=o.read_shift(4);if(m!==0x71b239f4)return v;v.UnicodeClipboardFormat=parse_ClipboardFormatOrUnicodeString(o);m=o.read_shift(4);if(m==0||m>40)return v;o.l-=4;v.Reserved2=o.read_shift(0,"lpwstr");}/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/var CONTINUE_RT=[0x003c,0x043c,0x0812,0x0875,0x087f];function slurp(RecordType,R,blob,length/*:number*/,opts)/*:any*/{var l=length;var bufs=[];var d=blob.slice(blob.l,blob.l+l);if(opts&&opts.enc&&opts.enc.insitu&&d.length>0)switch(RecordType){case 0x0009:case 0x0209:case 0x0409:case 0x0809/* BOF */:case 0x002f/* FilePass */:case 0x0195/* FileLock */:case 0x00e1/* InterfaceHdr */:case 0x0196/* RRDInfo */:case 0x0138/* RRDHead */:case 0x0194/* UsrExcl */:case 0x000a/* EOF */:break;case 0x0085/* BoundSheet8 */:break;default:opts.enc.insitu(d);}bufs.push(d);blob.l+=l;var nextrt=__readUInt16LE(blob,blob.l),next=XLSRecordEnum[nextrt];var start=0;while(next!=null&&CONTINUE_RT.indexOf(nextrt)>-1){l=__readUInt16LE(blob,blob.l+2);start=blob.l+4;if(nextrt==0x0812/* ContinueFrt */)start+=4;else if(nextrt==0x0875||nextrt==0x087f){start+=12;}d=blob.slice(start,blob.l+4+l);bufs.push(d);blob.l+=4+l;next=XLSRecordEnum[nextrt=__readUInt16LE(blob,blob.l)];}var b=bconcat(bufs)/*:any*/;prep_blob(b,0);var ll=0;b.lens=[];for(var j=0;j<bufs.length;++j){b.lens.push(ll);ll+=bufs[j].length;}if(b.length<length)throw"XLS Record 0x"+RecordType.toString(16)+" Truncated: "+b.length+" < "+length;return R.f(b,b.length,opts);}function safe_format_xf(p/*:any*/,opts/*:ParseOpts*/,date1904/*:?boolean*/){if(p.t==='z')return;if(!p.XF)return;var fmtid=0;try{fmtid=p.z||p.XF.numFmtId||0;if(opts.cellNF)p.z=table_fmt[fmtid];}catch(e){if(opts.WTF)throw e;}if(!opts||opts.cellText!==false)try{if(p.t==='e'){p.w=p.w||BErr[p.v];}else if(fmtid===0||fmtid=="General"){if(p.t==='n'){if((p.v|0)===p.v)p.w=p.v.toString(10);else p.w=SSF_general_num(p.v);}else p.w=SSF_general(p.v);}else p.w=SSF_format(fmtid,p.v,{date1904:!!date1904,dateNF:opts&&opts.dateNF});}catch(e){if(opts.WTF)throw e;}if(opts.cellDates&&fmtid&&p.t=='n'&&fmt_is_date(table_fmt[fmtid]||String(fmtid))){var _d=SSF_parse_date_code(p.v);if(_d){p.t='d';p.v=new Date(_d.y,_d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u);}}}function make_cell(val,ixfe,t)/*:Cell*/{return{v:val,ixfe:ixfe,t:t/*:any*/};}// 2.3.2
function parse_workbook(blob,options/*:ParseOpts*/)/*:Workbook*/{var wb={opts:{}/*:any*/};var Sheets={};if(DENSE!=null&&options.dense==null)options.dense=DENSE;var out/*:Worksheet*/=options.dense?[]:{};var Directory={};var range/*:Range*/={}/*:any*/;var last_formula=null;var sst/*:SST*/=[]/*:any*/;var cur_sheet="";var Preamble={};var lastcell,last_cell="",cc/*:Cell*/,cmnt,rngC,rngR;var sharedf={};var arrayf/*:Array<[Range, string]>*/=[];var temp_val/*:Cell*/;var country;var XFs=[];/* XF records */var palette/*:Array<[number, number, number]>*/=[];var Workbook/*:WBWBProps*/={Sheets:[],WBProps:{date1904:false},Views:[{}]/*:any*/},wsprops={};var get_rgb=function getrgb(icv/*:number*/)/*:[number, number, number]*/{if(icv<8)return XLSIcv[icv];if(icv<64)return palette[icv-8]||XLSIcv[icv];return XLSIcv[icv];};var process_cell_style=function pcs(cell,line/*:any*/,options){var xfd=line.XF.data;if(!xfd||!xfd.patternType||!options||!options.cellStyles)return;line.s={}/*:any*/;line.s.patternType=xfd.patternType;var t;if(t=rgb2Hex(get_rgb(xfd.icvFore))){line.s.fgColor={rgb:t};}if(t=rgb2Hex(get_rgb(xfd.icvBack))){line.s.bgColor={rgb:t};}};var addcell=function addcell(cell/*:any*/,line/*:any*/,options/*:any*/){if(file_depth>1)return;if(options.sheetRows&&cell.r>=options.sheetRows)return;if(options.cellStyles&&line.XF&&line.XF.data)process_cell_style(cell,line,options);delete line.ixfe;delete line.XF;lastcell=cell;last_cell=encode_cell(cell);if(!range||!range.s||!range.e)range={s:{r:0,c:0},e:{r:0,c:0}};if(cell.r<range.s.r)range.s.r=cell.r;if(cell.c<range.s.c)range.s.c=cell.c;if(cell.r+1>range.e.r)range.e.r=cell.r+1;if(cell.c+1>range.e.c)range.e.c=cell.c+1;if(options.cellFormula&&line.f){for(var afi=0;afi<arrayf.length;++afi){if(arrayf[afi][0].s.c>cell.c||arrayf[afi][0].s.r>cell.r)continue;if(arrayf[afi][0].e.c<cell.c||arrayf[afi][0].e.r<cell.r)continue;line.F=encode_range(arrayf[afi][0]);if(arrayf[afi][0].s.c!=cell.c||arrayf[afi][0].s.r!=cell.r)delete line.f;if(line.f)line.f=""+stringify_formula(arrayf[afi][1],range,cell,supbooks,opts);break;}}{if(options.dense){if(!out[cell.r])out[cell.r]=[];out[cell.r][cell.c]=line;}else out[last_cell]=line;}};var opts={enc:false,// encrypted
sbcch:0,// cch in the preceding SupBook
snames:[],// sheetnames
sharedf:sharedf,// shared formulae by address
arrayf:arrayf,// array formulae array
rrtabid:[],// RRTabId
lastuser:"",// Last User from WriteAccess
biff:8,// BIFF version
codepage:0,// CP from CodePage record
winlocked:0,// fLockWn from WinProtect
cellStyles:!!options&&!!options.cellStyles,WTF:!!options&&!!options.wtf/*:any*/};if(options.password)opts.password=options.password;var themes;var merges/*:Array<Range>*/=[];var objects=[];var colinfo/*:Array<ColInfo>*/=[],rowinfo/*:Array<RowInfo>*/=[];var seencol=false;var supbooks=[]/*:any*/;// 1-indexed, will hold extern names
supbooks.SheetNames=opts.snames;supbooks.sharedf=opts.sharedf;supbooks.arrayf=opts.arrayf;supbooks.names=[];supbooks.XTI=[];var last_RT=0;var file_depth=0;/* TODO: make a real stack */var BIFF2Fmt=0,BIFF2FmtTable/*:Array<string>*/=[];var FilterDatabases=[];/* TODO: sort out supbooks and process elsewhere */var last_lbl/*:?DefinedName*/;/* explicit override for some broken writers */opts.codepage=1200;set_cp(1200);var seen_codepage=false;while(blob.l<blob.length-1){var s=blob.l;var RecordType=blob.read_shift(2);if(RecordType===0&&last_RT===0x000a/* EOF */)break;var length=blob.l===blob.length?0:blob.read_shift(2);var R=XLSRecordEnum[RecordType];//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
//if(!R) console.log(blob.slice(blob.l, blob.l + length));
if(R&&R.f){if(options.bookSheets){if(last_RT===0x0085/* BoundSheet8 */&&RecordType!==0x0085/* R.n !== 'BoundSheet8' */)break;}last_RT=RecordType;if(R.r===2||R.r==12){var rt=blob.read_shift(2);length-=2;if(!opts.enc&&rt!==RecordType&&((rt&0xFF)<<8|rt>>8)!==RecordType)throw new Error("rt mismatch: "+rt+"!="+RecordType);if(R.r==12){blob.l+=10;length-=10;}// skip FRT
}//console.error(R,blob.l,length,blob.length);
var val/*:any*/={}/*:any*/;if(RecordType===0x000a/* EOF */)val=/*::(*/R.f(blob,length,opts)/*:: :any)*/;else val=/*::(*/slurp(RecordType,R,blob,length,opts)/*:: :any)*/;/*:: val = (val:any); */if(file_depth==0&&[0x0009,0x0209,0x0409,0x0809].indexOf(last_RT)===-1/* 'BOF' */)continue;switch(RecordType){case 0x0022/* Date1904 */:/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */wb.opts.Date1904=Workbook.WBProps.date1904=val;break;case 0x0086/* WriteProtect */:wb.opts.WriteProtect=true;break;case 0x002f/* FilePass */:if(!opts.enc)blob.l=0;opts.enc=val;if(!options.password)throw new Error("File is password-protected");if(val.valid==null)throw new Error("Encryption scheme unsupported");if(!val.valid)throw new Error("Password is incorrect");break;case 0x005c/* WriteAccess */:opts.lastuser=val;break;case 0x0042/* CodePage */:var cpval=Number(val);/* overrides based on test cases */switch(cpval){case 0x5212:cpval=1200;break;case 0x8000:cpval=10000;break;case 0x8001:cpval=1252;break;}set_cp(opts.codepage=cpval);seen_codepage=true;break;case 0x013d/* RRTabId */:opts.rrtabid=val;break;case 0x0019/* WinProtect */:opts.winlocked=val;break;case 0x01b7/* RefreshAll */:wb.opts["RefreshAll"]=val;break;case 0x000c/* CalcCount */:wb.opts["CalcCount"]=val;break;case 0x0010/* CalcDelta */:wb.opts["CalcDelta"]=val;break;case 0x0011/* CalcIter */:wb.opts["CalcIter"]=val;break;case 0x000d/* CalcMode */:wb.opts["CalcMode"]=val;break;case 0x000e/* CalcPrecision */:wb.opts["CalcPrecision"]=val;break;case 0x005f/* CalcSaveRecalc */:wb.opts["CalcSaveRecalc"]=val;break;case 0x000f/* CalcRefMode */:opts.CalcRefMode=val;break;// TODO: implement R1C1
case 0x08a3/* ForceFullCalculation */:wb.opts.FullCalc=val;break;case 0x0081/* WsBool */:if(val.fDialog)out["!type"]="dialog";if(!val.fBelow)(out["!outline"]||(out["!outline"]={})).above=true;if(!val.fRight)(out["!outline"]||(out["!outline"]={})).left=true;break;// TODO
case 0x00e0/* XF */:XFs.push(val);break;case 0x01ae/* SupBook */:supbooks.push([val]);supbooks[supbooks.length-1].XTI=[];break;case 0x0023:case 0x0223/* ExternName */:supbooks[supbooks.length-1].push(val);break;case 0x0018:case 0x0218/* Lbl */:last_lbl={Name:val.Name,Ref:stringify_formula(val.rgce,range,null,supbooks,opts)/*:DefinedName*/};if(val.itab>0)last_lbl.Sheet=val.itab-1;supbooks.names.push(last_lbl);if(!supbooks[0]){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].push(val);if(val.Name=="_xlnm._FilterDatabase"&&val.itab>0)if(val.rgce&&val.rgce[0]&&val.rgce[0][0]&&val.rgce[0][0][0]=='PtgArea3d')FilterDatabases[val.itab-1]={ref:encode_range(val.rgce[0][0][1][2])};break;case 0x0016/* ExternCount */:opts.ExternCount=val;break;case 0x0017/* ExternSheet */:if(supbooks.length==0){supbooks[0]=[];supbooks[0].XTI=[];}supbooks[supbooks.length-1].XTI=supbooks[supbooks.length-1].XTI.concat(val);supbooks.XTI=supbooks.XTI.concat(val);break;case 0x0894/* NameCmt */:/* TODO: search for correct name */if(opts.biff<8)break;if(last_lbl!=null)last_lbl.Comment=val[1];break;case 0x0012/* Protect */:out["!protect"]=val;break;/* for sheet or book */case 0x0013/* Password */:if(val!==0&&opts.WTF)console.error("Password verifier: "+val);break;case 0x0085/* BoundSheet8 */:{Directory[val.pos]=val;opts.snames.push(val.name);}break;case 0x000a/* EOF */:{if(--file_depth)break;if(range.e){if(range.e.r>0&&range.e.c>0){range.e.r--;range.e.c--;out["!ref"]=encode_range(range);if(options.sheetRows&&options.sheetRows<=range.e.r){var tmpri=range.e.r;range.e.r=options.sheetRows-1;out["!fullref"]=out["!ref"];out["!ref"]=encode_range(range);range.e.r=tmpri;}range.e.r++;range.e.c++;}if(merges.length>0)out["!merges"]=merges;if(objects.length>0)out["!objects"]=objects;if(colinfo.length>0)out["!cols"]=colinfo;if(rowinfo.length>0)out["!rows"]=rowinfo;Workbook.Sheets.push(wsprops);}if(cur_sheet==="")Preamble=out;else Sheets[cur_sheet]=out;out=options.dense?[]:{};}break;case 0x0009:case 0x0209:case 0x0409:case 0x0809/* BOF */:{if(opts.biff===8)opts.biff={/*::[*/0x0009/*::]*/:2,/*::[*/0x0209/*::]*/:3,/*::[*/0x0409/*::]*/:4}[RecordType]||{/*::[*/0x0200/*::]*/:2,/*::[*/0x0300/*::]*/:3,/*::[*/0x0400/*::]*/:4,/*::[*/0x0500/*::]*/:5,/*::[*/0x0600/*::]*/:8,/*::[*/0x0002/*::]*/:2,/*::[*/0x0007/*::]*/:2}[val.BIFFVer]||8;opts.biffguess=val.BIFFVer==0;if(val.BIFFVer==0&&val.dt==0x1000){opts.biff=5;seen_codepage=true;set_cp(opts.codepage=28591);}if(opts.biff==8&&val.BIFFVer==0&&val.dt==16)opts.biff=2;if(file_depth++)break;out=options.dense?[]:{};if(opts.biff<8&&!seen_codepage){seen_codepage=true;set_cp(opts.codepage=options.codepage||1252);}if(opts.biff<5||val.BIFFVer==0&&val.dt==0x1000){if(cur_sheet==="")cur_sheet="Sheet1";range={s:{r:0,c:0},e:{r:0,c:0}};/* fake BoundSheet8 */var fakebs8={pos:blob.l-length,name:cur_sheet};Directory[fakebs8.pos]=fakebs8;opts.snames.push(cur_sheet);}else cur_sheet=(Directory[s]||{name:""}).name;if(val.dt==0x20)out["!type"]="chart";if(val.dt==0x40)out["!type"]="macro";merges=[];objects=[];opts.arrayf=arrayf=[];colinfo=[];rowinfo=[];seencol=false;wsprops={Hidden:(Directory[s]||{hs:0}).hs,name:cur_sheet};}break;case 0x0203/* Number */:case 0x0003/* BIFF2NUM */:case 0x0002/* BIFF2INT */:{if(out["!type"]=="chart")if(options.dense?(out[val.r]||[])[val.c]:out[encode_cell({c:val.c,r:val.r})])++val.c;temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe]||{},v:val.val,t:'n'/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x0005:case 0x0205/* BoolErr */:{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:val.t/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x027e/* RK */:{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.rknum,t:'n'/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x00bd/* MulRk */:{for(var j=val.c;j<=val.C;++j){var ixfe=val.rkrec[j-val.c][0];temp_val={ixfe:ixfe,XF:XFs[ixfe],v:val.rkrec[j-val.c][1],t:'n'/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:j,r:val.r},temp_val,options);}}break;case 0x0006:case 0x0206:case 0x0406/* Formula */:{if(val.val=='String'){last_formula=val;break;}temp_val=make_cell(val.val,val.cell.ixfe,val.tt);temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){var _f=val.formula;if(_f&&_f[0]&&_f[0][0]&&_f[0][0][0]=='PtgExp'){var _fr=_f[0][0][1][0],_fc=_f[0][0][1][1];var _fe=encode_cell({r:_fr,c:_fc});if(sharedf[_fe])temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);else temp_val.F=((options.dense?(out[_fr]||[])[_fc]:out[_fe])||{}).F;}else temp_val.f=""+stringify_formula(val.formula,range,val.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(val.cell,temp_val,options);last_formula=val;}break;case 0x0007:case 0x0207/* String */:{if(last_formula){/* technically always true */last_formula.val=val;temp_val=make_cell(val,last_formula.cell.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula){temp_val.f=""+stringify_formula(last_formula.formula,range,last_formula.cell,supbooks,opts);}if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(last_formula.cell,temp_val,options);last_formula=null;}else throw new Error("String record expects Formula");}break;case 0x0021:case 0x0221/* Array */:{arrayf.push(val);var _arraystart=encode_cell(val[0].s);cc=options.dense?(out[val[0].s.r]||[])[val[0].s.c]:out[_arraystart];if(options.cellFormula&&cc){if(!last_formula)break;/* technically unreachable */if(!_arraystart||!cc)break;cc.f=""+stringify_formula(val[1],range,val[0],supbooks,opts);cc.F=encode_range(val[0]);}}break;case 0x04bc/* ShrFmla */:{if(!options.cellFormula)break;if(last_cell){/* TODO: capture range */if(!last_formula)break;/* technically unreachable */sharedf[encode_cell(last_formula.cell)]=val[0];cc=options.dense?(out[last_formula.cell.r]||[])[last_formula.cell.c]:out[encode_cell(last_formula.cell)];(cc||{}).f=""+stringify_formula(val[0],range,lastcell,supbooks,opts);}}break;case 0x00fd/* LabelSst */:temp_val=make_cell(sst[val.isst].t,val.ixfe,'s');if(sst[val.isst].h)temp_val.h=sst[val.isst].h;temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case 0x0201/* Blank */:if(options.sheetStubs){temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],t:'z'/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);}break;case 0x00be/* MulBlank */:if(options.sheetStubs){for(var _j=val.c;_j<=val.C;++_j){var _ixfe=val.ixfe[_j-val.c];temp_val={ixfe:_ixfe,XF:XFs[_ixfe],t:'z'/*:any*/};if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:_j,r:val.r},temp_val,options);}}break;case 0x00d6/* RString */:case 0x0204/* Label */:case 0x0004/* BIFF2STR */:temp_val=make_cell(val.val,val.ixfe,'s');temp_val.XF=XFs[temp_val.ixfe];if(BIFF2Fmt>0)temp_val.z=BIFF2FmtTable[temp_val.ixfe>>8&0x3F];safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case 0x0000:case 0x0200/* Dimensions */:{if(file_depth===1)range=val;/* TODO: stack */}break;case 0x00fc/* SST */:{sst=val;}break;case 0x041e/* Format */:{/* val = [id, fmt] */if(opts.biff==4){BIFF2FmtTable[BIFF2Fmt++]=val[1];for(var b4idx=0;b4idx<BIFF2Fmt+163;++b4idx){if(table_fmt[b4idx]==val[1])break;}if(b4idx>=163)SSF_load(val[1],BIFF2Fmt+163);}else SSF_load(val[1],val[0]);}break;case 0x001e/* BIFF2FORMAT */:{BIFF2FmtTable[BIFF2Fmt++]=val;for(var b2idx=0;b2idx<BIFF2Fmt+163;++b2idx){if(table_fmt[b2idx]==val)break;}if(b2idx>=163)SSF_load(val,BIFF2Fmt+163);}break;case 0x00e5/* MergeCells */:merges=merges.concat(val);break;case 0x005d/* Obj */:objects[val.cmo[0]]=opts.lastobj=val;break;case 0x01b6/* TxO */:opts.lastobj.TxO=val;break;case 0x007f/* ImData */:opts.lastobj.ImData=val;break;case 0x01b8/* HLink */:{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR){for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc)cc.l=val[1];}}}break;case 0x0800/* HLinkTooltip */:{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR){for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC){cc=options.dense?(out[rngR]||[])[rngC]:out[encode_cell({c:rngC,r:rngR})];if(cc&&cc.l)cc.l.Tooltip=val[1];}}}break;case 0x001c/* Note */:{if(opts.biff<=5&&opts.biff>=2)break;/* TODO: BIFF5 */cc=options.dense?(out[val[0].r]||[])[val[0].c]:out[encode_cell(val[0])];var noteobj=objects[val[2]];if(!cc){if(options.dense){if(!out[val[0].r])out[val[0].r]=[];cc=out[val[0].r][val[0].c]={t:"z"/*:any*/};}else{cc=out[encode_cell(val[0])]={t:"z"/*:any*/};}range.e.r=Math.max(range.e.r,val[0].r);range.s.r=Math.min(range.s.r,val[0].r);range.e.c=Math.max(range.e.c,val[0].c);range.s.c=Math.min(range.s.c,val[0].c);}if(!cc.c)cc.c=[];cmnt={a:val[1],t:noteobj.TxO.t};cc.c.push(cmnt);}break;case 0x087d/* XFExt */:update_xfext(XFs[val.ixfe],val.ext);break;case 0x007d/* ColInfo */:{if(!opts.cellStyles)break;while(val.e>=val.s){colinfo[val.e--]={width:val.w/256,level:val.level||0,hidden:!!(val.flags&1)};if(!seencol){seencol=true;find_mdw_colw(val.w/256);}process_col(colinfo[val.e+1]);}}break;case 0x0208/* Row */:{var rowobj={};if(val.level!=null){rowinfo[val.r]=rowobj;rowobj.level=val.level;}if(val.hidden){rowinfo[val.r]=rowobj;rowobj.hidden=true;}if(val.hpt){rowinfo[val.r]=rowobj;rowobj.hpt=val.hpt;rowobj.hpx=pt2px(val.hpt);}}break;case 0x0026/* LeftMargin */:case 0x0027/* RightMargin */:case 0x0028/* TopMargin */:case 0x0029/* BottomMargin */:if(!out['!margins'])default_margins(out['!margins']={});out['!margins'][{0x26:"left",0x27:"right",0x28:"top",0x29:"bottom"}[RecordType]]=val;break;case 0x00a1/* Setup */:// TODO
if(!out['!margins'])default_margins(out['!margins']={});out['!margins'].header=val.header;out['!margins'].footer=val.footer;break;case 0x023e/* Window2 */:// TODO
// $FlowIgnore
if(val.RTL)Workbook.Views[0].RTL=true;break;case 0x0092/* Palette */:palette=val;break;case 0x0896/* Theme */:themes=val;break;case 0x008c/* Country */:country=val;break;case 0x01ba/* CodeName */:{/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */if(!cur_sheet)Workbook.WBProps.CodeName=val||"ThisWorkbook";else wsprops.CodeName=val||wsprops.name;}break;}}else{if(!R)console.error("Missing Info for XLS Record 0x"+RecordType.toString(16));blob.l+=length;}}wb.SheetNames=keys(Directory).sort(function(a,b){return Number(a)-Number(b);}).map(function(x){return Directory[x].name;});if(!options.bookSheets)wb.Sheets=Sheets;if(!wb.SheetNames.length&&Preamble["!ref"]){wb.SheetNames.push("Sheet1");/*jshint -W069 */if(wb.Sheets)wb.Sheets["Sheet1"]=Preamble;/*jshint +W069 */}else wb.Preamble=Preamble;if(wb.Sheets)FilterDatabases.forEach(function(r,i){wb.Sheets[wb.SheetNames[i]]['!autofilter']=r;});wb.Strings=sst;wb.SSF=dup(table_fmt);if(opts.enc)wb.Encryption=opts.enc;if(themes)wb.Themes=themes;wb.Metadata={};if(country!==undefined)wb.Metadata.Country=country;if(supbooks.names.length>0)Workbook.Names=supbooks.names;wb.Workbook=Workbook;return wb;}/* TODO: split props*/var PSCLSID={SI:"e0859ff2f94f6810ab9108002b27b3d9",DSI:"02d5cdd59c2e1b10939708002b2cf9ae",UDI:"05d5cdd59c2e1b10939708002b2cf9ae"};function parse_xls_props(cfb/*:CFBContainer*/,props,o){/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */var DSI=CFB.find(cfb,'/!DocumentSummaryInformation');if(DSI&&DSI.size>0)try{var DocSummary=parse_PropertySetStream(DSI,DocSummaryPIDDSI,PSCLSID.DSI);for(var d in DocSummary){props[d]=DocSummary[d];}}catch(e){if(o.WTF)throw e;/* empty */}/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/var SI=CFB.find(cfb,'/!SummaryInformation');if(SI&&SI.size>0)try{var Summary=parse_PropertySetStream(SI,SummaryPIDSI,PSCLSID.SI);for(var s in Summary){if(props[s]==null)props[s]=Summary[s];}}catch(e){if(o.WTF)throw e;/* empty */}if(props.HeadingPairs&&props.TitlesOfParts){load_props_pairs(props.HeadingPairs,props.TitlesOfParts,props,o);delete props.HeadingPairs;delete props.TitlesOfParts;}}function write_xls_props(wb/*:Workbook*/,cfb/*:CFBContainer*/){var DSEntries=[],SEntries=[],CEntries=[];var i=0,Keys;var DocSummaryRE/*:{[key:string]:string}*/=evert_key(DocSummaryPIDDSI,"n");var SummaryRE/*:{[key:string]:string}*/=evert_key(SummaryPIDSI,"n");if(wb.Props){Keys=keys(wb.Props);// $FlowIgnore
for(i=0;i<Keys.length;++i){(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Props[Keys[i]]]);}}if(wb.Custprops){Keys=keys(wb.Custprops);// $FlowIgnore
for(i=0;i<Keys.length;++i){if(!Object.prototype.hasOwnProperty.call(wb.Props||{},Keys[i]))(Object.prototype.hasOwnProperty.call(DocSummaryRE,Keys[i])?DSEntries:Object.prototype.hasOwnProperty.call(SummaryRE,Keys[i])?SEntries:CEntries).push([Keys[i],wb.Custprops[Keys[i]]]);}}var CEntries2=[];for(i=0;i<CEntries.length;++i){if(XLSPSSkip.indexOf(CEntries[i][0])>-1||PseudoPropsPairs.indexOf(CEntries[i][0])>-1)continue;if(CEntries[i][1]==null)continue;CEntries2.push(CEntries[i]);}if(SEntries.length)CFB.utils.cfb_add(cfb,"/\x05SummaryInformation",write_PropertySetStream(SEntries,PSCLSID.SI,SummaryRE,SummaryPIDSI));if(DSEntries.length||CEntries2.length)CFB.utils.cfb_add(cfb,"/\x05DocumentSummaryInformation",write_PropertySetStream(DSEntries,PSCLSID.DSI,DocSummaryRE,DocSummaryPIDDSI,CEntries2.length?CEntries2:null,PSCLSID.UDI));}function parse_xlscfb(cfb/*:any*/,options/*:?ParseOpts*/)/*:Workbook*/{if(!options)options={};fix_read_opts(options);reset_cp();if(options.codepage)set_ansi(options.codepage);var CompObj/*:?CFBEntry*/,WB/*:?any*/;if(cfb.FullPaths){if(CFB.find(cfb,'/encryption'))throw new Error("File is password-protected");CompObj=CFB.find(cfb,'!CompObj');WB=CFB.find(cfb,'/Workbook')||CFB.find(cfb,'/Book');}else{switch(options.type){case'base64':cfb=s2a(Base64_decode(cfb));break;case'binary':cfb=s2a(cfb);break;case'buffer':break;case'array':if(!Array.isArray(cfb))cfb=Array.prototype.slice.call(cfb);break;}prep_blob(cfb,0);WB={content:cfb/*:any*/};}var/*::CompObjP, */WorkbookP/*:: :Workbook = XLSX.utils.book_new(); */;var _data/*:?any*/;if(CompObj)/*::CompObjP = */parse_compobj(CompObj);if(options.bookProps&&!options.bookSheets)WorkbookP={}/*:any*/;else/*:: if(cfb instanceof CFBContainer) */{var T=has_buf?'buffer':'array';if(WB&&WB.content)WorkbookP=parse_workbook(WB.content,options);/* Quattro Pro 7-8 */else if((_data=CFB.find(cfb,'PerfectOffice_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));/* Quattro Pro 9 */else if((_data=CFB.find(cfb,'NativeContent_MAIN'))&&_data.content)WorkbookP=WK_.to_workbook(_data.content,(options.type=T,options));/* Works 4 for Mac */else if((_data=CFB.find(cfb,'MN0'))&&_data.content)throw new Error("Unsupported Works 4 for Mac file");else throw new Error("Cannot find Workbook stream");if(options.bookVBA&&cfb.FullPaths&&CFB.find(cfb,'/_VBA_PROJECT_CUR/VBA/dir'))WorkbookP.vbaraw=make_vba_xls(cfb);}var props={};if(cfb.FullPaths)parse_xls_props(/*::((*/cfb/*:: :any):CFBContainer)*/,props,options);WorkbookP.Props=WorkbookP.Custprops=props;/* TODO: split up properties */if(options.bookFiles)WorkbookP.cfb=cfb;/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */return WorkbookP;}function write_xlscfb(wb/*:Workbook*/,opts/*:WriteOpts*/)/*:CFBContainer*/{var o=opts||{};var cfb=CFB.utils.cfb_new({root:"R"});var wbpath="/Workbook";switch(o.bookType||"xls"){case"xls":o.bookType="biff8";/* falls through */case"xla":if(!o.bookType)o.bookType="xla";/* falls through */case"biff8":wbpath="/Workbook";o.biff=8;break;case"biff5":wbpath="/Book";o.biff=5;break;default:throw new Error("invalid type "+o.bookType+" for XLS CFB");}CFB.utils.cfb_add(cfb,wbpath,write_biff_buf(wb,o));if(o.biff==8&&(wb.Props||wb.Custprops))write_xls_props(wb,cfb);// TODO: SI, DSI, CO
if(o.biff==8&&wb.vbaraw)fill_vba_xls(cfb,CFB.read(wb.vbaraw,{type:typeof wb.vbaraw=="string"?"binary":"buffer"}));return cfb;}/* [MS-XLSB] 2.3 Record Enumeration */var XLSBRecordEnum={/*::[*/0x0000/*::]*/:{/* n:"BrtRowHdr", */f:parse_BrtRowHdr},/*::[*/0x0001/*::]*/:{/* n:"BrtCellBlank", */f:parse_BrtCellBlank},/*::[*/0x0002/*::]*/:{/* n:"BrtCellRk", */f:parse_BrtCellRk},/*::[*/0x0003/*::]*/:{/* n:"BrtCellError", */f:parse_BrtCellError},/*::[*/0x0004/*::]*/:{/* n:"BrtCellBool", */f:parse_BrtCellBool},/*::[*/0x0005/*::]*/:{/* n:"BrtCellReal", */f:parse_BrtCellReal},/*::[*/0x0006/*::]*/:{/* n:"BrtCellSt", */f:parse_BrtCellSt},/*::[*/0x0007/*::]*/:{/* n:"BrtCellIsst", */f:parse_BrtCellIsst},/*::[*/0x0008/*::]*/:{/* n:"BrtFmlaString", */f:parse_BrtFmlaString},/*::[*/0x0009/*::]*/:{/* n:"BrtFmlaNum", */f:parse_BrtFmlaNum},/*::[*/0x000A/*::]*/:{/* n:"BrtFmlaBool", */f:parse_BrtFmlaBool},/*::[*/0x000B/*::]*/:{/* n:"BrtFmlaError", */f:parse_BrtFmlaError},/*::[*/0x000C/*::]*/:{/* n:"BrtShortBlank", */f:parse_BrtShortBlank},/*::[*/0x000D/*::]*/:{/* n:"BrtShortRk", */f:parse_BrtShortRk},/*::[*/0x000E/*::]*/:{/* n:"BrtShortError", */f:parse_BrtShortError},/*::[*/0x000F/*::]*/:{/* n:"BrtShortBool", */f:parse_BrtShortBool},/*::[*/0x0010/*::]*/:{/* n:"BrtShortReal", */f:parse_BrtShortReal},/*::[*/0x0011/*::]*/:{/* n:"BrtShortSt", */f:parse_BrtShortSt},/*::[*/0x0012/*::]*/:{/* n:"BrtShortIsst", */f:parse_BrtShortIsst},/*::[*/0x0013/*::]*/:{/* n:"BrtSSTItem", */f:parse_RichStr},/*::[*/0x0014/*::]*/:{/* n:"BrtPCDIMissing" */},/*::[*/0x0015/*::]*/:{/* n:"BrtPCDINumber" */},/*::[*/0x0016/*::]*/:{/* n:"BrtPCDIBoolean" */},/*::[*/0x0017/*::]*/:{/* n:"BrtPCDIError" */},/*::[*/0x0018/*::]*/:{/* n:"BrtPCDIString" */},/*::[*/0x0019/*::]*/:{/* n:"BrtPCDIDatetime" */},/*::[*/0x001A/*::]*/:{/* n:"BrtPCDIIndex" */},/*::[*/0x001B/*::]*/:{/* n:"BrtPCDIAMissing" */},/*::[*/0x001C/*::]*/:{/* n:"BrtPCDIANumber" */},/*::[*/0x001D/*::]*/:{/* n:"BrtPCDIABoolean" */},/*::[*/0x001E/*::]*/:{/* n:"BrtPCDIAError" */},/*::[*/0x001F/*::]*/:{/* n:"BrtPCDIAString" */},/*::[*/0x0020/*::]*/:{/* n:"BrtPCDIADatetime" */},/*::[*/0x0021/*::]*/:{/* n:"BrtPCRRecord" */},/*::[*/0x0022/*::]*/:{/* n:"BrtPCRRecordDt" */},/*::[*/0x0023/*::]*/:{/* n:"BrtFRTBegin", */T:1},/*::[*/0x0024/*::]*/:{/* n:"BrtFRTEnd", */T:-1},/*::[*/0x0025/*::]*/:{/* n:"BrtACBegin", */T:1},/*::[*/0x0026/*::]*/:{/* n:"BrtACEnd", */T:-1},/*::[*/0x0027/*::]*/:{/* n:"BrtName", */f:parse_BrtName},/*::[*/0x0028/*::]*/:{/* n:"BrtIndexRowBlock" */},/*::[*/0x002A/*::]*/:{/* n:"BrtIndexBlock" */},/*::[*/0x002B/*::]*/:{/* n:"BrtFont", */f:parse_BrtFont},/*::[*/0x002C/*::]*/:{/* n:"BrtFmt", */f:parse_BrtFmt},/*::[*/0x002D/*::]*/:{/* n:"BrtFill", */f:parse_BrtFill},/*::[*/0x002E/*::]*/:{/* n:"BrtBorder", */f:parse_BrtBorder},/*::[*/0x002F/*::]*/:{/* n:"BrtXF", */f:parse_BrtXF},/*::[*/0x0030/*::]*/:{/* n:"BrtStyle" */},/*::[*/0x0031/*::]*/:{/* n:"BrtCellMeta", */f:parse_Int32LE},/*::[*/0x0032/*::]*/:{/* n:"BrtValueMeta" */},/*::[*/0x0033/*::]*/:{/* n:"BrtMdb" */f:parse_BrtMdb},/*::[*/0x0034/*::]*/:{/* n:"BrtBeginFmd", */T:1},/*::[*/0x0035/*::]*/:{/* n:"BrtEndFmd", */T:-1},/*::[*/0x0036/*::]*/:{/* n:"BrtBeginMdx", */T:1},/*::[*/0x0037/*::]*/:{/* n:"BrtEndMdx", */T:-1},/*::[*/0x0038/*::]*/:{/* n:"BrtBeginMdxTuple", */T:1},/*::[*/0x0039/*::]*/:{/* n:"BrtEndMdxTuple", */T:-1},/*::[*/0x003A/*::]*/:{/* n:"BrtMdxMbrIstr" */},/*::[*/0x003B/*::]*/:{/* n:"BrtStr" */},/*::[*/0x003C/*::]*/:{/* n:"BrtColInfo", */f:parse_ColInfo},/*::[*/0x003E/*::]*/:{/* n:"BrtCellRString", */f:parse_BrtCellRString},/*::[*/0x003F/*::]*/:{/* n:"BrtCalcChainItem$", */f:parse_BrtCalcChainItem$},/*::[*/0x0040/*::]*/:{/* n:"BrtDVal", */f:parse_BrtDVal},/*::[*/0x0041/*::]*/:{/* n:"BrtSxvcellNum" */},/*::[*/0x0042/*::]*/:{/* n:"BrtSxvcellStr" */},/*::[*/0x0043/*::]*/:{/* n:"BrtSxvcellBool" */},/*::[*/0x0044/*::]*/:{/* n:"BrtSxvcellErr" */},/*::[*/0x0045/*::]*/:{/* n:"BrtSxvcellDate" */},/*::[*/0x0046/*::]*/:{/* n:"BrtSxvcellNil" */},/*::[*/0x0080/*::]*/:{/* n:"BrtFileVersion" */},/*::[*/0x0081/*::]*/:{/* n:"BrtBeginSheet", */T:1},/*::[*/0x0082/*::]*/:{/* n:"BrtEndSheet", */T:-1},/*::[*/0x0083/*::]*/:{/* n:"BrtBeginBook", */T:1,f:parsenoop,p:0},/*::[*/0x0084/*::]*/:{/* n:"BrtEndBook", */T:-1},/*::[*/0x0085/*::]*/:{/* n:"BrtBeginWsViews", */T:1},/*::[*/0x0086/*::]*/:{/* n:"BrtEndWsViews", */T:-1},/*::[*/0x0087/*::]*/:{/* n:"BrtBeginBookViews", */T:1},/*::[*/0x0088/*::]*/:{/* n:"BrtEndBookViews", */T:-1},/*::[*/0x0089/*::]*/:{/* n:"BrtBeginWsView", */T:1,f:parse_BrtBeginWsView},/*::[*/0x008A/*::]*/:{/* n:"BrtEndWsView", */T:-1},/*::[*/0x008B/*::]*/:{/* n:"BrtBeginCsViews", */T:1},/*::[*/0x008C/*::]*/:{/* n:"BrtEndCsViews", */T:-1},/*::[*/0x008D/*::]*/:{/* n:"BrtBeginCsView", */T:1},/*::[*/0x008E/*::]*/:{/* n:"BrtEndCsView", */T:-1},/*::[*/0x008F/*::]*/:{/* n:"BrtBeginBundleShs", */T:1},/*::[*/0x0090/*::]*/:{/* n:"BrtEndBundleShs", */T:-1},/*::[*/0x0091/*::]*/:{/* n:"BrtBeginSheetData", */T:1},/*::[*/0x0092/*::]*/:{/* n:"BrtEndSheetData", */T:-1},/*::[*/0x0093/*::]*/:{/* n:"BrtWsProp", */f:parse_BrtWsProp},/*::[*/0x0094/*::]*/:{/* n:"BrtWsDim", */f:parse_BrtWsDim,p:16},/*::[*/0x0097/*::]*/:{/* n:"BrtPane", */f:parse_BrtPane},/*::[*/0x0098/*::]*/:{/* n:"BrtSel" */},/*::[*/0x0099/*::]*/:{/* n:"BrtWbProp", */f:parse_BrtWbProp},/*::[*/0x009A/*::]*/:{/* n:"BrtWbFactoid" */},/*::[*/0x009B/*::]*/:{/* n:"BrtFileRecover" */},/*::[*/0x009C/*::]*/:{/* n:"BrtBundleSh", */f:parse_BrtBundleSh},/*::[*/0x009D/*::]*/:{/* n:"BrtCalcProp" */},/*::[*/0x009E/*::]*/:{/* n:"BrtBookView" */},/*::[*/0x009F/*::]*/:{/* n:"BrtBeginSst", */T:1,f:parse_BrtBeginSst},/*::[*/0x00A0/*::]*/:{/* n:"BrtEndSst", */T:-1},/*::[*/0x00A1/*::]*/:{/* n:"BrtBeginAFilter", */T:1,f:parse_UncheckedRfX},/*::[*/0x00A2/*::]*/:{/* n:"BrtEndAFilter", */T:-1},/*::[*/0x00A3/*::]*/:{/* n:"BrtBeginFilterColumn", */T:1},/*::[*/0x00A4/*::]*/:{/* n:"BrtEndFilterColumn", */T:-1},/*::[*/0x00A5/*::]*/:{/* n:"BrtBeginFilters", */T:1},/*::[*/0x00A6/*::]*/:{/* n:"BrtEndFilters", */T:-1},/*::[*/0x00A7/*::]*/:{/* n:"BrtFilter" */},/*::[*/0x00A8/*::]*/:{/* n:"BrtColorFilter" */},/*::[*/0x00A9/*::]*/:{/* n:"BrtIconFilter" */},/*::[*/0x00AA/*::]*/:{/* n:"BrtTop10Filter" */},/*::[*/0x00AB/*::]*/:{/* n:"BrtDynamicFilter" */},/*::[*/0x00AC/*::]*/:{/* n:"BrtBeginCustomFilters", */T:1},/*::[*/0x00AD/*::]*/:{/* n:"BrtEndCustomFilters", */T:-1},/*::[*/0x00AE/*::]*/:{/* n:"BrtCustomFilter" */},/*::[*/0x00AF/*::]*/:{/* n:"BrtAFilterDateGroupItem" */},/*::[*/0x00B0/*::]*/:{/* n:"BrtMergeCell", */f:parse_BrtMergeCell},/*::[*/0x00B1/*::]*/:{/* n:"BrtBeginMergeCells", */T:1},/*::[*/0x00B2/*::]*/:{/* n:"BrtEndMergeCells", */T:-1},/*::[*/0x00B3/*::]*/:{/* n:"BrtBeginPivotCacheDef", */T:1},/*::[*/0x00B4/*::]*/:{/* n:"BrtEndPivotCacheDef", */T:-1},/*::[*/0x00B5/*::]*/:{/* n:"BrtBeginPCDFields", */T:1},/*::[*/0x00B6/*::]*/:{/* n:"BrtEndPCDFields", */T:-1},/*::[*/0x00B7/*::]*/:{/* n:"BrtBeginPCDField", */T:1},/*::[*/0x00B8/*::]*/:{/* n:"BrtEndPCDField", */T:-1},/*::[*/0x00B9/*::]*/:{/* n:"BrtBeginPCDSource", */T:1},/*::[*/0x00BA/*::]*/:{/* n:"BrtEndPCDSource", */T:-1},/*::[*/0x00BB/*::]*/:{/* n:"BrtBeginPCDSRange", */T:1},/*::[*/0x00BC/*::]*/:{/* n:"BrtEndPCDSRange", */T:-1},/*::[*/0x00BD/*::]*/:{/* n:"BrtBeginPCDFAtbl", */T:1},/*::[*/0x00BE/*::]*/:{/* n:"BrtEndPCDFAtbl", */T:-1},/*::[*/0x00BF/*::]*/:{/* n:"BrtBeginPCDIRun", */T:1},/*::[*/0x00C0/*::]*/:{/* n:"BrtEndPCDIRun", */T:-1},/*::[*/0x00C1/*::]*/:{/* n:"BrtBeginPivotCacheRecords", */T:1},/*::[*/0x00C2/*::]*/:{/* n:"BrtEndPivotCacheRecords", */T:-1},/*::[*/0x00C3/*::]*/:{/* n:"BrtBeginPCDHierarchies", */T:1},/*::[*/0x00C4/*::]*/:{/* n:"BrtEndPCDHierarchies", */T:-1},/*::[*/0x00C5/*::]*/:{/* n:"BrtBeginPCDHierarchy", */T:1},/*::[*/0x00C6/*::]*/:{/* n:"BrtEndPCDHierarchy", */T:-1},/*::[*/0x00C7/*::]*/:{/* n:"BrtBeginPCDHFieldsUsage", */T:1},/*::[*/0x00C8/*::]*/:{/* n:"BrtEndPCDHFieldsUsage", */T:-1},/*::[*/0x00C9/*::]*/:{/* n:"BrtBeginExtConnection", */T:1},/*::[*/0x00CA/*::]*/:{/* n:"BrtEndExtConnection", */T:-1},/*::[*/0x00CB/*::]*/:{/* n:"BrtBeginECDbProps", */T:1},/*::[*/0x00CC/*::]*/:{/* n:"BrtEndECDbProps", */T:-1},/*::[*/0x00CD/*::]*/:{/* n:"BrtBeginECOlapProps", */T:1},/*::[*/0x00CE/*::]*/:{/* n:"BrtEndECOlapProps", */T:-1},/*::[*/0x00CF/*::]*/:{/* n:"BrtBeginPCDSConsol", */T:1},/*::[*/0x00D0/*::]*/:{/* n:"BrtEndPCDSConsol", */T:-1},/*::[*/0x00D1/*::]*/:{/* n:"BrtBeginPCDSCPages", */T:1},/*::[*/0x00D2/*::]*/:{/* n:"BrtEndPCDSCPages", */T:-1},/*::[*/0x00D3/*::]*/:{/* n:"BrtBeginPCDSCPage", */T:1},/*::[*/0x00D4/*::]*/:{/* n:"BrtEndPCDSCPage", */T:-1},/*::[*/0x00D5/*::]*/:{/* n:"BrtBeginPCDSCPItem", */T:1},/*::[*/0x00D6/*::]*/:{/* n:"BrtEndPCDSCPItem", */T:-1},/*::[*/0x00D7/*::]*/:{/* n:"BrtBeginPCDSCSets", */T:1},/*::[*/0x00D8/*::]*/:{/* n:"BrtEndPCDSCSets", */T:-1},/*::[*/0x00D9/*::]*/:{/* n:"BrtBeginPCDSCSet", */T:1},/*::[*/0x00DA/*::]*/:{/* n:"BrtEndPCDSCSet", */T:-1},/*::[*/0x00DB/*::]*/:{/* n:"BrtBeginPCDFGroup", */T:1},/*::[*/0x00DC/*::]*/:{/* n:"BrtEndPCDFGroup", */T:-1},/*::[*/0x00DD/*::]*/:{/* n:"BrtBeginPCDFGItems", */T:1},/*::[*/0x00DE/*::]*/:{/* n:"BrtEndPCDFGItems", */T:-1},/*::[*/0x00DF/*::]*/:{/* n:"BrtBeginPCDFGRange", */T:1},/*::[*/0x00E0/*::]*/:{/* n:"BrtEndPCDFGRange", */T:-1},/*::[*/0x00E1/*::]*/:{/* n:"BrtBeginPCDFGDiscrete", */T:1},/*::[*/0x00E2/*::]*/:{/* n:"BrtEndPCDFGDiscrete", */T:-1},/*::[*/0x00E3/*::]*/:{/* n:"BrtBeginPCDSDTupleCache", */T:1},/*::[*/0x00E4/*::]*/:{/* n:"BrtEndPCDSDTupleCache", */T:-1},/*::[*/0x00E5/*::]*/:{/* n:"BrtBeginPCDSDTCEntries", */T:1},/*::[*/0x00E6/*::]*/:{/* n:"BrtEndPCDSDTCEntries", */T:-1},/*::[*/0x00E7/*::]*/:{/* n:"BrtBeginPCDSDTCEMembers", */T:1},/*::[*/0x00E8/*::]*/:{/* n:"BrtEndPCDSDTCEMembers", */T:-1},/*::[*/0x00E9/*::]*/:{/* n:"BrtBeginPCDSDTCEMember", */T:1},/*::[*/0x00EA/*::]*/:{/* n:"BrtEndPCDSDTCEMember", */T:-1},/*::[*/0x00EB/*::]*/:{/* n:"BrtBeginPCDSDTCQueries", */T:1},/*::[*/0x00EC/*::]*/:{/* n:"BrtEndPCDSDTCQueries", */T:-1},/*::[*/0x00ED/*::]*/:{/* n:"BrtBeginPCDSDTCQuery", */T:1},/*::[*/0x00EE/*::]*/:{/* n:"BrtEndPCDSDTCQuery", */T:-1},/*::[*/0x00EF/*::]*/:{/* n:"BrtBeginPCDSDTCSets", */T:1},/*::[*/0x00F0/*::]*/:{/* n:"BrtEndPCDSDTCSets", */T:-1},/*::[*/0x00F1/*::]*/:{/* n:"BrtBeginPCDSDTCSet", */T:1},/*::[*/0x00F2/*::]*/:{/* n:"BrtEndPCDSDTCSet", */T:-1},/*::[*/0x00F3/*::]*/:{/* n:"BrtBeginPCDCalcItems", */T:1},/*::[*/0x00F4/*::]*/:{/* n:"BrtEndPCDCalcItems", */T:-1},/*::[*/0x00F5/*::]*/:{/* n:"BrtBeginPCDCalcItem", */T:1},/*::[*/0x00F6/*::]*/:{/* n:"BrtEndPCDCalcItem", */T:-1},/*::[*/0x00F7/*::]*/:{/* n:"BrtBeginPRule", */T:1},/*::[*/0x00F8/*::]*/:{/* n:"BrtEndPRule", */T:-1},/*::[*/0x00F9/*::]*/:{/* n:"BrtBeginPRFilters", */T:1},/*::[*/0x00FA/*::]*/:{/* n:"BrtEndPRFilters", */T:-1},/*::[*/0x00FB/*::]*/:{/* n:"BrtBeginPRFilter", */T:1},/*::[*/0x00FC/*::]*/:{/* n:"BrtEndPRFilter", */T:-1},/*::[*/0x00FD/*::]*/:{/* n:"BrtBeginPNames", */T:1},/*::[*/0x00FE/*::]*/:{/* n:"BrtEndPNames", */T:-1},/*::[*/0x00FF/*::]*/:{/* n:"BrtBeginPName", */T:1},/*::[*/0x0100/*::]*/:{/* n:"BrtEndPName", */T:-1},/*::[*/0x0101/*::]*/:{/* n:"BrtBeginPNPairs", */T:1},/*::[*/0x0102/*::]*/:{/* n:"BrtEndPNPairs", */T:-1},/*::[*/0x0103/*::]*/:{/* n:"BrtBeginPNPair", */T:1},/*::[*/0x0104/*::]*/:{/* n:"BrtEndPNPair", */T:-1},/*::[*/0x0105/*::]*/:{/* n:"BrtBeginECWebProps", */T:1},/*::[*/0x0106/*::]*/:{/* n:"BrtEndECWebProps", */T:-1},/*::[*/0x0107/*::]*/:{/* n:"BrtBeginEcWpTables", */T:1},/*::[*/0x0108/*::]*/:{/* n:"BrtEndECWPTables", */T:-1},/*::[*/0x0109/*::]*/:{/* n:"BrtBeginECParams", */T:1},/*::[*/0x010A/*::]*/:{/* n:"BrtEndECParams", */T:-1},/*::[*/0x010B/*::]*/:{/* n:"BrtBeginECParam", */T:1},/*::[*/0x010C/*::]*/:{/* n:"BrtEndECParam", */T:-1},/*::[*/0x010D/*::]*/:{/* n:"BrtBeginPCDKPIs", */T:1},/*::[*/0x010E/*::]*/:{/* n:"BrtEndPCDKPIs", */T:-1},/*::[*/0x010F/*::]*/:{/* n:"BrtBeginPCDKPI", */T:1},/*::[*/0x0110/*::]*/:{/* n:"BrtEndPCDKPI", */T:-1},/*::[*/0x0111/*::]*/:{/* n:"BrtBeginDims", */T:1},/*::[*/0x0112/*::]*/:{/* n:"BrtEndDims", */T:-1},/*::[*/0x0113/*::]*/:{/* n:"BrtBeginDim", */T:1},/*::[*/0x0114/*::]*/:{/* n:"BrtEndDim", */T:-1},/*::[*/0x0115/*::]*/:{/* n:"BrtIndexPartEnd" */},/*::[*/0x0116/*::]*/:{/* n:"BrtBeginStyleSheet", */T:1},/*::[*/0x0117/*::]*/:{/* n:"BrtEndStyleSheet", */T:-1},/*::[*/0x0118/*::]*/:{/* n:"BrtBeginSXView", */T:1},/*::[*/0x0119/*::]*/:{/* n:"BrtEndSXVI", */T:-1},/*::[*/0x011A/*::]*/:{/* n:"BrtBeginSXVI", */T:1},/*::[*/0x011B/*::]*/:{/* n:"BrtBeginSXVIs", */T:1},/*::[*/0x011C/*::]*/:{/* n:"BrtEndSXVIs", */T:-1},/*::[*/0x011D/*::]*/:{/* n:"BrtBeginSXVD", */T:1},/*::[*/0x011E/*::]*/:{/* n:"BrtEndSXVD", */T:-1},/*::[*/0x011F/*::]*/:{/* n:"BrtBeginSXVDs", */T:1},/*::[*/0x0120/*::]*/:{/* n:"BrtEndSXVDs", */T:-1},/*::[*/0x0121/*::]*/:{/* n:"BrtBeginSXPI", */T:1},/*::[*/0x0122/*::]*/:{/* n:"BrtEndSXPI", */T:-1},/*::[*/0x0123/*::]*/:{/* n:"BrtBeginSXPIs", */T:1},/*::[*/0x0124/*::]*/:{/* n:"BrtEndSXPIs", */T:-1},/*::[*/0x0125/*::]*/:{/* n:"BrtBeginSXDI", */T:1},/*::[*/0x0126/*::]*/:{/* n:"BrtEndSXDI", */T:-1},/*::[*/0x0127/*::]*/:{/* n:"BrtBeginSXDIs", */T:1},/*::[*/0x0128/*::]*/:{/* n:"BrtEndSXDIs", */T:-1},/*::[*/0x0129/*::]*/:{/* n:"BrtBeginSXLI", */T:1},/*::[*/0x012A/*::]*/:{/* n:"BrtEndSXLI", */T:-1},/*::[*/0x012B/*::]*/:{/* n:"BrtBeginSXLIRws", */T:1},/*::[*/0x012C/*::]*/:{/* n:"BrtEndSXLIRws", */T:-1},/*::[*/0x012D/*::]*/:{/* n:"BrtBeginSXLICols", */T:1},/*::[*/0x012E/*::]*/:{/* n:"BrtEndSXLICols", */T:-1},/*::[*/0x012F/*::]*/:{/* n:"BrtBeginSXFormat", */T:1},/*::[*/0x0130/*::]*/:{/* n:"BrtEndSXFormat", */T:-1},/*::[*/0x0131/*::]*/:{/* n:"BrtBeginSXFormats", */T:1},/*::[*/0x0132/*::]*/:{/* n:"BrtEndSxFormats", */T:-1},/*::[*/0x0133/*::]*/:{/* n:"BrtBeginSxSelect", */T:1},/*::[*/0x0134/*::]*/:{/* n:"BrtEndSxSelect", */T:-1},/*::[*/0x0135/*::]*/:{/* n:"BrtBeginISXVDRws", */T:1},/*::[*/0x0136/*::]*/:{/* n:"BrtEndISXVDRws", */T:-1},/*::[*/0x0137/*::]*/:{/* n:"BrtBeginISXVDCols", */T:1},/*::[*/0x0138/*::]*/:{/* n:"BrtEndISXVDCols", */T:-1},/*::[*/0x0139/*::]*/:{/* n:"BrtEndSXLocation", */T:-1},/*::[*/0x013A/*::]*/:{/* n:"BrtBeginSXLocation", */T:1},/*::[*/0x013B/*::]*/:{/* n:"BrtEndSXView", */T:-1},/*::[*/0x013C/*::]*/:{/* n:"BrtBeginSXTHs", */T:1},/*::[*/0x013D/*::]*/:{/* n:"BrtEndSXTHs", */T:-1},/*::[*/0x013E/*::]*/:{/* n:"BrtBeginSXTH", */T:1},/*::[*/0x013F/*::]*/:{/* n:"BrtEndSXTH", */T:-1},/*::[*/0x0140/*::]*/:{/* n:"BrtBeginISXTHRws", */T:1},/*::[*/0x0141/*::]*/:{/* n:"BrtEndISXTHRws", */T:-1},/*::[*/0x0142/*::]*/:{/* n:"BrtBeginISXTHCols", */T:1},/*::[*/0x0143/*::]*/:{/* n:"BrtEndISXTHCols", */T:-1},/*::[*/0x0144/*::]*/:{/* n:"BrtBeginSXTDMPS", */T:1},/*::[*/0x0145/*::]*/:{/* n:"BrtEndSXTDMPs", */T:-1},/*::[*/0x0146/*::]*/:{/* n:"BrtBeginSXTDMP", */T:1},/*::[*/0x0147/*::]*/:{/* n:"BrtEndSXTDMP", */T:-1},/*::[*/0x0148/*::]*/:{/* n:"BrtBeginSXTHItems", */T:1},/*::[*/0x0149/*::]*/:{/* n:"BrtEndSXTHItems", */T:-1},/*::[*/0x014A/*::]*/:{/* n:"BrtBeginSXTHItem", */T:1},/*::[*/0x014B/*::]*/:{/* n:"BrtEndSXTHItem", */T:-1},/*::[*/0x014C/*::]*/:{/* n:"BrtBeginMetadata", */T:1},/*::[*/0x014D/*::]*/:{/* n:"BrtEndMetadata", */T:-1},/*::[*/0x014E/*::]*/:{/* n:"BrtBeginEsmdtinfo", */T:1},/*::[*/0x014F/*::]*/:{/* n:"BrtMdtinfo", */f:parse_BrtMdtinfo},/*::[*/0x0150/*::]*/:{/* n:"BrtEndEsmdtinfo", */T:-1},/*::[*/0x0151/*::]*/:{/* n:"BrtBeginEsmdb", */f:parse_BrtBeginEsmdb,T:1},/*::[*/0x0152/*::]*/:{/* n:"BrtEndEsmdb", */T:-1},/*::[*/0x0153/*::]*/:{/* n:"BrtBeginEsfmd", */T:1},/*::[*/0x0154/*::]*/:{/* n:"BrtEndEsfmd", */T:-1},/*::[*/0x0155/*::]*/:{/* n:"BrtBeginSingleCells", */T:1},/*::[*/0x0156/*::]*/:{/* n:"BrtEndSingleCells", */T:-1},/*::[*/0x0157/*::]*/:{/* n:"BrtBeginList", */T:1},/*::[*/0x0158/*::]*/:{/* n:"BrtEndList", */T:-1},/*::[*/0x0159/*::]*/:{/* n:"BrtBeginListCols", */T:1},/*::[*/0x015A/*::]*/:{/* n:"BrtEndListCols", */T:-1},/*::[*/0x015B/*::]*/:{/* n:"BrtBeginListCol", */T:1},/*::[*/0x015C/*::]*/:{/* n:"BrtEndListCol", */T:-1},/*::[*/0x015D/*::]*/:{/* n:"BrtBeginListXmlCPr", */T:1},/*::[*/0x015E/*::]*/:{/* n:"BrtEndListXmlCPr", */T:-1},/*::[*/0x015F/*::]*/:{/* n:"BrtListCCFmla" */},/*::[*/0x0160/*::]*/:{/* n:"BrtListTrFmla" */},/*::[*/0x0161/*::]*/:{/* n:"BrtBeginExternals", */T:1},/*::[*/0x0162/*::]*/:{/* n:"BrtEndExternals", */T:-1},/*::[*/0x0163/*::]*/:{/* n:"BrtSupBookSrc", */f:parse_RelID},/*::[*/0x0165/*::]*/:{/* n:"BrtSupSelf" */},/*::[*/0x0166/*::]*/:{/* n:"BrtSupSame" */},/*::[*/0x0167/*::]*/:{/* n:"BrtSupTabs" */},/*::[*/0x0168/*::]*/:{/* n:"BrtBeginSupBook", */T:1},/*::[*/0x0169/*::]*/:{/* n:"BrtPlaceholderName" */},/*::[*/0x016A/*::]*/:{/* n:"BrtExternSheet", */f:parse_ExternSheet},/*::[*/0x016B/*::]*/:{/* n:"BrtExternTableStart" */},/*::[*/0x016C/*::]*/:{/* n:"BrtExternTableEnd" */},/*::[*/0x016E/*::]*/:{/* n:"BrtExternRowHdr" */},/*::[*/0x016F/*::]*/:{/* n:"BrtExternCellBlank" */},/*::[*/0x0170/*::]*/:{/* n:"BrtExternCellReal" */},/*::[*/0x0171/*::]*/:{/* n:"BrtExternCellBool" */},/*::[*/0x0172/*::]*/:{/* n:"BrtExternCellError" */},/*::[*/0x0173/*::]*/:{/* n:"BrtExternCellString" */},/*::[*/0x0174/*::]*/:{/* n:"BrtBeginEsmdx", */T:1},/*::[*/0x0175/*::]*/:{/* n:"BrtEndEsmdx", */T:-1},/*::[*/0x0176/*::]*/:{/* n:"BrtBeginMdxSet", */T:1},/*::[*/0x0177/*::]*/:{/* n:"BrtEndMdxSet", */T:-1},/*::[*/0x0178/*::]*/:{/* n:"BrtBeginMdxMbrProp", */T:1},/*::[*/0x0179/*::]*/:{/* n:"BrtEndMdxMbrProp", */T:-1},/*::[*/0x017A/*::]*/:{/* n:"BrtBeginMdxKPI", */T:1},/*::[*/0x017B/*::]*/:{/* n:"BrtEndMdxKPI", */T:-1},/*::[*/0x017C/*::]*/:{/* n:"BrtBeginEsstr", */T:1},/*::[*/0x017D/*::]*/:{/* n:"BrtEndEsstr", */T:-1},/*::[*/0x017E/*::]*/:{/* n:"BrtBeginPRFItem", */T:1},/*::[*/0x017F/*::]*/:{/* n:"BrtEndPRFItem", */T:-1},/*::[*/0x0180/*::]*/:{/* n:"BrtBeginPivotCacheIDs", */T:1},/*::[*/0x0181/*::]*/:{/* n:"BrtEndPivotCacheIDs", */T:-1},/*::[*/0x0182/*::]*/:{/* n:"BrtBeginPivotCacheID", */T:1},/*::[*/0x0183/*::]*/:{/* n:"BrtEndPivotCacheID", */T:-1},/*::[*/0x0184/*::]*/:{/* n:"BrtBeginISXVIs", */T:1},/*::[*/0x0185/*::]*/:{/* n:"BrtEndISXVIs", */T:-1},/*::[*/0x0186/*::]*/:{/* n:"BrtBeginColInfos", */T:1},/*::[*/0x0187/*::]*/:{/* n:"BrtEndColInfos", */T:-1},/*::[*/0x0188/*::]*/:{/* n:"BrtBeginRwBrk", */T:1},/*::[*/0x0189/*::]*/:{/* n:"BrtEndRwBrk", */T:-1},/*::[*/0x018A/*::]*/:{/* n:"BrtBeginColBrk", */T:1},/*::[*/0x018B/*::]*/:{/* n:"BrtEndColBrk", */T:-1},/*::[*/0x018C/*::]*/:{/* n:"BrtBrk" */},/*::[*/0x018D/*::]*/:{/* n:"BrtUserBookView" */},/*::[*/0x018E/*::]*/:{/* n:"BrtInfo" */},/*::[*/0x018F/*::]*/:{/* n:"BrtCUsr" */},/*::[*/0x0190/*::]*/:{/* n:"BrtUsr" */},/*::[*/0x0191/*::]*/:{/* n:"BrtBeginUsers", */T:1},/*::[*/0x0193/*::]*/:{/* n:"BrtEOF" */},/*::[*/0x0194/*::]*/:{/* n:"BrtUCR" */},/*::[*/0x0195/*::]*/:{/* n:"BrtRRInsDel" */},/*::[*/0x0196/*::]*/:{/* n:"BrtRREndInsDel" */},/*::[*/0x0197/*::]*/:{/* n:"BrtRRMove" */},/*::[*/0x0198/*::]*/:{/* n:"BrtRREndMove" */},/*::[*/0x0199/*::]*/:{/* n:"BrtRRChgCell" */},/*::[*/0x019A/*::]*/:{/* n:"BrtRREndChgCell" */},/*::[*/0x019B/*::]*/:{/* n:"BrtRRHeader" */},/*::[*/0x019C/*::]*/:{/* n:"BrtRRUserView" */},/*::[*/0x019D/*::]*/:{/* n:"BrtRRRenSheet" */},/*::[*/0x019E/*::]*/:{/* n:"BrtRRInsertSh" */},/*::[*/0x019F/*::]*/:{/* n:"BrtRRDefName" */},/*::[*/0x01A0/*::]*/:{/* n:"BrtRRNote" */},/*::[*/0x01A1/*::]*/:{/* n:"BrtRRConflict" */},/*::[*/0x01A2/*::]*/:{/* n:"BrtRRTQSIF" */},/*::[*/0x01A3/*::]*/:{/* n:"BrtRRFormat" */},/*::[*/0x01A4/*::]*/:{/* n:"BrtRREndFormat" */},/*::[*/0x01A5/*::]*/:{/* n:"BrtRRAutoFmt" */},/*::[*/0x01A6/*::]*/:{/* n:"BrtBeginUserShViews", */T:1},/*::[*/0x01A7/*::]*/:{/* n:"BrtBeginUserShView", */T:1},/*::[*/0x01A8/*::]*/:{/* n:"BrtEndUserShView", */T:-1},/*::[*/0x01A9/*::]*/:{/* n:"BrtEndUserShViews", */T:-1},/*::[*/0x01AA/*::]*/:{/* n:"BrtArrFmla", */f:parse_BrtArrFmla},/*::[*/0x01AB/*::]*/:{/* n:"BrtShrFmla", */f:parse_BrtShrFmla},/*::[*/0x01AC/*::]*/:{/* n:"BrtTable" */},/*::[*/0x01AD/*::]*/:{/* n:"BrtBeginExtConnections", */T:1},/*::[*/0x01AE/*::]*/:{/* n:"BrtEndExtConnections", */T:-1},/*::[*/0x01AF/*::]*/:{/* n:"BrtBeginPCDCalcMems", */T:1},/*::[*/0x01B0/*::]*/:{/* n:"BrtEndPCDCalcMems", */T:-1},/*::[*/0x01B1/*::]*/:{/* n:"BrtBeginPCDCalcMem", */T:1},/*::[*/0x01B2/*::]*/:{/* n:"BrtEndPCDCalcMem", */T:-1},/*::[*/0x01B3/*::]*/:{/* n:"BrtBeginPCDHGLevels", */T:1},/*::[*/0x01B4/*::]*/:{/* n:"BrtEndPCDHGLevels", */T:-1},/*::[*/0x01B5/*::]*/:{/* n:"BrtBeginPCDHGLevel", */T:1},/*::[*/0x01B6/*::]*/:{/* n:"BrtEndPCDHGLevel", */T:-1},/*::[*/0x01B7/*::]*/:{/* n:"BrtBeginPCDHGLGroups", */T:1},/*::[*/0x01B8/*::]*/:{/* n:"BrtEndPCDHGLGroups", */T:-1},/*::[*/0x01B9/*::]*/:{/* n:"BrtBeginPCDHGLGroup", */T:1},/*::[*/0x01BA/*::]*/:{/* n:"BrtEndPCDHGLGroup", */T:-1},/*::[*/0x01BB/*::]*/:{/* n:"BrtBeginPCDHGLGMembers", */T:1},/*::[*/0x01BC/*::]*/:{/* n:"BrtEndPCDHGLGMembers", */T:-1},/*::[*/0x01BD/*::]*/:{/* n:"BrtBeginPCDHGLGMember", */T:1},/*::[*/0x01BE/*::]*/:{/* n:"BrtEndPCDHGLGMember", */T:-1},/*::[*/0x01BF/*::]*/:{/* n:"BrtBeginQSI", */T:1},/*::[*/0x01C0/*::]*/:{/* n:"BrtEndQSI", */T:-1},/*::[*/0x01C1/*::]*/:{/* n:"BrtBeginQSIR", */T:1},/*::[*/0x01C2/*::]*/:{/* n:"BrtEndQSIR", */T:-1},/*::[*/0x01C3/*::]*/:{/* n:"BrtBeginDeletedNames", */T:1},/*::[*/0x01C4/*::]*/:{/* n:"BrtEndDeletedNames", */T:-1},/*::[*/0x01C5/*::]*/:{/* n:"BrtBeginDeletedName", */T:1},/*::[*/0x01C6/*::]*/:{/* n:"BrtEndDeletedName", */T:-1},/*::[*/0x01C7/*::]*/:{/* n:"BrtBeginQSIFs", */T:1},/*::[*/0x01C8/*::]*/:{/* n:"BrtEndQSIFs", */T:-1},/*::[*/0x01C9/*::]*/:{/* n:"BrtBeginQSIF", */T:1},/*::[*/0x01CA/*::]*/:{/* n:"BrtEndQSIF", */T:-1},/*::[*/0x01CB/*::]*/:{/* n:"BrtBeginAutoSortScope", */T:1},/*::[*/0x01CC/*::]*/:{/* n:"BrtEndAutoSortScope", */T:-1},/*::[*/0x01CD/*::]*/:{/* n:"BrtBeginConditionalFormatting", */T:1},/*::[*/0x01CE/*::]*/:{/* n:"BrtEndConditionalFormatting", */T:-1},/*::[*/0x01CF/*::]*/:{/* n:"BrtBeginCFRule", */T:1},/*::[*/0x01D0/*::]*/:{/* n:"BrtEndCFRule", */T:-1},/*::[*/0x01D1/*::]*/:{/* n:"BrtBeginIconSet", */T:1},/*::[*/0x01D2/*::]*/:{/* n:"BrtEndIconSet", */T:-1},/*::[*/0x01D3/*::]*/:{/* n:"BrtBeginDatabar", */T:1},/*::[*/0x01D4/*::]*/:{/* n:"BrtEndDatabar", */T:-1},/*::[*/0x01D5/*::]*/:{/* n:"BrtBeginColorScale", */T:1},/*::[*/0x01D6/*::]*/:{/* n:"BrtEndColorScale", */T:-1},/*::[*/0x01D7/*::]*/:{/* n:"BrtCFVO" */},/*::[*/0x01D8/*::]*/:{/* n:"BrtExternValueMeta" */},/*::[*/0x01D9/*::]*/:{/* n:"BrtBeginColorPalette", */T:1},/*::[*/0x01DA/*::]*/:{/* n:"BrtEndColorPalette", */T:-1},/*::[*/0x01DB/*::]*/:{/* n:"BrtIndexedColor" */},/*::[*/0x01DC/*::]*/:{/* n:"BrtMargins", */f:parse_BrtMargins},/*::[*/0x01DD/*::]*/:{/* n:"BrtPrintOptions" */},/*::[*/0x01DE/*::]*/:{/* n:"BrtPageSetup" */},/*::[*/0x01DF/*::]*/:{/* n:"BrtBeginHeaderFooter", */T:1},/*::[*/0x01E0/*::]*/:{/* n:"BrtEndHeaderFooter", */T:-1},/*::[*/0x01E1/*::]*/:{/* n:"BrtBeginSXCrtFormat", */T:1},/*::[*/0x01E2/*::]*/:{/* n:"BrtEndSXCrtFormat", */T:-1},/*::[*/0x01E3/*::]*/:{/* n:"BrtBeginSXCrtFormats", */T:1},/*::[*/0x01E4/*::]*/:{/* n:"BrtEndSXCrtFormats", */T:-1},/*::[*/0x01E5/*::]*/:{/* n:"BrtWsFmtInfo", */f:parse_BrtWsFmtInfo},/*::[*/0x01E6/*::]*/:{/* n:"BrtBeginMgs", */T:1},/*::[*/0x01E7/*::]*/:{/* n:"BrtEndMGs", */T:-1},/*::[*/0x01E8/*::]*/:{/* n:"BrtBeginMGMaps", */T:1},/*::[*/0x01E9/*::]*/:{/* n:"BrtEndMGMaps", */T:-1},/*::[*/0x01EA/*::]*/:{/* n:"BrtBeginMG", */T:1},/*::[*/0x01EB/*::]*/:{/* n:"BrtEndMG", */T:-1},/*::[*/0x01EC/*::]*/:{/* n:"BrtBeginMap", */T:1},/*::[*/0x01ED/*::]*/:{/* n:"BrtEndMap", */T:-1},/*::[*/0x01EE/*::]*/:{/* n:"BrtHLink", */f:parse_BrtHLink},/*::[*/0x01EF/*::]*/:{/* n:"BrtBeginDCon", */T:1},/*::[*/0x01F0/*::]*/:{/* n:"BrtEndDCon", */T:-1},/*::[*/0x01F1/*::]*/:{/* n:"BrtBeginDRefs", */T:1},/*::[*/0x01F2/*::]*/:{/* n:"BrtEndDRefs", */T:-1},/*::[*/0x01F3/*::]*/:{/* n:"BrtDRef" */},/*::[*/0x01F4/*::]*/:{/* n:"BrtBeginScenMan", */T:1},/*::[*/0x01F5/*::]*/:{/* n:"BrtEndScenMan", */T:-1},/*::[*/0x01F6/*::]*/:{/* n:"BrtBeginSct", */T:1},/*::[*/0x01F7/*::]*/:{/* n:"BrtEndSct", */T:-1},/*::[*/0x01F8/*::]*/:{/* n:"BrtSlc" */},/*::[*/0x01F9/*::]*/:{/* n:"BrtBeginDXFs", */T:1},/*::[*/0x01FA/*::]*/:{/* n:"BrtEndDXFs", */T:-1},/*::[*/0x01FB/*::]*/:{/* n:"BrtDXF" */},/*::[*/0x01FC/*::]*/:{/* n:"BrtBeginTableStyles", */T:1},/*::[*/0x01FD/*::]*/:{/* n:"BrtEndTableStyles", */T:-1},/*::[*/0x01FE/*::]*/:{/* n:"BrtBeginTableStyle", */T:1},/*::[*/0x01FF/*::]*/:{/* n:"BrtEndTableStyle", */T:-1},/*::[*/0x0200/*::]*/:{/* n:"BrtTableStyleElement" */},/*::[*/0x0201/*::]*/:{/* n:"BrtTableStyleClient" */},/*::[*/0x0202/*::]*/:{/* n:"BrtBeginVolDeps", */T:1},/*::[*/0x0203/*::]*/:{/* n:"BrtEndVolDeps", */T:-1},/*::[*/0x0204/*::]*/:{/* n:"BrtBeginVolType", */T:1},/*::[*/0x0205/*::]*/:{/* n:"BrtEndVolType", */T:-1},/*::[*/0x0206/*::]*/:{/* n:"BrtBeginVolMain", */T:1},/*::[*/0x0207/*::]*/:{/* n:"BrtEndVolMain", */T:-1},/*::[*/0x0208/*::]*/:{/* n:"BrtBeginVolTopic", */T:1},/*::[*/0x0209/*::]*/:{/* n:"BrtEndVolTopic", */T:-1},/*::[*/0x020A/*::]*/:{/* n:"BrtVolSubtopic" */},/*::[*/0x020B/*::]*/:{/* n:"BrtVolRef" */},/*::[*/0x020C/*::]*/:{/* n:"BrtVolNum" */},/*::[*/0x020D/*::]*/:{/* n:"BrtVolErr" */},/*::[*/0x020E/*::]*/:{/* n:"BrtVolStr" */},/*::[*/0x020F/*::]*/:{/* n:"BrtVolBool" */},/*::[*/0x0210/*::]*/:{/* n:"BrtBeginCalcChain$", */T:1},/*::[*/0x0211/*::]*/:{/* n:"BrtEndCalcChain$", */T:-1},/*::[*/0x0212/*::]*/:{/* n:"BrtBeginSortState", */T:1},/*::[*/0x0213/*::]*/:{/* n:"BrtEndSortState", */T:-1},/*::[*/0x0214/*::]*/:{/* n:"BrtBeginSortCond", */T:1},/*::[*/0x0215/*::]*/:{/* n:"BrtEndSortCond", */T:-1},/*::[*/0x0216/*::]*/:{/* n:"BrtBookProtection" */},/*::[*/0x0217/*::]*/:{/* n:"BrtSheetProtection" */},/*::[*/0x0218/*::]*/:{/* n:"BrtRangeProtection" */},/*::[*/0x0219/*::]*/:{/* n:"BrtPhoneticInfo" */},/*::[*/0x021A/*::]*/:{/* n:"BrtBeginECTxtWiz", */T:1},/*::[*/0x021B/*::]*/:{/* n:"BrtEndECTxtWiz", */T:-1},/*::[*/0x021C/*::]*/:{/* n:"BrtBeginECTWFldInfoLst", */T:1},/*::[*/0x021D/*::]*/:{/* n:"BrtEndECTWFldInfoLst", */T:-1},/*::[*/0x021E/*::]*/:{/* n:"BrtBeginECTwFldInfo", */T:1},/*::[*/0x0224/*::]*/:{/* n:"BrtFileSharing" */},/*::[*/0x0225/*::]*/:{/* n:"BrtOleSize" */},/*::[*/0x0226/*::]*/:{/* n:"BrtDrawing", */f:parse_RelID},/*::[*/0x0227/*::]*/:{/* n:"BrtLegacyDrawing" */},/*::[*/0x0228/*::]*/:{/* n:"BrtLegacyDrawingHF" */},/*::[*/0x0229/*::]*/:{/* n:"BrtWebOpt" */},/*::[*/0x022A/*::]*/:{/* n:"BrtBeginWebPubItems", */T:1},/*::[*/0x022B/*::]*/:{/* n:"BrtEndWebPubItems", */T:-1},/*::[*/0x022C/*::]*/:{/* n:"BrtBeginWebPubItem", */T:1},/*::[*/0x022D/*::]*/:{/* n:"BrtEndWebPubItem", */T:-1},/*::[*/0x022E/*::]*/:{/* n:"BrtBeginSXCondFmt", */T:1},/*::[*/0x022F/*::]*/:{/* n:"BrtEndSXCondFmt", */T:-1},/*::[*/0x0230/*::]*/:{/* n:"BrtBeginSXCondFmts", */T:1},/*::[*/0x0231/*::]*/:{/* n:"BrtEndSXCondFmts", */T:-1},/*::[*/0x0232/*::]*/:{/* n:"BrtBkHim" */},/*::[*/0x0234/*::]*/:{/* n:"BrtColor" */},/*::[*/0x0235/*::]*/:{/* n:"BrtBeginIndexedColors", */T:1},/*::[*/0x0236/*::]*/:{/* n:"BrtEndIndexedColors", */T:-1},/*::[*/0x0239/*::]*/:{/* n:"BrtBeginMRUColors", */T:1},/*::[*/0x023A/*::]*/:{/* n:"BrtEndMRUColors", */T:-1},/*::[*/0x023C/*::]*/:{/* n:"BrtMRUColor" */},/*::[*/0x023D/*::]*/:{/* n:"BrtBeginDVals", */T:1},/*::[*/0x023E/*::]*/:{/* n:"BrtEndDVals", */T:-1},/*::[*/0x0241/*::]*/:{/* n:"BrtSupNameStart" */},/*::[*/0x0242/*::]*/:{/* n:"BrtSupNameValueStart" */},/*::[*/0x0243/*::]*/:{/* n:"BrtSupNameValueEnd" */},/*::[*/0x0244/*::]*/:{/* n:"BrtSupNameNum" */},/*::[*/0x0245/*::]*/:{/* n:"BrtSupNameErr" */},/*::[*/0x0246/*::]*/:{/* n:"BrtSupNameSt" */},/*::[*/0x0247/*::]*/:{/* n:"BrtSupNameNil" */},/*::[*/0x0248/*::]*/:{/* n:"BrtSupNameBool" */},/*::[*/0x0249/*::]*/:{/* n:"BrtSupNameFmla" */},/*::[*/0x024A/*::]*/:{/* n:"BrtSupNameBits" */},/*::[*/0x024B/*::]*/:{/* n:"BrtSupNameEnd" */},/*::[*/0x024C/*::]*/:{/* n:"BrtEndSupBook", */T:-1},/*::[*/0x024D/*::]*/:{/* n:"BrtCellSmartTagProperty" */},/*::[*/0x024E/*::]*/:{/* n:"BrtBeginCellSmartTag", */T:1},/*::[*/0x024F/*::]*/:{/* n:"BrtEndCellSmartTag", */T:-1},/*::[*/0x0250/*::]*/:{/* n:"BrtBeginCellSmartTags", */T:1},/*::[*/0x0251/*::]*/:{/* n:"BrtEndCellSmartTags", */T:-1},/*::[*/0x0252/*::]*/:{/* n:"BrtBeginSmartTags", */T:1},/*::[*/0x0253/*::]*/:{/* n:"BrtEndSmartTags", */T:-1},/*::[*/0x0254/*::]*/:{/* n:"BrtSmartTagType" */},/*::[*/0x0255/*::]*/:{/* n:"BrtBeginSmartTagTypes", */T:1},/*::[*/0x0256/*::]*/:{/* n:"BrtEndSmartTagTypes", */T:-1},/*::[*/0x0257/*::]*/:{/* n:"BrtBeginSXFilters", */T:1},/*::[*/0x0258/*::]*/:{/* n:"BrtEndSXFilters", */T:-1},/*::[*/0x0259/*::]*/:{/* n:"BrtBeginSXFILTER", */T:1},/*::[*/0x025A/*::]*/:{/* n:"BrtEndSXFilter", */T:-1},/*::[*/0x025B/*::]*/:{/* n:"BrtBeginFills", */T:1},/*::[*/0x025C/*::]*/:{/* n:"BrtEndFills", */T:-1},/*::[*/0x025D/*::]*/:{/* n:"BrtBeginCellWatches", */T:1},/*::[*/0x025E/*::]*/:{/* n:"BrtEndCellWatches", */T:-1},/*::[*/0x025F/*::]*/:{/* n:"BrtCellWatch" */},/*::[*/0x0260/*::]*/:{/* n:"BrtBeginCRErrs", */T:1},/*::[*/0x0261/*::]*/:{/* n:"BrtEndCRErrs", */T:-1},/*::[*/0x0262/*::]*/:{/* n:"BrtCrashRecErr" */},/*::[*/0x0263/*::]*/:{/* n:"BrtBeginFonts", */T:1},/*::[*/0x0264/*::]*/:{/* n:"BrtEndFonts", */T:-1},/*::[*/0x0265/*::]*/:{/* n:"BrtBeginBorders", */T:1},/*::[*/0x0266/*::]*/:{/* n:"BrtEndBorders", */T:-1},/*::[*/0x0267/*::]*/:{/* n:"BrtBeginFmts", */T:1},/*::[*/0x0268/*::]*/:{/* n:"BrtEndFmts", */T:-1},/*::[*/0x0269/*::]*/:{/* n:"BrtBeginCellXFs", */T:1},/*::[*/0x026A/*::]*/:{/* n:"BrtEndCellXFs", */T:-1},/*::[*/0x026B/*::]*/:{/* n:"BrtBeginStyles", */T:1},/*::[*/0x026C/*::]*/:{/* n:"BrtEndStyles", */T:-1},/*::[*/0x0271/*::]*/:{/* n:"BrtBigName" */},/*::[*/0x0272/*::]*/:{/* n:"BrtBeginCellStyleXFs", */T:1},/*::[*/0x0273/*::]*/:{/* n:"BrtEndCellStyleXFs", */T:-1},/*::[*/0x0274/*::]*/:{/* n:"BrtBeginComments", */T:1},/*::[*/0x0275/*::]*/:{/* n:"BrtEndComments", */T:-1},/*::[*/0x0276/*::]*/:{/* n:"BrtBeginCommentAuthors", */T:1},/*::[*/0x0277/*::]*/:{/* n:"BrtEndCommentAuthors", */T:-1},/*::[*/0x0278/*::]*/:{/* n:"BrtCommentAuthor", */f:parse_BrtCommentAuthor},/*::[*/0x0279/*::]*/:{/* n:"BrtBeginCommentList", */T:1},/*::[*/0x027A/*::]*/:{/* n:"BrtEndCommentList", */T:-1},/*::[*/0x027B/*::]*/:{/* n:"BrtBeginComment", */T:1,f:parse_BrtBeginComment},/*::[*/0x027C/*::]*/:{/* n:"BrtEndComment", */T:-1},/*::[*/0x027D/*::]*/:{/* n:"BrtCommentText", */f:parse_BrtCommentText},/*::[*/0x027E/*::]*/:{/* n:"BrtBeginOleObjects", */T:1},/*::[*/0x027F/*::]*/:{/* n:"BrtOleObject" */},/*::[*/0x0280/*::]*/:{/* n:"BrtEndOleObjects", */T:-1},/*::[*/0x0281/*::]*/:{/* n:"BrtBeginSxrules", */T:1},/*::[*/0x0282/*::]*/:{/* n:"BrtEndSxRules", */T:-1},/*::[*/0x0283/*::]*/:{/* n:"BrtBeginActiveXControls", */T:1},/*::[*/0x0284/*::]*/:{/* n:"BrtActiveX" */},/*::[*/0x0285/*::]*/:{/* n:"BrtEndActiveXControls", */T:-1},/*::[*/0x0286/*::]*/:{/* n:"BrtBeginPCDSDTCEMembersSortBy", */T:1},/*::[*/0x0288/*::]*/:{/* n:"BrtBeginCellIgnoreECs", */T:1},/*::[*/0x0289/*::]*/:{/* n:"BrtCellIgnoreEC" */},/*::[*/0x028A/*::]*/:{/* n:"BrtEndCellIgnoreECs", */T:-1},/*::[*/0x028B/*::]*/:{/* n:"BrtCsProp", */f:parse_BrtCsProp},/*::[*/0x028C/*::]*/:{/* n:"BrtCsPageSetup" */},/*::[*/0x028D/*::]*/:{/* n:"BrtBeginUserCsViews", */T:1},/*::[*/0x028E/*::]*/:{/* n:"BrtEndUserCsViews", */T:-1},/*::[*/0x028F/*::]*/:{/* n:"BrtBeginUserCsView", */T:1},/*::[*/0x0290/*::]*/:{/* n:"BrtEndUserCsView", */T:-1},/*::[*/0x0291/*::]*/:{/* n:"BrtBeginPcdSFCIEntries", */T:1},/*::[*/0x0292/*::]*/:{/* n:"BrtEndPCDSFCIEntries", */T:-1},/*::[*/0x0293/*::]*/:{/* n:"BrtPCDSFCIEntry" */},/*::[*/0x0294/*::]*/:{/* n:"BrtBeginListParts", */T:1},/*::[*/0x0295/*::]*/:{/* n:"BrtListPart" */},/*::[*/0x0296/*::]*/:{/* n:"BrtEndListParts", */T:-1},/*::[*/0x0297/*::]*/:{/* n:"BrtSheetCalcProp" */},/*::[*/0x0298/*::]*/:{/* n:"BrtBeginFnGroup", */T:1},/*::[*/0x0299/*::]*/:{/* n:"BrtFnGroup" */},/*::[*/0x029A/*::]*/:{/* n:"BrtEndFnGroup", */T:-1},/*::[*/0x029B/*::]*/:{/* n:"BrtSupAddin" */},/*::[*/0x029C/*::]*/:{/* n:"BrtSXTDMPOrder" */},/*::[*/0x029D/*::]*/:{/* n:"BrtCsProtection" */},/*::[*/0x029F/*::]*/:{/* n:"BrtBeginWsSortMap", */T:1},/*::[*/0x02A0/*::]*/:{/* n:"BrtEndWsSortMap", */T:-1},/*::[*/0x02A1/*::]*/:{/* n:"BrtBeginRRSort", */T:1},/*::[*/0x02A2/*::]*/:{/* n:"BrtEndRRSort", */T:-1},/*::[*/0x02A3/*::]*/:{/* n:"BrtRRSortItem" */},/*::[*/0x02A4/*::]*/:{/* n:"BrtFileSharingIso" */},/*::[*/0x02A5/*::]*/:{/* n:"BrtBookProtectionIso" */},/*::[*/0x02A6/*::]*/:{/* n:"BrtSheetProtectionIso" */},/*::[*/0x02A7/*::]*/:{/* n:"BrtCsProtectionIso" */},/*::[*/0x02A8/*::]*/:{/* n:"BrtRangeProtectionIso" */},/*::[*/0x02A9/*::]*/:{/* n:"BrtDValList" */},/*::[*/0x0400/*::]*/:{/* n:"BrtRwDescent" */},/*::[*/0x0401/*::]*/:{/* n:"BrtKnownFonts" */},/*::[*/0x0402/*::]*/:{/* n:"BrtBeginSXTupleSet", */T:1},/*::[*/0x0403/*::]*/:{/* n:"BrtEndSXTupleSet", */T:-1},/*::[*/0x0404/*::]*/:{/* n:"BrtBeginSXTupleSetHeader", */T:1},/*::[*/0x0405/*::]*/:{/* n:"BrtEndSXTupleSetHeader", */T:-1},/*::[*/0x0406/*::]*/:{/* n:"BrtSXTupleSetHeaderItem" */},/*::[*/0x0407/*::]*/:{/* n:"BrtBeginSXTupleSetData", */T:1},/*::[*/0x0408/*::]*/:{/* n:"BrtEndSXTupleSetData", */T:-1},/*::[*/0x0409/*::]*/:{/* n:"BrtBeginSXTupleSetRow", */T:1},/*::[*/0x040A/*::]*/:{/* n:"BrtEndSXTupleSetRow", */T:-1},/*::[*/0x040B/*::]*/:{/* n:"BrtSXTupleSetRowItem" */},/*::[*/0x040C/*::]*/:{/* n:"BrtNameExt" */},/*::[*/0x040D/*::]*/:{/* n:"BrtPCDH14" */},/*::[*/0x040E/*::]*/:{/* n:"BrtBeginPCDCalcMem14", */T:1},/*::[*/0x040F/*::]*/:{/* n:"BrtEndPCDCalcMem14", */T:-1},/*::[*/0x0410/*::]*/:{/* n:"BrtSXTH14" */},/*::[*/0x0411/*::]*/:{/* n:"BrtBeginSparklineGroup", */T:1},/*::[*/0x0412/*::]*/:{/* n:"BrtEndSparklineGroup", */T:-1},/*::[*/0x0413/*::]*/:{/* n:"BrtSparkline" */},/*::[*/0x0414/*::]*/:{/* n:"BrtSXDI14" */},/*::[*/0x0415/*::]*/:{/* n:"BrtWsFmtInfoEx14" */},/*::[*/0x0416/*::]*/:{/* n:"BrtBeginConditionalFormatting14", */T:1},/*::[*/0x0417/*::]*/:{/* n:"BrtEndConditionalFormatting14", */T:-1},/*::[*/0x0418/*::]*/:{/* n:"BrtBeginCFRule14", */T:1},/*::[*/0x0419/*::]*/:{/* n:"BrtEndCFRule14", */T:-1},/*::[*/0x041A/*::]*/:{/* n:"BrtCFVO14" */},/*::[*/0x041B/*::]*/:{/* n:"BrtBeginDatabar14", */T:1},/*::[*/0x041C/*::]*/:{/* n:"BrtBeginIconSet14", */T:1},/*::[*/0x041D/*::]*/:{/* n:"BrtDVal14", */f:parse_BrtDVal14},/*::[*/0x041E/*::]*/:{/* n:"BrtBeginDVals14", */T:1},/*::[*/0x041F/*::]*/:{/* n:"BrtColor14" */},/*::[*/0x0420/*::]*/:{/* n:"BrtBeginSparklines", */T:1},/*::[*/0x0421/*::]*/:{/* n:"BrtEndSparklines", */T:-1},/*::[*/0x0422/*::]*/:{/* n:"BrtBeginSparklineGroups", */T:1},/*::[*/0x0423/*::]*/:{/* n:"BrtEndSparklineGroups", */T:-1},/*::[*/0x0425/*::]*/:{/* n:"BrtSXVD14" */},/*::[*/0x0426/*::]*/:{/* n:"BrtBeginSXView14", */T:1},/*::[*/0x0427/*::]*/:{/* n:"BrtEndSXView14", */T:-1},/*::[*/0x0428/*::]*/:{/* n:"BrtBeginSXView16", */T:1},/*::[*/0x0429/*::]*/:{/* n:"BrtEndSXView16", */T:-1},/*::[*/0x042A/*::]*/:{/* n:"BrtBeginPCD14", */T:1},/*::[*/0x042B/*::]*/:{/* n:"BrtEndPCD14", */T:-1},/*::[*/0x042C/*::]*/:{/* n:"BrtBeginExtConn14", */T:1},/*::[*/0x042D/*::]*/:{/* n:"BrtEndExtConn14", */T:-1},/*::[*/0x042E/*::]*/:{/* n:"BrtBeginSlicerCacheIDs", */T:1},/*::[*/0x042F/*::]*/:{/* n:"BrtEndSlicerCacheIDs", */T:-1},/*::[*/0x0430/*::]*/:{/* n:"BrtBeginSlicerCacheID", */T:1},/*::[*/0x0431/*::]*/:{/* n:"BrtEndSlicerCacheID", */T:-1},/*::[*/0x0433/*::]*/:{/* n:"BrtBeginSlicerCache", */T:1},/*::[*/0x0434/*::]*/:{/* n:"BrtEndSlicerCache", */T:-1},/*::[*/0x0435/*::]*/:{/* n:"BrtBeginSlicerCacheDef", */T:1},/*::[*/0x0436/*::]*/:{/* n:"BrtEndSlicerCacheDef", */T:-1},/*::[*/0x0437/*::]*/:{/* n:"BrtBeginSlicersEx", */T:1},/*::[*/0x0438/*::]*/:{/* n:"BrtEndSlicersEx", */T:-1},/*::[*/0x0439/*::]*/:{/* n:"BrtBeginSlicerEx", */T:1},/*::[*/0x043A/*::]*/:{/* n:"BrtEndSlicerEx", */T:-1},/*::[*/0x043B/*::]*/:{/* n:"BrtBeginSlicer", */T:1},/*::[*/0x043C/*::]*/:{/* n:"BrtEndSlicer", */T:-1},/*::[*/0x043D/*::]*/:{/* n:"BrtSlicerCachePivotTables" */},/*::[*/0x043E/*::]*/:{/* n:"BrtBeginSlicerCacheOlapImpl", */T:1},/*::[*/0x043F/*::]*/:{/* n:"BrtEndSlicerCacheOlapImpl", */T:-1},/*::[*/0x0440/*::]*/:{/* n:"BrtBeginSlicerCacheLevelsData", */T:1},/*::[*/0x0441/*::]*/:{/* n:"BrtEndSlicerCacheLevelsData", */T:-1},/*::[*/0x0442/*::]*/:{/* n:"BrtBeginSlicerCacheLevelData", */T:1},/*::[*/0x0443/*::]*/:{/* n:"BrtEndSlicerCacheLevelData", */T:-1},/*::[*/0x0444/*::]*/:{/* n:"BrtBeginSlicerCacheSiRanges", */T:1},/*::[*/0x0445/*::]*/:{/* n:"BrtEndSlicerCacheSiRanges", */T:-1},/*::[*/0x0446/*::]*/:{/* n:"BrtBeginSlicerCacheSiRange", */T:1},/*::[*/0x0447/*::]*/:{/* n:"BrtEndSlicerCacheSiRange", */T:-1},/*::[*/0x0448/*::]*/:{/* n:"BrtSlicerCacheOlapItem" */},/*::[*/0x0449/*::]*/:{/* n:"BrtBeginSlicerCacheSelections", */T:1},/*::[*/0x044A/*::]*/:{/* n:"BrtSlicerCacheSelection" */},/*::[*/0x044B/*::]*/:{/* n:"BrtEndSlicerCacheSelections", */T:-1},/*::[*/0x044C/*::]*/:{/* n:"BrtBeginSlicerCacheNative", */T:1},/*::[*/0x044D/*::]*/:{/* n:"BrtEndSlicerCacheNative", */T:-1},/*::[*/0x044E/*::]*/:{/* n:"BrtSlicerCacheNativeItem" */},/*::[*/0x044F/*::]*/:{/* n:"BrtRangeProtection14" */},/*::[*/0x0450/*::]*/:{/* n:"BrtRangeProtectionIso14" */},/*::[*/0x0451/*::]*/:{/* n:"BrtCellIgnoreEC14" */},/*::[*/0x0457/*::]*/:{/* n:"BrtList14" */},/*::[*/0x0458/*::]*/:{/* n:"BrtCFIcon" */},/*::[*/0x0459/*::]*/:{/* n:"BrtBeginSlicerCachesPivotCacheIDs", */T:1},/*::[*/0x045A/*::]*/:{/* n:"BrtEndSlicerCachesPivotCacheIDs", */T:-1},/*::[*/0x045B/*::]*/:{/* n:"BrtBeginSlicers", */T:1},/*::[*/0x045C/*::]*/:{/* n:"BrtEndSlicers", */T:-1},/*::[*/0x045D/*::]*/:{/* n:"BrtWbProp14" */},/*::[*/0x045E/*::]*/:{/* n:"BrtBeginSXEdit", */T:1},/*::[*/0x045F/*::]*/:{/* n:"BrtEndSXEdit", */T:-1},/*::[*/0x0460/*::]*/:{/* n:"BrtBeginSXEdits", */T:1},/*::[*/0x0461/*::]*/:{/* n:"BrtEndSXEdits", */T:-1},/*::[*/0x0462/*::]*/:{/* n:"BrtBeginSXChange", */T:1},/*::[*/0x0463/*::]*/:{/* n:"BrtEndSXChange", */T:-1},/*::[*/0x0464/*::]*/:{/* n:"BrtBeginSXChanges", */T:1},/*::[*/0x0465/*::]*/:{/* n:"BrtEndSXChanges", */T:-1},/*::[*/0x0466/*::]*/:{/* n:"BrtSXTupleItems" */},/*::[*/0x0468/*::]*/:{/* n:"BrtBeginSlicerStyle", */T:1},/*::[*/0x0469/*::]*/:{/* n:"BrtEndSlicerStyle", */T:-1},/*::[*/0x046A/*::]*/:{/* n:"BrtSlicerStyleElement" */},/*::[*/0x046B/*::]*/:{/* n:"BrtBeginStyleSheetExt14", */T:1},/*::[*/0x046C/*::]*/:{/* n:"BrtEndStyleSheetExt14", */T:-1},/*::[*/0x046D/*::]*/:{/* n:"BrtBeginSlicerCachesPivotCacheID", */T:1},/*::[*/0x046E/*::]*/:{/* n:"BrtEndSlicerCachesPivotCacheID", */T:-1},/*::[*/0x046F/*::]*/:{/* n:"BrtBeginConditionalFormattings", */T:1},/*::[*/0x0470/*::]*/:{/* n:"BrtEndConditionalFormattings", */T:-1},/*::[*/0x0471/*::]*/:{/* n:"BrtBeginPCDCalcMemExt", */T:1},/*::[*/0x0472/*::]*/:{/* n:"BrtEndPCDCalcMemExt", */T:-1},/*::[*/0x0473/*::]*/:{/* n:"BrtBeginPCDCalcMemsExt", */T:1},/*::[*/0x0474/*::]*/:{/* n:"BrtEndPCDCalcMemsExt", */T:-1},/*::[*/0x0475/*::]*/:{/* n:"BrtPCDField14" */},/*::[*/0x0476/*::]*/:{/* n:"BrtBeginSlicerStyles", */T:1},/*::[*/0x0477/*::]*/:{/* n:"BrtEndSlicerStyles", */T:-1},/*::[*/0x0478/*::]*/:{/* n:"BrtBeginSlicerStyleElements", */T:1},/*::[*/0x0479/*::]*/:{/* n:"BrtEndSlicerStyleElements", */T:-1},/*::[*/0x047A/*::]*/:{/* n:"BrtCFRuleExt" */},/*::[*/0x047B/*::]*/:{/* n:"BrtBeginSXCondFmt14", */T:1},/*::[*/0x047C/*::]*/:{/* n:"BrtEndSXCondFmt14", */T:-1},/*::[*/0x047D/*::]*/:{/* n:"BrtBeginSXCondFmts14", */T:1},/*::[*/0x047E/*::]*/:{/* n:"BrtEndSXCondFmts14", */T:-1},/*::[*/0x0480/*::]*/:{/* n:"BrtBeginSortCond14", */T:1},/*::[*/0x0481/*::]*/:{/* n:"BrtEndSortCond14", */T:-1},/*::[*/0x0482/*::]*/:{/* n:"BrtEndDVals14", */T:-1},/*::[*/0x0483/*::]*/:{/* n:"BrtEndIconSet14", */T:-1},/*::[*/0x0484/*::]*/:{/* n:"BrtEndDatabar14", */T:-1},/*::[*/0x0485/*::]*/:{/* n:"BrtBeginColorScale14", */T:1},/*::[*/0x0486/*::]*/:{/* n:"BrtEndColorScale14", */T:-1},/*::[*/0x0487/*::]*/:{/* n:"BrtBeginSxrules14", */T:1},/*::[*/0x0488/*::]*/:{/* n:"BrtEndSxrules14", */T:-1},/*::[*/0x0489/*::]*/:{/* n:"BrtBeginPRule14", */T:1},/*::[*/0x048A/*::]*/:{/* n:"BrtEndPRule14", */T:-1},/*::[*/0x048B/*::]*/:{/* n:"BrtBeginPRFilters14", */T:1},/*::[*/0x048C/*::]*/:{/* n:"BrtEndPRFilters14", */T:-1},/*::[*/0x048D/*::]*/:{/* n:"BrtBeginPRFilter14", */T:1},/*::[*/0x048E/*::]*/:{/* n:"BrtEndPRFilter14", */T:-1},/*::[*/0x048F/*::]*/:{/* n:"BrtBeginPRFItem14", */T:1},/*::[*/0x0490/*::]*/:{/* n:"BrtEndPRFItem14", */T:-1},/*::[*/0x0491/*::]*/:{/* n:"BrtBeginCellIgnoreECs14", */T:1},/*::[*/0x0492/*::]*/:{/* n:"BrtEndCellIgnoreECs14", */T:-1},/*::[*/0x0493/*::]*/:{/* n:"BrtDxf14" */},/*::[*/0x0494/*::]*/:{/* n:"BrtBeginDxF14s", */T:1},/*::[*/0x0495/*::]*/:{/* n:"BrtEndDxf14s", */T:-1},/*::[*/0x0499/*::]*/:{/* n:"BrtFilter14" */},/*::[*/0x049A/*::]*/:{/* n:"BrtBeginCustomFilters14", */T:1},/*::[*/0x049C/*::]*/:{/* n:"BrtCustomFilter14" */},/*::[*/0x049D/*::]*/:{/* n:"BrtIconFilter14" */},/*::[*/0x049E/*::]*/:{/* n:"BrtPivotCacheConnectionName" */},/*::[*/0x0800/*::]*/:{/* n:"BrtBeginDecoupledPivotCacheIDs", */T:1},/*::[*/0x0801/*::]*/:{/* n:"BrtEndDecoupledPivotCacheIDs", */T:-1},/*::[*/0x0802/*::]*/:{/* n:"BrtDecoupledPivotCacheID" */},/*::[*/0x0803/*::]*/:{/* n:"BrtBeginPivotTableRefs", */T:1},/*::[*/0x0804/*::]*/:{/* n:"BrtEndPivotTableRefs", */T:-1},/*::[*/0x0805/*::]*/:{/* n:"BrtPivotTableRef" */},/*::[*/0x0806/*::]*/:{/* n:"BrtSlicerCacheBookPivotTables" */},/*::[*/0x0807/*::]*/:{/* n:"BrtBeginSxvcells", */T:1},/*::[*/0x0808/*::]*/:{/* n:"BrtEndSxvcells", */T:-1},/*::[*/0x0809/*::]*/:{/* n:"BrtBeginSxRow", */T:1},/*::[*/0x080A/*::]*/:{/* n:"BrtEndSxRow", */T:-1},/*::[*/0x080C/*::]*/:{/* n:"BrtPcdCalcMem15" */},/*::[*/0x0813/*::]*/:{/* n:"BrtQsi15" */},/*::[*/0x0814/*::]*/:{/* n:"BrtBeginWebExtensions", */T:1},/*::[*/0x0815/*::]*/:{/* n:"BrtEndWebExtensions", */T:-1},/*::[*/0x0816/*::]*/:{/* n:"BrtWebExtension" */},/*::[*/0x0817/*::]*/:{/* n:"BrtAbsPath15" */},/*::[*/0x0818/*::]*/:{/* n:"BrtBeginPivotTableUISettings", */T:1},/*::[*/0x0819/*::]*/:{/* n:"BrtEndPivotTableUISettings", */T:-1},/*::[*/0x081B/*::]*/:{/* n:"BrtTableSlicerCacheIDs" */},/*::[*/0x081C/*::]*/:{/* n:"BrtTableSlicerCacheID" */},/*::[*/0x081D/*::]*/:{/* n:"BrtBeginTableSlicerCache", */T:1},/*::[*/0x081E/*::]*/:{/* n:"BrtEndTableSlicerCache", */T:-1},/*::[*/0x081F/*::]*/:{/* n:"BrtSxFilter15" */},/*::[*/0x0820/*::]*/:{/* n:"BrtBeginTimelineCachePivotCacheIDs", */T:1},/*::[*/0x0821/*::]*/:{/* n:"BrtEndTimelineCachePivotCacheIDs", */T:-1},/*::[*/0x0822/*::]*/:{/* n:"BrtTimelineCachePivotCacheID" */},/*::[*/0x0823/*::]*/:{/* n:"BrtBeginTimelineCacheIDs", */T:1},/*::[*/0x0824/*::]*/:{/* n:"BrtEndTimelineCacheIDs", */T:-1},/*::[*/0x0825/*::]*/:{/* n:"BrtBeginTimelineCacheID", */T:1},/*::[*/0x0826/*::]*/:{/* n:"BrtEndTimelineCacheID", */T:-1},/*::[*/0x0827/*::]*/:{/* n:"BrtBeginTimelinesEx", */T:1},/*::[*/0x0828/*::]*/:{/* n:"BrtEndTimelinesEx", */T:-1},/*::[*/0x0829/*::]*/:{/* n:"BrtBeginTimelineEx", */T:1},/*::[*/0x082A/*::]*/:{/* n:"BrtEndTimelineEx", */T:-1},/*::[*/0x082B/*::]*/:{/* n:"BrtWorkBookPr15" */},/*::[*/0x082C/*::]*/:{/* n:"BrtPCDH15" */},/*::[*/0x082D/*::]*/:{/* n:"BrtBeginTimelineStyle", */T:1},/*::[*/0x082E/*::]*/:{/* n:"BrtEndTimelineStyle", */T:-1},/*::[*/0x082F/*::]*/:{/* n:"BrtTimelineStyleElement" */},/*::[*/0x0830/*::]*/:{/* n:"BrtBeginTimelineStylesheetExt15", */T:1},/*::[*/0x0831/*::]*/:{/* n:"BrtEndTimelineStylesheetExt15", */T:-1},/*::[*/0x0832/*::]*/:{/* n:"BrtBeginTimelineStyles", */T:1},/*::[*/0x0833/*::]*/:{/* n:"BrtEndTimelineStyles", */T:-1},/*::[*/0x0834/*::]*/:{/* n:"BrtBeginTimelineStyleElements", */T:1},/*::[*/0x0835/*::]*/:{/* n:"BrtEndTimelineStyleElements", */T:-1},/*::[*/0x0836/*::]*/:{/* n:"BrtDxf15" */},/*::[*/0x0837/*::]*/:{/* n:"BrtBeginDxfs15", */T:1},/*::[*/0x0838/*::]*/:{/* n:"BrtEndDxfs15", */T:-1},/*::[*/0x0839/*::]*/:{/* n:"BrtSlicerCacheHideItemsWithNoData" */},/*::[*/0x083A/*::]*/:{/* n:"BrtBeginItemUniqueNames", */T:1},/*::[*/0x083B/*::]*/:{/* n:"BrtEndItemUniqueNames", */T:-1},/*::[*/0x083C/*::]*/:{/* n:"BrtItemUniqueName" */},/*::[*/0x083D/*::]*/:{/* n:"BrtBeginExtConn15", */T:1},/*::[*/0x083E/*::]*/:{/* n:"BrtEndExtConn15", */T:-1},/*::[*/0x083F/*::]*/:{/* n:"BrtBeginOledbPr15", */T:1},/*::[*/0x0840/*::]*/:{/* n:"BrtEndOledbPr15", */T:-1},/*::[*/0x0841/*::]*/:{/* n:"BrtBeginDataFeedPr15", */T:1},/*::[*/0x0842/*::]*/:{/* n:"BrtEndDataFeedPr15", */T:-1},/*::[*/0x0843/*::]*/:{/* n:"BrtTextPr15" */},/*::[*/0x0844/*::]*/:{/* n:"BrtRangePr15" */},/*::[*/0x0845/*::]*/:{/* n:"BrtDbCommand15" */},/*::[*/0x0846/*::]*/:{/* n:"BrtBeginDbTables15", */T:1},/*::[*/0x0847/*::]*/:{/* n:"BrtEndDbTables15", */T:-1},/*::[*/0x0848/*::]*/:{/* n:"BrtDbTable15" */},/*::[*/0x0849/*::]*/:{/* n:"BrtBeginDataModel", */T:1},/*::[*/0x084A/*::]*/:{/* n:"BrtEndDataModel", */T:-1},/*::[*/0x084B/*::]*/:{/* n:"BrtBeginModelTables", */T:1},/*::[*/0x084C/*::]*/:{/* n:"BrtEndModelTables", */T:-1},/*::[*/0x084D/*::]*/:{/* n:"BrtModelTable" */},/*::[*/0x084E/*::]*/:{/* n:"BrtBeginModelRelationships", */T:1},/*::[*/0x084F/*::]*/:{/* n:"BrtEndModelRelationships", */T:-1},/*::[*/0x0850/*::]*/:{/* n:"BrtModelRelationship" */},/*::[*/0x0851/*::]*/:{/* n:"BrtBeginECTxtWiz15", */T:1},/*::[*/0x0852/*::]*/:{/* n:"BrtEndECTxtWiz15", */T:-1},/*::[*/0x0853/*::]*/:{/* n:"BrtBeginECTWFldInfoLst15", */T:1},/*::[*/0x0854/*::]*/:{/* n:"BrtEndECTWFldInfoLst15", */T:-1},/*::[*/0x0855/*::]*/:{/* n:"BrtBeginECTWFldInfo15", */T:1},/*::[*/0x0856/*::]*/:{/* n:"BrtFieldListActiveItem" */},/*::[*/0x0857/*::]*/:{/* n:"BrtPivotCacheIdVersion" */},/*::[*/0x0858/*::]*/:{/* n:"BrtSXDI15" */},/*::[*/0x0859/*::]*/:{/* n:"BrtBeginModelTimeGroupings", */T:1},/*::[*/0x085A/*::]*/:{/* n:"BrtEndModelTimeGroupings", */T:-1},/*::[*/0x085B/*::]*/:{/* n:"BrtBeginModelTimeGrouping", */T:1},/*::[*/0x085C/*::]*/:{/* n:"BrtEndModelTimeGrouping", */T:-1},/*::[*/0x085D/*::]*/:{/* n:"BrtModelTimeGroupingCalcCol" */},/*::[*/0x0C00/*::]*/:{/* n:"BrtUid" */},/*::[*/0x0C01/*::]*/:{/* n:"BrtRevisionPtr" */},/*::[*/0x1000/*::]*/:{/* n:"BrtBeginDynamicArrayPr", */T:1},/*::[*/0x1001/*::]*/:{/* n:"BrtEndDynamicArrayPr", */T:-1},/*::[*/0x138A/*::]*/:{/* n:"BrtBeginRichValueBlock", */T:1},/*::[*/0x138B/*::]*/:{/* n:"BrtEndRichValueBlock", */T:-1},/*::[*/0x13D9/*::]*/:{/* n:"BrtBeginRichFilters", */T:1},/*::[*/0x13DA/*::]*/:{/* n:"BrtEndRichFilters", */T:-1},/*::[*/0x13DB/*::]*/:{/* n:"BrtRichFilter" */},/*::[*/0x13DC/*::]*/:{/* n:"BrtBeginRichFilterColumn", */T:1},/*::[*/0x13DD/*::]*/:{/* n:"BrtEndRichFilterColumn", */T:-1},/*::[*/0x13DE/*::]*/:{/* n:"BrtBeginCustomRichFilters", */T:1},/*::[*/0x13DF/*::]*/:{/* n:"BrtEndCustomRichFilters", */T:-1},/*::[*/0x13E0/*::]*/:{/* n:"BrtCustomRichFilter" */},/*::[*/0x13E1/*::]*/:{/* n:"BrtTop10RichFilter" */},/*::[*/0x13E2/*::]*/:{/* n:"BrtDynamicRichFilter" */},/*::[*/0x13E4/*::]*/:{/* n:"BrtBeginRichSortCondition", */T:1},/*::[*/0x13E5/*::]*/:{/* n:"BrtEndRichSortCondition", */T:-1},/*::[*/0x13E6/*::]*/:{/* n:"BrtRichFilterDateGroupItem" */},/*::[*/0x13E7/*::]*/:{/* n:"BrtBeginCalcFeatures", */T:1},/*::[*/0x13E8/*::]*/:{/* n:"BrtEndCalcFeatures", */T:-1},/*::[*/0x13E9/*::]*/:{/* n:"BrtCalcFeature" */},/*::[*/0x13EB/*::]*/:{/* n:"BrtExternalLinksPr" */},/*::[*/0xFFFF/*::]*/:{n:""}};/* [MS-XLS] 2.3 Record Enumeration (and other sources) */var XLSRecordEnum={/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 *//*::[*/0x0006/*::]*/:{/* n:"Formula", */f:parse_Formula},/*::[*/0x000a/*::]*/:{/* n:"EOF", */f:parsenoop2},/*::[*/0x000c/*::]*/:{/* n:"CalcCount", */f:parseuint16},//
/*::[*/0x000d/*::]*/:{/* n:"CalcMode", */f:parseuint16},//
/*::[*/0x000e/*::]*/:{/* n:"CalcPrecision", */f:parsebool},//
/*::[*/0x000f/*::]*/:{/* n:"CalcRefMode", */f:parsebool},//
/*::[*/0x0010/*::]*/:{/* n:"CalcDelta", */f:parse_Xnum},//
/*::[*/0x0011/*::]*/:{/* n:"CalcIter", */f:parsebool},//
/*::[*/0x0012/*::]*/:{/* n:"Protect", */f:parsebool},/*::[*/0x0013/*::]*/:{/* n:"Password", */f:parseuint16},/*::[*/0x0014/*::]*/:{/* n:"Header", */f:parse_XLHeaderFooter},/*::[*/0x0015/*::]*/:{/* n:"Footer", */f:parse_XLHeaderFooter},/*::[*/0x0017/*::]*/:{/* n:"ExternSheet", */f:parse_ExternSheet},/*::[*/0x0018/*::]*/:{/* n:"Lbl", */f:parse_Lbl},/*::[*/0x0019/*::]*/:{/* n:"WinProtect", */f:parsebool},/*::[*/0x001a/*::]*/:{/* n:"VerticalPageBreaks", */},/*::[*/0x001b/*::]*/:{/* n:"HorizontalPageBreaks", */},/*::[*/0x001c/*::]*/:{/* n:"Note", */f:parse_Note},/*::[*/0x001d/*::]*/:{/* n:"Selection", */},/*::[*/0x0022/*::]*/:{/* n:"Date1904", */f:parsebool},/*::[*/0x0023/*::]*/:{/* n:"ExternName", */f:parse_ExternName},/*::[*/0x0026/*::]*/:{/* n:"LeftMargin", */f:parse_Xnum},// *
/*::[*/0x0027/*::]*/:{/* n:"RightMargin", */f:parse_Xnum},// *
/*::[*/0x0028/*::]*/:{/* n:"TopMargin", */f:parse_Xnum},// *
/*::[*/0x0029/*::]*/:{/* n:"BottomMargin", */f:parse_Xnum},// *
/*::[*/0x002a/*::]*/:{/* n:"PrintRowCol", */f:parsebool},/*::[*/0x002b/*::]*/:{/* n:"PrintGrid", */f:parsebool},/*::[*/0x002f/*::]*/:{/* n:"FilePass", */f:parse_FilePass},/*::[*/0x0031/*::]*/:{/* n:"Font", */f:parse_Font},/*::[*/0x0033/*::]*/:{/* n:"PrintSize", */f:parseuint16},/*::[*/0x003c/*::]*/:{/* n:"Continue", */},/*::[*/0x003d/*::]*/:{/* n:"Window1", */f:parse_Window1},/*::[*/0x0040/*::]*/:{/* n:"Backup", */f:parsebool},/*::[*/0x0041/*::]*/:{/* n:"Pane", */f:parse_Pane},/*::[*/0x0042/*::]*/:{/* n:"CodePage", */f:parseuint16},/*::[*/0x004d/*::]*/:{/* n:"Pls", */},/*::[*/0x0050/*::]*/:{/* n:"DCon", */},/*::[*/0x0051/*::]*/:{/* n:"DConRef", */},/*::[*/0x0052/*::]*/:{/* n:"DConName", */},/*::[*/0x0055/*::]*/:{/* n:"DefColWidth", */f:parseuint16},/*::[*/0x0059/*::]*/:{/* n:"XCT", */},/*::[*/0x005a/*::]*/:{/* n:"CRN", */},/*::[*/0x005b/*::]*/:{/* n:"FileSharing", */},/*::[*/0x005c/*::]*/:{/* n:"WriteAccess", */f:parse_WriteAccess},/*::[*/0x005d/*::]*/:{/* n:"Obj", */f:parse_Obj},/*::[*/0x005e/*::]*/:{/* n:"Uncalced", */},/*::[*/0x005f/*::]*/:{/* n:"CalcSaveRecalc", */f:parsebool},//
/*::[*/0x0060/*::]*/:{/* n:"Template", */},/*::[*/0x0061/*::]*/:{/* n:"Intl", */},/*::[*/0x0063/*::]*/:{/* n:"ObjProtect", */f:parsebool},/*::[*/0x007d/*::]*/:{/* n:"ColInfo", */f:parse_ColInfo},/*::[*/0x0080/*::]*/:{/* n:"Guts", */f:parse_Guts},/*::[*/0x0081/*::]*/:{/* n:"WsBool", */f:parse_WsBool},/*::[*/0x0082/*::]*/:{/* n:"GridSet", */f:parseuint16},/*::[*/0x0083/*::]*/:{/* n:"HCenter", */f:parsebool},/*::[*/0x0084/*::]*/:{/* n:"VCenter", */f:parsebool},/*::[*/0x0085/*::]*/:{/* n:"BoundSheet8", */f:parse_BoundSheet8},/*::[*/0x0086/*::]*/:{/* n:"WriteProtect", */},/*::[*/0x008c/*::]*/:{/* n:"Country", */f:parse_Country},/*::[*/0x008d/*::]*/:{/* n:"HideObj", */f:parseuint16},/*::[*/0x0090/*::]*/:{/* n:"Sort", */},/*::[*/0x0092/*::]*/:{/* n:"Palette", */f:parse_Palette},/*::[*/0x0097/*::]*/:{/* n:"Sync", */},/*::[*/0x0098/*::]*/:{/* n:"LPr", */},/*::[*/0x0099/*::]*/:{/* n:"DxGCol", */},/*::[*/0x009a/*::]*/:{/* n:"FnGroupName", */},/*::[*/0x009b/*::]*/:{/* n:"FilterMode", */},/*::[*/0x009c/*::]*/:{/* n:"BuiltInFnGroupCount", */f:parseuint16},/*::[*/0x009d/*::]*/:{/* n:"AutoFilterInfo", */},/*::[*/0x009e/*::]*/:{/* n:"AutoFilter", */},/*::[*/0x00a0/*::]*/:{/* n:"Scl", */f:parse_Scl},/*::[*/0x00a1/*::]*/:{/* n:"Setup", */f:parse_Setup},/*::[*/0x00ae/*::]*/:{/* n:"ScenMan", */},/*::[*/0x00af/*::]*/:{/* n:"SCENARIO", */},/*::[*/0x00b0/*::]*/:{/* n:"SxView", */},/*::[*/0x00b1/*::]*/:{/* n:"Sxvd", */},/*::[*/0x00b2/*::]*/:{/* n:"SXVI", */},/*::[*/0x00b4/*::]*/:{/* n:"SxIvd", */},/*::[*/0x00b5/*::]*/:{/* n:"SXLI", */},/*::[*/0x00b6/*::]*/:{/* n:"SXPI", */},/*::[*/0x00b8/*::]*/:{/* n:"DocRoute", */},/*::[*/0x00b9/*::]*/:{/* n:"RecipName", */},/*::[*/0x00bd/*::]*/:{/* n:"MulRk", */f:parse_MulRk},/*::[*/0x00be/*::]*/:{/* n:"MulBlank", */f:parse_MulBlank},/*::[*/0x00c1/*::]*/:{/* n:"Mms", */f:parsenoop2},/*::[*/0x00c5/*::]*/:{/* n:"SXDI", */},/*::[*/0x00c6/*::]*/:{/* n:"SXDB", */},/*::[*/0x00c7/*::]*/:{/* n:"SXFDB", */},/*::[*/0x00c8/*::]*/:{/* n:"SXDBB", */},/*::[*/0x00c9/*::]*/:{/* n:"SXNum", */},/*::[*/0x00ca/*::]*/:{/* n:"SxBool", */f:parsebool},/*::[*/0x00cb/*::]*/:{/* n:"SxErr", */},/*::[*/0x00cc/*::]*/:{/* n:"SXInt", */},/*::[*/0x00cd/*::]*/:{/* n:"SXString", */},/*::[*/0x00ce/*::]*/:{/* n:"SXDtr", */},/*::[*/0x00cf/*::]*/:{/* n:"SxNil", */},/*::[*/0x00d0/*::]*/:{/* n:"SXTbl", */},/*::[*/0x00d1/*::]*/:{/* n:"SXTBRGIITM", */},/*::[*/0x00d2/*::]*/:{/* n:"SxTbpg", */},/*::[*/0x00d3/*::]*/:{/* n:"ObProj", */},/*::[*/0x00d5/*::]*/:{/* n:"SXStreamID", */},/*::[*/0x00d7/*::]*/:{/* n:"DBCell", */},/*::[*/0x00d8/*::]*/:{/* n:"SXRng", */},/*::[*/0x00d9/*::]*/:{/* n:"SxIsxoper", */},/*::[*/0x00da/*::]*/:{/* n:"BookBool", */f:parseuint16},/*::[*/0x00dc/*::]*/:{/* n:"DbOrParamQry", */},/*::[*/0x00dd/*::]*/:{/* n:"ScenarioProtect", */f:parsebool},/*::[*/0x00de/*::]*/:{/* n:"OleObjectSize", */},/*::[*/0x00e0/*::]*/:{/* n:"XF", */f:parse_XF},/*::[*/0x00e1/*::]*/:{/* n:"InterfaceHdr", */f:parse_InterfaceHdr},/*::[*/0x00e2/*::]*/:{/* n:"InterfaceEnd", */f:parsenoop2},/*::[*/0x00e3/*::]*/:{/* n:"SXVS", */},/*::[*/0x00e5/*::]*/:{/* n:"MergeCells", */f:parse_MergeCells},/*::[*/0x00e9/*::]*/:{/* n:"BkHim", */},/*::[*/0x00eb/*::]*/:{/* n:"MsoDrawingGroup", */},/*::[*/0x00ec/*::]*/:{/* n:"MsoDrawing", */},/*::[*/0x00ed/*::]*/:{/* n:"MsoDrawingSelection", */},/*::[*/0x00ef/*::]*/:{/* n:"PhoneticInfo", */},/*::[*/0x00f0/*::]*/:{/* n:"SxRule", */},/*::[*/0x00f1/*::]*/:{/* n:"SXEx", */},/*::[*/0x00f2/*::]*/:{/* n:"SxFilt", */},/*::[*/0x00f4/*::]*/:{/* n:"SxDXF", */},/*::[*/0x00f5/*::]*/:{/* n:"SxItm", */},/*::[*/0x00f6/*::]*/:{/* n:"SxName", */},/*::[*/0x00f7/*::]*/:{/* n:"SxSelect", */},/*::[*/0x00f8/*::]*/:{/* n:"SXPair", */},/*::[*/0x00f9/*::]*/:{/* n:"SxFmla", */},/*::[*/0x00fb/*::]*/:{/* n:"SxFormat", */},/*::[*/0x00fc/*::]*/:{/* n:"SST", */f:parse_SST},/*::[*/0x00fd/*::]*/:{/* n:"LabelSst", */f:parse_LabelSst},/*::[*/0x00ff/*::]*/:{/* n:"ExtSST", */f:parse_ExtSST},/*::[*/0x0100/*::]*/:{/* n:"SXVDEx", */},/*::[*/0x0103/*::]*/:{/* n:"SXFormula", */},/*::[*/0x0122/*::]*/:{/* n:"SXDBEx", */},/*::[*/0x0137/*::]*/:{/* n:"RRDInsDel", */},/*::[*/0x0138/*::]*/:{/* n:"RRDHead", */},/*::[*/0x013b/*::]*/:{/* n:"RRDChgCell", */},/*::[*/0x013d/*::]*/:{/* n:"RRTabId", */f:parseuint16a},/*::[*/0x013e/*::]*/:{/* n:"RRDRenSheet", */},/*::[*/0x013f/*::]*/:{/* n:"RRSort", */},/*::[*/0x0140/*::]*/:{/* n:"RRDMove", */},/*::[*/0x014a/*::]*/:{/* n:"RRFormat", */},/*::[*/0x014b/*::]*/:{/* n:"RRAutoFmt", */},/*::[*/0x014d/*::]*/:{/* n:"RRInsertSh", */},/*::[*/0x014e/*::]*/:{/* n:"RRDMoveBegin", */},/*::[*/0x014f/*::]*/:{/* n:"RRDMoveEnd", */},/*::[*/0x0150/*::]*/:{/* n:"RRDInsDelBegin", */},/*::[*/0x0151/*::]*/:{/* n:"RRDInsDelEnd", */},/*::[*/0x0152/*::]*/:{/* n:"RRDConflict", */},/*::[*/0x0153/*::]*/:{/* n:"RRDDefName", */},/*::[*/0x0154/*::]*/:{/* n:"RRDRstEtxp", */},/*::[*/0x015f/*::]*/:{/* n:"LRng", */},/*::[*/0x0160/*::]*/:{/* n:"UsesELFs", */f:parsebool},/*::[*/0x0161/*::]*/:{/* n:"DSF", */f:parsenoop2},/*::[*/0x0191/*::]*/:{/* n:"CUsr", */},/*::[*/0x0192/*::]*/:{/* n:"CbUsr", */},/*::[*/0x0193/*::]*/:{/* n:"UsrInfo", */},/*::[*/0x0194/*::]*/:{/* n:"UsrExcl", */},/*::[*/0x0195/*::]*/:{/* n:"FileLock", */},/*::[*/0x0196/*::]*/:{/* n:"RRDInfo", */},/*::[*/0x0197/*::]*/:{/* n:"BCUsrs", */},/*::[*/0x0198/*::]*/:{/* n:"UsrChk", */},/*::[*/0x01a9/*::]*/:{/* n:"UserBView", */},/*::[*/0x01aa/*::]*/:{/* n:"UserSViewBegin", */},/*::[*/0x01ab/*::]*/:{/* n:"UserSViewEnd", */},/*::[*/0x01ac/*::]*/:{/* n:"RRDUserView", */},/*::[*/0x01ad/*::]*/:{/* n:"Qsi", */},/*::[*/0x01ae/*::]*/:{/* n:"SupBook", */f:parse_SupBook},/*::[*/0x01af/*::]*/:{/* n:"Prot4Rev", */f:parsebool},/*::[*/0x01b0/*::]*/:{/* n:"CondFmt", */},/*::[*/0x01b1/*::]*/:{/* n:"CF", */},/*::[*/0x01b2/*::]*/:{/* n:"DVal", */},/*::[*/0x01b5/*::]*/:{/* n:"DConBin", */},/*::[*/0x01b6/*::]*/:{/* n:"TxO", */f:parse_TxO},/*::[*/0x01b7/*::]*/:{/* n:"RefreshAll", */f:parsebool},//
/*::[*/0x01b8/*::]*/:{/* n:"HLink", */f:parse_HLink},/*::[*/0x01b9/*::]*/:{/* n:"Lel", */},/*::[*/0x01ba/*::]*/:{/* n:"CodeName", */f:parse_XLUnicodeString},/*::[*/0x01bb/*::]*/:{/* n:"SXFDBType", */},/*::[*/0x01bc/*::]*/:{/* n:"Prot4RevPass", */f:parseuint16},/*::[*/0x01bd/*::]*/:{/* n:"ObNoMacros", */},/*::[*/0x01be/*::]*/:{/* n:"Dv", */},/*::[*/0x01c0/*::]*/:{/* n:"Excel9File", */f:parsenoop2},/*::[*/0x01c1/*::]*/:{/* n:"RecalcId", */f:parse_RecalcId,r:2},/*::[*/0x01c2/*::]*/:{/* n:"EntExU2", */f:parsenoop2},/*::[*/0x0200/*::]*/:{/* n:"Dimensions", */f:parse_Dimensions},/*::[*/0x0201/*::]*/:{/* n:"Blank", */f:parse_Blank},/*::[*/0x0203/*::]*/:{/* n:"Number", */f:parse_Number},/*::[*/0x0204/*::]*/:{/* n:"Label", */f:parse_Label},/*::[*/0x0205/*::]*/:{/* n:"BoolErr", */f:parse_BoolErr},/*::[*/0x0207/*::]*/:{/* n:"String", */f:parse_String},/*::[*/0x0208/*::]*/:{/* n:"Row", */f:parse_Row},/*::[*/0x020b/*::]*/:{/* n:"Index", */},/*::[*/0x0221/*::]*/:{/* n:"Array", */f:parse_Array},/*::[*/0x0225/*::]*/:{/* n:"DefaultRowHeight", */f:parse_DefaultRowHeight},/*::[*/0x0236/*::]*/:{/* n:"Table", */},/*::[*/0x023e/*::]*/:{/* n:"Window2", */f:parse_Window2},/*::[*/0x027e/*::]*/:{/* n:"RK", */f:parse_RK},/*::[*/0x0293/*::]*/:{/* n:"Style", */},/*::[*/0x0418/*::]*/:{/* n:"BigName", */},/*::[*/0x041e/*::]*/:{/* n:"Format", */f:parse_Format},/*::[*/0x043c/*::]*/:{/* n:"ContinueBigName", */},/*::[*/0x04bc/*::]*/:{/* n:"ShrFmla", */f:parse_ShrFmla},/*::[*/0x0800/*::]*/:{/* n:"HLinkTooltip", */f:parse_HLinkTooltip},/*::[*/0x0801/*::]*/:{/* n:"WebPub", */},/*::[*/0x0802/*::]*/:{/* n:"QsiSXTag", */},/*::[*/0x0803/*::]*/:{/* n:"DBQueryExt", */},/*::[*/0x0804/*::]*/:{/* n:"ExtString", */},/*::[*/0x0805/*::]*/:{/* n:"TxtQry", */},/*::[*/0x0806/*::]*/:{/* n:"Qsir", */},/*::[*/0x0807/*::]*/:{/* n:"Qsif", */},/*::[*/0x0808/*::]*/:{/* n:"RRDTQSIF", */},/*::[*/0x0809/*::]*/:{/* n:"BOF", */f:parse_BOF},/*::[*/0x080a/*::]*/:{/* n:"OleDbConn", */},/*::[*/0x080b/*::]*/:{/* n:"WOpt", */},/*::[*/0x080c/*::]*/:{/* n:"SXViewEx", */},/*::[*/0x080d/*::]*/:{/* n:"SXTH", */},/*::[*/0x080e/*::]*/:{/* n:"SXPIEx", */},/*::[*/0x080f/*::]*/:{/* n:"SXVDTEx", */},/*::[*/0x0810/*::]*/:{/* n:"SXViewEx9", */},/*::[*/0x0812/*::]*/:{/* n:"ContinueFrt", */},/*::[*/0x0813/*::]*/:{/* n:"RealTimeData", */},/*::[*/0x0850/*::]*/:{/* n:"ChartFrtInfo", */},/*::[*/0x0851/*::]*/:{/* n:"FrtWrapper", */},/*::[*/0x0852/*::]*/:{/* n:"StartBlock", */},/*::[*/0x0853/*::]*/:{/* n:"EndBlock", */},/*::[*/0x0854/*::]*/:{/* n:"StartObject", */},/*::[*/0x0855/*::]*/:{/* n:"EndObject", */},/*::[*/0x0856/*::]*/:{/* n:"CatLab", */},/*::[*/0x0857/*::]*/:{/* n:"YMult", */},/*::[*/0x0858/*::]*/:{/* n:"SXViewLink", */},/*::[*/0x0859/*::]*/:{/* n:"PivotChartBits", */},/*::[*/0x085a/*::]*/:{/* n:"FrtFontList", */},/*::[*/0x0862/*::]*/:{/* n:"SheetExt", */},/*::[*/0x0863/*::]*/:{/* n:"BookExt", */r:12},/*::[*/0x0864/*::]*/:{/* n:"SXAddl", */},/*::[*/0x0865/*::]*/:{/* n:"CrErr", */},/*::[*/0x0866/*::]*/:{/* n:"HFPicture", */},/*::[*/0x0867/*::]*/:{/* n:"FeatHdr", */f:parsenoop2},/*::[*/0x0868/*::]*/:{/* n:"Feat", */},/*::[*/0x086a/*::]*/:{/* n:"DataLabExt", */},/*::[*/0x086b/*::]*/:{/* n:"DataLabExtContents", */},/*::[*/0x086c/*::]*/:{/* n:"CellWatch", */},/*::[*/0x0871/*::]*/:{/* n:"FeatHdr11", */},/*::[*/0x0872/*::]*/:{/* n:"Feature11", */},/*::[*/0x0874/*::]*/:{/* n:"DropDownObjIds", */},/*::[*/0x0875/*::]*/:{/* n:"ContinueFrt11", */},/*::[*/0x0876/*::]*/:{/* n:"DConn", */},/*::[*/0x0877/*::]*/:{/* n:"List12", */},/*::[*/0x0878/*::]*/:{/* n:"Feature12", */},/*::[*/0x0879/*::]*/:{/* n:"CondFmt12", */},/*::[*/0x087a/*::]*/:{/* n:"CF12", */},/*::[*/0x087b/*::]*/:{/* n:"CFEx", */},/*::[*/0x087c/*::]*/:{/* n:"XFCRC", */f:parse_XFCRC,r:12},/*::[*/0x087d/*::]*/:{/* n:"XFExt", */f:parse_XFExt,r:12},/*::[*/0x087e/*::]*/:{/* n:"AutoFilter12", */},/*::[*/0x087f/*::]*/:{/* n:"ContinueFrt12", */},/*::[*/0x0884/*::]*/:{/* n:"MDTInfo", */},/*::[*/0x0885/*::]*/:{/* n:"MDXStr", */},/*::[*/0x0886/*::]*/:{/* n:"MDXTuple", */},/*::[*/0x0887/*::]*/:{/* n:"MDXSet", */},/*::[*/0x0888/*::]*/:{/* n:"MDXProp", */},/*::[*/0x0889/*::]*/:{/* n:"MDXKPI", */},/*::[*/0x088a/*::]*/:{/* n:"MDB", */},/*::[*/0x088b/*::]*/:{/* n:"PLV", */},/*::[*/0x088c/*::]*/:{/* n:"Compat12", */f:parsebool,r:12},/*::[*/0x088d/*::]*/:{/* n:"DXF", */},/*::[*/0x088e/*::]*/:{/* n:"TableStyles", */r:12},/*::[*/0x088f/*::]*/:{/* n:"TableStyle", */},/*::[*/0x0890/*::]*/:{/* n:"TableStyleElement", */},/*::[*/0x0892/*::]*/:{/* n:"StyleExt", */},/*::[*/0x0893/*::]*/:{/* n:"NamePublish", */},/*::[*/0x0894/*::]*/:{/* n:"NameCmt", */f:parse_NameCmt,r:12},/*::[*/0x0895/*::]*/:{/* n:"SortData", */},/*::[*/0x0896/*::]*/:{/* n:"Theme", */f:parse_Theme,r:12},/*::[*/0x0897/*::]*/:{/* n:"GUIDTypeLib", */},/*::[*/0x0898/*::]*/:{/* n:"FnGrp12", */},/*::[*/0x0899/*::]*/:{/* n:"NameFnGrp12", */},/*::[*/0x089a/*::]*/:{/* n:"MTRSettings", */f:parse_MTRSettings,r:12},/*::[*/0x089b/*::]*/:{/* n:"CompressPictures", */f:parsenoop2},/*::[*/0x089c/*::]*/:{/* n:"HeaderFooter", */},/*::[*/0x089d/*::]*/:{/* n:"CrtLayout12", */},/*::[*/0x089e/*::]*/:{/* n:"CrtMlFrt", */},/*::[*/0x089f/*::]*/:{/* n:"CrtMlFrtContinue", */},/*::[*/0x08a3/*::]*/:{/* n:"ForceFullCalculation", */f:parse_ForceFullCalculation},/*::[*/0x08a4/*::]*/:{/* n:"ShapePropsStream", */},/*::[*/0x08a5/*::]*/:{/* n:"TextPropsStream", */},/*::[*/0x08a6/*::]*/:{/* n:"RichTextStream", */},/*::[*/0x08a7/*::]*/:{/* n:"CrtLayout12A", */},/*::[*/0x1001/*::]*/:{/* n:"Units", */},/*::[*/0x1002/*::]*/:{/* n:"Chart", */},/*::[*/0x1003/*::]*/:{/* n:"Series", */},/*::[*/0x1006/*::]*/:{/* n:"DataFormat", */},/*::[*/0x1007/*::]*/:{/* n:"LineFormat", */},/*::[*/0x1009/*::]*/:{/* n:"MarkerFormat", */},/*::[*/0x100a/*::]*/:{/* n:"AreaFormat", */},/*::[*/0x100b/*::]*/:{/* n:"PieFormat", */},/*::[*/0x100c/*::]*/:{/* n:"AttachedLabel", */},/*::[*/0x100d/*::]*/:{/* n:"SeriesText", */},/*::[*/0x1014/*::]*/:{/* n:"ChartFormat", */},/*::[*/0x1015/*::]*/:{/* n:"Legend", */},/*::[*/0x1016/*::]*/:{/* n:"SeriesList", */},/*::[*/0x1017/*::]*/:{/* n:"Bar", */},/*::[*/0x1018/*::]*/:{/* n:"Line", */},/*::[*/0x1019/*::]*/:{/* n:"Pie", */},/*::[*/0x101a/*::]*/:{/* n:"Area", */},/*::[*/0x101b/*::]*/:{/* n:"Scatter", */},/*::[*/0x101c/*::]*/:{/* n:"CrtLine", */},/*::[*/0x101d/*::]*/:{/* n:"Axis", */},/*::[*/0x101e/*::]*/:{/* n:"Tick", */},/*::[*/0x101f/*::]*/:{/* n:"ValueRange", */},/*::[*/0x1020/*::]*/:{/* n:"CatSerRange", */},/*::[*/0x1021/*::]*/:{/* n:"AxisLine", */},/*::[*/0x1022/*::]*/:{/* n:"CrtLink", */},/*::[*/0x1024/*::]*/:{/* n:"DefaultText", */},/*::[*/0x1025/*::]*/:{/* n:"Text", */},/*::[*/0x1026/*::]*/:{/* n:"FontX", */f:parseuint16},/*::[*/0x1027/*::]*/:{/* n:"ObjectLink", */},/*::[*/0x1032/*::]*/:{/* n:"Frame", */},/*::[*/0x1033/*::]*/:{/* n:"Begin", */},/*::[*/0x1034/*::]*/:{/* n:"End", */},/*::[*/0x1035/*::]*/:{/* n:"PlotArea", */},/*::[*/0x103a/*::]*/:{/* n:"Chart3d", */},/*::[*/0x103c/*::]*/:{/* n:"PicF", */},/*::[*/0x103d/*::]*/:{/* n:"DropBar", */},/*::[*/0x103e/*::]*/:{/* n:"Radar", */},/*::[*/0x103f/*::]*/:{/* n:"Surf", */},/*::[*/0x1040/*::]*/:{/* n:"RadarArea", */},/*::[*/0x1041/*::]*/:{/* n:"AxisParent", */},/*::[*/0x1043/*::]*/:{/* n:"LegendException", */},/*::[*/0x1044/*::]*/:{/* n:"ShtProps", */f:parse_ShtProps},/*::[*/0x1045/*::]*/:{/* n:"SerToCrt", */},/*::[*/0x1046/*::]*/:{/* n:"AxesUsed", */},/*::[*/0x1048/*::]*/:{/* n:"SBaseRef", */},/*::[*/0x104a/*::]*/:{/* n:"SerParent", */},/*::[*/0x104b/*::]*/:{/* n:"SerAuxTrend", */},/*::[*/0x104e/*::]*/:{/* n:"IFmtRecord", */},/*::[*/0x104f/*::]*/:{/* n:"Pos", */},/*::[*/0x1050/*::]*/:{/* n:"AlRuns", */},/*::[*/0x1051/*::]*/:{/* n:"BRAI", */},/*::[*/0x105b/*::]*/:{/* n:"SerAuxErrBar", */},/*::[*/0x105c/*::]*/:{/* n:"ClrtClient", */f:parse_ClrtClient},/*::[*/0x105d/*::]*/:{/* n:"SerFmt", */},/*::[*/0x105f/*::]*/:{/* n:"Chart3DBarShape", */},/*::[*/0x1060/*::]*/:{/* n:"Fbi", */},/*::[*/0x1061/*::]*/:{/* n:"BopPop", */},/*::[*/0x1062/*::]*/:{/* n:"AxcExt", */},/*::[*/0x1063/*::]*/:{/* n:"Dat", */},/*::[*/0x1064/*::]*/:{/* n:"PlotGrowth", */},/*::[*/0x1065/*::]*/:{/* n:"SIIndex", */},/*::[*/0x1066/*::]*/:{/* n:"GelFrame", */},/*::[*/0x1067/*::]*/:{/* n:"BopPopCustom", */},/*::[*/0x1068/*::]*/:{/* n:"Fbi2", */},/*::[*/0x0000/*::]*/:{/* n:"Dimensions", */f:parse_Dimensions},/*::[*/0x0001/*::]*/:{/* n:"BIFF2BLANK", */},/*::[*/0x0002/*::]*/:{/* n:"BIFF2INT", */f:parse_BIFF2INT},/*::[*/0x0003/*::]*/:{/* n:"BIFF2NUM", */f:parse_BIFF2NUM},/*::[*/0x0004/*::]*/:{/* n:"BIFF2STR", */f:parse_BIFF2STR},/*::[*/0x0005/*::]*/:{/* n:"BoolErr", */f:parse_BoolErr},/*::[*/0x0007/*::]*/:{/* n:"String", */f:parse_BIFF2STRING},/*::[*/0x0008/*::]*/:{/* n:"BIFF2ROW", */},/*::[*/0x0009/*::]*/:{/* n:"BOF", */f:parse_BOF},/*::[*/0x000b/*::]*/:{/* n:"Index", */},/*::[*/0x0016/*::]*/:{/* n:"ExternCount", */f:parseuint16},/*::[*/0x001e/*::]*/:{/* n:"BIFF2FORMAT", */f:parse_BIFF2Format},/*::[*/0x001f/*::]*/:{/* n:"BIFF2FMTCNT", */},/* 16-bit cnt of BIFF2FORMAT records *//*::[*/0x0020/*::]*/:{/* n:"BIFF2COLINFO", */},/*::[*/0x0021/*::]*/:{/* n:"Array", */f:parse_Array},/*::[*/0x0024/*::]*/:{/* n:"COLWIDTH", */},/*::[*/0x0025/*::]*/:{/* n:"DefaultRowHeight", */f:parse_DefaultRowHeight},// 0x2c ??
// 0x2d ??
// 0x2e ??
// 0x30 FONTCOUNT: number of fonts
/*::[*/0x0032/*::]*/:{/* n:"BIFF2FONTXTRA", */f:parse_BIFF2FONTXTRA},// 0x35: INFOOPTS
// 0x36: TABLE (BIFF2 only)
// 0x37: TABLE2 (BIFF2 only)
// 0x38: WNDESK
// 0x39 ??
// 0x3a: BEGINPREF
// 0x3b: ENDPREF
/*::[*/0x003e/*::]*/:{/* n:"BIFF2WINDOW2", */},// 0x3f ??
// 0x46: SHOWSCROLL
// 0x47: SHOWFORMULA
// 0x48: STATUSBAR
// 0x49: SHORTMENUS
// 0x4A:
// 0x4B:
// 0x4C:
// 0x4E:
// 0x4F:
// 0x58: TOOLBAR (BIFF3)
/* - - - *//*::[*/0x0034/*::]*/:{/* n:"DDEObjName", */},/*::[*/0x0043/*::]*/:{/* n:"BIFF2XF", */},/*::[*/0x0044/*::]*/:{/* n:"BIFF2XFINDEX", */f:parseuint16},/*::[*/0x0045/*::]*/:{/* n:"BIFF2FONTCLR", */},/*::[*/0x0056/*::]*/:{/* n:"BIFF4FMTCNT", */},/* 16-bit cnt, similar to BIFF2 *//*::[*/0x007e/*::]*/:{/* n:"RK", */},/* Not necessarily same as 0x027e *//*::[*/0x007f/*::]*/:{/* n:"ImData", */f:parse_ImData},/*::[*/0x0087/*::]*/:{/* n:"Addin", */},/*::[*/0x0088/*::]*/:{/* n:"Edg", */},/*::[*/0x0089/*::]*/:{/* n:"Pub", */},// 0x8A
// 0x8B LH: alternate menu key flag (BIFF3/4)
// 0x8E
// 0x8F
/*::[*/0x0091/*::]*/:{/* n:"Sub", */},// 0x93 STYLE
/*::[*/0x0094/*::]*/:{/* n:"LHRecord", */},/*::[*/0x0095/*::]*/:{/* n:"LHNGraph", */},/*::[*/0x0096/*::]*/:{/* n:"Sound", */},// 0xA2 FNPROTO: function prototypes (BIFF4)
// 0xA3
// 0xA8
/*::[*/0x00a9/*::]*/:{/* n:"CoordList", */},/*::[*/0x00ab/*::]*/:{/* n:"GCW", */},/*::[*/0x00bc/*::]*/:{/* n:"ShrFmla", */},/* Not necessarily same as 0x04bc *//*::[*/0x00bf/*::]*/:{/* n:"ToolbarHdr", */},/*::[*/0x00c0/*::]*/:{/* n:"ToolbarEnd", */},/*::[*/0x00c2/*::]*/:{/* n:"AddMenu", */},/*::[*/0x00c3/*::]*/:{/* n:"DelMenu", */},/*::[*/0x00d6/*::]*/:{/* n:"RString", */f:parse_RString},/*::[*/0x00df/*::]*/:{/* n:"UDDesc", */},/*::[*/0x00ea/*::]*/:{/* n:"TabIdConf", */},/*::[*/0x0162/*::]*/:{/* n:"XL5Modify", */},/*::[*/0x01a5/*::]*/:{/* n:"FileSharing2", */},/*::[*/0x0206/*::]*/:{/* n:"Formula", */f:parse_Formula},/*::[*/0x0209/*::]*/:{/* n:"BOF", */f:parse_BOF},/*::[*/0x0218/*::]*/:{/* n:"Lbl", */f:parse_Lbl},/*::[*/0x0223/*::]*/:{/* n:"ExternName", */f:parse_ExternName},/*::[*/0x0231/*::]*/:{/* n:"Font", */},/*::[*/0x0243/*::]*/:{/* n:"BIFF3XF", */},/*::[*/0x0406/*::]*/:{/* n:"Formula", */f:parse_Formula},/*::[*/0x0409/*::]*/:{/* n:"BOF", */f:parse_BOF},/*::[*/0x0443/*::]*/:{/* n:"BIFF4XF", */},/*::[*/0x086d/*::]*/:{/* n:"FeatInfo", */},/*::[*/0x0873/*::]*/:{/* n:"FeatInfo11", */},/*::[*/0x0881/*::]*/:{/* n:"SXAddl12", */},/*::[*/0x08c0/*::]*/:{/* n:"AutoWebPub", */},/*::[*/0x08c1/*::]*/:{/* n:"ListObj", */},/*::[*/0x08c2/*::]*/:{/* n:"ListField", */},/*::[*/0x08c3/*::]*/:{/* n:"ListDV", */},/*::[*/0x08c4/*::]*/:{/* n:"ListCondFmt", */},/*::[*/0x08c5/*::]*/:{/* n:"ListCF", */},/*::[*/0x08c6/*::]*/:{/* n:"FMQry", */},/*::[*/0x08c7/*::]*/:{/* n:"FMSQry", */},/*::[*/0x08c8/*::]*/:{/* n:"PLV", */},/*::[*/0x08c9/*::]*/:{/* n:"LnExt", */},/*::[*/0x08ca/*::]*/:{/* n:"MkrExt", */},/*::[*/0x08cb/*::]*/:{/* n:"CrtCoopt", */},/*::[*/0x08d6/*::]*/:{/* n:"FRTArchId$", */r:12},/*::[*/0x7262/*::]*/:{}};function write_biff_rec(ba/*:BufArray*/,type/*:number*/,payload,length/*:?number*/)/*:void*/{var t/*:number*/=type;if(isNaN(t))return;var len=length||(payload||[]).length||0;var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,len);if(/*:: len != null &&*/len>0&&is_buf(payload))ba.push(payload);}function write_biff_continue(ba/*:BufArray*/,type/*:number*/,payload,length/*:?number*/)/*:void*/{var len=length||(payload||[]).length||0;if(len<=8224)return write_biff_rec(ba,type,payload,len);var t=type;if(isNaN(t))return;var parts=payload.parts||[],sidx=0;var i=0,w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}var o=ba.next(4);o.write_shift(2,t);o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;while(i<len){o=ba.next(4);o.write_shift(2,0x3c);// TODO: figure out correct continue type
w=0;while(w+(parts[sidx]||8224)<=8224){w+=parts[sidx]||8224;sidx++;}o.write_shift(2,w);ba.push(payload.slice(i,i+w));i+=w;}}function write_BIFF2Cell(out,r/*:number*/,c/*:number*/){if(!out)out=new_buf(7);out.write_shift(2,r);out.write_shift(2,c);out.write_shift(2,0);out.write_shift(1,0);return out;}function write_BIFF2BERR(r/*:number*/,c/*:number*/,val,t/*:?string*/){var out=new_buf(9);write_BIFF2Cell(out,r,c);write_Bes(val,t||'b',out);return out;}/* TODO: codepage, large strings */function write_BIFF2LABEL(r/*:number*/,c/*:number*/,val){var out=new_buf(8+2*val.length);write_BIFF2Cell(out,r,c);out.write_shift(1,val.length);out.write_shift(val.length,val,'sbcs');return out.l<out.length?out.slice(0,out.l):out;}function write_ws_biff2_cell(ba/*:BufArray*/,cell/*:Cell*/,R/*:number*/,C/*:number*//*::, opts*/){if(cell.v!=null)switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;if(v==(v|0)&&v>=0&&v<65536)write_biff_rec(ba,0x0002,write_BIFF2INT(R,C,v));else write_biff_rec(ba,0x0003,write_BIFF2NUM(R,C,v));return;case'b':case'e':write_biff_rec(ba,0x0005,write_BIFF2BERR(R,C,cell.v,cell.t));return;/* TODO: codepage, sst */case's':case'str':write_biff_rec(ba,0x0004,write_BIFF2LABEL(R,C,(cell.v||"").slice(0,255)));return;}write_biff_rec(ba,0x0001,write_BIFF2Cell(null,R,C));}function write_ws_biff2(ba/*:BufArray*/,ws/*:Worksheet*/,idx/*:number*/,opts/*::, wb:Workbook*/){var dense=Array.isArray(ws);var range=safe_decode_range(ws['!ref']||"A1"),ref/*:string*/,rr="",cols/*:Array<string>*/=[];if(range.e.c>0xFF||range.e.r>0x3FFF){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,0x3FFF);ref=encode_range(range);}for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff2_cell(ba,cell,R,C,opts);}}}/* Based on test files */function write_biff2_buf(wb/*:Workbook*/,opts/*:WriteOpts*/){var o=opts||{};if(DENSE!=null&&o.dense==null)o.dense=DENSE;var ba=buf_array();var idx=0;for(var i=0;i<wb.SheetNames.length;++i){if(wb.SheetNames[i]==o.sheet)idx=i;}if(idx==0&&!!o.sheet&&wb.SheetNames[0]!=o.sheet)throw new Error("Sheet not found: "+o.sheet);write_biff_rec(ba,o.biff==4?0x0409:o.biff==3?0x0209:0x0009,write_BOF(wb,0x10,o));/* ... */write_ws_biff2(ba,wb.Sheets[wb.SheetNames[idx]],idx,o,wb);/* ... */write_biff_rec(ba,0x000A);return ba.end();}function write_FONTS_biff8(ba,data,opts){write_biff_rec(ba,0x0031/* Font */,write_Font({sz:12,color:{theme:1},name:"Arial",family:2,scheme:"minor"},opts));}function write_FMTS_biff8(ba,NF/*:?SSFTable*/,opts){if(!NF)return;[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r){/*:: if(!NF) return; */for(var i=r[0];i<=r[1];++i){if(NF[i]!=null)write_biff_rec(ba,0x041E/* Format */,write_Format(i,NF[i],opts));}});}function write_FEAT(ba,ws){/* [MS-XLS] 2.4.112 */var o=new_buf(19);o.write_shift(4,0x867);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,1);o.write_shift(4,0);write_biff_rec(ba,0x0867/* FeatHdr */,o);/* [MS-XLS] 2.4.111 */o=new_buf(39);o.write_shift(4,0x868);o.write_shift(4,0);o.write_shift(4,0);o.write_shift(2,3);o.write_shift(1,0);o.write_shift(4,0);o.write_shift(2,1);o.write_shift(4,4);o.write_shift(2,0);write_Ref8U(safe_decode_range(ws['!ref']||"A1"),o);o.write_shift(4,4);write_biff_rec(ba,0x0868/* Feat */,o);}function write_CELLXFS_biff8(ba,opts){for(var i=0;i<16;++i){write_biff_rec(ba,0x00e0/* XF */,write_XF({numFmtId:0,style:true},0,opts));}opts.cellXfs.forEach(function(c){write_biff_rec(ba,0x00e0/* XF */,write_XF(c,0,opts));});}function write_ws_biff8_hlinks(ba/*:BufArray*/,ws){for(var R=0;R<ws['!links'].length;++R){var HL=ws['!links'][R];write_biff_rec(ba,0x01b8/* HLink */,write_HLink(HL));if(HL[1].Tooltip)write_biff_rec(ba,0x0800/* HLinkTooltip */,write_HLinkTooltip(HL));}delete ws['!links'];}function write_ws_cols_biff8(ba,cols){if(!cols)return;var cnt=0;cols.forEach(function(col,idx){if(++cnt<=256&&col){write_biff_rec(ba,0x007d/* ColInfo */,write_ColInfo(col_obj_w(idx,col),idx));}});}function write_ws_biff8_cell(ba/*:BufArray*/,cell/*:Cell*/,R/*:number*/,C/*:number*/,opts){var os=16+get_cell_style(opts.cellXfs,cell,opts);if(cell.v==null&&!cell.bf){write_biff_rec(ba,0x0201/* Blank */,write_XLSCell(R,C,os));return;}if(cell.bf)write_biff_rec(ba,0x0006/* Formula */,write_Formula(cell,R,C,opts,os));else switch(cell.t){case'd':case'n':var v=cell.t=='d'?datenum(parseDate(cell.v)):cell.v;/* TODO: emit RK as appropriate */write_biff_rec(ba,0x0203/* Number */,write_Number(R,C,v,os,opts));break;case'b':case'e':write_biff_rec(ba,0x0205/* BoolErr */,write_BoolErr(R,C,cell.v,os,opts,cell.t));break;/* TODO: codepage, sst */case's':case'str':if(opts.bookSST){var isst=get_sst_id(opts.Strings,cell.v,opts.revStrings);write_biff_rec(ba,0x00fd/* LabelSst */,write_LabelSst(R,C,isst,os,opts));}else write_biff_rec(ba,0x0204/* Label */,write_Label(R,C,(cell.v||"").slice(0,255),os,opts));break;default:write_biff_rec(ba,0x0201/* Blank */,write_XLSCell(R,C,os));}}/* [MS-XLS] 2.1.7.20.5 */function write_ws_biff8(idx/*:number*/,opts,wb/*:Workbook*/){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var _WB/*:WBWBProps*/=(wb||{}).Workbook||{}/*:any*/;var _sheet/*:WBWSProp*/=(_WB.Sheets||[])[idx]||{}/*:any*/;var dense=Array.isArray(ws);var b8=opts.biff==8;var ref/*:string*/,rr="",cols/*:Array<string>*/=[];var range=safe_decode_range(ws['!ref']||"A1");var MAX_ROWS=b8?65536:16384;if(range.e.c>0xFF||range.e.r>=MAX_ROWS){if(opts.WTF)throw new Error("Range "+(ws['!ref']||"A1")+" exceeds format limit A1:IV16384");range.e.c=Math.min(range.e.c,0xFF);range.e.r=Math.min(range.e.c,MAX_ROWS-1);}write_biff_rec(ba,0x0809,write_BOF(wb,0x10,opts));/* [Uncalced] Index */write_biff_rec(ba,0x000d/* CalcMode */,writeuint16(1));write_biff_rec(ba,0x000c/* CalcCount */,writeuint16(100));write_biff_rec(ba,0x000f/* CalcRefMode */,writebool(true));write_biff_rec(ba,0x0011/* CalcIter */,writebool(false));write_biff_rec(ba,0x0010/* CalcDelta */,write_Xnum(0.001));write_biff_rec(ba,0x005f/* CalcSaveRecalc */,writebool(true));write_biff_rec(ba,0x002a/* PrintRowCol */,writebool(false));write_biff_rec(ba,0x002b/* PrintGrid */,writebool(false));write_biff_rec(ba,0x0082/* GridSet */,writeuint16(1));write_biff_rec(ba,0x0080/* Guts */,write_Guts([0,0]));/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] *//* Header (string) *//* Footer (string) */write_biff_rec(ba,0x0083/* HCenter */,writebool(false));write_biff_rec(ba,0x0084/* VCenter */,writebool(false));/* ... */if(b8)write_ws_cols_biff8(ba,ws["!cols"]);/* ... */write_biff_rec(ba,0x200,write_Dimensions(range,opts));/* ... */if(b8)ws['!links']=[];for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;var cell=dense?(ws[R]||[])[C]:ws[ref];if(!cell)continue;/* write cell */write_ws_biff8_cell(ba,cell,R,C,opts);if(b8&&cell.l)ws['!links'].push([ref,cell.l]);}}var cname/*:string*/=_sheet.CodeName||_sheet.name||s;/* ... */if(b8)write_biff_rec(ba,0x023e/* Window2 */,write_Window2((_WB.Views||[])[0]));/* ... */if(b8&&(ws['!merges']||[]).length)write_biff_rec(ba,0x00e5/* MergeCells */,write_MergeCells(ws['!merges']));/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */if(b8)write_ws_biff8_hlinks(ba,ws);/* [DVAL] */write_biff_rec(ba,0x01ba/* CodeName */,write_XLUnicodeString(cname,opts));/* *WebPub *CellWatch [SheetExt] */if(b8)write_FEAT(ba,ws);/* *FEAT11 *RECORD12 */write_biff_rec(ba,0x000a/* EOF */);return ba.end();}/* [MS-XLS] 2.1.7.20.3 */function write_biff8_global(wb/*:Workbook*/,bufs,opts/*:WriteOpts*/){var A=buf_array();var _WB/*:WBWBProps*/=(wb||{}).Workbook||{}/*:any*/;var _sheets/*:Array<WBWSProp>*/=_WB.Sheets||[];var _wb/*:WBProps*/=/*::((*/_WB.WBProps||{}/*::CodeName:"ThisWorkbook"*//*:: ):any)*/;var b8=opts.biff==8,b5=opts.biff==5;write_biff_rec(A,0x0809,write_BOF(wb,0x05,opts));if(opts.bookType=="xla")write_biff_rec(A,0x0087/* Addin */);write_biff_rec(A,0x00e1/* InterfaceHdr */,b8?writeuint16(0x04b0):null);write_biff_rec(A,0x00c1/* Mms */,writezeroes(2));if(b5)write_biff_rec(A,0x00bf/* ToolbarHdr */);if(b5)write_biff_rec(A,0x00c0/* ToolbarEnd */);write_biff_rec(A,0x00e2/* InterfaceEnd */);write_biff_rec(A,0x005c/* WriteAccess */,write_WriteAccess("SheetJS",opts));/* [FileSharing] */write_biff_rec(A,0x0042/* CodePage */,writeuint16(b8?0x04b0:0x04E4));/* *2047 Lel */if(b8)write_biff_rec(A,0x0161/* DSF */,writeuint16(0));if(b8)write_biff_rec(A,0x01c0/* Excel9File */);write_biff_rec(A,0x013d/* RRTabId */,write_RRTabId(wb.SheetNames.length));if(b8&&wb.vbaraw)write_biff_rec(A,0x00d3/* ObProj */);/* [ObNoMacros] */if(b8&&wb.vbaraw){var cname/*:string*/=_wb.CodeName||"ThisWorkbook";write_biff_rec(A,0x01ba/* CodeName */,write_XLUnicodeString(cname,opts));}write_biff_rec(A,0x009c/* BuiltInFnGroupCount */,writeuint16(0x11));/* *FnGroupName *FnGrp12 *//* *Lbl *//* [OleObjectSize] */write_biff_rec(A,0x0019/* WinProtect */,writebool(false));write_biff_rec(A,0x0012/* Protect */,writebool(false));write_biff_rec(A,0x0013/* Password */,writeuint16(0));if(b8)write_biff_rec(A,0x01af/* Prot4Rev */,writebool(false));if(b8)write_biff_rec(A,0x01bc/* Prot4RevPass */,writeuint16(0));write_biff_rec(A,0x003d/* Window1 */,write_Window1(opts));write_biff_rec(A,0x0040/* Backup */,writebool(false));write_biff_rec(A,0x008d/* HideObj */,writeuint16(0));write_biff_rec(A,0x0022/* Date1904 */,writebool(safe1904(wb)=="true"));write_biff_rec(A,0x000e/* CalcPrecision */,writebool(true));if(b8)write_biff_rec(A,0x01b7/* RefreshAll */,writebool(false));write_biff_rec(A,0x00DA/* BookBool */,writeuint16(0));/* ... */write_FONTS_biff8(A,wb,opts);write_FMTS_biff8(A,wb.SSF,opts);write_CELLXFS_biff8(A,opts);/* ... */if(b8)write_biff_rec(A,0x0160/* UsesELFs */,writebool(false));var a=A.end();var C=buf_array();/* METADATA [MTRSettings] [ForceFullCalculation] */if(b8)write_biff_rec(C,0x008C,write_Country());/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP *//* BIFF8: [SST *Continue] ExtSST */if(b8&&opts.Strings)write_biff_continue(C,0x00FC,write_SST(opts.Strings,opts));/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */write_biff_rec(C,0x000A/* EOF */);var c=C.end();var B=buf_array();var blen=0,j=0;for(j=0;j<wb.SheetNames.length;++j){blen+=(b8?12:11)+(b8?2:1)*wb.SheetNames[j].length;}var start=a.length+blen+c.length;for(j=0;j<wb.SheetNames.length;++j){var _sheet/*:WBWSProp*/=_sheets[j]||{}/*:any*/;write_biff_rec(B,0x0085/* BoundSheet8 */,write_BoundSheet8({pos:start,hs:_sheet.Hidden||0,dt:0,name:wb.SheetNames[j]},opts));start+=bufs[j].length;}/* 1*BoundSheet8 */var b=B.end();if(blen!=b.length)throw new Error("BS8 "+blen+" != "+b.length);var out=[];if(a.length)out.push(a);if(b.length)out.push(b);if(c.length)out.push(c);return bconcat(out);}/* [MS-XLS] 2.1.7.20 Workbook Stream */function write_biff8_buf(wb/*:Workbook*/,opts/*:WriteOpts*/){var o=opts||{};var bufs=[];if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);// $FlowIgnore
o.revssf=evert_num(wb.SSF);o.revssf[wb.SSF[65535]]=0;o.ssf=wb.SSF;}o.Strings=/*::((*/[]/*:: :any):SST)*/;o.Strings.Count=0;o.Strings.Unique=0;fix_write_opts(o);o.cellXfs=[];get_cell_style(o.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};for(var i=0;i<wb.SheetNames.length;++i){bufs[bufs.length]=write_ws_biff8(i,o,wb);}bufs.unshift(write_biff8_global(wb,bufs,o));return bconcat(bufs);}function write_biff_buf(wb/*:Workbook*/,opts/*:WriteOpts*/){for(var i=0;i<=wb.SheetNames.length;++i){var ws=wb.Sheets[wb.SheetNames[i]];if(!ws||!ws["!ref"])continue;var range=decode_range(ws["!ref"]);if(range.e.c>255){// note: 255 is IV
if(typeof console!="undefined"&&console.error)console.error("Worksheet '"+wb.SheetNames[i]+"' extends beyond column IV (255).  Data may be lost.");}}var o=opts||{};switch(o.biff||2){case 8:case 5:return write_biff8_buf(wb,opts);case 4:case 3:case 2:return write_biff2_buf(wb,opts);}throw new Error("invalid type "+o.bookType+" for BIFF");}/* note: browser DOM element cannot see mso- style attrs, must parse */function html_to_sheet(str/*:string*/,_opts)/*:Workbook*/{var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var ws/*:Worksheet*/=opts.dense?[]/*:any*/:{}/*:any*/;str=str.replace(/<!--.*?-->/g,"");var mtch/*:any*/=str.match(/<table/i);if(!mtch)throw new Error("Invalid HTML: could not find <table>");var mtch2/*:any*/=str.match(/<\/table/i);var i/*:number*/=mtch.index,j/*:number*/=mtch2&&mtch2.index||str.length;var rows=split_regex(str.slice(i,j),/(:?<tr[^>]*>)/i,"<tr>");var R=-1,C=0,RS=0,CS=0;var range/*:Range*/={s:{r:10000000,c:10000000},e:{r:0,c:0}};var merges/*:Array<Range>*/=[];for(i=0;i<rows.length;++i){var row=rows[i].trim();var hd=row.slice(0,3).toLowerCase();if(hd=="<tr"){++R;if(opts.sheetRows&&opts.sheetRows<=R){--R;break;}C=0;continue;}if(hd!="<td"&&hd!="<th")continue;var cells=row.split(/<\/t[dh]>/i);for(j=0;j<cells.length;++j){var cell=cells[j].trim();if(!cell.match(/<t[dh]/i))continue;var m=cell,cc=0;/* TODO: parse styles etc */while(m.charAt(0)=="<"&&(cc=m.indexOf(">"))>-1){m=m.slice(cc+1);}for(var midx=0;midx<merges.length;++midx){var _merge/*:Range*/=merges[midx];if(_merge.s.c==C&&_merge.s.r<R&&R<=_merge.e.r){C=_merge.e.c+1;midx=-1;}}var tag=parsexmltag(cell.slice(0,cell.indexOf(">")));CS=tag.colspan?+tag.colspan:1;if((RS=+tag.rowspan)>1||CS>1)merges.push({s:{r:R,c:C},e:{r:R+(RS||1)-1,c:C+CS-1}});var _t/*:string*/=tag.t||tag["data-t"]||"";/* TODO: generate stub cells */if(!m.length){C+=CS;continue;}m=htmldecode(m);if(range.s.r>R)range.s.r=R;if(range.e.r<R)range.e.r=R;if(range.s.c>C)range.s.c=C;if(range.e.c<C)range.e.c=C;if(!m.length){C+=CS;continue;}var o/*:Cell*/={t:'s',v:m};if(opts.raw||!m.trim().length||_t=='s'){}else if(m==='TRUE')o={t:'b',v:true};else if(m==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(m)))o={t:'n',v:fuzzynum(m)};else if(!isNaN(fuzzydate(m).getDate())){o={t:'d',v:parseDate(m)/*:any*/};if(!opts.cellDates)o={t:'n',v:datenum(o.v)/*:any*/};o.z=opts.dateNF||table_fmt[14];}if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=o;}else ws[encode_cell({r:R,c:C})]=o;C+=CS;}}ws['!ref']=encode_range(range);if(merges.length)ws["!merges"]=merges;return ws;}function make_html_row(ws/*:Worksheet*/,r/*:Range*/,R/*:number*/,o/*:Sheet2HTMLOpts*/)/*:string*/{var M/*:Array<Range>*/=ws['!merges']||[];var oo/*:Array<string>*/=[];for(var C=r.s.c;C<=r.e.c;++C){var RS=0,CS=0;for(var j=0;j<M.length;++j){if(M[j].s.r>R||M[j].s.c>C)continue;if(M[j].e.r<R||M[j].e.c<C)continue;if(M[j].s.r<R||M[j].s.c<C){RS=-1;break;}RS=M[j].e.r-M[j].s.r+1;CS=M[j].e.c-M[j].s.c+1;break;}if(RS<0)continue;var coord=encode_cell({r:R,c:C});var cell=o.dense?(ws[R]||[])[C]:ws[coord];/* TODO: html entities */var w=cell&&cell.v!=null&&(cell.h||escapehtml(cell.w||(format_cell(cell),cell.w)||""))||"";var sp={}/*:any*/;if(RS>1)sp.rowspan=RS;if(CS>1)sp.colspan=CS;if(o.editable)w='<span contenteditable="true">'+w+'</span>';else if(cell){sp["data-t"]=cell&&cell.t||'z';if(cell.v!=null)sp["data-v"]=cell.v;if(cell.z!=null)sp["data-z"]=cell.z;if(cell.l&&(cell.l.Target||"#").charAt(0)!="#")w='<a href="'+cell.l.Target+'">'+w+'</a>';}sp.id=(o.id||"sjs")+"-"+coord;oo.push(writextag('td',w,sp));}var preamble="<tr>";return preamble+oo.join("")+"</tr>";}var HTML_BEGIN='<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';var HTML_END='</body></html>';function html_to_workbook(str/*:string*/,opts)/*:Workbook*/{var mtch=str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);if(!mtch||mtch.length==0)throw new Error("Invalid HTML: could not find <table>");if(mtch.length==1)return sheet_to_workbook(html_to_sheet(mtch[0],opts),opts);var wb=book_new();mtch.forEach(function(s,idx){book_append_sheet(wb,html_to_sheet(s,opts),"Sheet"+(idx+1));});return wb;}function make_html_preamble(ws/*:Worksheet*/,R/*:Range*/,o/*:Sheet2HTMLOpts*/)/*:string*/{var out/*:Array<string>*/=[];return out.join("")+'<table'+(o&&o.id?' id="'+o.id+'"':"")+'>';}function sheet_to_html(ws/*:Worksheet*/,opts/*:?Sheet2HTMLOpts*//*, wb:?Workbook*/)/*:string*/{var o=opts||{};var header=o.header!=null?o.header:HTML_BEGIN;var footer=o.footer!=null?o.footer:HTML_END;var out/*:Array<string>*/=[header];var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);out.push(make_html_preamble(ws,r,o));for(var R=r.s.r;R<=r.e.r;++R){out.push(make_html_row(ws,r,R,o));}out.push("</table>"+footer);return out.join("");}function sheet_add_dom(ws/*:Worksheet*/,table/*:HTMLElement*/,_opts/*:?any*/)/*:Worksheet*/{var opts=_opts||{};if(DENSE!=null)opts.dense=DENSE;var or_R=0,or_C=0;if(opts.origin!=null){if(typeof opts.origin=='number')or_R=opts.origin;else{var _origin/*:CellAddress*/=typeof opts.origin=="string"?decode_cell(opts.origin):opts.origin;or_R=_origin.r;or_C=_origin.c;}}var rows/*:HTMLCollection<HTMLTableRowElement>*/=table.getElementsByTagName('tr');var sheetRows=Math.min(opts.sheetRows||10000000,rows.length);var range/*:Range*/={s:{r:0,c:0},e:{r:or_R,c:or_C}};if(ws["!ref"]){var _range/*:Range*/=decode_range(ws["!ref"]);range.s.r=Math.min(range.s.r,_range.s.r);range.s.c=Math.min(range.s.c,_range.s.c);range.e.r=Math.max(range.e.r,_range.e.r);range.e.c=Math.max(range.e.c,_range.e.c);if(or_R==-1)range.e.r=or_R=_range.e.r+1;}var merges/*:Array<Range>*/=[],midx=0;var rowinfo/*:Array<RowInfo>*/=ws["!rows"]||(ws["!rows"]=[]);var _R=0,R=0,_C=0,C=0,RS=0,CS=0;if(!ws["!cols"])ws['!cols']=[];for(;_R<rows.length&&R<sheetRows;++_R){var row/*:HTMLTableRowElement*/=rows[_R];if(is_dom_element_hidden(row)){if(opts.display)continue;rowinfo[R]={hidden:true};}var elts/*:HTMLCollection<HTMLTableCellElement>*/=row.children/*:any*/;for(_C=C=0;_C<elts.length;++_C){var elt/*:HTMLTableCellElement*/=elts[_C];if(opts.display&&is_dom_element_hidden(elt))continue;var v/*:?string*/=elt.hasAttribute('data-v')?elt.getAttribute('data-v'):elt.hasAttribute('v')?elt.getAttribute('v'):htmldecode(elt.innerHTML);var z/*:?string*/=elt.getAttribute('data-z')||elt.getAttribute('z');for(midx=0;midx<merges.length;++midx){var m/*:Range*/=merges[midx];if(m.s.c==C+or_C&&m.s.r<R+or_R&&R+or_R<=m.e.r){C=m.e.c+1-or_C;midx=-1;}}/* TODO: figure out how to extract nonstandard mso- style */CS=+elt.getAttribute("colspan")||1;if((RS=+elt.getAttribute("rowspan")||1)>1||CS>1)merges.push({s:{r:R+or_R,c:C+or_C},e:{r:R+or_R+(RS||1)-1,c:C+or_C+(CS||1)-1}});var o/*:Cell*/={t:'s',v:v};var _t/*:string*/=elt.getAttribute("data-t")||elt.getAttribute("t")||"";if(v!=null){if(v.length==0)o.t=_t||'z';else if(opts.raw||v.trim().length==0||_t=="s"){}else if(v==='TRUE')o={t:'b',v:true};else if(v==='FALSE')o={t:'b',v:false};else if(!isNaN(fuzzynum(v)))o={t:'n',v:fuzzynum(v)};else if(!isNaN(fuzzydate(v).getDate())){o={t:'d',v:parseDate(v)/*:any*/};if(!opts.cellDates)o={t:'n',v:datenum(o.v)/*:any*/};o.z=opts.dateNF||table_fmt[14];}}if(o.z===undefined&&z!=null)o.z=z;/* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */var l="",Aelts=elt.getElementsByTagName("A");if(Aelts&&Aelts.length)for(var Aelti=0;Aelti<Aelts.length;++Aelti){if(Aelts[Aelti].hasAttribute("href")){l=Aelts[Aelti].getAttribute("href");if(l.charAt(0)!="#")break;}}if(l&&l.charAt(0)!="#")o.l={Target:l};if(opts.dense){if(!ws[R+or_R])ws[R+or_R]=[];ws[R+or_R][C+or_C]=o;}else ws[encode_cell({c:C+or_C,r:R+or_R})]=o;if(range.e.c<C+or_C)range.e.c=C+or_C;C+=CS;}++R;}if(merges.length)ws['!merges']=(ws["!merges"]||[]).concat(merges);range.e.r=Math.max(range.e.r,R-1+or_R);ws['!ref']=encode_range(range);if(R>=sheetRows)ws['!fullref']=encode_range((range.e.r=rows.length-_R+R-1+or_R,range));// We can count the real number of rows to parse but we don't to improve the performance
return ws;}function parse_dom_table(table/*:HTMLElement*/,_opts/*:?any*/)/*:Worksheet*/{var opts=_opts||{};var ws/*:Worksheet*/=opts.dense?[]/*:any*/:{}/*:any*/;return sheet_add_dom(ws,table,_opts);}function table_to_book(table/*:HTMLElement*/,opts/*:?any*/)/*:Workbook*/{return sheet_to_workbook(parse_dom_table(table,opts),opts);}function is_dom_element_hidden(element/*:HTMLElement*/)/*:boolean*/{var display/*:string*/='';var get_computed_style/*:?function*/=get_get_computed_style_function(element);if(get_computed_style)display=get_computed_style(element).getPropertyValue('display');if(!display)display=element.style&&element.style.display;return display==='none';}/* global getComputedStyle */function get_get_computed_style_function(element/*:HTMLElement*/)/*:?function*/{// The proper getComputedStyle implementation is the one defined in the element window
if(element.ownerDocument.defaultView&&typeof element.ownerDocument.defaultView.getComputedStyle==='function')return element.ownerDocument.defaultView.getComputedStyle;// If it is not available, try to get one from the global namespace
if(typeof getComputedStyle==='function')return getComputedStyle;return null;}/* OpenDocument */function parse_text_p(text/*:string*//*::, tag*/)/*:Array<any>*/{/* 6.1.2 White Space Characters */var fixed=text.replace(/[\t\r\n]/g," ").trim().replace(/ +/g," ").replace(/<text:s\/>/g," ").replace(/<text:s text:c="(\d+)"\/>/g,function($$,$1){return Array(parseInt($1,10)+1).join(" ");}).replace(/<text:tab[^>]*\/>/g,"\t").replace(/<text:line-break\/>/g,"\n");var v=unescapexml(fixed.replace(/<[^>]*>/g,""));return[v];}var number_formats_ods={/* ods name: [short ssf fmt, long ssf fmt] */day:["d","dd"],month:["m","mm"],year:["y","yy"],hours:["h","hh"],minutes:["m","mm"],seconds:["s","ss"],"am-pm":["A/P","AM/PM"],"day-of-week":["ddd","dddd"],era:["e","ee"],/* there is no native representation of LO "Q" format */quarter:["\\Qm","m\\\"th quarter\""]};function parse_content_xml(d/*:string*/,_opts)/*:Workbook*/{var opts=_opts||{};if(DENSE!=null&&opts.dense==null)opts.dense=DENSE;var str=xlml_normalize(d);var state/*:Array<any>*/=[],tmp;var tag/*:: = {}*/;var NFtag={name:""},NF="",pidx=0;var sheetag/*:: = {name:"", '名称':""}*/;var rowtag/*:: = {'行号':""}*/;var Sheets={},SheetNames/*:Array<string>*/=[];var ws=opts.dense?[]/*:any*/:{}/*:any*/;var Rn,q/*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/;var ctag={value:""/*:any*/};var textp="",textpidx=0,textptag/*:: = {}*/;var textR=[];var R=-1,C=-1,range={s:{r:1000000,c:10000000},e:{r:0,c:0}};var row_ol=0;var number_format_map={};var merges/*:Array<Range>*/=[],mrange={},mR=0,mC=0;var rowinfo/*:Array<RowInfo>*/=[],rowpeat=1,colpeat=1;var arrayf/*:Array<[Range, string]>*/=[];var WB={Names:[]};var atag={}/*:any*/;var _Ref/*:[string, string]*/=["",""];var comments/*:Array<Comment>*/=[],comment/*:Comment*/={}/*:any*/;var creator="",creatoridx=0;var isstub=false,intable=false;var i=0;xlmlregex.lastIndex=0;str=str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");while(Rn=xlmlregex.exec(str)){switch(Rn[3]=Rn[3].replace(/_.*$/,"")){case'table':case'工作表':// 9.1.2 <table:table>
if(Rn[1]==='/'){if(range.e.c>=range.s.c&&range.e.r>=range.s.r)ws['!ref']=encode_range(range);else ws['!ref']="A1:A1";if(opts.sheetRows>0&&opts.sheetRows<=range.e.r){ws['!fullref']=ws['!ref'];range.e.r=opts.sheetRows-1;ws['!ref']=encode_range(range);}if(merges.length)ws['!merges']=merges;if(rowinfo.length)ws["!rows"]=rowinfo;sheetag.name=sheetag['名称']||sheetag.name;if(typeof JSON!=='undefined')(0,_stringify2.default)(sheetag);SheetNames.push(sheetag.name);Sheets[sheetag.name]=ws;intable=false;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){sheetag=parsexmltag(Rn[0],false);R=C=-1;range.s.r=range.s.c=10000000;range.e.r=range.e.c=0;ws=opts.dense?[]/*:any*/:{}/*:any*/;merges=[];rowinfo=[];intable=true;}break;case'table-row-group':// 9.1.9 <table:table-row-group>
if(Rn[1]==="/")--row_ol;else++row_ol;break;case'table-row':case'行':// 9.1.3 <table:table-row>
if(Rn[1]==='/'){R+=rowpeat;rowpeat=1;break;}rowtag=parsexmltag(Rn[0],false);if(rowtag['行号'])R=rowtag['行号']-1;else if(R==-1)R=0;rowpeat=+rowtag['number-rows-repeated']||1;/* TODO: remove magic */if(rowpeat<10)for(i=0;i<rowpeat;++i){if(row_ol>0)rowinfo[R+i]={level:row_ol};}C=-1;break;case'covered-table-cell':// 9.1.5 <table:covered-table-cell>
if(Rn[1]!=='/')++C;if(opts.sheetStubs){if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]={t:'z'};}else ws[encode_cell({r:R,c:C})]={t:'z'};}textp="";textR=[];break;/* stub */case'table-cell':case'数据':if(Rn[0].charAt(Rn[0].length-2)==='/'){++C;ctag=parsexmltag(Rn[0],false);colpeat=parseInt(ctag['number-columns-repeated']||"1",10);q={t:'z',v:null/*:: , z:null, w:"",c:[]*//*:any*/};if(ctag.formula&&opts.cellFormula!=false)q.f=ods_to_csf_formula(unescapexml(ctag.formula));if((ctag['数据类型']||ctag['value-type'])=="string"){q.t="s";q.v=unescapexml(ctag['string-value']||"");if(opts.dense){if(!ws[R])ws[R]=[];ws[R][C]=q;}else{ws[encode_cell({r:R,c:C})]=q;}}C+=colpeat-1;}else if(Rn[1]!=='/'){++C;textp="";textpidx=0;textR=[];colpeat=1;var rptR=rowpeat?R+rowpeat-1:R;if(C>range.e.c)range.e.c=C;if(C<range.s.c)range.s.c=C;if(R<range.s.r)range.s.r=R;if(rptR>range.e.r)range.e.r=rptR;ctag=parsexmltag(Rn[0],false);comments=[];comment={}/*:any*/;q={t:ctag['数据类型']||ctag['value-type'],v:null/*:: , z:null, w:"",c:[]*//*:any*/};if(opts.cellFormula){if(ctag.formula)ctag.formula=unescapexml(ctag.formula);if(ctag['number-matrix-columns-spanned']&&ctag['number-matrix-rows-spanned']){mR=parseInt(ctag['number-matrix-rows-spanned'],10)||0;mC=parseInt(ctag['number-matrix-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};q.F=encode_range(mrange);arrayf.push([mrange,q.F]);}if(ctag.formula)q.f=ods_to_csf_formula(ctag.formula);else for(i=0;i<arrayf.length;++i){if(R>=arrayf[i][0].s.r&&R<=arrayf[i][0].e.r)if(C>=arrayf[i][0].s.c&&C<=arrayf[i][0].e.c)q.F=arrayf[i][1];}}if(ctag['number-columns-spanned']||ctag['number-rows-spanned']){mR=parseInt(ctag['number-rows-spanned'],10)||0;mC=parseInt(ctag['number-columns-spanned'],10)||0;mrange={s:{r:R,c:C},e:{r:R+mR-1,c:C+mC-1}};merges.push(mrange);}/* 19.675.2 table:number-columns-repeated */if(ctag['number-columns-repeated'])colpeat=parseInt(ctag['number-columns-repeated'],10);/* 19.385 office:value-type */switch(q.t){case'boolean':q.t='b';q.v=parsexmlbool(ctag['boolean-value']);break;case'float':q.t='n';q.v=parseFloat(ctag.value);break;case'percentage':q.t='n';q.v=parseFloat(ctag.value);break;case'currency':q.t='n';q.v=parseFloat(ctag.value);break;case'date':q.t='d';q.v=parseDate(ctag['date-value']);if(!opts.cellDates){q.t='n';q.v=datenum(q.v);}q.z='m/d/yy';break;case'time':q.t='n';q.v=parse_isodur(ctag['time-value'])/86400;if(opts.cellDates){q.t='d';q.v=numdate(q.v);}q.z='HH:MM:SS';break;case'number':q.t='n';q.v=parseFloat(ctag['数据数值']);break;default:if(q.t==='string'||q.t==='text'||!q.t){q.t='s';if(ctag['string-value']!=null){textp=unescapexml(ctag['string-value']);textR=[];}}else throw new Error('Unsupported value type '+q.t);}}else{isstub=false;if(q.t==='s'){q.v=textp||'';if(textR.length)q.R=textR;isstub=textpidx==0;}if(atag.Target)q.l=atag;if(comments.length>0){q.c=comments;comments=[];}if(textp&&opts.cellText!==false)q.w=textp;if(isstub){q.t="z";delete q.v;}if(!isstub||opts.sheetStubs){if(!(opts.sheetRows&&opts.sheetRows<=R)){for(var rpt=0;rpt<rowpeat;++rpt){colpeat=parseInt(ctag['number-columns-repeated']||"1",10);if(opts.dense){if(!ws[R+rpt])ws[R+rpt]=[];ws[R+rpt][C]=rpt==0?q:dup(q);while(--colpeat>0){ws[R+rpt][C+colpeat]=dup(q);}}else{ws[encode_cell({r:R+rpt,c:C})]=q;while(--colpeat>0){ws[encode_cell({r:R+rpt,c:C+colpeat})]=dup(q);}}if(range.e.c<=C)range.e.c=C;}}}colpeat=parseInt(ctag['number-columns-repeated']||"1",10);C+=colpeat-1;colpeat=0;q={/*:: t:"", v:null, z:null, w:"",c:[]*/};textp="";textR=[];}atag={}/*:any*/;break;// 9.1.4 <table:table-cell>
/* pure state */case'document':// TODO: <office:document> is the root for FODS
case'document-content':case'电子表格文档':// 3.1.3.2 <office:document-content>
case'spreadsheet':case'主体':// 3.7 <office:spreadsheet>
case'scripts':// 3.12 <office:scripts>
case'styles':// TODO <office:styles>
case'font-face-decls':// 3.14 <office:font-face-decls>
case'master-styles':// 3.15.4 <office:master-styles> -- relevant for FODS
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],true]);break;case'annotation':// 14.1 <office:annotation>
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;comment.t=textp;if(textR.length)/*::(*/comment/*:: :any)*/.R=textR;comment.a=creator;comments.push(comment);}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){state.push([Rn[3],false]);}creator="";creatoridx=0;textp="";textpidx=0;textR=[];break;case'creator':// 4.3.2.7 <dc:creator>
if(Rn[1]==='/'){creator=str.slice(creatoridx,Rn.index);}else creatoridx=Rn.index+Rn[0].length;break;/* ignore state */case'meta':case'元数据':// TODO: <office:meta> <uof:元数据> FODS/UOF
case'settings':// TODO: <office:settings>
case'config-item-set':// TODO: <office:config-item-set>
case'config-item-map-indexed':// TODO: <office:config-item-map-indexed>
case'config-item-map-entry':// TODO: <office:config-item-map-entry>
case'config-item-map-named':// TODO: <office:config-item-map-entry>
case'shapes':// 9.2.8 <table:shapes>
case'frame':// 10.4.2 <draw:frame>
case'text-box':// 10.4.3 <draw:text-box>
case'image':// 10.4.4 <draw:image>
case'data-pilot-tables':// 9.6.2 <table:data-pilot-tables>
case'list-style':// 16.30 <text:list-style>
case'form':// 13.13 <form:form>
case'dde-links':// 9.8 <table:dde-links>
case'event-listeners':// TODO
case'chart':// TODO
if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/')state.push([Rn[3],false]);textp="";textpidx=0;textR=[];break;case'scientific-number':// TODO: <number:scientific-number>
break;case'currency-symbol':// TODO: <number:currency-symbol>
break;case'currency-style':// TODO: <number:currency-style>
break;case'number-style':// 16.27.2 <number:number-style>
case'percentage-style':// 16.27.9 <number:percentage-style>
case'date-style':// 16.27.10 <number:date-style>
case'time-style':// 16.27.18 <number:time-style>
if(Rn[1]==='/'){number_format_map[NFtag.name]=NF;if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;}else if(Rn[0].charAt(Rn[0].length-2)!=='/'){NF="";NFtag=parsexmltag(Rn[0],false);state.push([Rn[3],true]);}break;case'script':break;// 3.13 <office:script>
case'libraries':break;// TODO: <ooo:libraries>
case'automatic-styles':break;// 3.15.3 <office:automatic-styles>
case'default-style':// TODO: <style:default-style>
case'page-layout':break;// TODO: <style:page-layout>
case'style':// 16.2 <style:style>
break;case'map':break;// 16.3 <style:map>
case'font-face':break;// 16.21 <style:font-face>
case'paragraph-properties':break;// 17.6 <style:paragraph-properties>
case'table-properties':break;// 17.15 <style:table-properties>
case'table-column-properties':break;// 17.16 <style:table-column-properties>
case'table-row-properties':break;// 17.17 <style:table-row-properties>
case'table-cell-properties':break;// 17.18 <style:table-cell-properties>
case'number':// 16.27.3 <number:number>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats_ods[Rn[3]][tag.style==='long'?1:0];break;}break;case'fraction':break;// TODO 16.27.6 <number:fraction>
case'day':// 16.27.11 <number:day>
case'month':// 16.27.12 <number:month>
case'year':// 16.27.13 <number:year>
case'era':// 16.27.14 <number:era>
case'day-of-week':// 16.27.15 <number:day-of-week>
case'week-of-year':// 16.27.16 <number:week-of-year>
case'quarter':// 16.27.17 <number:quarter>
case'hours':// 16.27.19 <number:hours>
case'minutes':// 16.27.20 <number:minutes>
case'seconds':// 16.27.21 <number:seconds>
case'am-pm':// 16.27.22 <number:am-pm>
switch(state[state.length-1][0]){case'time-style':case'date-style':tag=parsexmltag(Rn[0],false);NF+=number_formats_ods[Rn[3]][tag.style==='long'?1:0];break;}break;case'boolean-style':break;// 16.27.23 <number:boolean-style>
case'boolean':break;// 16.27.24 <number:boolean>
case'text-style':break;// 16.27.25 <number:text-style>
case'text':// 16.27.26 <number:text>
if(Rn[0].slice(-2)==="/>")break;else if(Rn[1]==="/")switch(state[state.length-1][0]){case'number-style':case'date-style':case'time-style':NF+=str.slice(pidx,Rn.index);break;}else pidx=Rn.index+Rn[0].length;break;case'named-range':// 9.4.12 <table:named-range>
tag=parsexmltag(Rn[0],false);_Ref=ods_to_csf_3D(tag['cell-range-address']);var nrange={Name:tag.name,Ref:_Ref[0]+'!'+_Ref[1]/*:any*/};if(intable)nrange.Sheet=SheetNames.length;WB.Names.push(nrange);break;case'text-content':break;// 16.27.27 <number:text-content>
case'text-properties':break;// 16.27.27 <style:text-properties>
case'embedded-text':break;// 16.27.4 <number:embedded-text>
case'body':case'电子表格':break;// 3.3 16.9.6 19.726.3
case'forms':break;// 12.25.2 13.2
case'table-column':break;// 9.1.6 <table:table-column>
case'table-header-rows':break;// 9.1.7 <table:table-header-rows>
case'table-rows':break;// 9.1.12 <table:table-rows>
/* TODO: outline levels */case'table-column-group':break;// 9.1.10 <table:table-column-group>
case'table-header-columns':break;// 9.1.11 <table:table-header-columns>
case'table-columns':break;// 9.1.12 <table:table-columns>
case'null-date':break;// 9.4.2 <table:null-date> TODO: date1904
case'graphic-properties':break;// 17.21 <style:graphic-properties>
case'calculation-settings':break;// 9.4.1 <table:calculation-settings>
case'named-expressions':break;// 9.4.11 <table:named-expressions>
case'label-range':break;// 9.4.9 <table:label-range>
case'label-ranges':break;// 9.4.10 <table:label-ranges>
case'named-expression':break;// 9.4.13 <table:named-expression>
case'sort':break;// 9.4.19 <table:sort>
case'sort-by':break;// 9.4.20 <table:sort-by>
case'sort-groups':break;// 9.4.22 <table:sort-groups>
case'tab':break;// 6.1.4 <text:tab>
case'line-break':break;// 6.1.5 <text:line-break>
case'span':break;// 6.1.7 <text:span>
case'p':case'文本串':// 5.1.3 <text:p>
if(['master-styles'].indexOf(state[state.length-1][0])>-1)break;if(Rn[1]==='/'&&(!ctag||!ctag['string-value'])){var ptp=parse_text_p(str.slice(textpidx,Rn.index),textptag);textp=(textp.length>0?textp+"\n":"")+ptp[0];}else{textptag=parsexmltag(Rn[0],false);textpidx=Rn.index+Rn[0].length;}break;// <text:p>
case's':break;// <text:s>
case'database-range':// 9.4.15 <table:database-range>
if(Rn[1]==='/')break;try{_Ref=ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);Sheets[_Ref[0]]['!autofilter']={ref:_Ref[1]};}catch(e){/* empty */}break;case'date':break;// <*:date>
case'object':break;// 10.4.6.2 <draw:object>
case'title':case'标题':break;// <*:title> OR <uof:标题>
case'desc':break;// <*:desc>
case'binary-data':break;// 10.4.5 TODO: b64 blob
/* 9.2 Advanced Tables */case'table-source':break;// 9.2.6
case'scenario':break;// 9.2.6
case'iteration':break;// 9.4.3 <table:iteration>
case'content-validations':break;// 9.4.4 <table:
case'content-validation':break;// 9.4.5 <table:
case'help-message':break;// 9.4.6 <table:
case'error-message':break;// 9.4.7 <table:
case'database-ranges':break;// 9.4.14 <table:database-ranges>
case'filter':break;// 9.5.2 <table:filter>
case'filter-and':break;// 9.5.3 <table:filter-and>
case'filter-or':break;// 9.5.4 <table:filter-or>
case'filter-condition':break;// 9.5.5 <table:filter-condition>
case'list-level-style-bullet':break;// 16.31 <text:
case'list-level-style-number':break;// 16.32 <text:
case'list-level-properties':break;// 17.19 <style:
/* 7.3 Document Fields */case'sender-firstname':// 7.3.6.2
case'sender-lastname':// 7.3.6.3
case'sender-initials':// 7.3.6.4
case'sender-title':// 7.3.6.5
case'sender-position':// 7.3.6.6
case'sender-email':// 7.3.6.7
case'sender-phone-private':// 7.3.6.8
case'sender-fax':// 7.3.6.9
case'sender-company':// 7.3.6.10
case'sender-phone-work':// 7.3.6.11
case'sender-street':// 7.3.6.12
case'sender-city':// 7.3.6.13
case'sender-postal-code':// 7.3.6.14
case'sender-country':// 7.3.6.15
case'sender-state-or-province':// 7.3.6.16
case'author-name':// 7.3.7.1
case'author-initials':// 7.3.7.2
case'chapter':// 7.3.8
case'file-name':// 7.3.9
case'template-name':// 7.3.9
case'sheet-name':// 7.3.9
break;case'event-listener':break;/* TODO: FODS Properties */case'initial-creator':case'creation-date':case'print-date':case'generator':case'document-statistic':case'user-defined':case'editing-duration':case'editing-cycles':break;/* TODO: FODS Config */case'config-item':break;/* TODO: style tokens */case'page-number':break;// TODO <text:page-number>
case'page-count':break;// TODO <text:page-count>
case'time':break;// TODO <text:time>
/* 9.3 Advanced Table Cells */case'cell-range-source':break;// 9.3.1 <table:
case'detective':break;// 9.3.2 <table:
case'operation':break;// 9.3.3 <table:
case'highlighted-range':break;// 9.3.4 <table:
/* 9.6 Data Pilot Tables <table: */case'data-pilot-table':// 9.6.3
case'source-cell-range':// 9.6.5
case'source-service':// 9.6.6
case'data-pilot-field':// 9.6.7
case'data-pilot-level':// 9.6.8
case'data-pilot-subtotals':// 9.6.9
case'data-pilot-subtotal':// 9.6.10
case'data-pilot-members':// 9.6.11
case'data-pilot-member':// 9.6.12
case'data-pilot-display-info':// 9.6.13
case'data-pilot-sort-info':// 9.6.14
case'data-pilot-layout-info':// 9.6.15
case'data-pilot-field-reference':// 9.6.16
case'data-pilot-groups':// 9.6.17
case'data-pilot-group':// 9.6.18
case'data-pilot-group-member':// 9.6.19
break;/* 10.3 Drawing Shapes */case'rect':// 10.3.2
break;/* 14.6 DDE Connections */case'dde-connection-decls':// 14.6.2 <text:
case'dde-connection-decl':// 14.6.3 <text:
case'dde-link':// 14.6.4 <table:
case'dde-source':// 14.6.5 <office:
break;case'properties':break;// 13.7 <form:properties>
case'property':break;// 13.8 <form:property>
case'a':// 6.1.8 hyperlink
if(Rn[1]!=='/'){atag=parsexmltag(Rn[0],false);if(!atag.href)break;atag.Target=unescapexml(atag.href);delete atag.href;if(atag.Target.charAt(0)=="#"&&atag.Target.indexOf(".")>-1){_Ref=ods_to_csf_3D(atag.Target.slice(1));atag.Target="#"+_Ref[0]+"!"+_Ref[1];}else if(atag.Target.match(/^\.\.[\\\/]/))atag.Target=atag.Target.slice(3);}break;/* non-standard */case'table-protection':break;case'data-pilot-grand-total':break;// <table:
case'office-document-common-attrs':break;// bare
default:switch(Rn[2]){case'dc:':// TODO: properties
case'calcext:':// ignore undocumented extensions
case'loext:':// ignore undocumented extensions
case'ooo:':// ignore undocumented extensions
case'chartooo:':// ignore undocumented extensions
case'draw:':// TODO: drawing
case'style:':// TODO: styles
case'chart:':// TODO: charts
case'form:':// TODO: forms
case'uof:':// TODO: uof
case'表:':// TODO: uof
case'字:':// TODO: uof
break;default:if(opts.WTF)throw new Error(Rn);}}}var out/*:Workbook*/={Sheets:Sheets,SheetNames:SheetNames,Workbook:WB/*:any*/};if(opts.bookSheets)delete/*::(*/out/*:: :any)*/.Sheets;return out;}function parse_ods(zip/*:ZIPFile*/,opts/*:?ParseOpts*/)/*:Workbook*/{opts=opts||{}/*:any*/;if(safegetzipfile(zip,'META-INF/manifest.xml'))parse_manifest(getzipdata(zip,'META-INF/manifest.xml'),opts);var content=getzipstr(zip,'content.xml');if(!content)throw new Error("Missing content.xml in ODS / UOF file");var wb=parse_content_xml(utf8read(content),opts);if(safegetzipfile(zip,'meta.xml'))wb.Props=parse_core_props(getzipdata(zip,'meta.xml'));return wb;}function parse_fods(data/*:string*/,opts/*:?ParseOpts*/)/*:Workbook*/{return parse_content_xml(data,opts);}/* OpenDocument */var write_styles_ods/*:{(wb:any, opts:any):string}*/=/* @__PURE__ */function(){var master_styles=['<office:master-styles>','<style:master-page style:name="mp1" style:page-layout-name="mp1">','<style:header/>','<style:header-left style:display="false"/>','<style:footer/>','<style:footer-left style:display="false"/>','</style:master-page>','</office:master-styles>'].join("");var payload='<office:document-styles '+wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'office:version':"1.2"})+'>'+master_styles+'</office:document-styles>';return function wso()/*::wb, opts*/{return XML_HEADER+payload;};}();var write_content_ods/*:{(wb:any, opts:any):string}*/=/* @__PURE__ */function(){/* 6.1.2 White Space Characters */var write_text_p=function write_text_p(text/*:string*/)/*:string*/{return escapexml(text).replace(/  +/g,function($$){return'<text:s text:c="'+$$.length+'"/>';}).replace(/\t/g,"<text:tab/>").replace(/\n/g,"</text:p><text:p>").replace(/^ /,"<text:s/>").replace(/ $/,"<text:s/>");};var null_cell_xml='          <table:table-cell />\n';var covered_cell_xml='          <table:covered-table-cell/>\n';var write_ws=function write_ws(ws,wb/*:Workbook*/,i/*:number*//*::, opts*/)/*:string*/{/* Section 9 Tables */var o/*:Array<string>*/=[];o.push('      <table:table table:name="'+escapexml(wb.SheetNames[i])+'" table:style-name="ta1">\n');var R=0,C=0,range=decode_range(ws['!ref']||"A1");var marr/*:Array<Range>*/=ws['!merges']||[],mi=0;var dense=Array.isArray(ws);if(ws["!cols"]){for(C=0;C<=range.e.c;++C){o.push('        <table:table-column'+(ws["!cols"][C]?' table:style-name="co'+ws["!cols"][C].ods+'"':'')+'></table:table-column>\n');}}var H="",ROWS=ws["!rows"]||[];for(R=0;R<range.s.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'></table:table-row>\n');}for(;R<=range.e.r;++R){H=ROWS[R]?' table:style-name="ro'+ROWS[R].ods+'"':"";o.push('        <table:table-row'+H+'>\n');for(C=0;C<range.s.c;++C){o.push(null_cell_xml);}for(;C<=range.e.c;++C){var skip=false,ct={},textp="";for(mi=0;mi!=marr.length;++mi){if(marr[mi].s.c>C)continue;if(marr[mi].s.r>R)continue;if(marr[mi].e.c<C)continue;if(marr[mi].e.r<R)continue;if(marr[mi].s.c!=C||marr[mi].s.r!=R)skip=true;ct['table:number-columns-spanned']=marr[mi].e.c-marr[mi].s.c+1;ct['table:number-rows-spanned']=marr[mi].e.r-marr[mi].s.r+1;break;}if(skip){o.push(covered_cell_xml);continue;}var ref=encode_cell({r:R,c:C}),cell=dense?(ws[R]||[])[C]:ws[ref];if(cell&&cell.f){ct['table:formula']=escapexml(csf_to_ods_formula(cell.f));if(cell.F){if(cell.F.slice(0,ref.length)==ref){var _Fref=decode_range(cell.F);ct['table:number-matrix-columns-spanned']=_Fref.e.c-_Fref.s.c+1;ct['table:number-matrix-rows-spanned']=_Fref.e.r-_Fref.s.r+1;}}}if(!cell){o.push(null_cell_xml);continue;}switch(cell.t){case'b':textp=cell.v?'TRUE':'FALSE';ct['office:value-type']="boolean";ct['office:boolean-value']=cell.v?'true':'false';break;case'n':textp=cell.w||String(cell.v||0);ct['office:value-type']="float";ct['office:value']=cell.v||0;break;case's':case'str':textp=cell.v==null?"":cell.v;ct['office:value-type']="string";break;case'd':textp=cell.w||parseDate(cell.v).toISOString();ct['office:value-type']="date";ct['office:date-value']=parseDate(cell.v).toISOString();ct['table:style-name']="ce1";break;//case 'e':
default:o.push(null_cell_xml);continue;}var text_p=write_text_p(textp);if(cell.l&&cell.l.Target){var _tgt=cell.l.Target;_tgt=_tgt.charAt(0)=="#"?"#"+csf_to_ods_3D(_tgt.slice(1)):_tgt;// TODO: choose correct parent path format based on link delimiters
if(_tgt.charAt(0)!="#"&&!_tgt.match(/^\w+:/))_tgt='../'+_tgt;text_p=writextag('text:a',text_p,{'xlink:href':_tgt.replace(/&/g,"&amp;")});}o.push('          '+writextag('table:table-cell',writextag('text:p',text_p,{}),ct)+'\n');}o.push('        </table:table-row>\n');}o.push('      </table:table>\n');return o.join("");};var write_automatic_styles_ods=function write_automatic_styles_ods(o/*:Array<string>*/,wb){o.push(' <office:automatic-styles>\n');o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');o.push('   <number:month number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:day number:style="long"/>\n');o.push('   <number:text>/</number:text>\n');o.push('   <number:year/>\n');o.push('  </number:date-style>\n');/* column styles */var cidx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!cols"]){for(var C=0;C<ws["!cols"].length;++C){if(ws["!cols"][C]){var colobj=ws["!cols"][C];if(colobj.width==null&&colobj.wpx==null&&colobj.wch==null)continue;process_col(colobj);colobj.ods=cidx;var w=ws["!cols"][C].wpx+"px";o.push('  <style:style style:name="co'+cidx+'" style:family="table-column">\n');o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="'+w+'"/>\n');o.push('  </style:style>\n');++cidx;}}}});/* row styles */var ridx=0;wb.SheetNames.map(function(n){return wb.Sheets[n];}).forEach(function(ws){if(!ws)return;if(ws["!rows"]){for(var R=0;R<ws["!rows"].length;++R){if(ws["!rows"][R]){ws["!rows"][R].ods=ridx;var h=ws["!rows"][R].hpx+"px";o.push('  <style:style style:name="ro'+ridx+'" style:family="table-row">\n');o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="'+h+'"/>\n');o.push('  </style:style>\n');++ridx;}}}});/* table */o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');o.push('  </style:style>\n');/* table cells, text */o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');/* page-layout */o.push(' </office:automatic-styles>\n');};return function wcx(wb,opts){var o=[XML_HEADER];/* 3.1.3.2 */var attr=wxt_helper({'xmlns:office':"urn:oasis:names:tc:opendocument:xmlns:office:1.0",'xmlns:table':"urn:oasis:names:tc:opendocument:xmlns:table:1.0",'xmlns:style':"urn:oasis:names:tc:opendocument:xmlns:style:1.0",'xmlns:text':"urn:oasis:names:tc:opendocument:xmlns:text:1.0",'xmlns:draw':"urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",'xmlns:fo':"urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",'xmlns:xlink':"http://www.w3.org/1999/xlink",'xmlns:dc':"http://purl.org/dc/elements/1.1/",'xmlns:meta':"urn:oasis:names:tc:opendocument:xmlns:meta:1.0",'xmlns:number':"urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",'xmlns:presentation':"urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",'xmlns:svg':"urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",'xmlns:chart':"urn:oasis:names:tc:opendocument:xmlns:chart:1.0",'xmlns:dr3d':"urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",'xmlns:math':"http://www.w3.org/1998/Math/MathML",'xmlns:form':"urn:oasis:names:tc:opendocument:xmlns:form:1.0",'xmlns:script':"urn:oasis:names:tc:opendocument:xmlns:script:1.0",'xmlns:ooo':"http://openoffice.org/2004/office",'xmlns:ooow':"http://openoffice.org/2004/writer",'xmlns:oooc':"http://openoffice.org/2004/calc",'xmlns:dom':"http://www.w3.org/2001/xml-events",'xmlns:xforms':"http://www.w3.org/2002/xforms",'xmlns:xsd':"http://www.w3.org/2001/XMLSchema",'xmlns:xsi':"http://www.w3.org/2001/XMLSchema-instance",'xmlns:sheet':"urn:oasis:names:tc:opendocument:sh33tjs:1.0",'xmlns:rpt':"http://openoffice.org/2005/report",'xmlns:of':"urn:oasis:names:tc:opendocument:xmlns:of:1.2",'xmlns:xhtml':"http://www.w3.org/1999/xhtml",'xmlns:grddl':"http://www.w3.org/2003/g/data-view#",'xmlns:tableooo':"http://openoffice.org/2009/table",'xmlns:drawooo':"http://openoffice.org/2010/draw",'xmlns:calcext':"urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",'xmlns:loext':"urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",'xmlns:field':"urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",'xmlns:formx':"urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",'xmlns:css3t':"http://www.w3.org/TR/css3-text/",'office:version':"1.2"});var fods=wxt_helper({'xmlns:config':"urn:oasis:names:tc:opendocument:xmlns:config:1.0",'office:mimetype':"application/vnd.oasis.opendocument.spreadsheet"});if(opts.bookType=="fods"){o.push('<office:document'+attr+fods+'>\n');o.push(write_meta_ods().replace(/office:document-meta/g,"office:meta"));// TODO: settings (equiv of settings.xml for ODS)
}else o.push('<office:document-content'+attr+'>\n');// o.push('  <office:scripts/>\n');
write_automatic_styles_ods(o,wb);o.push('  <office:body>\n');o.push('    <office:spreadsheet>\n');for(var i=0;i!=wb.SheetNames.length;++i){o.push(write_ws(wb.Sheets[wb.SheetNames[i]],wb,i,opts));}o.push('    </office:spreadsheet>\n');o.push('  </office:body>\n');if(opts.bookType=="fods")o.push('</office:document>');else o.push('</office:document-content>');return o.join("");};}();function write_ods(wb/*:any*/,opts/*:any*/){if(opts.bookType=="fods")return write_content_ods(wb,opts);var zip=zip_new();var f="";var manifest/*:Array<Array<string> >*/=[];var rdf/*:Array<[string, string]>*/=[];/* Part 3 Section 3.3 MIME Media Type */f="mimetype";zip_add_file(zip,f,"application/vnd.oasis.opendocument.spreadsheet");/* Part 1 Section 2.2 Documents */f="content.xml";zip_add_file(zip,f,write_content_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"ContentFile"]);/* TODO: these are hard-coded styles to satiate excel */f="styles.xml";zip_add_file(zip,f,write_styles_ods(wb,opts));manifest.push([f,"text/xml"]);rdf.push([f,"StylesFile"]);/* TODO: this is hard-coded to satiate excel */f="meta.xml";zip_add_file(zip,f,XML_HEADER+write_meta_ods()/*::wb, opts*/);manifest.push([f,"text/xml"]);rdf.push([f,"MetadataFile"]);/* Part 3 Section 6 Metadata Manifest File */f="manifest.rdf";zip_add_file(zip,f,write_rdf(rdf/*, opts*/));manifest.push([f,"application/rdf+xml"]);/* Part 3 Section 4 Manifest File */f="META-INF/manifest.xml";zip_add_file(zip,f,write_manifest(manifest/*, opts*/));return zip;}/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */function u8_to_dataview(array){return new DataView(array.buffer,array.byteOffset,array.byteLength);}function u8str(u8){return typeof TextDecoder!="undefined"?new TextDecoder().decode(u8):utf8read(a2s(u8));}function stru8(str){return typeof TextEncoder!="undefined"?new TextEncoder().encode(str):s2a(utf8write(str));}function u8contains(body,search){outer:for(var L=0;L<=body.length-search.length;++L){for(var j=0;j<search.length;++j){if(body[L+j]!=search[j])continue outer;}return true;}return false;}function u8concat(u8a){var len=u8a.reduce(function(acc,x){return acc+x.length;},0);var out=new Uint8Array(len);var off=0;u8a.forEach(function(u8){out.set(u8,off);off+=u8.length;});return out;}function popcnt(x){x-=x>>1&1431655765;x=(x&858993459)+(x>>2&858993459);return(x+(x>>4)&252645135)*16843009>>>24;}function readDecimal128LE(buf,offset){var exp=(buf[offset+15]&127)<<7|buf[offset+14]>>1;var mantissa=buf[offset+14]&1;for(var j=offset+13;j>=offset;--j){mantissa=mantissa*256+buf[j];}return(buf[offset+15]&128?-mantissa:mantissa)*Math.pow(10,exp-6176);}function writeDecimal128LE(buf,offset,value){var exp=Math.floor(value==0?0:Math.LOG10E*Math.log(Math.abs(value)))+6176-20;var mantissa=value/Math.pow(10,exp-6176);buf[offset+15]|=exp>>7;buf[offset+14]|=(exp&127)<<1;for(var i=0;mantissa>=1;++i,mantissa/=256){buf[offset+i]=mantissa&255;}buf[offset+15]|=value>=0?0:128;}function parse_varint49(buf,ptr){var l=ptr?ptr[0]:0;var usz=buf[l]&127;varint:if(buf[l++]>=128){usz|=(buf[l]&127)<<7;if(buf[l++]<128)break varint;usz|=(buf[l]&127)<<14;if(buf[l++]<128)break varint;usz|=(buf[l]&127)<<21;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,28);++l;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,35);++l;if(buf[l++]<128)break varint;usz+=(buf[l]&127)*Math.pow(2,42);++l;if(buf[l++]<128)break varint;}if(ptr)ptr[0]=l;return usz;}function write_varint49(v){var usz=new Uint8Array(7);usz[0]=v&127;var L=1;sz:if(v>127){usz[L-1]|=128;usz[L]=v>>7&127;++L;if(v<=16383)break sz;usz[L-1]|=128;usz[L]=v>>14&127;++L;if(v<=2097151)break sz;usz[L-1]|=128;usz[L]=v>>21&127;++L;if(v<=268435455)break sz;usz[L-1]|=128;usz[L]=v/256>>>21&127;++L;if(v<=34359738367)break sz;usz[L-1]|=128;usz[L]=v/65536>>>21&127;++L;if(v<=4398046511103)break sz;usz[L-1]|=128;usz[L]=v/16777216>>>21&127;++L;}return usz.slice(0,L);}function varint_to_i32(buf){var l=0,i32=buf[l]&127;varint:if(buf[l++]>=128){i32|=(buf[l]&127)<<7;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<14;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<21;if(buf[l++]<128)break varint;i32|=(buf[l]&127)<<28;}return i32;}function parse_shallow(buf){var out=[],ptr=[0];while(ptr[0]<buf.length){var off=ptr[0];var num=parse_varint49(buf,ptr);var type=num&7;num=Math.floor(num/8);var len=0;var res;if(num==0)break;switch(type){case 0:{var l=ptr[0];while(buf[ptr[0]++]>=128){}res=buf.slice(l,ptr[0]);}break;case 5:len=4;res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 1:len=8;res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 2:len=parse_varint49(buf,ptr);res=buf.slice(ptr[0],ptr[0]+len);ptr[0]+=len;break;case 3:case 4:default:throw new Error("PB Type ".concat(type," for Field ").concat(num," at offset ").concat(off));}var v={data:res,type:type};if(out[num]==null)out[num]=[v];else out[num].push(v);}return out;}function write_shallow(proto){var out=[];proto.forEach(function(field,idx){field.forEach(function(item){if(!item.data)return;out.push(write_varint49(idx*8+item.type));if(item.type==2)out.push(write_varint49(item.data.length));out.push(item.data);});});return u8concat(out);}function mappa(data,cb){return(data==null?void 0:data.map(function(d){return cb(d.data);}))||[];}function parse_iwa_file(buf){var _a;var out=[],ptr=[0];while(ptr[0]<buf.length){var len=parse_varint49(buf,ptr);var ai=parse_shallow(buf.slice(ptr[0],ptr[0]+len));ptr[0]+=len;var res={id:varint_to_i32(ai[1][0].data),messages:[]};ai[2].forEach(function(b){var mi=parse_shallow(b.data);var fl=varint_to_i32(mi[3][0].data);res.messages.push({meta:mi,data:buf.slice(ptr[0],ptr[0]+fl)});ptr[0]+=fl;});if((_a=ai[3])==null?void 0:_a[0])res.merge=varint_to_i32(ai[3][0].data)>>>0>0;out.push(res);}return out;}function write_iwa_file(ias){var bufs=[];ias.forEach(function(ia){var ai=[];ai[1]=[{data:write_varint49(ia.id),type:0}];ai[2]=[];if(ia.merge!=null)ai[3]=[{data:write_varint49(+!!ia.merge),type:0}];var midata=[];ia.messages.forEach(function(mi){midata.push(mi.data);mi.meta[3]=[{type:0,data:write_varint49(mi.data.length)}];ai[2].push({data:write_shallow(mi.meta),type:2});});var aipayload=write_shallow(ai);bufs.push(write_varint49(aipayload.length));bufs.push(aipayload);midata.forEach(function(mid){return bufs.push(mid);});});return u8concat(bufs);}function parse_snappy_chunk(type,buf){if(type!=0)throw new Error("Unexpected Snappy chunk type ".concat(type));var ptr=[0];var usz=parse_varint49(buf,ptr);var chunks=[];while(ptr[0]<buf.length){var tag=buf[ptr[0]]&3;if(tag==0){var len=buf[ptr[0]++]>>2;if(len<60)++len;else{var c=len-59;len=buf[ptr[0]];if(c>1)len|=buf[ptr[0]+1]<<8;if(c>2)len|=buf[ptr[0]+2]<<16;if(c>3)len|=buf[ptr[0]+3]<<24;len>>>=0;len++;ptr[0]+=c;}chunks.push(buf.slice(ptr[0],ptr[0]+len));ptr[0]+=len;continue;}else{var offset=0,length=0;if(tag==1){length=(buf[ptr[0]]>>2&7)+4;offset=(buf[ptr[0]++]&224)<<3;offset|=buf[ptr[0]++];}else{length=(buf[ptr[0]++]>>2)+1;if(tag==2){offset=buf[ptr[0]]|buf[ptr[0]+1]<<8;ptr[0]+=2;}else{offset=(buf[ptr[0]]|buf[ptr[0]+1]<<8|buf[ptr[0]+2]<<16|buf[ptr[0]+3]<<24)>>>0;ptr[0]+=4;}}chunks=[u8concat(chunks)];if(offset==0)throw new Error("Invalid offset 0");if(offset>chunks[0].length)throw new Error("Invalid offset beyond length");if(length>=offset){chunks.push(chunks[0].slice(-offset));length-=offset;while(length>=chunks[chunks.length-1].length){chunks.push(chunks[chunks.length-1]);length-=chunks[chunks.length-1].length;}}chunks.push(chunks[0].slice(-offset,-offset+length));}}var o=u8concat(chunks);if(o.length!=usz)throw new Error("Unexpected length: ".concat(o.length," != ").concat(usz));return o;}function decompress_iwa_file(buf){var out=[];var l=0;while(l<buf.length){var t=buf[l++];var len=buf[l]|buf[l+1]<<8|buf[l+2]<<16;l+=3;out.push(parse_snappy_chunk(t,buf.slice(l,l+len)));l+=len;}if(l!==buf.length)throw new Error("data is not a valid framed stream!");return u8concat(out);}function compress_iwa_file(buf){var out=[];var l=0;while(l<buf.length){var c=Math.min(buf.length-l,268435455);var frame=new Uint8Array(4);out.push(frame);var usz=write_varint49(c);var L=usz.length;out.push(usz);if(c<=60){L++;out.push(new Uint8Array([c-1<<2]));}else if(c<=256){L+=2;out.push(new Uint8Array([240,c-1&255]));}else if(c<=65536){L+=3;out.push(new Uint8Array([244,c-1&255,c-1>>8&255]));}else if(c<=16777216){L+=4;out.push(new Uint8Array([248,c-1&255,c-1>>8&255,c-1>>16&255]));}else if(c<=4294967296){L+=5;out.push(new Uint8Array([252,c-1&255,c-1>>8&255,c-1>>16&255,c-1>>>24&255]));}out.push(buf.slice(l,l+c));L+=c;frame[0]=0;frame[1]=L&255;frame[2]=L>>8&255;frame[3]=L>>16&255;l+=c;}return u8concat(out);}function parse_old_storage(buf,sst,rsst,v){var dv=u8_to_dataview(buf);var flags=dv.getUint32(4,true);var data_offset=(v>1?12:8)+popcnt(flags&(v>1?3470:398))*4;var ridx=-1,sidx=-1,ieee=NaN,dt=new Date(2001,0,1);if(flags&512){ridx=dv.getUint32(data_offset,true);data_offset+=4;}data_offset+=popcnt(flags&(v>1?12288:4096))*4;if(flags&16){sidx=dv.getUint32(data_offset,true);data_offset+=4;}if(flags&32){ieee=dv.getFloat64(data_offset,true);data_offset+=8;}if(flags&64){dt.setTime(dt.getTime()+dv.getFloat64(data_offset,true)*1e3);data_offset+=8;}var ret;switch(buf[2]){case 0:break;case 2:ret={t:"n",v:ieee};break;case 3:ret={t:"s",v:sst[sidx]};break;case 5:ret={t:"d",v:dt};break;case 6:ret={t:"b",v:ieee>0};break;case 7:ret={t:"n",v:ieee/86400};break;case 8:ret={t:"e",v:0};break;case 9:{if(ridx>-1)ret={t:"s",v:rsst[ridx]};else if(sidx>-1)ret={t:"s",v:sst[sidx]};else if(!isNaN(ieee))ret={t:"n",v:ieee};else throw new Error("Unsupported cell type ".concat(buf.slice(0,4)));}break;default:throw new Error("Unsupported cell type ".concat(buf.slice(0,4)));}return ret;}function parse_new_storage(buf,sst,rsst){var dv=u8_to_dataview(buf);var flags=dv.getUint32(8,true);var data_offset=12;var ridx=-1,sidx=-1,d128=NaN,ieee=NaN,dt=new Date(2001,0,1);if(flags&1){d128=readDecimal128LE(buf,data_offset);data_offset+=16;}if(flags&2){ieee=dv.getFloat64(data_offset,true);data_offset+=8;}if(flags&4){dt.setTime(dt.getTime()+dv.getFloat64(data_offset,true)*1e3);data_offset+=8;}if(flags&8){sidx=dv.getUint32(data_offset,true);data_offset+=4;}if(flags&16){ridx=dv.getUint32(data_offset,true);data_offset+=4;}var ret;switch(buf[1]){case 0:break;case 2:ret={t:"n",v:d128};break;case 3:ret={t:"s",v:sst[sidx]};break;case 5:ret={t:"d",v:dt};break;case 6:ret={t:"b",v:ieee>0};break;case 7:ret={t:"n",v:ieee/86400};break;case 8:ret={t:"e",v:0};break;case 9:{if(ridx>-1)ret={t:"s",v:rsst[ridx]};else throw new Error("Unsupported cell type ".concat(buf[1]," : ").concat(flags&31," : ").concat(buf.slice(0,4)));}break;case 10:ret={t:"n",v:d128};break;default:throw new Error("Unsupported cell type ".concat(buf[1]," : ").concat(flags&31," : ").concat(buf.slice(0,4)));}return ret;}function write_new_storage(cell,sst){var out=new Uint8Array(32),dv=u8_to_dataview(out),l=12,flags=0;out[0]=5;switch(cell.t){case"n":out[1]=2;writeDecimal128LE(out,l,cell.v);flags|=1;l+=16;break;case"b":out[1]=6;dv.setFloat64(l,cell.v?1:0,true);flags|=2;l+=8;break;case"s":if(sst.indexOf(cell.v)==-1)throw new Error("Value ".concat(cell.v," missing from SST!"));out[1]=3;dv.setUint32(l,sst.indexOf(cell.v),true);flags|=8;l+=4;break;default:throw"unsupported cell type "+cell.t;}dv.setUint32(8,flags,true);return out.slice(0,l);}function write_old_storage(cell,sst){var out=new Uint8Array(32),dv=u8_to_dataview(out),l=12,flags=0;out[0]=3;switch(cell.t){case"n":out[2]=2;dv.setFloat64(l,cell.v,true);flags|=32;l+=8;break;case"b":out[2]=6;dv.setFloat64(l,cell.v?1:0,true);flags|=32;l+=8;break;case"s":if(sst.indexOf(cell.v)==-1)throw new Error("Value ".concat(cell.v," missing from SST!"));out[2]=3;dv.setUint32(l,sst.indexOf(cell.v),true);flags|=16;l+=4;break;default:throw"unsupported cell type "+cell.t;}dv.setUint32(4,flags,true);return out.slice(0,l);}function parse_cell_storage(buf,sst,rsst){switch(buf[0]){case 0:case 1:case 2:case 3:return parse_old_storage(buf,sst,rsst,buf[0]);case 5:return parse_new_storage(buf,sst,rsst);default:throw new Error("Unsupported payload version ".concat(buf[0]));}}function parse_TSP_Reference(buf){var pb=parse_shallow(buf);return parse_varint49(pb[1][0].data);}function write_TSP_Reference(idx){var out=[];out[1]=[{type:0,data:write_varint49(idx)}];return write_shallow(out);}function parse_TST_TableDataList(M,root){var pb=parse_shallow(root.data);var type=varint_to_i32(pb[1][0].data);var entries=pb[3];var data=[];(entries||[]).forEach(function(entry){var le=parse_shallow(entry.data);var key=varint_to_i32(le[1][0].data)>>>0;switch(type){case 1:data[key]=u8str(le[3][0].data);break;case 8:{var rt=M[parse_TSP_Reference(le[9][0].data)][0];var rtp=parse_shallow(rt.data);var rtpref=M[parse_TSP_Reference(rtp[1][0].data)][0];var mtype=varint_to_i32(rtpref.meta[1][0].data);if(mtype!=2001)throw new Error("2000 unexpected reference to ".concat(mtype));var tswpsa=parse_shallow(rtpref.data);data[key]=tswpsa[3].map(function(x){return u8str(x.data);}).join("");}break;}});return data;}function parse_TST_TileRowInfo(u8,type){var _a,_b,_c,_d,_e,_f,_g,_h,_i,_j,_k,_l,_m,_n;var pb=parse_shallow(u8);var R=varint_to_i32(pb[1][0].data)>>>0;var cnt=varint_to_i32(pb[2][0].data)>>>0;var wide_offsets=((_b=(_a=pb[8])==null?void 0:_a[0])==null?void 0:_b.data)&&varint_to_i32(pb[8][0].data)>0||false;var used_storage_u8,used_storage;if(((_d=(_c=pb[7])==null?void 0:_c[0])==null?void 0:_d.data)&&type!=0){used_storage_u8=(_f=(_e=pb[7])==null?void 0:_e[0])==null?void 0:_f.data;used_storage=(_h=(_g=pb[6])==null?void 0:_g[0])==null?void 0:_h.data;}else if(((_j=(_i=pb[4])==null?void 0:_i[0])==null?void 0:_j.data)&&type!=1){used_storage_u8=(_l=(_k=pb[4])==null?void 0:_k[0])==null?void 0:_l.data;used_storage=(_n=(_m=pb[3])==null?void 0:_m[0])==null?void 0:_n.data;}else throw"NUMBERS Tile missing ".concat(type," cell storage");var width=wide_offsets?4:1;var used_storage_offsets=u8_to_dataview(used_storage_u8);var offsets=[];for(var C=0;C<used_storage_u8.length/2;++C){var off=used_storage_offsets.getUint16(C*2,true);if(off<65535)offsets.push([C,off]);}if(offsets.length!=cnt)throw"Expected ".concat(cnt," cells, found ").concat(offsets.length);var cells=[];for(C=0;C<offsets.length-1;++C){cells[offsets[C][0]]=used_storage.subarray(offsets[C][1]*width,offsets[C+1][1]*width);}if(offsets.length>=1)cells[offsets[offsets.length-1][0]]=used_storage.subarray(offsets[offsets.length-1][1]*width);return{R:R,cells:cells};}function parse_TST_Tile(M,root){var _a;var pb=parse_shallow(root.data);var storage=((_a=pb==null?void 0:pb[7])==null?void 0:_a[0])?varint_to_i32(pb[7][0].data)>>>0>0?1:0:-1;var ri=mappa(pb[5],function(u8){return parse_TST_TileRowInfo(u8,storage);});return{nrows:varint_to_i32(pb[4][0].data)>>>0,data:ri.reduce(function(acc,x){if(!acc[x.R])acc[x.R]=[];x.cells.forEach(function(cell,C){if(acc[x.R][C])throw new Error("Duplicate cell r=".concat(x.R," c=").concat(C));acc[x.R][C]=cell;});return acc;},[])};}function parse_TST_TableModelArchive(M,root,ws){var _a;var pb=parse_shallow(root.data);var range={s:{r:0,c:0},e:{r:0,c:0}};range.e.r=(varint_to_i32(pb[6][0].data)>>>0)-1;if(range.e.r<0)throw new Error("Invalid row varint ".concat(pb[6][0].data));range.e.c=(varint_to_i32(pb[7][0].data)>>>0)-1;if(range.e.c<0)throw new Error("Invalid col varint ".concat(pb[7][0].data));ws["!ref"]=encode_range(range);var store=parse_shallow(pb[4][0].data);var sst=parse_TST_TableDataList(M,M[parse_TSP_Reference(store[4][0].data)][0]);var rsst=((_a=store[17])==null?void 0:_a[0])?parse_TST_TableDataList(M,M[parse_TSP_Reference(store[17][0].data)][0]):[];var tile=parse_shallow(store[3][0].data);var _R=0;tile[1].forEach(function(t){var tl=parse_shallow(t.data);var ref=M[parse_TSP_Reference(tl[2][0].data)][0];var mtype=varint_to_i32(ref.meta[1][0].data);if(mtype!=6002)throw new Error("6001 unexpected reference to ".concat(mtype));var _tile=parse_TST_Tile(M,ref);_tile.data.forEach(function(row,R){row.forEach(function(buf,C){var addr=encode_cell({r:_R+R,c:C});var res=parse_cell_storage(buf,sst,rsst);if(res)ws[addr]=res;});});_R+=_tile.nrows;});}function parse_TST_TableInfoArchive(M,root){var pb=parse_shallow(root.data);var out={"!ref":"A1"};var tableref=M[parse_TSP_Reference(pb[2][0].data)];var mtype=varint_to_i32(tableref[0].meta[1][0].data);if(mtype!=6001)throw new Error("6000 unexpected reference to ".concat(mtype));parse_TST_TableModelArchive(M,tableref[0],out);return out;}function parse_TN_SheetArchive(M,root){var _a;var pb=parse_shallow(root.data);var out={name:((_a=pb[1])==null?void 0:_a[0])?u8str(pb[1][0].data):"",sheets:[]};var shapeoffs=mappa(pb[2],parse_TSP_Reference);shapeoffs.forEach(function(off){M[off].forEach(function(m){var mtype=varint_to_i32(m.meta[1][0].data);if(mtype==6e3)out.sheets.push(parse_TST_TableInfoArchive(M,m));});});return out;}function parse_TN_DocumentArchive(M,root){var out=book_new();var pb=parse_shallow(root.data);var sheetoffs=mappa(pb[1],parse_TSP_Reference);sheetoffs.forEach(function(off){M[off].forEach(function(m){var mtype=varint_to_i32(m.meta[1][0].data);if(mtype==2){var root2=parse_TN_SheetArchive(M,m);root2.sheets.forEach(function(sheet,idx){book_append_sheet(out,sheet,idx==0?root2.name:root2.name+"_"+idx,true);});}});});if(out.SheetNames.length==0)throw new Error("Empty NUMBERS file");return out;}function parse_numbers_iwa(cfb){var _a,_b,_c,_d;var M={},indices=[];cfb.FullPaths.forEach(function(p){if(p.match(/\.iwpv2/))throw new Error("Unsupported password protection");});cfb.FileIndex.forEach(function(s){if(!s.name.match(/\.iwa$/))return;var o;try{o=decompress_iwa_file(s.content);}catch(e){return console.log("?? "+s.content.length+" "+(e.message||e));}var packets;try{packets=parse_iwa_file(o);}catch(e){return console.log("## "+(e.message||e));}packets.forEach(function(packet){M[packet.id]=packet.messages;indices.push(packet.id);});});if(!indices.length)throw new Error("File has no messages");var docroot=((_d=(_c=(_b=(_a=M==null?void 0:M[1])==null?void 0:_a[0])==null?void 0:_b.meta)==null?void 0:_c[1])==null?void 0:_d[0].data)&&varint_to_i32(M[1][0].meta[1][0].data)==1&&M[1][0];if(!docroot)indices.forEach(function(idx){M[idx].forEach(function(iwam){var mtype=varint_to_i32(iwam.meta[1][0].data)>>>0;if(mtype==1){if(!docroot)docroot=iwam;else throw new Error("Document has multiple roots");}});});if(!docroot)throw new Error("Cannot find Document root");return parse_TN_DocumentArchive(M,docroot);}function write_tile_row(tri,data,SST){var _a,_b,_c,_d;if(!((_a=tri[6])==null?void 0:_a[0])||!((_b=tri[7])==null?void 0:_b[0]))throw"Mutation only works on post-BNC storages!";var wide_offsets=((_d=(_c=tri[8])==null?void 0:_c[0])==null?void 0:_d.data)&&varint_to_i32(tri[8][0].data)>0||false;if(wide_offsets)throw"Math only works with normal offsets";var cnt=0;var dv=u8_to_dataview(tri[7][0].data),last_offset=0,cell_storage=[];var _dv=u8_to_dataview(tri[4][0].data),_last_offset=0,_cell_storage=[];for(var C=0;C<data.length;++C){if(data[C]==null){dv.setUint16(C*2,65535,true);_dv.setUint16(C*2,65535);continue;}dv.setUint16(C*2,last_offset,true);_dv.setUint16(C*2,_last_offset,true);var celload,_celload;switch((0,_typeof3.default)(data[C])){case"string":celload=write_new_storage({t:"s",v:data[C]},SST);_celload=write_old_storage({t:"s",v:data[C]},SST);break;case"number":celload=write_new_storage({t:"n",v:data[C]},SST);_celload=write_old_storage({t:"n",v:data[C]},SST);break;case"boolean":celload=write_new_storage({t:"b",v:data[C]},SST);_celload=write_old_storage({t:"b",v:data[C]},SST);break;default:throw new Error("Unsupported value "+data[C]);}cell_storage.push(celload);last_offset+=celload.length;_cell_storage.push(_celload);_last_offset+=_celload.length;++cnt;}tri[2][0].data=write_varint49(cnt);for(;C<tri[7][0].data.length/2;++C){dv.setUint16(C*2,65535,true);_dv.setUint16(C*2,65535,true);}tri[6][0].data=u8concat(cell_storage);tri[3][0].data=u8concat(_cell_storage);return cnt;}function write_numbers_iwa(wb,opts){if(!opts||!opts.numbers)throw new Error("Must pass a `numbers` option -- check the README");var ws=wb.Sheets[wb.SheetNames[0]];if(wb.SheetNames.length>1)console.error("The Numbers writer currently writes only the first table");var range=decode_range(ws["!ref"]);range.s.r=range.s.c=0;var trunc=false;if(range.e.c>9){trunc=true;range.e.c=9;}if(range.e.r>49){trunc=true;range.e.r=49;}if(trunc)console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));var data=sheet_to_json(ws,{range:range,header:1});var SST=["~Sh33tJ5~"];data.forEach(function(row){return row.forEach(function(cell){if(typeof cell=="string")SST.push(cell);});});var dependents={};var indices=[];var cfb=CFB.read(opts.numbers,{type:"base64"});cfb.FileIndex.map(function(fi,idx){return[fi,cfb.FullPaths[idx]];}).forEach(function(row){var fi=row[0],fp=row[1];if(fi.type!=2)return;if(!fi.name.match(/\.iwa/))return;var old_content=fi.content;var raw1=decompress_iwa_file(old_content);var x2=parse_iwa_file(raw1);x2.forEach(function(packet2){indices.push(packet2.id);dependents[packet2.id]={deps:[],location:fp,type:varint_to_i32(packet2.messages[0].meta[1][0].data)};});});indices.sort(function(x2,y2){return x2-y2;});var indices_varint=indices.filter(function(x2){return x2>1;}).map(function(x2){return[x2,write_varint49(x2)];});cfb.FileIndex.map(function(fi,idx){return[fi,cfb.FullPaths[idx]];}).forEach(function(row){var fi=row[0],fp=row[1];if(!fi.name.match(/\.iwa/))return;var x2=parse_iwa_file(decompress_iwa_file(fi.content));x2.forEach(function(ia){ia.messages.forEach(function(m){indices_varint.forEach(function(ivi){if(ia.messages.some(function(mess){return varint_to_i32(mess.meta[1][0].data)!=11006&&u8contains(mess.data,ivi[1]);})){dependents[ivi[0]].deps.push(ia.id);}});});});});function get_unique_msgid(){for(var i=927262;i<2e6;++i){if(!dependents[i])return i;}throw new Error("Too many messages");}var entry=CFB.find(cfb,dependents[1].location);var x=parse_iwa_file(decompress_iwa_file(entry.content));var docroot;for(var xi=0;xi<x.length;++xi){var packet=x[xi];if(packet.id==1)docroot=packet;}var sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}sheetrootref=parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);entry=CFB.find(cfb,dependents[sheetrootref].location);x=parse_iwa_file(decompress_iwa_file(entry.content));for(xi=0;xi<x.length;++xi){packet=x[xi];if(packet.id==sheetrootref)docroot=packet;}var pb=parse_shallow(docroot.messages[0].data);{pb[6][0].data=write_varint49(range.e.r+1);pb[7][0].data=write_varint49(range.e.c+1);var cruidsref=parse_TSP_Reference(pb[46][0].data);var oldbucket=CFB.find(cfb,dependents[cruidsref].location);var _x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{for(var j=0;j<_x.length;++j){if(_x[j].id==cruidsref)break;}if(_x[j].id!=cruidsref)throw"Bad ColumnRowUIDMapArchive";var cruids=parse_shallow(_x[j].messages[0].data);cruids[1]=[];cruids[2]=[],cruids[3]=[];for(var C=0;C<=range.e.c;++C){var uuid=[];uuid[1]=uuid[2]=[{type:0,data:write_varint49(C+420690)}];cruids[1].push({type:2,data:write_shallow(uuid)});cruids[2].push({type:0,data:write_varint49(C)});cruids[3].push({type:0,data:write_varint49(C)});}cruids[4]=[];cruids[5]=[],cruids[6]=[];for(var R=0;R<=range.e.r;++R){uuid=[];uuid[1]=uuid[2]=[{type:0,data:write_varint49(R+726270)}];cruids[4].push({type:2,data:write_shallow(uuid)});cruids[5].push({type:0,data:write_varint49(R)});cruids[6].push({type:0,data:write_varint49(R)});}_x[j].messages[0].data=write_shallow(cruids);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;delete pb[46];var store=parse_shallow(pb[4][0].data);{store[7][0].data=write_varint49(range.e.r+1);var row_headers=parse_shallow(store[1][0].data);var row_header_ref=parse_TSP_Reference(row_headers[2][0].data);oldbucket=CFB.find(cfb,dependents[row_header_ref].location);_x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{if(_x[0].id!=row_header_ref)throw"Bad HeaderStorageBucket";var base_bucket=parse_shallow(_x[0].messages[0].data);for(R=0;R<data.length;++R){var _bucket=parse_shallow(base_bucket[2][0].data);_bucket[1][0].data=write_varint49(R);_bucket[4][0].data=write_varint49(data[R].length);base_bucket[2][R]={type:base_bucket[2][0].type,data:write_shallow(_bucket)};}_x[0].messages[0].data=write_shallow(base_bucket);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;var col_header_ref=parse_TSP_Reference(store[2][0].data);oldbucket=CFB.find(cfb,dependents[col_header_ref].location);_x=parse_iwa_file(decompress_iwa_file(oldbucket.content));{if(_x[0].id!=col_header_ref)throw"Bad HeaderStorageBucket";base_bucket=parse_shallow(_x[0].messages[0].data);for(C=0;C<=range.e.c;++C){_bucket=parse_shallow(base_bucket[2][0].data);_bucket[1][0].data=write_varint49(C);_bucket[4][0].data=write_varint49(range.e.r+1);base_bucket[2][C]={type:base_bucket[2][0].type,data:write_shallow(_bucket)};}_x[0].messages[0].data=write_shallow(base_bucket);}oldbucket.content=compress_iwa_file(write_iwa_file(_x));oldbucket.size=oldbucket.content.length;var sstref=parse_TSP_Reference(store[4][0].data);(function(){var sentry=CFB.find(cfb,dependents[sstref].location);var sx=parse_iwa_file(decompress_iwa_file(sentry.content));var sstroot;for(var sxi=0;sxi<sx.length;++sxi){var packet2=sx[sxi];if(packet2.id==sstref)sstroot=packet2;}var sstdata=parse_shallow(sstroot.messages[0].data);{sstdata[3]=[];var newsst=[];SST.forEach(function(str,i){newsst[1]=[{type:0,data:write_varint49(i)}];newsst[2]=[{type:0,data:write_varint49(1)}];newsst[3]=[{type:2,data:stru8(str)}];sstdata[3].push({type:2,data:write_shallow(newsst)});});}sstroot.messages[0].data=write_shallow(sstdata);var sy=write_iwa_file(sx);var raw32=compress_iwa_file(sy);sentry.content=raw32;sentry.size=sentry.content.length;})();var tile=parse_shallow(store[3][0].data);{var t=tile[1][0];delete tile[2];var tl=parse_shallow(t.data);{var tileref=parse_TSP_Reference(tl[2][0].data);(function(){var tentry=CFB.find(cfb,dependents[tileref].location);var tx=parse_iwa_file(decompress_iwa_file(tentry.content));var tileroot;for(var sxi=0;sxi<tx.length;++sxi){var packet2=tx[sxi];if(packet2.id==tileref)tileroot=packet2;}var tiledata=parse_shallow(tileroot.messages[0].data);{delete tiledata[6];delete tile[7];var rowload=new Uint8Array(tiledata[5][0].data);tiledata[5]=[];var cnt=0;for(var R2=0;R2<=range.e.r;++R2){var tilerow=parse_shallow(rowload);cnt+=write_tile_row(tilerow,data[R2],SST);tilerow[1][0].data=write_varint49(R2);tiledata[5].push({data:write_shallow(tilerow),type:2});}tiledata[1]=[{type:0,data:write_varint49(range.e.c+1)}];tiledata[2]=[{type:0,data:write_varint49(range.e.r+1)}];tiledata[3]=[{type:0,data:write_varint49(cnt)}];tiledata[4]=[{type:0,data:write_varint49(range.e.r+1)}];}tileroot.messages[0].data=write_shallow(tiledata);var ty=write_iwa_file(tx);var raw32=compress_iwa_file(ty);tentry.content=raw32;tentry.size=tentry.content.length;})();}t.data=write_shallow(tl);}store[3][0].data=write_shallow(tile);}pb[4][0].data=write_shallow(store);}docroot.messages[0].data=write_shallow(pb);var y=write_iwa_file(x);var raw3=compress_iwa_file(y);entry.content=raw3;entry.size=entry.content.length;return cfb;}function fix_opts_func(defaults/*:Array<Array<any> >*/)/*:{(o:any):void}*/{return function fix_opts(opts){for(var i=0;i!=defaults.length;++i){var d=defaults[i];if(opts[d[0]]===undefined)opts[d[0]]=d[1];if(d[2]==='n')opts[d[0]]=Number(opts[d[0]]);}};}function fix_read_opts(opts){fix_opts_func([['cellNF',false],/* emit cell number format string as .z */['cellHTML',true],/* emit html string as .h */['cellFormula',true],/* emit formulae as .f */['cellStyles',false],/* emits style/theme as .s */['cellText',true],/* emit formatted text as .w */['cellDates',false],/* emit date cells with type `d` */['sheetStubs',false],/* emit empty cells */['sheetRows',0,'n'],/* read n rows (0 = read all rows) */['bookDeps',false],/* parse calculation chains */['bookSheets',false],/* only try to get sheet names (no Sheets) */['bookProps',false],/* only try to get properties (no Sheets) */['bookFiles',false],/* include raw file structure (keys, files, cfb) */['bookVBA',false],/* include vba raw data (vbaraw) */['password',''],/* password */['WTF',false]/* WTF mode (throws errors) */])(opts);}function fix_write_opts(opts){fix_opts_func([['cellDates',false],/* write date cells with type `d` */['bookSST',false],/* Generate Shared String Table */['bookType','xlsx'],/* Type of workbook (xlsx/m/b) */['compression',false],/* Use file compression */['WTF',false]/* WTF mode (throws errors) */])(opts);}function get_sheet_type(n/*:string*/)/*:string*/{if(RELS.WS.indexOf(n)>-1)return"sheet";if(RELS.CS&&n==RELS.CS)return"chart";if(RELS.DS&&n==RELS.DS)return"dialog";if(RELS.MS&&n==RELS.MS)return"macro";return n&&n.length?n:"sheet";}function safe_parse_wbrels(wbrels,sheets){if(!wbrels)return 0;try{wbrels=sheets.map(function pwbr(w){if(!w.id)w.id=w.strRelID;return[w.name,wbrels['!id'][w.id].Target,get_sheet_type(wbrels['!id'][w.id].Type)];});}catch(e){return null;}return!wbrels||wbrels.length===0?null:wbrels;}function safe_parse_sheet(zip,path/*:string*/,relsPath/*:string*/,sheet,idx/*:number*/,sheetRels,sheets,stype/*:string*/,opts,wb,themes,styles){try{sheetRels[sheet]=parse_rels(getzipstr(zip,relsPath,true),path);var data=getzipdata(zip,path);var _ws;switch(stype){case'sheet':_ws=parse_ws(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'chart':_ws=parse_cs(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);if(!_ws||!_ws['!drawel'])break;var dfile=resolve_path(_ws['!drawel'].Target,path);var drelsp=get_rels_path(dfile);var draw=parse_drawing(getzipstr(zip,dfile,true),parse_rels(getzipstr(zip,drelsp,true),dfile));var chartp=resolve_path(draw,dfile);var crelsp=get_rels_path(chartp);_ws=parse_chart(getzipstr(zip,chartp,true),chartp,opts,parse_rels(getzipstr(zip,crelsp,true),chartp),wb,_ws);break;case'macro':_ws=parse_ms(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;case'dialog':_ws=parse_ds(data,path,idx,opts,sheetRels[sheet],wb,themes,styles);break;default:throw new Error("Unrecognized sheet type "+stype);}sheets[sheet]=_ws;/* scan rels for comments and threaded comments */var tcomments=[];if(sheetRels&&sheetRels[sheet])keys(sheetRels[sheet]).forEach(function(n){var dfile="";if(sheetRels[sheet][n].Type==RELS.CMNT){dfile=resolve_path(sheetRels[sheet][n].Target,path);var comments=parse_cmnt(getzipdata(zip,dfile,true),dfile,opts);if(!comments||!comments.length)return;sheet_insert_comments(_ws,comments,false);}if(sheetRels[sheet][n].Type==RELS.TCMNT){dfile=resolve_path(sheetRels[sheet][n].Target,path);tcomments=tcomments.concat(parse_tcmnt_xml(getzipdata(zip,dfile,true),opts));}});if(tcomments&&tcomments.length)sheet_insert_comments(_ws,tcomments,true,opts.people||[]);}catch(e){if(opts.WTF)throw e;}}function strip_front_slash(x/*:string*/)/*:string*/{return x.charAt(0)=='/'?x.slice(1):x;}function parse_zip(zip/*:ZIP*/,opts/*:?ParseOpts*/)/*:Workbook*/{make_ssf();opts=opts||{};fix_read_opts(opts);/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */if(safegetzipfile(zip,'META-INF/manifest.xml'))return parse_ods(zip,opts);/* UOC */if(safegetzipfile(zip,'objectdata.xml'))return parse_ods(zip,opts);/* Numbers */if(safegetzipfile(zip,'Index/Document.iwa')){if(typeof Uint8Array=="undefined")throw new Error('NUMBERS file parsing requires Uint8Array support');if(typeof parse_numbers_iwa!="undefined"){if(zip.FileIndex)return parse_numbers_iwa(zip);var _zip=CFB.utils.cfb_new();zipentries(zip).forEach(function(e){zip_add_file(_zip,e,getzipbin(zip,e));});return parse_numbers_iwa(_zip);}throw new Error('Unsupported NUMBERS file');}if(!safegetzipfile(zip,'[Content_Types].xml')){if(safegetzipfile(zip,'index.xml.gz'))throw new Error('Unsupported NUMBERS 08 file');if(safegetzipfile(zip,'index.xml'))throw new Error('Unsupported NUMBERS 09 file');throw new Error('Unsupported ZIP file');}var entries=zipentries(zip);var dir=parse_ct(getzipstr(zip,'[Content_Types].xml')/*:?any*/);var xlsb=false;var sheets,binname;if(dir.workbooks.length===0){binname="xl/workbook.xml";if(getzipdata(zip,binname,true))dir.workbooks.push(binname);}if(dir.workbooks.length===0){binname="xl/workbook.bin";if(!getzipdata(zip,binname,true))throw new Error("Could not find workbook");dir.workbooks.push(binname);xlsb=true;}if(dir.workbooks[0].slice(-3)=="bin")xlsb=true;var themes={}/*:any*/;var styles={}/*:any*/;if(!opts.bookSheets&&!opts.bookProps){strs=[];if(dir.sst)try{strs=parse_sst(getzipdata(zip,strip_front_slash(dir.sst)),dir.sst,opts);}catch(e){if(opts.WTF)throw e;}if(opts.cellStyles&&dir.themes.length)themes=parse_theme(getzipstr(zip,dir.themes[0].replace(/^\//,''),true)||"",dir.themes[0],opts);if(dir.style)styles=parse_sty(getzipdata(zip,strip_front_slash(dir.style)),dir.style,themes,opts);}/*var externbooks = */dir.links.map(function(link){try{var rels=parse_rels(getzipstr(zip,get_rels_path(strip_front_slash(link))),link);return parse_xlink(getzipdata(zip,strip_front_slash(link)),rels,link,opts);}catch(e){}});var wb=parse_wb(getzipdata(zip,strip_front_slash(dir.workbooks[0])),dir.workbooks[0],opts);var props={},propdata="";if(dir.coreprops.length){propdata=getzipdata(zip,strip_front_slash(dir.coreprops[0]),true);if(propdata)props=parse_core_props(propdata);if(dir.extprops.length!==0){propdata=getzipdata(zip,strip_front_slash(dir.extprops[0]),true);if(propdata)parse_ext_props(propdata,props,opts);}}var custprops={};if(!opts.bookSheets||opts.bookProps){if(dir.custprops.length!==0){propdata=getzipstr(zip,strip_front_slash(dir.custprops[0]),true);if(propdata)custprops=parse_cust_props(propdata,opts);}}var out={}/*:any*/;if(opts.bookSheets||opts.bookProps){if(wb.Sheets)sheets=wb.Sheets.map(function pluck(x){return x.name;});else if(props.Worksheets&&props.SheetNames.length>0)sheets=props.SheetNames;if(opts.bookProps){out.Props=props;out.Custprops=custprops;}if(opts.bookSheets&&typeof sheets!=='undefined')out.SheetNames=sheets;if(opts.bookSheets?out.SheetNames:opts.bookProps)return out;}sheets={};var deps={};if(opts.bookDeps&&dir.calcchain)deps=parse_cc(getzipdata(zip,strip_front_slash(dir.calcchain)),dir.calcchain,opts);var i=0;var sheetRels={}/*:any*/;var path,relsPath;{var wbsheets=wb.Sheets;props.Worksheets=wbsheets.length;props.SheetNames=[];for(var j=0;j!=wbsheets.length;++j){props.SheetNames[j]=wbsheets[j].name;}}var wbext=xlsb?"bin":"xml";var wbrelsi=dir.workbooks[0].lastIndexOf("/");var wbrelsfile=(dir.workbooks[0].slice(0,wbrelsi+1)+"_rels/"+dir.workbooks[0].slice(wbrelsi+1)+".rels").replace(/^\//,"");if(!safegetzipfile(zip,wbrelsfile))wbrelsfile='xl/_rels/workbook.'+wbext+'.rels';var wbrels=parse_rels(getzipstr(zip,wbrelsfile,true),wbrelsfile.replace(/_rels.*/,"s5s"));if((dir.metadata||[]).length>=1){/* TODO: MDX and other types of metadata */opts.xlmeta=parse_xlmeta(getzipdata(zip,strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);}if((dir.people||[]).length>=1){opts.people=parse_people_xml(getzipdata(zip,strip_front_slash(dir.people[0])),opts);}if(wbrels)wbrels=safe_parse_wbrels(wbrels,wb.Sheets);/* Numbers iOS hack */var nmode=getzipdata(zip,"xl/worksheets/sheet.xml",true)?1:0;wsloop:for(i=0;i!=props.Worksheets;++i){var stype="sheet";if(wbrels&&wbrels[i]){path='xl/'+wbrels[i][1].replace(/[\/]?xl\//,"");if(!safegetzipfile(zip,path))path=wbrels[i][1];if(!safegetzipfile(zip,path))path=wbrelsfile.replace(/_rels\/.*$/,"")+wbrels[i][1];stype=wbrels[i][2];}else{path='xl/worksheets/sheet'+(i+1-nmode)+"."+wbext;path=path.replace(/sheet0\./,"sheet.");}relsPath=path.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");if(opts&&opts.sheets!=null)switch((0,_typeof3.default)(opts.sheets)){case"number":if(i!=opts.sheets)continue wsloop;break;case"string":if(props.SheetNames[i].toLowerCase()!=opts.sheets.toLowerCase())continue wsloop;break;default:if(Array.isArray&&Array.isArray(opts.sheets)){var snjseen=false;for(var snj=0;snj!=opts.sheets.length;++snj){if(typeof opts.sheets[snj]=="number"&&opts.sheets[snj]==i)snjseen=1;if(typeof opts.sheets[snj]=="string"&&opts.sheets[snj].toLowerCase()==props.SheetNames[i].toLowerCase())snjseen=1;}if(!snjseen)continue wsloop;}}safe_parse_sheet(zip,path,relsPath,props.SheetNames[i],i,sheetRels,sheets,stype,opts,wb,themes,styles);}out={Directory:dir,Workbook:wb,Props:props,Custprops:custprops,Deps:deps,Sheets:sheets,SheetNames:props.SheetNames,Strings:strs,Styles:styles,Themes:themes,SSF:dup(table_fmt)/*:any*/};if(opts&&opts.bookFiles){if(zip.files){out.keys=entries;out.files=zip.files;}else{out.keys=[];out.files={};zip.FullPaths.forEach(function(p,idx){p=p.replace(/^Root Entry[\/]/,"");out.keys.push(p);out.files[p]=zip.FileIndex[idx];});}}if(opts&&opts.bookVBA){if(dir.vba.length>0)out.vbaraw=getzipdata(zip,strip_front_slash(dir.vba[0]),true);else if(dir.defaults&&dir.defaults.bin===CT_VBA)out.vbaraw=getzipdata(zip,'xl/vbaProject.bin',true);}return out;}/* [MS-OFFCRYPTO] 2.1.1 */function parse_xlsxcfb(cfb,_opts/*:?ParseOpts*/)/*:Workbook*/{var opts=_opts||{};var f='Workbook',data=CFB.find(cfb,f);try{f='/!DataSpaces/Version';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var version = */parse_DataSpaceVersionInfo(data.content);/* 2.3.4.1 */f='/!DataSpaces/DataSpaceMap';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var dsm=parse_DataSpaceMap(data.content);if(dsm.length!==1||dsm[0].comps.length!==1||dsm[0].comps[0].t!==0||dsm[0].name!=="StrongEncryptionDataSpace"||dsm[0].comps[0].v!=="EncryptedPackage")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.2 */f='/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var seds=parse_DataSpaceDefinition(data.content);if(seds.length!=1||seds[0]!="StrongEncryptionTransform")throw new Error("ECMA-376 Encrypted file bad "+f);/* 2.3.4.3 */f='/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*var hdr = */parse_Primary(data.content);}catch(e){}f='/EncryptionInfo';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);var einfo=parse_EncryptionInfo(data.content);/* 2.3.4.4 */f='/EncryptedPackage';data=CFB.find(cfb,f);if(!data||!data.content)throw new Error("ECMA-376 Encrypted file missing "+f);/*global decrypt_agile *//*:: declare var decrypt_agile:any; */if(einfo[0]==0x04&&typeof decrypt_agile!=='undefined')return decrypt_agile(einfo[1],data.content,opts.password||"",opts);/*global decrypt_std76 *//*:: declare var decrypt_std76:any; */if(einfo[0]==0x02&&typeof decrypt_std76!=='undefined')return decrypt_std76(einfo[1],data.content,opts.password||"",opts);throw new Error("File is password-protected");}function write_zip(wb/*:Workbook*/,opts/*:WriteOpts*/)/*:ZIP*/{if(opts.bookType=="ods")return write_ods(wb,opts);if(opts.bookType=="numbers")return write_numbers_iwa(wb,opts);if(opts.bookType=="xlsb")return write_zip_xlsxb(wb,opts);return write_zip_xlsx(wb,opts);}/* XLSX and XLSB writing are very similar.  Originally they were unified in one
   export function.  This is horrible for tree shaking in the common case (most
   applications need to export files in one format) so this function supports
   both formats while write_zip_xlsx only handles XLSX */function write_zip_xlsxb(wb/*:Workbook*/,opts/*:WriteOpts*/)/*:ZIP*/{_shapeid=1024;if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=/*::((*/[]/*:: :any):SST)*/;opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new _map2.default();else{opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext=opts.bookType=="xlsb"?"bin":"xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);/*::if(!wb.Props) throw "unreachable"; */f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames){/* empty */}else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else{var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i){if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);}wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":/* falls through */default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws(rId-1,f,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;var cf="";if(comments&&comments.length>0){cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_cmnt(comments,cf,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst(opts.Strings,f,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb(wb,f,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);/* TODO: something more intelligent with themes */f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);/* TODO: something more intelligent with styles */f="xl/styles."+wbext;zip_add_file(zip,f,write_sty(wb,f,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}f="xl/metadata."+wbext;zip_add_file(zip,f,write_xlmeta(f));ct.metadata.push(f);add_rels(opts.wbrels,-1,"metadata."+wbext,RELS.XLMETA);zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function write_zip_xlsx(wb/*:Workbook*/,opts/*:WriteOpts*/)/*:ZIP*/{_shapeid=1024;if(wb&&!wb.SSF){wb.SSF=dup(table_fmt);}if(wb&&wb.SSF){make_ssf();SSF_load_table(wb.SSF);// $FlowIgnore
opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0;opts.ssf=wb.SSF;}opts.rels={};opts.wbrels={};opts.Strings=/*::((*/[]/*:: :any):SST)*/;opts.Strings.Count=0;opts.Strings.Unique=0;if(browser_has_Map)opts.revStrings=new _map2.default();else{opts.revStrings={};opts.revStrings.foo=[];delete opts.revStrings.foo;}var wbext="xml";var vbafmt=VBAFMTS.indexOf(opts.bookType)>-1;var ct=new_ct();fix_write_opts(opts=opts||{});var zip=zip_new();var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{"General":0}});if(!wb.Props)wb.Props={};f="docProps/core.xml";zip_add_file(zip,f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);/*::if(!wb.Props) throw "unreachable"; */f="docProps/app.xml";if(wb.Props&&wb.Props.SheetNames){/* empty */}else if(!wb.Workbook||!wb.Workbook.Sheets)wb.Props.SheetNames=wb.SheetNames;else{var _sn=[];for(var _i=0;_i<wb.SheetNames.length;++_i){if((wb.Workbook.Sheets[_i]||{}).Hidden!=2)_sn.push(wb.SheetNames[_i]);}wb.Props.SheetNames=_sn;}wb.Props.Worksheets=wb.Props.SheetNames.length;zip_add_file(zip,f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip_add_file(zip,f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS);}var people=["SheetJ5"];opts.tcid=0;for(rId=1;rId<=wb.SheetNames.length;++rId){var wsrels={'!id':{}};var ws=wb.Sheets[wb.SheetNames[rId-1]];var _type=(ws||{})["!type"]||"sheet";switch(_type){case"chart":/* falls through */default:f="xl/worksheets/sheet"+rId+"."+wbext;zip_add_file(zip,f,write_ws_xml(rId-1,opts,wb,wsrels));ct.sheets.push(f);add_rels(opts.wbrels,-1,"worksheets/sheet"+rId+"."+wbext,RELS.WS[0]);}if(ws){var comments=ws['!comments'];var need_vml=false;var cf="";if(comments&&comments.length>0){var needtc=false;comments.forEach(function(carr){carr[1].forEach(function(c){if(c.T==true)needtc=true;});});if(needtc){cf="xl/threadedComments/threadedComment"+rId+"."+wbext;zip_add_file(zip,cf,write_tcmnt_xml(comments,people,opts));ct.threadedcomments.push(cf);add_rels(wsrels,-1,"../threadedComments/threadedComment"+rId+"."+wbext,RELS.TCMNT);}cf="xl/comments"+rId+"."+wbext;zip_add_file(zip,cf,write_comments_xml(comments,opts));ct.comments.push(cf);add_rels(wsrels,-1,"../comments"+rId+"."+wbext,RELS.CMNT);need_vml=true;}if(ws['!legacy']){if(need_vml)zip_add_file(zip,"xl/drawings/vmlDrawing"+rId+".vml",write_comments_vml(rId,ws['!comments']));}delete ws['!comments'];delete ws['!legacy'];}if(wsrels['!id'].rId1)zip_add_file(zip,get_rels_path(f),write_rels(wsrels));}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip_add_file(zip,f,write_sst_xml(opts.Strings,opts));ct.strs.push(f);add_rels(opts.wbrels,-1,"sharedStrings."+wbext,RELS.SST);}f="xl/workbook."+wbext;zip_add_file(zip,f,write_wb_xml(wb,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);/* TODO: something more intelligent with themes */f="xl/theme/theme1.xml";zip_add_file(zip,f,write_theme(wb.Themes,opts));ct.themes.push(f);add_rels(opts.wbrels,-1,"theme/theme1.xml",RELS.THEME);/* TODO: something more intelligent with styles */f="xl/styles."+wbext;zip_add_file(zip,f,write_sty_xml(wb,opts));ct.styles.push(f);add_rels(opts.wbrels,-1,"styles."+wbext,RELS.STY);if(wb.vbaraw&&vbafmt){f="xl/vbaProject.bin";zip_add_file(zip,f,wb.vbaraw);ct.vba.push(f);add_rels(opts.wbrels,-1,"vbaProject.bin",RELS.VBA);}f="xl/metadata."+wbext;zip_add_file(zip,f,write_xlmeta_xml());ct.metadata.push(f);add_rels(opts.wbrels,-1,"metadata."+wbext,RELS.XLMETA);if(people.length>1){f="xl/persons/person.xml";zip_add_file(zip,f,write_people_xml(people,opts));ct.people.push(f);add_rels(opts.wbrels,-1,"persons/person.xml",RELS.PEOPLE);}zip_add_file(zip,"[Content_Types].xml",write_ct(ct,opts));zip_add_file(zip,'_rels/.rels',write_rels(opts.rels));zip_add_file(zip,'xl/_rels/workbook.'+wbext+'.rels',write_rels(opts.wbrels));delete opts.revssf;delete opts.ssf;return zip;}function firstbyte(f/*:RawData*/,o/*:?TypeOpts*/)/*:Array<number>*/{var x="";switch((o||{}).type||"base64"){case'buffer':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];case'base64':x=Base64_decode(f.slice(0,12));break;case'binary':x=f;break;case'array':return[f[0],f[1],f[2],f[3],f[4],f[5],f[6],f[7]];default:throw new Error("Unrecognized type "+(o&&o.type||"undefined"));}return[x.charCodeAt(0),x.charCodeAt(1),x.charCodeAt(2),x.charCodeAt(3),x.charCodeAt(4),x.charCodeAt(5),x.charCodeAt(6),x.charCodeAt(7)];}function read_cfb(cfb/*:CFBContainer*/,opts/*:?ParseOpts*/)/*:Workbook*/{if(CFB.find(cfb,"EncryptedPackage"))return parse_xlsxcfb(cfb,opts);return parse_xlscfb(cfb,opts);}function read_zip(data/*:RawData*/,opts/*:?ParseOpts*/)/*:Workbook*/{var zip,d=data;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";zip=zip_read(d,o);return parse_zip(zip,o);}function read_plaintext(data/*:string*/,o/*:ParseOpts*/)/*:Workbook*/{var i=0;main:while(i<data.length){switch(data.charCodeAt(i)){case 0x0A:case 0x0D:case 0x20:++i;break;case 0x3C:return parse_xlml(data.slice(i),o);default:break main;}}return PRN.to_workbook(data,o);}function read_plaintext_raw(data/*:RawData*/,o/*:ParseOpts*/)/*:Workbook*/{var str="",bytes=firstbyte(data,o);switch(o.type){case'base64':str=Base64_decode(data);break;case'binary':str=data;break;case'buffer':str=data.toString('binary');break;case'array':str=cc2str(data);break;default:throw new Error("Unrecognized type "+o.type);}if(bytes[0]==0xEF&&bytes[1]==0xBB&&bytes[2]==0xBF)str=utf8read(str);o.type="binary";return read_plaintext(str,o);}function read_utf16(data/*:RawData*/,o/*:ParseOpts*/)/*:Workbook*/{var d=data;if(o.type=='base64')d=Base64_decode(d);d=$cptable.utils.decode(1200,d.slice(2),'str');o.type="binary";return read_plaintext(d,o);}function bstrify(data/*:string*/)/*:string*/{return!data.match(/[^\x00-\x7F]/)?data:utf8write(data);}function read_prn(data,d,o,str){if(str){o.type="string";return PRN.to_workbook(data,o);}return PRN.to_workbook(d,o);}function readSync(data/*:RawData*/,opts/*:?ParseOpts*/)/*:Workbook*/{reset_cp();var o=opts||{};if(typeof ArrayBuffer!=='undefined'&&data instanceof ArrayBuffer)return readSync(new Uint8Array(data),(o=dup(o),o.type="array",o));if(typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&!o.type)o.type=typeof Deno!=="undefined"?"buffer":"array";var d=data,n=[0,0,0,0],str=false;if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}_ssfopts={};if(o.dateNF)_ssfopts.dateNF=o.dateNF;if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";if(o.type=="file"){o.type=has_buf?"buffer":"binary";d=read_binary(data);if(typeof Uint8Array!=='undefined'&&!has_buf)o.type="array";}if(o.type=="string"){str=true;o.type="binary";o.codepage=65001;d=bstrify(data);}if(o.type=='array'&&typeof Uint8Array!=='undefined'&&data instanceof Uint8Array&&typeof ArrayBuffer!=='undefined'){// $FlowIgnore
var ab=new ArrayBuffer(3),vu=new Uint8Array(ab);vu.foo="bar";// $FlowIgnore
if(!vu.foo){o=dup(o);o.type='array';return readSync(ab2a(d),o);}}switch((n=firstbyte(d,o))[0]){case 0xD0:if(n[1]===0xCF&&n[2]===0x11&&n[3]===0xE0&&n[4]===0xA1&&n[5]===0xB1&&n[6]===0x1A&&n[7]===0xE1)return read_cfb(CFB.read(d,o),o);break;case 0x09:if(n[1]<=0x08)return parse_xlscfb(d,o);break;case 0x3C:return parse_xlml(d,o);case 0x49:if(n[1]===0x49&&n[2]===0x2a&&n[3]===0x00)throw new Error("TIFF Image File is not a spreadsheet");if(n[1]===0x44)return read_wb_ID(d,o);break;case 0x54:if(n[1]===0x41&&n[2]===0x42&&n[3]===0x4C)return DIF.to_workbook(d,o);break;case 0x50:return n[1]===0x4B&&n[2]<0x09&&n[3]<0x09?read_zip(d,o):read_prn(data,d,o,str);case 0xEF:return n[3]===0x3C?parse_xlml(d,o):read_prn(data,d,o,str);case 0xFF:if(n[1]===0xFE){return read_utf16(d,o);}else if(n[1]===0x00&&n[2]===0x02&&n[3]===0x00)return WK_.to_workbook(d,o);break;case 0x00:if(n[1]===0x00){if(n[2]>=0x02&&n[3]===0x00)return WK_.to_workbook(d,o);if(n[2]===0x00&&(n[3]===0x08||n[3]===0x09))return WK_.to_workbook(d,o);}break;case 0x03:case 0x83:case 0x8B:case 0x8C:return DBF.to_workbook(d,o);case 0x7B:if(n[1]===0x5C&&n[2]===0x72&&n[3]===0x74)return RTF.to_workbook(d,o);break;case 0x0A:case 0x0D:case 0x20:return read_plaintext_raw(d,o);case 0x89:if(n[1]===0x50&&n[2]===0x4E&&n[3]===0x47)throw new Error("PNG Image File is not a spreadsheet");break;}if(DBF_SUPPORTED_VERSIONS.indexOf(n[0])>-1&&n[2]<=12&&n[3]<=31)return DBF.to_workbook(d,o);return read_prn(data,d,o,str);}function readFileSync(filename/*:string*/,opts/*:?ParseOpts*/)/*:Workbook*/{var o=opts||{};o.type='file';return readSync(filename,o);}function write_cfb_ctr(cfb/*:CFBContainer*/,o/*:WriteOpts*/)/*:any*/{switch(o.type){case"base64":case"binary":break;case"buffer":case"array":o.type="";break;case"file":return write_dl(o.file,CFB.write(cfb,{type:has_buf?'buffer':""}));case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");default:throw new Error("Unrecognized type "+o.type);}return CFB.write(cfb,o);}/*:: declare var encrypt_agile:any; */function write_zip_type(wb/*:Workbook*/,opts/*:?WriteOpts*/)/*:any*/{var o=dup(opts||{});var z=write_zip(wb,o);return write_zip_denouement(z,o);}function write_zip_typeXLSX(wb/*:Workbook*/,opts/*:?WriteOpts*/)/*:any*/{var o=dup(opts||{});var z=write_zip_xlsx(wb,o);return write_zip_denouement(z,o);}function write_zip_denouement(z/*:any*/,o/*:?WriteOpts*/)/*:any*/{var oopts={};var ftype=has_buf?"nodebuffer":typeof Uint8Array!=="undefined"?"array":"string";if(o.compression)oopts.compression='DEFLATE';if(o.password)oopts.type=ftype;else switch(o.type){case"base64":oopts.type="base64";break;case"binary":oopts.type="string";break;case"string":throw new Error("'string' output type invalid for '"+o.bookType+"' files");case"buffer":case"file":oopts.type=ftype;break;default:throw new Error("Unrecognized type "+o.type);}var out=z.FullPaths?CFB.write(z,{fileType:"zip",type:/*::(*/{"nodebuffer":"buffer","string":"binary"/*:: :any)*/}[oopts.type]||oopts.type,compression:!!o.compression}):z.generate(oopts);if(typeof Deno!=="undefined"){if(typeof out=="string"){if(o.type=="binary"||o.type=="base64")return out;out=new Uint8Array(s2ab(out));}}/*jshint -W083 */if(o.password&&typeof encrypt_agile!=='undefined')return write_cfb_ctr(encrypt_agile(out,o.password),o);// eslint-disable-line no-undef
/*jshint +W083 */if(o.type==="file")return write_dl(o.file,out);return o.type=="string"?utf8read(/*::(*/out/*:: :any)*/):out;}function write_cfb_type(wb/*:Workbook*/,opts/*:?WriteOpts*/)/*:any*/{var o=opts||{};var cfb/*:CFBContainer*/=write_xlscfb(wb,o);return write_cfb_ctr(cfb,o);}function write_string_type(out/*:string*/,opts/*:WriteOpts*/,bom/*:?string*/)/*:any*/{if(!bom)bom="";var o=bom+out;switch(opts.type){case"base64":return Base64_encode(utf8write(o));case"binary":return utf8write(o);case"string":return out;case"file":return write_dl(opts.file,o,'utf8');case"buffer":{if(has_buf)return Buffer_from(o,'utf8');else if(typeof TextEncoder!=="undefined")return new TextEncoder().encode(o);else return write_string_type(o,{type:'binary'}).split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}function write_stxt_type(out/*:string*/,opts/*:WriteOpts*/)/*:any*/{switch(opts.type){case"base64":return Base64_encode(out);case"binary":return out;case"string":return out;/* override in sheet_to_txt */case"file":return write_dl(opts.file,out,'binary');case"buffer":{if(has_buf)return Buffer_from(out,'binary');else return out.split("").map(function(c){return c.charCodeAt(0);});}}throw new Error("Unrecognized type "+opts.type);}/* TODO: test consistency */function write_binary_type(out,opts/*:WriteOpts*/)/*:any*/{switch(opts.type){case"string":case"base64":case"binary":var bstr="";// $FlowIgnore
for(var i=0;i<out.length;++i){bstr+=String.fromCharCode(out[i]);}return opts.type=='base64'?Base64_encode(bstr):opts.type=='string'?utf8read(bstr):bstr;case"file":return write_dl(opts.file,out);case"buffer":return out;default:throw new Error("Unrecognized type "+opts.type);}}function writeSyncXLSX(wb/*:Workbook*/,opts/*:?WriteOpts*/){reset_cp();check_wb(wb);var o=dup(opts||{});if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out/*:string*/=writeSyncXLSX(wb,o)/*:any*/;o.type="array";return s2ab(out);}return write_zip_typeXLSX(wb,o);}function writeSync(wb/*:Workbook*/,opts/*:?WriteOpts*/){reset_cp();check_wb(wb);var o=dup(opts||{});if(o.cellStyles){o.cellNF=true;o.sheetStubs=true;}if(o.type=="array"){o.type="binary";var out/*:string*/=writeSync(wb,o)/*:any*/;o.type="array";return s2ab(out);}var idx=0;if(o.sheet){if(typeof o.sheet=="number")idx=o.sheet;else idx=wb.SheetNames.indexOf(o.sheet);if(!wb.SheetNames[idx])throw new Error("Sheet not found: "+o.sheet+" : "+(0,_typeof3.default)(o.sheet));}switch(o.bookType||'xlsb'){case'xml':case'xlml':return write_string_type(write_xlml(wb,o),o);case'slk':case'sylk':return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'htm':case'html':return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]],o),o);case'txt':return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]],o),o);case'csv':return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]],o),o,"\uFEFF");case'dif':return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'dbf':return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'prn':return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'rtf':return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'eth':return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]],o),o);case'fods':return write_string_type(write_ods(wb,o),o);case'wk1':return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]],o),o);case'wk3':return write_binary_type(WK_.book_to_wk3(wb,o),o);case'biff2':if(!o.biff)o.biff=2;/* falls through */case'biff3':if(!o.biff)o.biff=3;/* falls through */case'biff4':if(!o.biff)o.biff=4;return write_binary_type(write_biff_buf(wb,o),o);case'biff5':if(!o.biff)o.biff=5;/* falls through */case'biff8':case'xla':case'xls':if(!o.biff)o.biff=8;return write_cfb_type(wb,o);case'xlsx':case'xlsm':case'xlam':case'xlsb':case'numbers':case'ods':return write_zip_type(wb,o);default:throw new Error("Unrecognized bookType |"+o.bookType+"|");}}function resolve_book_type(o/*:WriteFileOpts*/){if(o.bookType)return;var _BT={"xls":"biff8","htm":"html","slk":"sylk","socialcalc":"eth","Sh33tJS":"WTF"};var ext=o.file.slice(o.file.lastIndexOf(".")).toLowerCase();if(ext.match(/^\.[a-z]+$/))o.bookType=ext.slice(1);o.bookType=_BT[o.bookType]||o.bookType;}function writeFileSync(wb/*:Workbook*/,filename/*:string*/,opts/*:?WriteFileOpts*/){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSync(wb,o);}function writeFileSyncXLSX(wb/*:Workbook*/,filename/*:string*/,opts/*:?WriteFileOpts*/){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);return writeSyncXLSX(wb,o);}function writeFileAsync(filename/*:string*/,wb/*:Workbook*/,opts/*:?WriteFileOpts*/,cb/*:?(e?:ErrnoError)=>void*/){var o=opts||{};o.type='file';o.file=filename;resolve_book_type(o);o.type='buffer';var _cb=cb;if(!(_cb instanceof Function))_cb=opts/*:any*/;return _fs.writeFile(filename,writeSync(wb,o),_cb);}/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/function make_json_row(sheet/*:Worksheet*/,r/*:Range*/,R/*:number*/,cols/*:Array<string>*/,header/*:number*/,hdr/*:Array<any>*/,dense/*:boolean*/,o/*:Sheet2JSONOpts*/)/*:MJRObject*/{var rr=encode_row(R);var defval=o.defval,raw=o.raw||!Object.prototype.hasOwnProperty.call(o,"raw");var isempty=true;var row/*:any*/=header===1?[]:{};if(header!==1){if(_defineProperty2.default)try{Object.defineProperty(row,'__rowNum__',{value:R,enumerable:false});}catch(e){row.__rowNum__=R;}else row.__rowNum__=R;}if(!dense||sheet[R])for(var C=r.s.c;C<=r.e.c;++C){var val=dense?sheet[R][C]:sheet[cols[C]+rr];if(val===undefined||val.t===undefined){if(defval===undefined)continue;if(hdr[C]!=null){row[hdr[C]]=defval;}continue;}var v=val.v;switch(val.t){case'z':if(v==null)break;continue;case'e':v=v==0?null:void 0;break;case's':case'd':case'b':case'n':break;default:throw new Error('unrecognized type '+val.t);}if(hdr[C]!=null){if(v==null){if(val.t=="e"&&v===null)row[hdr[C]]=null;else if(defval!==undefined)row[hdr[C]]=defval;else if(raw&&v===null)row[hdr[C]]=null;else continue;}else{row[hdr[C]]=raw&&(val.t!=="n"||val.t==="n"&&o.rawNumbers!==false)?v:format_cell(val,v,o);}if(v!=null)isempty=false;}}return{row:row,isempty:isempty};}function sheet_to_json(sheet/*:Worksheet*/,opts/*:?Sheet2JSONOpts*/){if(sheet==null||sheet["!ref"]==null)return[];var val={t:'n',v:0},header=0,offset=1,hdr/*:Array<any>*/=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;else if(o.header==null)header=0;switch(typeof range==="undefined"?"undefined":(0,_typeof3.default)(range)){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols/*:Array<string>*/=[];var out/*:Array<any>*/=[];var outi=0,counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0;var header_cnt={};if(dense&&!sheet[R])sheet[R]=[];var colinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!cols"]||[];var rowinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!rows"]||[];for(C=r.s.c;C<=r.e.c;++C){if((colinfo[C]||{}).hidden)continue;cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=header_cnt[v]||0;if(!counter)header_cnt[v]=1;else{do{vv=v+"_"+counter++;}while(header_cnt[vv]);header_cnt[v]=counter;header_cnt[vv]=1;}hdr[C]=vv;}}for(R=r.s.r+offset;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows))out[outi++]=row.row;}out.length=outi;return out;}var qreg=/"/g;function make_csv_row(sheet/*:Worksheet*/,r/*:Range*/,R/*:number*/,cols/*:Array<string>*/,fs/*:number*/,rs/*:number*/,FS/*:string*/,o/*:Sheet2CSVOpts*/)/*:?string*/{var isempty=true;var row/*:Array<string>*/=[],txt="",rr=encode_row(R);for(var C=r.s.c;C<=r.e.c;++C){if(!cols[C])continue;var val=o.dense?(sheet[R]||[])[C]:sheet[cols[C]+rr];if(val==null)txt="";else if(val.v!=null){isempty=false;txt=''+(o.rawNumbers&&val.t=="n"?val.v:format_cell(val,null,o));for(var i=0,cc=0;i!==txt.length;++i){if((cc=txt.charCodeAt(i))===fs||cc===rs||cc===34||o.forceQuotes){txt="\""+txt.replace(qreg,'""')+"\"";break;}}if(txt=="ID")txt='"ID"';}else if(val.f!=null&&!val.F){isempty=false;txt='='+val.f;if(txt.indexOf(",")>=0)txt='"'+txt.replace(qreg,'""')+'"';}else txt="";/* NOTE: Excel CSV does not support array formulae */row.push(txt);}if(o.blankrows===false&&isempty)return null;return row.join(FS);}function sheet_to_csv(sheet/*:Worksheet*/,opts/*:?Sheet2CSVOpts*/)/*:string*/{var out/*:Array<string>*/=[];var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null)return"";var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row="",cols/*:Array<string>*/=[];o.dense=Array.isArray(sheet);var colinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!cols"]||[];var rowinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C){if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);}var w=0;for(var R=r.s.r;R<=r.e.r;++R){if((rowinfo[R]||{}).hidden)continue;row=make_csv_row(sheet,r,R,cols,fs,rs,FS,o);if(row==null){continue;}if(o.strip)row=row.replace(endregex,"");if(row||o.blankrows!==false)out.push((w++?RS:"")+row);}delete o.dense;return out.join("");}function sheet_to_txt(sheet/*:Worksheet*/,opts/*:?Sheet2CSVOpts*/){if(!opts)opts={};opts.FS="\t";opts.RS="\n";var s=sheet_to_csv(sheet,opts);if(typeof $cptable=='undefined'||opts.type=='string')return s;var o=$cptable.utils.encode(1200,s,'str');return String.fromCharCode(255)+String.fromCharCode(254)+o;}function sheet_to_formulae(sheet/*:Worksheet*/)/*:Array<string>*/{var y="",x,val="";if(sheet==null||sheet["!ref"]==null)return[];var r=safe_decode_range(sheet['!ref']),rr="",cols/*:Array<string>*/=[],C;var cmds/*:Array<string>*/=[];var dense=Array.isArray(sheet);for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);}for(var R=r.s.r;R<=r.e.r;++R){rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){y=cols[C]+rr;x=dense?(sheet[R]||[])[C]:sheet[y];val="";if(x===undefined)continue;else if(x.F!=null){y=x.F;if(!x.f)continue;val=x.f;if(y.indexOf(":")==-1)y=y+":"+y;}if(x.f!=null)val=x.f;else if(x.t=='z')continue;else if(x.t=='n'&&x.v!=null)val=""+x.v;else if(x.t=='b')val=x.v?"TRUE":"FALSE";else if(x.w!==undefined)val="'"+x.w;else if(x.v===undefined)continue;else if(x.t=='s')val="'"+x.v;else val=""+x.v;cmds[cmds.length]=y+"="+val;}}return cmds;}function sheet_add_json(_ws/*:?Worksheet*/,js/*:Array<any>*/,opts)/*:Worksheet*/{var o=opts||{};var offset=+!o.skipHeader;var ws/*:Worksheet*/=_ws||{}/*:any*/;var _R=0,_C=0;if(ws&&o.origin!=null){if(typeof o.origin=='number')_R=o.origin;else{var _origin/*:CellAddress*/=typeof o.origin=="string"?decode_cell(o.origin):o.origin;_R=_origin.r;_C=_origin.c;}}var cell/*:Cell*/;var range/*:Range*/={s:{c:0,r:0},e:{c:_C,r:_R+js.length-1+offset}/*:any*/};if(ws['!ref']){var _range=safe_decode_range(ws['!ref']);range.e.c=Math.max(range.e.c,_range.e.c);range.e.r=Math.max(range.e.r,_range.e.r);if(_R==-1){_R=_range.e.r+1;range.e.r=_R+js.length-1+offset;}}else{if(_R==-1){_R=0;range.e.r=js.length-1+offset;}}var hdr/*:Array<string>*/=o.header||[],C=0;js.forEach(function(JS,R/*:number*/){keys(JS).forEach(function(k){if((C=hdr.indexOf(k))==-1)hdr[C=hdr.length]=k;var v=JS[k];var t='z';var z="";var ref=encode_cell({c:_C+C,r:_R+R+offset});cell=ws_get_cell_stub(ws,ref);if(v&&(typeof v==="undefined"?"undefined":(0,_typeof3.default)(v))==='object'&&!(v instanceof Date)){ws[ref]=v;}else{if(typeof v=='number')t='n';else if(typeof v=='boolean')t='b';else if(typeof v=='string')t='s';else if(v instanceof Date){t='d';if(!o.cellDates){t='n';v=datenum(v);}z=o.dateNF||table_fmt[14];}else if(v===null&&o.nullError){t='e';v=0;}if(!cell)ws[ref]=cell={t:t,v:v/*:any*/};else{cell.t=t;cell.v=v;delete cell.w;delete cell.R;if(z)cell.z=z;}if(z)cell.z=z;}});});range.e.c=Math.max(range.e.c,_C+hdr.length-1);var __R=encode_row(_R);if(offset)for(C=0;C<hdr.length;++C){ws[encode_col(C+_C)+__R]={t:'s',v:hdr[C]};}ws['!ref']=encode_range(range);return ws;}function json_to_sheet(js/*:Array<any>*/,opts)/*:Worksheet*/{return sheet_add_json(null,js,opts);}/* get cell, creating a stub if necessary */function ws_get_cell_stub(ws/*:Worksheet*/,R,C/*:?number*/)/*:Cell*/{/* A1 cell address */if(typeof R=="string"){/* dense */if(Array.isArray(ws)){var RC=decode_cell(R);if(!ws[RC.r])ws[RC.r]=[];return ws[RC.r][RC.c]||(ws[RC.r][RC.c]={t:'z'});}return ws[R]||(ws[R]={t:'z'});}/* cell address object */if(typeof R!="number")return ws_get_cell_stub(ws,encode_cell(R));/* R and C are 0-based indices */return ws_get_cell_stub(ws,encode_cell({r:R,c:C||0}));}/* find sheet index for given name / validate index */function wb_sheet_idx(wb/*:Workbook*/,sh/*:number|string*/){if(typeof sh=="number"){if(sh>=0&&wb.SheetNames.length>sh)return sh;throw new Error("Cannot find sheet # "+sh);}else if(typeof sh=="string"){var idx=wb.SheetNames.indexOf(sh);if(idx>-1)return idx;throw new Error("Cannot find sheet name |"+sh+"|");}else throw new Error("Cannot find sheet |"+sh+"|");}/* simple blank workbook object */function book_new()/*:Workbook*/{return{SheetNames:[],Sheets:{}};}/* add a worksheet to the end of a given workbook */function book_append_sheet(wb/*:Workbook*/,ws/*:Worksheet*/,name/*:?string*/,roll/*:?boolean*/)/*:string*/{var i=1;if(!name)for(;i<=0xFFFF;++i,name=undefined){if(wb.SheetNames.indexOf(name="Sheet"+i)==-1)break;}if(!name||wb.SheetNames.length>=0xFFFF)throw new Error("Too many worksheets");if(roll&&wb.SheetNames.indexOf(name)>=0){var m=name.match(/(^.*?)(\d+)$/);i=m&&+m[2]||0;var root=m&&m[1]||name;for(++i;i<=0xFFFF;++i){if(wb.SheetNames.indexOf(name=root+i)==-1)break;}}check_ws_name(name);if(wb.SheetNames.indexOf(name)>=0)throw new Error("Worksheet with name |"+name+"| already exists!");wb.SheetNames.push(name);wb.Sheets[name]=ws;return name;}/* set sheet visibility (visible/hidden/very hidden) */function book_set_sheet_visibility(wb/*:Workbook*/,sh/*:number|string*/,vis/*:number*/){if(!wb.Workbook)wb.Workbook={};if(!wb.Workbook.Sheets)wb.Workbook.Sheets=[];var idx=wb_sheet_idx(wb,sh);// $FlowIgnore
if(!wb.Workbook.Sheets[idx])wb.Workbook.Sheets[idx]={};switch(vis){case 0:case 1:case 2:break;default:throw new Error("Bad sheet visibility setting "+vis);}// $FlowIgnore
wb.Workbook.Sheets[idx].Hidden=vis;}/* set number format */function cell_set_number_format(cell/*:Cell*/,fmt/*:string|number*/){cell.z=fmt;return cell;}/* set cell hyperlink */function cell_set_hyperlink(cell/*:Cell*/,target/*:string*/,tooltip/*:?string*/){if(!target){delete cell.l;}else{cell.l={Target:target/*:Hyperlink*/};if(tooltip)cell.l.Tooltip=tooltip;}return cell;}function cell_set_internal_link(cell/*:Cell*/,range/*:string*/,tooltip/*:?string*/){return cell_set_hyperlink(cell,"#"+range,tooltip);}/* add to cell comments */function cell_add_comment(cell/*:Cell*/,text/*:string*/,author/*:?string*/){if(!cell.c)cell.c=[];cell.c.push({t:text,a:author||"SheetJS"});}/* set array formula and flush related cells */function sheet_set_array_formula(ws/*:Worksheet*/,range,formula/*:string*/,dynamic/*:boolean*/){var rng=typeof range!="string"?range:safe_decode_range(range);var rngstr=typeof range=="string"?range:encode_range(range);for(var R=rng.s.r;R<=rng.e.r;++R){for(var C=rng.s.c;C<=rng.e.c;++C){var cell=ws_get_cell_stub(ws,R,C);cell.t='n';cell.F=rngstr;delete cell.v;if(R==rng.s.r&&C==rng.s.c){cell.f=formula;if(dynamic)cell.D=true;}}}return ws;}var utils/*:any*/={encode_col:encode_col,encode_row:encode_row,encode_cell:encode_cell,encode_range:encode_range,decode_col:decode_col,decode_row:decode_row,split_cell:split_cell,decode_cell:decode_cell,decode_range:decode_range,format_cell:format_cell,sheet_add_aoa:sheet_add_aoa,sheet_add_json:sheet_add_json,sheet_add_dom:sheet_add_dom,aoa_to_sheet:aoa_to_sheet,json_to_sheet:json_to_sheet,table_to_sheet:parse_dom_table,table_to_book:table_to_book,sheet_to_csv:sheet_to_csv,sheet_to_txt:sheet_to_txt,sheet_to_json:sheet_to_json,sheet_to_html:sheet_to_html,sheet_to_formulae:sheet_to_formulae,sheet_to_row_object_array:sheet_to_json,sheet_get_cell:ws_get_cell_stub,book_new:book_new,book_append_sheet:book_append_sheet,book_set_sheet_visibility:book_set_sheet_visibility,cell_set_number_format:cell_set_number_format,cell_set_hyperlink:cell_set_hyperlink,cell_set_internal_link:cell_set_internal_link,cell_add_comment:cell_add_comment,sheet_set_array_formula:sheet_set_array_formula,consts:{SHEET_VISIBLE:0,SHEET_HIDDEN:1,SHEET_VERY_HIDDEN:2}};var _Readable;function set_readable(R){_Readable=R;}function write_csv_stream(sheet/*:Worksheet*/,opts/*:?Sheet2CSVOpts*/){var stream=_Readable();var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var endregex=new RegExp((FS=="|"?"\\|":FS)+"+$");var row/*:?string*/="",cols/*:Array<string>*/=[];o.dense=Array.isArray(sheet);var colinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!cols"]||[];var rowinfo/*:Array<RowInfo>*/=o.skipHidden&&sheet["!rows"]||[];for(var C=r.s.c;C<=r.e.c;++C){if(!(colinfo[C]||{}).hidden)cols[C]=encode_col(C);}var R=r.s.r;var BOM=false,w=0;stream._read=function(){if(!BOM){BOM=true;return stream.push("\uFEFF");}while(R<=r.e.r){++R;if((rowinfo[R-1]||{}).hidden)continue;row=make_csv_row(sheet,r,R-1,cols,fs,rs,FS,o);if(row!=null){if(o.strip)row=row.replace(endregex,"");if(row||o.blankrows!==false)return stream.push((w++?RS:"")+row);}}return stream.push(null);};return stream;}function write_html_stream(ws/*:Worksheet*/,opts/*:?Sheet2HTMLOpts*/){var stream=_Readable();var o=opts||{};var header=o.header!=null?o.header:HTML_BEGIN;var footer=o.footer!=null?o.footer:HTML_END;stream.push(header);var r=decode_range(ws['!ref']);o.dense=Array.isArray(ws);stream.push(make_html_preamble(ws,r,o));var R=r.s.r;var end=false;stream._read=function(){if(R>r.e.r){if(!end){end=true;stream.push("</table>"+footer);}return stream.push(null);}while(R<=r.e.r){stream.push(make_html_row(ws,r,R,o));++R;break;}};return stream;}function write_json_stream(sheet/*:Worksheet*/,opts/*:?Sheet2CSVOpts*/){var stream=_Readable({objectMode:true});if(sheet==null||sheet["!ref"]==null){stream.push(null);return stream;}var val={t:'n',v:0},header=0,offset=1,hdr/*:Array<any>*/=[],v=0,vv="";var r={s:{r:0,c:0},e:{r:0,c:0}};var o=opts||{};var range=o.range!=null?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;switch(typeof range==="undefined"?"undefined":(0,_typeof3.default)(range)){case'string':r=safe_decode_range(range);break;case'number':r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range;}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols/*:Array<string>*/=[];var counter=0;var dense=Array.isArray(sheet);var R=r.s.r,C=0;var header_cnt={};if(dense&&!sheet[R])sheet[R]=[];var colinfo/*:Array<ColInfo>*/=o.skipHidden&&sheet["!cols"]||[];var rowinfo/*:Array<RowInfo>*/=o.skipHidden&&sheet["!rows"]||[];for(C=r.s.c;C<=r.e.c;++C){if((colinfo[C]||{}).hidden)continue;cols[C]=encode_col(C);val=dense?sheet[R][C]:sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C-r.s.c;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val==null)val={w:"__EMPTY",t:"s"};vv=v=format_cell(val,null,o);counter=header_cnt[v]||0;if(!counter)header_cnt[v]=1;else{do{vv=v+"_"+counter++;}while(header_cnt[vv]);header_cnt[v]=counter;header_cnt[vv]=1;}hdr[C]=vv;}}R=r.s.r+offset;stream._read=function(){while(R<=r.e.r){if((rowinfo[R-1]||{}).hidden)continue;var row=make_json_row(sheet,r,R,cols,header,hdr,dense,o);++R;if(row.isempty===false||(header===1?o.blankrows!==false:!!o.blankrows)){stream.push(row.row);return;}}return stream.push(null);};return stream;}var __stream={to_json:write_json_stream,to_html:write_html_stream,to_csv:write_csv_stream,set_readable:set_readable};var version=exports.version=XLSX.version;exports.parse_xlscfb=parse_xlscfb;exports.parse_zip=parse_zip;exports.read=readSync;exports.readFile=readFileSync;exports.readFileSync=readFileSync;exports.write=writeSync;exports.writeFile=writeFileSync;exports.writeFileSync=writeFileSync;exports.writeFileAsync=writeFileAsync;exports.writeXLSX=writeSyncXLSX;exports.writeFileXLSX=writeFileSyncXLSX;exports.utils=utils;exports.stream=__stream;exports.SSF=SSF;exports.CFB=CFB;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(371).Buffer, __webpack_require__(1533)))

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviceList = getProviceList;
exports.getWaitList = getWaitList;
exports.getSuccessiveList = getSuccessiveList;
exports.adminExam = adminExam;
exports.postToPvs = postToPvs;
exports.backToPvs = backToPvs;
exports.batchBackSystem = batchBackSystem;
exports.listAdminAuditQuery = listAdminAuditQuery;
exports.getWorkerStatisticList = getWorkerStatisticList;
exports.getBasicInfoStatisticList = getBasicInfoStatisticList;
exports.getPublicationStatisticList = getPublicationStatisticList;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* 获取省局列表 */

function getProviceList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getProvinceList',
    url: "eavar/bureau/list",
    method: "post",
    data: params
  });
}

// zym.新闻出版署：获取出版社列表
function getWaitList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getPublishList',
    url: "eavar/examine/list",
    method: "post",
    data: params
  });
}

/* 获取连续型出版物列表 */

function getSuccessiveList(params) {
  return (0, _fetch2.default)({
    //  url:'Ydnj/Ydnj/getLxdzPublishList',
    url: "eavar/lxdz/examine/list",
    method: "post",
    data: params
  });
}

// zym.总局核验
function adminExam(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/executeBatch',
    url: "eavar/general/examine/executeBatch",
    method: "post",
    data: params
  });
}

// zym.总局整体发布
function postToPvs(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/wholeRelease',
    url: "eavar/general/examine/wholeRelease",
    method: "post",
    data: params
  });
}

// zym.总局整体退回
function backToPvs(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/wholeBack',
    url: "eavar/general/examine/wholeBack",
    method: "post",
    data: params
  });
}

// zym.总局整体退回
function batchBackSystem(params) {
  return (0, _fetch2.default)({
    // url: 'Ydnj/Ydnj/wholeBack',
    url: "eavar/general/examine/batchBackSystem",
    method: "post",
    data: params
  });
}

// zym.音像、电子申报情况统计
function listAdminAuditQuery(params) {
  return (0, _fetch2.default)({
    url: "eavar/general/examine/listAdminAuditQuery",
    method: "post",
    data: params
  });
}

function getWorkerStatisticList(params) {
  return (0, _fetch2.default)({
    url: "eavar/ydnj/getWorkerStatisticList",
    method: "post",
    data: params
  });
}

function getBasicInfoStatisticList(params) {
  return (0, _fetch2.default)({
    url: "eavar/ydnj/getBasicInfoStatisticList",
    method: "post",
    data: params
  });
}

function getPublicationStatisticList(params) {
  return (0, _fetch2.default)({
    url: "eavar/ydnj/getPublicationStatisticList",
    method: "post",
    data: params
  });
}

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listChartData = listChartData;
exports.listData = listData;
exports.getChartData1 = getChartData1;
exports.getChartData2 = getChartData2;
exports.getChartData3 = getChartData3;
exports.getChartData4 = getChartData4;
exports.getChartData5 = getChartData5;
exports.getChartData6 = getChartData6;
exports.getChartData7 = getChartData7;
exports.getChartData11 = getChartData11;
exports.getChartData12 = getChartData12;
exports.getChartData13 = getChartData13;
exports.getChartData14 = getChartData14;
exports.getChartData15 = getChartData15;
exports.getChartData16 = getChartData16;
exports.getChartData17 = getChartData17;
exports.getChartData18 = getChartData18;
exports.getChartData181 = getChartData181;
exports.getChartData182 = getChartData182;
exports.getChartData183 = getChartData183;
exports.getChartData31To40 = getChartData31To40;
exports.getChartData51 = getChartData51;
exports.getChartData52 = getChartData52;
exports.getFinanceChart1 = getFinanceChart1;
exports.getFinanceDetail = getFinanceDetail;
exports.getProvinceFinanceChart = getProvinceFinanceChart;
exports.getProvinceFinanceDetail = getProvinceFinanceDetail;
exports.getWorkerBaseInfo = getWorkerBaseInfo;
exports.getLxdzInfo = getLxdzInfo;
exports.getLxdzDetail = getLxdzDetail;

var _fetch = __webpack_require__(369);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 查询单位数据
 * @param params
 * @returns {*}
 */
function listChartData(params) {
  return (0, _fetch2.default)({
    url: "/statistics/listChartData",
    method: "post",
    data: params
  });
}

/**
 * 查询数据
 * @param params
 * @returns {*}
 */
function listData(params) {
  return (0, _fetch2.default)({
    url: "/statistics/listData",
    method: "post",
    data: params
  });
}

/**
 * 参检单位资质占比  单资质、双资质
 * @param params
 * @returns {*}
 */
function getChartData1(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData1",
    method: "post",
    data: params
  });
}

/**
 * 参检单位资质数量统计 音像、电子
 * @param params
 * @returns {*}
 */
function getChartData2(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData2",
    method: "post",
    data: params
  });
}

/**
 * 检单位资质数量统计 zizhi
 * @param params
 * @returns {*}
 */
function getChartData3(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData3",
    method: "post",
    data: params
  });
}

/**
 * 参检单位资质2数量统计 zizhi2
 * @param params
 * @returns {*}
 */
function getChartData4(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData4",
    method: "post",
    data: params
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
function getChartData5(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData5",
    method: "post",
    data: params
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
function getChartData6(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData6",
    method: "post",
    data: params
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
function getChartData7(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData7",
    method: "post",
    data: params
  });
}

/**
 * 音电出版物信息 出版数量
 * @param params
 * @returns {*}
 */
function getChartData11(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData11",
    method: "post",
    data: params
  });
}

/**
 * 音电出版物信息 时长
 * @param params
 * @returns {*}
 */
function getChartData12(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData12",
    method: "post",
    data: params
  });
}

/**
 * 音像制品内容来源类型
 * @param params
 * @returns {*}
 */
function getChartData13(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData13",
    method: "post",
    data: params
  });
}

/**
 * 书配盘标记-中文
 * @param params
 * @returns {*}
 */
function getChartData14(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData14",
    method: "post",
    data: params
  });
}

/**
 * 实（载）体、网络传播
 * @param params
 * @returns {*}
 */
function getChartData15(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData15",
    method: "post",
    data: params
  });
}

/**
 * 实（载）体
 * @param params
 * @returns {*}
 */
function getChartData16(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData16",
    method: "post",
    data: params
  });
}

/**
 * 除传统光盘载体出版外在哪些方面有所拓展
 * @param params
 * @returns {*}
 */
function getChartData17(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData17",
    method: "post",
    data: params
  });
}

/**
 * 音像制品出版单位结合音像电子业务开设并运营的项目数量
 * @param params
 * @returns {*}
 */
function getChartData18(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData18",
    method: "post",
    data: params
  });
}

/**
 * 音电 实（载）体出版销售数量（张/盒）
 * @param params
 * @returns {*}
 */
function getChartData181(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData181",
    method: "post",
    data: params
  });
}

/**
 * 音电 实（载）体出版年收入
 * @param params
 * @returns {*}
 */
function getChartData182(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData182",
    method: "post",
    data: params
  });
}

/**
 * 音电 网络传播年收入
 * @param params
 * @returns {*}
 */
function getChartData183(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData183",
    method: "post",
    data: params
  });
}

/**
 * 人员分类
 * @param params
 * @returns {*}
 */
function getChartData31To40(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData31To40",
    method: "post",
    data: params
  });
}

/**
 * 注册资本、资产及负债情况
 * @param params
 * @returns {*}
 */
function getChartData51(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData51",
    method: "post",
    data: params
  });
}

/**
 * 利润率
 * @param params
 * @returns {*}
 */
function getChartData52(params) {
  return (0, _fetch2.default)({
    url: "/statistics/getChartData52",
    method: "post",
    data: params
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
function getFinanceChart1(params) {
  return (0, _fetch2.default)({
    url: "/hzbfinance/getTotalChart",
    method: "post",
    data: params
  });
}

function getFinanceDetail(params) {
  return (0, _fetch2.default)({
    url: "/hzbfinance/getFinanceDetail",
    method: "post",
    data: params
  });
}

function getProvinceFinanceChart(params) {
  return (0, _fetch2.default)({
    url: "/hzbfinance/getProvinceFinanceChart",
    method: "post",
    data: params
  });
}

function getProvinceFinanceDetail(params) {
  return (0, _fetch2.default)({
    url: "/hzbfinance/getProvinceFinanceDetail",
    method: "post",
    data: params
  });
}

function getWorkerBaseInfo(params) {
  return (0, _fetch2.default)({
    url: "/hzbworkerbase/getTotalInfo",
    method: "post",
    data: params
  });
}

function getLxdzInfo(params) {
  return (0, _fetch2.default)({
    url: "/hzblxdzfinance/getLxdzInfo",
    method: "post",
    data: params
  });
}

function getLxdzDetail(params) {
  return (0, _fetch2.default)({
    url: "/hzblxdzfinance/getLxdzDetail",
    method: "post",
    data: params
  });
}

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://blog.csdn.net/weixin_42512937/article/details/103484986
exports.default = {
  data: function data() {
    return {
      total: 0,
      pageSize: 20,
      currentPage: 1,
      sizesArray: [10, 20, 50, 100]
    };
  },

  watch: {
    total: function total(val) {
      var total = this.total,
          currentPage = this.currentPage,
          pageSize = this.pageSize;

      console.debug('total: ', total, currentPage, pageSize, currentPage * pageSize, val <= (currentPage - 1) * pageSize);
      if (val <= (currentPage - 1) * pageSize) {
        this.handleCurrentChange(1);
      }
    }
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(value) {
      console.debug('handleCurrentChange', value, this);
      this.currentPage = value;
    },
    handleSizeChange: function handleSizeChange(value) {
      console.debug('handleSizeChange', value, this);
      this.pageSize = value;
    }
  }
};

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1516)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(727),
  /* template */
  __webpack_require__(1797),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, exports) {

module.exports = Vuex;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expFile = expFile;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * hyy 导出文件下载
 * @param query
 */
function expFile(query) {
  return (0, _fetch2.default)({
    url: 'export/export/expFile',
    method: 'post',
    data: query,
    responseType: 'blob'
  });
}

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filesDownload = filesDownload;
exports.filesDownloadUploadBtn = filesDownloadUploadBtn;
exports.uploadBase64 = uploadBase64;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * zym.从图书年检，新复制的方法 - 下载文件url
 * @param query
 */
function filesDownload(query) {
    return (0, _fetch2.default)({
        // url: '/Material/Material/downMaterialFile',
        url: '/eavar/pfile/url',
        method: 'post',
        data: query
    });
}

/**
 * zym.从图书年检，新复制的方法 - 下载文件url
 * @param query
 */
function filesDownloadUploadBtn(query) {
    return (0, _fetch2.default)({
        // url: '/Material/Material/downMaterialFile',
        url: '/eavar/mfile/url',
        method: 'post',
        data: query
    });
}

function uploadBase64(query) {
    return (0, _fetch2.default)({
        url: '/eavar/file/uploadBase64',
        method: 'post',
        data: query
    });
}

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1407)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1694),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-253fe868",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1485)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1767),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68ac910d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1425)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1711),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1473)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(728),
  /* template */
  __webpack_require__(1755),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1389)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(722),
  /* template */
  __webpack_require__(1678),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1415)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(723),
  /* template */
  __webpack_require__(1701),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var bsParams = {

	firstYear: '', // [2017]年度
	firstTotalSales: '', // [2017]年销售收入（万元）
	firstTotalProfit: '', // [2017]年利润总额（万元）
	firstSales: '', // [2017]连续型电子销售收入（万元）
	firstProfit: '', // [2017]连续型电子利润总额（万元）

	secondYear: '', // [2018]年度
	secondTotalSales: '', // [2018]年销售收入（万元）
	secondTotalProfit: '', // [2018]年利润总额（万元）
	secondSales: '', // [2018]连续型电子销售收入（万元）
	secondProfit: '', // [2018]连续型电子利润总额（万元）

	publishMaterialId: '', // publishMaterialId
	publishId: '', // 出版单位ID
	id: '' // id

};

var paramsRule = {

	firstTotalSales: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2017]年销售收入（万元）
	firstTotalProfit: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2017]年利润总额（万元）
	firstSales: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2017]连续型电子销售收入（万元）
	firstProfit: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2017]连续型电子利润总额（万元）

	secondTotalSales: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2018]年销售收入（万元）
	secondTotalProfit: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2018]年利润总额（万元）
	secondSales: [{ required: true, message: '不能为空！', trigger: 'change' }], // [2018]连续型电子销售收入（万元）
	secondProfit: [{ required: true, message: '不能为空！', trigger: 'change' }] // [2018]连续型电子利润总额（万元）

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1507)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(719),
  /* template */
  __webpack_require__(1789),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1519)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(726),
  /* template */
  __webpack_require__(1800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.login = login;
exports.getUserRuleList = getUserRuleList;
exports.logout = logout;
exports.passCodeSet = passCodeSet;
exports.userSSet = userSSet;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function login(param) {
    return (0, _fetch2.default)({
        // url: '/User/User/login',
        url: '/auth/login',
        method: 'post',
        data: param
    });
}

function getUserRuleList(param) {
    return (0, _fetch2.default)({
        // url: '/Rule/Rule/getUserRuleList',
        url: '/eavar/user/getUserRuleList',
        method: 'post',
        params: param
    });
}

function logout() {
    return (0, _fetch2.default)({
        url: '/User/User/logout',
        method: 'post'
    });
}

function passCodeSet(param) {
    return (0, _fetch2.default)({
        // url: '/User/User/modifyPassword',
        url: '/eavar/modifyPassword',
        method: 'post',
        data: param
    });
}

function userSSet(param) {
    return (0, _fetch2.default)({
        url: '/User/User/updateUserChangePasswordStatus',
        method: 'post',
        data: param
    });
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var rotateImg = exports.rotateImg = function rotateImg(url, rotate, callback) {
  try {
    var img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    // img.setAttribute('Access-Control-Allow-Origin',"*");
    img.src = url + '?tamp=' + new Date().valueOf();

    if (rotate) {
      if (rotate !== 90 && rotate !== -90 && rotate !== 180) {
        rotate = null;
      }
    }

    img.onload = function (ev) {
      console.log("img.onload");
      var originWidth = this.width;
      var originHeight = this.height;
      var targetWidth = originWidth;
      var targetHeight = originHeight;

      var maxWidth = 1920,
          maxHeight = 1920;

      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      console.log("Test Rotate 30L");
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      context.drawImage(img, 0, 0, originWidth, originHeight, 0, 0, targetWidth, targetHeight);

      var dataUrl = canvas.toDataURL("image/jpeg");

      if (rotate) {
        var angle = 0;
        var canvas2 = document.createElement('canvas');
        var context2 = canvas2.getContext('2d');
        canvas2.width = targetWidth;
        canvas2.height = targetHeight;

        var _setting = {
          dx: 0,
          dy: 0,
          dw: 0,
          dh: 0,
          transX: 0,
          transY: 0
        };
        var scale = 0;
        if (rotate === 180) {
          angle = Math.PI;
          _setting.dw = targetWidth;
          _setting.dh = targetHeight;
          context2.translate(targetWidth, targetHeight);
          context2.rotate(angle);
          context2.translate(0, 0);
        } else {
          if (rotate === 90) {
            angle = 90 * (Math.PI / 180);
          } else if (rotate === -90) {
            angle = -90 * (Math.PI / 180);
          }
          canvas2.width = targetHeight;
          canvas2.height = targetWidth;

          _setting.transX = parseFloat(targetHeight / 2);
          _setting.transY = parseFloat(targetWidth / 2);
          _setting.dw = targetHeight;
          scale = targetWidth / targetHeight;
          _setting.dh = parseFloat(_setting.dw / scale);
          _setting.dy = (targetWidth - _setting.dh) / 2;
          context2.translate(_setting.transX, _setting.transY);
          context2.rotate(angle);
          context2.scale(scale, scale);
        }
        console.log("Test Rotate 83L");
        /**
         * ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
         *
         * image: 可以是一个image ，或者一个canvas
         * sx: 在画布所绘制图片本身的x轴的距离
         * sy: 在画布所绘制图片本身y轴的距离
         * sWidth:表示所绘制图片的宽度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * sHeight:表示所绘制图片的高度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * dx:表示在画布x轴的坐标值
         * dy:表示在画布y轴的坐标值
         * dWidth: 在画布绘制的宽度
         * dHeight:在画布绘制的长度
         */
        context2.drawImage(canvas, 0, 0, targetWidth, targetHeight, _setting.dx - _setting.transX, _setting.dy - _setting.transY, _setting.dw, _setting.dh);
        dataUrl = canvas2.toDataURL("image/jpeg");
      }
      callback(dataUrl);
    };
  } catch (ex) {
    console.error(ex.toString());
  }
};

var rotateImgBase64 = exports.rotateImgBase64 = function rotateImgBase64(url, rotate, callback) {
  try {
    var img = new Image();
    img.src = url;

    if (rotate) {
      if (rotate !== 90 && rotate !== -90 && rotate !== 180) {
        rotate = null;
      }
    }

    img.onload = function (ev) {
      console.log("img.onload");
      var originWidth = this.width;
      var originHeight = this.height;
      var targetWidth = originWidth;
      var targetHeight = originHeight;

      var maxWidth = 1920,
          maxHeight = 1920;

      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      console.log("Test Rotate 30L");
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      context.drawImage(img, 0, 0, originWidth, originHeight, 0, 0, targetWidth, targetHeight);

      var dataUrl = canvas.toDataURL("image/jpeg");

      if (rotate) {
        var angle = 0;
        var canvas2 = document.createElement('canvas');
        var context2 = canvas2.getContext('2d');
        canvas2.width = targetWidth;
        canvas2.height = targetHeight;

        var _setting = {
          dx: 0,
          dy: 0,
          dw: 0,
          dh: 0,
          transX: 0,
          transY: 0
        };
        var scale = 0;
        if (rotate === 180) {
          angle = Math.PI;
          _setting.dw = targetWidth;
          _setting.dh = targetHeight;
          context2.translate(targetWidth, targetHeight);
          context2.rotate(angle);
          context2.translate(0, 0);
        } else {
          if (rotate === 90) {
            angle = 90 * (Math.PI / 180);
          } else if (rotate === -90) {
            angle = -90 * (Math.PI / 180);
          }
          canvas2.width = targetHeight;
          canvas2.height = targetWidth;

          _setting.transX = parseFloat(targetHeight / 2);
          _setting.transY = parseFloat(targetWidth / 2);
          _setting.dw = targetHeight;
          scale = targetWidth / targetHeight;
          _setting.dh = parseFloat(_setting.dw / scale);
          _setting.dy = (targetWidth - _setting.dh) / 2;
          context2.translate(_setting.transX, _setting.transY);
          context2.rotate(angle);
          context2.scale(scale, scale);
        }
        console.log("Test Rotate 83L");
        /**
         * ctx.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
         *
         * image: 可以是一个image ，或者一个canvas
         * sx: 在画布所绘制图片本身的x轴的距离
         * sy: 在画布所绘制图片本身y轴的距离
         * sWidth:表示所绘制图片的宽度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * sHeight:表示所绘制图片的高度范围，一般默认是图片的完整大小。也可以是部分绘制。
         * dx:表示在画布x轴的坐标值
         * dy:表示在画布y轴的坐标值
         * dWidth: 在画布绘制的宽度
         * dHeight:在画布绘制的长度
         */
        context2.drawImage(canvas, 0, 0, targetWidth, targetHeight, _setting.dx - _setting.transX, _setting.dy - _setting.transY, _setting.dw, _setting.dh);
        dataUrl = canvas2.toDataURL("image/jpeg");
      }
      callback(dataUrl);
    };
  } catch (ex) {
    console.error(ex.toString());
  }
};

// export const dataURLtoFile = (dataUrl, filename) => {
//     const arr = dataUrl.split(',')
//     const mime = arr[0].match(/:(.*?);/)[1]
//     const bstr = atob(arr[1])
//     let n = bstr.length
//     let u8arr = new Uint8Array(n);
//     while (n--) {
//         u8arr[n] = bstr.charCodeAt(n);
//     }
//     return new File([u8arr], filename, {type: mime});
// }
var dataURLtoFile = exports.dataURLtoFile = function dataURLtoFile(dataUrl, filename) {
  var arr = dataUrl.split(',');
  var bstr = window.atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg'
  });
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bsParams = {
  year: "", // 年度
  publicationName: "", // 出版物名称
  isbn: "", // 专用书号 ISBN
  carrierForm: "", // 载体形式（选择项）
  publicationForm: "", // 出版形式（选择项）
  carrierFormQT: "", // 出版形式其他
  productionUnit: "", // 节目来源/制作单位
  programCapacity: "", // 节目时长或容量(分钟/兆)
  publicationQuantity: "", // 出版数量（张/盒）
  issueQuantity: "", // 发行数量（张/盒）
  unitPrice: "", // 发行单价（元）
  publishingTime: "", // 出版时间
  sampleDelivery: "", // 样品缴送（选择项）
  sign: "", // 书配盘标记（选择项）

  publishMaterialId: "", // publishMaterialId
  publishId: "", // 出版单位ID

  id: "" // id
};

var paramsRule = {
  year: [{ required: true, message: "请选择", trigger: "change" }], // 年度
  publicationName: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 180, message: "填写内容过长！", trigger: "blur" }], // 出版物名称
  isbn: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 专用书号 ISBN
  carrierForm: [{ required: true, message: "请选择", trigger: "change" }], // 载体形式（选择项）
  publicationForm: [{ required: true, message: "请选择", trigger: "change" }], // 出版形式（选择项）
  carrierFormQT: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 专
  productionUnit: [
  // { required:true, message:'不能为空！', trigger:'blur' },
  { max: 127, message: "填写内容过长！", trigger: "blur" }], // 节目来源/制作单位
  programCapacity: [{ required: false, message: "请输入", trigger: "change" }], // 节目时长或容量(分钟/兆)
  publicationQuantity: [{ required: true, message: "请输入", trigger: "change" }], // 出版数量（张/盒）
  issueQuantity: [{ required: true, message: "请输入", trigger: "change" }], // 发行数量（张/盒）
  unitPrice: [{ required: true, message: "请输入", trigger: "change" }], // 发行单价（元）
  publishingTime: [{ required: true, message: "请输入", trigger: "change" }], // 出版时间
  sampleDelivery: [{ required: true, message: "请选择", trigger: "change" }], // 样品缴送（选择项）
  sign: [{ required: true, message: "请选择", trigger: "change" }] // 书配盘标记（选择项）
};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(211);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(126);

var _vuex2 = _interopRequireDefault(_vuex);

var _app = __webpack_require__(814);

var _app2 = _interopRequireDefault(_app);

var _user = __webpack_require__(818);

var _user2 = _interopRequireDefault(_user);

var _error = __webpack_require__(816);

var _error2 = _interopRequireDefault(_error);

var _permission = __webpack_require__(817);

var _permission2 = _interopRequireDefault(_permission);

var _dictionary = __webpack_require__(815);

var _dictionary2 = _interopRequireDefault(_dictionary);

var _getters = __webpack_require__(813);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vue.use(Vuex);

var store = new _vuex2.default.Store({
    modules: {
        app: _app2.default,
        user: _user2.default,
        error: _error2.default,
        permission: _permission2.default,
        dictionary: _dictionary2.default
    },
    getters: _getters2.default
});

exports.default = store;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.outSheets = exports.outExcel = undefined;

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = __webpack_require__(180);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

// import { getColumnsTitle, getBcBookColumn } from './bookColumn';

// const xml2js = require('xml2js');

// const STORAGE_CURRENT_USER_NAME = 'CURRENT USER';
// interface ColInfo {
//     /* visibility */
//     hidden?: boolean; // if true, the column is hidden

//     /* column width is specified in one of the following ways: */
//     wpx?: number; // width in screen pixels
//     width?: number; // width in Excel's "Max Digit Width", width*256 is integral
//     wch?: number; // width in characters

//     /* other fields for preserving features from files */
//     MDW?: number; // Excel's "Max Digit Width" unit, always integral
// }

// 原来用列名当下标 但是遇上同样列名的就麻烦了
// 应该用dataIndex当下标，第一行弄个列名行就行了
var create_sheet = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data, cols) {
    var skipHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var wscols, rows, cellWidths, opts, ws;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            wscols = void 0;
            rows = void 0;
            cellWidths = [];

            if (cols) {
              // const keys = _.map(cols, 'dataIndex');
              // wscols = cols.map(col => ({ wch: col.width || 20 }))
              wscols = _lodash2.default.map(function (row) {
                return _lodash2.default.pick(row, ["hidden", "wpx", "width", "wch", "MDW"]);
              });
              // data = data.map(row => _.pick(row, keys))
              rows = data.map(function (row) {
                var newrow = {};
                cols.forEach(function (col) {
                  if ("cellwidth" in col) {
                    cellWidths.push({ wpx: col.cellwidth });
                  } else {
                    cellWidths.push({ wpx: 100 });
                  }
                  if ("dataType" in col && col.dataType === "date" && row[col.dataIndex] != null && row[col.dataIndex] !== "") {
                    newrow[col.title || col.dataIndex || ""] = (0, _moment2.default)(row[col.dataIndex]).format("YYYY-MM-DD");
                  } else if ("dataType" in col && col.dataType === "yearmonth" && row[col.dataIndex] != null && row[col.dataIndex] !== "") {
                    newrow[col.title || col.dataIndex || ""] = (0, _moment2.default)(row[col.dataIndex]).format("YYYY-MM");
                  } else {
                    newrow[col.title || col.dataIndex || ""] = col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex];
                  }
                });
                return newrow;
              });
              // console.log('cols: ', cols, header, wscols, rows);
            }
            // 原来用列名当下标 但是遇上同样列名的就麻烦了
            // 应该用dataIndex当下标，第一行弄个列名行就行了
            opts = {};

            if (skipHeader) {
              opts.skipHeader = skipHeader;
              opts.header = _lodash2.default.map(cols, "dataIndex");
              rows = [_lodash2.default.mapValues(_lodash2.default.keyBy(cols, "dataIndex"), function (o) {
                return o.title;
              })].concat((0, _toConsumableArray3.default)(_lodash2.default.map(data, _lodash2.default.partialRight(_lodash2.default.pick, opts.header))));
            } else {
              opts.header = _lodash2.default.map(cols, "title");
            }
            _context.next = 8;
            return XLSX.utils.json_to_sheet(rows, opts);

          case 8:
            ws = _context.sent;

            // if (wscols) ws['!cols'] = wscols;
            // console.log(ws)
            ws["!cols"] = cellWidths;
            return _context.abrupt("return", ws);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function create_sheet(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var outExcel = exports.outExcel = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data, cols, filename, wsname) {
    var filetype = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "xlsx";
    var wb, ws;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log("Excel.outExcel: ", data, cols, filename, wsname);
            if (!filename) {
              filename = "temp";
            }
            filename = filename + "_" + (0, _moment2.default)().format("YYYYMMDD_HHmm");
            if (!wsname) {
              wsname = "Sheet1";
            }
            /* create a new blank workbook */
            wb = XLSX.utils.book_new();
            _context2.next = 7;
            return create_sheet(data, cols);

          case 7:
            ws = _context2.sent;

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, wsname);
            /* output format determined by filename */
            _context2.next = 11;
            return XLSX.writeFile(wb, filename + "." + filetype);

          case 11:
            return _context2.abrupt("return", { code: 0, message: "Excel File Created!" });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function outExcel(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var outSheets = exports.outSheets = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(data, cols, filename) {
    var _this = this;

    var XLSX, wb, wss;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            console.debug("Excel.outSheets: ", data, cols, filename);
            if (!filename) filename = "temp_" + (0, _moment2.default)().format("YYYYMMDD_HHmm");
            XLSX = __webpack_require__(55);

            console.debug("XLSX: ", XLSX);
            _context5.next = 6;
            return XLSX.utils.book_new();

          case 6:
            wb = _context5.sent;

            // Promise.all(data.forEach(async sheet => {
            // await data.map(async sheet => {
            //   // if (sheet.list.length === 0) return
            //   console.debug('sheet: ', sheet);
            //   /* if (!wsname) wsname = filename; */
            //   const wsname = `${sheet.title}(${sheet.id})`;
            //   /* create a new blank workbook */
            //   const ws = await this.create_sheet(sheet.list, cols);
            //   console.debug('ws.', ws)
            //   /* Add the worksheet to the workbook */
            //   XLSX.utils.book_append_sheet(wb, ws, wsname);
            //   console.debug('loop.', wb)
            //   return ws
            // })
            wss = data.map(function () {
              var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(sheet) {
                var ws;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(!sheet.list || sheet.list.length === 0)) {
                          _context3.next = 2;
                          break;
                        }

                        return _context3.abrupt("return", sheet);

                      case 2:
                        console.debug("sheet: ", sheet);
                        /* create a new blank workbook */
                        _context3.next = 5;
                        return create_sheet(sheet.list, cols);

                      case 5:
                        ws = _context3.sent;
                        return _context3.abrupt("return", (0, _extends3.default)({}, sheet, { __ws: ws }));

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x12) {
                return _ref4.apply(this, arguments);
              };
            }());

            console.debug("wss is over.", wss);
            _promise2.default.all(wss).then(function () {
              var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(res) {
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        console.debug("res: ", res);
                        res.forEach(function (sheet) {
                          if (!sheet.list || sheet.list.length === 0) return;
                          if (!sheet.id) return;
                          /* if (!wsname) wsname = filename; */
                          // const wsname = `${sheet.title}(${sheet.id})`;
                          var wsname = "" + sheet.title;
                          if (wb.SheetNames.indexOf(wsname) >= 0) console.error("出现重复数据？", sheet);
                          // eslint-disable-next-line no-underscore-dangle
                          XLSX.utils.book_append_sheet(wb, sheet.__ws, wsname);
                        });
                        // console.debug('sheets is over.', wb)
                        /* output format determined by filename */
                        console.debug("will write: ", wb);

                        if (!(wb.SheetNames.length <= 0)) {
                          _context4.next = 5;
                          break;
                        }

                        return _context4.abrupt("return", { code: -1, message: "Workbook is empty!" });

                      case 5:
                        _context4.next = 7;
                        return XLSX.writeFile(wb, filename + ".xlsx");

                      case 7:
                        return _context4.abrupt("return", { code: 0, message: "Excel File Created!" });

                      case 8:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this);
              }));

              return function (_x13) {
                return _ref5.apply(this, arguments);
              };
            }());

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function outSheets(_x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * 导出
 */
// export default {
//   Excel: 'excel',
//   Xml: 'xml',
//   // columns_book: {},

//   async out(format = this.Excel, data, cols, filename, wsname, filetype = 'xlsx') {
//     console.log('Excel.out: ', format, data, cols, filename, wsname, filetype);
//     if (format === this.Excel) return this.outExcel(data, cols, filename, wsname);
//     if (format === this.Xml) return this.outXml(data, filename);
//     return { code: -1, message: 'Wrong Format.' };
//   },

//   // async outXml(data, filename) {
//   //   let xml = '';
//   //   // const xml = builder
//   //   //   .create({ CIPData: data }, { encoding: 'gb2312', keepNullNodes: true, openNode: true })
//   //   //   .end({ pretty: true });
//   //   const builder = new xml2js.Builder({ xmldec: { encoding: 'gb2312' } });
//   //   // builder.xmldec({ encoding: 'gb2312' })
//   //   xml = builder.buildObject({ CIPData: data });
//   //   console.log(xml);
//   //   // Note: Ie and Edge don't support the new File constructor,
//   //   // so it's better to construct blobs and use saveAs(blob, filename)
//   //   // const file = new File(xml, `${filename}.xml`, { type: 'text/plain;charset=utf-8' });
//   //   // // FileSaver.saveAs(file);
//   //   // saveAs(file);
//   //   const blob = new Blob([iconv.encode(xml, 'gb2312')], { type: 'text/plain;charset=gb2312' });
//   //   // const blob = new Blob([xml], { type: 'text/plain;charset=gb2312' });
//   //   await FileSaver.saveAs(blob, `${filename}.xml`);
//   //   // fs.writeFileSync(`${filename}.xml`, 'xml');
//   //   // await XLSX.writeFile(xml, `${filename}.xml`);
//   //   return { code: 0, message: 'Xml File Created!' };
//   // },

//   // getColumns() {
//   //   const columns = getColumnsTitle();
//   //   console.log('columns: ', columns);
//   //   const arr = [];
//   //   _.forEach(columns, (value, key) => {
//   //     const { colName, render } = value;
//   //     const newcol = { dataIndex: colName.toLowerCase(), title: key, checked: true, render };
//   //     if ('isTime' in value) {
//   //       newcol.dataType = 'date';
//   //     }
//   //     if (
//   //       'publishPlanTime'.toLowerCase() === colName.toLowerCase() ||
//   //       'publishRealTime'.toLowerCase() === colName.toLowerCase()
//   //     ) {
//   //       newcol.dataType = 'yearmonth';
//   //     }
//   //     arr.push(newcol);
//   //   });

//   //   const columnsBc = getBcBookColumn();
//   //   _.forEach(columnsBc, (value, key) => {
//   //     const { colName, render } = value;
//   //     const newcol = { dataIndex: colName.toLowerCase(), title: key, checked: true, render };
//   //     if ('isTime' in value) {
//   //       newcol.dataType = 'date';
//   //     }
//   //     arr.push(newcol);
//   //   });

//   //   return arr;
//   // },
// };


var _lodash = __webpack_require__(341);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import XLSX from 'xlsx';
var XLSX = __webpack_require__(55);
// xmlbuilder lib/Utility.js 中 assign的参数
// ...sources ie 报错 做以下修改
// ```js
//       var target
//       for (i = 0, len = sources.length; i < 1; i++) {
//         target = sources[i];
//       }
//       for (i = 1, len = sources.length; i < len; i++) {
//       // for (i = 0, len = sources.length; i < len; i++) {
// import builder from 'xmlbuilder';
// import fs from 'fs';
// import FileSaver from 'file-saver';
// import iconv from 'iconv-lite';

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * 对象深拷贝
 * @param obj
 * @returns {*}
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(181);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.deepCopy = deepCopy;
exports.tirm = tirm;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deepCopy(obj) {
    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
        return obj;
    }
    var newobj = {};
    for (var attr in obj) {
        newobj[attr] = deepCopy(obj[attr]);
    }
    return newobj;
}

/**
 * 对象去空格
 * @param  {[type]} obj [description]
 * @return {[type]}     [description]
 */
function tirm(obj) {
    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        //是否为数组
        for (var i in obj) {
            // console.log("数组：",i,obj[i]);
            obj[i] = tirm(obj[i]);
        }
    } else {
        for (var j in obj) {
            // console.log("属性：",j,obj[j]);
            if (typeof obj[j] === 'string') {
                obj[j] = obj[j].replace(/(^\s*)|(\s*$)/g, "");
                // console.log("字符串：",j,obj[j]);
            } else {
                obj[j] = tirm(obj[j]);
            }
        }
    }

    return obj;
}

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTdDRURERUY1QzdFMTFFQjlFRTBENkE1QzQ5QzJFQ0UiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTdDRURERjA1QzdFMTFFQjlFRTBENkE1QzQ5QzJFQ0UiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxN0NFRERFRDVDN0UxMUVCOUVFMEQ2QTVDNDlDMkVDRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxN0NFRERFRTVDN0UxMUVCOUVFMEQ2QTVDNDlDMkVDRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqmPBTMAAAFxSURBVHjanJQxKEVRGIDPfWQ1vUWyeImyyW5Qsig2RV4mAwYsr54nvYTFgE15l2QxyCBJcjcZDBhMSiYsBmV7ru+v/9a9x/Xuu059/e/855zvnnv+867xfd/UolJxs1BOmtdoajTX3WslnMGTSWiZBIkH3aaOlvlDklNJu6ZayHX+Z0czIYm0XnhEdg9DaURzsrFQ/xqKkIUTZFvgxIp08FZ+5/MTVcIkbOvwO7kVYgccwTSUfokQ9OmgFwyw0Ad5xbVQ7pMwqpUshc8t2NGsPBUW7XdkcYGwGurLbqegqg+PiPrhgElfcQdG/sbqvxAuYdAWbcCOSdfuoM0WfYCTUtSgRERyBsspRT3wbItOYZgqdNVj0HlS6XNbVNZX269D0kTY1aptBnlHPgE6YVz/FsfwRmVeYyRysw+1ykW9pFFRaPIDIacLriSy4Ju83LF5aIZ1KMilDdbFfY8GYAFGYAwuZIdyhlryJQSevehHgAEAkz+sLHy1JAoAAAAASUVORK5CYII="

/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDcyQzU0Q0E1QzdFMTFFQjlFRTBENkE1QzQ5QzJFQ0UiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDcyQzU0Q0I1QzdFMTFFQjlFRTBENkE1QzQ5QzJFQ0UiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxN0NFRERGNTVDN0UxMUVCOUVFMEQ2QTVDNDlDMkVDRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxN0NFRERGNjVDN0UxMUVCOUVFMEQ2QTVDNDlDMkVDRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmfojDwAAAFsSURBVHjalJTPK0RRFMdnkP9gIsmGRJmVld2IkpSyNBuTlYWhbJAfpUdsbIayEPP82FlLCs3WwsKekpVYSFN2ej6nztPruu/XqU+ne96533POve+9jOd5mTCqVdeBXFSOT0Mm2vJw57on7TF5sUJifVCLEwsVYmMPrk2XnSrWFZbfZBEYx23qWEETsTLMRwohkMVVYBbeYBXGYMBPgYUko62ryAV0l0pTW/h3fbYP08R+tOgD7P0T0vMQoSuYZEM9kLPDugxeIFaTouwrmB1JJ1Jtxq+qts162TLJmnY7ZwqNwi2bXoPZrO9t50H8G3cOw+Zhd+jZpLFDqJsdNSppTG750xR6gf6UQhtyhqbQNRS4hd4kCpo3AZemUEVv7Zik5gRapzqa8zen/AK0yop+GjdQ5GY+LJ204lq0m2dyzmxCWZ15Eb5gl0SHuHRdhEH1T8TzoZ+IvLmwpBsetapYDo5gCA5gxDbrrwADANvcpeyNF2gmAAAAAElFTkSuQmCC"

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1448)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(730),
  /* template */
  __webpack_require__(1732),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1442)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(736),
  /* template */
  __webpack_require__(1726),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-449e602f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1392)
  __webpack_require__(1391)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0cb271c7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1493)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1776),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bsParams = { /* 音像制品 基本情况表 */

    publishName: '', // 出版单位名称
    usccNum: '', // 统一社会信用代码
    usccOrgName: '', // 营业执照上“名称”
    usccType: '', // 营业执照类型
    residence: '', // 住所
    faren: '',
    yyzzZczb: '', // 营业执照注册资本
    clDate: '', // 成立日期

    areaDate: '',

    startYyDate: '', // startYyDate
    endYyDate: '', // endYyDate
    yyfw: '', // 经营范围
    djDate: '', // 登记日期
    usccCode: '', // 证照编号
    yyzzId: '', // 营业执照附件ID

    nature: '', // 企业性质（选择项）
    otherNature: '', // 企业性质（其他）
    isIndependentLP: '', // 是否独立法人（选择项）
    unitType: '', // 独立法人单位类型（选择项）
    independentLPSituation: '', // 独立法人隶属关系（选择项）
    nonIndependentLPSituation: '', // 非独立法人隶属关系（选择项）
    publishAddr: '', // 出版单位地址
    publishPostalcode: '', // 出版单位邮政编码
    publishLinkman: '', // 出版单位联系人
    publishTel: '', // 出版单位联系电话
    publishPhone: '', // 出版单位联系人手机号
    workers: '', // 职工总数
    businessWorkers: '', // 从事（电子/音像）业务人员数
    otherWorkers: '', // 其他人员数
    registeredCapital: '', // 注册资本（万元）
    totalAssets: '', // 资产总额（万元）
    totalLiabilities: '', // 负债总额（万元）
    remark: '', // 备注


    id: '', // id
    publishId: '', // 出版单位ID
    publishMaterialId: '', // 当前年度，出版单位填写资料表，资料表Id
    updatedAt: '' //申报时间
};

var mobelPhone = function mobelPhone(rule, val, callback) {
    // 手机验证
    var pattern = /^1[0-9]{10}$/;
    if (val == '') {
        callback(new Error('请输入手机号'));
    } else if (!pattern.test(val)) {
        callback(new Error('手机号格式错误！'));
    } else {
        callback();
    }
};

var zipCode = function zipCode(rule, val, callback) {
    // 邮编验证
    var pattern = /(^[0-9]{6})$/;
    if (val == '') {
        callback(new Error('请输入单位邮编'));
    } else if (!pattern.test(val)) {
        callback(new Error('邮编格式错误！'));
    } else {
        callback();
    }
};

var homePhone = function homePhone(rule, val, callback) {
    //固话验证
    var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
    if (val == '') {
        callback(new Error('请输入电话'));
    } else if (!pattern.test(val)) {
        callback(new Error('电话格式错误！'));
    } else {
        callback();
    }
};

var paramsRule = {

    publishName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 出版单位名称
    usccNum: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 统一社会信用代码
    usccOrgName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 营业执照上“名称”
    usccType: [{ required: true, message: '请选择', trigger: 'change' }], // 营业执照类型
    residence: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 住所
    faren: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    yyzzZczb: [{ required: true, message: '请选择', trigger: 'change' }], // 营业执照注册资本
    clDate: [{ required: true, message: '请选择', trigger: 'change' }], // 成立日期
    areaDate: [{ required: true, message: '请选择', trigger: 'change' }],
    startYyDate: [{ required: true, message: '请选择', trigger: 'change' }], // startYyDate
    endYyDate: [{ required: true, message: '请选择', trigger: 'change' }], // endYyDate
    yyfw: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 1000, message: '填写内容过长！', trigger: 'blur' }], // 经营范围
    djDate: [{ required: true, message: '请选择', trigger: 'change' }], // 登记日期
    usccCode: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 证照编号
    yyzzId: [{ required: true, message: '请上传！', trigger: 'change' }], // 证照编,     // 营业执照附件ID

    nature: [{ required: true, message: '请选择', trigger: 'change' }], // 企业性质（选择项）
    otherNature: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    isIndependentLP: [{ required: true, message: '请选择', trigger: 'change' }], // 是否独立法人（选择项）
    unitType: [{ required: true, message: '请选择', trigger: 'change' }], // 独立法人单位类型（选择项）
    independentLPSituation: [{ required: true, message: '请选择', trigger: 'change' }], // 独立法人隶属关系（选择项）
    nonIndependentLPSituation: [{ required: true, message: '请选择', trigger: 'change' }], // 非独立法人隶属关系（选择项）
    publishAddr: [{ required: true, message: '请选择', trigger: 'change' }], // 出版单位地址
    publishPostalcode: [{ validator: zipCode, trigger: 'blur' }], // 出版单位邮政编码
    publishLinkman: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 出版单位联系人
    publishTel: [{ validator: homePhone, trigger: 'blur' }], // 出版单位联系电话
    publishPhone: [{ validator: mobelPhone, trigger: 'blur' }], // 出版单位联系人手机号

    remark: [{ max: 1000, message: '填写内容过长！', trigger: 'blur' }],

    workers: '', // 职工总数
    businessWorkers: '', // 从事（电子/音像）业务人员数
    otherWorkers: '', // 其他人员数
    registeredCapital: '', // 注册资本（万元）
    totalAssets: '', // 资产总额（万元）
    totalLiabilities: '' // 负债总额（万元）


};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bsParams = {
  /* 音像制品 基本情况表 */

  xkzNum: "", // 出版许可证号
  orgName: "", // 单位名称
  orgAddr: "", // 单位地址
  cbzMa: "", // 出版者码
  fddbr: "", // 法定代表人

  areaDate: "",

  yxStartDate: "", // 有效开始日期
  yxEndDate: "", // 有效截止日期
  businessScope: "", // 经营范围
  otherScope: "", // 其他主要业务
  approvalTime: "", // （音像/电子）制品出版资质获批时间
  otherSituation: "", // 需要说明的其他情况
  xkzFileId: "", // 出版许可证ID

  hostId: "", // 主办单位ID
  hostName: "", // 主办单位名称
  hostAddr: "", // 主办单位地址
  hostPostalcode: "", // 主办单位邮编
  hostLinkman: "", // 主办单位联系人
  hostTel: "", // 主办单位联系电话
  hostPhone: "", // 主办单位联系人手机

  chargeId: "", // 主管单位ID
  chargeName: "", // 主管单位名称
  chargeAddr: "", // 主管单位地址
  chargePostalcode: "", // 主管单位邮编
  chargeLinkman: "", // 主管单位联系人
  chargeTel: "", // 主管单位联系电话
  chargePhone: "", // 主管单位联系人手机

  publishMaterialId: "", // publishMaterialId
  publishId: "", // 出版单位ID
  id: "", // id
  updatedAt: "" //申报时间
};

var idCard = function idCard(rule, val, callback) {
  var pattern = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
  if (val == "") {
    callback(new Error("请输入身份证号"));
  } else if (!pattern.test(val)) {
    callback(new Error("身份证号错误"));
  } else {
    callback();
  }
};

var homePhone = function homePhone(rule, val, callback) {
  //固话验证
  var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
  if (val == "") {
    callback(new Error("请输入电话"));
  } else if (!pattern.test(val)) {
    callback(new Error("电话格式错误！"));
  } else {
    callback();
  }
};

var zipCode = function zipCode(rule, val, callback) {
  // 邮编验证
  var pattern = /(^[0-9]{6})$/;
  if (val == "") {
    callback(new Error("请输入单位邮编"));
  } else if (!pattern.test(val)) {
    callback(new Error("邮编格式错误！"));
  } else {
    callback();
  }
};

var mobelPhone = function mobelPhone(rule, val, callback) {
  // 手机验证
  var pattern = /^1[0-9]{10}$/;
  if (val == "") {
    callback(new Error("请输入手机号"));
  } else if (!pattern.test(val)) {
    callback(new Error("手机号格式错误！"));
  } else {
    callback();
  }
};

var nameMatch1 = function nameMatch1(rule, val, callback) {
  var weqName = bsParams.orgName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    // if (inName == weqName) {
    //   callback(new Error('主办单位名称不能与单位名称相同！'));
    // } else
    if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
};

var nameMatch2 = function nameMatch2(rule, val, callback) {
  var weqName = bsParams.orgName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    if (inName == weqName) {
      callback(new Error("主管单位名称不能与单位名称相同！"));
    } else if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
  if (inName.length > 0) {}
};

var nameMatch3 = function nameMatch3(rule, val, callback) {
  var weqName1 = bsParams.hostName.replace(/\s*/gi, "");
  var weqName2 = bsParams.chargeName.replace(/\s*/gi, "");
  var inName = val.replace(/\s*/gi, "");
  if (inName.length == 0) {
    callback(new Error("不能为空！"));
  } else {
    if (inName == weqName1) {
      callback(new Error("单位名称不能与主办单位名称相同！"));
    } else if (inName == weqName2) {
      callback(new Error("单位名称不能与主管单位名称相同！"));
    } else if (inName.length > 127) {
      callback(new Error("内容过长！"));
    } else {
      callback();
    }
  }
};

var paramsRule = {
  xkzNum: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 出版许可证号
  orgName: [{
    validator: nameMatch3,
    trigger: "blur"
  }], // 单位名称
  orgAddr: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 单位地址
  cbzMa: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 出版者码
  fddbr: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 法定代表人

  areaDate: [{
    required: true,
    message: "请选择",
    trigger: "change"
  }],

  yxStartDate: [{
    required: true,
    message: "请选择",
    trigger: "change"
  }], // 有效开始日期
  yxEndDate: [{
    required: true,
    message: "请选择",
    trigger: "change"
  }], // 有效截止日期

  businessScope: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 600,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 经营范围
  otherScope: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 其他主要业务
  approvalTime: [{
    required: true,
    message: "请选择",
    trigger: "change"
  }], // （音像/电子）制品出版资质获批时间
  otherSituation: [{
    required: true,
    message: "请选择",
    trigger: "change"
  }], // 需要说明的其他情况

  // xkzFileId:[
  // 	   { required:true, message:'请上传', trigger:'change' },
  // ],

  xkzFileId1: [{
    required: true,
    message: "请上传",
    trigger: "change"
  }],
  xkzFileId2: [{
    required: true,
    message: "请上传",
    trigger: "change"
  }],
  xkzFileId3: [{
    required: true,
    message: "请上传",
    trigger: "change"
  }],
  xkzFileId4: [{
    required: true,
    message: "请上传",
    trigger: "change"
  }],
  xkzFileId5: [{
    required: true,
    message: "请上传",
    trigger: "change"
  }],

  hostName: [{
    validator: nameMatch1,
    trigger: "blur"
  }], // 主办单位名称

  hostCategory: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }], // 主办单位名称

  hostAddr: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 主办单位地址
  hostPostalcode: [{
    validator: zipCode,
    trigger: "blur"
  }], // 主办单位邮编
  hostLinkman: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 主办单位联系人
  hostTel: [{
    validator: homePhone,
    trigger: "blur"
  }], // 主办单位联系电话
  hostPhone: [{
    validator: mobelPhone,
    trigger: "blur"
  }], // 主办单位联系人手机

  chargeName: [{
    validator: nameMatch2,
    trigger: "blur"
  }], // 主管单位名称

  chargeCategory: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }], // 主办单位名称
  chargeAddr: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 主管单位地址
  chargePostalcode: [{
    validator: zipCode,
    trigger: "blur"
  }], // 主管单位邮编
  chargeLinkman: [{
    required: true,
    message: "不能为空！",
    trigger: "blur"
  }, {
    max: 127,
    message: "填写内容过长！",
    trigger: "blur"
  }], // 主管单位联系人
  chargeTel: [{
    validator: homePhone,
    trigger: "blur"
  }], // 主管单位联系电话
  chargePhone: [{
    validator: mobelPhone,
    trigger: "blur"
  }] // 主管单位联系人手机
};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bsParams = {
  id: '', // id
  publishMaterialId: '', // publishMaterialId
  publishId: '', // 出版单位ID

  qualificationTs: '0', // 出版资质-图书  1-是  0-否
  qualificationQk: '0', // 出版资质-期刊  1-是  0-否
  qualificationYx: '0', // 出版资质-音像  1-是  0-否
  qualificationDz: '0', // 出版资质-电子  1-是  0-否
  qualificationWl: '0', // 出版资质-网络  1-是  0-否
  qualificationBz: '0', // 出版资质-报纸  1-是  0-否
  qualificationRm1: '0', // 出版资质-备用1  1-是  0-否
  qualificationRm2: '0', // 出版资质-备用2  1-是  0-否


  mainBusinessTs: '0', // 主营业务-音像  1-是  0-否
  mainBusinessQk: '0', // 主营业务-电子  1-是  0-否
  mainBusinessWl: '0', // 主营业务-网络  1-是  0-否
  mainBusinessBz: '0', // 主营业务-报纸  1-是  0-否
  mainBusinessRm1: '0', // 主营业务-备用1  1-是  0-否
  mainBusinessRm2: '0', // 主营业务-备用2  1-是  0-否

  otherbusiness: '', // 营收高于出版业务的其他主营业务


  expandBusinessEmpty: '0', // 拓展业务-无  1-是  0-否
  expandBusinessMedium: '0', // 拓展业务-媒体  1-是  0-否
  expandBusinessWeb: '0', // 拓展业务-网络  1-是  0-否
  expandBusinessBook: '0', // 拓展业务-图书  1-是  0-否
  expandBusinessLxdz: '0', // 拓展业务-连续电子  1-是  0-否
  expandBusinessOther: '0', // 拓展业务-其他  1-是  0-否
  expandBusinessOtherFill: '', // 拓展业务-其他填写  1-是  0-否
  expandBusinessRm1: '0', // 拓展业务-备用1  1-是  0-否
  expandBusinessRm2: '0', // 拓展业务-备用2  1-是  0-否


  operationProjectEmpty: '0', // 开设并运营-无  1-是  0-否
  operationProjectWeb: '0', // 开设并运营-媒体  1-是  0-否
  operationProjectWebNum: 0, // 开设并运营-网络  1-是  0-否
  operationProjectDatabase: '0', // 开设并运营-图书  1-是  0-否
  operationProjectDatabaseNum: 0, // 开设并运营-连续电子  1-是  0-否
  operationProjectWechat: '0', // 开设并运营-其他  1-是  0-否
  operationProjectWechatNum1: 0, // 开设并运营-其他填写  1-是  0-否
  operationProjectWechatNum2: 0, // 开设并运营-备用1  1-是  0-否
  operationProjectApp: '0', // 开设并运营-备用2  1-是  0-否
  operationProjectAppNum: 0, // 开设并运营-无  1-是  0-否
  operationProjectWeibo: '0', // 开设并运营-媒体  1-是  0-否
  operationProjectWeiboNum: 0, // 开设并运营-网络  1-是  0-否
  operationProjectOther: '0', // 开设并运营-图书  1-是  0-否
  operationProjectOtherNum: 0, // 开设并运营-连续电子  1-是  0-否
  operationProjectOtherFill: '0', // 开设并运营-其他  1-是  0-否
  operationProjectRm1: '', // 开设并运营-备用1 1-是 0-否
  operationProjectRm2: '', // 开设并运营-备用2  1-是  0-否

  pepnumProcess: 0, // 除编辑以外有关制作加工等
  pepnumInternation: 0, // 除编辑以外的有关新媒体、网络运营等技术人员
  pepnumIssue: 0, // 专职发行人员
  pepnumOther: 0, // 其他人员，包括行政人员等
  pepnumTotal: 0, // 总人数（应该是计算出来的，因为编辑人员、领导是动态的）

  remark: '', // 备注
  createdAt: '', // 创建时间
  updatedAt: '' // 更新时间

};

var paramsRule = {

  // year: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 年度
  // publicationName: [
  //     { required: true, message: '不能为空！', trigger: 'blur' },
  //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
  // ],     // 出版物名称
  // isbn: [
  //     { required: true, message: '不能为空！', trigger: 'blur' },
  //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
  // ],     // 专用书号 ISBN
  // carrierForm: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 载体形式（选择项）
  // publicationForm: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 出版形式（选择项）
  // carrierFormQT: [
  //     { required: true, message: '不能为空！', trigger: 'blur' },
  //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
  // ],     // 专
  // productionUnit: [
  //     { required: true, message: '不能为空！', trigger: 'blur' },
  //     { max: 127, message: '填写内容过长！', trigger: 'blur' }
  // ],     // 节目来源/制作单位
  // programCapacity: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 节目时长或容量(分钟/兆)
  // publicationQuantity: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 出版数量（张/盒）
  // issueQuantity: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 发行数量（张/盒）
  // unitPrice: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 发行单价（元）
  // publishingTime: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 出版时间
  // sampleDelivery: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 样品缴送（选择项）
  // sign: [
  //     { required: true, message: '请选择', trigger: 'change' },
  // ],     // 书配盘标记（选择项）

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bsParams = {
  /* 音像制品 出版情况登记表 */

  id: "", //
  publishMaterialId: "", //
  publishId: "", // 出版单位ID
  createdAt: "", //
  updatedAt: "", //

  firstYear: "", // [2017]年度
  firstTotalSales: "", // 出版单位[2017]年销售收入（万元）
  firstTotalProfit: "", // 出版单位[2017]年利润总额（万元）
  firstSales: "", // [2017]XX制品销售收入（万元）
  firstProfit: "", // [2017]XX制品利润总额（万元）
  firstPublicationVariety: "", // [2017]出版品种
  firstSalesVolumes: "", // [2017]销售数量（套/张）
  firstZtcbSales: "", // [2017]音像制品载体出版年销售收入（万元）
  firstZtcbProfit: "", // [2017]音像制品载体出版年利润总额（万元）
  firstWlcbSales: "", // [2017]音像制品信息网络出物年销售收入（万元）
  firstWlcbProfit: "", // [2017]音像制品信息网络出物年利润总额（万元）
  secondYear: "", // [2018]年度
  secondTotalSales: "", // 出版单位[2018]年销售收入（万元）
  secondTotalProfit: "", // 出版单位[2018]年利润总额（万元）
  secondSales: "", // [2018]XX制品销售收入（万元）
  secondProfit: "", // [2018]XX制品利润总额（万元）
  secondPublicationVariety: "", // [2018]出版品种
  secondSalesVolumes: "", // [2018]销售数量（套/张）
  secondZtcbSales: "", // [2018]音像制品载体出版年销售收入（万元）
  secondZtcbProfit: "", // [2018]音像制品载体出版年利润总额（万元）
  secondWlcbSales: "", // [2018]音像制品信息网络出物年销售收入（万元）
  secondWlcbProfit: "", // [2018]音像制品信息网络出物年利润总额（万元）
  firstSales1: "", //
  firstSales2: "", //
  firstSales3: "", //
  firstSales4: "", //
  firstSales5: "", //
  secondSales1: "", //
  secondSales2: "", //
  secondSales3: "", //
  secondSales4: "", //
  secondSales5: "", //
  firstPay: "", //
  firstPay1: "", //
  firstPay2: "", //
  firstPay3: "", //
  firstPay4: "", //
  firstPay5: "", //
  firstPay6: "", //
  firstPay7: "", //
  firstPay8: "", //
  secondPay: "", //
  secondPay1: "", //
  secondPay2: "", //
  secondPay3: "", //
  secondPay4: "", //
  secondPay5: "", //
  secondPay6: "", //
  secondPay7: "", //
  secondPay8: "", //
  firstTax: "", //
  secondTax: "", //
  firstFund: "", //
  secondFund: "", //
  firstSuperior: "", //
  secondSuperior: "", //
  firstZtcbVariety: "", //
  firstWlcbVariety: "", //
  secondZtcbVariety: "", //
  secondWlcbVariety: "", //
  firstZtcbDistributionChanne: "", //
  firstZtcbDistributionChanne1: "", //
  firstZtcbDistributionChanne2: "", //
  firstZtcbDistributionChanne3: "", //
  firstZtcbDistributionChanne4: "", //
  secondZtcbDistributionChanne: "", //
  secondZtcbDistributionChanne1: "", //
  secondZtcbDistributionChanne2: "", //
  secondZtcbDistributionChanne3: "", //
  secondZtcbDistributionChanne4: "", //
  firstWlcbDistributionChanne: "", //
  firstWlcbDistributionChanne1: "", //
  secondWlcbDistributionChanne: "", //
  secondWlcbDistributionChanne1: "" //
};

var paramsRule = {
  firstYear: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]年度
  firstTotalSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2017]年销售收入（万元）
  firstTotalProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2017]年利润总额（万元）
  firstSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]XX制品销售收入（万元）
  firstProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]XX制品利润总额（万元）
  firstPublicationVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]出版品种
  firstSalesVolumes: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]销售数量（套/张）
  firstZtcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品载体出版年销售收入（万元）
  firstZtcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品载体出版年利润总额（万元）
  firstWlcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品信息网络出物年销售收入（万元）
  firstWlcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2017]音像制品信息网络出物年利润总额（万元）
  secondYear: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]年度
  secondTotalSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2018]年销售收入（万元）
  secondTotalProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // 出版单位[2018]年利润总额（万元）
  secondSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]XX制品销售收入（万元）
  secondProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]XX制品利润总额（万元）
  secondPublicationVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]出版品种
  secondSalesVolumes: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]销售数量（套/张）
  secondZtcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品载体出版年销售收入（万元）
  secondZtcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品载体出版年利润总额（万元）
  secondWlcbSales: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品信息网络出物年销售收入（万元）
  secondWlcbProfit: [{ required: true, message: "不能为空！", trigger: "blur" }], // [2018]音像制品信息网络出物年利润总额（万元）

  firstSales1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSales5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSales5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay6: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay7: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstPay8: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay5: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay6: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay7: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondPay8: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstTax: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondTax: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstFund: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondFund: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstSuperior: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondSuperior: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbVariety: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstZtcbDistributionChanne4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne2: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne3: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondZtcbDistributionChanne4: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  firstWlcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbDistributionChanne: [{ required: true, message: "不能为空！", trigger: "blur" }], //
  secondWlcbDistributionChanne1: [{ required: true, message: "不能为空！", trigger: "blur" }] //
};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var bsParams = { /* 资质情况表 */

	placeSituation: '', // 场所情况
	otherSituation: '', // 其他情况
	placePower: '', // 场所情况所有权（选择项）
	otherPower: '', // 其他场所所有权
	placeArea: '', // 场所面积（平方米）
	remark: '', // 备注

	id: '', // id
	publishMaterialId: '', // publishMaterialId
	publishId: '' // 出版单位ID

};

var paramsRule = {

	placeSituation: [{ required: true, message: '请选择', trigger: 'change' }], // 场所情况
	otherSituation: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 其他情况
	placePower: [{ required: true, message: '请选择', trigger: 'change' }], // 场所情况所有权（选择项）
	otherPower: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 其他场所所有权
	placeArea: [{ required: true, message: '请选择', trigger: 'blur' }], // 场所面积（平方米）
	remark: [{ max: 500, message: '填写内容过长！', trigger: 'blur' }] // 备注

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bsParams = {

    hjName: '', // 奖项名称
    bzObject: '', // 表彰对象
    commend: '', // 奖励内容
    bjName: '', // 颁奖单位
    hjLevel: '', // 获奖级别
    hjLevelOther: '',
    hjDate: '', // 表彰时间

    id: '', // id
    publishMaterialId: '', // publishMaterialId
    publishId: '' // 出版单位ID


};

var paramsRule = {

    hjName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 奖项名称
    bzObject: [{ required: true, message: '请选择', trigger: 'change' }], // 表彰对象
    commend: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 奖励内容
    bjName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 颁奖单位
    hjLevel: [{ required: true, message: '请选择', trigger: 'change' }], // 获奖级别
    hjLevelOther: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    hjDate: [{ required: true, message: '请选择', trigger: 'change' }], // 表彰时间

    id: '', // id
    publishMaterialId: '', // publishMaterialId
    publishId: '' // 出版单位ID

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bsParams = {

    proName: '', // 项目名称
    importantProName: '',
    importantProNameOther: '', // 重点项目名称其他
    hjLevel: '', // 获奖级别
    hjLevelOther: '', // 获奖级别其他
    ydDate: '', // 拟定完成时间
    remark: '',

    id: '', // id
    publishId: '', // 出版单位ID
    publishMaterialId: '' // publishMaterialId

};

var paramsRule = {

    proName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 项目名称
    importantProName: [{ required: true, message: '请选择', trigger: 'change' }],
    importantProNameOther: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    hjLevel: [{ required: true, message: '请选择', trigger: 'change' }], // 获奖级别
    hjLevelOther: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    ydDate: [{ required: true, message: '请选择', trigger: 'change' }], // 拟定完成时间
    remark: [{ max: 500, message: '填写内容过长！', trigger: 'change' }]

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bsParams = {

    type: '', // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: '', // 姓名
    gender: '', // 性别（选择项）
    idNumber: '', // 身份证号码
    job: '', // 职务
    professionalOther: '', // 职务其他
    politicalStatus: '', // 政治面貌（选择项）
    culture: '', // 文化程度（选择项）
    cellphone: '', // 手机
    major: '', // 专业
    professionalTitleSeries: '', // 职称系列（选择项）
    titleLevel: '', // 职称级别（选择项）

    professionalCertificateId: '',
    certificateSituation: '', // 持有出版专业技术人员职业资格证书情况
    professionalCertificate: '', // 职业资格证书文件名

    trainCertificateId: '', // 岗位培训合格证书存放目录
    isTrainCertificate: '', // 是否持有岗位培训合格证书
    trainCertificate: '', // 岗位培训合格证书文件名

    id: '', // id
    publishId: '', // 出版单位ID
    publishMaterialId: '', // publishMaterialId
    publishType: '', // 根据单位性质，决定人员类型（比如1电子业务人员、2音像业务人员、3音像电子业务人员、4连续电子业务人员）

    rzDate: ''
};

var idCard = function idCard(rule, val, callback) {
    var pattern = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
    var reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

    if (val == '') {
        callback(new Error('请输入身份证号或军官证号'));
    } else if (val.length > 15) {
        if (!pattern.test(val)) {
            callback(new Error('身份证号错误'));
        } else {
            callback();
        }
    } else {
        if (!reg.test(val)) {
            callback(new Error('军官证号错误'));
        } else {
            callback();
        }
    }
};

var homePhone = function homePhone(rule, val, callback) {
    //固话验证
    var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
    if (val == '') {
        callback(new Error('请输入电话'));
    } else if (!pattern.test(val)) {
        callback(new Error('电话格式错误！'));
    } else {
        callback();
    }
};

var zipCode = function zipCode(rule, val, callback) {
    // 邮编验证
    var pattern = /(^[0-9]{6})$/;
    if (val == '') {
        callback(new Error('请输入单位邮编'));
    } else if (!pattern.test(val)) {
        callback(new Error('邮编格式错误！'));
    } else {
        callback();
    }
};

var mobelPhone = function mobelPhone(rule, val, callback) {
    // 手机验证
    var pattern = /^1[0-9]{10}$/;
    if (val == '') {
        callback(new Error('请输入手机号'));
    } else if (!pattern.test(val)) {
        callback(new Error('手机号格式错误！'));
    } else {
        callback();
    }
};

var paramsRule = {

    type: [{ required: true, message: '请选择', trigger: 'change' }], // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 姓名
    gender: [{ required: true, message: '请选择', trigger: 'change' }], // 性别（选择项）
    idNumber: [{ validator: idCard, trigger: 'blur' }], // 身份证号码
    job: [{ required: true, message: '请选择', trigger: 'change' }], // 职务
    professionalOther: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 姓名
    politicalStatus: [{ required: true, message: '请选择', trigger: 'change' }], // 政治面貌（选择项）
    culture: [{ required: true, message: '请选择', trigger: 'change' }], // 文化程度（选择项）
    cellphone: [{ validator: mobelPhone, trigger: 'blur' }], // 手机
    major: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 专业
    professionalTitleSeries: [{ required: true, message: '请选择', trigger: 'change' }], // 职称系列（选择项）
    titleLevel: [{ required: true, message: '请选择', trigger: 'change' }], // 职称级别（选择项）
    certificateSituation: [{ required: true, message: '请选择', trigger: 'change' }], // 持有出版专业技术人员职业资格证书情况

    professionalCertificateId: [{ required: true, message: '不能为空！', trigger: 'change' }],
    trainCertificateId: [{ required: true, message: '不能为空！', trigger: 'change' }],
    isTrainCertificate: [{ required: true, message: '请选择', trigger: 'change' }], // 是否持有岗位培训合格证书
    rzDate: [{ required: true, message: '不能为空！', trigger: 'change' }]
};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var bsParams = {

	publication: '', // 连续型电子出版物名称 中文
	publicationEnglish: '', // 连续型电子出版物名称 英文
	category: '', // 类别（选择项）
	recordType: '', // 文种
	periodicals: '', // 刊期（选择项）
	cn: '', // 刊号
	issn: '', // 国际刊号
	approvalTime: '', // 批准时间
	mediaForm: '', // 媒体形态（选择项）
	mediaFormQT: '',
	issueQuantity: '', // 发行数量（套）
	unitPrice: '', // 单价
	isSampleDelivery: '', // 是否按规定向国家版本馆、国家图书馆缴送样本
	publicationScope: '', // 出版范围
	issueScope: '', // 发行范围
	readers: '', // 读者对象

	id: '', // id
	publishMaterialId: '', // publishMaterialId
	publishId: '' // 出版单位ID

};

var paramsRule = {

	publication: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 连续型电子出版物名称 中文
	publicationEnglish: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 连续型电子出版物名称 英文
	category: [{ required: true, message: '请选择', trigger: 'change' }], // 类别（选择项）
	recordType: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 文种
	periodicals: [{ required: true, message: '请选择', trigger: 'change' }], // 刊期（选择项）
	cn: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 刊号
	issn: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 国际刊号
	approvalTime: [{ required: true, message: '请选择', trigger: 'change' }], // 批准时间
	mediaForm: [{ required: true, message: '请选择', trigger: 'change' }], // 媒体形态（选择项）
	mediaFormQT: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], //
	issueQuantity: [{ required: true, message: '请选择', trigger: 'change' }], // 发行数量（套）
	unitPrice: [{ required: true, message: '请选择', trigger: 'change' }], // 单价
	isSampleDelivery: [{ required: true, message: '请选择', trigger: 'change' }], // 是否按规定向国家版本馆、国家图书馆缴送样本
	publicationScope: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 出版范围
	issueScope: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 发行范围
	readers: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 读者对象

	id: '', // id
	publishMaterialId: '', // publishMaterialId
	publishId: '' // 出版单位ID

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bsParams = {
  publishName: "", // 出版单位名称
  publishAddr: "", // 出版单位地址
  publishPostalcode: "", // 出版单位邮政编码
  publishLinkman: "", // 出版单位联系人
  publishTel: "", // 出版单位联系电话

  hostName: "", // 主办单位
  chargeName: "", // 主管单位

  workers: "", // 职工总数
  businessWorkers: "", // 连续型电子出版物业务人员数
  otherWorkers: "", // 其中取得中级以上资格证书人员数
  unitType: "", // 法人身份
  evolution: "", // 演变情况
  remark: "", // 备注

  id: "", // id
  publishMaterialId: "", // 当前年度，出版单位填写资料表，资料表Id

  publishId: "", // 出版单位ID
  hostId: "", // 主办单位ID
  chargeId: "" // 主管单位ID
};

var zipCode = function zipCode(rule, val, callback) {
  // 邮编验证
  var pattern = /(^[0-9]{6})$/;
  if (val == "") {
    callback(new Error("请输入单位邮编"));
  } else if (!pattern.test(val)) {
    callback(new Error("邮编格式错误！"));
  } else {
    callback();
  }
};

var mobelPhone = function mobelPhone(rule, val, callback) {
  // 手机验证
  var pattern = /^1[0-9]{10}$/;
  if (val == "") {
    callback(new Error("请输入手机号"));
  } else if (!pattern.test(val)) {
    callback(new Error("手机号格式错误！"));
  } else {
    callback();
  }
};

var paramsRule = {
  publication: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }],
  publishName: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 出版单位名称
  publishAddr: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 出版单位地址
  publishPostalcode: [{ validator: zipCode, trigger: "blur" }], // 出版单位邮政编码
  publishLinkman: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 出版单位联系人
  publishTel: [{ validator: mobelPhone, trigger: "blur" }], // 出版单位联系电话

  hostName: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 主办单位
  chargeName: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 主管单位

  workers: [{ required: true, message: "不能为空！", trigger: "change" }], // 职工总数
  businessWorkers: [{ required: true, message: "不能为空！", trigger: "change" }], // 连续型电子出版物业务人员数
  otherWorkers: [{ required: true, message: "不能为空！", trigger: "change" }], // 其中取得中级以上资格证书人员数
  unitType: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 法人身份
  evolution: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }], // 演变情况

  firstTotalSales: [{ required: true, message: "不能为空！", trigger: "change" }], // 2023年出版单位年销售收入（万元）
  secondTotalSales: [{ required: true, message: "不能为空！", trigger: "change" }], // 2024年出版单位年销售收入（万元）
  firstTotalProfit: [{ required: true, message: "不能为空！", trigger: "change" }], // 2023出版单位年度利润（税后）总额（万元）
  secondTotalProfit: [{ required: true, message: "不能为空！", trigger: "change" }], // 2024出版单位年度利润（税后）总额（万元）

  remark: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "blur" }] // 备注
};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bsParams = {

    type: '', // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: '', // 姓名
    gender: '', // 性别（选择项）
    idNumber: '', // 身份证号码
    job: '', // 职务
    professionalOther: '', // 职务其他
    politicalStatus: '', // 政治面貌（选择项）
    culture: '', // 文化程度（选择项）
    cellphone: '', // 手机
    major: '', // 专业
    professionalTitleSeries: '', // 职称系列（选择项）
    titleLevel: '', // 职称级别（选择项）

    professionalCertificateId: '',
    certificateSituation: '', // 持有出版专业技术人员职业资格证书情况
    professionalCertificate: '', // 职业资格证书文件名

    trainCertificateId: '', // 岗位培训合格证书存放目录
    isTrainCertificate: '', // 是否持有岗位培训合格证书
    trainCertificate: '', // 岗位培训合格证书文件名


    id: '', // id
    publishId: '', // 出版单位ID
    publishMaterialId: '', // publishMaterialId
    publishType: '' // 根据单位性质，决定人员类型（比如1电子业务人员、2音像业务人员、3音像电子业务人员、4连续电子业务人员）

};

var idCard = function idCard(rule, val, callback) {
    var pattern = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
    var reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

    if (val == '') {
        callback(new Error('请输入身份证号或军官证号'));
    } else if (val.length > 15) {
        if (!pattern.test(val)) {
            callback(new Error('身份证号错误'));
        } else {
            callback();
        }
    } else {
        if (!reg.test(val)) {
            callback(new Error('军官证号错误'));
        } else {
            callback();
        }
    }
};

var homePhone = function homePhone(rule, val, callback) {
    //固话验证
    var pattern = /(^(0\d{2,3})?-?\d{7,8}$)$/;
    if (val == '') {
        callback(new Error('请输入电话'));
    } else if (!pattern.test(val)) {
        callback(new Error('电话格式错误！'));
    } else {
        callback();
    }
};

var zipCode = function zipCode(rule, val, callback) {
    // 邮编验证
    var pattern = /(^[0-9]{6})$/;
    if (val == '') {
        callback(new Error('请输入单位邮编'));
    } else if (!pattern.test(val)) {
        callback(new Error('邮编格式错误！'));
    } else {
        callback();
    }
};

var mobelPhone = function mobelPhone(rule, val, callback) {
    // 手机验证
    var pattern = /^1[0-9]{10}$/;
    if (val == '') {
        callback(new Error('请输入手机号'));
    } else if (!pattern.test(val)) {
        callback(new Error('手机号格式错误！'));
    } else {
        callback();
    }
};

var paramsRule = {

    type: [{ required: true, message: '请选择', trigger: 'change' }], // 岗位类型（1：主要负责人、2：其他负责人、3：编辑人员）
    fullName: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 姓名
    gender: [{ required: true, message: '请选择', trigger: 'change' }], // 性别（选择项）
    idNumber: [{ validator: idCard, trigger: 'blur' }], // 身份证号码
    job: [{ required: true, message: '请选择', trigger: 'change' }], // 职务
    professionalOther: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }],
    politicalStatus: [{ required: true, message: '请选择', trigger: 'change' }], // 政治面貌（选择项）
    culture: [{ required: true, message: '请选择', trigger: 'change' }], // 文化程度（选择项）
    cellphone: [{ validator: mobelPhone, trigger: 'blur' }], // 手机
    major: [{ required: true, message: '不能为空！', trigger: 'blur' }, { max: 127, message: '填写内容过长！', trigger: 'blur' }], // 专业
    professionalTitleSeries: [{ required: true, message: '请选择', trigger: 'change' }], // 职称系列（选择项）
    titleLevel: [{ required: true, message: '请选择', trigger: 'change' }], // 职称级别（选择项）

    certificateSituation: [{ required: true, message: '请选择', trigger: 'change' }], // 持有出版专业技术人员职业资格证书情况

    isTrainCertificate: [{ required: true, message: '请选择', trigger: 'change' }] // 是否持有岗位培训合格证书

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});
var bsParams = {};

var paramsRule = {

				id: '', // id
				publishMaterialId: '', // publishMaterialId
				publishId: '' // 出版单位ID

};

exports.bsParams = bsParams;
exports.paramsRule = paramsRule;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerComponentMap = exports.constantRouterMap = undefined;

var _vue = __webpack_require__(211);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1845);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Layout = __webpack_require__(635);

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _import = __webpack_require__(812);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */


/* login */
var Login = _import("login/login");
var ForcePassSet = _import("login/passSet");
var PassSet = _import("components/userSet/passReset");

/* dashboard */
var dashboard = _import("dashboard/index");

/* error page */
var Err404 = _import("404");

/* 系统设置 */

var MdelMent = _import("pgment/modelMent");
var UserMent = _import("pgment/userMent");
var RoleMent = _import("pgment/roleMent");
var DictMent = _import("pgment/dictMent");
var PublishMent = _import("pgment/publishMent");
var SectMent = _import("pgment/sectMent");
var SectStatic = _import("pgment/sectStatic");

/* 出版单位 */

var audioPs = _import("pressRole/Audio_Electronic/audioPress");
var electPs = _import("pressRole/Audio_Electronic/electPress");
var pgStep = _import("pressRole/Audio_Electronic/examProgress");
var deepSee = _import("pressRole/Audio_Electronic/skimFrame");
// 音像/电子核验进度历史
var pgStepHistory = _import("pressRole/Audio_Electronic/examProgressHistory");
// 连续型出版物核验进度历史
var successiveStepHistory = _import("pressRole/SuccessivePart/examProgressHistory");

var successivePs = _import("pressRole/SuccessivePart/successiveList");
var successiveTb = _import("pressRole/SuccessivePart/successiveTabs");
var successiveStep = _import("pressRole/SuccessivePart/examProgress");
var successiveRead = _import("pressRole/SuccessivePart/skimFrame");

var table1Edit = _import("pressRole/Audio_Electronic/forEdit/table1");
var table2Edit = _import("pressRole/Audio_Electronic/forEdit/table2");
var table3Edit = _import("pressRole/Audio_Electronic/forEdit/table3");
var table4Edit = _import("pressRole/Audio_Electronic/forEdit/table4");
var table5Edit = _import("pressRole/Audio_Electronic/forEdit/table5");
var table6Edit = _import("pressRole/Audio_Electronic/forEdit/table6");
var table7Edit = _import("pressRole/Audio_Electronic/forEdit/table7");
var table8Edit = _import("pressRole/Audio_Electronic/forEdit/table8");
var table9Edit = _import("pressRole/Audio_Electronic/forEdit/table9");
var table10Edit = _import("pressRole/Audio_Electronic/forEdit/table10");

var table4Tab = _import("pressRole/Audio_Electronic/forTabs/table4");
var table5Tab = _import("pressRole/Audio_Electronic/forTabs/table5");
var table6Tab = _import("pressRole/Audio_Electronic/forTabs/table6");
var table8Tab = _import("pressRole/Audio_Electronic/forTabs/table8");
var table9Tab = _import("pressRole/Audio_Electronic/forTabs/table9");

var ssTab1Edit = _import("pressRole/SuccessivePart/forEdit/ssTab1");
var ssTab2Edit = _import("pressRole/SuccessivePart/forEdit/ssTab2");
var ssTab3Edit = _import("pressRole/SuccessivePart/forEdit/ssTab3");
var ssTab4Edit = _import("pressRole/SuccessivePart/forEdit/ssTab4");
var ssTab5Edit = _import("pressRole/SuccessivePart/forEdit/ssTab5");

var ssTab4List = _import("pressRole/SuccessivePart/forTabs/ssTab4");

/* 省局 */

var audioEx = _import("provinceRole/audioPgress/audioList");
var audioRegister = _import("provinceRole/audioPgress/audioRegist");
var audioRpt = _import("provinceRole/audioPgress/audioReport");
var AudioSeek = _import("provinceRole/audioPgress/AudioPressSeek");

var electEx = _import("provinceRole/electPgress/electList");
var electRegister = _import("provinceRole/electPgress/electRegist");
var electRpt = _import("provinceRole/electPgress/electReport");

var examCeek = _import("provinceRole/Audio_Elect/commonTabs");
var provinceRpt = _import("provinceRole/Audio_Elect/commonReport");
var ElectSeek = _import("provinceRole/electPgress/ElectPressSeek");

var successiveEx = _import("provinceRole/successivePgress/successiveList");
var pvcSkimFrame = _import("provinceRole/successivePgress/successiveTabs");
var ssReport = _import("provinceRole/successivePgress/successiveReport");
var ssRegist = _import("provinceRole/successivePgress/successiveRegist");
var successiveSeek = _import("provinceRole/successivePgress/successivePressSeek");

/* 总局 */

var audioFEx = _import("adminRole/audioFExam");
var electFEx = _import("adminRole/electFExam");
var successiveFEx = _import("adminRole/successiveFExam");
var adminPck = _import("adminRole/adminPressck");
var adminssSuccessSkim = _import("adminRole/adminSuccessSkim");
var adminAudioSeek = _import("adminRole/AudioPressSeek");
var adminElectSeek = _import("adminRole/ElectPressSeek");
var adminSuccessiveSeek = _import("adminRole/successivePressSeek");
var adminPersonOperation = _import("adminRole/adminPersonOperation");
var adminPublishOperation = _import("adminRole/adminPublishOperation");
var adminBasicOperation = _import("adminRole/adminBasicOperation");
var chart1 = _import("adminRole/chart1");

/**zym.音像、电子上报情况统计 start */
var adminYxauditQuery = _import("adminRole/adminYxauditQuery");
var adminDzauditQuery = _import("adminRole/adminDzauditQuery");
/**zym.音像、电子上报情况统计 end */

/* 查看打印 */

var seekTab1 = _import("components/SPEC/glanceDcp/table1");
var seekTab2 = _import("components/SPEC/glanceDcp/table2");
var seekTab3 = _import("components/SPEC/glanceDcp/table3");
var seekTab4 = _import("components/SPEC/glanceDcp/table4");
var seekTab5 = _import("components/SPEC/glanceDcp/table5");
var seekTab6 = _import("components/SPEC/glanceDcp/table6");
var seekTab7 = _import("components/SPEC/glanceDcp/table7");
var seekTab8 = _import("components/SPEC/glanceDcp/table8");
var seekTab9 = _import("components/SPEC/glanceDcp/table9");
var seekTab209 = _import("components/SPEC/glanceDcp/table209");

var listTab4 = _import("components/SPEC/glanceTab/table4");
var listTab5 = _import("components/SPEC/glanceTab/table5");
var listTab6 = _import("components/SPEC/glanceTab/table6");
var listTab8 = _import("components/SPEC/glanceTab/table8");
var listTab9 = _import("components/SPEC/glanceTab/table9");

var skimTab1 = _import("components/SPEC/ssBlock/forEdit/ssTab1");
var skimTab2 = _import("components/SPEC/ssBlock/forEdit/ssTab2");
var skimTab3 = _import("components/SPEC/ssBlock/forEdit/ssTab3");
var skimTab4 = _import("components/SPEC/ssBlock/forEdit/ssTab4");
var skimTab5 = _import("components/SPEC/ssBlock/forEdit/ssTab5");

var ssListTab = _import("components/SPEC/ssBlock/forTabs/ssTab4");

// Vue.use(Router);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
var constantRouterMap = exports.constantRouterMap = [{ path: "/login", component: Login, hidden: true }, { path: "/404", component: Err404, hidden: true }, { path: "/paddSet", component: ForcePassSet, hidden: true }, {
  path: "/",
  component: _Layout2.default,
  redirect: "/dashboard",
  name: "Home",
  hidden: true,
  children: [{ path: "dashboard", component: dashboard }]
}];

exports.default = new _vueRouter2.default({
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: constantRouterMap
});

// key必须对应数据库中的key否则不能注册路由

var registerComponentMap = exports.registerComponentMap = [{
  key: "press_role",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "audio_press",
    parent: false,
    component: audioPs
  }, {
    key: "elect_press",
    parent: false,
    component: electPs
  }, {
    key: "successive_press",
    parent: false,
    component: successivePs
  }, {
    key: "successive_tabs",
    parent: false,
    component: successiveTb
  }, {
    key: "successive_step",
    parent: false,
    component: successiveStep
  }, {
    key: "successive_read",
    parent: false,
    component: successiveRead
  }, {
    key: "pgress_step",
    parent: false,
    component: pgStep
  }, {
    key: "deep_see",
    parent: false,
    component: deepSee
  }, {
    key: "edit_tab1",
    parent: false,
    component: table1Edit
  }, {
    key: "edit_tab2",
    parent: false,
    component: table2Edit
  }, {
    key: "edit_tab3",
    parent: false,
    component: table3Edit
  }, {
    key: "edit_tab4",
    parent: false,
    component: table4Edit
  }, {
    key: "edit_tab5",
    parent: false,
    component: table5Edit
  }, {
    key: "edit_tab6",
    parent: false,
    component: table6Edit
  }, {
    key: "edit_tab7",
    parent: false,
    component: table7Edit
  }, {
    key: "edit_tab8",
    parent: false,
    component: table8Edit
  }, {
    key: "edit_tab9",
    parent: false,
    component: table9Edit
  }, {
    key: "edit_tab10",
    parent: false,
    component: table10Edit
  }, {
    key: "edit_ssTab1",
    parent: false,
    component: ssTab1Edit
  }, {
    key: "edit_ssTab2",
    parent: false,
    component: ssTab2Edit
  }, {
    key: "edit_ssTab3",
    parent: false,
    component: ssTab3Edit
  }, {
    key: "edit_ssTab4",
    parent: false,
    component: ssTab4Edit
  }, {
    key: "edit_ssTab5",
    parent: false,
    component: ssTab5Edit
  }, {
    key: "view_tab4",
    parent: false,
    component: table4Tab
  }, {
    key: "view_tab5",
    parent: false,
    component: table5Tab
  }, {
    key: "view_tab6",
    parent: false,
    component: table6Tab
  }, {
    key: "view_tab8",
    parent: false,
    component: table8Tab
  }, {
    key: "view_tab9",
    parent: false,
    component: table9Tab
  }, {
    key: "sstab4_list",
    parent: false,
    component: ssTab4List
  }, {
    key: "edsct_tab1",
    parent: false,
    component: seekTab1
  }, {
    key: "edsct_tab2",
    parent: false,
    component: seekTab2
  }, {
    key: "edsct_tab3",
    parent: false,
    component: seekTab3
  }, {
    key: "edsct_tab4",
    parent: false,
    component: seekTab4
  }, {
    key: "edsct_tab5",
    parent: false,
    component: seekTab5
  }, {
    key: "edsct_tab6",
    parent: false,
    component: seekTab6
  }, {
    key: "edsct_tab7",
    parent: false,
    component: seekTab7
  }, {
    key: "edsct_tab8",
    parent: false,
    component: seekTab8
  }, {
    key: "edsct_tab9",
    parent: false,
    component: seekTab9
  }, {
    key: "edsct_tab10",
    parent: false,
    component: seekTab209
  }, {
    key: "edlct_tab4",
    parent: false,
    component: listTab4
  }, {
    key: "edlct_tab5",
    parent: false,
    component: listTab5
  }, {
    key: "edlct_tab6",
    parent: false,
    component: listTab6
  }, {
    key: "edlct_tab8",
    parent: false,
    component: listTab8
  }, {
    key: "edlct_tab9",
    parent: false,
    component: listTab9
  }, {
    key: "ss_skimtab1",
    parent: false,
    component: skimTab1
  }, {
    key: "ss_skimtab2",
    parent: false,
    component: skimTab2
  }, {
    key: "ss_skimtab3",
    parent: false,
    component: skimTab3
  }, {
    key: "ss_skimtab4",
    parent: false,
    component: skimTab4
  }, {
    key: "ss_skimtab5",
    parent: false,
    component: skimTab5
  }, {
    key: "ss_listtab4",
    parent: false,
    component: ssListTab
  }]
}, {
  key: "province_role",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "audio_exam",
    parent: false,
    component: audioEx
  }, {
    key: "elect_exam",
    parent: false,
    component: electEx
  }, {
    key: "successive_exam",
    parent: false,
    component: successiveEx
  }, {
    key: "province_report",
    parent: false,
    component: provinceRpt
  }, {
    key: "ss_report",
    parent: false,
    component: ssReport
  }, {
    key: "audio_register",
    parent: false,
    component: audioRegister
  }, {
    key: "elect_register",
    parent: false,
    component: electRegister
  }, {
    key: "ss_regist",
    parent: false,
    component: ssRegist
  }, {
    key: "successive_skim",
    parent: false,
    component: pvcSkimFrame
  }, {
    key: "exam_check",
    parent: false,
    component: examCeek
  }, {
    key: "Audio_seek",
    parent: false,
    component: AudioSeek
  }, {
    key: "Elect_seek",
    parent: false,
    component: ElectSeek
  }, {
    key: "successive_seek",
    parent: false,
    component: successiveSeek
  }, {
    key: "edsct_tab1",
    parent: false,
    component: seekTab1
  }, {
    key: "edsct_tab2",
    parent: false,
    component: seekTab2
  }, {
    key: "edsct_tab3",
    parent: false,
    component: seekTab3
  }, {
    key: "edsct_tab4",
    parent: false,
    component: seekTab4
  }, {
    key: "edsct_tab5",
    parent: false,
    component: seekTab5
  }, {
    key: "edsct_tab6",
    parent: false,
    component: seekTab6
  }, {
    key: "edsct_tab7",
    parent: false,
    component: seekTab7
  }, {
    key: "edsct_tab8",
    parent: false,
    component: seekTab8
  }, {
    key: "edsct_tab9",
    parent: false,
    component: seekTab9
  }, {
    key: "edsct_tab10",
    parent: false,
    component: seekTab209
  }, {
    key: "edlct_tab4",
    parent: false,
    component: listTab4
  }, {
    key: "edlct_tab5",
    parent: false,
    component: listTab5
  }, {
    key: "edlct_tab6",
    parent: false,
    component: listTab6
  }, {
    key: "edlct_tab8",
    parent: false,
    component: listTab8
  }, {
    key: "edlct_tab9",
    parent: false,
    component: listTab9
  }, {
    key: "ss_skimtab1",
    parent: false,
    component: skimTab1
  }, {
    key: "ss_skimtab2",
    parent: false,
    component: skimTab2
  }, {
    key: "ss_skimtab3",
    parent: false,
    component: skimTab3
  }, {
    key: "ss_skimtab4",
    parent: false,
    component: skimTab4
  }, {
    key: "ss_skimtab5",
    parent: false,
    component: skimTab5
  }, {
    key: "ss_listtab4",
    parent: false,
    component: ssListTab
  }]
}, {
  key: "admin_role",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "audio_fexam",
    parent: false,
    component: audioFEx
  }, {
    key: "elect_fexam",
    parent: false,
    component: electFEx
  }, {
    key: "successive_fexam",
    parent: false,
    component: successiveFEx
  }, {
    key: "admin_fexam",
    parent: false,
    component: adminPck
  }, {
    key: "successive_skim",
    parent: false,
    component: adminssSuccessSkim
  },

  /**zym.音像、电子上报情况统计 end */
  {
    key: "edsct_tab1",
    parent: false,
    component: seekTab1
  }, {
    key: "edsct_tab2",
    parent: false,
    component: seekTab2
  }, {
    key: "edsct_tab3",
    parent: false,
    component: seekTab3
  }, {
    key: "edsct_tab4",
    parent: false,
    component: seekTab4
  }, {
    key: "edsct_tab5",
    parent: false,
    component: seekTab5
  }, {
    key: "edsct_tab6",
    parent: false,
    component: seekTab6
  }, {
    key: "edsct_tab7",
    parent: false,
    component: seekTab7
  }, {
    key: "edsct_tab8",
    parent: false,
    component: seekTab8
  }, {
    key: "edsct_tab9",
    parent: false,
    component: seekTab9
  }, {
    key: "edsct_tab10",
    parent: false,
    component: seekTab209
  }, {
    key: "edlct_tab4",
    parent: false,
    component: listTab4
  }, {
    key: "edlct_tab5",
    parent: false,
    component: listTab5
  }, {
    key: "edlct_tab6",
    parent: false,
    component: listTab6
  }, {
    key: "edlct_tab8",
    parent: false,
    component: listTab8
  }, {
    key: "edlct_tab9",
    parent: false,
    component: listTab9
  }, {
    key: "ss_skimtab1",
    parent: false,
    component: skimTab1
  }, {
    key: "ss_skimtab2",
    parent: false,
    component: skimTab2
  }, {
    key: "ss_skimtab3",
    parent: false,
    component: skimTab3
  }, {
    key: "ss_skimtab4",
    parent: false,
    component: skimTab4
  }, {
    key: "ss_skimtab5",
    parent: false,
    component: skimTab5
  }, {
    key: "ss_listtab4",
    parent: false,
    component: ssListTab
  }]
},
// 出版社 - 核验进度查询
{
  key: "cbs_examine_progress",
  parent: true,
  component: _Layout2.default,
  children: [{
    key: "cbs_examine_progress_yd",
    parent: false,
    component: pgStepHistory
  }, {
    key: "cbs_examine_progress_lxdz",
    parent: false,
    component: successiveStepHistory
  },
  // 连续型出版物Tabs
  {
    key: "successive_tabs",
    parent: false,
    component: successiveTb
  }, {
    key: "successive_read",
    parent: false,
    component: successiveRead
  },
  // {
  //   key: "pgress_step",
  //   parent: false,
  //   component: pgStep,
  // },
  {
    key: "deep_see",
    parent: false,
    component: deepSee
  }, {
    key: "edit_tab1",
    parent: false,
    component: table1Edit
  }, {
    key: "edit_tab2",
    parent: false,
    component: table2Edit
  }, {
    key: "edit_tab3",
    parent: false,
    component: table3Edit
  }, {
    key: "edit_tab4",
    parent: false,
    component: table4Edit
  }, {
    key: "edit_tab5",
    parent: false,
    component: table5Edit
  }, {
    key: "edit_tab6",
    parent: false,
    component: table6Edit
  }, {
    key: "edit_tab7",
    parent: false,
    component: table7Edit
  }, {
    key: "edit_tab8",
    parent: false,
    component: table8Edit
  }, {
    key: "edit_tab9",
    parent: false,
    component: table9Edit
  }, {
    key: "edit_tab10",
    parent: false,
    component: table10Edit
  }, {
    key: "edit_ssTab1",
    parent: false,
    component: ssTab1Edit
  }, {
    key: "edit_ssTab2",
    parent: false,
    component: ssTab2Edit
  }, {
    key: "edit_ssTab3",
    parent: false,
    component: ssTab3Edit
  }, {
    key: "edit_ssTab4",
    parent: false,
    component: ssTab4Edit
  }, {
    key: "edit_ssTab5",
    parent: false,
    component: ssTab5Edit
  }, {
    key: "view_tab4",
    parent: false,
    component: table4Tab
  }, {
    key: "view_tab5",
    parent: false,
    component: table5Tab
  }, {
    key: "view_tab6",
    parent: false,
    component: table6Tab
  }, {
    key: "view_tab8",
    parent: false,
    component: table8Tab
  }, {
    key: "view_tab9",
    parent: false,
    component: table9Tab
  }, {
    key: "sstab4_list",
    parent: false,
    component: ssTab4List
  }, {
    key: "edsct_tab1",
    parent: false,
    component: seekTab1
  }, {
    key: "edsct_tab2",
    parent: false,
    component: seekTab2
  }, {
    key: "edsct_tab3",
    parent: false,
    component: seekTab3
  }, {
    key: "edsct_tab4",
    parent: false,
    component: seekTab4
  }, {
    key: "edsct_tab5",
    parent: false,
    component: seekTab5
  }, {
    key: "edsct_tab6",
    parent: false,
    component: seekTab6
  }, {
    key: "edsct_tab7",
    parent: false,
    component: seekTab7
  }, {
    key: "edsct_tab8",
    parent: false,
    component: seekTab8
  }, {
    key: "edsct_tab9",
    parent: false,
    component: seekTab9
  }, {
    key: "edsct_tab10",
    parent: false,
    component: seekTab209
  }, {
    key: "edlct_tab4",
    parent: false,
    component: listTab4
  }, {
    key: "edlct_tab5",
    parent: false,
    component: listTab5
  }, {
    key: "edlct_tab6",
    parent: false,
    component: listTab6
  }, {
    key: "edlct_tab8",
    parent: false,
    component: listTab8
  }, {
    key: "edlct_tab9",
    parent: false,
    component: listTab9
  }, {
    key: "ss_skimtab1",
    parent: false,
    component: skimTab1
  }, {
    key: "ss_skimtab2",
    parent: false,
    component: skimTab2
  }, {
    key: "ss_skimtab3",
    parent: false,
    component: skimTab3
  }, {
    key: "ss_skimtab4",
    parent: false,
    component: skimTab4
  }, {
    key: "ss_skimtab5",
    parent: false,
    component: skimTab5
  }, {
    key: "ss_listtab4",
    parent: false,
    component: ssListTab
  }]
}, {
  key: "admin_seek_publish",
  parent: true,
  component: _Layout2.default,
  children: [{
    key: "admin_audio_seek",
    parent: false,
    component: adminAudioSeek
  }, {
    key: "admin_elect_seek",
    parent: false,
    component: adminElectSeek
  }, {
    key: "admin_successive_seek",
    parent: false,
    component: adminSuccessiveSeek
  },
  /**zym.音像、电子上报情况统计 start */
  {
    key: "admin_yxaudit_query",
    parent: false,
    component: adminYxauditQuery
  }, {
    key: "admin_dzaudit_query",
    parent: false,
    component: adminDzauditQuery
  },

  /**zym.音像、电子上报情况统计 end */
  {
    key: "admin_fexam",
    parent: false,
    component: adminPck
  }, {
    key: "edsct_tab1",
    parent: false,
    component: seekTab1
  }, {
    key: "edsct_tab2",
    parent: false,
    component: seekTab2
  }, {
    key: "edsct_tab3",
    parent: false,
    component: seekTab3
  }, {
    key: "edsct_tab4",
    parent: false,
    component: seekTab4
  }, {
    key: "edsct_tab5",
    parent: false,
    component: seekTab5
  }, {
    key: "edsct_tab6",
    parent: false,
    component: seekTab6
  }, {
    key: "edsct_tab7",
    parent: false,
    component: seekTab7
  }, {
    key: "edsct_tab8",
    parent: false,
    component: seekTab8
  }, {
    key: "edsct_tab9",
    parent: false,
    component: seekTab9
  }, {
    key: "edsct_tab10",
    parent: false,
    component: seekTab209
  }, {
    key: "edlct_tab4",
    parent: false,
    component: listTab4
  }, {
    key: "edlct_tab5",
    parent: false,
    component: listTab5
  }, {
    key: "edlct_tab6",
    parent: false,
    component: listTab6
  }, {
    key: "edlct_tab8",
    parent: false,
    component: listTab8
  }, {
    key: "edlct_tab9",
    parent: false,
    component: listTab9
  }, {
    key: "ss_skimtab1",
    parent: false,
    component: skimTab1
  }, {
    key: "ss_skimtab2",
    parent: false,
    component: skimTab2
  }, {
    key: "ss_skimtab3",
    parent: false,
    component: skimTab3
  }, {
    key: "ss_skimtab4",
    parent: false,
    component: skimTab4
  }, {
    key: "ss_skimtab5",
    parent: false,
    component: skimTab5
  }, {
    key: "ss_listtab4",
    parent: false,
    component: ssListTab
  }, {
    key: "successive_skim",
    parent: false,
    component: adminssSuccessSkim
  }]
}, {
  key: "admin_seek_info",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "admin_basic_operation",
    parent: false,
    component: adminBasicOperation
  }, {
    key: "admin_person_operation",
    parent: false,
    component: adminPersonOperation
  }, {
    key: "admin_publish_operation",
    parent: false,
    component: adminPublishOperation
  }]
}, {
  key: "admin_statistical_analysis",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "chart1",
    parent: false,
    component: chart1
  }]
}, {
  key: "ss_ment",
  component: _Layout2.default,
  parent: true,
  children: [{
    key: "sect_ment",
    parent: false,
    component: SectMent
  }, {
    key: "user_ment",
    parent: false,
    component: UserMent
  }, {
    key: "role_ment",
    parent: false,
    component: RoleMent
  }, {
    key: "dict_ment",
    parent: false,
    component: DictMent
  }, {
    key: "publish_ment",
    parent: false,
    component: PublishMent
  }, {
    key: "model_ment",
    parent: false,
    component: MdelMent
  }, {
    key: "sect_static",
    parent: false,
    component: SectStatic
  }]
}, { key: "pass_set", noDropdown: true, component: _Layout2.default, childrenComponent: PassSet }];

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(665);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(664);

var _store = __webpack_require__(264);

var _store2 = _interopRequireDefault(_store);

var _auth = __webpack_require__(46);

var _object = __webpack_require__(266);

var _validate = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 创建axios实例
var service2 = _axios2.default.create({
  baseURL: "https://ydnj.capub.cn/statistics", // api的base_url
  withCredentials: true, // zym.send cookies when cross-domain request
  // timeout: 72000000 // 请求超时时间
  timeout: 20 * 60 * 1000 // 请求超时时间
});

// request拦截器
service2.interceptors.request.use(function (config) {
  if (_store2.default.getters.token) {
    // config.headers['X-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers["Authorization"] = "Bearer " + (0, _auth.getToken)();
  }

  var param = (0, _object.tirm)(config.data);
  config.data = param;
  // config['data1']= param;
  console.debug(config.url, config.data);
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  _promise2.default.reject(error);
});

// respone拦截器
service2.interceptors.response.use(function (response) {
  // console.debug('rep: ', response.data.data)
  /**
   * code大于0抛错
   */
  var res = response.data;
  // const payload = res.payload
  // if(payload.resultStatus&&payload.resultStatus.status>0){
  //     console.log(res.payload.resultStatus.status)
  if (res.code && res.code !== 0) {
    console.warn("返回异常: ", res.code, res);
    (0, _elementUi.Message)({
      message: res.message || res.error,
      type: "error",
      duration: 5 * 1000
    });
    // 画面sonomama 不想统一处理
    return _promise2.default.resolve(res);
    // 130033:非法的token; 130033:其他客户端登录了;  130033:Token 过期了;
    // if (res.payload.resultStatus.status === 130033) {
    //     MessageBox.alert('你已被登出，请重新登录，如非本人操作请修改密码', '提示', {
    //         confirmButtonText: '重新登录',
    //         callback: action => {
    //             store.dispatch('FedLogOut').then(() => {
    //                 location.reload();// 为了重新实例化vue-router对象 避免bug
    //             });
    //         }
    //     });
    // }else{
    //     Message({
    //         message: payload.resultStatus.message,
    //         type: 'error',
    //         duration: 5 * 1000
    //     });
    // }
    // return Promise.reject('error');
  } else {
    //HYY 修改
    if (res instanceof Blob) {
      var content = response.headers["content-disposition"];
      var filename = "文件名称";
      if (!(0, _validate.isEmpty)(content)) {
        var arr = content.split("=");
        if (arr.length > 1) {
          filename = arr[1];
        }
      }
      localStorage.setItem("dfilename", filename);
      return _promise2.default.resolve(res);
    } else {
      return _promise2.default.resolve(res.data);
    }
  }
}, function (error) {
  console.log("err:", error); // for debug
  var _error$response = error.response,
      data = _error$response.data,
      status = _error$response.status,
      statusText = _error$response.statusText;

  var message = "";
  if (error.message === "Network Error") {
    message = "网络异常";
  } else if (error.message === "timeout of 200000ms exceeded") {
    message = "请求服务器超时，请重试";
  } else {
    message = error.message;
  }
  if (status && status === 401) message = "认证已经过期，请尝试退出并重新登录。";
  (0, _elementUi.Message)({
    message: message,
    type: "error",
    duration: 5 * 1000
  });
  // var message = '网络异常'
  // if(error==='Error: Network Error'){
  //     message = '网络异常'
  // }
  return _promise2.default.reject(error);
});

exports.default = service2;

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1417)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3361eb2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1472)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1754),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6374096f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1502)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1784),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83fe70f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1474)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1756),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-668fe809",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1440)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1724),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42f8645e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1439)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(721),
  /* template */
  __webpack_require__(1723),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1388)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(731),
  /* template */
  __webpack_require__(1677),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1464)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(732),
  /* template */
  __webpack_require__(1747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1398)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(734),
  /* template */
  __webpack_require__(1686),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1504)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(735),
  /* template */
  __webpack_require__(1786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e73146c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1521)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(737),
  /* template */
  __webpack_require__(1802),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d07098a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1465)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(738),
  /* template */
  __webpack_require__(1748),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b723828",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1429)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(739),
  /* template */
  __webpack_require__(1714),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1499)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(740),
  /* template */
  __webpack_require__(1782),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7eb4d13a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(211);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(1569);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(368);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(264);

var _store2 = _interopRequireDefault(_store);

var _nprogress = __webpack_require__(1532);

var _nprogress2 = _interopRequireDefault(_nprogress);

__webpack_require__(1385);

__webpack_require__(1384);

__webpack_require__(809);

__webpack_require__(1386);

var _auth = __webpack_require__(46);

var _vueLazyload = __webpack_require__(667);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

__webpack_require__(355);

__webpack_require__(811);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//阿里icon
_vue2.default.config.productionTip = false;
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'


_vue2.default.directive('title', {
    inserted: function inserted(el, binding) {
        document.title = el.innerText;
        el.remove();
    }
});

// Vue.use(ElementUI, { locale })
// Vue.use(ElementUI);
_vue2.default.use(_vueLazyload2.default, {
    preLoad: 1.3,
    error: 'http://img1.3lian.com/2015/a1/82/d/158.jpg',
    loading: 'http://h.hiphotos.baidu.com/zhidao/wh%3D450%2C600/sign=bf193fc3f8f2b211e47b8d4affb0490e/e824b899a9014c08c1277115097b02087bf4f466.jpg',
    attempt: 1
});

var whiteList = ['/login', '/viewadcontent', '/adcontent'];
_router2.default.beforeEach(function (to, from, next) {
    _nprogress2.default.start();
    if ((0, _auth.getToken)()) {
        if (to.path === '/login') {
            next({ path: '/' });
        } else {
            if (_store2.default.getters.roles.length === 0) {
                _store2.default.dispatch('fileTokenStore');
                _store2.default.dispatch('getUserRuleList').then(function (response) {
                    // 拉取user_info
                    // roro
                    var roles = response.menus;

                    if (roles) {
                        // if (response && response.getMenuModules) {

                        // const roles = response.getMenuModules;

                        for (var i = 0; i < roles.length; i++) {
                            roles[i].key = roles[i].url;
                        }

                        if (roles.length === 0) {
                            (0, _auth.removeToken)();
                            next({ path: '/login' });
                            _nprogress2.default.done();
                        } else {

                            _store2.default.dispatch('GenerateRoutes', { roles: roles }).then(function () {
                                // 生成可访问的路由表
                                _router2.default.addRoutes(_store2.default.getters.addRouters); // 动态添加可访问路由表
                                next((0, _extends3.default)({}, to)); // hack方法 确保addRoutes已完成
                            });
                        }
                    } else {
                        next((0, _extends3.default)({}, to));
                        _nprogress2.default.done();
                    }
                }).catch(function () {
                    _store2.default.dispatch('FedLogOut').then(function () {
                        next({ path: '/login' });
                        _nprogress2.default.done();
                    });
                });
            } else {
                next();
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next('/login');
            _nprogress2.default.done();
        }
    }
});

_router2.default.afterEach(function () {
    _nprogress2.default.done();
});

new _vue2.default({
    el: '#app',
    router: _router2.default,
    store: _store2.default,
    template: '<App/>',
    components: { App: _App2.default }
});

/***/ }),
/* 667 */,
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'app'
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(150);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      yearsOptions: [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024],
      provinceOptions: [],
      limitsOptions: [{ text: "前10", value: 10 }, { text: "前20", value: 20 }, { text: "全部", value: 0 }],
      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: 2024,
      targetprovince: [],
      targetlimit: 0,

      table1colname: "音像",
      table2colname: "音像",
      table3colname: "音像",
      datalist: [],

      queryVisible: {
        chart_province_1: false,
        chart_province_2: false,
        chart_province_3: false
      },
      query: {
        chart_province_1: {
          provincename: "",
          name: "",
          value: ""
        },
        chart_province_2: {
          provincename: "",
          name: "",
          value: ""
        },
        chart_province_3: {
          provincename: "",
          name: "",
          value: ""
        }
      },
      bakData: {},

      chartDataBase: [],
      chartDataFinance: []
    };
  },

  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler: function handler(val) {
        this.chartTheme = val;
        console.log("chartTheme====", this.activeName);
        if (this.activeName == "business") {
          setTimeout(function () {
            this.initChatOptionData();
          }.bind(this), 1000);
        }
      },

      immediate: true
    },
    activeName: {
      handler: function handler(val) {
        if (val == "business") {
          var myChart = echarts.init(document.getElementById("chart_province_2"), this.chartTheme);
          this.chartResize(myChart);
          var myChart = echarts.init(document.getElementById("chart_province_3"), this.chartTheme);
          this.chartResize(myChart);
        }
      },

      immediate: true
    }
  },
  methods: {
    downloadData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var columns, cellWidths, list, i, po, data, key, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = { provincename: "省局", name: "出版单位", value: this.category };
                cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
                list = [];

                for (i in this.datalist) {
                  po = this.datalist[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[key];
                  }
                  list.push(data);
                }
                filename = this.targetyear + "\u5E74" + this.category + "_" + (0, _moment2.default)() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 10;
                return XLSX.utils.json_to_sheet(list, opts);

              case 10:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 15;
                return XLSX.writeFile(wb, "" + filename);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadData(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadData;
    }(),
    initCharts: function initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml: function createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      var html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html += ' <td style="text-align: center; vertical-align: middle;width:30px;padding: 0.74rem;">' + (Number(index) + 1) + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 190px;padding: 0.74rem;">' + item.provincename + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 230px;padding: 0.74rem;">' + item.name + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + this.formatEmpty(item.value) + "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts: function goSearchBusinessCharts() {
      var _this = this;

      var that = this;
      (0, _statisticsAnalysis.getProvinceFinanceChart)({ firstyear: this.searchFirstYear }).then(function (res) {
        console.log("getProvinceFinanceChart====", res);
        that.chartDataBase = res.base;
        that.chartDataFinance = res.finance;

        var provinceOptions = [];
        if (that.chartDataBase.length > 0) {
          // 一般是两组 音像一组 电子一组
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(_this.chartDataBase), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var record = _step.value;

              provinceOptions.push(record.provincename);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          that.provinceOptions = provinceOptions;
          if (that.targetprovince.length == 0) {
            that.targetprovince = [].concat(provinceOptions);
          }
        }

        setTimeout(function () {
          that.initChatOptionData();
        }, 1000);
      });
    },
    initChatOptionData: function initChatOptionData() {
      var that = this;
      var baseYear = that.targetyear; // 基准年度
      var isFirst = true;
      if (baseYear % 2 == 0) {
        isFirst = false;
        baseYear = that.targetyear - 1;
      }

      // 数据
      var pList2 = [];
      var sList2 = [];
      var pList3 = [];
      var sList3 = [];

      var lineMediaBase = {};
      var lineElectrBase = {};
      if (this.chartDataFinance.length > 0) {
        var lstMediaProfit = [];
        var lstMediaSales = [];
        var lstElectrProfit = [];
        var lstElectrSales = [];

        // 一般是两组 音像一组 电子一组
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(this.chartDataFinance), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var record = _step2.value;

            if (this.targetprovince.length > 0 && this.targetprovince.indexOf(record.provincename) == -1) {
              continue;
            }

            if (record.type == "音像") {
              pList2.push(record.provincename);
              lstMediaProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
              lstMediaSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
            } else {
              pList3.push(record.provincename);
              lstElectrProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
              lstElectrSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        lineMediaBase[that.targetyear + "年音像销售收入"] = lstMediaSales;
        lineMediaBase[that.targetyear + "年音像利润(税后)总额"] = lstMediaProfit;

        lineElectrBase[that.targetyear + "年电子销售收入"] = lstElectrSales;
        lineElectrBase[that.targetyear + "年电子利润(税后)总额"] = lstElectrProfit;
      }

      (0, _keys2.default)(lineMediaBase).forEach(function (item) {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          barGap: "-100%",
          label: {
            show: true,
            position: "insideLeft",
            offset: isSort ? [200, 2] : [50, 2],
            distance: 15,
            align: "left",
            verticalAlign: "middle",
            // rotate: 90,
            formatter: "{c}",
            fontSize: 12,
            rich: {
              name: {}
            }
          },
          emphasis: {
            focus: "series"
          },
          data: lineMediaBase[item]
        };
        sList2.push(series);
      });

      (0, _keys2.default)(lineElectrBase).forEach(function (item) {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          barGap: "-100%",
          label: {
            show: true,
            position: "insideLeft",
            offset: isSort ? [200, 2] : [50, 2],
            distance: 15,
            align: "left",
            verticalAlign: "middle",
            // rotate: 90,
            formatter: "{c}",
            fontSize: 12,
            rich: {
              name: {}
            }
          },
          emphasis: {
            focus: "series"
          },
          data: lineElectrBase[item]
        };
        sList3.push(series);
      });

      var Params2 = {
        title: "音像经营数据",
        subtext: "省局数量：" + pList2.length,
        provinceList: pList2,
        series: sList2
      };
      this.drawAnimeBar("chart_province_2", Params2);

      var Params3 = {
        title: "电子经营数据",
        subtext: "省局数量：" + pList3.length,
        provinceList: pList3,
        series: sList3
      };
      this.drawAnimeBar("chart_province_3", Params3);

      setTimeout(function () {
        that.changeAndRedraw();
      }, 1000);
    },
    changeAndRedraw: function changeAndRedraw() {
      var that = this;
      var baseYear = that.targetyear; // 基准年度
      var isFirst = true;
      if (baseYear % 2 == 0) {
        isFirst = false;
        baseYear = that.targetyear - 1;
      }

      var sList2 = [];
      var sList3 = [];
      var lineMediaBase = {};
      var lineElectrBase = {};
      if (this.chartDataFinance.length > 0) {
        var lstMediaProfit = [];
        var lstMediaSales = [];
        var lstElectrProfit = [];
        var lstElectrSales = [];

        // 一般是两组 音像一组 电子一组
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(this.chartDataFinance), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var record = _step3.value;

            if (this.targetprovince.length > 0 && this.targetprovince.indexOf(record.provincename) == -1) {
              continue;
            }
            if (record.type == "音像") {
              lstMediaProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
              lstMediaSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
            } else {
              lstElectrProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
              lstElectrSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        lineMediaBase[that.targetyear + "年音像销售收入"] = lstMediaSales;
        lineMediaBase[that.targetyear + "年音像利润(税后)总额"] = lstMediaProfit;

        lineElectrBase[that.targetyear + "年电子销售收入"] = lstElectrSales;
        lineElectrBase[that.targetyear + "年电子利润(税后)总额"] = lstElectrProfit;
      }

      (0, _keys2.default)(lineMediaBase).forEach(function (item) {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          data: lineMediaBase[item]
        };
        sList2.push(series);
      });

      (0, _keys2.default)(lineElectrBase).forEach(function (item) {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          data: lineElectrBase[item]
        };
        sList3.push(series);
      });

      var myChart = echarts.init(document.getElementById("chart_province_2"), this.chartTheme);
      myChart.setOption({
        series: sList2
      });
      var myChart = echarts.init(document.getElementById("chart_province_3"), this.chartTheme);
      myChart.setOption({
        series: sList3
      });
    },

    drawAnimeBar: function drawAnimeBar(id, chartParams) {
      console.log("drawAnimeBar", chartParams);
      var that = this;
      this.disposeChart(id);

      var maxCount = this.targetlimit;
      if (maxCount == 0) {
        maxCount = chartParams.provinceList.length - 1;
      }

      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 50
        },
        tooltip: {
          trigger: "item"
        },
        grid: { top: "15%", left: "27%" },
        legend: {
          show: true,
          bottom: "10"
        },
        xAxis: {
          gridIndex: 0,
          max: "dataMax",
          min: 0,
          axisLabel: {
            show: false,
            interval: 5,
            hideOverlap: true,
            showMaxLabel: true
          },
          position: "top",
          name: "万元"
        },
        yAxis: {
          type: "category",
          gridIndex: 0,
          data: chartParams.provinceList,
          inverse: true,
          animationDuration: 300,
          animationDurationUpdate: 300,
          max: maxCount
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "搜索筛选", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 50,
          right: 10
        },
        animationDuration: 0,
        animationDurationUpdate: 1000,
        animationEasing: "linear",
        animationEasingUpdate: "linear"
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", id, params);
        var title = params.seriesName.substr(5);
        if (id == "chart_province_1") {
          that.table1colname = title;
        } else if (id == "chart_province_2") {
          that.table2colname = title;
        } else if (id == "chart_province_3") {
          that.table3colname = title;
        }
        (0, _statisticsAnalysis.getProvinceFinanceDetail)({
          type: id,
          firstyear: this.searchFirstYear,
          targetyear: params.seriesName,
          province: params.name
        }).then(function (res) {
          that.datalist = res.data;
          that.bakData[id] = res.data;
          that.createDataHtml(id, res.data);
          that.backEcharts(id, myChart, params);
        });

        console.log(params);
      });
      this.chartResize(myChart);
    },
    chartResize: function chartResize(myChart) {
      myChart.resize();
    },
    backEcharts: function backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN: function clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible: function setQueryVisible(id) {
      this.queryVisible[id] = !this.queryVisible[id];
    },
    goFilterList: function goFilterList(id) {
      console.log("goFilterList", this.query);
      var query = this.query[id];
      var datalist = this.bakData[id];

      var filtedData = datalist.filter(function (item) {
        return item.provincename.indexOf(query.provincename) > -1 && item.name.indexOf(query.name) > -1 && (item.value + "").indexOf(query.value) > -1;
      });
      this.createDataHtml(id, filtedData);
    },
    formatEmpty: function formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    }
  },
  created: function created() {
    var that = this;
    window.addEventListener("resize", function () {
      that.initCharts();
    });
    that.initCharts();
  }
};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(180);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(150);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: "2024",
      category: "音像",
      datalist: [],
      filtedData: [],

      queryVisible: false,
      query: {
        provincename: "",
        name: "",
        value: ""
      },

      financeMedia: {},
      financeElectr: {}
    };
  },

  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler: function handler(val) {
        this.chartTheme = val;
        if (this.activeName == "business") {
          this.goSearchBusinessCharts();
        }
      },

      immediate: true
    },
    activeName: {
      handler: function handler(val) {
        if (val == "business") {
          var myChart = echarts.init(document.getElementById("chart_business_1"), this.chartTheme);
          this.chartResize(myChart);
          var ffpcm = echarts.init(document.getElementById("first_finance_pie_chart_media"), this.chartTheme);
          this.chartResize(ffpcm);
          var ffpce = echarts.init(document.getElementById("first_finance_pie_chart_electr"), this.chartTheme);
          this.chartResize(ffpce);
          var sfpcm = echarts.init(document.getElementById("second_finance_pie_chart_media"), this.chartTheme);
          this.chartResize(sfpcm);
          var sfpce = echarts.init(document.getElementById("second_finance_pie_chart_electr"), this.chartTheme);
          this.chartResize(sfpce);
          var ffpcmp = echarts.init(document.getElementById("first_finance_pie_chart_media_pay"), this.chartTheme);
          this.chartResize(ffpcmp);
          var ffpcep = echarts.init(document.getElementById("first_finance_pie_chart_electr_pay"), this.chartTheme);
          this.chartResize(ffpcep);
          var sfpcmp = echarts.init(document.getElementById("second_finance_pie_chart_media_pay"), this.chartTheme);
          this.chartResize(sfpcmp);
          var sfpcep = echarts.init(document.getElementById("second_finance_pie_chart_electr_pay"), this.chartTheme);
          this.chartResize(sfpcep);
        }
      },

      immediate: true
    }
  },
  methods: {
    downloadData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var columns, cellWidths, list, i, po, data, key, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = { provincename: "省局", name: "出版单位", value: this.category };
                cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
                list = [];

                for (i in this.datalist) {
                  po = this.datalist[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[key];
                  }
                  list.push(data);
                }
                filename = this.targetyear + "\u5E74" + this.category + "_" + (0, _moment2.default)() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 10;
                return XLSX.utils.json_to_sheet(list, opts);

              case 10:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 15;
                return XLSX.writeFile(wb, "" + filename);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadData(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadData;
    }(),
    initCharts: function initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml: function createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      var html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html += ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' + (Number(index) + 1) + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 270px;padding: 0.74rem;">' + item.provincename + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + item.name + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + this.formatEmpty(item.value) + "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts: function goSearchBusinessCharts() {
      var years = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024];
      var that = this;

      (0, _statisticsAnalysis.getFinanceChart1)({ firstyear: this.searchFirstYear }).then(function (res) {
        console.log("getFinanceChart1====", res);

        // echat对象
        var lineNames = [];
        var seriesList = [];
        // 数据
        var lineBase = {};
        if (res.base.length > 0) {
          var baseTags = {
            年销售收入: "totalsales",
            "年利润(税后)总额": "totalprofit"
          };

          // 一般是两组 音像一组 电子一组
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(res.base), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var record = _step.value;

              // 类型分类
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(baseTags)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var tag = _step2.value;

                  // 年份数据
                  var data = [];
                  for (var i = 0; i < years.length; i++) {
                    var baseYear = years[i];
                    var isFirst = true;
                    if (i % 2 == 1) {
                      isFirst = false;
                      baseYear = years[i - 1];
                    }
                    var colname = (isFirst ? "first" : "second") + baseTags[tag] + baseYear;
                    data.push(record[colname]);
                  }

                  var typeName = "出版单位";
                  lineBase[typeName + tag] = data;
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        lineNames.push.apply(lineNames, (0, _toConsumableArray3.default)((0, _keys2.default)(lineBase)));
        (0, _keys2.default)(lineBase).forEach(function (item) {
          // 线图
          // var series = {
          //   name: item,
          //   symbolSize: 5,
          //   type: "line",
          //   smooth: true,
          //   emphasis: {
          //     focus: "series",
          //   },
          //   // endLabel: {
          //   //   show: true,
          //   //   formatter: "{a}",
          //   //   distance: 20,
          //   // },
          //   lineStyle: {
          //     width: 4,
          //   },
          //   data: lineBase[item],
          // };

          var series = {
            name: item,
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {}
              }
            },
            emphasis: {
              focus: "series"
            },
            data: lineBase[item],
            xAxisIndex: 1,
            yAxisIndex: 1
          };
          seriesList.push(series);
        });

        var lineFinace = {};
        if (res.finance.length > 0) {
          var financeTags = {
            年度销售收入: "sales",
            // 年度支出: "pay",
            "年度利润（税后）总额": "profit"
          };
          // 一般是两组 音像一组 电子一组
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(res.finance), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var record = _step3.value;

              if (record.type == "音像") {
                that.financeMedia = record;
              } else if (record.type == "电子") {
                that.financeElectr = record;
              }
              // 类型分类
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = (0, _getIterator3.default)((0, _keys2.default)(financeTags)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var tag = _step4.value;

                  // 年份数据
                  var data = [];
                  for (var i = 0; i < years.length; i++) {
                    var baseYear = years[i];
                    var isFirst = true;
                    if (i % 2 == 1) {
                      isFirst = false;
                      baseYear = years[i - 1];
                    }
                    var colname = (isFirst ? "first" : "second") + financeTags[tag] + baseYear;
                    data.push(record[colname]);
                  }

                  var typeName = "";
                  if (record.type == "音像") {
                    typeName = "音像制品";
                  } else if (record.type == "电子") {
                    typeName = "电子出版物";
                  }
                  lineFinace[typeName + tag] = data;
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }

        lineNames.push.apply(lineNames, (0, _toConsumableArray3.default)((0, _keys2.default)(lineFinace)));
        (0, _keys2.default)(lineFinace).forEach(function (item) {
          // 线图
          // var series = {
          //   name: item,
          //   symbolSize: 5,
          //   type: "line",
          //   smooth: true,
          //   emphasis: {
          //     focus: "series",
          //   },
          //   // endLabel: {
          //   //   show: true,
          //   //   formatter: "{a}",
          //   //   distance: 20,
          //   // },
          //   lineStyle: {
          //     width: 4,
          //   },
          //   data: lineFinace[item],
          // };

          var series = {
            name: item,
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {}
              }
            },
            emphasis: {
              focus: "series"
            },
            data: lineFinace[item]
          };
          seriesList.push(series);
        });

        var chartParams = {
          title: "全国经营数据统计",
          // subtext: "单位数量：" + res.count,
          names: lineNames,
          years: years,
          series: seriesList
        };

        setTimeout(function () {
          that.drawChartLine("chart_business_1", chartParams);
          that.draw2DPieChart();
          that.draw2DPieChartPay();
        }, 1000);
      });
    },

    drawChartLine: function drawChartLine(id, chartParams) {
      console.log("drawChartLine", chartParams);
      var that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          // subtext: chartParams.subtext,
          left: "center",
          top: 10
        },
        tooltip: {
          trigger: "item"
        },
        grid: [{ top: "55%" }, { bottom: "55%" }],
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 10,
          data: chartParams.names
        },
        xAxis: [{
          type: "category",
          gridIndex: 0,
          data: chartParams.years
        }, {
          type: "category",
          gridIndex: 1,
          data: chartParams.years
        }],
        yAxis: [{
          gridIndex: 0,
          type: "value",
          name: "万元"
        }, { gridIndex: 1, type: "value", name: "万元" }],
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "数据列表", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", params);
        that.targetyear = params.name;
        that.category = params.seriesName;
        (0, _statisticsAnalysis.getFinanceDetail)({
          firstyear: this.searchFirstYear,
          targetyear: params.name,
          category: params.seriesName
        }).then(function (res) {
          that.datalist = res.data;
          that.filtedData = res.data;
          that.createDataHtml(id, res.data);
          that.backEcharts(id, myChart, params);
        });

        console.log(params);
      });
      this.chartResize(myChart);
    },
    draw2DPieChart: function draw2DPieChart() {
      console.log(this.financeMedia);
      this.disposeChart("first_finance_pie_chart_media");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_media"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年音像制品出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: this.financeMedia.firstsales1, name: "发行销售" }, { value: this.financeMedia.firstsales2, name: "出让版权" }, { value: this.financeMedia.firstsales3, name: "出版活动" }, { value: this.financeMedia.firstsales4, name: "审校加工" }, { value: this.financeMedia.firstsales5, name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("second_finance_pie_chart_media");
      var myChart2 = echarts.init(document.getElementById("second_finance_pie_chart_media"), this.chartTheme);
      var option2 = {
        title: {
          text: "2024年音像制品出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: this.financeMedia.secondsales1, name: "发行销售" }, { value: this.financeMedia.secondsales2, name: "出让版权" }, { value: this.financeMedia.secondsales3, name: "出版活动" }, { value: this.financeMedia.secondsales4, name: "审校加工" }, { value: this.financeMedia.secondsales5, name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("first_finance_pie_chart_electr");
      var myChart3 = echarts.init(document.getElementById("first_finance_pie_chart_electr"), this.chartTheme);
      var option3 = {
        title: {
          text: "2023年电子出版物出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: this.financeElectr.firstsales1, name: "发行销售" }, { value: this.financeElectr.firstsales2, name: "出让版权" }, { value: this.financeElectr.firstsales3, name: "出版活动" }, { value: this.financeElectr.firstsales4, name: "审校加工" }, { value: this.financeElectr.firstsales5, name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_electr");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_electr"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年电子出版物出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: this.financeElectr.secondsales1, name: "发行销售" }, { value: this.financeElectr.secondsales2, name: "出让版权" }, { value: this.financeElectr.secondsales3, name: "出版活动" }, { value: this.financeElectr.secondsales4, name: "审校加工" }, { value: this.financeElectr.secondsales5, name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },
    draw2DPieChartPay: function draw2DPieChartPay() {
      console.log(this.financeMedia);
      this.disposeChart("first_finance_pie_chart_media_pay");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_media_pay"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年音像制品出版业务支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出构成",
          type: "pie",
          radius: "50%",
          data: [{ value: this.financeMedia.firstpay12023, name: "人员成本" }, { value: this.financeMedia.firstpay22023, name: "运营成本" }, { value: this.financeMedia.firstpay32023, name: "劳务支出" }, { value: this.financeMedia.firstpay42023, name: "包装费用" }, { value: this.financeMedia.firstpay52023, name: "新媒体支出" }, { value: this.financeMedia.firstpay62023, name: "固定资产" }, { value: this.financeMedia.firstpay72023, name: "培训支出" }, { value: this.financeMedia.firstpay82023, name: "其他支出" }],
          center: ["55%", "50%"],
          startAngle: 180,
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("second_finance_pie_chart_media_pay");
      var myChart2 = echarts.init(document.getElementById("second_finance_pie_chart_media_pay"), this.chartTheme);
      var option2 = {
        title: {
          text: "2024年音像制品出版业务支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出构成",
          type: "pie",
          radius: "50%",
          data: [{ value: this.financeMedia.secondpay12024, name: "人员成本" }, { value: this.financeMedia.secondpay22024, name: "运营成本" }, { value: this.financeMedia.secondpay32024, name: "劳务支出" }, { value: this.financeMedia.secondpay42024, name: "包装费用" }, { value: this.financeMedia.secondpay52024, name: "新媒体支出" }, { value: this.financeMedia.secondpay62024, name: "固定资产" }, { value: this.financeMedia.secondpay72024, name: "培训支出" }, { value: this.financeMedia.secondpay82024, name: "其他支出" }],
          center: ["55%", "50%"],
          startAngle: 180,
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("first_finance_pie_chart_electr_pay");
      var myChart3 = echarts.init(document.getElementById("first_finance_pie_chart_electr_pay"), this.chartTheme);
      var option3 = {
        title: {
          text: "2023年电子出版物出版业务支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出构成",
          type: "pie",
          radius: "50%",
          data: [{ value: this.financeElectr.firstpay12023, name: "人员成本" }, { value: this.financeElectr.firstpay22023, name: "运营成本" }, { value: this.financeElectr.firstpay32023, name: "劳务支出" }, { value: this.financeElectr.firstpay42023, name: "包装费用" }, { value: this.financeElectr.firstpay52023, name: "新媒体支出" }, { value: this.financeElectr.firstpay62023, name: "固定资产" }, { value: this.financeElectr.firstpay72023, name: "培训支出" }, { value: this.financeElectr.firstpay82023, name: "其他支出" }],
          center: ["55%", "50%"],
          startAngle: 180,
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_electr_pay");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_electr_pay"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年电子出版物出版业务支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出构成",
          type: "pie",
          radius: "50%",
          data: [{ value: this.financeElectr.secondpay12024, name: "人员成本" }, { value: this.financeElectr.secondpay22024, name: "运营成本" }, { value: this.financeElectr.secondpay32024, name: "劳务支出" }, { value: this.financeElectr.secondpay42024, name: "包装费用" }, { value: this.financeElectr.secondpay52024, name: "新媒体支出" }, { value: this.financeElectr.secondpay62024, name: "固定资产" }, { value: this.financeElectr.secondpay72024, name: "培训支出" }, { value: this.financeElectr.secondpay82024, name: "其他支出" }],
          center: ["55%", "50%"],
          startAngle: 180,
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },

    draw3DPieChart: function draw3DPieChart(id, chartParams) {
      console.log("draw3DPieChart", chartParams);
      var id = "finance_pie_chart_media";
      var that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);

      var option = {
        grid3D: {
          show: false,
          boxHeight: 0.01,
          // top: '30%',
          bottom: "50%",
          viewControl: {
            distance: 300,
            alpha: 35,
            beta: 60,
            autoRotate: false // 自动旋转
          }
        }
      };
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    get3DPieData: function get3DPieData(startRatio, endRatio, isSelected, isHovered, k, height) {
      // 计算
      var midRatio = (startRatio + endRatio) / 2;
      var startRadian = startRatio * Math.PI * 2;
      var endRadian = endRatio * Math.PI * 2;
      var midRadian = midRatio * Math.PI * 2;

      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }

      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== "undefined" ? k : 1 / 3;

      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      var offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      var offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      var hoverRate = isHovered ? 1.05 : 1;

      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32
        },

        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20
        },

        x: function x(u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        y: function y(u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        z: function z(u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u);
          }
          return Math.sin(v) > 0 ? 1 * height : -1;
        }
      };
    },
    chartResize: function chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts: function backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN: function clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible: function setQueryVisible() {
      this.queryVisible = !this.queryVisible;
    },
    goFilterList: function goFilterList() {
      var _this = this;

      console.log("goFilterList", this.query);
      this.filtedData = this.datalist.filter(function (item) {
        return item.provincename.indexOf(_this.query.provincename) > -1 && item.name.indexOf(_this.query.name) > -1 && (item.value + "").indexOf(_this.query.value) > -1;
      });
      this.createDataHtml("chart_business_1", filtedData);
    },
    formatEmpty: function formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    }
  },
  created: function created() {
    var that = this;
    window.addEventListener("resize", function () {
      that.initCharts();
    });
    that.initCharts();
  }
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(150);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: "2023",
      category: "音像",
      datalist: [],
      filtedData: [],

      queryVisible: false,
      query: {
        provincename: "",
        name: "",
        value: ""
      },

      nLxdzCount: 0,
      nOrgCount: 0,
      nParOrgCount: 0,
      groupData: [],
      pieInfo: {}
    };
  },

  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler: function handler(val) {
        this.chartTheme = val;
        console.log("lxdzfinace====", val);
        if (this.activeName == "lxdzfinace") {
          this.goSearchBusinessCharts();
        }
      },

      immediate: true
    },
    activeName: {
      handler: function handler(val) {
        console.log("lxdzfinace====", val);
        if (val == "lxdzfinace") {
          var myChart = echarts.init(document.getElementById("chart_lxdz_1"), this.chartTheme);
          this.chartResize(myChart);
          var ffpcsChart = echarts.init(document.getElementById("first_finance_pie_chart_sale"), this.chartTheme);
          this.chartResize(ffpcsChart);
          var ffpcpChart = echarts.init(document.getElementById("first_finance_pie_chart_pay"), this.chartTheme);
          this.chartResize(ffpcpChart);
          var sfpcsChart = echarts.init(document.getElementById("second_finance_pie_chart_sale"), this.chartTheme);
          this.chartResize(sfpcsChart);
          var sfpcpChart = echarts.init(document.getElementById("second_finance_pie_chart_pay"), this.chartTheme);
          this.chartResize(sfpcpChart);
        }
      },

      immediate: true
    }
  },
  methods: {
    downloadData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var columns, changeName, cellWidths, list, i, po, data, key, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = { provincename: "省局", name: "出版单位", value: "连续型电子出版物数量" };
                changeName = { provincename: "organizationname", name: "materialtitle", value: "materialcode" };
                cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
                list = [];

                console.log("datalist==", this.datalist);
                for (i in this.datalist) {
                  po = this.datalist[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[changeName[key]];
                  }
                  list.push(data);
                }
                filename = this.targetyear + "\u5E74\u8FDE\u7EED\u578B\u7535\u5B50\u51FA\u7248\u7269\u8BE6\u7EC6_" + (0, _moment2.default)() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 12;
                return XLSX.utils.json_to_sheet(list, opts);

              case 12:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 17;
                return XLSX.writeFile(wb, "" + filename);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadData(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadData;
    }(),
    initCharts: function initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml: function createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      var html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html += ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' + (Number(index) + 1) + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 160px;padding: 0.74rem;">' + item.organizationname + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 220px;padding: 0.74rem;">' + item.materialtitle + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + this.formatEmpty(item.materialcode) + "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts: function goSearchBusinessCharts() {
      var years = [2021, 2022, 2023, 2024];
      var that = this;

      (0, _statisticsAnalysis.getLxdzInfo)({ firstyear: this.searchFirstYear }).then(function (res) {
        console.log("getLxdzInfo====", res);
        that.nLxdzCount = res.lxdzCount;
        that.nOrgCount = res.orgCount;
        that.nParOrgCount = res.parOrgCount;
        that.groupData = res.groupData;
        that.pieInfo = res.pieInfo[0];

        // echat对象
        var lineNames = [];
        var seriesList = [];
        // 数据
        var lineBase = {};
        if (res.base.length > 0) {
          lineNames.push("年度销售收入");
          lineNames.push("年度利润总额");
          // 一般是两组 音像一组 电子一组
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(res.base), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var record = _step.value;

              if (record["firstyear"] % 2 == 0) {
                // 有几组以偶数年份开头的错误数据
                continue;
              }

              // 年份数据
              var firstdata = [];
              firstdata.push(record["firstsales"]);
              firstdata.push(record["firstprofit"]);
              lineBase[record["firstyear"]] = firstdata;

              var seconddata = [];
              seconddata.push(record["secondsales"]);
              seconddata.push(record["secondprofit"]);
              lineBase[record["secondyear"]] = seconddata;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        console.log("lineBase==", lineBase);
        (0, _keys2.default)(lineNames).forEach(function (item) {
          var dataList = [];
          if (lineNames[item] == "年度销售收入") {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(years), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var year = _step2.value;

                dataList.push((lineBase[year][0] * 1).toFixed(2));
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (lineNames[item] == "年度利润总额") {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = (0, _getIterator3.default)(years), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var year = _step3.value;

                dataList.push((lineBase[year][1] * 1).toFixed(2));
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }

          var series = {
            name: lineNames[item],
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {}
              }
            },
            emphasis: {
              focus: "series"
            },
            data: dataList
          };
          seriesList.push(series);
        });

        var chartParams = {
          title: "连续型电子出版物经营数据统计",
          // subtext: "单位数量：" + res.count,
          names: lineNames,
          years: years,
          series: seriesList
        };

        setTimeout(function () {
          that.drawChartLine("chart_lxdz_1", chartParams);
          that.draw2DPieChart();
        }, 1000);
      });
    },

    drawChartLine: function drawChartLine(id, chartParams) {
      var _this = this;

      console.log("drawChartLine", id, chartParams);
      var that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 10
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 10,
          data: chartParams.names
        },
        xAxis: {
          type: "category",
          data: chartParams.years
        },
        yAxis: {
          type: "value",
          name: "万元"
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "数据列表", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };

      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);

      document.getElementById("changelist").addEventListener("click", function (e) {
        (0, _statisticsAnalysis.getLxdzDetail)({
          firstyear: _this.searchFirstYear
        }).then(function (res) {
          console.log("getLxdzDetail====", res);
          that.datalist = res.data;
          that.filtedData = res.data;
          that.backEcharts();
          that.createDataHtml(id, res.data);
        });
      });
    },
    draw2DPieChart: function draw2DPieChart() {
      console.log(this.pieInfo);
      this.disposeChart("first_finance_pie_chart_sale");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_sale"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年连续型电子出版物出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: (this.pieInfo.firstsales1 * 1).toFixed(2), name: "国内发行" }, { value: (this.pieInfo.firstsales2 * 1).toFixed(2), name: "海外发行" }, { value: (this.pieInfo.firstsales3 * 1).toFixed(2), name: "出让版权" }, { value: (this.pieInfo.firstsales4 * 1).toFixed(2), name: "出版活动" }, { value: (this.pieInfo.firstsales5 * 1).toFixed(2), name: "网站广告" }, { value: (this.pieInfo.firstsales6 * 1).toFixed(2), name: "审校加工" }, { value: (this.pieInfo.firstsales7 * 1).toFixed(2), name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("first_finance_pie_chart_pay");
      var myChart2 = echarts.init(document.getElementById("first_finance_pie_chart_pay"), this.chartTheme);
      var option2 = {
        title: {
          text: "2023年连续型电子出版物支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: (this.pieInfo.firstpay1 * 1).toFixed(2), name: "团队人员成本" }, { value: (this.pieInfo.firstpay2 * 1).toFixed(2), name: "运营成本" }, { value: (this.pieInfo.firstpay3 * 1).toFixed(2), name: "审校劳务支出" }, { value: (this.pieInfo.firstpay4 * 1).toFixed(2), name: "印刷压盘包装" }, { value: (this.pieInfo.firstpay5 * 1).toFixed(2), name: "新媒体上的投入" }, { value: (this.pieInfo.firstpay6 * 1).toFixed(2), name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("second_finance_pie_chart_sale");
      var myChart3 = echarts.init(document.getElementById("second_finance_pie_chart_sale"), this.chartTheme);
      var option3 = {
        title: {
          text: "2024年连续型电子出版物出版业务收入构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "出版业务收入构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: (this.pieInfo.secondsales1 * 1).toFixed(2), name: "国内发行" }, { value: (this.pieInfo.secondsales2 * 1).toFixed(2), name: "海外发行" }, { value: (this.pieInfo.secondsales3 * 1).toFixed(2), name: "出让版权" }, { value: (this.pieInfo.secondsales4 * 1).toFixed(2), name: "出版活动" }, { value: (this.pieInfo.secondsales5 * 1).toFixed(2), name: "网站广告" }, { value: (this.pieInfo.secondsales6 * 1).toFixed(2), name: "审校加工" }, { value: (this.pieInfo.secondsales7 * 1).toFixed(2), name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_pay");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_pay"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年连续型电子出版物支出构成",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "支出构成",
          type: "pie",
          selectedMode: "single",
          radius: "50%",
          data: [{ value: (this.pieInfo.secondpay1 * 1).toFixed(2), name: "团队人员成本" }, { value: (this.pieInfo.secondpay2 * 1).toFixed(2), name: "运营成本" }, { value: (this.pieInfo.secondpay3 * 1).toFixed(2), name: "审校劳务支出" }, { value: (this.pieInfo.secondpay4 * 1).toFixed(2), name: "印刷压盘包装" }, { value: (this.pieInfo.secondpay5 * 1).toFixed(2), name: "新媒体上的投入" }, { value: (this.pieInfo.secondpay6 * 1).toFixed(2), name: "其他收入" }],
          center: ["55%", "50%"],
          startAngle: 180,
          label: {
            position: "outside",
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "labelLine",
            edgeDistance: "10%",
            minMargin: 15
          },
          labelLine: {
            length2: 20
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4
        }
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },
    chartResize: function chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts: function backEcharts() {
      var disb = $("#chart_lxdz_1_introduce").css("display");
      console.log("disb==", disb);
      if (disb == "none") {
        $("#chart_lxdz_1_introduce").fadeIn(500);
        $("#chart_lxdz_1_table").css("width", $("chart_lxdz_1_table").width());
        $("#chart_lxdz_1_table").css("display", "none");
      } else {
        $("#chart_lxdz_1_introduce").css("display", "none");
        $("#chart_lxdz_1_table").fadeIn(500);
      }
    },
    clearQueryFilerN: function clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible: function setQueryVisible() {
      this.queryVisible = !this.queryVisible;
    },
    goFilterList: function goFilterList() {
      var _this2 = this;

      console.log("goFilterList", this.query);
      this.filtedData = this.datalist.filter(function (item) {
        return item.organizationname.indexOf(_this2.query.provincename) > -1 && item.materialtitle.indexOf(_this2.query.name) > -1 && (item.materialcode + "").indexOf(_this2.query.value) > -1;
      });
      this.createDataHtml("chart_lxdz_1", this.filtedData);
    },
    formatEmpty: function formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    }
  },
  created: function created() {
    var that = this;
    window.addEventListener("resize", function () {
      that.initCharts();
    });
    that.initCharts();
  }
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      yearsOptions: [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024],
      provinceOptions: [],
      limitsOptions: [{ text: "前10", value: 10 }, { text: "前20", value: 20 }, { text: "全部", value: 0 }],

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: 2021,
      targetprovince: [],
      targetlimit: 0,

      datalist: [],

      query: {},
      bakData: {},

      workerBaseInfo: {},
      chartDataBase: [],
      chartDataFinance: []
    };
  },

  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler: function handler(val) {
        this.chartTheme = val;
        console.log("chartTheme====", this.activeName);
        if (this.activeName == "worker") {
          setTimeout(function () {
            this.drawBaseCharts();
            this.drawMemberCharts();
            this.drawMemberPieElectr();
            this.drawMemberPieMedia();
          }.bind(this), 1000);
        }
      },

      immediate: true
    },
    activeName: {
      handler: function handler(val) {
        if (val == "worker") {
          var baseChart = echarts.init(document.getElementById("base_chart"), this.chartTheme);
          this.chartResize(baseChart);
          var memberChart = echarts.init(document.getElementById("member_chart"), this.chartTheme);
          this.chartResize(memberChart);
          var memberPieElectr = echarts.init(document.getElementById("member_pie_electr"), this.chartTheme);
          this.chartResize(memberPieElectr);
          var memberPieMedia = echarts.init(document.getElementById("member_pie_media"), this.chartTheme);
          this.chartResize(memberPieMedia);
        }
      },

      immediate: true
    }
  },
  methods: {
    downloadData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var columns, cellWidths, list, i, po, data, key, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = { provincename: "省局", name: "出版单位", value: this.category };
                cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
                list = [];

                for (i in this.datalist) {
                  po = this.datalist[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[key];
                  }
                  list.push(data);
                }
                filename = this.targetyear + "\u5E74" + this.category + "_" + (0, _moment2.default)() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 10;
                return XLSX.utils.json_to_sheet(list, opts);

              case 10:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 15;
                return XLSX.writeFile(wb, "" + filename);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadData(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadData;
    }(),
    initCharts: function initCharts() {
      this.goSearchworkerCharts();
    },
    createDataHtml: function createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      var html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html += ' <td style="text-align: center; vertical-align: middle;width:30px;padding: 0.74rem;">' + (Number(index) + 1) + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 190px;padding: 0.74rem;">' + item.provincename + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;width: 230px;padding: 0.74rem;">' + item.name + "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + this.formatEmpty(item.value) + "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchworkerCharts: function goSearchworkerCharts() {
      var that = this;
      (0, _statisticsAnalysis.getWorkerBaseInfo)({ firstyear: this.searchFirstYear }).then(function (res) {
        console.log("getWorkerBaseInfo====", res);
        that.workerBaseInfo = res.base[0];

        setTimeout(function () {
          that.drawBaseCharts();
          that.drawMemberCharts();
          that.drawMemberPieElectr();
          that.drawMemberPieMedia();
        }, 1000);
      });
    },
    drawBaseCharts: function drawBaseCharts() {
      this.disposeChart("base_chart");
      var myChart = echarts.init(document.getElementById("base_chart"), this.chartTheme);
      var option = {
        grid: {
          top: "50px",
          left: "15%",
          bottom: "50px"
        },
        xAxis: {
          type: "value"
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: ["职工总数", "音像", "电子"]
        },
        series: [{
          type: "bar",
          avoidLabelOverlap: false,
          // color:['#4FA1F3','#C976F4'],
          data: [{
            value: this.workerBaseInfo.workers,
            itemStyle: {
              color: myChart._theme.color[2]
            }
          }, {
            value: this.workerBaseInfo.businessworkersyx,
            itemStyle: {
              color: myChart._theme.color[0]
            }
          }, {
            value: this.workerBaseInfo.businessworkersdz,
            itemStyle: {
              color: myChart._theme.color[1]
            }
          }]
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberCharts: function drawMemberCharts() {
      console.log("drawMemberCharts", this.workerBaseInfo);
      this.disposeChart("member_chart");
      var myChart = echarts.init(document.getElementById("member_chart"), this.chartTheme);
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          top: "10px"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: ["领导班子", "编辑", "制作加工", "技术人员", "出版物发行", "其他(包含行政人员)"]
        },
        series: [{
          name: "音像",
          type: "bar",
          data: [this.workerBaseInfo.businessleaderyx, this.workerBaseInfo.totalworkeryx, this.workerBaseInfo.pepnumprocessyx, this.workerBaseInfo.pepnuminternationyx, this.workerBaseInfo.pepnumissueyx, this.workerBaseInfo.pepnumotheryx]
        }, {
          name: "电子",
          type: "bar",
          data: [this.workerBaseInfo.businessleaderdz, this.workerBaseInfo.totalworkerdz, this.workerBaseInfo.pepnumprocessdz, this.workerBaseInfo.pepnuminternationdz, this.workerBaseInfo.pepnumissuedz, this.workerBaseInfo.pepnumotherdz]
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberPieMedia: function drawMemberPieMedia() {
      this.disposeChart("member_pie_media");
      var myChart = echarts.init(document.getElementById("member_pie_media"), this.chartTheme);
      var option = {
        title: {
          text: "音像制品从业人员比例",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "人员占比",
          type: "pie",
          radius: "50%",
          data: [{ value: this.workerBaseInfo.businessleaderyx, name: "领导班子" }, { value: this.workerBaseInfo.totalworkeryx, name: "编辑人员" }, { value: this.workerBaseInfo.pepnumprocessyx, name: "制作加工" }, { value: this.workerBaseInfo.pepnuminternationyx, name: "技术人员" }, { value: this.workerBaseInfo.pepnumissueyx, name: "发行人员" }, { value: this.workerBaseInfo.pepnumotheryx, name: "其他(包含行政人员)" }],
          label: {
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "edge",
            minMargin: 5
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    drawMemberPieElectr: function drawMemberPieElectr() {
      this.disposeChart("member_pie_electr");
      var myChart = echarts.init(document.getElementById("member_pie_electr"), this.chartTheme);
      var option = {
        title: {
          text: "电子出版物从业人员比例",
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [{
          name: "人员占比",
          type: "pie",
          radius: "50%",
          data: [{ value: this.workerBaseInfo.businessleaderdz, name: "领导班子" }, { value: this.workerBaseInfo.totalworkerdz, name: "编辑人员" }, { value: this.workerBaseInfo.pepnumprocessdz, name: "制作加工" }, { value: this.workerBaseInfo.pepnuminternationdz, name: "技术人员" }, { value: this.workerBaseInfo.pepnumissuedz, name: "发行人员" }, { value: this.workerBaseInfo.pepnumotherdz, name: "其他(包含行政人员)" }],
          label: {
            formatter: "{b}: \n{c} ({d}%)",
            alignTo: "edge",
            minMargin: 5
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },

    drawAnimeBar: function drawAnimeBar(id, chartParams) {
      console.log("drawAnimeBar", chartParams);
      var that = this;
      this.disposeChart(id);

      var maxCount = this.targetlimit;
      if (maxCount == 0) {
        maxCount = chartParams.provinceList.length - 1;
      }

      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 50
        },
        tooltip: {
          trigger: "item"
        },
        grid: { top: "15%", left: "27%" },
        legend: {
          show: true,
          bottom: "10"
        },
        xAxis: {
          gridIndex: 0,
          max: "dataMax",
          min: 0,
          axisLabel: {
            show: false,
            interval: 5,
            hideOverlap: true,
            showMaxLabel: true
          },
          position: "top",
          name: "万元"
        },
        yAxis: {
          type: "category",
          gridIndex: 0,
          data: chartParams.provinceList,
          inverse: true,
          animationDuration: 300,
          animationDurationUpdate: 300,
          max: maxCount
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "搜索筛选", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          },
          top: 50,
          right: 10
        },
        animationDuration: 0,
        animationDurationUpdate: 1000,
        animationEasing: "linear",
        animationEasingUpdate: "linear"
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", id, params);
        var title = params.seriesName.substr(5);
        if (id == "chart_province_1") {
          that.table1colname = title;
        } else if (id == "chart_province_2") {
          that.table2colname = title;
        } else if (id == "chart_province_3") {
          that.table3colname = title;
        }

        console.log(params);
      });
      this.chartResize(myChart);
    },
    chartResize: function chartResize(myChart) {
      myChart.resize();
    },
    backEcharts: function backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN: function clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible: function setQueryVisible(id) {
      this.queryVisible[id] = !this.queryVisible[id];
    },
    goFilterList: function goFilterList(id) {
      console.log("goFilterList", this.query);
      var query = this.query[id];
      var datalist = this.bakData[id];

      var filtedData = datalist.filter(function (item) {
        return item.provincename.indexOf(query.provincename) > -1 && item.name.indexOf(query.name) > -1 && (item.value + "").indexOf(query.value) > -1;
      });
      this.createDataHtml(id, filtedData);
    },
    formatEmpty: function formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    }
  },
  created: function created() {
    var that = this;
    window.addEventListener("resize", function () {
      that.initCharts();
    });
    that.initCharts();
  }
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    }
  }
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ = __webpack_require__(1535);

var _2 = _interopRequireDefault(_);

var _cloud = __webpack_require__(1536);

var _cloud2 = _interopRequireDefault(_cloud);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      img_404: _2.default,
      img_404_cloud: _cloud2.default
    };
  },

  computed: {
    message: function message() {
      return '特朗普说这个页面你不能进......';
    }
  }
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        type: 1,
        year1: "",
        keyword: "",
        sjExamineId: "",
        no: 1,
        size: 12,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.pressSeek)(this.params).then(function (response) {
        console.log("pressSeek: ", response, _this.params);
        _this.tabDats = response.generalPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(rows) {
      this.$router.push({
        path: "admin_fexam",
        query: {
          mtId: rows.materialExamineId,
          pressType: 1,
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          pressName: rows.organizationName,
          examId: rows.id,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearYx", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    var selYearYx = sessionStorage.getItem("selYearYx") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: this.params.type
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearYx != "") {
              _this2.params.year1 = selYearYx;
              _this2.selYear = selYearYx;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["params", "searchData", "queryFilter", "queryVisible", "querySort", "sortData", "downloadData", "chartResize", "backEcharts", "setDisplayVisible", "createDataHtml", "setQueryVisible", "listTableData", "barType"],
  data: function data() {
    return {
      options: []
    };
  },

  methods: {
    //柱图
    chart_2: function chart_2(id, data) {
      var that = this;
      this.disposeChart(id);
      var names = [];
      var values = [];
      var total = 0;
      for (var index in data.data) {
        var item = data.data[index];
        names.push(item.name);
        if (id == "chart_11" && item.name == "0") {
          //item.name == "1-10" ||
          values.push({ value: item.value, itemStyle: { color: "red" } });
        } else if (id == "chart_21" && item.name == "0") {
          values.push({ value: item.value, itemStyle: { color: "red" } });
        } else if (id == "chart_41" && item.name.indexOf("不低于") == -1) {
          values.push({ value: item.value, itemStyle: { color: "red" } });
        } else if (id == "chart_42" && item.name.indexOf("不小于") == -1) {
          values.push({ value: item.value, itemStyle: { color: "red" } });
        } else {
          values.push(item.value);
        }
        total += Number(item.value);
      }
      if (id == "chart_181" || id == "chart_182" || id == "chart_183" || id == "chart_281" || id == "chart_282" || id == "chart_283") {
        total = total.toFixed(2);
      }
      this.options = names;
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: id == "chart_41" || id == "chart_42" ? "" : "共计数量：" + total,
          left: "center",
          top: 30
        },
        grid: {
          top: 80,
          bottom: id == "chart_41" || id == "chart_42" ? 120 : 60,
          left: id == "chart_41" || id == "chart_42" ? 200 : 80
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, myChart, option1);
              }
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function onclick(option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, null, option);
              }
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          }
        },
        tooltip: {
          trigger: "item"
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: id == "chart_41" || id == "chart_42" ? 20 : 15
          },
          data: names
        },
        yAxis: {
          type: "value"
        },
        series: [{
          type: that.barType || "bar",
          barMaxWidth: 30,
          avoidLabelOverlap: false,
          label: {
            show: true
            // formatter(param) {
            //   return param;
            // }
          },
          labelLine: {
            length: 8,
            length2: 8,
            maxSurfaceAngle: 80
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: "bold"
            }
          },
          // color:['#4FA1F3','#C976F4'],
          data: values
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("===", params);
        that.listTableData(id, myChart, option, { name: params.name });
      });
      this.chartResize(myChart);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    }
  },
  mounted: function mounted() {
    this.chart_2(this.params.id, this.params.data[this.params.id] || []);
  },

  created: function created() {}
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["params", "searchData", "queryFilter", "queryVisible", "querySort", "sortData", "downloadData", "chartResize", "backEcharts", "setDisplayVisible", "createDataHtml", "setQueryVisible", "listTableData"],
  data: function data() {
    return {};
  },

  methods: {
    //饼图-圆环
    chart_1: function chart_1(id, data) {
      var that = this;
      this.disposeChart(id);
      var nameVal = {};
      var total = 0;
      var flag = false;
      for (var index in data.data) {
        var item = data.data[index];
        if (id == "chart_41" || id == "chart_44" || id == "chart_45") {
          flag = true;
          item.name = item.name;
          //.replaceAll(/领导班子成员持证上岗率/g, "")
          //.replaceAll(/音像/g, "")
          //.replaceAll(/电子/g, "");
        }
        if (id == "chart_42" || id == "chart_46" || id == "chart_47") {
          flag = true;
        }
        nameVal[item.name] = item.value;
        total += Number(item.value);
      }

      if (id == "chart_7") {
        flag = true;
      }

      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: "共计数量：" + total,
          left: "center",
          top: 40
        },
        grid: {
          top: 80,
          bottom: 60,
          left: 10
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function onclick(option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, myChart, option1);
              }
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, null, option);
              }
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          }
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: id == "chart_35" ? 10 : 40,
          itemGap: (data.data || []).length < 5 ? 30 : 10,
          // itemWidth: 10,  // 设置宽度
          // itemHeight: 10, // 设置高度
          formatter: function formatter(name) {
            return name; //+ "  " + nameVal[name];
          }
        },
        series: [{
          type: "pie",
          center: ["50%", "50%"],
          radius: flag ? "40%" : "50%",
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: function formatter(param) {
              return param.name + "\n" + param.value + "（" + param.percent + "%）";
            }
          },
          labelLine: {
            length: 8,
            length2: 8,
            maxSurfaceAngle: 80
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: "bold"
            }
          },
          //color:['#4FA1F3','#C976F4'],
          data: data.data
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("===", params);
        that.listTableData(id, myChart, option, { name: params.name });
      });
      this.chartResize(myChart);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    }
  },
  mounted: function mounted() {
    this.chart_1(this.params.id, this.params.data[this.params.id] || []);
  },

  created: function created() {}
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        type: 2,
        year1: "",
        keyword: "",
        sjExamineId: "",
        no: 1,
        size: 12,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.pressSeek)(this.params).then(function (response) {
        _this.tabDats = response.generalPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(rows) {
      this.$router.push({
        path: "admin_fexam",
        query: {
          mtId: rows.materialExamineId,
          pressType: 2,
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          pressName: rows.organizationName,
          examId: rows.id,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearDz", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    var selYearDz = sessionStorage.getItem("selYearDz") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: this.params.type
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearDz != "") {
              _this2.params.year1 = selYearDz;
              _this2.selYear = selYearDz;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["params", "searchData", "queryFilter", "queryVisible", "querySort", "sortData", "downloadData", "chartResize", "backEcharts", "setDisplayVisible", "createDataHtml", "setQueryVisible", "listTableData"],
  data: function data() {
    return {};
  },

  methods: {
    //柱图 横柱 叠加图
    chart_3: function chart_3(id, data) {
      var that = this;
      this.disposeChart(id);
      var names = [];
      var values1 = [];
      var values2 = [];
      var json = {};
      for (var index in data.data) {
        var item = data.data[index];
        json[item.name] = item.value;
      }
      if (id == "chart_31") {
        var szzNums = Number(json["音电中级职称人数"]);
        var comNums = Number(json["中级职称人数"]);
        var yxNums = Number(json["音像中级职称人数"]);
        var dzNums = Number(json["电子中级职称人数"]);
        var nums = Number(yxNums) - Number(dzNums);
        names = ["音电中级职称人数", "电子中级职称", "音像中级职称"];
        values1 = [comNums, szzNums, szzNums];
        values2 = [0, dzNums - szzNums, yxNums - szzNums];

        var txtNums = [comNums, szzNums, yxNums - szzNums, dzNums - szzNums, yxNums, dzNums];
        this.txtNums = txtNums;
      } else {
        var _szzNums = Number(json["双资质"]);
        var _comNums = Number(json["单位数量"]);
        var _yxNums = Number(json["音像"]);
        var _dzNums = Number(json["电子"]);
        var _nums = Number(_yxNums) - Number(_dzNums);
        names = ["单位数量", "电子", "音像"];
        if (_nums > 0) {
          values1 = [_comNums, _szzNums, _szzNums];
          values2 = [0, _dzNums - _szzNums, _yxNums - _szzNums];
        } else {
          values1 = [_comNums, _szzNums, _szzNums];
          values2 = [0, _dzNums - _szzNums, _yxNums - _szzNums];
        }
        var _txtNums = [_comNums, _szzNums, _yxNums - _szzNums, _dzNums - _szzNums, _yxNums, _dzNums];
        this.txtNums = _txtNums;
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: data.subtext,
          left: "center",
          top: 30
        },
        grid: {
          top: 80,
          bottom: 60,
          left: 40,
          containLabel: true
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, myChart, option1);
              }
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, null, option);
              }
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          }
        },
        xAxis: {
          type: "value"
        },
        yAxis: {
          type: "category",
          data: names
        },
        series: [{
          type: "bar",
          barMaxWidth: 30,
          avoidLabelOverlap: false,
          stack: "总量",
          label: {
            show: true,
            position: "inside",
            formatter: function formatter(param) {
              return param.value == 0 ? "" : param.value;
            }
          },
          // labelLine: {
          //   length: 8,
          //   length2: 8,
          //   maxSurfaceAngle: 80
          // },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: "bold"
            }
          },
          // color:['#4FA1F3','#C976F4'],
          data: values1
        }, {
          type: "bar",
          barMaxWidth: 30,
          avoidLabelOverlap: false,
          stack: "总量",
          label: {
            show: true,
            position: "inside",
            formatter: function formatter(param) {
              return param.value == 0 ? "" : param.value;
            }
          },
          labelLine: {
            length: 8,
            length2: 8,
            maxSurfaceAngle: 80
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: "bold"
            }
          },
          // color:['#4FA1F3','#C976F4'],
          data: values2
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    }
  },
  mounted: function mounted() {
    this.chart_3(this.params.id, this.params.data[this.params.id] || []);
  },

  created: function created() {}
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["params", "searchData", "queryFilter", "queryVisible", "querySort", "sortData", "downloadData", "chartResize", "backEcharts", "setDisplayVisible", "createDataHtml", "setQueryVisible", "listTableData"],
  data: function data() {
    return {};
  },

  methods: {
    //柱图 组
    chart_4: function chart_4(id, data) {
      var that = this;
      this.disposeChart(id);
      var barNums = [];
      var names = [];
      if (id == "chart_51") {
        var narr = ["注册资本", "资产", "负债"];
        for (var s = 0; s < 3; s++) {
          var arr = [];
          for (var i in data.data) {
            var item = data.data[i];
            if (s == 0) {
              arr.push(item.value);
              names.push(item.name);
            } else {
              arr.push(item["value" + (s + 1)]);
            }
          }
          barNums.push({ type: "bar", name: narr[s], data: arr });
        }
      }
      if (id == "chart_52") {
        var narr = ["<0", "0", "0-0.5", "0.5-1", "1-5", "5-10", "10-20", ">20"];
        var json = {};
        //console.log("====", data);
        for (var s = 0; s < 8; s++) {
          var list = data.data[s];
          for (var i in list) {
            var _item = list[i];
            if (!json[s]) {
              json[s] = [];
            }
            json[s].push(_item.value);
            if (s == 0) names.push(_item.name);
          }
        }
        //console.log("====", json);
        for (var key in json) {
          barNums.push({ type: "bar", name: narr[key], data: json[key] });
        }
      }
      if (id == "chart_182" || id == "chart_282") {
        var narr = ["实（载）体出版", "利用信息网络出版", "总计"];
        var json = {};
        //console.log("AA====", data);
        var d1 = data.data["szt"].list;
        var d2 = data.data["wlcb"].list;
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        for (var i in d1) {
          var _item2 = d1[i];
          var item2 = d2[i];
          arr1.push(_item2.value);
          arr2.push(item2.value);
          arr3.push(Number(_item2.value) + Number(item2.value));
          names.push(_item2.name);
        }
        //console.log("====", arr1);
        //console.log("====", arr2);
        barNums.push({ type: "line", name: narr[0], data: arr1 });
        barNums.push({ type: "line", name: narr[1], data: arr2 });
        barNums.push({ type: "line", name: narr[2], data: arr3 });
      }
      if (id == "chart_183" || id == "chart_283") {
        var narr = ["实（载）体出版", "利用信息网络出版", "总计"];
        var json = {};
        //console.log("AA====", data);
        var d1 = data.data;
        var arr1 = [];
        var arr2 = [];
        var arr3 = [];
        for (var i in d1) {
          var _item3 = d1[i];
          if (i % 2 == 0) {
            arr1.push(_item3.value);
            names.push(_item3.year);
          }
          if (i % 2 == 1) {
            arr2.push(_item3.value);
          }
        }
        for (var i in arr1) {
          arr3.push(Number(arr1[i]) + Number(arr2[i]));
        }
        barNums.push({ type: "line", name: narr[0], data: arr1 });
        barNums.push({ type: "line", name: narr[1], data: arr2 });
        barNums.push({ type: "line", name: narr[2], data: arr3 });
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: data.subtext,
          left: "center",
          top: 30
        },
        grid: {
          top: 80,
          bottom: 100,
          left: 80
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function onclick(option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, myChart, option1);
              }
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, null, option);
              }
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          }
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 30
        },
        tooltip: {
          trigger: "item"
        },
        xAxis: {
          type: "category",
          data: names,
          axisLabel: {
            interval: 0,
            rotate: 15
          }
        },
        yAxis: {},
        dataset: { source: data.data },
        series: barNums
      };
      // 绘制图表
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    }
  },
  mounted: function mounted() {
    this.chart_4(this.params.id, this.params.data[this.params.id] || []);
  },

  created: function created() {}
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["params", "searchData", "queryFilter", "queryVisible", "querySort", "sortData", "downloadData", "chartResize", "backEcharts", "setDisplayVisible", "createDataHtml", "setQueryVisible", "listTableData"],
  data: function data() {
    return {};
  },

  methods: {
    //饼图-圆环
    chart_1: function chart_1(id, data) {
      var that = this;
      this.disposeChart(id);
      var nameVal = {};
      var total = 0;
      for (var index in data.data) {
        var item = data.data[index];
        nameVal[item.name] = item.value;
        total += Number(item.value);
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: "共计数量：" + total,
          left: "center",
          top: 40
        },
        grid: {
          top: 80,
          bottom: 60,
          left: 80
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function onclick(option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, myChart, option1);
              }
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function onclick(option1) {
                that.listTableData(id, null, option);
              }
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload } //,iconStyle:{color:'#BAFBFB'}
          }
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: id == "chart_35" ? 10 : 40,
          itemGap: (data.data || []).length < 5 ? 30 : 10,
          // itemWidth: 10,  // 设置宽度
          // itemHeight: 10, // 设置高度
          formatter: function formatter(name) {
            return name; //+ "  " + nameVal[name];
          }
        },
        series: [{
          type: "pie",
          radius: ["40%", "50%"],
          center: ["50%", "50%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            formatter: function formatter(param) {
              return param.name + " " + param.value + "（" + param.percent + "%）";
            }
          },
          labelLine: {
            length: 8,
            length2: 8,
            maxSurfaceAngle: 80
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: "bold"
            }
          },
          //color:['#4FA1F3','#C976F4'],
          data: data.data
        }]
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("===", params);
        that.listTableData(id, myChart, option, { name: params.name });
      });
      this.chartResize(myChart);
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    }
  },
  mounted: function mounted() {
    this.chart_1(this.params.id, this.params.data[this.params.id] || []);
  },

  created: function created() {}
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _adminRole = __webpack_require__(71);

var _pressRole = __webpack_require__(7);

var _Export = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      selYear: "",
      selYearRecord: [],
      loading: false,

      selType: "1",
      Zizhi: [{
        value: "1",
        label: "音像"
      }, {
        value: "2",
        label: "电子"
      }],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [{
        value: "firstTotalSales",
        label: this.selYear + "年销售收入"
      }, {
        value: "firstTotalProfit",
        label: this.selYear + "年利润总额"
      }, {
        value: "firstSales",
        label: this.selYear + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "销售收入"
      }, {
        value: "firstProfit",
        label: this.selYear + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "利润总额"
      }, {
        value: "firstPublicationVariety",
        label: this.selYear + "年出版品种数量"
      }, {
        value: "secondTotalSales",
        label: this.selYear * 1 + 1 + "年销售收入"
      }, {
        value: "secondTotalProfit",
        label: this.selYear * 1 + 1 + "年利润总额"
      }, {
        value: "secondSales",
        label: this.selYear * 1 + 1 + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "销售收入"
      }, {
        value: "secondProfit",
        label: this.selYear * 1 + 1 + "年" + (this.selType == 1 ? "音像制品" : "电子出版物") + "利润总额"
      }, {
        value: "secondPublicationVariety",
        label: this.selYear * 1 + 1 + "年出版品种数量"
      }],

      selSort: "asc",
      Sort: [{
        value: "asc",
        label: "正序"
      }, {
        value: "desc",
        label: "倒序"
      }],

      tabDats: [],
      params: {
        year1: ""
      },

      dicDats: [],
      dicMap: {},

      tableHeight: 250
    };
  },


  methods: {
    tabSeek: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(type) {
        var _this = this;

        var vm;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                this.params = {
                  type: this.selType,
                  provinceId: this.selProvinceId,
                  order: this.selOrder,
                  sort: this.selSort,
                  year: this.selYear
                };
                vm = this;


                (0, _adminRole.getBasicInfoStatisticList)(this.params).then(function (response) {
                  console.debug("getBasicInfoStatisticList: ", response);
                  console.debug("数据字典: ", vm.$store.getters.dictionary);
                  for (var i in response.basicInfoStatisticList) {
                    // 资质
                    response.basicInfoStatisticList[i].type = response.basicInfoStatisticList[i].type == 1 ? "音像" : "电子";
                    // 企业性质
                    response.basicInfoStatisticList[i].nature = _this.dicMap["C001"][response.basicInfoStatisticList[i].nature];
                    // 隶属关系
                    response.basicInfoStatisticList[i].isIndependentLP = _this.dicMap["C018"][response.basicInfoStatisticList[i].isIndependentLP];
                    var LPSituation = "";
                    if (response.basicInfoStatisticList[i].independentLPSituation && response.basicInfoStatisticList[i].independentLPSituation.length > 0) {
                      LPSituation = _this.dicMap["C003"][response.basicInfoStatisticList[i].independentLPSituation];
                    }
                    if (response.basicInfoStatisticList[i].nonIndependentLPSituation && response.basicInfoStatisticList[i].nonIndependentLPSituation.length > 0) {
                      LPSituation = _this.dicMap["C004"][response.basicInfoStatisticList[i].nonIndependentLPSituation];
                    }
                    response.basicInfoStatisticList[i].LPSituation = LPSituation;
                  }

                  setTimeout(function () {
                    vm.loading = false;
                    vm.tabDats = response.basicInfoStatisticList;
                  }, 300);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tabSeek(_x) {
        return _ref.apply(this, arguments);
      }

      return tabSeek;
    }(),
    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C018", "C003", "C004", "C001"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });

      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.dicMap["C018"] = _this2.$store.getters.dictionary["C018"];
        _this2.dicMap["C003"] = _this2.$store.getters.dictionary["C003"];
        _this2.dicMap["C004"] = _this2.$store.getters.dictionary["C004"];
        _this2.dicMap["C001"] = _this2.$store.getters.dictionary["C001"];
      });
    },

    goFirm: function goFirm(rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.loading = true;
      this.tabSeek();
    },
    provinceSet: function provinceSet() {
      var vm = this;
      (0, _adminRole.getProviceList)({
        type: this.selType
      }).then(function (response) {
        vm.Shengju = response.proList;
      });
    },
    getOrderByList: function getOrderByList(year, type) {
      return [{
        value: "firstTotalSales",
        label: year + "年销售收入"
      }, {
        value: "firstTotalProfit",
        label: year + "年利润总额"
      }, {
        value: "firstSales",
        label: year + "年" + (type == 1 ? "音像制品" : "电子出版物") + "销售收入"
      }, {
        value: "firstProfit",
        label: year + "年" + (type == 1 ? "音像制品" : "电子出版物") + "利润总额"
      }, {
        value: "firstPublicationVariety",
        label: year + "年出版品种数量"
      }, {
        value: "secondTotalSales",
        label: year * 1 + 1 + "年销售收入"
      }, {
        value: "secondTotalProfit",
        label: year * 1 + 1 + "年利润总额"
      }, {
        value: "secondSales",
        label: year * 1 + 1 + "年" + (type == 1 ? "音像制品" : "电子出版物") + "销售收入"
      }, {
        value: "secondProfit",
        label: year * 1 + 1 + "年" + (type == 1 ? "音像制品" : "电子出版物") + "利润总额"
      }, {
        value: "secondPublicationVariety",
        label: year * 1 + 1 + "年出版品种数量"
      }];
    },
    getHeight: function getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },

    goExport: function goExport() {
      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear
      };
      (0, _adminRole.getBasicInfoStatisticList)(params).then(function (response) {
        console.debug("getBasicInfoStatisticList: ", response);
        for (var i in response.basicInfoStatisticList) {
          // 资质
          response.basicInfoStatisticList[i].type = response.basicInfoStatisticList[i].type == 1 ? "音像" : "电子";
          // 企业性质
          response.basicInfoStatisticList[i].nature = that.dicMap["C001"][response.basicInfoStatisticList[i].nature];
          // 隶属关系
          response.basicInfoStatisticList[i].isIndependentLP = that.dicMap["C018"][response.basicInfoStatisticList[i].isIndependentLP];
          var LPSituation = "";
          if (response.basicInfoStatisticList[i].independentLPSituation && response.basicInfoStatisticList[i].independentLPSituation.length > 0) {
            LPSituation = that.dicMap["C003"][response.basicInfoStatisticList[i].independentLPSituation];
          }
          if (response.basicInfoStatisticList[i].nonIndependentLPSituation && response.basicInfoStatisticList[i].nonIndependentLPSituation.length > 0) {
            LPSituation = that.dicMap["C004"][response.basicInfoStatisticList[i].nonIndependentLPSituation];
          }
          response.basicInfoStatisticList[i].LPSituation = LPSituation;
        }

        var filename = "基本信息情况统计";
        var cols = [{
          dataIndex: "organizationName",
          title: "出版单位",
          width: 180
        }, {
          dataIndex: "provinceName",
          title: "所属省局",
          width: 180
        }, {
          dataIndex: "type",
          title: "资质",
          width: 180
        }, {
          dataIndex: "nature",
          title: "企业性质",
          width: 180
        }, {
          dataIndex: "LPSituation",
          title: "隶属关系",
          width: 180
        }, {
          dataIndex: "hostName",
          title: "主办单位",
          width: 180
        }, {
          dataIndex: "chargeName",
          title: "主管单位",
          width: 180
        }];
        var wsname = "基本信息情况统计";
        (0, _Export.outExcel)(response.basicInfoStatisticList, cols, filename, wsname);
      });
    }
  },

  created: function created() {
    this.provinceSet();
    this.dictInit();
    var that = this;
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: 3
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            that.params.year1 = po.firstYear;
            that.selYear = po.firstYear;

            that.OrderBy = that.getOrderByList(that.selYear, that.selType);
          }
        }
      }
      that.selYearRecord = arr;
      // that.tabSeek();
    });
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.getHeight();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

exports.default = {
  data: function data() {
    return {
      tabDatsAll: [],
      tabDats: [],
      params: {
        sbstatus: "全部数据"
      }
    };
  },

  watch: {
    params: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek() {
      var _this = this;

      (0, _adminRole.listAdminAuditQuery)({
        type: 2
      }).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        _this.tabDatsAll = response.adminAuditList;
        _this.filterTableData();
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 页面数据筛选
    filterTableData: function filterTableData() {
      var qData = this.tabDatsAll;
      var qName = this.params.pname;
      var qSbstatus = this.params.sbstatus;
      // 名称查询
      if (qName) {
        var itemName = void 0;
        qData = qData.filter(function (item) {
          itemName = item.pname || "";

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }
      if (qSbstatus && qSbstatus != "全部数据") {
        var _itemName = void 0;
        qData = qData.filter(function (item) {
          _itemName = item.sbstatus || "";

          if (_itemName.indexOf(qSbstatus) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = qData;
    }
  },

  created: function created() {
    this.tabSeek();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

var _pressRole = __webpack_require__(7);

var _Export = __webpack_require__(265);

exports.default = {
  data: function data() {
    return {
      selType: "1",
      Zizhi: [{
        value: "1",
        label: "音像"
      }, {
        value: "2",
        label: "电子"
      }],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [{
        value: "workers",
        label: "单位职工总数"
      }, {
        value: "businessWorkers",
        label: "从事电子出版物业务人员数"
      }, {
        value: "otherWorkers",
        label: "其他人员数"
      }, {
        value: "leaderWorkers",
        label: "领导班子总人数"
      }, {
        value: "leaderWorkerProportion",
        label: "领导班子持证上岗率"
      }, {
        value: "zjCertificateWorkers",
        label: "出版专业中级职称以上人数"
      }],

      selSort: "asc",
      Sort: [{
        value: "asc",
        label: "正序"
      }, {
        value: "desc",
        label: "倒序"
      }],

      selYear: "",
      tabDats: [],
      params: {
        year1: ""
      },
      tableHeight: 250
    };
  },


  methods: {
    tabSeek: function tabSeek(type) {
      this.loading = true;
      this.params = {
        type: this.selType,
        provinceId: this.selProvinceId,
        order: this.selOrder,
        sort: this.selSort,
        year: this.selYear
      };
      var vm = this;

      (0, _adminRole.getWorkerStatisticList)(this.params).then(function (response) {
        console.debug("getWorkerStatisticList: ", response);

        setTimeout(function () {
          vm.loading = false;
          vm.tabDats = response.workerStatisticList;
        }, 300);
      });
    },
    handleSortChange: function handleSortChange(column) {
      this.selOrder = column.prop;

      var sort = undefined;
      if (column.order == "ascending") {
        sort = 1;
      } else if (column.order == "descending") {
        sort = 0;
      }
      this.selSort = sort;
      console.log(this.selOrder, this.selSort, column);
      this.tabSeek();
    },
    goFirm: function goFirm(rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabSeek();
    },

    provinceSet: function provinceSet() {
      var vm = this;
      (0, _adminRole.getProviceList)({
        type: this.selType
      }).then(function (response) {
        vm.Shengju = response.proList;
      });
    },
    getHeight: function getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },

    goExport: function goExport() {
      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear
      };
      (0, _adminRole.getWorkerStatisticList)(this.params).then(function (response) {
        var filename = "人员情况统计";
        var cols = [{
          dataIndex: "organizationName",
          title: "出版单位",
          width: 180
        }, {
          dataIndex: "provinceName",
          title: "所属省局",
          width: 180
        }, {
          dataIndex: "workers",
          title: "单位职工总数",
          width: 120
        }, {
          dataIndex: "businessWorkers",
          title: "从事电子出版物业务人员数",
          width: 230
        }, {
          dataIndex: "otherWorkers",
          title: "其他人员数",
          width: 120
        }, {
          dataIndex: "leaderWorkers",
          title: "领导班子总人数",
          width: 120
        }, {
          dataIndex: "leaderWorkerProportion",
          title: "领导班子持证上岗率",
          width: 150
        }, {
          dataIndex: "zjCertificateWorkers",
          title: "出版专业中级职称以上人数",
          width: 200
        }];
        var wsname = "人员情况统计";
        (0, _Export.outExcel)(response.workerStatisticList, cols, filename, wsname);
      });
    }
  },

  created: function created() {
    var _this = this;

    this.provinceSet();
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: 3
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this.params.year1 = po.firstYear;
            _this.selYear = po.firstYear;
          }
        }
      }
      _this.selYearRecord = arr;
      _this.tabSeek();
    });
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.getHeight();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _SpecCommonTab = __webpack_require__(175);

var _SpecCommonTab2 = _interopRequireDefault(_SpecCommonTab);

var _provinceRole = __webpack_require__(20);

var _adminRole = __webpack_require__(71);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CommonTab: _SpecCommonTab2.default
  },
  data: function data() {
    return {
      emType: "",
      emId: "",
      emState: "",

      querys: {
        pressType: "",
        pressId: "",
        pressName: "",
        pressState: "",

        examId: "",
        pvcName: "",
        year1: ""
      },

      wSat: 0,

      resDat: [{}],
      selYearRecord: [{}],
      params: {
        ids: [],
        type: "",
        status: "1",
        message: "",
        pubNumber: ""
      },

      //  审核历史
      tabDat: [],

      publishUnitJson: {}
    };
  },


  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state" || code == "statuscbs") {
        console.log("state=", dat.flowName, "  ", dat.status);
        if (dat.flowName == "省局") {
          var map = {
            1: "通过",
            3: "退回",
            21: "暂缓登记",
            // 22: "暂缓登记",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销"
          };
          if (code == "statuscbs") {
            return map[dat.status];
          }
          //   console.log("测试整改：", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map = {
            1: "通过",
            2: "暂缓登记",
            3: "退回",
            21: "暂缓登记",
            // 22: "暂缓登记",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布"
          };

          return _map[dat.status];
        } else if (dat.flowName == "登记") {
          var _map2 = {
            1: "待登记",
            2: "已登记"
          };

          return _map2[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date" || !dat["checkdAt"]) {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    }
  },

  methods: {
    goBackExamsave: function goBackExamsave() {
      var _this = this;

      var msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        var _msg = '确定已查看完毕，并对该单位核验材料批以 "退回" 处理吗？';
        var vm = this;
        this.$confirm(_msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.ids.push(_this.$route.query.examId);
          var paramsNew = (0, _extends3.default)({}, _this.params, { status: "3" });
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _adminRole.adminExam)(paramsNew).then(function (response) {
            loading.close();
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
            } else {
              _this.$message({
                message: tipMessage,
                type: "success"
              });
              vm.goBack();
            }
          });
        }).catch(function () {});
      }
    },
    goExamsave: function goExamsave() {
      var _this2 = this;

      //   let transArr = ["", "通过", "暂缓", "退回", "撤销", "注销"];
      var transArrMap = {
        0: "",
        1: "通过",
        2: "暂缓登记",
        3: "退回",
        4: "撤销",
        5: "注销或拟注销"
        // , 22: "暂缓登记"
      };
      var msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArrMap[this.params.status] + '" 处理吗？';
      var vm = this;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.params.ids.push(_this2.$route.query.examId);
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _adminRole.adminExam)(_this2.params).then(function (response) {
          loading.close();
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage;
          if (tipCode == "fail") {
            _this2.$message({
              message: tipMessage,
              type: "error"
            });
          } else {
            _this2.$message({
              message: tipMessage,
              type: "success"
            });
            vm.goBack();
          }
        });
      }).catch(function () {});
    },

    goBack: function goBack() {
      var pathStr = "audio_fexam";
      if (this.$route.query.pressType == 2) {
        pathStr = "elect_fexam";
      }

      if (this.$route.query.pressState == 3) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: pathStr,
          query: {
            pvcId: this.$route.query.pvcId
          }
        });
      }
    },
    valChangeSearch: function valChangeSearch(val) {
      this.gPlist(val);
    },
    // zym.审核历史
    historyRecord: function historyRecord() {
      var _this3 = this;

      (0, _provinceRole.successiveHistory)({ examineId: this.querys.mtId, year1: this.querys.year1 }).then(function (response) {
        _this3.tabDat = response.fFlowTaskList;
        // for (let item of response.fFlowTaskList) {
        // 	if (item.examineName) {
        // 		this.tabDat.push(item);
        // 	}
        // }
        // 查找最后的省局审核意见
        var tabDatProvince = (_this3.tabDat || []).filter(function (item) {
          return item.flowName == "国家新闻出版署";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          var last = tabDatProvince[tabDatProvince.length - 1];
          _this3.params.status = last.status == "0" ? "1" : last.status + "";
          _this3.params.message = last.examineMessage;
        } else {
          _this3.params.status = "1";
          _this3.params.message = "";
        }
      });
    },
    gPlist: function gPlist(year) {
      var _this4 = this;

      (0, _pressRole.getPressList)({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year
      }).then(function (response) {
        var vm = _this4;
        vm.wSat = 1;
        _this4.resDat.splice(0, 1, response);
        console.log(_this4.resDat);
      });
    },

    writeReadTime: function writeReadTime(year) {
      (0, _provinceRole.writeReadTime)({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year
      }).then(function (response) {
        console.debug("writeReadTime: ", response);
      });
    },

    //获取出版单位各项统计信息
    getPublishStatic: function getPublishStatic() {
      var _this5 = this;

      //  publishStatic().then(response => {
      (0, _provinceRole.publishStatic)({ examineId: this.querys.mtId }).then(function (response) {
        console.debug("publishStatic: ", response);
        _this5.publishUnitJson = response.publisherStatistics;
      });
    }
  },

  created: function created() {
    var _this6 = this;

    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressName: this.$route.query.pressName,
      pressState: this.$route.query.pressState,
      mtId: this.$route.query.mtId,
      examId: this.$route.query.examId,
      pvcName: this.$route.query.pvcName,
      year1: this.$route.query.year1
    };

    // zym.设置操作的类型
    this.params.type = this.$route.query.pressType;

    this.gPlist(this.querys.year1);

    // zym.更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTime(this.$route.query.year1);
    }

    (0, _pressRole.getSelYearRecord)({
      publishId: this.querys.pressId,
      type: this.querys.pressType
    }).then(function (response) {
      console.log("======", response);
      var arr = [{}];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
        }
      }
      _this6.selYearRecord = arr;
    });

    this.historyRecord();

    this.getPublishStatic();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

var _pressRole = __webpack_require__(7);

var _Export = __webpack_require__(265);

exports.default = {
  data: function data() {
    return {
      selYear: '',

      selType: "1",
      Zizhi: [{
        value: '1',
        label: '音像'
      }, {
        value: '2',
        label: '电子'
      }],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [{
        value: 'firstTotalSales',
        label: this.selYear + '年销售收入'
      }, {
        value: 'firstTotalProfit',
        label: this.selYear + '年利润总额'
      }, {
        value: 'firstSales',
        label: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'firstProfit',
        label: this.selYear + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'firstPublicationVariety',
        label: this.selYear + '年出版品种数量'
      }, {
        value: 'secondTotalSales',
        label: this.selYear * 1 + 1 + '年销售收入'

      }, {
        value: 'secondTotalProfit',
        label: this.selYear * 1 + 1 + '年利润总额'

      }, {
        value: 'secondSales',
        label: this.selYear * 1 + 1 + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'secondProfit',
        label: this.selYear * 1 + 1 + '年' + (this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'secondPublicationVariety',
        label: this.selYear * 1 + 1 + '年出版品种数量'
      }],

      selSort: "asc",
      Sort: [{
        value: 'asc',
        label: '正序'
      }, {
        value: 'desc',
        label: '倒序'
      }],

      tabDats: [],
      params: {
        year1: ""
      },
      tableHeight: 250
    };
  },


  methods: {
    tabSeek: function tabSeek(type) {
      this.loading = true;
      this.params = {
        type: this.selType,
        provinceId: this.selProvinceId,
        order: this.selOrder,
        sort: this.selSort,
        year: this.selYear
      };
      var vm = this;
      console.log(this.params);

      (0, _adminRole.getPublicationStatisticList)(this.params).then(function (response) {
        console.debug('getPublicationStatisticList: ', response);
        setTimeout(function () {
          vm.loading = false;
          vm.tabDats = response.publicationStatisticList;
        }, 300);
      });
    },
    handleSortChange: function handleSortChange(column) {
      this.selOrder = column.prop;

      var sort = undefined;
      if (column.order == 'ascending') {
        sort = 1;
      } else if (column.order == 'descending') {
        sort = 0;
      }
      this.selSort = sort;
      console.log(this.selOrder, this.selSort, column);
      this.tabSeek();
    },
    goFirm: function goFirm(rows) {
      this.$router.push({
        path: 'successive_skim',
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || '';
      this.pgAll = 0;
      this.tabSeek();
    },
    provinceSet: function provinceSet() {
      var vm = this;
      (0, _adminRole.getProviceList)({
        type: this.selType
      }).then(function (response) {
        vm.Shengju = response.proList;
      });
    },
    getOrderByList: function getOrderByList(year, type) {
      return [{
        value: 'firstTotalSales',
        label: year + '年销售收入'
      }, {
        value: 'firstTotalProfit',
        label: year + '年利润总额'
      }, {
        value: 'firstSales',
        label: year + '年' + (type == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'firstProfit',
        label: year + '年' + (type == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'firstPublicationVariety',
        label: year + '年出版品种数量'
      }, {
        value: 'secondTotalSales',
        label: year * 1 + 1 + '年销售收入'

      }, {
        value: 'secondTotalProfit',
        label: year * 1 + 1 + '年利润总额'

      }, {
        value: 'secondSales',
        label: year * 1 + 1 + '年' + (type == 1 ? '音像制品' : '电子出版物') + '销售收入'

      }, {
        value: 'secondProfit',
        label: year * 1 + 1 + '年' + (type == 1 ? '音像制品' : '电子出版物') + '利润总额'

      }, {
        value: 'secondPublicationVariety',
        label: year * 1 + 1 + '年出版品种数量'
      }];
    },
    getHeight: function getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },

    goExport: function goExport() {
      var _this = this;

      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear
      };
      (0, _adminRole.getPublicationStatisticList)(this.params).then(function (response) {
        var filename = "出版经营情况统计";
        var cols = [{
          title: '出版单位',
          dataIndex: 'organizationName'
        }, {
          title: '所属省局',
          dataIndex: 'provinceName'
        }, {
          title: _this.selYear + '年销售收入（万元）',
          dataIndex: 'firstTotalSales'
        }, {
          title: _this.selYear + '年利润总额（万元）',
          dataIndex: 'firstTotalProfit'
        }, {
          title: _this.selYear + '年' + (_this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入（万元）',
          dataIndex: 'firstSales'
        }, {
          title: _this.selYear + '年' + (_this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额（万元）',
          dataIndex: 'firstProfit'
        }, {
          title: _this.selYear + '年出版品种数量',
          dataIndex: 'firstPublicationVariety'
        }, {
          title: _this.selYear * 1 + 1 + '年销售收入（万元）',
          dataIndex: 'secondTotalSales'
        }, {
          title: _this.selYear * 1 + 1 + '年利润总额（万元）',
          dataIndex: 'secondTotalProfit'
        }, {
          title: _this.selYear * 1 + 1 + '年' + (_this.selType == 1 ? '音像制品' : '电子出版物') + '销售收入（万元）',
          dataIndex: 'secondSales'
        }, {
          title: _this.selYear * 1 + 1 + '年' + (_this.selType == 1 ? '音像制品' : '电子出版物') + '利润总额（万元）',
          dataIndex: 'secondProfit'
        }, {
          title: _this.selYear * 1 + 1 + '年出版品种数量',
          dataIndex: 'secondPublicationVariety'
        }];
        var wsname = "出版经营情况统计";
        (0, _Export.outExcel)(response.publicationStatisticList, cols, filename, wsname);
      });
    }
  },

  created: function created() {
    this.provinceSet();
    var that = this;
    (0, _pressRole.getSelYearRecord)({
      publishId: '',
      type: 3
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            that.params.year1 = po.firstYear;
            that.selYear = po.firstYear;

            that.OrderBy = that.getOrderByList(that.selYear, that.selType);
          }
        }
      }
      that.selYearRecord = arr;
      that.tabSeek();
    });
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.getHeight();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _ssCommonTabs = __webpack_require__(248);

var _ssCommonTabs2 = _interopRequireDefault(_ssCommonTabs);

var _pressSuccessive = __webpack_require__(28);

var _provinceRole = __webpack_require__(20);

var _adminRole = __webpack_require__(71);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MainTabs: _ssCommonTabs2.default
  },
  data: function data() {
    return {
      wSat: 0,
      querys: {
        pressState: 1,
        pressName: "",
        pgsType: "",
        year1: ""
      },
      bookName: "",
      resDat: [{}],
      selYearRecord: [{}],
      tabDat: [],

      opMsg: "",

      params: {
        ids: [],
        status: "1",
        message: ""
      },

      wordsMap: {
        1: "",
        2: "请填写暂缓原因",
        4: "请填写撤销原因",
        5: "请填写注销原因"
      }
    };
  },

  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          var map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记"
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map = {
            1: "通过",
            2: "暂缓登记",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布"
          };

          return _map[dat.status];
        } else if (dat.flowName == "登记") {
          var _map2 = {
            1: "待登记",
            2: "已登记"
          };

          return _map2[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date" || !dat["checkdAt"]) {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    }
  },
  methods: {
    valChangeSearch: function valChangeSearch(year) {
      this.getHistoryData(year);
    },
    goBack: function goBack() {
      if (this.querys.pressState == 3) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: "successive_fexam",
          query: {
            pvcId: this.$route.query.pvcId
          }
        });
      }
    },
    goBackExamsave: function goBackExamsave() {
      var _this = this;

      var msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        var _msg = '确定已查看完毕，并对该单位核验材料批以 "退回" 处理吗？';
        var vm = this;
        this.$confirm(_msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.ids.push(_this.$route.query.examId);
          var paramsNew = (0, _extends3.default)({}, _this.params, { status: "3" });
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _adminRole.adminExam)(paramsNew).then(function (response) {
            loading.close();
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
            } else {
              _this.$message({
                message: tipMessage,
                type: "success"
              });
              vm.goBack();
            }
          });
        }).catch(function () {});
      }
    },
    goExamsave: function goExamsave() {
      var _this2 = this;

      var transArr = ["", "通过", "暂缓登记", "退回", "撤销", "注销或拟注销"];
      var msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArr[this.params.status] + '" 处理吗？';
      var vm = this;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.params.ids.push(_this2.$route.query.examId);
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _adminRole.adminExam)(_this2.params).then(function (response) {
          loading.close();
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage;
          if (tipCode == "fail") {
            _this2.$message({
              message: tipMessage,
              type: "error"
            });
          } else {
            _this2.$message({
              message: tipMessage,
              type: "success"
            });
            vm.goBack();
          }
        });
      }).catch(function () {});
    },
    gPlist: function gPlist() {
      var _this3 = this;

      (0, _pressSuccessive.getSuccessTabs)({
        publishMaterialId: this.$route.query.listId,
        organizationId: this.$route.query.pressId,
        isSearch: true
      }).then(function (response) {
        var vm = _this3;
        vm.wSat = 1;
        _this3.bookName = _this3.$route.query.bookName;
        if (_this3.querys.pressState == 1) {
          _this3.opMsg = response.msg;
        }
        _this3.resDat.splice(0, 1, response.ppublicationOrganizationMaterialList);
      });
    },
    getHistoryData: function getHistoryData(year) {
      var _this4 = this;

      (0, _provinceRole.successiveHistoryNew)({ examineId: this.$route.query.examId, year1: year }).then(function (response) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.fFlowTaskList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.examineName) {
              _this4.tabDat.push(item);
            }
          }

          // 查找最后的省局审核意见
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var tabDatProvince = (_this4.tabDat || []).filter(function (item) {
          return item.flowName == "国家新闻出版署";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          var last = tabDatProvince[tabDatProvince.length - 1];
          _this4.params.status = last.status == "0" ? "1" : last.status + "";
          _this4.params.message = last.examineMessage;
        } else {
          _this4.params.status = "1";
          _this4.params.message = "";
        }
      });
    },


    writeReadTimeLxdz: function writeReadTimeLxdz() {
      // console.log('写入审批时间....')
      (0, _provinceRole.writeReadTimeLxdz)({
        publishMaterialId: this.$route.query.listId
      }).then(function (response) {
        console.debug("writeReadTimeLxdz: ", response);
      });
    }
  },
  created: function created() {
    var _this5 = this;

    this.querys.pressState = this.$route.query.pressState;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.year1 = this.$route.query.year1;

    this.gPlist();

    // zym.更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTimeLxdz();
    }

    (0, _pressRole.getSelYearRecord)({
      publishId: this.$route.query.pressId,
      type: 3,
      year1: this.querys.year1
    }).then(function (response) {
      console.log("======", response);
      var arr = [{}];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
        }
      }
      _this5.selYearRecord = arr;
    });

    // if(this.querys.pressState == 2){
    this.getHistoryData(this.querys.year1);
    // }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

exports.default = {
  data: function data() {
    return {
      tabDatsAll: [],
      tabDats: [],
      params: {
        sbstatus: "全部数据"
      }
    };
  },

  watch: {
    params: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek() {
      var _this = this;

      (0, _adminRole.listAdminAuditQuery)({
        type: 1
      }).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        _this.tabDatsAll = response.adminAuditList;
        _this.filterTableData();
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 页面数据筛选
    filterTableData: function filterTableData() {
      var qData = this.tabDatsAll;
      var qName = this.params.pname;
      var qSbstatus = this.params.sbstatus;
      // 名称查询
      if (qName) {
        var itemName = void 0;
        qData = qData.filter(function (item) {
          itemName = item.pname || "";

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }
      if (qSbstatus && qSbstatus != "全部数据") {
        var _itemName = void 0;
        qData = qData.filter(function (item) {
          _itemName = item.sbstatus || "";

          if (_itemName.indexOf(qSbstatus) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = qData;
    }
  },

  created: function created() {
    this.tabSeek();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _vue = __webpack_require__(211);

exports.default = {
  data: function data() {
    return {
      activeIndex: "1",
      leftHt: 0,
      screenHeight: "",
      loading: false,
      // typeArr: [
      //   {
      //     name: "全部",
      //     key: 99,
      //   },
      //   {
      //     name: "待核验",
      //     key: 0,
      //   },
      //   {
      //     name: "通过",
      //     key: 1,
      //   },
      //   {
      //     name: "暂缓登记",
      //     key: 2,
      //   },
      //   {
      //     name: "撤销",
      //     key: 4,
      //   },
      //   {
      //     name: "注销或拟注销",
      //     key: 5,
      //   },
      //   {
      //     name: "退回",
      //     key: 98,
      //   },
      // ],
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "待核验",
        key: 0
      }, {
        name: "通过",
        key: 1
      }, {
        name: "暂缓登记",
        key: 21
      }, {
        name: "已登记",
        key: 11
      }, {
        name: "注销或拟注销",
        key: 13
      }],

      postDat: {
        type: 1,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        msg: "",

        no: 1,
        size: 15
      },

      paramsEx: {
        ids: [],
        type: "",
        status: 1,
        message: "",
        pubNumber: ""
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0,

      provinceList: [],
      provinceMap: {},

      pvcName: "",
      pvcSta: "",
      fileToken: "",
      postUrl: "", // zym.省局的分析报告
      postUrlZg: "", // zym.省局的整改报告

      // 整体退回意见
      dialogVisible: false,
      // 核验新增退回操作
      dialogShow: false
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          0: "待核验",
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          4: "撤销",
          5: "注销或拟注销",
          10: "整体退回",
          9: "整体发布"
        };
        if (dat.status == 9) {
          return map[dat.pubStatus] + "（已发布）";
        } else {
          return map[dat.status];
        }
      } else if (code == "statussj") {
        var _map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          // 9: "整体提交",
          11: "已登记",

          // 12: "省局暂缓",
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return _map[dat.statussj];
      } else if (code == "navset") {
        // zym.20250321，去掉各种情况的判断，直接返回省局名称
        // if (dat.status == 0) {
        //   return dat.sjExamine;
        // } else if (dat.status == 8) {
        //   return dat.sjExamine + "（未提交）";
        // } else if (dat.status == 9) {
        //   return dat.sjExamine + "（已完成）";
        // } else if (dat.status == 10) {
        //   return dat.sjExamine + "（退回）";
        // }
        return dat.sjExamine;
      } else if (code == "time") {
        if (dat == "Invalid date" || !dat) {
          return "";
        }
        return dat.substr(0, 16);
      } else if (code == "examineMessage") {
        return dat.examineMessage;
      }
    }
  },
  // watch: {
  //   // screenHeight:function(val){
  //   // this.leftHt = "height:" + val + "px";
  //   // this.$refs.aaa.update();
  //   // this.$message.error('aaa');
  //   // console.log(this.leftHt);

  //   // }
  // },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    goUrl: function goUrl(url) {
      window.open(url);
    },
    resizeSet: function resizeSet() {
      this.leftHt = document.documentElement.clientHeight - 50;
      window.onresize = function () {
        this.leftHt = document.documentElement.clientHeight - 50;
      };

      this.leftHt = "height:" + this.leftHt + "px";
    },

    // zym.查询某个省份的待审核的数据
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _adminRole.getWaitList)(this.postDat).then(function (response) {
        _this.tabDatsAll = response.fGeneralExamineList;
        // this.pgAll = response.totalPages;
        _this.loading = false;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        // tabDats = tabDats.filter(function (item) {
        //   // zym.待核验
        //   if (qType == 0 && item.status == "0") {
        //     return true;
        //   } else if (qType == 1 && item.status == "1") {
        //     return true;
        //   } else if (qType == 2 && item.status == "2") {
        //     return true;
        //   } else if (qType == 4 && item.status == "4") {
        //     return true;
        //   } else if (qType == 5 && item.status == "5") {
        //     return true;
        //   } else if (qType == 98 && (item.status == "3" || item.status == "10")) {
        //     return true;
        //   }
        //   return false;
        // });
        // console.log("qType=", qType);
        tabDats = tabDats.filter(function (item) {
          // console.log("item.statussj=", item.organizationName, "   ", item.statussj);
          var statussj = item.statussj + "";
          if (qType == 1 && statussj == "1") {
            return true;
          } else if (qType == 21 && statussj == "21") {
            return true;
          } else if (qType == 11 && statussj == "11") {
            return true;
          } else if (qType == 13 && statussj == "13") {
            return true;
          } else if (qType == 0 && ["1", "21", "11", "13"].indexOf(statussj) == -1) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },

    // zym.省局设置
    provinceSet: function provinceSet() {
      var _this2 = this;

      this.postUrl = "";
      this.postUrlZg = "";

      var vm = this;
      (0, _adminRole.getProviceList)({
        type: 1
      }).then(function (response) {
        _this2.provinceList = response.proList;
        if (!_this2.postDat.sjExamineId) {
          for (var i in _this2.provinceList) {
            var pstas = _this2.provinceList[i].status;
            if (pstas == 0 || pstas == 1 || pstas == 9) {
              _this2.postDat.sjExamineId = _this2.provinceList[i].sjExamineId;
              _this2.pvcName = _this2.provinceList[i].sjExamine;
              _this2.pvcSta = _this2.provinceList[i].status;
              break;
            }
          }
        } else {
          for (var _i in _this2.provinceList) {
            if (_this2.provinceList[_i].sjExamineId == _this2.postDat.sjExamineId) {
              _this2.pvcName = _this2.provinceList[_i].sjExamine;
              _this2.pvcSta = _this2.provinceList[_i].status;
              break;
            }
          }
        }
        for (var _i2 in _this2.provinceList) {
          _this2.provinceMap[_this2.provinceList[_i2].sjExamineId] = _this2.provinceList[_i2];
        }
        if (_this2.postDat.sjExamineId) {
          (0, _provinceRole.ssReportLoad)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var provinceReport = response.provinceReport;
            if (provinceReport && provinceReport.reportId) {
              (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
                vm.postUrl = response.payload.url;
                // vm.fileNameHybg = response.payload.fileName
              });
            }
          }).catch(function (error) {});

          // zym.查询整改报告
          (0, _provinceRole.getPostponeDesc)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var upPostponeDesc = response.upPostponeDesc;
            if (upPostponeDesc && upPostponeDesc.reportId) {
              (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
                vm.postUrlZg = response.payload.url;
              });
            }
          }).catch(function (error) {});
        }

        _this2.tabSeek("init");
      });
    },

    // zym.选择核验意见
    handleSelect: function handleSelect(dat) {
      var _this3 = this;

      if (this.paramsEx.ids.length > 0) {
        this.paramsEx.status = dat;
        // zym.退回
        if (dat == 3 || dat == 22 || dat == 2 || dat == 4 || dat == 5) {
          this.dialogShow = true;
          this.paramsEx.message = "";
        } else {
          // let transArr = ["", "通过", "暂缓登记", "", "撤销", "注销或拟注销"];
          var transArrMap = { 0: "", 1: "通过", 2: "暂缓登记", 3: "", 4: "撤销", 5: "注销或拟注销", 22: "暂缓登记" };
          var msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArrMap[this.paramsEx.status] + '" 处理吗？';

          var vm = this;
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.adminExam)(_this3.paramsEx).then(function (response) {
              loading.close();
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                _this3.$message({
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this3.$message({
                  message: tipMessage,
                  type: "success"
                });
                _this3.tabSeek("init");
              }
            });
          }).catch(function () {});
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },
    // zym.退回填写完意见后提交服务器
    returnFun: function returnFun() {
      var _this4 = this;

      // this.paramsEx.message = this.paramsEx.message.replace(/\s+/g, "");
      // if (this.paramsEx.message.length == 0) {
      //   this.$message.error("请输入内容！");
      //   return;
      // }

      this.dialogShow = false;
      var vm = this;
      var loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _adminRole.adminExam)(this.paramsEx).then(function (response) {
        loading.close();
        var tipCode = response.payload.tipCode;
        var tipMessage = response.payload.tipMessage;
        if (tipCode == "fail") {
          _this4.$message({
            message: tipMessage,
            type: "error"
          });
        } else {
          _this4.$message({
            message: tipMessage,
            type: "success"
          });
          _this4.tabSeek("init");
        }
      });
    },

    paramsClean: function paramsClean() {
      this.postDat = {
        type: 1,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        no: 1,
        size: 15
      };
    },

    // zym.省局切换
    provinceChange: function provinceChange(inx) {
      this.pvcName = this.provinceMap[inx].sjExamine;
      this.pvcSta = this.provinceMap[inx].status;

      this.paramsClean();
      this.postDat.sjExamineId = inx;
      this.paramsEx.ids = [];
      this.tabSeek();

      var vm = this;

      this.postUrl = "";
      this.postUrlZg = "";
      // zym.省局提交的报告查验
      (0, _provinceRole.ssReportLoad)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var provinceReport = response.provinceReport;
        // vm.postUrl = process.env.BASE_API + '/File/File/download/token/' + vm.fileToken + '/id/' + response
        //   .provinceReport.reportId;

        if (provinceReport && provinceReport.reportId) {
          (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
            vm.postUrl = response.payload.url;
            // vm.fileNameHybg = response.payload.fileName
          });
        }
      }).catch(function (error) {});

      // zym.查询整改报告
      (0, _provinceRole.getPostponeDesc)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var upPostponeDesc = response.upPostponeDesc;
        if (upPostponeDesc && upPostponeDesc.reportId) {
          (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
            vm.postUrlZg = response.payload.url;
          });
        }
      }).catch(function (error) {});
    },

    goFirm: function goFirm(rows, type) {
      this.$router.push({
        path: "admin_fexam",
        query: {
          mtId: rows.materialExamineId,
          pressType: 1,
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: this.postDat.sjExamineId,
          pressName: rows.organizationName,
          examId: rows.id,
          pressState: type,
          updateViewDate: true // zym.是否更新审阅时间
        }
      });
    },

    selectionChange: function selectionChange(resDat) {
      this.paramsEx.ids = [];
      for (var i = 0; i < resDat.length; i++) {
        this.paramsEx.ids.push(resDat[i].id);
      }
    },

    // zym.整体退回、整体发布
    // zym.1-发布  2-退回
    postBack: function postBack(code) {
      var _this5 = this;

      var vm = this;
      if (code == 1) {
        this.$confirm("确定进行整体发布吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _adminRole.postToPvs)({
            sjExamineId: _this5.postDat.sjExamineId,
            type: 1
          }).then(function (response) {
            loading.close();
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage || "操作失败";
            if (tipCode == "fail") {
              _this5.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this5.$message({
                message: tipMessage,
                type: "success",
                onClose: function onClose() {
                  vm.tabSeek("init");
                }
              });
            }
          });
        }).catch(function () {});
      } else if (code == 2) {
        this.postDat.msg = this.postDat.msg.replace(/\s+/g, "");
        if (this.postDat.msg.length == 0) {
          this.$message.error("请填写退回意见");
        } else {
          this.$confirm("确定进行整体退回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.backToPvs)({
              sjExamineId: _this5.postDat.sjExamineId,
              examineMessage: _this5.postDat.msg,
              type: 1
            }).then(function (response) {
              loading.close();

              _this5.dialogVisible = false;

              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage || "操作失败";
              if (tipCode == "fail") {
                _this5.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this5.$message({
                  message: tipMessage,
                  type: "success",
                  onClose: function onClose() {
                    vm.tabSeek("init");
                  }
                });
              }
            });
          }).catch(function () {});
        }
      }
    },

    ableSet: function ableSet(datIn) {
      if (datIn == 8 || datIn == 10) {
        return true;
      } else {
        return false;
      }
    },

    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    closeHandle: function closeHandle() {
      this.postDat.msg = "";
      this.dialogVisible = false;
    },

    checkDfine: function checkDfine(dat) {
      if (dat.progress != "登记" && (dat.status == 0 || dat.status == 1 || dat.status == 2 || dat.status == 4 || dat.status == 5)) {
        return true;
      } else {
        return false;
      }
      // if (dat.status == 9 || dat.status == 3 || dat.status == 10) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    computedColor: function computedColor(item) {
      // if (item.status == 8 || item.status == 10) {
      if (item.progress == "国家新闻出版署" || item.progress == "登记") {
        return { color: "#4fb000", fontWeight: "bold" };
      } else {
        return { color: "#a2a2a2" };
      }
    }
  },
  created: function created() {
    var _this6 = this;

    console.debug("created: ", this.$route.query);
    if (this.$route.query.pvcId) {
      this.postDat.sjExamineId = this.$route.query.pvcId;
    }
    this.resizeSet();

    (0, _account.getFileToken)().then(function (response) {
      _this6.fileToken = response.resultStatus.token;
      _this6.resizeSet();
      _this6.provinceSet();
    });
  },
  mounted: function mounted() {
    var vm = this;

    // window.onresize = function() {
    //     vm.screenHeight = document.documentElement.clientHeight;
    // }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(180);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = __webpack_require__(150);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _echarts = __webpack_require__(34);

var echarts = _interopRequireWildcard(_echarts);

var _vintage = __webpack_require__(123);

var _vintage2 = _interopRequireDefault(_vintage);

var _macarons = __webpack_require__(119);

var _macarons2 = _interopRequireDefault(_macarons);

var _macarons3 = __webpack_require__(120);

var _macarons4 = _interopRequireDefault(_macarons3);

var _blue = __webpack_require__(112);

var _blue2 = _interopRequireDefault(_blue);

var _cool = __webpack_require__(113);

var _cool2 = _interopRequireDefault(_cool);

var _forest = __webpack_require__(114);

var _forest2 = _interopRequireDefault(_forest);

var _fruit = __webpack_require__(115);

var _fruit2 = _interopRequireDefault(_fruit);

var _green = __webpack_require__(116);

var _green2 = _interopRequireDefault(_green);

var _roma = __webpack_require__(121);

var _roma2 = _interopRequireDefault(_roma);

var _shine = __webpack_require__(122);

var _shine2 = _interopRequireDefault(_shine);

var _london = __webpack_require__(118);

var _london2 = _interopRequireDefault(_london);

var _infographic = __webpack_require__(117);

var _infographic2 = _interopRequireDefault(_infographic);

var _StatisticalFinance = __webpack_require__(174);

var _StatisticalFinance2 = _interopRequireDefault(_StatisticalFinance);

var _ProvinceFinance = __webpack_require__(173);

var _ProvinceFinance2 = _interopRequireDefault(_ProvinceFinance);

var _LxdzFinance = __webpack_require__(1570);

var _LxdzFinance2 = _interopRequireDefault(_LxdzFinance);

var _WorkerBase = __webpack_require__(1571);

var _WorkerBase2 = _interopRequireDefault(_WorkerBase);

var _BarChart = __webpack_require__(626);

var _BarChart2 = _interopRequireDefault(_BarChart);

var _HBarChart = __webpack_require__(628);

var _HBarChart2 = _interopRequireDefault(_HBarChart);

var _MBarChart = __webpack_require__(629);

var _MBarChart2 = _interopRequireDefault(_MBarChart);

var _PieChart = __webpack_require__(630);

var _PieChart2 = _interopRequireDefault(_PieChart);

var _BingChart = __webpack_require__(627);

var _BingChart2 = _interopRequireDefault(_BingChart);

var _statisticsAnalysis = __webpack_require__(82);

var _validate = __webpack_require__(59);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XLSX = __webpack_require__(55); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    chartFinance: _StatisticalFinance2.default,
    provinceFinance: _ProvinceFinance2.default,
    lxdzFinance: _LxdzFinance2.default,
    workerBase: _WorkerBase2.default,
    barChart: _BarChart2.default,
    pieChart: _PieChart2.default,
    hbarChart: _HBarChart2.default,
    mbarChart: _MBarChart2.default,
    bingChart: _BingChart2.default
  },
  data: function data() {
    var _chart_;

    return {
      form: {},
      chartHeight: "height: 420px;width:100%;",
      dialogVisible: false,
      activeName: "1",
      chartTheme: "macarons",
      themes: ["macarons", "macarons2", "vintage", "blue", "cool", "forest", "fruit", "green", "roma", "shine", "london", "infographic"],
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",
      option_n: null,
      currentId: "",
      etype: 2,
      listZj: ["音像", "电子", "图书", "期刊", "报纸", "网络"],
      checkListZj: ["音像", "电子"],
      listZj2: ["图书", "期刊", "报纸", "网络", "无"],
      checkListZj2: ["图书", "期刊"],
      columnMap: {
        chart_2: { provincename: "省局", name: "出版单位", type: "音电资质" },
        chart_3: { provincename: "省局", name: "出版单位", zizhi: "出版资质" },
        chart_4: { provincename: "省局", name: "出版单位", zizhi2: "主营出版业务" },
        chart_5: { provincename: "省局", name: "出版单位", zizhi2: "主营出版业务" },
        chart_6: { provincename: "省局", name: "出版单位", isindependentlp: "否为独立法人" },
        chart_7: { provincename: "省局", name: "出版单位", nature: "企业性质", unittype: "单位类型" },
        chart_11: { orgname: "出版单位", value: "出版数量" },
        chart_12: { orgname: "出版单位", publicationname: "出版物名称", value: "时长" },
        chart_13: { orgname: "出版单位", publicationname: "出版物名称", value: "内容来源类型" },
        chart_14: { orgname: "出版单位", publicationname: "出版物名称", value: "书配盘" },
        chart_15: { orgname: "出版单位", ztNums: "实（载）体出版", networkNums: "利用信息网络出版" },
        chart_16: { orgname: "出版单位", xhsdNums: "新华书店", gpsNums: "馆配商", yjNums: "邮局" },
        chart_17: { provincename: "省局", name: "出版单位", expandbusiness: "拓展方向" },
        chart_18: {
          provincename: "省局",
          name: "出版单位",
          operationprojectwebnum: "业务网站",
          operationprojectdatabasenum: "专业数据库",
          operationprojectwechatnum1: "微信公众号个数",
          operationprojectwechatnum2: "微信公众号总用户数",
          operationprojectappnum: "小程序或APP",
          operationprojectweibonum: "微博",
          operationprojectothernum: "其他"
        },
        chart_181: { name: "年度", value: "销售数量（张/盒）" },
        chart_182: (_chart_ = { name: "年度", value: "实载体" }, (0, _defineProperty3.default)(_chart_, "value", "利用信息网络出版"), (0, _defineProperty3.default)(_chart_, "value", "总计"), _chart_),
        chart_183: { name: "年度", value: "年收入（万元）" },
        chart_21: { orgname: "出版单位", value: "出版数量" },
        chart_22: { orgname: "出版单位", publicationname: "出版物名称", value: "时长" },
        chart_23: { orgname: "出版单位", publicationname: "出版物名称", value: "内容来源类型" },
        chart_24: { orgname: "出版单位", publicationname: "出版物名称", value: "书配盘" },
        chart_25: { orgname: "出版单位", ztNums: "实（载）体出版", networkNums: "利用信息网络出版" },
        chart_26: { orgname: "出版单位", xhsdNums: "新华书店", gpsNums: "馆配商", yjNums: "邮局" },
        chart_27: { provincename: "省局", name: "出版单位", expandbusiness: "拓展方向" },
        chart_28: {
          provincename: "省局",
          name: "出版单位",
          operationprojectwebnum: "业务网站",
          operationprojectdatabasenum: "专业数据库",
          operationprojectwechatnum1: "微信公众号个数",
          operationprojectwechatnum2: "微信公众号总用户数",
          operationprojectappnum: "小程序或APP",
          operationprojectweibonum: "微博",
          operationprojectothernum: "其他"
        },
        chart_281: { name: "年度", value: "销售数量（张/盒）" },
        chart_282: { name: "年度", value: "年收入（万元）" },
        chart_283: { name: "年度", value: "品牌数数量" },
        chart_31: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "音电类型" },
        chart_32: { provincename: "省局", name: "出版单位", value: "出版专业职业资格中级及以上职称占比" },
        chart_33: { provincename: "省局", name: "出版单位", value: "领导班子岗位培训合格证书持有占比" },
        chart_34: { provincename: "省局", name: "出版单位", value: "领导班子出版专业职业资格证书中级及以上占比" },
        chart_35: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "政治面貌" },
        chart_36: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "文化程度" },
        chart_37: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_38: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称等级" },
        chart_39: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称等级" },
        chart_40: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_41: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率"
        },
        chart_42: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数"
        },
        chart_43: { provincename: "省局", orgname: "出版单位", name: "姓名", value: "职称系列" },
        chart_44: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率"
        },
        chart_45: {
          provincename: "省局",
          name: "出版单位",
          value: "音像领导班子成员持证上岗率",
          value2: "电子领导班子成员持证上岗率"
        },
        chart_46: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数"
        },
        chart_47: {
          provincename: "省局",
          name: "出版单位",
          value: "音像取得国家出版专业职业资格的编辑人员数",
          value2: "音像具有中级及以上出版专业职业资格人数",
          value3: "电子具有中级及以上出版专业职业资格人数"
        },
        chart_51: {
          name: "类别",
          value: "<100",
          value2: "100-500",
          value3: "500-1000",
          value4: "1000-5000",
          value5: "5000-10000",
          value6: ">=10000"
        },
        chart_52: {
          name: "年度",
          value: "<0",
          value2: "0",
          value3: "0-0.5",
          value4: "0.5-1",
          value5: "1-5",
          value6: "5-10",
          value7: "10-20",
          value8: ">=20"
        },
        chart_n: {}
      },
      queryFilter: {},
      queryFilterN: {},
      queryVisible: {},
      queryData: {},
      querySort: {},
      txtNumsData: {},
      dataArray: {},
      searchDataParams: {},
      txtNums: [0, 0, 0, 0, 0, 0],
      txtNums2: [0, 0, 0, 0],
      roundKey: new Date().getTime(),
      rangeValus: {
        "<10": "0-10",
        "10-20": "10-20",
        "20-100": "20-100",
        "100-1000": "100-1000",
        ">=1000": "1000",
        "10-30": "10-30",
        "30-60": "30-60",
        "60-120": "120-600",
        "600-1200": "600-1200",
        ">=1200": "1200"
      }
    };
  },

  created: function created() {
    var queryVisible = {};
    var queryData = {};
    var querySort = {};
    var txtNumsData = {};
    for (var key in this.columnMap) {
      queryVisible[key] = false;
      queryData[key] = [];
      var jpo = {};
      for (var key2 in this.columnMap[key]) {
        jpo[key2] = "sort";
      }
      querySort[key] = jpo;
      txtNumsData[key] = {};
    }
    this.queryVisible = queryVisible;
    this.queryData = queryData;
    this.querySort = querySort;
    this.txtNumsData = txtNumsData;
  },
  mounted: function mounted() {
    var that = this;
    window.addEventListener("resize", function () {
      that.initCharts();
    });
    this.initCharts();
    this.initYxCharts();
    this.initDzCharts();
    this.initChartsPerson();
  },

  methods: {
    initCharts: function initCharts() {
      this.getData2("chart_2", "出版单位音像电子资质统计", {});
      this.searchChart3Data();
      this.searchChart4Data();
      this.getData5("chart_5", "出版单位主营出版业务的营收高于音像电子的业务统计", {});
      this.initCharts2();
      this.initChartsBusiness();
    },
    searchChart3Data: function searchChart3Data() {
      this.getData3("chart_3", "出版单位出版资质统计", {
        zizhi1list: this.checkListZj,
        zizhi1str: this.checkListZj.join(",")
      });
    },
    searchChart4Data: function searchChart4Data() {
      this.getData4("chart_4", "出版单位主营出版业务营收高于音像电子业务统计", {
        zizhi2list: this.checkListZj2,
        zizhi2str: this.checkListZj2.join(",")
      });
    },
    initYxCharts: function initYxCharts() {
      this.getData11("chart_11", "2023-2024年度音像制品出版单位出版品种数分段统计", { type: 1 });
      this.getData12("chart_12", "2023-2024年度音音像制品节目时长分段统计", { type: 1 });
      this.getData13("chart_13", "2023-2024年度音像制品内容来源类型统计", { type: 1 });
      this.getData14("chart_14", "2023-2024年度音像制品书配盘统计", { type: 1 });
      this.getData15("chart_15", "2023-2024年度音像制品载体形式统计", { type: 1 });
      //this.getData16("chart_16", "2023-2024音像制品出版渠道统计", { type: 1 });
      this.getData17("chart_17", "2023-2024年度除传统光盘载体外音像制品出版单位拓展方向分布情况", { type: 1 });
      this.getData18("chart_18", "2023-2024年度音像制品出版单位结合音像电子业务开设并运营的项目分布情况", { type: 1 });
      this.getData181("chart_181", "2017-2024年音像制品实（载）体出版销售数量（亿张/盒）统计", { type: 1 });
      this.getData182("chart_182", "2017-2024年音像制品出版年收入（亿元）统计", { type: 1 });
      this.getData183("chart_183", "2017-2024年音像制品品种数统计", { type: 1 });
    },
    initDzCharts: function initDzCharts() {
      this.getData11("chart_21", "2023-2024年度电子出版单位出版品种数分段统计", { type: 2 });
      this.getData12("chart_22", "2023-2024年度电子出版物数据容量分段统计", { type: 2 });
      this.getData13("chart_23", "2023-2024年度电子出版物内容来源类型统计", { type: 2 });
      this.getData14("chart_24", "2023-2024年度电子出版物书配盘统计", { type: 2 });
      this.getData15("chart_25", "2023-2024年度电子出版物载体形式统计", { type: 2 });
      //this.getData16("chart_26", "2023-2024电子出版物出版渠道统计", { type: 2 });
      this.getData17("chart_27", "2023-2024年度除传统光盘载体外电子出版物出版单位拓展方向分布情况", { type: 2 });
      this.getData18("chart_28", "2023-2024年度电子出版物出版单位结合音像电子业务开设并运营的项目分布情况", {
        type: 2
      });
      this.getData181("chart_281", "2017-2024年电子出版物实（载）体出版销售数量（亿张/盒）统计", { type: 2 });
      this.getData182("chart_282", "2017-2024年电子出版物年收入（亿元）统计", { type: 2 });
      this.getData183("chart_283", "2017-2024年电子出版物品种数统计", { type: 2 });
    },
    initCharts2: function initCharts2() {
      this.getData6("chart_6", "法人类型统计", {});
      this.getData7("chart_7", "单位性质统计", {});
    },
    initChartsBusiness: function initChartsBusiness() {
      this.getData51("chart_51", "出版单位注册资本或开办资金、资产、负债分段统计", {});
      this.getData52("chart_52", "出版单位资产收益率分段统计", {});
    },
    initChartsPerson: function initChartsPerson() {
      var tit = {
        31: "音像及电子中级职称人数统计",
        32: "出版专业职业资格中级及以上职称占比情况统计",
        33: "领导班子岗位培训合格证书持有占比统计",
        34: "领导班子出版专业职业资格证书中级及以上占比统计",
        35: "政治面貌统计",
        36: "文化程度统计",
        37: "职称系列统计",
        38: "音像电子人员职称统计",
        39: "出版专业人员职称统计",
        40: "各专业高级职称编辑人数统计",
        41: "音像领导班子成员持证上岗率情况",
        42: "音像取得国家出版专业职业资格\n编辑人员统计",
        43: "各专业中级职称编辑人数统计",
        44: "电子领导班子成员持证上岗率统计",
        45: "领导班子成员持证上岗率统计",
        46: "音像具有中级及以上出版专业\n职业资格人员统计",
        47: "电子具有中级及以上出版专业\n职业资格人员统计"
      };
      for (var i = 32; i <= 47; i++) {
        if (i == 33) {
          continue;
        }
        this.getData31To42("chart_" + i, tit[i], { chartn: "chart" + i });
      }
    },

    // getData1(params) {
    //   getChartData1(params).then((response) => {
    //     let data = {
    //       title: "参检单位资质占比",
    //       subtext: "共计数量：" + response.total,
    //       data: response.list,
    //       datalist: response.datalist,
    //     };
    //     this.chart_1("chart_1", data);
    //   });
    // },
    getData2: function getData2(id, title, params) {
      var _this = this;

      (0, _statisticsAnalysis.getChartData2)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list
          //datalist: response.datalist,
        };
        var json = {};
        for (var index in data.data) {
          var item = data.data[index];
          json[item.name] = item.value;
        }
        var szzNums = Number(json["双资质"]);
        var comNums = Number(json["单位数量"]);
        var yxNums = Number(json["音像"]);
        var dzNums = Number(json["电子"]);
        var nums = Number(yxNums) - Number(dzNums);
        var txtNums = [comNums, szzNums, yxNums - szzNums, dzNums - szzNums, yxNums, dzNums];
        _this.txtNums = txtNums;
        _this.dataArray[id] = data;
        _this.searchDataParams[id] = params;
        _this.roundKey = new Date().getTime();
      });
    },
    getData3: function getData3(id, title, params) {
      var _this2 = this;

      (0, _statisticsAnalysis.getChartData3)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list
          //datalist: response.datalist,
        };
        var txtNums2 = response.datalist.map(function (item) {
          return item.value;
        });
        // if (response.datalist && response.datalist.length > 0) {
        //   var a1 = 0;
        //   var a2 = 0;
        //   var a3 = 0;
        //   var a4 = 0;
        //   for (var i in response.datalist) {
        //     var zizhi = response.datalist[i].zizhi || "";
        //     if (zizhi.indexOf("图书") != -1) {
        //       a1++;
        //     }
        //     if (zizhi.indexOf("期刊") != -1) {
        //       a2++;
        //     }
        //     if (zizhi.indexOf("报纸") != -1) {
        //       a3++;
        //     }
        //     if (zizhi.indexOf("网络") != -1) {
        //       a4++;
        //     }
        //   }
        // }
        // txtNums2 = [a1, a2, a3, a4];
        _this2.txtNums2 = txtNums2;
        _this2.dataArray[id] = data;
        _this2.searchDataParams[id] = params;
        _this2.roundKey = new Date().getTime();
      });
    },
    getData4: function getData4(id, title, params) {
      var _this3 = this;

      (0, _statisticsAnalysis.getChartData4)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        _this3.dataArray[id] = data;
        _this3.searchDataParams[id] = params;
        _this3.roundKey = new Date().getTime();
      });
    },
    getData5: function getData5(id, title, params) {
      var _this4 = this;

      (0, _statisticsAnalysis.getChartData5)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        _this4.dataArray[id] = data;
        _this4.searchDataParams[id] = params;
        _this4.roundKey = new Date().getTime();
      });
    },
    getData6: function getData6(id, title, params) {
      var _this5 = this;

      (0, _statisticsAnalysis.getChartData6)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this5.txtNumsData[id] = chartTxtNums;
        _this5.dataArray[id] = data;
        _this5.searchDataParams[id] = params;
        _this5.roundKey = new Date().getTime();
      });
    },
    getData7: function getData7(id, title, params) {
      var _this6 = this;

      (0, _statisticsAnalysis.getChartData7)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this6.txtNumsData[id] = chartTxtNums;
        _this6.dataArray[id] = data;
        _this6.searchDataParams[id] = params;
        _this6.roundKey = new Date().getTime();
      });
    },
    getData11: function getData11(id, title, params) {
      var _this7 = this;

      (0, _statisticsAnalysis.getChartData11)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[" " + po.name + " "] = po.value;
        }
        _this7.txtNumsData[id] = chartTxtNums;
        _this7.dataArray[id] = data;
        _this7.searchDataParams[id] = params;
        _this7.roundKey = new Date().getTime();
      });
    },
    getData12: function getData12(id, title, params) {
      var _this8 = this;

      (0, _statisticsAnalysis.getChartData12)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this8.txtNumsData[id] = chartTxtNums;
        _this8.dataArray[id] = data;
        _this8.searchDataParams[id] = params;
        _this8.roundKey = new Date().getTime();
      });
    },
    getData13: function getData13(id, title, params) {
      var _this9 = this;

      (0, _statisticsAnalysis.getChartData13)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this9.txtNumsData[id] = chartTxtNums;
        _this9.dataArray[id] = data;
        _this9.searchDataParams[id] = params;
        _this9.roundKey = new Date().getTime();
      });
    },
    getData14: function getData14(id, title, params) {
      var _this10 = this;

      (0, _statisticsAnalysis.getChartData14)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this10.txtNumsData[id] = chartTxtNums;
        _this10.dataArray[id] = data;
        _this10.searchDataParams[id] = params;
        _this10.roundKey = new Date().getTime();
      });
    },
    getData15: function getData15(id, title, params) {
      var _this11 = this;

      (0, _statisticsAnalysis.getChartData15)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this11.txtNumsData[id] = chartTxtNums;
        _this11.dataArray[id] = data;
        _this11.searchDataParams[id] = params;
        _this11.roundKey = new Date().getTime();
      });
    },
    getData16: function getData16(id, title, params) {
      var _this12 = this;

      (0, _statisticsAnalysis.getChartData16)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this12.txtNumsData[id] = chartTxtNums;
        _this12.dataArray[id] = data;
        _this12.searchDataParams[id] = params;
        _this12.roundKey = new Date().getTime();
      });
    },
    getData17: function getData17(id, title, params) {
      var _this13 = this;

      (0, _statisticsAnalysis.getChartData17)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this13.txtNumsData[id] = chartTxtNums;
        _this13.dataArray[id] = data;
        _this13.searchDataParams[id] = params;
        _this13.roundKey = new Date().getTime();
      });
    },
    getData18: function getData18(id, title, params) {
      var _this14 = this;

      (0, _statisticsAnalysis.getChartData18)(params).then(function (response) {
        var data = {
          title: title,
          subtext: "共计数量：" + response.total,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this14.txtNumsData[id] = chartTxtNums;
        _this14.dataArray[id] = data;
        _this14.searchDataParams[id] = params;
        _this14.roundKey = new Date().getTime();
      });
    },
    getData181: function getData181(id, title, params) {
      var _this15 = this;

      (0, _statisticsAnalysis.getChartData181)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist || []
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this15.txtNumsData[id] = chartTxtNums;
        _this15.dataArray[id] = data;
        _this15.searchDataParams[id] = params;
        _this15.roundKey = new Date().getTime();
      });
    },
    getData182: function getData182(id, title, params) {
      var _this16 = this;

      (0, _statisticsAnalysis.getChartData182)(params).then(function (response) {
        console.log("BB==", response);
        var data = {
          title: title,
          data: response,
          datalist: response.datalist || []
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this16.txtNumsData[id] = chartTxtNums;
        _this16.dataArray[id] = data;
        _this16.searchDataParams[id] = params;
        _this16.roundKey = new Date().getTime();
      });
    },
    getData183: function getData183(id, title, params) {
      var _this17 = this;

      (0, _statisticsAnalysis.getChartData183)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist || []
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this17.txtNumsData[id] = chartTxtNums;
        _this17.dataArray[id] = data;
        _this17.searchDataParams[id] = params;
        _this17.roundKey = new Date().getTime();
      });
    },
    getData51: function getData51(id, title, params) {
      var _this18 = this;

      (0, _statisticsAnalysis.getChartData51)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this18.txtNumsData[id] = chartTxtNums;
        _this18.dataArray[id] = data;
        _this18.searchDataParams[id] = params;
        _this18.roundKey = new Date().getTime();
      });
    },
    getData52: function getData52(id, title, params) {
      var _this19 = this;

      (0, _statisticsAnalysis.getChartData52)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        for (var i in response.list) {
          var po = response.list[i];
          chartTxtNums[po.name] = po.value;
        }
        _this19.txtNumsData[id] = chartTxtNums;
        _this19.dataArray[id] = data;
        _this19.searchDataParams[id] = params;
        _this19.roundKey = new Date().getTime();
      });
    },
    getData31To42: function getData31To42(id, title, params) {
      var _this20 = this;

      (0, _statisticsAnalysis.getChartData31To40)(params).then(function (response) {
        var data = {
          title: title,
          data: response.list,
          datalist: response.datalist
        };
        var chartTxtNums = {};
        var total = 0;
        for (var i in response.list) {
          var po = response.list[i];
          if (id == "chart_33" || id == "chart_34" || id == "chart_32") {
            chartTxtNums[" " + po.name + " "] = po.value;
          } else {
            chartTxtNums[po.name] = po.value;
          }
          total += Number(po.value);
        }
        var tjson = {};
        if (id == "chart_38" || id == "chart_39") {
          tjson = { 人员总数: total };
        }
        _this20.txtNumsData[id] = (0, _extends3.default)({}, tjson, chartTxtNums);
        _this20.dataArray[id] = data;
        _this20.searchDataParams[id] = params;
        _this20.roundKey = new Date().getTime();
      });
    },
    listTableData: function listTableData(id, myChart, option, p) {
      var _this21 = this;

      var params = (0, _extends3.default)({ chartn: id.replace("_", "") }, this.searchDataParams[id] || {}, p || {});
      console.log("=====", this.searchDataParams[id]);
      console.log("params=====", params);
      var loading = this.$loading({
        lock: true,
        text: "数据查询中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _statisticsAnalysis.listData)(params).then(function (response) {
        loading.close();
        if (myChart == null) {
          _this21.createDataHtml(id, response.datalist);
          _this21.setDisplayVisible(id, option);
        } else {
          _this21.createDataHtml(id, response.datalist);
          _this21.backEcharts(id, myChart, option);
        }
      });
    },
    setQueryVisible: function setQueryVisible(id) {
      if (this.queryVisible[id]) {
        this.queryVisible[id] = false;
      } else {
        this.queryVisible[id] = true;
      }
    },
    createDataHtml: function createDataHtml(id, datalist, search) {
      var _this22 = this;

      var columns = (0, _keys2.default)(this.columnMap[id]);
      var html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html += ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' + (Number(index) + 1) + "</td>";
        columns.forEach(function (key, index) {
          html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + _this22.formatEmpty(item[key]) + "</td>";
        });
        html += "</tr>";
      }
      if (!search) {
        this.queryData[id] = datalist;
      }
      if (this.dialogVisible) {
        $("#echart_n_html").html(html);
        this.$forceUpdate();
      } else {
        $("#" + id + "_html").html(html);
      }
    },
    downloadData: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var sortAttr, column, sort, key, val, datalist, columns, cellWidths, list, i, po, data, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sortAttr = this.querySort[id];
                column = "";
                sort = "";

                for (key in sortAttr) {
                  val = sortAttr[key];

                  if (val != "sort") {
                    column = key;
                    sort = val;
                  }
                }
                datalist = this.searchData(id, column, sort, "yes");
                columns = this.columnMap[id == "chart_n" ? this.currentId : id];
                cellWidths = [{ wpx: 240 }, { wpx: 300 }, { wpx: 150 }, { wpx: 150 }];
                list = [];

                for (i in datalist) {
                  po = datalist[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[key];
                  }
                  list.push(data);
                }
                filename = "统计数据" + (0, _moment2.default)().format("YYYY-MM-DD") + "_" + new Date().getTime() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 15;
                return XLSX.utils.json_to_sheet(list, opts);

              case 15:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 20;
                return XLSX.writeFile(wb, "" + filename);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadData(_x) {
        return _ref.apply(this, arguments);
      }

      return downloadData;
    }(),
    searchData: function searchData(id, column, sort, exp) {
      if (id == "chart_n") {
        id = this.currentId;
      }
      var datalist = [].concat((0, _toConsumableArray3.default)(this.queryData[id]));
      if (column && sort != "sort") {
        datalist.sort(function (a, b) {
          if (sort == "asc") {
            return (a[column] || "").localeCompare(b[column] || "");
          }
          if (sort == "desc") {
            return (b[column] || "").localeCompare(a[column] || "");
          }
          return 0;
        });
      }
      var columns = this.columnMap[id];
      console.log("columns===", columns);
      var list = [];
      for (var i in datalist) {
        var po = datalist[i];
        var flag = true;
        for (var key in columns) {
          flag = this.searchFlag(po, key);
          if (!flag) {
            break;
          }
        }
        if (flag) {
          list.push(po);
        }
      }
      if (exp == "yes") {
        return list;
      } else {
        this.createDataHtml(id, list, true);
      }
    },
    searchFlag: function searchFlag(po, column) {
      var flag = true;
      var params = {};
      if (this.dialogVisible) {
        params = this.queryFilterN;
      } else {
        params = this.queryFilter;
      }
      if (!(0, _validate.isEmpty)(params[column])) {
        var sval = params[column];
        if (sval in this.rangeValus) {
          var val = po[column] || 0;
          if (sval == ">=1000" || sval == ">=1200") {
            sval = this.rangeValus[sval];
            console.log(sval, val);
            if (Number(val) >= Number(sval)) {
              flag = true;
            } else {
              flag = false;
            }
          } else {
            var arr = this.rangeValus[sval].split("-");
            if (Number(val) >= Number(arr[0]) && Number(val) < Number(arr[1])) {
              flag = true;
            } else {
              flag = false;
            }
          }
        } else {
          if ((po[column] || "").indexOf(params[column]) != -1) {
            flag = true;
          } else {
            flag = false;
          }
        }
      }
      return flag;
    },
    sortData: function sortData(id, column, sort) {
      var currentSrot = "";
      if (sort == "sort") {
        currentSrot = "asc";
      } else if (sort == "asc") {
        currentSrot = "desc";
      } else if (sort == "desc") {
        currentSrot = "sort";
      }
      for (var key in this.querySort[id]) {
        if (key != column) {
          this.querySort[id][key] = "sort";
        }
      }
      this.querySort[id][column] = currentSrot;
      this.searchData(id, column, currentSrot);
    },
    chagenZjVal: function chagenZjVal() {
      this.searchChart3Data();
    },
    chagenZjVal2: function chagenZjVal2() {
      this.searchChart4Data();
    },
    disposeChart: function disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },

    handleClick: function handleClick(tab, event) {
      var that = this;
      // console.log("===", tab);
      // if (tab.name == "1") {
      //   this.initCharts();
      // } else if (tab.name == "3") {
      //   this.initYxCharts();
      // } else if (tab.name == "4") {
      //   this.initDzCharts();
      // } else if (tab.name == "5") {
      //   this.initChartsPerson();
      // }
      // 设定延迟时间以便画面切换后尺寸响应
      this.roundKey = new Date().getTime();
    },
    chartResize: function chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts: function backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN: function clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setDisplayVisible: function setDisplayVisible(id, option) {
      this.option_n = option;
      this.currentId = id;
      this.dialogVisible = true;
      this.queryVisible["chart_n"] = false;
      //设置弹出框查询字段和排序字段
      var columns = this.columnMap[this.currentId];
      for (var key in columns) {
        this.queryFilterN[key] = "";
        this.querySort["chart_n"][key] = "";
      }
      this.clearQueryFilerN();
    },
    openedDialog: function openedDialog() {
      var height = $(window).height() - 220;
      if (this.etype == 1) {
        $("#tj1").attr("class", "col-lg-12");
        $("#tj2").attr("class", "col-lg-12");
        $("#tj2").css("padding-top", "10px");
        $("#tj2").css("padding-bottom", "10px");
        height = height / 2;
      }
      $("#echart_n").css("height", height + "px");
      $("#echart_n_table").css("height", height + "px");
      height = height - 43;
      $("#echart_n_table table tbody").css("height", height + "px");
      this.searchData("chart_n");
      this.initChartN();
    },
    initChartN: function initChartN() {
      this.disposeChart("echart_n");
      var myChartn = echarts.init(document.getElementById("echart_n"), this.chartTheme);
      // var htm=$("#"+this.currentId+"_table").html().replace('fa fa-mail-reply','').replace('searchFilterBtn','searchFilterBtnN').replace(/searchInput/g,'searchInputN');
      // $("#echart_n_table").html(htm);
      var option_n = this.option_n;
      delete option_n.toolbox.feature.myTool2;
      delete option_n.toolbox.feature.myTool1;
      myChartn.setOption(option_n);
      window.onresize = function () {
        myChartn.resize();
      };
      var height = $(window).height() - 220;
      if (this.etype == 1) {
        height = height / 2;
      }
      $("#echart_n_table").css("height", height + "px");
      height = height - 73;
      $("#echart_n_table table tbody").css("height", height + "px");
    },
    formatEmpty: function formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
    handleChangeTheme: function handleChangeTheme(val) {
      this.chartTheme = val;
      this.initCharts();
    },
    onInput: function onInput() {
      this.$forceUpdate();
    }
  }
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      activeIndex: "1",
      leftHt: 0,
      loading: false,
      // typeArr: [
      //   {
      //     name: "全部",
      //     key: 99,
      //   },
      //   {
      //     name: "待核验",
      //     key: 0,
      //   },
      //   {
      //     name: "通过",
      //     key: 1,
      //   },
      //   {
      //     name: "暂缓登记",
      //     key: 2,
      //   },
      //   {
      //     name: "撤销",
      //     key: 4,
      //   },
      //   {
      //     name: "注销或拟注销",
      //     key: 5,
      //   },
      //   {
      //     name: "退回",
      //     key: 98,
      //   },
      // ],
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "待核验",
        key: 0
      }, {
        name: "通过",
        key: 1
      }, {
        name: "暂缓登记",
        key: 21
      }, {
        name: "已登记",
        key: 11
      }, {
        name: "注销或拟注销",
        key: 13
      }],

      postDat: {
        type: 2,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        msg: "",

        no: 1,
        size: 15
      },

      paramsEx: {
        ids: [],
        type: "",
        status: 1,
        message: "",
        pubNumber: ""
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0,

      provinceList: [],
      provinceMap: {},

      pvcName: "",
      pvcSta: "",
      fileToken: "",
      postUrl: "", // zym.省局的分析报告
      postUrlZg: "", // zym.省局的整改报告

      //  整体退回意见

      dialogVisible: false,
      // 核验新增退回操作
      dialogShow: false
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          0: "待核验",
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          4: "撤销",
          5: "注销或拟注销",
          10: "整体退回",
          9: "整体发布"
        };
        if (dat.status == 9) {
          return map[dat.pubStatus] + "（已发布）";
        } else {
          return map[dat.status];
        }
      } else if (code == "statussj") {
        var _map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          // 9: "整体提交",
          11: "已登记",

          // 12: "省局暂缓",
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return _map[dat.statussj];
      } else if (code == "navset") {
        // zym.20250321，去掉各种情况的判断，直接返回省局名称
        // if (dat.status == 0) {
        //   return dat.sjExamine;
        // } else if (dat.status == 8) {
        //   return dat.sjExamine + "（未提交）";
        // } else if (dat.status == 9) {
        //   return dat.sjExamine + "（已完成）";
        // } else if (dat.status == 10) {
        //   return dat.sjExamine + "（退回）";
        // }
        return dat.sjExamine;
      } else if (code == "time") {
        if (dat == "Invalid date" || !dat) {
          return "";
        }
        return dat.substr(0, 16);
      }
    }
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    goUrl: function goUrl(url) {
      window.open(url);
    },
    resizeSet: function resizeSet() {
      this.leftHt = document.documentElement.clientHeight - 50;
      window.onresize = function () {
        this.leftHt = document.documentElement.clientHeight - 50;
      };

      this.leftHt = "height:" + this.leftHt + "px";
    },

    // zym.查询某个省份的待审核的数据
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _adminRole.getWaitList)(this.postDat).then(function (response) {
        _this.tabDatsAll = response.fGeneralExamineList;
        // this.pgAll = response.totalPages;
        _this.loading = false;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        // tabDats = tabDats.filter(function (item) {
        //   // zym.待核验
        //   if (qType == 0 && item.status == "0") {
        //     return true;
        //   } else if (qType == 1 && item.status == "1") {
        //     return true;
        //   } else if (qType == 2 && item.status == "2") {
        //     return true;
        //   } else if (qType == 4 && item.status == "4") {
        //     return true;
        //   } else if (qType == 5 && item.status == "5") {
        //     return true;
        //   } else if (qType == 98 && (item.status == "3" || item.status == "10")) {
        //     return true;
        //   }
        //   return false;
        // });
        tabDats = tabDats.filter(function (item) {
          // console.log("item.statussj=", item.organizationName, "   ", item.statussj);
          var statussj = item.statussj + "";
          if (qType == 1 && statussj == "1") {
            return true;
          } else if (qType == 21 && statussj == "21") {
            return true;
          } else if (qType == 11 && statussj == "11") {
            return true;
          } else if (qType == 13 && statussj == "13") {
            return true;
          } else if (qType == 0 && ["1", "21", "11", "13"].indexOf(statussj) == -1) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },

    provinceSet: function provinceSet() {
      var _this2 = this;

      var vm = this;
      (0, _adminRole.getProviceList)({
        type: 2
      }).then(function (response) {
        _this2.provinceList = response.proList;
        if (!_this2.postDat.sjExamineId) {
          for (var i in _this2.provinceList) {
            var pstas = _this2.provinceList[i].status;
            if (pstas == 0 || pstas == 1 || pstas == 9) {
              _this2.postDat.sjExamineId = _this2.provinceList[i].sjExamineId;
              _this2.pvcName = _this2.provinceList[i].sjExamine;
              _this2.pvcSta = _this2.provinceList[i].status;
              break;
            }
          }
        } else {
          for (var _i in _this2.provinceList) {
            if (_this2.provinceList[_i].sjExamineId == _this2.postDat.sjExamineId) {
              _this2.pvcName = _this2.provinceList[_i].sjExamine;
              _this2.pvcSta = _this2.provinceList[_i].status;
              break;
            }
          }
        }
        for (var _i2 in _this2.provinceList) {
          _this2.provinceMap[_this2.provinceList[_i2].sjExamineId] = _this2.provinceList[_i2];
        }

        if (_this2.postDat.sjExamineId) {
          (0, _provinceRole.ssReportLoad)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var provinceReport = response.provinceReport;
            if (provinceReport && provinceReport.reportId) {
              (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
                vm.postUrl = response.payload.url;
                // vm.fileNameHybg = response.payload.fileName
              });
            }
          }).catch(function (error) {});

          // zym.查询整改报告
          (0, _provinceRole.getPostponeDesc)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var upPostponeDesc = response.upPostponeDesc;
            if (upPostponeDesc && upPostponeDesc.reportId) {
              (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
                vm.postUrlZg = response.payload.url;
              });
            }
          }).catch(function (error) {});
        }

        _this2.tabSeek("init");
      });
    },

    // zym.选择核验意见
    handleSelect: function handleSelect(dat) {
      var _this3 = this;

      if (this.paramsEx.ids.length > 0) {
        this.paramsEx.status = dat;
        if (dat == 3 || dat == 22 || dat == 2 || dat == 4 || dat == 5) {
          this.dialogShow = true;
          this.paramsEx.message = "";
        } else {
          // let transArr = ["", "通过", "暂缓登记", "", "撤销", "注销或拟注销"];
          var transArrMap = {
            0: "",
            1: "通过",
            2: "暂缓登记",
            3: "暂缓",
            4: "撤销",
            5: "注销或拟注销",
            22: "暂缓登记"
          };
          var msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArrMap[this.paramsEx.status] + '" 处理吗？';

          var vm = this;
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.adminExam)(_this3.paramsEx).then(function (response) {
              loading.close();
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                _this3.$message({
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this3.$message({
                  message: tipMessage,
                  type: "success"
                });
                _this3.tabSeek("init");
              }
            });
          }).catch(function () {});
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },
    // 退回填写完意见后提交服务器
    returnFun: function returnFun() {
      var _this4 = this;

      // this.paramsEx.message = this.paramsEx.message.replace(/\s+/g, "");
      // if (this.paramsEx.message.length == 0) {
      //   this.$message.error("请输入内容！");
      //   return;
      // }
      this.dialogShow = false;
      var vm = this;
      var loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _adminRole.adminExam)(this.paramsEx).then(function (response) {
        loading.close();
        var tipCode = response.payload.tipCode;
        var tipMessage = response.payload.tipMessage;
        if (tipCode == "fail") {
          _this4.$message({
            message: tipMessage,
            type: "error"
          });
        } else {
          _this4.$message({
            message: tipMessage,
            type: "success"
          });
          _this4.tabSeek("init");
        }
      });
    },

    paramsClean: function paramsClean() {
      this.postDat = {
        type: 2,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        no: 1,
        size: 15
      };
    },

    // zym.省局切换
    peovinceChange: function peovinceChange(inx) {
      this.pvcName = this.provinceMap[inx].sjExamine;
      this.pvcSta = this.provinceMap[inx].status;

      this.paramsClean();
      this.postDat.sjExamineId = inx;
      this.paramsEx.ids = [];
      this.tabSeek();

      var vm = this;

      this.postUrl = "";
      this.postUrlZg = "";
      // zym.省局提交的报告查验
      (0, _provinceRole.ssReportLoad)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var provinceReport = response.provinceReport;
        // vm.postUrl = process.env.BASE_API + '/File/File/download/token/' + vm.fileToken + '/id/' + response
        //   .provinceReport.reportId;

        if (provinceReport && provinceReport.reportId) {
          (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
            vm.postUrl = response.payload.url;
            // vm.fileNameHybg = response.payload.fileName
          });
        }
      }).catch(function (error) {});

      // zym.查询整改报告
      (0, _provinceRole.getPostponeDesc)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var upPostponeDesc = response.upPostponeDesc;
        if (upPostponeDesc && upPostponeDesc.reportId) {
          (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
            vm.postUrlZg = response.payload.url;
          });
        }
      }).catch(function (error) {});
    },

    goFirm: function goFirm(rows, type) {
      this.$router.push({
        path: "admin_fexam",
        query: {
          pressType: 2,
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: this.postDat.sjExamineId,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.id,
          pressState: type,
          updateViewDate: true // zym.是否更新审阅时间
        }
      });
    },

    selectionChange: function selectionChange(resDat) {
      this.paramsEx.ids = [];
      for (var i = 0; i < resDat.length; i++) {
        this.paramsEx.ids.push(resDat[i].id);
      }
    },

    // zym.整体退回、整体发布
    // zym.1-发布  2-退回
    postBack: function postBack(code) {
      var _this5 = this;

      var vm = this;
      if (code == 1) {
        this.$confirm("确定进行整体发布吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _adminRole.postToPvs)({
            sjExamineId: _this5.postDat.sjExamineId,
            type: 2
          }).then(function (response) {
            loading.close();
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage || "操作失败";
            if (tipCode == "fail") {
              _this5.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this5.$message({
                message: tipMessage,
                type: "success",
                onClose: function onClose() {
                  vm.tabSeek("init");
                }
              });
            }
          });
        }).catch(function () {});
      } else if (code == 2) {
        this.postDat.msg = this.postDat.msg.replace(/\s+/g, "");
        if (this.postDat.msg.length == 0) {
          this.$message.error("请填写退回意见");
        } else {
          this.$confirm("确定进行整体退回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.backToPvs)({
              sjExamineId: _this5.postDat.sjExamineId,
              examineMessage: _this5.postDat.msg,
              type: 2
            }).then(function (response) {
              loading.close();
              _this5.dialogVisible = false;

              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage || "操作失败";
              if (tipCode == "fail") {
                _this5.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this5.$message({
                  message: tipMessage,
                  type: "success",
                  onClose: function onClose() {
                    vm.tabSeek("init");
                  }
                });
              }
              // this.$emit('go-frash');
            });
          }).catch(function () {});
        }
      }
    },

    ableSet: function ableSet(datIn) {
      if (datIn == 8 || datIn == 10) {
        return true;
      } else {
        return false;
      }
    },

    checkDfine: function checkDfine(dat) {
      console.log("dat---", dat);
      if (dat.progress != "登记" && (dat.status == 0 || dat.status == 1 || dat.status == 2 || dat.status == 4 || dat.status == 5)) {
        return true;
      } else {
        return false;
      }
      // if (dat.status == 9) {
      //   return false;
      // } else {
      //   return true;
      // }
    },

    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },
    computedColor: function computedColor(item) {
      // if (item.status == 8 || item.status == 10) {
      if (item.progress == "国家新闻出版署" || item.progress == "登记") {
        return { color: "#4fb000", fontWeight: "bold" };
      } else {
        return { color: "#a2a2a2" };
      }
    }
  },
  created: function created() {
    var _this6 = this;

    if (this.$route.query.pvcId) {
      this.postDat.sjExamineId = this.$route.query.pvcId;
    }
    (0, _account.getFileToken)().then(function (response) {
      _this6.fileToken = response.resultStatus.token;

      _this6.resizeSet();
      _this6.provinceSet();
    });
  }
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _adminRole = __webpack_require__(71);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      activeIndex: "1",
      leftHt: 0,
      loading: false,
      // typeArr: [
      //   {
      //     name: "全部",
      //     key: 99,
      //   },
      //   {
      //     name: "待核验",
      //     key: 0,
      //   },
      //   {
      //     name: "通过",
      //     key: 1,
      //   },
      //   {
      //     name: "暂缓登记",
      //     key: 2,
      //   },
      //   {
      //     name: "撤销",
      //     key: 4,
      //   },
      //   {
      //     name: "注销或拟注销",
      //     key: 5,
      //   },
      //   {
      //     name: "退回",
      //     key: 98,
      //   },
      // ],
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "待核验",
        key: 0
      }, {
        name: "通过",
        key: 1
      }, {
        name: "暂缓登记",
        key: 21
      }, {
        name: "已登记",
        key: 11
      }, {
        name: "注销或拟注销",
        key: 13
      }],

      postDat: {
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        msg: "",

        no: 1,
        size: 12
      },

      paramsEx: {
        ids: [],
        type: "",
        status: 1,
        message: "",
        pubNumber: ""
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0,

      provinceList: [],
      provinceMap: {},

      pvcName: "",
      pvcSta: "",

      // 整体退回
      dialogVisible: false,
      // 核验新增退回操作
      dialogShow: false,

      postUrl: "", // zym.省局的分析报告
      postUrlZg: "" // zym.省局的整改报告
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          0: "待核验",
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          10: "整体退回",
          9: "整体发布"
        };
        if (dat.status == 9) {
          return map[dat.pubStatus] + "（已发布）";
        } else {
          return map[dat.status];
        }
      } else if (code == "statussj") {
        var _map = {
          // 0: "待核验",
          1: "通过",
          2: "暂缓登记",
          // 3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          10: "整体退回",
          9: "整体提交",
          11: "已登记",

          12: "省局暂缓",
          13: "注销或拟注销",
          14: "建议撤销",

          21: "暂缓登记"
        };
        return _map[dat.statussj];
      } else if (code == "navset") {
        // zym.20250321，去掉各种情况的判断，直接返回省局名称
        // if (dat.status == 0) {
        //   return dat.sjExamine;
        // } else if (dat.status == 8) {
        //   return dat.sjExamine + "（未提交）";
        // } else if (dat.status == 9) {
        //   return dat.sjExamine + "（已完成）";
        // } else if (dat.status == 10) {
        //   return dat.sjExamine + "（退回）";
        // }
        return dat.sjExamine;
      } else if (code == "navctrs") {} else if (code == "time") {
        if (dat == "Invalid date" || !dat) {
          return "";
        }
        return dat.substr(0, 16);
      }
    }
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    goUrl: function goUrl(url) {
      window.open(url);
    },
    resizeSet: function resizeSet() {
      this.leftHt = document.documentElement.clientHeight - 50;
      window.onresize = function () {
        this.leftHt = document.documentElement.clientHeight - 50;
      };

      this.leftHt = "height:" + this.leftHt + "px";
    },

    checkDfine: function checkDfine(dat) {
      if (dat.progress != "登记" && (dat.status == 0 || dat.status == 1 || dat.status == 2 || dat.status == 4 || dat.status == 5)) {
        return true;
      } else {
        return false;
      }
      // if (dat.status == 9) {
      //   return false;
      // } else {
      //   return true;
      // }
    },

    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _adminRole.getSuccessiveList)(this.postDat).then(function (response) {
        _this.tabDatsAll = response.fGeneralExamineList;
        // this.pgAll = response.totalPages;
        _this.loading = false;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        // tabDats = tabDats.filter(function (item) {
        //   // zym.待核验
        //   if (qType == 0 && item.status == "0") {
        //     return true;
        //   } else if (qType == 1 && item.status == "1") {
        //     return true;
        //   } else if (qType == 2 && item.status == "2") {
        //     return true;
        //   } else if (qType == 4 && item.status == "4") {
        //     return true;
        //   } else if (qType == 5 && item.status == "5") {
        //     return true;
        //   } else if (qType == 98 && (item.status == "3" || item.status == "10")) {
        //     return true;
        //   }
        //   return false;
        // });
        tabDats = tabDats.filter(function (item) {
          // console.log("item.statussj=", item.organizationName, "   ", item.statussj);
          var statussj = item.statussj + "";
          if (qType == 1 && statussj == "1") {
            return true;
          } else if (qType == 21 && statussj == "21") {
            return true;
          } else if (qType == 11 && statussj == "11") {
            return true;
          } else if (qType == 13 && statussj == "13") {
            return true;
          } else if (qType == 0 && ["1", "21", "11", "13"].indexOf(statussj) == -1) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1 || (item.name || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },

    // zym.省局设置
    provinceSet: function provinceSet() {
      var _this2 = this;

      var vm = this;
      (0, _adminRole.getProviceList)({
        type: 3
      }).then(function (response) {
        _this2.provinceList = response.proList;
        if (!_this2.postDat.sjExamineId) {
          for (var i in _this2.provinceList) {
            var pstas = _this2.provinceList[i].status;
            if (pstas == 0 || pstas == 1 || pstas == 9) {
              _this2.postDat.sjExamineId = _this2.provinceList[i].sjExamineId;
              _this2.pvcName = _this2.provinceList[i].sjExamine;
              _this2.pvcSta = _this2.provinceList[i].status;
              break;
            }
          }
        } else {
          for (var _i in _this2.provinceList) {
            if (_this2.provinceList[_i].sjExamineId == _this2.postDat.sjExamineId) {
              _this2.pvcName = _this2.provinceList[_i].sjExamine;
              _this2.pvcSta = _this2.provinceList[_i].status;
              break;
            }
          }
        }
        for (var _i2 in _this2.provinceList) {
          _this2.provinceMap[_this2.provinceList[_i2].sjExamineId] = _this2.provinceList[_i2];
        }

        if (_this2.postDat.sjExamineId) {
          (0, _provinceRole.ssReportLoad)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var provinceReport = response.provinceReport;
            if (provinceReport && provinceReport.reportId) {
              (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
                vm.postUrl = response.payload.url;
                // vm.fileNameHybg = response.payload.fileName
              });
            }
          }).catch(function (error) {});

          // zym.查询整改报告
          (0, _provinceRole.getPostponeDesc)({
            type: 1,
            provinceId: _this2.postDat.sjExamineId
          }).then(function (response) {
            var upPostponeDesc = response.upPostponeDesc;
            if (upPostponeDesc && upPostponeDesc.reportId) {
              (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
                vm.postUrlZg = response.payload.url;
              });
            }
          }).catch(function (error) {});
        }

        _this2.tabSeek("init");
      });
    },

    // zym.选择核验意见
    handleSsuccessive: function handleSsuccessive(dat) {
      var _this3 = this;

      if (this.paramsEx.ids.length > 0) {
        this.paramsEx.status = dat;
        if (dat == 3 || dat == 2 || dat == 4 || dat == 5) {
          this.dialogShow = true;
          this.paramsEx.message = "";
        } else {
          var transArr = ["", "通过", "暂缓登记", "", "撤销", "注销或拟注销"];
          var msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArr[this.paramsEx.status] + '" 处理吗？';

          var vm = this;
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.adminExam)(_this3.paramsEx).then(function (response) {
              loading.close();
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                _this3.$message({
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this3.$message({
                  message: tipMessage,
                  type: "success"
                });
                _this3.tabSeek("init");
              }
            });
          }).catch(function () {});
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },
    // zym.退回填写完意见后提交服务器
    returnFun: function returnFun() {
      var _this4 = this;

      // this.paramsEx.message = this.paramsEx.message.replace(/\s+/g, "");
      // if (this.paramsEx.message.length == 0) {
      //   this.$message.error("请输入内容！");
      //   return;
      // }
      this.dialogShow = false;
      var vm = this;
      var loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _adminRole.adminExam)(this.paramsEx).then(function (response) {
        loading.close();
        var tipCode = response.payload.tipCode;
        var tipMessage = response.payload.tipMessage;
        if (tipCode == "fail") {
          _this4.$message({
            message: tipMessage,
            type: "error"
          });
        } else {
          _this4.$message({
            message: tipMessage,
            type: "success"
          });
          _this4.tabSeek("init");
        }
      });
    },
    paramsClean: function paramsClean() {
      this.postDat = {
        type: 1,
        status: 99,
        keyword: "",
        sjExamineId: "",
        isZyzj: 0,
        no: 1,
        size: 12
      };
    },

    peovinceChange: function peovinceChange(inx) {
      this.pvcName = this.provinceMap[inx].sjExamine;
      this.pvcSta = this.provinceMap[inx].status;

      this.paramsClean();
      this.postDat.sjExamineId = inx;
      this.paramsEx.ids = [];
      this.tabSeek();

      var vm = this;

      this.postUrl = "";
      this.postUrlZg = "";
      // zym.省局提交的报告查验
      (0, _provinceRole.ssReportLoad)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var provinceReport = response.provinceReport;
        // vm.postUrl = process.env.BASE_API + '/File/File/download/token/' + vm.fileToken + '/id/' + response
        //   .provinceReport.reportId;

        if (provinceReport && provinceReport.reportId) {
          (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
            vm.postUrl = response.payload.url;
            // vm.fileNameHybg = response.payload.fileName
          });
        }
      }).catch(function (error) {});

      // zym.查询整改报告
      (0, _provinceRole.getPostponeDesc)({
        type: 1,
        provinceId: inx
      }).then(function (response) {
        var upPostponeDesc = response.upPostponeDesc;
        if (upPostponeDesc && upPostponeDesc.reportId) {
          (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
            vm.postUrlZg = response.payload.url;
          });
        }
      }).catch(function (error) {});
    },

    goFirm: function goFirm(rows, type) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.publishMaterialId,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: type,
          updateViewDate: true // zym.是否更新审阅时间
        }
      });
    },

    selectChange: function selectChange(resDat) {
      this.paramsEx.ids = [];
      for (var i = 0; i < resDat.length; i++) {
        this.paramsEx.ids.push(resDat[i].id);
      }
    },

    // zym.整体退回、整体发布
    // zym.1-发布  2-退回
    postBack: function postBack(code) {
      var _this5 = this;

      var vm = this;
      if (code == 1) {
        this.$confirm("确定进行整体发布吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _adminRole.postToPvs)({
            sjExamineId: _this5.postDat.sjExamineId,
            type: 3
          }).then(function (response) {
            loading.close();
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage || "操作失败";
            if (tipCode == "fail") {
              _this5.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this5.$message({
                message: tipMessage,
                type: "success",
                onClose: function onClose() {
                  vm.provinceSet();
                  vm.tabSeek("init");
                }
              });
            }
          });
        }).catch(function () {});
      } else if (code == 2) {
        this.postDat.msg = this.postDat.msg.replace(/\s+/g, "");
        if (this.postDat.msg.length == 0) {
          this.$message.error("请填写退回意见");
        } else {
          this.$confirm("确定进行整体退回吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _adminRole.backToPvs)({
              sjExamineId: _this5.postDat.sjExamineId,
              examineMessage: _this5.postDat.msg,
              type: 3
            }).then(function (response) {
              loading.close();

              _this5.dialogVisible = false;
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage || "操作失败";
              if (tipCode == "fail") {
                _this5.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this5.$message({
                  message: tipMessage,
                  type: "success",
                  onClose: function onClose() {
                    vm.tabSeek("init");
                    // this.$emit('go-frash');
                  }
                });
              }
            });
          }).catch(function () {});
        }
      } else if (code == 3) {
        // backToPvs({
        //   sjExamineId: this.postDat.sjExamineId,
        //   examineMessage: this.rebackMsg,
        //   type: 3
        // }).then(response => {
        //   this.diaMessage = false;
        //   this.postDat.sjExamineId = '';
        //   this.message = '';
        //   this.provinceSet();
        //   this.tabSeek('init');
        // })
      }
    },

    handleClose: function handleClose() {
      this.rebackMsg = "";
    },

    ableSet: function ableSet(datIn) {
      if (datIn == 8 || datIn == 10) {
        return true;
      } else {
        return false;
      }
    },

    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    // loadReport: function () {
    //   if (!this.postUrl) {
    //     this.$message.error('当前省局未提交分析报告');
    //   } else {
    //     return true;
    //   }
    // }
    computedColor: function computedColor(item) {
      // if (item.status == 8 || item.status == 10) {
      if (item.progress == "国家新闻出版署" || item.progress == "登记") {
        return { color: "#4fb000", fontWeight: "bold" };
      } else {
        return { color: "#a2a2a2" };
      }
    }
  },
  created: function created() {
    var _this6 = this;

    if (this.$route.query.pvcId) {
      this.postDat.sjExamineId = this.$route.query.pvcId;
    }
    (0, _account.getFileToken)().then(function (response) {
      _this6.fileToken = response.resultStatus.token;

      _this6.resizeSet();
      _this6.provinceSet();
    });
  }
};

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        keyword: "",
        year1: "",
        sjExamineId: "",
        no: 1,
        size: 12,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.successiveSeek)(this.params).then(function (response) {
        console.log("response==", response);
        _this.tabDats = response.generalLxPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearLxdz", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    var selYearLxdz = sessionStorage.getItem("selYearLxdz") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: 3
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearLxdz != "") {
              _this2.params.year1 = selYearLxdz;
              _this2.selYear = selYearLxdz;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(181);

var _typeof3 = _interopRequireDefault(_typeof2);

var _uploadBtn = __webpack_require__(249);

var _uploadBtn2 = _interopRequireDefault(_uploadBtn);

var _pressRole = __webpack_require__(7);

var _provinceRole = __webpack_require__(20);

var _account = __webpack_require__(16);

var _export = __webpack_require__(127);

var _file = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import downLoad from 'downloadjs';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    UpBtn: _uploadBtn2.default
  },
  props: ["pressType", "pressDat", "role", "organization", "selYears", "defaultYear", "cancelFlag"],
  data: function data() {
    return {
      tabCage: {
        tabDat1: [],
        tabDat2: [],
        tabDat3: []
        // tabDat4:[],
      },
      selYear: "",
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: ""
      },
      progress: "",
      msgStatus: "",
      opMsg: "",

      fileToken: "",
      loadUrl: "",

      filrUrl1: "",
      filrUrl2: "",

      printUrl1: "",
      printUrl2: "",
      printUrl3: "",

      //  审核历史
      tabDat: []
    };
  },

  watch: {
    pressDat: function pressDat(curVal, oldVal) {
      this.pressInit();
      // 流转记录
      this.historyRecord();
    }
  },
  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          var map = {
            0: "开始",
            7: "提交",
            21: "暂缓登记"
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          var _map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记",
            22: "暂缓登记"
          };
          return _map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map2 = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
            21: "暂缓登记",
            22: "暂缓登记"
          };

          return _map2[dat.status];
        } else if (dat.flowName == "登记") {
          var _map3 = {
            0: "待登记",
            1: "待登记",
            2: "已登记"
          };

          return _map3[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
    filterMsgStatus: function filterMsgStatus(code) {
      var map = {
        0: "待审核",
        1: "通过",
        2: "暂缓",
        3: "退回",
        4: "撤销",
        5: "注销",
        6: "全部",
        7: "已提交",
        8: "未提交",
        9: "整体提交",
        10: "整体退回",
        11: "已登记",
        12: "省局暂缓",
        13: "注销或拟注销",
        14: "建议撤销",
        15: "待审核（存在问题）",
        16: "待审核（省局暂缓）",
        17: "待审核（建议注销）",
        18: "待审核（建议撤销）",
        19: "待审核（省局通过）",
        21: "暂缓登记", // 省局整改
        22: "暂缓登记" // 出版署整改
      };
      return map[code] || "";
    },
    translate: function translate(dat, code) {
      // console.debug('translate: ', dat,code)
      if (code == "pgress") {
        var transArr = ["未提交", "已提交"];
        return transArr[dat - 1];
      } else if (code == "time") {
        return dat && dat.substr(0, 16);
      }
    }
  },
  methods: {
    // zym.流转记录
    historyRecord: function historyRecord() {
      var _this = this;

      var dat = this.pressDat[0];
      this.examineId = dat.id;
      // console.log("流转记录：", this.examineId, " 年度：", this.selYear);

      (0, _provinceRole.successiveHistoryNew)({ examineId: this.examineId, year1: this.selYear }).then(function (response) {
        var flowData = response.fFlowTaskList;
        // 如果是出版社，需要显示出版社、省局、出版署的通过意见
        if (_this.role == "press") {
          console.log("出版社...");
          _this.tabDat = flowData.filter(function (item) {
            if (item.flowName == "国家新闻出版署") {
              if (item.status == "1") {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          });
        } else {
          console.log("非出版社...");
          _this.tabDat = flowData;
        }
      });
    },
    valChange: function valChange() {
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function toEdit(row) {
      var urlMap = {
        201: "edsct_tab1",
        202: "edsct_tab2",
        203: "edsct_tab3",
        204: "edlct_tab4",
        205: "edlct_tab5",
        206: "edlct_tab6",
        207: "edsct_tab7",
        208: "edlct_tab8",
        301: "edlct_tab9",
        209: "edsct_tab10"
      };
      this.$router.push({
        path: urlMap[row.materialCode],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pressType: this.pressType,
          role: this.role
        }
      });
    },

    zeroStoreCtrls: function zeroStoreCtrls(dat) {
      var _this2 = this;

      var detAble = this.zeroStoreage.fileId;
      this.zeroStoreage.fileId = dat;
      (0, _pressRole.sUpdate0)({
        pfile1: this.zeroStoreage
      }).then(function (response) {
        if (detAble) {
          (0, _account.detFile)({
            id: detAble
          }).then(function (inresp) {
            _this2.zeroStoreage.id = response.pfile1.id;
          });
        }
      }).catch(function (error) {});
    },

    // zym.文件下载
    filesDown: function filesDown(dat) {
      if (dat.status == 1) {
        this.$message({
          message: "附件未上传",
          type: "error"
        });
      } else {
        // console.log('dat:', JSON.stringify(dat));
        if (dat.id && dat.materialCode) {
          var dataIn = {};
          dataIn.organizationMaterialId = dat.id;
          dataIn.code = dat.materialCode;
          dataIn.materialTitle = dat.materialTitle;
          dataIn.organizationId = dat.organizationId;
          // console.log(JSON.stringify(dat));
          (0, _file.filesDownloadUploadBtn)(dataIn).then(function (response) {
            window.open(response.payload.url);
          });
        }
      }
    },
    // zym.撤回
    toCancel: function toCancel() {
      var _this3 = this;

      var vm = this;
      this.$confirm("确认撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _pressRole.cancelTabSubmit)({
          materialExamineId: _this3.postId
          // type: 1 // zym.type类型不能要，音像、电子共用接口，nodejs根据examine来判断哪种类型
        }).then(function (response) {
          loading.close();
          // console.log('response=', JSON.stringify(response));
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.message || "操作失败";
          if (tipCode == "fail") {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this3.$message({
              message: "操作成功！",
              type: "success"
            });
            _this3.$router.push("pgress_step");
          }
        });
      }).catch(function (error) {});
    },

    pressInit: function pressInit() {
      var dat = this.pressDat[0];
      var vm = this;
      console.debug("pressInit: ", dat);
      if (dat.reportUploadList) {
        this.tabCage.tabDat1 = dat.reportUploadList;
        this.tabCage.tabDat2 = dat.yearVerificationList;
        this.tabCage.tabDat3 = dat.licenseUploadList;

        // console.log('文件材料信息: ', JSON.stringify(this.tabCage.tabDat1))
        // console.log('dat.pFile1: ', JSON.stringify(dat.pFile1))
        // console.log('dat.pFile2: ', JSON.stringify(dat.pFile2))

        this.opMsg = dat.msg;
        this.msgStatus = dat.msgStatus;
        this.progress = dat.progress;
        this.postId = dat.reportUploadList[0].materialExamineId;

        // console.log('publishMaterialId1=', this.tabCage.tabDat1[0].id)
        // console.log('publishMaterialId2=', this.tabCage.tabDat2[0].id)

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        var zichaReportFileId = undefined;
        var zhenggaiReportFileId = undefined;
        if (dat.pFile1 && dat.pFile1.length > 0) {
          // console.log('到达file1...')
          zichaReportFileId = dat.pFile1[0].id;
        }

        if (dat.pFile2 && dat.pFile2.length > 0) {
          // console.log('到达file2...,', dat.pFile2[0].id, ',', this.tabCage.tabDat1[1].id);
          zhenggaiReportFileId = dat.pFile2[0].id;
        }

        this.saveFileId(this.tabCage.tabDat1[0], zichaReportFileId, zhenggaiReportFileId);
        if (this.tabCage.tabDat1[1] != undefined) {
          this.saveFileId(this.tabCage.tabDat1[1], zichaReportFileId, zhenggaiReportFileId);
        }

        // 调节顺序
        if (this.tabCage.tabDat1[0].materialTitle == "整改报告") {
          // 有整改必有自查
          var tabDatTmp = this.tabCage.tabDat1[0];
          this.tabCage.tabDat1[0] = this.tabCage.tabDat1[1];
          this.tabCage.tabDat1[1] = tabDatTmp;
        }

        (0, _account.getFileToken)().then(function (response) {
          vm.loadUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + response.resultStatus.token + "/id/" + dat.pFile1.fileId;
          //  vm.printUrl1 = process.env.BASE_API + '/File/File/printYxdzJbxx?type='+ vm.pressType + '&organizationId=' + vm.tabCage.tabDat2[0].organizationId +'&token=' + encodeURIComponent(vm.$store.getters.token);
          //vm.printUrl2 = process.env.BASE_API + '/File/File/printRyJbxx?type='+ vm.pressType + '&publishMaterialId=' + vm.tabCage.tabDat2[7].id +'&token=' + encodeURIComponent(vm.$store.getters.token);
          //vm.printUrl3 = process.env.BASE_API + '/File/File/printYxdzCbwqkb?type='+ vm.pressType + '&publishMaterialId=' + vm.tabCage.tabDat3[0].id+ '&organization=' + encodeURIComponent(vm.organization) +'&token=' + encodeURIComponent(vm.$store.getters.token);
        });
      }
    },
    saveZeroStoreage: function saveZeroStoreage(publishMaterialId, publishId, fileId) {
      this.zeroStoreage[publishMaterialId] = {
        publishMaterialId: publishMaterialId,
        publishId: publishId,
        fileId: fileId
      };
    },

    saveFileId: function saveFileId(tabDat1Item, zichaReportFileId, zhenggaiReportFileId) {
      var zgbgPublishMaterialId = void 0,
          zcbgPublishMaterialId = void 0;
      if (tabDat1Item.materialTitle == "整改报告") {
        // 整改报告
        zgbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zgbgPublishMaterialId, tabDat1Item.organizationId, zhenggaiReportFileId);
      } else {
        // 有时候不叫自查报告 而是工作报告（
        zcbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zcbgPublishMaterialId, tabDat1Item.organizationId, zichaReportFileId);
      }
    },

    postPrevs: function postPrevs() {
      return this.postId;
    },
    dmyfile: function dmyfile(exp, obj) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printYxdzJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat2[7].id,
          organization: encodeURIComponent(this.organization),
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 3) {
        expUrl = "/api/export/printYxdzCbwqkb";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat3[0].id,
          organization: encodeURIComponent(this.organization),
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 4) {
        expUrl = "/api/export/download";
        params = {
          id: this.pressDat[0].pFile1.fileId
        };
      }
      console.debug("expUrl: ", expUrl);
      console.debug("params: ", params);
      (0, _export.expFile)({
        expUrl: expUrl,
        p: params
      }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    }
  },
  created: function created() {
    this.selYear = this.defaultYear;
    console.debug("defaultYear: ", this.defaultYear);
    this.pressInit();
    // 流转记录
    this.historyRecord();
    //  this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    //  this.filrUrl2 = process.env.BASE_API + '/File/File/downloadDrmb?code=0012&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = "https://ydnj.capub.cn/ydfile" + "/drmb/001.xlsx"; // 封面和盖章页
    this.filrUrl2 = "https://ydnj.capub.cn/ydfile" + "/drmb/002.xlsx"; // 封面和盖章页
    console.log((0, _typeof3.default)(this.cancelFlag));
  }
};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _paramsEt = __webpack_require__(356);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      dialogVisible: false,
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,
      imgId: "",
      imgUrl: "",
      options: [],
      value: "",
      getImg: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: ""
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ""
      },
      CompanyNatureMap: {}
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C001", "C018", "C019", "C003", "C004"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      var vm = this;
      newPromise.then(function (result) {
        _this.dicDats = result;
        _this.isNot = _this.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (var key in _this.isNot) {
          if (_this.isNot[key] == "是") {
            _this.params.isIndependentLP = key;
          }
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      var vm = this;
      (0, _pressRole.tabRead1)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        response.pbasic.areaDate = [response.pbasic.startYyDate, response.pbasic.endYyDate];
        _this2.params = response.pbasic;
        _this2.imgId = response.pbasic.yyzzId;
        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        _this2.layChange();
        // getFileToken().then(inresp => {
        //   this.imgUrl = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token +
        //     '/id/' + vm.imgId;
        // })
        // zym.设置营业执照或事业法人证书
        (0, _pressRole.getPfileUrl)({ id: response.pbasic.yyzzId }).then(function (response) {
          var url = response.payload.url;
          _this2.dialogVisible = false;
          _this2.imgUrl = url;
        });
      });
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({
              value: list.createdAt,
              id: list.id
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + data.resultStatus.token + "/id/" + that.historyJsonParams.yyzzId;
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },
    // 返回上一页
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    var pathArr = this.$route.path.split("/");
    this.dictInit();
    this.tabReEdit();
  }
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _paramsEt = __webpack_require__(357);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadSingle = __webpack_require__(344);

var _uploadSingle2 = _interopRequireDefault(_uploadSingle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadSingle2.default
  },
  data: function data() {
    return {
      pressType: "",
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      imgId: "",
      imgUrl: "",
      upUrl: "",
      fileList: "",
      options: [],
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: ""
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ""
      },

      xkzFileId1: "",
      xkzFileId2: "",
      xkzFileId3: "",
      xkzFileId4: "",
      xkzFileId5: "",
      xkzFileId6: "",

      cats: [{ code: "1", name: "行政机关" }, { code: "2", name: "事业单位" }, { code: "3", name: "企业法人" }, { code: "4", name: "社团法人" }, { code: "5", name: "其他" }]
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.yxStartDate = dat[0];
      this.params.yxEndDate = dat[1];
    }
  },
  methods: {
    fileTdSet1: function fileTdSet1() {},
    filesDown: function filesDown(dat) {
      console.log("发文文件：", dat);
      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        console.log("url=", url);

        window.open(url);
      });
    },
    tabReEdit: function tabReEdit() {
      var _this = this;

      var vm = this;
      (0, _pressRole.tabRead2)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        response.pqualification.areaDate = [response.pqualification.yxStartDate, response.pqualification.yxEndDate];
        _this.params = response.pqualification;
        _this.declare.contact = response.pOrganizationPersonnel.contact;
        _this.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        _this.publishFileId = response.pqualification.publishFileId;
        _this.xkzFileId1 = response.pqualification.xkzFileId1;
        _this.xkzFileId2 = response.pqualification.xkzFileId2;
        _this.xkzFileId3 = response.pqualification.xkzFileId3;
        _this.xkzFileId4 = response.pqualification.xkzFileId4;
        _this.xkzFileId5 = response.pqualification.xkzFileId5;
        _this.xkzFileId6 = response.pqualification.xkzFileId6;
      });
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({
              value: list.createdAt,
              id: list.id
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + data.resultStatus.token + "/id/" + that.historyJsonParams.yyzzId;
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.xkzFileId = id;
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.tabReEdit();
    this.pressType = this.$route.query.pressType;
    this.upUrl = "https://ydnj.capub.cn" + "/File/File/upload";
  }
};
// import Upbtn from '@/views/components/upload/uploadCards';

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(358);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Upbtn from '@/views/components/upload';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0
    };
  },

  watch: {},
  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C001", "C018", "C019", "C003", "C004"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      var vm = this;
      newPromise.then(function (result) {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (var key in _this.isNot) {}
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      console.log("信息读取", this.$route.query.mtId);
      (0, _pressRole.tabRead209)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        // console.log('response.pquestionnaire=',JSON.stringify(response.pquestionnaire))
        _this2.params = response.pquestionnaire;
        _this2.params.publishMaterialId = _this2.$route.query.mtId;

        _this2.declare.publishMaterialId = _this2.$route.query.mtId;
        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },
    changeHandle: function changeHandle(code) {
      var newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    this.dictInit();
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  }
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _paramsEt = __webpack_require__(359);

var _pressRole = __webpack_require__(7);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      yearSet: {
        year1: "",
        year2: ""
      },
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: ""
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ""
      }
    };
  },

  methods: {
    tabReEdit: function tabReEdit() {
      var _this = this;

      (0, _pressRole.tabRead3)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        _this.params = response.pfinance;

        // 处理年份
        _this.yearSet.year1 = _this.params.firstYear;
        _this.yearSet.year2 = Number(_this.params.firstYear) + 1;

        if (response.pOrganizationPersonnel !== null) {
          _this.declare.contact = response.pOrganizationPersonnel.contact;
          _this.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ value: list.createdAt, id: list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      getFileToken().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + data.resultStatus.token + "/id/" + that.historyJsonParams.yyzzId;
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.tabReEdit();
    // let newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2;
    // this.yearSet.year2 = newDate.getFullYear() - 1;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(360);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C002: {},
        C020: {}
      }
    };
  },

  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C002", "C020"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this.dicDats = result;
        _this.dicMap["C002"] = _this.$store.getters.dictionary["C002"];
        _this.dicMap["C020"] = _this.$store.getters.dictionary["C020"];
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead4)({ id: this.$route.query.id }).then(function (response) {
        _this2.params = response.pplace;
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.tabReEdit();
  }
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(361);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      submiting: false,

      dicMap: {}
    };
  },

  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C023", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this.dicDats = result;
        _this.dicMap["C024"] = _this.$store.getters.dictionary["C024"];
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead5)({ id: this.$route.query.id }).then(function (response) {
        _this2.params = response.pcommend;
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.tabReEdit();
  }
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(362);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      submiting: false,
      pressType: this.$route.query.pressType,
      dicMap: {
        C021: {},
        C024: {}
      }
    };
  },

  methods: {
    tabReEdit: function tabReEdit() {
      var _this = this;

      (0, _pressRole.tabRead6)({ id: this.$route.query.id }).then(function (response) {
        _this.params = response.pimportantproducts;
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C021", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.dicMap["C021"] = _this2.$store.getters.dictionary["C021"];
        _this2.dicMap["C024"] = _this2.$store.getters.dictionary["C024"];
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.tabReEdit();
  }
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    var _ref;

    return _ref = {
      params: {
        isPunishment: "",
        punishment: "",
        id: "",
        publishId: "",
        publishMaterialId: ""
      },
      rules: {
        isPunishment: [{ required: true, message: "请选择", trigger: "change" }],
        punishment: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 127, message: "填写内容过长！", trigger: "change" }]
      },
      dicDats: {},
      submiting: false,
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: ""
    }, (0, _defineProperty3.default)(_ref, "historyJsonParams", []), (0, _defineProperty3.default)(_ref, "historyJson", []), (0, _defineProperty3.default)(_ref, "historyDeclare", {
      personnel: "",
      contact: "",
      updatedAt: ""
    }), (0, _defineProperty3.default)(_ref, "options", []), (0, _defineProperty3.default)(_ref, "value", ""), _ref;
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        _this.params.publishId = _this.$route.query.pressId;
        _this.params.publishMaterialId = _this.$route.query.mtId;
        if (valid) {
          (0, _pressRole.tabUpdate7)({ ppunishment: _this.params }).then(function (response) {
            _this.submiting = false;
            _this.$message({
              message: "保存成功！",
              type: "success"
            });
            _this.$router.push({
              path: "audio_press",
              query: {
                pressType: _this.$route.query.pressType
              }
            });
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead7)({ id: this.$route.query.mtId }).then(function (response) {
        _this2.params = response.ppunishment;
        if (response.pOrganizationPersonnel !== null) {
          _this2.declare.contact = response.pOrganizationPersonnel.contact;
          _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this2.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    dictInit: function dictInit() {
      var _this3 = this;

      var nameArr = ["C018"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this3.dicDats = result;
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ value: list.createdAt, id: list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + data.resultStatus.token + "/id/" + that.historyJsonParams.yyzzId;
      });
    }
  },

  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.dictInit();
    this.tabReEdit();
  }
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _paramsEt = __webpack_require__(363);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadSingleView = __webpack_require__(632);

var _uploadSingleView2 = _interopRequireDefault(_uploadSingleView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Upbtn from '@/views/components/uploadCards';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadSingleView2.default
  },
  data: function data() {
    var _ref;

    return _ref = {
      dialogVisible: false,
      params: {},
      rules: _paramsEt.paramsRule,
      submiting: false,
      dicDats: {},

      diaImg: '',

      urls1: '',
      urls2: '',

      highLight: false,

      img1: ""
    }, (0, _defineProperty3.default)(_ref, 'dialogVisible', false), (0, _defineProperty3.default)(_ref, 'img2', ""), (0, _defineProperty3.default)(_ref, 'dialogImageUrl', ""), _ref;
  },

  methods: {
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    getImageUrl: function getImageUrl(dat, col) {
      var vm = this;
      // let url = "";
      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        // console.log('url=',url)
        vm[col] = url;
      });
      // return url;
    },
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ['C017', 'C018', 'C006', 'C005', 'C007', 'C008', 'C009'];
      var newPromise = this.$store.dispatch('dictUpdate', {
        codeArr: nameArr,
        type: 'arr'
      });
      newPromise.then(function (result) {
        _this.dicDats = result;
      });
    },

    menReEdit: function menReEdit() {
      var _this2 = this;

      var vm = this;
      (0, _pressRole.tabRead8)({
        id: this.$route.query.id
      }).then(function (response) {
        _this2.params = response.pworker;
        (0, _pressRole.getPfileUrl)({ id: _this2.params.professionalCertificateId }).then(function (response) {
          _this2.img1 = response.payload.url;
          // console.log('img1=',this.img1)       
        });
        (0, _pressRole.getPfileUrl)({ id: _this2.params.trainCertificateId }).then(function (response) {
          _this2.img2 = response.payload.url;
          // console.log('img2=',this.img2)       
        });

        // 选择时间距今如果超过5年，则高亮显示已过期
        if (_this2.params.trainCertificateDate) {
          var trainCertificateDate = new Date(_this2.params.trainCertificateDate.replace(/-/g, '/'));
          var timeDifference = 0;
          if (trainCertificateDate && trainCertificateDate != 'Invalid Date') {
            timeDifference = new Date().getTime() - trainCertificateDate.getTime();
          }
          // console.log('1=',24 * 60 * 60 * 1000 * 1820)
          // console.log('1=',timeDifference)
          if (timeDifference >= 24 * 60 * 60 * 1000 * 1820) {
            // console.log('true');
            _this2.highLight = true;
          } else {
            // console.log('false');
            _this2.highLight = false;
          }
        }

        // getFileToken().then(inresp => {
        //      if (vm.params.professionalCertificateId) {
        //           vm.urls1 = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token + '/id/' + vm.params.professionalCertificateId;
        //      }

        //      if (vm.params.trainCertificateId) {
        //           vm.urls2 = process.env.BASE_API + '/File/File/download/token/' + inresp.resultStatus.token + '/id/' + vm.params.trainCertificateId;
        //      }
        // })
      });
    },

    fileTdSet1: function fileTdSet1(dat) {
      this.params.professionalCertificateId = dat;
    },

    fileTdSet2: function fileTdSet2(dat) {
      this.params.trainCertificateId = dat;
    },

    goVSee: function goVSee(code) {
      if (code == 1) {
        this.diaImg = this.urls1;
      } else if (code == 2) {
        this.diaImg = this.urls2;
      }

      this.dialogVisible = true;
    },

    colseHandle: function colseHandle() {
      this.diaImg = '';
      return true;
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
    this.menReEdit();
  }
};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(263);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      params: _paramsEt.bsParams,
      numShow: true,
      rules: _paramsEt.paramsRule,
      mediaTyp1: {},
      mediaTyp2: {},
      submiting: false,
      dicDats: {},
      yearOpts: [{ code: 2021, name: "2021年" }, { code: 2022, name: "2022年" }]
    };
  },

  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C010", "C011", "C018", "C025", "C012"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      var vm = this;
      newPromise.then(function (result) {
        _this.dicDats = result;
        vm.mediaTyp1 = vm.$store.getters.dictionary["C010"];
        vm.mediaTyp2 = vm.$store.getters.dictionary["C025"];
        _this.mtReEdit();
      });
    },

    editSave: function editSave(name) {
      var _this2 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this2.params.publishId = _this2.$route.query.pressId;
          _this2.params.publishMaterialId = _this2.$route.query.mtId;
          _this2.params.type = _this2.$route.query.pressType;

          (0, _pressRole.tabUpdate9)({ ppublication: _this2.params }).then(function (response) {
            _this2.submiting = false;
            _this2.$message({
              message: "保存成功！",
              type: "success"
            });

            for (var key in _this2.params) {
              _this2.params[key] = "";
            }

            _this2.$router.replace({
              path: "view_tab9",
              query: {
                pressId: _this2.$route.query.pressId,
                mtId: _this2.$route.query.mtId,
                pressType: _this2.$route.query.pressType
              }
            });
          }).catch(function (error) {
            _this2.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    btnCtrls: function btnCtrls(type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    mtReEdit: function mtReEdit() {
      var _this3 = this;

      (0, _pressRole.tabRead9)({ id: this.$route.query.id }).then(function (response) {
        _this3.params = response.ppublication;
        if (_this3.pressType == 1) {
          if (_this3.mediaTyp1[_this3.params.carrierForm] == "电子-信息网络出版") {
            _this3.numShow = false;
          } else {
            _this3.numShow = true;
          }
        } else if (_this3.pressType == 2) {
          if (_this3.mediaTyp2[_this3.params.carrierForm] == "电子-信息网络出版") {
            _this3.numShow = false;
          } else {
            _this3.numShow = true;
          }
        }
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
  }
};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

exports.default = {
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15
      }
    };
  },

  filters: {
    translate: function translate(dat, code, transMap) {
      return transMap[code][dat];
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      var nowYear = new Date().getFullYear();

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = nowYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = nowYear - 1;
      }

      (0, _pressRole.tabList3)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.ppublicationList;
          vm.loading = false;
        }, 300);
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var params = {};
      var message = '确定删除出版物 "' + dat.publicationName + '" 的在库信息吗？';

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确定删除所有选中人员的在库信息吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this2.$route.query.mtId;
        (0, _pressRole.tab3Remove)(params).then(function (response) {
          _this2.tabSeek();
        }).catch(function (error) {});
      });
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操作会删除所有已录入数据库的出版物信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab3Clean)().then(function (response) {
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ["C010", "C011", "C018"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.replace({
        path: "edit_tab3",
        query: pathParams
      });
    }
  },
  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: '',
        no: 1,
        size: 15
      },

      pgAll: 0,
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: '',
      options: [],
      value: '',
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ''
      }
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, row) {
      if (code == "C002" && transMap[code][dat] == '其他') {
        return row.otherSituation;
      } else if (code == "C020" && transMap[code][dat] == '其他') {
        return row.otherPower;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == 'time') {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == 'init') {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList4)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pPlaceList;
          vm.loading = false;
          vm.pgAll = response.totalPages;
          if (response.pOrganizationPersonnel !== null) {
            vm.declare.contact = response.pOrganizationPersonnel.contact;
            vm.declare.personnel = response.pOrganizationPersonnel.personnel;
            vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        }, 300);
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ['C002', 'C020'];
      var newPromise = this.$store.dispatch('dictUpdate', { codeArr: nameArr, type: 'map' });
      newPromise.then(function (result) {
        _this2.dicMap = result;
        _this2.tabSeek();
      });
    },
    memberEdit: function memberEdit(dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType
      };
      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: 'edsct_tab4',
        query: pathParams
      });
    },

    pageSent: function pageSent(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ 'value': list.createdAt, 'id': list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
      });
    }

  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: '',
        no: 1,
        size: 15
      },
      pgAll: 0,
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: '',
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ''
      },
      options: [],
      value: ''
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowdat) {
      if (code == 'C024' && transMap[code][dat] == '其他') {
        return rowdat.hjLevelOther;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == 'time') {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == 'init') {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList5)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pCommendList;
          vm.loading = false;
          vm.pgAll = response.totalPages;
          if (response.pOrganizationPersonnel !== null) {
            vm.declare.contact = response.pOrganizationPersonnel.contact;
            vm.declare.personnel = response.pOrganizationPersonnel.personnel;
            vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        }, 300);
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ['C023', 'C024'];
      var newPromise = this.$store.dispatch('dictUpdate', { codeArr: nameArr, type: 'map' });
      newPromise.then(function (result) {
        _this2.dicMap = result;
        _this2.tabSeek();
      });
    },
    memberEdit: function memberEdit(dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: 'edsct_tab5',
        query: pathParams
      });
    },

    pageSent: function pageSent(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ 'value': list.createdAt, 'id': list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
      });
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: '',
        no: 1,
        size: 15
      },
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: '',
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ''
      },
      options: [],
      value: ''
    };
  },

  filters: {
    translate: function translate(dat, code, transMap) {
      if (code == 'C021') {
        if (transMap[code][dat.importantProName] == '其他') {
          return dat.importantProNameOther;
        } else {
          return transMap[code][dat.importantProName];
        }
      } else if (code == 'C024') {
        if (transMap[code][dat.hjLevel] == '其他') {
          return dat.hjLevelOther;
        } else {
          return transMap[code][dat.hjLevel];
        }
      } else {
        return transMap[code][dat];
      }
    },

    stringTrans: function stringTrans(dat, code) {
      if (code == 'time') {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {

    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == 'init') {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList6)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pImportantProductsList;
          vm.loading = false;
          vm.pgAll = response.totalPages;
          if (response.pOrganizationPersonnel !== null) {
            vm.declare.contact = response.pOrganizationPersonnel.contact;
            vm.declare.personnel = response.pOrganizationPersonnel.personnel;
            vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        }, 300);
      });
    },

    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ['C021', 'C024'];
      var newPromise = this.$store.dispatch('dictUpdate', { codeArr: nameArr, type: 'map' });
      newPromise.then(function (result) {
        _this2.dicMap = result;
        _this2.tabSeek();
      });
    },
    memberEdit: function memberEdit(dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: 'edsct_tab6',
        query: pathParams
      });
    },

    pageSent: function pageSent(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ 'value': list.createdAt, 'id': list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            console.log(that.historyJsonParams);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
      });
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
};

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    mixins: [_initPagin2.default],
    data: function data() {
        return {
            loading: false,
            tabDat: [],
            detArrs: [],
            dicMap: {},
            seekPms: {
                type: 0,
                keyword: '',
                no: 1,
                size: 15
            },

            pgAll: 0,

            percentArr: [],
            munCount: {},
            role: '',

            // 图片查看
            dialogVisible: false,
            imgShowUrl: '',
            declare: {
                personnel: "",
                contact: ""
            },
            updatedAt: '',
            historyJsonParams: [],
            historyJson: [],
            historyDeclare: {
                personnel: "",
                contact: "",
                updatedAt: ''
            },
            options: [],
            value: ''
        };
    },

    filters: {
        translate: function translate(dat, code, transMap, rowDat) {
            if (code == "C022" && transMap[code][dat] == '其他') {
                return rowDat.professionalOther;
            } else {
                return transMap[code][dat];
            }
        },
        transStr: function transStr(dat, code) {
            if (code == 'type') {
                var map = {
                    1: "主要负责人",
                    2: "其他负责人",
                    3: "编辑人员"
                };

                return map[dat];
            }
        },
        pecCount: function pecCount(dat, arrDat, type) {
            if (type == 1) {
                if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = (arrDat[0].certificateWorker + arrDat[1].certificateWorker) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }
            } else if (type == 2) {
                if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = (arrDat[0].zjCertificate + arrDat[1].zjCertificate) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }
            } else if (type == 3) {
                if (arrDat[2].thisWorker == 0) {
                    return '0%';
                } else {
                    var pct = arrDat[2].zjCertificate / arrDat[2].thisWorker;
                    pct = (pct * 100 + '').substr(0, 5) + '%';
                    return pct;
                }
            }
        }
    },
    methods: {
        tabSeek: function tabSeek(type) {
            var _this = this;

            if (type == 'seek') return;
            this.loading = true;
            if (type == 'init') {
                this.seekPms.no = 1;
            }

            (0, _pressRole.tabList8)(this.seekPms).then(function (response) {
                var vm = _this;
                vm.tabDat = [];

                var pages = 1;
                if (response.pworkerList.length > 0) {
                    pages = parseInt(response.pworkerList.length / vm.pageSize);
                    if (response.pworkerList.length % vm.pageSize > 0) {
                        pages += 1;
                    }
                }
                setTimeout(function () {
                    vm.loading = false;
                    vm.tabDat = response.pworkerList;
                    vm.pgAll = pages;
                    // undefine?
                    // if(response.pOrganizationPersonnel!==null){
                    if (response.pOrganizationPersonnel) {
                        vm.declare.contact = response.pOrganizationPersonnel.contact;
                        vm.declare.personnel = response.pOrganizationPersonnel.personnel;
                        vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
                    }
                }, 300);
            });
        },

        selectionChange: function selectionChange(selection) {
            var newArr = [];
            for (var i = 0; i < selection.length; i++) {
                newArr.push(selection[i].id);
            }
        },
        dictInit: function dictInit() {
            var _this2 = this;

            var nameArr = ['C017', 'C018', 'C006', 'C022', 'C005', 'C007', 'C008', 'C009'];
            var newPromise = this.$store.dispatch('dictUpdate', {
                codeArr: nameArr,
                type: 'map'
            });
            newPromise.then(function (result) {
                _this2.dicMap = result;
                _this2.tabSeek();
            });

            (0, _pressRole.percentCount)({ materialId: this.$route.query.mtId }).then(function (response) {
                console.debug('percentCount: ', response);
                //    let unFormate = response.workerproportion;
                var unFormate = response;
                _this2.percentArr = [{
                    workerType: 1,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }, {
                    workerType: 2,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }, {
                    workerType: 3,
                    thisWorker: 0,
                    zjCertificate: 0,
                    certificateWorker: 0
                }];
                for (var i = 0; i < unFormate.pWorkerSumList.length; i++) {
                    console.debug('unFormate.pWorkerSumList: ', unFormate.pWorkerSumList[i]);
                    var turnType = unFormate.pWorkerSumList[i].workerType;
                    if (turnType == 1) {
                        _this2.percentArr.splice(0, 1, unFormate.pWorkerSumList[i]);
                    } else if (turnType == 2) {
                        _this2.percentArr.splice(1, 1, unFormate.pWorkerSumList[i]);
                    } else if (turnType == 3) {
                        _this2.percentArr.splice(2, 1, unFormate.pWorkerSumList[i]);
                    }
                }
                console.debug('unFormate.pWorkerProportion: ', unFormate.pWorkerProportion);
                _this2.munCount = unFormate.pWorkerProportion;
            });
        },
        memberEdit: function memberEdit(dat) {
            var pathParams = {
                pressId: this.$route.query.pressId,
                mtId: this.$route.query.mtId,
                pressType: this.$route.query.pressType
            };

            if (dat) {
                pathParams.id = dat.id;
            }

            this.$router.push({
                path: 'edsct_tab8',
                query: pathParams
            });
        },

        // urlCreate: function(mode,id) {
        //     if(mode == 'open'){
        //        this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
        //        this.dialogVisible = true;
        //     }else if(mode == 'close'){
        //        this.imgShowUrl = '';
        //     }
        // },

        urlCreate: function urlCreate(mode, id) {
            var _this3 = this;

            if (mode == 'open') {
                //  this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
                (0, _pressRole.getPfileUrl)({ id: id }).then(function (response) {
                    _this3.imgShowUrl = response.payload.url;
                });
                this.dialogVisible = true;
            } else if (mode == 'close') {
                this.imgShowUrl = '';
            }
        },

        pageSent: function pageSent(inx) {
            this.seekPms.no = inx;
            // this.tabSeek();
            this.currentPage = inx;
        },

        goBack: function goBack() {
            this.$router.go(-1);
        },
        // 获取出版单位历史提交版本列表
        getHistoryList: function getHistoryList() {
            var that = this;
            (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
                console.debug('pSubmitHistoryList: ', response);
                that.historyJson = response.pSubmitHistoryList;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var list = _step.value;

                        that.options.push({ 'value': list.createdAt, 'id': list.id });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        },
        // 获取出版单位历史提交json数据
        gethistory: function gethistory(id) {
            var that = this;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var list = _step2.value;

                    if (id == list.id) {
                        that.historyJsonParams = JSON.parse(list.afterJson);
                        that.historyDeclare = JSON.parse(list.submittor);
                    }
                }
                // 获取图片
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            (0, _account.getFileToken)().then(function (data) {
                that.historyImgUrl = "https://ydnj.capub.cn" + '/File/File/download/token/' + data.resultStatus.token + '/id/' + that.historyJsonParams.yyzzId;
            });
        },
        filterData: function filterData(data, params) {
            console.debug('filterData: ', params.type, params.keyword);
            var text = params.keyword;
            // if (!text || text.trim() === '') return data
            text = text.toLowerCase();
            var list = _.filter(data, function (x) {
                // if (params.type !=0 && x.type != params.type) return false
                return (x.fullName && x.fullName.includes(text) || x.idNumber && x.idNumber.includes(text) || x.cellphone && x.cellphone.includes(text)) && (params.type == 0 || x.type == params.type);
            });

            var pages = parseInt(list.length / this.pageSize);
            if (list.length % this.pageSize > 0) {
                pages += 1;
            }
            this.pgAll = pages;
            if (this.currentPage > this.pgAll) {
                this.seekPms.no = 1;
                this.currentPage = 1;
            }

            return list;
        }
    },
    mounted: function mounted() {
        this.getHistoryList();
    },

    created: function created() {
        this.seekPms.publishMaterialId = this.$route.query.mtId;
        this.dictInit();
        this.role = this.$route.query.role;
    }
};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_initPagin2.default],
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15
      },
      pgAll: 0,
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: ""
      },
      options: [],
      value: "",
      selYear: 0
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowDat) {
      if (code == "C010" || code == "C025") {
        if (transMap[code][dat] == "其他") {
          return rowDat.carrierFormQT;
        } else {
          return transMap[code][dat];
        }
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (dat != null && code == "time") {
        var timeStr = dat.substr(0, 10);
        return timeStr;
      }
      return dat;
    }
  },
  methods: {
    //HYY新加
    tabSeek: function tabSeek(type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = this.selYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = this.selYear - 1;
      }
      var vm = this;

      (0, _pressRole.tabList9)(this.seekPms).then(function (response) {
        vm.tabDat = [];

        var pages = 1;
        if (response.ppublicationList.length > 0) {
          // 近两年的申报 奇数年是1年 偶数年是2年
          var dummyYear = response.ppublicationList[0].year;
          if (dummyYear % 2 == 0) {
            vm.selYear = dummyYear * 1 + 1;
          } else {
            vm.selYear = dummyYear * 1 + 2;
          }
          pages = parseInt(response.ppublicationList.length / vm.pageSize);
          if (response.ppublicationList.length % vm.pageSize > 0) {
            pages += 1;
          }
        }

        setTimeout(function () {
          for (var i = 0; i < response.ppublicationList.length; i++) {
            if (!(response.ppublicationList[i].publicationName == "无" && response.ppublicationList[i].isbn == "无")) {
              vm.tabDat.push(response.ppublicationList[i]);
            }
          }

          vm.loading = false;
          vm.pgAll = pages;
          if (response.pOrganizationPersonnel !== null) {
            vm.declare.contact = response.pOrganizationPersonnel.contact;
            vm.declare.personnel = response.pOrganizationPersonnel.personnel;
            vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        }, 300);
      });
    },

    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C010", "C011", "C018", "C025"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then(function (result) {
        _this.dicMap = result;
        _this.tabSeek();
      });
    },
    memberEdit: function memberEdit(dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edsct_tab9",
        query: pathParams
      });
    },

    pageSent: function pageSent(inx) {
      this.seekPms.no = inx;
      // this.tabSeek();
      this.currentPage = inx;
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function getHistoryList() {
      var that = this;
      (0, _pressRole.pSubmitHistoryList)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        that.historyJson = response.pSubmitHistoryList;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(response.pSubmitHistoryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var list = _step.value;

            that.options.push({ value: list.createdAt, id: list.id });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function gethistory(id) {
      var that = this;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(that.historyJson), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var list = _step2.value;

          if (id == list.id) {
            that.historyJsonParams = JSON.parse(list.afterJson);
            that.historyDeclare = JSON.parse(list.submittor);
          }
        }
        // 获取图片
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      (0, _account.getFileToken)().then(function (data) {
        that.historyImgUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + data.resultStatus.token + "/id/" + that.historyJsonParams.yyzzId;
      });
    },
    filterData: function filterData(data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      var text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      var list = _.filter(data, function (x) {
        // if (params.type !=0 && x.type != params.type) return false
        return (x.publicationName && x.publicationName.includes(text) || x.isbn && x.isbn.includes(text)) && (params.year == 0 || x.year == params.year);
      });

      var pages = parseInt(list.length / this.pageSize);
      if (list.length % this.pageSize > 0) {
        pages += 1;
      }
      this.pgAll = pages;
      if (this.currentPage > this.pgAll) {
        this.seekPms.no = 1;
        this.currentPage = 1;
      }

      return list;
    }
  },
  mounted: function mounted() {
    this.getHistoryList();
  },

  created: function created() {
    if (this.$route.query.pressType == 1) {
      this.selYear = Number(sessionStorage.getItem("selYearYx") || 0);
    } else {
      this.selYear = Number(sessionStorage.getItem("selYearDz") || 0);
    }
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsSEt = __webpack_require__(364);

var _pressRole = __webpack_require__(7);

var _pressSuccessive = __webpack_require__(28);

var _uploadPdf = __webpack_require__(176);

var _uploadPdf2 = _interopRequireDefault(_uploadPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    UpbtnPdf: _uploadPdf2.default
  },
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      numShow: false,
      mediaType: {},
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,

      declare: {
        personnel: "",
        contact: ""
      }
    };
  },


  methods: {
    filesDown: function filesDown(dat) {
      console.log('批复文件：', dat);
      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        console.log('url=', url);

        window.open(url);
      });
    },
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;
          (0, _pressSuccessive.ssSave1)({
            plxdzPublication: _this.params
          }).then(function (response) {
            _this.submiting = false;
            _this.$message({
              message: '保存成功！',
              type: 'success'
            });
            for (var key in _this.params) {
              _this.params[key] = '';
            };
            _this.$router.push({
              path: 'successive_tabs',
              query: {
                mtId: _this.$route.query.mtId
              }
            });
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ['C026', 'C014', 'C025', 'C018'];
      var newPromise = this.$store.dispatch('dictUpdate', {
        codeArr: nameArr,
        type: 'arr'
      });
      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.isNot = _this2.$store.getters.dictionary['C018'];
        _this2.mediaType = _this2.$store.getters.dictionary['C025'];

        if (_this2.$route.query.pgress == 2) {
          _this2.tabReEdit();
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      var vm = this;
      (0, _pressSuccessive.ssRead1)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        console.log('>>>', response);
        _this3.params = response.plxdzPublication;

        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        if (vm.mediaType[vm.params.mediaForm] == '电子-信息网络出版') {
          vm.numShow = false;
          vm.params.issueQuantity = 0;
          vm.params.unitPrice = 0;
        } else {
          vm.numShow = true;
        }
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
  }
};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsSEt = __webpack_require__(365);

var _pressSuccessive = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      pzs: 0,
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,
      imgId: "",

      declare: {
        personnel: "",
        contact: ""
      }
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;
          (0, _pressSuccessive.ssSave2)({
            plxdzBasic: _this.params
          }).then(function (response) {
            _this.submiting = false;
            _this.$message({
              message: "保存成功！",
              type: "success"
            });
            // for(let key in this.params){
            // 	 this.params[key] = '';
            // };
            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C016"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      newPromise.then(function (result) {
        _this2.dicDats = result;
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      (0, _pressSuccessive.ssRead2)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        _this3.params = response.plxdzBasic;
        _this3.pzs = response.pzs;

        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
      // this.$router.push({
      // 	 path:'successive_skim',
      // 	 query:{
      // 	 	 mtId:this.$route.query.mtId,
      // 	 	 pressId:this.$route.query.pressId,
      // 	 	 listId:this.$route.query.listId,
      // 	 	 bookName:this.$route.query.bookName
      // 	 }
      // });
    }
  },
  created: function created() {
    this.dictInit();
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  }
};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
             value: true
});

var _paramsSEt = __webpack_require__(212);

var _pressSuccessive = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
             data: function data() {
                          return {
                                       params: _paramsSEt.bsParams,
                                       rules: _paramsSEt.paramsRule,
                                       submiting: false,

                                       yearSet: {
                                                    year1: '',
                                                    year2: ''
                                       }
                          };
             },

             watch: {
                          'params.areaDate': function paramsAreaDate(dat) {
                                       this.params.startYyDate = dat[0];
                                       this.params.endYyDate = dat[1];
                          }
             },
             methods: {
                          editSave: function editSave(name) {
                                       var _this = this;

                                       this.$refs[name].validate(function (valid) {
                                                    if (valid) {
                                                                 _this.params.publishId = _this.$route.query.pressId;
                                                                 _this.params.publishMaterialId = _this.$route.query.mtId;

                                                                 _this.params.firstYear = _this.yearSet.year1;
                                                                 _this.params.secondYear = _this.yearSet.year2;

                                                                 (0, _pressSuccessive.ssSave3)({ plxdzfinance: _this.params }).then(function (response) {
                                                                              _this.submiting = false;
                                                                              _this.$message({
                                                                                           message: '保存成功！',
                                                                                           type: 'success'
                                                                              });
                                                                              for (var key in _this.params) {
                                                                                           _this.params[key] = '';
                                                                              };
                                                                              _this.goBack();
                                                                 }).catch(function (error) {
                                                                              _this.submiting = false;
                                                                 });
                                                    } else {
                                                                 return false;
                                                    }
                                       });
                          },

                          tabReEdit: function tabReEdit() {
                                       var _this2 = this;

                                       (0, _pressSuccessive.ssRead3)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
                                                    _this2.params = response.plxdzFinance;
                                       });
                          },

                          fileTdSet: function fileTdSet(id) {
                                       this.params.yyzzId = id;
                          },

                          layChange: function layChange() {
                                       if (this.isNot[this.params.isIndependentLP] == "是") {
                                                    this.layDasion = 1;
                                       } else {
                                                    this.layDasion = 2;
                                       }
                          },

                          goBack: function goBack() {
                                       this.$router.go(-1);
                                       // this.$router.push({
                                       // 	 path:'successive_skim',
                                       // 	 query:{
                                       // 	 	 mtId:this.$route.query.mtId,
                                       // 	 	 pressId:this.$route.query.pressId,
                                       // 	 	 listId:this.$route.query.listId,
                                       // 	 	 bookName:this.$route.query.bookName
                                       // 	 }
                                       // });
                          }
             },
             created: function created() {
                          if (this.$route.query.pgress == 2) {
                                       this.tabReEdit();
                          }

                          var newDate = new Date();
                          this.yearSet.year1 = newDate.getFullYear() - 2;
                          this.yearSet.year2 = newDate.getFullYear() - 1;
             }
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsSEt = __webpack_require__(212);

var _pressSuccessive = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      modifyFlag: false,
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      submiting: false,

      yearSet: {
        year1: "",
        year2: ""
      },

      declare: {
        personnel: "",
        contact: ""
      }
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          _this.params.firstYear = _this.yearSet.year1;
          _this.params.secondYear = _this.yearSet.year2;

          (0, _pressSuccessive.ssSave3)({
            plxdzfinance: _this.params
          }).then(function (response) {
            _this.submiting = false;
            _this.$message({
              message: "保存成功！",
              type: "success"
            });
            for (var key in _this.params) {
              _this.params[key] = "";
            }
            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressSuccessive.ssRead3)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        _this2.params = response.plxdzFinance;

        // 新增
        if (_this2.$route.query.pgress == 1) {
          // 处理年份
          _this2.yearSet.year1 = response.plxdzFinance.firstYear;
          _this2.yearSet.year2 = Number(response.plxdzFinance.firstYear) + 1;
        } else {
          // 处理年份
          _this2.yearSet.year1 = _this2.params.firstYear;
          _this2.yearSet.year2 = Number(_this2.params.firstYear) + 1;
        }

        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
      // this.$router.push({
      // 	 path:'successive_skim',
      // 	 query:{
      // 	 	 mtId:this.$route.query.mtId,
      // 	 	 pressId:this.$route.query.pressId,
      // 	 	 listId:this.$route.query.listId,
      // 	 	 bookName:this.$route.query.bookName
      // 	 }
      // });
    }
  },
  created: function created() {
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }

    var newDate = new Date();
    this.yearSet.year1 = newDate.getFullYear() - 2;
    this.yearSet.year2 = newDate.getFullYear() - 1;
  }
};

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(366);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            params: _paramsSEt.bsParams,
            rules: _paramsSEt.paramsRule,
            submiting: false,
            dicDats: {}
        };
    },

    methods: {
        dictInit: function dictInit() {
            var _this = this;

            var nameArr = ['C022', 'C006', 'C005', 'C007', 'C008', 'C009', 'C018', 'C017'];
            var newPromise = this.$store.dispatch('dictUpdate', { codeArr: nameArr, type: 'arr' });
            newPromise.then(function (result) {
                _this.dicDats = result;
            });
        },

        editSave: function editSave(name) {
            var _this2 = this;

            this.$refs[name].validate(function (valid) {
                if (valid) {

                    _this2.params.publishId = _this2.$route.query.pressId;
                    _this2.params.publishMaterialId = _this2.$route.query.mtId;
                    _this2.params.publishType = _this2.$route.query.pressType;

                    (0, _pressSuccessive.ssSave4)({ plxdzworker: _this2.params }).then(function (response) {
                        _this2.submiting = false;
                        _this2.$message({
                            message: '保存成功！',
                            type: 'success'
                        });

                        _this2.goBack();
                    }).catch(function (error) {
                        _this2.submiting = false;
                    });
                } else {
                    return false;
                }
            });
        },

        btnCtrls: function btnCtrls(type, dats) {
            if (type == 1) {
                this.btnCtrls1 = false;
            } else if (type == 2) {
                this.btnCtrls2 = false;
            }
        },

        menReEdit: function menReEdit() {
            var _this3 = this;

            (0, _pressSuccessive.ssRead4)({ id: this.$route.query.id }).then(function (response) {
                console.log('menReEdit response=', (0, _stringify2.default)(response));
                _this3.params = response.plxdzworker;
            });
        },

        goBack: function goBack() {
            this.$router.go(-1);
            //  this.$router.push({
            //     path:'ss_listtab4',
            //     query:{
            //         listId:this.$route.query.listId,
            //         pressId:this.$route.query.pressId,
            //         mtId:this.$route.query.mtId,
            //         pressType:this.$route.query.pressType,
            //     }
            // });
        }
    },
    created: function created() {
        this.dictInit();
        this.params.type = 3;
        if (this.$route.query.pgress == 2) {
            this.menReEdit();
        }
    }
};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(367);

var _pressSuccessive = __webpack_require__(28);

var _uploadPdf = __webpack_require__(176);

var _uploadPdf2 = _interopRequireDefault(_uploadPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UpbtnPdf: _uploadPdf2.default
  },
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,

      dicDats: {},
      isNot: {},
      isSub: {},
      mediaType: {},
      submiting: false,
      layDasion: 1,
      declare: {
        personnel: "",
        contact: ""
      },

      pubStatus: 0,

      modifyFlag: false
    };
  },


  watch: {},
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId; // *publicationOrganizationMaterial的主键
          _this.params.materialCode = _this.$route.query.mtcode;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact || _this.declare.contact == "") {
            _this.$message.error("申报人联系方式必填");
            return;
          }

          // !出版物基本信息保存
          (0, _pressSuccessive.ssSave5)({
            data: _this.params,
            organizationPersonnel: _this.declare
            // plxdzPublication: this.params,
            // organizationPersonnel: this.declare,
          }).then(function (response) {
            console.log("response=", (0, _stringify2.default)(response));
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
            } else {
              _this.submiting = false;
              _this.$message({
                message: "保存成功！",
                type: "success"
              });

              _this.goBack();
            }
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      // let nameArr = ['C026', 'C014', 'C012', 'C025', 'C018'];
      // let newPromise = this.$store.dispatch('dictUpdate', {
      //   codeArr: nameArr,
      //   type: 'arr'
      // });
      // newPromise.then(result => {
      //   this.dicDats = result;
      //   this.isNot = this.$store.getters.dictionary['C018'];
      //   this.isSub = this.$store.getters.dictionary['C012'];
      //   this.mediaType = this.$store.getters.dictionary['C025'];
      //   for (let key in this.isNot) {
      //     if (this.isNot[key] == '是') {
      //       // this.params.isIndependentLP = key;// !是否独立法人，这个页面应该不需要
      //     } else if (this.isNot[key] == '否') {
      //       this.params.isSampleDelivery = key;
      //     }
      //   }
      //   if (this.$route.query.pgress == 2) {
      //     // this.tabReEdit();
      //   }
      // });
    },

    // !读取信息
    tabReEdit: function tabReEdit() {
      var _this2 = this;

      console.log("tabReEdit...");
      var vm = this;
      (0, _pressSuccessive.ssRead5)({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
        judgeModify: true
      }).then(function (response) {
        vm.params = response.plxdzQuestionnaire;

        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        _this2.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", _this2.modifyFlag);
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
    // if (this.$route.query.pgress == 2) {
    console.log("我进来了");
    this.tabReEdit();
    // }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _pressSuccessive = __webpack_require__(28);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {

      querys: {
        pressId: '',
        mtId: '',
        pgress: '',
        listId: '',
        bookName: ''
      },
      loading: false,
      tabDatAll: [], // zym.所有的数据
      tabDat: [], // zym.列表上的数据
      detArrs: [],
      dicMap: {},
      seekPms: {
        type: 0,
        keyword: '',
        no: 1,
        size: 15
      },

      percentArr: [],
      munCount: {},
      role: '',

      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: ''
    };
  },

  filters: {
    translate: function translate(dat, code, transMap) {
      return transMap[code][dat];
    },
    transStr: function transStr(dat, code) {
      if (code == 'type') {
        var map = {
          1: "主要负责人",
          2: "其他负责人",
          3: "编辑人员"
        };

        return map[dat];
      }
    },
    pecCount: function pecCount(dat, arrDat, type) {
      if (type == 1) {
        if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
          return '0%';
        } else {
          var pct = (arrDat[0].certificateWorker + arrDat[1].certificateWorker) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
          pct = (pct * 100 + '').substr(0, 5) + '%';
          return pct;
        }
      } else if (type == 2) {
        if (arrDat[0].thisWorker + arrDat[1].thisWorker == 0) {
          return '0%';
        } else {
          var pct = (arrDat[0].zjCertificate + arrDat[1].zjCertificate) / (arrDat[0].thisWorker + arrDat[1].thisWorker);
          pct = (pct * 100 + '').substr(0, 5) + '%';
          return pct;
        }
      } else if (type == 3) {
        if (arrDat[2].thisWorker == 0) {
          return '0%';
        } else {
          var pct = arrDat[2].zjCertificate / arrDat[2].thisWorker;
          pct = (pct * 100 + '').substr(0, 5) + '%';
          return pct;
        }
      }
    }
  },

  watch: {
    seekPms: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == 'init') {
        this.seekPms.no = 1;
      }

      // ssList4(this.seekPms).then(response => {
      (0, _pressSuccessive.ssList4)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.loading = false;
          // console.log('response=',JSON.stringify(response))
          // vm.tabDat = response.plxdzWorkerList;
          vm.tabDatAll = response.plxdzWorkerList;
          vm.modifyFlag = response.modifyFlag;
          console.log('modifyFlag=', vm.modifyFlag);

          vm.filterTableData();
        }, 300);
        _this.declare.contact = response.pOrganizationPersonnel.contact;
        _this.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDat = this.tabDatAll;
      var qType = this.seekPms.type;
      var qKeyword = this.seekPms.keyword;
      // !人员类型
      if (qType) {
        tabDat = tabDat.filter(function (item) {
          if ((item.type || '') == qType) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDat = tabDat.filter(function (item) {

          if ((item.fullName || '').indexOf(qKeyword) > -1 || (item.idNumber || '').indexOf(qKeyword) > -1 || (item.cellphone || '').indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDat = tabDat;
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var detSure = false;
      var vm = this;

      if (type == 1) {
        if (this.detArrs.length > 0) {
          detSure = true;
        } else {
          this.$message.error('请勾选人员！');
        }
      } else if (type == 2) {
        detSure = true;
      }

      if (detSure) {
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var params = {};
          if (type == 1) {
            params.ids = vm.detArrs;
          } else if (type == 2) {
            params.ids = [dat.id];
          }

          params.publishMaterialId = _this2.$route.query.mtId;
          (0, _pressSuccessive.ssRemove4)(params).then(function (response) {
            _this2.tabSeek();
          }).catch(function (error) {});
        }).catch(function () {});
      }
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm('此操作会删除所有已录入数据库的人员信息，确定全部清除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _pressSuccessive.ssClean4)({
          type: _this3.$route.query.pressType
        }).then(function (response) {
          _this3.seekPms.type = 0;
          _this3.keyword = '';
          _this3.no = 1;
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ['C022', 'C017', 'C018', 'C006', 'C005', 'C007', 'C008', 'C009'];
      var newPromise = this.$store.dispatch('dictUpdate', {
        codeArr: nameArr,
        type: 'map'
      });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });

      // zym.连续型电子出版物提交之后，进入人员列表页面，调用了这个统计的方法
      (0, _pressRole.percentCountLxdz)({
        materialId: this.$route.query.mtId
      }).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        // let unFormate = response.workerproportion;
        _this4.percentArr = response.pWorkerSum;
        console.log('this.percentArr=', (0, _stringify2.default)(_this4.percentArr));
        // this.munCount = response.pWorkerProportion;
      });
    },
    // zym.人员信息查看
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pgress: 2,

        listId: this.$route.query.listId,
        bookName: this.$route.query.bookName
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: 'ss_skimtab4',
        query: pathParams
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {

    this.querys.pressId = this.$route.query.pressId;
    this.querys.mtId = this.$route.query.mtId;
    this.querys.pgress = this.$route.query.pgress;
    this.querys.listId = this.$route.query.listId;
    this.querys.bookName = this.$route.query.bookName;

    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.role = this.$route.query.role;
    this.dictInit();
  }
};

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressSuccessive = __webpack_require__(28);

var _export = __webpack_require__(127);

var _file = __webpack_require__(149);

exports.default = {
  props: ["bookName", "pressDat", "role", "selYears", "defaultYear"],
  data: function data() {
    return {
      querys: {},
      tabDat: [],
      tabDat1: [],
      postId: "",
      selYear: "",
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: "",

        wSat: 0
      },
      opMsg: "",

      printUrl: "",
      fileUrl: ""
    };
  },

  filters: {
    translate: function translate(dat, code) {
      if (code == "pgress") {
        if (dat == 8) {
          return "未提交";
        } else if (dat == 2) {
          return "已提交";
        }
      } else if (code == "time") {
        return dat.substr(0, 16);
      }
    }
  },
  methods: {
    // zym.文件下载
    filesDown: function filesDown(dat) {
      if (dat.status == 1) {
        this.$message({
          message: "附件未上传",
          type: "error"
        });
      } else {
        // console.log("dat:", JSON.stringify(dat));
        if (dat.id && (dat.materialCode || dat.code)) {
          var dataIn = {};
          dataIn.organizationMaterialId = dat.id;
          // 兼容连续型出版物
          dataIn.code = dat.materialCode || dat.code;
          dataIn.materialTitle = dat.materialTitle || dat.name;
          dataIn.organizationId = dat.organizationId;
          // console.log(JSON.stringify(dat));
          (0, _file.filesDownloadUploadBtn)(dataIn).then(function (response) {
            window.open(response.payload.url);
          });
        }
      }
    },
    valChange: function valChange() {
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function toEdit(row) {
      var urlMap = {
        401: "ss_skimtab1",
        402: "ss_skimtab2",
        403: "ss_skimtab3",
        404: "ss_listtab4",

        405: "ss_skimtab5" // pressRole/SuccessivePart/forTabs/ssTab4
      };

      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pgress: 2,
          role: this.role,
          listId: this.$route.query.listId,
          bookName: this.querys.bookName,
          pgsType: this.$route.pgsType
        }
      });
    },

    zeroStoreCtrls: function zeroStoreCtrls(dat) {
      var _this = this;

      var detAble = this.zeroStoreage.fileId;
      this.zeroStoreage.fileId = dat;
      sUpdate0({
        pfile1: this.zeroStoreage
      }).then(function (response) {
        if (detAble) {
          detFile({
            id: detAble
          }).then(function (inresp) {
            _this.zeroStoreage.id = response.pfile1.id;
          });
        }
      }).catch(function (error) {});
    },

    arraySpanMethod: function arraySpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (rowIndex == 0 && columnIndex == 4) {
        return [3, 1];
      }
    },

    pressInit: function pressInit() {
      var vm = this;
      var unFormate = this.pressDat[0];
      this.postId = this.pressDat[0][0].publishMaterialId;
      this.querys = {
        listId: this.$route.query.listId,
        pressId: this.$route.query.pressId,
        bookName: this.$route.query.bookName
      };

      for (var i = 0; i < unFormate.length; i++) {
        if (i < 3) {
          this.tabDat.push(unFormate[i]);
        } else {
          this.tabDat.push(unFormate[i]);
        }
      }

      vm.printUrl = "https://ydnj.capub.cn" + "/File/File/printLxJbxx?type=" + vm.pressType + "&publishMaterialId=" + vm.querys.listId + "&token=" + encodeURIComponent(vm.$store.getters.token);
      vm.printUrl1 = "https://ydnj.capub.cn" + "/File/File/printRyJbxx?type=3&publishMaterialId=" + vm.tabDat[3].id + "&token=" + encodeURIComponent(vm.$store.getters.token);
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },

    postPrevs: function postPrevs() {
      return this.postId;
    },
    dmyfile: function dmyfile(exp, term) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printLxJbxx";
        params = {
          firstYear: this.$route.query.firstYear,
          type: this.pressType,
          publishMaterialId: this.querys.listId
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          type: 3,
          publishMaterialId: term.id
        };
      }
      (0, _export.expFile)({
        expUrl: expUrl,
        p: params
      }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    }
  },
  created: function created() {
    this.pressInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.filrUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/002.xlsx"; // 封面和盖章页
  },

  mounted: function mounted() {
    this.selYear = this.defaultYear;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//

exports.default = {
  name: 'authImg',
  props: {
    authSrc: String
  },
  computed: {
    // 拿到token值，登录成功后由后台返回的
    token: function token() {
      // 这里我把登录之后拿到的token放到了vuex中
      return this.$store.state.commonState.m_token;
    }
  },
  mounted: function mounted() {
    this.getImgSrcByToken();
  },

  methods: {
    // 携带token请求img的src
    getImgSrcByToken: function getImgSrcByToken() {
      // Object.defineProperty()方法会直接在一个对象上定义一个新属性，或者修改一个对象的现有属性，并返回此对象
      Object.defineProperty(Image.prototype, 'authSrc', {
        // 可写
        writable: true,
        // 可枚举
        enumerable: true,
        // 若configurable设为false，那就不可以delete了
        configurable: true
      });
      var img = this.$refs.img;
      var request = new XMLHttpRequest();
      request.responseType = 'blob';
      request.open('get', this.authSrc, true);
      request.setRequestHeader('token', this.token);
      request.onreadystatechange(function (e) {
        if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
          // URL.createObjectURL() 静态方法会创建一个 DOMString，其中包含一个表示参数中给出的对象URL，这个新的URL对象表示指定的File对象或blob对象
          img.src = URL.createObjectURL(request.response);
          img.onload = function () {
            // 在每次调用 createObjectURL() 方法时，都会创建一个新的 URL 对象，即使你已经用相同的对象作为参数创建过。当不再需要这些 URL 对象时，每个对象必须通过调用 URL.revokeObjectURL() 方法来释放。
            URL.revokeObjectURL(img.src);
          };
        }
      });
      request.send(null);
    }
  }
};

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	props: ['outTime'],
	data: function data() {
		return {
			time1: {
				year: '',
				month: '',
				day: ''
			},
			strTime: ''
		};
	},

	watch: {
		time1: {
			handler: function handler(val) {
				this.strTime = this.timePostSet(val);
				this.$emit('time-frash', this.strTime);
				//返回给外部
			},
			deep: true
		},
		outTime: function outTime(val) {
			this.timeShowSet(val);
		}
	},
	methods: {
		beforeTimeClick: function beforeTimeClick(type) {

			if (type === "m") {
				this.time1.month = this.time1.year + '-01-01';
			} else if (type === "d") {
				this.time1.day = this.time1.month + '-01';
			}
		},
		timeFormate: function timeFormate(type) {
			if (type == "y") {
				this.time1.month = '';
				this.time1.day = '';
			} else if (type == "m") {
				this.time1.year = this.time1.month;
				this.time1.day = '';
			} else {
				this.time1.year = this.time1.day;
				this.time1.month = this.time1.day;
			}
		},
		timePostSet: function timePostSet(val) {
			console.log(val);
			var storage = '';
			if (val.year) {
				storage = val.year.split("-")[0];
			};

			if (val.month) {
				storage = storage + '-' + val.month.split("-")[1];
			}

			if (val.day) {
				storage = storage + '-' + val.day.split("-")[2];
			}

			return storage;
		},

		timeShowSet: function timeShowSet(val, time) {

			// val = val.replace(/年/g, ",");
			// val = val.replace(/月/g, ",");
			// val = val.replace(/日/g, "");

			var tempArr = val.split("-");
			var timeArr = [];
			for (var i = 0; i < tempArr.length; i++) {
				if (tempArr[i] && tempArr[i] != '') {
					timeArr.push(tempArr[i]);
				}
			}

			if (timeArr.length == 1) {
				this.time1.year = val.substring(0, val.length);
			} else if (timeArr.length == 2) {
				this.time1.year = val.substring(0, 4);
				this.time1.month = val + '01';
			} else if (timeArr.length == 3) {
				this.time1.year = val;
				this.time1.month = val;
				this.time1.day = val;
			}
		}
	},

	created: function created() {
		this.timeShowSet(this.outTime);
	}
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(180);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _pressRole = __webpack_require__(7);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { tb2Edit,tb2Predata } from '@/api/edits';
// import { deleteAll6 } from '@/api/rowsDelete';
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['pressType', 'pressId', 'mtId', "excelCode"],
    data: function data() {
        return {
            loading: false,
            numData: {},
            excelData: {
                header: null,
                results: null
            },

            map401: {}
        };
    },

    methods: {
        handleUpload: function handleUpload(dat) {
            document.getElementById('excel-upload-input').click();
            if (this.excelCode == '401') {
                this.map401 = dat;
            }
        },

        errorHandler: function errorHandler(code, loading) {
            var vm = this;

            (0, _pressRole.excelErrors)({ num: code }).then(function (response) {
                var errorDatas = [];
                for (var i in response.exportLogs) {
                    if (response.exportLogs[i].errMsg) {
                        errorDatas.push(response.exportLogs[i]);
                    }
                }
                var successSure = true;
                for (var i in errorDatas) {
                    if (errorDatas[i].errMsg) {
                        successSure = false;
                        break;
                    }
                }

                setTimeout(function () {
                    loading.close();
                    if (successSure) {
                        vm.$alert('导入成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: function callback(action) {
                                vm.$emit('t-frash');
                            }
                        });
                    } else {
                        vm.$message.error('导入失败！');
                        vm.$emit('excel-errors', errorDatas);
                        vm.$emit('t-frash');
                    }
                }, 600);
            }).catch(function (error) {
                loading.close();
            });
        },

        specialUpex: function specialUpex(code, data, loading, id) {
            // specialUpex:function(code,data,errors,loading){
            var vm = this;
            /*
             *  多线程
             */

            var postArr = [];

            for (var i = 0; i < 2000; i++) {
                if (data.length > 2000) {
                    postArr.push(new _promise2.default(function (resolve, reject) {
                        var post = {};
                        post.iMaterial05s = data.splice(0, 2000);
                        setTimeout(function () {
                            excelIn5(post).then(function (response) {
                                ExcelErrors({ code: response.payload.num }).then(function (response) {
                                    var errorDatas = [];
                                    for (var t in response.payload.exportLogs) {
                                        if (response.payload.exportLogs[t].errMsg) {
                                            errorDatas.push(response.payload.exportLogs[t]);
                                        }
                                    };
                                    resolve(errorDatas);
                                }).catch(function (error) {
                                    reject(error);
                                });
                            }).catch(function (error) {
                                reject(error);
                            });
                        }, i * 2000);
                    }));
                } else {
                    postArr.push(new _promise2.default(function (resolve, reject) {
                        var post = {};
                        post.iMaterial05s = data;
                        excelIn5(post).then(function (response) {
                            ExcelErrors({ code: response.payload.num }).then(function (response) {
                                var errorDatas = [];
                                for (var t in response.payload.exportLogs) {
                                    if (response.payload.exportLogs[t].errMsg) {
                                        errorDatas.push(response.payload.exportLogs[t]);
                                    }
                                };
                                resolve(errorDatas);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }).catch(function (error) {
                            reject(error);
                        });
                    }));

                    break;
                }
            }

            _promise2.default.all(postArr).then(function (result) {

                var allErrors = [];
                for (var i = 0; i < result.length; i++) {
                    allErrors.push.apply(allErrors, (0, _toConsumableArray3.default)(result[i]));
                };

                var successSure = true;
                for (var i in allErrors) {
                    if (allErrors[i].errMsg) {
                        successSure = false;
                        break;
                    }
                }

                setTimeout(function () {
                    loading.close();
                    if (successSure) {
                        vm.$alert('导入成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: function callback(action) {
                                vm.$emit('t-frash');
                            }
                        });
                    } else {
                        var dataIN = {};
                        dataIN.organizationMaterialId = id;
                        deleteAll6(dataIN).then(function (response) {
                            vm.$emit('t-frash');
                        });
                        vm.$message.error('导入失败！');
                        vm.$emit('excel-errors', allErrors);
                    }
                }, 600);
            }).catch(function (error) {
                loading.close();
                var dataIN = {};
                dataIN.organizationMaterialId = id;
                deleteAll6(dataIN).then(function (response) {
                    vm.$emit('t-frash');
                });
            });
        },

        errorClean: function errorClean() {
            var dataIN = {};
            dataIN.organizationMaterialId = this.orgid;
            deleteAll6(dataIN);
        },

        handleClick: function handleClick(e) {

            var vm = this;
            var files = e.target.files;
            var fileReader = new FileReader();

            var loading = vm.$loading({
                lock: true,
                text: '导入中，请耐心等候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            if (!FileReader.prototype.readAsBinaryString) {
                FileReader.prototype.readAsBinaryString = function (fileData) {
                    var data = "";
                    var pt = this;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for (var i = 0; i < length; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        dataRead(data);

                        //pt.result  - readonly so assign binary
                    };
                    reader.readAsArrayBuffer(fileData);
                };
            } else {
                fileReader.onload = function (ev) {
                    var data = ev.target.result;
                    dataRead(data);
                    document.getElementById('excel-upload-input').value = '';
                };
                // 以二进制方式打开文件
            }

            fileReader.readAsBinaryString(files[0]);
            // console.log(e.target.files)

            function dataRead(data) {
                /*try {
                    var workbook = XLSX.read(data, {
                            type: 'binary'
                        }); // 以二进制流方式读取得到整份excel表格对象
                    var persons = []; // 存储获取到的数据
                } catch (e) {
                    this.$message({
                      type: 'error',
                      message: '文件类型不正确！'
                    });
                    return;
                }*/

                // console.log(data)

                var workbook = XLSX.read(data, {
                    type: 'binary'
                }); // 以二进制流方式读取得到整份excel表格对象
                var persons = []; // 存储获取到的数据

                // 表格的表格范围，可用于判断表头是否数量是否正确
                var fromTo = '';
                // 遍历每张表读取


                for (var sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        fromTo = workbook.Sheets[sheet]['!ref'];
                        persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        break; // 如果只取第一张表，就取消注释这行
                    }
                }

                function dateFormate(time) {
                    var newDate = new Date(time);
                    var y = newDate.getFullYear();
                    var m = newDate.getMonth() + 1;
                    var d = newDate.getDate();

                    if (m < 10) {
                        m = '0' + m;
                    }

                    if (d < 10) {
                        d = '0' + d;
                    }

                    return y + '-' + m + '-' + d;
                };

                // console.log(this.pressId);

                if (persons.length > 0) {
                    persons.shift();
                    if (vm.excelCode == '301') {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = (0, _getIterator3.default)(persons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                item.publishMaterialId = vm.$route.query.mtId;
                                item.publishId = vm.$route.query.pressId;
                                item.publishingTime = dateFormate(item.publishingTime);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (0, _pressRole.subExcel)({
                            data: persons,
                            // ppublicationList: persons,
                            type: vm.pressType,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(function (response) {
                            vm.errorHandler(response.num, loading);
                        }).catch(function (error) {
                            return function () {
                                loading.close();
                            };
                        });
                    } else if (vm.excelCode == '401') {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = (0, _getIterator3.default)(persons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var _item = _step2.value;

                                _item.publishId = vm.pressId[0].psId;
                                _item.publishMaterialId = vm.map401[_item.materialCode];
                                _item.approvalTime = dateFormate(_item.approvalTime);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        (0, _pressSuccessive.ssExcel)({ plxdzPublicationList: persons }).then(function (response) {
                            vm.errorHandler(response.num, loading);
                        }).catch(function (error) {
                            return function () {
                                loading.close();
                            };
                        });
                    } else if (vm.excelCode == '404') {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {

                            for (var _iterator3 = (0, _getIterator3.default)(persons), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item2 = _step3.value;

                                _item2.publishMaterialId = vm.$route.query.mtId;
                                _item2.publishId = vm.$route.query.pressId;
                                _item2.materialCode = vm.$route.query.mtcode;
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        console.log(persons);
                        (0, _pressSuccessive.pExcel)({
                            importWorkerList: persons,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(function (response) {
                            vm.errorHandler(response.num, loading);
                        }).catch(function (error) {
                            return function () {
                                loading.close();
                            };
                        });
                    } else if (vm.excelCode == '208') {
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = (0, _getIterator3.default)(persons), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var _item3 = _step4.value;

                                _item3.publishMaterialId = vm.$route.query.mtId;
                                _item3.publishId = vm.$route.query.pressId;
                                _item3.materialCode = vm.$route.query.mtcode;
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }

                        (0, _pressRole.exPersons)({
                            // importWorkerList: persons,
                            data: persons,
                            type: vm.pressType,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(function (response) {
                            vm.errorHandler(response.num, loading);
                        }).catch(function (error) {
                            return function () {
                                loading.close();
                            };
                        });
                    }
                } else {
                    setTimeout(function () {
                        loading.close();
                        vm.$alert('请检查数据后重新导入！', '导入失败', {
                            confirmButtonText: '确定',
                            callback: function callback(action) {
                                vm.$message({
                                    type: 'error'
                                });
                            }
                        });
                    }, 600);
                }

                vm.$emit("imported", persons);

                // console.log(persons);
            };
        },
        readerData: function readerData(rawFile) {
            var workbook = XLSX.read(btoa(rawFile), { type: 'base64' });
        },


        upLoadFiles: function upLoadFiles() {}

    },

    created: function created() {
        // console.log(this.excelCode);
    }
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _object = __webpack_require__(266);

var _paramsEt = __webpack_require__(263);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["errorList", "pressCode"],
  data: function data() {
    return {
      dialogVisible: false,
      tempHead: [],
      thead2: [],
      erList: [],
      thead: [],
      paramsMap: {
        208: [{
          dataName: "type",
          name: "岗位类型"
        }, {
          dataName: "fullName",
          name: "姓名"
        }, {
          dataName: "gender",
          name: "性別"
        }, {
          dataName: "idNumber",
          name: "身份证号"
        }, {
          dataName: "job",
          name: "职务"
        }, {
          dataName: "politicalStatus",
          name: "政治面貌"
        }, {
          dataName: "culture",
          name: "文化程度"
        }, {
          dataName: "cellphone",
          name: "手机"
        }, {
          dataName: "major",
          name: "专业"
        }, {
          dataName: "professionalTitleSeries",
          name: "职称系列"
        }, {
          dataName: "titleLevel",
          name: "职称级别"
        }, {
          dataName: "rzDate",
          name: "入职时间"
        }, {
          dataName: "lzDate",
          name: "离职时间"
        }, {
          dataName: "certificateSituation",
          name: "持有出版专业技术人员职业资格证书情况"
        }, {
          dataName: "isTrainCertificate",
          name: "是否持有岗位培训合格证书"
        }],
        301: [{
          dataName: "year",
          name: "年份"
        }, {
          dataName: "publicationName",
          name: "出版物名称"
        }, {
          dataName: "isbn",
          name: "专用书号ISBN"
        }, {
          dataName: "carrierForm",
          name: "载体形式"
        }, {
          dataName: "publicationForm",
          name: "出版形式"
        }, {
          dataName: "productionUnit",
          name: "节目来源/制作单位"
        }, {
          dataName: "programCapacity",
          name: "节目时长或容量(分钟/兆)"
        }, {
          dataName: "publicationQuantity",
          name: "出版数量(张/盒)"
        }, {
          dataName: "issueQuantity",
          name: "发行数量(张/盒)"
        }, {
          dataName: "unitPrice",
          name: "发行单价(元)"
        }, {
          dataName: "publishingTime",
          name: "出版时间"
        }, {
          dataName: "sampleDelivery",
          name: "是否缴送样本"
        }, {
          dataName: "sign",
          name: "是否书配盘标记"
        }],

        401: [{
          dataName: "materialCode",
          name: "导入编码"
        }, {
          dataName: "publication",
          name: "出版物名称"
        }, {
          dataName: "publicationEnglish",
          name: "出版物外文名称"
        }, {
          dataName: "category",
          name: "类别"
        }, {
          dataName: "recordType",
          name: "文种"
        }, {
          dataName: "periodicals",
          name: "刊期"
        }, {
          dataName: "cn",
          name: "刊号（CN）"
        }, {
          dataName: "issn",
          name: "国际刊号（ISSN）"
        }, {
          dataName: "approvalTime",
          name: "批准时间"
        }, {
          dataName: "mediaForm",
          name: "媒体形态"
        }, {
          dataName: "mediaFormQT",
          name: "媒体形态其他"
        }, {
          dataName: "issueQuantity",
          name: "发行数量(套)"
        }, {
          dataName: "unitPrice",
          name: "发行单价(元)"
        }, {
          dataName: "isSampleDelivery",
          name: "是否缴送样本"
        }, {
          dataName: "publicationScope",
          name: "出版范围"
        }, {
          dataName: "issueScope",
          name: "发行范围"
        }, {
          dataName: "readers",
          name: "读者对象"
        }],
        404: [{
          dataName: "type",
          name: "岗位类型"
        }, {
          dataName: "fullName",
          name: "姓名"
        }, {
          dataName: "gender",
          name: "性別"
        }, {
          dataName: "idNumber",
          name: "身份证号"
        }, {
          dataName: "job",
          name: "职务"
        }, {
          dataName: "politicalStatus",
          name: "政治面貌"
        }, {
          dataName: "culture",
          name: "文化程度"
        }, {
          dataName: "cellphone",
          name: "手机"
        }, {
          dataName: "major",
          name: "专业"
        }, {
          dataName: "professionalTitleSeries",
          name: "职称系列"
        }, {
          dataName: "titleLevel",
          name: "职称级别"
        }, {
          dataName: "certificateSituation",
          name: "持有出版专业技术人员职业资格证书情况"
        }, {
          dataName: "isTrainCertificate",
          name: "是否持有岗位培训合格证书"
        }]
      }
    };
  },


  computed: {
    compData: function compData() {
      var temps = [];
      for (var i in this.errorList) {
        var tempj = {};
        tempj = this.errorList[i];
        tempj.readCode = "第 " + (parseInt(i) + 1) + " 条错误数据（点击查看）";
        var pattern = /remark/gi;
        /*if(tempj.code == '401' && pattern.test(tempj.errMsg)){
                         tempj.remark = true;
                    }else{
                         tempj.remark = false;
                    }*/
        if (pattern.test(tempj.errMsg)) {
          tempj.remark = tempj.errMsg.split(",")[0].split(":")[1];
        } else {
          tempj.remark = false;
        }
        temps.push(tempj);
      }
      return temps;
    }
  },

  filters: {
    formateData: function formateData(val, val1, code) {
      var es = val.errMsg;
      var cnt = val.content;

      var esTemp = {};
      var cntTemp = JSON.parse(cnt);
      if (es) {
        var arrs = es.split(",");
        for (var i in arrs) {
          if (arrs[i]) {
            esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
          }
        }
      }

      if (esTemp[val1]) {
        return esTemp[val1];
      } else if (cntTemp[val1]) {
        if (val1 == "carrierForm" && cntTemp[val1] == "其他") {
          if (cntTemp["carrierFormQT"]) {
            return cntTemp["carrierFormQT"];
          } else {
            return '请填写"载体形式（其他）"项';
          }
        } else if (val1 == "job" && cntTemp[val1] == "其他") {
          if (cntTemp["professionalOther"]) {
            return cntTemp["professionalOther"];
          } else {
            return '请填写"职务（其他）"项';
          }
        } else {
          return cntTemp[val1];
        }
      }
    }
  },
  methods: {
    handErrors: function handErrors() {
      this.dialogVisible = true;
    },

    lineCtrls: function lineCtrls(row, event, column) {
      this.$refs.exStrees.toggleRowExpansion(row);
      this.thead2 = [];
      var storage = (0, _object.deepCopy)(this.tempHead);
      for (var termp in storage) {
        this.thead2.push(storage[termp]);
      }
    },

    errorRed: function errorRed(val1, val2, val4) {
      var es = val1.errMsg;
      var esTemp = {};

      if (es) {
        var arrs = es.split(",");
        for (var i in arrs) {
          esTemp[arrs[i].split(":")[0]] = arrs[i].split(":")[1];
        }

        if (esTemp["mediaFormQT"]) {
          esTemp["mediaForm"] = true;
        }

        if (esTemp["carrierFormQT"]) {
          esTemp["carrierForm"] = true;
        }

        if (esTemp["professionalOther"]) {
          esTemp["job"] = true;
        }
      }

      return esTemp[val2];
    }
  },
  created: function created() {
    this.tempHead = [];
    var storage = (0, _object.deepCopy)(this.paramsMap[this.pressCode]);
    for (var termp in storage) {
      this.tempHead.push(storage[termp]);
    }
    this.thead2 = this.paramsMap[this.pressCode];
  }
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
     value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
     return: function _return() {
          tabList: '';
     },

     methods: {
          datPrev: function datPrev(idArrs) {
               var promiseArr = [];
               promiseArr.push(new _promise2.default(function (resolve, reject) {
                    (0, _pressRole.tabRead1)({ id: idArrs[0] }).then(function (response) {
                         resolve(response);
                    }).catch(function (error) {
                         reject(error);
                    });
               }));

               promiseArr.push(new _promise2.default(function (resolve, reject) {
                    (0, _pressRole.tabRead2)({ id: idArrs[1] }).then(function (response) {
                         resolve(response);
                    }).catch(function (error) {
                         reject(error);
                    });
               }));

               promiseArr.push(new _promise2.default(function (resolve, reject) {
                    (0, _pressRole.tabRead3)({ id: idArrs[2] }).then(function (response) {
                         resolve(response);
                    }).catch(function (error) {
                         reject(error);
                    });
               }));

               promiseArr.push(new _promise2.default(function (resolve, reject) {
                    (0, _pressRole.tabRead7)({ id: idArrs[3] }).then(function (response) {
                         resolve(response);
                    }).catch(function (error) {
                         reject(error);
                    });
               }));

               _promise2.default.all(promiseArr).then(function (result) {
                    console.log(result);
               });
          }
     },
     created: function created() {
          var _this = this;

          (0, _pressRole.getPressList)({ type: 1 }).then(function (response) {
               var unFormate = response.yearVerificationList;
               var idArr = [];

               function isInside(code) {
                    return code == 201 || code == 202 || code == 203 || code == 207;
               }

               for (var i = 0; i < unFormate.length; i++) {
                    if (isInside(unFormate[i].materialCode)) {
                         idArr.push(unFormate[i].id);
                    }
               }

               _this.datPrev(idArr);
          });
     }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _canvasRotateImage = __webpack_require__(262);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: ['ableSure'],
    name: "uploadCards",
    data: function data() {
        return {
            dialogVisible: false,
            percentage: 0,
            upState: 'wait',
            fileData: {},
            imgUrl: '',
            fileToken: '',
            upUrl: '',
            disabled: false,
            // 图片属性
            img: {
                name: '',
                type: ''
            },
            showSaveBtn: false
        };
    },

    watch: {
        ableSure: function ableSure(dat) {
            this.imgInit(this.ableSure);
        }
    },
    methods: {
        // 左转
        handleLeftRotate: function handleLeftRotate(imageUrl) {
            var that = this;
            that.showSaveBtn = true;
            (0, _canvasRotateImage.rotateImg)(imageUrl, -90, function (base64) {
                that.imgUrl = base64;
            });
        },

        // 右转
        handleRightRotate: function handleRightRotate(imageUrl) {
            var that = this;
            that.showSaveBtn = true;
            (0, _canvasRotateImage.rotateImg)(imageUrl, 90, function (base64) {
                that.imgUrl = base64;
            });
        },

        //手动提交图片
        submitUpload: function submitUpload() {
            // this.$refs.upload.submit();
            var file = (0, _canvasRotateImage.dataURLtoFile)(this.imgUrl, this.img.name);
            var param = new FormData(); //创建form对象
            param.append('file', file); //通过append向form对象添加数据
            param.append('token', (0, _auth.getToken)()); //通过append向form对象添加数据
            console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
            var config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }; //添加请求头
            (0, _pressRole.postImg)({ file: param, config: config }).then(function (res) {
                console.log(res);
            });
            // Request.post(this.upUrl,param,config)
            //     .then(res=>{
            //         console.log(res.data);
            //         // this.imgUrl = res.data.imgUrl;
            //     })
        },

        // 移除图片
        handleRemove: function handleRemove(file, fileList) {
            console.log(file, fileList);
        },

        // 图片预览
        handlePreview: function handlePreview(file) {
            console.log(file);
        },

        // 图片上传前的判断
        prevCtrls: function prevCtrls(file) {
            var nameArr = file.type.split('/');
            var fileType = nameArr[nameArr.length - 1];

            if (fileType != 'jpeg' && fileType != 'png') {
                this.$message({
                    message: '请上传格式为 JPGE 或 PNG 的文件！',
                    type: 'error'
                });
                return false;
            } else if (file.size / 1024 / 1024 > 10) {
                this.$message({
                    message: '文件大小不能超过 10M！',
                    type: 'error'
                });
                return false;
            } else {
                this.percentage = 0;
                this.upState = 'loading';
                this.fileData.token = (0, _auth.getToken)();
                this.fileData.fileSize = file.size;

                return true;
            }
        },
        pgressCtrls: function pgressCtrls(evt, file) {
            this.percentage = parseInt(file.percentage);
            this.img.name = file.name;
            this.img.type = file.raw.type;
        },
        errorCtrls: function errorCtrls(err) {
            this.upState = "wait";
            this.$alert('上传失败，请稍后重试！', '提示', {
                confirmButtonText: '确定',
                type: 'error'
            });
        },
        successCtrls: function successCtrls(data) {
            this.percentage = 100;
            this.ableSure = data.payload.id;
            this.imgInit(data.payload.id);
            this.$emit('upFileId', data.payload.id);
        },
        // successCtrls: function(res) {
        //     this.upState = 'loaded';
        //     // this.imgUrl = res.data.imgUrl;
        //     this.percentage = 100;
        //     this.ableSure = data.payload.id;
        //     this.imgInit(data.payload.id);
        //     this.$emit('upFileId', data.payload.id);
        // },

        imgInit: function imgInit(dat) {
            if (dat) {
                this.upState = 'loaded';
                this.imgUrl = "https://ydnj.capub.cn" + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
            }
        },

        handleExceed: function handleExceed() {}
    },

    created: function created() {
        var _this = this;

        this.upUrl = "https://ydnj.capub.cn" + '/File/File/upload';
        (0, _account.getFileToken)().then(function (response) {
            _this.fileToken = response.resultStatus.token;
            _this.imgInit(_this.ableSure);
        });
    }
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _file = __webpack_require__(149);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["fileID", "btnProps", "pubStatus"],
  data: function data() {
    return {
      percentage: 0,
      upState: "wait",
      stmpState: "wait",
      loadUrl: "",
      fileToken: "",

      postHead: {}
    };
  },

  watch: {
    fileID: function fileID(newDat) {
      if (newDat) {
        this.upState = "loaded";
        this.urlInit(this.response.payload.id);
      }
    },
    pubStatus: function pubStatus(newDat) {
      this.pubStatus = newDat;
    }
  },
  methods: {
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.name.split(".");
      if (nameArr[nameArr.length - 1] != "doc" && nameArr[nameArr.length - 1] != "docx") {
        this.$message({
          message: "请上传 word 格式的文件！",
          type: "error"
        });
        return false;
      } else if (file.size / 1024 / 1024 > 100) {
        this.$message({
          message: "文件大小不能超过 100M！",
          type: "error"
        });
        return false;
      } else {
        this.postHead["Authorization"] = "Bearer " + (0, _auth.getToken)();
        this.upState = "loading";
        return true;
      }
    },
    pgressCtrls: function pgressCtrls(evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function errorCtrls(err) {
      this.upState = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error"
      });
    },
    successCtrls: function successCtrls(response, file) {
      // console.log("successCtrls=",JSON.stringify(response.payload));
      // console.log("file=",JSON.stringify(file));
      if (response.code != 0) {
        this.upState = "wait";
        this.$alert("上传失败，请稍后重试！", "提示", {
          confirmButtonText: "确定",
          type: "error"
        });
      } else {
        // 上传成功之后，需要把数据写入到表中，如果之前有文件信息，需要再删除掉
        this.$emit("zeroTabStore", response.payload.id, this.btnProps);
        this.percentage = 100;
        this.upState = "loaded";
      }
    },
    urlInit: function urlInit(dat) {
      console.log("dat=", dat);
      if (dat) {
        this.upState = "loaded";
        // this.loadUrl = process.env.BASE_API + '/File/File/download/token/' + this.fileToken + '/id/' + dat;
        // console.log("uploadBtn.vue > loadUrl:" + this.loadUrl)
        // if (this.loadUrl == undefined) {
        //   this.loadUrl = ""
        // }
      }
    },
    handleExceed: function handleExceed() {
      this.$message.error("只能选择一个文件");
    },
    filesDown: function filesDown() {
      var _this = this;

      // console.log("filesDown:", this.btnProps);
      if (this.btnProps.id && (this.btnProps.materialCode || this.btnProps.code)) {
        var dataIn = {};
        dataIn.organizationMaterialId = this.btnProps.id;
        // zym.20250610，兼容连续型出版物，需要使用code、name
        dataIn.code = this.btnProps.materialCode || this.btnProps.code;
        dataIn.materialTitle = this.btnProps.materialTitle || this.btnProps.name;
        // console.log("dataIn=", dataIn);
        (0, _file.filesDownloadUploadBtn)(dataIn).then(function (response) {
          // console.log('response=',JSON.stringify(response));
          // roro
          //   response.payload.url = CONST.PATH_TSNJ + response.payload.catalog
          if (response.payload.url) {
            if (_this.type == "img") {
              _this.$emit("openImage", response.payload.url, _this.type);
            } else {
              window.open(response.payload.url);
            }
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    console.log("uploadBtn.vue > loadUrl:" + this.loadUrl);
    this.$refs.upload.$refs["upload-inner"].uploadFiles = function (files) {
      var svm = vm.$refs.upload.$refs["upload-inner"];
      if (svm.limit && svm.fileList.length + files.length > svm.limit) {
        svm.onExceed && svm.onExceed(files, svm.fileList);
        return;
      }
      var postFiles = Array.prototype.slice.call(files);
      if (!svm.multiple) {
        postFiles = postFiles.slice(0, 1);
      }
      if (postFiles.length === 0) {
        return;
      }
      postFiles.forEach(function (rawFile) {
        svm.onStart(rawFile);
        // rawFile.postUrl = process.env.BASE_API + '/File/File/upload';
        rawFile.postUrl = "https://ydnj.capub.cn" + "/eavar/file/upload";
        if (svm.autoUpload) svm.upload(rawFile);
      });
    };

    this.$refs.upload.$refs["upload-inner"].post = function (rawFile) {
      var _this2 = this;

      var uid = rawFile.uid;

      var svm = vm.$refs.upload.$refs["upload-inner"];
      var s = {
        token: (0, _auth.getToken)(),
        // fileToken:rawFile.token,
        fileSize: rawFile.size
      };
      // this.postHead['Authorization'] = `Bearer ${getToken()}`;
      // console.log({Authorization:`Bearer ${getToken()}`})
      // svm.headers = {Authorization:`Bearer ${getToken()}`};
      console.log("svm=", svm);
      var options = {
        headers: svm.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: s,
        filename: svm.name,
        action: rawFile.postUrl || "",
        onProgress: function onProgress(e) {
          svm.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          svm.onSuccess(res, rawFile);
          delete _this2.reqs[uid];
        },
        onError: function onError(err) {
          svm.onError(err, rawFile);
          delete _this2.reqs[uid];
        }
      };

      console.log("options=", (0, _stringify2.default)(options));

      var req = svm.httpRequest(options);
      svm.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    };
  },
  created: function created() {
    // getFileToken().then(response => {
    //   this.fileToken = response.resultStatus.token;
    //   this.urlInit(this.fileID);
    // });
    console.log("fileID=", this.fileID);
    console.log("btnProps=", (0, _stringify2.default)(this.btnProps));
    this.urlInit(this.fileID);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__(46);

var _canvasRotateImage = __webpack_require__(262);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

var _file = __webpack_require__(149);

exports.default = {
  props: ['ableSure', 'needTip'],
  data: function data() {
    return {
      dialogVisible: false,
      percentage: 0,
      upState: 'wait',
      fileData: {},
      imgUrl: '',
      fileToken: '',
      upUrl: '',
      postHead: {},
      disabled: false
    };
  },

  watch: {
    ableSure: function ableSure(dat) {
      this.imgInit(this.ableSure);
    }
  },
  methods: {
    // 左转
    handleLeftRotate: function handleLeftRotate(imgUrl) {
      var that = this;
      if (imgUrl.toString().startsWith("http")) {
        (0, _canvasRotateImage.rotateImg)(imgUrl, -90, function (base64) {
          that.imgUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        (0, _canvasRotateImage.rotateImgBase64)(imgUrl, -90, function (base64) {
          that.imgUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }
    },

    // 右转
    handleRightRotate: function handleRightRotate(imgUrl) {
      var that = this;
      if (imgUrl.toString().startsWith("http")) {
        (0, _canvasRotateImage.rotateImg)(imgUrl, 90, function (base64) {
          that.imgUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        (0, _canvasRotateImage.rotateImgBase64)(imgUrl, 90, function (base64) {
          that.imgUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }
    },

    //手动提交图片
    submitUpload: function submitUpload() {
      // this.$refs.upload.submit();
      if (!this.imgUrl.toString().startsWith("http")) {
        (0, _file.uploadBase64)({ ableSure: this.ableSure, base64: this.imgUrl });
      }
    },

    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    // 图片预览
    handlePreview: function handlePreview(file) {
      console.log(file);
    },

    // 图片上传前的判断
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.type.split('/');
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        });
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        });
        return false;
      } else {
        this.percentage = 0;
        this.upState = 'loading';
        this.postHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;
      }
    },
    pgressCtrls: function pgressCtrls(evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function errorCtrls(err) {
      this.upState = "wait";
      this.$alert('上传失败，请稍后重试！', '提示', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    successCtrls: function successCtrls(data) {
      console.log(data);
      if (data.code && data.code != 0) {
        this.upState = "wait";
        this.$alert('\u4E0A\u4F20\u5931\u8D25.     ' + (data.message || data.error), '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
        return;
      }
      this.percentage = 100;
      // this.ableSure = data.payload.id;
      this.imgInit(data.payload.id);
      this.$emit('upFileId', data.payload.id);
    },

    imgInit: function imgInit(dat) {
      var _this = this;

      if (dat) {
        this.upState = 'loaded';
        // this.imgUrl = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
        (0, _pressRole.getPfileUrl)({
          id: dat
        }).then(function (response) {
          _this.imgUrl = response.payload.url + "?" + new Date().getTime();
        });
      }
    },

    handleExceed: function handleExceed() {}
  },

  created: function created() {
    var _this2 = this;

    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = "https://ydnj.capub.cn" + '/eavar/file/upload';
    (0, _account.getFileToken)().then(function (response) {
      _this2.fileToken = response.resultStatus.token;
      _this2.imgInit(_this2.ableSure);
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _file = __webpack_require__(149);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['fileID', 'btnProps'],
  data: function data() {
    return {
      percentage: 0,
      upState: 'wait',
      stmpState: 'wait',
      loadUrl: '',
      downUrl: '',
      fileToken: '',

      postHead: {}
    };
  },

  watch: {
    fileID: function fileID(newDat) {
      if (newDat) {
        this.upState = "loaded";
        this.urlInit(newDat);
      }
    }
  },
  methods: {
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.name.split('.');
      if (nameArr[nameArr.length - 1] != 'pdf' && nameArr[nameArr.length - 1] != 'PDF') {
        this.$message({
          message: '请上传 pdf 格式的文件！',
          type: 'error'
        });
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        });
        return false;
      } else {

        this.postHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
        this.upState = 'loading';
        return true;
      }
    },
    pgressCtrls: function pgressCtrls(evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function errorCtrls(err) {
      this.upState = "wait";
      this.$alert('上传失败，请稍后重试！', '提示', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    successCtrls: function successCtrls(response, file) {
      // console.log("successCtrls=",JSON.stringify(response.payload));
      // console.log("file=",JSON.stringify(file));
      if (response.code != 0) {
        this.upState = "wait";
        this.$alert('上传失败，请稍后重试！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      } else {
        this.fileID = response.payload.id;
        // console.log('this.fileID=',this.fileID)
        this.urlInit(this.fileID);
        // 上传成功之后，需要把数据写入到表中，如果之前有文件信息，需要再删除掉
        this.$emit('upFileId', response.payload.id, this.btnProps);
        this.percentage = 100;
        this.upState = "loaded";
      }
    },
    urlInit: function urlInit(dat) {
      var _this = this;

      if (dat) {
        this.upState = 'loaded';
        // this.loadUrl = process.env.BASE_API + '/File/File/download/token/' + this.fileToken + '/id/' + dat;
        // console.log("uploadBtn.vue > loadUrl:" + this.loadUrl)
        // if (this.loadUrl == undefined) {
        //   this.loadUrl = ""
        // }

        (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
          var url = response.payload.url;
          console.log('url=', url);

          _this.downUrl = url; // window.open(url);
        });
      }
    },
    handleExceed: function handleExceed() {
      this.$message.error('只能选择一个文件');
    },
    filesDown: function filesDown() {
      if (!this.downUrl) {
        this.$message.error('未找到下载地址');
        return;
      }

      window.open(this.downUrl);
    }
  },
  mounted: function mounted() {
    var vm = this;
    // console.log("uploadBtn.vue > loadUrl:" + this.loadUrl)
    this.$refs.upload.$refs['upload-inner'].uploadFiles = function (files) {
      var svm = vm.$refs.upload.$refs['upload-inner'];
      if (svm.limit && svm.fileList.length + files.length > svm.limit) {
        svm.onExceed && svm.onExceed(files, svm.fileList);
        return;
      }
      var postFiles = Array.prototype.slice.call(files);
      if (!svm.multiple) {
        postFiles = postFiles.slice(0, 1);
      }
      if (postFiles.length === 0) {
        return;
      }
      postFiles.forEach(function (rawFile) {
        svm.onStart(rawFile);
        // rawFile.postUrl = process.env.BASE_API + '/File/File/upload';
        rawFile.postUrl = "https://ydnj.capub.cn" + '/eavar/file/upload';
        if (svm.autoUpload) svm.upload(rawFile);
      });
    };

    this.$refs.upload.$refs['upload-inner'].post = function (rawFile) {
      var _this2 = this;

      var uid = rawFile.uid;

      var svm = vm.$refs.upload.$refs['upload-inner'];
      var s = {
        token: (0, _auth.getToken)(),
        // fileToken:rawFile.token,
        fileSize: rawFile.size
      };
      // this.postHead['Authorization'] = `Bearer ${getToken()}`;
      // console.log({Authorization:`Bearer ${getToken()}`})
      // svm.headers = {Authorization:`Bearer ${getToken()}`};
      // console.log('svm=', svm);
      var options = {
        headers: svm.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: s,
        filename: svm.name,
        action: rawFile.postUrl || "",
        onProgress: function onProgress(e) {
          svm.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          svm.onSuccess(res, rawFile);
          delete _this2.reqs[uid];
        },
        onError: function onError(err) {
          svm.onError(err, rawFile);
          delete _this2.reqs[uid];
        }
      };

      // console.log("options=", JSON.stringify(options));

      var req = svm.httpRequest(options);
      svm.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    };
  },
  created: function created() {
    // getFileToken().then(response => {
    //   this.fileToken = response.resultStatus.token;
    //   this.urlInit(this.fileID);
    // });
    console.log('fileID=', this.fileID);
    console.log('btnProps=', (0, _stringify2.default)(this.btnProps));
    this.urlInit(this.fileID);
  }
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['ableSure', "limit", "viewType"],
  data: function data() {
    return {
      fileData: {},
      imgUrl: '',
      fileToken: '',
      upUrl: '',
      postHead: {},
      dialogVisible: false,
      dialogImageUrl: '',
      imgfiles: [],
      imgIds: [],
      imgmap: {},
      imgNum: 1,

      ableSet: false,
      isAct: ''
    };
  },

  watch: {
    ableSure: function ableSure(dat) {
      var _this = this;

      console.log("watch ableSure", dat);
      this.imgmap = {};
      this.imgfiles = [];
      this.imgIds = [];
      if (this.ableSure) {
        if (!this.fileToken) {
          (0, _account.getFileToken)().then(function (response) {
            _this.fileToken = response.resultStatus.token;
            var arr = _this.ableSure.split(',');
            if (arr.length > 0) {
              for (var index in arr) {
                _this.imgInit(arr[index]);
              }
            }
          });
        } else {
          var arr = this.ableSure.split(',');
          if (arr.length > 0) {
            for (var index in arr) {
              this.imgInit(arr[index]);
            }
          }
        }
        // console.log(dat);
      }
    }
  },
  methods: {
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.type.split('/');
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        });
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        });
        return false;
      } else {
        this.postHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;
      }
    },
    successCtrls: function successCtrls(data) {
      var _this2 = this;

      // console.log('我上传成功了,data=',JSON.stringify(data));
      // this.imgIds.push(data.payload.id);

      var dat = data.payload.id;
      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        console.log('url=', url);
        var file = {
          id: dat,
          name: dat + '.jpeg',
          url: url
        };
        _this2.imgmap[dat] = file;
        _this2.imgfiles.push(file);
        _this2.imgIds.push(dat);

        console.log('successCtrls=', (0, _stringify2.default)(_this2.imgIds));

        console.log('this.imgIds.join()=', _this2.imgIds.join());
        _this2.$emit('upFileId', _this2.imgIds.join());
      });
    },

    imgInit: function imgInit(dat) {
      var _this3 = this;

      if (dat) {
        if (!this.imgmap[dat]) {
          console.log('dat=', (0, _stringify2.default)(dat));
          var url;
          (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
            url = response.payload.url;
            console.log('url=', url);
            // var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
            var file = {
              id: dat,
              name: dat + '.jpeg',
              url: url
            };
            _this3.imgmap[dat] = file;
            _this3.imgfiles.push(file);
            _this3.imgIds.push(dat);
          });
        }
      }
      console.log("imgInit", this.imgfiles);
    },

    handleExceed: function handleExceed(files, fileList) {
      // var num = 1;
      // if(this.limit){
      //     this.imgNum=this.limit;
      // }
      //
      // console.log(fileList,files,this.imgNum);
      //
      // if(fileList.length+files.length>this.imgNum){
      //     this.$message({
      //       message: "最多只能上传"+this.imgNum+"个文件!",
      //       type: 'error'
      //     });
      // }
      this.$message({
        message: "最多只能上传" + this.imgNum + "个文件!",
        type: 'error'
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList) {
      for (var index in this.imgIds) {
        console.log(file.id, ' ', this.imgIds[index]);
        if (this.imgIds[index] == file.id) {
          console.log('我是相同的，为啥删除不了呢？');
          this.imgIds.splice(index, 1);
        }
      }

      console.log('this.imgIds=', (0, _stringify2.default)(this.imgIds));

      this.$emit('upFileId', this.imgIds.join());
    }
  },

  created: function created() {
    var _this4 = this;

    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = "https://ydnj.capub.cn" + '/eavar/file/upload';
    if (this.limit) {
      this.imgNum = this.limit;
    }
    if (this.viewType == 2) {
      this.ableSet = true;
      this.isAct = 'addHide';
    }
    console.log("created ableSure=", this.ableSure);
    if (!this.fileToken) {
      (0, _account.getFileToken)().then(function (response) {
        _this4.fileToken = response.resultStatus.token;

        if (_this4.ableSure) {

          var arr = _this4.ableSure.split(',');
          if (arr.length > 0) {
            for (var index in arr) {
              _this4.imgInit(arr[index]);
            }
          }
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _auth = __webpack_require__(46);

var _canvasRotateImage = __webpack_require__(262);

var _file = __webpack_require__(149);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['btnProps', 'ableSure', "limit", "viewType"],
  data: function data() {
    return {
      fileData: {},
      // dialogImageUrl: '',
      fileToken: '',
      upUrl: '',
      postHead: {},
      dialogVisible: false,
      dialogImageUrl: '',
      imgfiles: [],
      imgIds: [],
      imgmap: {},
      imgNum: 1,

      ableSet: false,
      isAct: ''
    };
  },

  watch: {
    imgIds: {
      handler: function handler(newValue, oldValue) {
        if (this.viewType == 2 || newValue && newValue.length >= 1) {
          // this.ableSet = true;
          this.isAct = 'addHide';
        } else {
          console.log('重新设置了');
          this.ableSet = false;
          this.isAct = '';
        }
        // for (let i = 0; i < newValue.length; i++) {
        //   if (oldValue[i] != newValue[i]) {
        //     console.log(newValue)
        //   }
        // }
      },

      deep: true
    },
    ableSure: function ableSure(dat) {
      this.initAbleSure(dat);
      //     console.log("watch ableSure",dat);
      //     this.imgmap = {};
      //     this.imgfiles = [];
      //     this.imgIds = [];
      //     if(this.ableSure){

      //       if(!this.fileToken){
      //         getFileToken().then(response => {
      //             this.fileToken = response.resultStatus.token;
      //             var arr = this.ableSure.split(',');
      //             if(arr.length>0){
      //                 for(var index in arr){
      //                     this.imgInit(arr[index]);
      //                 }
      //             }
      //         })
      //       }else{
      //         var arr = this.ableSure.split(',');
      //         if(arr.length>0){
      //             for(var index in arr){
      //                 this.imgInit(arr[index]);
      //             }
      //         }
      //       }
      //     }
    }
  },
  methods: {
    // 左转
    handleLeftRotate: function handleLeftRotate(dialogImageUrl) {
      console.log('测试');
      var that = this;
      if (dialogImageUrl.toString().startsWith("http")) {
        (0, _canvasRotateImage.rotateImg)(dialogImageUrl, -90, function (base64) {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        (0, _canvasRotateImage.rotateImgBase64)(dialogImageUrl, -90, function (base64) {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }
    },

    // 右转
    handleRightRotate: function handleRightRotate(dialogImageUrl) {
      var that = this;
      if (dialogImageUrl.toString().startsWith("http")) {
        (0, _canvasRotateImage.rotateImg)(dialogImageUrl, 90, function (base64) {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      } else {
        (0, _canvasRotateImage.rotateImgBase64)(dialogImageUrl, 90, function (base64) {
          that.dialogImageUrl = base64;
          // 保存旋转效果
          that.submitUpload();
        });
      }
    },

    //手动提交图片
    submitUpload: function submitUpload() {
      // this.$refs.upload.submit();
      // this.ableSure = "";
      var that = this;
      if (!this.dialogImageUrl.toString().startsWith("http")) {
        (0, _file.uploadBase64)({ ableSure: this.ableSure, base64: this.dialogImageUrl });
        // this.ableSure = this.props.ableSure;
        this.initAbleSure(this.ableSure);
        // that.$forceUpdate();
      }
    },

    initAbleSure: function initAbleSure(dat) {
      var _this = this;

      console.log("watch ableSure", dat);
      this.imgmap = {};
      this.imgfiles = [];
      this.imgIds = [];
      if (this.ableSure) {

        if (!this.fileToken) {
          (0, _account.getFileToken)().then(function (response) {
            _this.fileToken = response.resultStatus.token;
            var arr = _this.ableSure.split(',');
            if (arr.length > 0) {
              for (var index in arr) {
                _this.imgInit(arr[index]);
              }
            }
          });
        } else {
          var arr = this.ableSure.split(',');
          if (arr.length > 0) {
            for (var index in arr) {
              this.imgInit(arr[index]);
            }
          }
        }
        // console.log(dat);
      }
    },
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.type.split('/');
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        });
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        });
        return false;
      } else {
        this.postHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;
      }
    },
    successCtrls: function successCtrls(data) {
      var _this2 = this;

      // console.log('我上传成功了,data=',JSON.stringify(data));
      // this.imgIds.push(data.payload.id);

      var dat = data.payload.id;

      // if(dat){
      //     this.ableSet = true;
      //     this.isAct = 'addHide';
      // }

      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        console.log('url=', url);
        var file = {
          id: dat,
          name: dat + '.jpeg',
          url: url + "?" + new Date().getTime()
        };
        _this2.imgmap[dat] = file;
        _this2.imgfiles = [file];
        _this2.imgIds = [dat];

        console.log('successCtrls=', (0, _stringify2.default)(_this2.imgIds));

        console.log('this.imgIds.join()=', _this2.imgIds.join());
        _this2.$emit('upFileId', _this2.imgIds.join(), _this2.btnProps);
      });
    },

    imgInit: function imgInit(dat) {
      var _this3 = this;

      if (dat) {
        if (!this.imgmap[dat]) {
          console.log('dat=', (0, _stringify2.default)(dat));
          var url;
          (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
            url = response.payload.url;
            console.log('url=', url);
            // var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
            var file = {
              id: dat,
              name: dat + '.jpeg',
              url: url + '?tamp=' + new Date().valueOf()
            };
            _this3.imgmap[dat] = file;
            _this3.imgfiles.push(file);
            _this3.imgIds.push(dat);
          });
        }
      }
      console.log("imgInit", this.imgfiles);
    },

    handleExceed: function handleExceed(files, fileList) {
      // var num = 1;
      // if(this.limit){
      //     this.imgNum=this.limit;
      // }
      //
      // console.log(fileList,files,this.imgNum);
      //
      // if(fileList.length+files.length>this.imgNum){
      //     this.$message({
      //       message: "最多只能上传"+this.imgNum+"个文件!",
      //       type: 'error'
      //     });
      // }
      this.$message({
        message: "最多只能上传" + this.imgNum + "个文件!",
        type: 'error'
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url + "?" + new Date().getTime();
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList) {
      for (var index in this.imgIds) {
        console.log(file.id, ' ', this.imgIds[index]);
        if (this.imgIds[index] == file.id) {
          console.log('我是相同的，为啥删除不了呢？');
          this.imgIds.splice(index, 1);
        }
      }

      console.log('this.imgIds=', (0, _stringify2.default)(this.imgIds));

      this.$emit('upFileId', this.imgIds.join(), this.btnProps);
    }
  },

  created: function created() {
    // console.log('viewType=',this.viewType)
    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = "https://ydnj.capub.cn" + '/eavar/file/upload';
    if (this.limit) {
      this.imgNum = this.limit;
    }
    var arr = this.ableSure.split(',');
    console.log('arr=', (0, _stringify2.default)(arr));
    if (this.viewType == 2 || this.ableSure && arr && arr.length != 0 && arr.length >= this.imgNum) {
      this.ableSet = true;
      this.isAct = 'addHide';
    }

    // console.log('this.ableSure=',this.ableSure.ableSure);
    // this.initAbleSure(this.ableSure);

    // console.log("created ableSure=",this.ableSure);
    // if(!this.fileToken){
    //     getFileToken().then(response => {
    //         this.fileToken = response.resultStatus.token;

    //         if(this.ableSure){

    //           this.initAbleSure(this.ableSure);

    //           // var arr = this.ableSure.split(',');
    //           // if(arr.length>0){
    //           //     for(var index in arr){
    //           //         this.imgInit(arr[index]);
    //           //     }
    //           // }
    //         }

    //     })
    // }

  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['btnProps', 'ableSure', "limit", "viewType"],
  data: function data() {
    return {
      fileData: {},
      imgUrl: '',
      fileToken: '',
      upUrl: '',
      postHead: {},
      dialogVisible: false,
      dialogImageUrl: '',
      imgfiles: [],
      imgIds: [],
      imgmap: {},
      imgNum: 1,

      ableSet: false,
      isAct: ''
    };
  },

  watch: {
    imgIds: {
      handler: function handler(newValue, oldValue) {
        if (this.viewType == 2 || newValue && newValue.length >= 1) {
          // this.ableSet = true;
          this.isAct = 'addHide';
        } else {
          console.log('重新设置了');
          this.ableSet = false;
          this.isAct = '';
        }
        // for (let i = 0; i < newValue.length; i++) {
        //   if (oldValue[i] != newValue[i]) {
        //     console.log(newValue)
        //   }
        // }
      },

      deep: true
    },
    ableSure: function ableSure(dat) {
      this.initAbleSure(dat);
    }
  },
  methods: {
    initAbleSure: function initAbleSure(dat) {
      var _this = this;

      console.log("watch ableSure", dat);
      this.imgmap = {};
      this.imgfiles = [];
      this.imgIds = [];
      if (this.ableSure) {

        if (!this.fileToken) {
          (0, _account.getFileToken)().then(function (response) {
            _this.fileToken = response.resultStatus.token;
            var arr = _this.ableSure.split(',');
            if (arr.length > 0) {
              for (var index in arr) {
                _this.imgInit(arr[index]);
              }
            }
          });
        } else {
          var arr = this.ableSure.split(',');
          if (arr.length > 0) {
            for (var index in arr) {
              this.imgInit(arr[index]);
            }
          }
        }
        // console.log(dat);
      }
    },
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.type.split('/');
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != 'jpeg' && fileType != 'png') {
        this.$message({
          message: '请上传格式为 JPGE 或 PNG 的文件！',
          type: 'error'
        });
        return false;
      } else if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: '文件大小不能超过 10M！',
          type: 'error'
        });
        return false;
      } else {
        this.postHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        return true;
      }
    },
    successCtrls: function successCtrls(data) {
      var _this2 = this;

      // console.log('我上传成功了,data=',JSON.stringify(data));
      // this.imgIds.push(data.payload.id);

      var dat = data.payload.id;

      // if(dat){
      //     this.ableSet = true;
      //     this.isAct = 'addHide';
      // }

      (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
        var url = response.payload.url;
        console.log('url=', url);
        var file = {
          id: dat,
          name: dat + '.jpeg',
          url: url
        };
        _this2.imgmap[dat] = file;
        _this2.imgfiles = [file];
        _this2.imgIds = [dat];

        console.log('successCtrls=', (0, _stringify2.default)(_this2.imgIds));

        console.log('this.imgIds.join()=', _this2.imgIds.join());
        _this2.$emit('upFileId', _this2.imgIds.join(), _this2.btnProps);
      });
    },

    imgInit: function imgInit(dat) {
      var _this3 = this;

      if (dat) {
        if (!this.imgmap[dat]) {
          console.log('dat=', (0, _stringify2.default)(dat));
          var url;
          (0, _pressRole.getPfileUrl)({ id: dat }).then(function (response) {
            url = response.payload.url;
            console.log('url=', url);
            // var url = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
            var file = {
              id: dat,
              name: dat + '.jpeg',
              url: url
            };
            _this3.imgmap[dat] = file;
            _this3.imgfiles.push(file);
            _this3.imgIds.push(dat);
          });
        }
      }
      console.log("imgInit", this.imgfiles);
    },

    handleExceed: function handleExceed(files, fileList) {
      // var num = 1;
      // if(this.limit){
      //     this.imgNum=this.limit;
      // }
      //
      // console.log(fileList,files,this.imgNum);
      //
      // if(fileList.length+files.length>this.imgNum){
      //     this.$message({
      //       message: "最多只能上传"+this.imgNum+"个文件!",
      //       type: 'error'
      //     });
      // }
      this.$message({
        message: "最多只能上传" + this.imgNum + "个文件!",
        type: 'error'
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file, fileList) {
      for (var index in this.imgIds) {
        console.log(file.id, ' ', this.imgIds[index]);
        if (this.imgIds[index] == file.id) {
          console.log('我是相同的，为啥删除不了呢？');
          this.imgIds.splice(index, 1);
        }
      }

      console.log('this.imgIds=', (0, _stringify2.default)(this.imgIds));

      this.$emit('upFileId', this.imgIds.join(), this.btnProps);
    }
  },

  created: function created() {
    // console.log('viewType=',this.viewType)
    // this.upUrl = process.env.BASE_API + '/File/File/upload';
    this.upUrl = "https://ydnj.capub.cn" + '/eavar/file/upload';
    if (this.limit) {
      this.imgNum = this.limit;
    }
    var arr = this.ableSure.split(',');

    this.initAbleSure("");
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _login = __webpack_require__(261);

var _vuex = __webpack_require__(126);

var _hide_dark = __webpack_require__(1540);

var _hide_dark2 = _interopRequireDefault(_hide_dark);

var _show_dark = __webpack_require__(1542);

var _show_dark2 = _interopRequireDefault(_show_dark);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["forcePass"],
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),
  data: function data() {
    var _this = this;

    var strongPassword = /(?=^.{8,30})(?=^.*?\d)(?=^.*?[a-z])(?=^.*?[A-Z])(?=^.*?[~!@#$%^&*()_\-+|<>,.?/:;'\[\]\\{}\"])/g;
    var passCode1 = function passCode1(rule, val, callback) {
      // 邮编验证
      if (val == "") {
        callback(new Error("请输入原始密码！"));
      } else {
        callback();
      }
    };

    var passCode2 = function passCode2(rule, val, callback) {
      // 新密码检测
      var pattern = strongPassword;
      if (val == "") {
        callback(new Error("请输入新密码！"));
      } else if (val == _this.ruleForm.oldPwd) {
        callback(new Error("新密码不能和旧密码相同！"));
      } else {
        var sure = strongPassword.test(val);
        if (sure) {
          callback();
        } else {
          callback(new Error("密码必须为8-30位，大小写字母及数字及特殊字符组合！"));
        }
      }
    };

    var passCode3 = function passCode3(rule, val, callback) {
      // 重复输入检查
      if (_this.ruleForm.newPwd == "") {
        callback(new Error("请先输入新密码！"));
      } else if (_this.ruleForm.newPwd != val) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      submiting: false,
      ruleForm: {
        oldPwd: "",
        newPwd: "",
        sureCode: ""
      },
      rules: {
        oldPwd: [{
          validator: passCode1,
          trigger: "blur"
        }],
        newPwd: [{
          validator: passCode2,
          trigger: "blur"
        }],
        sureCode: [{
          validator: passCode3,
          trigger: "blur"
        }]
      },

      pwdtype: "password",
      pwd_hide: _hide_dark2.default,
      pwd_show: _show_dark2.default
    };
  },

  methods: {
    submitForm: function submitForm(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.submiting = true;
          _this2.ruleForm.userId = _this2.userInfo.userId;
          (0, _login.passCodeSet)(_this2.ruleForm).then(function (response) {
            _this2.submiting = false;
            var code = response.payload.tipcode;
            var message = response.payload.tipmsg;
            if (code == "success") {
              _this2.$alert(message, "成功", {
                confirmButtonText: "确定",
                type: "success",
                callback: function callback(action) {
                  _this2.$emit("go-frash");
                }
              });
            } else {
              _this2.$alert(message, "错误", {
                confirmButtonText: "确定",
                type: "error"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    showPwd: function showPwd() {
      if (this.pwdtype == "password") {
        this.pwdtype = "text";
      } else {
        this.pwdtype = "password";
      }
    }
  }
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _welcome = __webpack_require__(1538);

var _welcome2 = _interopRequireDefault(_welcome);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { ExcelErrors } from '@/api/pressAsk';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "dashboard",
  data: function data() {
    return {
      img_welcome: _welcome2.default,
      list: [],
      downloadLoading: false,
      tableData: [],
      userInfo: {}
    };
  },

  methods: {
    getProvinceList: function getProvinceList() {
      var _this = this;

      (0, _provinceRole.provinceStatistics)().then(function (response) {
        // console.log('response=',JSON.stringify(response));
        _this.tableData = response.provinceStatisticsList;
        _this.userInfo = response.userInfo;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_this.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.type == 1) {
              item.type = "音像";
            } else if (item.type == 2) {
              item.type = "电子";
            } else if (item.type == 3) {
              item.type = "连续电子";
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    //
    handTopage: function handTopage(type, key) {
      if (type == "音像") {
        this.$router.push({ path: "/province_role/audio_exam?key=" + key });
      } else if (type == "电子") {
        this.$router.push({ path: "/province_role/elect_exam?key=" + key });
      } else if (type == "连续电子") {
        this.$router.push({ path: "/province_role/successive_exam?key=" + key });
      }
    }
  },
  created: function created() {
    // this.init();
    this.getProvinceList();
  }
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//

exports.default = {
    name: 'AppMain',
    data: function data() {
        return {
            frashKey: true
        };
    },

    computed: {
        key: function key() {
            return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();
        }
    },

    methods: {
        goFrash: function goFrash() {
            var _this = this;

            this.frashKey = false;
            this.$nextTick(function () {
                _this.frashKey = true;
            });
        }
    }
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = __webpack_require__(821);

exports.default = {
  name: 'layout',
  components: {
    Navbar: _layout.Navbar,
    Sidebar: _layout.Sidebar,
    AppMain: _layout.AppMain
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  created: function created() {
    this.getBreadcrumb();
  },
  data: function data() {
    return {
      levelList: null
    };
  },

  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== '首页' || first.path !== '')) {
        matched = [{ name: '首页', path: '/' }].concat(matched);
      }
      this.levelList = matched;
    }
  },
  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  }
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(126);

var _Levelbar = __webpack_require__(345);

var _Levelbar2 = _interopRequireDefault(_Levelbar);

var _TabsView = __webpack_require__(639);

var _TabsView2 = _interopRequireDefault(_TabsView);

var _main = __webpack_require__(1537);

var _main2 = _interopRequireDefault(_main);

var _Hamburger = __webpack_require__(1572);

var _Hamburger2 = _interopRequireDefault(_Hamburger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Levelbar: _Levelbar2.default,
    Hamburger: _Hamburger2.default,
    TabsView: _TabsView2.default
  },
  data: function data() {
    return {
      img_main: _main2.default,
      downloadUrl: "",
      tzUrl: ""
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["sidebar", "avatar", "userInfo"])),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout: function logout() {
      this.$store.dispatch("LogOut").then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  },
  created: function created() {
    var roles = this.$store.getters.roles;
    var roleType = "";
    for (var i = 0; i < roles.length; i++) {
      if (roles[i]["key"] == "audio_press" || roles[i]["key"] == "elect_press") {
        roleType = 1;
        break;
      } else if (roles[i]["key"] == "successive_press") {
        roleType = 2;
        break;
      }
    }
    if (roleType == 1) {
      //   this.downloadUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=0031&token=' + encodeURIComponent(this.$store.getters.token);
      // this.downloadUrl = process.env.URL_FILE + "/drmb/czsm_cbdw_yxdz.docx";
      this.downloadUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/%E5%87%BA%E7%89%88%E5%8D%95%E4%BD%8D%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C.docx";
    } else if (roleType == 2) {
      //   this.downloadUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=0032&token=' + encodeURIComponent(this.$store.getters.token);
      this.downloadUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/czsm_cbdw_lxdz.docx";
    }

    // this.tzUrl = process.env.BASE_API + '/Uploads/tz/tz.pdf';
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(126);

var _SidebarItem = __webpack_require__(638);

var _SidebarItem2 = _interopRequireDefault(_SidebarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//

exports.default = {
  components: { SidebarItem: _SidebarItem2.default },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['permission_routers'])),
  data: function data() {
    return {
      defaultOpeneds: []
    };
  },

  created: function created() {
    var arr = [];
    this.permission_routers.forEach(function (item, index) {
      if (!item.hidden) {
        arr.push(item);
      }
    });

    this.defaultOpeneds.push(arr[0].key);
  }
};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array
        }
    },
    methods: {
        bgSet: function bgSet(key) {
            var bgMap = {
                'audio_exam': '#F2F6FC',
                'elect_exam': '#F2F6FC',
                'successive_exam': '#F2F6FC',
                'province_report': '#F2F6FC',
                'ss_report': '#F2F6FC',
                'audio_register': '#F2F6FC',
                'elect_register': '#F2F6FC',
                'ss_regist': '#F2F6FC'
            };

            // if(key == 'audio_exam'){
            //     return 'border-top:1px solid #e8e8e8;';
            // }else if(bgMap[key]){
            //     return 'border-bottom:1px solid #e8e8e8;';
            // }

            // return 'background:' + bgMap[key] + "!important;";


            // console.log(term);
        }
    },

    created: function created() {}
};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    visitedViews: function visitedViews() {
      return this.$store.state.app.visitedViews.slice(-6);
    }
  },
  methods: {
    closeViewTabs: function closeViewTabs(view, $event) {
      this.$store.dispatch('delVisitedViews', view);
      $event.preventDefault();
    },
    generateRoute: function generateRoute() {

      return this.$route;
      //      if (this.$route.matched[this.$route.matched.length - 1].name) {
      //        return this.$route.matched[this.$route.matched.length - 1]
      //      }
      //      this.$route.matched[0].path = '/'
      //      return this.$route.matched[0]
    },
    addViewTabs: function addViewTabs() {
      this.$store.dispatch('addVisitedViews', this.generateRoute());
    },
    isActive: function isActive(path) {

      return path === this.$route.path;
    }
  },
  watch: {
    $route: function $route() {
      this.addViewTabs();
    }
  }
};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validate = __webpack_require__(820);

var _auth = __webpack_require__(46);

var _uuid = __webpack_require__(819);

var _hide = __webpack_require__(1539);

var _hide2 = _interopRequireDefault(_hide);

var _show = __webpack_require__(1541);

var _show2 = _interopRequireDefault(_show);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "login",
  data: function data() {
    var validateMobilePhone = function validateMobilePhone(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error("密码不能小于8位"));
      } else {
        callback();
      }
    };

    return {
      imgUrl: "",
      loginForm: {
        account: "",
        pwd: "",
        imgCode: ""
      },
      loginRules: {
        account: [{ required: true, trigger: "blur", validator: validateMobilePhone }],
        pwd: [{ required: true, trigger: "blur", validator: validatePass }],
        imgCode: [{ required: true, trigger: "blur", message: "验证码不能为空" }]
      },
      loading: false,
      pwd_hide: _hide2.default,
      pwd_show: _show2.default,
      imgPwd: _show2.default,
      typePwd: "password",
      imgPwdShow: true
    };
  },

  computed: {
    isShowChromeTip: function isShowChromeTip() {
      var browser = this.checkBrowser();
      var flag = false;
      if (browser != "Chrome") {
        flag = true;
      }
      // console.log(browser);
      return flag;
    }
  },
  methods: {
    handleLogin: function handleLogin() {
      var _this = this;

      // console.warn('handleLogin');
      if (!this.isShowChromeTip) {
        this.loading = true;
        this.$store.dispatch("Login", this.loginForm).then(function (state) {
          // console.warn('dispatch(Login: ', state)
          _this.loading = false;
          if (state == 2) {
            _this.$router.push({ path: "/paddSet" });
          } else if (state == 1) {
            _this.$router.push({ path: "/" });
          }
        }).catch(function () {
          _this.loading = false;
          _this.imgChange();
        });
      } else {
        this.$message.error("请使用360浏览器极速模式，或谷歌浏览器打开！");
      }
    },
    showPwd: function showPwd() {
      if (this.typePwd === "password") {
        this.typePwd = "text";
        this.imgPwd = _hide2.default;
      } else {
        this.typePwd = "password";
        this.imgPwd = _show2.default;
      }
    },


    imgChange: function imgChange() {
      var newTime = Date.parse(new Date());
      // this.imgUrl = process.env.BASE_API + "/User/User/getVerifyImg?t=" + uuid() + newTime;
      this.imgUrl = "https://ydnj.capub.cn" + "/auth/getVerifyImg?t=" + (0, _uuid.uuid)() + newTime;
    },

    checkBrowser: function checkBrowser() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) {
        return "Opera";
      } //判断是否Opera浏览器
      if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
      } //判断是否Firefox浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
      }
      if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
      } //判断是否Safari浏览器
      if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
      } //判断是否IE浏览器
    }
  },

  created: function created() {
    this.imgChange();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _passReset = __webpack_require__(633);

var _passReset2 = _interopRequireDefault(_passReset);

var _login = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//

exports.default = {
    components: {
        PassCode: _passReset2.default
    },
    data: function data() {
        return {};
    },

    methods: {
        goFrash: function goFrash() {
            (0, _login.userSSet)().then(function () {});
            this.$router.push("/");
        }
    }
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _dictMent = __webpack_require__(802);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			tableData: [],
			storeArr: [],
			showArr: [],

			pstate: false,

			//  弹出层

			diaForAdd: false,
			diaTitle: '',

			postDats: {
				id: '',
				parentId: '',
				name: '',
				sort: '',
				code: ''
			}

		};
	},

	methods: {
		goDeeper: function goDeeper(dats) {
			// console.log(dats);
		},

		formateDat: function formateDat(dats, inx) {
			for (var i in dats) {
				var Item = dats[i];
				console.log('Item:' + (0, _stringify2.default)(Item));
				if (inx) {
					var tmp = [i];
					Item.x = inx.concat(tmp);
				} else {
					Item.x = [i];
				}
				Item.hide = true;
				this.storeArr.push(Item);
				if (Item.items && Item.items.length > 0) {
					this.formateDat(Item.items, Item.x);
				}
			}
		},

		arrEquires: function arrEquires(arr1, arr2) {

			var eqs = true;
			for (var i in arr1) {
				if (arr1[i] != arr2[i]) {
					eqs = false;
					break;
				}
			};

			return eqs;
		},

		preFmate: function preFmate(rows) {
			// console.log('rows:' + JSON.stringify(rows));
			if (rows.hide) {
				rows.hide = false;
				this.showFormate('open', rows.x);
			} else {
				rows.hide = true;
				this.showFormate('close', rows.x);
			}
		},

		showFormate: function showFormate(state, iArr) {
			// console.log('storeArr:' + this.storeArr);
			// console.log('state:' + state);
			// console.log('iArr:' + iArr);
			// iArr 被点击行的 root 数组
			// state 执行 code

			var tempArr = [];
			for (var i in this.storeArr) {
				var item = this.storeArr[i];
				// console.log('item:' + item);
				if (state == "init") {
					if (item.x && item.x.length == 1) {
						tempArr.push(item);
					}
				} else {
					if (this.arrEquires(iArr, item.x)) {
						if (item.x.length - iArr.length == 1) {
							tempArr.push(item);
						}
					}
				}
			}

			if (state == "open") {
				for (var _i in this.showArr) {
					var _item = this.showArr[_i];
					if (this.arrEquires(iArr, _item.x) && iArr.length == _item.x.length) {
						var _showArr;

						(_showArr = this.showArr).splice.apply(_showArr, [parseInt(_i) + 1, 0].concat(tempArr));
						break;
					}
				}
			} else if (state == "close") {
				var transArr = [];
				for (var _i2 in this.showArr) {
					var toAdd = true;
					for (var j in tempArr) {
						if (this.arrEquires(tempArr[j].x, this.showArr[_i2].x)) {
							toAdd = false;
							break;
						}
					};
					if (toAdd) {
						transArr.push(this.showArr[_i2]);
					}
				};

				this.showArr = transArr;
			} else if (state == "init") {
				this.showArr = tempArr;
			}
		},
		goSave: function goSave() {
			var _this = this;

			var msg = '';
			if (!this.postDats.name) {
				msg = '请填写名称！';
			} else if (!this.postDats.sort && this.postDats.sort != 0) {
				msg = '请填写排序！';
			}

			if (msg) {
				this.$message({
					showClose: true,
					message: msg,
					type: 'error'
				});
			} else {
				(0, _dictMent.dictCreate)({ dataDictionary: this.postDats }).then(function (response) {
					_this.diaForAdd = false;
					_this.$message({
						showClose: true,
						message: '操作成功！',
						type: 'success'
					});
					_this.$emit('go-frash');
					_this.dictGet();
				});
			}
		},

		goRemove: function goRemove(dat) {
			var _this2 = this;

			this.$confirm('确定要删除该节点吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(function () {
				var posts = {
					id: dat.id
				};
				(0, _dictMent.dictRemove)(posts).then(function (response) {
					_this2.$message({
						showClose: true,
						message: '删除成功！',
						type: 'success'
					});
					_this2.$emit('go-frash');
					_this2.dictGet();
				});
			});
		},

		btnTrans: function btnTrans(state, dat) {
			if (state == "add") {
				this.diaForAdd = true;
				this.diaTitle = "添加";
				if (dat) {
					this.postDats.parentId = dat.id;
				} else {
					this.pstate = true;
				}
			} else if (state == "edit") {
				this.diaForAdd = true;
				this.diaTitle = "编辑";
				this.postDats = {
					id: dat.id,
					parentId: dat.parentId,
					name: dat.name,
					sort: dat.sort,
					code: dat.code
				};

				if (!dat.parentId) {
					this.pstate = true;
				}
			} else if (state == "remove") {
				this.goRemove(dat);
			}
		},

		dictGet: function dictGet() {
			var that = this;
			(0, _dictMent.getDistTree)().then(function (response) {
				that.tableData = response.dataDictionaryTreeModules;
				that.formateDat(that.tableData);
				that.showFormate("init");
			});
		},

		menuCreate: function menuCreate() {
			var _this3 = this;

			getMenu().then(function (response) {
				console.log(response);
				_this3.tableData = response.getMenuTreeModules;
				_this3.formateDat(_this3.tableData);
				_this3.showFormate("init");
			});
		},

		closeHandle: function closeHandle() {
			this.postDats.id = '';
			this.postDats.name = '';
			this.postDats.sort = '';
			this.postDats.code = '';
			this.postDats.parentId = '';

			this.pstate = false;
			console.log('aaa');
		}

	},
	created: function created() {
		// this.menuCreate();
		this.dictGet();
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(267);

var _assign2 = _interopRequireDefault(_assign);

var _modelSet = __webpack_require__(803);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      loading: false,
      tableData: [],

      storeArr: [],
      showArr: [],

      //  弹出层

      diaForAdd: false,
      radio1: '',
      radio2: '',
      diaTitle: '',

      postDats: {
        id: '',
        pId: '',
        iconUrl: '',
        name: '',
        type: '',
        url: '',
        view: ''
      }

    };
  },

  filters: {
    translate: function translate(dat, code, map) {
      if (code == 'type') {
        var transMap = ['', '页面', '按钮'];
        return transMap[dat];
      } else if (code == 'view') {
        var stateArr = ['', '显示', '不显示'];
        return stateArr[dat];
      }
    }
  },
  methods: {

    // zym.生成树形结构
    arrayToTree: function arrayToTree(nodes, config) {
      var _map$;

      if (!Array.isArray(nodes)) {
        console.error('params arr need Array');
        return [];
      }

      // let cfg = Object.assign(config, {id: 'id', pid: 'pid', sn: 'level', order: true});
      var cfg = (0, _assign2.default)({ id: 'id', pid: 'pid', sn: 'level', order: true }, config);
      // console.log('cfg=',JSON.stringify(cfg));
      var keyName = cfg.id;
      var parentKeyName = cfg.pid;
      var sn = cfg.sn;
      var order = cfg.order;

      var map = {};
      nodes.forEach(function (v) {
        if (!v[parentKeyName]) {
          v[parentKeyName] = "0";
        }
        v.menuRuleModules = [];
        map[v[keyName]] = v;
      });
      // console.log("nodes=",JSON.stringify(nodes));
      map[0] = (_map$ = {}, (0, _defineProperty3.default)(_map$, keyName, "0"), (0, _defineProperty3.default)(_map$, 'name', 'root'), (0, _defineProperty3.default)(_map$, 'menuRuleModules', []), _map$);
      nodes.forEach(function (v) {
        // console.log('map[v[parentKeyName]]=',v[parentKeyName]);
        if (v[parentKeyName]) {
          var menuRuleModules = map[v[parentKeyName]].menuRuleModules;

          // 当前第一个节点，直接放入children数组
          if (menuRuleModules.length == 0) {
            menuRuleModules.push(v);
            return true;
          }

          // 序号小的节点排在前面，否则往后放
          if (order) {
            var i = 0;
            for (var len = menuRuleModules.length; i < len; i++) {
              if (v[sn] < menuRuleModules[i][sn]) {
                break;
              }
            }
            menuRuleModules.splice(i, 0, v);
          } else {
            menuRuleModules.push(v);
          }
        }
      });
      return map[0].menuRuleModules;
    },

    goDeeper: function goDeeper(dats) {
      // console.log(dats);
    },

    formateDat: function formateDat(dats, inx) {
      for (var i in dats) {
        var Item = dats[i];

        if (inx) {
          var tmp = [i];
          Item.x = inx.concat(tmp);
        } else {
          Item.x = [i];
        }
        Item.hide = true;
        this.storeArr.push(Item);
        if (Item.menuRuleModules.length > 0) {
          this.formateDat(Item.menuRuleModules, Item.x);
        }
      }
    },

    arrEquires: function arrEquires(arr1, arr2) {

      var eqs = true;
      for (var i in arr1) {
        if (arr1[i] != arr2[i]) {
          eqs = false;
          break;
        }
      };

      return eqs;
    },

    preFmate: function preFmate(rows) {
      if (rows.hide) {
        rows.hide = false;
        this.showFormate('open', rows.x);
      } else {
        rows.hide = true;
        this.showFormate('close', rows.x);
      }
    },

    showFormate: function showFormate(state, iArr) {

      // iArr 被点击行的 root 数组
      // state 执行 code

      var tempArr = [];
      for (var i in this.storeArr) {
        var item = this.storeArr[i];
        if (state == "init") {
          if (item.x.length == 1) {
            tempArr.push(item);
          }
        } else {
          if (this.arrEquires(iArr, item.x)) {
            if (item.x.length - iArr.length == 1) {
              tempArr.push(item);
            }
          }
        }
      }

      if (state == "open") {
        for (var _i in this.showArr) {
          var _item = this.showArr[_i];
          if (this.arrEquires(iArr, _item.x) && iArr.length == _item.x.length) {
            var _showArr;

            (_showArr = this.showArr).splice.apply(_showArr, [parseInt(_i) + 1, 0].concat(tempArr));
            break;
          }
        }
      } else if (state == "close") {
        var transArr = [];
        for (var _i2 in this.showArr) {
          var toAdd = true;
          for (var j in tempArr) {
            if (this.arrEquires(tempArr[j].x, this.showArr[_i2].x)) {
              toAdd = false;
              break;
            }
          };
          if (toAdd) {
            transArr.push(this.showArr[_i2]);
          }
        };

        this.showArr = transArr;
      } else if (state == "init") {
        this.showArr = tempArr;
      }
    },
    // zym.保存
    goSave: function goSave() {
      var _this = this;

      var msg = '';
      if (!this.postDats.type) {
        msg = '请选择类型！';
      } else if (!this.postDats.view) {
        msg = '请选择显示与否！';
      } else if (!this.postDats.name) {
        msg = '请填写名称！';
      } else if (!this.postDats.url) {
        msg = '请输入菜单URL！';
      } else if (!this.postDats.iconUrl) {
        msg = '请输入菜单icon！';
      }

      if (msg) {
        this.$message({
          showClose: true,
          message: msg,
          type: 'error'
        });
      } else {
        (0, _modelSet.menuCreate)({ menu: this.postDats }).then(function (response) {
          console.log('response=', (0, _stringify2.default)(response));
          var tipCode = response.tipCode;
          var tipMessage = response.message || '操作失败';
          if (tipCode == 'fail') {
            _this.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this.diaForAdd = false;
            _this.$message({
              showClose: true,
              message: '操作成功！',
              type: 'success'
            });
            _this.storeArr = [];
            _this.menuCreate();
          }
        }).catch(function (error) {
          _this.diaForAdd = false;
          _this.$message({
            showClose: true,
            message: '操作失败！',
            type: 'error'
          });
        });
      }
    },
    // zym.删除发票
    goRemove: function goRemove(dat) {
      var _this2 = this;

      this.$confirm('确定要删除 "' + dat.name + '" 节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var posts = {
          id: dat.id
        };
        (0, _modelSet.delDot)(posts).then(function (response) {
          _this2.$message({
            showClose: true,
            message: '删除成功！',
            type: 'success'
          });
          _this2.storeArr = [];
          _this2.menuCreate();
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },

    btnTrans: function btnTrans(state, dat) {
      if (state == "add") {
        this.diaForAdd = true;
        this.diaTitle = "添加";
        this.postDats = {
          id: '',
          pId: '',
          iconUrl: '',
          name: '',
          type: '',
          url: '',
          view: ''
        };
        if (dat) {
          this.postDats.pId = dat.id;
        }
      } else if (state == "edit") {
        console.log(dat);
        this.diaForAdd = true;
        this.diaTitle = "编辑";
        this.postDats = {
          id: dat.id,
          pId: dat.pId,
          iconUrl: dat.iconUrl,
          name: dat.name,
          type: dat.type,
          url: dat.url,
          view: dat.view
        };
      } else if (state == "remove") {
        this.goRemove(dat);
      }
    },
    // zym.显示菜单
    menuCreate: function menuCreate() {
      var _this3 = this;

      (0, _modelSet.getMenu)().then(function (response) {
        var menuTree = _this3.arrayToTree(response.payload, { "id": "id", "pid": "pId", "sn": "createdAt" });
        _this3.tableData = menuTree; // response.payload;
        // this.tableData = response.getMenuTreeModules;
        _this3.formateDat(_this3.tableData);
        _this3.showFormate("init");
      });
    }

  },
  created: function created() {

    this.menuCreate();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(101);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(151);

var _values2 = _interopRequireDefault(_values);

var _asyncToGenerator2 = __webpack_require__(100);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _publishMent = __webpack_require__(804);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var XLSX = __webpack_require__(55);

exports.default = {
  data: function data() {
    return {
      tableData: [],
      storeArr: [],
      showArr: [],
      totalCount: "0",

      condition: {
        shparentorgname: "",
        ydname: "",
        ydzz: "",
        ydstatus: ""
      },

      colYdzzName: "资质",

      ydzzOptions: [{ label: "音像", value: "0" }, { label: "电子", value: "1" }, { label: "连续型电子出版物", value: "2" }, { label: "音像+电子", value: "0,1" }],
      ydstatusOptions: [{ label: "正常", value: "2" }, { label: "注销", value: "1" }]
    };
  },

  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var that = this;
      (0, _publishMent.getPublishList)({}).then(function (response) {
        // console.log("getPublishList", response);
        that.tableData = response.data;
        that.formateDat(that.tableData);
        // console.log("that.showArr", that.storeArr);
        that.showFormate("init");
      });
    },

    goDeeper: function goDeeper(dats) {
      // console.log(dats);
    },
    sortChanged: function sortChanged(params) {
      console.log(params);
    },
    formateDat: function formateDat(dats, inx) {
      this.storeArr = [];
      for (var i in dats) {
        var Item = dats[i];
        // 格式化资质
        var values = Item.ydzz.split(",");
        var ydzzName = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var value = _step.value;

            switch (value) {
              case "0":
                ydzzName += ",音像";
                break;
              case "1":
                ydzzName += ",电子";
                break;
              case "2":
                ydzzName += ",连续型电子出版物";
                break;
              default:
                ydzzName += "," + value;
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (ydzzName.length > 0) {
          ydzzName = ydzzName.substring(1);
        }
        Item.ydzzName = ydzzName;

        // 格式化状态
        var ydstatusName = "";
        if (Item.ydstatus == "1") {
          ydstatusName = "注销";
        } else {
          ydstatusName = "正常";
        }
        Item.ydstatusName = ydstatusName;
        this.storeArr.push(Item);
      }
    },

    arrEquires: function arrEquires(arr1, arr2) {
      var eqs = true;
      for (var i in arr1) {
        if (arr1[i] != arr2[i]) {
          eqs = false;
          break;
        }
      }

      return eqs;
    },
    showFormate: function showFormate(state, iArr) {
      var tempArr = [];
      for (var i in this.storeArr) {
        var item = this.storeArr[i];
        if (state == "init") {
          tempArr.push(item);
        }
      }
      this.showArr = tempArr;
      this.totalCount = this.showArr.length;
    },
    setQueryVisible: function setQueryVisible(scope) {
      console.log(scope);
    },
    search: function search() {
      var that = this;
      console.log(that.condition);
      (0, _publishMent.getPublishList)(that.condition).then(function (response) {
        that.colYdzzName = that.condition.ydzz == "2" ? "连续型电子出版物" : "资质";
        that.tableData = response.data;
        that.formateDat(that.tableData);
        that.showFormate("init");
      });
    },
    exportTable: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var columns, cellWidths, list, i, po, data, key, filename, opts, wsname, wb, ws;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = { shparentorgname: "省局", ydname: "出版单位", ydzzName: this.colYdzzName };
                cellWidths = [{ wpx: 180 }, { wpx: 300 }, { wpx: 80 }];
                list = [];

                for (i in this.showArr) {
                  po = this.showArr[i];
                  data = {};

                  for (key in columns) {
                    data[columns[key]] = po[key];
                  }
                  list.push(data);
                }
                filename = "\u51FA\u7248\u5355\u4F4D\u4E00\u89C8_" + (0, _moment2.default)() + ".xlsx";
                opts = (0, _values2.default)(columns);
                wsname = "Sheet1";
                wb = XLSX.utils.book_new();
                _context.next = 10;
                return XLSX.utils.json_to_sheet(list, opts);

              case 10:
                ws = _context.sent;

                ws["!cols"] = cellWidths;
                XLSX.utils.book_append_sheet(wb, ws, wsname);
                _context.next = 15;
                return XLSX.writeFile(wb, "" + filename);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exportTable() {
        return _ref.apply(this, arguments);
      }

      return exportTable;
    }()
  }
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(267);

var _assign2 = _interopRequireDefault(_assign);

var _roleMent = __webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {

      leftHt: 0,

      // 机构树
      gmTree: [],

      // 角色表
      roleAllData: [],
      roleData: [],
      roleSeek: {
        where: '',
        gmId: '',
        gmName: ''
      },

      // 角色新建、修改
      roleCreate: {
        diaName: '',
        diaPop: false,
        roleName: '',
        roleId: ''
      },

      // 角色配置
      roleConfig: {
        diaPop: false,
        roleId: '',
        treeArr: [],
        props: {
          children: 'menuRuleModules',
          label: 'name'
        },
        selected: []
      },

      // leftHt:0,
      diaForCet: false,
      diaForSet: false,
      diaTitle: '创建新角色',
      defaultProps: {
        children: 'getCompanyPostModules',
        label: 'name'
      },
      defaultProps2: {
        children: 'menuRuleModules',
        label: 'name'
      },
      roleDat: [],
      data2: [],

      tableData: [],

      search: '',

      diaName1: '',
      diaName2: '',

      // 角色tree默认展开节点

      defaultArr: [],
      defaultAct: '',

      // zym.关键字
      param: {
        name: ''
      }

    };
  },


  watch: {
    param: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },

  methods: {
    // 页面数据筛选
    filterTableData: function filterTableData() {
      var roleData = this.roleAllData;
      var qName = this.param.name;
      // 名称查询
      if (qName) {
        var itemName = void 0;
        roleData = roleData.filter(function (item) {
          itemName = item.name || '';

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }

      this.roleData = roleData;
    }
    // 机构树创建
    , gmTreeCreate: function gmTreeCreate() {
      // getGmTree().then(response => {
      //   let unFormate = response.getCompanyPostTreeModules;
      //   this.gmTree = unFormate;
      //   this.roleSeek.gmId = unFormate[0].id;
      //   this.roleSeek.gmName = unFormate[0].name;
      //   this.roleSkList();
      //   // this.defaultAct = unFormate[0];
      //   // this.getLists();
      // }).catch(error => {
      //   console.log(error);
      // })

      this.roleSkList();
    },

    // 机构切换

    nodeChange: function nodeChange(node, state) {
      if (node.id != this.roleSeek.gmId) {
        this.roleSeek.gmId = node.id;
        this.roleSeek.gmName = node.name;
        this.roleSkList();
      }
    },

    // 关联机构的角色列表
    roleSkList: function roleSkList() {
      var _this = this;

      (0, _roleMent.getRoleList)({
        id: this.roleSeek.gmId,
        type: 4
      }).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        // let unFormate = response.getCompanyPostModules;
        // this.roleData = unFormate;
        _this.roleAllData = response.payload;
        _this.filterTableData();
      }).catch(function (error) {
        console.log(error);
      });
    },

    // 角色新建、修改
    roleCtrls: function roleCtrls(type, code, dats) {
      var _this2 = this;

      if (type == 'show') {
        if (code == 1) {
          this.diaName = '新建角色';
          this.roleCreate.roleName = '';
          this.roleCreate.roleId = '';
        } else if (code == 2) {
          this.diaName = '修改角色信息';
          this.roleCreate.roleName = dats.name;
          this.roleCreate.roleId = dats.id;
        }
        this.roleCreate.diaPop = true;
      } else if (type == 'cencel') {
        this.roleCreate.diaPop = false;
      } else if (type == 'sure') {
        (0, _roleMent.CreateRole)({
          post: {
            id: this.roleCreate.roleId,
            name: this.roleCreate.roleName,
            companyOrganizationId: this.roleSeek.gmId
          }
        }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || '操作失败';
          if (tipCode == 'fail') {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this2.$message({
              message: '操作成功！',
              type: 'success'
            });
            _this2.roleCreate.diaPop = false;
            _this2.roleSkList();
          }
        }).catch(function (error) {
          _this2.$message({
            message: '创建失败，请稍后重试！',
            type: 'error'
          });
        });
      }
    },
    // 角色删除
    roleDelete: function roleDelete(dats) {
      var _this3 = this;

      this.$confirm("删除后无法恢复，是否确定删除！", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _roleMent.removeRole)({
          id: dats.id,
          type: 4
        }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || '操作失败';
          if (tipCode == 'fail') {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this3.$message({
              message: '操作成功！',
              type: 'success'
            });
            _this3.roleSkList();
          }
        }).catch(function (error) {
          _this3.$message({
            message: '删除失败，请稍后重试！',
            type: 'error'
          });
        });
      }).catch(function () {});
    },
    // zym.生成树形结构
    arrayToTree: function arrayToTree(nodes, config) {
      var _map$;

      if (!Array.isArray(nodes)) {
        console.error('params arr need Array');
        return [];
      }

      // let cfg = Object.assign(config, {id: 'id', pid: 'pid', sn: 'level', order: true});
      var cfg = (0, _assign2.default)({ id: 'id', pid: 'pid', sn: 'level', order: true }, config);
      // console.log('cfg=',JSON.stringify(cfg));
      var keyName = cfg.id;
      var parentKeyName = cfg.pid;
      var sn = cfg.sn;
      var order = cfg.order;

      var map = {};
      nodes.forEach(function (v) {
        if (!v[parentKeyName]) {
          v[parentKeyName] = "0";
        }
        v.menuRuleModules = [];
        map[v[keyName]] = v;
      });
      // console.log("nodes=",JSON.stringify(nodes));
      map[0] = (_map$ = {}, (0, _defineProperty3.default)(_map$, keyName, "0"), (0, _defineProperty3.default)(_map$, 'name', 'root'), (0, _defineProperty3.default)(_map$, 'menuRuleModules', []), _map$);
      nodes.forEach(function (v) {
        // console.log('map[v[parentKeyName]]=',v[parentKeyName]);
        if (v[parentKeyName]) {
          var menuRuleModules = map[v[parentKeyName]].menuRuleModules;

          // 当前第一个节点，直接放入children数组
          if (menuRuleModules.length == 0) {
            menuRuleModules.push(v);
            return true;
          }

          // 序号小的节点排在前面，否则往后放
          if (order) {
            var i = 0;
            for (var len = menuRuleModules.length; i < len; i++) {
              if (v[sn] < menuRuleModules[i][sn]) {
                break;
              }
            }
            menuRuleModules.splice(i, 0, v);
          } else {
            menuRuleModules.push(v);
          }
        }
      });
      return map[0].menuRuleModules;
    },

    // 角色权限
    roleProwers: function roleProwers(type, dats) {
      var _this4 = this;

      function arrsCreate(dats, arrs) {
        for (var i = 0; i < dats.length; i++) {
          arrs.push(dats[i].id);
          if (dats[i].menuRuleModules.length > 0) {
            arrsCreate(dats[i].menuRuleModules, arrs);
          }
        };
        return arrs;
      }

      if (type == 'show') {
        this.roleConfig.diaPop = true;
        this.roleConfig.roleId = dats.id;

        // 把数据重置
        this.roleConfig.treeArr = [];
        this.roleConfig.selected = [];

        (0, _roleMent.ropList)({
          postId: this.roleSeek.gmId
        }).then(function (response) {
          // console.log('menuTree=',JSON.stringify(response.payload))
          var menuTree = _this4.arrayToTree(response.payload, { "id": "id", "pid": "pId", "sn": "createdAt" });
          // console.log('menuTree=',JSON.stringify(menuTree))
          _this4.roleConfig.treeArr = menuTree; // response.payload;// menuRuleTreeModules;
        });

        // 查询角色的菜单权限
        (0, _roleMent.dfPower)({
          postIds: [dats.id]
        }).then(function (response) {
          console.log('response=', response.menuRuleTreeModules);
          // this.roleConfig.selected = arrsCreate(response.menuRuleTreeModules, []);
          _this4.roleConfig.selected = response.menuRuleTreeModules.map(function (item) {
            return item.id;
          });
        });
      }
      // 取消页面弹窗
      else if (type == 'cencel') {
          this.roleConfig.diaPop = false;
        }
        // 保存角色的菜单设置
        else if (type == 'sure') {
            (0, _roleMent.ropSave)({
              postId: this.roleConfig.roleId,
              menuIds: this.$refs.tree.getCheckedKeys()
            }).then(function (response) {
              var tipCode = response.tipCode;
              var tipMessage = response.message || '操作失败';
              if (tipCode == 'fail') {
                _this4.$message({
                  showClose: true,
                  message: tipMessage,
                  type: 'error'
                });
              } else {
                _this4.$message({
                  message: '操作成功！',
                  type: 'success'
                });
                _this4.roleConfig.diaPop = false;
              }
            }).catch(function (error) {
              _this4.$message({
                message: '保存失败，请稍后重试！',
                type: 'error'
              });
            });
          }
    },

    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    }

  },

  beforeMount: function beforeMount() {
    this.leftHt = window.screen.height - 285;
  },

  created: function created() {
    this.gmTreeCreate();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sectMent = __webpack_require__(806);

var _adminRole = __webpack_require__(71);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_initPagin2.default],
  props: {
    hidePagin: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      loading: false,

      // zym.关键字
      param: {
        parentname: "",
        name: ""
      },
      tableData: [],
      tableAllData: [],

      storeArr: [],
      showArr: [],

      //  弹出层

      diaForAdd: false,

      radio1: "",
      radio2: "",
      diaTitle: "",

      postDats: {
        id: "",
        pId: "",
        name: ""
      },

      diaForSetTsorgid: false,
      tsorgid: "", // zym.图书id
      ydOrganizationId: "" // zym.音电系统id
    };
  },

  watch: {
    tableData: function tableData(val) {
      if (val) this.total = val.length;
    },

    param: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },
  filters: {
    translate: function translate(dat, code, map) {
      if (code == "type") {
        var transMap = ["", "页面", "按钮"];
        return transMap[dat];
      } else if (code == "view") {
        var stateArr = ["", "显示", "不显示"];
        return stateArr[dat];
      } else if (code == "level") {
        var _stateArr = ["", "新闻出版署", "省局", "出版单位"];
        return _stateArr[dat];
      }
    },
    // zym.处理上级单位
    transParent: function transParent(val) {
      if (val == undefined) {
        return "无";
      }
      return val.name;
    }
  },
  methods: {
    batchBackSystem: function batchBackSystem() {
      var _this = this;

      this.$confirm("确定要批量退回吗？退回的数据已经内置在数据库中，请知晓！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        (0, _adminRole.batchBackSystem)().then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || "操作失败";
          if (tipCode == "fail") {
            _this.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this.$message({
              showClose: true,
              message: "退回成功！",
              type: "success"
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },
    setClaimId: function setClaimId(dat) {
      this.diaForSetTsorgid = true;
      this.tsorgid = dat.tsorgid || "";
      this.ydOrganizationId = dat.id || "";
    },
    closeCliamId: function closeCliamId() {
      this.diaForSetTsorgid = false;
      this.tsorgid = "";
      this.ydOrganizationId = "";
    },
    // zym.设置书号id
    saveClaimId: function saveClaimId() {
      var _this2 = this;

      console.log("ydOrganizationId=", this.ydOrganizationId, "  ", this.tsorgid);
      this.$confirm("确定要保存书号系统ID？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        (0, _sectMent.saveClaimId)({ id: _this2.ydOrganizationId, tsorgid: _this2.tsorgid }).then(function (response) {
          _this2.closeCliamId();

          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "success") {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });

            _this2.listOrganization();
          } else {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },
    // zym.设置申报资料
    setMaterials: function setMaterials(type, dat) {
      var _this3 = this;

      var types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型填报资料吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        (0, _sectMent.setMaterials)({ type: type, id: dat.id }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "success") {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });

            _this3.listOrganization();
          } else {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },
    // zym.设置申报资料 - 连续电子
    setMaterialsLxdz: function setMaterialsLxdz(type, dat) {
      var _this4 = this;

      var types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型填报资料吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        (0, _sectMent.setMaterialsLxdz)({ type: type, id: dat.id }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "success") {
            _this4.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });

            _this4.listOrganization();
          } else {
            _this4.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },

    setWorks: function setWorks(type, dat) {
      var _this5 = this;

      var types = ["", "音像", "电子", "连续电子"];
      this.$confirm('确定要初始化 "' + types[type] + '" 类型审批流程吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        (0, _sectMent.setWorks)({ type: type, id: dat.id }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "success") {
            _this5.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });

            _this5.listOrganization();
          } else {
            _this5.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },
    isEmpty: function isEmpty(val) {
      if (val == undefined || val == "") {
        return true;
      }
      return false;
    },
    goDeeper: function goDeeper(dats) {
      // console.log(dats);
    },

    formateDat: function formateDat(dats, inx) {
      for (var i in dats) {
        var Item = dats[i];
        if (inx) {
          var tmp = [i];
          Item.x = inx.concat(tmp);
        } else {
          Item.x = [i];
        }
        Item.hide = true;
        this.storeArr.push(Item);
        // if(Item.getCompanyPostModules.length > 0){
        // 	  this.formateDat(Item.getCompanyPostModules,Item.x);
        if (Item.children && Item.children.length > 0) {
          this.formateDat(Item.children, Item.x);
        }
      }
    },

    arrEquires: function arrEquires(arr1, arr2) {
      var eqs = true;
      for (var i in arr1) {
        if (arr1[i] != arr2[i]) {
          eqs = false;
          break;
        }
      }

      return eqs;
    },

    preFmate: function preFmate(rows) {
      if (rows.hide) {
        rows.hide = false;
        this.showFormate("open", rows.x);
      } else {
        rows.hide = true;
        this.showFormate("close", rows.x);
      }
    },

    showFormate: function showFormate(state, iArr) {
      // iArr 被点击行的 root 数组
      // state 执行 code

      var tempArr = [];
      for (var i in this.storeArr) {
        var item = this.storeArr[i];
        if (state == "init") {
          if (item.x.length == 1) {
            tempArr.push(item);
          }
        } else {
          if (this.arrEquires(iArr, item.x)) {
            if (item.x.length - iArr.length == 1) {
              tempArr.push(item);
            }
          }
        }
      }

      if (state == "open") {
        for (var _i in this.showArr) {
          var _item = this.showArr[_i];
          if (this.arrEquires(iArr, _item.x) && iArr.length == _item.x.length) {
            var _showArr;

            (_showArr = this.showArr).splice.apply(_showArr, [parseInt(_i) + 1, 0].concat(tempArr));
            break;
          }
        }
      } else if (state == "close") {
        var transArr = [];
        for (var _i2 in this.showArr) {
          var toAdd = true;
          for (var j in tempArr) {
            if (this.arrEquires(tempArr[j].x, this.showArr[_i2].x)) {
              toAdd = false;
              break;
            }
          }
          if (toAdd) {
            transArr.push(this.showArr[_i2]);
          }
        }

        this.showArr = transArr;
      } else if (state == "init") {
        this.showArr = tempArr;
      }
    },

    goSave: function goSave() {
      var _this6 = this;

      var msg = "";
      if (!this.postDats.name) {
        msg = "请填写名称！";
      }

      // console.log("save data = " ,JSON.stringify(this.postDats));

      if (msg) {
        this.$message({
          showClose: true,
          message: msg,
          type: "error"
        });
      } else {
        (0, _sectMent.menuCreate)({
          organization: this.postDats
        }).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || "操作失败";
          if (tipCode == "fail") {
            _this6.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this6.diaForAdd = false;
            _this6.$message({
              showClose: true,
              message: "操作成功！",
              type: "success"
            });
            // this.storeArr = [];
            _this6.initPage();
          }
        }).catch(function (error) {
          _this6.diaForAdd = false;
          _this6.$message({
            showClose: true,
            message: "操作失败！",
            type: "error"
          });
        });
      }
    },

    goRemove: function goRemove(dat) {
      var _this7 = this;

      this.$confirm('确定要删除 "' + dat.name + '" 节点吗？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(function () {
        var posts = {
          id: dat.id
        };
        (0, _sectMent.delDot)(posts).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || "操作失败";
          if (tipCode == "fail") {
            _this7.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this7.$message({
              showClose: true,
              message: "删除成功！",
              type: "success"
            });
            // this.storeArr = [];
            _this7.initPage();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function () {});
    },

    btnTrans: function btnTrans(state, dat) {
      if (state == "add") {
        this.diaForAdd = true;
        this.diaTitle = "添加";
        if (dat) {
          this.postDats.pId = dat.id;
          this.postDats.name = "";
          this.postDats.id = "";
        } else {
          this.postDats.pId = "";
          this.postDats.name = "";
          this.postDats.id = "";
        }
      } else if (state == "edit") {
        console.log(dat);
        this.diaForAdd = true;
        this.diaTitle = "编辑";
        this.postDats = {
          id: dat.id,
          pId: dat.pId,
          name: dat.name
        };
      } else if (state == "remove") {
        //  if(dat.getCompanyPostModules.length > 0){
        // if (dat.children.length > 0) {
        //   this.$message({
        //     showClose: true,
        //     message: '该机构下存在子机构，请先删除子机构！',
        //     type: 'info'
        //   });
        // } else {
        this.goRemove(dat);
        // }
      }
    },

    listOrganization: function listOrganization() {
      var that = this;
      (0, _sectMent.listOrganization)(this.param).then(function (response) {
        that.tableAllData = response.payload;
        that.filterTableData();
      });
    },

    filterTableData: function filterTableData() {
      var tableData = this.tableAllData;
      var qName = this.param.name;
      var qParentname = this.param.parentname;
      // 名称查询
      if (!this.isEmpty(qName)) {
        var itemName = void 0;
        tableData = tableData.filter(function (item) {
          itemName = item.name || "";

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }
      // 上级单位查询
      if (!this.isEmpty(qParentname)) {
        var itemParentName = void 0;
        tableData = tableData.filter(function (item) {
          itemParentName = item.parent == undefined ? "" : item.parent.name;

          if (itemParentName.indexOf(qParentname) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tableData = tableData;
    },

    initPage: function initPage() {
      // listOrganization(this.param).then(response => {
      //   this.tableData = response.payload;
      //   this.tableAllData = response.payload;
      // });
      this.listOrganization();
    }
  },
  created: function created() {
    this.initPage();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sectStatic = __webpack_require__(807);

var _provinceRole = __webpack_require__(20);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_initPagin2.default],
  props: {
    hidePagin: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      loading: false,
      param: {}
    };
  },

  watch: {},
  filters: {
    translate: function translate(dat, code, map) {}
  },
  methods: {
    // zym.基本信息初始化
    initBase: function initBase() {
      var _this = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initBase)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },

    // zym.基本信息初始化 - 连续型
    initLxdzBase: function initLxdzBase() {
      var _this2 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this2.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initLxdzBase)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this2.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this2.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this2.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },
    // zym.经营情况初始化
    initFinance: function initFinance() {
      var _this3 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this3.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initFinance)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this3.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this3.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this3.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },
    // zym.经营情况初始化 - 连续电子
    initLxdzFinance: function initLxdzFinance() {
      var _this4 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this4.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initLxdzFinance)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this4.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this4.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this4.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },
    // zym.作品初始化
    initPublication: function initPublication() {
      var _this5 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this5.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initPublication)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this5.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this5.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this5.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },
    // zym.人员初始化
    initWorker: function initWorker() {
      var _this6 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u5220\u9664\u539F\u6765\u7684\u6570\u636E\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this6.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _sectStatic.initWorker)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this6.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this6.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        console.log("测试...", e);
        var loading = _this6.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    },
    // zym.省局：批量生成审核的条件数据
    batchAuditGen: function batchAuditGen() {
      var _this7 = this;

      var tipMsg = "<span style='font-weight:bold;color:red'>\u6B64\u64CD\u4F5C\u4F1A\u81EA\u52A8\u751F\u6210\u5BA1\u6838\u5224\u65AD\u6761\u4EF6\uFF0C\u662F\u5426\u786E\u5B9A\u751F\u6210?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var loading = _this7.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        var dataIn = {};
        (0, _provinceRole.batchAuditGen)({ dataIn: dataIn }).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "处理失败";
          if (code == "success") {
            loading.close();
            _this7.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this7.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function (e) {
        var loading = _this7.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        loading.close();
      });
    }
  },
  created: function created() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(181);

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _userMent = __webpack_require__(808);

var _account = __webpack_require__(16);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _lodash = __webpack_require__(341);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_initPagin2.default],
  data: function data() {
    return {
      styleSet: {
        edWidth: 480
      },
      leftHt: 0,
      muserId: "",
      // 机构树
      gmpTree: [],
      gmpTreeProps: {
        //  children: 'getCompanyPostModules',
        label: "name"
      },

      // 用列表默认缓存
      seekStore: {
        no: 1,
        size: 15,
        where: "",
        organizationId: "",
        id: ""
      },
      tabDat: [],
      tabPages: 0,

      // 新增、修改用户基础信息
      userPop: {
        diaCtrls: false,
        diaTitle: "",
        uName: "",
        uPhone: "",
        uId: ""
      },
      // 配置用户角色
      rolePop: {
        userId: "",
        diaCtrls: false,
        roleArrs: [],
        chosenArrs: [],
        tmpRole: {}
      },
      // 角色关联权限树
      enterTree: [],
      enterTreeProps: {
        children: "menuRuleModules",
        label: "name"
      },
      tableData: [],
      dialogVisible: false,
      no: 1,
      size: 20,
      historytotalPages: 0
    };
  },

  watch: {
    "seekStore.where": function seekStoreWhere() {
      this.seekStore.no = 1;
      this.userList();
    }
  },
  methods: {
    setDeleted: function setDeleted(dat, goStatus) {
      var _this = this;

      (0, _userMent.setDeleted)({
        id: dat.id,
        goStatus: goStatus
      }).then(function (response) {
        console.log("response=", (0, _stringify2.default)(response));
        var tipCode = response.tipCode;
        var tipMessage = response.tipMessage || "操作失败";
        if (tipCode == "fail") {
          _this.$message({
            showClose: true,
            message: tipMessage,
            type: "error"
          });
        } else {
          _this.$message({
            showClose: true,
            message: tipMessage,
            type: "success"
          });
          _this.$emit("go-frash");
        }
      });
    },
    // zym.补充连续型出版物整改报告
    fillReportForLxdz: function fillReportForLxdz(type) {
      var _this2 = this;

      this.$confirm("是否确定补充连续型出版物整改报告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _userMent.fillReportForLxdz)({
          type: type
        }).then(function (response) {
          console.log("response=", (0, _stringify2.default)(response));
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "fail") {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });
          }
        });
      }).catch(function (error) {});
    },
    // zym.同步音电年检数据
    initPublisherStartBatch: function initPublisherStartBatch(type) {
      var _this3 = this;

      this.$confirm("是否确定初始化流程？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _userMent.initPublisherStartBatch)({
          type: type
        }).then(function (response) {
          console.log("response=", (0, _stringify2.default)(response));
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "fail") {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "success"
            });
          }
        });
      }).catch(function (error) {});
    },
    recheckWorkerSum: function recheckWorkerSum() {
      var _this4 = this;

      (0, _userMent.recheckWorkerSum)({}).then(function (response) {
        console.log("response=", (0, _stringify2.default)(response));
        var tipCode = response.tipCode;
        var tipMessage = response.tipMessage || "操作失败";
        if (tipCode == "fail") {
          _this4.$message({
            showClose: true,
            message: tipMessage,
            type: "error"
          });
        }
      });
    },
    /*
     * 获取机构树
     */

    gmpTreeInit: function gmpTreeInit() {
      var _this5 = this;

      (0, _userMent.getGmpTree)().then(function (response) {
        // let unFormate = response.getCompanyPostTreeModules;
        var unFormate = response.payload;
        _this5.gmpTree = unFormate;
        _this5.seekStore.organizationId = unFormate[0].id;
        _this5.seekStore.organizationName = unFormate[0].name;
        _this5.seekStore.no = 1;
        _this5.userList();
        _this5.muserId = unFormate[0].id;
        _this5.gmpRolesGet();
      }).catch(function (error) {
        console.log(error);
      });
    },

    /*
     * 获取当前机构下用户列表 (列表刷新通用)
     */

    userList: function userList() {
      var _this6 = this;

      (0, _userMent.getUserList)(this.seekStore).then(function (response) {
        // this.tabDat = response.userModules;
        _this6.tabDat = response.payload;
        // this.tabPages = response.totalPages;
        _this6.total = response.payload.length;
      }).catch(function (error) {
        console.log(error);
      });
    },

    /*
     * 新增、修改用户基础信息
     */

    userPocts: function userPocts(_ref) {
      var _this7 = this;

      var type = _ref.type,
          code = _ref.code,
          dats = _ref.dats;

      if (type == "show") {
        if (code == 1) {
          this.userPop.diaTitle = "新增账号";
          this.userPop.uName = "";
          this.userPop.uPhone = "";
          this.userPop.uId = "";
          this.userPop.organizationName = this.seekStore.organizationName;
          this.userPop.organizationId = this.seekStore.organizationId;
        } else if (code == 2) {
          this.userPop.diaTitle = "修改账号信息";
          this.userPop.uName = dats.account;
          this.userPop.uPhone = dats.cellPhone;
          this.userPop.uId = dats.id;
          this.userPop.organizationName = dats.organizationName;
          this.userPop.organizationId = dats.organizationId;
        }
        this.userPop.diaCtrls = true;
      } else if (type == "cencel") {
        this.userPop.diaCtrls = false;
      } else if (type == "sure") {
        if (!this.userPop.uName) {
          this.$message.error("姓名必须填写");
        }
        // else if (!this.userPop.uPhone) {
        //   this.$message.error('手机号必须填写');
        // }
        // else {
        //   let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        //   if (pattern.test(this.userPop.uPhone)) {
        if (this.userPop.uId) {
          (0, _userMent.userCreate)({
            account: this.userPop.uName,
            cellPhone: this.userPop.uPhone,
            id: this.userPop.uId,
            organizationId: this.seekStore.organizationId
          }).then(function (response) {
            var tipCode = response.tipCode;
            var tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              _this7.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this7.$message.success("修改成功");
              _this7.$emit("go-frash");
            }
          });
        } else {
          (0, _userMent.userCreate)({
            account: this.userPop.uName,
            cellPhone: this.userPop.uPhone,
            organizationId: this.seekStore.organizationId
          }).then(function (response) {
            var tipCode = response.tipCode;
            var tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              _this7.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this7.$message.success("新增成功");
              _this7.$emit("go-frash");
            }
          });
        }
        //   } else {
        //     this.$message.error('手机号错误');
        //   }
        // }
      } else if (type == "remove") {
        this.$confirm('确定要删除账号"' + dats.account + '"吗？', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          (0, _userMent.userRemove)({
            id: dats.id
          }).then(function (response) {
            var tipCode = response.tipCode;
            var tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              _this7.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this7.$message({
                showClose: true,
                message: "删除成功！",
                type: "success"
              });
              _this7.$emit("go-frash");
            }
          });
        }).catch(function (error) {});
      }
    },
    /*
     * 用户角色配置
     */
    rolePocts: function rolePocts(_ref2) {
      var _this8 = this;

      var type = _ref2.type,
          dats = _ref2.dats;

      if (type == "show") {
        this.rolePop.diaCtrls = true;
        this.rolePop.tempRole = dats;
        (0, _userMent.getUserRoles)({
          userId: dats.id
        }).then(function (response) {
          console.log("response=", (0, _stringify2.default)(response));
          // let unFormate = response.userModule.postIds;
          // if (unFormate) {
          //   this.rolePop.chosenArrs = unFormate.split(",");
          // } else {
          //   this.rolePop.chosenArrs = [];
          // }
          _this8.rolePop.chosenArrs = response;
          _this8.userDefine();
        });
      } else if (type == "cencel") {
        this.rolePop.diaCtrls = false;
      } else if (type == "sure") {
        this.rolePop.tempRole.postIds = this.rolePop.chosenArrs;
        (0, _userMent.userConnectRole)(this.rolePop.tempRole).then(function (response) {
          var tipCode = response.tipCode;
          var tipMessage = response.message || "操作失败";
          if (tipCode == "fail") {
            _this8.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this8.$message({
              showClose: true,
              message: "配置成功！",
              type: "success"
            });
            _this8.rolePop.diaCtrls = false;
          }
        });
      } else if (type == "resetPwd") {
        this.$confirm("确认要重置 “" + dats.account + "” 的密码吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          // console.warn('resetPasswordFormAdmin: ', dats)
          (0, _account.resetPasswordFormAdmin)({
            id: dats.id
          }).then(function (response) {
            var tipCode = response.tipCode;
            var tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              _this8.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this8.$message.success({ message: tipMessage });
            }
          });
        });
      }
    },

    /*
     * 根据角色获取权限
     */
    userDefine: function userDefine() {
      // if (this.rolePop.chosenArrs.length > 0) {
      //   getConfiged({
      //     postIds: this.rolePop.chosenArrs
      //   }).then(response => {
      //     this.enterTree = response.menuRuleTreeModules;
      //   }).catch(error => {
      //     console.log(error);
      //   })
      // } else {
      //   this.enterTree = [];
      // }
    },

    /*
     * 机构检索
     */

    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    /*
     * 机构变动
     */

    handleNodeClick: function handleNodeClick(data) {
      if (this.seekStore.organizationId != data.id) {
        this.seekStore.no = 1;
        this.seekStore.organizationId = data.id;
        this.seekStore.organizationName = data.name;
        this.userList();
        this.gmpRolesGet();
      }
    },

    /*
     * 机构角色
     */
    gmpRolesGet: function gmpRolesGet() {
      var _this9 = this;

      (0, _userMent.getRoles)({
        id: this.muserId,
        type: 4
      }).then(function (response) {
        // let newArr = [];
        _this9.rolePop.roleArrs = response;
      });
    },

    /*
     * 分页
     */

    pageChange: function pageChange(inx) {
      this.seekStore.no = inx;
      this.userList();
    },
    /*
     * 新增管理员对用户的操作历史记录
     */
    getHistoryList: function getHistoryList() {
      var _this10 = this;

      (0, _userMent.UserAdminOperationList)({
        no: this.no,
        size: this.size
      }).then(function (response) {
        // console.warn('getHistoryList: ', response)
        _this10.historytotalPages = response.totalPages;
        _this10.tableData = response.adminOperations;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_this10.tableData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.type == 1) {
              item.type = "新增";
            } else if (item.type == 2) {
              item.type = "修改信息";
            } else if (item.type == 3) {
              item.type = "分配权限";
            } else if (item.type == 4) {
              item.type = "重置密码";
            } else if (item.type == 5) {
              item.type = "删除";
            }

            // 如果是json 则转成json
            if (_this10.isJSON(item.content)) {
              item.content = JSON.parse(item.content.trim());
            } else {
              item.content = "暂无内容";
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    // 判断字符串是不是json格式
    isJSON: function isJSON(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if ((typeof obj === "undefined" ? "undefined" : (0, _typeof3.default)(obj)) == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },

    /*
     * 新增管理员对用户的操作历史记录的翻页
     */
    historyPageChange: function historyPageChange(inx) {
      this.no = inx;
      this.getHistoryList();
    },
    filterData: function filterData(data, text) {
      console.debug("filterData: ", text);
      if (!text || text.trim() === "") return data;
      text = text.toLowerCase();
      return _lodash2.default.filter(data, function (x) {
        return x.organizationName && x.organizationName.includes(text) || x.account && x.account.includes(text);
      });
    }
  },

  beforeMount: function beforeMount() {
    this.gmpTreeInit();
  },

  created: function created() {
    this.getHistoryList();
    var bdHt = document.body.clientHeight;
    var wsHt = document.documentElement.clientHeight;
    // if(bdHt > wsHt){
    // 		this.leftHt = bdHt - 140;
    // }else{
    // 		this.leftHt = wsHt - 140;
    // }

    this.leftHt = wsHt - 140;

    var scWidth = document.documentElement.clientWidth;
    if (scWidth <= 1280) {
      this.styleSet.edWidth = 420;
    }
  }
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CommonTab = __webpack_require__(346);

var _CommonTab2 = _interopRequireDefault(_CommonTab);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MainTabs: _CommonTab2.default
  },
  data: function data() {
    return {
      frashCode: true,
      opMsg: "",
      postId: "",
      wSat: 0,
      resDat: [{}]
    };
  },

  methods: {
    valChangeSearch: function valChangeSearch(val) {
      var _this = this;

      (0, _pressRole.getPressList)({
        year: val,
        type: 1
      }).then(function (response) {
        console.log("getPressList: ", response, _this.resDat);
        var vm = _this;
        // 显示历史信息，提交控制在里边做
        vm.wSat = 1;
        _this.resDat.splice(0, 1, response);
        console.log("resDat: ", _this.resDat);
      });
    },
    frashHandle: function frashHandle() {
      console.log("验证文件上传后是否刷新页面...");
      var vm = this;
      (0, _pressRole.getPressList)({
        type: 1
      }).then(function (response) {
        vm.resDat.splice(0, 1, response);
        vm.frashCode = false;
        vm.$nextTick(function () {
          vm.frashCode = true;
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var vm = this;

    (0, _pressRole.getPressList)({
      type: 1
    }).then(function (response) {
      console.log("getPressList: ", response, _this2.resDat);

      if (response.pubStatus == 0) {
        vm.wSat = 1;
        _this2.resDat.splice(0, 1, response);
        console.log("resDat: ", _this2.resDat);
      } else if (response.pubStatus == 1) {
        vm.wSat = 2;
      }
    });
  }
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CommonTab = __webpack_require__(346);

var _CommonTab2 = _interopRequireDefault(_CommonTab);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MainTabs: _CommonTab2.default
  },
  data: function data() {
    return {
      frashCode: true,
      opMsg: "",
      postId: "",
      wSat: 0,
      resDat: [{}]
    };
  },

  methods: {
    valChangeSearch: function valChangeSearch(val) {
      var vm = this;
      (0, _pressRole.getPressList)({
        year: val,
        type: 2
      }).then(function (response) {
        console.log("getPressList: ", response, vm.resDat);
        // 显示历史信息，提交控制在里边做
        vm.wSat = 1;
        vm.resDat.splice(0, 1, response);
        console.log("resDat: ", vm.resDat);
      });
    },
    frashHandle: function frashHandle() {
      var vm = this;
      (0, _pressRole.getPressList)({
        type: 2
      }).then(function (response) {
        vm.resDat.splice(0, 1, response);
        vm.frashCode = false;
        vm.$nextTick(function () {
          vm.frashCode = true;
        });
      });
    }
  },
  created: function created() {
    var vm = this;
    var cacheYear = sessionStorage.getItem("selYear");

    (0, _pressRole.getPressList)({
      type: 2
    }).then(function (response) {
      console.log("getPressList: ", response, vm.resDat);
      if (response.pubStatus == 0) {
        vm.wSat = 1;
        vm.resDat.splice(0, 1, response);
        console.log("resDat: ", vm.resDat);
      } else if (response.pubStatus == 1) {
        vm.wSat = 2;
      }
    });
  }
};

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

exports.default = {
  data: function data() {
    return {
      tabDat: [],
      filrUrl1: ""
    };
  },

  filters: {
    strTrans: function strTrans(dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      } else if (code == "type") {
        var transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return transArr[dat - 1];
      } else if (code == "status") {
        var _transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return _transArr[dat - 1];
      } else if (code == "pgstate") {
        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        var regist = {
          1: "未登记",
          2: "已登记"
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    }
  },
  methods: {
    tabInit: function tabInit() {
      var _this = this;

      // 获取当前的年份
      var year1 = this.$store.getters.userInfo.year1;
      (0, _pressRole.getPgress)({
        year1: year1,
        type: 1,
        no: 1,
        size: 15
      }).then(function (response) {
        _this.tabDat = response.examineProgressList;
      });
    },
    goDeep: function goDeep(dat) {
      this.$router.push({
        path: "deep_see",
        query: {
          pressType: dat.type
        }
      });
    }
  },

  created: function created() {
    this.tabInit();
    // this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = "https://ydnj.capub.cn/ydfile" + "/drmb/001.xlsx"; // 封面和盖章页
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

exports.default = {
  data: function data() {
    return {
      tabDat: [],
      filrUrl1: ""
    };
  },

  filters: {
    strTrans: function strTrans(dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      } else if (code == "type") {
        var transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return transArr[dat - 1];
      } else if (code == "status") {
        var _transArr = ["音像制品出版单位", "电子出版物出版单位"];
        return _transArr[dat - 1];
      } else if (code == "pgstate") {
        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        var regist = {
          1: "未登记",
          2: "已登记"
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    }
  },
  methods: {
    tabInit: function tabInit() {
      var _this = this;

      (0, _pressRole.getPgress)({
        type: 1,
        no: 1,
        size: 15
      }).then(function (response) {
        _this.tabDat = response.examineProgressList;
      });
    },
    goDeep: function goDeep(dat) {
      console.log("dat=", dat);
      this.$router.push({
        path: "deep_see",
        query: {
          pressType: dat.type,
          // zym.20241212，增加年份
          firstYear: dat.firstYear,
          cancelFlagStr: "false"
        }
      });
    }
  },

  created: function created() {
    this.tabInit();
    // this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = "https://ydnj.capub.cn/ydfile" + "/drmb/001.xlsx"; // 封面和盖章页
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _paramsEt = __webpack_require__(356);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Upbtn from '@/views/components/upload';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          that.params.publishId = that.$route.query.pressId;
          that.params.publishMaterialId = that.$route.query.mtId;
          if (that.declare.personnel == "") {
            that.$message.error("申报人姓名必填");
            return;
          }
          // var pattern = /^1[0-9]{10}$/;
          // if (!pattern.test(that.declare.contact)) {
          //   that.$message.error('申报人手机号格式错误');
          //   return
          // }
          if (that.declare.contact == "") {
            that.$message.error("申报人联系方式必填");
            return;
          }

          var byyzzZczb = that.params.yyzzZczb > 1500000;
          var bZczb = that.params.registeredCapital > 1500000;
          if (byyzzZczb || bZczb) {
            that.$confirm("请确认注册资本填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error"
            });
            return;
          }

          var msg = "请再次确认页面中所输入的金额单位为万元。";
          that.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            (0, _pressRole.tabUpdate1)({
              data: that.params,
              organizationPersonnel: that.declare,
              // 身份验证要用
              publishMaterialId: _this.params.publishMaterialId
              // code:
            }).then(function (response) {
              var tipCode = response.payload.pbasic.code;
              var tipMessage = response.payload.pbasic.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
              } else {
                that.$message({
                  message: "保存成功！",
                  type: "success"
                });

                // that.editAfter(response);
                that.goBack();
              }
            }).catch(function (error) {
              that.submiting = false;
            });
          }).catch(function () {});
        } else {
          return false;
        }
      });
    },

    editAfter: function editAfter(resDat) {
      // 后台把值从.data里边带回来了.hsj
      if (this.imgId != resDat.payload.pbasic.data.yyzzId) {
        (0, _account.detFile)({
          id: this.imgId
        }).then(function (response) {}).catch(function (error) {});
      }
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C001", "C018", "C019", "C003", "C004"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      var vm = this;
      newPromise.then(function (result) {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (var key in _this2.isNot) {
          if (vm.isNot[key] == "否") {
            vm.params.isIndependentLP = key;
          }
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      console.log("信息读取", this.$route.query.mtId);
      (0, _pressRole.tabRead1)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        _this3.params = response.pbasic;
        _this3.params.publishMaterialId = _this3.$route.query.mtId;

        _this3.imgId = response.pbasic.yyzzId;

        _this3.declare.publishMaterialId = _this3.$route.query.mtId;
        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        _this3.layChange();
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
      this.imgId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
        this.params.nonIndependentLPSituation = "";
      } else {
        this.layDasion = 2;
        this.params.unitType = "";
        this.params.independentLPSituation = "";
        this.params.registeredCapital = 0;
        this.params.totalAssets = 0;
        this.params.totalLiabilities = 0;
      }
    },

    changeHandle: function changeHandle(code) {
      var newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function goBack() {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode201HistoryData: function getcode201HistoryData() {
      var that = this;
      this.imgId = "";
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _pressRole.code201HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        delete response.pbasic.id;
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.pbasic, { publishMaterialId: that.$route.query.mtId });
        that.imgId = response.pbasic.yyzzId;

        // zym.删除申报时间
        delete that.params.updatedAt;
        // if (response.pOrganizationPersonnel !== null && response.pOrganizationPersonnel != undefined) {
        //   that.declare.contact = response.pOrganizationPersonnel.contact;
        //   that.declare.personnel = response.pOrganizationPersonnel.personnel;
        //   // that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        // }
        that.layChange();
      }).catch(function (error) {
        that.submiting = false;
      });
    }
    // //加载loading
    // openFullScreen2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // }
  },
  created: function created() {
    this.dictInit();
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsEt = __webpack_require__(358);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Upbtn from '@/views/components/upload';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 2,
      imgId: "",

      CompanyNatureMap: {},
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0
    };
  },

  watch: {},
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          that.params.publishId = that.$route.query.pressId;
          that.params.publishMaterialId = that.$route.query.mtId;
          if (!that.declare.personnel || that.declare.personnel == "") {
            that.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(that.declare.contact)) {
          //   that.$message.error('申报人手机号格式错误');
          //   return
          // }
          if (!that.declare.contact || that.declare.contact == "") {
            that.$message.error("申报人联系方式必填");
            return;
          }

          (0, _pressRole.tabUpdate209)({
            data: that.params,
            organizationPersonnel: that.declare,
            // 身份验证要用
            publishMaterialId: _this.params.publishMaterialId
            // code:
          }).then(function (response) {
            console.log("response=", (0, _stringify2.default)(response));
            var tipCode = response.payload.pquestionnaire.code;
            var tipMessage = response.payload.pquestionnaire.message;

            that.submiting = false;
            if (tipCode == -1) {
              that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
            } else {
              that.$message({
                message: "保存成功！",
                type: "success"
              });

              // that.editAfter(response);
              that.goBack();
            }
          }).catch(function (error) {
            that.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    editAfter: function editAfter(resDat) {
      // 后台把值从.data里边带回来了.hsj
      if (this.imgId != resDat.payload.pbasic.data.yyzzId) {
        (0, _account.detFile)({
          id: this.imgId
        }).then(function (response) {}).catch(function (error) {});
      }
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C001", "C018", "C019", "C003", "C004"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      var vm = this;
      newPromise.then(function (result) {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.CompanyNatureMap = vm.$store.getters.dictionary["C001"];
        for (var key in _this2.isNot) {}
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      console.log("信息读取", this.$route.query.mtId);
      (0, _pressRole.tabRead209)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        // console.log('response.pquestionnaire=',JSON.stringify(response.pquestionnaire))
        _this3.params = response.pquestionnaire;
        _this3.params.publishMaterialId = _this3.$route.query.mtId;

        _this3.declare.publishMaterialId = _this3.$route.query.mtId;
        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    changeHandle: function changeHandle(code) {
      var newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.clDate).getTime() > newDate) {
          this.params.clDate = "";
          this.$message.error("成立时间不可大于当前日期！");
        } else {
          if (!this.params.startYyDate) {
            this.params.startYyDate = this.params.clDate;
          }
        }
      } else if (code == 2) {
        if (new Date(this.params.startYyDate).getTime() > newDate) {
          this.params.startYyDate = "";
          this.$message.error("营业开始时间不可大于当前日期！");
        } else if (this.params.endYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.startYyDate = "";
            this.$message.error("营业开始时间不可大于营业结束日期！");
          }
        }
      } else if (code == 3) {
        if (this.params.startYyDate) {
          if (new Date(this.params.endYyDate).getTime() < new Date(this.params.startYyDate).getTime()) {
            this.params.endYyDate = "";
            this.$message.error("营业结束日期不能小于营业开始日期！");
          }
        }
      } else if (code == 4) {
        if (new Date(this.params.djDate).getTime() > newDate) {
          this.params.djDate = "";
          this.$message.error("营业登记时间不可大于当前日期！");
        }
      }
    },
    // 返回上一页
    goBack: function goBack() {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode201HistoryData: function getcode201HistoryData() {
      var that = this;
      this.imgId = "";
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      code201HistoryData({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        delete response.pbasic.id;
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.pbasic, { publishMaterialId: that.$route.query.mtId });
        that.imgId = response.pbasic.yyzzId;
        if (response.pOrganizationPersonnel !== null) {
          that.declare.contact = response.pOrganizationPersonnel.contact;
          that.declare.personnel = response.pOrganizationPersonnel.personnel;
          that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      }).catch(function (error) {
        that.submiting = false;
      });
    }
    // //加载loading
    // openFullScreen2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // }
  },
  created: function created() {
    this.dictInit();
    console.log("this.$route.query.pgress=", this.$route.query.pgress);
    this.pubStatus = this.$route.query.pubStatus;
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsEt = __webpack_require__(357);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadSingle = __webpack_require__(344);

var _uploadSingle2 = _interopRequireDefault(_uploadSingle);

var _uploadPdf = __webpack_require__(176);

var _uploadPdf2 = _interopRequireDefault(_uploadPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Upbtn from '@/views/components/uploadCards';

// import Upbtn from "@/views/components/upload/uploadCards"
exports.default = {
  components: {
    Upbtn: _uploadSingle2.default,
    UpbtnPdf: _uploadPdf2.default
  },
  data: function data() {
    return {
      urls1: "",
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      imgId: "",
      pressType: "",
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0,

      publishFileId: "",
      xkzFileId1: "",
      xkzFileId2: "",
      xkzFileId3: "",
      xkzFileId4: "",
      xkzFileId5: "",
      xkzFileId6: "",

      cats: [{ code: "1", name: "行政机关" }, { code: "2", name: "事业单位" }, { code: "3", name: "企业法人" }, { code: "4", name: "社团法人" }, { code: "5", name: "其他" }]
    };
  },


  methods: {
    // zym.发文文件
    fileTdSetPublishFileId: function fileTdSetPublishFileId(id) {
      this.params.publishFileId = id;
      this.publishFileId = id;
    },
    // zym.废弃(原来一个许可证的时候使用)
    fileTdSet: function fileTdSet(id) {
      this.params.xkzFileId = id;
    },
    fileTdSet1: function fileTdSet1(dat, btnProps) {
      // console.log("dat=", dat);
      console.log("btnProps=", (0, _stringify2.default)(btnProps));

      var colId = btnProps.colId;
      this.params[colId] = dat;

      this[colId] = dat;
    },
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error("申报人手机号格式错误")
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error("申报人联系方式必填");
            return;
          }
          (0, _pressRole.mebUpdate)({
            // pqualification: this.params,
            data: _this.params,
            organizationPersonnel: _this.declare,
            // 身份验证要用
            publishMaterialId: _this.params.publishMaterialId
          }).then(function (response) {
            console.log("response=", (0, _stringify2.default)(response));
            var tipCode = response.payload.pqualification.code;
            var tipMessage = response.payload.pqualification.message;

            _this.submiting = false;
            if (tipCode == -1) {
              _this.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
            } else {
              _this.$message({
                message: "保存成功！",
                type: "success"
              });
              // this.editAfter()

              _this.goBack();
            }
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      console.log("this.$route.query.mtId=", this.$route.query.mtId);
      (0, _pressRole.tabRead2)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        _this2.params = response.pqualification;

        _this2.publishFileId = response.pqualification.publishFileId;
        _this2.xkzFileId1 = response.pqualification.xkzFileId1;
        _this2.xkzFileId2 = response.pqualification.xkzFileId2;
        _this2.xkzFileId3 = response.pqualification.xkzFileId3;
        _this2.xkzFileId4 = response.pqualification.xkzFileId4;
        _this2.xkzFileId5 = response.pqualification.xkzFileId5;
        _this2.xkzFileId6 = response.pqualification.xkzFileId6;

        // console.log('xkzFileId1=',that.xkzFileId1);

        // this.imgId = response.pqualification.xkzFileId
        if (response.pOrganizationPersonnel !== null) {
          _this2.declare.contact = response.pOrganizationPersonnel.contact;
          _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    editAfter: function editAfter() {
      if (this.params.xkzFileId != this.imgId) {
        // detFile({
        //   id: this.imgId
        // }).then(response => {}).catch(error => {})
      }
    },

    changeHandle: function changeHandle(code) {
      var newDate = new Date().getTime();
      if (code == 1) {
        if (new Date(this.params.yxStartDate).getTime() > newDate) {
          this.params.yxStartDate = "";
          this.$message.error("有效开始日期不能大于当前日期！");
        }
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    //获取历史导入数据
    getcode202HistoryData: function getcode202HistoryData() {
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      (0, _pressRole.code202HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        // this.params = response.pqualification
        delete response.pqualification.id;
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.pqualification, { publishMaterialId: that.$route.query.mtId });
        // zym.删除申报时间
        delete that.params.updatedAt;

        // that.publishFileId = response.pqualification.publishFileId
        // that.xkzFileId1 = response.pqualification.xkzFileId1
        // that.xkzFileId2 = response.pqualification.xkzFileId2
        // that.xkzFileId3 = response.pqualification.xkzFileId3
        // that.xkzFileId4 = response.pqualification.xkzFileId4
        // that.xkzFileId5 = response.pqualification.xkzFileId5
        // that.xkzFileId6 = response.pqualification.xkzFileId6

        // console.log('xkzFileId1=',that.xkzFileId1);

        // console.log("response.pOrganizationPersonnel=", response.pOrganizationPersonnel);
        // that.declare.contact = response.pOrganizationPersonnel.contact;
        // that.declare.personnel = response.pOrganizationPersonnel.personnel;
        // that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      }).catch(function (error) {
        that.submiting = false;
      });
    }
  },
  created: function created() {
    this.pressType = this.$route.query.pressType;
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(359);

var _pressRole = __webpack_require__(7);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      pressType: this.$route.query.pressType,
      yearSet: {
        year1: "",
        year2: ""
      },
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this.declare.personnel == "") {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //      this.$message.error("申报人手机号格式错误")
          //      return
          // }
          if (_this.declare.contact == "") {
            _this.$message.error("申报人联系方式必填");
            return;
          }
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          _this.params.firstYear = _this.yearSet.year1;
          _this.params.secondYear = _this.yearSet.year2;

          var bFirst = that.params.firstTotalSales > 500000;
          var bSecond = that.params.secondTotalSales > 500000;
          if (bFirst || bSecond) {
            that.$confirm("请确认年销售收入填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error"
            });
            return;
          }

          var nTotalFirst = that.params.firstZtcbVariety + that.params.firstWlcbVariety;
          var nTotalSecond = that.params.secondZtcbVariety + that.params.secondWlcbVariety;
          var bTotalCheckFirst = that.params.firstPublicationVariety != nTotalFirst;
          var bTotalCheckSecond = that.params.secondPublicationVariety != nTotalSecond;
          // zym.注释 start
          // if (bTotalCheckFirst || bTotalCheckSecond) {
          //   that.$confirm('请确认出版品种数填写的是否正确。', '提示', {
          //     confirmButtonText: '确定', //确认按钮的文字
          //     showCancelButton: false, //是否显示取消按钮
          //     showClose: false, //是否显示关闭按钮
          //     closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
          //     type: 'error'
          //   });
          //   return
          // };
          // zym.注释 end

          var msg = "请再次确认页面中所输入的金额单位为万元。";
          that.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            (0, _pressRole.tabUpdate3)({
              // pfinance: this.params,
              // 代码通用模块化
              data: that.params,
              organizationPersonnel: that.declare,
              // 身份验证要用
              publishMaterialId: that.params.publishMaterialId
            }).then(function (response) {
              var tipCode = response.payload.pfinance.code;
              var tipMessage = response.payload.pfinance.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
                return;
              }

              _this.$message({
                message: "保存成功！",
                type: "success"
              });

              _this.goBack();
            }).catch(function (error) {
              that.submiting = false;
            });
          }).catch(function () {});
        } else {
          return false;
        }
      });
    },

    goBack: function goBack() {
      for (var key in this.params) {
        this.params[key] = "";
      }
      this.$router.go(-1);
      // let pathStr = 'audio_press';
      // if(this.$route.query.pressType == 2){
      //     pathStr = 'elect_press';
      // }
      // this.$router.push({
      //   path:pathStr
      // });
    },
    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead3)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        console.log("response=", response);
        if (response.pfinance) {
          // 新增
          if (_this2.$route.query.pgress == 1) {
            // 处理年份
            _this2.yearSet.year1 = response.pfinance.firstYear;
            _this2.yearSet.year2 = Number(response.pfinance.firstYear) + 1;
          } else {
            _this2.params = response.pfinance;

            // 处理年份
            _this2.yearSet.year1 = _this2.params.firstYear;
            _this2.yearSet.year2 = Number(_this2.params.firstYear) + 1;

            if (response.pOrganizationPersonnel !== null) {
              _this2.declare.contact = response.pOrganizationPersonnel.contact;
              _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
              _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
            }
          }
        }
      });
    }
  },
  created: function created() {
    var newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2
    // this.yearSet.year2 = newDate.getFullYear() - 1
    this.pubStatus = this.$route.query.pubStatus;
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
  }

  // beforeDestroy:function(){
  // 		 for(let key in this.params){
  // 					this.params[key] = '';
  // 		 }
  // }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(360);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C002: {},
        C020: {}
      },
      pubStatus: 0
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          (0, _pressRole.tabUpdate4)({
            // pplace: this.params,
            // 模组化
            data: _this.params,
            // 身份验证要用
            publishMaterialId: _this.params.publishMaterialId
          }).then(function (response) {
            var tipCode = response.payload.pplace.code;
            var tipMessage = response.payload.pplace.message;

            that.submiting = false;
            if (tipCode == -1) {
              that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
              return;
            }
            _this.$message({
              message: "保存成功！",
              type: "success"
            });

            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C002", "C020"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.dicMap["C002"] = _this2.$store.getters.dictionary["C002"];
        _this2.dicMap["C020"] = _this2.$store.getters.dictionary["C020"];
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      (0, _pressRole.tabRead4)({ id: this.$route.query.id }).then(function (response) {
        _this3.params = response.pplace;
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(361);

var _pressRole = __webpack_require__(7);

var _date = __webpack_require__(631);

var _date2 = _interopRequireDefault(_date);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TimeSelect: _date2.default
  },
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      dicDats: {},
      submiting: false,
      htTime: "",

      dicMap: {},
      pubStatus: 0
      // 日期格式
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          (0, _pressRole.tabUpdate5)({
            // pcommend: this.params,
            // 模组化
            data: _this.params,
            // 身份验证要用
            publishMaterialId: _this.params.publishMaterialId
          }).then(function (response) {
            var tipCode = response.payload.pcommend.code;
            var tipMessage = response.payload.pcommend.message;

            that.submiting = false;
            if (tipCode == -1) {
              that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
              return;
            }
            _this.$message({
              message: "保存成功！",
              type: "success"
            });
            // this.params.isIndependentLP = 1;
            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C023", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.dicMap["C024"] = _this2.$store.getters.dictionary["C024"];
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      (0, _pressRole.tabRead5)({
        id: this.$route.query.id
      }).then(function (response) {
        _this3.params = response.pcommend;
        _this3.htTime = _this3.params.hjDate;
      });
    },

    inpDisableCtrls: function inpDisableCtrls(val) {
      if (this.params.isIndependentLP == 1) {
        this.inpDisable = false;
      } else if (this.params.isIndependentLP == 2) {
        this.inpDisable = true;
      }
    },

    changeHandle: function changeHandle() {
      var newDate = new Date().getTime();
      if (new Date(this.params.hjDate).getTime() > newDate) {
        this.params.hjDate = "";
        this.$message.error("表彰时间不可大于当前日期！");
      }
    },

    timeUpdate: function timeUpdate(dat) {
      this.params.hjDate = dat;
      // // console.log(dat);
      // console.log()
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(362);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      pressType: this.$route.query.pressType,
      dicDats: {},
      submiting: false,
      dicMap: {
        C021: {},
        C024: {}
      },
      pubStatus: 0
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        _this.params.publishId = _this.$route.query.pressId;
        _this.params.publishMaterialId = _this.$route.query.mtId;
        if (valid) {
          (0, _pressRole.tabUpdate6)({
            // pimportantproducts: this.params
            // 模组化
            data: _this.params,
            // 身份验证要用
            publishMaterialId: _this.params.publishMaterialId
          }).then(function (response) {
            var tipCode = response.payload.pimportantproducts.code;
            var tipMessage = response.payload.pimportantproducts.message;

            that.submiting = false;
            if (tipCode == -1) {
              that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
              return;
            }
            _this.$message({
              message: "保存成功！",
              type: "success"
            });

            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead6)({ id: this.$route.query.id }).then(function (response) {
        _this2.params = response.pimportantproducts;
      });
    },

    dictInit: function dictInit() {
      var _this3 = this;

      var nameArr = ["C021", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this3.dicDats = result;
        _this3.dicMap["C021"] = _this3.$store.getters.dictionary["C021"];
        _this3.dicMap["C024"] = _this3.$store.getters.dictionary["C024"];
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
      // this.$router.push({
      //      path:'view_tab6',
      //      query:{
      //          pressId:this.$route.query.pressId,
      //          mtId:this.$route.query.mtId,
      //          pressType:this.$route.query.pressType,
      //      }
      //  });
    }
  },

  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constraints = __webpack_require__(810);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: {
        isPunishment: "",
        punishment: "",

        id: "",
        publishId: "",
        publishMaterialId: ""
        // 可能是缩紧不对写错位置了
        // basFirm:true,
        // isMap:{},
        // updatedAt:'',
      },
      isMap: {},
      basFirm: true,
      rules: {
        isPunishment: [{ required: true, message: "请选择", trigger: "change" }],
        punishment: [{ required: true, message: "不能为空！", trigger: "blur" }, { max: 600, message: "填写内容过长！", trigger: "change" }]
      },
      dicDats: {},
      submiting: false,
      declare: {
        personnel: "",
        contact: ""
      },
      pubStatus: 0
    };
  },

  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        _this.params.publishId = _this.$route.query.pressId;
        _this.params.publishMaterialId = _this.$route.query.mtId;
        if (!_this.declare.personnel) {
          _this.$message.error("申报人姓名必填");
          return;
        }
        // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
        // 	this.$message.error('申报人手机号格式错误');
        // 	return
        // }
        if (!_this.declare.contact) {
          _this.$message.error("申报人联系方式必填");
          return;
        }
        if (valid) {
          (0, _pressRole.tabUpdate7)({
            publishMaterialId: _this.params.publishMaterialId,
            data: _this.params,
            organizationPersonnel: _this.declare
          }).then(function (response) {
            var tipCode = response.payload.ppunishment.code;
            var tipMessage = response.payload.ppunishment.message;

            _this.submiting = false;
            if (tipCode == -1) {
              _this.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
            } else {
              _this.$message({
                message: "保存成功！",
                type: "success"
              });

              // this.editAfter(response);
              _this.goBack();
            }

            // console.log('response: ', response)
            // this.submiting = false;
            // if (response.code && response.code != 0) {
            // 	console.error('提交错误: ', response.message, response)
            // 	this.$message.error(`提交错误: ${response.message || response.error}`);
            // 	return
            // }
            // this.$message({
            // 		message: '保存成功！',
            // 		type: 'success'
            // });
            // this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressRole.tabRead7)({ publishMaterialId: this.$route.query.mtId }).then(function (response) {
        _this2.params = response.ppunishment;
        if (response.pOrganizationPersonnel !== null) {
          _this2.declare.contact = response.pOrganizationPersonnel.contact;
          _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
          // TODO: 这个完全没必要吧？ 概念混了？
          // this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },

    dictInit: function dictInit() {
      var _this3 = this;

      var nameArr = ["C018"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then(function (result) {
        _this3.isMap = _this3.$store.getters.dictionary["C018"];
        console.debug("isMap: ", _this3.isMap);
        _this3.dicDats = result;
      });
    },

    isHandle: function isHandle() {
      if (this.isMap[this.params.isPunishment] == "是") {
        this.basFirm = true;
      } else {
        this.basFirm = false;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  }
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsEt = __webpack_require__(363);

var _pressRole = __webpack_require__(7);

var _account = __webpack_require__(16);

var _uploadCards = __webpack_require__(124);

var _uploadCards2 = _interopRequireDefault(_uploadCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    Upbtn: _uploadCards2.default
  },
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      rules: _paramsEt.paramsRule,
      submiting: false,
      dicDats: {},

      urls1: "",
      urls2: "",
      btnCtrls1: false,
      btnCtrls2: false,

      dicMap: {
        C018: {},
        C009: {},
        C022: {}
      },
      systemTime: "",
      highLight: false,
      pubStatus: 0
    };
  },

  methods: {
    // 判断证书取得时间与当前时间的时间差
    selectTime: function selectTime(e) {
      this.params.getCertificateTime = new Date(e).getTime();
      //选择时间距今如果超过5年，则高亮显示已过期
      var timeDifference = new Date().getTime() - this.params.getCertificateTime;
      if (timeDifference >= 24 * 60 * 60 * 1000 * 1820) {
        this.highLight = true;
      } else {
        this.highLight = false;
      }
    },
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });

      newPromise.then(function (result) {
        _this.dicDats = result;
        // this.isNot = this.$store.getters.dictionary['C018'];
        // this.isCertificate = this.$store.getters.dictionary['C009'];
        _this.dicMap["C018"] = _this.$store.getters.dictionary["C018"];
        _this.dicMap["C009"] = _this.$store.getters.dictionary["C009"];
        _this.dicMap["C022"] = _this.$store.getters.dictionary["C022"];
      });
    },

    editSave: function editSave(name) {
      var _this2 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this2.params.publishId = _this2.$route.query.pressId;
          _this2.params.publishMaterialId = _this2.$route.query.mtId;
          _this2.params.publishType = _this2.$route.query.pressType;

          var errpop = [];

          if (_this2.btnCtrls1 && !_this2.params.professionalCertificateId) {
            errpop.push("请上传出版专业职业资格证书证照");
          }

          if (_this2.params.type != 3) {
            if (_this2.btnCtrls2 && !_this2.params.trainCertificateId) {
              errpop.push("请上传岗位培训合格证书证照");
            }
          }

          if (errpop.length > 0) {
            _this2.$message.error(errpop[0]);
          } else {
            _this2.saveAct();
          }
        } else {
          return false;
        }
      });
    },

    saveAct: function saveAct() {
      var _this3 = this;

      (0, _pressRole.tabUpdate8)({
        data: this.params,
        // organizationPersonnel:this.declare,
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        console.log("response=", (0, _stringify2.default)(response));
        var tipCode = response.payload.pworker.code;
        var tipMessage = response.payload.pworker.message;

        _this3.submiting = false;
        if (tipCode == -1) {
          _this3.$message.error("" + tipMessage);
        } else {
          console.debug("tabUpdate8: ", response);
          _this3.submiting = false;
          _this3.$message({
            message: "保存成功！",
            type: "success"
          });
          // this.editAfter(response);
          _this3.goBack();
        }
      }).catch(function (error) {
        _this3.submiting = false;
      });
    },

    editAfter: function editAfter(resDat) {
      if (this.params.professionalCertificateId != this.urls1) {
        (0, _account.detFile)({
          id: this.urls1
        });
      }

      if (this.params.trainCertificateId != this.urls2) {
        (0, _account.detFile)({
          id: this.urls2
        });
      }
    },

    btnCtrls: function btnCtrls(type) {
      if (type == 1) {
        if (this.dicMap["C009"][this.params.certificateSituation] == "暂时没有证书") {
          this.btnCtrls1 = false;
          this.params.professionalCertificateId = "";
          this.urls1 = "";
        } else {
          this.btnCtrls1 = true;
        }
      } else if (type == 2) {
        if (this.dicMap["C018"][this.params.isTrainCertificate] == "否") {
          this.btnCtrls2 = false;
          this.params.trainCertificateId = "";
          this.urls2 = "";
        } else {
          this.btnCtrls2 = true;
        }
      }
    },

    menReEdit: function menReEdit() {
      var _this4 = this;

      (0, _pressRole.tabRead8)({
        id: this.$route.query.id
      }).then(function (response) {
        _this4.params = response.pworker;
        _this4.urls1 = _this4.params.professionalCertificateId;
        _this4.urls2 = _this4.params.trainCertificateId;

        if (_this4.dicMap["C009"][_this4.params.certificateSituation] != "暂时没有证书") {
          _this4.btnCtrls1 = true;
        }

        if (_this4.dicMap["C018"][_this4.params.isTrainCertificate] != "否") {
          _this4.btnCtrls2 = true;
        }
      });
    },

    fileTdSet1: function fileTdSet1(dat) {
      this.params.professionalCertificateId = dat;
    },

    fileTdSet2: function fileTdSet2(dat) {
      this.params.trainCertificateId = dat;
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.menReEdit();
    } else {
      this.params.type = 3;
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paramsEt = __webpack_require__(263);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsEt.bsParams,
      pressType: this.$route.query.pressType,
      rules: _paramsEt.paramsRule,
      submiting: false,
      dicDats: {},
      mediaTyp1: {},
      mediaTyp2: {},
      numShow: true,
      // 是否显示出版时间
      publishingTimeShow: true,
      yearOpts: [{ code: 2021, name: "2021年" }, { code: 2022, name: "2022年" }],

      timeStore: {
        time1: ""
      },

      //编辑模式下可以变更的项目有限
      onlyEditMode: true,
      checked: false,
      emptyDate: {
        year: "", // 年度
        publicationName: "无", // 出版物名称
        isbn: "无", // 专用书号 ISBN
        carrierForm: "", // 载体形式（选择项）
        carrierFormQT: "未出版", // 载体形式其他
        publicationForm: "", // 出版形式（选择项）
        productionUnit: "无", // 节目来源/制作单位
        programCapacity: 0, // 节目时长或容量(分钟/兆)
        publicationQuantity: 0, // 出版数量（张/盒）
        issueQuantity: 0, // 发行数量（张/盒）
        unitPrice: 0, // 发行单价（元）
        publishingTime: "2019-04-22", // 出版时间
        sampleDelivery: "", // 样品缴送（选择项）
        sign: "", // 书配盘标记（选择项）

        publishMaterialId: "", // publishMaterialId
        publishId: "" // 出版单位ID
      },
      pubStatus: 0
    };
  },

  methods: {
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ["C010", "C011", "C018", "C025", "C012"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      var vm = this;
      newPromise.then(function (result) {
        vm.dicDats = result;
        vm.isNot = vm.$store.getters.dictionary["C018"];
        vm.mediaTyp1 = vm.$store.getters.dictionary["C010"];
        vm.mediaTyp2 = vm.$store.getters.dictionary["C025"];

        for (var key in vm.isNot) {
          if (vm.isNot[key] == "否") {
            vm.params.sampleDelivery = key;
            _this.emptyDate.sampleDelivery = key;
            _this.emptyDate.sign = key;
          }
        }

        if (_this.pressType == 1) {
          for (var _key in vm.mediaTyp1) {
            if (vm.mediaTyp1[_key] == "其他") {
              _this.emptyDate.carrierForm = _key;
            }
          }
        } else if (_this.pressType == 2) {
          for (var _key2 in vm.mediaTyp2) {
            if (vm.mediaTyp2[_key2] == "其他") {
              _this.emptyDate.carrierForm = _key2;
            }
          }
        }
      });
    },

    numHandle: function numHandle() {
      // 音像
      if (this.pressType == 1) {
        if (this.mediaTyp1[this.params.carrierForm] == "电子-信息网络出版") {
          this.numShow = false;
        } else if (this.mediaTyp1[this.params.carrierForm] == "电子出版-电子书") {
          this.rules.publishingTime[0].required = false;
          // this.publishingTimeShow = false;
        } else {
          this.rules.publishingTime[0].required = true;
          // this.publishingTimeShow = true;
          this.numShow = true;
        }
      }
      // 电子
      else if (this.pressType == 2) {
          if (this.mediaTyp2[this.params.carrierForm] == "电子-信息网络出版") {
            this.numShow = false;
          } else if (this.mediaTyp2[this.params.carrierForm] == "电子出版-电子书") {
            this.rules.publishingTime[0].required = false;
            // this.publishingTimeShow = false;
          } else {
            this.rules.publishingTime[0].required = true;
            // this.publishingTimeShow = true;
            this.numShow = true;
          }
        }

      if (this.numShow == false) {
        this.params.publicationQuantity = 0;
        this.params.issueQuantity = 0;
        this.params.unitPrice = 0;
      }
    },

    editSave: function editSave(name) {
      var _this2 = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this2.params.publishId = _this2.$route.query.pressId;
          _this2.params.publishMaterialId = _this2.$route.query.mtId;
          _this2.params.type = _this2.$route.query.pressType;

          _this2.emptyDate.publishId = _this2.$route.query.pressId;
          _this2.emptyDate.publishMaterialId = _this2.$route.query.mtId;

          var postDat = {
            //后台身份验证用.hsj
            publishMaterialId: _this2.$route.query.mtId
          };
          if (_this2.checked) {
            _this2.emptyDate.year = _this2.params.year;
            //    postDat.ppublication = this.emptyDate;
            postDat.data = _this2.emptyDate;
          } else {
            //    postDat.ppublication = this.params;
            postDat.data = _this2.params;
          }

          //参数写在外边了
          (0, _pressRole.tabUpdate9)(postDat).then(function (response) {
            var tipCode = response.payload.ppublication.code;
            var tipMessage = response.payload.ppublication.message;

            that.submiting = false;
            if (tipCode == -1) {
              that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
              return;
            }
            _this2.$message({
              message: "保存成功！",
              type: "success"
            });

            _this2.goBack();
          }).catch(function (error) {
            _this2.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    btnCtrls: function btnCtrls(type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    mtReEdit: function mtReEdit() {
      var _this3 = this;

      (0, _pressRole.tabRead9)({ id: this.$route.query.id }).then(function (response) {
        _this3.params = response.ppublication;
        _this3.timeStore.time1 = _this3.params.publishingTime;
        // 只有电子里面有这个选项
        if (_this3.mediaTyp2[_this3.params.carrierForm] == "电子出版-电子书") {
          _this3.rules.publishingTime[0].required = false;
          // this.publishingTimeShow = false;
        } else {
          _this3.rules.publishingTime[0].required = true;
          // this.publishingTimeShow = true;
        }
      });
    },

    goBack: function goBack() {
      var page = sessionStorage.getItem("fromPage");
      sessionStorage.setItem("toPage", page);
      this.$router.go(-1);
    },

    timeTrans: function timeTrans(dat, strName) {
      var dayv = new Date(dat);
      var y = dayv.getFullYear();
      var m = dayv.getMonth() + 1;
      var d = dayv.getDate();

      if (m < 10) {
        m = "0" + m;
      }

      if (d < 10) {
        d = "0" + d;
      }

      this.params[strName] = y + "-" + m + "-" + d;
    }
  },
  created: function created() {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.mtReEdit();
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

exports.default = {
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15
      }
    };
  },

  filters: {
    translate: function translate(dat, code, transMap) {
      return transMap[code][dat];
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      var nowYear = new Date().getFullYear();

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = nowYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = nowYear - 1;
      }

      (0, _pressRole.tabList3)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.ppublicationList;
          vm.loading = false;
        }, 300);
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var params = {};
      var message = '确定删除出版物 "' + dat.publicationName + '" 的在库信息吗？';

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确定删除所有选中人员的在库信息吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this2.$route.query.mtId;
        (0, _pressRole.tab3Remove)(params).then(function (response) {
          _this2.tabSeek();
        }).catch(function (error) {});
      });
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操作会删除所有已录入数据库的出版物信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab3Clean)().then(function (response) {
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ["C010", "C011", "C018"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.replace({
        path: "edit_tab3",
        query: pathParams
      });
    }
  },
  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

exports.default = {
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: "",
        no: 1,
        size: 15
      },
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      allPage: "",
      pubStatus: 0
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, row) {
      if (code == "C002" && transMap[code][dat] == "其他") {
        return row.otherSituation;
      } else if (code == "C020" && transMap[code][dat] == "其他") {
        return row.otherPower;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList4)(this.seekPms).then(function (response) {
        console.debug("tabList4", response, _this.seekPms);
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pPlaceList;
          vm.loading = false;
          vm.allPage = response.totalPages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          _this.declare.contact = response.pOrganizationPersonnel.contact;
          _this.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var params = {};
      var message = "删除后无法恢复，是否继续？";
      if (type == 1) {
        params.ids = this.detArrs;
        message = "确认删除所有选中项吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
        message = "确认删除吗？";
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this2.$route.query.mtId;
        (0, _pressRole.tab4Remove)(params).then(function (response) {
          _this2.tabSeek();
        }).catch(function (error) {});
      });
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操作会删除所有出版物信息，确认全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab4Clean)().then(function (response) {
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ["C002", "C020"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab4",
        query: pathParams
      });
    },

    goPage: function goPage(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function postDeclareFun() {
      var that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      // 	this.$message.error('申报人手机号格式错误');
      // 	return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      (0, _pressRole.submitDeclare)({
        // hsj.手动加code，统一模组化
        code: "204",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare
      }).then(function (response) {
        var tipCode = response.payload.code;
        var tipMessage = response.payload.message;

        that.submiting = false;
        if (tipCode == -1) {
          that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
          return;
        }

        that.$message({
          message: "保存成功！",
          type: "success"
        });

        that.goBack();
      }).catch(function (error) {
        console.log(error);
      });
    },
    //获取历史导入数据
    getcode204HistoryData: function getcode204HistoryData() {
      var _this5 = this;

      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _pressRole.code204HistoryData)({
        publishMaterialId: this.$route.query.mtId,
        no: 1,
        size: 15
      }).then(function (response) {
        loading.close();
        _this5.tabDat = response.pPlaceList;
        _this5.loading = false;
        _this5.allPage = response.totalPages;
        _this5.declare.contact = response.pOrganizationPersonnel.contact;
        _this5.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this5.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
      }).catch(function (error) {
        _this5.submiting = false;
      });
    }
  },
  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_initPagin2.default],
  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: "",
        no: 1,
        size: 15
      },
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      pubStatus: 0
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowdat) {
      if (code == "C024" && transMap[code][dat] == "其他") {
        return rowdat.hjLevelOther;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList5)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pCommendList;
          vm.loading = false;
          vm.allPage = response.totalPages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          _this.declare.contact = response.pOrganizationPersonnel.contact;
          _this.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var params = {};
      var message = "";

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确认删除所有选中项吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
        message = "确定删除吗？";
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this2.$route.query.mtId;

        if (params.ids.length == 0) {
          _this2.$message.error("请勾选所想要删除的项！");
        } else {
          (0, _pressRole.tab5Remove)(params).then(function (response) {
            _this2.tabSeek();
          }).catch(function (error) {});
        }
      });
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操将永久删除全部信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab5Clean)({
          publishMaterialId: _this3.$route.query.mtId
        }).then(function (response) {
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ["C023", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map"
      });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab5",
        query: pathParams
      });
    },

    goPage: function goPage(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function postDeclareFun() {
      var that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('申报人手机号格式错误');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      (0, _pressRole.submitDeclare)({
        // hsj.手动加code，统一模组化
        code: "205",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare
      }).then(function (response) {
        var tipCode = response.payload.code;
        var tipMessage = response.payload.message;

        that.submiting = false;
        if (tipCode == -1) {
          that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
          return;
        }

        that.$message({
          message: "保存成功！",
          type: "success"
        });

        that.goBack();
      }).catch(function (error) {
        console.log(error);
      });
    },
    filterData: function filterData(data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      var text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      return _.filter(data, function (x) {
        // if (params.type !=0 && x.type != params.type) return false
        return x.hjName && x.hjName.includes(text) || x.bjName && x.bjName.includes(text);
      });
    }
  },
  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
  }
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_initPagin2.default],
  data: function data() {
    return {
      loading: false,
      pressType: this.$route.query.pressType,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: "",
        no: 1,
        size: 15
      },
      allPage: 0,
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      pubStatus: 0
    };
  },

  filters: {
    translate: function translate(dat, code, transMap) {
      if (code == "C021") {
        if (transMap[code][dat.importantProName] == "其他") {
          return dat.importantProNameOther;
        } else {
          return transMap[code][dat.importantProName];
        }
      } else if (code == "C024") {
        if (transMap[code][dat.hjLevel] == "其他") {
          return dat.hjLevelOther;
        } else {
          return transMap[code][dat.hjLevel];
        }
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList6)(this.seekPms).then(function (response) {
        var vm = _this;
        setTimeout(function () {
          vm.tabDat = response.pImportantProductsList;
          vm.loading = false;
          vm.allPage = response.totalPages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          _this.declare.contact = response.pOrganizationPersonnel.contact;
          _this.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this2 = this;

      var params = {};
      var message = "";

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确认删除所有选中项吗？";
      } else if (type == 2) {
        message = "确认删除吗？";
        params.ids = [dat.id];
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this2.$route.query.mtId;
        (0, _pressRole.tab6Remove)(params).then(function (response) {
          _this2.tabSeek();
        }).catch(function (error) {});
      });
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操作会删除所有出版物信息，确认全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab6Clean)().then(function (response) {
          _this3.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      var nameArr = ["C021", "C024"];
      var newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab6",
        query: pathParams
      });
    },
    goPage: function goPage(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function postDeclareFun() {
      var that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      // 	this.$message.error('申报人手机号格式错误');
      // 	return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      (0, _pressRole.submitDeclare)({
        // hsj.手动加code，统一模组化
        code: "206",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare
      }).then(function (response) {
        var tipCode = response.payload.code;
        var tipMessage = response.payload.message;

        that.submiting = false;
        if (tipCode == -1) {
          that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
          return;
        }
        that.$message({
          message: "保存成功！",
          type: "success"
        });

        that.goBack();
      }).catch(function (error) {
        console.log(error);
      });
    },
    filterData: function filterData(data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      var text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      return _.filter(data, function (x) {
        // if (params.type !=0 && x.type != params.type) return false
        return x.proName && x.proName.includes(text);
      });
    }
  },
  created: function created() {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
  }
};

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _lodash = __webpack_require__(341);

var _lodash2 = _interopRequireDefault(_lodash);

var _pressRole = __webpack_require__(7);

var _excel = __webpack_require__(207);

var _excel2 = _interopRequireDefault(_excel);

var _excelError = __webpack_require__(208);

var _excelError2 = _interopRequireDefault(_excelError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_initPagin2.default],
  components: {
    ExcelIn: _excel2.default,
    ExError: _excelError2.default
  },

  data: function data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      fileToken: "",
      seekPms: {
        type: 0,
        keyword: "",
        no: 1,
        size: 15
      },
      allPage: 0,

      excelModeUrl: "",
      pressType: "",
      excelEr: "",
      // 图片查看
      dialogVisible: false,
      imgShowUrl: "",
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      pubStatus: 0
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowDat) {
      if (code == "C022" && transMap[code][dat] == "其他") {
        return rowDat.professionalOther;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (code == "time" && dat && dat.length > 10) {
        return dat.substr(0, 10);
      } else if (code == "time" && dat && dat.length <= 10) {
        return dat;
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(type) {
      var _this = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      (0, _pressRole.tabList8)(this.seekPms).then(function (response) {
        console.debug("tabList8: ", response);
        var vm = _this;
        setTimeout(function () {
          vm.loading = false;
          vm.tabDat = response.pworkerList;
          vm.allPage = response.totalPages;
          vm.allPage = 1;
        }, 300);
        _this.declare.contact = response.pOrganizationPersonnel.contact;
        _this.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    memberDet: function memberDet(deteMode, dat) {
      var _this2 = this;

      var params = {};
      var vm = this;

      function goRemove(postDat) {
        postDat.publishMaterialId = vm.$route.query.mtId;
        (0, _pressRole.tab8Remove)(postDat).then(function () {
          vm.tabSeek();
        });
      }

      if (deteMode == 1) {
        if (this.detArrs.length > 0) {
          this.$confirm("确定删除所有选中项吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            params.ids = _this2.detArrs;
            goRemove(params);
          });
        } else {
          this.$message.error("请勾选所需要删除的项");
        }
      } else if (deteMode == 2) {
        this.$confirm("确定删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          params.ids = [dat.id];
          goRemove(params);
        });
      }
    },
    memberClean: function memberClean() {
      var _this3 = this;

      this.$confirm("此操作会删除所有人员信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab8Clean)({
          type: _this3.$route.query.pressType,
          publishMaterialId: _this3.$route.query.mtId
        }).then(function (response) {
          _this3.seekPms.type = 0;
          _this3.keyword = "";
          _this3.no = 1;
          _this3.tabSeek();
        });
      }).catch(function () {});
    },

    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this4 = this;

      console.debug("dictInit: ");
      var nameArr = ["C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map"
      });
      newPromise.then(function (result) {
        _this4.dicMap = result;
        _this4.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab8",
        query: pathParams
      });
    },

    urlCreate: function urlCreate(mode, id) {
      var _this5 = this;

      if (mode == "open") {
        //  this.imgShowUrl = process.env.BASE_API + '/File/File/view/token/' + this.$store.getters.fileToken + '/id/' + id;
        (0, _pressRole.getPfileUrl)({ id: id }).then(function (response) {
          _this5.imgShowUrl = response.payload.url;
        });
        this.dialogVisible = true;
      } else if (mode == "close") {
        this.imgShowUrl = "";
      }
    },

    ExHandle: function ExHandle() {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function errorCtrls(val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goPage: function goPage(inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goFresh: function goFresh() {
      this.tabSeek("init");
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function postDeclareFun() {
      var _this6 = this;

      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('申报人手机号格式错误');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      (0, _pressRole.submitDeclare)({
        code: "208",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare
      }).then(function (response) {
        console.log("response=", (0, _stringify2.default)(response));
        var tipCode = response.payload.code;
        var tipMessage = response.payload.message;

        if (tipCode == -1) {
          _this6.$message.error("" + tipMessage);
        } else {
          _this6.$message({
            message: "保存成功！",
            type: "success"
          });
          _this6.goBack();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    filterData: function filterData(data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      var text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      return _lodash2.default.filter(data, function (x) {
        // if (params.type !=0 && x.type != params.type) return false
        return (x.fullName && x.fullName.includes(text) || x.idNumber && x.idNumber.includes(text) || x.cellphone && x.cellphone.includes(text)) && (params.type == 0 || x.type == params.type);
      });
    }
  },
  created: function created() {
    console.debug("created: ", this.$route.query);
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.pressType = this.$route.query.pressType;
    this.dictInit();
    // this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=208&token=' + encodeURIComponent(this.$store.getters.fileToken);
    this.excelModeUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/208_404.xlsx";
    // this.excelModeUrl = process.env.BASE_API + '/drmb/208_404.xlsx';
    this.pubStatus = this.$route.query.pubStatus;
  }
};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _initPagin = __webpack_require__(91);

var _initPagin2 = _interopRequireDefault(_initPagin);

var _pressRole = __webpack_require__(7);

var _export = __webpack_require__(127);

var _excel = __webpack_require__(207);

var _excel2 = _interopRequireDefault(_excel);

var _excelError = __webpack_require__(208);

var _excelError2 = _interopRequireDefault(_excelError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_initPagin2.default],
  components: {
    ExcelIn: _excel2.default,
    ExError: _excelError2.default
  },
  data: function data() {
    return {
      pressType: this.$route.query.pressType,
      querys: {
        pressId: "",
        mtId: ""
      },

      loading: false,
      excelEr: [],

      tabDat: [],
      detArrs: [],
      dicMap: {},

      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15
      },
      allPage: 0,

      excelModeUrl: "",
      excelExportUrl: "",
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",
      pubStatus: 0,

      selYear: new Date().getFullYear(),

      currentPage: 1
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowDat) {
      if (code == "C010" || code == "C025") {
        if (transMap[code][dat] == "其他") {
          return rowDat.carrierFormQT;
        } else {
          return transMap[code][dat];
        }
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function stringTrans(dat, code) {
      if (dat != null && code == "time") {
        var timeStr = dat.substr(0, 10);
        return timeStr;
      }
      return dat;
    }
  },
  methods: (_methods = {
    // zym.对接音电书号系统，将数据迁移过来
    pullProductFromSystem: function pullProductFromSystem() {
      var _this = this;

      var publishMaterialId = this.$route.query.mtId;
      var tipType = "音像制品出版情况登记表";
      if (this.pressType == "2") {
        tipType = "电子出版物出版情况登记表";
      }
      var tipMsg = "<span>\u5BFC\u5165\u97F3\u7535\u4E66\u53F7\u7CFB\u7EDF\u4E2D\u5DF2\u6210\u54C1\u4E0A\u4F20\u7684\u97F3\u7535\u6570\u636E\uFF0C\u5BFC\u5165\u524D\u4F1A<span style='font-weight:bold;color:red'>\u5220\u9664\u6240\u6709" + tipType + "\u4E2D\u7684\u6570\u636E</span>\uFF0C\u5982\u679C\u5DF2\u7ECF\u6267\u884C\u8FC7\u5BFC\u5165\uFF0C\u8BF7\u8C28\u614E\u64CD\u4F5C\uFF0C\u662F\u5426\u7EE7\u7EED?</span>";
      this.$confirm(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning"
      }).then(function () {
        var dataIn = {};
        dataIn.publishMaterialId = publishMaterialId;

        var loading = _this.$loading({
          lock: true,
          text: "导入中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        (0, _pressRole.tb9PullProductFromSystem)(dataIn).then(function (response) {
          console.log("response=", response);
          var code = (response || {}).code;
          var msg = (response || {}).message || "导入失败";
          if (code == 0) {
            _this.tabSeek();
            loading.close();
            _this.$message({
              type: "success",
              message: msg
            });
          } else {
            loading.close();
            _this.$message({
              type: "error",
              message: msg
            });
          }
        });
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "已取消导入"
        });
      });
    },
    tabSeek: function tabSeek(type) {
      var _this2 = this;

      var that = this;
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = this.selYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = this.selYear - 1;
      }
      var vm = this;

      var page = sessionStorage.getItem("toPage"); // 手动加的，用于跳转到指定页
      if (page && page > 0) {
        this.currentPage = +page; // 0+page 转数字的方式
        sessionStorage.removeItem("toPage");
        sessionStorage.removeItem("fromPage");
      }

      (0, _pressRole.tabList9)(this.seekPms).then(function (response) {
        vm.tabDat = [];
        var pages = 1;

        if (response.ppublicationList.length > 0) {
          // 近两年的申报 奇数年是1年 偶数年是2年
          var dummyYear = response.ppublicationList[0].year;
          console.log("response.ppublicationList[0]=", (0, _stringify2.default)(response.ppublicationList[0]));
          if (dummyYear % 2 == 0) {
            vm.selYear = dummyYear * 1 + 1;
          } else {
            vm.selYear = dummyYear * 1 + 2;
          }
          pages = parseInt(response.ppublicationList.length / that.pageSize);
          if (response.ppublicationList.length % that.pageSize > 0) {
            pages += 1;
          }
        }

        setTimeout(function () {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(response.ppublicationList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (!(item.publicationName == "无" && item.isbn == "无")) {
                vm.tabDat.push(item);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          vm.loading = false;
          vm.allPage = pages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          _this2.declare.contact = response.pOrganizationPersonnel.contact;
          _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this2.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function memberDet(type, dat) {
      var _this3 = this;

      var params = {};
      var message = "确认删除所有选中项吗？";

      if (type == 1) {
        params.ids = this.detArrs;
      } else if (type == 2) {
        params.ids = [dat.id];
        message = "确认删除吗？";
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        params.publishMaterialId = _this3.$route.query.mtId;
        (0, _pressRole.tab9Remove)(params).then(function (response) {
          _this3.tabSeek();
        }).catch(function (error) {});
      });
    },
    memberClean: function memberClean() {
      var _this4 = this;

      this.$confirm("此操作会删除所有出版物信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressRole.tab9Clean)({
          publishMaterialId: _this4.$route.query.mtId
        }).then(function (response) {
          _this4.tabSeek();
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this5 = this;

      var nameArr = ["C010", "C011", "C018", "C012", "C025"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map"
      });
      newPromise.then(function (result) {
        _this5.dicMap = result;
        _this5.tabSeek();
      });
    },
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      sessionStorage.setItem("fromPage", this.currentPage);
      this.$router.push({
        path: "edit_tab9",
        query: pathParams
      });
    },

    ExcelHandler: function ExcelHandler() {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function errorCtrls(val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },

    goFresh: function goFresh() {
      this.yearSet = 0;
      this.seekPms.year = "";
      this.seekPms.keyword = "";
      this.tabSeek("init");
    },

    goPage: function goPage(inx) {
      // this.seekPms.no = inx;
      // this.tabSeek();
      this.currentPage = inx;
    }

  }, (0, _defineProperty3.default)(_methods, "errorCtrls", function errorCtrls(val) {
    this.excelEr = val;
    this.$refs.chinldError.handErrors();
  }), (0, _defineProperty3.default)(_methods, "postDeclareFun", function postDeclareFun() {
    var that = this;
    if (!this.declare.personnel) {
      this.$message.error("申报人姓名必填");
      return;
    }
    // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
    //   this.$message.error('申报人手机号格式错误');
    //   return
    // }
    if (!this.declare.contact) {
      this.$message.error("申报人联系方式必填");
      return;
    }
    (0, _pressRole.submitDeclare)({
      // hsj.手动加code，统一模组化
      code: "301",
      publishMaterialId: this.$route.query.mtId,
      organizationPersonnel: this.declare
    }).then(function (response) {
      var tipCode = response.payload.code;
      var tipMessage = response.payload.message;

      that.submiting = false;
      if (tipCode == -1) {
        that.$message.error("\u4FDD\u5B58\u9519\u8BEF: " + tipMessage);
        return;
      }
      that.$message({
        message: "保存成功！",
        type: "success"
      });

      that.goBack();
    }).catch(function (error) {
      console.log(error);
    });
  }), (0, _defineProperty3.default)(_methods, "filterData", function filterData(data, params) {
    var text = params.keyword;
    // if (!text || text.trim() === '') return data
    text = text.toLowerCase();

    var list = _.filter(data, function (x) {
      // if (params.type !=0 && x.type != params.type) return false
      return (x.publicationName && x.publicationName.includes(text) || x.isbn && x.isbn.includes(text)) && (params.year == 0 || x.year == params.year);
    });

    var pages = parseInt(list.length / this.pageSize);
    if (list.length % this.pageSize > 0) {
      pages += 1;
    }

    if (pages == 0) {
      return [];
    }

    this.allPage = pages;
    if (this.currentPage > this.allPage) {
      this.currentPage = 1;
    }

    // 没起到实际作用，但是刷新回来的时候靠这个显示
    if (this.seekPms.no != this.currentPage) {
      this.seekPms.no = this.currentPage;
    }
    return list;
  }), (0, _defineProperty3.default)(_methods, "dmyfile", function dmyfile(exp) {
    var params = {};
    var expUrl = "";
    if (exp == 1) {
      expUrl = "/api/export/printYxdzCbwList";
      params = {
        type: this.querys.pressType,
        year: this.seekPms.year,
        publishMaterialId: this.$route.query.mtId
      };
    }
    (0, _export.expFile)({
      expUrl: expUrl,
      p: params
    }).then(function (blob) {
      var blobHref = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.href = blobHref;
      var fname = localStorage.getItem("dfilename");
      anchor.download = decodeURIComponent(fname);
      document.body.appendChild(anchor);
      anchor.click();
      window.URL.revokeObjectURL(blobHref);
      document.body.removeChild(anchor);
    }).catch(function (error) {});
  }), _methods),
  created: function created() {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      mtId: this.$route.query.mtId
    };

    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;

    if (this.querys.pressType == 1) {
      //this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=3011&token=' + encodeURIComponent(this.$store.getters.token);
      this.excelModeUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/3011.xlsx";
    } else {
      //this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=3012&token=' + encodeURIComponent(this.$store.getters.token);
      this.excelModeUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/3012.xlsx";
    }

    this.excelExportUrl = "https://ydnj.capub.cn/ydfile" + "/File/File/printYxdzCbwList?type=" + this.querys.pressType + "&publishMaterialId=" + this.$route.query.mtId + "&token=" + encodeURIComponent(this.$store.getters.token);
  }
};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpecCommonTab = __webpack_require__(175);

var _SpecCommonTab2 = _interopRequireDefault(_SpecCommonTab);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MainTabs: _SpecCommonTab2.default
  },
  data: function data() {
    return {
      wSat: 0,
      typeLst: "",
      organization: "",
      resDat: [{}],
      cancelFlag: false
    };
  },

  created: function created() {
    var _this = this;

    this.organization = this.$store.getters.name;
    this.typeLst = this.$route.query.pressType;

    var vm = this;
    var loading = vm.$loading({
      lock: true,
      text: "加载中",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    (0, _pressRole.getPressList)({
      type: this.$route.query.pressType,
      // zym.20241212，增加年份
      year: this.$route.query.firstYear
    }).then(function (response) {
      loading.close();
      vm.wSat = 1;
      // console.log("response.cancelFlag=", response.cancelFlag);
      // console.log(typeof response.cancelFlag);
      // console.log(typeof this.$route.query.cancelFlag);
      if (_this.$route.query.cancelFlagStr) {
        vm.cancelFlag = _this.$route.query.cancelFlagStr == "true";
      } else {
        vm.cancelFlag = response.cancelFlag;
      }

      _this.resDat.splice(0, 1, response);
    }).catch(function () {
      loading.close();
    });
  }
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

var _export = __webpack_require__(127);

var _pressSuccessive = __webpack_require__(28);

exports.default = {
  data: function data() {
    return {
      tabDat: [],
      // 连续型电子出版物单位基本信息、人员基本信息
      tabDatCommon: [],
      loading: false,
      fileUrl: "",
      tabPost: {
        no: 1,
        size: 15,
        total: 0
      }
    };
  },

  filters: {
    transStr: function transStr(dat, code) {
      if (code == "tabsta") {
        var arrs = ["/", "已完成"];
        return arrs[dat - 1];
      }
    },
    strTrans: function strTrans(dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      }
      if (code == "pgstate") {
        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        var regist = {
          1: "未登记",
          2: "已登记"
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    },
    translate: function translate(dat, code) {
      // if (code == "pgress") {
      //   let transArr = ["未提交", "已提交"];
      //   return transArr[dat - 1];
      // } else if (code == "time") {
      // if (dat.status == 2) {
      return dat.updatedatpom.substr(0, 16);
      // } else {
      //   return "";
      // }
      // }
    }
  },
  methods: {
    expFullFile: function expFullFile(material) {
      console.log("material=", material);
      var expUrl = "/api/export/printRyJbxx";
      var params = {
        type: 3,
        publishMaterialId: material.pomid
      };
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    },
    tabInit: function tabInit() {
      this.loading = true;
      var vm = this;
      // 获取当前的年份
      var year1 = this.$store.getters.userInfo.year1;
      //  getPgress(this.tabPost).then(response => {
      (0, _pressRole.getLxdzProgress)({ year1: year1 }).then(function (response) {
        setTimeout(function () {
          vm.tabDat = response.examineProgressList;
          // zym.20241227，出版单位基本信息、人员信息
          vm.tabDatCommon = response.flxdzOrganizationMaterialCommonList;
          vm.tabPost.total = response.totalPages;
          vm.loading = false;
        }, 300);
      });
    },
    pageChange: function pageChange(inx) {
      this.tabPost.no = inx;
      this.tabInit();
    },
    goDeep: function goDeep(dat) {
      this.$router.push({
        path: "successive_read",
        query: {
          listId: dat.publishMaterialId,
          pressId: dat.organizationId,
          bookName: dat.name,
          firstYear: dat.firstYear
        }
      });
    },

    // zym.20241227，单位基本信息、人员信息，
    toEdit: function toEdit(row, type) {
      // let urlMap = {
      //   401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
      //   402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
      //   403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
      //   404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

      //   405: "edit_ssTab5", // pressRole/SuccessivePart/forTabs/ssTab4
      // };
      var urlMap = {
        401: "ss_skimtab1",
        402: "ss_skimtab2",
        403: "ss_skimtab3",
        404: "ss_listtab4",

        405: "ss_skimtab5" // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.pomid,
          pgress: type,

          listId: row.id, // zym.publishMaterialId

          bookName: row.materialTitle,
          mtcode: row.materialCode // zym.materialCode 出版物的code编号
        }
      });
    },
    toCancel: function toCancel() {
      var _this = this;

      var vm = this;
      this.$confirm("确认整体撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        (0, _pressSuccessive.cancelTabSubmit)().then(function (response) {
          loading.close();
          // console.log('response=',JSON.stringify(response));
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.message || "操作失败";
          if (tipCode == "fail") {
            _this.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this.$message({
              message: "操作成功！",
              type: "success"
            });
            _this.$router.push("successive_press");
          }
        });
      }).catch(function (error) {});
    }
  },

  created: function created() {
    this.tabInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/003.xlsx";
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getPgress } from '@/api/pressRole/pressRole';

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pressRole = __webpack_require__(7);

var _pressSuccessive = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { getPgress } from '@/api/pressRole/pressRole';
exports.default = {
  data: function data() {
    return {
      tabDat: [],
      loading: false,
      fileUrl: "",
      tabPost: {
        no: 1,
        size: 15,
        total: 0
      }
    };
  },

  filters: {
    strTrans: function strTrans(dat, code) {
      if (code == "year") {
        return dat.firstYear + "-" + dat.secondYear;
      }
      if (code == "pgstate") {
        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        var regist = {
          1: "未登记",
          2: "已登记"
        };

        if (dat.progress == "登记") {
          return regist[dat.record];
        } else if (dat.progress == "国家新闻出版署") {
          if (dat.pubStatus == 1 || dat.pubStatus == 0) {
            return "已上报";
          } else {
            return setMap[dat.pubStatus];
          }
        } else if (dat.progress == "开始") {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        } else {
          return "已上报";
        }
      }
    }
  },
  methods: {
    tabInit: function tabInit() {
      this.loading = true;
      var vm = this;
      //  getPgress(this.tabPost).then(response => {
      (0, _pressRole.getLxdzProgress)().then(function (response) {
        setTimeout(function () {
          vm.tabDat = response.examineProgressList;
          vm.tabPost.total = response.totalPages;
          vm.loading = false;
        }, 300);
      });
    },
    pageChange: function pageChange(inx) {
      this.tabPost.no = inx;
      this.tabInit();
    },
    goDeep: function goDeep(dat) {
      this.$router.push({
        path: "successive_read",
        query: {
          listId: dat.publishMaterialId,
          pressId: dat.organizationId,
          bookName: dat.name
        }
      });
    },
    toCancel: function toCancel() {
      var _this = this;

      var vm = this;
      this.$confirm("确认整体撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        (0, _pressSuccessive.cancelTabSubmit)().then(function (response) {
          loading.close();
          // console.log('response=',JSON.stringify(response));
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.message || "操作失败";
          if (tipCode == "fail") {
            _this.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this.$message({
              message: "操作成功！",
              type: "success"
            });
            _this.$router.push("successive_press");
          }
        });
      }).catch(function (error) {});
    }
  },

  created: function created() {
    this.tabInit();
    // this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/003.xlsx";
  }
};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _paramsSEt = __webpack_require__(364);

var _pressSuccessive = __webpack_require__(28);

var _uploadPdf = __webpack_require__(176);

var _uploadPdf2 = _interopRequireDefault(_uploadPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UpbtnPdf: _uploadPdf2.default
  },
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      numShow: true,
      dicDats: {},
      isNot: {},
      isSub: {},
      mediaType: {},
      submiting: false,
      layDasion: 1,
      declare: {
        personnel: "",
        contact: ""
      },

      applyFileId: "",

      modifyFlag: false
    };
  },


  methods: {
    // zym.批复文件
    fileTdSetApplyFileId: function fileTdSetApplyFileId(id) {
      this.params.applyFileId = id;
      this.applyFileId = id;
    },
    fileTdSet1: function fileTdSet1(dat) {
      // this.params.professionalCertificateId = dat;
    },
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId; // *publicationOrganizationMaterial的主键
          _this.params.materialCode = _this.$route.query.mtcode;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error("申报人联系方式必填");
            return;
          }

          // !出版物基本信息保存
          (0, _pressSuccessive.ssSave1)({
            data: _this.params,
            organizationPersonnel: _this.declare
            // plxdzPublication: this.params,
            // organizationPersonnel: this.declare,
          }).then(function (response) {
            // console.log('response=', JSON.stringify(response));
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
            } else {
              _this.submiting = false;
              _this.$message({
                message: "保存成功！",
                type: "success"
              });

              _this.goBack();
            }
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode401HistoryData: function getCode401HistoryData() {
      var that = this;
      this.imgId = "";
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _pressSuccessive.code401HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.plxdzPublication, { publishMaterialId: that.$route.query.mtId });
        // that.imgId = response.plxdzPublication.yyzzId;
        if (response.pOrganizationPersonnel !== null) {
          that.declare.contact = response.pOrganizationPersonnel.contact;
          that.declare.personnel = response.pOrganizationPersonnel.personnel;
          that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
        that.layChange();
      }).catch(function (error) {
        that.submiting = false;
      });
    },
    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C026", "C014", "C012", "C025", "C018"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      newPromise.then(function (result) {
        _this2.dicDats = result;
        _this2.isNot = _this2.$store.getters.dictionary["C018"];
        _this2.isSub = _this2.$store.getters.dictionary["C012"];
        _this2.mediaType = _this2.$store.getters.dictionary["C025"];
        for (var key in _this2.isNot) {
          if (_this2.isNot[key] == "是") {
            // this.params.isIndependentLP = key;// !是否独立法人，这个页面应该不需要
          } else if (_this2.isNot[key] == "否") {
            _this2.params.isSampleDelivery = key;
          }
        }

        if (_this2.$route.query.pgress == 2) {
          _this2.tabReEdit();
        } else {
          _this2.modifyFlag = true;
        }
      });
    },

    // !读取信息
    tabReEdit: function tabReEdit() {
      var _this3 = this;

      console.log("tabReEdit...");
      var vm = this;
      (0, _pressSuccessive.ssRead1)({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
        judgeModify: true
      }).then(function (response) {
        vm.params = response.plxdzPublication;

        vm.applyFileId = response.plxdzPublication.applyFileId;

        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        _this3.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", _this3.modifyFlag);

        if (vm.mediaType[vm.params.mediaForm] == "电子-信息网络出版") {
          vm.numShow = false;
          vm.params.issueQuantity = 0;
          vm.params.unitPrice = 0;
        } else {
          vm.numShow = true;
        }
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    mediaHandle: function mediaHandle() {
      if (this.mediaType[this.params.mediaForm] == "电子-信息网络出版") {
        this.numShow = false;
        this.params.issueQuantity = 0;
        this.params.unitPrice = 0;
      } else {
        this.numShow = true;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log("getLxdzModifyFlagByPublication...");
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    console.log("this.$route.query.mtId=", this.$route.query.mtId);
    console.log("this.$route.query.mtcode=", this.$route.query.mtcode);
    this.dictInit();
    this.params.publication = this.$route.query.bookName;
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _paramsSEt = __webpack_require__(365);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      pzs: 0,
      rules: _paramsSEt.paramsRule,
      dicDats: {},
      isNot: {},
      submiting: false,
      layDasion: 1,
      imgId: "",
      declare: {
        personnel: "",
        contact: ""
      },

      modifyFlag: false
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error("申报人联系方式必填");
            return;
          }
          (0, _pressSuccessive.ssSave2)({
            data: _this.params,
            // plxdzBasic: this.params,
            organizationPersonnel: _this.declare
          }).then(function (response) {
            // console.log('response=', JSON.stringify(Response))
            _this.submiting = false;
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
              return;
            }
            _this.$message({
              message: "保存成功！",
              type: "success"
            });

            _this.goBack();
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode402HistoryData: function getCode402HistoryData() {
      var that = this;
      this.imgId = "";
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _pressSuccessive.code402HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.plxdzBasic, { publishMaterialId: that.$route.query.mtId });
        // that.imgId = response.plxdzPublication.yyzzId;
        // zym.20241225，注释掉代码，导入历史数据的时候，不导入申报人信息
        // zym.20241225，删除申报时间
        delete that.params.updatedAt;
        // if (response.pOrganizationPersonnel !== null) {
        //   that.declare.contact = response.pOrganizationPersonnel.contact;
        //   that.declare.personnel = response.pOrganizationPersonnel.personnel;
        //   that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        // }
        that.layChange();
      }).catch(function (error) {
        that.submiting = false;
      });
    },
    dictInit: function dictInit() {
      var _this2 = this;

      var nameArr = ["C016"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "arr"
      });
      newPromise.then(function (result) {
        _this2.dicDats = result;
      });
    },

    tabReEdit: function tabReEdit() {
      var _this3 = this;

      (0, _pressSuccessive.ssRead2)({
        publishMaterialId: this.$route.query.mtId,
        judgeModify: true
      }).then(function (response) {
        console.log("plxdzBasic=", (0, _stringify2.default)(response));
        _this3.params = response.plxdzBasic;
        _this3.pzs = response.pzs;
        _this3.declare.contact = response.pOrganizationPersonnel.contact;
        _this3.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this3.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        _this3.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", _this3.modifyFlag);
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log("getLxdzModifyFlagByPublication...");
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.dictInit();
    console.log("this.$route.query.pgress=" + this.$route.query.pgress);
    // if (this.$route.query.pgress == 2) {
    this.tabReEdit();
    // }
    // else{
    //   this.modifyFlag = true;
    // }
  },
  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(212);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      submiting: false,

      yearSet: {
        year1: '',
        year2: ''
      },
      declare: {
        personnel: "",
        contact: ""
      }
    };
  },

  watch: {
    'params.areaDate': function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          _this.params.firstYear = _this.yearSet.year1;
          _this.params.secondYear = _this.yearSet.year2;
          if (!_this.declare.personnel) {
            _this.$message.error('申报人姓名必填');
            return;
          };
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error('申报人联系方式必填');
            return;
          };
          (0, _pressSuccessive.ssSave3)({
            data: _this.params,
            // plxdzfinance: this.params,
            organizationPersonnel: _this.declare
          }).then(function (response) {
            console.log('response=', (0, _stringify2.default)(response));
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == 'fail') {
              _this.$message({
                message: tipMessage,
                type: 'error'
              });
            } else {
              _this.submiting = false;
              _this.$message({
                message: '保存成功！',
                type: 'success'
              });

              _this.goBack();
            }
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode403HistoryData: function getCode403HistoryData() {
      var that = this;
      this.imgId = '';
      var loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _pressSuccessive.code403HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.plxdzfinance, { publishMaterialId: that.$route.query.mtId });
        // that.imgId = response.plxdzPublication.yyzzId;
        if (response.pOrganizationPersonnel !== null) {
          that.declare.contact = response.pOrganizationPersonnel.contact;
          that.declare.personnel = response.pOrganizationPersonnel.personnel;
          that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
        that.layChange();
      }).catch(function (error) {
        that.submiting = false;
      });
    },
    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressSuccessive.ssRead3)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        if (response.plxdzFinance) {
          _this2.params = response.plxdzFinance;
          _this2.declare.contact = response.pOrganizationPersonnel.contact;
          _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
          _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

          _this2.modifyFlag = response.modifyFlag;
          console.log('modifyFlag=', _this2.modifyFlag);
        }
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
    // zym.判断是否可以修改
    , getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log('getLxdzModifyFlagByPublication...');
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }

    var newDate = new Date();
    this.yearSet.year1 = newDate.getFullYear() - 2;
    this.yearSet.year2 = newDate.getFullYear() - 1;
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = '';
    }
  }
};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(212);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      submiting: false,

      yearSet: {
        year1: "",
        year2: ""
      },
      declare: {
        personnel: "",
        contact: ""
      },

      modifyFlag: false
    };
  },

  watch: {
    "params.areaDate": function paramsAreaDate(dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    }
  },
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      var that = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId;

          _this.params.firstYear = _this.yearSet.year1;
          _this.params.secondYear = _this.yearSet.year2;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error("申报人联系方式必填");
            return;
          }

          var bFirst = that.params.firstTotalSales > 500000;
          var bSecond = that.params.secondTotalSales > 500000;
          if (bFirst || bSecond) {
            that.$confirm("请确认年销售收入填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error"
            });
            return;
          }

          var msg = "请再次确认页面中所输入的金额单位为万元。";
          that.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            (0, _pressSuccessive.ssSave3)({
              data: that.params,
              // plxdzfinance: this.params,
              organizationPersonnel: that.declare
            }).then(function (response) {
              console.log("response=", (0, _stringify2.default)(response));
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                that.$message({
                  message: tipMessage,
                  type: "error"
                });
              } else {
                that.submiting = false;
                that.$message({
                  message: "保存成功！",
                  type: "success"
                });

                that.goBack();
              }
            }).catch(function (error) {
              that.submiting = false;
            });
          }).catch(function () {});
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode403HistoryData: function getCode403HistoryData() {
      var that = this;
      this.imgId = "";
      var loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _pressSuccessive.code403HistoryData)({
        publishMaterialId: this.$route.query.mtId
      }).then(function (response) {
        loading.close();
        // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
        that.params = (0, _extends3.default)({}, that.params, response.plxdzfinance, {
          publishMaterialId: that.$route.query.mtId
        });
        // that.imgId = response.plxdzPublication.yyzzId;
        if (response.pOrganizationPersonnel !== null) {
          that.declare.contact = response.pOrganizationPersonnel.contact;
          that.declare.personnel = response.pOrganizationPersonnel.personnel;
          that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
        that.layChange();
      }).catch(function (error) {
        that.submiting = false;
      });
    },
    tabReEdit: function tabReEdit() {
      var _this2 = this;

      (0, _pressSuccessive.ssRead3)({
        publishMaterialId: this.$route.query.mtId,
        judgeModify: true
      }).then(function (response) {
        // console.log('1')
        if (response.plxdzFinance) {
          // 新增
          if (_this2.$route.query.pgress == 1) {
            // 处理年份
            _this2.yearSet.year1 = response.plxdzFinance.firstYear;
            _this2.yearSet.year2 = Number(response.plxdzFinance.firstYear) + 1;
          } else {
            // console.log('2')
            _this2.modifyFlag = response.modifyFlag;
            _this2.params = response.plxdzFinance;

            // 处理年份
            _this2.yearSet.year1 = _this2.params.firstYear;
            _this2.yearSet.year2 = Number(_this2.params.firstYear) + 1;

            _this2.declare.contact = response.pOrganizationPersonnel.contact;
            _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
            _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        } else {
          _this2.modifyFlag = response.modifyFlag;
          // console.log('3')
        }
      });
    },

    fileTdSet: function fileTdSet(id) {
      this.params.yyzzId = id;
    },

    layChange: function layChange() {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log("getLxdzModifyFlagByPublication...");
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.tabReEdit();
    if (this.$route.query.pgress == 2) {
      console.log("进来1...");
      // this.tabReEdit();
    } else {
      console.log("进来2...");
      this.modifyFlag = true;
    }

    // let newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2;
    // this.yearSet.year2 = newDate.getFullYear() - 1;
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(366);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C022: {}
      },

      modifyFlag: false
    };
  },

  methods: {
    tabSeek: function tabSeek() {},
    dictInit: function dictInit() {
      var _this = this;

      var nameArr = ['C022', 'C006', 'C005', 'C007', 'C008', 'C009', 'C018', 'C017'];
      var newPromise = this.$store.dispatch('dictUpdate', {
        codeArr: nameArr,
        type: 'arr'
      });
      newPromise.then(function (result) {
        _this.dicDats = result;
        _this.dicMap['C022'] = _this.$store.getters.dictionary['C022'];
      });
    },

    editSave: function editSave(name) {
      var _this2 = this;

      var that = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {

          _this2.params.publishId = _this2.$route.query.pressId;
          _this2.params.publishMaterialId = _this2.$route.query.mtId;
          _this2.params.publishType = _this2.$route.query.pressType;

          (0, _pressSuccessive.ssSave4)({
            // plxdzworker: this.params
            publishMaterialId: _this2.$route.query.mtId, // zym.基本信息
            data: _this2.params
          }).then(function (response) {
            console.log('response=', (0, _stringify2.default)(response));
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == 'fail') {
              _this2.$message({
                message: tipMessage,
                type: 'error'
              });
            } else {
              that.submiting = false;
              var _tipCode = response.payload.tipCode;
              var _tipMessage = response.payload.tipMessage;
              if (_tipCode == 'fail') {
                that.$message({
                  message: _tipMessage,
                  type: 'error'
                });
                return;
              }
              that.$message({
                message: '保存成功！',
                type: 'success'
              });

              that.goBack();
            }
          }).catch(function (error) {
            _this2.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    // zym.控制是否显示
    btnCtrls: function btnCtrls(type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    // zym.读取单位人员信息
    menReEdit: function menReEdit() {
      var _this3 = this;

      (0, _pressSuccessive.ssRead4)({
        id: this.$route.query.id,
        publishMaterialId: this.$route.query.mtId // zym.新增，用于判断是否可以修改数据
        , judgeModify: true
      }).then(function (response) {
        // console.log('response=', JSON.stringify(response));
        _this3.params = response.plxdzworker;

        _this3.modifyFlag = response.modifyFlag;
        // console.log('modifyFlag=',this.modifyFlag)
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
    // zym.判断是否可以修改
    , getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log('getLxdzModifyFlagByPublication...');
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.dictInit();
    this.params.type = 3;
    // zym.pgress 新增-1，还是修改-2
    if (this.$route.query.pgress == 2) {
      this.menReEdit();
    } else {
      this.modifyFlag = true;
    }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = '';
    }
  }
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _paramsSEt = __webpack_require__(367);

var _pressSuccessive = __webpack_require__(28);

var _uploadPdf = __webpack_require__(176);

var _uploadPdf2 = _interopRequireDefault(_uploadPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UpbtnPdf: _uploadPdf2.default
  },
  data: function data() {
    return {
      params: _paramsSEt.bsParams,
      rules: _paramsSEt.paramsRule,

      dicDats: {},
      isNot: {},
      isSub: {},
      mediaType: {},
      submiting: false,
      layDasion: 1,
      declare: {
        personnel: "",
        contact: ""
      },

      pubStatus: 0,

      modifyFlag: false
    };
  },


  watch: {},
  methods: {
    editSave: function editSave(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this.params.publishId = _this.$route.query.pressId;
          _this.params.publishMaterialId = _this.$route.query.mtId; // *publicationOrganizationMaterial的主键
          _this.params.materialCode = _this.$route.query.mtcode;
          if (!_this.declare.personnel) {
            _this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!_this.declare.contact) {
            _this.$message.error("申报人联系方式必填");
            return;
          }

          // !出版物基本信息保存
          (0, _pressSuccessive.ssSave5)({
            data: _this.params,
            organizationPersonnel: _this.declare
            // plxdzPublication: this.params,
            // organizationPersonnel: this.declare,
          }).then(function (response) {
            console.log("response=", (0, _stringify2.default)(response));
            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage,
                type: "error"
              });
            } else {
              _this.submiting = false;
              _this.$message({
                message: "保存成功！",
                type: "success"
              });

              _this.goBack();
            }
          }).catch(function (error) {
            _this.submiting = false;
          });
        } else {
          return false;
        }
      });
    },

    dictInit: function dictInit() {
      // let nameArr = ['C026', 'C014', 'C012', 'C025', 'C018'];
      // let newPromise = this.$store.dispatch('dictUpdate', {
      //   codeArr: nameArr,
      //   type: 'arr'
      // });
      // newPromise.then(result => {
      //   this.dicDats = result;
      //   this.isNot = this.$store.getters.dictionary['C018'];
      //   this.isSub = this.$store.getters.dictionary['C012'];
      //   this.mediaType = this.$store.getters.dictionary['C025'];
      //   for (let key in this.isNot) {
      //     if (this.isNot[key] == '是') {
      //       // this.params.isIndependentLP = key;// !是否独立法人，这个页面应该不需要
      //     } else if (this.isNot[key] == '否') {
      //       this.params.isSampleDelivery = key;
      //     }
      //   }
      //   if (this.$route.query.pgress == 2) {
      //     // this.tabReEdit();
      //   }
      // });
    },

    // !读取信息
    tabReEdit: function tabReEdit() {
      var _this2 = this;

      console.log("tabReEdit...");
      var vm = this;
      (0, _pressSuccessive.ssRead5)({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
        judgeModify: true
      }).then(function (response) {
        vm.params = response.plxdzQuestionnaire;

        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        _this2.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", _this2.modifyFlag);
      });
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    this.dictInit();
    // if (this.$route.query.pgress == 2) {
    console.log("我进来了");
    this.tabReEdit();
    // }
  },

  beforeDestroy: function beforeDestroy() {
    for (var key in this.params) {
      this.params[key] = "";
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _pressSuccessive = __webpack_require__(28);

var _excel = __webpack_require__(207);

var _excel2 = _interopRequireDefault(_excel);

var _excelError = __webpack_require__(208);

var _excelError2 = _interopRequireDefault(_excelError);

var _vuex = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    ExcelIn: _excel2.default,
    ExError: _excelError2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["token"])),
  data: function data() {
    return {
      querys: {
        pressId: "",
        mtId: "",
        pgress: "",
        listId: "",
        bookName: ""
      },
      excelModeUrl: "",
      loading: false,
      tabDatAll: [], // zym.所有的数据
      tabDat: [], // zym.列表上的数据
      detArrs: [],
      dicMap: {},
      seekPms: {
        type: 0,
        keyword: "",
        no: 1,
        size: 15
      },

      excelEr: [],
      declare: {
        personnel: "",
        contact: ""
      },
      updatedAt: "",

      modifyFlag: false
    };
  },

  filters: {
    translate: function translate(dat, code, transMap, rowDat) {
      if (code == "C022" && transMap[code][dat] == "其他") {
        console.log(rowDat);
        return rowDat.professionalOther;
      } else {
        return transMap[code][dat];
      }
    }
  },
  watch: {
    seekPms: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.filterTableData();
      }
    }
  },
  methods: {
    /*
     *提交申报人信息
     * */
    postDeclareFun: function postDeclareFun() {
      var _this = this;

      var that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('请填写正确的手机号');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      (0, _pressSuccessive.submitDeclare)({
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare
      }).then(function (response) {
        console.log("response=", (0, _stringify2.default)(response));
        that.submiting = false;
        var tipCode = response.payload.tipCode;
        var tipMessage = response.payload.tipMessage;
        if (tipCode == "fail") {
          that.$message({
            message: tipMessage,
            type: "error"
          });
          return;
        }
        _this.$message({
          message: "保存成功！",
          type: "success"
        });

        _this.goBack();
      }).catch(function (error) {
        console.log(error);
      });
    },
    tabSeek: function tabSeek(type) {
      var _this2 = this;

      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      // ssList4(this.seekPms).then(response => {
      (0, _pressSuccessive.ssList4)({
        publishMaterialId: this.$route.query.mtId,
        judgeModify: true
      }).then(function (response) {
        var vm = _this2;
        setTimeout(function () {
          vm.loading = false;
          // console.log('response=',JSON.stringify(response))
          // vm.tabDat = response.plxdzWorkerList;
          vm.tabDatAll = response.plxdzWorkerList;
          vm.modifyFlag = response.modifyFlag;
          console.log("modifyFlag=", vm.modifyFlag);

          vm.filterTableData();
        }, 300);
        _this2.declare.contact = response.pOrganizationPersonnel.contact;
        _this2.declare.personnel = response.pOrganizationPersonnel.personnel;
        _this2.updatedAt = response.pOrganizationPersonnel.updatedAt;
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDat = this.tabDatAll;
      var qType = this.seekPms.type;
      var qKeyword = this.seekPms.keyword;
      // !人员类型
      if (qType) {
        tabDat = tabDat.filter(function (item) {
          if ((item.type || "") == qType) {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDat = tabDat.filter(function (item) {
          if ((item.fullName || "").indexOf(qKeyword) > -1 || (item.idNumber || "").indexOf(qKeyword) > -1 || (item.cellphone || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDat = tabDat;
    },
    // zym.删除数据 type=1勾选删除   type=2行记录删除
    memberDet: function memberDet(type, dat) {
      var _this3 = this;

      var detSure = false;
      var vm = this;

      if (type == 1) {
        if (this.detArrs.length > 0) {
          detSure = true;
        } else {
          this.$message.error("请勾选人员！");
        }
      } else if (type == 2) {
        detSure = true;
      }

      if (detSure) {
        this.$confirm("确定删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          var params = {};
          if (type == 1) {
            params.ids = vm.detArrs;
          } else if (type == 2) {
            params.ids = [dat.id];
          }

          params.publishMaterialId = _this3.$route.query.mtId;
          (0, _pressSuccessive.ssRemove4)(params).then(function (response) {
            var tipCode = response.tipCode;
            var tipMessage = response.tipMessage || "操作失败";
            if (tipCode == "fail") {
              _this3.$message({
                showClose: true,
                message: tipMessage,
                type: "error"
              });
            } else {
              _this3.$message({
                message: tipMessage,
                type: "success"
              });
              _this3.tabSeek();
            }
          }).catch(function (error) {});
        }).catch(function () {});
      }
    },
    memberClean: function memberClean() {
      var _this4 = this;

      this.$confirm("此操作会删除所有已录入数据库的人员信息，确定全部清除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        (0, _pressSuccessive.ssClean4)({
          type: _this4.$route.query.pressType,
          publishMaterialId: _this4.$route.query.mtId
        }).then(function (response) {
          console.log("response=", (0, _stringify2.default)(response));
          var tipCode = response.tipCode;
          var tipMessage = response.tipMessage || "操作失败";
          if (tipCode == "fail") {
            _this4.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this4.seekPms.type = 0;
            _this4.keyword = "";
            _this4.no = 1;
            _this4.tabSeek();
          }
        });
      }).catch(function () {});
    },
    selectionChange: function selectionChange(selection) {
      var newArr = [];
      for (var i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function dictInit() {
      var _this5 = this;

      var nameArr = ["C022", "C017", "C018", "C022", "C006", "C005", "C007", "C008", "C009"];
      var newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map"
      });
      newPromise.then(function (result) {
        _this5.dicMap = result;
        _this5.tabSeek();
      });
    },
    // zym.新增、编辑人员基本信息
    // zym.type：类型 新增-1  编辑-2
    memberEdit: function memberEdit(type, dat) {
      var pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pgress: type,
        listId: this.$route.query.listId,
        mtcode: this.$route.query.mtcode,

        modifyFlag: this.$route.query.modifyFlag // zym.是否可以修改
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_ssTab4",
        query: pathParams
      });
    },

    ExHandle: function ExHandle() {
      this.$refs.ExcelSet.handleUpload();
    },

    errorCtrls: function errorCtrls(val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goFresh: function goFresh() {
      this.tabSeek("init");
    },

    goBack: function goBack() {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function getLxdzModifyFlagByPublication() {
      console.log("getLxdzModifyFlagByPublication...");
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByPublication)({
        publishMaterialId: this.$route.query.mtId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.querys.pressId = this.$route.query.pressId;
    this.querys.mtId = this.$route.query.mtId;
    this.querys.pgress = this.$route.query.pgress;
    this.querys.listId = this.$route.query.listId;
    this.querys.bookName = this.$route.query.bookName;

    this.seekPms.publishMaterialId = this.$route.query.mtId;

    // this.excelModeUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=404&token=' + encodeURIComponent(this.token);
    this.excelModeUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/208_404.xlsx";
    // this.excelModeUrl = process.env.BASE_API + '/drmb/208_404.xlsx';
    this.dictInit();
  }
};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ssCommonTabs = __webpack_require__(248);

var _ssCommonTabs2 = _interopRequireDefault(_ssCommonTabs);

var _pressSuccessive = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MainTabs: _ssCommonTabs2.default
  },
  data: function data() {
    return {
      wSat: 0,
      bookname: this.$route.query.bookName,
      resDat: [{}]
    };
  },

  created: function created() {
    var _this = this;

    (0, _pressSuccessive.getSuccessTabs)({
      publishMaterialId: this.$route.query.listId,
      organizationId: this.$route.query.pressId
    }).then(function (response) {
      var vm = _this;
      vm.wSat = 1;
      _this.resDat.splice(0, 1, response.ppublicationOrganizationMaterialList);
    });
  }
};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _pressSuccessive = __webpack_require__(28);

var _excel = __webpack_require__(207);

var _excel2 = _interopRequireDefault(_excel);

var _excelError = __webpack_require__(208);

var _excelError2 = _interopRequireDefault(_excelError);

var _export = __webpack_require__(127);

var _vuex = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    ExcelIn: _excel2.default,
    ExError: _excelError2.default
  },
  data: function data() {
    return {
      selYearLxdz: "",
      selYearRecord: [],

      tabDatAll: [],
      // 连续型电子出版物单位基本信息、人员基本信息
      tabDatCommon: [],
      tabDat: [],
      postId: "",
      pressId: [],
      excelEr: [],
      tabPost: {
        no: 1,
        size: 15,
        total: 0,
        keyword: ""
      },

      loading: false,

      uploadStorage: {},

      excelModeUrl: "",
      fileUrl: "",

      modifyFlag: false
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["token"])),
  filters: {
    transStr: function transStr(dat, code) {
      if (code == "tabsta") {
        var arrs = ["/", "已完成"];
        return arrs[dat - 1];
      }
    },
    translate: function translate(dat, code) {
      // if (code == "pgress") {
      //   let transArr = ["未提交", "已提交"];
      //   return transArr[dat - 1];
      // } else if (code == "time") {
      // if (dat.status == 2) {
      return dat.updatedatpom.substr(0, 16);
      // } else {
      //   return "";
      // }
      // }
    }
  },
  watch: {
    tabPost: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.tabPost.no = 1;
        }
        this.tabPost.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    expFullFile: function expFullFile(material) {
      console.log("material=", material);
      var expUrl = "/api/export/printRyJbxx";
      var params = {
        type: 3,
        publishMaterialId: material.pomid
      };
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    },
    expLxJbxxFile: function expLxJbxxFile(row) {
      var expUrl = "/api/export/printLxJbxx";
      var params = {
        firstYear: row.firstYear,
        type: 3,
        publishMaterialId: row.id
      };
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    },
    valChange: function valChange() {
      // sessionStorage.setItem('selYearLxdz', this.selYearLxdz)
      // // zym.判断是否可以修改
      // this.pressTabs();
    },
    initYearArray: function initYearArray() {
      // let that = this;
      // // zym.查询历史年份
      // getSelYearRecordLxdz({
      // }).then(response => {
      //   console.log("======", response);
      //   let arr = [];
      //   let historyYear = response.generalPublisher;
      //   if (historyYear && historyYear.length > 0) {
      //     for (let i = 0; i < historyYear.length; i++) {
      //       let po = historyYear[i];
      //       arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });

      //       if ((historyYear.length - 1) == i) {
      //         let cacheYear = sessionStorage.getItem('selYearLxdz');
      //         if (cacheYear) {
      //           that.selYearLxdz = cacheYear;
      //         }
      //         else {
      //           that.selYearLxdz = po.firstYear;
      //         }
      //       }
      //     }
      //   }
      //   that.selYearRecord = arr;

      //   // zym.年份初始化好了，再调用这个方法
      //   this.pressTabs();
      // })
      this.selYearLxdz = this.$store.getters.userInfo.year1;
      this.pressTabs();
    },
    goComTab: function goComTab(dat) {
      this.$router.push({
        path: "successive_tabs",
        query: {
          listId: dat.id,
          bookName: dat.materialTitle,
          mtcode: dat.materialCode,
          firstYear: this.selYearLxdz
        }
      });
    },
    pressTabs: function pressTabs() {
      var _this = this;

      this.loading = true;
      var vm = this;
      this.tabPost.selYearLxdz = this.selYearLxdz;
      (0, _pressSuccessive.getSuccessList)(this.tabPost).then(function (response) {
        _this.loading = false;
        _this.tabDatAll = response.flxdzOrganizationMaterialList;
        // zym.20241227，出版单位基本信息、人员信息
        _this.tabDatCommon = response.flxdzOrganizationMaterialCommonList;
        _this.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", _this.modifyFlag);

        _this.filterTableData();

        // 计算分页信息
        // vm.calPage();

        if (_this.tabDat.length > 0) {
          _this.postId = _this.tabDat[0].materialExamineId;
        }

        for (var i = 0; i < _this.tabDat.length; i++) {
          var temp = {
            psId: _this.tabDat[i].organizationId,
            mtId: _this.tabDat[i].id
          };

          _this.pressId.push(temp);
        }

        setTimeout(function () {
          (0, _pressSuccessive.getSuccessList)({
            no: 1,
            size: 1000
          }).then(function (response) {
            var ssDat = response.flxdzOrganizationMaterialList;
            for (var _i = 0; _i < ssDat.length; _i++) {
              vm.uploadStorage[ssDat[_i].materialCode] = ssDat[_i].materialExamineId;
            }
          });
        }, 1000);
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatAll;
      var qKeyword = this.tabPost.keyword;

      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.materialTitle || "").indexOf(qKeyword) > -1 || (item.materialCode || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage() {
      var tabPost = this.tabPost;
      var tabDatAll = this.tabDats;
      var dataLen = Number(tabDatAll.length);
      var size = Number(tabPost.size);
      var total = Math.floor(dataLen / size);
      this.tabDat = tabDatAll.slice((tabPost.no - 1) * size, tabPost.no * size);

      // console.log("tabDat=", JSON.stringify(this.tabDat));
      // console.log("dataLen=", dataLen);
      // console.log("size=", size);
      // console.log("dataLen-size=", dataLen % size);
      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      tabPost["total"] = total;
      this.tabPost = tabPost;
      console.log("this.tabPost=", (0, _stringify2.default)(this.tabPost));
    },
    pageChange: function pageChange(inx) {
      this.tabPost.no = inx;
      // this.pressTabs();
      this.tabPost.goPage = true;
    },
    // zym.20241227，单位基本信息、人员信息，
    toEdit: function toEdit(row, type) {
      var urlMap = {
        401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
        402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
        403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
        404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

        405: "edit_ssTab5" // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.pomid,
          pgress: type,

          listId: row.id, // zym.publishMaterialId

          bookName: row.materialTitle,
          mtcode: row.materialCode // zym.materialCode 出版物的code编号
        }
      });
    },
    // zym.整体提交
    toPvc: function toPvc() {
      var _this2 = this;

      var vm = this;
      this.$confirm("确认提交至省局吗？", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        (0, _pressSuccessive.successTabSubmit)().then(function (response) {
          loading.close();

          // console.log('response=',JSON.stringify(response));
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.message || "操作失败";
          if (tipCode == "fail") {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this2.$message({
              message: "操作成功！",
              type: "success"
            });
            _this2.$router.push("successive_step");
          }
        });
      }).catch(function (error) {});
    },

    transCode: function transCode(dat, showType) {
      return dat.table1Status == 2 && dat.table2Status == 2 && dat.table3Status == 2 && dat.table4Status == 2;
    },

    ExcelHandler: function ExcelHandler() {
      if (this.uploadStorage) {
        this.$refs.ExcelSet.handleUpload(this.uploadStorage);
      } else {
        this.$message.error("初始化尚未完成，请稍后再试");
      }
    },

    errorCtrls: function errorCtrls(val) {
      this.excelEr = val;
      this.$refs.chinldError.handErrors();
    },

    goSeek: function goSeek() {
      this.tabPost.no = 1;
      this.pressTabs();
    },

    goFresh: function goFresh() {
      this.pressTabs();
    },
    dmyfile: function dmyfile() {
      var expUrl = "/api/export/downloadLxdzmb";
      var params = {
        code: 401
      };
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    }
  },

  created: function created() {
    this.initYearArray();

    // this.getLxdzModifyFlagByOrganization();

    this.excelModeUrl = "https://ydnj.capub.cn" + "/File/File/downloadLxdzmb?code=401&token=" + encodeURIComponent(this.token);
    //  this.fileUrl = process.env.BASE_API + '/File/File/downloadDrmb?code=002&token=' + encodeURIComponent(this.token);
    this.fileUrl = "https://ydnj.capub.cn/ydfile" + "/drmb/003.xlsx";
    // this.fileUrl = process.env.BASE_API + '/drmb/002.xlsx // 封面和盖章页';
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _uploadBtn = __webpack_require__(249);

var _uploadBtn2 = _interopRequireDefault(_uploadBtn);

var _pressRole = __webpack_require__(7);

var _pressSuccessive = __webpack_require__(28);

var _export = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["pressType"],
  components: {
    UpBtn: _uploadBtn2.default
  },
  data: function data() {
    var _ref;

    return _ref = {
      querys: {
        listId: "",
        bookName: ""
      },
      tabDat: [],
      zeroStoreage: {
        id: "",
        publishMaterialId: "",
        publishId: "",
        fileId: "",

        wSat: 0
      },
      opMsg: "",

      // 数据拷贝
      dialogVisible: false,
      checkList: [],
      codeArr: []

    }, (0, _defineProperty3.default)(_ref, "zeroStoreage", {}), (0, _defineProperty3.default)(_ref, "pubStatus", 0), (0, _defineProperty3.default)(_ref, "msgStatus", ""), _ref;
  },

  filters: {
    translate: function translate(dat, code) {
      if (code == "pgress") {
        if (dat == 1) {
          return "未提交";
        } else if (dat == 2) {
          return "已提交";
        }
      } else if (code == "time") {
        if (dat.status == 2) {
          return dat.updatedAt.substr(0, 10);
        } else {
          return "/";
        }
      }
    }
  },
  methods: {
    // zym.他是通用的，感觉this.zeroStoreage使用有问题，因为这个地方有两个文件
    // zym.上传完成后，更新文件上传的信息
    // zym.dat = 上传之后，返回来的fileId
    zeroStoreCtrls: function zeroStoreCtrls(dat, btnProps) {
      console.log("dat=", dat);
      console.log("btnProps=", (0, _stringify2.default)(btnProps));

      var btnKey = btnProps.id;
      // 材料类型名称
      var materialTitle = btnProps.name;

      var detAble = void 0,
          idOld = void 0,
          publishMaterialId = void 0;
      if (this.zeroStoreage[btnKey]) {
        detAble = this.zeroStoreage[btnKey].fileId;
        idOld = this.zeroStoreage[btnKey].id;
        publishMaterialId = this.zeroStoreage[btnKey].publishMaterialId;
      }

      var vm = this;
      this.zeroStoreage[btnKey].fileId = dat;
      (0, _pressRole.sUpdate0)({
        id: idOld,
        publishMaterialId: publishMaterialId,
        fileId: dat,
        materialTitle: materialTitle, // zym.新增
        code: 501
        // pfile1: this.zeroStoreage
      }).then(function (response) {
        console.log("sUpdate0 file = ", (0, _stringify2.default)(response));
        var code = response.payload.tipCode;
        var msg = response.payload.message;
        if (code != "success") {}
        // zym.成功，需要刷新页面
        else {
            vm.$emit("go-frash");
          }
      }).catch(function (error) {});
    },
    handleClose: function handleClose() {},
    toEdit: function toEdit(row, type) {
      var urlMap = {
        401: "edit_ssTab1", // pressRole/SuccessivePart/forEdit/ssTab1
        402: "edit_ssTab2", // pressRole/SuccessivePart/forEdit/ssTab2
        403: "edit_ssTab3", // pressRole/SuccessivePart/forEdit/ssTab3
        404: "sstab4_list", // pressRole/SuccessivePart/forTabs/ssTab4

        405: "edit_ssTab5" // pressRole/SuccessivePart/forTabs/ssTab4
      };
      this.$router.push({
        path: urlMap[row.code],
        query: {
          pressId: row.organizationId,
          mtId: row.id,
          pgress: type,

          listId: this.$route.query.listId, // zym.publishMaterialId

          bookName: this.querys.bookName,
          mtcode: this.$route.query.mtcode // zym.materialCode 出版物的code编号
        }
      });
    },

    copyHandle: function copyHandle(code) {
      var _this = this;

      var vm = this;
      if (code == "show") {
        this.dialogVisible = true;
        (0, _pressSuccessive.ssCopyList)().then(function (response) {
          vm.checkList = response.synchroCodeList;
        });
      } else if (code == "act") {
        (0, _pressSuccessive.ssCopyAct)({
          publishMaterialId: this.$route.query.listId,
          codes: vm.codeArr
        }).then(function (response) {
          _this.$message.success("拷贝成功");
          _this.dialogVisible = false;
          _this.$emit("go-frash");
        });
      }
    },

    pressInit: function pressInit() {
      var _this2 = this;

      var vm = this;
      (0, _pressSuccessive.getSuccessTabs)({
        publishMaterialId: this.$route.query.listId,
        no: 1,
        size: 15
      }).then(function (response) {
        var tabDat = response.ppublicationOrganizationMaterialList;

        // zym.20250606，复制音电逻辑。是否出版社阶段，后天比对的是progress（CONST.TASKTYPE.START.value），如果是出版社阶段返回0，否则返回1
        _this2.pubStatus = response.pubStatus;

        var zgbgPublishMaterialId = undefined;
        var publishId = undefined;
        var filterList = (tabDat || []).filter(function (item) {
          // 如果是整改报告
          if (item.code == "501") {
            zgbgPublishMaterialId = item.id;
            publishId = item.organizationId;
          }
          return item.code != "402" && item.code != "404";
        });
        _this2.tabDat = filterList;
        _this2.opMsg = response.opMsg;
        // 状态
        _this2.msgStatus = response.msgStatus;

        _this2.modifyFlag = response.modifyFlag;
        _this2.modifyFlag = response.modifyFlag;
        // zym.20250609，新增逻辑
        _this2.isModifyStage = response.isModifyStage;

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        var fileId = undefined;
        if (response.zgbgFile && response.zgbgFile.id) {
          fileId = response.zgbgFile.id;
        }

        // 设置文件上传信息
        console.log("zgbgPublishMaterialId=", zgbgPublishMaterialId);
        console.log("publishId=", publishId);
        _this2.zeroStoreage[zgbgPublishMaterialId] = {
          publishMaterialId: zgbgPublishMaterialId,
          publishId: publishId,
          fileId: fileId
        };
        console.log("this.zeroStoreage=", _this2.zeroStoreage);

        vm.printUrl = "https://ydnj.capub.cn" + "/File/File/printLxJbxx?type=" + vm.pressType + "&publishMaterialId=" + vm.querys.listId + "&token=" + encodeURIComponent(vm.$store.getters.token);
        vm.printUrl1 = "https://ydnj.capub.cn" + "/File/File/printRyJbxx?type=3&publishMaterialId=" + vm.tabDat[3].id + "&token=" + encodeURIComponent(vm.$store.getters.token);
      });
    },
    dmyfile: function dmyfile(exp) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printLxJbxx";
        params = {
          firstYear: this.$route.query.firstYear,
          type: this.pressType,
          publishMaterialId: this.querys.listId
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          type: 3,
          publishMaterialId: this.tabDat[3].id
        };
      }
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    },
    goBack: function goBack() {
      this.$router.push({
        path: "successive_press"
      });
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByOMaterial: function getLxdzModifyFlagByOMaterial() {
      console.log("getLxdzModifyFlagByOMaterial...");
      var vm = this;
      (0, _pressSuccessive.getLxdzModifyFlagByOMaterial)({
        publishMaterialId: this.$route.query.listId // *publicationOrganizationMaterial的主键
      }).then(function (response) {
        vm.modifyFlag = response.payload;
      });
    }
  },
  created: function created() {
    // this.getLxdzModifyFlagByOMaterial();

    this.pressInit();
    this.querys.listId = this.$route.query.listId;
    this.querys.bookName = this.$route.query.bookName;
  }
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _uploadBtn = __webpack_require__(249);

var _uploadBtn2 = _interopRequireDefault(_uploadBtn);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

var _export = __webpack_require__(127);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UpBtn: _uploadBtn2.default
  },
  props: ["pressType", "pressDat"],
  data: function data() {
    return {
      dialogVisible: false,
      checkList: [],
      codeArr: [],
      tabNameMap: {},
      // zym.列表页面不同区域的数据信息
      tabCage: {
        tabDat1: [],
        tabDat2: [],
        tabDat3: []
      },
      // zym.文件上传信息存储（改造成数组）
      zeroStoreage: {},
      // zeroStoreage: {
      //   id: '',
      //   publishMaterialId: '',
      //   publishId: '',
      //   fileId: ''
      // },
      opMsg: "",
      // 核验状态
      msgStatus: "",
      // 是否整改阶段
      isModifyStage: "",
      postId: "",

      filrUrl1: "",
      filrUrl2: "",

      fileToken: "",
      loadUrl: "",

      printUrl1: "",
      printUrl2: "",
      printUrl3: "",

      selYear: "",
      selYearRecord: [{}],
      params: {},

      pubStatus: 0,

      //  审核历史
      tabDat: []
    };
  },

  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          var map = {
            0: "开始",
            7: "提交"
            // 21: "暂缓登记",
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          var _map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记"
          };
          return _map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map2 = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
            22: "暂缓登记",
            21: "暂缓登记"
          };

          return _map2[dat.status];
        } else if (dat.flowName == "登记") {
          var _map3 = {
            0: "待登记",
            1: "待登记",
            2: "已登记"
          };

          return _map3[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
    translate: function translate(dat, code) {
      if (code == "pgress") {
        var transArr = ["未提交", "已提交"];
        return transArr[dat - 1];
      } else if (code == "time") {
        if (dat.status == 2) {
          return dat.updatedAt.substr(0, 16);
        } else {
          return "";
        }
      }
    }
  },
  methods: {
    valChange: function valChange() {
      if (this.selYear != undefined) {
        sessionStorage.setItem("selYear", this.selYear);
      }
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function toEdit(row, type) {
      var urlMap = {
        // 基本情况表
        201: "edit_tab1",
        // 资质情况表 ———— 电子出版物出版许可证
        202: "edit_tab2",
        // 经营情况表
        203: "edit_tab3",
        // 经营场所情况表
        204: "view_tab4",
        // 获得表彰情况登记表
        205: "view_tab5",
        // 重点电子出版物情况登记表
        206: "view_tab6",
        // 受处罚情况表
        207: "edit_tab7",
        // 人员基本情况登记表
        208: "view_tab8",
        301: "view_tab9",

        209: "edit_tab10" // zym.20230404新增
      };
      if (type == 1) {
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 1,
            pubStatus: 0
          }
        });
      } else if (type == 2) {
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 2,
            pubStatus: 0
          }
        });
      } else if (type == 3) {
        // 只能查看
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 2,
            pubStatus: 1
          }
        });
      }
    },

    // 复制表
    copyHandle: function copyHandle(code) {
      var _this = this;

      var vm = this;
      if (code == "show") {
        this.dialogVisible = true;
        (0, _pressRole.copyList)({
          type: vm.pressType
        }).then(function (response) {
          vm.checkList = response.synchroCodeList;
        });
      } else if (code == "act") {
        (0, _pressRole.copySet)({
          type: vm.pressType,
          codes: vm.codeArr
        }).then(function (response) {
          _this.$message.success("拷贝成功");
          _this.dialogVisible = false;
          _this.$emit("go-frash");
        });
      }
    },

    handleClose: function handleClose() {
      this.checkList = [];
      this.codeArr = [];
      this.dialogVisible = false;
    },

    // zym.流转记录
    historyRecord: function historyRecord() {
      var _this2 = this;

      var dat = this.pressDat[0];
      this.examineId = dat.id;
      // console.log("流转记录：", this.examineId, " 年度：", this.selYear);

      (0, _provinceRole.successiveHistoryNew)({ examineId: this.examineId, year1: this.selYear }).then(function (response) {
        var flowData = response.fFlowTaskList;
        _this2.tabDat = flowData.filter(function (item) {
          if (item.flowName == "国家新闻出版署") {
            if (item.status == "1") {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });
      });
    },

    // zym.他是通用的，感觉this.zeroStoreage使用有问题，因为这个地方有两个文件
    // zym.上传完成后，更新文件上传的信息
    // zym.dat = 上传之后，返回来的fileId
    zeroStoreCtrls: function zeroStoreCtrls(dat, btnProps) {
      // console.log("dat=", dat);
      console.log("btnProps=", (0, _stringify2.default)(btnProps));

      var btnKey = btnProps.id;
      var materialTitle = btnProps.materialTitle;

      console.log("this.zeroStoreage[btnKey]=", (0, _stringify2.default)(this.zeroStoreage[btnKey]));

      var detAble = void 0,
          idOld = void 0,
          publishMaterialId = void 0;
      if (this.zeroStoreage[btnKey]) {
        detAble = this.zeroStoreage[btnKey].fileId;
        idOld = this.zeroStoreage[btnKey].id;
        publishMaterialId = this.zeroStoreage[btnKey].publishMaterialId;
      }

      var vm = this;
      this.zeroStoreage[btnKey].fileId = dat;
      (0, _pressRole.sUpdate0)({
        id: idOld,
        publishMaterialId: publishMaterialId,
        fileId: dat,
        materialTitle: materialTitle // zym.新增。20250609，备注：用来标记是整改报告，还是自查报告
        // pfile1: this.zeroStoreage
      }).then(function (response) {
        console.log("sUpdate0 file = ", (0, _stringify2.default)(response));
        var code = response.payload.tipCode;
        var msg = response.payload.message;
        if (code != "success") {}
        // zym.成功，需要刷新页面
        else {
            vm.$emit("go-frash");
          }
        // vm.zeroStoreage.id = response.pfile1.id;
        // this.$emit('go-frash');
        // if (detAble) {
        //   detFile({
        //     id: detAble
        //   }).then(inresp => {
        //     this.$emit('go-frash');
        //   })
        // } else {
        //   vm.zeroStoreage.id = response.pfile1.id;
        //   this.$emit('go-frash');
        // }
      }).catch(function (error) {});
    },

    saveZeroStoreage: function saveZeroStoreage(publishMaterialId, publishId, fileId) {
      this.zeroStoreage[publishMaterialId] = {
        publishMaterialId: publishMaterialId,
        publishId: publishId,
        fileId: fileId
      };
    },

    saveFileId: function saveFileId(tabDat1Item, zichaReportFileId, zhenggaiReportFileId) {
      var zgbgPublishMaterialId = void 0,
          zcbgPublishMaterialId = void 0;
      if (tabDat1Item.materialTitle == "整改报告") {
        // 整改报告
        zgbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zgbgPublishMaterialId, tabDat1Item.organizationId, zhenggaiReportFileId);
      } else {
        // 有时候不叫自查报告 而是工作报告（
        zcbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zcbgPublishMaterialId, tabDat1Item.organizationId, zichaReportFileId);
      }
    },
    // zym.数据获取之后，页面其他信息初始化
    pressInit: function pressInit() {
      var dat = this.pressDat[0];
      // console.log('pressInit: ', JSON.stringify(dat))
      var vm = this;
      if (dat.reportUploadList) {
        // 是否出版社阶段，比对的是progress（CONST.TASKTYPE.START.value），如果是出版社阶段返回0，否则返回1
        this.pubStatus = dat.pubStatus;
        this.tabCage.tabDat1 = dat.reportUploadList;
        this.tabCage.tabDat2 = dat.yearVerificationList;
        this.tabCage.tabDat3 = dat.licenseUploadList;

        console.log("文件材料信息: ", (0, _stringify2.default)(this.tabCage.tabDat1));
        console.log("dat.pFile1: ", (0, _stringify2.default)(dat.pFile1));
        console.log("dat.pFile2: ", (0, _stringify2.default)(dat.pFile2));

        // 退回消息
        this.opMsg = dat.msg;
        // 状态
        this.msgStatus = dat.msgStatus;
        this.isModifyStage = dat.isModifyStage;
        this.postId = dat.reportUploadList[0].materialExamineId;

        console.log("publishMaterialId1=", this.tabCage.tabDat1[0].id);
        console.log("publishMaterialId2=", this.tabCage.tabDat2[0].id);

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        var zichaReportFileId = undefined;
        var zhenggaiReportFileId = undefined;
        if (dat.pFile1 && dat.pFile1.length > 0) {
          console.log("到达file1...");
          zichaReportFileId = dat.pFile1[0].id;
        }

        if (dat.pFile2 && dat.pFile2.length > 0) {
          console.log("到达file2...,", dat.pFile2[0].id, ",", this.tabCage.tabDat1[1].id);
          zhenggaiReportFileId = dat.pFile2[0].id;
        }

        this.saveFileId(this.tabCage.tabDat1[0], zichaReportFileId, zhenggaiReportFileId);
        if (this.tabCage.tabDat1[1] != undefined) {
          this.saveFileId(this.tabCage.tabDat1[1], zichaReportFileId, zhenggaiReportFileId);
        }

        // 调节顺序
        if (this.tabCage.tabDat1[0].materialTitle == "整改报告") {
          // 有整改必有自查
          var tabDatTmp = this.tabCage.tabDat1[0];
          this.tabCage.tabDat1[0] = this.tabCage.tabDat1[1];
          this.tabCage.tabDat1[1] = tabDatTmp;
        }

        // console.log('this.zeroStoreage=',JSON.stringify(this.zeroStoreage));
        (0, _account.getFileToken)().then(function (response) {
          vm.printUrl1 = "https://ydnj.capub.cn" + "/File/File/printYxdzJbxx?type=" + vm.pressType + "&organizationId=" + vm.tabCage.tabDat2[0].organizationId + "&token=" + encodeURIComponent(vm.$store.getters.token);
          vm.printUrl2 = "https://ydnj.capub.cn" + "/File/File/printRyJbxx?type=" + vm.pressType + "&publishMaterialId=" + vm.tabCage.tabDat2[7].id + "&token=" + encodeURIComponent(vm.$store.getters.token);
          vm.printUrl3 = "https://ydnj.capub.cn" + "/File/File/printYxdzCbwqkb?type=" + vm.pressType + "&publishMaterialId=" + vm.tabCage.tabDat3[0].id + "&organization=" + encodeURIComponent(vm.$store.getters.name) + "&token=" + encodeURIComponent(vm.$store.getters.token);
        });
      }

      this.setYearArray();
    },
    // 设置年份（废弃掉，直接选择当前年份的即可）
    setYearArray: function setYearArray() {
      this.selYear = this.$store.getters.userInfo.year1;
      // let that = this;
      // getSelYearRecord({
      //   publishId: this.tabCage.tabDat2[0].organizationId,
      //   type: this.pressType,
      // }).then((response) => {
      //   console.log("======", response);
      //   let arr = [];
      //   let yearList = response.generalPublisher;
      //   if (yearList.length > 0) {
      //     let po = yearList[yearList.length - 1];
      //     that.params.year1 = po.firstYear;
      //     that.selYear = po.firstYear;
      //     // for (let i = 0; i < response.generalPublisher.length; i++) {
      //     //   let po = response.generalPublisher[i];
      //     //   arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
      //     //   if (response.generalPublisher.length - 1 == i) {
      //     //     that.params.year1 = po.firstYear;

      //     //     let cacheYear = sessionStorage.getItem("selYear");
      //     //     if (cacheYear !== null && cacheYear !== "") {
      //     //       that.selYear = cacheYear;
      //     //     } else {
      //     //       that.selYear = po.firstYear;
      //     //     }
      //     //   }
      //     // }
      //   }
      //   that.selYearRecord = arr;
      // });
    },
    dmyfile: function dmyfile(exp, obj) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printYxdzJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat2[7].id,
          organization: encodeURIComponent(this.$store.getters.name),
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 3) {
        expUrl = "/api/export/printYxdzCbwqkb";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat3[0].id,
          organization: encodeURIComponent(this.$store.getters.name),
          organizationId: this.tabCage.tabDat2[0].organizationId
        };
      } else if (exp == 4) {
        expUrl = "/api/export/download";
        params = {
          id: this.pressDat[0].pFile1.fileId
        };
      }
      (0, _export.expFile)({ expUrl: expUrl, p: params }).then(function (blob) {
        var blobHref = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = blobHref;
        var fname = localStorage.getItem("dfilename");
        anchor.download = decodeURIComponent(fname);
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobHref);
        document.body.removeChild(anchor);
      }).catch(function (error) {});
    },
    goFrash: function goFrash() {
      this.$emit("go-frash");
    },

    upToPvc: function upToPvc() {
      var _this3 = this;

      var vm = this;
      this.$confirm("确定所需填报表格已填写完成，并提交省局吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });

        (0, _pressRole.subToPvc)({
          materialExamineId: _this3.postId
          // type: 1 // zym.type类型不能要，音像、电子共用接口，nodejs根据examine来判断哪种类型
        }).then(function (response) {
          loading.close();
          console.log("response=", (0, _stringify2.default)(response));
          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.message || "操作失败";
          if (tipCode == "fail") {
            _this3.$message({
              showClose: true,
              message: tipMessage,
              type: "error"
            });
          } else {
            _this3.$message({
              message: "操作成功！",
              type: "success"
            });
            _this3.$router.push("pgress_step");
          }
        });
      }).catch(function () {});
    }
  },
  watch: {
    pressDat: function pressDat(curVal, oldVal) {
      this.pressInit();

      // 流转记录
      this.historyRecord();
    }
  },
  created: function created() {
    // this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    // this.filrUrl2 = process.env.BASE_API + '/File/File/downloadDrmb?code=0012&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = "https://ydnj.capub.cn/ydfile" + "/drmb/001.xlsx"; // 封面和盖章页
    this.filrUrl2 = "https://ydnj.capub.cn/ydfile" + "/drmb/002.xlsx"; // 封面和盖章页
    // this.filrUrl1 = process.env.BASE_API + '/drmb/001.xlsx // 封面和盖章页';

    // 之后再重设选择年份
    // let cacheYear = sessionStorage.getItem("selYear");
    // if (cacheYear != null && cacheYear != "") {
    //   if (cacheYear != this.selYear) {
    //     this.selYear = cacheYear;
    //     this.valChange();
    //     return;
    //   }
    // }

    // 年份设置为固定当年的
    this.selYear = this.$store.getters.userInfo.year1;

    this.pressInit();

    // 流转记录
    this.historyRecord();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pressSuccessive = __webpack_require__(28);

exports.default = {
    props: ['pressType'],
    data: function data() {
        return {
            tabDat: [],
            zeroStoreage: {
                id: '',
                publishMaterialId: '',
                publishId: '',
                fileId: '',

                wSat: 0
            },
            opMsg: ''
        };
    },

    filters: {
        translate: function translate(dat, code) {
            if (code == 'pgress') {
                if (dat == 8) {
                    return '未提交';
                } else if (dat == 2) {
                    return '已提交';
                }
            } else if (code == 'time') {
                return dat.substr(0, 16);
            }
        }
    },
    methods: {
        toEdit: function toEdit(row, type) {
            var urlMap = {
                401: 'edit_ssTab1',
                402: 'edit_ssTab2',
                404: 'edit_ssTab3',
                410: 'sstab4_list'
            };

            this.$router.push({
                path: urlMap[row.code],
                query: {
                    pressId: row.organizationId,
                    mtId: row.id,
                    pgress: type,
                    listId: this.$route.query.listId
                }
            });
        },

        zeroStoreCtrls: function zeroStoreCtrls(dat) {
            var _this = this;

            var detAble = this.zeroStoreage.fileId;
            this.zeroStoreage.fileId = dat;
            sUpdate0({ pfile1: this.zeroStoreage }).then(function (response) {
                if (detAble) {
                    detFile({ id: detAble }).then(function (inresp) {
                        _this.zeroStoreage.id = response.pfile1.id;
                    });
                }
            }).catch(function (error) {});
        },

        pressInit: function pressInit() {
            var _this2 = this;

            (0, _pressSuccessive.getSuccessTabs)({
                publishMaterialId: this.$route.query.listId,
                no: 1,
                size: 15
            }).then(function (response) {
                _this2.tabDat = response.ppublicationOrganizationMaterialList;
            });
        },

        goBack: function goBack() {
            this.$router.go(-1);
            // this.$router.push({
            //     path:'successive_press'
            // })
        }
    },
    created: function created() {
        this.pressInit();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _auth = __webpack_require__(46);

var _provinceRole = __webpack_require__(20);

var _account = __webpack_require__(16);

var _pressRole = __webpack_require__(7);

var _vuex = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      percentage: 0, // zym.上传百分比
      upStateHybg: "wait", // zym.上传的状态
      upStateZgbg: "wait", // zym.上传的状态

      fileData: {},
      fileToken: "",

      ableUpHybg: 0, // zym.分析报告
      ableUpZgbg: 0, // zym.整改报告

      reportId: "",

      fileUrlHybg: "",
      fileNameHybg: "",

      fileUrlZgbg: "",
      fileNameZgbg: "",

      postUrl: "",
      postHead: {}
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  methods: {
    goUrl: function goUrl(url) {
      window.open(url);
    },
    handleExceed: function handleExceed() {},
    removeCtrls: function removeCtrls() {},
    prevCtrls1: function prevCtrls1(file) {
      var nameArr = file.name.split(".");
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error"
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error"
        });
        return false;
      } else {
        this.percentage = 0;
        this.upStateHybg = "loading";
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        this.postHead["Authorization"] = "Bearer " + (0, _auth.getToken)();

        return true;
      }
    },
    prevCtrls2: function prevCtrls2(file) {
      var nameArr = file.name.split(".");
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error"
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error"
        });
        return false;
      } else {
        this.percentage = 0;
        this.upStateZgbg = "loading";
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        this.postHead["Authorization"] = "Bearer " + (0, _auth.getToken)();

        return true;
      }
    },
    pgressCtrls: function pgressCtrls(evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function errorCtrls(err) {
      this.upStateHybg = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error"
      });
    },

    successCtrls: function successCtrls(data, file) {
      var _this = this;

      var vm = this;
      this.percentage = 99;
      var newDate = new Date();
      var yearStr = newDate.getFullYear() - 2 + "-" + (newDate.getFullYear() - 1);

      var params = data.data.params;
      console.log("data=", data);
      // console.log('data.data=',JSON.stringify(data.data.params))

      // zym.分析报告
      if (params.fileProperty == 1) {
        (0, _provinceRole.ssReportUpload)({
          provinceReport: {
            reportId: data.payload.id,
            type: 1,
            status: this.ableUpHybg
          }
        }).then(function (response) {
          _this.percentage = 100;
          _this.upStateHybg = "loaded";
          _this.$refs.upload.clearFiles();

          vm.fileNameHybg = data.payload.fileName;
          (0, _pressRole.getPfileUrl)({ id: data.payload.id }).then(function (response) {
            vm.fileUrlHybg = response.payload.url;
          });

          _this.$emit("go-frash");
        }).catch(function (error) {
          _this.$refs.upload.clearFiles();
          _this.upStateHybg = "wait";
        });
      }
      // zym.整改报告
      else if (params.fileProperty == 2) {
          (0, _provinceRole.upPostponeDesc)({
            provinceReport: {
              reportId: data.payload.id,
              type: 1,
              status: this.ableUpZgbg
            }
          }).then(function (response) {
            _this.percentage = 100;
            _this.upStateZgbg = "loaded";
            _this.$refs.upload.clearFiles();

            vm.fileNameZgbg = data.payload.fileName;
            (0, _pressRole.getPfileUrl)({ id: data.payload.id }).then(function (response) {
              vm.fileUrlZgbg = response.payload.url;
            });

            _this.$emit("go-frash");
          }).catch(function (error) {
            _this.$refs.upload.clearFiles();
            _this.upStateZgbg = "wait";
          });
        }
    },

    // zym.上报国家新闻出版署
    goAdmin: function goAdmin() {
      var _this2 = this;

      var vm = this;
      var loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _provinceRole.stepToAdmin)({
        type: 1
      }).then(function (response) {
        loading.close();
        var tipCode = response.payload.tipCode;
        var tipMessage = response.payload.tipMessage || "操作失败";
        if (tipCode == "fail") {
          _this2.$message({
            showClose: true,
            message: tipMessage,
            type: "error"
          });
        } else {
          _this2.$message({
            message: tipMessage,
            type: "success",
            onClose: function onClose() {
              vm.$emit("go-frash");
            }
          });
          // this.ableUpHybg = 2;
          // this.ableUpZgbg = 2;
        }
      });
    },

    goFirmSeek: function goFirmSeek() {
      var _this3 = this;

      var promiseArr = [];
      var vm = this;
      var loading = vm.$loading({
        lock: true,
        text: "状态查询中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      // zym.查询通过状态
      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _provinceRole.successiveReported)({
          type: 1
        }).then(function (response) {
          // console.log('response11=',JSON.stringify(response));
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));
      // zym.查询分析报告
      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _provinceRole.ssReportLoad)({
          type: 1,
          provinceId: _this3.userInfo.orgId
        }).then(function (response) {
          console.log("response=", (0, _stringify2.default)(response));
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));

      // zym.整改报告
      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _provinceRole.getPostponeDesc)({
          type: 1,
          provinceId: _this3.userInfo.orgId
        }).then(function (response) {
          // console.log('response=',JSON.stringify(response));
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));

      // promiseArr.push(new Promise((resolve, reiect) => {
      //   getFileToken().then(response => {
      //     resolve(response);
      //   }).catch(error => {
      //     reiect(error);
      //   })
      // }));
      _promise2.default.all(promiseArr).then(function (result) {
        // console.debug('Promise.all: ', result)
        var isPosted = false; // zym.是否全部通过
        var isUploadHybg = false; // zym.分析报告是否上传
        var isUploadZgbg = false; // zym.分析报告是否上传
        // vm.fileToken = result[2].resultStatus.token;
        console.log("result[0]=", result[0]);
        if (result[0].status == 2) {
          isPosted = true;
        }

        // zym.分析报告
        var provinceReport = result[1].provinceReport;
        // console.log('provinceReport=',JSON.stringify(provinceReport));
        if (provinceReport && provinceReport.reportId) {
          isUploadHybg = true;
          (0, _pressRole.getPfileUrl)({ id: provinceReport.reportId }).then(function (response) {
            vm.fileUrlHybg = response.payload.url;
            vm.fileNameHybg = response.payload.fileName;
          });
        }

        // zym.整改报告
        var upPostponeDesc = result[2].upPostponeDesc;
        if (upPostponeDesc && upPostponeDesc.reportId) {
          isUploadZgbg = true;
          (0, _pressRole.getPfileUrl)({ id: upPostponeDesc.reportId }).then(function (response) {
            vm.fileUrlZgbg = response.payload.url;
            vm.fileNameZgbg = response.payload.fileName;
          });
        }

        console.log("isPosted=", isPosted);
        console.log("isUploadHybg=", isUploadHybg);
        console.log("isUploadZgbg=", isUploadZgbg);
        if (isPosted) {
          if (isUploadHybg) {
            vm.ableUpHybg = 2;
          } else {
            vm.ableUpHybg = 3;
          }

          // zym.整改报告
          if (isUploadZgbg) {
            vm.ableUpZgbg = 2;
          } else {
            vm.ableUpZgbg = 3;
          }
        } else {
          vm.ableUpHybg = 1;
          vm.ableUpZgbg = 1;
          if (isUploadHybg) {
            vm.upStateHybg = "loaded";
          }
          if (isUploadZgbg) {
            vm.upStateZgbg = "loaded";
          }
        }

        loading.close();
      });
    }
  },

  created: function created() {
    this.goFirmSeek();
    this.postUrl = "https://ydnj.capub.cn" + "/eavar/file/upload";
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _SpecCommonTab = __webpack_require__(175);

var _SpecCommonTab2 = _interopRequireDefault(_SpecCommonTab);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CommonTab: _SpecCommonTab2.default
  },
  data: function data() {
    return {
      querys: {
        pressType: "",
        pressId: "",
        pressState: 1,
        pressName: ""
      },
      wSat: 0,
      resDat: [{}],
      params: {
        publishMaterialIds: [],
        status: "1",
        message: "",
        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "" // zym.注销意见
      },

      //  审核历史
      tabDat: [],
      dialogTableVisible: false,
      repeatJson: {},
      publishUnitJson: {}
    };
  },


  filters: {
    processYijian: function processYijian(dat) {
      var yijian = dat.examineMessage;
      if (!yijian) {
        return "";
      }
      console.log("yijian=", yijian);
      var yijianArray = yijian.split("；");
      var backYijian = void 0;
      for (var index = 0; index < yijianArray.length; index++) {
        backYijian += yijianArray[index] + "<br/>";
      }
      return backYijian;
    },
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          var map = {
            0: "开始",
            7: "提交",
            21: "暂缓登记"
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          var _map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",

            21: "暂缓登记"
            // 22: "暂缓登记",
          };
          return _map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map2 = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",

            21: "暂缓登记"
            // 22: "暂缓登记",
          };

          return _map2[dat.status];
        } else if (dat.flowName == "登记") {
          var _map3 = {
            0: "待登记",
            1: "待登记",
            2: "已登记"
          };

          return _map3[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    }
  },

  methods: {
    goBackExamsave: function goBackExamsave() {
      var _this = this;

      var msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        var _msg = "确定已查看完毕，退回出版单位吗？";
        this.$confirm(_msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.publishMaterialIds = [];
          _this.params.publishMaterialIds.push(_this.$refs.mainTab.postPrevs());

          // 创建新的参数
          var paramsNew = (0, _extends3.default)({}, _this.params, { status: "3" });
          var vm = _this;
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          (0, _provinceRole.goProvinceExam)(paramsNew).then(function (response) {
            loading.close();

            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            var resMsg = response.payload.resMsg;
            var appendMsg = resMsg ? resMsg.join(",") : "";
            // console.log('response=',JSON.stringify(response));
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage + " " + appendMsg,
                type: "error"
              });
            } else {
              _this.$message({
                message: tipMessage + " " + appendMsg,
                type: "success"
              });

              // zym.原来的方法
              _this.goBack();
            }
          });
        }).catch(function () {});
      }
    },
    goExamsave: function goExamsave() {
      var _this2 = this;

      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 12) {
        this.params.zanhuanMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 13) {
        this.params.zhuxiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 14) {
        this.params.chexiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      // this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      // this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      // this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      var msg = "请填写意见！";
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写退回意见！");
      } else if (this.params.status == 21 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓登记意见！");
      } else if (this.params.status == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓意见！");
      } else if (this.params.status == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写建议注销意见！");
      } else if (this.params.status == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写建议撤销意见！");
      } else {
        // let msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？"; // zym.通过
        // console.log("this.params.status=", this.params.status);
        // if (this.params.status == 3) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        // } else if (this.params.status == 21) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        //   // msg = "确定已查看完毕，并对该单位核验材料批以暂缓登记处理吗？";
        // } else if (this.params.status == 12) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以暂缓吗？";
        // } else if (this.params.status == 13) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以注销吗？";
        //   // msg = "确定已查看完毕，并对该单位核验材料批以建议注销吗？";
        // }
        // else if (this.params.status == 14) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以建议撤销吗？";
        // }
        // else if (this.params.status == 1) {
        //   msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？";
        // } else {
        //   this.$message.error("发现不可操作的审批结果，无法进行操作！");
        //   return;
        // }
        console.log("this.params.status=", this.params.status);
        var _msg2 = "确定已查看完毕，提交审核意见吗？";
        if (this.params.status == 3) {
          _msg2 = "确定已查看完毕，退回出版单位吗？";
        }
        this.$confirm(_msg2, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this2.params.publishMaterialIds = [];
          _this2.params.publishMaterialIds.push(_this2.$refs.mainTab.postPrevs());
          var vm = _this2;
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _provinceRole.goProvinceExam)(_this2.params).then(function (response) {
            // this.$message.info({
            // 	message: '若音像、电子出版单位全部审核完成，请前往上报板块向进行上报',
            // 	duration: 5000
            // });
            loading.close();

            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            var resMsg = response.payload.resMsg;
            var appendMsg = resMsg ? resMsg.join(",") : "";
            // console.log('response=',JSON.stringify(response));
            if (tipCode == "fail") {
              _this2.$message({
                message: tipMessage + " " + appendMsg,
                type: "error"
              });
            } else {
              _this2.$message({
                message: tipMessage + " " + appendMsg,
                type: "success"
              });

              // zym.原来的方法
              _this2.goBack();
            }
          });
        }).catch(function () {});
      }
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    valChangeSearch: function valChangeSearch(val) {
      this.gPlist(val);
    },
    // zym.流转记录
    // zym.20250321，处理一下当前选中的审核意见
    historyRecord: function historyRecord() {
      var _this3 = this;

      (0, _provinceRole.successiveHistoryNew)({ examineId: this.querys.mtId, year1: this.querys.year1 }).then(function (response) {
        _this3.tabDat = response.fFlowTaskList;
        // 查找最后的省局审核意见
        var tabDatProvince = (_this3.tabDat || []).filter(function (item) {
          return item.flowName == "省局";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          var last = tabDatProvince[tabDatProvince.length - 1];
          _this3.params.status = last.status == "0" ? "1" : last.status + "";
          _this3.params.message = last.examineMessage;
        } else {
          _this3.params.status = "1";
          _this3.params.message = "";
        }
        //  successiveHistory({publishId:this.querys.mtId}).then(response => {
        // console.debug('successiveHistory: ', response)
        // for (let i = 0; i < response.fFlowTaskList.length; i++) {
        // 	if (response.fFlowTaskList[i].examineName) {
        // 		this.tabDat.push(response.fFlowTaskList[i]);
        // 	}
        // }
      });
    },

    gPlist: function gPlist(year) {
      var _this4 = this;

      (0, _pressRole.getPressList)({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year
      }).then(function (response) {
        console.debug("getPressList: ", response);
        var vm = _this4;
        vm.wSat = 1;
        _this4.resDat.splice(0, 1, response);
        _this4.repeatJson = response.verifyWorkerList;
        // console.log(this.repeatJson)
      });
    },

    writeReadTime: function writeReadTime(year) {
      (0, _provinceRole.writeReadTime)({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year
      }).then(function (response) {
        console.debug("writeReadTime: ", response);
      });
    },
    //获取出版单位各项统计信息
    getPublishStatic: function getPublishStatic() {
      var _this5 = this;

      //  publishStatic().then(response => {
      (0, _provinceRole.publishStatic)({ examineId: this.querys.mtId }).then(function (response) {
        console.debug("publishStatic: ", response);
        _this5.publishUnitJson = response.publisherStatistics;
      });
    }
  },

  created: function created() {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressName: this.$route.query.pressName,
      pressState: this.$route.query.pressState,

      mtId: this.$route.query.mtId,
      examId: this.$route.query.examId,
      pvcName: this.$route.query.pvcName,
      year1: this.$route.query.year1
    };

    this.gPlist(this.querys.year1);

    // 更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTime(this.querys.year1);
    }

    this.historyRecord();
    this.getPublishStatic();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        type: 1,
        year1: "",
        keyword: "",
        sjExamineId: "",
        no: 1,
        size: 15,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.pressSeek)(this.params).then(function (response) {
        _this.tabDats = response.generalPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(inDat) {
      this.$router.push({
        path: "exam_check",
        query: {
          mtId: inDat.materialExamineId,
          pressType: 1,
          pressId: inDat.organizationId,
          pvcName: inDat.sjExamine,
          pvcId: inDat.sjExamineId,
          pressName: inDat.organizationName,
          examId: inDat.id,
          pressState: 2,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearYx", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    this.params.sjExamineId = this.$store.getters.userInfo.orgId;
    var selYearYx = sessionStorage.getItem("selYearYx") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: this.params.type
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearYx != "") {
              _this2.params.year1 = selYearYx;
              _this2.selYear = selYearYx;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

exports.default = {
  data: function data() {
    return {
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "未提交",
        key: 8
      }, {
        name: "待审核",
        key: 0
      }, {
        name: "已审核",
        key: 1
      }],
      backdiag: false,
      backtype: "", // zym.类型
      postDat: {
        type: 1,
        status: 99,
        keyword: "",
        no: 1,
        size: 15
      },
      tabDatAll: [],
      tabDats: [],
      pgAll: "",
      loading: false,

      examIds: [],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: "",
        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "" // zym.注销意见
      },
      selectKey: ""
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      console.log("dat.statuszj=", dat);
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    // zym.数据处理
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          8: "未提交",
          0: "待审核",
          1: "通过",
          3: "未提交",
          9: "已上报",

          12: "暂缓",
          13: "注销或拟注销",
          // 14: "建议撤销",
          // 21: "暂缓登记",
          // 22: "暂缓登记",
          14: "注销或拟注销",
          21: "暂缓登记",
          22: "暂缓登记"
        };

        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        if (dat.progress == "登记") {
          // return setMap[dat.pubStatus] + "（已核验）";
          return "已发布";
        } else if (dat.progress == "国家新闻出版署") {
          return "已上报";
        } else if (dat.progress == "省局") {
          // if (dat.isBack == 2) {
          //   return map[dat.status] + "（退回）";
          // } else {
          //   return map[dat.status];
          // }
          return "";
        } else {
          if (dat.isBack == 2 && dat.status == 21) {
            return "未提交（暂缓登记）";
          } else if (dat.isBack == 2 && dat.status == 22) {
            return "出版署（暂缓登记）";
          } else if (dat.isBack == 2 && dat.status != 21) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        }
      } else if (code == "time") {
        // console.log(dat)
        if (!dat || dat == "Invalid date") {
          return "";
        } else {
          return dat.substr(0, 16);
        }
      } else if (code == "sjstatus") {
        var _map = {
          // 8: "未提交",
          // 0: "待审核",
          1: "通过",
          // 3: "未提交",
          // 9: "已上报",

          13: "注销或拟注销",
          21: "暂缓登记"
        };

        // if (dat.isBack == 2) {
        return _map[dat.sjstatus];
        // } else {
        // return map[dat.status];
        // }
        // return "";
      }
    }
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.params.publishMaterialIds = [];
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    // zym.查询数据
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _provinceRole.getProvinceList)(this.postDat).then(function (response) {
        console.debug("getProvinceList: ", response, _this.postDat);
        _this.tabDatAll = response.fmaterialexamineList;
        // this.pgAll = response.totalPages;

        _this.loading = false;
        _this.firstYear = response.firstYear;
        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        tabDats = tabDats.filter(function (item) {
          // zym.未提交
          if (qType == 8 && (item.progress || "") == "开始") {
            return true;
          }
          // zym.待审核
          if (qType == 0 && (item.progress || "") == "省局" && item.status == "0") {
            return true;
          }
          // zym.已审核
          if (qType == 1 && ((item.progress || "") == "省局" && (item.status == "1" || item.status == "12" || item.status == "13" || item.status == "14") || (item.progress || "") == "国家新闻出版署")) {
            return true;
          }
          return false;
          // if ((item.progress || '') == statusKey[qType]) {
          //   return true;
          // }
          // return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatAll = this.tabDats;
      var dataLen = Number(tabDatAll.length);
      var size = Number(postDat.size);
      var total = Math.floor(dataLen / size);
      this.tabDats = tabDatAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },
    // zym.翻页
    pageSent: function pageSent(dat) {
      this.postDat.no = dat;
      // this.tabSeek();
      this.postDat.goPage = true;
    },
    styleTrans: function styleTrans(row, code) {},
    // zym.跳转到查看页面
    goFirm: function goFirm(inDat, type) {
      this.$router.push({
        path: "exam_check",
        query: {
          pressType: 1,
          pressId: inDat.organizationId,
          pressName: inDat.organizationName,
          mtId: inDat.materialExamineId,
          pressState: type,
          updateViewDate: true,
          year1: this.firstYear
        }
      });
    },
    // zym.选择的记录，materialExamineId集合
    selectionChange: function selectionChange(resDat) {
      this.params.publishMaterialIds = [];
      for (var i = 0; i < resDat.length; i++) {
        this.params.publishMaterialIds.push(resDat[i].materialExamineId);
      }
    },
    // zym.选择审核结果，保存审核内容
    handleSelect: function handleSelect(dat) {
      var _this2 = this;

      var vm = this;
      if (this.params.publishMaterialIds.length > 0) {
        this.params.status = dat;
        // zym.通过
        if (dat == 1) {
          this.$confirm('确定已查看完毕，并对该单位核验材料批以"审核通过"处理吗？', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            // this.$message.info({
            //      message:'若省局已经审核完成，请点击“上报国家新闻出版署”。',
            //      duration:5000
            // });
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _provinceRole.goProvinceExam)(_this2.params).then(function (response) {
              loading.close();

              // this.tabSeek('init');
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              var resMsg = response.payload.resMsg;
              var appendMsg = resMsg ? resMsg.join(",") : "";
              console.log("appendMsg=", appendMsg);
              if (tipCode == "fail") {
                _this2.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error"
                });
              } else {
                _this2.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success"
                });

                _this2.tabSeek("init");
              }
            });
          }).catch(function () {
            loading.close();
          });
        }
        // zym.退回
        else if (dat == 3 || dat == 21 || dat == 12 || dat == 13 || dat == 14) {
            this.backdiag = true;
            this.backtype = dat;
          }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },

    // zym.退回的时候处理
    arrExam: function arrExam() {
      var _this3 = this;

      this.params.message = this.params.message.replace(/\s+/g, "");
      this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      var tipMsg = "请填写意见";
      if (this.backtype == 3 && this.params.message.length == 0) {
        this.$message.error(tipMsg);
        // this.$message.error("请填写退回意见！");
      } else if (this.backtype == 21 && this.params.message.length == 0) {
        this.$message.error(tipMsg);
        // this.$message.error("请填写暂缓登记意见！");
      } else if (this.backtype == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error(tipMsg);
        // this.$message.error("请填写暂缓意见！");
      } else if (this.backtype == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error(tipMsg);
        // this.$message.error("请填写建议注销意见！");
      } else if (this.backtype == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error(tipMsg);
        // this.$message.error("请填写建议撤销意见！");
      } else {
        this.backdiag = false;
        var vm = this;
        var _loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _provinceRole.goProvinceExam)(this.params).then(function (response) {
          _loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage;
          var resMsg = response.payload.resMsg;
          var appendMsg = resMsg ? resMsg.join(",") : "";
          console.log("appendMsg=", appendMsg);
          if (tipCode == "fail") {
            _this3.$message({
              message: tipMessage + "！" + appendMsg,
              type: "error"
            });
          } else {
            _this3.$message({
              message: "操作完成，" + "！" + appendMsg,
              type: "success"
            });

            _this3.tabSeek("init");
          }
        });
      }
    },

    // zym.关闭意见填写框
    handleClose: function handleClose() {
      this.params.message = "";
      this.params.zanhuanMessage = "";
      this.params.chexiaoMessage = "";
      this.params.zhuxiaoMessage = "";
      this.backdiag = false;
    },

    // zym.判断是否可以审核，可以审核的
    checkDfine: function checkDfine(row, inx) {
      console.log(row.status);
      if (row.status == 0 || row.status == 1 ||
      // zym.新增
      row.status == 12 || row.status == 21 ||
      // 出版署整改
      row.status == 22 || row.status == 13 || row.status == 14) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.tabSeek();

    if (this.$route.query.pams_no) {
      this.postDat.no = parseInt(this.$route.query.pams_no);
      this.postDat.status = parseInt(this.$route.query.pams_status);
      this.postDat.keyword = this.$route.query.pams_keyword;
    } else if (this.$route.query.key) {
      this.postDat.status = parseInt(this.$route.query.key);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {

      // 登记状态组
      typeArr: [{
        name: '全部',
        key: 0
      }, {
        name: '未登记',
        key: 1
      }, {
        name: '已登记',
        key: 2
      }],

      // 核验状态组
      staArr: [{
        name: '全部',
        key: 99
      }, {
        name: '通过',
        key: 1
      }, {
        name: '暂缓',
        key: 2
      }, {
        name: '撤销',
        key: 4
      }, {
        name: '注销',
        key: 5
      }],

      loading: false,
      postDat: {
        type: 1,
        status: 0,
        record: 0,
        keyword: '',

        no: 1,
        size: 15,
        total: 0
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0
    };
  },


  filters: {
    transStr: function transStr(row, code) {
      if (code == 'record_state') {
        if (row.record == 1) {
          return '未登记';
        } else if (row.record == 2) {
          return '已登记';
        }
      } else if (code == 'state') {
        var map = {
          1: '通过',
          2: '暂缓',
          4: '撤销',
          5: '注销'
        };
        return map[row.pubStatus];
      } else if (code == 'time') {
        if (row == 'Invalid date' || !row) {
          return "";
        }
        return row.substr(0, 16);
      }
    }
  },

  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == 'init') {
        this.postDat.no = 1;
      };
      this.loading = true;
      (0, _provinceRole.registList)(this.postDat).then(function (response) {
        // console.log('response=',JSON.stringify(response));
        _this.loading = false;
        _this.tabDatsAll = response.provinceRecordList;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      if (qType != '0') {
        tabDats = tabDats.filter(function (item) {
          // zym.待核验
          if (qType == 1 && item.record == '1') {
            return true;
          } else if (qType == 2 && item.record == '2') {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || '').indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat['total'] = total;
      this.postDat = postDat;
    },
    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    goRegist: function goRegist(row) {
      var _this2 = this;

      var vm = this;
      this.$confirm('确认登记吗？', '提示', {
        confirmButtonText: '登记',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: '处理中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _provinceRole.goRegist)({
          id: row.id
        }).then(function (response) {
          loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage || '操作失败';
          if (tipCode == 'fail') {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this2.$message({
              message: tipMessage,
              type: 'success',
              onClose: function onClose() {
                vm.tabSeek('init');
              }
            });
          }
        });
      }).catch(function () {});
    },

    goScan: function goScan(inDat) {
      this.$router.push({
        path: 'exam_check',
        query: (0, _defineProperty3.default)({
          pressType: 1,
          pressId: inDat.organizationId,
          mtId: inDat.materialExamineId,
          pressState: 2,
          leadFrom: 2
        }, 'mtId', inDat.materialExamineId)
      });
    }

  },

  created: function created() {
    this.tabSeek();
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonReport = __webpack_require__(347);

var _commonReport2 = _interopRequireDefault(_commonReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        reportTemp: _commonReport2.default
    },
    data: function data() {
        return {
            frashState: true
        };
    },

    methods: {
        frashCtrls: function frashCtrls() {
            var _this = this;

            this.frashState = false;
            this.$nextTick(function () {
                return _this.frashState = true;
            });
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpecCommonTab = __webpack_require__(175);

var _SpecCommonTab2 = _interopRequireDefault(_SpecCommonTab);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CommonTab: _SpecCommonTab2.default
  },
  data: function data() {
    return {
      querys: {
        pressType: "",
        pressId: "",
        pressState: 1,
        leadFrom: ""
      },

      wSat: 0,
      resDat: [{}],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: ""
      }
    };
  },


  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          var map = {
            1: "通过",
            3: "退回",
            9: "已审核"
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map = {
            1: "通过",
            2: "暂缓",
            4: "撤销",
            5: "注销",
            9: "已发布"
          };

          return _map[dat.status];
        } else if (dat.flowName == "登记") {
          var _map2 = {
            1: "待登记",
            2: "已登记"
          };
          return _map2[dat.status];
        }
      }
    }
  },

  methods: {
    goExamsave: function goExamsave() {
      var _this = this;

      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error("请填写退回意见！");
      } else {
        var msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？";
        if (this.params.status == 3) {
          msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.publishMaterialIds.push(_this.$refs.mainTab.postPrevs());
          (0, _provinceRole.goProvinceExam)(_this.params).then(function (response) {
            _this.goBack();
          });
        }).catch(function () {});
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    var _this2 = this;

    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressState: this.$route.query.pressState,
      leadFrom: this.$route.query.leadFrom
    };

    (0, _pressRole.getPressList)({
      type: this.querys.pressType,
      publishId: this.querys.pressId
    }).then(function (response) {
      var vm = _this2;
      vm.wSat = 1;
      _this2.resDat.splice(0, 1, response);
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        type: 2,
        year1: "",
        keyword: "",
        sjExamineId: "",
        no: 1,
        size: 15,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.pressSeek)(this.params).then(function (response) {
        _this.tabDats = response.generalPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(inDat) {
      this.$router.push({
        path: "exam_check",
        query: {
          mtId: inDat.materialExamineId,
          pressType: 2,
          pressId: inDat.organizationId,
          pvcName: inDat.sjExamine,
          pvcId: inDat.sjExamineId,
          pressName: inDat.organizationName,
          examId: inDat.id,
          pressState: 2,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearDz", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    this.params.sjExamineId = this.$store.getters.userInfo.orgId;
    var selYearDz = sessionStorage.getItem("selYearDz") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: this.params.type
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearDz != "") {
              _this2.params.year1 = selYearDz;
              _this2.selYear = selYearDz;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "未提交",
        key: 8
      }, {
        name: "待审核",
        key: 0
      }, {
        name: "已审核",
        key: 1
      }],
      backdiag: false,
      backtype: "", // zym.类型
      postDat: {
        type: 2,
        status: 99,
        keyword: "",
        no: 1,
        size: 15
      },
      tabDats: [],
      tabDatAll: [],
      pgAll: "",
      loading: false,

      examIds: [],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: "",

        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "" // zym.注销意见
      }
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    // zym.数据处理
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          8: "未提交",
          0: "待审核",
          1: "通过",
          3: "未提交",
          9: "已上报",

          12: "暂缓",
          13: "注销或拟注销",
          // 14: "建议撤销",
          // 21: "暂缓登记",
          // 22: "暂缓登记",
          14: "注销或拟注销",
          21: "暂缓登记",
          22: "暂缓登记"
        };

        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        if (dat.progress == "登记") {
          // return setMap[dat.pubStatus] + "（已核验）";
          return "已发布";
        } else if (dat.progress == "国家新闻出版署") {
          return "已上报";
        } else if (dat.progress == "省局") {
          // if (dat.isBack == 2) {
          //   return map[dat.status] + "（退回）";
          // } else {
          //   return map[dat.status];
          // }
          return "";
        } else {
          if (dat.isBack == 2 && dat.status == 21) {
            return "未提交（暂缓登记）";
          } else if (dat.isBack == 2 && dat.status == 22) {
            return "出版署（暂缓登记）";
          } else if (dat.isBack == 2 && dat.status != 21) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        }
      } else if (code == "time") {
        // console.log(dat)
        if (!dat || dat == "Invalid date") {
          return "";
        } else {
          return dat.substr(0, 16);
        }
      } else if (code == "sjstatus") {
        var _map = {
          // 8: "未提交",
          // 0: "待审核",
          1: "通过",
          // 3: "未提交",
          // 9: "已上报",

          13: "注销或拟注销",
          21: "暂缓登记"
        };

        // if (dat.isBack == 2) {
        return _map[dat.sjstatus];
        // } else {
        // return map[dat.status];
        // }
        // return "";
      }
    }
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.params.publishMaterialIds = [];
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _provinceRole.getProvinceList)(this.postDat).then(function (response) {
        _this.tabDatAll = response.fmaterialexamineList;
        // this.pgAll = response.totalPages;
        _this.loading = false;
        _this.firstYear = response.firstYear;
        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        tabDats = tabDats.filter(function (item) {
          // zym.未提交
          if (qType == 8 && (item.progress || "") == "开始") {
            return true;
          }
          // zym.待审核
          if (qType == 0 && (item.progress || "") == "省局" && item.status == "0") {
            return true;
          }
          // zym.已审核
          if (qType == 1 && ((item.progress || "") == "省局" && (item.status == "1" || item.status == "12" || item.status == "13" || item.status == "14") || (item.progress || "") == "国家新闻出版署")) {
            return true;
          }
          return false;
          // if ((item.progress || '') == statusKey[qType]) {
          //   return true;
          // }
          // return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatAll = this.tabDats;
      var dataLen = Number(tabDatAll.length);
      var size = Number(postDat.size);
      var total = Math.floor(dataLen / size);
      this.tabDats = tabDatAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },
    pageSent: function pageSent(dat) {
      this.postDat.no = dat;
      // this.tabSeek();
      this.postDat.goPage = true;
    },
    styleTrans: function styleTrans(code) {
      var styleArr = ["spanc1", "spanc2", "spanc3"];
    },
    goFirm: function goFirm(inDat, type) {
      this.$router.push({
        path: "exam_check",
        query: {
          pressType: 2,
          pressId: inDat.organizationId,
          pressName: inDat.organizationName,
          mtId: inDat.materialExamineId,
          pressState: type,
          updateViewDate: true,
          year1: this.firstYear
        }
      });
    },

    selectionChange: function selectionChange(resDat) {
      this.params.publishMaterialIds = [];
      for (var i = 0; i < resDat.length; i++) {
        this.params.publishMaterialIds.push(resDat[i].materialExamineId);
      }
    },

    handleSelect: function handleSelect(dat) {
      var _this2 = this;

      var vm = this;
      if (this.params.publishMaterialIds.length > 0) {
        this.params.status = dat;
        // zym.通过
        if (dat == 1) {
          this.$confirm('确定已查看完毕，并对该单位核验材料批以"审核通过"处理吗？', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            // this.$message.info({
            //   message: '若省局已经审核完成，请点击“上报国家新闻出版署”。',
            //   duration: 5000
            // });
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _provinceRole.goProvinceExam)(_this2.params).then(function (response) {
              loading.close();

              // this.tabSeek('init');
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              var resMsg = response.payload.resMsg;
              var appendMsg = resMsg ? resMsg.join(",") : "";
              console.log("response=", (0, _stringify2.default)(response));
              if (tipCode == "fail") {
                _this2.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "error"
                });
              } else {
                _this2.$message({
                  message: tipMessage + " " + appendMsg,
                  type: "success"
                });

                _this2.tabSeek("init");
              }
            });
          }).catch(function () {
            loading.close();
          });
        }
        // zym.退回
        else if (dat == 3 || dat == 21 || dat == 12 || dat == 13 || dat == 14) {
            this.backdiag = true;
            this.backtype = dat;
          }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },

    arrExam: function arrExam() {
      var _this3 = this;

      this.params.message = this.params.message.replace(/\s+/g, "");
      this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      if (this.backtype == 3 && this.params.message.length == 0) {
        this.$message.error("请填写退回意见！");
      } else if (this.backtype == 21 && this.params.message.length == 0) {
        this.$message.error("请填写暂缓登记意见！");
      } else if (this.backtype == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error("请填写暂缓意见！");
      } else if (this.backtype == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error("请填写建议注销意见！");
      } else if (this.backtype == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error("请填写建议撤销意见！");
      } else {
        this.backdiag = false;
        var vm = this;
        var _loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _provinceRole.goProvinceExam)(this.params).then(function (response) {
          _loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage;
          var resMsg = response.payload.resMsg;
          console.log("response=", (0, _stringify2.default)(response));
          if (tipCode == "fail") {
            _this3.$message({
              message: tipMessage,
              type: "error"
            });
          } else {
            _this3.$message({
              message: "操作完成！",
              type: "success"
            });

            _this3.tabSeek("init");
          }
        });
      }
    },

    handleClose: function handleClose() {
      this.params.message = "";
      this.params.zanhuanMessage = "";
      this.params.chexiaoMessage = "";
      this.params.zhuxiaoMessage = "";
      this.backdiag = false;
    },

    checkDfine: function checkDfine(row, inx) {
      if (row.status == 0 || row.status == 1 ||
      // zym.新增
      row.status == 12 ||
      // 出版署整改
      row.status == 22 || row.status == 21 || row.status == 13 || row.status == 14) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.tabSeek();

    if (this.$route.query.pams_no) {
      this.postDat.no = parseInt(this.$route.query.pams_no);
      this.postDat.status = parseInt(this.$route.query.pams_status);
      this.postDat.keyword = this.$route.query.pams_keyword;
    } else if (this.$route.query.key) {
      this.postDat.status = parseInt(this.$route.query.key);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {

      // 登记状态组
      typeArr: [{
        name: '全部',
        key: 0
      }, {
        name: '未登记',
        key: 1
      }, {
        name: '已登记',
        key: 2
      }],

      // 核验状态组
      staArr: [{
        name: '全部',
        key: 99
      }, {
        name: '通过',
        key: 1
      }, {
        name: '暂缓',
        key: 2
      }, {
        name: '撤销',
        key: 4
      }, {
        name: '注销',
        key: 5
      }],

      loading: false,
      postDat: {
        type: 2,
        status: 0,
        record: 0,
        keyword: '',

        no: 1,
        size: 15
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0
    };
  },


  filters: {
    transStr: function transStr(row, code) {
      if (code == 'record_state') {
        if (row.record == 1) {
          return '未登记';
        } else if (row.record == 2) {
          return '已登记';
        }
      } else if (code == 'state') {
        var map = {
          1: '通过',
          2: '暂缓',
          4: '撤销',
          5: '注销'
        };
        return map[row.pubStatus];
      } else if (code == 'time') {
        if (row == 'Invalid date' || !row) {
          return "";
        }
        return row.substr(0, 16);
      }
    }
  },

  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: (0, _defineProperty3.default)({
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == 'init') {
        this.postDat.no = 1;
      };
      (0, _provinceRole.registList)(this.postDat).then(function (response) {
        _this.loading = false;
        _this.tabDatsAll = response.provinceRecordList;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      if (qType != '0') {
        tabDats = tabDats.filter(function (item) {
          // zym.待核验
          if (qType == 1 && item.record == '1') {
            return true;
          } else if (qType == 2 && item.record == '2') {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || '').indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat['total'] = total;
      this.postDat = postDat;
    },
    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    goRegist: function goRegist(row) {
      var _this2 = this;

      var vm = this;
      this.$confirm('确认登记吗？', '提示', {
        confirmButtonText: '登记',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: '处理中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _provinceRole.goRegist)({
          id: row.id
        }).then(function (response) {

          loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage || '操作失败';
          if (tipCode == 'fail') {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this2.$message({
              message: tipMessage,
              type: 'success',
              onClose: function onClose() {
                vm.tabSeek('init');
              }
            });
          }
        });
      }).catch(function () {});
    },

    goScan: function goScan(inDat) {
      this.$router.push({
        path: 'exam_check',
        query: {
          pressType: 2,
          pressId: inDat.organizationId,
          mtId: inDat.materialExamineId,
          pressState: 2,
          leadFrom: 2,

          pams_no: this.postDat.no,
          pams_status: this.postDat.status,
          pams_keyword: this.postDat.keyword
        }
      });
    }

  }, 'pageSent', function pageSent(inx) {
    this.postDat.no = inx;
    this.postDat.goPage = true;
    // this.tabSeek();
  }),

  created: function created() {
    this.tabSeek();
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonReport = __webpack_require__(347);

var _commonReport2 = _interopRequireDefault(_commonReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        reportTemp: _commonReport2.default
    },
    data: function data() {
        return {
            frashState: true
        };
    },

    methods: {
        frashCtrls: function frashCtrls() {
            var _this = this;

            this.frashState = false;
            this.$nextTick(function () {
                return _this.frashState = true;
            });
        }
    }
}; //
//
//
//
//
//

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SpecCommonTab = __webpack_require__(175);

var _SpecCommonTab2 = _interopRequireDefault(_SpecCommonTab);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    CommonTab: _SpecCommonTab2.default
  },
  data: function data() {
    return {
      querys: {
        pressType: "",
        pressId: "",
        pressState: 1,
        leadFrom: ""
      },

      wSat: 0,
      resDat: [{}],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: ""
      }
    };
  },


  methods: {
    goExamsave: function goExamsave() {
      var _this = this;

      this.params.message = this.params.message || "";
      if (this.params.status == 3 && !this.params.message) {
        this.$message.error("请填写退回意见！");
      } else {
        var msg = "确定已查看完毕，并对该单位核验材料批以通过处理吗？";
        if (this.params.status == 3) {
          msg = "确定已查看完毕，并对该单位核验材料批以退回处理吗？";
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.publishMaterialIds.push(_this.$refs.mainTab.postPrevs());
          (0, _provinceRole.goProvinceExam)(_this.params).then(function (response) {
            _this.goBack();
          });
        }).catch(function () {});
      }
    },

    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    var _this2 = this;

    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressState: this.$route.query.pressState,
      leadFrom: this.$route.query.leadFrom
    };

    (0, _pressRole.getPressList)({
      type: this.querys.pressType,
      publishId: this.querys.pressId
    }).then(function (response) {
      var vm = _this2;
      vm.wSat = 1;
      _this2.resDat.splice(0, 1, response);
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _provinceRole = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      typeArr: [{
        name: "全部",
        key: 99
      }, {
        name: "未提交",
        key: 8
      }, {
        name: "待审核",
        key: 0
      }, {
        name: "已审核",
        key: 1
      }],
      backdiag: false,
      backtype: "",
      postDat: {
        status: 99,
        keyword: "",
        isZyzj: 0,
        no: 1,
        size: 15
      },
      tabDats: [],
      tabDatAll: [],
      pgAll: "",
      loading: false,

      examIds: [],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: "",

        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "" // zym.注销意见
      }
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        console.log("dat.statuszj=", dat.statuszj);
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      if (code == "state") {
        var map = {
          8: "未提交",
          0: "待审核",
          1: "通过",
          3: "未提交",
          9: "已上报",

          12: "暂缓",
          13: "注销或拟注销",
          14: "建议撤销",
          21: "暂缓登记"
        };

        var setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销"
        };

        // zym.把progress 换成了 progress
        if (dat.progress == "登记") {
          // return setMap[dat.pubStatus] + "（已核验）";
          return "已发布";
        } else if (dat.progress == "国家新闻出版署") {
          return "已上报";
        } else if (dat.progress == "省局") {
          // if (dat.isBack == 2) {
          //   return map[dat.status] + "（退回）";
          // } else {
          //   return map[dat.status];
          // }
          return "";
        } else {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        }
      } else if (code == "time") {
        console.log("dat.sjViewDate=", dat.sjViewDate);
        if (dat.sjViewDate && dat.sjViewDate != "Invalid date") {
          return dat.sjViewDate.substr(0, 16);
        } else {
          return "";
        }
      } else if (code == "sjstatus") {
        var _map = {
          // 8: "未提交",
          // 0: "待审核",
          1: "通过",
          // 3: "未提交",
          // 9: "已上报",

          13: "注销或拟注销",
          21: "暂缓登记"
        };

        // if (dat.isBack == 2) {
        return _map[dat.sjstatus];
        // } else {
        // return map[dat.status];
        // }
        // return "";
      }
    }
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        this.params.publishMaterialIds = [];
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      (0, _provinceRole.successiveWaitList)(this.postDat).then(function (response) {
        _this.tabDatAll = response.flxdzOrganizationMaterialList;
        // this.pgAll = response.totalPages;
        _this.loading = false;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      var statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        tabDats = tabDats.filter(function (item) {
          // zym.未提交
          if (qType == 8 && (item.progress || "") == "开始") {
            return true;
          }
          // zym.待审核
          if (qType == 0 && (item.progress || "") == "省局" && item.status == "0") {
            return true;
          }
          // zym.已审核
          if (qType == 1 && ((item.progress || "") == "省局" && (item.status == "1" || item.status == "12" || item.status == "13" || item.status == "14") || (item.progress || "") == "国家新闻出版署")) {
            return true;
          }
          return false;
          // if ((item.progress || '') == statusKey[qType]) {
          //   return true;
          // }
          // return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.name || "").indexOf(qKeyword) > -1 || (item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatAll = this.tabDats;
      var dataLen = Number(tabDatAll.length);
      var size = Number(postDat.size);
      var total = Math.floor(dataLen / size);
      this.tabDats = tabDatAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },
    pageSent: function pageSent(dat) {
      this.postDat.no = dat;
      // this.tabSeek();
      this.postDat.goPage = true;
    },
    styleTrans: function styleTrans(code) {
      var styleArr = ["spanc1", "spanc2", "spanc3"];
    },
    goFirm: function goFirm(inDat, type) {
      // console.log('inDat=',JSON.stringify(inDat))
      this.$router.push({
        path: "successive_skim",
        query: {
          pressState: type,
          listId: inDat.publishMaterialId,
          pressId: inDat.organizationId,
          examId: inDat.materialExamineId,
          bookName: inDat.name,
          pressName: inDat.organizationName,
          updateViewDate: true
        }
      });
    },

    selectionChange: function selectionChange(resDat) {
      this.params.publishMaterialIds = [];
      for (var i = 0; i < resDat.length; i++) {
        this.params.publishMaterialIds.push(resDat[i].materialExamineId);
      }
    },

    handleSelect: function handleSelect(dat) {
      var _this2 = this;

      var vm = this;
      if (this.params.publishMaterialIds.length > 0) {
        this.params.status = dat;
        if (dat == 1) {
          this.$confirm('确定已查看完毕，并对该单位核验材料批以"审核通过"处理吗？', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            // this.$message.info({
            //   message: '若省局已经审核完成，请点击“上报国家新闻出版署”。',
            //   duration: 5000
            // });
            var loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            (0, _provinceRole.goProvinceExam)(_this2.params).then(function (response) {
              loading.close();

              // this.tabSeek('init');
              var tipCode = response.payload.tipCode;
              var tipMessage = response.payload.tipMessage;
              var resMsg = response.payload.resMsg;
              // console.log('response=',JSON.stringify(response));
              if (tipCode == "fail") {
                _this2.$message({
                  message: tipMessage,
                  type: "error"
                });
              } else {
                _this2.$message({
                  message: "操作完成！",
                  type: "success"
                });

                _this2.tabSeek("init");
              }
            });
          }).catch(function () {
            loading.close();
          });
          // zym.退回
        } else if (dat == 3 || dat == 12 || dat == 13 || dat == 14) {
          this.backdiag = true;
          this.backtype = dat;
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },

    arrExam: function arrExam() {
      var _this3 = this;

      this.params.message = this.params.message.replace(/\s+/g, "");
      this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      if (this.backtype == 3 && this.params.message.length == 0) {
        this.$message.error("请填写退回意见！");
      } else if (this.backtype == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error("请填写暂缓意见！");
      } else if (this.backtype == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error("请填写注销或拟注销意见！");
      } else if (this.backtype == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error("请填写建议撤销意见！");
      } else {
        this.backdiag = false;
        var vm = this;
        var _loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        (0, _provinceRole.goProvinceExam)(this.params).then(function (response) {
          _loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage;
          var resMsg = response.payload.resMsg;
          var appendMsg = resMsg ? resMsg.join(",") : "";
          console.log("response=", (0, _stringify2.default)(response));
          if (tipCode == "fail") {
            _this3.$message({
              message: tipMessage + " " + appendMsg,
              type: "error"
            });
          } else {
            _this3.$message({
              message: tipMessage + " " + appendMsg,
              type: "success"
            });
            _this3.tabSeek("init");
          }
        });
      }
    },

    handleClose: function handleClose() {
      this.params.message = "";
      this.backdiag = false;
    },

    checkDfine: function checkDfine(row, inx) {
      if (row.status == 0 || row.status == 1 ||
      // zym.新增
      row.status == 12 || row.status == 21 || row.status == 13 || row.status == 14) {
        return true;
      } else {
        return false;
      }
    }
  },
  created: function created() {
    this.tabSeek();
    if (this.$route.query.key) {
      this.postDat.status = parseInt(this.$route.query.key);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      tabDats: [],
      params: {
        keyword: "",
        year1: "",
        sjExamineId: "",
        no: 1,
        size: 12,
        pgAll: 0
      },
      selYear: "",
      selYearRecord: [{}]
    };
  },

  filters: {
    transZjStr: function transZjStr(dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        var map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布"
        };
        return map[dat.statuszj];
      }
    },
    transStr: function transStr(dat, code) {
      // console.log("省局：", code, " ", dat);
      if (code == "statussj") {
        var map = {
          // 0: "待核验",
          1: "通过",
          // 2: "暂缓登记",
          // 3: "退回",
          21: "暂缓登记",
          22: "暂缓登记",
          // 4: "撤销",
          // 5: "注销或拟注销",
          // 10: "整体退回",
          9: "整体上报", // 开放
          11: "已登记",

          12: "省局暂缓", // 开放
          13: "注销或拟注销"
          // 14: "建议撤销",
        };
        return map[dat.statussj];
      }
    }
  },

  methods: {
    tabList: function tabList() {
      var _this = this;

      (0, _provinceRole.successiveSeek)(this.params).then(function (response) {
        _this.tabDats = response.generalLxPublisher;
        _this.params.pgAll = response.totalPages;
      });
    },
    goFirm: function goFirm(inDat) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: inDat.organizationId,
          pvcName: inDat.sjExamine,
          pvcId: inDat.sjExamineId,
          listId: inDat.id,
          bookName: inDat.name,
          pressName: inDat.organizationName,
          mtId: inDat.materialExamineId,

          examId: inDat.materialExamineId,
          pressState: 2,
          year1: this.selYear
        }
      });
    },
    pageSent: function pageSent(inx) {
      this.params.no = inx;
      this.tabList();
    },
    goSeek: function goSeek() {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabList();
    },
    valChange: function valChange() {
      this.params.year1 = this.selYear;
      sessionStorage.setItem("selYearLxdz", this.selYear);
      this.tabList();
    }
  },

  created: function created() {
    var _this2 = this;

    this.params.sjExamineId = this.$store.getters.userInfo.orgId;
    var selYearLxdz = sessionStorage.getItem("selYearLxdz") || "";
    (0, _pressRole.getSelYearRecord)({
      publishId: "",
      type: 3
    }).then(function (response) {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            _this2.params.year1 = po.firstYear;
            _this2.selYear = po.firstYear;
            if (selYearLxdz != "") {
              _this2.params.year1 = selYearLxdz;
              _this2.selYear = selYearLxdz;
            }
          }
        }
      }
      _this2.selYearRecord = arr;
      _this2.tabList();
    });
  }
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provinceRole = __webpack_require__(20);

exports.default = {
  data: function data() {
    return {

      // 登记状态组
      typeArr: [{
        name: '全部',
        key: 0
      }, {
        name: '未登记',
        key: 1
      }, {
        name: '已登记',
        key: 2
      }],

      // 核验状态组
      staArr: [{
        name: '全部',
        key: 99
      }, {
        name: '通过',
        key: 1
      }, {
        name: '暂缓',
        key: 2
      }, {
        name: '撤销',
        key: 4
      }, {
        name: '注销',
        key: 5
      }],

      loading: false,
      postDat: {
        status: 0,
        record: 0,
        keyword: '',

        no: 1,
        size: 15
      },

      tabDats: [],
      tabDatsAll: [],
      pgAll: 0
    };
  },


  filters: {
    transStr: function transStr(row, code) {
      if (code == 'record_state') {
        if (row.record == 1) {
          return '未登记';
        } else if (row.record == 2) {
          return '已登记';
        }
      } else if (code == 'state') {
        var map = {
          1: '通过',
          2: '暂缓',
          4: '撤销',
          5: '注销'
        };
        return map[row.pubStatus];
      } else if (code == 'time') {
        if (row == 'Invalid date' || !row) {
          return "";
        }
        return row.substr(0, 16);
      }
    }
  },

  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler: function handler(v) {
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      }
    }
  },
  methods: {
    tabSeek: function tabSeek(code) {
      var _this = this;

      if (code == 'init') {
        this.postDat.no = 1;
      };
      this.loading = true;
      (0, _provinceRole.successiveRegistList)(this.postDat).then(function (response) {
        // console.log('response=',JSON.stringify(response));  
        _this.loading = false;
        _this.tabDatsAll = response.provinceRecordList;

        _this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function filterTableData() {
      var tabDats = this.tabDatsAll;

      var qType = this.postDat.status;
      var qKeyword = this.postDat.keyword;
      // !状态
      if (qType != '0') {
        tabDats = tabDats.filter(function (item) {
          // zym.待核验
          if (qType == 1 && item.record == '1') {
            return true;
          } else if (qType == 2 && item.record == '2') {
            return true;
          }
          return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.organizationName || '').indexOf(qKeyword) > -1 || (item.name || '').indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function calPage(tabDatsTemp) {
      var postDat = this.postDat;
      var tabDatsAll = this.tabDats;
      // console.log('postDat=',JSON.stringify(tabDatsAll));
      var dataLen = Number(tabDatsAll.length);
      // console.log('dataLen=',dataLen);
      var size = Number(postDat.size);
      // console.log('size=',size);
      var total = Math.floor(dataLen / size);
      // console.log('total=',total);
      this.tabDats = tabDatsAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat['total'] = total;
      this.postDat = postDat;
    },
    pageSent: function pageSent(inx) {
      this.postDat.no = inx;
      this.postDat.goPage = true;
      // this.tabSeek();
    },

    goRegist: function goRegist(row) {
      var _this2 = this;

      var vm = this;
      this.$confirm('确认登记吗？', '提示', {
        confirmButtonText: '登记',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = vm.$loading({
          lock: true,
          text: '处理中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        (0, _provinceRole.goRegist)({
          id: row.id
        }).then(function (response) {
          loading.close();

          var tipCode = response.payload.tipCode;
          var tipMessage = response.payload.tipMessage || '操作失败';
          if (tipCode == 'fail') {
            _this2.$message({
              showClose: true,
              message: tipMessage,
              type: 'error'
            });
          } else {
            _this2.$message({
              message: tipMessage,
              type: 'success',
              onClose: function onClose() {
                vm.tabSeek('init');
              }
            });
          }
        });
      }).catch(function () {});
    },

    goScan: function goScan(inDat) {
      this.$router.push({
        path: 'successive_skim',
        query: {
          pressId: inDat.organizationId,
          listId: inDat.publishMaterialId,
          pressState: 2,
          examId: inDat.materialExamineId,
          bookName: inDat.name,
          pressName: inDat.organizationName
        }
      });
    }
  },

  created: function created() {
    this.tabSeek();
  }

}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _auth = __webpack_require__(46);

var _provinceRole = __webpack_require__(20);

var _account = __webpack_require__(16);

var _vuex = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      percentage: 0,
      upState: "wait",
      fileData: {},
      imgUrl: "",
      fileToken: "",
      ableUp: 0,
      reportId: "",

      fileUrl: "",
      fileName: "",
      postUrl: ""
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["userInfo"])),

  methods: {
    prevCtrls: function prevCtrls(file) {
      var nameArr = file.name.split(".");
      var fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error"
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error"
        });
        return false;
      } else {
        this.percentage = 0;
        this.upState = "loading";
        this.fileData.token = (0, _auth.getToken)();
        this.fileData.fileSize = file.size;
        return true;
      }
    },
    pgressCtrls: function pgressCtrls(evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function errorCtrls(err) {
      this.upState = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error"
      });
    },

    successCtrls: function successCtrls(data, file) {
      var _this = this;

      var vm = this;
      this.percentage = 99;
      var newDate = new Date();
      var yearStr = newDate.getFullYear() - 2 + "-" + (newDate.getFullYear() - 1);

      (0, _provinceRole.ssReportUpload)({
        provinceReport: {
          reportId: data.payload.id,
          year: yearStr,
          type: 3,
          status: this.ableUp
        }
      }).then(function (response) {
        _this.percentage = 100;
        _this.upState = "loaded";
        _this.$refs.upload.clearFiles();

        _this.fileUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + _this.fileToken + "/id/" + data.payload.id;
        _this.fileName = file.name;

        _this.$emit("go-frash");
      }).catch(function (error) {
        _this.$refs.upload.clearFiles();
        _this.upState = "wait";
      });
    },

    goAdmin: function goAdmin() {
      var _this2 = this;

      (0, _provinceRole.stepToAdmin)({ type: 3 }).then(function (response) {
        _this2.ableUp = 2;
        _this2.$message.success("提交成功！");
      });
    },

    goFirmSeek: function goFirmSeek() {
      var _this3 = this;

      var promiseArr = [];
      var vm = this;

      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _provinceRole.successiveReported)({ type: 3 }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));

      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _provinceRole.ssReportLoad)({ type: 3, provinceId: _this3.userInfo.orgId }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));

      promiseArr.push(new _promise2.default(function (resolve, reiect) {
        (0, _account.getFileToken)().then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reiect(error);
        });
      }));

      _promise2.default.all(promiseArr).then(function (result) {
        var isPosted = false;
        var isUpload = false;

        vm.fileToken = result[2].resultStatus.token;

        if (result[0].status == 2) {
          isPosted = true;
        }

        if (result[1].provinceReport) {
          isUpload = true;
          vm.fileUrl = "https://ydnj.capub.cn" + "/File/File/download/token/" + vm.fileToken + "/id/" + result[1].provinceReport.reportId;
          vm.fileName = result[1].provinceReport.fileName;
        }

        if (isPosted) {
          if (isUpload) {
            vm.ableUp = 2;
          } else {
            vm.ableUp = 3;
          }
        } else {
          vm.ableUp = 1;
          if (isUpload) {
            vm.upState = "loaded";
          }
        }
      });
    }
  },

  created: function created() {
    this.goFirmSeek();
    this.postUrl = "https://ydnj.capub.cn" + "/File/File/upload";
    // console.log(this.userInfo);
  }
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _ssCommonTabs = __webpack_require__(248);

var _ssCommonTabs2 = _interopRequireDefault(_ssCommonTabs);

var _pressSuccessive = __webpack_require__(28);

var _provinceRole = __webpack_require__(20);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MainTabs: _ssCommonTabs2.default
  },
  data: function data() {
    return {
      wSat: 0,
      querys: {
        pressState: 1,
        pressName: "",
        pgsType: "",
        year1: ""
      },
      bookName: "",
      resDat: [{}],
      selYearRecord: [{}],
      tabDat: [],

      opMsg: "",

      params: {
        publishMaterialIds: [],
        status: "1",
        message: "",
        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "" // zym.注销意见
      }
    };
  },

  filters: {
    tansStr: function tansStr(dat, code) {
      if (code == "state") {
        if (dat.flowName == "省局") {
          var map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记"
          };

          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          var _map = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布"
          };

          return _map[dat.status];
        } else if (dat.flowName == "登记") {
          var _map2 = {
            0: "待登记",
            1: "待登记",
            2: "已登记"
          };

          return _map2[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (!dat["checkdAt"] || dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    }
  },
  methods: {
    valChangeSearch: function valChangeSearch(year) {
      this.getHistoryData(year);
    },
    goBack: function goBack() {
      this.$router.go(-1);
      // let urlArrs = ['successive_exam','ss_regist'];
      // this.$router.push({
      //     path:urlArrs[this.querys.pgsType - 1]
      // })
    },
    goBackExamsave: function goBackExamsave() {
      var _this = this;

      var msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        var _msg = "确定已查看完毕，退回出版单位吗？";
        this.$confirm(_msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this.params.publishMaterialIds = [];
          _this.params.publishMaterialIds.push(_this.$route.query.examId);

          // 创建新的参数
          var paramsNew = (0, _extends3.default)({}, _this.params, { status: "3" });
          var vm = _this;
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });

          (0, _provinceRole.goProvinceExam)(paramsNew).then(function (response) {
            loading.close();

            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            var resMsg = response.payload.resMsg;
            var appendMsg = resMsg ? resMsg.join(",") : "";
            // console.log('response=',JSON.stringify(response));
            if (tipCode == "fail") {
              _this.$message({
                message: tipMessage + " " + appendMsg,
                type: "error"
              });
            } else {
              _this.$message({
                message: tipMessage + " " + appendMsg,
                type: "success"
              });

              // zym.原来的方法
              _this.goBack();
            }
          });
        }).catch(function () {});
      }
    },
    goExamsave: function goExamsave() {
      var _this2 = this;

      this.params.message = this.params.message || "";
      this.params.message = this.params.message.replace(/\s+/g, "");
      if (this.params.status == 12) {
        this.params.zanhuanMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 13) {
        this.params.zhuxiaoMessage = this.params.message.replace(/\s+/g, "");
      }
      if (this.params.status == 14) {
        this.params.chexiaoMessage = this.params.message.replace(/\s+/g, "");
      }

      // this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g,"");
      // this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g,"");
      // this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g,"");
      var msg = "请填写意见！";
      if (this.params.status == 3 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写退回意见！');
      } else if (this.params.status == 21 && this.params.message.length == 0) {
        this.$message.error(msg);
        // this.$message.error("请填写暂缓登记意见！");
      } else if (this.params.status == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写暂缓意见！');
      } else if (this.params.status == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写注销或拟注销意见！');
      } else if (this.params.status == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error(msg);
        // this.$message.error('请填写建议撤销意见！');
      } else {
        // let msg = "确定已查看完毕，并对该连续型电子出版物批以通过处理吗？"; // zym.通过
        // if (this.params.status == 3) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以退回处理吗？";
        // } else if (this.params.status == 12) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以暂缓吗？";
        // } else if (this.params.status == 13) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以注销或拟注销吗？";
        // } else if (this.params.status == 14) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以建议撤销吗？";
        // } else if (this.params.status == 1) {
        //   msg = "确定已查看完毕，并对该连续型电子出版物批以通过处理吗？";
        // } else {
        //   this.$message.error("发现不可操作的审批结果，无法进行操作！");
        //   return;
        // }
        var _msg2 = "确定已查看完毕，提交审核意见吗？";
        if (this.params.status == 3) {
          _msg2 = "确定已查看完毕，退回出版单位吗？";
        }
        this.$confirm(_msg2, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function () {
          _this2.params.publishMaterialIds = [];
          _this2.params.publishMaterialIds.push(_this2.$route.query.examId);
          var vm = _this2;
          var loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          (0, _provinceRole.goProvinceExam)(_this2.params).then(function (response) {
            // this.$message.info({
            // 	message: '若音像、电子出版单位全部审核完成，请前往上报板块向进行上报',
            // 	duration: 5000
            // });
            loading.close();

            var tipCode = response.payload.tipCode;
            var tipMessage = response.payload.tipMessage;
            var resMsg = response.payload.resMsg;
            var appendMsg = resMsg ? resMsg.join(",") : "";
            console.log("response=", (0, _stringify2.default)(response));
            if (tipCode == "fail") {
              _this2.$message({
                message: tipMessage + " " + appendMsg,
                type: "error"
              });
            } else {
              _this2.$message({
                message: tipMessage + " " + appendMsg,
                type: "success"
              });

              // zym.原来的方法
              _this2.goBack();
            }
          });
        }).catch(function () {});
      }
    },

    gPlist: function gPlist() {
      var _this3 = this;

      (0, _pressSuccessive.getSuccessCheckTabs)({
        publishMaterialId: this.$route.query.listId,
        organizationId: this.$route.query.pressId
      }).then(function (response) {
        var vm = _this3;
        vm.wSat = 1;
        _this3.bookName = _this3.$route.query.bookName;
        if (_this3.querys.pressState == 1) {
          _this3.opMsg = response.msg;
        }
        _this3.resDat.splice(0, 1, response.ppublicationOrganizationMaterialList);
      });
    },
    getHistoryData: function getHistoryData(year) {
      var _this4 = this;

      var vm = this;
      // successiveHistory({ examineId: this.$route.query.examId, year1: year }).then(response => {
      //   for (let item of response.fFlowTaskList) {
      //     if (item.examineName) {
      //       vm.tabDat.push(item);
      //     }
      //   }
      // })
      (0, _provinceRole.successiveHistoryNew)({ examineId: this.$route.query.examId }).then(function (response) {
        _this4.tabDat = response.fFlowTaskList;
        //  successiveHistory({publishId:this.querys.mtId}).then(response => {
        // console.debug("successiveHistory: ", response);
        // for (let i = 0; i < response.fFlowTaskList.length; i++) {
        // 	if (response.fFlowTaskList[i].examineName) {
        // 		this.tabDat.push(response.fFlowTaskList[i]);
        // 	}
        // }
        // 查找最后的省局审核意见
        var tabDatProvince = (_this4.tabDat || []).filter(function (item) {
          return item.flowName == "省局";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          var last = tabDatProvince[tabDatProvince.length - 1];
          _this4.params.status = last.status == "0" ? "1" : last.status + "";
          _this4.params.message = last.examineMessage;
        } else {
          _this4.params.status = "1";
          _this4.params.message = "";
        }
      });
    },


    writeReadTimeLxdz: function writeReadTimeLxdz() {
      (0, _provinceRole.writeReadTimeLxdz)({
        publishMaterialId: this.$route.query.listId
      }).then(function (response) {
        console.debug("writeReadTimeLxdz: ", response);
      });
    }
  },

  created: function created() {
    this.querys.pressState = this.$route.query.pressState;
    this.querys.pressName = this.$route.query.pressName;
    this.querys.year1 = this.$route.query.year1;

    this.gPlist();

    // 更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTimeLxdz();
    }

    // getSelYearRecord({
    //   publishId: this.$route.query.pressId,
    //   type: 3,
    //   year1: this.querys.year1
    // }).then(response => {
    //   console.log("======", response);
    //   var arr = [{}];
    //   if (response.generalPublisher.length > 0) {
    //     for (var i in response.generalPublisher) {
    //       var po = response.generalPublisher[i];
    //       arr.push({ label: po.firstYear + '~' + po.secondYear, value: po.firstYear });
    //     }
    //   }
    //   this.selYearRecord = arr;
    // })

    // if(this.querys.pressState == 2){
    this.getHistoryData(this.querys.year1);
    // }
  }
};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dictCreate = dictCreate;
exports.getDistTree = getDistTree;
exports.dictRemove = dictRemove;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dictCreate(params) {

    return (0, _fetch2.default)({
        // url: 'System/System/saveDataDictionary',
        url: 'manage/system/saveDataDictionary',
        method: "post",
        data: params
    });
}

function getDistTree(params) {
    return (0, _fetch2.default)({
        //  url:'System/System/getDataDictionaryTree',
        url: 'manage/system/getDataDictionaryTree',
        method: "post",
        data: params
    });
}

function dictRemove(params) {

    return (0, _fetch2.default)({
        // url: 'System/System/delDataDictionary',
        url: 'manage/system/delDataDictionary',
        method: "post",
        data: params
    });
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
     value: true
});
exports.menuCreate = menuCreate;
exports.getMenu = getMenu;
exports.delDot = delDot;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// zym.保存菜单信息
function menuCreate(params) {
     return (0, _fetch2.default)({
          //  url:'Rule/Rule/saveMenu',
          url: 'manage/menu/saveMenu',
          method: "post",
          data: params
     });
}

// zym.显示菜单
function getMenu(params) {
     return (0, _fetch2.default)({
          //  url:'Rule/Rule/getMenuTree',
          url: 'manage/menu/getPostRuleTree',
          method: "post",
          data: params
     });
}

// zym.删除菜单
function delDot(params) {
     return (0, _fetch2.default)({
          //  url:'Rule/Rule/delMenu',
          url: 'manage/menu/delMenu',
          method: "post",
          data: params
     });
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublishList = getPublishList;

var _fetch = __webpack_require__(369);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublishList(params) {
  return (0, _fetch2.default)({
    // url: 'System/System/saveDataDictionary',
    url: "manage/getPublishList",
    method: "post",
    data: params
  });
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
     value: true
});
exports.getGmTree = getGmTree;
exports.getRoleList = getRoleList;
exports.getConfiged = getConfiged;
exports.CreateRole = CreateRole;
exports.removeRole = removeRole;
exports.ropSave = ropSave;
exports.ropList = ropList;
exports.dfPower = dfPower;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getGmTree(params) {

     return (0, _fetch2.default)({

          url: 'Rule/Rule/getOrganizationAndPostTree',
          method: "post",
          data: params

     });
}

// zym.角色列表
function getRoleList(params) {
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/getOrganizationAndPostList',
          url: 'manage/post/all',
          method: "post",
          data: params

     });
}

function getConfiged(params) {

     return (0, _fetch2.default)({

          url: 'Rule/Rule/getPostRuleTree',
          method: "post",
          data: params

     });
}

// zym.角色新增、修改
function CreateRole(params) {
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/addOrUdatePost',
          url: 'manage/post/addOrUdatePost',
          method: "post",
          data: params
     });
}

// zym.角色停用
function removeRole(params) {
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/delOrganizationAndPost',
          url: 'manage/post/delOrganizationAndPost',
          method: "post",
          data: params
     });
}

// 保存角色菜单权限
function ropSave(params) {
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/savePostRule',
          url: 'manage/post/savePostRule',
          method: "post",
          data: params
     });
}

// zym.角色菜单权限
function ropList(params) {
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/getPostRuleTree',
          url: 'manage/menu/getPostRuleTree',
          method: "post",
          data: params

     });
}

// zym.查询某个角色的菜单权限
function dfPower(params) {
     //  获取职位默认权限     
     return (0, _fetch2.default)({
          //  url: 'Rule/Rule/getUserPostRuleTree',
          url: 'manage/post/getUserPostRuleTree',
          method: "post",
          data: params
     });
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listOrganization = listOrganization;
exports.menuCreate = menuCreate;
exports.delDot = delDot;
exports.getMenu = getMenu;
exports.setWorks = setWorks;
exports.setMaterials = setMaterials;
exports.setMaterialsLxdz = setMaterialsLxdz;
exports.saveClaimId = saveClaimId;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// zym.机构列表
function listOrganization(params) {
  return (0, _fetch2.default)({
    //  url:'Rule/Rule/getOrganizationAndPostTree',
    url: 'eavar/organization/listOrganization',
    method: "post",
    data: params

  });
}

// 创建、修改机构信息
function menuCreate(params) {
  return (0, _fetch2.default)({
    //  url:'Rule/Rule/addOrUdateOrganization',
    url: 'eavar/organization/addOrUpdateOrganization',
    method: "post",
    data: params
  });
}

// 删除机构、机构角色信息
function delDot(params) {
  return (0, _fetch2.default)({
    // url:'Rule/Rule/delOrganizationAndPost',
    url: 'eavar/organization/deleteOrganization',
    method: "post",
    data: params
  });
}

function getMenu(params) {

  return (0, _fetch2.default)({
    //  url:'Rule/Rule/getOrganizationAndPostTree',
    url: 'eavar/organization/tree',
    method: "post",
    data: params

  });
}

// zym.初始化流程（新方法）
function setWorks(params) {
  return (0, _fetch2.default)({
    url: 'eavar/organization/setWorks',
    method: "post",
    data: params
  });
}

// zym.初始化申报资料（新方法）
function setMaterials(params) {
  return (0, _fetch2.default)({
    url: 'eavar/organization/setMaterials',
    method: "post",
    data: params
  });
}

// zym.初始化申报资料（连续电子）
function setMaterialsLxdz(params) {
  return (0, _fetch2.default)({
    url: 'eavar/organization/setMaterialsLxdz',
    method: "post",
    data: params
  });
}

// zym.保存书号系统Id（新方法）
function saveClaimId(params) {
  return (0, _fetch2.default)({
    url: 'eavar/organization/saveClaimId',
    method: "post",
    data: params
  });
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initBase = initBase;
exports.initLxdzBase = initLxdzBase;
exports.initFinance = initFinance;
exports.initLxdzFinance = initLxdzFinance;
exports.initPublication = initPublication;
exports.initWorker = initWorker;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// zym.基本信息
function initBase(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initBase",
    method: "post",
    data: params
  });
}

// zym.基本信息  - 连续型出版物
function initLxdzBase(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initLxdzBase",
    method: "post",
    data: params
  });
}

// zym.经营情况
function initFinance(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initFinance",
    method: "post",
    data: params
  });
}

// zym.经营情况  - 连续型出版物
function initLxdzFinance(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initLxdzFinance",
    method: "post",
    data: params
  });
}

// zym.出版物
function initPublication(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initPublication",
    method: "post",
    data: params
  });
}

// zym.人员情况
function initWorker(params) {
  return (0, _fetch2.default)({
    url: "eavar/static-data-gen/initWorker",
    method: "post",
    data: params
  });
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGmpTree = getGmpTree;
exports.getUserList = getUserList;
exports.setDeleted = setDeleted;
exports.getRoles = getRoles;
exports.getConfiged = getConfiged;
exports.userConnectRole = userConnectRole;
exports.userCreate = userCreate;
exports.userRemove = userRemove;
exports.getUserRoles = getUserRoles;
exports.UserAdminOperationList = UserAdminOperationList;
exports.initPublisherStartBatch = initPublisherStartBatch;
exports.fillReportForLxdz = fillReportForLxdz;
exports.recheckWorkerSum = recheckWorkerSum;

var _fetch = __webpack_require__(51);

var _fetch2 = _interopRequireDefault(_fetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 用户管理 - 机构树形
function getGmpTree(params) {
  return (0, _fetch2.default)({
    //  url: 'Rule/Rule/getOrganizationAndPostTree',
    url: "eavar/organization/tree",
    method: "post",
    data: params
  });
}

// 用户信息列表
function getUserList(params) {
  return (0, _fetch2.default)({
    //  url: 'User/User/getUserListByOrganizationId',
    url: "eavar/organization/users",
    method: "post",
    data: params
  });
}

// zym.设置启用禁用
function setDeleted(params) {
  return (0, _fetch2.default)({
    //  url: 'User/User/getUserListByOrganizationId',
    url: "eavar/organization/setDeleted",
    method: "post",
    data: params
  });
}

// zym.获得所有的角色
function getRoles(params) {
  return (0, _fetch2.default)({
    //  url: 'Rule/Rule/getOrganizationAndPostList',
    url: "manage/post/getOrganizationAndPostList",
    method: "post",
    data: params
  });
}

// zym.根据角色获得可以操作的权限
function getConfiged(params) {
  return (0, _fetch2.default)({
    url: "Rule/Rule/getUserPostRuleTree",
    method: "post",
    data: params
  });
}

// zym.保存分配的角色
function userConnectRole(params) {
  //  账号角色绑定
  return (0, _fetch2.default)({
    //  url: 'User/User/updateOrganizationUser',
    url: "manage/post/updateOrganizationUser",
    method: "post",
    data: params
  });
}
// zym.用户新建、修改
function userCreate(params) {
  //  账号新建

  return (0, _fetch2.default)({
    //  url: 'User/User/registerOrganization',
    url: "eavar/organization/addOrUpdateUser",
    method: "post",
    data: params
  });
}

// zym.帐号删除
function userRemove(params) {
  //  账号删除
  return (0, _fetch2.default)({
    //  url: 'User/User/delOrganizationUser',
    url: "eavar/organization/delOrganizationUser",
    method: "post",
    data: params
  });
}

// zym.获取用户角色信息
function getUserRoles(params) {
  return (0, _fetch2.default)({
    //  url: 'User/User/getOrganizationUserByUserId',
    url: "manage/post/getUserRolesByUserId",
    method: "post",
    data: params
  });
}

/*新增管理员对用户的操作历史记录（分页）*/

function UserAdminOperationList(params) {
  return (0, _fetch2.default)({
    url: "User/User/getUserAdminOperationList",
    method: "post",
    data: params
  });
}

// zym.批量生成初始化数据 - 音像、电子
function initPublisherStartBatch(params) {
  return (0, _fetch2.default)({
    url: "eavar/publisher/initPublisherStartBatch",
    method: "post",
    data: params
  });
}

// zym.补充连续型出版物整改报告
function fillReportForLxdz(params) {
  return (0, _fetch2.default)({
    url: "eavar/publisher/fillReportForLxdz",
    method: "post",
    data: params
  });
}

function recheckWorkerSum(params) {
  return (0, _fetch2.default)({
    url: "eavar/publisher/recheckWorkerSum",
    method: "post",
    data: params
  });
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (window) {
  var svgSprite = "<svg>" + "" + '<symbol id="icon-QQ" viewBox="0 0 1024 1024">' + "" + '<path d="M273.5104 480.17408 272.31232 476.44672 271.33952 471.6032 270.6944 468.95104 270.6944 465.6128 270.6944 461.62944 270.6944 458.02496 271.85152 453.72416 273.02912 449.1776 274.5856 444.40576 276.6848 439.0912 279.43936 433.57184 283.33056 428.04224 283.33056 424.17152 283.70944 420.54656 284.3136 415.62112 285.98272 410.08128 287.51872 404.10112 288.74752 401.3568 290.16064 398.7968 291.98336 395.95008 293.96992 393.8304 293.96992 389.9392 293.96992 385.56672 293.96992 380.16 295.1168 373.11488 296.27392 364.93312 298.33216 355.14368 301.16864 344.95488 303.27808 339.3536 305.36704 333.2608 307.6608 327.5776 310.40512 321.4848 313.20064 314.81856 316.416 308.57216 320.03072 301.90592 324.58752 295.24992 326.69696 291.4304 328.93952 288.3072 333.824 281.26208 338.85184 274.23744 344.55552 267.008 350.6688 259.97312 357.30432 253.04064 364.22656 245.9136 372.60288 238.22336 377.91744 233.54368 384.39936 228.49536 390.97344 224.04096 398.08 219.76064 404.91008 215.95136 412.61056 212.79744 420.79232 208.91648 428.92288 206.25408 437.03296 203.48928 445.7984 200.74496 454.5536 198.656 463.75936 196.9152 473.09824 195.40992 482.31424 194.18112 491.52 192.9216 501.34016 192.38912 510.67904 192.38912 520.33536 192.38912 530.35008 192.38912 540.01664 193.60768 549.7344 194.7648 559.63648 195.79904 568.832 198.01088 578.53952 200.07936 587.65312 202.45504 597.63712 205.1072 606.7712 208.34304 615.51616 212.03968 624.85504 215.95136 633.37472 220.22144 641.65888 224.9728 649.7792 230.20544 656.77312 235.06944 660.0192 237.81376 663.41888 239.8208 669.91104 245.32992 675.3792 250.65472 680.83712 256.16384 686.15168 262.2464 690.5344 268.14464 695.7568 274.23744 699.392 280.7808 703.0784 286.59712 706.99008 293.36576 710.23616 299.25376 715.69408 311.71584 718.37696 318.1568 720.47616 324.12672 722.57536 330.60864 724.45952 336.70144 725.77024 341.94432 727.47008 348.1088 730.44992 359.1168 732.35456 368.75264 733.5936 378.07104 734.65856 385.56672 736.33792 396.98432 736.7168 398.7968 738.05824 400.85504 741.67296 406.76352 743.99744 410.76736 746.05568 414.93504 748.67712 419.39968 750.99136 424.7552 752.49664 430.2336 754.13504 436.24448 755.37408 442.40896 755.93728 445.44 756.45952 449.1776 756.45952 452.42368 755.93728 455.63904 755.93728 459.64288 754.9952 463.52384 753.27488 471.04 751.29856 474.83904 749.83424 479.10912 749.83424 480.17408 750.53056 481.49504 752.49664 484.61824 761.05728 497.28512 767.81568 506.79808 771.05152 513.14688 775.41376 520.09984 779.2128 527.7184 783.59552 535.8592 787.97824 545.01376 792.91392 555.37664 795.6992 561.72544 798.23872 567.93088 800.43008 574.47424 802.59072 580.36224 804.23936 586.5472 805.91872 592.35328 808.0384 603.67872 809.71776 615.24992 810.87488 625.5104 810.87488 631.11168 810.87488 635.71968 810.87488 639.98976 810.09664 645.12 808.99072 653.9776 807.4752 661.93408 805.12 669.15328 804.23936 672.09216 802.59072 675.6352 801.21856 678.10304 799.37536 681.14432 797.75744 683.0592 795.6992 685.53728 793.856 687.53408 791.88992 689.24416 789.53472 690.2784 787.41504 691.31264 785.67424 691.88608 784.15872 691.88608 783.01184 691.88608 781.312 691.31264 778.07616 689.7152 776.59136 688.65024 775.03488 687.53408 773.33504 686.00832 771.61472 684.29824 768.77824 681.14432 765.41952 676.68992 762.7776 672.09216 760.13568 668.416 757.5552 664.13568 753.92 656.5376 749.83424 648.63232 749.35296 648.35584 748.67712 648.35584 747.01824 649.59488 746.05568 651.6736 744.45824 654.25408 741.67296 661.93408 737.47456 672.86016 732.09856 686.00832 728.05376 692.56192 723.8144 699.40224 718.77632 707.09248 713.43104 714.61888 710.69696 718.0288 707.3792 721.74592 699.7504 729.2416 700.416 729.91744 701.45024 730.99264 705.25952 733.22496 721.13152 740.85376 728.05376 744.7552 734.65856 748.544 741.19168 753.31584 747.01824 758.23104 749.83424 760.45312 751.95392 763.01312 754.13504 765.98272 755.93728 769.19808 756.91008 771.87072 758.09792 775.07584 758.60992 777.85088 759.17312 781.08672 758.60992 783.2576 758.60992 785.4592 758.09792 787.73248 756.91008 789.8112 756.45952 791.43936 755.37408 793.41568 752.49664 797.3376 749.83424 800.48128 747.776 802.83648 746.05568 804.57728 741.67296 807.77216 736.7168 810.55744 731.43296 813.21984 725.77024 815.77984 719.45216 818.25792 716.05248 819.29216 713.07264 820.13184 705.73056 821.84192 698.15296 823.47008 690.5344 825.088 682.25024 826.43968 673.71008 826.79808 664.95488 827.8528 656.29184 827.8528 647.17824 827.8528 637.77792 827.8528 627.97824 827.27936 618.8544 826.43968 609.01376 825.088 599.25504 824.04352 588.97408 822.60992 579.01056 820.13184 569.2928 818.25792 559.63648 815.49312 549.7344 811.95008 540.01664 809.02144 534.89664 807.31136 530.35008 805.69344 527.47264 804.57728 524.61568 803.97312 520.93952 803.97312 516.53632 803.97312 507.19744 803.31776 502.4768 802.83648 496.39424 802.16064 492.4928 805.69344 487.168 809.02144 479.9488 812.53376 471.9616 816.91648 467.10784 819.29216 462.03904 821.17632 450.84672 825.7536 444.76416 827.27936 438.38464 828.99968 429.53728 830.72 423.99744 831.15008 418.14016 831.65184 412.02688 832.32768 404.91008 832.59392 398.08 832.59392 390.97344 832.59392 375.83872 832.59392 359.424 832.32768 343.48032 830.72 335.4112 829.57312 327.61856 828.416 320.03072 827.27936 312.44288 825.7536 305.36704 823.47008 298.33216 821.84192 291.98336 819.29216 285.98272 816.91648 280.38144 814.24384 275.51744 811.32544 270.6944 807.77216 269.04576 806.05184 266.88512 803.97312 265.24672 802.16064 263.77216 800.07168 262.41024 797.99296 261.35552 795.89376 259.82976 791.43936 259.29728 789.13536 258.62144 786.57536 258.62144 784.20992 259.29728 781.53728 259.29728 778.88512 259.82976 776.23296 259.82976 774.61504 259.82976 770.87744 260.08576 768.0512 261.35552 764.81536 262.41024 761.57952 264.32512 757.67808 265.728 756.1728 266.88512 754.432 269.90592 750.73536 272.31232 748.83072 274.5856 747.49952 276.6848 745.80992 280.00256 744.7552 282.66496 743.13728 285.98272 741.4272 289.76128 740.29056 293.56032 739.13344 297.96352 738.17088 302.1312 737.61792 307.07712 736.9728 312.44288 736.5632 313.83552 736.1024 314.14272 736.1024 314.81856 735.52896 314.81856 734.8736 313.83552 733.5424 310.9888 732.19072 303.872 726.02624 299.08992 722.21696 293.56032 717.37344 287.98976 711.95648 282.19392 705.03424 275.51744 697.23136 273.02912 693.01248 269.73184 688.65024 266.88512 683.61216 264.32512 678.10304 260.87424 672.86016 258.62144 666.88 255.93856 660.91008 253.25568 654.25408 251.31008 647.87456 249.45664 639.98976 248.90368 639.70304 248.34048 639.70304 248.05376 639.13984 247.36768 639.13984 246.24128 639.70304 245.67808 639.98976 244.89984 641.31072 244.62336 642.9184 244.03968 644.352 243.02592 646.73792 239.7696 652.53376 238.08 656.04608 235.39712 659.10784 232.5504 662.79424 229.40672 666.88 226.08896 670.50496 222.18752 674.01728 218.58304 677.31456 214.58944 679.936 210.2272 682.67008 206.0288 684.29824 201.08288 685.53728 196.22912 686.00832 195.75808 686.00832 195.08224 686.00832 193.96608 685.53728 193.08544 683.61216 191.66208 682.67008 189.7984 678.10304 188.63104 675.6352 187.38176 672.09216 186.34752 668.416 185.79456 664.79104 184.25856 656.5376 183.67488 651.6736 183.67488 646.73792 183.67488 635.71968 184.25856 623.81056 185.22112 617.728 186.34752 611.46112 187.38176 604.71296 189.21472 598.43584 191.27296 591.2064 193.39264 584.16128 196.22912 576.91136 198.90176 569.99936 202.5984 562.98496 206.0288 555.37664 210.2272 548.23936 215.16288 540.53888 220.18048 533.61664 225.42336 525.91616 229.79584 520.5504 235.39712 514.4064 241.29536 508.2112 244.03968 505.26208 247.36768 501.94432 252.20096 497.75616 257.16736 493.48608 265.24672 486.2464 271.33952 481.792Z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-weixin" viewBox="0 0 1024 1024">' + "" + '<path d="M669.029188 317.395814c10.181291 0 20.235686 0.748037 30.23789 1.865487C672.100256 192.728466 536.831031 98.730629 382.414962 98.730629c-172.618362 0-314.03484 117.659747-314.03484 267.066545 0 86.2422 47.044337 157.061129 125.674313 211.988112l-31.406554 94.467535 109.75511-55.05285c39.302708 7.78122 70.80955 15.765055 110.010947 15.765055 9.849726 0 19.624747-0.481977 29.323017-1.243317-6.144182-20.996197-9.69827-42.982954-9.69827-65.792449C402.040732 428.732551 519.845498 317.395814 669.029188 317.395814zM500.167537 232.256738c23.639342 0 39.302708 15.550161 39.302708 39.185464 0 23.536043-15.66439 39.300075-39.302708 39.300075-23.535984 0-47.146672-15.765055-47.146672-39.300075C453.021889 247.806899 476.632577 232.256738 500.167537 232.256738zM280.402504 310.7433c-23.537007 0-47.300174-15.765055-47.300174-39.300075 0-23.635303 23.76419-39.185464 47.300174-39.185464 23.53496 0 39.200373 15.550161 39.200373 39.185464C319.602877 294.978245 303.937464 310.7433 280.402504 310.7433z"  ></path>' + "" + '<path d="M955.617831 562.14712c0-125.543298-125.622123-227.882104-266.733643-227.882104-149.41292 0-267.090791 102.338806-267.090791 227.882104 0 125.770472 117.677871 227.879034 267.090791 227.879034 31.278636 0 62.837668-7.896854 94.243199-15.765055l86.119862 47.170323-23.612735-78.473259C908.675829 695.672206 955.617831 632.965026 955.617831 562.14712zM602.306891 522.858302c-15.638806 0-31.431114-15.549138-31.431114-31.416524 0-15.651468 15.792308-31.405267 31.431114-31.405267 23.73963 0 39.302708 15.754822 39.302708 31.405267C641.609599 507.309164 626.04652 522.858302 602.306891 522.858302zM775.027587 522.858302c-15.538518 0-31.201884-15.549138-31.201884-31.416524 0-15.651468 15.66439-31.405267 31.201884-31.405267 23.535984 0 39.300661 15.754822 39.300661 31.405267C814.329272 507.309164 798.563571 522.858302 775.027587 522.858302z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-bug" viewBox="0 0 1024 1024">' + "" + '<path d="M969.142857 548.571429q0 14.848-10.861714 25.709714t-25.709714 10.861714l-128 0q0 97.718857-38.290286 165.705143l118.857143 119.442286q10.861714 10.861714 10.861714 25.709714t-10.861714 25.709714q-10.276571 10.861714-25.709714 10.861714t-25.709714-10.861714l-113.152-112.566857q-2.852571 2.852571-8.557714 7.424t-23.990857 16.274286-37.156571 20.845714-46.848 16.566857-55.442286 7.424l0-512-73.142857 0 0 512q-29.147429 0-58.002286-7.716571t-49.700571-18.870857-37.705143-22.272-24.868571-18.578286l-8.557714-8.009143-104.557714 118.272q-11.446857 11.995429-27.428571 11.995429-13.714286 0-24.576-9.142857-10.861714-10.276571-11.702857-25.417143t8.850286-26.587429l115.419429-129.718857q-33.133714-65.133714-33.133714-156.562286l-128 0q-14.848 0-25.709714-10.861714t-10.861714-25.709714 10.861714-25.709714 25.709714-10.861714l128 0 0-168.009143-98.852571-98.852571q-10.861714-10.861714-10.861714-25.709714t10.861714-25.709714 25.709714-10.861714 25.709714 10.861714l98.852571 98.852571 482.304 0 98.852571-98.852571q10.861714-10.861714 25.709714-10.861714t25.709714 10.861714 10.861714 25.709714-10.861714 25.709714l-98.852571 98.852571 0 168.009143 128 0q14.848 0 25.709714 10.861714t10.861714 25.709714zM694.857143 219.428571l-365.714286 0q0-75.995429 53.430857-129.426286t129.426286-53.430857 129.426286 53.430857 53.430857 129.426286z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-tubiaoleixingzhengchang" viewBox="0 0 1024 1024">' + "" + '<path d="M64 448 320 448 320 960 64 960 64 448 64 448ZM704 256 960 256 960 960 704 960 704 256 704 256ZM384 64 640 64 640 960 384 960 384 64 384 64Z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-quanxian" viewBox="0 0 1024 1024">' + "" + '<path d="M818.246893 412.326906l-45.988404 0 0-70.991868c0-152.307871-123.463939-275.778974-275.778974-275.778974s-275.78102 123.471103-275.78102 275.778974l0 70.991868-45.987381 0c-25.379017 0-45.988404 20.566408-45.988404 45.987381l0 455.407074c0 25.428136 20.560268 45.988404 45.988404 45.988404l643.535779 0c25.37697 0 45.988404-20.560268 45.988404-45.988404L864.235296 458.314287C864.190271 432.893314 843.623863 412.326906 818.246893 412.326906L818.246893 412.326906zM680.331823 412.326906 312.62516 412.326906l0-70.991868c0-101.55393 82.344426-183.853331 183.854355-183.853331 101.509928 0 183.853331 82.343403 183.853331 183.853331L680.332846 412.326906 680.331823 412.326906zM680.331823 412.326906"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-mima" viewBox="0 0 1024 1024">' + "" + '<path d="M780.8 354.579692 665.6 354.579692 665.6 311.689846c0-72.310154-19.849846-193.299692-153.6-193.299692-138.870154 0-153.6 135.049846-153.6 193.299692l0 42.889846L243.2 354.579692 243.2 311.689846C243.2 122.249846 348.790154 0 512 0s268.8 122.249846 268.8 311.689846L780.8 354.579692zM588.8 669.420308C588.8 625.900308 554.220308 590.769231 512 590.769231s-76.8 35.131077-76.8 78.651077c0 29.459692 15.399385 54.468923 38.439385 67.820308l0 89.639385c0 21.740308 17.250462 39.699692 38.4 39.699692s38.4-17.959385 38.4-39.699692l0-89.639385C573.44 723.889231 588.8 698.88 588.8 669.420308zM896 512l0 393.609846c0 65.260308-51.869538 118.390154-115.2 118.390154L243.2 1024c-63.291077 0-115.2-53.129846-115.2-118.390154L128 512c0-65.220923 51.869538-118.390154 115.2-118.390154l537.6 0C844.130462 393.609846 896 446.779077 896 512z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-jiedianyoujian" viewBox="0 0 1024 1024">' + "" + '<path d="M513 583.8l448.5-448.5c-11.6-4.7-24.3-7.3-37.5-7.3L100 128c-12.7 0-24.9 2.4-36.1 6.7L513 583.8z"  ></path>' + "" + '<path d="M513 674.3 14.6 175.9C5.3 191.1 0 208.9 0 228l0 568c0 55.2 44.8 100 100 100l824 0c55.2 0 100-44.8 100-100l0-568c0-18.5-5.1-35.9-13.9-50.8L513 674.3z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-zonghe" viewBox="0 0 1024 1024">' + "" + '<path d="M770.56 460.8l250.88 0C998.4 220.16 803.84 25.6 563.2 2.56l0 250.88C668.16 273.92 750.08 355.84 770.56 460.8L770.56 460.8zM770.56 460.8"  ></path>' + "" + '<path d="M460.8 253.44 460.8 2.56C220.16 25.6 25.6 220.16 2.56 460.8l250.88 0C273.92 355.84 355.84 273.92 460.8 253.44L460.8 253.44zM460.8 253.44"  ></path>' + "" + '<path d="M563.2 770.56l0 250.88c243.2-23.04 435.2-217.6 460.8-460.8l-250.88 0C750.08 668.16 668.16 750.08 563.2 770.56L563.2 770.56zM563.2 770.56"  ></path>' + "" + '<path d="M253.44 563.2 2.56 563.2c23.04 243.2 217.6 435.2 460.8 460.8l0-250.88C355.84 750.08 273.92 668.16 253.44 563.2L253.44 563.2zM253.44 563.2"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-404" viewBox="0 0 1024 1024">' + "" + '<path d="M931.6 585.6l0 79c28.6-60.2 44.8-127.4 44.8-198.4C976.4 211 769.4 4 514.2 4S52 211 52 466.2c0 3.2 0.2 6.4 0.2 9.6l166-206 96.4 0L171.8 485.6l46.4 0 0-54.8 99.2-154.6 0 209.4 0 100 0 82.4-99.2 0 0-82.4L67.6 585.6c43 161 170.6 287.4 332.4 328.6-10.4 26.2-40.6 89.4-90.8 100.6-62.2 14 168.8 3.4 333.6-104.6 126.6-36.6 230.8-125.8 287.4-242.2l-97.6 0 0-82.4-166.2 0 0-87.2 0-12.8L666.4 476l166.2-206.2 94 0-140.4 215.8 46.4 0 0-59 99.2-154 0 213.2L931.8 585.6zM366.2 608c-4.8-11.2-7.2-23.2-7.2-36L359 357.6c0-12.8 2.4-24.8 7.2-36 4.8-11.2 11.4-21 19.6-29.2 8.2-8.2 18-14.8 29.2-19.6 11.2-4.8 23.2-7.2 36-7.2l81.6 0c12.8 0 24.8 2.4 36 7.2 11 4.8 20.6 11.2 28.8 19.2l-88.6 129.4 0-23c0-4.8-1.6-8.8-4.8-12-3.2-3.2-7.2-4.8-12-4.8-4.8 0-8.8 1.6-12 4.8-3.2 3.2-4.8 7.2-4.8 12l0 72L372.6 620C370.2 616.2 368 612.2 366.2 608zM624.4 572c0 12.8-2.4 24.8-7.2 36-4.8 11.2-11.4 21-19.6 29.2-8.2 8.2-18 14.8-29.2 19.6-11.2 4.8-23.2 7.2-36 7.2l-81.6 0c-12.8 0-24.8-2.4-36-7.2-11.2-4.8-21-11.4-29.2-19.6-3.6-3.6-7-7.8-10-12l99.2-144.6 0 50.6c0 4.8 1.6 8.8 4.8 12 3.2 3.2 7.2 4.8 12 4.8 4.8 0 8.8-1.6 12-4.8 3.2-3.2 4.8-7.2 4.8-12l0-99.6 92.6-135.2c6.6 7.4 12 15.8 16 25.2 4.8 11.2 7.2 23.2 7.2 36L624.2 572z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-xinrenzhinan" viewBox="0 0 1024 1024">' + "" + '<path d="M780.108 761.059c54.451 60.351 87.706 138.983 87.706 225.358 0 12.015-0.659 23.882-1.902 35.581l-71.955 0c1.589-11.675 2.695-23.493 2.695-35.581 0-71.578-29.094-136.386-76.189-185.002C658.778 836.02 587.76 855.95 512 855.95c-75.689 0-146.65-19.888-208.294-54.432-47.129 48.604-76.358 113.305-76.358 184.9 0 12.088 1.105 23.906 2.695 35.581l-71.955 0c-1.243-11.699-1.902-23.567-1.902-35.581 0-86.366 33.19-165.055 87.587-225.446-96.765-78.277-158.75-197.84-158.75-331.998C85.023 193.163 276.188 2.001 512 2.001s426.977 191.162 426.977 426.972C938.977 563.184 876.94 682.785 780.108 761.059zM512 295.787c-196.511 0-355.814-80.302-355.814 122.251 0 202.551 159.303 366.749 355.814 366.749s355.814-164.199 355.814-366.749C867.814 215.485 708.511 295.787 512 295.787zM678.047 500.136c-26.2 0-47.442-21.24-47.442-47.442 0-26.197 21.242-47.442 47.442-47.442 26.202 0 47.442 21.244 47.442 47.442C725.488 478.896 704.249 500.136 678.047 500.136zM654.326 630.601c0 32.754-63.722 59.302-142.326 59.302s-142.326-26.549-142.326-59.302c0-8.445 4.376-16.446 12.017-23.719 21.98 20.927 71.979 35.579 130.309 35.579s108.329-14.652 130.309-35.579C649.949 614.155 654.326 622.156 654.326 630.601zM345.953 500.136c-26.202 0-47.442-21.24-47.442-47.442 0-26.197 21.24-47.442 47.442-47.442 26.2 0 47.442 21.244 47.442 47.442C393.395 478.896 372.153 500.136 345.953 500.136z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-theme" viewBox="0 0 1024 1024">' + "" + '<path d="M788.00002 159.831491C756.00002 128 746 128 724.3801 128L642 128C642 128 576 188.923077 512 188.923077 448 188.923077 384 128 384 128L299.204802 128C276.629934 128 266 140.923077 245.847214 159.831491L81.582979 323.871735C70.243732 335.19552 52 371.692308 81.582979 408.655004 81.582979 408.655004 224.023667 540.29784 238.000003 541.53846L238.000003 835.076924C238.000003 868.452352 286.579 896 320 896L706 896C739.419808 896 788.00002 868.452352 788.00002 835.076924L788.00002 541.53846C802.145492 540.385864 942.448564 408.654992 942.448564 408.654992 974.00002 372 965.851264 334.883878 942.448584 311.513109L788.00002 159.831491Z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-tuozhuai" viewBox="0 0 1024 1024">' + "" + '<path d="M574.957891 267.016403 511.503696 267.016403l204.64896 0L511.212054 63.654762l-203.361641 203.361641L449.041086 267.016403l0 189.662641L258.687714 456.679044l0 125.916804L449.041086 582.595848l0 190.354396 125.916804 0L574.957891 582.595848l188.874695 0L763.832586 456.679044 574.957891 456.679044 574.957891 267.016403zM511.25401 960.345238l189.620685-187.394994L323.125305 772.950244 511.25401 960.345238zM71.291696 518.891967l187.394994 189.620685L258.68669 330.762239 71.291696 518.891967zM763.832586 330.762239l0 377.74939 188.874695-189.620685L763.832586 330.762239z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-wujiaoxing" viewBox="0 0 1024 1024">' + "" + '<path d="M565.272827 34.627285l112.095872 237.542288c8.706637 18.321022 25.411424 31.051641 44.82285 33.996289l250.776598 38.081157c48.697387 7.411435 68.22505 70.046082 32.933559 105.979639l-181.494353 184.937155c-13.998147 14.230618-20.352386 34.815477-17.05903 54.93539l42.819161 261.127145c8.346858 50.695541-42.64204 89.451974-86.225039 65.51841l-224.307979-123.271141c-17.285968-9.525824-37.992596-9.525824-55.278564 0l-224.313514 123.271141c-43.582999 23.933565-94.571897-14.822869-86.219504-65.51841l42.813626-261.127145c3.321031-20.119914-3.088559-40.704772-17.086706-54.93539l-181.439002-184.937155c-35.285956-35.933557-15.819179-98.57374 32.933559-105.979639l250.748923-38.081157c19.350541-2.939112 36.083003-15.675267 44.75643-33.996289l112.123547-237.542288C480.497972-11.540583 543.509003-11.540583 565.272827 34.627285z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-EXCEL" viewBox="0 0 1024 1024">' + "" + '<path d="M625.664 132.608V199.68h309.76v43.008h-309.76V312.32h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.608h309.76v43.008h-309.76v68.096h309.76v43.008h-309.76v89.088H1024v-757.76h-398.336zM0 914.944L577.024 1024V0L0 109.056"  ></path>' + "" + '<path d="M229.376 660.48H139.776l118.272-187.904-112.64-180.736h92.16l65.536 119.808L370.688 291.84h89.088l-112.64 177.664L466.944 660.48H373.248l-70.144-125.44L229.376 660.48z"  ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-b" viewBox="0 0 1024 1024">' + "" + '<path d="M712.347826 0h44.521739v979.478261h-44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM44.521739 712.347826h44.521739v267.130435H44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z" fill="" ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-c" viewBox="0 0 1131 1024">' + "" + '<path d="M0 0h53.894737v970.105263H0zM269.473684 431.157895h53.894737v538.947368H269.473684zM538.947368 161.684211h53.894737v808.421052h-53.894737zM808.421053 646.736842h53.894736v323.368421h-53.894736zM1077.894737 323.368421h53.894737v646.736842h-53.894737z" fill="" ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-a" viewBox="0 0 1024 1024">' + "" + '<path d="M44.521739 0h44.521739v979.478261H44.521739zM267.130435 534.26087h44.521739v445.217391H267.130435zM489.73913 311.652174h44.52174v667.826087h-44.52174zM712.347826 712.347826h44.521739v267.130435h-44.521739zM934.956522 445.217391h44.521739v534.26087h-44.521739z" fill="" ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-zujian" viewBox="0 0 1024 1024">' + "" + '<path d="M568.6 0h454.9v454.9H568.6V0z m0 568.6h454.9v454.9H568.6V568.6zM0 568.6h454.9v454.9H0V568.6zM0 0h454.9v454.9H0V0z" fill="" ></path>' + "" + "</symbol>" + "" + '<symbol id="icon-gouwuche" viewBox="0 0 1024 1024">' + "" + '<path d="M874.68544 301.13792c-1.62816-2.6624-3.84512-5.17632-6.50752-7.3984s-6.0672-4.14208-9.91232-5.77024c-7.69536-3.84512-18.64192-5.77024-32.8448-5.77024H316.46208L312.32 254.53056l-3.25632-21.15584a49.3056 49.3056 0 0 0-0.73728-8.13568c0-0.14848 0-0.29696-0.14848-0.59392a128.34304 128.34304 0 0 0-3.25632-13.02016l-2.36544-7.54688c-0.59392-2.6624-1.77664-5.47328-3.25632-8.28416-2.36544-4.58752-6.0672-8.43264-10.35776-11.24352h-0.14848a54.0416 54.0416 0 0 0-27.07456-8.87808c-1.47968 0-2.95936-0.14848-4.43904-0.14848H181.82656a42.496 42.496 0 0 0-14.7968 2.51392c-1.3312 0.44544-2.6624 1.03424-3.84512 1.62816-11.24352 5.17632-18.19648 16.7168-18.34496 28.99968v0.29696c0 2.21696 0.14848 4.58752 0.44544 7.3984 0.29696 2.6624 0.73728 5.47328 1.18272 8.13568 0.59392 2.6624 1.47968 5.47328 2.81088 8.13568 0.44544 0.88576 0.88576 1.77664 1.3312 2.81088 2.21696 5.02784 5.17632 9.76384 9.17504 13.61408 2.0736 1.92512 4.14208 3.84512 6.36416 5.47328 4.43904 3.25632 10.35776 4.88448 18.048 4.88448h38.31808a21.248 21.248 0 0 1 20.85888 17.16224l28.70272 146.62144 12.27776 62.73024 10.65472 56.22272 8.28416 41.5744 4.14208 21.15584c0.88576 4.14208 2.21696 9.91232 3.9936 17.16224 1.62816 6.50752 3.9936 12.7232 7.10144 18.7904 1.92512 3.84512 3.9936 7.3984 6.21568 10.65472a56.94976 56.94976 0 0 0 16.42496 17.16224c2.21696 1.62816 4.43904 2.81088 6.95296 3.69664 2.51392 0.88576 5.17632 1.47968 8.28416 2.0736 2.95936 0.59392 6.0672 0.73728 9.46688 0.73728h405.53472c14.20288 0 23.5264-3.55328 27.96544-10.65472 4.88448-7.10144 7.3984-15.53408 7.3984-25.29792 0-20.1216-11.98592-30.1824-36.10112-30.1824H414.11072a39.84384 39.84384 0 0 1-39.20896-32.8448l-5.62176-32.256h390.74304c14.20288 0 26.33728-3.84512 36.10112-11.392 4.88448-3.84512 9.46688-9.02656 13.61408-15.83104s7.84384-14.7968 11.09504-23.96672c1.62816-4.88448 6.0672-17.60768 13.16864-38.31808l17.16224-48.08192 15.53408-44.83072 9.91232-26.92608c0.59392-1.62816 1.03424-3.25632 1.18272-4.88448 0.29696-1.62816 0.59392-3.4048 0.88576-5.3248s0.44544-3.9936 0.44544-6.0672c0.29696-6.0672-1.18272-11.68896-4.43904-17.16224zM739.16416 728.71936c-5.17632-5.62176-11.54048-9.76384-19.08736-12.57472-3.69664-1.3312-7.69536-2.51392-11.68896-3.10784a63.75936 63.75936 0 0 0-11.68896-1.03424c-2.81088 0-5.47328 0.14848-8.13568 0.29696a46.976 46.976 0 0 0-7.69536 1.47968c-2.6624 0.73728-5.02784 1.47968-7.3984 2.51392-3.25632 1.47968-6.656 3.10784-9.91232 5.3248a36.95104 36.95104 0 0 0-8.43264 7.3984c-5.62176 5.62176-9.91232 11.68896-12.7232 18.19648a37.43232 37.43232 0 0 0-3.84512 11.24352 58.01984 58.01984 0 0 0-1.03424 11.24352c0 7.9872 1.62816 15.3856 5.02784 22.48704 2.81088 6.50752 7.10144 12.87168 12.7232 18.93888 4.736 4.736 10.79808 8.58112 18.34496 11.98592 7.10144 3.25632 14.7968 4.88448 23.37792 4.88448 8.43264 0 16.27648-1.62816 23.37792-4.88448 7.54688-2.81088 13.90592-6.80448 19.08736-11.98592 5.62176-6.0672 10.20928-12.42624 13.4656-18.93888 1.47968-3.25632 2.51392-6.95296 3.25632-10.79808 0.73728-3.9936 1.03424-7.84384 1.03424-11.54048 0-7.9872-1.47968-15.3856-4.29056-22.48704a77.07648 77.07648 0 0 0-13.76256-18.64192zM455.38816 737.44896c-2.0736-3.10784-4.58752-5.91872-7.3984-8.7296a55.67488 55.67488 0 0 0-19.08736-12.57472 66.10944 66.10944 0 0 0-23.37792-4.29056c-1.92512 0-3.84512 0.14848-6.0672 0.29696a77.7216 77.7216 0 0 0-6.0672 0.73728 26.22464 26.22464 0 0 0-5.62176 1.47968c-1.92512 0.73728-3.69664 1.3312-5.62176 1.77664a39.64928 39.64928 0 0 0-7.10144 3.55328l-5.62176 4.29056a42.68032 42.68032 0 0 0-6.36416 4.88448 66.37568 66.37568 0 0 0-7.3984 8.7296 59.64288 59.64288 0 0 0-5.3248 9.46688c-2.81088 7.54688-4.29056 15.08864-4.29056 22.784 0 7.69536 1.47968 15.08864 4.29056 22.04672 2.81088 6.50752 7.10144 12.87168 12.7232 18.93888a72.49408 72.49408 0 0 0 19.08736 12.57472c7.10144 2.81088 14.7968 4.29056 23.37792 4.29056 7.9872 0 15.68256-1.47968 22.93248-4.58752s13.75744-7.10144 19.3792-12.27776c5.62176-6.0672 9.91232-12.42624 12.7232-18.93888 3.25632-6.95296 4.88448-14.35136 4.88448-22.04672s-1.62816-15.3856-4.88448-22.784c-1.32096-3.40992-3.0976-6.51264-5.1712-9.62048z" p-id="2271" fill=""></path>' + "" + "</symbol>" + "" + '<symbol id="icon-shanghu" viewBox="0 0 1024 1024">' + "" + '<path fill="" d="M862.435556 844.231111c0 40.96-20.48 61.44-56.888889 61.44H209.351111c-34.133333 0-54.613333-18.204444-56.888889-52.337778-2.275556-77.368889 0-293.546667 0-368.64 27.306667-4.551111 56.888889-4.551111 81.92-15.928889 22.755556-11.377778 40.96-34.133333 63.715556-52.337777 20.48 36.408889 54.613333 63.715556 104.675555 63.715555 47.786667 0 81.92-25.031111 106.951111-68.266666 56.888889 93.297778 163.84 88.746667 211.626667 4.551111 20.48 18.204444 38.684444 40.96 61.44 52.337777 22.755556 11.377778 52.337778 11.377778 81.92 15.928889v22.755556c-2.275556 65.991111 0 270.791111-2.275555 336.782222z"></path><path fill="" d="M851.057778 411.875556c-59.164444 11.377778-104.675556-18.204444-131.982222-86.471112-18.204444 56.888889-52.337778 91.022222-111.502223 88.746667-52.337778-2.275556-84.195556-34.133333-102.4-86.471111-20.48 59.164444-56.888889 91.022222-116.053333 86.471111-47.786667-2.275556-77.368889-29.582222-100.124444-86.471111-4.551111 9.102222-6.826667 18.204444-9.102223 25.031111-20.48 40.96-61.44 65.991111-106.951111 63.715556-45.511111-4.551111-81.92-34.133333-93.297778-79.644445-2.275556-13.653333-2.275556-29.582222 2.275556-43.235555 18.204444-54.613333 50.062222-104.675556 68.266667-159.288889 4.551111-13.653333 13.653333-18.204444 27.306666-18.204445h650.808889c15.928889 0 22.755556 4.551111 29.582222 20.48 18.204444 50.062222 43.235556 95.573333 65.991112 141.084445 31.857778 52.337778-13.653333 125.155556-72.817778 134.257778z"></path>' + "" + "</symbol>" + "" + '<symbol id="icon-gouwuche2" viewBox="0 0 1024 1024">' + "" + '<path d="M235.097303 699.133018C247.384597 735.582848 286.382106 763.623932 324.772759 763.623932L861.658537 763.623932 880.429732 763.623932 885.649214 745.458146 1009.08775 315.845043C1021.388907 273.032339 993.187631 235.213675 949.051586 235.213675L424.585365 235.213675C410.791718 235.213675 399.609756 246.479262 399.609756 260.376068 399.609756 274.272875 410.791718 285.538462 424.585365 285.538462L949.051586 285.538462C959.924 285.538462 964.161052 291.220461 961.106394 301.851829L837.667859 731.464932 861.658537 713.299145 324.772759 713.299145C307.742153 713.299145 287.789837 698.952471 282.395194 682.949451L73.600164 63.566336C69.16437 50.407706 54.980454 43.363344 41.919502 47.832313 28.858551 52.301281 21.86648 66.591273 26.302275 79.749903L235.097303 699.133018Z" p-id="2063"></path><path d="M399.609756 902.017094C399.609756 846.429871 354.881911 801.367522 299.707317 801.367522 244.532723 801.367522 199.804878 846.429871 199.804878 902.017094 199.804878 957.604318 244.532723 1002.666667 299.707317 1002.666667 354.881911 1002.666667 399.609756 957.604318 399.609756 902.017094ZM249.756098 902.017094C249.756098 874.223482 272.120021 851.692307 299.707317 851.692307 327.294613 851.692307 349.658537 874.223482 349.658537 902.017094 349.658537 929.810705 327.294613 952.341879 299.707317 952.341879 272.120021 952.341879 249.756098 929.810705 249.756098 902.017094Z" p-id="2064"></path><path d="M924.097562 902.017094C924.097562 846.429871 879.369715 801.367522 824.195121 801.367522 769.020529 801.367522 724.292683 846.429871 724.292683 902.017094 724.292683 957.604318 769.020529 1002.666667 824.195121 1002.666667 879.369715 1002.666667 924.097562 957.604318 924.097562 902.017094ZM774.243902 902.017094C774.243902 874.223482 796.607825 851.692307 824.195121 851.692307 851.782419 851.692307 874.146342 874.223482 874.146342 902.017094 874.146342 929.810705 851.782419 952.341879 824.195121 952.341879 796.607825 952.341879 774.243902 929.810705 774.243902 902.017094Z" p-id="2065"></path>' + "" + "</symbol>" + "" + '<symbol id="icon-videoplay" viewBox="0 0 1024 1024">' + "" + '<path d="M512 0C230.4 0 0 230.4 0 512c0 281.6 230.4 512 512 512 117.76 0 227.84-38.4 320-110.08 10.24-7.68 12.8-23.04 5.12-35.84-7.68-10.24-23.04-12.8-35.84-5.12C719.36 939.52 616.96 972.8 512 972.8 256 972.8 51.2 768 51.2 512 51.2 256 256 51.2 512 51.2 768 51.2 972.8 256 972.8 512c0 87.04-25.6 171.52-69.12 243.2-7.68 12.8-2.56 28.16 7.68 33.28 12.8 7.68 28.16 2.56 33.28-7.68 51.2-79.36 76.8-174.08 76.8-271.36C1024 230.4 793.6 0 512 0z" p-id="2412"></path><path d="M714.24 458.24c-17.92-15.36-245.76-222.72-245.76-222.72-10.24-10.24-25.6-7.68-35.84 2.56-5.12 5.12-7.68 12.8-7.68 17.92 0 0 0 0 0 0 0 0 0 499.2 0 512 0 15.36 10.24 25.6 25.6 25.6 5.12 0 12.8-2.56 15.36-7.68 2.56-2.56 217.6-186.88 240.64-207.36 23.04-20.48 33.28-38.4 33.28-64C742.4 491.52 732.16 473.6 714.24 458.24zM680.96 535.04c-7.68 5.12-204.8 176.64-204.8 176.64l0-399.36c0 0 186.88 166.4 202.24 181.76C696.32 512 698.88 519.68 680.96 535.04z" p-id="2413"></path>' + "" + "</symbol>" + "" + '<symbol id="icon-videoimg" viewBox="0 0 1024 1024">' + "" + '<path d="M49.770667 199.104H658.773333c19.925333 5.674667 33.493333 14.336 42.24 25.024 8.448 10.24 11.157333 20.117333 11.157334 25.066667v214.250666l262.357333-168.682666v414.826666l-262.357333-168.661333v148.096a24.896 24.896 0 1 0 49.770666 0v-62.442667l262.378667 174.186667V203.605333L761.92 372.266667v-123.093334c0-15.488-5.696-36.266667-22.464-56.661333-16-19.477333-39.573333-34.133333-71.104-42.368L665.258667 149.333333H0v608.96l0.768 3.029334c2.986667 11.669333 9.173333 27.989333 19.690667 44.629333 18.730667 29.653333 44.906667 48.725333 79.146666 49.066667h637.44a24.896 24.896 0 0 0 0-49.770667H99.84c-14.4-0.149333-26.752-9.130667-37.333333-25.877333a120.213333 120.213333 0 0 1-12.757334-27.690667V199.104z" p-id="2180"></path><path d="M205.909333 324.48a46.506667 46.506667 0 1 1-92.992-0.042667 46.506667 46.506667 0 0 1 92.992 0.021334z" p-id="2181"></path>' + "" + "</symbol>" + "" + '<symbol id="icon-del" viewBox="0 0 1024 1024">' + "" + '<path d="M821.344 197.248l-126.752 17.824-11.904-84.512a36.48 36.48 0 0 0-14.464-24.192c-16.416-12.384-41.376-11.072-54.688-9.152l-253.792 35.648c-46.624 6.56-60.16 30.688-57.312 51.072l11.008 78.24 0.896 6.336-76.128 10.688-50.656 7.136a32 32 0 1 0 8.928 63.36l23.552-3.328 18.176-2.528 4.224-0.608 50.752-7.136 63.936-8.992 73.088-10.272 192-26.976 192-27.008 16.032-2.24c17.504-2.432 29.696-18.624 27.232-36.128s-18.528-29.76-36.128-27.232zM398.208 454.208a32 32 0 0 1 64 0v210.496a32 32 0 0 1-64 0v-210.496z m192 0a32 32 0 0 1 64 0v210.496a32 32 0 0 1-64 0v-210.496z m-352-40.736v392.704c0 20.608 9.984 38.816 25.184 50.56 10.816 8.32 24.192 13.44 38.848 13.44h447.936a63.36 63.36 0 0 0 38.816-13.44c15.232-11.712 25.216-29.888 25.216-50.56V394.176H237.344l0.864 19.328z" p-id="2281"></path>' + "" + "</symbol>" + "" + "</svg>";var script = function () {
    var scripts = document.getElementsByTagName("script");return scripts[scripts.length - 1];
  }();var shouldInjectCss = script.getAttribute("data-injectcss");var ready = function ready(fn) {
    if (document.addEventListener) {
      if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) {
        setTimeout(fn, 0);
      } else {
        var loadFn = function loadFn() {
          document.removeEventListener("DOMContentLoaded", loadFn, false);fn();
        };document.addEventListener("DOMContentLoaded", loadFn, false);
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn);
    }function IEContentLoaded(w, fn) {
      var d = w.document,
          done = false,
          init = function init() {
        if (!done) {
          done = true;fn();
        }
      };var polling = function polling() {
        try {
          d.documentElement.doScroll("left");
        } catch (e) {
          setTimeout(polling, 50);return;
        }init();
      };polling();d.onreadystatechange = function () {
        if (d.readyState == "complete") {
          d.onreadystatechange = null;init();
        }
      };
    }
  };var before = function before(el, target) {
    target.parentNode.insertBefore(el, target);
  };var prepend = function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  };function appendSvg() {
    var div, svg;div = document.createElement("div");div.innerHTML = svgSprite;svgSprite = null;svg = div.getElementsByTagName("svg")[0];if (svg) {
      svg.setAttribute("aria-hidden", "true");svg.style.position = "absolute";svg.style.width = 0;svg.style.height = 0;svg.style.overflow = "hidden";prepend(svg, document.body);
    }
  }if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true;try {
      document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
    } catch (e) {
      console && console.log(e);
    }
  }ready(appendSvg);
})(window);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(83);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

exports.CONST = CONST;
exports.Material01 = Material01;
exports.Material02 = Material02;
exports.Material03 = Material03;
exports.Material04 = Material04;
exports.Material05 = Material05;
exports.Material06 = Material06;
exports.Material07 = Material07;
exports.Material08 = Material08;

var _validate2 = __webpack_require__(59);

var _validate3 = _interopRequireDefault(_validate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = __webpack_require__(2);

var NOTFOUND = 'NOTFOUND';
var PATTERN_ISBN = /^978-7-((\d{2})-(\d{6})|(\d{3})-(\d{5})|(\d{4})-(\d{4})|(\d{5})-(\d{3}))-(\d)$/;
var PATTERN_IDCARD = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
var PATTERN_MOBILE = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/;
// 这个应该没用 可空的话直接不require就行了
var PATTERN_MOBILE_NULL = /(^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$)|无$/;
var PATTERN_PHONE = /(^(?:\d{3,4}-?)?\d{7,8}(?:-\d{1,6})?$)|无$/;
var PATTERN_URL = /(^((http|https)?:\/\/)?(([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}$)|无$/;
// var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
//     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
//     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
//     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
//     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
//     '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

// const PATTERN_PHONE = /(^(0\d{2,3})?-?\d{7,8}$)|无$/;
var PATTERN_ZIP = /(^[0-9]{6})|无$/;
var DICT_XINGBIE = [{ id: '1', name: '男' }, { id: '2', name: '女' }];
var DICT_ISZHENGSHU = [{ id: '1', name: '有' }, { id: '2', name: '无' }];
var DICT_ISZIZHI = [{ id: '1', name: '有' }, { id: '2', name: '' }, { id: '2', name: '无' }];

function CONST() {
  return {
    PATTERN_ISBN: PATTERN_ISBN,
    PATTERN_IDCARD: PATTERN_IDCARD,
    PATTERN_MOBILE: PATTERN_MOBILE,
    PATTERN_PHONE: PATTERN_PHONE,
    PATTERN_URL: PATTERN_URL
  };
}

// validate.validators.custom = function(value, options, key, attributes) {
//   console.log(value);
//   console.log(options);
//   console.log(key);
//   console.log(attributes);
//   return "is totally wrong";
// };

// // Will log:
// //   - "some value"
// //   - "some options"
// //   - "foo"
// //   - {"foo": "some value"}
// validate({foo: "some value"}, {foo: {custom: "some options"}});
// => {foo: ["Foo is totally wrong"]}
// Before using it we must add the parse and format functions
// Here is a sample implementation using moment.js
_validate3.default.extend(_validate3.default.validators.datetime, {
  // The value is guaranteed not to be null or undefined but otherwise it
  // could be anything.
  parse: function parse(value, options) {
    return +moment.utc(value);
  },
  // Input is a unix timestamp
  format: function format(value, options) {
    console.debug('format: [' + value + ']', value, options);
    var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
    // return moment.utc(value).format(format);
    return moment(new value()).format(format);
  }
});

function formatDate(value) {
  var format = "YYYY-MM-DD";
  // console.debug('formatDate: ', value, moment(value).format(format))
  return moment(value).format(format);
}

// 检查日期 没错的话顺便格式化一下
_validate3.default.validators.formatdate = function (value, options, key, attributes) {
  // console.debug('formatdate: ', key, value, options, attributes)
  // 空的话无所谓？ 非空用别的设定判断？
  if (_validate3.default.isEmpty(value)) return;
  // 有错的话 回错误的数组 没错回undefined 所以true是有错
  if ((0, _validate3.default)({ formatdate: value }, { formatdate: { datetime: { dateOnly: true } } })) {
    return options.message;
  }
  attributes[key] = formatDate(attributes[key]);
};

// 可以直接用format
// validate.validators.isbn = function(value, options, key, attributes) {
//   // 格式
//   let pattern = /^978-7-((\d{2})-(\d{6})|(\d{3})-(\d{5})|(\d{4})-(\d{4})|(\d{5})-(\d{3}))-(\d)$/
//   if (!pattern.test(value)) {
//     return '请检查标准书号格式'
//   }
// };

_validate3.default.validators.biaozhushuhao = function (value, options, key, attributes) {
  if (_validate3.default.isEmpty(attributes.biaozhushuhao) && _validate3.default.isEmpty(attributes.tongyishuhao)) {
    return '请输入标准书号或统一书号';
  }
  if (!_validate3.default.isEmpty(attributes.biaozhushuhao) && !_validate3.default.isEmpty(attributes.tongyishuhao)) {
    return '标准书号或统一书号只能填写一个';
  }
  if (!_validate3.default.isEmpty(attributes.biaozhushuhao) && !PATTERN_ISBN.test(attributes.biaozhushuhao)) {
    return '标准书号格式错误';
  }
};

_validate3.default.validators.tongyishuhao = function (value, options, key, attributes) {
  if (_validate3.default.isEmpty(attributes.biaozhushuhao) && _validate3.default.isEmpty(attributes.tongyishuhao)) {
    return '请输入标准书号或统一书号';
  }
  if (!_validate3.default.isEmpty(attributes.biaozhushuhao) && !_validate3.default.isEmpty(attributes.tongyishuhao)) {
    return '标准书号或统一书号只能填写一个';
  }
};

_validate3.default.validators.years = function (value, options, key, attributes) {
  var year1 = options.year1,
      year2 = options.year2;

  if (!_validate3.default.contains([year1, year2], value * 1)) {
    return '年份';
  }
};

_validate3.default.validators.isyinjin = function (value, options, key, attributes) {
  console.log('!!!!!!!!!!', value, options, key, attributes);
  var dict = options.dict;

  if (_validate3.default.isEmpty(value)) {
    return '是否引进版不能为空';
  }
  // 是
  if (value.trim() === '是') {
    var res = getKeyFromItems(attributes.yinjinqingkuangmingcheng, dict);
    if (res === NOTFOUND) {
      return '请按照手册填写引进情况';
    }
    attributes.isyinjin = 1;
    attributes.yinjinqingkuangId = res;
    // "ff8080816467fb6d0164683b6a4d01ba" 
    // "其他国家/地区"
    if (res === 'ff8080816467fb6d0164683b6a4d01ba') {
      if (_validate3.default.isEmpty(attributes.qtyinjinqingkuang)) {
        return '\u8BF7\u586B\u5199\u5176\u4ED6\u5F15\u8FDB\u60C5\u51B5';
      }
    } else {
      if (!_validate3.default.isEmpty(attributes.qtyinjinqingkuang)) {
        return '\u5176\u4ED6\u5F15\u8FDB\u60C5\u51B5';
      }
    }
    // 否的时候 另外两项不能填
  } else if (value.trim() === '否') {
    if (!_validate3.default.isEmpty(attributes.yinjinqingkuangmingcheng)) {
      return '请确认引进情况'; // [%{value}]
    }
    if (!_validate3.default.isEmpty(attributes.qtyinjinqingkuang)) {
      return '\u8BF7\u586B\u5199\u5176\u4ED6\u5F15\u8FDB\u60C5\u51B5';
    }
    attributes.isyinjin = 2;
  } else {
    return '请按手册选择是否引进版';
  }
};
// 可能用不上了
_validate3.default.validators.yinjinqingkuang = function (value, options, key, attributes) {
  // var pbNum2 = (rule,val,callback) => {      // 标准书号
  console.debug('yinjinqingkuang: ', value, options, key, attributes);
  console.debug(attributes.isyinjin + ': [' + value + ']', !_validate3.default.isEmpty(value));
  var dict = options.dict;
  // 是

  if (attributes.isyinjin.trim() === '1') {
    var res = getKeyFromItems(value, dict);
    if (res === NOTFOUND) {
      return '请按照手册填写引进情况';
    }
    attributes.yinjinqingkuangId = res;
  } else {
    if (!_validate3.default.isEmpty(value)) {
      return '请确认引进情况'; // [%{value}]
    }
  }
};

_validate3.default.validators.leibie = function (value, options, key, attributes) {
  var dict = options.dict,
      message = options.message;

  var _dict = dict.map(function (d) {
    var _d = (0, _extends3.default)({}, d);
    _d.name = d.name.split(' ')[0];
    return _d;
  });
  var res = getKeyFromItems(value, _dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  attributes.leibieId = res;
  var resName = getNameFromItems(attributes.leibieId, dict);
  attributes.leibiemingcheng = resName;
};

// 中小学教材
_validate3.default.validators.iszxxjc = function (value, options, key, attributes) {
  var dict = options.dict,
      message = options.message;

  var _dict = dict.map(function (d) {
    var _d = (0, _extends3.default)({}, d);
    _d.name = d.name.split(' ')[0];
    return _d;
  });
  var res = getKeyFromItems(value ? value : 'NULL', _dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  attributes.iszxxjcId = res;
  var resName = getNameFromItems(attributes.iszxxjcId, dict);
  attributes.iszxxjcmingcheng = resName;
};

// 教辅
_validate3.default.validators.isjf = function (value, options, key, attributes) {
  // console.debug('isjf: ', value, options)
  var dict = options.dict,
      message = options.message;

  var _dict = dict.map(function (d) {
    var _d = (0, _extends3.default)({}, d);
    _d.name = d.name.split(' ')[0];
    return _d;
  });
  var res = getKeyFromItems(value ? value : 'NULL', _dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  attributes.isjfId = res;
  var resName = getNameFromItems(attributes.isjfId, dict);
  attributes.isjfmingcheng = resName;
};

// 再版重印
_validate3.default.validators.zaibancy = function (value, options, key, attributes) {
  // console.debug('zaibancy: ', value, options)
  var dict = options.dict,
      message = options.message;

  var _dict = dict.map(function (d) {
    var _d = (0, _extends3.default)({}, d);
    _d.name = d.name.split(' ')[0];
    return _d;
  });
  var res = getKeyFromItems(value ? value : 'NULL', _dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  attributes.zaibancyId = res;
  var resName = getNameFromItems(attributes.zaibancyId, dict);
  attributes.zaibancymingcheng = resName;
};

// 重点项目
_validate3.default.validators.inDictAndSetId = function (value, options, key, attributes) {
  // console.debug('inDictAndSetId: ', value, options)
  var dict = options.dict,
      message = options.message,
      setId = options.setId,
      other = options.other;

  var res = getKeyFromItems(value, dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  // 如果需要setId
  if (setId) {
    attributes[setId] = res;
  }
  // 如果有其他名称
  if (other) {
    var id = other.id,
        name = other.name,
        otherKey = other.key,
        otherMessge = other.message;

    if (res === id) {
      if (_validate3.default.isEmpty(attributes[otherKey])) {
        return '' + otherMessge;
      }
    } else {
      if (!_validate3.default.isEmpty(attributes[otherKey])) {
        return '' + otherMessge;
      }
    }
  }
};

// 
_validate3.default.validators.inDictAndCheckOthers = function (value, options, key, attributes) {
  console.debug('inDictAndCheckOthers: ', value, options);
  var dict = options.dict,
      message = options.message,
      setId = options.setId,
      others = options.others;

  var res = getKeyFromItems(value, dict);
  if (res === NOTFOUND) {
    return '' + message;
  }
  // 如果需要setId
  if (setId) {
    attributes[setId] = res;
  }
  // 如果有其他名称
  if (others) {
    var ret = void 0,
        msgs = void 0;
    var ids = others.ids,
        name = others.name,
        items = others.items;

    if (_validate3.default.contains(ids, res)) {
      ret = items.map(function (other) {
        var key = other.key,
            options = other.options,
            message = other.message;
        // 有错的话 回错误的数组 没错回undefined 所以true是有错
        // return validate({ item: attributes[key] }, { item: options }, {fullMessages: false})

        var va = (0, _validate3.default)(attributes, (0, _defineProperty3.default)({}, key, options), { fullMessages: false });
        // console.debug('others: ', va, _.values(va))
        return _.values(va);
      });
      // console.debug('ret: ', ret)
      msgs = [];
      _.forEach(ret, function (x) {
        // console.debug('x: ', x)
        msgs = _.concat(msgs, x);
      });
      // ret = _.compact(_.map(ret, 'item'))
      console.debug('others: ', msgs);
    } else {
      ret = items.map(function (other) {
        var key = other.key,
            message = other.message;

        if (!_validate3.default.isEmpty(attributes[key])) return message;
      });
      console.debug('no others: ', ret, _.compact(_.map(ret, 'item')), ids, res, _validate3.default.contains(ids, res));
      msgs = _.compact(ret);
    }
    // console.debug('msgs: ', msgs)
    // compact 是remove了废物项
    return msgs;
  }
};

function getKeyFromItems(value, items) {
  // console.debug('getKeyFromItems: ', value, items)
  var item = _.find(items, { name: value });
  if (item) {
    return item.id;
  }
  return NOTFOUND;
}

function getNameFromItems(value, items) {
  // console.debug('getKeyFromItems: ', value, items)
  var item = _.find(items, { id: value });
  if (item) {
    return item.name;
  }
  return '';
}

function Material01(options) {
  var d0001 = options.dictionary.d0001;

  console.log('d0001', d0001);
  var year1 = options.year1,
      year2 = options.year2;
  // console.debug('Material05: ', options, _.map(d0008.items, 'name'))
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))

  return {
    danwei: { presence: { message: '请输入单位名称' } },
    isbn: { presence: { message: '请输入现用ISBN前缀' }
      // format: { pattern: /\d{2,5}/, message: "现用ISBN前缀格式错误"}
    },
    wangzhi: { presence: { message: '请输入单位网址' }, format: { pattern: PATTERN_URL, message: "网址格式错误" } },
    leibiemingcheng: { presence: { message: '请输入单位类别' },
      inDictAndCheckOthers: {
        dict: d0001.items, setId: 'leibieId', message: '请选择单位类别'
      }
    },
    chenglrq: { presence: { allowEmpty: false, message: '请输入单位成立日期' }, formatdate: { message: '单位成立日期' } },
    djshijian: { presence: { allowEmpty: false, message: '请输入法人登记时间' }, formatdate: { message: '法人登记时间' } },
    dizhi: { presence: { allowEmpty: false, message: '请输入单位地址' } },
    youbian: { presence: { message: '请输入单位邮编' }, format: { pattern: PATTERN_ZIP, message: "单位邮编格式错误" } },
    faren: { presence: { allowEmpty: false, message: '请输入法定代表人姓名' } },
    farendf: { presence: { message: '请输入法定代表人办公室电话' }, format: { pattern: PATTERN_PHONE, message: "法定代表人办公室电话格式错误" } },
    farensj: { presence: { message: '请输入法定代表人办公手机号' }, format: { pattern: PATTERN_MOBILE, message: "法定代表人办公手机号格式错误" } },
    sbdianhua: { presence: { message: '请输入社办电话' }, format: { pattern: PATTERN_PHONE, message: "社办电话格式错误" } },
    sbchuanzhen: { presence: { message: '请输入社办传真' }, format: { pattern: PATTERN_PHONE, message: "社办传真格式错误" } },
    zbdianhua: { presence: { message: '请输入总编室电话' }, format: { pattern: PATTERN_PHONE, message: "总编室电话格式错误" } },
    zbchuanzhen: { presence: { message: '请输入总编室传真' }, format: { pattern: PATTERN_PHONE, message: "总编室传真格式错误" } },
    chusfw: { presence: { allowEmpty: false, message: '请输入出书范围' } },
    zhigshu: { presence: { message: '请输入单位职工总数' }, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '职工总数错误' } },
    gaojizhichengshu: { presence: { message: '请输入单位职工高级职称人数' }, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '高级职称人数错误' } },
    zhongjizhichengshu: { presence: { message: '请输入单位职工中级职称人数' }, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '中级职称人数错误' } },
    neisjg: { presence: { allowEmpty: false, message: '请输入内设机构' } },
    zhubandw: { presence: { allowEmpty: false, message: '请输入主办单位' } },
    zbzzbm: { presence: { allowEmpty: false, message: '请输入主办单位承担管理职责的部门' } },
    zbdizhi: { presence: { allowEmpty: false, message: '请输入主办单位地址' } },
    zbyoubian: { presence: { message: '请输入主办单位邮编' }, format: { pattern: PATTERN_ZIP, message: "主办单位邮编格式错误" } },
    zhubanlianxiren: { presence: { allowEmpty: false, message: '请输入主办单位联系人' } },
    zhubandwzuoji: { presence: { message: '请输入主办单位联系人座机' }, format: { pattern: PATTERN_PHONE, message: "主办单位联系人座机格式错误" } },
    zhubanshouji: { presence: { message: '请输入主办单位联系人手机' }, format: { pattern: PATTERN_MOBILE, message: "主办单位联系人手机格式错误" } },
    zgdanw: { presence: { allowEmpty: false, message: '请输入主管单位' } },
    zgzzbm: { presence: { allowEmpty: false, message: '请输入主管单位承担管理职责的部门' } },
    zgdizhi: { presence: { allowEmpty: false, message: '请输入主管单位地址' } },
    zgyoubian: { presence: { message: '请输入主管单位邮编' }, format: { pattern: PATTERN_ZIP, message: "主管单位邮编格式错误" } },
    zglxr: { presence: { allowEmpty: false, message: '请输入主管单位联系人' } },
    zglxrzuoji: { presence: { message: '请输入主管单位联系人座机' }, format: { pattern: PATTERN_PHONE, message: "主管单位联系人座机格式错误" } },
    zglxrdf: { presence: { message: '请输入主管单位联系人手机' }, format: { pattern: PATTERN_MOBILE, message: "主管单位联系人手机格式错误" } },
    gzfzr: { presence: { allowEmpty: false, message: '请输入出版单位年度核验工作负责人' } },
    gzfzrsj: { presence: { message: '请输入出版单位年度核验工作负责人电话' }, format: { pattern: PATTERN_PHONE, message: "出版单位年度核验工作负责人电格式错误" } },
    gzfzrdf: { presence: { message: '请输入出版单位年度核验工作负责人手机' }, format: { pattern: PATTERN_MOBILE, message: "入出版单位年度核验工作负责人手机格式错误" } }
  };
}

function Material02(options) {
  var _options$dictionary = options.dictionary,
      d0002 = _options$dictionary.d0002,
      d0003 = _options$dictionary.d0003,
      d0004 = _options$dictionary.d0004,
      d0005 = _options$dictionary.d0005,
      d0013 = _options$dictionary.d0013;

  console.debug('Material02: ', options, _.map(d0004.items, 'name'));
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    xingming: { presence: { allowEmpty: false, message: '请输入姓名' } },
    // xingbie: { presence: {message: '请输入性别'},}, 
    xingbie: { presence: { message: '请输入性别' },
      inDictAndCheckOthers: {
        dict: DICT_XINGBIE, setId: 'xingbie', message: '请选择性别'
      }
    },
    // pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/
    shenfenzheng: { presence: { message: '请输入身份证号' },
      format: {
        pattern: PATTERN_IDCARD,
        flag: "i",
        message: "身份证格式"
      }
    },
    zhiwu: { presence: { allowEmpty: false, message: '请输入职务/职称' } },
    renzhisj: { presence: { allowEmpty: false, message: '请输入任职时间' } },
    zhenzhimmmingcheng: { presence: { message: '请输入政治面貌' },
      inDictAndSetId: {
        dict: d0003.items, setId: 'zhenzhimmId', message: '请选择政治面貌'
      }
    },
    wenhuamingcheng: { presence: { message: '请输入文化程度' },
      inDictAndSetId: {
        dict: d0004.items, setId: 'wenhuaId', message: '请选择文化程度'
      }
    },
    jibiemingcheng: { presence: { message: '请输入出版专业职称级别' },
      inDictAndCheckOthers: {
        dict: d0005.items, setId: 'jibieId', message: '请选择出版专业职称级别',
        others: {
          // ids: 'ff808081648886600164888c43bb0018', name: '暂无', 
          ids: _.map(_.filter(d0005.items, function (o) {
            return o.name !== '暂无';
          }), 'id'), name: '暂无',
          items: [{ key: 'zhengshubh', message: '出版专业职业资格证书编号',
            options: { presence: { allowEmpty: false, message: '请输入出版专业职业资格证书编号' } } }]
        }
      }
    },
    iszhengshu: { presence: { message: '请输入是否获得岗位培训证书' },
      inDictAndCheckOthers: {
        dict: DICT_ISZHENGSHU, setId: 'iszhengshu', message: '是否获得岗位培训证书',
        others: {
          ids: ['1'], name: '有',
          items: [{ key: 'zhengshusj', message: '岗位培训证书获得时间',
            options: { presence: { allowEmpty: false, message: '岗位培训证书获得时间' }, formatdate: { message: '岗位培训证书获得时间' } } }]
        }
      }
    },
    shouji: { presence: { message: '请输入手机' },
      format: {
        pattern: PATTERN_MOBILE,
        flag: "i",
        message: "手机"
      }
    }
  };
}

function Material03(options) {
  var _options$dictionary2 = options.dictionary,
      d0002 = _options$dictionary2.d0002,
      d0003 = _options$dictionary2.d0003,
      d0004 = _options$dictionary2.d0004,
      d0005 = _options$dictionary2.d0005,
      d0013 = _options$dictionary2.d0013;
  // console.debug('Material03: ', options, _.map(d0005.items, 'name'), _.keyBy(d0005.items, 'name'), _.mapValues(_.keyBy(d0005.items, 'name'), 'id'))
  // console.debug('Material03: ', options)

  return {
    xingming: { presence: { allowEmpty: false, message: '请输入姓名' } },
    // xingbie: { presence: {message: '请输入性别'},}, 
    xingbie: { presence: { message: '请输入性别' },
      inDictAndCheckOthers: {
        dict: DICT_XINGBIE, setId: 'xingbie', message: '请选择性别'
      }
    },
    // pattern: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{4}$/
    shenfenzheng: { presence: { allowEmpty: false, message: '请输入身份证号' },
      format: {
        pattern: PATTERN_IDCARD,
        flag: "i",
        message: "身份证格式错误"
      }
    },
    zhenzhimmmingcheng: { presence: { message: '请输入政治面貌' },
      inDictAndSetId: {
        dict: d0003.items, setId: 'zhenzhimmId', message: '请选择政治面貌'
      }
    },
    wenhuamingcheng: { presence: { message: '请输入文化程度' },
      inDictAndSetId: {
        dict: d0004.items, setId: 'wenhuaId', message: '请选择文化程度'
      }
    },
    zhuanye1mingcheng: { presence: { allowEmpty: false, message: '请输入专业' } },
    // zhuanye1mingcheng: { presence: {message: '请输入专业'},
    //   inDictAndSetId: {
    //     dict: d0013.items, setId: 'xiangmuId', message: '请选择项目名称',
    //   },
    // }, 
    gangweimingcheng: { presence: { message: '请输入所在岗位' },
      inDictAndSetId: {
        dict: d0002.items, setId: 'gangweiId', message: '请选择所在岗位'
      }
    },
    zhiwu: { presence: { allowEmpty: false, message: '请输入职务/职称' } },
    jibiemingcheng: { presence: { message: '请输入出版专业职称级别' },
      inDictAndCheckOthers: {
        dict: d0005.items, setId: 'jibieId', message: '请选择出版专业职称级别',
        others: {
          // ids: 'ff808081648886600164888c43bb0018', name: '暂无', 
          ids: _.map(_.filter(d0005.items, function (o) {
            return o.name !== '暂无';
          }), 'id'), name: '暂无',
          items: [{ key: 'zbzyzyzgzsbh', message: '出版专业职业资格证书编号',
            options: { presence: { allowEmpty: false, message: '请输入出版专业职业资格证书编号' } } }]
        }
      }
    },
    // 要一起检查了？
    // zbzyzyzgzsbh: { presence: {message: '请输入出版专业职业资格证书编号'},}, 
    // zczrbjbh: { presence: {message: '请输入注册责任编辑编号'},}, 
    // yxDate: { presence: {message: '请输入注册有效期'},}, 
    iscscbwzz: { presence: { message: '请输入是否有辞书出版资质' },
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iscscbwzz', message: '是否有辞书出版资质'
      }
    },
    isysbjlcbwcbzz: { presence: { message: '请输入是否有养生保健类出版物出版资质' },
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'isysbjlcbwcbzz', message: '是否有养生保健类出版物出版资质'
      }
    },
    isdtcbcbzz: { presence: { message: '请输入是否有地图出版资质' },
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'isdtcbcbzz', message: '是否有地图出版资质'
      }
    },
    iszxxjfcbzz: { presence: { message: '请输入是否有中小学教辅出版资质' },
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iszxxjfcbzz', message: '是否有中小学教辅出版资质'
      }
    },
    iswlcbzz: { presence: { message: '请输入是否有网络出版资质' },
      inDictAndCheckOthers: {
        dict: DICT_ISZIZHI, setId: 'iswlcbzz', message: '是否有网络出版资质'
      }
    }
  };
}

function Material04(options) {
  var d0012 = options.dictionary.d0012;

  return {
    zyywsr: {
      presence: { message: '请输入主营业务收入' },
      numericality: { greaterThanOrEqualTo: 0, message: '主营业务收入' }
    },
    qtywsr: {
      presence: { message: '请输入其他业务收入' },
      numericality: { greaterThanOrEqualTo: 0, message: '其他业务收入' }
    },
    pzbzsh: {
      presence: { message: '请输入品种数(标准)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '品种数(标准)' }
    },
    pztysh: {
      presence: { message: '请输入品种数(统一)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '品种数(统一)' }
    },
    xsbzsh: {
      presence: { message: '请输入新书品种数(标准)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '新书品种数(标准)' }
    },
    xstysh: {
      presence: { message: '请输入新书品种数(统一)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '新书品种数(统一)' }
    },
    cypzbzsh: {
      presence: { message: '请输入重印品种数(标准)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '重印品种数(标准)' }
    },
    cypztysh: {
      presence: { message: '请输入重印品种数(统一)' },
      numericality: { onlyInteger: true, greaterThanOrEqualTo: 0, message: '重印品种数(统一)' }
    },
    zongyinshu: {
      presence: { message: '请输入总印数' },
      numericality: { greaterThanOrEqualTo: 0, message: '总印数' }
    },
    zongyinzhang: {
      presence: { message: '请输入总印张' },
      numericality: { greaterThanOrEqualTo: 0, message: '总印张' }
    },
    chubanmayang: {
      presence: { message: '请输入定价总金额' },
      numericality: { greaterThanOrEqualTo: 0, message: '定价总金额' }
    },
    fahuomayang: {
      presence: { message: '请输入发货总金额' },
      numericality: { greaterThanOrEqualTo: 0, message: '发货总金额' }
    },
    xiaoshouzongce: {
      presence: { message: '请输入销售总册数' },
      numericality: { greaterThanOrEqualTo: 0, message: '销售总册数' }
    },
    xiaoshoumayang: {
      presence: { message: '请输入销售总金额' },
      numericality: { greaterThanOrEqualTo: 0, message: '销售总金额' }
    },
    xiaoshoushouru: {
      presence: { message: '请输入销售收入' },
      numericality: { greaterThanOrEqualTo: 0, message: '销售收入' }
    },
    qzszcbsr: {
      presence: { message: '请输入数字出版总额' },
      numericality: { greaterThanOrEqualTo: 0, message: '数字出版总额' }
    },
    szcblrze: {
      presence: { message: '请输入数字出版利润总额' },
      numericality: { number: true, message: '数字出版利润总额' }
    },
    tushulirun: {
      presence: { message: '请输入图书利润总额' },
      numericality: { number: true, message: '图书利润总额' }
    },
    pingjunlirun: {
      presence: { message: '请输入图书单品种平均利润' },
      numericality: { number: true, message: '图书单品种平均利润' }
    },
    kucunmayang: {
      presence: { message: '请输入库存总金额' },
      numericality: { greaterThanOrEqualTo: 0, message: '库存总金额' }
    },
    rjnsr: {
      presence: { message: '请输入人均年收入' },
      numericality: { greaterThanOrEqualTo: 0, message: '人均年收入' }
    }
  };
}

function Material05(options) {
  var _options$dictionary3 = options.dictionary,
      d0006 = _options$dictionary3.d0006,
      d0007 = _options$dictionary3.d0007,
      d0008 = _options$dictionary3.d0008,
      d0009 = _options$dictionary3.d0009,
      d0014 = _options$dictionary3.d0014;
  var year1 = options.year1,
      year2 = options.year2;
  // console.debug('Material05: ', options, _.map(d0008.items, 'name'))
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))

  return {
    year: {
      years: { year1: year1, year2: year2, message: '年份' }
    },
    shuming: {
      presence: { allowEmpty: false, message: '请输入书名', fullMessages: false }
    },
    biaozhushuhao: {
      biaozhushuhao: true
      // isbn: true,
      // format: { pattern: PATTERN_ISBN, message: "标准书号格式错误"}
    },
    tongyishuhao: {
      tongyishuhao: true
    },
    zhebian: {
      presence: { allowEmpty: false, message: '请输入责编' }
    },
    yishen: {
      presence: { allowEmpty: false, message: '请输入初审' }
    },
    ershen: {
      presence: { allowEmpty: false, message: '请输入复审' }
    },
    sanshen: {
      presence: { allowEmpty: false, message: '请输入终审' }
    },
    zishu: {
      // validator: number1,
      presence: { message: '字数不能为空' },
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        message: '字数应为正整数'
      }
    },
    isyinjin: {
      isyinjin: { message: "是否为引进版", dict: d0014.items }
      // presence: true, //{message: '请选择是否为引进版'},
      // inclusion: {
      //   within: ['1', '2'],
      //   message: "是否为引进版"
      // }
    },
    // 上边一起check了
    // yinjinqingkuangmingcheng: {
    //   // yinjinqingkuang: true,
    //   yinjinqingkuang: {
    //     dict: d0014.items,
    //   }
    // },
    // qtyinjinqingkuang: {
    //   presence: {message: '请填写国家或地区'},
    // },
    leibiemingcheng: {
      leibie: { dict: d0006.items, message: '图书分类' }
    },
    iszxxjcmingcheng: {
      iszxxjc: { dict: d0007.items, message: '是否中小学教材' }
    },
    isjfmingcheng: {
      isjf: { dict: d0008.items, message: '是否中小学教辅' }
    },
    zaibancymingcheng: {
      zaibancy: { dict: d0009.items, message: '是否再版重印' }
    },
    dingjia: {
      presence: { message: '请输入定价' },
      // type: {type: 'number', message: '请确认定价'},
      numericality: {
        greaterThanOrEqualTo: 0,
        // lessThan: 100000,
        message: '请确认定价'
      }
    },
    yinshu: {
      presence: { message: '请输入印数' },
      // type: {type: 'number', message: '请确认印数'},
      numericality: {
        onlyInteger: true,
        greaterThan: 0,
        message: '印数应为正整数'
      }
    }
    // cbName: {
    //   presence: {message: '出版单位'},
    // },
  };
}

// 表7 表彰
function Material06(options) {
  var d0012 = options.dictionary.d0012;

  return {
    hjtime: { presence: { allowEmpty: false, message: '请选择时间' } },
    jiangxiangmingcheng: {
      inDictAndSetId: {
        dict: d0012.items, setId: 'jiangxiangId', message: '请选择表彰奖项',
        other: { id: '75', name: '其他按规定程序获得批准举办的省部级图书奖项', key: 'jxname', message: '表彰奖项(其他)' }
      }
    },
    hjtushu: { presence: { allowEmpty: false, message: '请输入表彰对象' } },
    banjiangdanwei: { presence: { allowEmpty: false, message: '请输入颁奖单位' } }
  };
}

// 表8 重点 07
function Material07(options) {
  var d0010 = options.dictionary.d0010;

  return {
    shuming: { presence: { allowEmpty: false, message: '请输入书名' } },
    xiangmumingcheng: {
      inDictAndSetId: {
        dict: d0010.items, setId: 'xiangmuId', message: '请选择项目名称',
        other: { id: '64', name: '其他', key: 'jxname', message: '项目名称(其他)' }
      }
    },
    zizhujine: { presence: { message: '请输入资助金额' },
      numericality: {
        greaterThanOrEqualTo: 0,
        // lessThan: 10000,
        message: '资助金额'
      }
    },
    wancqk: { presence: { allowEmpty: false, message: '请输入完成情况' } },
    remark: { presence: { allowEmpty: false, message: '请输入备注' } }
    // 项目里一起
    // jxname: { presence: {message: '请输入项目名称'},}, 
  };
}

// 表9 管理制度
// date
// https://github.com/ansman/validate.js/issues/129
function Material08(options) {
  console.debug('Material08: ', options);
  // console.debug('Material05: ', options, _.keyBy(d0008.items, 'name'), _.mapValues(_.keyBy(d0008.items, 'name'), 'id'))
  return {
    zhidu: { presence: { allowEmpty: false, message: '请输入制度名称' } },
    zdtime: { presence: { allowEmpty: false, message: '请选择制定时间' }, formatdate: { message: '制定时间' } },
    xdtime: { formatdate: { message: '修改时间' } },
    snwenhao: { presence: { allowEmpty: false, message: '请输入社内文号' } },
    zxqk: { presence: { allowEmpty: false, message: '请输入执行情况' } }
  };
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(211);

var _vue2 = _interopRequireDefault(_vue);

var _IconSvg = __webpack_require__(1573);

var _IconSvg2 = _interopRequireDefault(_IconSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// svg组件
// import generateIconsView from '@/views/svg-icons/generateIconsView.js'// just for views/icons , you can delete it
// register globally

_vue2.default.component('icon-svg', _IconSvg2.default);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__(1843);
// console.log(req)
var iconMap = requireAll(req);
// console.log(iconMap)
// generateIconsView.generate(iconMap) // just for views/icons , you can delete it

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// module.exports = file => () => import('@/views/' + file + '.vue')
module.exports = function (file) {
  return __webpack_require__(1844)("./" + file + '.vue');
};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getters = {
    sidebar: function sidebar(state) {
        return state.app.sidebar;
    },
    token: function token(state) {
        return state.user.token;
    },
    avatar: function avatar(state) {
        return state.user.avatar;
    },
    name: function name(state) {
        return state.user.name;
    },
    roles: function roles(state) {
        return state.user.roles;
    },
    userInfo: function userInfo(state) {
        return state.user.userInfo;
    },
    fileToken: function fileToken(state) {
        return state.user.fileToken;
    },
    permission_routers: function permission_routers(state) {
        return state.permission.routers;
    },
    routerStatus: function routerStatus(state) {
        return state.permission.routerStatus;
    },
    addRouters: function addRouters(state) {
        return state.permission.addRouters;
    },
    errorNo: function errorNo(state) {
        return state.error.errorNo;
    },
    dictionary: function dictionary(state) {
        return state.dictionary.dicStorage;
    }
};
exports.default = getters;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(180);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(832);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(37);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _jsCookie = __webpack_require__(490);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = {
  state: {
    sidebar: {
      opened: !+_jsCookie2.default.get('sidebarStatus')
    },
    visitedViews: []
  },
  mutations: {
    TOGGLE_SIDEBAR: function TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        _jsCookie2.default.set('sidebarStatus', 1);
      } else {
        _jsCookie2.default.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    ADD_VISITED_VIEWS: function ADD_VISITED_VIEWS(state, view) {
      console.log(view);
      if (state.visitedViews.some(function (v) {
        return v.path === view.path;
      })) return;
      state.visitedViews.push({ name: view.name, path: view.path, params: view.params, query: view.query });
    },
    DEL_VISITED_VIEWS: function DEL_VISITED_VIEWS(state, view) {
      var index = void 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(state.visitedViews.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              i = _step$value[0],
              v = _step$value[1];

          if (v.path === view.path) {
            index = i;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      state.visitedViews.splice(index, 1);
    }
  },
  actions: {
    ToggleSideBar: function ToggleSideBar(_ref) {
      var commit = _ref.commit;

      commit('TOGGLE_SIDEBAR');
    },
    addVisitedViews: function addVisitedViews(_ref2, view) {
      var commit = _ref2.commit;

      commit('ADD_VISITED_VIEWS', view);
    },
    delVisitedViews: function delVisitedViews(_ref3, view) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new _promise2.default(function (resolve) {
        commit('DEL_VISITED_VIEWS', view);
        resolve([].concat((0, _toConsumableArray3.default)(state.visitedViews)));
      });
    }
  }
};

exports.default = app;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _pressRole = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dictionary = {
	state: {
		dicStorage: {},
		dicArrStorage: {}
	},

	mutations: {
		DICT_UPDATE: function DICT_UPDATE(state, inDats) {
			if (!state.dicStorage[inDats.code]) {
				state.dicStorage[inDats.code] = inDats.dats;
				state.dicArrStorage[inDats.code] = inDats.datArrs;
			};
		}
	},

	actions: {
		dictUpdate: function dictUpdate(_ref, inPams) {
			var commit = _ref.commit,
			    state = _ref.state;

			var codeArr = inPams.codeArr;
			return new _promise2.default(function (resolve, reject) {
				var promiseArr = [];
				var dictStore = state.dicStorage;

				var _loop = function _loop(i) {
					if (!dictStore[codeArr[i]]) {
						var inCode = codeArr[i].substr(1, codeArr[i].length - 1);
						promiseArr.push(new _promise2.default(function (inResolve, inReject) {
							(0, _pressRole.dicSeek)({ code: inCode }).then(function (response) {
								//  let unFormate = response.dataDictionarys;
								var unFormate = response.payload;
								var dicDat = {};
								var dicArr = [];
								for (var _i = 0; _i < unFormate.length; _i++) {
									dicDat[unFormate[_i].id] = unFormate[_i].name;
									var stemp = {
										name: unFormate[_i].name,
										code: unFormate[_i].id
									};
									dicArr.push(stemp);
								};
								var dicMap = {
									code: codeArr[i],
									dats: dicDat,
									datArrs: dicArr
								};
								commit('DICT_UPDATE', dicMap);
								inResolve(response);
							}).catch(function (error) {
								inReject(error);
							});
						}));
					}
				};

				for (var i = 0; i < codeArr.length; i++) {
					_loop(i);
				};

				if (promiseArr.length > 0) {
					_promise2.default.all(promiseArr).then(function (result) {
						if (inPams.type == 'map') {
							resolve(state.dicStorage);
						} else if (inPams.type == 'arr') {
							resolve(state.dicArrStorage);
						}
					}).catch(function (error) {
						reject(error);
					});
				} else {
					if (inPams.type == 'map') {
						resolve(state.dicStorage);
					} else if (inPams.type == 'arr') {
						resolve(state.dicArrStorage);
					}
				}
			});
		}
	}
};

exports.default = dictionary;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var error = {
  state: {
    error: {
      errorNo: 0
    }
  },
  mutations: {
    COMMIT_ERROR: function COMMIT_ERROR(state, errorNo) {
      state.error.errorNo = errorNo;
    }
  },
  actions: {
    CommitError: function CommitError(_ref) {
      var commit = _ref.commit;

      commit('COMMIT_ERROR');
    }
  }
};

exports.default = error;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__(368);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(rolesMap, route) {

    if (rolesMap[route.key]) {
        return true;
    }
    return false;
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(registerComponentMap, roles) {
    var accessedRouters = registerComponentMap.filter(function (route) {
        var rolesMap = {};
        roles.forEach(function (currentValue) {
            rolesMap[currentValue.url] = currentValue;
        });
        if (hasPermission(rolesMap, route)) {

            if (route.noDropdown) {
                route.name = rolesMap[route.key].name;
                route.icon = rolesMap[route.key].iconUrl;
                route.path = '/' + rolesMap[route.key].url;
                route.redirect = '/children_' + rolesMap[route.key].url;
                route.children = [{ path: 'children_' + rolesMap[route.key].url, name: rolesMap[route.key].name, isShow: true, parent: false, component: route.childrenComponent }];
                delete route.childrenComponent;
            } else {
                // 组装权限
                if (route.parent) {
                    route.path = '/' + rolesMap[route.key].url;
                    route.redirect = 'noredirect';
                } else {
                    route.path = rolesMap[route.key].url;
                }
                route.name = rolesMap[route.key].name;
                route.icon = rolesMap[route.key].iconUrl;
                if (rolesMap[route.key].view === 1) {
                    route.isShow = true;
                } else {
                    route.isShow = false;
                }
                if (route.children && route.children.length) {
                    route.children = filterAsyncRouter(route.children, roles);
                }
            }
            return true;
        }
        return false;
    });

    return accessedRouters;
}

var permission = {
    state: {
        routers: _index.constantRouterMap,
        addRouters: [],
        routerStatus: false
    },
    mutations: {
        SET_ROUTERS: function SET_ROUTERS(state, routers) {
            state.addRouters = routers;
            state.routers = _index.constantRouterMap.concat(routers);
        },
        SET_ROUTER_STATUS: function SET_ROUTER_STATUS(state, status) {
            state.routerStatus = status;
        }
    },
    actions: {
        GenerateRoutes: function GenerateRoutes(_ref, data) {
            var commit = _ref.commit;

            return new _promise2.default(function (resolve) {
                var roles = data.roles;
                // 判断权限

                var accessedRouters = filterAsyncRouter(_index.registerComponentMap, roles);
                // 提交action
                commit('SET_ROUTERS', accessedRouters);
                commit('SET_ROUTER_STATUS', true);
                resolve();
            });
        },
        ResetRouterStatus: function ResetRouterStatus(_ref2, data) {
            var commit = _ref2.commit;

            return new _promise2.default(function (resolve) {
                commit('SET_ROUTERS', []);
                commit('SET_ROUTER_STATUS', data);
                resolve();
            });
        }
    }
};

exports.default = permission;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(61);

var _promise2 = _interopRequireDefault(_promise);

var _login = __webpack_require__(261);

var _auth = __webpack_require__(46);

var _account = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var user = {
  state: {
    token: (0, _auth.getToken)(),
    name: "",
    avatar: "",
    userInfo: {},
    roles: [],
    fileToken: ""
  },

  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_FILE_TOKEN: function SET_FILE_TOKEN(state, fileToken) {
      state.fileToken = fileToken;
    }
  },

  actions: {
    // 登录
    Login: function Login(_ref, params) {
      var commit = _ref.commit;

      // console.warn(' Login({ commit }, params)');
      var account = params.account.trim();
      var pwd = params.pwd;
      return new _promise2.default(function (resolve, reject) {
        var param = {
          account: account,
          pwd: pwd,
          //   outIp: returnCitySN["cip"],
          innerIp: "127.0.0.1",
          imgCode: params.imgCode
        };
        (0, _login.login)(param).then(function (response) {
          // reject(error);
          // const token = response.token;
          // const user= response.userInfo;
          // const userInfo = {
          //     userName:user.organization,
          //     picUrl:user.picUrl,
          //     userId:user.id,
          //     orgId:response.organizationId,
          //     phone:user.phone,
          // };
          var token = response.token,
              userInfo = response.userInfo,
              isChangePassword = response.isChangePassword;

          console.debug("userInfo: ", userInfo, response);
          if (userInfo) {
            // userInfo.userMainnot = userInfo.isZfp
            (0, _auth.setToken)(token);
            commit("SET_TOKEN", token);
            commit("SET_USER_INFO", userInfo);
            commit("SET_NAME", userInfo.userName);
            commit("SET_AVATAR", userInfo.picUrl);
            resolve(isChangePassword);
          } else {
            reject("error");
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 获取用户信息
    getUserRuleList: function getUserRuleList(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;

      return new _promise2.default(function (resolve, reject) {
        try {
          (0, _login.getUserRuleList)({ token: (0, _auth.getToken)() }).then(function (response) {
            // const getMenuModules = response.getMenuModules;
            // const userInfo = {
            //     userName:response.organization,
            //     userMainnot:response.isZfp,
            //     picUrl:response.userHeadUrl,
            //     userId:response.userId,
            //     phone:response.phone,
            //     orgId:response.organizationId,
            // };
            var userInfo = response.userInfo,
                getMenuModules = response.menus;

            var superType = 0;
            console.debug("getMenuModules: ", getMenuModules);
            for (var i = 0; i < getMenuModules.length; i++) {
              if (getMenuModules[i].url == "prassType") {
                userInfo.userTp = 0;
                superType++;
              } else if (getMenuModules[i].url == "companyType") {
                userInfo.userTp = 1;
                superType++;
              } else if (getMenuModules[i].url == "provinceType") {
                userInfo.userTp = 2;
                superType++;
              } else if (getMenuModules[i].url == "centralType") {
                userInfo.userTp = 3;
                superType++;
              }
            }

            /*if(superType > 2){
                           userInfo.userTp = 'empty';
                      }else if(superType == 2){
                           userInfo.userTp = 4;
                      }*/

            commit("SET_TOKEN", (0, _auth.getToken)());
            commit("SET_ROLES", getMenuModules);
            commit("SET_NAME", userInfo.userName);
            commit("SET_USER_INFO", userInfo);
            commit("SET_AVATAR", userInfo.picUrl);
            resolve(response);
          }).catch(function (error) {
            reject("error");
          });
        } catch (e) {
          reject("error");
        }
      });
    },
    fileTokenStore: function fileTokenStore(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new _promise2.default(function (resolve, reject) {
        (0, _account.getFileToken)().then(function (response) {
          console.debug("getFileToken: ", response);
          commit("SET_FILE_TOKEN", response.resultStatus.token);
          resolve(response);
        }).catch(function (error) {
          reject("error");
        });
      });
    },


    // 登出
    LogOut: function LogOut(_ref4) {
      var commit = _ref4.commit,
          state = _ref4.state;

      return new _promise2.default(function (resolve, reject) {
        (0, _login.logout)(state.token).then(function () {
          commit("SET_TOKEN", "");
          commit("SET_ROLES", []);
          (0, _auth.removeToken)();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 前端 登出
    FedLogOut: function FedLogOut(_ref5) {
      var commit = _ref5.commit;

      return new _promise2.default(function (resolve) {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        (0, _auth.removeToken)();
        resolve();
      });
    }
  }
};

exports.default = user;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uuid = uuid;
function uuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWscnEmail = isWscnEmail;
exports.validateURL = validateURL;
exports.validateLowerCase = validateLowerCase;
exports.validateUpperCase = validateUpperCase;
exports.validatAlphabets = validatAlphabets;
/**
 * Created by jiachenpan on 16/11/18.
 */

/* 是否是公司邮箱*/
function isWscnEmail(str) {
    var reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@wallstreetcn\.com$/i;
    return reg.test(str.trim());
}

/* 合法uri*/
function validateURL(textval) {
    var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(textval);
}

/* 小写字母*/
function validateLowerCase(str) {
    var reg = /^[a-z]+$/;
    return reg.test(str);
}

/* 大写字母*/
function validateUpperCase(str) {
    var reg = /^[A-Z]+$/;
    return reg.test(str);
}

/* 大小写字母*/
function validatAlphabets(str) {
    var reg = /^[A-Za-z]+$/;
    return reg.test(str);
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(636);

Object.defineProperty(exports, 'Navbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Navbar).default;
  }
});

var _Sidebar = __webpack_require__(637);

Object.defineProperty(exports, 'Sidebar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sidebar).default;
  }
});

var _Levelbar = __webpack_require__(345);

Object.defineProperty(exports, 'Levelbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Levelbar).default;
  }
});

var _AppMain = __webpack_require__(634);

Object.defineProperty(exports, 'AppMain', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppMain).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */,
/* 1530 */,
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 491,
	"./af.js": 491,
	"./ar": 498,
	"./ar-dz": 492,
	"./ar-dz.js": 492,
	"./ar-kw": 493,
	"./ar-kw.js": 493,
	"./ar-ly": 494,
	"./ar-ly.js": 494,
	"./ar-ma": 495,
	"./ar-ma.js": 495,
	"./ar-sa": 496,
	"./ar-sa.js": 496,
	"./ar-tn": 497,
	"./ar-tn.js": 497,
	"./ar.js": 498,
	"./az": 499,
	"./az.js": 499,
	"./be": 500,
	"./be.js": 500,
	"./bg": 501,
	"./bg.js": 501,
	"./bm": 502,
	"./bm.js": 502,
	"./bn": 504,
	"./bn-bd": 503,
	"./bn-bd.js": 503,
	"./bn.js": 504,
	"./bo": 505,
	"./bo.js": 505,
	"./br": 506,
	"./br.js": 506,
	"./bs": 507,
	"./bs.js": 507,
	"./ca": 508,
	"./ca.js": 508,
	"./cs": 509,
	"./cs.js": 509,
	"./cv": 510,
	"./cv.js": 510,
	"./cy": 511,
	"./cy.js": 511,
	"./da": 512,
	"./da.js": 512,
	"./de": 515,
	"./de-at": 513,
	"./de-at.js": 513,
	"./de-ch": 514,
	"./de-ch.js": 514,
	"./de.js": 515,
	"./dv": 516,
	"./dv.js": 516,
	"./el": 517,
	"./el.js": 517,
	"./en-au": 518,
	"./en-au.js": 518,
	"./en-ca": 519,
	"./en-ca.js": 519,
	"./en-gb": 520,
	"./en-gb.js": 520,
	"./en-ie": 521,
	"./en-ie.js": 521,
	"./en-il": 522,
	"./en-il.js": 522,
	"./en-in": 523,
	"./en-in.js": 523,
	"./en-nz": 524,
	"./en-nz.js": 524,
	"./en-sg": 525,
	"./en-sg.js": 525,
	"./eo": 526,
	"./eo.js": 526,
	"./es": 530,
	"./es-do": 527,
	"./es-do.js": 527,
	"./es-mx": 528,
	"./es-mx.js": 528,
	"./es-us": 529,
	"./es-us.js": 529,
	"./es.js": 530,
	"./et": 531,
	"./et.js": 531,
	"./eu": 532,
	"./eu.js": 532,
	"./fa": 533,
	"./fa.js": 533,
	"./fi": 534,
	"./fi.js": 534,
	"./fil": 535,
	"./fil.js": 535,
	"./fo": 536,
	"./fo.js": 536,
	"./fr": 539,
	"./fr-ca": 537,
	"./fr-ca.js": 537,
	"./fr-ch": 538,
	"./fr-ch.js": 538,
	"./fr.js": 539,
	"./fy": 540,
	"./fy.js": 540,
	"./ga": 541,
	"./ga.js": 541,
	"./gd": 542,
	"./gd.js": 542,
	"./gl": 543,
	"./gl.js": 543,
	"./gom-deva": 544,
	"./gom-deva.js": 544,
	"./gom-latn": 545,
	"./gom-latn.js": 545,
	"./gu": 546,
	"./gu.js": 546,
	"./he": 547,
	"./he.js": 547,
	"./hi": 548,
	"./hi.js": 548,
	"./hr": 549,
	"./hr.js": 549,
	"./hu": 550,
	"./hu.js": 550,
	"./hy-am": 551,
	"./hy-am.js": 551,
	"./id": 552,
	"./id.js": 552,
	"./is": 553,
	"./is.js": 553,
	"./it": 555,
	"./it-ch": 554,
	"./it-ch.js": 554,
	"./it.js": 555,
	"./ja": 556,
	"./ja.js": 556,
	"./jv": 557,
	"./jv.js": 557,
	"./ka": 558,
	"./ka.js": 558,
	"./kk": 559,
	"./kk.js": 559,
	"./km": 560,
	"./km.js": 560,
	"./kn": 561,
	"./kn.js": 561,
	"./ko": 562,
	"./ko.js": 562,
	"./ku": 563,
	"./ku.js": 563,
	"./ky": 564,
	"./ky.js": 564,
	"./lb": 565,
	"./lb.js": 565,
	"./lo": 566,
	"./lo.js": 566,
	"./lt": 567,
	"./lt.js": 567,
	"./lv": 568,
	"./lv.js": 568,
	"./me": 569,
	"./me.js": 569,
	"./mi": 570,
	"./mi.js": 570,
	"./mk": 571,
	"./mk.js": 571,
	"./ml": 572,
	"./ml.js": 572,
	"./mn": 573,
	"./mn.js": 573,
	"./mr": 574,
	"./mr.js": 574,
	"./ms": 576,
	"./ms-my": 575,
	"./ms-my.js": 575,
	"./ms.js": 576,
	"./mt": 577,
	"./mt.js": 577,
	"./my": 578,
	"./my.js": 578,
	"./nb": 579,
	"./nb.js": 579,
	"./ne": 580,
	"./ne.js": 580,
	"./nl": 582,
	"./nl-be": 581,
	"./nl-be.js": 581,
	"./nl.js": 582,
	"./nn": 583,
	"./nn.js": 583,
	"./oc-lnc": 584,
	"./oc-lnc.js": 584,
	"./pa-in": 585,
	"./pa-in.js": 585,
	"./pl": 586,
	"./pl.js": 586,
	"./pt": 588,
	"./pt-br": 587,
	"./pt-br.js": 587,
	"./pt.js": 588,
	"./ro": 589,
	"./ro.js": 589,
	"./ru": 590,
	"./ru.js": 590,
	"./sd": 591,
	"./sd.js": 591,
	"./se": 592,
	"./se.js": 592,
	"./si": 593,
	"./si.js": 593,
	"./sk": 594,
	"./sk.js": 594,
	"./sl": 595,
	"./sl.js": 595,
	"./sq": 596,
	"./sq.js": 596,
	"./sr": 598,
	"./sr-cyrl": 597,
	"./sr-cyrl.js": 597,
	"./sr.js": 598,
	"./ss": 599,
	"./ss.js": 599,
	"./sv": 600,
	"./sv.js": 600,
	"./sw": 601,
	"./sw.js": 601,
	"./ta": 602,
	"./ta.js": 602,
	"./te": 603,
	"./te.js": 603,
	"./tet": 604,
	"./tet.js": 604,
	"./tg": 605,
	"./tg.js": 605,
	"./th": 606,
	"./th.js": 606,
	"./tk": 607,
	"./tk.js": 607,
	"./tl-ph": 608,
	"./tl-ph.js": 608,
	"./tlh": 609,
	"./tlh.js": 609,
	"./tr": 610,
	"./tr.js": 610,
	"./tzl": 611,
	"./tzl.js": 611,
	"./tzm": 613,
	"./tzm-latn": 612,
	"./tzm-latn.js": 612,
	"./tzm.js": 613,
	"./ug-cn": 614,
	"./ug-cn.js": 614,
	"./uk": 615,
	"./uk.js": 615,
	"./ur": 616,
	"./ur.js": 616,
	"./uz": 618,
	"./uz-latn": 617,
	"./uz-latn.js": 617,
	"./uz.js": 618,
	"./vi": 619,
	"./vi.js": 619,
	"./x-pseudo": 620,
	"./x-pseudo.js": 620,
	"./yo": 621,
	"./yo.js": 621,
	"./zh-cn": 622,
	"./zh-cn.js": 622,
	"./zh-hk": 623,
	"./zh-hk.js": 623,
	"./zh-mo": 624,
	"./zh-mo.js": 624,
	"./zh-tw": 625,
	"./zh-tw.js": 625
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1531;

/***/ }),
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/404.a57b6f3.png";

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDNDREM0FEQkU1ODExRUU4RjM5REJFREYyNjc1MjkxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDNDREM0FFQkU1ODExRUU4RjM5REJFREYyNjc1MjkxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0M0NEQzQUJCRTU4MTFFRThGMzlEQkVERjI2NzUyOTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0M0NEQzQUNCRTU4MTFFRThGMzlEQkVERjI2NzUyOTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6gvZy8AAAABlBMVEX///////9VfPVsAAAAAnRSTlP/AOW3MEoAAADcSURBVHja5JZLFoMwDAOl+1+67QaINUph2dcsQyb4Iwvkx0v/iOi9niHSwegJ8QU54pgEIjoXEIloXUkEokQGMRDdIFZkPV0Ii4BS3UAyGCZOBEokr5cMJPPNGiDSqmbo/lVCQIAskwiVXN6IyOXMetWBxEsWYjKauY2oIB1GsLqBgMxMz7aI7VuBmfqRiFsHsJaOSYUOjn2xwsCKRvep51AGhZKZaEr+bKYkS7g45wio2kUf62YX1T2rXbSRBofZuEXxMW3sovjYxi4iPcWn0N6d/9dfhR9AXgIMAPOvBmd/Fp33AAAAAElFTkSuQmCC"

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjREQUQ1MDdCRjBDMTFFRUIzMDdCRjU3MEM4Nzk1QkQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjREQUQ1MDZCRjBDMTFFRUIzMDdCRjU3MEM4Nzk1QkQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0M0NEQzQURCRTU4MTFFRThGMzlEQkVERjI2NzUyOTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0M0NEQzQUVCRTU4MTFFRThGMzlEQkVERjI2NzUyOTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5xCLj8AAAABlBMVEWvr6////+q7D3yAAAAAnRSTlP/AOW3MEoAAADcSURBVHja5JZLFoMwDAOl+1+67QaINUph2dcsQyb4Iwvkx0v/iOi9niHSwegJ8QU54pgEIjoXEIloXUkEokQGMRDdIFZkPV0Ii4BS3UAyGCZOBEokr5cMJPPNGiDSqmbo/lVCQIAskwiVXN6IyOXMetWBxEsWYjKauY2oIB1GsLqBgMxMz7aI7VuBmfqRiFsHsJaOSYUOjn2xwsCKRvep51AGhZKZaEr+bKYkS7g45wio2kUf62YX1T2rXbSRBofZuEXxMW3sovjYxi4iPcWn0N6d/9dfhR9AXgIMAPOvBmd/Fp33AAAAAElFTkSuQmCC"

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc2OUUyMjEyQkU1ODExRUVBMzc3REQ3MEU0QjY0REM2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc2OUUyMjEzQkU1ODExRUVBMzc3REQ3MEU0QjY0REM2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzY5RTIyMTBCRTU4MTFFRUEzNzdERDcwRTRCNjREQzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzY5RTIyMTFCRTU4MTFFRUEzNzdERDcwRTRCNjREQzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4nmdA2AAAABlBMVEX///////9VfPVsAAAAAnRSTlP/AOW3MEoAAACvSURBVHja7NVBDsMgDETR8f0v3VWrwMyPIalUVQqrgPMUAsaotpse8huiY1sg8nZOlNsJkRaMSHg3kBz3QXnw0LHxgSi9NXYnAsK+aSQt2xx+ExZuBAKeP4SmUB1xkSOa/y1t5cjvkGpJfYHsTayukq1FZsNbWZC1cICq6EhR+k/nBZJfIfnZ8BEj4yJVGPCxjqUCFAqVloollb5LBZZQd790d0V7JT2X+N+QlwADAC4ABqqwfqvvAAAAAElFTkSuQmCC"

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QkMxQjIwQTVCRjBDMTFFRUEwQUREMzJDRTQ3Rjc1REMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QkMxQjIwQTRCRjBDMTFFRUEwQUREMzJDRTQ3Rjc1REMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzY5RTIyMTJCRTU4MTFFRUEzNzdERDcwRTRCNjREQzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzY5RTIyMTNCRTU4MTFFRUEzNzdERDcwRTRCNjREQzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7Y/P63AAAABlBMVEWvr6////+q7D3yAAAAAnRSTlP/AOW3MEoAAACvSURBVHja7NVBDsMgDETR8f0v3VWrwMyPIalUVQqrgPMUAsaotpse8huiY1sg8nZOlNsJkRaMSHg3kBz3QXnw0LHxgSi9NXYnAsK+aSQt2xx+ExZuBAKeP4SmUB1xkSOa/y1t5cjvkGpJfYHsTayukq1FZsNbWZC1cICq6EhR+k/nBZJfIfnZ8BEj4yJVGPCxjqUCFAqVloollb5LBZZQd790d0V7JT2X+N+QlwADAC4ABqqwfqvvAAAAAElFTkSuQmCC"

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0ODczMzMxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwNDIyIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NCA0NDggMzIwIDQ0OCAzMjAgOTYwIDY0IDk2MCA2NCA0NDggNjQgNDQ4Wk03MDQgMjU2IDk2MCAyNTYgOTYwIDk2MCA3MDQgOTYwIDcwNCAyNTYgNzA0IDI1NlpNMzg0IDY0IDY0MCA2NCA2NDAgOTYwIDM4NCA5NjAgMzg0IDY0IDM4NCA2NFoiIHAtaWQ9IjEwNDIzIj48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA2NDE5ODYwNTM4IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQ2NjIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTQzOC44NTcxNDMgOTUwLjg1NzE0M2w1MTIgMCAwLTM2NS43MTQyODYtMjM3LjcxNDI4NiAwcS0yMi44MjA1NzEgMC0zOC44Mzg4NTctMTYuMDE4Mjg2dC0xNi4wMTgyODYtMzguODM4ODU3bDAtMjM3LjcxNDI4Ni0yMTkuNDI4NTcxIDAgMCA2NTguMjg1NzE0ek01ODUuMTQyODU3IDEyOGwwLTM2LjU3MTQyOXEwLTcuNDYwNTcxLTUuNDEyNTcxLTEyLjg3MzE0M3QtMTIuODczMTQzLTUuNDEyNTcxbC00MDIuMjg1NzE0IDBxLTcuNDYwNTcxIDAtMTIuODczMTQzIDUuNDEyNTcxdC01LjQxMjU3MSAxMi44NzMxNDNsMCAzNi41NzE0MjlxMCA3LjQ2MDU3MSA1LjQxMjU3MSAxMi44NzMxNDN0MTIuODczMTQzIDUuNDEyNTcxbDQwMi4yODU3MTQgMHE3LjQ2MDU3MSAwIDEyLjg3MzE0My01LjQxMjU3MXQ1LjQxMjU3MS0xMi44NzMxNDN6TTczMS40Mjg1NzEgNTEybDE3MC44NjE3MTQgMC0xNzAuODYxNzE0LTE3MC44NjE3MTQgMCAxNzAuODYxNzE0ek0xMDI0IDU4NS4xNDI4NTdsMCAzODRxMCAyMi44MjA1NzEtMTYuMDE4Mjg2IDM4LjgzODg1N3QtMzguODM4ODU3IDE2LjAxODI4NmwtNTQ4LjU3MTQyOSAwcS0yMi44MjA1NzEgMC0zOC44Mzg4NTctMTYuMDE4Mjg2dC0xNi4wMTgyODYtMzguODM4ODU3bDAtOTEuNDI4NTcxLTMxMC44NTcxNDMgMHEtMjIuODIwNTcxIDAtMzguODM4ODU3LTE2LjAxODI4NnQtMTYuMDE4Mjg2LTM4LjgzODg1N2wwLTc2OHEwLTIyLjgyMDU3MSAxNi4wMTgyODYtMzguODM4ODU3dDM4LjgzODg1Ny0xNi4wMTgyODZsNjIxLjcxNDI4NiAwcTIyLjgyMDU3MSAwIDM4LjgzODg1NyAxNi4wMTgyODZ0MTYuMDE4Mjg2IDM4LjgzODg1N2wwIDE4Ny40NjUxNDNxMTEuOTk1NDI5IDcuNDYwNTcxIDIwLjU1MzE0MyAxNi4wMTgyODZsMjMzLjE3OTQyOSAyMzMuMTc5NDI5cTE2LjAxODI4NiAxNi4wMTgyODYgMjcuNDI4NTcxIDQzLjQ0Njg1N3QxMS40MTAyODYgNTAuMzIyMjg2eiIgcC1pZD0iNDY2MyI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA2MzI5OTE2NzY1IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE2NjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTY0IDY0IDQ0OCA2NCA0NDggNDQ4IDY0IDQ0OCA2NCA2NFpNNjQgNTc2IDQ0OCA1NzYgNDQ4IDk2MCA2NCA5NjAgNjQgNTc2Wk01NzYgNTc2IDk2MCA1NzYgOTYwIDk2MCA1NzYgOTYwIDU3NiA1NzZaTTc2OCA0NDhDODc0LjAzODY2OSA0NDggOTYwIDM2Mi4wMzg2NzIgOTYwIDI1NiA5NjAgMTQ5Ljk2MTMyOCA4NzQuMDM4NjY5IDY0IDc2OCA2NCA2NjEuOTYxMzI4IDY0IDU3NiAxNDkuOTYxMzI4IDU3NiAyNTYgNTc2IDM2Mi4wMzg2NzIgNjYxLjk2MTMyOCA0NDggNzY4IDQ0OFoiIHAtaWQ9IjE2NjIiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0MTkwNzU3IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjkwMDciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTU3NC45NTc4OTEgMjY3LjAxNjQwMyA1MTEuNTAzNjk2IDI2Ny4wMTY0MDNsMjA0LjY0ODk2IDBMNTExLjIxMjA1NCA2My42NTQ3NjJsLTIwMy4zNjE2NDEgMjAzLjM2MTY0MUw0NDkuMDQxMDg2IDI2Ny4wMTY0MDNsMCAxODkuNjYyNjQxTDI1OC42ODc3MTQgNDU2LjY3OTA0NGwwIDEyNS45MTY4MDRMNDQ5LjA0MTA4NiA1ODIuNTk1ODQ4bDAgMTkwLjM1NDM5NiAxMjUuOTE2ODA0IDBMNTc0Ljk1Nzg5MSA1ODIuNTk1ODQ4bDE4OC44NzQ2OTUgMEw3NjMuODMyNTg2IDQ1Ni42NzkwNDQgNTc0Ljk1Nzg5MSA0NTYuNjc5MDQ0IDU3NC45NTc4OTEgMjY3LjAxNjQwM3pNNTExLjI1NDAxIDk2MC4zNDUyMzhsMTg5LjYyMDY4NS0xODcuMzk0OTk0TDMyMy4xMjUzMDUgNzcyLjk1MDI0NCA1MTEuMjU0MDEgOTYwLjM0NTIzOHpNNzEuMjkxNjk2IDUxOC44OTE5NjdsMTg3LjM5NDk5NCAxODkuNjIwNjg1TDI1OC42ODY2OSAzMzAuNzYyMjM5IDcxLjI5MTY5NiA1MTguODkxOTY3ek03NjMuODMyNTg2IDMzMC43NjIyMzlsMCAzNzcuNzQ5MzkgMTg4Ljg3NDY5NS0xODkuNjIwNjg1TDc2My44MzI1ODYgMzMwLjc2MjIzOXoiIHAtaWQ9IjkwMDgiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0MjEwOTY3IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjkxMjAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTUxMyA1ODMuOGw0NDguNS00NDguNWMtMTEuNi00LjctMjQuMy03LjMtMzcuNS03LjNMMTAwIDEyOGMtMTIuNyAwLTI0LjkgMi40LTM2LjEgNi43TDUxMyA1ODMuOHoiIHAtaWQ9IjkxMjEiPjwvcGF0aD48cGF0aCBkPSJNNTEzIDY3NC4zIDE0LjYgMTc1LjlDNS4zIDE5MS4xIDAgMjA4LjkgMCAyMjhsMCA1NjhjMCA1NS4yIDQ0LjggMTAwIDEwMCAxMDBsODI0IDBjNTUuMiAwIDEwMC00NC44IDEwMC0xMDBsMC01NjhjMC0xOC41LTUuMS0zNS45LTEzLjktNTAuOEw1MTMgNjc0LjN6IiBwLWlkPSI5MTIyIj48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0ODExNTgzIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijk4NzgiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTc3MC41NiA0NjAuOGwyNTAuODggMEM5OTguNCAyMjAuMTYgODAzLjg0IDI1LjYgNTYzLjIgMi41NmwwIDI1MC44OEM2NjguMTYgMjczLjkyIDc1MC4wOCAzNTUuODQgNzcwLjU2IDQ2MC44TDc3MC41NiA0NjAuOHpNNzcwLjU2IDQ2MC44IiBwLWlkPSI5ODc5Ij48L3BhdGg+PHBhdGggZD0iTTQ2MC44IDI1My40NCA0NjAuOCAyLjU2QzIyMC4xNiAyNS42IDI1LjYgMjIwLjE2IDIuNTYgNDYwLjhsMjUwLjg4IDBDMjczLjkyIDM1NS44NCAzNTUuODQgMjczLjkyIDQ2MC44IDI1My40NEw0NjAuOCAyNTMuNDR6TTQ2MC44IDI1My40NCIgcC1pZD0iOTg4MCI+PC9wYXRoPjxwYXRoIGQ9Ik01NjMuMiA3NzAuNTZsMCAyNTAuODhjMjQzLjItMjMuMDQgNDM1LjItMjE3LjYgNDYwLjgtNDYwLjhsLTI1MC44OCAwQzc1MC4wOCA2NjguMTYgNjY4LjE2IDc1MC4wOCA1NjMuMiA3NzAuNTZMNTYzLjIgNzcwLjU2ek01NjMuMiA3NzAuNTYiIHAtaWQ9Ijk4ODEiPjwvcGF0aD48cGF0aCBkPSJNMjUzLjQ0IDU2My4yIDIuNTYgNTYzLjJjMjMuMDQgMjQzLjIgMjE3LjYgNDM1LjIgNDYwLjggNDYwLjhsMC0yNTAuODhDMzU1Ljg0IDc1MC4wOCAyNzMuOTIgNjY4LjE2IDI1My40NCA1NjMuMkwyNTMuNDQgNTYzLjJ6TTI1My40NCA1NjMuMiIgcC1pZD0iOTg4MiI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0ODQyMjcyIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEwMDk3IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02MjUuNjY0IDEzMi42MDhWMTk5LjY4aDMwOS43NnY0My4wMDhoLTMwOS43NlYzMTIuMzJoMzA5Ljc2djQzLjAwOGgtMzA5Ljc2djY4LjYwOGgzMDkuNzZ2NDMuMDA4aC0zMDkuNzZ2NjguNjA4aDMwOS43NnY0My4wMDhoLTMwOS43NnY2OC42MDhoMzA5Ljc2djQzLjAwOGgtMzA5Ljc2djY4LjA5NmgzMDkuNzZ2NDMuMDA4aC0zMDkuNzZ2ODkuMDg4SDEwMjR2LTc1Ny43NmgtMzk4LjMzNnpNMCA5MTQuOTQ0TDU3Ny4wMjQgMTAyNFYwTDAgMTA5LjA1NiIgcC1pZD0iMTAwOTgiPjwvcGF0aD48cGF0aCBkPSJNMjI5LjM3NiA2NjAuNDhIMTM5Ljc3NmwxMTguMjcyLTE4Ny45MDQtMTEyLjY0LTE4MC43MzZoOTIuMTZsNjUuNTM2IDExOS44MDhMMzcwLjY4OCAyOTEuODRoODkuMDg4bC0xMTIuNjQgMTc3LjY2NEw0NjYuOTQ0IDY2MC40OEgzNzMuMjQ4bC03MC4xNDQtMTI1LjQ0TDIyOS4zNzYgNjYwLjQ4eiIgcC1pZD0iMTAwOTkiPjwvcGF0aD48L3N2Zz4="

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA0MDAwMTc4NDI0IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjE0NzY0IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik04NzEuNDI0IDYxLjQ0cTE4LjQzMiAwIDM0LjgxNiA2LjY1NnQyOC42NzIgMTguOTQ0IDE5LjQ1NiAyOC42NzIgNy4xNjggMzUuODRsMCA3MjAuODk2cTAgMzguOTEyLTI1LjA4OCA2NC41MTJ0LTYyLjk3NiAyNS42bC03MjEuOTIgMHEtNDAuOTYgMC02Ni4wNDgtMjYuNjI0dC0yNS4wODgtNjYuNTZsMC03MTguODQ4cTAtMzUuODQgMjQuNTc2LTYyLjQ2NHQ2NS41MzYtMjYuNjI0bDcyMC44OTYgMHpNNjMzLjg1NiA4MjkuNDRxMTguNDMyIDAgMjYuNjI0LTguNzA0dDguMTkyLTIzLjA0cTAtMTMuMzEyLTguMTkyLTIyLjUyOHQtMjYuNjI0LTkuMjE2bC02Mi40NjQgMHExLjAyNC0yLjA0OCAxLjAyNC02LjE0NGwwLTUwNy45MDQgNjMuNDg4IDBxMTguNDMyIDAgMjUuNi05LjIxNnQ3LjE2OC0yMi41MjgtNy4xNjgtMjIuNTI4LTI1LjYtOS4yMTZsLTI0OS44NTYgMHEtMTguNDMyIDAtMjUuNiA5LjIxNnQtNy4xNjggMjIuNTI4IDcuMTY4IDIyLjUyOCAyNS42IDkuMjE2bDU3LjM0NCAwIDAgNTA3LjkwNHEwIDIuMDQ4IDAuNTEyIDMuMDcydDAuNTEyIDMuMDcybC01Ni4zMiAwcS0xOC40MzIgMC0yNi42MjQgOS4yMTZ0LTguMTkyIDIyLjUyOHEwIDE0LjMzNiA4LjE5MiAyMy4wNHQyNi42MjQgOC43MDRsMjQ1Ljc2IDB6IiBwLWlkPSIxNDc2NSI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0Nzc2MDg0IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijk2NjIiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTgxOC4yNDY4OTMgNDEyLjMyNjkwNmwtNDUuOTg4NDA0IDAgMC03MC45OTE4NjhjMC0xNTIuMzA3ODcxLTEyMy40NjM5MzktMjc1Ljc3ODk3NC0yNzUuNzc4OTc0LTI3NS43Nzg5NzRzLTI3NS43ODEwMiAxMjMuNDcxMTAzLTI3NS43ODEwMiAyNzUuNzc4OTc0bDAgNzAuOTkxODY4LTQ1Ljk4NzM4MSAwYy0yNS4zNzkwMTcgMC00NS45ODg0MDQgMjAuNTY2NDA4LTQ1Ljk4ODQwNCA0NS45ODczODFsMCA0NTUuNDA3MDc0YzAgMjUuNDI4MTM2IDIwLjU2MDI2OCA0NS45ODg0MDQgNDUuOTg4NDA0IDQ1Ljk4ODQwNGw2NDMuNTM1Nzc5IDBjMjUuMzc2OTcgMCA0NS45ODg0MDQtMjAuNTYwMjY4IDQ1Ljk4ODQwNC00NS45ODg0MDRMODY0LjIzNTI5NiA0NTguMzE0Mjg3Qzg2NC4xOTAyNzEgNDMyLjg5MzMxNCA4NDMuNjIzODYzIDQxMi4zMjY5MDYgODE4LjI0Njg5MyA0MTIuMzI2OTA2TDgxOC4yNDY4OTMgNDEyLjMyNjkwNnpNNjgwLjMzMTgyMyA0MTIuMzI2OTA2IDMxMi42MjUxNiA0MTIuMzI2OTA2bDAtNzAuOTkxODY4YzAtMTAxLjU1MzkzIDgyLjM0NDQyNi0xODMuODUzMzMxIDE4My44NTQzNTUtMTgzLjg1MzMzMSAxMDEuNTA5OTI4IDAgMTgzLjg1MzMzMSA4Mi4zNDM0MDMgMTgzLjg1MzMzMSAxODMuODUzMzMxTDY4MC4zMzI4NDYgNDEyLjMyNjkwNiA2ODAuMzMxODIzIDQxMi4zMjY5MDZ6TTY4MC4zMzE4MjMgNDEyLjMyNjkwNiIgcC1pZD0iOTY2MyI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0Njc4NzI5IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjkyMjkiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTc4MC44IDM1NC41Nzk2OTIgNjY1LjYgMzU0LjU3OTY5MiA2NjUuNiAzMTEuNjg5ODQ2YzAtNzIuMzEwMTU0LTE5Ljg0OTg0Ni0xOTMuMjk5NjkyLTE1My42LTE5My4yOTk2OTItMTM4Ljg3MDE1NCAwLTE1My42IDEzNS4wNDk4NDYtMTUzLjYgMTkzLjI5OTY5MmwwIDQyLjg4OTg0NkwyNDMuMiAzNTQuNTc5NjkyIDI0My4yIDMxMS42ODk4NDZDMjQzLjIgMTIyLjI0OTg0NiAzNDguNzkwMTU0IDAgNTEyIDBzMjY4LjggMTIyLjI0OTg0NiAyNjguOCAzMTEuNjg5ODQ2TDc4MC44IDM1NC41Nzk2OTJ6TTU4OC44IDY2OS40MjAzMDhDNTg4LjggNjI1LjkwMDMwOCA1NTQuMjIwMzA4IDU5MC43NjkyMzEgNTEyIDU5MC43NjkyMzFzLTc2LjggMzUuMTMxMDc3LTc2LjggNzguNjUxMDc3YzAgMjkuNDU5NjkyIDE1LjM5OTM4NSA1NC40Njg5MjMgMzguNDM5Mzg1IDY3LjgyMDMwOGwwIDg5LjYzOTM4NWMwIDIxLjc0MDMwOCAxNy4yNTA0NjIgMzkuNjk5NjkyIDM4LjQgMzkuNjk5NjkyczM4LjQtMTcuOTU5Mzg1IDM4LjQtMzkuNjk5NjkybDAtODkuNjM5Mzg1QzU3My40NCA3MjMuODg5MjMxIDU4OC44IDY5OC44OCA1ODguOCA2NjkuNDIwMzA4ek04OTYgNTEybDAgMzkzLjYwOTg0NmMwIDY1LjI2MDMwOC01MS44Njk1MzggMTE4LjM5MDE1NC0xMTUuMiAxMTguMzkwMTU0TDI0My4yIDEwMjRjLTYzLjI5MTA3NyAwLTExNS4yLTUzLjEyOTg0Ni0xMTUuMi0xMTguMzkwMTU0TDEyOCA1MTJjMC02NS4yMjA5MjMgNTEuODY5NTM4LTExOC4zOTAxNTQgMTE1LjItMTE4LjM5MDE1NGw1MzcuNiAwQzg0NC4xMzA0NjIgMzkzLjYwOTg0NiA4OTYgNDQ2Ljc3OTA3NyA4OTYgNTEyeiIgcC1pZD0iOTIzMCI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0Nzk3NDcxIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijk3NzAiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTU2NS4yNzI4MjcgMzQuNjI3Mjg1bDExMi4wOTU4NzIgMjM3LjU0MjI4OGM4LjcwNjYzNyAxOC4zMjEwMjIgMjUuNDExNDI0IDMxLjA1MTY0MSA0NC44MjI4NSAzMy45OTYyODlsMjUwLjc3NjU5OCAzOC4wODExNTdjNDguNjk3Mzg3IDcuNDExNDM1IDY4LjIyNTA1IDcwLjA0NjA4MiAzMi45MzM1NTkgMTA1Ljk3OTYzOWwtMTgxLjQ5NDM1MyAxODQuOTM3MTU1Yy0xMy45OTgxNDcgMTQuMjMwNjE4LTIwLjM1MjM4NiAzNC44MTU0NzctMTcuMDU5MDMgNTQuOTM1MzlsNDIuODE5MTYxIDI2MS4xMjcxNDVjOC4zNDY4NTggNTAuNjk1NTQxLTQyLjY0MjA0IDg5LjQ1MTk3NC04Ni4yMjUwMzkgNjUuNTE4NDFsLTIyNC4zMDc5NzktMTIzLjI3MTE0MWMtMTcuMjg1OTY4LTkuNTI1ODI0LTM3Ljk5MjU5Ni05LjUyNTgyNC01NS4yNzg1NjQgMGwtMjI0LjMxMzUxNCAxMjMuMjcxMTQxYy00My41ODI5OTkgMjMuOTMzNTY1LTk0LjU3MTg5Ny0xNC44MjI4NjktODYuMjE5NTA0LTY1LjUxODQxbDQyLjgxMzYyNi0yNjEuMTI3MTQ1YzMuMzIxMDMxLTIwLjExOTkxNC0zLjA4ODU1OS00MC43MDQ3NzItMTcuMDg2NzA2LTU0LjkzNTM5bC0xODEuNDM5MDAyLTE4NC45MzcxNTVjLTM1LjI4NTk1Ni0zNS45MzM1NTctMTUuODE5MTc5LTk4LjU3Mzc0IDMyLjkzMzU1OS0xMDUuOTc5NjM5bDI1MC43NDg5MjMtMzguMDgxMTU3YzE5LjM1MDU0MS0yLjkzOTExMiAzNi4wODMwMDMtMTUuNjc1MjY3IDQ0Ljc1NjQzLTMzLjk5NjI4OWwxMTIuMTIzNTQ3LTIzNy41NDIyODhDNDgwLjQ5Nzk3Mi0xMS41NDA1ODMgNTQzLjUwOTAwMy0xMS41NDA1ODMgNTY1LjI3MjgyNyAzNC42MjcyODV6IiBwLWlkPSI5NzcxIj48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA2MzI5NzYxNTQ2IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjEzODQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTYyMi4yNzY5MjMgMzkuMzg0NjE1SDQwMS43MjMwNzdjLTEzLjc4NDYxNSAwLTIzLjYzMDc2OSAxMS44MTUzODUtMjMuNjMwNzY5IDI1LjZ2NDkuMjMwNzdjMCAxMy43ODQ2MTUgMTEuODE1Mzg1IDI1LjYgMjMuNjMwNzY5IDI1LjZoMjIwLjU1Mzg0NmMxMy43ODQ2MTUgMCAyMy42MzA3NjktMTEuODE1Mzg1IDIzLjYzMDc2OS0yNS42VjY0Ljk4NDYxNWMxLjk2OTIzMS0xMy43ODQ2MTUtOS44NDYxNTQtMjUuNi0yMy42MzA3NjktMjUuNnogbTMzNi43Mzg0NjIgMEg3MzguNDYxNTM4Yy0xMy43ODQ2MTUgMC0yNS42IDExLjgxNTM4NS0yNS42IDI1LjZ2NDkuMjMwNzdjMCAxMy43ODQ2MTUgMTEuODE1Mzg1IDI1LjYgMjUuNiAyNS42aDIyMC41NTM4NDdjMTMuNzg0NjE1LTEuOTY5MjMxIDI1LjYtMTEuODE1Mzg1IDI1LjYtMjUuNlY2NC45ODQ2MTVjMC0xMy43ODQ2MTUtMTEuODE1Mzg1LTI1LjYtMjUuNi0yNS42eiBtMCAxNjUuNDE1Mzg1SDMzNC43NjkyMzFjLTEzLjc4NDYxNSAwLTI1LjYtMTEuODE1Mzg1LTI1LjYtMjUuNlY2NC45ODQ2MTVjMC0xMy43ODQ2MTUtMTEuODE1Mzg1LTI1LjYtMjUuNi0yNS42SDY0Ljk4NDYxNUM1MS4yIDM5LjM4NDYxNSAzOS4zODQ2MTUgNTEuMiAzOS4zODQ2MTUgNjQuOTg0NjE1djg5NmMwIDExLjgxNTM4NSAxMS44MTUzODUgMjMuNjMwNzY5IDI1LjYgMjMuNjMwNzdoODk0LjAzMDc3YzEzLjc4NDYxNSAwIDI1LjYtMTEuODE1Mzg1IDI1LjYtMjUuNnYtNzI4LjYxNTM4NWMwLTEzLjc4NDYxNS0xMS44MTUzODUtMjUuNi0yNS42LTI1LjZ6IiBwLWlkPSIxMzg1Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0ODI5NjY3IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijk5ODkiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTc4OC4wMDAwMiAxNTkuODMxNDkxQzc1Ni4wMDAwMiAxMjggNzQ2IDEyOCA3MjQuMzgwMSAxMjhMNjQyIDEyOEM2NDIgMTI4IDU3NiAxODguOTIzMDc3IDUxMiAxODguOTIzMDc3IDQ0OCAxODguOTIzMDc3IDM4NCAxMjggMzg0IDEyOEwyOTkuMjA0ODAyIDEyOEMyNzYuNjI5OTM0IDEyOCAyNjYgMTQwLjkyMzA3NyAyNDUuODQ3MjE0IDE1OS44MzE0OTFMODEuNTgyOTc5IDMyMy44NzE3MzVDNzAuMjQzNzMyIDMzNS4xOTU1MiA1MiAzNzEuNjkyMzA4IDgxLjU4Mjk3OSA0MDguNjU1MDA0IDgxLjU4Mjk3OSA0MDguNjU1MDA0IDIyNC4wMjM2NjcgNTQwLjI5Nzg0IDIzOC4wMDAwMDMgNTQxLjUzODQ2TDIzOC4wMDAwMDMgODM1LjA3NjkyNEMyMzguMDAwMDAzIDg2OC40NTIzNTIgMjg2LjU3OSA4OTYgMzIwIDg5Nkw3MDYgODk2QzczOS40MTk4MDggODk2IDc4OC4wMDAwMiA4NjguNDUyMzUyIDc4OC4wMDAwMiA4MzUuMDc2OTI0TDc4OC4wMDAwMiA1NDEuNTM4NDZDODAyLjE0NTQ5MiA1NDAuMzg1ODY0IDk0Mi40NDg1NjQgNDA4LjY1NDk5MiA5NDIuNDQ4NTY0IDQwOC42NTQ5OTIgOTc0LjAwMDAyIDM3MiA5NjUuODUxMjY0IDMzNC44ODM4NzggOTQyLjQ0ODU4NCAzMTEuNTEzMTA5TDc4OC4wMDAwMiAxNTkuODMxNDkxWiIgcC1pZD0iOTk5MCI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0MTU1NzI2IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijg1NTQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTQ0LjUyMTczOSAwaDQ0LjUyMTczOXY5NzkuNDc4MjYxSDQ0LjUyMTczOXpNMjY3LjEzMDQzNSA1MzQuMjYwODdoNDQuNTIxNzM5djQ0NS4yMTczOTFIMjY3LjEzMDQzNXpNNDg5LjczOTEzIDMxMS42NTIxNzRoNDQuNTIxNzR2NjY3LjgyNjA4N2gtNDQuNTIxNzR6TTcxMi4zNDc4MjYgNzEyLjM0NzgyNmg0NC41MjE3Mzl2MjY3LjEzMDQzNWgtNDQuNTIxNzM5ek05MzQuOTU2NTIyIDQ0NS4yMTczOTFoNDQuNTIxNzM5djUzNC4yNjA4N2gtNDQuNTIxNzM5eiIgZmlsbD0iIiBwLWlkPSI4NTU1Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0MTc3ODk1IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijg4OTQiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTcxMi4zNDc4MjYgMGg0NC41MjE3Mzl2OTc5LjQ3ODI2MWgtNDQuNTIxNzM5ek0yNjcuMTMwNDM1IDUzNC4yNjA4N2g0NC41MjE3Mzl2NDQ1LjIxNzM5MUgyNjcuMTMwNDM1ek00ODkuNzM5MTMgMzExLjY1MjE3NGg0NC41MjE3NHY2NjcuODI2MDg3aC00NC41MjE3NHpNNDQuNTIxNzM5IDcxMi4zNDc4MjZoNDQuNTIxNzM5djI2Ny4xMzA0MzVINDQuNTIxNzM5ek05MzQuOTU2NTIyIDQ0NS4yMTczOTFoNDQuNTIxNzM5djUzNC4yNjA4N2gtNDQuNTIxNzM5eiIgZmlsbD0iIiBwLWlkPSI4ODk1Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTk0MTY2OTM3IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDExMzEgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijg3ODYiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNzAuNjg3NSIgaGVpZ2h0PSI2NCI+PGRlZnM+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMCAwaDUzLjg5NDczN3Y5NzAuMTA1MjYzSDB6TTI2OS40NzM2ODQgNDMxLjE1Nzg5NWg1My44OTQ3Mzd2NTM4Ljk0NzM2OEgyNjkuNDczNjg0ek01MzguOTQ3MzY4IDE2MS42ODQyMTFoNTMuODk0NzM3djgwOC40MjEwNTJoLTUzLjg5NDczN3pNODA4LjQyMTA1MyA2NDYuNzM2ODQyaDUzLjg5NDczNnYzMjMuMzY4NDIxaC01My44OTQ3MzZ6TTEwNzcuODk0NzM3IDMyMy4zNjg0MjFoNTMuODk0NzM3djY0Ni43MzY4NDJoLTUzLjg5NDczN3oiIGZpbGw9IiIgcC1pZD0iODc4NyI+PC9wYXRoPjwvc3ZnPg=="

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTAzOTkzODkxODgyIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijc5ODYiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTUwNC45NTEgNTExLjk4YzkzLjQ5IDAgMTY5LjI4LTc0LjAwMiAxNjkuMjgtMTY1LjI2IDAtOTEuMjc2LTc1Ljc5LTE2NS4yNDgtMTY5LjI4LTE2NS4yNDgtOTMuNDg2IDAtMTY5LjI4NyA3My45NzItMTY5LjI3OSAxNjUuMjQ4LTAuMDAxIDkxLjI1OCA3NS43OTMgMTY1LjI2IDE2OS4yOCAxNjUuMjZ6IG03Ny42IDU1LjA5OEg0NDEuNDY2Yy0xMjAuNzY3IDAtMjE4LjY3OCA5NS41NjQtMjE4LjY3OCAyMTMuNDVWNzk0LjNjMCA0OC4xODMgOTcuOTExIDQ4LjIyOSAyMTguNjc4IDQ4LjIyOUg1ODIuNTVjMTIwLjc1NCAwIDIxOC42Ni0xLjc4IDIxOC42Ni00OC4yMjl2LTEzLjc3YzAtMTE3Ljg4Ny05Ny44OTgtMjEzLjQ1LTIxOC42Ni0yMTMuNDV6IiBwLWlkPSI3OTg3Ij48L3BhdGg+PC9zdmc+"

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1445)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1729),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1441)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1725),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43d52178",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1497)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1780),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c507bd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1447)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1731),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49dd2087",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1788),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1522)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1803),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d39e6f1a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1524)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1805),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d71160f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1387)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00885a6b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1527)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1808),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fb95384e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1452)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1735),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e590ac3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1513)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bce7a17c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1491)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1406)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1693),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-209b92d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1520)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1801),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1404)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1691),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b99698c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1500)
  __webpack_require__(1501)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1783),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1490)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1773),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70e2a552",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1400)
  __webpack_require__(1401)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1688),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1505)
  __webpack_require__(1506)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1787),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1484)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1766),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6801d1b7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1475)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1757),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1476)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1758),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1437)
  __webpack_require__(1436)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1721),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d5dacef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1477)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1759),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1478)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1760),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1479)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1761),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1480)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1762),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1481)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1763),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1482)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1764),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1483)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1765),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1430)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1715),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1431)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1432)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1717),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1433)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1718),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1719),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1435)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1720),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1696),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1410)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1697),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(714),
  /* template */
  __webpack_require__(1771),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1411)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(715),
  /* template */
  __webpack_require__(1698),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1412)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(716),
  /* template */
  __webpack_require__(1699),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1414)
  __webpack_require__(1413)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(717),
  /* template */
  __webpack_require__(1700),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29b4ed0e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1428)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(718),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(720),
  /* template */
  __webpack_require__(1770),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1438)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(724),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(725),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1403)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(729),
  /* template */
  __webpack_require__(1690),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1509)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(733),
  /* template */
  __webpack_require__(1791),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1512)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(741),
  /* template */
  __webpack_require__(1793),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1486)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(742),
  /* template */
  __webpack_require__(1768),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1492)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(743),
  /* template */
  __webpack_require__(1775),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1397)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(744),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1525)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(745),
  /* template */
  __webpack_require__(1806),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7586c30",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1523)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(746),
  /* template */
  __webpack_require__(1804),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1418)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(747),
  /* template */
  __webpack_require__(1704),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(1796),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c1566cf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1449)
  __webpack_require__(1450)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(749),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1498)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(750),
  /* template */
  __webpack_require__(1781),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1405)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(751),
  /* template */
  __webpack_require__(1692),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(752),
  /* template */
  __webpack_require__(1684),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1390)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(753),
  /* template */
  __webpack_require__(1679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1462)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(754),
  /* template */
  __webpack_require__(1745),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1511)
  __webpack_require__(1510)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(755),
  /* template */
  __webpack_require__(1792),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af4f54dc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1461)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(756),
  /* template */
  __webpack_require__(1744),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1460)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(757),
  /* template */
  __webpack_require__(1743),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1459)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(758),
  /* template */
  __webpack_require__(1742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1458)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(759),
  /* template */
  __webpack_require__(1741),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1457)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(1740),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1456)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(761),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1455)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(762),
  /* template */
  __webpack_require__(1738),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1454)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(763),
  /* template */
  __webpack_require__(1737),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1424)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(764),
  /* template */
  __webpack_require__(1710),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1423)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1709),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1422)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1708),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1421)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(767),
  /* template */
  __webpack_require__(1707),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1420)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(768),
  /* template */
  __webpack_require__(1706),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1419)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(769),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1444)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(770),
  /* template */
  __webpack_require__(1728),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1453)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(771),
  /* template */
  __webpack_require__(1736),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1496)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(772),
  /* template */
  __webpack_require__(1779),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1466)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(773),
  /* template */
  __webpack_require__(1749),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1467)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(774),
  /* template */
  __webpack_require__(1750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1394)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(775),
  /* template */
  __webpack_require__(1682),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1468)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(776),
  /* template */
  __webpack_require__(1751),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1469)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(777),
  /* template */
  __webpack_require__(1752),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1471)
  __webpack_require__(1470)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(778),
  /* template */
  __webpack_require__(1753),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c9b3928",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1489)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(779),
  /* template */
  __webpack_require__(1772),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1495)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(1778),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75b89b35",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1503)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(781),
  /* template */
  __webpack_require__(1785),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1427)
  __webpack_require__(1426)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37cc33df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1446)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4821c62c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1487)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1769),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1494)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1777),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75382198",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1463)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1746),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1518)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1799),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1528)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1809),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1451)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1734),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1395)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1683),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-125614e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1517)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1798),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1514)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1795),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1526)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1807),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1402)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1689),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1416)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1702),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1399)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1687),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-171586cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1443)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1727),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1408)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1695),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1508)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1790),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    style: ({
      width: '360px'
    }),
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版单位名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 12 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("电子出版物出版单位查询")])])
}]}

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "addHide",
    attrs: {
      "action": _vm.xxx,
      "headers": _vm.postHead,
      "before-upload": _vm.prevCtrls,
      "on-success": _vm.successCtrls,
      "file-list": _vm.imgfiles,
      "disabled": true,
      "list-type": "picture-card",
      "data": _vm.fileData,
      "on-remove": _vm.handleRemove,
      "limit": 1,
      "on-preview": _vm.handlePictureCardPreview,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excel-up"
  }, [_c('input', {
    ref: "excel-upload-input",
    attrs: {
      "id": "excel-upload-input",
      "type": "file",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleClick
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-3"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("音像电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验项目",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row.type, "type")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.taskStatus == 7) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pressTabList"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), (_vm.msgStatus == 21) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("暂缓登记")]) : _vm._e(), _vm._v(" "), (_vm.msgStatus == 3) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, _vm._l(((_vm.opMsg || '').split('；')), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(item ? item + (index == (_vm.opMsg || "").split("；").length - 1 ? "" : "；") : "") + "\n          ")])
  }))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabCage.tabDat1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "材料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成进度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.status, "pgress")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row, "time")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pubStatus == 1 || _vm.pubStatus == 0) ? _c('UpBtn', {
          attrs: {
            "fileID": _vm.zeroStoreage[scope.row.id] ? _vm.zeroStoreage[scope.row.id].fileId : '',
            "btnProps": scope.row,
            "pubStatus": (scope.row.materialTitle == '整改报告' && _vm.pubStatus == 0 && _vm.isModifyStage == '1') ||
              (scope.row.materialTitle != '整改报告' && _vm.pubStatus == 0) ?
              0 :
              1
          },
          on: {
            "zeroTabStore": _vm.zeroStoreCtrls
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tabTips"
  }, [_vm._v("注：上传文件格式为WORD，文件大小不超过100M")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("材料2：音像制品出版单位年度核验表、音像制品出版情况表（"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果已经填写了电子数据，部分表格可以通过数据拷贝的方式获取")]), _vm._v("）")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("材料2：电子出版物出版单位年度核验表、电子出版物出版情况表（"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果已经填写了音像数据，部分表格可以通过数据拷贝的方式获取")]), _vm._v("）")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "copyBtn",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('show')
      }
    }
  }, [_vm._v("数据拷贝")]), _vm._v(" "), (_vm.pressType == 1) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl2,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表1：音像制品出版单位年度核验表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表1：电子出版物出版单位年度核验表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabCage.tabDat2), function(item, inx) {
    return _c('tr', {
      key: "inx"
    }, [_c('td', [_vm._v("1-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(_vm.pubStatus == 0 && item.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 0 && item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 3)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "7"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 7) ? _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 8) ? _c('td') : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表2：音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表2：电子出版物出版情况表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.tabCage.tabDat3), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("2-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(_vm.pubStatus == 0 && item.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 0 && item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.pubStatus == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item, 3)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(3)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)])])
  })], 2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(4), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [(_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.upToPvc
    }
  }, [_vm._v("提交")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressDiag",
    attrs: {
      "title": "选择需要拷贝的表",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.checkList && _vm.checkList.length > 0) ? _c('div', [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n          数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。\n        ")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.codeArr),
      callback: function($$v) {
        _vm.codeArr = $$v
      },
      expression: "codeArr"
    }
  }, _vm._l((_vm.checkList), function(tab, index) {
    return _c('div', {
      staticClass: "selectItem"
    }, [_c('el-checkbox', {
      key: tab.id,
      attrs: {
        "label": tab.materialCode
      }
    }, [_vm._v(_vm._s("1-" + tab.materialCode.substr(2, 3)) + " " + _vm._s(tab.materialTitle))])], 1)
  }))], 1) : _c('div', {
    staticClass: "errors"
  }, [_vm._v("目前尚未生成可拷贝的表")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.checkList && _vm.checkList.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('act')
      }
    }
  }, [_vm._v("拷 贝")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料1：工作总结    ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "float": "right"
    }
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTips"
  }, [_c('div', {
    staticClass: "tipBold"
  }, [_vm._v("注：")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("1、")]), _vm._v("\n            所有表格填写项目，若本单位无此项内容，文字项请填写“无”，数字项请填写“0”。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("2、")]), _vm._v("\n            核验年度如果没有发生表1-5、1-6、1-7、2-1的事项，则可以不用填写。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("3、")]), _vm._v("\n            表1-8可使用Excel进行批量导入。导入前需要先下载“导入模板”，并在“导入模板”文件中按其规定格式填写后才能批量导入。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("4、")]), _vm._v("\n            数据拷贝是指同时具有音像、电子业务的单位，在填写好音像材料后，两处材料一样的表格内容可以通过“数据拷贝”复制到电子出版物这边。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "tipLine"
  }, [_c('span', {
    staticClass: "fsDot"
  }, [_vm._v("5、")]), _vm._v("\n            导出打印表可以将标准格式Excel文件下载到本地电脑，下载的文件可以微调格式适应换行、换页后再打印，但不能修改内容。提交之后可从“核验进度”\n            菜单导出打印表。\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
}]}

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "disabled": _vm.upState == 'loading',
      "action": _vm.upUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "data": _vm.fileData,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.upState == 'loading',
      "size": "small"
    }
  }, [(_vm.upState == 'wait' || _vm.upState == 'loading') ? _c('span', [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('span', [_vm._v("更新")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("注：上传文件格式为JPEG/PNG，文件大小不超过10M")])], 1), _vm._v(" "), _c('div', {
    staticClass: "progressBox"
  }, [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "edName uploadLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "icons"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(342)
    },
    on: {
      "click": function($event) {
        _vm.handleLeftRotate(_vm.imgUrl)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(343)
    },
    on: {
      "click": function($event) {
        _vm.handleRightRotate(_vm.imgUrl)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab3"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("经营情况信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticClass: "importBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getCode403HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1)]), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: " subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版单位名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("电子出版物出版单位查询")])])
}]}

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-3"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("音像电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验项目",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row.type, "type")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.taskStatus == 7) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-2"
  }, [_c('div', {
    staticClass: "tbs"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.showArr
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper",
          on: {
            "click": function($event) {
              _vm.preFmate(scope.row)
            }
          }
        }, [_c('span', {
          style: ('margin-left:' + 24 * scope.row.x.length + 'px')
        }, [(scope.row.menuRuleModules.length > 0) ? _c('span', {
          staticStyle: {
            "margin-left": "-18px"
          }
        }, [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-caret-right"
        }) : _c('i', {
          staticClass: "el-icon-caret-bottom"
        })]) : _vm._e(), _vm._v("\n                " + _vm._s(scope.row.name) + "\n              ")]), _vm._v(" "), (scope.row.menuRuleModules.length > 0) ? _c('span', {
          staticClass: "tbIcon"
        }, [_vm._v("( " + _vm._s(scope.row.menuRuleModules.length) + "\n                )")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("translate")(scope.row.type, 'type')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "显示"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("translate")(scope.row.view, 'view')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "width": "240",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "newAdd",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add')
            }
          }
        }, [_vm._v("添加父级")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add', scope.row)
            }
          }
        }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('edit', scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('remove', scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-2-dag",
    attrs: {
      "title": _vm.diaTitle,
      "visible": _vm.diaForAdd,
      "width": "450px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.diaForAdd = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("类型：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [
    [_c('el-radio', {
      attrs: {
        "label": 1
      },
      model: {
        value: (_vm.postDats.type),
        callback: function($$v) {
          _vm.$set(_vm.postDats, "type", $$v)
        },
        expression: "postDats.type"
      }
    }, [_vm._v("页面")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      },
      model: {
        value: (_vm.postDats.type),
        callback: function($$v) {
          _vm.$set(_vm.postDats, "type", $$v)
        },
        expression: "postDats.type"
      }
    }, [_vm._v("按钮")])]
  ], 2)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("显示：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [
    [_c('el-radio', {
      attrs: {
        "label": 1
      },
      model: {
        value: (_vm.postDats.view),
        callback: function($$v) {
          _vm.$set(_vm.postDats, "view", $$v)
        },
        expression: "postDats.view"
      }
    }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 2
      },
      model: {
        value: (_vm.postDats.view),
        callback: function($$v) {
          _vm.$set(_vm.postDats, "view", $$v)
        },
        expression: "postDats.view"
      }
    }, [_vm._v("不显示")])]
  ], 2)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.name),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "name", $$v)
      },
      expression: "postDats.name"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("菜单URL：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.url),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "url", $$v)
      },
      expression: "postDats.url"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("图标URL：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.iconUrl),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "iconUrl", $$v)
      },
      expression: "postDats.iconUrl"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.diaForAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.frashKey) ? _c('router-view', {
    key: _vm.key,
    on: {
      "go-frash": _vm.goFrash
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版物名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("连续型电子出版物出版单位查询")])])
}]}

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-3"
  }, [_c('div', {
    staticClass: "provinceArea",
    style: (_vm.leftHt)
  }, [_c('el-scrollbar', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.postDat.sjExamineId,
      "background-color": "#fff",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.peovinceChange
    }
  }, _vm._l((_vm.provinceList), function(item, inx) {
    return _c('el-menu-item', {
      key: inx,
      class: {
        'custom-active': _vm.postDat.sjExamineId == item.sjExamineId
      },
      style: (Object.assign({}, _vm.computedColor(item))),
      attrs: {
        "index": item.sjExamineId
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm._f("transStr")(item, "navset")))])])
  }))], 1)], 1), _vm._v(" "), (_vm.postDat.sjExamineId) ? _c('div', {
    staticClass: "contArea"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.pvcName))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("电子出版物出版单位核验")]), _vm._v(" "), _c('div', {
    staticClass: "btnCtrls"
  }, [(_vm.pvcSta == 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.postBack(1)
      }
    }
  }, [_vm._v("整体发布")]) : _vm._e(), _vm._v(" "), (_vm.pvcSta == 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.postDat.msg == '';
      }
    }
  }, [_vm._v("整体退回")]) : _vm._e(), _vm._v(" "), (_vm.postUrl) ? _c('a', {
    attrs: {
      "href": _vm.postUrl
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局分析报告")])], 1) : _c('el-button', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    }
  }, [_vm._v("省局分析报告（未上传）")]), _vm._v(" "), (_vm.postUrlZg) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrlZg)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局整改报告")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [(_vm.pvcSta == 0) ? _c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("核验意见")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 0 ||
          scope.row.status == 1 ||
          scope.row.status == 2 ||
          scope.row.status == 4 ||
          scope.row.status == 5
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("进入\n              ")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "批准文号",
      "prop": "pubNumber",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, "time")) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "unProvince"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_elect_pop",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [_c('span', [_vm._v("请填写整体退回意见")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "rows": "3",
      "type": "textarea"
    },
    model: {
      value: (_vm.postDat.msg),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "msg", $$v)
      },
      expression: "postDat.msg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.postBack(2)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_elect_pop",
    attrs: {
      "title": "",
      "width": "40%",
      "center": "",
      "visible": _vm.dialogShow
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [(_vm.paramsEx.status == 3) ? _c('span', [_vm._v("请填写退回意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 22) ? _c('span', [_vm._v("请填写整改意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 2) ? _c('span', [_vm._v("请填写暂缓意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 4) ? _c('span', [_vm._v("请填写撤销意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 5) ? _c('span', [_vm._v("请填写注销意见")]) : _vm._e()]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.paramsEx.message),
      callback: function($$v) {
        _vm.$set(_vm.paramsEx, "message", $$v)
      },
      expression: "paramsEx.message"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-6"
  }, [_vm._m(0), _vm._v(" "), (_vm.wSat == 1) ? _c('CommonTab', {
    ref: "mainTab",
    attrs: {
      "cancelFlag": false,
      "pressType": _vm.emType,
      "pressDat": _vm.resDat
    }
  }) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "radioBx"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("退回")])], 1), _vm._v(" "), (_vm.params.status == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写退回原因"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("审核")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("音像审核制品")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("音像审核制品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核意见")])])
}]}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    class: _vm.isAct,
    attrs: {
      "action": _vm.upUrl,
      "headers": _vm.postHead,
      "before-upload": _vm.prevCtrls,
      "on-success": _vm.successCtrls,
      "file-list": _vm.imgfiles,
      "disabled": _vm.ableSet,
      "list-type": "picture-card",
      "data": _vm.fileData,
      "on-remove": _vm.handleRemove,
      "limit": _vm.imgNum,
      "on-preview": _vm.handlePictureCardPreview,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.sbstatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "sbstatus", $$v)
      },
      expression: "params.sbstatus"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "全部数据"
    }
  }, [_vm._v("全部数据")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "全部上报"
    }
  }, [_vm._v("全部上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "部分上报"
    }
  }, [_vm._v("部分上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "未上报"
    }
  }, [_vm._v("未上报")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省局"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入省局名称模糊查询"
    },
    model: {
      value: (_vm.params.pname),
      callback: function($$v) {
        _vm.$set(_vm.params, "pname", $$v)
      },
      expression: "params.pname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "省局",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sbstatus",
      "label": "状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "出版单位数量",
      "width": "190",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nonum",
      "label": "未上报数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wsnum",
      "label": "待审",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ysnum",
      "label": "已审",
      "align": "center"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-2"
  }, [(_vm.wSat == 0) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "dvsWait"
  }) : _vm._e(), _vm._v(" "), (_vm.wSat == 2) ? _c('div', {
    staticClass: "succedTips"
  }, [_vm._v("\n    材料已提交至省局，可从\n    "), _c('router-link', {
    attrs: {
      "to": "pgress_step"
    }
  }, [_c('a', [_vm._v("核验进度")])]), _vm._v(" 菜单查看审核进度。\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('div', [(_vm.frashCode) ? _c('MainTabs', {
    attrs: {
      "pressType": 2,
      "pressDat": _vm.resDat
    },
    on: {
      "go-frash": _vm.frashHandle,
      "valChangeSearch": _vm.valChangeSearch
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("资质：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selType),
      callback: function($$v) {
        _vm.selType = $$v
      },
      expression: "selType"
    }
  }, _vm._l((_vm.Zizhi), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("省局：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.selProvinceId),
      callback: function($$v) {
        _vm.selProvinceId = $$v
      },
      expression: "selProvinceId"
    }
  }, _vm._l((_vm.Shengju), function(item) {
    return _c('el-option', {
      key: item.sjExamineId,
      attrs: {
        "label": item.sjExamine,
        "value": item.sjExamineId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.goExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": "",
      "height": this.tableHeight
    },
    on: {
      "sort-change": this.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "width": "180",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "所属省局",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.selYear + '年'
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "firstTotalSales",
      "label": "出版单位年销售收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstTotalProfit",
      "label": "出版单位年利润收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstSales",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstProfit",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "firstPublicationVariety",
      "label": "出版物品种数量",
      "width": "200",
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": (_vm.selYear * 1 + 1) + '年'
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "secondTotalSales",
      "label": "出版单位年销售收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondTotalProfit",
      "label": "出版单位年利润收入（万元）",
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondSales",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年销售收入（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondProfit",
      "label": (_vm.selType == 1 ? '音像制品' : '电子出版物') + '年利润总额（万元）',
      "width": "230",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "secondPublicationVariety",
      "label": "出版物品种数量",
      "width": "200",
      "sortable": "custom"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;display: flex;"
    }
  }, [_c('el-form', {
    staticStyle: {
      "position": "absolute",
      "top": "5px",
      "left": "20px",
      "z-index": "50"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "年度"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请选择",
      "size": "mini"
    },
    on: {
      "change": function($event) {
        _vm.changeAndRedraw()
      }
    },
    model: {
      value: (_vm.targetyear),
      callback: function($$v) {
        _vm.targetyear = $$v
      },
      expression: "targetyear"
    }
  }, _vm._l((_vm.yearsOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "10px",
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "省局"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择",
      "size": "mini"
    },
    model: {
      value: (_vm.targetprovince),
      callback: function($$v) {
        _vm.targetprovince = $$v
      },
      expression: "targetprovince"
    }
  }, _vm._l((_vm.provinceOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "10px",
      "margin-bottom": "0px"
    },
    attrs: {
      "label": "排名"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "placeholder": "请选择",
      "size": "mini"
    },
    model: {
      value: (_vm.targetlimit),
      callback: function($$v) {
        _vm.targetlimit = $$v
      },
      expression: "targetlimit"
    }
  }, _vm._l((_vm.limitsOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initChatOptionData()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "860px",
      "width": "50%"
    },
    attrs: {
      "id": "chart_province_2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": "chart_province_2_table"
    }
  }, [_c('div', {
    staticClass: "text-warning",
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_province_2_html')
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入出版单位名称"
    },
    model: {
      value: (_vm.query['chart_province_2'].name),
      callback: function($$v) {
        _vm.$set(_vm.query['chart_province_2'], "name", $$v)
      },
      expression: "query['chart_province_2'].name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList('chart_province_2')
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    attrs: {
      "id": "chart_province_2_tab"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "title": "返回"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('div', {
    staticClass: "th-inner",
    on: {
      "click": function($event) {
        _vm.backEcharts('chart_province_2')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("省局")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("出版单位")])]), _vm._v(" "), _c('th', {
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("\n              " + _vm._s(this.table2colname) + "\n            ")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "chart_province_2_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "860px",
      "width": "50%"
    },
    attrs: {
      "id": "chart_province_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": "chart_province_3_table"
    }
  }, [_c('div', {
    staticClass: "text-warning",
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_province_3_html')
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入出版单位名称"
    },
    model: {
      value: (_vm.query['chart_province_3'].name),
      callback: function($$v) {
        _vm.$set(_vm.query['chart_province_3'], "name", $$v)
      },
      expression: "query['chart_province_3'].name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList('chart_province_3')
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    attrs: {
      "id": "chart_province_3_tab"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "title": "返回"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('div', {
    staticClass: "th-inner",
    on: {
      "click": function($event) {
        _vm.backEcharts('chart_province_3')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("省局")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("出版单位")])]), _vm._v(" "), _c('th', {
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("\n              " + _vm._s(this.table3colname) + "\n            ")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "chart_province_3_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [(_vm.ableUp == 1) ? _c('el-upload', {
    ref: "upload",
    attrs: {
      "disabled": "upState == 'loading'",
      "accept": ".doc,docx",
      "disabled": _vm.upState == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": _vm.fileData,
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upState == 'loaded') ? _c('span', [_vm._v("更新分析报告")]) : (_vm.upState == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传分析报告")])])], 1) : _vm._e(), _vm._v(" "), (_vm.ableUp == 1) ? _c('div', {
    staticClass: "flieList"
  }, [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.fileName))])]) : _vm._e(), _vm._v(" "), (_vm.ableUp == 2) ? _c('el-button', [_c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_vm._v("下载分析报告")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    staticClass: "progressBox",
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), (_vm.ableUp == 3) ? _c('div', {
    staticClass: "pvcTips"
  }, [_vm._v("已上报至总局")]) : _vm._e()], 1), _vm._v(" "), (_vm.ableUp == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goAdmin
    }
  }, [_vm._v("上报国家新闻出版署")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位上报")])])
}]}

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物中文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publication",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publication),
      callback: function($$v) {
        _vm.$set(_vm.params, "publication", $$v)
      },
      expression: "params.publication"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物外文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationEnglish",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationEnglish),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationEnglish", $$v)
      },
      expression: "params.publicationEnglish"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.category),
      callback: function($$v) {
        _vm.$set(_vm.params, "category", $$v)
      },
      expression: "params.category"
    }
  }, _vm._l((_vm.dicDats['C026']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "recordType",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.recordType),
      callback: function($$v) {
        _vm.$set(_vm.params, "recordType", $$v)
      },
      expression: "params.recordType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "periodicals",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.periodicals),
      callback: function($$v) {
        _vm.$set(_vm.params, "periodicals", $$v)
      },
      expression: "params.periodicals"
    }
  }, _vm._l((_vm.dicDats['C014']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊号（CN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cn),
      callback: function($$v) {
        _vm.$set(_vm.params, "cn", $$v)
      },
      expression: "params.cn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("国际刊号（ISSN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.issn),
      callback: function($$v) {
        _vm.$set(_vm.params, "issn", $$v)
      },
      expression: "params.issn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("批准时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "approvalTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "size": "small"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("批复文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.params.applyFileId) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.filesDown(_vm.params.applyFileId)
      }
    }
  }, [_vm._v("\n              下载\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.params.applyFileId) ? _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "size": "mini",
      "type": "danger"
    }
  }, [_vm._v("\n              未上传\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("媒体形态：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "mediaForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.mediaForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "mediaForm", $$v)
      },
      expression: "params.mediaForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否缴送样本：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isSampleDelivery",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isSampleDelivery),
      callback: function($$v) {
        _vm.$set(_vm.params, "isSampleDelivery", $$v)
      },
      expression: "params.isSampleDelivery"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationScope", $$v)
      },
      expression: "params.publicationScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("发行范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issueScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.issueScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "issueScope", $$v)
      },
      expression: "params.issueScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("读者对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "readers",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.readers),
      callback: function($$v) {
        _vm.$set(_vm.params, "readers", $$v)
      },
      expression: "params.readers"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版物基本信息")])])
}]}

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab2E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n    注：本表中所指“连续型电子出版物出版单位”，是指依照《电子出版物出版管理规定》经批准办理审批和履行登记手续的出版单位，法人单位出版连续型电子出版物且不再设立法人出版单位的，其设立的连续型电子出版物编辑部视为连续型电子出版物出版单位。\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物品种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "type": "input",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.pzs),
      callback: function($$v) {
        _vm.pzs = $$v
      },
      expression: "pzs"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物出版单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "workers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物业务人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其中取得中级以上资格证书人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法人身份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "unitType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C016']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("演变情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "evolution",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.evolution),
      callback: function($$v) {
        _vm.$set(_vm.params, "evolution", $$v)
      },
      expression: "params.evolution"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("出版单位（主办单位）"), _c('br'), _vm._v("具有的出版资质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营收高于出版业务"), _c('br'), _vm._v("的其他主营业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherbusiness",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  }), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版单位基本信息")])])
}]}

/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.modifyFlag) ? _c('el-button', {
    staticClass: "importBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getCode403HistoryData
    }
  }, [_vm._v("导入历史数据\n      ")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "8"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度销售收入（万元）")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("国内发行和销售收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("海外发行收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("与出版相关活动收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("及新媒体网站上"), _c('br'), _vm._v("所做广告收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales6", $$v)
      },
      expression: "params.firstSales6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales6", $$v)
      },
      expression: "params.secondSales6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales7", $$v)
      },
      expression: "params.firstSales7"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales7", $$v)
      },
      expression: "params.secondSales7"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("连续型电子出版物年度支出（万元）")]), _vm._v(" "), _c('td', [_vm._v("出版团队的人员"), _c('br'), _vm._v("成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘包装等费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            连续型电子出版物年税费（万元）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与连续型电子出版相关的企业所得缴纳税费，含营业税和所得税。")])]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度利润（税后）总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("载体出版"), _c('br'), _vm._v("经营情况")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("\n            载体出版发行的渠道及占比\n            "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版"), _c('br'), _vm._v("\n            经营情况\n          ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版渠道及占比\n            "), _c('br'), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果在网络营销平台同时发行载体出版物，对应销售收入及利润总额也应计入网络出版相关细目。")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityCn", $$v)
      },
      expression: "params.firstIssueQuantityCn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityCn", $$v)
      },
      expression: "params.secondIssueQuantityCn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行单价(元)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstUnitPrice", $$v)
      },
      expression: "params.firstUnitPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondUnitPrice", $$v)
      },
      expression: "params.secondUnitPrice"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("海外发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityFn", $$v)
      },
      expression: "params.firstIssueQuantityFn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityFn", $$v)
      },
      expression: "params.secondIssueQuantityFn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("收文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSwl", $$v)
      },
      expression: "params.firstSwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSwl", $$v)
      },
      expression: "params.secondSwl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("录用量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstLyl", $$v)
      },
      expression: "params.firstLyl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondLyl", $$v)
      },
      expression: "params.secondLyl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("发文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFwl", $$v)
      },
      expression: "params.firstFwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFwl", $$v)
      },
      expression: "params.secondFwl"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fullName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "gender",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "idNumber",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "politicalStatus",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "culture",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellphone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "major",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "professionalTitleSeries",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "titleLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "certificateSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isTrainCertificate",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")])])
}]}

/***/ }),
/* 1700 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("围绕本连续型电子"), _c('br'), _vm._v("出版物自行开设并运营"), _c('br'), _vm._v("的项目：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站(数据平台）"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), (_vm.params.operationProjectOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.operationProjectOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherFill", $$v)
      },
      expression: "params.operationProjectOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            获取文章数字传播权主要方式：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "在期刊刊登声明，投稿即视为授权"
    },
    model: {
      value: (_vm.params.getGPLMethodSubmit),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodSubmit", $$v)
      },
      expression: "params.getGPLMethodSubmit"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "在投审稿平台予以提示，同意授权方可投稿"
    },
    model: {
      value: (_vm.params.getGPLMethodTip),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodTip", $$v)
      },
      expression: "params.getGPLMethodTip"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "与作者签订一对一的数字传播权授权合同"
    },
    model: {
      value: (_vm.params.getGPLMethodAuthor),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodAuthor", $$v)
      },
      expression: "params.getGPLMethodAuthor"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "label": "其他",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.getGPLMethodOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodOther", $$v)
      },
      expression: "params.getGPLMethodOther"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.getGPLMethodEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodEmpty", $$v)
      },
      expression: "params.getGPLMethodEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("数据平台建设和合作情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.databasePlatformOwner),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformOwner", $$v)
      },
      expression: "params.databasePlatformOwner"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("自建")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("共建")])], 1), _vm._v(" "), (_vm.params.databasePlatformOwner == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写平台名称"
    },
    model: {
      value: (_vm.params.databasePlatformName),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformName", $$v)
      },
      expression: "params.databasePlatformName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否与国际出版商开展合作：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.internationpublisher),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisher", $$v)
      },
      expression: "params.internationpublisher"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.internationpublisher == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写合作商名称"
    },
    model: {
      value: (_vm.params.internationpublisherName),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisherName", $$v)
      },
      expression: "params.internationpublisherName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否被知名数据库收录：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.collectdatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabase", $$v)
      },
      expression: "params.collectdatabase"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.collectdatabase == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请填写数据库名称"
    },
    model: {
      value: (_vm.params.collectdatabaseName),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabaseName", $$v)
      },
      expression: "params.collectdatabaseName"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位领导：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbSld", $$v)
      },
      expression: "params.zbSld"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("编辑人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbBjry", $$v)
      },
      expression: "params.zbBjry"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等"), _c('br'), _vm._v("相关人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专职发行人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员"), _c('br'), _vm._v("（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数"), _c('br'), _vm._v("（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  })], 1), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况调查表")])])
}]}

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excelEr-area"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "1000px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-area"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-table', {
    ref: "exStrees",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.compData
    },
    on: {
      "row-click": _vm.lineCtrls
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [(props.row.remark) ? [_c('el-form-item', {
          staticClass: "imptError",
          attrs: {
            "label": "文件错误："
          }
        }, [_c('span', {
          staticClass: "active"
        }, [_vm._v(_vm._s(props.row.remark))])])] : _vm._l((_vm.thead2), function(term) {
          return [_c('el-form-item', {
            attrs: {
              "label": term.name
            }
          }, [_c('span', {
            class: {
              active: _vm.errorRed(props.row, term.dataName, term)
            }
          }, [_vm._v(_vm._s(_vm._f("formateData")(props.row, term.dataName, _vm.pressCode)))])])]
        })], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "导入错误信息列表",
      "prop": "readCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "21"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_vm._v("注销或拟注销")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("（若省局已经审核完成，请点击“上报国家新闻出版署”。）")]), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版单位、出版物名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "time")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "省局意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "sjstatus")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "state")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0 || scope.row.progress == '省局') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("审核")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看 ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pg3_3dig",
    attrs: {
      "visible": _vm.backdiag,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.backdiag = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.backtype == 3) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zhuxiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zhuxiaoMessage", $$v)
      },
      expression: "params.zhuxiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.arrExam
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("连续型电子出版物单位审核")])])
}]}

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    style: (_vm.params.chartHeight),
    attrs: {
      "id": _vm.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": _vm.params.id + '_table'
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.params.id)
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": Object.keys(_vm.params.columnMap[_vm.params.id]).length <= 4 ? 6 : 4
      }
    }, [(
      (_vm.params.id == 'chart_11' ||
        _vm.params.id == 'chart_12' ||
        _vm.params.id == 'chart_21' ||
        _vm.params.id == 'chart_22') &&
      key == 'value'
    ) ? _c('el-select', {
      attrs: {
        "size": "mini",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, _vm._l((_vm.options), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    })) : _c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.params.columnMap[_vm.params.id][key]
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.params.id + '_tab'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts(_vm.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning",
      staticStyle: {
        "max-width": "96%",
        "white-space": "initial"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.params.columnMap[_vm.params.id][key]) + "\n              "), _c('i', {
      class: _vm.querySort[_vm.params.id][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort[_vm.params.id][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort[_vm.params.id][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort[_vm.params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData(_vm.params.id, key, _vm.querySort[_vm.params.id][key])
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fht-cell"
    })])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": _vm.params.id + '_html'
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上级单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询"
    },
    model: {
      value: (_vm.param.parentname),
      callback: function($$v) {
        _vm.$set(_vm.param, "parentname", $$v)
      },
      expression: "param.parentname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机构名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询"
    },
    model: {
      value: (_vm.param.name),
      callback: function($$v) {
        _vm.$set(_vm.param, "name", $$v)
      },
      expression: "param.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.batchBackSystem()
      }
    }
  }, [_vm._v("国家新闻出版署批量退回")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hidePagin ? _vm.tableData : _vm.tableData.slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize)
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上级单位",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("transParent")(scope.row.parent)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(_vm._f("translate")(scope.row.type, "level")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流程",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.flowName))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "goDeeper",
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.flowId ? "已初始化" : ""))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "书号对应ID",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level == 3) ? _c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.tsorgid))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "line-height": "40px",
            "float": "left"
          }
        }, [(scope.row.level != 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add', scope.row)
            }
          }
        }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('edit', scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), (scope.row.level != 1) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('remove', scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setClaimId(scope.row)
            }
          }
        }, [_vm._v("设置书号ID")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('br') : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "bold"
          }
        }, [_vm._v("创建审批流程：")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('1', scope.row)
            }
          }
        }, [_vm._v("音像")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('2', scope.row)
            }
          }
        }, [_vm._v("电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setWorks('3', scope.row)
            }
          }
        }, [_vm._v("连续电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('br') : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "bold"
          }
        }, [_vm._v("生成申报资料清单：")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterials('1', scope.row)
            }
          }
        }, [_vm._v("音像")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterials('2', scope.row)
            }
          }
        }, [_vm._v("电子")]) : _vm._e(), _vm._v(" "), (scope.row.level == 3) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setMaterialsLxdz('3', scope.row)
            }
          }
        }, [_vm._v("连续电子")]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.hidePagin == false) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.sizesArray
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-4-dag",
    attrs: {
      "title": _vm.diaTitle,
      "visible": _vm.diaForAdd,
      "width": "480px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.diaForAdd = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.name),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "name", $$v)
      },
      expression: "postDats.name"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.diaForAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-4-dag",
    attrs: {
      "title": "设置书号ID",
      "visible": _vm.diaForSetTsorgid,
      "width": "480px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.diaForSetTsorgid = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.tsorgid),
      callback: function($$v) {
        _vm.tsorgid = $$v
      },
      expression: "tsorgid"
    }
  })], 1)])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.closeCliamId()
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.saveClaimId()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("机构管理")])])
}]}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table9"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.pullProductFromSystem
    }
  }, [_vm._v("音电书号系统导入")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.dmyfile(1)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("导出Excel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressId": _vm.querys.pressId,
      "mtId": _vm.querys.mtId,
      "excelCode": "301",
      "pressType": _vm.pressType
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.selYear - 2) + "年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.selYear - 1) + "年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称、专用书号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 20 * (_vm.currentPage - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pressType == 1) ? _c('div', [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap, scope.row)) + "\n          ")]) : (_vm.pressType == 2) ? _c('div', [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C025", _vm.dicMap, scope.row)) + "\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [(_vm.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "301"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_tips"
  }, [_c('p', [_vm._v("注：此表内容只能从书号系统同步数据，规则为成品上传时间在两个核验年度中的全部出版物信息。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table8"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.excelModeUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载模板")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "excelRead",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.ExHandle
    }
  }, [_vm._v("导入Excel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressType": _vm.pressType,
      "excelCode": "208"
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "通过姓名，身份证号（军官证号），手机号查询",
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n      注：1、持有岗位培训合格证书、持有出版专业职业资格证书，需要上传对应证书图片才能提交到上级，点击“编辑”按钮可以上传对应图片。\n      "), _c('br'), _vm._v(" "), _vm._v("\n      2、请在编辑人员中填写"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像业务")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子业务")]) : _vm._e(), _vm._v("全部编辑人员。\n      "), _c('br'), _vm._v(" "), _vm._v("\n      3、编辑人员表中不能重复填写负责人信息。\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.gender, "C017", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "job",
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.job, "C022", _vm.dicMap, scope.row)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, "C006", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.culture, "C005", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, "C007", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.titleLevel, "C008", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "入职时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.rzDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "离职时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.lzDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "取得证书时间",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.trainCertificateDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, "C018", _vm.dicMap)) + "\n            "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, "C009", _vm.dicMap)) + "\n            "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.tabDat.length,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.sizesArray
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "208"
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressComDiag",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": function($event) {
        _vm.urlCreate('close')
      }
    }
  }, [_c('div', {
    staticClass: "imgCont"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgShowUrl,
      "alt": ""
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table6"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重点出版物名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row, "C021", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row, "C024", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ydDate",
      "label": "拟完成时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.ydDate, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [(_vm.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table5"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-5：获得表彰情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过奖项名称、颁奖单位查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms),
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hjName",
      "label": "奖项名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰对象",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.bzObject, "C023", _vm.dicMap, scope.row)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commend",
      "label": "奖励内容",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bjName",
      "label": "颁奖单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "获奖级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.hjLevel, "C024", _vm.dicMap, scope.row)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.hjDate) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [(_vm.allPage > 1) ? _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage table4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "importBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getcode204HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所有权",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.placeSituation, "C002", _vm.dicMap, scope.row)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场所情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.placePower, "C020", _vm.dicMap, scope.row)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placeArea",
      "width": "150",
      "label": "占地面积（平米）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pageArea"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.seekPms.no,
      "page-count": _vm.allPage
    },
    on: {
      "current-change": _vm.goPage
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-3：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 1-3：电子出版物出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("2017年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("2018年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IssueQuantity",
      "label": "发行数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitPrice",
      "label": "发行单价（元）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否缴送样本",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sampleDelivery, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pressTabList2"
  }, [(_vm.opMsg && _vm.role == 'show') ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm._f("filterMsgStatus")(_vm.msgStatus)))])]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, _vm._l(((_vm.opMsg || '').split('；')), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n            " + _vm._s(item ? item + (index == (_vm.opMsg || "").split("；").length - 1 ? "" : "；") : "") + "\n          ")])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料1：工作总结")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.toCancel
    }
  }, [(_vm.cancelFlag) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("撤 回")]) : _vm._e()], 1)]), _vm._v(" "), _c('span'), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabCage.tabDat1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "材料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成进度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.status, "pgress")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.updatedAt, "time")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          }
        }, [_c('a', {
          attrs: {
            "download": ""
          },
          on: {
            "click": function($event) {
              _vm.filesDown(scope.row)
            }
          }
        }, [_vm._v("下载")])]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("材料2：音像制品出版单位年度核验表、音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("材料2：电子出版物出版单位年度核验表、电子出版物出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 1) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl1,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.filrUrl2,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表1：音像制品出版单位年度核验表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表1：电子出版物出版单位年度核验表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabCage.tabDat2), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("1-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.updatedAt, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "7"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : (inx == 7) ? _c('td', [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subBar"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表2：音像制品出版情况表")]) : _vm._e(), _vm._v(" "), (_vm.pressType == 2) ? _c('span', [_vm._v("表2：电子出版物出版情况表")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabCage.tabDat3), function(item, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v("2-" + _vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.materialTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.status, "pgress")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(item.updatedAt, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [(item.status == 2) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(item)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "120px"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);",
        "downLoad": ""
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(3)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)])])
  })], 2)]), _vm._v(" "), (_vm.role == 'press') ? _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(2), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("材料名称")]), _vm._v(" "), _c('td', [_vm._v("完成进度")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
}]}

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-8"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), (_vm.msgStatus == 21) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("暂缓登记")]) : _vm._e(), _vm._v(" "), (_vm.msgStatus == 3) ? _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.querys.bookName))])]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term, "time")))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "150px"
      }
    }, [(term.code != 501) ? _c('span', [(!_vm.modifyFlag) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 2)
        }
      }
    }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && term.status == 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 1)
        }
      }
    }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && term.status != 1) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term, 2)
        }
      }
    }, [_vm._v("修改")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (term.code == 501) ? _c('span', [(_vm.pubStatus == 1 || _vm.pubStatus == 0) ? _c('UpBtn', {
      attrs: {
        "fileID": _vm.zeroStoreage[term.id] ? _vm.zeroStoreage[term.id].fileId : '',
        "btnProps": Object.assign({}, term),
        "pubStatus": (term.name == '整改报告' && _vm.pubStatus == 0 && _vm.isModifyStage == '1') ||
          (term.name != '整改报告' && _vm.pubStatus == 0) ?
          0 :
          1
      },
      on: {
        "zeroTabStore": _vm.zeroStoreCtrls
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (inx == 0) ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "3"
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1)
        }
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      }
    }, [_vm._v("导出打印表")])], 1)]) : _vm._e(), _vm._v(" "), (term.code == '501') ? _c('td', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "rowspan": "3"
      }
    }, [_vm._v(" ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tabTips"
  }, [_vm._v("注：上传整改报告文件格式为WORD，文件大小不超过100M")])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "ssPressDiag",
    attrs: {
      "title": "选择需要拷贝的表",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.checkList.length > 0) ? _c('div', [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n        数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。\n      ")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.codeArr),
      callback: function($$v) {
        _vm.codeArr = $$v
      },
      expression: "codeArr"
    }
  }, _vm._l((_vm.checkList), function(tab, index) {
    return _c('div', {
      staticClass: "selectItem"
    }, [_c('el-checkbox', {
      key: tab.id,
      attrs: {
        "label": tab.materialCode
      }
    }, [_vm._v(_vm._s(tab.materialCode.substr(2, 3)) + " " + _vm._s(tab.materialTitle))])], 1)
  }))], 1) : _c('div', {
    staticClass: "errors"
  }, [_vm._v("目前尚未生成可拷贝的表")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.checkList.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.copyHandle('act')
      }
    }
  }, [_vm._v("拷 贝")]) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("更新时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage ssTab4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过姓名，身份证号（军官证号），手机号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Left_nav_set"
  }, [_vm._l((_vm.routes), function(item) {
    return [(!item.hidden && item.noDropdown && item.children.length > 0) ? _c('router-link', {
      attrs: {
        "to": item.path + '/' + item.children[0].path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": item.path + '/' + item.children[0].path
      }
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(item.children[0].name) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      attrs: {
        "index": item.key
      }
    }, [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(item.name) + "\n            ")]), _vm._v(" "), (item.key == 'province_role') ? [_c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("审核：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx < 3) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("上报：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 3 && inx < 5) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("登记：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 5 && inx < 8) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("查询：")]), _vm._v(" "), _vm._l((item.children), function(child, inx) {
      return (!child.hidden && inx >= 8) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                    " + _vm._s(child.name) + "\n                                ")])], 1)] : _vm._e()] : _vm._e()
    })], 2)] : [_vm._l((item.children), function(child, inx) {
      return (!child.hidden) ? [(child.isShow) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        style: (_vm.bgSet(child.key)),
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [_vm._v("\n                                " + _vm._s(child.name) + "\n                            ")])], 1)] : _vm._e()] : _vm._e()
    })]], 2) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 3：音像制品出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("2017年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("2018年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IssueQuantity",
      "label": "发行数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitPrice",
      "label": "发行单价（元）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否缴送样本",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sampleDelivery, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所有权",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placeSituation, 'C002', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场所情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placePower, 'C020', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placeArea",
      "width": "150",
      "label": "占地面积（平米）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }]
  }, [_c('p', [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所有权",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placeSituation, 'C002', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "场所情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.placePower, 'C020', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "placeArea",
      "width": "150",
      "label": "占地面积（平米）",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable5"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-5：获得表彰情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过奖项名称、颁奖单位查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hjName",
      "label": "奖项名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰对象",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.bzObject, 'C023', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commend",
      "label": "奖励内容",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bjName",
      "label": "颁奖单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "获奖级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.hjLevel, 'C024', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(scope.row.hjDate) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }]
  }, [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hjName",
      "label": "奖项名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰对象",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.bzObject, 'C023', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commend",
      "label": "奖励内容",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bjName",
      "label": "颁奖单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "获奖级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row.hjLevel, 'C024', _vm.dicMap, scope.row)) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "表彰时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(scope.row.hjDate) + "\n\t\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable6"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "项目名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重点项目名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row, 'C021', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row, 'C024', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ydDate",
      "label": "拟完成时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("stringTrans")(scope.row.ydDate, 'time')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }]
  }, [_c('p', [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(scope.$index + 1 + 15 * (_vm.seekPms.no - 1)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proName",
      "label": "项目名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重点项目名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row, 'C021', _vm.dicMap)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("translate")(scope.row, 'C024', _vm.dicMap)) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ydDate",
      "label": "拟完成时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(_vm._f("stringTrans")(scope.row.ydDate, 'time')) + "\n\t\t\t\t\t\t ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value!==''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable8"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), (_vm.role == 'show') ? _c('div', {
    staticClass: "percentTab"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.percentArr), function(term, inx) {
    return _c('tr', [(inx < 2) ? [_c('td', [_vm._v(_vm._s(_vm._f("transStr")(term.workerType, 'type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.thisWorker))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.certificateWorker))]), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v("\n                          " + _vm._s((_vm.munCount && _vm.munCount.length > 0) ? _vm.munCount[0].certificateWorkerProportion : 0) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.zjCertificate))]), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s(_vm._f("pecCount")(term, _vm.percentArr, 2)))]) : _vm._e()] : [_c('td', [_vm._v(_vm._s(_vm._f("transStr")(term.workerType, 'type')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.thisWorker))]), _vm._v(" "), _c('td', [_vm._v(" ———— ")]), _vm._v(" "), _c('td', [_vm._v(" ———— ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.zjCertificate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("pecCount")(term, _vm.percentArr, 3)))])]], 2)
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": function($event) {
        _vm.tabSeek('seek')
      }
    },
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过姓名、身份证号、手机号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('seek')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap, scope.row)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n                            "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, 'C009', _vm.dicMap)) + "\n                            "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.gender, 'C017', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.job, 'C022', _vm.dicMap, scope.row)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, 'C006', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.culture, 'C005', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, 'C007', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm._f("translate")(scope.row.titleLevel, 'C008', _vm.dicMap)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, 'C018', _vm.dicMap)) + "\n                                "), (scope.row.trainCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, 'C009', _vm.dicMap)) + "\n                                "), (scope.row.professionalCertificateId) ? _c('i', {
          staticClass: "el-icon-picture"
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "pressComDiag",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": function($event) {
        _vm.urlCreate('close')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgShowUrl,
      "width": "100%",
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("人数统计")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("岗位培训合格证书持有统计")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版专业职业资格证书持有情况统计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("岗位类别")]), _vm._v(" "), _c('td', [_vm._v("人员数（人）")]), _vm._v(" "), _c('td', [_vm._v("持证人数")]), _vm._v(" "), _c('td', [_vm._v("占比")]), _vm._v(" "), _c('td', [_vm._v("中级以上")]), _vm._v(" "), _c('td', [_vm._v("占比")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage Rtable9"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.yearSet),
      callback: function($$v) {
        _vm.yearSet = $$v
      },
      expression: "yearSet"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(this.selYear - 2) + "年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(this.selYear - 1) + "年")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称、专用书号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "seekBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.tabSeek('init')
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekPms).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + _vm.pageSize * (_vm.seekPms.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pressType == 1) ? _c('div', [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap, scope.row)) + "\n            ")]) : (_vm.pressType == 2) ? _c('div', [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C025", _vm.dicMap, scope.row)) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }]
  }, [_vm._v("历史版本：")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.historyJsonParams,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + _vm.pageSize * (_vm.seekPms.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "year",
      "label": "年份",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationName",
      "label": "出版物名称",
      "width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isbn",
      "width": "150",
      "label": "专用书号(ISBN 978-7-)",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "载体形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.pressType == 1) ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C010", _vm.dicMap, scope.row)) + "\n              ")]) : (_vm.pressType == 2) ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("translate")(scope.row.carrierForm, "C025", _vm.dicMap, scope.row)) + "\n              ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版形式",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.publicationForm, "C011", _vm.dicMap)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productionUnit",
      "label": "节目来源/制作单位",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "programCapacity",
      "label": "节目时长或容量(分钟/兆)",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publicationQuantity",
      "label": "出版数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issueQuantity",
      "label": "发行数量（张/盒）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitPrice",
      "label": "发行单价（元）",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publishingTime",
      "label": "出版时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("stringTrans")(scope.row.publishingTime, "time")) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否缴送样本",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.sampleDelivery, "C018", _vm.dicMap)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否书配盘标记",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.sign, "C018", _vm.dicMap)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.seekPms.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_tips"
  }, [_c('p', [_vm._v("注：此表内容只能从书号系统同步数据，规则为成品上传时间在两个核验年度中的全部出版物信息。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("所在出版单位(非部门)"), _c('br'), _vm._v("具有的出版资质包括：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("主营出版业务"), _c('br'), _vm._v("(营收高于音像电子业务的出版业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.mainBusinessTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessTs", $$v)
      },
      expression: "params.mainBusinessTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.mainBusinessQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessQk", $$v)
      },
      expression: "params.mainBusinessQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.mainBusinessWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessWl", $$v)
      },
      expression: "params.mainBusinessWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.mainBusinessBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessBz", $$v)
      },
      expression: "params.mainBusinessBz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.mainBusinessRm1),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessRm1", $$v)
      },
      expression: "params.mainBusinessRm1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("是否主营有其他业务"), _c('br'), _vm._v("（营收高于出版业务的业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "连续型电子/网络出版物"
    },
    model: {
      value: (_vm.params.expandBusinessLxdz),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessLxdz", $$v)
      },
      expression: "params.expandBusinessLxdz"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "无",
      "disabled": "",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("的单位或部门"), _c('br'), _vm._v("结合"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务"), _c('br'), _vm._v("开设并运营有以下项目：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWebNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWebNum", $$v)
      },
      expression: "params.operationProjectWebNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectDatabaseNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabaseNum", $$v)
      },
      expression: "params.operationProjectDatabaseNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum1),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum1", $$v)
      },
      expression: "params.operationProjectWechatNum1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('span', {
    staticClass: "chboxLeft"
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum2),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum2", $$v)
      },
      expression: "params.operationProjectWechatNum2"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（总用户数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectAppNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectAppNum", $$v)
      },
      expression: "params.operationProjectAppNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（小程序用户数或APP下载量）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "粉丝数"
    },
    model: {
      value: (_vm.params.operationProjectWeiboNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeiboNum", $$v)
      },
      expression: "params.operationProjectWeiboNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（粉丝数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他（与第三方平台合作)"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "平台数量"
    },
    model: {
      value: (_vm.params.operationProjectOtherNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherNum", $$v)
      },
      expression: "params.operationProjectOtherNum"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版单位(社)领导：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbSld", $$v)
      },
      expression: "params.zbSld"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("编辑人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbBjry", $$v)
      },
      expression: "params.zbBjry"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等相关人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("中除编辑以外"), _c('br'), _vm._v("的有关新媒体、网络运营等技术人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumInternation),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumInternation", $$v)
      },
      expression: "params.pepnumInternation"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("的专职"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版物发行人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  }), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-9：出版经营情况调查表")])])
}]}

/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "printArea"
    }
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("基本情况表")])]), _vm._v(" "), _c('div', {
    staticClass: "tabCage"
  }, [_c('table', [_c('tr', {
    staticClass: "cpLine"
  }, [_c('td', {
    staticClass: "stype_1"
  }), _vm._v(" "), _c('td', {
    staticClass: "stype_2"
  }), _vm._v(" "), _c('td', {
    staticClass: "stype_3"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "stype_1"
  }), _vm._v(" "), _c('td', {
    staticClass: "stype_2"
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "stype_3"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "8"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("邮政编码")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系人")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办单位")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系人")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址/邮编")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主管单位")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系人")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址/邮编")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("职工总数")]), _vm._v(" "), _c('td', {
    staticClass: "stype_3"
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("从事音像电子业务人员数")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("其他人员数")]), _vm._v(" "), _c('td', {
    staticClass: "stype_3"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("企业性质")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("若企业性质为“其他”请填写")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("注册资本")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("资产总额")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("负债总额")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2017年本单位销售收入（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2018年本单位销售收入（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2017年本单位利润总额（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("aaa")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2018年本单位利润总额（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("aaa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "5"
    }
  }, [_vm._v("音像制品载体出版")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("年度")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2017年")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("2018年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版品种数")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("销售收入（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("利润总额（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2"
    }
  }, [_vm._v("音像制品信息网络出版")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("销售收入（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("利润总额（万元）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "rowspan": "2"
    }
  }, [_vm._v("经营范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "8"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                      除音像电子出版业务外本单位或本部门经营的其他主要业务\n                   ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "stype_1",
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("出版单位资质情况")]), _vm._v(" "), _c('td', {
    staticClass: "stype_2",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("法人情况")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("是否独立法人")]), _vm._v(" "), _c('td', {
    staticClass: "stype_2"
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("独立法人隶属关系")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("独立法人单位类型")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("是否为非独立法人")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("非独立法人隶属关系")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("出版资质获批时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("需要说明的其他情况")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "6"
    }
  })])])])])
}]}

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-date-picker', {
    attrs: {
      "size": "small",
      "align": "right",
      "type": "year",
      "format": "yyyy 年",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择年"
    },
    on: {
      "focus": function($event) {
        _vm.beforeTimeClick('y')
      },
      "change": function($event) {
        _vm.timeFormate('y')
      }
    },
    model: {
      value: (_vm.time1.year),
      callback: function($$v) {
        _vm.$set(_vm.time1, "year", $$v)
      },
      expression: "time1.year"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "size": "small",
      "align": "right",
      "type": "month",
      "format": "MM 月",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择月"
    },
    on: {
      "focus": function($event) {
        _vm.beforeTimeClick('m')
      },
      "change": function($event) {
        _vm.timeFormate('m')
      }
    },
    model: {
      value: (_vm.time1.month),
      callback: function($$v) {
        _vm.$set(_vm.time1, "month", $$v)
      },
      expression: "time1.month"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "size": "small",
      "align": "right",
      "format": "dd 日",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日"
    },
    on: {
      "focus": function($event) {
        _vm.beforeTimeClick('d')
      },
      "change": function($event) {
        _vm.timeFormate('d')
      }
    },
    model: {
      value: (_vm.time1.day),
      callback: function($$v) {
        _vm.$set(_vm.time1, "day", $$v)
      },
      expression: "time1.day"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    style: (_vm.params.chartHeight),
    attrs: {
      "id": _vm.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": _vm.params.id + '_table'
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.params.id)
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": Object.keys(_vm.params.columnMap[_vm.params.id]).length <= 4 ? 6 : 4
      }
    }, [_c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.params.columnMap[_vm.params.id][key]
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.params.id + '_tab'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts(_vm.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n              " + _vm._s(_vm.params.columnMap[_vm.params.id][key]) + "\n              "), _c('i', {
      class: _vm.querySort[_vm.params.id][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort[_vm.params.id][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort[_vm.params.id][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort[_vm.params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData(_vm.params.id, key, _vm.querySort[_vm.params.id][key])
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fht-cell"
    }, [(_vm.queryVisible[_vm.params.id]) ? _c('el-input', {
      staticClass: "searchInput",
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": _vm.params.id + '_html'
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "chart_lxdz_1_introduce"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "44px",
      "right": "30px"
    },
    attrs: {
      "id": "changelist",
      "src": '/static/list_ico.png',
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v("连续型电子出版物统计")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.nParOrgCount))]), _vm._v(" 个省局，\n              "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.nOrgCount))]), _vm._v(" 家出版单位，\n              "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.nLxdzCount))]), _vm._v(" 种连续型电子出版物\n            ")]), _vm._v(" "), _vm._l((_vm.groupData), function(item, index) {
    return _c('p', [_vm._v("\n              " + _vm._s(item.organizationname) + "\n              "), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(item.materialtitle))]), _vm._v(" 家，共\n              "), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(item.materialcode))]), _vm._v(" 种\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": "chart_lxdz_1_table"
    }
  }, [_c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    attrs: {
      "id": "chart_lxdz_1_tab"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "title": "返回"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_c('div', {
    staticClass: "th-inner",
    on: {
      "click": function($event) {
        _vm.backEcharts()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "0.74rem",
      "width": "160px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("省局")]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.provincename),
      callback: function($$v) {
        _vm.$set(_vm.query, "provincename", $$v)
      },
      expression: "query.provincename"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "0.74rem",
      "width": "220px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("出版单位")]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.name),
      callback: function($$v) {
        _vm.$set(_vm.query, "name", $$v)
      },
      expression: "query.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("\n                      连续型电子出版物数量\n                      "), _c('i', {
    staticClass: "fa fa-filter searchFilerCls",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "筛选"
    },
    on: {
      "click": function($event) {
        _vm.setQueryVisible()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_lxdz_1_html')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.value),
      callback: function($$v) {
        _vm.$set(_vm.query, "value", $$v)
      },
      expression: "query.value"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "chart_lxdz_1_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "484.5px",
      "width": "100%",
      "padding-top": "20px",
      "margin-bottom": "40px"
    },
    attrs: {
      "id": "chart_lxdz_1"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_sale"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_pay"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_sale"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_pay"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [_vm._v("\n    " + _vm._s(item.name) + "\n    ")])
  }))
},staticRenderFns: []}

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称、出版物名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, 'time')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, 'record_state')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.record == 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goRegist(scope.row)
            }
          }
        }, [_vm._v("登记\n              ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goScan(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位登记")])])
}]}

/***/ }),
/* 1728 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-4"
  }, [(_vm.wSat == 1) ? _c('MainTabs', {
    attrs: {
      "cancelFlag": _vm.cancelFlag,
      "pressType": _vm.typeLst,
      "pressDat": _vm.resDat,
      "role": "press",
      "organization": _vm.organization
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ssTabList"
  }, [(_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("中华XXXXXXX杂志（电子版）")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('table', {
    staticClass: "tabElement"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term.updatedAt, 'time')))]), _vm._v(" "), _c('td', [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term)
        }
      }
    }, [_vm._v("查看")])], 1), _vm._v(" "), (inx == 0) ? _c('td', {
      attrs: {
        "rowspan": "3"
      }
    }, [(term.code == '401') ? _c('a', {
      attrs: {
        "href": _vm.printUrl
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": _vm.printUrl1
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 3) ? _c('td', [(term.code == '401') ? _c('a', {
      attrs: {
        "href": _vm.printUrl
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": _vm.printUrl1
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.print(term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("查阅时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-icon hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "t": "1492500959545",
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": "1691",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "64",
      "height": "64"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [_c('path', {
    attrs: {
      "d": "M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z",
      "p-id": "1692"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z",
      "p-id": "1693"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z",
      "p-id": "1694"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    class: _vm.isAct,
    attrs: {
      "action": _vm.upUrl,
      "headers": _vm.postHead,
      "before-upload": _vm.prevCtrls,
      "on-success": _vm.successCtrls,
      "file-list": _vm.imgfiles,
      "disabled": _vm.ableSet,
      "list-type": "picture-card",
      "data": _vm.fileData,
      "on-remove": _vm.handleRemove,
      "limit": 1,
      "on-preview": _vm.handlePictureCardPreview,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "visible": _vm.dialogVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.handleLeftRotate(_vm.dialogImageUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(342)
    }
  })]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.handleRightRotate(_vm.dialogImageUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(343)
    }
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgment-5"
  }, [_c('div', {
    staticClass: "func-menu",
    style: ('height:' + _vm.leftHt + 'px')
  }, [_c('el-tree', {
    ref: "tree2",
    staticClass: "filter-tree",
    attrs: {
      "data": _vm.gmpTree,
      "props": _vm.gmpTreeProps,
      "filter-node-method": _vm.filterNode
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "role-list"
  }, [_c('div', {
    staticClass: "scroll-inner",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initPublisherStartBatch(1)
      }
    }
  }, [_vm._v("初始化音像")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initPublisherStartBatch(2)
      }
    }
  }, [_vm._v("初始化电子")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.recheckWorkerSum()
      }
    }
  }, [_vm._v("音像电子人员统计表计算")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.fillReportForLxdz()
      }
    }
  }, [_vm._v("补充连续型出版物整改报告")])], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-inner"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.filterData(_vm.tabDat, _vm.seekStore.where).slice((_vm.currentPage - 1) * _vm.pageSize, _vm.currentPage * _vm.pageSize)
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.$index + 1 + (_vm.currentPage - 1) * _vm.pageSize) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "账号",
      "width": "200",
      "prop": "account"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isDeleted == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("正常")]) : _vm._e(), _vm._v(" "), (scope.row.isDeleted != 1) ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("已禁用")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "200",
      "prop": "organizationName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": _vm.styleSet.edWidth,
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "headSeek",
          attrs: {
            "size": "small",
            "placeholder": "输入关键字搜索"
          },
          model: {
            value: (_vm.seekStore.where),
            callback: function($$v) {
              _vm.$set(_vm.seekStore, "where", $$v)
            },
            expression: "seekStore.where"
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "newAdd",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.userPocts({
                type: 'show',
                code: 1
              })
            }
          }
        }, [_vm._v("新增\n                ")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "btnGroup"
        }, [(scope.row.isDeleted == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.setDeleted(scope.row, 2)
            }
          }
        }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (scope.row.isDeleted != 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.setDeleted(scope.row, 1)
            }
          }
        }, [_vm._v("启用")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.userPocts({
                type: 'show',
                code: 2,
                dats: scope.row
              })
            }
          }
        }, [_vm._v("修改信息")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              _vm.rolePocts({
                type: 'show',
                dats: scope.row
              })
            }
          }
        }, [_vm._v("分配权限\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.rolePocts({
                type: 'resetPwd',
                dats: scope.row
              })
            }
          }
        }, [_vm._v("重置密码\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.userPocts({
                type: 'remove',
                dats: scope.row
              })
            }
          }
        }, [_vm._v("删除账号\n                  ")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "background": "",
      "layout": "total, prev, pager, next",
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "page-sizes": _vm.sizesArray
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgment-5-dag",
    attrs: {
      "title": _vm.userPop.diaTitle,
      "visible": _vm.userPop.diaCtrls,
      "width": "450px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.userPop, "diaCtrls", $event)
      }
    }
  }, [_c('el-row', {
    staticClass: "textRow"
  }, [_c('el-col', {
    staticClass: "ttName",
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("机构名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('span', {
    staticStyle: {
      "line-height": "26px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.userPop.organizationName))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "textRow"
  }, [_c('el-col', {
    staticClass: "ttName",
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.userPop.uName),
      callback: function($$v) {
        _vm.$set(_vm.userPop, "uName", $$v)
      },
      expression: "userPop.uName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "ttName",
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("手机：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.userPop.uPhone),
      callback: function($$v) {
        _vm.$set(_vm.userPop, "uPhone", $$v)
      },
      expression: "userPop.uPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.userPocts({
          type: 'cencel'
        })
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.userPocts({
          type: 'sure'
        })
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgment-5-dag2",
    attrs: {
      "title": "权限配置",
      "visible": _vm.rolePop.diaCtrls,
      "width": "540px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.rolePop, "diaCtrls", $event)
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "ttName",
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("角色：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 21
    }
  }, [
    [_c('el-checkbox-group', {
      staticClass: "checkGp",
      on: {
        "change": _vm.userDefine
      },
      model: {
        value: (_vm.rolePop.chosenArrs),
        callback: function($$v) {
          _vm.$set(_vm.rolePop, "chosenArrs", $$v)
        },
        expression: "rolePop.chosenArrs"
      }
    }, _vm._l((_vm.rolePop.roleArrs), function(role) {
      return _c('el-checkbox', {
        key: role.id,
        attrs: {
          "label": role.id
        }
      }, [_vm._v(_vm._s(role.name) + "\n                ")])
    }))]
  ], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.rolePocts({
          type: 'cencel'
        })
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "inContent",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.rolePocts({
          type: 'sure'
        })
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "操作历史",
      "width": "80%",
      "visible": _vm.dialogVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "操作",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userAccount",
      "label": "账号名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "操作内容"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.content === '暂无内容') ? _c('p', [_vm._v(_vm._s(scope.row.content))]) : _vm._l((scope.row.content), function(val, key) {
          return _c('p', [_vm._v(_vm._s(key) + ": " + _vm._s(val))])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "label": "操作时间"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-count": _vm.historytotalPages,
      "current-page": _vm.no
    },
    on: {
      "current-change": _vm.historyPageChange
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-3"
  }, [_vm._m(0), _vm._v(" "), (_vm.wSat == 1) ? _c('CommonTab', {
    ref: "mainTab",
    attrs: {
      "cancelFlag": false,
      "pressType": "1",
      "pressDat": _vm.resDat
    }
  }) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 2) ? _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "批准文号",
      "align": "center"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "radioBx"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("退回")])], 1), _vm._v(" "), (_vm.params.status == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写退回原因"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("审核")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("音像审核制品")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("音像审核制品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核历史")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核意见")])])
}]}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.sbstatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "sbstatus", $$v)
      },
      expression: "params.sbstatus"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "全部数据"
    }
  }, [_vm._v("全部数据")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "全部上报"
    }
  }, [_vm._v("全部上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "部分上报"
    }
  }, [_vm._v("部分上报")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "未上报"
    }
  }, [_vm._v("未上报")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省局"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "输入省局名称模糊查询"
    },
    model: {
      value: (_vm.params.pname),
      callback: function($$v) {
        _vm.$set(_vm.params, "pname", $$v)
      },
      expression: "params.pname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pname",
      "label": "省局",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sbstatus",
      "label": "状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "出版单位数量",
      "width": "190",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nonum",
      "label": "未上报数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wsnum",
      "label": "待审",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ysnum",
      "label": "已审",
      "align": "center"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-5"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("连续型电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.toCancel
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("整体撤回")])], 1), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.tabPost.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "核验出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.tabPost.total > 1) ? _c('div', {
    staticClass: "pageArea"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tabPost.no,
      "layout": "prev, pager, next",
      "page-count": _vm.tabPost.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table9E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("年份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "year",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.onlyEditMode,
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.year),
      callback: function($$v) {
        _vm.$set(_vm.params, "year", $$v)
      },
      expression: "params.year"
    }
  }, _vm._l((_vm.yearOpts), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), (!_vm.checked) ? [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.onlyEditMode,
      "size": "small",
      "placeholder": "请输入出版物名称"
    },
    model: {
      value: (_vm.params.publicationName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationName", $$v)
      },
      expression: "params.publicationName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专用书号（ISBN 978-7-）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "disabled": "true",
      "prop": "isbn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.onlyEditMode,
      "size": "small",
      "placeholder": "请输入专用书号"
    },
    model: {
      value: (_vm.params.isbn),
      callback: function($$v) {
        _vm.$set(_vm.params, "isbn", $$v)
      },
      expression: "params.isbn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("载体形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.pressType == 1) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.onlyEditMode,
      "size": "small",
      "placeholder": "请选择载体形式"
    },
    on: {
      "change": _vm.numHandle
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C010']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp1[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : (_vm.pressType == 2) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择载体形式"
    },
    on: {
      "change": _vm.numHandle
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp2[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择出版形式"
    },
    model: {
      value: (_vm.params.publicationForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationForm", $$v)
      },
      expression: "params.publicationForm"
    }
  }, _vm._l((_vm.dicDats['C011']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目来源/制作单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "productionUnit",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入节目来源/制作单位"
    },
    model: {
      value: (_vm.params.productionUnit),
      callback: function($$v) {
        _vm.$set(_vm.params, "productionUnit", $$v)
      },
      expression: "params.productionUnit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目时长或容量(分钟/兆)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "programCapacity",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "controls": false,
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.programCapacity),
      callback: function($$v) {
        _vm.$set(_vm.params, "programCapacity", $$v)
      },
      expression: "params.programCapacity"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.numShow) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版数量(张/盒)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationQuantity",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "controls": false,
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationQuantity),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationQuantity", $$v)
      },
      expression: "params.publicationQuantity"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.publishingTimeShow) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishingTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "size": "small",
      "value-formate": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    on: {
      "blur": function($event) {
        _vm.timeTrans(_vm.timeStore.time1, 'publishingTime')
      }
    },
    model: {
      value: (_vm.timeStore.time1),
      callback: function($$v) {
        _vm.$set(_vm.timeStore, "time1", $$v)
      },
      expression: "timeStore.time1"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否书配盘标记：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sign",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择是否书配盘标记"
    },
    model: {
      value: (_vm.params.sign),
      callback: function($$v) {
        _vm.$set(_vm.params, "sign", $$v)
      },
      expression: "params.sign"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("是否为配合本版出版物的音像制品")])], 1)])] : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table8E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fullName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "gender",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name) + "\n                ")])
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "idNumber",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入身份证号或军官证号"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("军官证号填写示例：军字第xxxxxxx号。编号位数据实情填写。")])], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选职务"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C022'][_vm.params.job] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "professionalOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.professionalOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalOther", $$v)
      },
      expression: "params.professionalOther"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "politicalStatus",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择政治面貌"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "culture",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择文化程度"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellphone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "major",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入专业"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "professionalTitleSeries",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择职称系列"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "titleLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择职称级别"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "certificateSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("选择持有证书的，必须上传证书图片才能提交")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("入职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.rzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "rzDate", $$v)
      },
      expression: "params.rzDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("离职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.lzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "lzDate", $$v)
      },
      expression: "params.lzDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("在职不填写")])], 1)]), _vm._v(" "), (_vm.btnCtrls1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("上传出版专业职业资格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.urls1
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isTrainCertificate",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(2)
      }
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("选择持有证书的，必须上传证书图片才能提交")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.btnCtrls2 && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("取得岗位证书时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    class: _vm.highLight == true ? 'hightLight' : '',
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.selectTime
    },
    model: {
      value: (_vm.params.trainCertificateDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "trainCertificateDate", $$v)
      },
      expression: "params.trainCertificateDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("岗位类别为主要负责人和其他负责人时需填写")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.btnCtrls2 && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("上传岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.urls2
    },
    on: {
      "upFileId": _vm.fileTdSet2
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")])])
}]}

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table7E"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isPunishment",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择处罚情况"
    },
    on: {
      "change": _vm.isHandle
    },
    model: {
      value: (_vm.params.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "isPunishment", $$v)
      },
      expression: "params.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [(_vm.basFirm) ? _c('el-form-item', {
    attrs: {
      "prop": "punishment",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1) : _c('el-input', {
    attrs: {
      "rows": 5,
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n              注：\n              填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-7：受处罚情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table6E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "proName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入项目名称"
    },
    model: {
      value: (_vm.params.proName),
      callback: function($$v) {
        _vm.$set(_vm.params, "proName", $$v)
      },
      expression: "params.proName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("重点项目名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "importantProName",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择重点项目名称"
    },
    model: {
      value: (_vm.params.importantProName),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProName", $$v)
      },
      expression: "params.importantProName"
    }
  }, _vm._l((_vm.dicDats['C021']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C021'][_vm.params.importantProName] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "importantProNameOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.importantProNameOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProNameOther", $$v)
      },
      expression: "params.importantProNameOther"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hjLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "hjLevelOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("拟定完成时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ydDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.ydDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "ydDate", $$v)
      },
      expression: "params.ydDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table5E"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖项名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hjName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入奖项名称"
    },
    model: {
      value: (_vm.params.hjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjName", $$v)
      },
      expression: "params.hjName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bzObject",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择表彰对象"
    },
    model: {
      value: (_vm.params.bzObject),
      callback: function($$v) {
        _vm.$set(_vm.params, "bzObject", $$v)
      },
      expression: "params.bzObject"
    }
  }, _vm._l((_vm.dicDats['C023']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖励内容：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "commend",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "size": "small",
      "placeholder": "请输入奖励内容"
    },
    model: {
      value: (_vm.params.commend),
      callback: function($$v) {
        _vm.$set(_vm.params, "commend", $$v)
      },
      expression: "params.commend"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("颁奖单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bjName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入颁奖单位"
    },
    model: {
      value: (_vm.params.bjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "bjName", $$v)
      },
      expression: "params.bjName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("获奖级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hjLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择获奖级别"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "hjLevelOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入获奖级别"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hjDate",
      "inline-message": true
    }
  }, [_c('TimeSelect', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "outTime": _vm.htTime
    },
    on: {
      "time-frash": _vm.timeUpdate
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-5：获得表彰情况登记表")])])
}]}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "placePower",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择场所情况"
    },
    model: {
      value: (_vm.params.placePower),
      callback: function($$v) {
        _vm.$set(_vm.params, "placePower", $$v)
      },
      expression: "params.placePower"
    }
  }, _vm._l((_vm.dicDats['C020']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C020'][_vm.params.placePower] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "otherPower",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.otherPower),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherPower", $$v)
      },
      expression: "params.otherPower"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所所有权：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "placeSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择场所所有权"
    },
    model: {
      value: (_vm.params.placeSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeSituation", $$v)
      },
      expression: "params.placeSituation"
    }
  }, _vm._l((_vm.dicDats['C002']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C002'][_vm.params.placeSituation] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "otherSituation",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("面积（平米）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "placeArea",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.placeArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeArea", $$v)
      },
      expression: "params.placeArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")])])
}]}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年利润(税后)总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度销售收入（万元）\n          ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("发行和销售收入\n          ")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出版活动收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "9"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度支出（万元）\n          ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版团队的"), _c('br'), _vm._v("人员成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）\n          ")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘"), _c('br'), _vm._v("包装等费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("固定资产投入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("培训支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay7", $$v)
      },
      expression: "params.firstPay7"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay7", $$v)
      },
      expression: "params.secondPay7"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay8",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay8", $$v)
      },
      expression: "params.firstPay8"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay8",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay8", $$v)
      },
      expression: "params.secondPay8"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年税费（万元）\n            "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版")]) : _vm._e(), _vm._v("相关的企业所得缴纳税费，含营业税和所得税")])]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度利润（税后）总额（万元）\n          ")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("出版品种\n          ")]), _vm._v(" "), _c('td', [_vm._v("载体出版")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbVariety", $$v)
      },
      expression: "params.firstZtcbVariety"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbVariety", $$v)
      },
      expression: "params.secondZtcbVariety"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("信息网络出版")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbVariety", $$v)
      },
      expression: "params.firstWlcbVariety"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbVariety", $$v)
      },
      expression: "params.secondWlcbVariety"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPublicationVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPublicationVariety", $$v)
      },
      expression: "params.firstPublicationVariety"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPublicationVariety",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPublicationVariety", $$v)
      },
      expression: "params.secondPublicationVariety"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("载体出版\n          ")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("载体出版发行的渠道及占比\n\n            "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("\n            信息网络出版\n          ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("信息网络出版渠道及占比 "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-3：经营情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-2：资质情况表 ———— 音像制品出版许可证")]) : _c('span', [_vm._v("表 1-2：资质情况表 ———— 电子出版物出版许可证")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getcode202HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "xkzNum",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号"
    },
    model: {
      value: (_vm.params.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "xkzNum", $$v)
      },
      expression: "params.xkzNum"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "orgName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“单位名称”项"
    },
    model: {
      value: (_vm.params.orgName),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgName", $$v)
      },
      expression: "params.orgName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "orgAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“单位地址”项"
    },
    model: {
      value: (_vm.params.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgAddr", $$v)
      },
      expression: "params.orgAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cbzMa",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“出版者码”项"
    },
    model: {
      value: (_vm.params.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.params, "cbzMa", $$v)
      },
      expression: "params.cbzMa"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：若没有，请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fddbr",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“法定代表人”项"
    },
    model: {
      value: (_vm.params.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.params, "fddbr", $$v)
      },
      expression: "params.fddbr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yxStartDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.yxStartDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxStartDate", $$v)
      },
      expression: "params.yxStartDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "yxEndDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.yxEndDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxEndDate", $$v)
      },
      expression: "params.yxEndDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "size": "small",
      "placeholder": "请输入出版许可证号上“出版范围”项"
    },
    model: {
      value: (_vm.params.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessScope", $$v)
      },
      expression: "params.businessScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "size": "small",
      "placeholder": "请填写除音像电子出版业务外本单位或本部门经营的其他主要业务"
    },
    model: {
      value: (_vm.params.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherScope", $$v)
      },
      expression: "params.otherScope"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：若没有，请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "approvalTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：请填写出版单位最早获得批复的发文时间")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("上传发文文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('UpbtnPdf', {
    staticClass: "upBtn",
    attrs: {
      "fileID": _vm.publishFileId
    },
    on: {
      "upFileId": _vm.fileTdSetPublishFileId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-top": "5px",
      "line-height": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注：")]), _vm._v("上传最早获得国家出版行政管理部门批复的发文文件，如果无法上传，请上传加盖社章的情况说明文件。\n              "), _c('br'), _vm._v("\n                     上传文件格式为PDF，文件大小不超过10M\n            ")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "size": "small",
      "placeholder": "请输入需要说明的其他情况"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("上传出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_vm._v("\n              注：按照五张图片的上传要求，逐一上传出版许可证相应页面，每张图片必须提供许可证的某一页，不能一张图片中包含多页内容。\n              "), _c('br'), _vm._v("\n              图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。\n              "), _c('br'), _vm._v("\n              每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M。\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("主办及主管单位信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位名称"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.hostType),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostType", $$v)
      },
      expression: "params.hostType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主办单位性质"
    },
    model: {
      value: (_vm.params.hostCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostCategory", $$v)
      },
      expression: "params.hostCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.hostCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "hostOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "需要填写具体主办单位性质"
    },
    model: {
      value: (_vm.params.hostOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostOtherCategory", $$v)
      },
      expression: "params.hostOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位地址"
    },
    model: {
      value: (_vm.params.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostAddr", $$v)
      },
      expression: "params.hostAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位邮政编码"
    },
    model: {
      value: (_vm.params.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPostalcode", $$v)
      },
      expression: "params.hostPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人"
    },
    model: {
      value: (_vm.params.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostLinkman", $$v)
      },
      expression: "params.hostLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人座机号码"
    },
    model: {
      value: (_vm.params.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostTel", $$v)
      },
      expression: "params.hostTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostPhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人手机号码"
    },
    model: {
      value: (_vm.params.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPhone", $$v)
      },
      expression: "params.hostPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位名称"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.chargeType),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeType", $$v)
      },
      expression: "params.chargeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主管单位性质"
    },
    model: {
      value: (_vm.params.chargeCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeCategory", $$v)
      },
      expression: "params.chargeCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.chargeCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "chargeOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "需要填写具体主管单位性质"
    },
    model: {
      value: (_vm.params.chargeOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeOtherCategory", $$v)
      },
      expression: "params.chargeOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位地址"
    },
    model: {
      value: (_vm.params.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeAddr", $$v)
      },
      expression: "params.chargeAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargePostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位邮政编码"
    },
    model: {
      value: (_vm.params.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePostalcode", $$v)
      },
      expression: "params.chargePostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人"
    },
    model: {
      value: (_vm.params.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeLinkman", $$v)
      },
      expression: "params.chargeLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人座机号码"
    },
    model: {
      value: (_vm.params.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeTel", $$v)
      },
      expression: "params.chargeTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargePhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人手机号码"
    },
    model: {
      value: (_vm.params.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePhone", $$v)
      },
      expression: "params.chargePhone"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版许可证信息（请按照出版许可证上的信息填写）")])])
}]}

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-1：基本情况表")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getcode201HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            单位名称：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "usccNum",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“统一社会信用代码”项"
    },
    model: {
      value: (_vm.params.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccNum", $$v)
      },
      expression: "params.usccNum"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "usccType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择营业执照上“类型”项"
    },
    model: {
      value: (_vm.params.usccType),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccType", $$v)
      },
      expression: "params.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "residence",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“住所”项"
    },
    model: {
      value: (_vm.params.residence),
      callback: function($$v) {
        _vm.$set(_vm.params, "residence", $$v)
      },
      expression: "params.residence"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "faren",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入工商营业执照上“法定代表人”项"
    },
    model: {
      value: (_vm.params.faren),
      callback: function($$v) {
        _vm.$set(_vm.params, "faren", $$v)
      },
      expression: "params.faren"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v(" 注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yyzzZczb",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyzzZczb", $$v)
      },
      expression: "params.yyzzZczb"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "clDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.clDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "clDate", $$v)
      },
      expression: "params.clDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "startYyDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.startYyDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "startYyDate", $$v)
      },
      expression: "params.startYyDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(3)
      }
    },
    model: {
      value: (_vm.params.endYyDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "endYyDate", $$v)
      },
      expression: "params.endYyDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注：营业执照有效期为长期的，无须填写结束日期")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yyfw",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入工商营业执照上“经营范围”项",
      "size": "small"
    },
    model: {
      value: (_vm.params.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyfw", $$v)
      },
      expression: "params.yyfw"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "djDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(4)
      }
    },
    model: {
      value: (_vm.params.djDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "djDate", $$v)
      },
      expression: "params.djDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入工商营业执照上“证照编号”项",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccCode", $$v)
      },
      expression: "params.usccCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("没有请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("上传营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_vm._v("注：图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。\n              "), _c('br'), _vm._v("\n              上传文件格式为JPEG/PNG，文件大小不超过10M。\n            ")]), _vm._v(" "), _c('Upbtn', {
    attrs: {
      "ableSure": _vm.imgId,
      "needTip": "no"
    },
    on: {
      "upFileId": _vm.fileTdSet
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("单位基本信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nature",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择企业性质"
    },
    model: {
      value: (_vm.params.nature),
      callback: function($$v) {
        _vm.$set(_vm.params, "nature", $$v)
      },
      expression: "params.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "otherNature",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "若企业性质为“其他”，请输入"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isIndependentLP",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.layChange
    },
    model: {
      value: (_vm.params.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.params, "isIndependentLP", $$v)
      },
      expression: "params.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "tip-red"
  }, [_vm._v("以音像电子业务为主体业务的独立法人单位填写\"是\"，其他单位填写\"否\"")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "unitType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择单位类型"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "independentLPSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择隶属关系"
    },
    model: {
      value: (_vm.params.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "independentLPSituation", $$v)
      },
      expression: "params.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "nonIndependentLPSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择隶属关系"
    },
    model: {
      value: (_vm.params.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "nonIndependentLPSituation", $$v)
      },
      expression: "params.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位地址"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位邮编"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人座机号码"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入单位联系人手机号码"
    },
    model: {
      value: (_vm.params.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPhone", $$v)
      },
      expression: "params.publishPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": _vm.layDasion == 2,
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalAssets", $$v)
      },
      expression: "params.totalAssets"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": _vm.layDasion == 2,
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalLiabilities", $$v)
      },
      expression: "params.totalLiabilities"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n              注：请填写出版单位其他需要说明的相关信息，譬如注册资金为美元、法人变更在进行中等情况，如没有不填写\n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("工商营业执照或事业法人证书信息（请按照营业执照或事业法人证书上的信息填写）")])])
}]}

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "21"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_vm._v("注销或拟注销")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("（若省局已经审核完成，请点击“上报国家新闻出版署”。）")]), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + _vm.postDat.size * (_vm.postDat.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row.sjViewDate, "time")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "省局意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "sjstatus")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "state")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0 || scope.row.progress == '省局') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("审核")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pg3_1dig",
    attrs: {
      "visible": _vm.backdiag,
      "modal": true,
      "close-on-click-modal": false,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.backdiag = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.backtype == 3) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zanhuanMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zanhuanMessage", $$v)
      },
      expression: "params.zanhuanMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zhuxiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zhuxiaoMessage", $$v)
      },
      expression: "params.zhuxiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.chexiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "chexiaoMessage", $$v)
      },
      expression: "params.chexiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.arrExam
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("音像制品出版单位审核")])])
}]}

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pass-code"
  }, [_c('div', {
    staticClass: "title_bar"
  }, [(!_vm.forcePass) ? _c('span', [_vm._v("密码修改")]) : _c('span', [_vm._v("首次登陆，请先重置您的密码！")])]), _vm._v(" "), _c('div', {
    staticClass: "codeArea"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "textName"
  }, [_vm._v("原始密码")]), _vm._v(" "), _c('td', {
    staticClass: "textInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "oldPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": this.pwdtype,
      "placeholder": "请输入初始密码",
      "size": "small"
    },
    model: {
      value: (_vm.ruleForm.oldPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "oldPwd", $$v)
      },
      expression: "ruleForm.oldPwd"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "22px",
      "height": "22px",
      "top": "10px",
      "right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": this.pwdtype == 'text' ? _vm.pwd_hide : _vm.pwd_show,
      "alt": "登录密码"
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textName"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('td', {
    staticClass: "textInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "8-18 位数字 + 字母组合",
      "type": this.pwdtype,
      "size": "small"
    },
    model: {
      value: (_vm.ruleForm.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "newPwd", $$v)
      },
      expression: "ruleForm.newPwd"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "22px",
      "height": "22px",
      "top": "10px",
      "right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": this.pwdtype == 'text' ? _vm.pwd_hide : _vm.pwd_show,
      "alt": "登录密码"
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textName"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('td', {
    staticClass: "textInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "sureCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "8-18 位数字 + 字母组合",
      "type": this.pwdtype,
      "size": "small"
    },
    model: {
      value: (_vm.ruleForm.sureCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sureCode", $$v)
      },
      expression: "ruleForm.sureCode"
    }
  })], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "22px",
      "height": "22px",
      "top": "10px",
      "right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": this.pwdtype == 'text' ? _vm.pwd_hide : _vm.pwd_show,
      "alt": "显示密码"
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "textName"
  }), _vm._v(" "), _c('td', {
    staticClass: "textInp text-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ruleForm')
      }
    }
  }, [_c('span', [_vm._v("保存")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submiting),
      expression: "submiting"
    }],
    staticClass: "el-icon-loading"
  })])], 1)])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": true,
      "default-openeds": _vm.defaultOpeneds,
      "default-active": _vm.$route.path
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版物基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.modifyFlag) ? _c('el-button', {
    staticClass: "importBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getCode401HistoryData
    }
  }, [_vm._v("导入历史数据")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物中文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publication",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publication),
      callback: function($$v) {
        _vm.$set(_vm.params, "publication", $$v)
      },
      expression: "params.publication"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物外文名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationEnglish",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入出版物外文名称"
    },
    model: {
      value: (_vm.params.publicationEnglish),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationEnglish", $$v)
      },
      expression: "params.publicationEnglish"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "category",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择类别"
    },
    model: {
      value: (_vm.params.category),
      callback: function($$v) {
        _vm.$set(_vm.params, "category", $$v)
      },
      expression: "params.category"
    }
  }, _vm._l((_vm.dicDats['C026']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "recordType",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入文种"
    },
    model: {
      value: (_vm.params.recordType),
      callback: function($$v) {
        _vm.$set(_vm.params, "recordType", $$v)
      },
      expression: "params.recordType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "periodicals",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择刊期"
    },
    model: {
      value: (_vm.params.periodicals),
      callback: function($$v) {
        _vm.$set(_vm.params, "periodicals", $$v)
      },
      expression: "params.periodicals"
    }
  }, _vm._l((_vm.dicDats['C014']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("刊号（CN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入刊号"
    },
    model: {
      value: (_vm.params.cn),
      callback: function($$v) {
        _vm.$set(_vm.params, "cn", $$v)
      },
      expression: "params.cn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("国际刊号（ISSN）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issn",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入国际刊号"
    },
    model: {
      value: (_vm.params.issn),
      callback: function($$v) {
        _vm.$set(_vm.params, "issn", $$v)
      },
      expression: "params.issn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("批准时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "approvalTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "size": "small",
      "placeholder": "请选择获批时间"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("上传批复文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('UpbtnPdf', {
    staticClass: "upBtn",
    attrs: {
      "fileID": _vm.applyFileId
    },
    on: {
      "upFileId": _vm.fileTdSetApplyFileId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-top": "5px",
      "line-height": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注：")]), _vm._v("请上传国家出版行政管理部门同意创办的批复文件，如有特殊情况无法上传，\n              "), _c('br'), _vm._v("       请对无法上传情况进行说明，上传加盖社章的说明文件。\n              "), _c('br'), _vm._v("\n                    上传文件格式为PDF，文件大小不超过10M\n            ")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("媒体形态：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "mediaForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.mediaHandle
    },
    model: {
      value: (_vm.params.mediaForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "mediaForm", $$v)
      },
      expression: "params.mediaForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code,
        "placeholder": "请选择媒体形态"
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaType[_vm.params.mediaForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "mediaFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.mediaFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "mediaFormQT", $$v)
      },
      expression: "params.mediaFormQT"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否缴送样本：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isSampleDelivery",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isSampleDelivery),
      callback: function($$v) {
        _vm.$set(_vm.params, "isSampleDelivery", $$v)
      },
      expression: "params.isSampleDelivery"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("按规定向国家版本馆、国家图书馆缴送样本")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publicationScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small",
      "placeholder": "请输入出版范围"
    },
    model: {
      value: (_vm.params.publicationScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationScope", $$v)
      },
      expression: "params.publicationScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("发行范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "issueScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small",
      "placeholder": "请输入发行范围"
    },
    model: {
      value: (_vm.params.issueScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "issueScope", $$v)
      },
      expression: "params.issueScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("读者对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "readers",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small",
      "placeholder": "请输入读者对象"
    },
    model: {
      value: (_vm.params.readers),
      callback: function($$v) {
        _vm.$set(_vm.params, "readers", $$v)
      },
      expression: "params.readers"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab2E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版单位基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.modifyFlag) ? _c('el-button', {
    staticClass: "importBtn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getCode402HistoryData
    }
  }, [_vm._v("导入历史数据")]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n    注：本表中所指“连续型电子出版物出版单位”，是指依照《电子出版物出版管理规定》经批准办理审批和履行登记手续的出版单位，法人单位出版连续型电子出版物且不再设立法人出版单位的，其设立的连续型电子出版物编辑部视为连续型电子出版物出版单位。\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物品种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "type": "input",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.pzs),
      callback: function($$v) {
        _vm.pzs = $$v
      },
      expression: "pzs"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物出版单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "workers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物业务人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其中取得中级以上资格证书人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法人身份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "unitType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C016']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("演变情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "evolution",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small"
    },
    model: {
      value: (_vm.params.evolution),
      callback: function($$v) {
        _vm.$set(_vm.params, "evolution", $$v)
      },
      expression: "params.evolution"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("出版单位（主办单位）"), _c('br'), _vm._v("具有的出版资质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营收高于出版业务"), _c('br'), _vm._v("的其他主营业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherbusiness",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  }), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "8"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度销售收入（万元）")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("国内发行和销售收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales1",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("海外发行收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("与出版相关活动收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("连续型电子出版物"), _c('br'), _vm._v("及新媒体网站上"), _c('br'), _vm._v("所做广告收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales6", $$v)
      },
      expression: "params.firstSales6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales6", $$v)
      },
      expression: "params.secondSales6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales7", $$v)
      },
      expression: "params.firstSales7"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales7",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales7", $$v)
      },
      expression: "params.secondSales7"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "7"
    }
  }, [_vm._v("连续型电子出版物年度支出（万元）")]), _vm._v(" "), _c('td', [_vm._v("出版团队的人员"), _c('br'), _vm._v("成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘包装等费用")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay5",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay6",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondPay",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n            连续型电子出版物年税费（万元）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与连续型电子出版相关的企业所得缴纳税费，含营业税和所得税。")])]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondTax",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("年度利润（税后）总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFund",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSuperior",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("载体出版"), _c('br'), _vm._v("经营情况")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSalesVolumes",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [_vm._v("\n            载体出版发行的渠道及占比\n            "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne2",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne3",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondZtcbDistributionChanne4",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版"), _c('br'), _vm._v("\n            经营情况\n          ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbSales",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbProfit",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n            信息网络出版渠道及占比\n            "), _c('br'), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondWlcbDistributionChanne1",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "10px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("如果在网络营销平台同时发行载体出版物，对应销售收入及利润总额也应计入网络出版相关细目。")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityCn", $$v)
      },
      expression: "params.firstIssueQuantityCn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityCn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityCn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityCn", $$v)
      },
      expression: "params.secondIssueQuantityCn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("国内发行单价(元)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstUnitPrice", $$v)
      },
      expression: "params.firstUnitPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondUnitPrice",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondUnitPrice),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondUnitPrice", $$v)
      },
      expression: "params.secondUnitPrice"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("海外发行数量(套)")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstIssueQuantityFn", $$v)
      },
      expression: "params.firstIssueQuantityFn"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondIssueQuantityFn",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondIssueQuantityFn),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondIssueQuantityFn", $$v)
      },
      expression: "params.secondIssueQuantityFn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("收文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSwl", $$v)
      },
      expression: "params.firstSwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondSwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSwl", $$v)
      },
      expression: "params.secondSwl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("录用量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstLyl", $$v)
      },
      expression: "params.firstLyl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondLyl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondLyl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondLyl", $$v)
      },
      expression: "params.secondLyl"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("发文量")]), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "firstFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFwl", $$v)
      },
      expression: "params.firstFwl"
    }
  })], 1)], 1), _vm._v(" "), _c('td', [_c('el-form-item', {
    attrs: {
      "prop": "secondFwl",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFwl),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFwl", $$v)
      },
      expression: "params.secondFwl"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns",
    staticStyle: {
      "float": "right"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "type",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fullName",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "gender",
      "inline-message": true
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.tabSeek
    },
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "idNumber",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("军官证号填写示例：军字第xxxxxxx号。编号位数据实情填写。")])], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择职务"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.dicMap['C022'][_vm.params.job] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "professionalOther",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.professionalOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalOther", $$v)
      },
      expression: "params.professionalOther"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "politicalStatus",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "culture",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellphone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "major",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "professionalTitleSeries",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "titleLevel",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "certificateSituation",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "isTrainCertificate",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.btnCtrls(1)
      }
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [_vm._v("保存")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")])])
}]}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab1E"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("围绕本连续型电子"), _c('br'), _vm._v("出版物自行开设并运营"), _c('br'), _vm._v("的项目：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站(数据平台）"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), (_vm.params.operationProjectOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.operationProjectOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherFill", $$v)
      },
      expression: "params.operationProjectOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            获取文章数字传播权主要方式：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "在期刊刊登声明，投稿即视为授权"
    },
    model: {
      value: (_vm.params.getGPLMethodSubmit),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodSubmit", $$v)
      },
      expression: "params.getGPLMethodSubmit"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "在投审稿平台予以提示，同意授权方可投稿"
    },
    model: {
      value: (_vm.params.getGPLMethodTip),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodTip", $$v)
      },
      expression: "params.getGPLMethodTip"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "与作者签订一对一的数字传播权授权合同"
    },
    model: {
      value: (_vm.params.getGPLMethodAuthor),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodAuthor", $$v)
      },
      expression: "params.getGPLMethodAuthor"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "其他",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.getGPLMethodOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodOther", $$v)
      },
      expression: "params.getGPLMethodOther"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    staticClass: "avgchbox",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.getGPLMethodEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "getGPLMethodEmpty", $$v)
      },
      expression: "params.getGPLMethodEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("数据平台建设和合作情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.databasePlatformOwner),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformOwner", $$v)
      },
      expression: "params.databasePlatformOwner"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("自建")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("共建")])], 1), _vm._v(" "), (_vm.params.databasePlatformOwner == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请填写平台名称"
    },
    model: {
      value: (_vm.params.databasePlatformName),
      callback: function($$v) {
        _vm.$set(_vm.params, "databasePlatformName", $$v)
      },
      expression: "params.databasePlatformName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否与国际出版商开展合作：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.internationpublisher),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisher", $$v)
      },
      expression: "params.internationpublisher"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.internationpublisher == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请填写合作商名称"
    },
    model: {
      value: (_vm.params.internationpublisherName),
      callback: function($$v) {
        _vm.$set(_vm.params, "internationpublisherName", $$v)
      },
      expression: "params.internationpublisherName"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否被知名数据库收录：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.collectdatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabase", $$v)
      },
      expression: "params.collectdatabase"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '0'
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.params.collectdatabase == 1) ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请填写数据库名称"
    },
    model: {
      value: (_vm.params.collectdatabaseName),
      callback: function($$v) {
        _vm.$set(_vm.params, "collectdatabaseName", $$v)
      },
      expression: "params.collectdatabaseName"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位领导：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumZbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumZbSld", $$v)
      },
      expression: "params.pepnumZbSld"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("编辑人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumZbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumZbBjry", $$v)
      },
      expression: "params.pepnumZbBjry"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等"), _c('br'), _vm._v("相关人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专职发行人员：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员"), _c('br'), _vm._v("（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数"), _c('br'), _vm._v("（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small",
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  })], 1), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版经营情况调查表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    style: (_vm.params.chartHeight),
    attrs: {
      "id": _vm.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": _vm.params.id + '_table'
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.params.id)
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": Object.keys(_vm.params.columnMap[_vm.params.id]).length <= 4 ? 6 : 4
      }
    }, [_c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.params.columnMap[_vm.params.id][key]
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.params.id + '_tab'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts(_vm.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n              " + _vm._s(_vm.params.columnMap[_vm.params.id][key]) + "\n              "), _c('i', {
      class: _vm.querySort[_vm.params.id][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort[_vm.params.id][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort[_vm.params.id][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort[_vm.params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData(_vm.params.id, key, _vm.querySort[_vm.params.id][key])
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fht-cell"
    }, [(_vm.queryVisible[_vm.params.id]) ? _c('el-input', {
      staticClass: "searchInput",
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": _vm.params.id + '_html'
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'wait' || _vm.upState == 'loaded'),
      expression: "upState == 'wait' || upState == 'loaded'"
    }],
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "aciton": _vm.loadUrl,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "multiple": "",
      "limit": 2,
      "on-exceed": _vm.handleExceed,
      "headers": _vm.postHead
    }
  }, [(_vm.upState == 'wait') ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("更新")]) : _vm._e()], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage,
      "width": 45,
      "stroke-width": 3
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.filesDown
    }
  }, [_vm._v("\n      下载\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    style: (_vm.params.chartHeight),
    attrs: {
      "id": _vm.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": _vm.params.id + '_table'
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.params.id)
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": Object.keys(_vm.params.columnMap[_vm.params.id]).length <= 4 ? 6 : 4
      }
    }, [_c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.params.columnMap[_vm.params.id][key]
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.params.id + '_tab'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts(_vm.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n              " + _vm._s(_vm.params.columnMap[_vm.params.id][key]) + "\n              "), _c('i', {
      class: _vm.querySort[_vm.params.id][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort[_vm.params.id][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort[_vm.params.id][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort[_vm.params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData(_vm.params.id, key, _vm.querySort[_vm.params.id][key])
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fht-cell"
    }, [(_vm.queryVisible[_vm.params.id]) ? _c('el-input', {
      staticClass: "searchInput",
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": _vm.params.id + '_html'
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccNum", $$v)
      },
      expression: "params.usccNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.usccType),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccType", $$v)
      },
      expression: "params.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.residence),
      callback: function($$v) {
        _vm.$set(_vm.params, "residence", $$v)
      },
      expression: "params.residence"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.faren),
      callback: function($$v) {
        _vm.$set(_vm.params, "faren", $$v)
      },
      expression: "params.faren"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyzzZczb", $$v)
      },
      expression: "params.yyzzZczb"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.clDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "clDate", $$v)
      },
      expression: "params.clDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "635px"
    },
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "size": "small",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.params.areaDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "areaDate", $$v)
      },
      expression: "params.areaDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyfw", $$v)
      },
      expression: "params.yyfw"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.djDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "djDate", $$v)
      },
      expression: "params.djDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccCode", $$v)
      },
      expression: "params.usccCode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "imgfram"
  }, [_c('img', {
    attrs: {
      "width": "250",
      "src": _vm.imgUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishName !== _vm.params.publishName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishName", $$v)
      },
      expression: "historyJsonParams.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccNum !== _vm.params.usccNum ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccNum", $$v)
      },
      expression: "historyJsonParams.usccNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccOrgName !== _vm.params.usccOrgName ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccOrgName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccOrgName", $$v)
      },
      expression: "historyJsonParams.usccOrgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.usccType !== _vm.params.usccType ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.usccType),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccType", $$v)
      },
      expression: "historyJsonParams.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.residence !== _vm.params.residence ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.residence),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "residence", $$v)
      },
      expression: "historyJsonParams.residence"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.faren !== _vm.params.faren ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.faren),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "faren", $$v)
      },
      expression: "historyJsonParams.faren"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.yyzzZczb !== _vm.params.yyzzZczb ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "yyzzZczb", $$v)
      },
      expression: "historyJsonParams.yyzzZczb"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.clDate !== _vm.params.clDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.clDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "clDate", $$v)
      },
      expression: "historyJsonParams.clDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "historyJsonParams.startYyDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.startYyDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "startYyDate", $$v)
      },
      expression: "historyJsonParams.startYyDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.endYyDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "endYyDate", $$v)
      },
      expression: "historyJsonParams.endYyDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.yyfw !== _vm.params.yyfw ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "yyfw", $$v)
      },
      expression: "historyJsonParams.yyfw"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.djDate !== _vm.params.djDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.djDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "djDate", $$v)
      },
      expression: "historyJsonParams.djDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccCode !== _vm.params.usccCode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccCode", $$v)
      },
      expression: "historyJsonParams.usccCode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "imgfram"
  }, [_c('img', {
    attrs: {
      "src": _vm.historyImgUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("单位基本信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.nature),
      callback: function($$v) {
        _vm.$set(_vm.params, "nature", $$v)
      },
      expression: "params.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.params, "isIndependentLP", $$v)
      },
      expression: "params.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注：以音像电子业务为主体业务的独立法人单位填写\"是\"，其他单位填写\"否\"")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "independentLPSituation", $$v)
      },
      expression: "params.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "nonIndependentLPSituation", $$v)
      },
      expression: "params.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPhone", $$v)
      },
      expression: "params.publishPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n              从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalAssets", $$v)
      },
      expression: "params.totalAssets"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalLiabilities", $$v)
      },
      expression: "params.totalLiabilities"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.nature !== _vm.params.nature ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.nature),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "nature", $$v)
      },
      expression: "historyJsonParams.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "若企业性质为“其他”，请输入"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.isIndependentLP !== _vm.params.isIndependentLP ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "isIndependentLP", $$v)
      },
      expression: "historyJsonParams.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tip-red"
  }, [_vm._v("以音像电子业务为主体业务的独立法人单位填写“是”，其他单位填写“否”")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.unitType !== _vm.params.unitType ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.unitType),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "unitType", $$v)
      },
      expression: "historyJsonParams.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.independentLPSituation !== _vm.params.independentLPSituation ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "independentLPSituation", $$v)
      },
      expression: "historyJsonParams.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.nonIndependentLPSituation !== _vm.params.nonIndependentLPSituation ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "nonIndependentLPSituation", $$v)
      },
      expression: "historyJsonParams.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishAddr !== _vm.params.publishAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishAddr", $$v)
      },
      expression: "historyJsonParams.publishAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishPostalcode !== _vm.params.publishPostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishPostalcode", $$v)
      },
      expression: "historyJsonParams.publishPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishLinkman !== _vm.params.publishLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishLinkman", $$v)
      },
      expression: "historyJsonParams.publishLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishTel !== _vm.params.publishTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishTel", $$v)
      },
      expression: "historyJsonParams.publishTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishPhone !== _vm.params.publishPhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishPhone", $$v)
      },
      expression: "historyJsonParams.publishPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "numLine",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.workers !== _vm.params.workers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.workers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "workers", $$v)
      },
      expression: "historyJsonParams.workers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("\n                  从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.businessWorkers !== _vm.params.businessWorkers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "businessWorkers", $$v)
      },
      expression: "historyJsonParams.businessWorkers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.otherWorkers !== _vm.params.otherWorkers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherWorkers", $$v)
      },
      expression: "historyJsonParams.otherWorkers"
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "numLine",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.totalAssets !== _vm.params.totalAssets ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "totalAssets", $$v)
      },
      expression: "historyJsonParams.totalAssets"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.totalLiabilities !== _vm.params.totalLiabilities ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "totalLiabilities", $$v)
      },
      expression: "historyJsonParams.totalLiabilities"
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp spMake"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    class: _vm.historyJsonParams.remark !== _vm.params.remark ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.remark),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "remark", $$v)
      },
      expression: "historyJsonParams.remark"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.params.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-1：基本情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("工商营业执照或事业法人证书信息")])])
}]}

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-2：资质情况表 ———— 音像制品出版许可证")]) : _c('span', [_vm._v("表 1-2：资质情况表 ———— 电子出版物出版许可证")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "xkzNum", $$v)
      },
      expression: "params.xkzNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.orgName),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgName", $$v)
      },
      expression: "params.orgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgAddr", $$v)
      },
      expression: "params.orgAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.params, "cbzMa", $$v)
      },
      expression: "params.cbzMa"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.params, "fddbr", $$v)
      },
      expression: "params.fddbr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yxStartDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.yxStartDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxStartDate", $$v)
      },
      expression: "params.yxStartDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "yxEndDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.yxEndDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxEndDate", $$v)
      },
      expression: "params.yxEndDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessScope", $$v)
      },
      expression: "params.businessScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherScope", $$v)
      },
      expression: "params.otherScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("发文文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.params.publishFileId) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.filesDown(_vm.params.publishFileId)
      }
    }
  }, [_vm._v("\n                下载\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.params.publishFileId) ? _c('span', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "size": "mini",
      "type": "danger"
    }
  }, [_vm._v(" 未上传 ")]) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.xkzNum !== _vm.params.xkzNum ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "xkzNum", $$v)
      },
      expression: "historyJsonParams.xkzNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.orgName !== _vm.params.orgName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.orgName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "orgName", $$v)
      },
      expression: "historyJsonParams.orgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.orgAddr !== _vm.params.orgAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "orgAddr", $$v)
      },
      expression: "historyJsonParams.orgAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.cbzMa !== _vm.params.cbzMa ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "cbzMa", $$v)
      },
      expression: "historyJsonParams.cbzMa"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.fddbr !== _vm.params.fddbr ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "fddbr", $$v)
      },
      expression: "historyJsonParams.fddbr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.areaDate !== _vm.params.areaDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "type": "daterange",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.historyJsonParams.areaDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "areaDate", $$v)
      },
      expression: "historyJsonParams.areaDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.businessScope !== _vm.params.businessScope ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 8,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "businessScope", $$v)
      },
      expression: "historyJsonParams.businessScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.otherScope !== _vm.params.otherScope ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherScope", $$v)
      },
      expression: "historyJsonParams.otherScope"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.approvalTime !== _vm.params.approvalTime ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "approvalTime", $$v)
      },
      expression: "historyJsonParams.approvalTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.otherSituation !== _vm.params.otherSituation ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherSituation", $$v)
      },
      expression: "historyJsonParams.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "viewType": "2",
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("主办及主管单位信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.hostType),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostType", $$v)
      },
      expression: "params.hostType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主办单位性质"
    },
    model: {
      value: (_vm.params.hostCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostCategory", $$v)
      },
      expression: "params.hostCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.hostCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "hostOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "需要填写具体主办单位性质"
    },
    model: {
      value: (_vm.params.hostOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostOtherCategory", $$v)
      },
      expression: "params.hostOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostAddr", $$v)
      },
      expression: "params.hostAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPostalcode", $$v)
      },
      expression: "params.hostPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostLinkman", $$v)
      },
      expression: "params.hostLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostTel", $$v)
      },
      expression: "params.hostTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPhone", $$v)
      },
      expression: "params.hostPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.chargeType),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeType", $$v)
      },
      expression: "params.chargeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主管单位性质"
    },
    model: {
      value: (_vm.params.chargeCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeCategory", $$v)
      },
      expression: "params.chargeCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.chargeCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "chargeOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "需要填写具体主管单位性质"
    },
    model: {
      value: (_vm.params.chargeOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeOtherCategory", $$v)
      },
      expression: "params.chargeOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeAddr", $$v)
      },
      expression: "params.chargeAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePostalcode", $$v)
      },
      expression: "params.chargePostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeLinkman", $$v)
      },
      expression: "params.chargeLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeTel", $$v)
      },
      expression: "params.chargeTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePhone", $$v)
      },
      expression: "params.chargePhone"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostName !== _vm.params.hostName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostName", $$v)
      },
      expression: "historyJsonParams.hostName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostAddr !== _vm.params.hostAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostAddr", $$v)
      },
      expression: "historyJsonParams.hostAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostPostalcode !== _vm.params.hostPostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostPostalcode", $$v)
      },
      expression: "historyJsonParams.hostPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostLinkman !== _vm.params.hostLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostLinkman", $$v)
      },
      expression: "historyJsonParams.hostLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostTel !== _vm.params.hostTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostTel", $$v)
      },
      expression: "historyJsonParams.hostTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.hostPhone !== _vm.params.hostPhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "hostPhone", $$v)
      },
      expression: "historyJsonParams.hostPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeName !== _vm.params.chargeName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeName", $$v)
      },
      expression: "historyJsonParams.chargeName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeAddr !== _vm.params.chargeAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeAddr", $$v)
      },
      expression: "historyJsonParams.chargeAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargePostalcode !== _vm.params.chargePostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargePostalcode", $$v)
      },
      expression: "historyJsonParams.chargePostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeLinkman !== _vm.params.chargeLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeLinkman", $$v)
      },
      expression: "historyJsonParams.chargeLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargeTel !== _vm.params.chargeTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargeTel", $$v)
      },
      expression: "historyJsonParams.chargeTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.chargePhone !== _vm.params.chargePhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "chargePhone", $$v)
      },
      expression: "historyJsonParams.chargePhone"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.params.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版许可证信息（请按照出版许可证上的信息填写）")])])
}]}

/***/ }),
/* 1759 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年利润(税后)总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度销售收入（万元）\n            ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("发行和销售收入\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出版活动收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "9"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度支出（万元）\n            ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版团队的"), _c('br'), _vm._v("人员成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘"), _c('br'), _vm._v("包装等费用")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("固定资产投入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("培训支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay7", $$v)
      },
      expression: "params.firstPay7"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay7", $$v)
      },
      expression: "params.secondPay7"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay8", $$v)
      },
      expression: "params.firstPay8"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay8", $$v)
      },
      expression: "params.secondPay8"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年税费（万元）\n              "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版")]) : _vm._e(), _vm._v("相关的企业所得缴纳税费，含营业税和所得税")])]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度利润（税后）总额（万元）\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("出版品种\n            ")]), _vm._v(" "), _c('td', [_vm._v("载体出版")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbVariety", $$v)
      },
      expression: "params.firstZtcbVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbVariety", $$v)
      },
      expression: "params.secondZtcbVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("信息网络出版")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbVariety", $$v)
      },
      expression: "params.firstWlcbVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbVariety", $$v)
      },
      expression: "params.secondWlcbVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("总计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPublicationVariety", $$v)
      },
      expression: "params.firstPublicationVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPublicationVariety", $$v)
      },
      expression: "params.secondPublicationVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("载体出版\n            ")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("载体出版发行的渠道及占比\n\n              "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("\n              信息网络出版\n            ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("信息网络出版渠道及占比 "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-3：经营情况表")])])
}]}

/***/ }),
/* 1760 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table4E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.placeSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeSituation", $$v)
      },
      expression: "params.placeSituation"
    }
  }, _vm._l((_vm.dicDats['C002']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C002'][_vm.params.placeSituation] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("场所所有权：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.placePower),
      callback: function($$v) {
        _vm.$set(_vm.params, "placePower", $$v)
      },
      expression: "params.placePower"
    }
  }, _vm._l((_vm.dicDats['C020']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C020'][_vm.params.placePower] == '其他') ? _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.otherPower),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherPower", $$v)
      },
      expression: "params.otherPower"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("面积（平米）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "placeArea",
      "show-message": false
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.placeArea),
      callback: function($$v) {
        _vm.$set(_vm.params, "placeArea", $$v)
      },
      expression: "params.placeArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-4：经营场所情况表")])])
}]}

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table5E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖项名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjName", $$v)
      },
      expression: "params.hjName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰对象：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.bzObject),
      callback: function($$v) {
        _vm.$set(_vm.params, "bzObject", $$v)
      },
      expression: "params.bzObject"
    }
  }, _vm._l((_vm.dicDats['C023']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("奖励内容：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.commend),
      callback: function($$v) {
        _vm.$set(_vm.params, "commend", $$v)
      },
      expression: "params.commend"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("颁奖单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.bjName),
      callback: function($$v) {
        _vm.$set(_vm.params, "bjName", $$v)
      },
      expression: "params.bjName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("获奖级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("表彰时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjDate", $$v)
      },
      expression: "params.hjDate"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 5：获得表彰情况登记表")])])
}]}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table6E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("项目名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.proName),
      callback: function($$v) {
        _vm.$set(_vm.params, "proName", $$v)
      },
      expression: "params.proName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("重点项目名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.importantProName),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProName", $$v)
      },
      expression: "params.importantProName"
    }
  }, _vm._l((_vm.dicDats['C021']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C021'][_vm.params.importantProName] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.importantProNameOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProNameOther", $$v)
      },
      expression: "params.importantProNameOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("拟定完成时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.ydDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "ydDate", $$v)
      },
      expression: "params.ydDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "disabled": "",
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1763 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table7E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    staticClass: "editBox",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "isPunishment", $$v)
      },
      expression: "params.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                注：\n                填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n              ")])])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.isPunishment !== _vm.params.isPunishment ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "isPunishment", $$v)
      },
      expression: "historyJsonParams.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.punishment !== _vm.params.punishment ? 'highlight' : '',
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.punishment),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "punishment", $$v)
      },
      expression: "historyJsonParams.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                注：\n                填写2021年和2022年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n              ")])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-7：受处罚情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1764 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table8E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择文化程度"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("入职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.rzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "rzDate", $$v)
      },
      expression: "params.rzDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("离职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.lzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "lzDate", $$v)
      },
      expression: "params.lzDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("在职不填写")])], 1)]), _vm._v(" "), (_vm.params.professionalCertificateId && _vm.params.certificateSituation != 'ff8080816892204e0168fe6728c70902') ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版专业职业资格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.params.professionalCertificateId,
      "viewType": "2"
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.trainCertificateId && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("取得岗位证书时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    class: _vm.highLight == true ? 'highLight' : '',
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.trainCertificateDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "trainCertificateDate", $$v)
      },
      expression: "params.trainCertificateDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("岗位类别为主要负责人和其他负责人时需填写")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.trainCertificateId && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.params.trainCertificateId,
      "viewType": "2"
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")])])
}]}

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table9E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 2-1：音像制品出版情况登记表")]) : _c('span', [_vm._v("表 2-1：电子出版物出版情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("年份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.year),
      callback: function($$v) {
        _vm.$set(_vm.params, "year", $$v)
      },
      expression: "params.year"
    }
  }, _vm._l((_vm.yearOpts), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版物名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationName", $$v)
      },
      expression: "params.publicationName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专用书号（ISBN 978-7-）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.isbn),
      callback: function($$v) {
        _vm.$set(_vm.params, "isbn", $$v)
      },
      expression: "params.isbn"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("载体形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [(_vm.pressType == 1) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择载体形式"
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C010']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp1[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : (_vm.pressType == 2) ? _c('div', {
    staticClass: "areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "carrierForm",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择载体形式"
    },
    model: {
      value: (_vm.params.carrierForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierForm", $$v)
      },
      expression: "params.carrierForm"
    }
  }, _vm._l((_vm.dicDats['C025']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.mediaTyp2[_vm.params.carrierForm] == '其他') ? _c('el-form-item', {
    attrs: {
      "prop": "carrierFormQT",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.carrierFormQT),
      callback: function($$v) {
        _vm.$set(_vm.params, "carrierFormQT", $$v)
      },
      expression: "params.carrierFormQT"
    }
  })], 1) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版形式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.publicationForm),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationForm", $$v)
      },
      expression: "params.publicationForm"
    }
  }, _vm._l((_vm.dicDats['C011']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目来源/制作单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.productionUnit),
      callback: function($$v) {
        _vm.$set(_vm.params, "productionUnit", $$v)
      },
      expression: "params.productionUnit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("节目时长或容量(分钟/兆)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.programCapacity),
      callback: function($$v) {
        _vm.$set(_vm.params, "programCapacity", $$v)
      },
      expression: "params.programCapacity"
    }
  })], 1)]), _vm._v(" "), (_vm.numShow) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版数量(张/盒)：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls": false,
      "controls-position": "right",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.publicationQuantity),
      callback: function($$v) {
        _vm.$set(_vm.params, "publicationQuantity", $$v)
      },
      expression: "params.publicationQuantity"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-formate": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.publishingTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishingTime", $$v)
      },
      expression: "params.publishingTime"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否书配盘标记：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.sign),
      callback: function($$v) {
        _vm.$set(_vm.params, "sign", $$v)
      },
      expression: "params.sign"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    style: ({
      width: '360px'
    }),
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版物名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 12 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("连续型电子出版物出版单位查询")])])
}]}

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "720px",
      "width": "100%"
    },
    attrs: {
      "id": "chart_business_1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": "chart_business_1_table"
    }
  }, [_c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    attrs: {
      "id": "chart_business_1_tab"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "title": "返回"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_c('div', {
    staticClass: "th-inner",
    on: {
      "click": function($event) {
        _vm.backEcharts('chart_business_1')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "0.74rem",
      "width": "270px"
    },
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("省局")]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.provincename),
      callback: function($$v) {
        _vm.$set(_vm.query, "provincename", $$v)
      },
      expression: "query.provincename"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("出版单位")]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.name),
      callback: function($$v) {
        _vm.$set(_vm.query, "name", $$v)
      },
      expression: "query.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    attrs: {
      "nowrap": "nowrap"
    }
  }, [_c('div', {
    staticClass: "th-inner text-warning"
  }, [_vm._v("\n                " + _vm._s(this.targetyear + "年 " + this.category + " (万元)") + "\n                "), _c('i', {
    staticClass: "fa fa-filter searchFilerCls",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "aria-hidden": "true",
      "title": "筛选"
    },
    on: {
      "click": function($event) {
        _vm.setQueryVisible()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_business_1_html')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  }, [(_vm.queryVisible) ? _c('el-input', {
    staticClass: "searchInput",
    attrs: {
      "clearable": "",
      "size": "mini",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.query.value),
      callback: function($$v) {
        _vm.$set(_vm.query, "value", $$v)
      },
      expression: "query.value"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "size": "mini",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        _vm.goFilterList()
      }
    },
    slot: "append"
  })], 1) : _vm._e()], 1)])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "chart_business_1_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_media"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_electr"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_media"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_electr"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_media_pay"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "first_finance_pie_chart_electr_pay"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 0px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_media_pay"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px"
    },
    attrs: {
      "id": "second_finance_pie_chart_electr_pay"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1768 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PassCode', {
    staticClass: "forceArea",
    attrs: {
      "forcePass": true
    },
    on: {
      "go-frash": _vm.goFrash
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-C"
  }, [_c('div', {
    staticClass: "headBar"
  }, [(_vm.querys.pressType == 1) ? _c('span', [_vm._v("音像制品出版单位审核")]) : (_vm.querys.pressType == 2) ? _c('span', [_vm._v("电子出版物出版单位审核 ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.wSat == 1) ? _c('CommonTab', {
    ref: "mainTab",
    attrs: {
      "cancelFlag": false,
      "pressType": _vm.querys.pressType,
      "pressDat": _vm.resDat,
      "role": "show",
      "organization": _vm.querys.pressName,
      "defaultYear": _vm.querys.year1
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版物数量：")]), _vm._v("\n      2023 + 2024年出版物数量小于10\n\n      "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 3、编辑人员人数：")]), _vm._v("\n      取得国家出版专业技术人员资格的编辑人员，其人数小于10人\n\n      "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 4、出版专业中级职称以上人数：")]), _vm._v("\n      具有中级以上出版专业职业资格人数小于5人\n\n      ")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressType == 2) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版专业中级职称以上人数：")]), _vm._v("\n      具有中级以上出版专业职业资格人数小于2人\n\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "informationStatic",
    staticStyle: {
      "padding": "10px 50px 50px 50px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第一年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.firstYearDeliverNum))])]), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第二年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.secondYearDeliverNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("领导班子成员持证上岗率（%）")]), _vm._v(" "), _c('span', {
    class: _vm.publishUnitJson.workerProportion < 50 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.workerProportion))])]), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("取得国家出版专业技术人员资格的编辑人员数")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificate < 10 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificate))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("出版专业中级职称以上人数")]), _vm._v(" "), _c('span', {
    class: (_vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificateWorkers < 5) ||
      (_vm.querys.pressType == 2 && _vm.publishUnitJson.zjCertificateWorkers < 2) ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificateWorkers))])])])]), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "250",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l(((scope.row.examineMessage || '').split('；')), function(item, index) {
          return _c('div', {
            key: index,
            staticStyle: {
              "text-align": "left"
            }
          }, [_vm._v("\n              " + _vm._s(item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "") + "\n            ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "radioBx",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '21'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '13'
    }
  }, [_vm._v("注销或拟注销")])], 1), _vm._v(" "), (
    _vm.params.status == '1' ||
    _vm.params.status == '3' ||
    _vm.params.status == '21' ||
    _vm.params.status == '12' ||
    _vm.params.status == '13'
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("提交审核意见")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版单位信息统计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("流转记录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "margin-top": "10px",
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v("审核    \n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "background-color": "#fff"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("2.审核意见提交（3选1）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ① 通过"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ② 暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项。缓登后整改应提交整改报告。）"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ③ 注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）"), _c('br')])])])])
}]}

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    ref: "img"
  })
},staticRenderFns: []}

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab3"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物年利润总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("经营情况信息")])])
}]}

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListCage ssTab4"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("人员基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "tabBtns"
  }, [(_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.memberEdit(1)
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.excelModeUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v(" 下载模板")])], 1), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    staticClass: "excelRead",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.ExHandle
    }
  }, [_vm._v("导入Excel")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressType": "3",
      "pressId": _vm.querys.pressId,
      "excelCode": "404"
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.seekPms.type),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "type", $$v)
      },
      expression: "seekPms.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过姓名，身份证号（军官证号），手机号查询"
    },
    model: {
      value: (_vm.seekPms.keyword),
      callback: function($$v) {
        _vm.$set(_vm.seekPms, "keyword", $$v)
      },
      expression: "seekPms.keyword"
    }
  }), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.memberDet(1)
      }
    }
  }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    staticClass: "dangerBtns",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.memberClean
    }
  }, [_vm._v("清除全部")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注：请填写此连续型出版物的全部编辑人员")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabForms"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "45"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fullName",
      "label": "姓名",
      "width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.gender, "C017", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "idNumber",
      "label": "身份证号（军官证号）",
      "width": "270",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职务",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.job, "C022", _vm.dicMap, scope.row)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "政治面貌",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.politicalStatus, "C006", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文化程度",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.culture, "C005", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "width": "90",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称系列",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.professionalTitleSeries, "C007", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "职称级别",
      "width": "90",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("translate")(scope.row.titleLevel, "C008", _vm.dicMap)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否持有岗位培训资格证书",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.trainCertificateId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.isTrainCertificate, "C018", _vm.dicMap)) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "持有出版专业职业资格证书情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "imgIcon",
          on: {
            "click": function($event) {
              _vm.urlCreate('open', scope.row.professionalCertificateId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm._f("translate")(scope.row.certificateSituation, "C009", _vm.dicMap)) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cellphone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.modifyFlag) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberEdit(2, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.memberDet(2, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "saveBtn"
  }, [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.postDeclareFun
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "404"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogVisible),
      expression: "!dialogVisible"
    }],
    staticStyle: {
      "display": "grid",
      "place-items": "end",
      "width": "250px",
      "position": "absolute",
      "right": "10px",
      "z-index": "1999"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主题"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function (val) { return _vm.handleChangeTheme(val); }
    },
    model: {
      value: (_vm.chartTheme),
      callback: function($$v) {
        _vm.chartTheme = $$v
      },
      expression: "chartTheme"
    }
  }, _vm._l((_vm.themes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "企业情况",
      "name": "1"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位音像电子资质统计")]), _vm._v(" "), _c('p', [_vm._v("\n                音像电子出版单位总数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[0]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                既有音像又有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[1]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                只有音像资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[2]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                只有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[3]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有音像资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[4]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有电子资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums[5]))]), _vm._v(" 家\n              ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('hbar-chart', {
    key: _vm.roundKey + '_2',
    attrs: {
      "params": {
        id: 'chart_2',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位出版资质统计")]), _vm._v(" "), _c('p', [_vm._v("\n                具有图书资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[0]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有期刊资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[1]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有报纸资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[2]))]), _vm._v(" 家\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                具有网络资质的出版单位数量："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.txtNums2[3]))]), _vm._v(" 家\n              ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_3',
    attrs: {
      "params": {
        id: 'chart_3',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-30px"
    },
    attrs: {
      "id": "sel_chart_3",
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    on: {
      "change": _vm.chagenZjVal
    },
    model: {
      value: (_vm.checkListZj),
      callback: function($$v) {
        _vm.checkListZj = $$v
      },
      expression: "checkListZj"
    }
  }, _vm._l((_vm.listZj), function(name, index) {
    return _c('el-checkbox', {
      key: name,
      attrs: {
        "label": name
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_5',
    attrs: {
      "params": {
        id: 'chart_5',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_4',
    attrs: {
      "params": {
        id: 'chart_4',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-30px"
    },
    attrs: {
      "id": "sel_chart_4",
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "padding": "0px 0px 10px 0px"
    },
    on: {
      "change": _vm.chagenZjVal2
    },
    model: {
      value: (_vm.checkListZj2),
      callback: function($$v) {
        _vm.checkListZj2 = $$v
      },
      expression: "checkListZj2"
    }
  }, _vm._l((_vm.listZj2), function(name, index) {
    return _c('el-checkbox', {
      key: name,
      attrs: {
        "label": name
      }
    })
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("单位性质统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_7'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_7"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_7',
    attrs: {
      "params": {
        id: 'chart_7',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("法人类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_6'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_6"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_6',
    attrs: {
      "params": {
        id: 'chart_6',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "音像制品",
      "name": "3"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_183',
    attrs: {
      "params": {
        id: 'chart_183',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_181',
    attrs: {
      "params": {
        id: 'chart_181',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_182',
    attrs: {
      "params": {
        id: 'chart_182',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像出版单位出版品种数分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_11'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                出版品种为" + _vm._s(key) + "的出版单位："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_11"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_11',
    attrs: {
      "params": {
        id: 'chart_11',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品载体形式统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_15'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_15"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_15',
    attrs: {
      "params": {
        id: 'chart_15',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品内容来源类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_13'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                内容来源类型" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_13"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_13',
    attrs: {
      "params": {
        id: 'chart_13',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品节目时长分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_12'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                时长分段" + _vm._s(key) + "的节目数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_12"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_12',
    attrs: {
      "params": {
        id: 'chart_12',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度音像制品书配盘统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_14'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                书配盘" + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_14"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_14',
    attrs: {
      "params": {
        id: 'chart_14',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度除传统光盘载体外音像制品出版单位拓展方向分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_17'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_17"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_17',
    attrs: {
      "params": {
        id: 'chart_17',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年音像制品出版单位结合音像电子业务开设并运营的项目分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_18'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_18"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_18',
    attrs: {
      "params": {
        id: 'chart_18',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "电子出版物",
      "name": "4"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_283',
    attrs: {
      "params": {
        id: 'chart_283',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_281',
    attrs: {
      "params": {
        id: 'chart_281',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_282',
    attrs: {
      "params": {
        id: 'chart_282',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData,
      "barType": 'line'
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版单位出版品种数分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_21'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                出版品种为" + _vm._s(key) + "的出版单位："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_21"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_21',
    attrs: {
      "params": {
        id: 'chart_21',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子载体形式统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_25'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_25"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_25',
    attrs: {
      "params": {
        id: 'chart_25',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物内容来源类型统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_23'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                内容来源类型" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_23"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_23',
    attrs: {
      "params": {
        id: 'chart_23',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物数据容量分段统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_22'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                数据容量分段" + _vm._s(key) + "的节目数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_22"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_22',
    attrs: {
      "params": {
        id: 'chart_22',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度电子出版物书配盘统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_24'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                书配盘" + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_24"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_24',
    attrs: {
      "params": {
        id: 'chart_24',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年度除传统光盘载体外电子出版物出版单位拓展方向分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_27'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_27"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_27',
    attrs: {
      "params": {
        id: 'chart_27',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("2023-2024年电子出版物出版单位结合音像电子业务开设并运营的项目分布情况")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_28'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "的数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_28"][key]))]), _vm._v(" 个\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bar-chart', {
    key: _vm.roundKey + '_28',
    attrs: {
      "params": {
        id: 'chart_28',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "经营情况",
      "name": "business"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_51',
    attrs: {
      "params": {
        id: 'chart_51',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('mbar-chart', {
    key: _vm.roundKey + '_52',
    attrs: {
      "params": {
        id: 'chart_52',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('chart-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('province-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "人员整体情况",
      "name": "worker"
    }
  }, [_c('worker-base', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "各单位人员情况",
      "name": "5"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("音像电子人员职称统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_38'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(index == 0 ? key : key + "职称") + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_38"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_38',
    attrs: {
      "params": {
        id: 'chart_38',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("职称系列统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_37'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_37"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_37',
    attrs: {
      "params": {
        id: 'chart_37',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版专业人员职称统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_39'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(index == 0 ? key : key + "职称") + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_39"][key]))]), _vm._v("\n                人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_39',
    attrs: {
      "params": {
        id: 'chart_39',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("领导班子成员持证上岗率统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_45'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_45"][key]))])])
  }), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_41'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_41"][key]))])])
  }), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_44'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_44"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_45',
    attrs: {
      "params": {
        id: 'chart_45',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_41',
    attrs: {
      "params": {
        id: 'chart_41',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_44',
    attrs: {
      "params": {
        id: 'chart_44',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("编辑人员统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_42'])), function(key, index) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_42"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 0px 0px 0px"
    },
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_42',
    attrs: {
      "params": {
        id: 'chart_42',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_46',
    attrs: {
      "params": {
        id: 'chart_46',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_47',
    attrs: {
      "params": {
        id: 'chart_47',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("政治面貌统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_35'])), function(key) {
    return _c('p', {
      key: key,
      staticStyle: {
        "width": "40%",
        "float": "left",
        "margin-bottom": "0px"
      }
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_35"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_35',
    attrs: {
      "params": {
        id: 'chart_35',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("文化程度统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_36'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                " + _vm._s(key) + "："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_36"][key]))])])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_36',
    attrs: {
      "params": {
        id: 'chart_36',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版专业职业资格中级及以上职称占比统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_32'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                中级及以上职称占比" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_32"][key]))]), _vm._v(" 家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_32',
    attrs: {
      "params": {
        id: 'chart_32',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("领导班子出版专业职业资格证书中级及以上占比统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_34'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                领导班子出版专业职业资格证书中级及以上占比" + _vm._s(key) + "数量："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_34"][key]))]), _vm._v("\n                家\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('pie-chart', {
    key: _vm.roundKey + '_34',
    attrs: {
      "params": {
        id: 'chart_34',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("各专业高级职称编辑人数统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_40'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                各专业高级职称编辑" + _vm._s(key) + "的人数："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_40"][key]))]), _vm._v(" 人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_40',
    attrs: {
      "params": {
        id: 'chart_40',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    style: (_vm.chartHeight),
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("各专业中级职称编辑人数统计")]), _vm._v(" "), _vm._l((Object.keys(_vm.txtNumsData['chart_43'])), function(key) {
    return _c('p', {
      key: key
    }, [_vm._v("\n                各专业中级职称编辑" + _vm._s(key) + "的人数："), _c('span', {
      staticClass: "numStyle"
    }, [_vm._v(_vm._s(_vm.txtNumsData["chart_43"][key]))]), _vm._v(" 人\n              ")])
  })], 2)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('bing-chart', {
    key: _vm.roundKey + '_43',
    attrs: {
      "params": {
        id: 'chart_43',
        data: _vm.dataArray,
        chartHeight: _vm.chartHeight,
        chartTheme: _vm.chartTheme,
        columnMap: _vm.columnMap,
        imgUrlfdj: _vm.imgUrlfdj,
        imgUrldata: _vm.imgUrldata,
        imgUrldownload: _vm.imgUrldownload,
      },
      "searchData": _vm.searchData,
      "queryFilter": _vm.queryFilter,
      "queryVisible": _vm.queryVisible,
      "querySort": _vm.querySort,
      "backEcharts": _vm.backEcharts,
      "chartResize": _vm.chartResize,
      "setDisplayVisible": _vm.setDisplayVisible,
      "sortData": _vm.sortData,
      "downloadData": _vm.downloadData,
      "createDataHtml": _vm.createDataHtml,
      "setQueryVisible": _vm.setQueryVisible,
      "listTableData": _vm.listTableData
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "连续型电子出版物",
      "name": "lxdzfinace"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "0px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('lxdz-finance', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    },
    attrs: {
      "chart-theme": this.chartTheme,
      "active-name": this.activeName
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "top": "6vh",
      "destroy-on-close": true,
      "visible": _vm.dialogVisible,
      "width": "94%"
    },
    on: {
      "opened": _vm.openedDialog,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-default panel-intro"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "echart_n"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "echart_table",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "echart_n_table"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData('chart_n')
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": (_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []).length <= 4 ? 6 : 4
      }
    }, [(
      (_vm.currentId == 'chart_11' ||
        _vm.currentId == 'chart_12' ||
        _vm.currentId == 'chart_21' ||
        _vm.currentId == 'chart_22') &&
      key == 'value'
    ) ? _c('el-select', {
      attrs: {
        "size": "mini",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.searchData('chart_n')
        }
      },
      model: {
        value: (_vm.queryFilterN[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilterN, key, $$v)
        },
        expression: "queryFilterN[key]"
      }
    }, _vm._l((Object.keys(_vm.rangeValus)), function(item) {
      return _c('el-option', {
        key: item,
        attrs: {
          "label": item,
          "value": item
        }
      })
    })) : _c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.columnMap[_vm.currentId][key]
      },
      on: {
        "input": function($event) {
          _vm.onInput()
        }
      },
      model: {
        value: (_vm.queryFilterN[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilterN, key, $$v)
        },
        expression: "queryFilterN[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData('chart_n')
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "echart_n_tab"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts('chart_n')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((_vm.currentId ? Object.keys(_vm.columnMap[_vm.currentId]) : []), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n                            " + _vm._s(_vm.columnMap[_vm.currentId][key]) + "\n                            "), _c('i', {
      class: _vm.querySort['chart_n'][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort['chart_n'][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort['chart_n'][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort['chart_n'][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData('chart_n', key, _vm.querySort['chart_n'][key])
        }
      }
    })])])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": "echart_n_html"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])], 1)], 1)], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-1"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.querys.pvcName))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.wSat == 1) ? _c('CommonTab', {
    ref: "mainTab",
    attrs: {
      "cancelFlag": false,
      "organization": _vm.querys.pressName,
      "pressType": _vm.querys.pressType,
      "defaultYear": _vm.querys.year1,
      "pressDat": _vm.resDat,
      "selYears": _vm.selYearRecord,
      "role": "show"
    },
    on: {
      "valChangeSearch": _vm.valChangeSearch
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版物数量：")]), _vm._v("\n    2023 + 2024年出版物数量小于10\n\n    "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 3、编辑人员人数：")]), _vm._v("\n    取得国家出版专业技术人员资格的编辑人员，其人数小于10人\n\n    "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 4、出版专业中级职称以上人数：")]), _vm._v("\n    具有中级以上出版专业职业资格人数小于5人\n\n    ")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressType == 2) ? _c('div', {
    staticClass: "progressTab",
    staticStyle: {
      "margin-left": "30px",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "red"
    }
  }, [_vm._v("以下情况数字会进行标红")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 1、领导班子成员持证上岗率：")]), _c('span', [_vm._v("上岗率低于50%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" 2、出版专业中级职称以上人数：")]), _vm._v("\n    具有中级以上出版专业职业资格人数小于2人\n\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "informationStatic",
    staticStyle: {
      "padding": "10px 50px 50px 50px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第一年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.firstYearDeliverNum))])]), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("第二年度出版物数量")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.firstYearDeliverNum + _vm.publishUnitJson.secondYearDeliverNum < 10 ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.secondYearDeliverNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("领导班子成员持证上岗率（%）")]), _vm._v(" "), _c('span', {
    class: _vm.publishUnitJson.workerProportion < 50 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.workerProportion))])]), _vm._v(" "), (_vm.querys.pressType == 1) ? _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("取得国家出版专业技术人员资格的编辑人员数")]), _vm._v(" "), _c('span', {
    class: _vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificate < 10 ? 'highlight' : ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificate))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "multiple"
  }, [_c('p', [_vm._v("出版专业中级职称以上人数")]), _vm._v(" "), _c('span', {
    class: (_vm.querys.pressType == 1 && _vm.publishUnitJson.zjCertificateWorkers < 5) ||
      (_vm.querys.pressType == 2 && _vm.publishUnitJson.zjCertificateWorkers < 2) ?
      'highlight' :
      ''
  }, [_vm._v(_vm._s(_vm.publishUnitJson.zjCertificateWorkers))])])])]), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "220",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("tansStr")(scope.row, "statuscbs")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "min-width": "300",
      "label": "审核意见",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "150",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n        ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "radioBx"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '5'
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '4'
    }
  }, [_vm._v("撤销")])], 1), _vm._v(" "), (
    _vm.params.status == 1 || _vm.params.status == 2 || _vm.params.status == 3 || _vm.params.status == 5 || _vm.params.status == 4
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("审 核")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版单位信息统计")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核历史")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核意见")])])
}]}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-1"
  }, [_c('div', {
    staticClass: "tbs"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.showArr
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "360"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper",
          on: {
            "click": function($event) {
              _vm.preFmate(scope.row)
            }
          }
        }, [_c('span', {
          style: ('margin-left:' + 24 * scope.row.x.length + 'px')
        }, [(scope.row.items && scope.row.items.length > 0) ? _c('span', {
          staticStyle: {
            "margin-left": "-18px"
          }
        }, [(scope.row.hide) ? _c('i', {
          staticClass: "el-icon-caret-right"
        }) : _c('i', {
          staticClass: "el-icon-caret-bottom"
        })]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), (scope.row.items && scope.row.items.length > 0) ? _c('span', {
          staticClass: "tbIcon"
        }, [_vm._v("( " + _vm._s(scope.row.items.length) + " )")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.sort))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "查询码",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "goDeeper"
        }, [_vm._v(_vm._s(scope.row.code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.level == null) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('add', scope.row)
            }
          }
        }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('edit', scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "disabled": scope.row.items && scope.row.items.length > 0,
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.btnTrans('remove', scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    staticClass: "newAdd",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.btnTrans('add')
      }
    }
  }, [_vm._v("新增")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-1-dag",
    attrs: {
      "title": _vm.diaTitle,
      "visible": _vm.diaForAdd,
      "width": "450px",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "close": _vm.closeHandle,
      "update:visible": function($event) {
        _vm.diaForAdd = $event
      }
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("名称：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.name),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "name", $$v)
      },
      expression: "postDats.name"
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("排序：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.sort),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "sort", $$v)
      },
      expression: "postDats.sort"
    }
  })], 1)])]), _vm._v(" "), (_vm.pstate) ? _c('tr', [_c('td', {
    staticClass: "inpName"
  }, [_c('div', [_vm._v("查询码：")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "inContent"
  }, [_c('el-input', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.postDats.code),
      callback: function($$v) {
        _vm.$set(_vm.postDats, "code", $$v)
      },
      expression: "postDats.code"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.diaForAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goSave()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-B"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "accept": ".doc,.docx",
      "headers": _vm.postHead,
      "disabled": _vm.upStateHybg == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls1,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": {
        fileProperty: 1
      },
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upStateHybg == 'loaded' || _vm.ableUpZgbg == 2) ? _c('span', [_vm._v("更新分析报告")]) : (_vm.upStateHybg == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传分析报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flieList",
    attrs: {
      "download": ""
    }
  }, [_c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.fileUrlHybg)
      }
    }
  }, [_vm._v(_vm._s(_vm.fileNameHybg))])]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    attrs: {
      "accept": ".doc,.docx",
      "headers": _vm.postHead,
      "disabled": _vm.upStateZgbg == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls2,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": {
        fileProperty: 2
      },
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upStateZgbg == 'loaded' || _vm.ableUpZgbg == 2) ? _c('span', [_vm._v("更新整改报告")]) : (_vm.upStateZgbg == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传整改报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flieList"
  }, [_c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.fileUrlZgbg)
      }
    }
  }, [_vm._v(_vm._s(_vm.fileNameZgbg))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "15px",
      "line-height": "20px",
      "color": "black"
    }
  }, [_vm._v("\n      上传文件格式为doc、docx，文件大小不超过10M\n    ")]), _vm._v(" "), _c('div', [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upStateHybg == 'loading' || _vm.upStateZgbg == 'loading'),
      expression: "upStateHybg == 'loading' || upStateZgbg == 'loading'"
    }],
    staticClass: "progressBox",
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), (_vm.ableUpHybg == 3) ? _c('div', {
    staticClass: "pvcTips"
  }, [_vm._v("已上报至总局")]) : _vm._e()], 1), _vm._v(" "), (_vm.ableUpHybg == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goAdmin
    }
  }, [_vm._v("上报国家新闻出版署")])], 1) : _vm._e(), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("上报国家新闻出版署")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "20px"
    }
  }, [_vm._v("若省局已经审核完成，请点击“上报国家新闻出版署”。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "font-size": "14px"
    }
  }, [_vm._v("音像电子出版单位年度核验情况报告等材料（含各社登记表）报送方式：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "font-size": "14px"
    }
  }, [_vm._v("由省级出版行政管理部门统一寄送至以下地址，北京市西城区宣武门外大街40号出版局音像电子处，联系人：郑加可，电话010-83138687")])])
}]}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-D"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版单位名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("音像制品出版单位查询")])])
}]}

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-6"
  }, [(_vm.wSat == 1) ? _c('MainTabs', {
    attrs: {
      "pressDat": _vm.resDat,
      "role": "press",
      "bookName": _vm.bookname
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-5"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("连续型电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.tabPost.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "核验出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.tabPost.total > 1) ? _c('div', {
    staticClass: "pageArea"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tabPost.no,
      "layout": "prev, pager, next",
      "page-count": _vm.tabPost.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("出版单位从业人员总体情况")]), _vm._v(" "), _c('p', [_vm._v("\n            出版单位职工总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.workers))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            音像制品从业人员总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessworkersyx))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            电子出版物从业人员总数："), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessworkersdz))]), _vm._v("\n            人\n          ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    },
    attrs: {
      "id": "base_chart"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticClass: "text-introduce"
  }, [_c('h3', [_vm._v("人员构成")]), _vm._v(" "), _c('p', [_vm._v("\n            领导班子：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessleaderyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.businessleaderdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            编辑人员：音像 "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.totalworkeryx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.totalworkerdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            制作加工人员： 音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumprocessyx))]), _vm._v(" 人， 电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumprocessdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            新媒体、网络运营等技术人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnuminternationyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnuminternationdz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            专职出版物发行人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumissueyx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumissuedz))]), _vm._v(" 人\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            其他人员：音像\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumotheryx))]), _vm._v(" 人，电子\n            "), _c('span', {
    staticClass: "numStyle"
  }, [_vm._v(_vm._s(_vm.workerBaseInfo.pepnumotherdz))]), _vm._v(" 人\n          ")])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "358.4px"
    },
    attrs: {
      "id": "member_chart"
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 0px 0px"
    },
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "274px"
    },
    attrs: {
      "id": "member_pie_media"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "274px"
    },
    attrs: {
      "id": "member_pie_electr"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-1"
  }, [(_vm.wSat == 0) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "dvsWait"
  }) : _vm._e(), _vm._v(" "), (_vm.wSat == 2) ? _c('div', {
    staticClass: "succedTips"
  }, [_vm._v("\n    材料已提交至省局，可从\n    "), _c('router-link', {
    attrs: {
      "to": "pgress_step"
    }
  }, [_c('a', [_vm._v("核验进度")])]), _vm._v(" 菜单查看审核进度。\n  ")], 1) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('div', [(_vm.frashCode) ? _c('MainTabs', {
    attrs: {
      "pressType": "1",
      "pressDat": _vm.resDat
    },
    on: {
      "go-frash": _vm.frashHandle,
      "valChangeSearch": _vm.valChangeSearch
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": {
          path: tag.path,
          query: tag.query,
          params: tag.params
        }
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-2"
  }, [_c('div', {
    staticClass: "provinceArea",
    style: (_vm.leftHt)
  }, [_c('el-scrollbar', {
    ref: "aaa"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.postDat.sjExamineId,
      "background-color": "#fff",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.provinceChange
    }
  }, _vm._l((_vm.provinceList), function(item, inx) {
    return _c('el-menu-item', {
      key: inx,
      class: {
        'custom-active': _vm.postDat.sjExamineId == item.sjExamineId
      },
      style: (Object.assign({}, _vm.computedColor(item))),
      attrs: {
        "index": item.sjExamineId
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm._f("transStr")(item, "navset")))])])
  }))], 1)], 1), _vm._v(" "), (_vm.postDat.sjExamineId) ? _c('div', {
    staticClass: "contArea"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.pvcName))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("音像制品出版单位核验")]), _vm._v(" "), _c('div', {
    staticClass: "btnCtrls"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.postBack(1)
      }
    }
  }, [_vm._v("整体发布")]), _vm._v(" "), (_vm.pvcSta == 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.postDat.msg == '';
      }
    }
  }, [_vm._v("整体退回")]) : _vm._e(), _vm._v(" "), (_vm.postUrl) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrl)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局分析报告")])], 1) : _c('el-button', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    }
  }, [_vm._v("省局分析报告（未上传）")]), _vm._v(" "), (_vm.postUrlZg) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrlZg)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局整改报告")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("核验意见")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 0 ||
          scope.row.status == 1 ||
          scope.row.status == 2 ||
          scope.row.status == 4 ||
          scope.row.status == 5
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("进入\n              ")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "批准文号",
      "prop": "pubNumber",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, "time")) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "unProvince"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_audio_pop",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeHandle
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [_c('span', [_vm._v("请填写整体退回意见")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "rows": "5",
      "placeholder": "请输入内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.postDat.msg),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "msg", $$v)
      },
      expression: "postDat.msg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.postBack(2)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_audio_pop",
    attrs: {
      "title": "请填写意见",
      "width": "40%",
      "center": "",
      "visible": _vm.dialogShow
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [(_vm.paramsEx.status == 3) ? _c('span', [_vm._v("请填写退回意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 22) ? _c('span', [_vm._v("请填写整改意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 2) ? _c('span', [_vm._v("请填写暂缓意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 4) ? _c('span', [_vm._v("请填写撤销意见")]) : _vm._e(), _vm._v(" "), (_vm.paramsEx.status == 5) ? _c('span', [_vm._v("请填写注销意见")]) : _vm._e()]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.paramsEx.message),
      callback: function($$v) {
        _vm.$set(_vm.paramsEx, "message", $$v)
      },
      expression: "paramsEx.message"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    attrs: {
      "shadow": "always",
      "body-style": "padding:0px;width:100%;"
    }
  }, [_c('div', {
    style: (_vm.params.chartHeight),
    attrs: {
      "id": _vm.params.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "echart_table",
    attrs: {
      "id": _vm.params.id + '_table'
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "60px",
      "float": "left",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-download searchFilerCls",
    attrs: {
      "aria-hidden": "true",
      "title": "导出"
    },
    on: {
      "click": function($event) {
        _vm.downloadData(_vm.params.id)
      }
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "calc(100% - 60px)",
      "float": "left"
    },
    attrs: {
      "gutter": 15
    }
  }, _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('el-col', {
      key: key,
      attrs: {
        "span": Object.keys(_vm.params.columnMap[_vm.params.id]).length <= 4 ? 6 : 4
      }
    }, [_c('el-input', {
      staticClass: "searchInput",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "3px"
      },
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": '请输入' + _vm.params.columnMap[_vm.params.id][key]
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('table', {
    staticClass: "tabletemp table-striped table-bordered tabletemp-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": _vm.params.id + '_tab'
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "th-inner",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "title": "返回"
    },
    on: {
      "click": function($event) {
        _vm.backEcharts(_vm.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply",
    staticStyle: {
      "font-size": "16px",
      "color": "#55d3d3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fht-cell"
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.params.columnMap[_vm.params.id])), function(key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "nowrap": "nowrap"
      }
    }, [_c('div', {
      staticClass: "th-inner text-warning"
    }, [_vm._v("\n              " + _vm._s(_vm.params.columnMap[_vm.params.id][key]) + "\n              "), _c('i', {
      class: _vm.querySort[_vm.params.id][key] == 'sort' ?
        'fa fa-sort' :
        _vm.querySort[_vm.params.id][key] == 'asc' ?
        'fa fa-sort-asc' :
        _vm.querySort[_vm.params.id][key] == 'desc' ?
        'fa fa-sort-desc' :
        '',
      style: (_vm.querySort[_vm.params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''),
      on: {
        "click": function($event) {
          _vm.sortData(_vm.params.id, key, _vm.querySort[_vm.params.id][key])
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fht-cell"
    }, [(_vm.queryVisible[_vm.params.id]) ? _c('el-input', {
      staticClass: "searchInput",
      attrs: {
        "clearable": "",
        "size": "mini",
        "placeholder": "请输入内容"
      },
      model: {
        value: (_vm.queryFilter[key]),
        callback: function($$v) {
          _vm.$set(_vm.queryFilter, key, $$v)
        },
        expression: "queryFilter[key]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "size": "mini",
        "icon": "el-icon-search"
      },
      on: {
        "click": function($event) {
          _vm.searchData(_vm.params.id)
        }
      },
      slot: "append"
    })], 1) : _vm._e()], 1)])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "font-size": "14px !important"
    },
    attrs: {
      "id": _vm.params.id + '_html'
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "vertical-align": "middle"
    },
    attrs: {
      "colspan": "99"
    }
  }, [_vm._v("加载中...")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ctrlsLine"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过导入编码、出版物中文名称查询"
    },
    model: {
      value: (_vm.tabPost.keyword),
      callback: function($$v) {
        _vm.$set(_vm.tabPost, "keyword", $$v)
      },
      expression: "tabPost.keyword"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "download": ""
    },
    on: {
      "click": _vm.dmyfile
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("下载导入模板")])], 1), _vm._v(" "), (_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.ExcelHandler
    }
  }, [_vm._v("导入Excel")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("下载封面和盖章页")])], 1), _vm._v(" "), _c('ExcelIn', {
    ref: "ExcelSet",
    attrs: {
      "pressType": "3",
      "pressId": _vm.pressId,
      "excelCode": "401"
    },
    on: {
      "t-frash": _vm.goFresh,
      "excel-errors": _vm.errorCtrls
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.tabDatCommon
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "材料名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "完成进度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.code == '402') ? _c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row.table2Status, "tabsta")))]) : _vm._e(), _vm._v(" "), (scope.row.code == '404') ? _c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row.table4Status, "tabsta")))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("translate")(scope.row, "time")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.modifyFlag) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toEdit(scope.row, 2)
            }
          }
        }, [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && scope.row.statuspom == 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toEdit(scope.row, 1)
            }
          }
        }, [_vm._v("填表")]) : _vm._e(), _vm._v(" "), (_vm.modifyFlag && scope.row.statuspom != 1) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.toEdit(scope.row, 2)
            }
          }
        }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (!_vm.modifyFlag && scope.row.code == '404') ? _c('a', {
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              _vm.expFullFile(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("导出打印表")])], 1) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "margin-top": "0px"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.tabPost.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "materialCode",
      "label": "导入编码",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialTitle",
      "label": "出版物中文名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版物基本信息",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("transStr")(scope.row.table1Status, "tabsta")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版经营情况",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("transStr")(scope.row.table3Status, "tabsta")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版经营情况调查表",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("transStr")(scope.row.table5Status, "tabsta")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "190",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.flowName == '省局' ||
          scope.row.flowName == '国家新闻出版署' ||
          (scope.row.flowName == '开始' && !_vm.transCode(scope.row))
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goComTab(scope.row)
            }
          }
        }, [(scope.row.flowName == '省局' || scope.row.flowName == '国家新闻出版署') ? _c('span', [_vm._v("查看")]) : _vm._e(), _vm._v(" "), (scope.row.flowName == '开始' && _vm.transCode(scope.row)) ? _c('span', [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (scope.row.flowName == '开始' && !_vm.transCode(scope.row)) ? _c('span', [_vm._v("填表")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.flowName == '开始' && _vm.transCode(scope.row)) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goComTab(scope.row)
            }
          }
        }, [(scope.row.flowName == '开始' && _vm.transCode(scope.row)) ? _c('span', [_vm._v("修改")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              _vm.expLxJbxxFile(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("导出打印表")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.tabPost.total > 1) ? _c('div', {
    staticClass: "pageArea"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tabPost.no,
      "layout": "prev, pager, next",
      "page-count": _vm.tabPost.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('ExError', {
    ref: "chinldError",
    attrs: {
      "errorList": _vm.excelEr,
      "pressCode": "401"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [(_vm.modifyFlag) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.toPvc
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tipsCage"
  }, [_c('span', [_vm._v("注：出版物基本信息可使用EXCEL进行批量导入。使用批量导入功能前，需要先下载“导入模板”，并直接使用下载的“导入模板”文件按其规定格式填写后才能批量导入到系统里；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料1：出版单位基本信息、人员信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("材料2：出版物信息")])])
}]}

/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('sidebar', {
    staticClass: "sidebar-container"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('navbar'), _vm._v(" "), _c('app-main')], 1)])
},staticRenderFns: []}

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-4"
  }, [_c('div', {
    staticClass: "provinceArea",
    style: (_vm.leftHt)
  }, [_c('el-scrollbar', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.postDat.sjExamineId,
      "background-color": "#fff",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.peovinceChange
    }
  }, _vm._l((_vm.provinceList), function(item, inx) {
    return _c('el-menu-item', {
      key: inx,
      class: {
        'custom-active': _vm.postDat.sjExamineId == item.sjExamineId
      },
      style: (Object.assign({}, _vm.computedColor(item))),
      attrs: {
        "index": item.sjExamineId
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm._f("transStr")(item, "navset")))])])
  }))], 1)], 1), _vm._v(" "), (_vm.postDat.sjExamineId) ? _c('div', {
    staticClass: "contArea"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.pvcName))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v("出版连续型电子出版物单位核验")]), _vm._v(" "), _c('div', {
    staticClass: "btnCtrls"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.postBack(1)
      }
    }
  }, [_vm._v("整体发布")]), _vm._v(" "), (_vm.pvcSta == 0) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.postDat.msg == '';
      }
    }
  }, [_vm._v("整体退回")]) : _vm._e(), _vm._v(" "), (_vm.postUrl) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrl)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局分析报告")])], 1) : _c('el-button', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    }
  }, [_vm._v("省局分析报告（未上传）")]), _vm._v(" "), (_vm.postUrlZg) ? _c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.postUrlZg)
      }
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("省局整改报告")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSsuccessive
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("核验意见")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "5"
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("撤销")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过出版物名称、出版单位查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 12 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(
          scope.row.status == 0 ||
          scope.row.status == 1 ||
          scope.row.status == 2 ||
          scope.row.status == 4 ||
          scope.row.status == 5
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("进入\n              ")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "批准文号",
      "prop": "pubNumber",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, "time")) + "\n            ")]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])]) : _c('div', {
    staticClass: "unProvince"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_successive_pop",
    attrs: {
      "title": "",
      "visible": _vm.dialogVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [_c('span', [_vm._v("请填写整体退回意见")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "rows": "3",
      "type": "textarea"
    },
    model: {
      value: (_vm.postDat.msg),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "msg", $$v)
      },
      expression: "postDat.msg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.postBack(2)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "admin_successive_pop",
    attrs: {
      "title": "",
      "width": "40%",
      "center": "",
      "visible": _vm.dialogShow
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "ppttl"
  }, [_c('span', [_vm._v("请填写意见")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.paramsEx.message),
      callback: function($$v) {
        _vm.$set(_vm.paramsEx, "message", $$v)
      },
      expression: "paramsEx.message"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogShow = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnFun
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ssTabList2"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [(_vm.role == 'press') ? _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位提交")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookName))])]) : _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.bookName))]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "tabElement"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.tabDat), function(term, inx) {
    return _c('tr', {
      key: inx
    }, [_c('td', [_vm._v(_vm._s(inx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("translate")(term.updatedAt, "time")))]), _vm._v(" "), _c('td', [(term.code != 501) ? _c('span', [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.toEdit(term)
        }
      }
    }, [_vm._v("查看")])], 1) : _vm._e(), _vm._v(" "), (term.code == 501) ? _c('span', [(term.status == 2) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "type": "warning"
      }
    }, [_c('a', {
      attrs: {
        "download": ""
      },
      on: {
        "click": function($event) {
          _vm.filesDown(term)
        }
      }
    }, [_vm._v("下载")])]) : _vm._e(), _vm._v(" "), (term.status != 2) ? _c('el-button', {
      attrs: {
        "size": "mini",
        "disabled": ""
      }
    }, [_vm._v(" 未上传 ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (inx == 0) ? _c('td', [(term.code == '402') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(1, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 1) ? _c('td', [(term.code == '401') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : (term.code == '404') ? _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          _vm.dmyfile(2, term)
        }
      }
    }, [_vm._v("导出打印表")])], 1) : _vm._e()]) : (inx == 2) ? _c('td', {
      attrs: {
        "rowspan": "3"
      }
    }, [_vm._v(" ")]) : (inx == 5) ? _c('td', [_vm._v(" ")]) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.role == 'press') ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tabHead"
  }, [_c('td', [_vm._v("序号")]), _vm._v(" "), _c('td', [_vm._v("连续型电子出版物出版情况登记表")]), _vm._v(" "), _c('td', [_vm._v("查阅时间")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("操作")])])
}]}

/***/ }),
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-A"
  }, [_c('div', {
    staticClass: "headBar linkRoutes"
  }, [_c('span', [_vm._v("出版连续型电子出版物单位审核")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('MainTabs', {
    ref: "mainTab",
    attrs: {
      "bookName": _vm.bookName,
      "pressDat": _vm.resDat,
      "role": "show"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "width": "320",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "width": "120",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "label": "审核意见",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pubNumber",
      "width": "120",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "180",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "radioBx",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '21'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '13'
    }
  }, [_vm._v("注销或拟注销")])], 1), _vm._v(" "), (
    _vm.params.status == '1' ||
    _vm.params.status == '3' ||
    _vm.params.status == '21' ||
    _vm.params.status == '12' ||
    _vm.params.status == '13'
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("提交审核意见")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v("退回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核历史")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar",
    staticStyle: {
      "height": "auto",
      "line-height": "20px",
      "margin-bottom": "10px",
      "padding-bottom": "10px",
      "background-color": "#fff"
    }
  }, [_c('span', [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("1.因出版单位在系统填写中存在问题，需退回出版单位修正的，按“退回”键。")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("2.审核意见提交（3选1）"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ① 通过"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ② 暂缓登记（暂不具备年检通过条件，但仍继续办社的，选此项）"), _c('br')]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("      ③ 注销或拟注销（暂不具备办社基本条件且已经主办单位同意进行注销的，选此项）"), _c('br')])])])])
}]}

/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-container"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("欢迎使用音像电子出版单位年度核验管理系统")]), _vm._v(" "), (_vm.userInfo.orgType == 2) ? _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "出版单位类型",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumNum",
      "label": "出版单位数量",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 99)
            }
          }
        }, [_vm._v(_vm._s(scope.row.sumNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uncommitNum",
      "label": "未提交数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 8)
            }
          }
        }, [_vm._v(_vm._s(scope.row.uncommitNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "waitCheckNum",
      "label": "待审核数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 0)
            }
          }
        }, [_vm._v(_vm._s(scope.row.waitCheckNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkNum",
      "label": "已审核数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 1)
            }
          }
        }, [_vm._v(_vm._s(scope.row.checkNum))])]
      }
    }])
  })], 1)], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_c('i', {
    staticClass: "el-icon-refresh-left"
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh-right"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("所在出版单位(非部门)"), _c('br'), _vm._v("具有的出版资质包括：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("主营出版业务"), _c('br'), _vm._v("(营收高于音像电子业务的出版业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.mainBusinessTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessTs", $$v)
      },
      expression: "params.mainBusinessTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.mainBusinessQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessQk", $$v)
      },
      expression: "params.mainBusinessQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.mainBusinessWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessWl", $$v)
      },
      expression: "params.mainBusinessWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.mainBusinessBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessBz", $$v)
      },
      expression: "params.mainBusinessBz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.mainBusinessRm1),
      callback: function($$v) {
        _vm.$set(_vm.params, "mainBusinessRm1", $$v)
      },
      expression: "params.mainBusinessRm1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("所在出版单位"), _c('br'), _vm._v("是否主营有其他业务"), _c('br'), _vm._v("（营收高于出版业务的业务）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherbusiness",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "连续型电子/网络出版物"
    },
    model: {
      value: (_vm.params.expandBusinessLxdz),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessLxdz", $$v)
      },
      expression: "params.expandBusinessLxdz"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "无",
      "true-label": "1",
      "false-label": "0"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务"), _c('br'), _vm._v("的单位或部门"), _c('br'), _vm._v("结合"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务"), _c('br'), _vm._v("开设并运营有以下项目：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "业务网站"
    },
    model: {
      value: (_vm.params.operationProjectWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeb", $$v)
      },
      expression: "params.operationProjectWeb"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectWeb != '1',
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWebNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWebNum", $$v)
      },
      expression: "params.operationProjectWebNum"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "专业数据库"
    },
    model: {
      value: (_vm.params.operationProjectDatabase),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabase", $$v)
      },
      expression: "params.operationProjectDatabase"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectDatabase != '1',
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectDatabaseNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectDatabaseNum", $$v)
      },
      expression: "params.operationProjectDatabaseNum"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "微信公众号"
    },
    model: {
      value: (_vm.params.operationProjectWechat),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechat", $$v)
      },
      expression: "params.operationProjectWechat"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectWechat != '1',
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum1),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum1", $$v)
      },
      expression: "params.operationProjectWechatNum1"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('span', {
    staticClass: "chboxLeft"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectWechat != '1',
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectWechatNum2),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWechatNum2", $$v)
      },
      expression: "params.operationProjectWechatNum2"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（总用户数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "小程序或APP"
    },
    model: {
      value: (_vm.params.operationProjectApp),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectApp", $$v)
      },
      expression: "params.operationProjectApp"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectApp != '1',
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.operationProjectAppNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectAppNum", $$v)
      },
      expression: "params.operationProjectAppNum"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（小程序用户数或APP下载量）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "微博"
    },
    model: {
      value: (_vm.params.operationProjectWeibo),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeibo", $$v)
      },
      expression: "params.operationProjectWeibo"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectWeibo != '1',
      "size": "small",
      "controls": false,
      "placeholder": "粉丝数"
    },
    model: {
      value: (_vm.params.operationProjectWeiboNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectWeiboNum", $$v)
      },
      expression: "params.operationProjectWeiboNum"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（粉丝数）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "其他（与第三方平台合作)"
    },
    model: {
      value: (_vm.params.operationProjectOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOther", $$v)
      },
      expression: "params.operationProjectOther"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": _vm.params.operationProjectOther != '1',
      "size": "small",
      "controls": false,
      "placeholder": "平台数量"
    },
    model: {
      value: (_vm.params.operationProjectOtherNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectOtherNum", $$v)
      },
      expression: "params.operationProjectOtherNum"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "suffixTitle"
  }, [_vm._v("（个）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chboxDiv"
  }, [_c('el-checkbox', {
    staticClass: "chboxLeft",
    attrs: {
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.operationProjectEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "operationProjectEmpty", $$v)
      },
      expression: "params.operationProjectEmpty"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("人员情况")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版单位(社)领导：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbSld),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbSld", $$v)
      },
      expression: "params.zbSld"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("编辑人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.zbBjry),
      callback: function($$v) {
        _vm.$set(_vm.params, "zbBjry", $$v)
      },
      expression: "params.zbBjry"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("有关制作加工等相关人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumProcess),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumProcess", $$v)
      },
      expression: "params.pepnumProcess"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版业务人员中"), _c('br'), _vm._v("中除编辑以外"), _c('br'), _vm._v("的有关新媒体、网络运营等技术人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumInternation),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumInternation", $$v)
      },
      expression: "params.pepnumInternation"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n            出版业务人员中"), _c('br'), _vm._v("除编辑以外"), _c('br'), _vm._v("的专职"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版物发行人员：\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumIssue),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumIssue", $$v)
      },
      expression: "params.pepnumIssue"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员（包括行政人员等）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumOther", $$v)
      },
      expression: "params.pepnumOther"
    }
  })], 1), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("总人数（以上6项合计）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    staticClass: "chboxRight",
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small",
      "controls": false,
      "placeholder": "数量"
    },
    model: {
      value: (_vm.params.pepnumTotal),
      callback: function($$v) {
        _vm.$set(_vm.params, "pepnumTotal", $$v)
      },
      expression: "params.pepnumTotal"
    }
  })], 1), _vm._v(" "), _c('br')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-9：出版经营情况调查表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
}]}

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container login-erea"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "card-box login-form",
    attrs: {
      "autoComplete": "on",
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("音像电子出版单位年度核验管理系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "prefix-icon": "el-icon-edit",
      "name": "mobilePhone",
      "type": "text",
      "autoComplete": "off",
      "placeholder": "单位名称"
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.typePwd,
      "prefix-icon": "el-icon-edit",
      "name": "password",
      "autoComplete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.handleLogin($event)
      }
    },
    model: {
      value: (_vm.loginForm.pwd),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "pwd", $$v)
      },
      expression: "loginForm.pwd"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "30px",
      "height": "30px",
      "top": "5px",
      "right": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.imgPwd,
      "alt": "密码",
      "hidden": !_vm.imgPwdShow
    },
    on: {
      "click": function($event) {
        _vm.showPwd()
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "imgCode"
    }
  }, [_c('el-input', {
    staticClass: "imgCode",
    attrs: {
      "autoComplete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.loginForm.imgCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "imgCode", $$v)
      },
      expression: "loginForm.imgCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": _vm.imgChange
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "login-bx"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v(" 登录 ")])], 1), _vm._v(" "), (_vm.isShowChromeTip) ? _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n      请务必使用360浏览器极速模式打开【"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://down.360safe.com/se/360se10.0.1250.0.exe"
    }
  }, [_vm._v("点击下载")]), _vm._v("】\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-tip"
  }, [_vm._v("\n      工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("资质：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selType),
      callback: function($$v) {
        _vm.selType = $$v
      },
      expression: "selType"
    }
  }, _vm._l((_vm.Zizhi), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("省局：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.selProvinceId),
      callback: function($$v) {
        _vm.selProvinceId = $$v
      },
      expression: "selProvinceId"
    }
  }, _vm._l((_vm.Shengju), function(item) {
    return _c('el-option', {
      key: item.sjExamineId,
      attrs: {
        "label": item.sjExamine,
        "value": item.sjExamineId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.goExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": "",
      "height": this.tableHeight
    },
    on: {
      "sort-change": this.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "min-width": "100",
      "align": "center",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "所属省局",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workers",
      "label": "单位职工总数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessWorkers",
      "label": "从事电子出版物业务人员数",
      "width": "230",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "otherWorkers",
      "label": "其他人员数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leaderWorkers",
      "label": "领导班子人员数",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "leaderWorkerProportion",
      "label": "领导班子持证上岗率",
      "align": "center",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zjCertificateWorkers",
      "label": "出版专业中级职称及以上人数",
      "width": "144",
      "align": "center",
      "sortable": "custom"
    }
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, 'time')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, 'record_state')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.record == 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goRegist(scope.row)
            }
          }
        }, [_vm._v("登记\n              ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goScan(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("电子出版物出版单位登记")])])
}]}

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "titleH"
  }, [_vm._v("汇总表")]), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initBase()
      }
    }
  }, [_vm._v("初始化基本信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initFinance()
      }
    }
  }, [_vm._v("初始化经营情况")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initPublication()
      }
    }
  }, [_vm._v("初始化出版物")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initWorker()
      }
    }
  }, [_vm._v("初始化人员")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initLxdzBase()
      }
    }
  }, [_vm._v("连续型-初始化单位信息")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.initLxdzFinance()
      }
    }
  }, [_vm._v("连续型-初始化经营情况")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.batchAuditGen()
      }
    }
  }, [_vm._v("审核判断数据生成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "seekArea",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("统计数据生成")])])
}]}

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "disabled": _vm.upState == 'loading',
      "action": _vm.upUrl,
      "headers": _vm.postHead,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "data": _vm.fileData,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceed,
      "submit": _vm.upUrl
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.upState == 'loading',
      "size": "small"
    }
  }, [(_vm.upState == 'wait' || _vm.upState == 'loading') ? _c('span', [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('span', [_vm._v("更新")]) : _vm._e()]), _vm._v(" "), (_vm.needTip != 'no') ? _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_vm._v("注：上传文件格式为JPEG/PNG，文件大小不超过10M")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "progressBox"
  }, [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "visible": _vm.dialogVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.handleLeftRotate(_vm.imgUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(342)
    }
  })]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.handleRightRotate(_vm.imgUrl)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(343)
    }
  })])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "21"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_vm._v("注销或拟注销")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("（若省局已经审核完成，请点击“上报国家新闻出版署”。）")]), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row.sjViewDate, "time")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "省局意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "sjstatus")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.styleTrans(scope.row.status)
        }, [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "state")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0 || scope.row.progress == '省局') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("审核")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看 ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pg3_1dig",
    attrs: {
      "visible": _vm.backdiag,
      "modal": true,
      "close-on-click-modal": false,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.backdiag = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.backtype == 3) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zanhuanMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zanhuanMessage", $$v)
      },
      expression: "params.zanhuanMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zhuxiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zhuxiaoMessage", $$v)
      },
      expression: "params.zhuxiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.chexiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "chexiaoMessage", $$v)
      },
      expression: "params.chexiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.arrExam
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("电子出版物出版单位审核")])])
}]}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.tabSeek('init')
      }
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("transStr")(scope.row.provinceConsult, 'time')) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, 'record_state')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.record == 1) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goRegist(scope.row)
            }
          }
        }, [_vm._v("登记\n              ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goScan(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("音像制品出版单位登记")])])
}]}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-btn"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'wait' || _vm.upState == 'loaded'),
      expression: "upState == 'wait' || upState == 'loaded'"
    }],
    ref: "upload",
    staticClass: "upload-btn",
    attrs: {
      "aciton": _vm.loadUrl,
      "disabled": _vm.pubStatus != 0,
      "before-upload": _vm.prevCtrls,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "show-file-list": false,
      "multiple": "",
      "limit": 1,
      "on-exceed": _vm.handleExceed,
      "headers": _vm.postHead
    }
  }, [(_vm.upState == 'wait') ? _c('el-button', {
    attrs: {
      "disabled": _vm.pubStatus != 0,
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("上传")]) : _vm._e(), _vm._v(" "), (_vm.upState == 'loaded') ? _c('el-button', {
    attrs: {
      "disabled": _vm.pubStatus != 0,
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("更新")]) : _vm._e()], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loading'),
      expression: "upState == 'loading'"
    }],
    attrs: {
      "type": "circle",
      "percentage": _vm.percentage,
      "width": 45,
      "stroke-width": 3
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upState == 'loaded'),
      expression: "upState == 'loaded'"
    }],
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.filesDown
    }
  }, [_vm._v(" 下载 ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-6"
  }, [_c('div', {
    staticClass: "headBar linkRoutes"
  }, [(_vm.querys.pressState == 3) ? _c('span', [_vm._v("连续型电子出版物查询")]) : _c('span', [_vm._v("出版连续型电子出版物单位核验")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.querys.pressName))])]), _vm._v(" "), (_vm.opMsg) ? _c('div', {
    staticClass: "rejects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("原因：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v(_vm._s(_vm.opMsg))])])]) : _vm._e(), _vm._v(" "), (_vm.wSat == 1) ? _c('MainTabs', {
    ref: "mainTab",
    attrs: {
      "bookName": _vm.bookName,
      "pressDat": _vm.resDat,
      "defaultYear": this.querys.year1,
      "selYears": _vm.selYearRecord,
      "role": "admin"
    },
    on: {
      "valChangeSearch": _vm.valChangeSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "progressTab"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineName",
      "label": "单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("tansStr")(scope.row, "state")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "examineMessage",
      "label": "审核意见",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "批准文号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkdAt",
      "width": "180",
      "label": "操作时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("tansStr")(scope.row, "checkdAt")) + "\n        ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "radioBx"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '5'
    }
  }, [_vm._v("注销或拟注销")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '4'
    }
  }, [_vm._v("撤销")])], 1), _vm._v(" "), (
    _vm.params.status == 1 || _vm.params.status == 2 || _vm.params.status == 3 || _vm.params.status == 5 || _vm.params.status == 4
  ) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请填写意见"
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subLine"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.goBackExamsave
    }
  }, [_vm._v("退回")]) : _vm._e(), _vm._v(" "), (_vm.querys.pressState == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.goExamsave
    }
  }, [_vm._v("审 核")]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rejLine"
  }, [_c('div', {
    staticClass: "rejName"
  }, [_vm._v("状态：")]), _vm._v(" "), _c('div', {
    staticClass: "rejText"
  }, [_vm._v("暂缓")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核历史")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("审核意见")])])
}]}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar"
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('levelbar'), _vm._v(" "), _c('a', {
    staticClass: "doc",
    attrs: {
      "href": _vm.tzUrl,
      "download": ""
    }
  }), _vm._v(" "), (_vm.downloadUrl) ? _c('a', {
    staticClass: "downLink",
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v("操作说明")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "userName",
    staticStyle: {
      "margin-right": "32px"
    },
    attrs: {
      "title": _vm.userInfo.userName
    }
  }, [_vm._v(_vm._s(_vm.userInfo.userName))]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('img', {
    staticClass: "userHome",
    attrs: {
      "src": _vm.img_main,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('router-link', {
    staticClass: "inlineBlock",
    attrs: {
      "to": "/"
    }
  }, [_c('el-dropdown-item', [_vm._v(" 首页 ")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_vm._v("退出")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#f0f2f5",
      "margin-top": "-20px"
    }
  }, [_c('div', {
    staticClass: "wscn-http404"
  }, [_c('div', {
    staticClass: "pic-404"
  }, [_c('img', {
    staticClass: "pic-404__parent",
    attrs: {
      "src": _vm.img_404,
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child left",
    attrs: {
      "src": _vm.img_404_cloud,
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child mid",
    attrs: {
      "src": _vm.img_404_cloud,
      "alt": "404"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic-404__child right",
    attrs: {
      "src": _vm.img_404_cloud,
      "alt": "404"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bullshit"
  }, [_c('div', {
    staticClass: "bullshit__oops"
  }, [_vm._v("OOPS!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bullshit__headline"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', {
    staticClass: "bullshit__info"
  }, [_vm._v("请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告")]), _vm._v(" "), _c('a', {
    staticClass: "bullshit__return-home",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bullshit__info"
  }, [_vm._v("版权所有"), _c('a', {
    staticClass: "link-type",
    attrs: {
      "href": "https://wallstreetcn.com",
      "target": "_blank"
    }
  }, [_vm._v("华尔街见闻")])])
}]}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-3"
  }, [_c('div', {
    staticClass: "role-list",
    style: ('height:' + _vm.leftHt + 'px')
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.roleData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "角色名称",
      "width": "240",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建日期",
      "width": "180",
      "prop": "createdAt"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "headSeek",
          attrs: {
            "size": "small",
            "placeholder": "输入关键字搜索"
          },
          model: {
            value: (_vm.param.name),
            callback: function($$v) {
              _vm.$set(_vm.param, "name", $$v)
            },
            expression: "param.name"
          }
        }), _vm._v(" "), _c('el-button', {
          staticClass: "newAdd",
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.roleCtrls('show', 1)
            }
          }
        }, [_vm._v("新增")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.roleProwers('show', scope.row)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.roleCtrls('show', 2, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.roleDelete(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "pgemnt-3-dag",
    attrs: {
      "title": _vm.roleCreate.diaName,
      "visible": _vm.roleCreate.diaPop,
      "width": "450px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.roleCreate, "diaPop", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dagInner"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "ttName"
  }, [_c('span', [_vm._v("角色名称：")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "ttInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "输入角色名称"
    },
    model: {
      value: (_vm.roleCreate.roleName),
      callback: function($$v) {
        _vm.$set(_vm.roleCreate, "roleName", $$v)
      },
      expression: "roleCreate.roleName"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.roleCtrls('cencel')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.roleCtrls('sure')
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "功能配置",
      "visible": _vm.roleConfig.diaPop,
      "width": "450px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.roleConfig, "diaPop", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dagInner"
  }, [_c('el-scrollbar', [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.roleConfig.treeArr,
      "show-checkbox": "",
      "node-key": "id",
      "check-strictly": true,
      "show-checkbox": true,
      "default-checked-keys": _vm.roleConfig.selected,
      "props": _vm.defaultProps2
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.roleProwers('cencel')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.roleProwers('sure')
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-7"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-input', {
    style: ({
      width: '360px'
    }),
    attrs: {
      "size": "small",
      "placeholder": "省局名称、出版单位名称"
    },
    model: {
      value: (_vm.params.keyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "keyword", $$v)
      },
      expression: "params.keyword"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-select', {
    staticClass: "lnjlClass",
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    on: {
      "change": _vm.valChange
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 12 * (_vm.params.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sjExamine",
      "label": "省局名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "省局意见",
      "prop": "statussj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "statussj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "prop": "statuszj",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "progress",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.progress == "开始" ? "" : scope.row.progress == "登记" ? "已发布" : scope.row.progress))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.params.pgAll > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "layout": "prev, pager, next",
      "page-count": _vm.params.pgAll
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("音像制品出版单位查询")])])
}]}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pgemnt-1"
  }, [_c('div', {
    staticClass: "tbs"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省局"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.shparentorgname),
      callback: function($$v) {
        _vm.$set(_vm.condition, "shparentorgname", $$v)
      },
      expression: "condition.shparentorgname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出版单位"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "输入关键字查询",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.ydname),
      callback: function($$v) {
        _vm.$set(_vm.condition, "ydname", $$v)
      },
      expression: "condition.ydname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资质",
      "width": "170"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.ydzz),
      callback: function($$v) {
        _vm.$set(_vm.condition, "ydzz", $$v)
      },
      expression: "condition.ydzz"
    }
  }, _vm._l((_vm.ydzzOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "justify-content": "end"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "justify-content": "end"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.exportTable()
      }
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.showArr
    },
    on: {
      "sort-change": _vm.sortChanged
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "省局",
      "prop": "shparentorgname",
      "width": "220",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出版单位",
      "prop": "ydname"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s("出版单位") + "\n            " + _vm._s(("（合计：" + _vm.totalCount + "）")) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "资质",
      "prop": "ydzzName",
      "width": "280"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.colYdzzName) + "\n          ")]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audio-4"
  }, [(_vm.frashState) ? _c('reportTemp', {
    attrs: {
      "repType": 1
    },
    on: {
      "go-frash": _vm.frashCtrls
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-F"
  }, [_c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "seekArea"
  }, [_c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("资质：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selType),
      callback: function($$v) {
        _vm.selType = $$v
      },
      expression: "selType"
    }
  }, _vm._l((_vm.Zizhi), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("省局：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.selProvinceId),
      callback: function($$v) {
        _vm.selProvinceId = $$v
      },
      expression: "selProvinceId"
    }
  }, _vm._l((_vm.Shengju), function(item) {
    return _c('el-option', {
      key: item.sjExamineId,
      attrs: {
        "label": item.sjExamine,
        "value": item.sjExamineId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('span', [_vm._v("年份：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "历年记录"
    },
    model: {
      value: (_vm.selYear),
      callback: function($$v) {
        _vm.selYear = $$v
      },
      expression: "selYear"
    }
  }, _vm._l((_vm.selYearRecord), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "selectBox"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.goSeek
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.goExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": "",
      "height": this.tableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "width": "180",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "label": "所属省局",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "资质",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nature",
      "label": "企业性质",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isIndependentLP",
      "label": "是否为独立法人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LPSituation",
      "label": "隶属关系",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hostName",
      "label": "主办单位",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "chargeName",
      "label": "主管单位",
      "width": "180"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Audio-4"
  }, [(_vm.frashState) ? _c('reportTemp', {
    attrs: {
      "repType": 1
    },
    on: {
      "go-frash": _vm.frashCtrls
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.svg": 1543,
	"./bug.svg": 1544,
	"./chart.svg": 1545,
	"./clipboard.svg": 1546,
	"./component.svg": 1547,
	"./drag.svg": 1548,
	"./email.svg": 1549,
	"./example.svg": 1550,
	"./excel.svg": 1551,
	"./eye.svg": 1552,
	"./form.svg": 1553,
	"./icon.svg": 1554,
	"./lock.svg": 1555,
	"./password.svg": 1556,
	"./people.svg": 1557,
	"./qq.svg": 1558,
	"./star.svg": 1559,
	"./tab.svg": 1560,
	"./table.svg": 1561,
	"./theme.svg": 1562,
	"./trendChart1.svg": 1563,
	"./trendChart2.svg": 1564,
	"./trendChart3.svg": 1565,
	"./user.svg": 1566,
	"./wechat.svg": 1567,
	"./zip.svg": 1568
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1843;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.vue": 1574,
	"./adminRole/AudioPressSeek.vue": 1575,
	"./adminRole/BarChart.vue": 626,
	"./adminRole/BingChart.vue": 627,
	"./adminRole/ElectPressSeek.vue": 1576,
	"./adminRole/HBarChart.vue": 628,
	"./adminRole/MBarChart.vue": 629,
	"./adminRole/PieChart.vue": 630,
	"./adminRole/adminBasicOperation.vue": 1577,
	"./adminRole/adminDzauditQuery.vue": 1578,
	"./adminRole/adminPersonOperation.vue": 1579,
	"./adminRole/adminPressck.vue": 1580,
	"./adminRole/adminPublishOperation.vue": 1581,
	"./adminRole/adminSuccessSkim.vue": 1582,
	"./adminRole/adminYxauditQuery.vue": 1583,
	"./adminRole/audioFExam.vue": 1584,
	"./adminRole/chart1.vue": 1585,
	"./adminRole/electFExam.vue": 1586,
	"./adminRole/successiveFExam.vue": 1587,
	"./adminRole/successivePressSeek.vue": 1588,
	"./components/SPEC/SpecCommonTab.vue": 175,
	"./components/SPEC/glanceDcp/table1.vue": 1589,
	"./components/SPEC/glanceDcp/table2.vue": 1590,
	"./components/SPEC/glanceDcp/table209.vue": 1591,
	"./components/SPEC/glanceDcp/table3.vue": 1592,
	"./components/SPEC/glanceDcp/table4.vue": 1593,
	"./components/SPEC/glanceDcp/table5.vue": 1594,
	"./components/SPEC/glanceDcp/table6.vue": 1595,
	"./components/SPEC/glanceDcp/table7.vue": 1596,
	"./components/SPEC/glanceDcp/table8.vue": 1597,
	"./components/SPEC/glanceDcp/table9.vue": 1598,
	"./components/SPEC/glanceTab/table3.vue": 1599,
	"./components/SPEC/glanceTab/table4.vue": 1600,
	"./components/SPEC/glanceTab/table5.vue": 1601,
	"./components/SPEC/glanceTab/table6.vue": 1602,
	"./components/SPEC/glanceTab/table8.vue": 1603,
	"./components/SPEC/glanceTab/table9.vue": 1604,
	"./components/SPEC/ssBlock/forEdit/ssTab1.vue": 1605,
	"./components/SPEC/ssBlock/forEdit/ssTab2.vue": 1606,
	"./components/SPEC/ssBlock/forEdit/ssTab3 copy.vue": 1607,
	"./components/SPEC/ssBlock/forEdit/ssTab3.vue": 1608,
	"./components/SPEC/ssBlock/forEdit/ssTab4.vue": 1609,
	"./components/SPEC/ssBlock/forEdit/ssTab5.vue": 1610,
	"./components/SPEC/ssBlock/forTabs/ssTab4.vue": 1611,
	"./components/SPEC/ssCommonTabs.vue": 248,
	"./components/authImg/index.vue": 1612,
	"./components/date/date.vue": 631,
	"./components/excelRead/excel.vue": 207,
	"./components/excelRead/excelError.vue": 208,
	"./components/forPrints/audio_elect/editPrint.vue": 1613,
	"./components/upload.vue": 1614,
	"./components/upload/uploadCards.vue": 1615,
	"./components/upload/uploadSingle.vue": 344,
	"./components/upload/uploadSingleView.vue": 632,
	"./components/uploadBtn.vue": 249,
	"./components/uploadCards.vue": 124,
	"./components/uploadPdf.vue": 176,
	"./components/userSet/passReset.vue": 633,
	"./dashboard/index.vue": 1616,
	"./layout/AppMain.vue": 634,
	"./layout/Layout.vue": 635,
	"./layout/Levelbar.vue": 345,
	"./layout/Navbar.vue": 636,
	"./layout/Sidebar.vue": 637,
	"./layout/SidebarItem.vue": 638,
	"./layout/TabsView.vue": 639,
	"./login/login.vue": 1617,
	"./login/passSet.vue": 1618,
	"./pgment/dictMent.vue": 1619,
	"./pgment/modelMent.vue": 1620,
	"./pgment/publishMent.vue": 1621,
	"./pgment/roleMent.vue": 1622,
	"./pgment/sectMent.vue": 1623,
	"./pgment/sectStatic.vue": 1624,
	"./pgment/userMent.vue": 1625,
	"./pressRole/Audio_Electronic/audioPress.vue": 1626,
	"./pressRole/Audio_Electronic/electPress.vue": 1627,
	"./pressRole/Audio_Electronic/examProgress.vue": 1628,
	"./pressRole/Audio_Electronic/examProgressHistory.vue": 1629,
	"./pressRole/Audio_Electronic/forEdit/table1.vue": 1630,
	"./pressRole/Audio_Electronic/forEdit/table10.vue": 1631,
	"./pressRole/Audio_Electronic/forEdit/table2.vue": 1632,
	"./pressRole/Audio_Electronic/forEdit/table3.vue": 1633,
	"./pressRole/Audio_Electronic/forEdit/table4.vue": 1634,
	"./pressRole/Audio_Electronic/forEdit/table5.vue": 1635,
	"./pressRole/Audio_Electronic/forEdit/table6.vue": 1636,
	"./pressRole/Audio_Electronic/forEdit/table7.vue": 1637,
	"./pressRole/Audio_Electronic/forEdit/table8.vue": 1638,
	"./pressRole/Audio_Electronic/forEdit/table9.vue": 1639,
	"./pressRole/Audio_Electronic/forTabs/table3.vue": 1640,
	"./pressRole/Audio_Electronic/forTabs/table4.vue": 1641,
	"./pressRole/Audio_Electronic/forTabs/table5.vue": 1642,
	"./pressRole/Audio_Electronic/forTabs/table6.vue": 1643,
	"./pressRole/Audio_Electronic/forTabs/table8.vue": 1644,
	"./pressRole/Audio_Electronic/forTabs/table9.vue": 1645,
	"./pressRole/Audio_Electronic/skimFrame.vue": 1646,
	"./pressRole/SuccessivePart/examProgress.vue": 1647,
	"./pressRole/SuccessivePart/examProgressHistory.vue": 1648,
	"./pressRole/SuccessivePart/forEdit/ssTab1.vue": 1649,
	"./pressRole/SuccessivePart/forEdit/ssTab2.vue": 1650,
	"./pressRole/SuccessivePart/forEdit/ssTab3 copy.vue": 1651,
	"./pressRole/SuccessivePart/forEdit/ssTab3.vue": 1652,
	"./pressRole/SuccessivePart/forEdit/ssTab4.vue": 1653,
	"./pressRole/SuccessivePart/forEdit/ssTab5.vue": 1654,
	"./pressRole/SuccessivePart/forTabs/ssTab4.vue": 1655,
	"./pressRole/SuccessivePart/skimFrame.vue": 1656,
	"./pressRole/SuccessivePart/successiveList.vue": 1657,
	"./pressRole/SuccessivePart/successiveTabs.vue": 1658,
	"./pressRole/pressComps/CommonTab.vue": 346,
	"./pressRole/pressComps/CommonsSive.vue": 1659,
	"./provinceRole/Audio_Elect/commonReport.vue": 347,
	"./provinceRole/Audio_Elect/commonTabs.vue": 1660,
	"./provinceRole/audioPgress/AudioPressSeek.vue": 1661,
	"./provinceRole/audioPgress/audioList.vue": 1662,
	"./provinceRole/audioPgress/audioRegist.vue": 1663,
	"./provinceRole/audioPgress/audioReport.vue": 1664,
	"./provinceRole/audioPgress/audioTabs.vue": 1665,
	"./provinceRole/electPgress/ElectPressSeek.vue": 1666,
	"./provinceRole/electPgress/electList.vue": 1667,
	"./provinceRole/electPgress/electRegist.vue": 1668,
	"./provinceRole/electPgress/electReport.vue": 1669,
	"./provinceRole/electPgress/electTabs.vue": 1670,
	"./provinceRole/successivePgress/successiveList.vue": 1671,
	"./provinceRole/successivePgress/successivePressSeek.vue": 1672,
	"./provinceRole/successivePgress/successiveRegist.vue": 1673,
	"./provinceRole/successivePgress/successiveReport.vue": 1674,
	"./provinceRole/successivePgress/successiveTabs.vue": 1675
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1844;

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

module.exports = VueRouter;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(355);
module.exports = __webpack_require__(666);


/***/ })
],[1846]);


// WEBPACK FOOTER //
// static/js/app.a861ff00031c05c7938e.js